
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("7tq7f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $057b38cdad03bad6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $foc4i = parcelRequire("foc4i");

var $7HGHG = parcelRequire("7HGHG");

var $182pZ = parcelRequire("182pZ");

var $guZLT = parcelRequire("guZLT");

var $lB25E = parcelRequire("lB25E");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$057b38cdad03bad6$export$2e2bcd8739ae039 = ()=>{
    const isAgentViewMounted = (0, $eUqFw.useRef)(false);
    const [{ match: match }] = (0, $lB25E.useRouter)();
    const [issueKeys, setIssueKeys] = (0, $eUqFw.useState)([]);
    const [issuesCount, setIssuesCount] = (0, $eUqFw.useState)(0);
    const pageId = match.params.issueKey ? 'queues-issue-view' : 'queues-agent-view';
    const onIssuesChanged = (keys)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(keys, issueKeys)) setIssueKeys(keys);
    };
    const onIssuesCountChanged = (count)=>{
        setIssuesCount(count);
    };
    const issueNavigatorData = (0, $eUqFw.useMemo)(()=>{
        const { issueKey: issueKey } = match.params;
        return issueKey ? {
            issueKey: issueKey,
            issueKeys: issueKeys,
            knownIssueKeys: issueKeys.filter((key)=>!!key),
            issuesCount: issuesCount
        } : undefined;
    }, [
        issueKeys,
        issuesCount,
        match.params
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7HGHG.default), {
        pageId: pageId
    }, ({ pageContext: pageContext, queuesData: queuesData, push: push, replace: replace })=>{
        if (!pageContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null);
        const shouldRenderAgentView = isAgentViewMounted.current || !match.params.issueKey;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, match.params.issueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $guZLT.default), {
            pageContext: pageContext,
            issueNavigatorData: issueNavigatorData,
            // @ts-expect-error - TS2322 - Type 'QueuesPush' is not assignable to type '(url: string) => void'.
            push: push,
            match: match
        }), shouldRenderAgentView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $182pZ.default), {
            queuesData: queuesData,
            push: push,
            // @ts-expect-error - TS2322 - Type '((path: string) => void | Promise<void>) | undefined' is not assignable to type '(path: string) => void | Promise<void>'.
            replace: replace,
            queueId: match.params.queueId || '',
            pageContext: pageContext,
            isQueueVisible: !match.params.issueKey,
            isAgentViewMountedRef: isAgentViewMounted,
            onIssuesChanged: onIssuesChanged,
            onIssuesCountChanged: onIssuesCountChanged
        }));
    });
};

});
parcelRegister("7HGHG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2488e0530c930d00$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $knPb9 = parcelRequire("knPb9");

var $kKzsy = parcelRequire("kKzsy");

var $aS6XE = parcelRequire("aS6XE");

var $9GzdM = parcelRequire("9GzdM");

var $1L8BM = parcelRequire("1L8BM");

var $2d7Sj = parcelRequire("2d7Sj");

var $51Ia6 = parcelRequire("51Ia6");

var $dVAlv = parcelRequire("dVAlv");

var $f5prk = parcelRequire("f5prk");

var $fDE9L = parcelRequire("fDE9L");

var $6vrw7 = parcelRequire("6vrw7");

var $6M8Uw = parcelRequire("6M8Uw");

var $lB25E = parcelRequire("lB25E");

var $75nMA = parcelRequire("75nMA");

var $gatu1 = parcelRequire("gatu1");
const $2488e0530c930d00$var$QueuesAppBase = (props)=>{
    const { QueuesPushProvider: QueuesPushProvider, pageId: pageId } = props;
    const [{ match: match }] = (0, $lB25E.useRouter)();
    const [{ data: pageContextData, error: error }] = (0, $51Ia6.usePageContext)();
    const { tenantContext: tenantContext, projectContext: projectContext, serviceDeskContext: serviceDeskContext } = pageContextData || {};
    const { baseUrl: baseUrl = '' } = tenantContext || {};
    const { projectName: projectName } = projectContext || {};
    const pageContextProps = (0, $eUqFw.useMemo)(()=>({
            ...tenantContext,
            ...projectContext,
            ...serviceDeskContext
        }), [
        projectContext,
        serviceDeskContext,
        tenantContext
    ]);
    const projectKey = (0, $6vrw7.toProjectKey)(match.params.projectKey || '');
    const practice = (0, $fDE9L.toItsmPractice)(match.params.practiceType);
    const [categorizedQueues, categorizedQueuesLoading, categorizedError, methods] = (0, $1L8BM.useCategorizedQueues)(baseUrl, projectKey, practice);
    let selectedQueueName;
    if (categorizedQueues && match.params.queueId) {
        const selectedQueue = categorizedQueues.find((queue)=>queue.id === Number(match.params.queueId));
        selectedQueueName = selectedQueue ? selectedQueue.name : undefined;
    }
    (0, $75nMA.useOnFavoritesChanged)(projectKey, practice, categorizedQueues, methods.editItemFavorite);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dVAlv.SpaPageWrapper), {
        pageId: pageId,
        baseUrl: baseUrl,
        currentUrl: match.url,
        // @ts-expect-error - TS2322 - Type '{ projectId: number; projectKey: string; projectName: string; projectType: ProjectType; isAdmin: boolean; isProjectSimplified: boolean; } | undefined' is not assignable to type 'ProjectContext | null | undefined'.
        projectContext: projectContext,
        isLoading: !pageContextData && !error || categorizedQueuesLoading,
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(QueuesPushProvider, {
        projectKey: projectKey
    }, ({ push: push, replace: providerReplace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2d7Sj.ServiceDeskDocumentTitle), {
            // @ts-expect-error - TS2322 - Type '{ projectName: string | undefined; section: string; }' is not assignable to type 'IntrinsicAttributes & Diff<(Diff<RefAttributes<any> | (RefAttributes<any> & { children?: ReactNode; }), Partial<RefAttributes<...> | (RefAttributes<...> & { ...; })>> & RefAttributes<...>) | (Diff<...> & ... 1 more ... & { ...; }), InjectIntlVoidProps> & { ...; }'.
            projectName: projectName,
            section: "queues",
            subsection: selectedQueueName
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children({
            push: push,
            match: match,
            replace: providerReplace,
            queuesData: {
                data: (0, $gatu1.pageToQueues)(categorizedQueues || []),
                error: categorizedError ? categorizedError.message : undefined,
                loading: categorizedQueuesLoading
            },
            category: practice,
            // @ts-expect-error - TS2322 - Type '{ portalId?: number | undefined; canSeeNewIssueView?: boolean | undefined; userRole?: string | undefined; serviceDeskId?: number | undefined; projectId?: number | undefined; projectKey?: string | undefined; ... 11 more ...; isSiteAdmin?: boolean | undefined; }' is not assignable to type 'PageProps'.
            pageContext: pageContextProps
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKzsy.JsdGettingStartedPanelShouldRender), null));
};
var $2488e0530c930d00$export$2e2bcd8739ae039 = (0, $knPb9.default)($2488e0530c930d00$var$QueuesAppBase, {
    QueueProvider: (0, $9GzdM.default),
    QueuesApiDataProvider: (0, $aS6XE.default),
    QueuesPushProvider: (0, $f5prk.default)
});

});
parcelRegister("kKzsy", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $993d872dc7228c2f$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $993d872dc7228c2f$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $993d872dc7228c2f$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $993d872dc7228c2f$export$c7732c55900cf0b9);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("5palF")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanel = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("iFQsc")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("10YNr")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("cVR9C")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $993d872dc7228c2f$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender, null));
$993d872dc7228c2f$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $993d872dc7228c2f$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanel, null));
$993d872dc7228c2f$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $993d872dc7228c2f$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton, null));
$993d872dc7228c2f$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $993d872dc7228c2f$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight, null));
$993d872dc7228c2f$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("5palF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kd6Ju").then(()=>parcelRequire('appSk'));

});

parcelRegister("iFQsc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("5eFqM")
]).then(()=>parcelRequire('ddfk6'));

});

parcelRegister("10YNr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("ahRif")
]).then(()=>parcelRequire('1HvEW'));

});

parcelRegister("cVR9C", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("cxrYi")
]).then(()=>parcelRequire('f9sDQ'));

});


parcelRegister("aS6XE", function(module, exports) {

$parcel$export(module.exports, "AvailableQueuesConsumer", () => $946c01b4eaf4ef31$export$dfebed0fc9519fcc);
$parcel$export(module.exports, "default", () => $946c01b4eaf4ef31$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $jG2Eu = parcelRequire("jG2Eu");

var $2bMHt = parcelRequire("2bMHt");

var $aNBkj = parcelRequire("aNBkj");

var $a2MDL = parcelRequire("a2MDL");

var $3RIuY = parcelRequire("3RIuY");

var $9Q5bD = parcelRequire("9Q5bD");
const $946c01b4eaf4ef31$var$LAST_VISITED_QUEUE_KEY_PREFIX = 'last_visited_queue';
// @ts-expect-error - TS2322 - Type 'Context<{ setFavorite: (...args: any[]) => void; deleteNavItem: (...args: any[]) => void; updateIssueCount: (...args: any[]) => void; markNavItemsAsStale: (...args: any[]) => void; getQueueCount: (...args: any[]) => void; setLastVisitedQueueId: (...args: any[]) => void; getLastVisitedQueueId: (...args: any[]) => voi...' is not assignable to type 'Context<QueuesContextType>'.
const $946c01b4eaf4ef31$var$AvailableQueuesContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    deleteNavItem: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    updateIssueCount: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    markNavItemsAsStale: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    getQueueCount: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    setLastVisitedQueueId: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    getLastVisitedQueueId: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});
const { Provider: $946c01b4eaf4ef31$var$Provider, Consumer: $946c01b4eaf4ef31$export$dfebed0fc9519fcc } = $946c01b4eaf4ef31$var$AvailableQueuesContext;
class $946c01b4eaf4ef31$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            FavoriteSubscriber: (0, $3RIuY.default),
            queuesPrefetchData: [],
            push: undefined,
            onDeleteNavItem: undefined
        };
    }
    constructor(props){
        const { onNavUpdated: onNavUpdated, onIssueCountUpdated: onIssueCountUpdated, queuesPrefetchData: queuesPrefetchData, push: push } = props;
        super(props);
        this.getQueueCount = ()=>{
            const { data: data } = this.state;
            return data ? Object.keys(data).filter((queueId)=>!this.deletedQueueIds.has((0, $aNBkj.toQueueIdString)(queueId))).length : 0;
        };
        this.getLastVisitedQueueId = (projectKey)=>{
            const { category: category } = this.props;
            if (!projectKey) return null;
            try {
                if (category) return (0, $a2MDL.getFromLocalStorage)(`${$946c01b4eaf4ef31$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`);
                return (0, $a2MDL.getFromLocalStorage)(`${$946c01b4eaf4ef31$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                return null;
            }
        };
        this.setFavorite = (queueId, newValue)=>{
            const { FavoriteSubscriber: FavoriteSubscriber } = this.props;
            FavoriteSubscriber.setFavorite(queueId, newValue);
        };
        this.setLastVisitedQueueId = (queueId, projectKey)=>{
            const lastVisitedQueueId = this.getLastVisitedQueueId(projectKey);
            const { category: category } = this.props;
            // @ts-expect-error - TS2367 - This condition will always return 'true' since the types 'string | null | undefined' and 'number' have no overlap.
            if (projectKey && lastVisitedQueueId !== queueId) try {
                if (category) (0, $a2MDL.setInLocalStorage)(`${$946c01b4eaf4ef31$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`, (0, $aNBkj.fromQueueIdString)(queueId));
                else (0, $a2MDL.setInLocalStorage)(`${$946c01b4eaf4ef31$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}`, (0, $aNBkj.fromQueueIdString)(queueId));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
            // Don't care if it fails. Default behavior in QueuesRedirect will take users to first available queue.
            }
        };
        this.queuesContext = {
            deleteNavItem: this.deleteNavItem(push),
            updateIssueCount: onIssueCountUpdated,
            markNavItemsAsStale: ()=>onNavUpdated(false),
            setFavorite: this.setFavorite,
            getQueueCount: this.getQueueCount,
            setLastVisitedQueueId: this.setLastVisitedQueueId,
            getLastVisitedQueueId: this.getLastVisitedQueueId
        };
        this.deletedQueueIds = new Set();
        this.state = {
            loading: false,
            error: undefined,
            data: queuesPrefetchData.length ? (0, $9Q5bD.pageToQueues)(queuesPrefetchData) : undefined
        };
    }
    static getDerivedStateFromProps(props, state) {
        const { queuesPrefetchData: queuesPrefetchData } = props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))((0, $9Q5bD.pageToQueues)(queuesPrefetchData), state.data) && queuesPrefetchData.length) return {
            data: (0, $9Q5bD.pageToQueues)(queuesPrefetchData)
        };
        return null;
    }
    componentWillUnmount() {
        const { fetchSubscription: fetchSubscription, deleteItemSubscription: deleteItemSubscription } = this;
        fetchSubscription && fetchSubscription.unsubscribe();
        deleteItemSubscription && deleteItemSubscription.unsubscribe();
    }
    deleteNavItem(push) {
        return (queueId)=>{
            const { onDeleteNavItem: onDeleteNavItem } = this.props;
            onDeleteNavItem && onDeleteNavItem((0, $aNBkj.fromQueueIdString)(queueId));
            // update queue counts to reflect the deletion
            // note that deleteQueueFromSidebar is called after the delete endpoint returns success
            const updatedQueues = {
                ...this.state.data
            };
            delete updatedQueues[(0, $aNBkj.fromQueueIdString)(queueId)];
            const deletedLastQueue = Object.keys(updatedQueues).length === 0;
            if (deletedLastQueue) push && push(`${(0, $2bMHt.getQueueFragment)()}/custom/new`);
            else push && push((0, $2bMHt.getQueueFragment)());
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($946c01b4eaf4ef31$var$Provider, {
            value: this.queuesContext
        }, this.props.children(this.state));
    }
}

});
parcelRegister("2bMHt", function(module, exports) {

$parcel$export(module.exports, "QUEUE_ROUTES", () => $aa4b24cdc7b12949$export$410a6306dae101ca);
$parcel$export(module.exports, "navigate", () => $aa4b24cdc7b12949$export$ff7962acd6052c28);
$parcel$export(module.exports, "getQueueFragment", () => $aa4b24cdc7b12949$export$954f428fa284c7);
$parcel$export(module.exports, "getEditQueueFragment", () => $aa4b24cdc7b12949$export$86f6a6d69e87f843);
$parcel$export(module.exports, "getCloneQueueFragment", () => $aa4b24cdc7b12949$export$7a487d215c9c3f76);
$parcel$export(module.exports, "getQueueIssueFragment", () => $aa4b24cdc7b12949$export$773cefb51b60b161);
$parcel$export(module.exports, "getIssueFragment", () => $aa4b24cdc7b12949$export$a796bfaff67c9fae);
$parcel$export(module.exports, "getQueueUrl", () => $aa4b24cdc7b12949$export$a29b42a005fecf0);
$parcel$export(module.exports, "getEditQueueUrlFromManageQueue", () => $aa4b24cdc7b12949$export$91152835d12ca65f);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("cpH8E");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $8BwtD = parcelRequire("8BwtD");

var $f1lMr = parcelRequire("f1lMr");

var $1MlrF = parcelRequire("1MlrF");
const $aa4b24cdc7b12949$var$LOCATION = 'servicedesk.common.navigation.queues';
let $aa4b24cdc7b12949$var$navigatorPromise;
const $aa4b24cdc7b12949$var$getPushStateNavigator = ()=>{
    if (!$aa4b24cdc7b12949$var$navigatorPromise) $aa4b24cdc7b12949$var$navigatorPromise = (0, $1MlrF.createPushStateNavigator)();
    return $aa4b24cdc7b12949$var$navigatorPromise;
};
const $aa4b24cdc7b12949$export$410a6306dae101ca = {
    [(0, $f1lMr.INCIDENTS)]: 'section/incidents',
    [(0, $f1lMr.CHANGES)]: 'section/changes',
    [(0, $f1lMr.SERVICE_REQUEST)]: 'section/service-requests',
    [(0, $f1lMr.PROBLEMS)]: 'section/problems',
    [(0, $f1lMr.POST_INCIDENT_REVIEWS)]: 'section/post-incident-reviews',
    [(0, $f1lMr.NO_CATEGORY)]: 'queues'
};
const $aa4b24cdc7b12949$var$fromCategory = (category)=>$aa4b24cdc7b12949$export$410a6306dae101ca[category || (0, $f1lMr.NO_CATEGORY)];
const $aa4b24cdc7b12949$export$ff7962acd6052c28 = (projectKey, fragment)=>{
    (0, $8BwtD.emitSignal)($aa4b24cdc7b12949$var$LOCATION, {
        projectKey: projectKey,
        fragment: fragment
    });
    return (0, $3JafE.Observable).fromPromise($aa4b24cdc7b12949$var$getPushStateNavigator()).mergeMap((pushStateNavigator)=>{
        pushStateNavigator.navigateToFragment(fragment);
        return (0, $3JafE.Observable).empty();
    }).catch(()=>(0, $3JafE.Observable).empty());
};
const $aa4b24cdc7b12949$export$954f428fa284c7 = (queueId, category)=>{
    const categoryString = $aa4b24cdc7b12949$var$fromCategory(category);
    return queueId != null ? `${categoryString}/custom/${queueId}` : `${categoryString}`;
};
const $aa4b24cdc7b12949$export$86f6a6d69e87f843 = (queueId, category)=>`${$aa4b24cdc7b12949$export$954f428fa284c7(queueId, category)}/edit`;
const $aa4b24cdc7b12949$export$7a487d215c9c3f76 = (queueId, category)=>{
    const categoryString = $aa4b24cdc7b12949$var$fromCategory(category);
    return queueId != null ? `${categoryString}/custom/new?parentId=${queueId}` : `${categoryString}/custom/new`;
};
const $aa4b24cdc7b12949$export$773cefb51b60b161 = (queueId, issueKey, category)=>`${$aa4b24cdc7b12949$export$954f428fa284c7(queueId, category)}/${issueKey}`;
const $aa4b24cdc7b12949$export$a796bfaff67c9fae = (issueKey)=>`${$aa4b24cdc7b12949$export$954f428fa284c7()}/issue/${issueKey}`;
const $aa4b24cdc7b12949$export$a29b42a005fecf0 = ({ projectKey: projectKey, category: category, queueId: queueId, queryParams: queryParams })=>{
    const urlSearchParams = new URLSearchParams();
    if (queryParams) Object.entries(queryParams).forEach(([key, value])=>{
        urlSearchParams.set(key, value);
    });
    const formattedQueryParams = urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : '';
    return `/jira/servicedesk/projects/${projectKey}/${$aa4b24cdc7b12949$export$954f428fa284c7(queueId, category)}${formattedQueryParams}`;
};
const $aa4b24cdc7b12949$export$91152835d12ca65f = (queueId, projectKey, category)=>`/jira/servicedesk/projects/${projectKey}/${$aa4b24cdc7b12949$export$86f6a6d69e87f843(queueId, category)}`;

});
parcelRegister("8BwtD", function(module, exports) {

$parcel$export(module.exports, "emitSignal", () => $32b8235f7373c763$export$a8a72bca1918549c);
/**
 * A signalling mechanism for Cypress tests.
 *
 * This acts as a bridge between the storybook application and cypress for
 * checking behaviours which cannot be asserted on via the DOM or are
 * otherwise not reflected in application state.
 *
 * This is the 'emit' side of the story. It should be used by
 * production-facing code to emit a signal.
 */ const $32b8235f7373c763$var$isProduction = ()=>true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32b8235f7373c763$var$registerSignal = (signal, meta)=>{
    window.cySignals.allSignals.push(signal);
    const signalsByName = window.cySignals.signalsByName;
    if (signalsByName[signal]) signalsByName[signal].push(meta);
    else signalsByName[signal] = [
        meta
    ];
};
const $32b8235f7373c763$var$initCySignals = ()=>{
    window.cySignals = {
        signalsByName: {},
        allSignals: []
    };
};
const $32b8235f7373c763$export$a8a72bca1918549c = (signal, meta = {})=>{
    if ($32b8235f7373c763$var$isProduction()) return;
    if (!window.cySignals) $32b8235f7373c763$var$initCySignals();
    $32b8235f7373c763$var$registerSignal(signal, meta);
};

});

parcelRegister("1MlrF", function(module, exports) {

$parcel$export(module.exports, "createPushStateNavigator", () => $7831c13a1ae73fca$export$d3bf579f8e5cd838);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
const $7831c13a1ae73fca$var$PUSH_STATE_NAVIGATOR_MODULE = 'servicedesk/internal-api/core/util/push-state-navigator/push-state-navigator';
// Try to require push-state-navigator over 500ms, otherwise we'll fallback.
const $7831c13a1ae73fca$var$REQUIRE_TIMEOUT = 100;
const $7831c13a1ae73fca$var$REQUIRE_RETRIES = 5;
const $7831c13a1ae73fca$export$d3bf579f8e5cd838 = ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $2BvS3.loadBridge)({
        name: $7831c13a1ae73fca$var$PUSH_STATE_NAVIGATOR_MODULE,
        timeout: $7831c13a1ae73fca$var$REQUIRE_TIMEOUT,
        tentatives: $7831c13a1ae73fca$var$REQUIRE_RETRIES
    });

});


parcelRegister("aNBkj", function(module, exports) {

$parcel$export(module.exports, "toQueueId", () => $bd51b1e2d773d6ee$export$dae52b119ebf2444);
$parcel$export(module.exports, "fromQueueId", () => $bd51b1e2d773d6ee$export$999de35c9ca8105b);
$parcel$export(module.exports, "toQueueIdString", () => $bd51b1e2d773d6ee$export$cda0e35414946580);
$parcel$export(module.exports, "fromQueueIdString", () => $bd51b1e2d773d6ee$export$cde8da12f845d56f);
$parcel$export(module.exports, "LOCAL_STORAGE_SOURCE", () => $bd51b1e2d773d6ee$export$6e21137db7aec966);
$parcel$export(module.exports, "PREFETCHER_SOURCE", () => $bd51b1e2d773d6ee$export$ce13a6c409c4db7d);
$parcel$export(module.exports, "REST_SOURCE", () => $bd51b1e2d773d6ee$export$e85fb1a0846db30f);
$parcel$export(module.exports, "SSR_SOURCE", () => $bd51b1e2d773d6ee$export$c5c05bf31a872c73);
const $bd51b1e2d773d6ee$export$dae52b119ebf2444 = (queueId)=>queueId;
const $bd51b1e2d773d6ee$export$999de35c9ca8105b = (queueId)=>queueId;
const $bd51b1e2d773d6ee$export$cda0e35414946580 = (queueId)=>$bd51b1e2d773d6ee$export$dae52b119ebf2444(Number(queueId));
const $bd51b1e2d773d6ee$export$cde8da12f845d56f = (queueId)=>$bd51b1e2d773d6ee$export$999de35c9ca8105b(queueId).toString();
const $bd51b1e2d773d6ee$export$6e21137db7aec966 = 'LOCAL_STORAGE';
const $bd51b1e2d773d6ee$export$ce13a6c409c4db7d = 'PREFETCHER';
const $bd51b1e2d773d6ee$export$e85fb1a0846db30f = 'REST';
const $bd51b1e2d773d6ee$export$c5c05bf31a872c73 = 'SSR';

});

parcelRegister("a2MDL", function(module, exports) {

$parcel$export(module.exports, "getFromLocalStorage", () => $a7ebc853463bf130$export$602bc7b349337fec);
$parcel$export(module.exports, "setInLocalStorage", () => $a7ebc853463bf130$export$e7b9840f77b6b2a4);

var $aZaPn = parcelRequire("aZaPn");

var $2IspF = parcelRequire("2IspF");
const $a7ebc853463bf130$export$f016358f0af18fa0 = (0, $aZaPn.createLocalExpirableStorageProvider)('servicedesk_queues');
const $a7ebc853463bf130$var$TIME_BEFORE_EXPIRY = 1209600000; // 14 days
const $a7ebc853463bf130$export$602bc7b349337fec = (key)=>{
    try {
        return $a7ebc853463bf130$export$f016358f0af18fa0.get(key);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        // .get() can trigger an exception due to a bug in 'storejs', where if
        // LS is not able to be read or written, it will not initialise the store.
        (0, $2IspF.default).safeWarnWithoutCustomerData('servicedesk.queues.agent-view.services', 'Local storage failure on read');
        return null;
    }
};
const $a7ebc853463bf130$export$e7b9840f77b6b2a4 = (key, value)=>{
    try {
        const now = Date.now();
        $a7ebc853463bf130$export$f016358f0af18fa0.set(key, value, now + $a7ebc853463bf130$var$TIME_BEFORE_EXPIRY);
        $a7ebc853463bf130$export$f016358f0af18fa0.removeExpiredKeys();
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        (0, $2IspF.default).safeWarnWithoutCustomerData('servicedesk.queues.agent-view.services', 'Local storage failure');
        return false;
    }
};

});
parcelRegister("aZaPn", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageProvider", () => $e83d7abe46867842$export$697e65b1658f821b);
$parcel$export(module.exports, "createLocalExpirableStorageProvider", () => $e83d7abe46867842$export$59acef2b3ab1df90);

var $jqvCZ = parcelRequire("jqvCZ");

var $avHyR = parcelRequire("avHyR");

var $kkXA4 = parcelRequire("kkXA4");
const $e83d7abe46867842$export$697e65b1658f821b = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>(0, $avHyR.createStorageProvider)(appPrefix, (0, $kkXA4.makeLocalStore)()));
const $e83d7abe46867842$export$59acef2b3ab1df90 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const store = (0, $kkXA4.makeLocalExpirableStore)();
    return store.namespace(appPrefix);
});

});
parcelRegister("avHyR", function(module, exports) {

$parcel$export(module.exports, "plugins", () => $e7af9f5944d51b15$export$8b3ca321c77fdea6);
$parcel$export(module.exports, "createStorageProvider", () => $e7af9f5944d51b15$export$8441605555fbd60c);

var $2y3XF = parcelRequire("2y3XF");

var $4b9NC = parcelRequire("4b9NC");
const $e7af9f5944d51b15$export$8b3ca321c77fdea6 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($2y3XF))),
    (0, $4b9NC.default)
];
const $e7af9f5944d51b15$export$8441605555fbd60c = (appPrefix, store)=>store.namespace(appPrefix);

});
parcelRegister("4b9NC", function(module, exports) {

$parcel$export(module.exports, "default", () => $19af1635632d325b$export$2e2bcd8739ae039);

var $guiFP = parcelRequire("guiFP");

var $gjqa4 = parcelRequire("gjqa4");
/**
 * Enhances storage operations with automated cleanup capabilities. This includes tracking
 * item timestamps for age-based cleanup, handling storage limits by removing older items,
 * and providing utility functions for managing storage contents. Designed to ensure
 * efficient use of storage space without manual intervention.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $19af1635632d325b$var$cleanUpPlugin() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, $gjqa4.NAMESPACE));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function set(superFn, key, val) {
        try {
            if (!self.hasNamespace((0, $gjqa4.NAMESPACE))) timestamps.set(key, Date.now());
            superFn();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // storage is full. Relevant only for localStorage
            if (e.code === (0, $gjqa4.LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, $gjqa4.LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                // 22 - the correct code most browsers use
                // 1014 - Firefox's code
                (0, $guiFP.default)({
                    meta: {
                        id: 'browserLocalStorageFullError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        namespace: self._namespacePrefix
                    },
                    error: e
                });
                if (self.cleanWhenFull()) self.set(superFn, key, val);
            } else {
                (0, $guiFP.default)({
                    meta: {
                        id: 'storageCleanupPluginError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        isLegacyFunction: false
                    },
                    error: e
                });
                throw e;
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function remove(superFn, key) {
        if (!self.hasNamespace((0, $gjqa4.NAMESPACE))) timestamps.remove(key);
        return superFn();
    }
    // quite stupid way of getting totals, but current library supports only this.each()
    function getTotalCount() {
        let count = 0;
        self.each(()=>{
            count += 1;
        });
        return count;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function cleanWhenFull(superFn, minAge = (0, $gjqa4.FOUR_WEEKS)) {
        const currTime = Date.now();
        const numKeysBefore = self.getTotalCount();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        self.each((_value, key)=>{
            // return correct value for current collection
            // and return null for timestamps collection
            const created = !self.hasNamespace((0, $gjqa4.NAMESPACE)) ? timestamps.get(key) : null;
            if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
        });
        const itemsRemovedCount = numKeysBefore - self.getTotalCount();
        if (!itemsRemovedCount && minAge - (0, $gjqa4.ONE_WEEK) >= (0, $gjqa4.ONE_WEEK)) return self.cleanWhenFull(minAge - (0, $gjqa4.ONE_WEEK));
        return itemsRemovedCount === 0;
    }
    return {
        set: set,
        remove: remove,
        cleanWhenFull: cleanWhenFull,
        getTotalCount: getTotalCount
    };
}
var $19af1635632d325b$export$2e2bcd8739ae039 = $19af1635632d325b$var$cleanUpPlugin;

});
parcelRegister("gjqa4", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE", () => $cf4854539b53d7dc$export$6aad947bda0f3f46);
$parcel$export(module.exports, "ONE_WEEK", () => $cf4854539b53d7dc$export$8187f416f1cc43d8);
$parcel$export(module.exports, "FOUR_WEEKS", () => $cf4854539b53d7dc$export$6e952fa7d47190cf);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", () => $cf4854539b53d7dc$export$da99ebca8f453abd);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", () => $cf4854539b53d7dc$export$ea28dfd9333cda2d);
const $cf4854539b53d7dc$export$6aad947bda0f3f46 = 'timestamps';
const $cf4854539b53d7dc$export$8187f416f1cc43d8 = 604800000;
const $cf4854539b53d7dc$export$6e952fa7d47190cf = 4 * $cf4854539b53d7dc$export$8187f416f1cc43d8;
const $cf4854539b53d7dc$export$da99ebca8f453abd = 22;
const $cf4854539b53d7dc$export$ea28dfd9333cda2d = 1014;

});



parcelRegister("kkXA4", function(module, exports) {

$parcel$export(module.exports, "makeLocalStore", () => $b4e518dc83f214e8$export$b2631085fe8db7af);
$parcel$export(module.exports, "makeLocalExpirableStore", () => $b4e518dc83f214e8$export$cf816b43e73de947);

var $2y3XF = parcelRequire("2y3XF");

var $gleLd = parcelRequire("gleLd");

var $ZGlKn = parcelRequire("ZGlKn");

var $5rWiD = parcelRequire("5rWiD");

var $gpWeB = parcelRequire("gpWeB");

var $avHyR = parcelRequire("avHyR");
const $b4e518dc83f214e8$export$b2631085fe8db7af = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($5rWiD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], (0, $avHyR.plugins));
const $b4e518dc83f214e8$export$cf816b43e73de947 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($5rWiD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($2y3XF))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gleLd)))
    ]);

});


parcelRegister("2IspF", function(module, exports) {

$parcel$export(module.exports, "default", () => $95e7f2142734ea48$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");
const $95e7f2142734ea48$var$PREFIX = '[Queues]';
/** This function logs privacy safe error.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $95e7f2142734ea48$var$safeErrorWithoutCustomerData = (location, message, event)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData(location, `${$95e7f2142734ea48$var$PREFIX} ${message}`, event);
};
/** This function logs privacy safe warning.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $95e7f2142734ea48$var$safeWarnWithoutCustomerData = (location, message, event)=>{
    (0, $gUUjF.default).safeWarnWithoutCustomerData(location, `${$95e7f2142734ea48$var$PREFIX} ${message}`, event);
};
/** This function logs privacy safe info.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $95e7f2142734ea48$var$safeInfoWithoutCustomerData = (location, message, event)=>{
    (0, $gUUjF.default).safeInfoWithoutCustomerData(location, `${$95e7f2142734ea48$var$PREFIX} ${message}`, event);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95e7f2142734ea48$export$2e2bcd8739ae039 = {
    safeInfoWithoutCustomerData: $95e7f2142734ea48$var$safeInfoWithoutCustomerData,
    safeWarnWithoutCustomerData: $95e7f2142734ea48$var$safeWarnWithoutCustomerData,
    safeErrorWithoutCustomerData: $95e7f2142734ea48$var$safeErrorWithoutCustomerData
};

});


parcelRegister("3RIuY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ecad685a6bf6254$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jrdvV = parcelRequire("jrdvV");

var $aNBkj = parcelRequire("aNBkj");
class $6ecad685a6bf6254$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    static setFavorite() {}
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.onFavoritesChanged = (items)=>{
            const queueItemsObj = items[0, $jrdvV.QUEUES_ITEM_TYPE];
            if (!queueItemsObj) return;
            // Object.values gives Array<mixed> according to Flow, which is wrong.
            // https://github.com/facebook/flow/issues/2221
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const queueItems = Object.values(queueItemsObj);
            // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
            queueItems.forEach((item)=>this.props.onFavoriteItemChanged((0, $aNBkj.toQueueIdString)(item.id), item.value));
        };
    }
}

});

parcelRegister("9Q5bD", function(module, exports) {

$parcel$export(module.exports, "pageToQueues", () => $251ab12b126901b1$export$8ada91ce992fa66f);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");

var $aNBkj = parcelRequire("aNBkj");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$251ab12b126901b1$export$2e2bcd8739ae039 = (rest, transformFunc)=>rest.mergeMap((payload)=>(0, $3JafE.Observable).of(transformFunc(payload)));
const $251ab12b126901b1$var$transformColumns = (responseColumns)=>responseColumns.map((responseColumn)=>{
        const column = {
            id: responseColumn.fieldId,
            title: responseColumn.title,
            fieldType: responseColumn.fieldType,
            sortable: responseColumn.sortable
        };
        if (responseColumn.sortOrder) return {
            ...column,
            currentSorting: responseColumn.sortOrder
        };
        return column;
    });
const $251ab12b126901b1$export$8ada91ce992fa66f = (page)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    page.reduce((acc, queue)=>{
        acc[queue.id] = {
            id: (0, $aNBkj.toQueueId)(queue.id),
            name: queue.name,
            jql: queue.jql,
            completeJql: queue.completeJql,
            order: queue.order,
            columns: $251ab12b126901b1$var$transformColumns(queue.columnsDetails),
            // British spelling from legacy Backend code
            isFavorite: queue.favourite,
            category: queue.category,
            canBeHidden: queue.canBeHidden
        };
        return acc;
    }, {});
const $251ab12b126901b1$export$9fd203f323102996 = (prefetchData, queues)=>{
    if (queues === undefined) return [];
    // @ts-expect-error - TS2322 - Type '{ favourite: boolean; columns: string[]; columnsDetails: { title: string; fieldType: string; sortable: boolean; fieldId: string; sortOrder: SortOrder | undefined; }[]; id: number; name: string; ... 8 more ...; shouldSkipIssueCountRefresh?: boolean | undefined; }[]' is not assignable to type 'Page[]'.
    return Object.keys(queues).map((queueId)=>{
        const updatedQueue = queues[queueId];
        const { isFavorite: isFavorite, columns: columns, isTransient: isTransient, ...queuesData } = updatedQueue;
        const cachedPage = prefetchData.find((q)=>String(q.id) === queueId);
        return {
            ...cachedPage,
            ...queuesData,
            favourite: isFavorite,
            columns: columns.map(({ id: id })=>id),
            columnsDetails: columns.map(({ id: id, currentSorting: currentSorting, ...remaining })=>({
                    fieldId: id,
                    sortOrder: currentSorting,
                    ...remaining
                }))
        };
    });
};
const $251ab12b126901b1$export$4906aa3ec3919ad9 = ()=>window.JSD_QUEUES_PRELOAD_PROMISES && window.JSD_QUEUES_PRELOAD_PROMISES.queues;
const $251ab12b126901b1$export$17bdd949b6a9952 = ()=>{
    if (window.JSD_QUEUES_PRELOAD_PROMISES) window.JSD_QUEUES_PRELOAD_PROMISES.queues = undefined;
};

});


parcelRegister("9GzdM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3af95322b447f872$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $jc7VN = parcelRequire("jc7VN");
var $3af95322b447f872$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $jc7VN.default));

});
parcelRegister("jc7VN", function(module, exports) {

$parcel$export(module.exports, "default", () => $667f4392b1198f8d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6HC1D = parcelRequire("6HC1D");

var $3NCZx = parcelRequire("3NCZx");

var $4yH5W = parcelRequire("4yH5W");

var $iyZnb = parcelRequire("iyZnb");

var $i8xmR = parcelRequire("i8xmR");
const $667f4392b1198f8d$var$findQueue = (source, id)=>(0, $6HC1D.getIn)(source, [
        'data',
        id
    ]);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$667f4392b1198f8d$export$2e2bcd8739ae039 = ({ queueId: queueId, queuesDataSource: queuesDataSource, baseUrl: baseUrl, projectKey: projectKey, children: children, intl: { formatMessage: formatMessage } })=>{
    const lastUnfoundQueue = (0, $eUqFw.useRef)('');
    if (queuesDataSource.loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4yH5W.default), null);
    const queue = $667f4392b1198f8d$var$findQueue(queuesDataSource, queueId);
    if (queue) {
        lastUnfoundQueue.current = '';
        (0, $iyZnb.setLastVisitedQueueIdAndCategory)(queue.id, projectKey, queue.category);
        return children(queue);
    }
    if (lastUnfoundQueue.current === queueId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3NCZx.default), {
        header: formatMessage((0, $i8xmR.default).notFoundHeader),
        description: formatMessage((0, $i8xmR.default).notFoundDescription),
        onRetry: ()=>{
            // If data source errors out let user retry the current page they are on.
            // Otherwise queue doesn't exist so go back to /queues
            if (queuesDataSource.error) window.location.reload();
            else window.location.assign(`${baseUrl}/jira/servicedesk/projects/${projectKey}/queues`);
        }
    });
    lastUnfoundQueue.current = queueId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4yH5W.default), null);
};

});
parcelRegister("3NCZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cbb1e7780288e8f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $1ybV0 = parcelRequire("1ybV0");

var $giAhk = parcelRequire("giAhk");

var $4zP5Y = parcelRequire("4zP5Y");

var $80J5A = parcelRequire("80J5A");

var $eQdlC = parcelRequire("eQdlC");
function $0cbb1e7780288e8f$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($4zP5Y))) : (0, (/*@__PURE__*/$parcel$interopDefault($80J5A)));
    const isAssetConsolidation = (0, $1ybV0.ff)('jfe-asset-consolidation-itsm-agni_po996');
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (isAssetConsolidation) {
        if (renderErrorImage) imageUrl = undefined;
        else imageUrl = fallbackImage;
    } else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        testId: "common-components-error-state.empty-state",
        size: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage
    });
}
$0cbb1e7780288e8f$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $eQdlC.default).retry
};
var $0cbb1e7780288e8f$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($0cbb1e7780288e8f$export$edf27be85e5f6da0);

});
parcelRegister("4zP5Y", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("80J5A", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("eQdlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc26b353252dab4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8bc26b353252dab4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("4yH5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $055eb3d48c7bfa62$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
// No delay on this spinner; we don't know if the monolith had previously
// provided one. Better to increase risk a very brief display of a spinner
// than have the spinner vanish and return.
const $055eb3d48c7bfa62$var$LoadingSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($055eb3d48c7bfa62$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large",
        testId: "servicedesk-common.ui.components.page-spinner.spinner"
    }));
var $055eb3d48c7bfa62$export$2e2bcd8739ae039 = $055eb3d48c7bfa62$var$LoadingSpinner;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $055eb3d48c7bfa62$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _154i1jfw _1bsb1osq _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iyZnb", function(module, exports) {

$parcel$export(module.exports, "getLastVisitedQueueIdAndCategory", () => $2202aa85cc588865$export$b5b4407b2529d2c4);
$parcel$export(module.exports, "setLastVisitedQueueIdAndCategory", () => $2202aa85cc588865$export$947aff127337ffa5);

var $8blac = parcelRequire("8blac");

var $aNBkj = parcelRequire("aNBkj");

var $a2MDL = parcelRequire("a2MDL");

var $f1lMr = parcelRequire("f1lMr");

var $fDE9L = parcelRequire("fDE9L");
const $2202aa85cc588865$var$LAST_VISITED_QUEUE_KEY_PREFIX = 'last_visited_queue';
const $2202aa85cc588865$var$LAST_VISITED_CATEGORY_KEY_PREFIX = 'last_visited_category';
const $2202aa85cc588865$export$b5b4407b2529d2c4 = (projectKey, category = (0, $f1lMr.NO_CATEGORY))=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(projectKey)) return [
        null,
        null
    ];
    try {
        if (category === (0, $f1lMr.NO_CATEGORY)) {
            // indicates a redirect from /queues endpoint
            const categoryToRedirectTo = (0, $a2MDL.getFromLocalStorage)(`${$2202aa85cc588865$var$LAST_VISITED_CATEGORY_KEY_PREFIX}_${projectKey}`);
            const queueId = (0, $a2MDL.getFromLocalStorage)(`${$2202aa85cc588865$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${categoryToRedirectTo}`);
            return [
                queueId,
                ...(0, $fDE9L.isValidItsmPractice)(categoryToRedirectTo) ? [
                    categoryToRedirectTo
                ] : [
                    (0, $f1lMr.NO_CATEGORY)
                ]
            ];
        }
        return [
            (0, $a2MDL.getFromLocalStorage)(`${$2202aa85cc588865$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`),
            category
        ];
    } catch (error) {
        return [
            null,
            null
        ];
    }
};
const $2202aa85cc588865$export$947aff127337ffa5 = (queueId, projectKey, category = (0, $f1lMr.NO_CATEGORY))=>{
    let lastVisitedQueueId;
    try {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(projectKey)) throw new Error('project key is empty');
        lastVisitedQueueId = (0, $a2MDL.getFromLocalStorage)(`${$2202aa85cc588865$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`);
    } catch (error) {
        lastVisitedQueueId = null;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(projectKey) && lastVisitedQueueId !== queueId) try {
        (0, $a2MDL.setInLocalStorage)(`${$2202aa85cc588865$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`, (0, $aNBkj.fromQueueIdString)(queueId));
        (0, $a2MDL.setInLocalStorage)(`${$2202aa85cc588865$var$LAST_VISITED_CATEGORY_KEY_PREFIX}_${projectKey}`, category);
    } catch (error) {
    // Don't care if it fails. Default behavior in QueuesRedirect will take users to first available queue.
    }
};

});
parcelRegister("fDE9L", function(module, exports) {

$parcel$export(module.exports, "toItsmPractice", () => $535b295fef57b491$export$1b27246f3c7494c);
$parcel$export(module.exports, "isValidItsmPractice", () => $535b295fef57b491$export$357b94e419749e3d);

var $f1lMr = parcelRequire("f1lMr");
const $535b295fef57b491$export$1b27246f3c7494c = (practiceString)=>{
    switch(practiceString){
        case 'incidents':
            return 0, $f1lMr.INCIDENTS;
        case 'changes':
            return 0, $f1lMr.CHANGES;
        case 'service-requests':
            return 0, $f1lMr.SERVICE_REQUEST;
        case 'problems':
            return 0, $f1lMr.PROBLEMS;
        case 'post-incident-reviews':
            return 0, $f1lMr.POST_INCIDENT_REVIEWS;
        default:
            return 0, $f1lMr.NO_CATEGORY;
    }
};
const $535b295fef57b491$export$357b94e419749e3d = (practiceString)=>{
    switch(practiceString){
        case 0, $f1lMr.INCIDENTS:
        case 0, $f1lMr.CHANGES:
        case 0, $f1lMr.SERVICE_REQUEST:
        case 0, $f1lMr.PROBLEMS:
        case 0, $f1lMr.POST_INCIDENT_REVIEWS:
        case 0, $f1lMr.NO_CATEGORY:
            return true;
        default:
            return false;
    }
};

});


parcelRegister("i8xmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7a1d79592523d6a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e7a1d79592523d6a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    notFoundHeader: {
        "id": "servicedesk-queues-available-queues-api.queue-provider.not-found-header",
        "defaultMessage": "We couldn't find your queue"
    },
    notFoundDescription: {
        "id": "servicedesk-queues-available-queues-api.queue-provider.not-found-description",
        "defaultMessage": "Looks like we\u2019re having trouble connecting, or it may have been removed."
    }
});

});



parcelRegister("1L8BM", function(module, exports) {

$parcel$export(module.exports, "useCategorizedNavItems", () => $93f34f3b432efde9$export$fec6561bcaa1c55b);
$parcel$export(module.exports, "useCurrentCategorizedNavItems", () => $93f34f3b432efde9$export$f9b7a4e20c09f3ce);
$parcel$export(module.exports, "useCategorizedQueues", () => $93f34f3b432efde9$export$c4ca47ba8c81dba6);
$parcel$export(module.exports, "useFavouriteNavItems", () => $93f34f3b432efde9$export$e27d61833d43b175);
$parcel$export(module.exports, "useCanBeHiddenNavItems", () => $93f34f3b432efde9$export$528be43f76fe19f7);
$parcel$export(module.exports, "useAlwaysVisibleNavItems", () => $93f34f3b432efde9$export$4c168500ca36ad18);
$parcel$export(module.exports, "usePracticeMetadata", () => $93f34f3b432efde9$export$f857eeb50ae9b1b2);
$parcel$export(module.exports, "usePracticeList", () => $93f34f3b432efde9$export$216a9245ead6e18a);
$parcel$export(module.exports, "CategorizedQueuesStore", () => $93f34f3b432efde9$export$5577ca8a6b2fed3c);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $hRe6W = parcelRequire("hRe6W");

var $f1lMr = parcelRequire("f1lMr");

var $5OEre = parcelRequire("5OEre");

var $lvy2i = parcelRequire("lvy2i");

var $2htGg = parcelRequire("2htGg");
const $93f34f3b432efde9$var$useCategorizedData = (category, dataSelector, customContext)=>{
    const { data: allData, loading: loading, error: error, refresh: refresh } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $hRe6W.queuesNavigationItems), customContext);
    const memoizedData = (0, $eUqFw.useMemo)(()=>dataSelector(allData, category), [
        allData,
        category,
        dataSelector
    ]);
    return [
        memoizedData,
        loading,
        error,
        refresh
    ];
};
const $93f34f3b432efde9$export$fec6561bcaa1c55b = (baseUrl, projectKey, category = (0, $f1lMr.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2htGg.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error, refresh] = $93f34f3b432efde9$var$useCategorizedData(category, (0, $lvy2i.navDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods,
        refresh
    ];
};
const $93f34f3b432efde9$export$f9b7a4e20c09f3ce = ()=>{
    const projectKey = (0, $5OEre.useProjectKey)();
    const category = (0, $5OEre.useCurrentCategory)();
    const [data, loading, error, methods] = $93f34f3b432efde9$export$c4ca47ba8c81dba6('', projectKey, category);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $93f34f3b432efde9$export$1dc9816387d038aa = (baseUrl, projectKey, category = (0, $f1lMr.NO_CATEGORY))=>{
    const [methods] = (0, $2htGg.useCategorizedActions)(baseUrl, projectKey, category);
    const [data, loading, error] = $93f34f3b432efde9$var$useCategorizedData(category, (0, $lvy2i.notFavouriteDataSelector));
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $93f34f3b432efde9$export$e27d61833d43b175 = (baseUrl, projectKey, category = (0, $f1lMr.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2htGg.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error] = $93f34f3b432efde9$var$useCategorizedData(category, (0, $lvy2i.favouriteDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $93f34f3b432efde9$export$528be43f76fe19f7 = (baseUrl, projectKey, category = (0, $f1lMr.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2htGg.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error] = $93f34f3b432efde9$var$useCategorizedData(category, (0, $lvy2i.notFavouriteAndCanBeHiddenDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $93f34f3b432efde9$export$4c168500ca36ad18 = (baseUrl, projectKey, category = (0, $f1lMr.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $2htGg.useCategorizedActions)(baseUrl, projectKey, category, customContext);
    const [data, loading, error] = $93f34f3b432efde9$var$useCategorizedData(category, (0, $lvy2i.cannotBeHiddenAndNotFavouriteDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $93f34f3b432efde9$export$c4ca47ba8c81dba6 = (baseUrl, projectKey, category = (0, $f1lMr.NO_CATEGORY))=>{
    const [methods] = (0, $2htGg.useCategorizedActions)(baseUrl, projectKey, category);
    const [data, loading, error] = $93f34f3b432efde9$var$useCategorizedData(category, (0, $lvy2i.queuesDataSelector));
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $93f34f3b432efde9$export$f857eeb50ae9b1b2 = (category = (0, $f1lMr.NO_CATEGORY), customContext)=>$93f34f3b432efde9$var$useCategorizedData(category, (0, $lvy2i.practiceMetadataSelector), customContext);
const $93f34f3b432efde9$export$216a9245ead6e18a = (customContext)=>$93f34f3b432efde9$var$useCategorizedData((0, $f1lMr.NO_CATEGORY), (0, $lvy2i.practiceListSelector), customContext);
const $93f34f3b432efde9$export$5577ca8a6b2fed3c = ({ baseUrl: baseUrl, projectKey: projectKey, category: category, children: children })=>{
    const [data, loading, error, methods] = $93f34f3b432efde9$export$c4ca47ba8c81dba6(baseUrl, projectKey, category);
    return children({
        data: data,
        loading: loading,
        error: error,
        methods: methods
    });
};
const $93f34f3b432efde9$export$aea9dc5735ed30c = ({ baseUrl: baseUrl, projectKey: projectKey, category: category, children: children })=>{
    const [data, loading, error, methods] = $93f34f3b432efde9$export$fec6561bcaa1c55b(baseUrl, projectKey, category);
    return children({
        data: data,
        loading: loading,
        error: error,
        methods: methods
    });
};
$93f34f3b432efde9$export$5577ca8a6b2fed3c.defaultProps = {
    category: (0, $f1lMr.NO_CATEGORY)
};
$93f34f3b432efde9$export$aea9dc5735ed30c.defaultProps = {
    category: (0, $f1lMr.NO_CATEGORY)
};

});
parcelRegister("5OEre", function(module, exports) {

$parcel$export(module.exports, "getQueuesForCategory", () => $e80fc5c8437d321b$export$fcf9c653a5f7167a);
$parcel$export(module.exports, "setQueuesForCategory", () => $e80fc5c8437d321b$export$7ca50bfd96f22f76);
$parcel$export(module.exports, "queuesToNavItems", () => $e80fc5c8437d321b$export$e6491f132367997c);
$parcel$export(module.exports, "useProjectKey", () => $e80fc5c8437d321b$export$f87be37f8e8be65);
$parcel$export(module.exports, "useCurrentCategory", () => $e80fc5c8437d321b$export$e42116f2f5c27c35);

var $6HC1D = parcelRequire("6HC1D");

var $2bMHt = parcelRequire("2bMHt");

var $fDE9L = parcelRequire("fDE9L");

var $6vrw7 = parcelRequire("6vrw7");

var $lB25E = parcelRequire("lB25E");
const $e80fc5c8437d321b$export$fcf9c653a5f7167a = (data, category)=>(0, $6HC1D.getIn)(data, [
        category,
        'queues'
    ]);
const $e80fc5c8437d321b$export$7ca50bfd96f22f76 = (data, category, newQueues)=>// @ts-expect-error(PARTIAL_RECORD) TS2740 - Type '{}' is missing the following properties from type 'CategorizedQueueData': "change-management", "incident-management", "problem-management", "service-request", and 2 more.
    (0, $6HC1D.updateIn)(data || {}, [
        category,
        'queues'
    ], (queues)=>{
        // We only want to update queues if they exist in a category already
        if (queues) return newQueues;
        throw new Error(`${category} does not exist in resource`);
    });
const $e80fc5c8437d321b$export$e6491f132367997c = (queues)=>queues.map(({ id: id, name: name, projectKey: projectKey, count: count, category: category, favourite: favourite, canBeHidden: canBeHidden, shouldSkipIssueCountRefresh: shouldSkipIssueCountRefresh, lastRefreshedTime: lastRefreshedTime })=>({
            id: String(id),
            name: name,
            url: `/projects/${projectKey}/${(0, $2bMHt.getQueueFragment)(id, category)}`,
            badgeCount: count,
            starred: favourite,
            canBeHidden: canBeHidden,
            shouldSkipIssueCountRefresh: shouldSkipIssueCountRefresh,
            category: category,
            lastRefreshedTime: lastRefreshedTime
        }));
const $e80fc5c8437d321b$export$f87be37f8e8be65 = ()=>{
    const [{ match: match }] = (0, $lB25E.useRouter)();
    return (0, $6vrw7.toProjectKey)(match.params.projectKey || '');
};
const $e80fc5c8437d321b$export$e42116f2f5c27c35 = ()=>{
    const [{ match: match }] = (0, $lB25E.useRouter)();
    return (0, $fDE9L.toItsmPractice)(match.params.practiceType);
};

});

parcelRegister("lvy2i", function(module, exports) {

$parcel$export(module.exports, "queuesDataSelector", () => $a719d5cd2d3098d5$export$fe10e38dc2f0e4c8);
$parcel$export(module.exports, "navDataSelector", () => $a719d5cd2d3098d5$export$caf8de9cbdbf9102);
$parcel$export(module.exports, "notFavouriteAndCanBeHiddenDataSelector", () => $a719d5cd2d3098d5$export$231e113a2e075013);
$parcel$export(module.exports, "notFavouriteDataSelector", () => $a719d5cd2d3098d5$export$46aa703ec1a01e);
$parcel$export(module.exports, "cannotBeHiddenAndNotFavouriteDataSelector", () => $a719d5cd2d3098d5$export$f28545acfde3f70e);
$parcel$export(module.exports, "favouriteDataSelector", () => $a719d5cd2d3098d5$export$fc3fab89f453b08e);
$parcel$export(module.exports, "practiceMetadataSelector", () => $a719d5cd2d3098d5$export$b0af22bb6bff9c49);
$parcel$export(module.exports, "isCountLoadingSelector", () => $a719d5cd2d3098d5$export$efbcd30acb5e816f);
$parcel$export(module.exports, "hasRequestedCountSelector", () => $a719d5cd2d3098d5$export$54e54a1ac5e7098f);
$parcel$export(module.exports, "practiceListSelector", () => $a719d5cd2d3098d5$export$61d9fd7be029b514);

var $6HC1D = parcelRequire("6HC1D");

var $5OEre = parcelRequire("5OEre");
const $a719d5cd2d3098d5$export$fe10e38dc2f0e4c8 = (data, category)=>(0, $5OEre.getQueuesForCategory)(data, category) || null;
const $a719d5cd2d3098d5$export$caf8de9cbdbf9102 = (data, category)=>{
    const queues = (0, $5OEre.getQueuesForCategory)(data, category);
    return queues ? (0, $5OEre.queuesToNavItems)(queues) : null;
};
const $a719d5cd2d3098d5$export$231e113a2e075013 = (data, category)=>{
    const queues = (0, $5OEre.getQueuesForCategory)(data, category);
    const otherQueuesData = queues ? queues.filter((q)=>q.canBeHidden && !q.favourite) : null;
    return otherQueuesData ? (0, $5OEre.queuesToNavItems)(otherQueuesData) : null;
};
const $a719d5cd2d3098d5$export$46aa703ec1a01e = (data, category)=>{
    const queues = (0, $5OEre.getQueuesForCategory)(data, category);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const otherQueuesData = queues ? queues.filter((q)=>!q.favourite) : null;
    return otherQueuesData ? (0, $5OEre.queuesToNavItems)(otherQueuesData) : null;
};
const $a719d5cd2d3098d5$export$f28545acfde3f70e = (data, category)=>{
    const queues = (0, $5OEre.getQueuesForCategory)(data, category);
    const defaultQueuesData = queues ? queues.filter((q)=>!q.canBeHidden && !q.favourite) : null;
    return defaultQueuesData ? (0, $5OEre.queuesToNavItems)(defaultQueuesData) : null;
};
const $a719d5cd2d3098d5$export$fc3fab89f453b08e = (data, category)=>{
    const queues = (0, $5OEre.getQueuesForCategory)(data, category);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const starredQueues = queues ? queues.filter((q)=>q.favourite) : null;
    return starredQueues ? (0, $5OEre.queuesToNavItems)(starredQueues) : null;
};
const $a719d5cd2d3098d5$export$b0af22bb6bff9c49 = (data, category)=>{
    const practiceData = (0, $6HC1D.getIn)(data, [
        category
    ]);
    return practiceData ? (0, $6HC1D.dissoc)(practiceData, 'queues') : null;
};
const $a719d5cd2d3098d5$export$efbcd30acb5e816f = (data, category)=>{
    const practiceData = (0, $6HC1D.getIn)(data, [
        category
    ]);
    return practiceData ? practiceData.isCountLoading : false;
};
const $a719d5cd2d3098d5$export$54e54a1ac5e7098f = (data, category)=>{
    const practiceData = (0, $6HC1D.getIn)(data, [
        category
    ]);
    return practiceData ? practiceData.hasRequestedCount : false;
};
const $a719d5cd2d3098d5$export$61d9fd7be029b514 = (data)=>// @ts-expect-error - TS2322 - Type 'string[] | null' is not assignable to type 'Data<ItsmPractice[]>'.
    data ? Object.keys(data) : null;

});

parcelRegister("2htGg", function(module, exports) {

$parcel$export(module.exports, "useCategorizedActions", () => $f77abdc2734c705f$export$8632bfeb0b672958);
$parcel$export(module.exports, "default", () => $f77abdc2734c705f$export$2e2bcd8739ae039);

var $iZJHG = parcelRequire("iZJHG");

var $hRe6W = parcelRequire("hRe6W");

var $g2iRM = parcelRequire("g2iRM");
const $f77abdc2734c705f$export$8632bfeb0b672958 = (baseUrl, projectKey, category, customContext)=>{
    const { update: update } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $hRe6W.queuesNavigationItems), customContext);
    const cachedActions = (0, $g2iRM.default)(category, update, {
        baseUrl: baseUrl,
        projectKey: projectKey
    });
    return [
        cachedActions
    ];
};
const $f77abdc2734c705f$var$ActionsProvider = ({ baseUrl: baseUrl, projectKey: projectKey, category: category, children: children })=>{
    const [actions] = $f77abdc2734c705f$export$8632bfeb0b672958(baseUrl, projectKey, category);
    return children(actions);
};
var $f77abdc2734c705f$export$2e2bcd8739ae039 = $f77abdc2734c705f$var$ActionsProvider;

});
parcelRegister("g2iRM", function(module, exports) {

$parcel$export(module.exports, "default", () => $29b1c6018b6f5b00$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $WBLbN = parcelRequire("WBLbN");

var $3uRX3 = parcelRequire("3uRX3");
const $29b1c6018b6f5b00$export$36d128238e6b60f5 = {
    currentCacheKey: '',
    // @ts-expect-error(PARTIAL_RECORD) TS2740 - Type '{}' is missing the following properties from type 'Record<ItsmPractice, ChildrenProps>': "change-management", "incident-management", "problem-management", "service-request", and 2 more.
    actionsByCategory: {}
};
const $29b1c6018b6f5b00$export$8b3bc28eb06c49b6 = {
    // Actions are lazily created for each category of a project.
    // Project key is used as the cache key. Once the cache key has changed
    // the store will be reset
    getActions: (...args)=>({ getState: getState, setState: setState })=>{
            const [category, , { projectKey: projectKey }] = args;
            const { currentCacheKey: currentCacheKey, actionsByCategory: actionsByCategory } = getState();
            const categoryActions = actionsByCategory[category];
            const hasSameKey = projectKey === currentCacheKey;
            if (hasSameKey && Boolean(categoryActions)) return categoryActions;
            const newCategoryActions = (0, $3uRX3.getActions)(...args);
            setState({
                currentCacheKey: projectKey,
                // @ts-expect-error(PARTIAL_RECORD) TS2322 - Type '{ "change-management"?: Actions | undefined; "incident-management"?: Actions | undefined; "problem-management"?: Actions | undefined; "service-request"?: Actions | undefined; "post-incident-review"?: Actions | undefined; "no-category"?: Actions | undefined; }' is not assignable to type 'Record<ItsmPractice, ChildrenProps>'.
                actionsByCategory: {
                    ...hasSameKey ? actionsByCategory : {},
                    [category]: newCategoryActions
                }
            });
            return newCategoryActions;
        }
};
const $29b1c6018b6f5b00$var$Store = (0, $WBLbN.createStore)({
    initialState: $29b1c6018b6f5b00$export$36d128238e6b60f5,
    actions: $29b1c6018b6f5b00$export$8b3bc28eb06c49b6,
    name: 'jira-servicedesk-categorized-queues-actions-store'
});
const $29b1c6018b6f5b00$var$useActionsStore = (0, $WBLbN.createHook)($29b1c6018b6f5b00$var$Store, {
    selector: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});
const $29b1c6018b6f5b00$export$193cb0fec61d3692 = (...args)=>{
    const [, { getActions: getActions }] = $29b1c6018b6f5b00$var$useActionsStore();
    return getActions(...args);
};
var $29b1c6018b6f5b00$export$2e2bcd8739ae039 = $29b1c6018b6f5b00$export$193cb0fec61d3692;

});
parcelRegister("3uRX3", function(module, exports) {

$parcel$export(module.exports, "getActions", () => $b6785e02894533d1$export$fe3955935f564b31);

var $6HC1D = parcelRequire("6HC1D");

var $a576Y = parcelRequire("a576Y");


var $1ybV0 = parcelRequire("1ybV0");

var $JRB5w = parcelRequire("JRB5w");

var $9U7QG = parcelRequire("9U7QG");

var $kzu7k = parcelRequire("kzu7k");

var $4czDf = parcelRequire("4czDf");

var $5OEre = parcelRequire("5OEre");

var $lvy2i = parcelRequire("lvy2i");

var $8tcOM = parcelRequire("8tcOM");

var $kG021 = parcelRequire("kG021");
const $b6785e02894533d1$var$throttleNavItemsRefreshRate = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('jsm.dynamic.queues.issue.count.refresh.interval', '60000', [
        '60000',
        '120000',
        '300000',
        '90000',
        '86400000'
    ]);
const $b6785e02894533d1$var$getThrottledRefresh = ()=>Number($b6785e02894533d1$var$throttleNavItemsRefreshRate());
const $b6785e02894533d1$var$getAnalyticsPayload = (err)=>{
    const wasQueueDeleted = err?.statusCode === (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef);
    const queueConflictOccurred = err?.statusCode === (0, $1c3fbb431a173cc6$export$c09e7ea0fc79f34f);
    const queueActionNotPermitted = err?.statusCode === (0, $1c3fbb431a173cc6$export$a3269a3914b007e3);
    return {
        wasQueueDeleted: wasQueueDeleted,
        queueConflictOccurred: queueConflictOccurred,
        queueActionNotPermitted: queueActionNotPermitted,
        isClientFetchError: (0, $JRB5w.isClientFetchError)(err)
    };
};
const $b6785e02894533d1$export$fe3955935f564b31 = (category, update, restParams)=>{
    const actions = {
        addItem: (item)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) return (0, $5OEre.setQueuesForCategory)(data, category, (0, $kG021.addItem)(queues, item));
                throw new Error(`Cannot add item because ${category} does not exist in resource`);
            });
        },
        deleteItem: (id)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) return (0, $5OEre.setQueuesForCategory)(data, category, (0, $kG021.deleteItem)(queues, id));
                throw new Error(`Cannot delete item because ${category} does not exist in resource`);
            });
        },
        editItem: (item)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) return (0, $5OEre.setQueuesForCategory)(data, category, (0, $kG021.editItem)(queues, item));
                throw new Error(`Cannot edit item because ${category} does not exist in resource`);
            });
        },
        moveItem: (from, to)=>{
            if (from !== to) update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kG021.moveItem)(queues, from, to);
                    (0, $kzu7k.setQueues)(baseUrl, projectKey, (0, $5OEre.queuesToNavItems)(result), category);
                    return (0, $5OEre.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item because ${category} does not exist in resource`);
            });
        },
        moveItemBelow: (queueId, targetQueueId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kG021.moveItemBelow)(queues, queueId, targetQueueId);
                    (0, $kzu7k.setQueues)(baseUrl, projectKey, (0, $5OEre.queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($b6785e02894533d1$var$getAnalyticsPayload(err)));
                    return (0, $5OEre.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item below because ${category} does not exist in resource`);
            });
        },
        moveItemAbove: (queueId, targetQueueId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kG021.moveItemAbove)(queues, queueId, targetQueueId);
                    (0, $kzu7k.setQueues)(baseUrl, projectKey, (0, $5OEre.queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($b6785e02894533d1$var$getAnalyticsPayload(err)));
                    return (0, $5OEre.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item above because ${category} does not exist in resource`);
            });
        },
        moveToTop: (queueId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) {
                    const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                    const result = (0, $kG021.moveToTop)(queues, queueId);
                    (0, $kzu7k.setQueues)(baseUrl, projectKey, (0, $5OEre.queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($b6785e02894533d1$var$getAnalyticsPayload(err)));
                    return (0, $5OEre.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item to top because ${category} does not exist in resource`);
            });
        },
        refreshNavItems: (0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))((analyticsEvent)=>{
            setTimeout(()=>{
                update((data)=>{
                    const isCountLoading = (0, $lvy2i.isCountLoadingSelector)(data, category);
                    if (isCountLoading) return data;
                    if (restParams.projectKey) (0, $8tcOM.refreshIssueCountForVisibleAndStarredQueues)(update, {
                        ...restParams,
                        category: category
                    }, analyticsEvent);
                    const updatedData = data ? (0, $6HC1D.assocIn)(data, [
                        category,
                        'isCountLoading'
                    ], true) : null;
                    return updatedData;
                });
            // Jitter the call randomly between 1 - 5secs in case of multiple tab requests
            }, Math.floor(Math.random() * 5000) + 1000);
        }, $b6785e02894533d1$var$getThrottledRefresh()),
        initialFetchNavItems: (analyticsEvent)=>{
            update((data)=>{
                const isCountLoading = (0, $lvy2i.isCountLoadingSelector)(data, category);
                const hasRequestedCount = (0, $lvy2i.hasRequestedCountSelector)(data, category);
                if (!isCountLoading && !hasRequestedCount) actions.refreshNavItems(analyticsEvent);
                return data;
            });
        },
        refreshIssueCountForItems: (queueIds, analyticsEvent)=>{
            (0, $8tcOM.refreshIssueCountForQueues)(update, {
                ...restParams,
                category: category
            }, queueIds, analyticsEvent);
        },
        editItemIssueCount: (id, count)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) return (0, $5OEre.setQueuesForCategory)(data, category, (0, $kG021.editItem)(queues, {
                    id: Number(id),
                    count: count,
                    lastRefreshedTime: Date.now()
                }));
                // There is no point update the issue-counts for default queue as there is no queues.
                // It might throwing exceptions if we cannot fetch queue categories.
                // Being defensive here for the rollout, if this code throw any errors, it's the same behavior as the below line.
                if (Number(id) === (0, $9U7QG.DEFAULT_QUEUE_ID)) return data;
                throw new Error(`Cannot edit item issue count because ${category} does not exist in resource for queue id ${id}`);
            });
        },
        editItemFavorite: (id, favourite)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) return (0, $5OEre.setQueuesForCategory)(data, category, (0, $kG021.editItem)(queues, {
                    id: Number(id),
                    favourite: favourite
                }));
                throw new Error(`Cannot edit item favorite because ${category} does not exist in resource`);
            });
        },
        editVisibilityOfItems: (updatedItems, draggableId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                const { baseUrl: baseUrl, projectKey: projectKey } = restParams;
                if (queues) {
                    (0, $4czDf.updateQueuesVisibility)(baseUrl, projectKey, updatedItems).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($b6785e02894533d1$var$getAnalyticsPayload(err)));
                    return (0, $5OEre.setQueuesForCategory)(data, category, (0, $kG021.editItems)(queues, [
                        ...updatedItems
                    ]));
                }
                throw new Error(`Cannot edit item favorite because ${category} does not exist in resource`);
            });
        },
        enableRefreshForQueues: (queueIds)=>{
            (0, $8tcOM.enableRefreshForQueues)(update, {
                ...restParams,
                category: category
            }, queueIds);
        },
        enableIssueCountForSelectedQueues: (selectedQueueIds)=>{
            update((data)=>{
                const queues = (0, $5OEre.getQueuesForCategory)(data, category);
                if (queues) return (0, $5OEre.setQueuesForCategory)(data, category, (0, $kG021.enableSelectedQueuesVisibility)(selectedQueueIds, queues));
                throw new Error(`Cannot enable issue count for selected queues because ${category} does not exist in resource`);
            });
        }
    };
    return actions;
};

});
const $1c3fbb431a173cc6$export$ff39ebd4bb12b718 = 201;
const $1c3fbb431a173cc6$export$3288b14b6745c572 = 204;
const $1c3fbb431a173cc6$export$9de493bcd9b1d977 = 400;
const $1c3fbb431a173cc6$export$67d19e9a991baa07 = 401;
const $1c3fbb431a173cc6$export$a3269a3914b007e3 = 403;
const $1c3fbb431a173cc6$export$8bca792d963eb0ef = 404;
const $1c3fbb431a173cc6$export$4a3cb39801694eee = 407;
const $1c3fbb431a173cc6$export$fa405bbf47d510e2 = 408;
const $1c3fbb431a173cc6$export$c09e7ea0fc79f34f = 409;
const $1c3fbb431a173cc6$export$5244030134e99 = 412;
const $1c3fbb431a173cc6$export$f90ac1df0b60853d = 413;
const $1c3fbb431a173cc6$export$a447d0a965e16776 = 422;
const $1c3fbb431a173cc6$export$3b48aba8957000cd = 426;
const $1c3fbb431a173cc6$export$6763168a631449a2 = 429;
const $1c3fbb431a173cc6$export$e813cd7045fcc98d = 500;
const $1c3fbb431a173cc6$export$2ce38d41a306034e = 502;
const $1c3fbb431a173cc6$export$974c37534b0191b1 = 503;
const $1c3fbb431a173cc6$export$5400e8dddac3fcf3 = 504;

parcelRegister("9U7QG", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_COLUMNS", () => $cf96a29155ecae50$export$50c19f60b9c144f7);
$parcel$export(module.exports, "DEFAULT_QUEUE_ID", () => $cf96a29155ecae50$export$e78379cc32bff512);
$parcel$export(module.exports, "FETCH_BATCH_SIZE", () => $cf96a29155ecae50$export$baa236d86cd0d3f5);
const $cf96a29155ecae50$export$50c19f60b9c144f7 = [
    'issuetype',
    'issuekey',
    'summary',
    'reporter',
    'assignee',
    'status',
    'created'
];
const $cf96a29155ecae50$export$e78379cc32bff512 = Number.MIN_VALUE;
const $cf96a29155ecae50$export$baa236d86cd0d3f5 = 100;

});

parcelRegister("kzu7k", function(module, exports) {

$parcel$export(module.exports, "setQueues", () => $03d5e58aec24405a$export$51b06787b88b2bf2);

var $lRmyA = parcelRequire("lRmyA");

var $7nVUh = parcelRequire("7nVUh");
const $03d5e58aec24405a$var$getQueuesUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues`;
const $03d5e58aec24405a$export$51b06787b88b2bf2 = (baseUrl, projectKey, queues, category)=>(0, $lRmyA.performPutRequest)($03d5e58aec24405a$var$getQueuesUrl(baseUrl, projectKey), {
        body: JSON.stringify((0, $7nVUh.transformQueues)(queues, category))
    });

});
parcelRegister("7nVUh", function(module, exports) {

$parcel$export(module.exports, "transformQueues", () => $9f9a0a7b480d38b8$export$66ec85c65393edb4);

var $f1lMr = parcelRequire("f1lMr");
const $9f9a0a7b480d38b8$export$66ec85c65393edb4 = (queues, category)=>({
        order: queues.map((queue)=>queue.id),
        id: 'com.atlassian.servicedesk.project-ui:sd-queues-custom',
        inline: true,
        deleted: [],
        ...category && category !== (0, $f1lMr.NO_CATEGORY) ? {
            category: category
        } : undefined
    });

});


parcelRegister("4czDf", function(module, exports) {

$parcel$export(module.exports, "updateQueuesVisibility", () => $1c8d54edade9a56e$export$c0862f2fb17c23c2);

var $lRmyA = parcelRequire("lRmyA");
const $1c8d54edade9a56e$var$getUpdateQueuesVisibilityUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues/update-visibility`;
const $1c8d54edade9a56e$export$c0862f2fb17c23c2 = (baseUrl, projectKey, modified)=>(0, $lRmyA.performPutRequest)($1c8d54edade9a56e$var$getUpdateQueuesVisibilityUrl(baseUrl, projectKey), {
        body: JSON.stringify({
            modified: modified
        })
    });

});

parcelRegister("8tcOM", function(module, exports) {

$parcel$export(module.exports, "refreshIssueCountForVisibleAndStarredQueues", () => $949c92075b18bf2b$export$aaa6aeca5994daee);
$parcel$export(module.exports, "enableRefreshForQueues", () => $949c92075b18bf2b$export$6b0c14cefee3edf5);
$parcel$export(module.exports, "refreshIssueCountForQueues", () => $949c92075b18bf2b$export$b05e3887bfb123a8);

var $6HC1D = parcelRequire("6HC1D");

var $3aUuh = parcelRequire("3aUuh");

var $jG2Eu = parcelRequire("jG2Eu");

var $3G3gn = parcelRequire("3G3gn");

var $guiFP = parcelRequire("guiFP");

var $5OEre = parcelRequire("5OEre");

var $lvy2i = parcelRequire("lvy2i");

var $ddvJX = parcelRequire("ddvJX");
const $949c92075b18bf2b$export$defcbd4ba0fd3734 = 5;
const $949c92075b18bf2b$var$RETRY_DELAY_IN_MS = 1000;
const $949c92075b18bf2b$var$fireErrorAnalyticsForRetryFailure = (error)=>{
    (0, $guiFP.default)({
        meta: {
            id: 'retryQueueIssueCountAction',
            packageName: 'jiraServicedeskCategorizedQueuesStore',
            teamName: 'jsd-shield'
        },
        error: error
    });
};
const $949c92075b18bf2b$export$ef7266a9f6c0de43 = ({ baseUrl: baseUrl, projectKey: projectKey, category: category }, skipHiddenQueues, update, retryCount, analyticsEvent)=>async (queueIds)=>{
        if (queueIds && queueIds.length === 0) return;
        if (retryCount >= $949c92075b18bf2b$export$defcbd4ba0fd3734) {
            (0, $ddvJX.fireManualOperationalAnalytics)({
                source: 'refreshQueueIssueCountAction',
                actionSubject: 'retryIssueCount',
                action: 'limitExceeded',
                attributes: {
                    retryCount: retryCount,
                    maxRetryCount: $949c92075b18bf2b$export$defcbd4ba0fd3734
                }
            });
            return;
        }
        setTimeout(()=>{
            try {
                const newRetryCount = retryCount + 1;
                update((data)=>{
                    const queues = (0, $5OEre.getQueuesForCategory)(data, category)?.filter((queue)=>queueIds.includes(queue.id));
                    if (queues && queues.length > 0) {
                        const retryCallback = $949c92075b18bf2b$export$ef7266a9f6c0de43({
                            baseUrl: baseUrl,
                            projectKey: projectKey,
                            category: category
                        }, true, update, newRetryCount, analyticsEvent);
                        (0, $ddvJX.updateIssueCountForQueues)(baseUrl, projectKey, category, queues, skipHiddenQueues, update, retryCallback, analyticsEvent);
                        (0, $ddvJX.fireManualOperationalAnalytics)({
                            source: 'refreshQueueIssueCountAction',
                            actionSubject: 'retryQueueIssueCount',
                            action: 'triggered',
                            attributes: {
                                retryCount: newRetryCount,
                                maxRetryCount: $949c92075b18bf2b$export$defcbd4ba0fd3734,
                                queuesCount: queues.length
                            }
                        });
                        return data ? (0, $6HC1D.assocIn)(data, [
                            category,
                            'isCountLoading'
                        ], true) : null;
                    }
                    return data;
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                $949c92075b18bf2b$var$fireErrorAnalyticsForRetryFailure(error);
                throw error;
            }
        }, $949c92075b18bf2b$var$RETRY_DELAY_IN_MS);
    };
const $949c92075b18bf2b$export$aaa6aeca5994daee = async (update, { baseUrl: baseUrl, projectKey: projectKey, category: category }, analyticsEvent)=>{
    try {
        update((data)=>{
            const queues = (0, $5OEre.getQueuesForCategory)(data, category);
            const retryCallback = !(0, $lvy2i.hasRequestedCountSelector)(data, category) ? $949c92075b18bf2b$export$ef7266a9f6c0de43({
                baseUrl: baseUrl,
                projectKey: projectKey,
                category: category
            }, true, update, 0, analyticsEvent) : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
            if (queues) {
                (0, $ddvJX.updateIssueCountForQueues)(baseUrl, projectKey, category, queues, true, update, retryCallback, analyticsEvent);
                return data ? (0, $6HC1D.assocIn)(data, [
                    category,
                    'isCountLoading'
                ], true) : null;
            }
            return data;
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $ddvJX.fireErrorAnalyticsForRefreshCountFailure)(error);
        throw error;
    }
};
const $949c92075b18bf2b$export$6b0c14cefee3edf5 = (update, { projectKey: _, category: category }, queueIds)=>{
    update((data)=>{
        const queues = (0, $5OEre.getQueuesForCategory)(data, category);
        const refreshEnabledQueues = queues?.filter((queue)=>queueIds.includes(queue.id.toString())).map((queue)=>queue.shouldSkipIssueCountRefresh ? {
                ...queue,
                shouldSkipIssueCountRefresh: false,
                count: undefined
            } : queue);
        const queuesMap = (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(queues, 'id');
        refreshEnabledQueues?.forEach((queue)=>{
            queuesMap[queue.id] = queue;
        });
        return (0, $5OEre.setQueuesForCategory)(data, category, (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(Object.values(queuesMap), 'order'));
    });
};
const $949c92075b18bf2b$export$b05e3887bfb123a8 = async (update, { baseUrl: baseUrl, projectKey: projectKey, category: category }, queueIds, analyticsEvent)=>{
    try {
        update((data)=>{
            const queues = (0, $5OEre.getQueuesForCategory)(data, category)?.filter((queue)=>queueIds.includes(queue.id.toString()));
            if (queues && queues.length > 0) {
                (0, $ddvJX.updateIssueCountForQueues)(baseUrl, projectKey, category, queues, false, update, (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), analyticsEvent);
                return data ? (0, $6HC1D.assocIn)(data, [
                    category,
                    'isCountLoading'
                ], true) : null;
            }
            return data;
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $ddvJX.fireErrorAnalyticsForRefreshCountFailure)(error);
        throw error;
    }
};

});
parcelRegister("3aUuh", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $f2sQe = parcelRequire("f2sQe");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $24fe1f7ac78dbb37$var$keyBy = $f2sQe(function(result, value, key) {
    $3pSMu(result, key, value);
});
module.exports = $24fe1f7ac78dbb37$var$keyBy;

});

parcelRegister("ddvJX", function(module, exports) {

$parcel$export(module.exports, "fireManualOperationalAnalytics", () => $95f367cfb169c39f$export$a9301d18019c11f9);
$parcel$export(module.exports, "fireErrorAnalyticsForRefreshCountFailure", () => $95f367cfb169c39f$export$b5e2038970f91d6c);
$parcel$export(module.exports, "updateIssueCountForQueues", () => $95f367cfb169c39f$export$d436cbef77099410);

var $6HC1D = parcelRequire("6HC1D");

var $lzTt0 = parcelRequire("lzTt0");

var $3aUuh = parcelRequire("3aUuh");

var $3G3gn = parcelRequire("3G3gn");

var $hvbu2 = parcelRequire("hvbu2");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");

var $3DOEL = parcelRequire("3DOEL");

var $53c4R = parcelRequire("53c4R");

var $5OEre = parcelRequire("5OEre");
const $95f367cfb169c39f$var$ERROR_DB_TIMEOUT = 'error.db-timeout';
const $95f367cfb169c39f$var$ERROR_UNKNOWN = 'error.unknown';
const $95f367cfb169c39f$export$cf85cf6a45b00808 = {
    FAILED: 'failed',
    SUCCESS: 'success',
    PENDING: 'pending'
};
const $95f367cfb169c39f$var$MAX_ISSUECOUNT_THRESHOLD = 1000;
const $95f367cfb169c39f$export$a9301d18019c11f9 = (payload)=>(0, $3DOEL.getAnalyticsWebClient)().getInstance().sendOperationalEvent(payload);
const $95f367cfb169c39f$var$filterOutHiddenQueues = (queues)=>queues.filter((q)=>!(q.canBeHidden === undefined ? false : q.canBeHidden) || q.favourite);
const $95f367cfb169c39f$var$filterOutBadQueues = (queues)=>queues.filter((q)=>!q.shouldSkipIssueCountRefresh);
const $95f367cfb169c39f$var$getIssueCountPerGroup = (issueCounts)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(issueCounts).reduce((curr, queueId)=>{
        const res = curr;
        if (issueCounts[Number(queueId)]) {
            if (issueCounts[Number(queueId)].issueCount || issueCounts[Number(queueId)].issueCount === 0) res[Number(queueId)] = issueCounts[Number(queueId)].issueCount;
        }
        return res;
    }, {});
const $95f367cfb169c39f$var$getQueuesPerGroup = (queues, skipHiddenQueues)=>{
    const starredQueues = [];
    const defaultQueues = [];
    let toGroupQueues = queues;
    let hasSkippedQueues = false;
    if (skipHiddenQueues === true) toGroupQueues = $95f367cfb169c39f$var$filterOutHiddenQueues(queues);
    toGroupQueues = $95f367cfb169c39f$var$filterOutBadQueues(toGroupQueues);
    let queueByGroups = {};
    toGroupQueues.forEach((queue)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($lzTt0)))(queue.count) && queue.count > $95f367cfb169c39f$var$MAX_ISSUECOUNT_THRESHOLD) {
            hasSkippedQueues = true;
            return;
        }
        if (queue.favourite) starredQueues.push(queue);
        else defaultQueues.push(queue);
    });
    queueByGroups = {
        starredQueues: starredQueues,
        defaultQueues: defaultQueues
    };
    if (hasSkippedQueues) $95f367cfb169c39f$export$a9301d18019c11f9({
        source: 'refreshQueueIssueCountAction',
        actionSubject: 'queueIssueCountRefresh',
        action: 'skipped'
    });
    return queueByGroups;
};
const $95f367cfb169c39f$var$getQueuesSortByLastRefreshedTime = (queuesBeforeSort)=>{
    let queuesSortByLastRefreshedTime = [];
    const queuesSortByGroup = [
        ...queuesBeforeSort.starredQueues,
        ...queuesBeforeSort.defaultQueues
    ];
    queuesSortByLastRefreshedTime = (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(queuesSortByGroup, [
        'lastRefreshedTime'
    ]);
    return queuesSortByLastRefreshedTime;
};
const $95f367cfb169c39f$export$b5e2038970f91d6c = (error)=>{
    (0, $guiFP.default)({
        meta: {
            id: 'refreshQueueIssueCountAction',
            packageName: 'jiraServicedeskCategorizedQueuesStore',
            teamName: 'jsd-shield'
        },
        error: error
    });
};
const $95f367cfb169c39f$var$isIssueCountAlreadyFetched = (queue)=>queue.count !== undefined;
const $95f367cfb169c39f$var$getSkippedQueues = (issueCounts, queuesMap)=>Object.keys(issueCounts).map((id)=>Number(id)).filter((queueId)=>issueCounts[queueId].result === $95f367cfb169c39f$export$cf85cf6a45b00808.PENDING && !$95f367cfb169c39f$var$isIssueCountAlreadyFetched(queuesMap[queueId]));
const $95f367cfb169c39f$var$fetchIssueCountForQueueGroup = async (projectKey, queueIds)=>(0, $lRmyA.performPostRequest)(`/rest/servicedesk/1/servicedesk/${projectKey}/queues/issue-counts/refresh`, {
        body: JSON.stringify(queueIds)
    });
const $95f367cfb169c39f$var$getQueueGroupData = (queueIds, issueCounts, queuesMap, batchStartProcessingTime)=>{
    const queueRefreshData = {
        minLastRefreshTimeFromCurrentBatch: Number.MAX_VALUE,
        queueCountChanges: 0
    };
    return queueIds.reduce((changes, queueId)=>{
        if (issueCounts[queueId]) {
            if (issueCounts[queueId].issueCount !== undefined || issueCounts[queueId].issueCount === 0) {
                const queue = queuesMap[queueId];
                const currentQueueLastRefreshedTime = queue.lastRefreshedTime !== undefined && queue.lastRefreshedTime !== 0 ? queue.lastRefreshedTime : batchStartProcessingTime;
                const minLastRefreshTimeFromCurrentBatch = Math.min(changes.minLastRefreshTimeFromCurrentBatch, currentQueueLastRefreshedTime);
                const queueCountChanges = queue.count !== issueCounts[queueId].issueCount ? changes.queueCountChanges + 1 : changes.queueCountChanges;
                return {
                    minLastRefreshTimeFromCurrentBatch: minLastRefreshTimeFromCurrentBatch,
                    queueCountChanges: queueCountChanges
                };
            }
        }
        return changes;
    }, queueRefreshData);
};
const $95f367cfb169c39f$var$fetchAndUpdateCount = async (baseUrl, projectKey, queueIds, category, analyticsEvent, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
update, batchStartProcessingTime, retryCallback)=>{
    if (queueIds.length === 0) return;
    let maxQueuesPerSd = await (0, $53c4R.getLimit)((0, $53c4R.MAX_QUEUES_PER_SD));
    if (maxQueuesPerSd === null) maxQueuesPerSd = queueIds.length;
    const queueIdsToFetch = queueIds.slice(0, maxQueuesPerSd);
    const startTime = Date.now();
    await $95f367cfb169c39f$var$fetchIssueCountForQueueGroup(projectKey, queueIdsToFetch).then(({ issueCounts: issueCounts })=>{
        update((data)=>{
            const queuesMap = (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))((0, $5OEre.getQueuesForCategory)(data, category), 'id');
            const skippedQueues = $95f367cfb169c39f$var$getSkippedQueues(issueCounts, queuesMap);
            if (skippedQueues.length > 0) retryCallback(skippedQueues);
            const endTime = Date.now();
            let queueCountChanges = 0;
            let minLastRefreshTimeFromCurrentBatch = 0;
            let numberOfBadQueues = 0;
            const queueRefreshData = $95f367cfb169c39f$var$getQueueGroupData(queueIds, issueCounts, queuesMap, batchStartProcessingTime);
            queueCountChanges = queueRefreshData.queueCountChanges;
            minLastRefreshTimeFromCurrentBatch = queueRefreshData.minLastRefreshTimeFromCurrentBatch;
            queueIds.forEach((queueId)=>{
                const queue = queuesMap[queueId];
                if (issueCounts[queueId]) {
                    if (issueCounts[queueId].issueCount !== undefined || issueCounts[queueId].issueCount === 0) queuesMap[queueId] = {
                        ...queue,
                        count: issueCounts[queueId].issueCount,
                        lastRefreshedTime: endTime,
                        shouldSkipIssueCountRefresh: false
                    };
                    else if (issueCounts[queueId].errorCode === $95f367cfb169c39f$var$ERROR_DB_TIMEOUT) {
                        numberOfBadQueues += 1;
                        queuesMap[queueId] = {
                            ...queue,
                            shouldSkipIssueCountRefresh: true
                        };
                    }
                }
            });
            if (analyticsEvent) {
                const issueCountPerGroup = $95f367cfb169c39f$var$getIssueCountPerGroup(issueCounts);
                const queueIssueCounts = Object.values(issueCountPerGroup).map((queueCount)=>Number(queueCount));
                const jiraShard = (0, $6rW04.default)('ajs-shard') || '';
                if (queueIssueCounts.length === 0) (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'navigationSession poorPerformanceQueuesCountsInfo', {
                    category: category,
                    queuesRequested: queueIdsToFetch.length,
                    maxQueuesPerSd: maxQueuesPerSd,
                    timeToFetchIssueCount: endTime - startTime,
                    timeSinceBatchStart: endTime - batchStartProcessingTime,
                    jiraShard: jiraShard,
                    browserTabVisibilityState: document.visibilityState,
                    numberOfBadQueues: numberOfBadQueues
                });
                else (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'navigationSession queuesCountsInfo', {
                    category: category,
                    queues: queueIssueCounts.length,
                    queuesRequested: queueIdsToFetch.length,
                    maxQueuesPerSd: maxQueuesPerSd,
                    maxIssueCount: Math.max(...queueIssueCounts),
                    timeToFetchIssueCount: endTime - startTime,
                    timeBetweenQueueRefresh: endTime - minLastRefreshTimeFromCurrentBatch,
                    timeSinceBatchStart: endTime - batchStartProcessingTime,
                    noOfQueuesWithUpdatedCount: queueCountChanges,
                    jiraShard: jiraShard,
                    browserTabVisibilityState: document.visibilityState,
                    numberOfBadQueues: numberOfBadQueues
                });
            }
            return (0, $5OEre.setQueuesForCategory)(data, category, // Object.values is typed as Mixed[] and makes flow unhappy
            (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))((0, (/*@__PURE__*/$parcel$interopDefault($hvbu2)))(queuesMap), 'order'));
        });
    }).catch((error)=>{
        $95f367cfb169c39f$export$b5e2038970f91d6c(error);
    });
};
const $95f367cfb169c39f$var$updateLoadingState = (category, queues, update)=>{
    update((data)=>data ? (0, $6HC1D.chain)(data).setIn([
            category,
            'hasRequestedCount'
        ], true).setIn([
            category,
            'isCountLoading'
        ], false).value() : null);
};
const $95f367cfb169c39f$export$d436cbef77099410 = async (baseUrl, projectKey, category, queues, skipHiddenQueues, update, retryCallback, analyticsEvent)=>{
    const queuesPerGroup = $95f367cfb169c39f$var$getQueuesPerGroup(queues, skipHiddenQueues);
    const queuesSortByLastRefreshedTime = $95f367cfb169c39f$var$getQueuesSortByLastRefreshedTime(queuesPerGroup);
    const queueIds = queuesSortByLastRefreshedTime.map((x)=>x.id);
    const batchStartProcessingTime = Date.now();
    try {
        // fetching the result in one call
        await $95f367cfb169c39f$var$fetchAndUpdateCount(baseUrl, projectKey, queueIds, category, analyticsEvent, update, batchStartProcessingTime, retryCallback);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        $95f367cfb169c39f$var$updateLoadingState(category, queues, update);
        $95f367cfb169c39f$export$b5e2038970f91d6c(error);
        throw error;
    }
    $95f367cfb169c39f$var$updateLoadingState(category, queues, update);
};

});
parcelRegister("lzTt0", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $fb57e46e5749abd1$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $fb57e46e5749abd1$var$isNumber(value) {
    return typeof value == 'number' || $hYEMs(value) && $2OY5s(value) == $fb57e46e5749abd1$var$numberTag;
}
module.exports = $fb57e46e5749abd1$var$isNumber;

});

parcelRegister("53c4R", function(module, exports) {

$parcel$export(module.exports, "MAX_AUTOMATION_RULES_PER_SD", () => $d0467ae3b0b1cf99$export$dca2c2105b681490);
$parcel$export(module.exports, "MAX_AUTOMATION_BRANCHES_PER_RULE", () => $d0467ae3b0b1cf99$export$a48ac34d39e0fc22);
$parcel$export(module.exports, "MAX_QUEUES_PER_SD", () => $d0467ae3b0b1cf99$export$2e0ba662d5bb7742);
$parcel$export(module.exports, "MAX_SLA_GOALS_PER_SD", () => $d0467ae3b0b1cf99$export$eb69982aa3a172b4);
$parcel$export(module.exports, "MAX_CMDB_OBJECTS_PER_FIELD", () => $d0467ae3b0b1cf99$export$cb3888a8c43147d2);
$parcel$export(module.exports, "MAX_NUM_TEAM_PRIORITY_QUEUES_PER_SD", () => $d0467ae3b0b1cf99$export$801a603585fb94d8);
$parcel$export(module.exports, "LIMIT_DEFAULTS", () => $d0467ae3b0b1cf99$export$5ed1d2ac050e39d);
$parcel$export(module.exports, "getLimit", () => $d0467ae3b0b1cf99$export$fb8ce379717a383d);
$parcel$export(module.exports, "LimitData", () => $d0467ae3b0b1cf99$export$9989835030ecd317);
$parcel$export(module.exports, "withLimitData", () => $d0467ae3b0b1cf99$export$c5d8aa8a650e690f);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
const $d0467ae3b0b1cf99$export$dca2c2105b681490 = 'max_automation_rules_per_sd';
const $d0467ae3b0b1cf99$export$a48ac34d39e0fc22 = 'max_automation_branches_per_rule';
const $d0467ae3b0b1cf99$export$2e0ba662d5bb7742 = 'max_queues_per_sd';
const $d0467ae3b0b1cf99$export$eb69982aa3a172b4 = 'max_sla_goals_per_sd';
const $d0467ae3b0b1cf99$export$cb3888a8c43147d2 = 'max_cmdb_objects_per_field';
const $d0467ae3b0b1cf99$export$801a603585fb94d8 = 'max_num_team_priority_queues_per_sd';
const $d0467ae3b0b1cf99$export$5ed1d2ac050e39d = {
    [$d0467ae3b0b1cf99$export$dca2c2105b681490]: 30,
    [$d0467ae3b0b1cf99$export$a48ac34d39e0fc22]: 30,
    [$d0467ae3b0b1cf99$export$2e0ba662d5bb7742]: 300,
    [$d0467ae3b0b1cf99$export$eb69982aa3a172b4]: 30,
    [$d0467ae3b0b1cf99$export$cb3888a8c43147d2]: 20,
    [$d0467ae3b0b1cf99$export$801a603585fb94d8]: 50
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $d0467ae3b0b1cf99$var$limitCache = {};
const $d0467ae3b0b1cf99$export$c419786abd6faaad = (limitProperty)=>{
    delete $d0467ae3b0b1cf99$var$limitCache[limitProperty];
};
const $d0467ae3b0b1cf99$export$fb8ce379717a383d = (limitProperty)=>{
    if (!$d0467ae3b0b1cf99$var$limitCache[limitProperty]) $d0467ae3b0b1cf99$var$limitCache[limitProperty] = (0, $2OdyW.default)(`/rest/servicedesk/latest/limit/${limitProperty}?_=${Date.now()}`).then(({ limit: limit })=>limit, (error)=>{
        // Will allow us to try again to fetch limit
        $d0467ae3b0b1cf99$export$c419786abd6faaad(limitProperty);
        (0, $gUUjF.default).safeWarnWithoutCustomerData('servicedesk.common.view.components.limit-data', `Failed to fetch limit for ${limitProperty}`);
        throw error;
    });
    return $d0467ae3b0b1cf99$var$limitCache[limitProperty];
};
class $d0467ae3b0b1cf99$export$9989835030ecd317 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { limitProperty: limitProperty } = this.props;
        const defaultLimit = $d0467ae3b0b1cf99$export$5ed1d2ac050e39d[limitProperty];
        $d0467ae3b0b1cf99$export$fb8ce379717a383d(limitProperty).then((limit)=>{
            this.updateLimit(limit || defaultLimit);
        }).catch(()=>{
            this.updateLimit(defaultLimit);
        });
    }
    updateLimit(newLimit) {
        this.setState(({ limit: oldLimit })=>oldLimit !== newLimit ? {
                limit: newLimit
            } : undefined);
    }
    render() {
        return this.props.children(this.state.limit);
    }
    constructor(...args){
        super(...args);
        this.state = {
            // Current consumers of LimitData expect typeof number so this cannot be an empty value.
            // This also voids limit messages showing until we have a reliable limit,
            // instead of showing then changing the value
            limit: Infinity
        };
    }
}
const $d0467ae3b0b1cf99$export$c5d8aa8a650e690f = (limitProperty, WrappedComponent)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0467ae3b0b1cf99$export$9989835030ecd317, {
            limitProperty: limitProperty
        }, (limit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                limit: limit,
                ...props
            }));

});



parcelRegister("kG021", function(module, exports) {

$parcel$export(module.exports, "addItem", () => $6679463effac295c$export$fb9705de59d96855);
$parcel$export(module.exports, "deleteItem", () => $6679463effac295c$export$8d8542dbbc23fe1a);
$parcel$export(module.exports, "editItem", () => $6679463effac295c$export$60832f4899fbf6a1);
$parcel$export(module.exports, "editItems", () => $6679463effac295c$export$8c896bccb18e1db1);
$parcel$export(module.exports, "moveItem", () => $6679463effac295c$export$ec937e64de6c1257);
$parcel$export(module.exports, "moveItemBelow", () => $6679463effac295c$export$17c7ebc966cf5476);
$parcel$export(module.exports, "moveItemAbove", () => $6679463effac295c$export$d54386016cadff45);
$parcel$export(module.exports, "moveToTop", () => $6679463effac295c$export$f2c5cc4c3f787c3e);
$parcel$export(module.exports, "enableSelectedQueuesVisibility", () => $6679463effac295c$export$ce58537552972d29);

var $k61d1 = parcelRequire("k61d1");
const $6679463effac295c$export$fb9705de59d96855 = (source, item)=>[
        ...source,
        item
    ];
const $6679463effac295c$export$8d8542dbbc23fe1a = (source, id)=>{
    const result = source.slice();
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(result, {
        id: Number(id)
    });
    if (index >= 0) result.splice(index, 1);
    return result;
};
const $6679463effac295c$export$60832f4899fbf6a1 = (source, updatedItem)=>{
    const result = source.slice();
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(result, {
        id: updatedItem.id
    });
    if (index >= 0) result[index] = {
        ...result[index],
        ...updatedItem
    };
    return result;
};
const $6679463effac295c$export$8c896bccb18e1db1 = (source, updatedItems)=>{
    const result = source.slice();
    updatedItems.forEach((item)=>{
        const index = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(result, {
            id: item.id
        });
        if (index >= 0) result[index] = {
            ...result[index],
            ...item
        };
    });
    return result;
};
const $6679463effac295c$export$ec937e64de6c1257 = (source, from, to)=>{
    const result = source.slice();
    const item = result[from];
    if (from !== to && from >= 0) {
        result.splice(from, 1);
        result.splice(to, 0, item);
    }
    return result.map((page, order)=>({
            ...page,
            order: order
        }));
};
const $6679463effac295c$export$17c7ebc966cf5476 = (source, sourceId, targetId)=>{
    const result = source.slice();
    if (sourceId !== targetId) {
        const sourceIndex = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(result, {
            id: sourceId
        });
        if (sourceIndex >= 0) {
            const sourceQueue = result[sourceIndex];
            result.splice(sourceIndex, 1);
            const targetIndex = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(result, {
                id: targetId
            });
            if (targetIndex >= 0) {
                result.splice(targetIndex + 1, 0, sourceQueue);
                return result.map((page, order)=>({
                        ...page,
                        order: order
                    }));
            }
        }
    }
    return source;
};
const $6679463effac295c$export$d54386016cadff45 = (source, sourceId, targetId)=>{
    const result = source.slice();
    if (sourceId !== targetId) {
        const sourceIndex = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(result, {
            id: sourceId
        });
        if (sourceIndex >= 0) {
            const sourceQueue = result[sourceIndex];
            result.splice(sourceIndex, 1);
            const targetIndex = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(result, {
                id: targetId
            });
            if (targetIndex >= 0) {
                result.splice(targetIndex, 0, sourceQueue);
                return result.map((page, order)=>({
                        ...page,
                        order: order
                    }));
            }
        }
    }
    return source;
};
const $6679463effac295c$export$f2c5cc4c3f787c3e = (source, sourceId)=>{
    const result = source.slice();
    if (result.length === 0) return source;
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(result, {
        id: sourceId
    });
    if (index > 0) {
        const sourceQueue = result[index];
        result.splice(index, 1);
        result.splice(0, 0, sourceQueue);
        return result.map((page, order)=>({
                ...page,
                order: order
            }));
    }
    return source;
};
const $6679463effac295c$export$ce58537552972d29 = (selectedQueueIds, queues)=>queues.map((queue)=>{
        if (selectedQueueIds.some((selectedQueueId)=>selectedQueueId === queue.id)) {
            if (!queue.canBeHidden) return queue;
            return {
                ...queue,
                canBeHidden: false
            };
        }
        if (queue.canBeHidden) return queue;
        return {
            ...queue,
            canBeHidden: true
        };
    });

});
parcelRegister("k61d1", function(module, exports) {

var $9mB9u = parcelRequire("9mB9u");

var $7qARj = parcelRequire("7qARj");

var $hNahz = parcelRequire("hNahz");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ea154e499f779271$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $ea154e499f779271$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $hNahz(fromIndex);
    if (index < 0) index = $ea154e499f779271$var$nativeMax(length + index, 0);
    return $9mB9u(array, $7qARj(predicate, 3), index);
}
module.exports = $ea154e499f779271$var$findIndex;

});






parcelRegister("2d7Sj", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $0653f34646647329$export$155581e8dc02007a);
$parcel$export(module.exports, "ServiceDeskDocumentTitle", () => $0653f34646647329$export$c7841d2c1c13065e);

var $eUqFw = parcelRequire("eUqFw");

var $knPb9 = parcelRequire("knPb9");

var $heNSb = parcelRequire("heNSb");

var $giAhk = parcelRequire("giAhk");

var $f9Osc = parcelRequire("f9Osc");
const $0653f34646647329$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, intl: { formatMessage: formatMessage }, projectName: projectName, subsection: subsection } = props;
    const title = subsection ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${subsection} - ${formatMessage((0, $f9Osc.default).serviceProject)}` : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${formatMessage((0, $f9Osc.default).serviceProject)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DocumentTitle, {
        title: title
    });
};
const $0653f34646647329$var$InjectedPage = (0, $knPb9.default)($0653f34646647329$export$155581e8dc02007a, {
    DocumentTitle: (0, $heNSb.DocumentTitle)
});
const $0653f34646647329$export$c7841d2c1c13065e = (0, $giAhk.injectIntlV2)($0653f34646647329$var$InjectedPage);
var $0653f34646647329$export$2e2bcd8739ae039 = $0653f34646647329$export$c7841d2c1c13065e;

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("f9Osc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be746c19c254767$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7be746c19c254767$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    atlassianAnalytics: {
        "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    serviceProject: {
        "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
        "defaultMessage": "Service project"
    },
    knowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
        "defaultMessage": "Knowledge base"
    },
    itsmFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
        "defaultMessage": "Features"
    },
    queues: {
        "id": "servicedesk-spa-commons.common.utils.document-title.queues",
        "defaultMessage": "Queues"
    },
    customers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customers",
        "defaultMessage": "Customers"
    },
    organizations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
        "defaultMessage": "Organizations"
    },
    customerServiceEscalations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
        "defaultMessage": "Developer escalations"
    },
    reports: {
        "id": "servicedesk-spa-commons.common.utils.document-title.reports",
        "defaultMessage": "Reports"
    },
    services: {
        "id": "servicedesk-spa-commons.common.utils.document-title.services",
        "defaultMessage": "Services"
    },
    oncall: {
        "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
        "defaultMessage": "On-call"
    },
    email: {
        "id": "servicedesk-spa-commons.common.utils.document-title.email",
        "defaultMessage": "Email request"
    },
    sla: {
        "id": "servicedesk-spa-commons.common.utils.document-title.sla",
        "defaultMessage": "Service level agreements"
    },
    csat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.csat",
        "defaultMessage": "Customer satisfaction"
    },
    details: {
        "id": "servicedesk-spa-commons.common.utils.document-title.details",
        "defaultMessage": "Details"
    },
    portal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal",
        "defaultMessage": "Customer portal"
    },
    externalLinks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
        "defaultMessage": "Links"
    },
    portalSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
        "defaultMessage": "Portal settings"
    },
    automation: {
        "id": "servicedesk-spa-commons.common.utils.document-title.automation",
        "defaultMessage": "Automation"
    },
    advanced: {
        "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
        "defaultMessage": "Advanced"
    },
    languageSupport: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
        "defaultMessage": "Language support"
    },
    languageTranslations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
        "defaultMessage": "Language translations"
    },
    notificationEmail: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    notifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
        "defaultMessage": "Notifications"
    },
    internalNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget",
        "defaultMessage": "Widget"
    },
    customerPermissions: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    people: {
        "id": "servicedesk-spa-commons.common.utils.document-title.people",
        "defaultMessage": "Internal access"
    },
    issueType: {
        "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
        "defaultMessage": "Request types"
    },
    connectAppControls: {
        "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    features: {
        "id": "servicedesk-spa-commons.common.utils.document-title.features",
        "defaultMessage": "Features"
    },
    calendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
        "defaultMessage": "Calendar"
    },
    changeCalendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
        "defaultMessage": "Change calendar"
    },
    changeManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
        "defaultMessage": "Change management"
    },
    incidentManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
        "defaultMessage": "Incident management"
    },
    virtualAgentConversations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
        "defaultMessage": "Conversations"
    },
    virtualAgentIntents: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
        "defaultMessage": "Intents"
    },
    virtualAgentStandardFlows: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
        "defaultMessage": "Standard flows"
    },
    virtualAgentSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
        "defaultMessage": "Settings"
    },
    virtualAgentLanding: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
        "defaultMessage": "Virtual agent"
    },
    chat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.chat",
        "defaultMessage": "Chat"
    },
    proformaForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    playbooks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
        "defaultMessage": "Playbooks"
    },
    dataClassifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
        "defaultMessage": "Data classification"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
        "defaultMessage": "Fields"
    },
    workflowScheme: {
        "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
        "defaultMessage": "Workflows"
    },
    journeysNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
        "defaultMessage": "Journeys"
    },
    journeyConfigNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
        "defaultMessage": "Journey configuration"
    }
});

});


parcelRegister("51Ia6", function(module, exports) {

$parcel$export(module.exports, "usePageContext", () => $16ae5fc48efca0d6$export$9c25024bdfe755f7);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $ixwgj = parcelRequire("ixwgj");

var $gd0Sp = parcelRequire("gd0Sp");

var $jyTef = parcelRequire("jyTef");
const $16ae5fc48efca0d6$var$getProjectContextResource = ()=>(0, $ixwgj.projectContextResourceWithCache);
const $16ae5fc48efca0d6$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $iZJHG.useResourceWithCustomRouterContext)($16ae5fc48efca0d6$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $jyTef.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $eUqFw.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    baseUrl: tenantContext.baseUrl,
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});
parcelRegister("jyTef", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $3f940b317a874b53$export$712ead87353ac687);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $ct0sQ = parcelRequire("ct0sQ");
const $3f940b317a874b53$var$getServiceDeskContextResource = ()=>(0, $ct0sQ.serviceDeskContextResource);
const $3f940b317a874b53$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $iZJHG.useResourceWithCustomRouterContext)($3f940b317a874b53$var$getServiceDeskContextResource(), customContext);
    (0, $eUqFw.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});


parcelRegister("dVAlv", function(module, exports) {

$parcel$export(module.exports, "SpaPageWrapper", () => $33637cae863dc9b4$export$577514961fbf4842);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $eUqFw = parcelRequire("eUqFw");

var $foc4i = parcelRequire("foc4i");

var $gUUjF = parcelRequire("gUUjF");

var $knPb9 = parcelRequire("knPb9");

var $fO5rB = parcelRequire("fO5rB");

var $bhwgQ = parcelRequire("bhwgQ");

var $1IzB8 = parcelRequire("1IzB8");

var $2Ba2b = parcelRequire("2Ba2b");
const $33637cae863dc9b4$export$91f88695e0d311a5 = (props)=>{
    const { projectContext: projectContext, isLoading: isLoading, error: error, children: children, AccessCheck: AccessCheck, AuthenticationCheck: AuthenticationCheck, ProjectNotFound: ProjectNotFound, GenericError: GenericError, SubProductUpdater: SubProductUpdater } = props;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null);
    if (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jsdspa-page-wrapper', 'rendering-error-page', error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AuthenticationCheck, null, error.statusCode === 404 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProjectNotFound, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(GenericError, null));
    }
    if (projectContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SubProductUpdater, {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AuthenticationCheck, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AccessCheck, null, children)));
    return null;
};
const $33637cae863dc9b4$export$577514961fbf4842 = (0, $knPb9.default)($33637cae863dc9b4$export$91f88695e0d311a5, {
    AccessCheck: (0, $1IzB8.default),
    GenericError: (0, $2Ba2b.GenericError),
    ProjectNotFound: (0, $2Ba2b.ProjectNotFound),
    AuthenticationCheck: (0, $bhwgQ.AuthenticationCheck),
    SubProductUpdater: (0, $fO5rB.SubProductUpdater)
});
var $33637cae863dc9b4$export$2e2bcd8739ae039 = $33637cae863dc9b4$export$577514961fbf4842;

});
parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("1IzB8", function(module, exports) {

$parcel$export(module.exports, "default", () => $edeca50de0b85084$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $10fdS = parcelRequire("10fdS");


var $bsgfb = parcelRequire("bsgfb");

var $1fuiA = parcelRequire("1fuiA");
const $edeca50de0b85084$var$AccessCheck = ({ children: children })=>{
    const isSettingsRoute = (0, $10fdS.useCurrentRoute)().path.includes(`${(0, $2df94debed157361$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
    const Gate = isSettingsRoute ? (0, $1fuiA.default) : (0, $bsgfb.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Gate, null, children);
};
var $edeca50de0b85084$export$2e2bcd8739ae039 = $edeca50de0b85084$var$AccessCheck;

});
const $2df94debed157361$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';

parcelRegister("bsgfb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d02215a42a3332$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fz8wa = parcelRequire("fz8wa");

var $lB25E = parcelRequire("lB25E");

var $11C4f = parcelRequire("11C4f");
const $a7d02215a42a3332$var$ProductAccessCheck = ({ children: children })=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $fz8wa.useApplicationPermissions)();
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    if (projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11C4f.default), null, children);
    return hasServiceDeskAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: "/jira"
    });
};
var $a7d02215a42a3332$export$2e2bcd8739ae039 = $a7d02215a42a3332$var$ProductAccessCheck;

});
parcelRegister("fz8wa", function(module, exports) {

$parcel$export(module.exports, "ApplicationPermissionsSubscriber", () => $d53bf78e5b3b7ada$export$d8c76f7e52d0a856);
$parcel$export(module.exports, "useApplicationPermissions", () => $d53bf78e5b3b7ada$export$4d9cadb4042acc1b);

var $df4Sl = parcelRequire("df4Sl");

var $WBLbN = parcelRequire("WBLbN");

var $k4yit = parcelRequire("k4yit");

var $gd0Sp = parcelRequire("gd0Sp");
const $d53bf78e5b3b7ada$var$selector = (0, $df4Sl.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
        data: {
            applicationPermissions: applicationPermissions
        }
    }));
const $d53bf78e5b3b7ada$export$d8c76f7e52d0a856 = (0, $WBLbN.createSubscriber)((0, $k4yit.default), {
    displayName: 'ApplicationPermissionsSubscriber',
    selector: $d53bf78e5b3b7ada$var$selector
});
const $d53bf78e5b3b7ada$export$4d9cadb4042acc1b = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.appPermissions;
};

});

parcelRegister("11C4f", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2544b3bfea70255$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");

var $jyTef = parcelRequire("jyTef");


var $6tW8V = parcelRequire("6tW8V");
const $a2544b3bfea70255$var$AgentCheck = ({ children: children })=>{
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    const [{ data: data, error: error }] = (0, $jyTef.useServiceDeskContext)();
    if (data || error) {
        // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
        if (!(0, $6tW8V.isAccessError)(error)) {
            const { userRole: userRole = '' } = data || {};
            if (userRole === 'agent' || userRole === 'agent-project-admin') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
            if (error) throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: `${(0, $2df94debed157361$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
        });
    }
    return null;
};
var $a2544b3bfea70255$export$2e2bcd8739ae039 = $a2544b3bfea70255$var$AgentCheck;

});
parcelRegister("6tW8V", function(module, exports) {

$parcel$export(module.exports, "isAccessError", () => $5107715f0b974007$export$ddaebe4928e793cb);

const $5107715f0b974007$var$RESTRICTED_ACCESS_CODES = [
    (0, $1c3fbb431a173cc6$export$a3269a3914b007e3),
    (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef),
    (0, $1c3fbb431a173cc6$export$67d19e9a991baa07)
];
const $5107715f0b974007$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $5107715f0b974007$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;

});



parcelRegister("1fuiA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0788b3e6146363c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2Ba2b = parcelRequire("2Ba2b");

var $jyTef = parcelRequire("jyTef");

var $6tW8V = parcelRequire("6tW8V");
const $0788b3e6146363c4$var$SettingsAccessCheck = ({ children: children })=>{
    const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, $jyTef.useServiceDeskContext)();
    const userRole = serviceDeskContext?.userRole;
    // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
    const hasAccessError = (0, $6tW8V.isAccessError)(serviceDeskContextError);
    // Service desk context is updated on every route change
    // If context fails to give us an indicative result (e.g. fetch failed, 500 error)
    // We will continue to use current value to assess permissions
    if (userRole === 'agent-project-admin' && !hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    if (userRole !== undefined || hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.ProjectNotFound), null);
    if (serviceDeskContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.GenericError), null);
    return null;
};
var $0788b3e6146363c4$export$2e2bcd8739ae039 = $0788b3e6146363c4$var$SettingsAccessCheck;

});
parcelRegister("2Ba2b", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $abcdf98f8a718d25$export$849d319c342682a2);
$parcel$export(module.exports, "GenericError", () => $abcdf98f8a718d25$export$7d465be8efa67280);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $heNSb = parcelRequire("heNSb");

var $lQXqy = parcelRequire("lQXqy");

var $7QuzF = parcelRequire("7QuzF");

var $4Es8k = parcelRequire("4Es8k");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $6Yj0X = parcelRequire("6Yj0X");
const $abcdf98f8a718d25$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $6Yj0X.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $7QuzF.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $6Yj0X.default).notFoundTitle),
        description: formatMessage((0, $6Yj0X.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
            to: projectsPath
        }, formatMessage((0, $6Yj0X.default).notFoundAction))
    }));
};
const $abcdf98f8a718d25$export$7d465be8efa67280 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $6Yj0X.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $lQXqy.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $6Yj0X.default).genericErrorTitle),
        description: formatMessage((0, $6Yj0X.default).genericErrorDescription)
    }));
};

});
parcelRegister("lQXqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $30559913302f86cb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $30559913302f86cb$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1cuWo")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("48S62")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $9TZf5 = parcelRequire("9TZf5");

var $48S62 = parcelRequire("48S62");

var $1cuWo = parcelRequire("1cuWo");
const $30559913302f86cb$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1cuWo)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($48S62))
});
var $30559913302f86cb$export$2e2bcd8739ae039 = $30559913302f86cb$var$Illustration;
// for advanced use only
const $30559913302f86cb$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("48S62", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("1cuWo", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("7QuzF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ab5059cf2dfabb6$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $9TZf5 = parcelRequire("9TZf5");

var $fCVbE = parcelRequire("fCVbE");
const $3ab5059cf2dfabb6$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($fCVbE)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fCVbE))
});
var $3ab5059cf2dfabb6$export$2e2bcd8739ae039 = $3ab5059cf2dfabb6$var$Illustration;
// for advanced use only
const $3ab5059cf2dfabb6$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("fCVbE", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("6Yj0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c13e1fbd282caae$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6c13e1fbd282caae$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    }
});

});





parcelRegister("f5prk", function(module, exports) {

$parcel$export(module.exports, "default", () => $92ebb2dbbec2e6e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");

var $2bMHt = parcelRequire("2bMHt");

var $lB25E = parcelRequire("lB25E");
/* Intended usage is to replace direct usage of history.push from react-dom-router with a Jira SPA compatible push history */ const $92ebb2dbbec2e6e0$var$QueuesPushProvider = (props)=>{
    const { projectKey: projectKey, children: children } = props;
    const { push: push, replace: replace } = (0, $lB25E.useRouterActions)();
    const pushWithSpaCompatibleUrl = (0, $eUqFw.useCallback)((path)=>{
        const pathWithLeadingSlash = path.charAt(0) === '/' ? `${path}` : `/${path}`;
        let fullPath = pathWithLeadingSlash;
        // Don't update the url if it is already in the right format
        if (pathWithLeadingSlash.indexOf('/jira/servicedesk/projects') !== 0) fullPath = `/jira/servicedesk/projects/${projectKey}${pathWithLeadingSlash}`;
        push(fullPath);
        // Some existing consumers in queues expect this to return an observable
        return (0, $3JafE.Observable).empty();
    }, [
        projectKey,
        push
    ]);
    const navigateWithProjectKey = (0, $eUqFw.useCallback)((path)=>(0, $2bMHt.navigate)(projectKey, path), [
        projectKey
    ]);
    if (!projectKey) return children({
        push: undefined
    });
    return __SPA__ ? children({
        push: pushWithSpaCompatibleUrl,
        replace: replace
    }) : children({
        push: navigateWithProjectKey
    });
};
var $92ebb2dbbec2e6e0$export$2e2bcd8739ae039 = $92ebb2dbbec2e6e0$var$QueuesPushProvider;

});

parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("75nMA", function(module, exports) {

$parcel$export(module.exports, "useOnFavoritesChanged", () => $787f5fd962a6c1b3$export$ddf44c597e03063d);

var $eUqFw = parcelRequire("eUqFw");

var $8i1R8 = parcelRequire("8i1R8");

var $hvbu2 = parcelRequire("hvbu2");

var $jrdvV = parcelRequire("jrdvV");

var $dQZ5c = parcelRequire("dQZ5c");
const $787f5fd962a6c1b3$export$ddf44c597e03063d = (projectKey, category, queues, callback)=>{
    const { items: items } = (0, $eUqFw.useContext)((0, $dQZ5c.FavoriteChangeContext));
    const queueItemChanges = items[0, $jrdvV.QUEUES_ITEM_TYPE];
    const previousChangesRef = (0, $eUqFw.useRef)({
        projectKey: projectKey,
        category: category,
        changedItems: undefined
    });
    const { current: previousChanges } = previousChangesRef;
    const hasPotentialChanges = previousChanges.projectKey !== projectKey || previousChanges.category !== category || previousChanges.changedItems !== queueItemChanges;
    if (hasPotentialChanges) {
        previousChangesRef.current = {
            projectKey: projectKey,
            category: category,
            changedItems: queueItemChanges
        };
        if (queues) (0, (/*@__PURE__*/$parcel$interopDefault($hvbu2)))(queueItemChanges).forEach(({ id: id, value: value })=>{
            const queue = (0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(queues, {
                id: Number(id)
            });
            if (queue && queue.favourite !== value) callback(id, value);
        });
    }
};

});
parcelRegister("8i1R8", function(module, exports) {

var $e5OGm = parcelRequire("e5OGm");

var $k61d1 = parcelRequire("k61d1");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $609171b9cff1596d$var$find = $e5OGm($k61d1);
module.exports = $609171b9cff1596d$var$find;

});
parcelRegister("e5OGm", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $jxg5X = parcelRequire("jxg5X");

var $8nrDO = parcelRequire("8nrDO");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $a428d8bbecbff7a6$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$jxg5X(collection)) {
            var iteratee = $7qARj(predicate, 3);
            collection = $8nrDO(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $a428d8bbecbff7a6$var$createFind;

});



parcelRegister("gatu1", function(module, exports) {

$parcel$export(module.exports, "pageToQueues", () => $929c5ad2a648b730$export$8ada91ce992fa66f);

var $aNBkj = parcelRequire("aNBkj");
const $929c5ad2a648b730$var$transformColumns = (responseColumns)=>responseColumns.map((responseColumn)=>{
        const column = {
            id: responseColumn.fieldId,
            title: responseColumn.title,
            fieldType: responseColumn.fieldType,
            sortable: responseColumn.sortable
        };
        if (responseColumn.sortOrder) return {
            ...column,
            currentSorting: responseColumn.sortOrder
        };
        return column;
    });
const $929c5ad2a648b730$export$8ada91ce992fa66f = (page)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    page.reduce((acc, queue)=>{
        acc[queue.id] = {
            id: (0, $aNBkj.toQueueId)(queue.id),
            name: queue.name,
            jql: queue.jql,
            completeJql: queue.completeJql,
            order: queue.order,
            columns: $929c5ad2a648b730$var$transformColumns(queue.columnsDetails),
            // British spelling from legacy Backend code
            isFavorite: queue.favourite,
            category: queue.category,
            canBeHidden: queue.canBeHidden
        };
        return acc;
    }, {});

});


parcelRegister("182pZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $012429969ceeb3ed$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5iWql = parcelRequire("5iWql");

var $eI5EY = parcelRequire("eI5EY");

var $IsF0v = parcelRequire("IsF0v");

var $iKpKQ = parcelRequire("iKpKQ");

var $biCbK = parcelRequire("biCbK");

var $fB298 = parcelRequire("fB298");

var $9GzdM = parcelRequire("9GzdM");

var $3o0h6 = parcelRequire("3o0h6");

var $6vrw7 = parcelRequire("6vrw7");

var $jK1pm = parcelRequire("jK1pm");

var $9CCgP = parcelRequire("9CCgP");
const $012429969ceeb3ed$var$deprecatedAgentViewProps = {
    onAtLeastOneIssueLoaded: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
const $012429969ceeb3ed$var$getInitialState = (0, $5iWql.default)((_queue)=>{
    // Only change the reference of initial state when we transition to a new queue, to avoid unnecessary re-renders
    // This shape of prop is required to be compatible what the AgentView expects in the non-spa
    // When JSD agent view is in the SPA by the default we can probably just pass appProps directly
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const initialState = {};
    return (0, $5iWql.default)((appProps)=>{
        initialState.appProps = appProps;
        return initialState;
    });
});
const $012429969ceeb3ed$var$QueuesAgentViewContent = ({ queuesData: queuesData, queueId: queueId, push: push, pageContext: pageContext, isQueueVisible: isQueueVisible, isAgentViewMountedRef: isAgentViewMountedRef, onIssuesChanged: onIssuesChanged, onIssuesCountChanged: onIssuesCountChanged })=>{
    (0, $eUqFw.useEffect)(()=>{
        if (isAgentViewMountedRef) {
            // eslint-disable-next-line no-param-reassign
            isAgentViewMountedRef.current = true;
            return ()=>{
                // eslint-disable-next-line no-param-reassign
                isAgentViewMountedRef.current = false;
            };
        }
        return 0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu));
    });
    const { data: isItsmProject } = (0, $IsF0v.useIsItsmTemplateProject)();
    const { canSeeNewIssueView: canSeeNewIssueView, isSiteAdmin: isSiteAdmin, userRole: userRole, serviceDeskId: serviceDeskId, ...appProps } = pageContext;
    const [state] = (0, $iKpKQ.useProjectBuilder)();
    const displayCipherDeprectaionBannerGate = (0, $eI5EY.fg)('spartans_cipher_deprecation_banner');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "queues-agent-view"
    }, displayCipherDeprectaionBannerGate && isQueueVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9CCgP.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3o0h6.PageStyle), null, (0, $eI5EY.fg)('hide_project_tour_on_project_builder') ? isItsmProject === true && !state.isProjectBuilderOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $biCbK.ProjectTour), {
        projectId: (0, $6vrw7.toProjectId)(`${pageContext.projectId}`),
        portalUrl: pageContext.portalUrl
    }) : isItsmProject === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $biCbK.ProjectTour), {
        projectId: (0, $6vrw7.toProjectId)(`${pageContext.projectId}`),
        portalUrl: pageContext.portalUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9GzdM.default), {
        queuesDataSource: queuesData,
        baseUrl: "",
        queueId: queueId,
        projectKey: pageContext.projectKey
    }, (queue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fB298.default), {
            ...$012429969ceeb3ed$var$deprecatedAgentViewProps,
            // @ts-expect-error - TS2741 - Property 'appProps' is missing in type 'Record<string, any>' but required in type 'InitialState'.
            initialState: $012429969ceeb3ed$var$getInitialState(queue)(appProps),
            locale: pageContext.locale,
            isQueueVisible: isQueueVisible,
            queue: queue,
            push: push,
            // set onQueueRenderFailure - undefined to satisfy flow (ignored prop)
            onQueueRenderFailure: undefined,
            onIssuesChanged: onIssuesChanged,
            onIssuesCountChanged: onIssuesCountChanged
        }))));
};
var $012429969ceeb3ed$export$2e2bcd8739ae039 = $012429969ceeb3ed$var$QueuesAgentViewContent;

});
parcelRegister("iKpKQ", function(module, exports) {

$parcel$export(module.exports, "useProjectBuilder", () => $c861deea98c4c695$export$5891129c2551a3c0);

var $WBLbN = parcelRequire("WBLbN");
const $c861deea98c4c695$var$ProjectBuilderStore = (0, $WBLbN.createStore)({
    initialState: {
        isProjectBuilderOpen: false
    },
    actions: {
        hideProjectBuilder: ()=>({ setState: setState })=>{
                setState({
                    isProjectBuilderOpen: false
                });
            },
        showProjectBuilder: ()=>({ setState: setState })=>{
                setState({
                    isProjectBuilderOpen: true
                });
            }
    },
    name: 'projectBuilder'
});
const $c861deea98c4c695$export$5891129c2551a3c0 = (0, $WBLbN.createHook)($c861deea98c4c695$var$ProjectBuilderStore);

});

parcelRegister("biCbK", function(module, exports) {

$parcel$export(module.exports, "ProjectTour", () => $75f45afead5af18f$export$efe5812745c27ad2);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $4KGwM = parcelRequire("4KGwM");

var $lhNMo = parcelRequire("lhNMo");

var $3SKoA = parcelRequire("3SKoA");

var $4dxCN = parcelRequire("4dxCN");

const $75f45afead5af18f$var$preloadComponent = ()=>(parcelRequire("4QLBD")).then((exportedModule)=>exportedModule.ProjectTour);
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $75f45afead5af18f$var$ProjectTourInternal = (0, $7rh0R.lazy)(()=>$75f45afead5af18f$var$preloadComponent(), {});
const $75f45afead5af18f$export$efe5812745c27ad2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "itsm-project-tour",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4dxCN.IfNavTargetsAreShowing), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4KGwM.StartExperiencesOnce), {
        experiences: [
            (0, $3SKoA.projectTourFirstStepExperience),
            (0, $lhNMo.sampleSpaceTourFirstStepExperience)
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75f45afead5af18f$var$ProjectTourInternal, props)));

});
parcelRegister("4KGwM", function(module, exports) {

$parcel$export(module.exports, "StartExperiencesOnce", () => $a43fb45e91d4f8b7$export$144439ff99ea00b7);

var $eUqFw = parcelRequire("eUqFw");

var $fegvt = parcelRequire("fegvt");

var $liN9S = parcelRequire("liN9S");
const $a43fb45e91d4f8b7$export$144439ff99ea00b7 = ({ experiences: experiences })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fegvt.default), {
        mount: ()=>{
            // Only start the experiences if they haven't been started before
            experiences.filter((exp)=>exp.state.id === (0, $liN9S.UFOExperienceState).NOT_STARTED.id).forEach((exp)=>exp.start());
        },
        unmount: ()=>{
            // Abort the experiences on unmount
            experiences.forEach((exp)=>exp.abort());
        }
    });

});
parcelRegister("fegvt", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f23651339c7adc1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line jira/react/no-class-components
class $2f23651339c7adc1$var$OpTrigger extends (0, $eUqFw.Component) {
    componentDidMount() {
        this.props.mount();
    }
    componentWillUnmount() {
        this.props.unmount();
    }
    render() {
        return null;
    }
}
var $2f23651339c7adc1$export$2e2bcd8739ae039 = $2f23651339c7adc1$var$OpTrigger;

});


parcelRegister("lhNMo", function(module, exports) {

$parcel$export(module.exports, "sampleSpaceTourFirstStepExperience", () => $2589af1a2fe6f53b$export$79aaeba705b81d95);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $2589af1a2fe6f53b$export$79aaeba705b81d95 = new (0, $kDfSL.UFOExperience)('jsm-first-session-flow-sample-space-tour-first-step', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("3SKoA", function(module, exports) {

$parcel$export(module.exports, "yourWorkFirstStepExperience", () => $51d8709b094f2fdc$export$df0fbb7740eb79c7);
$parcel$export(module.exports, "projectTourFirstStepExperience", () => $51d8709b094f2fdc$export$18d4c572a40cbc5b);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $51d8709b094f2fdc$export$df0fbb7740eb79c7 = new (0, $kDfSL.UFOExperience)('jsm-first-session-flow-your-work-tour-first-step', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $51d8709b094f2fdc$export$18d4c572a40cbc5b = new (0, $kDfSL.UFOExperience)('jsm-first-session-flow-project-tour-first-step', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("4dxCN", function(module, exports) {

$parcel$export(module.exports, "IfNavTargetsAreShowing", () => $7b66dc0f47a0d61e$export$88096496147f47d4);

var $eUqFw = parcelRequire("eUqFw");

var $cSpu7 = parcelRequire("cSpu7");

var $dYFw9 = parcelRequire("dYFw9");
const $7b66dc0f47a0d61e$var$targetName = (0, $dYFw9.HOME_ITEMS_IDS).ALL_ITSM_QUEUES_SPOTLIGHT;
const $7b66dc0f47a0d61e$export$88096496147f47d4 = ({ children: children })=>{
    const { isTargetRendered: isTargetRendered } = (0, $cSpu7.default)();
    const isNavTargetPresent = isTargetRendered($7b66dc0f47a0d61e$var$targetName);
    return isNavTargetPresent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : null;
};

});
parcelRegister("cSpu7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca219af817935263$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aOINP = parcelRequire("aOINP");
function $ca219af817935263$export$2e2bcd8739ae039() {
    const { targets: targets } = (0, $eUqFw.useContext)((0, $aOINP.SpotlightContext));
    const targetRef = (0, $eUqFw.useRef)(targets);
    (0, $eUqFw.useEffect)(()=>{
        targetRef.current = targets;
    }, [
        targets
    ]);
    const isTargetRendered = (0, $eUqFw.useCallback)((target)=>!!targetRef.current[target], []);
    return (0, $eUqFw.useMemo)(()=>({
            isTargetRendered: isTargetRendered
        }), [
        isTargetRendered
    ]);
}

});


parcelRegister("4QLBD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("448Ow")
]).then(()=>parcelRequire('ii9it'));

});


parcelRegister("fB298", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bb15753e0d08a36$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $MYW4e = parcelRequire("MYW4e");

var $dewtR = parcelRequire("dewtR");

var $hFmdR = parcelRequire("hFmdR");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $bFzGY = parcelRequire("bFzGY");

var $lNNXV = parcelRequire("lNNXV");

var $iVSJI = parcelRequire("iVSJI");

var $3tm9R = parcelRequire("3tm9R");

var $eZfBZ = parcelRequire("eZfBZ");

var $frZnw = parcelRequire("frZnw");

var $9EFi5 = parcelRequire("9EFi5");

var $bN0JP = parcelRequire("bN0JP");

var $aNBkj = parcelRequire("aNBkj");

var $8VKaY = parcelRequire("8VKaY");

var $6vrw7 = parcelRequire("6vrw7");

var $3e9vj = parcelRequire("3e9vj");

var $c7H0g = parcelRequire("c7H0g");

var $lB25E = parcelRequire("lB25E");

var $eV5Y9 = parcelRequire("eV5Y9");

var $9pWLn = parcelRequire("9pWLn");

var $23fNU = parcelRequire("23fNU");

var $1GlEk = parcelRequire("1GlEk");

var $brVi3 = parcelRequire("brVi3");

var $lEA7a = parcelRequire("lEA7a");

var $6weDO = parcelRequire("6weDO");

var $j1Y1q = parcelRequire("j1Y1q");

var $3dyVe = parcelRequire("3dyVe");

var $eV38i = parcelRequire("eV38i");

var $lUzaT = parcelRequire("lUzaT");
// for local dev, to be able to open Project Builder without creating project each time
const $1bb15753e0d08a36$var$ProjectBuilderWithQueryParamDev = ()=>{
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const isStagingOrDev = (0, $3e9vj.useIsStagingOrDevOrLocal)();
    const [projectBuilderQueryParamDev] = (0, $lB25E.useQueryParam)((0, $bN0JP.SHOW_PROJECT_BUILDER_QUERY_PARAM_DEV));
    const [isDrawerOpen] = (0, $eUqFw.useState)(()=>isStagingOrDev && projectBuilderQueryParamDev === 'true');
    if (isDrawerOpen) return (0, $9EFi5.canUseProjectBuilder)(isAdmin) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EFi5.AsyncProjectBuilderDrawer), {
        isOpenInitial: true
    }) : null;
    return null;
};
const $1bb15753e0d08a36$var$ReduxAnalyticsOld = (0, $lNNXV.connect)(null, (dispatch)=>({
        setAnalyticsToRedux: (createAnalyticsEvent)=>{
            dispatch((0, $23fNU.sendAnalyticCreatorAction)(createAnalyticsEvent));
        }
    }))(({ setAnalyticsToRedux: setAnalyticsToRedux })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // Save setAnalyticsToReduxRef to ref to avoid useEffect reevaluation on every rerender
    const setAnalyticsToReduxRef = (0, $eUqFw.useRef)();
    setAnalyticsToReduxRef.current = setAnalyticsToRedux;
    (0, $eUqFw.useEffect)(()=>{
        setAnalyticsToReduxRef.current && setAnalyticsToReduxRef.current(createAnalyticsEvent);
    }, [
        createAnalyticsEvent
    ]);
    return null;
});
const $1bb15753e0d08a36$var$ReduxAnalyticsNew = (0, $lNNXV.connect)(null, (dispatch)=>({
        setAnalyticsToRedux: (createAnalyticsEvent)=>{
            dispatch((0, $23fNU.sendAnalyticCreatorAction)(createAnalyticsEvent));
        }
    }))(({ setAnalyticsToRedux: setAnalyticsToRedux, children: children })=>{
    const [isAnalyticsSet, setIsAnalyticsSet] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // Save setAnalyticsToReduxRef to ref to avoid useEffect reevaluation on every rerender
    const setAnalyticsToReduxRef = (0, $eUqFw.useRef)();
    setAnalyticsToReduxRef.current = setAnalyticsToRedux;
    (0, $eUqFw.useEffect)(()=>{
        setAnalyticsToReduxRef.current && setAnalyticsToReduxRef.current(createAnalyticsEvent);
        setIsAnalyticsSet(true);
    }, [
        createAnalyticsEvent
    ]);
    if (isAnalyticsSet) return children;
    return null;
});
// eslint-disable-next-line jira/react/no-class-components
class $1bb15753e0d08a36$var$AgentApp extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            queue: undefined,
            push: undefined
        };
    }
    renderAgentView() {
        const { isQueueVisible: isQueueVisible, onAtLeastOneIssueLoaded: onAtLeastOneIssueLoaded, queue: queue, onIssuesChanged: onIssuesChanged, onIssuesCountChanged: onIssuesCountChanged } = this.props;
        return (0, $eI5EY.fg)('jsm_flash_servicedesk_analytics_removal') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lEA7a.default), {
            queue: queue,
            isQueueVisible: isQueueVisible,
            onAtLeastOneIssueLoaded: onAtLeastOneIssueLoaded,
            onIssuesChanged: onIssuesChanged,
            onIssuesCountChanged: onIssuesCountChanged
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eV38i.default), null), !(0, $eI5EY.fg)('view_queues_local_storage_data_updated') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1bb15753e0d08a36$var$ReduxAnalyticsOld, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), {
            forceRenderWhileLoading: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lEA7a.default), {
            queue: queue,
            isQueueVisible: isQueueVisible,
            onAtLeastOneIssueLoaded: onAtLeastOneIssueLoaded,
            onIssuesChanged: onIssuesChanged,
            onIssuesCountChanged: onIssuesCountChanged
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eV38i.default), null), !(0, $eI5EY.fg)('view_queues_local_storage_data_updated') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1bb15753e0d08a36$var$ReduxAnalyticsOld, null));
    }
    render() {
        const { isQueueVisible: isQueueVisible, initialState: initialState, locale: locale, onQueueRenderFailure: onQueueRenderFailure, push: push } = this.props;
        const { appProps: { isAdmin: isAdmin } = {} } = initialState;
        const state = {
            appProps: initialState.appProps
        };
        const { projectKey: projectKey } = state.appProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tm9R.default), {
            appName: (0, $frZnw.APP_NAMES).QUEUES_AGENT_VIEW,
            initialState: state,
            locale: locale,
            rootReducer: (0, $MYW4e.enableBatching)((0, $brVi3.default)),
            rootEpic: (0, $eV5Y9.default)(push),
            onErrorHandler: onQueueRenderFailure,
            ErrorView: (0, $8VKaY.QueuesErrorView),
            resetProjectContextAction: (0, $1GlEk.resetProjectContextAction)
        }, (0, $eI5EY.fg)('view_queues_local_storage_data_updated') ? // forceRenderWhileLoading guards against remounting caused by
        // ServiceDeskAnalyticsContext in rare scenarios, which can in turn
        // result in "Cannot update during an existing state transition".
        //
        // See: `this.triggerQueueChange()` called during render() in https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/servicedesk/queues-agent-view/src/view/layout/view.tsx#313
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), {
            forceRenderWhileLoading: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1bb15753e0d08a36$var$ReduxAnalyticsNew, null, (0, $1ybV0.ff)('sptn-1202-banner-for-basic-auth-connected-admins_dpyqu') && isQueueVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6weDO.default), {
            baseUrl: "",
            projectKey: projectKey,
            isAdmin: isAdmin
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dyVe.default), null, this.renderAgentView()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1bb15753e0d08a36$var$ProjectBuilderWithQueryParamDev, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1Y1q.ChangeManagementTour), {
            projectId: (0, $6vrw7.toProjectId)(`${state.appProps.projectId}`)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "incidentManagementTourQueues",
            packageName: "jiraServicedeskIncidentManagementTour",
            fallback: "flag"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUzaT.IncidentManagementTour), {
            projectId: (0, $6vrw7.toProjectId)(`${state.appProps.projectId}`)
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $1ybV0.ff)('sptn-1202-banner-for-basic-auth-connected-admins_dpyqu') && isQueueVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6weDO.default), {
            baseUrl: "",
            projectKey: projectKey,
            isAdmin: isAdmin
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dyVe.default), null, this.renderAgentView()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1bb15753e0d08a36$var$ProjectBuilderWithQueryParamDev, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1Y1q.ChangeManagementTour), {
            projectId: (0, $6vrw7.toProjectId)(`${state.appProps.projectId}`)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "incidentManagementTourQueues",
            packageName: "jiraServicedeskIncidentManagementTour",
            fallback: "flag"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUzaT.IncidentManagementTour), {
            projectId: (0, $6vrw7.toProjectId)(`${state.appProps.projectId}`)
        }))));
    }
}
const $1bb15753e0d08a36$var$AgentViewComponent = (props)=>{
    const { isQueueVisible: isQueueVisible, onAtLeastOneIssueLoaded: onAtLeastOneIssueLoaded, queue: queue, onIssuesChanged: onIssuesChanged, onIssuesCountChanged: onIssuesCountChanged } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), {
        forceRenderWhileLoading: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lEA7a.default), {
        queue: queue,
        isQueueVisible: isQueueVisible,
        onAtLeastOneIssueLoaded: onAtLeastOneIssueLoaded,
        onIssuesChanged: onIssuesChanged,
        onIssuesCountChanged: onIssuesCountChanged
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eV38i.default), null), !(0, $eI5EY.fg)('view_queues_local_storage_data_updated') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1bb15753e0d08a36$var$ReduxAnalyticsOld, null));
};
const $1bb15753e0d08a36$var$AgentAppComponent = (props)=>{
    const { isQueueVisible: isQueueVisible, initialState: initialState, locale: locale, onQueueRenderFailure: onQueueRenderFailure, push: push } = props;
    const { appProps: { isAdmin: isAdmin } = {} } = initialState;
    const { projectKey: projectKey } = initialState.appProps;
    const [{ route: route }] = (0, $lB25E.useRouter)();
    const [queueId] = (0, $lB25E.usePathParam)('queueId');
    const [practiceType] = (0, $lB25E.usePathParam)('practiceType');
    const ssrIssueList = (0, $9pWLn.useSSRIssuesData)({
        matchParams: {
            projectKey: projectKey,
            queueId: queueId ? (0, $aNBkj.toQueueIdString)(queueId) : undefined,
            practiceType: practiceType
        },
        route: route
    });
    const state = {
        appProps: initialState.appProps,
        persisted: {
            ssrIssuesData: {
                ssrIssueList: ssrIssueList,
                isInitialLoading: true
            }
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tm9R.default), {
        appName: (0, $frZnw.APP_NAMES).QUEUES_AGENT_VIEW,
        initialState: state,
        locale: locale,
        rootReducer: (0, $MYW4e.enableBatching)((0, $brVi3.default)),
        rootEpic: (0, $eV5Y9.default)(push),
        onErrorHandler: onQueueRenderFailure,
        ErrorView: (0, $8VKaY.QueuesErrorView),
        resetProjectContextAction: (0, $1GlEk.resetProjectContextAction)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "viewQueue"
    }, (0, $eI5EY.fg)('view_queues_local_storage_data_updated') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), {
        forceRenderWhileLoading: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1bb15753e0d08a36$var$ReduxAnalyticsNew, null, (0, $1ybV0.ff)('sptn-1202-banner-for-basic-auth-connected-admins_dpyqu') && isQueueVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6weDO.default), {
        baseUrl: "",
        projectKey: projectKey,
        isAdmin: isAdmin
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dyVe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1bb15753e0d08a36$var$AgentViewComponent, props)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1bb15753e0d08a36$var$ProjectBuilderWithQueryParamDev, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1Y1q.ChangeManagementTour), {
        projectId: (0, $6vrw7.toProjectId)(`${state.appProps.projectId}`)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "incidentManagementTourQueues",
        packageName: "jiraServicedeskIncidentManagementTour",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUzaT.IncidentManagementTour), {
        projectId: (0, $6vrw7.toProjectId)(`${state.appProps.projectId}`)
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $1ybV0.ff)('sptn-1202-banner-for-basic-auth-connected-admins_dpyqu') && isQueueVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6weDO.default), {
        baseUrl: "",
        projectKey: projectKey,
        isAdmin: isAdmin
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dyVe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1bb15753e0d08a36$var$AgentViewComponent, props)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1bb15753e0d08a36$var$ProjectBuilderWithQueryParamDev, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1Y1q.ChangeManagementTour), {
        projectId: (0, $6vrw7.toProjectId)(`${state.appProps.projectId}`)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "incidentManagementTourQueues",
        packageName: "jiraServicedeskIncidentManagementTour",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUzaT.IncidentManagementTour), {
        projectId: (0, $6vrw7.toProjectId)(`${state.appProps.projectId}`)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            context: (0, $eZfBZ.ANALYTIC_CONTEXTS).QUEUES,
            redesign: true
        }
    })));
};
const $1bb15753e0d08a36$var$AgentAppWithFF = ()=>{
    if (!(0, $eI5EY.fg)('ssr_view_queues_issuelist')) return $1bb15753e0d08a36$var$AgentAppWithAnalytics;
    return $1bb15753e0d08a36$var$AgentAppComponent;
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $1bb15753e0d08a36$var$AgentAppWithAnalytics = (0, $hFmdR.AnalyticsSource)('viewQueue', (0, $41ea3621645e2acc$export$f636b5b56f1d624a))((0, $dewtR.default)({
    attributes: {
        context: (0, $eZfBZ.ANALYTIC_CONTEXTS).QUEUES,
        redesign: true
    }
})($1bb15753e0d08a36$var$AgentApp)); // eslint-disable-line @typescript-eslint/no-explicit-any
var $1bb15753e0d08a36$export$2e2bcd8739ae039 = $1bb15753e0d08a36$var$AgentAppWithFF();

});
parcelRegister("dewtR", function(module, exports) {

$parcel$export(module.exports, "default", () => $47ac80de2ea993f9$export$2e2bcd8739ae039);

var $1ngde = parcelRequire("1ngde");

var $klunD = parcelRequire("klunD");
var /**
 * @deprecated - Just provide the data when firing analytics events.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$47ac80de2ea993f9$export$2e2bcd8739ae039 = (payload)=>(WrappedComponent)=>(0, $1ngde.default)((0, $klunD.default)(payload))(WrappedComponent);

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("iVSJI", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskAnalyticsContext", () => $98f32c00711ff158$export$ac31f8f3368d6881);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");

var $SEaoU = parcelRequire("SEaoU");

var $kJ81T = parcelRequire("kJ81T");
const $98f32c00711ff158$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
    const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
    const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
    if ((0, $eUqFw.Children).count(children) > 0) {
        const loading = containerContextLoading || analyticsContextLoading;
        const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
        if (!shouldRenderChildren) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = {};
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        if (containerContextData && containerContextData.project) {
            // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
            const { id: id, type: type } = containerContextData.project;
            // containerType and containerId are obsolete - See https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#glossary-of-terms
            // Also these dont work with screen events. See sendScreenEvent in: https://bitbucket.org/atlassian/analytics-web-client/src/master/src/analyticsWebClient.js
            // However they are kept here to not break any existing usages.
            context.containerType = 'project';
            context.containerId = `${id}`;
            // This is the preferred way to send container data for analytics
            context.containers = {
                project: {
                    id: `${id}`,
                    type: type
                }
            };
            if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), context, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
$98f32c00711ff158$export$ac31f8f3368d6881.defaultProps = {
    forceRenderWhileLoading: false,
    useServiceDeskAnalyticsContext: (0, $kJ81T.useServiceDeskAnalyticsContext),
    useContainerContext: (0, $SEaoU.useContainerContext)
};

});
parcelRegister("SEaoU", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $753bd1908e635680$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $753bd1908e635680$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $4MmfV = parcelRequire("4MmfV");

var $kXWpU = parcelRequire("kXWpU");

var $lB25E = parcelRequire("lB25E");

var $e8UKN = parcelRequire("e8UKN");
const $753bd1908e635680$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $lB25E.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource));
    const projectContext = (0, $eUqFw.useMemo)(()=>data && (0, $e8UKN.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $753bd1908e635680$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $lB25E.useResource)((0, $4MmfV.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $eUqFw.useMemo)(()=>data && (0, $e8UKN.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $753bd1908e635680$export$c7066c2d215990cf = ()=>{
    const projectContext = $753bd1908e635680$var$useProjectContext();
    const userBoardContext = $753bd1908e635680$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $753bd1908e635680$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $753bd1908e635680$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$753bd1908e635680$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("e8UKN", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $4c7bf04e2602d89a$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $4c7bf04e2602d89a$export$d17fffd59c7b3c60);

var $7ZZxN = parcelRequire("7ZZxN");

var $eWsAG = parcelRequire("eWsAG");
const $4c7bf04e2602d89a$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $4c7bf04e2602d89a$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $4c7bf04e2602d89a$var$getProjectType = (projectType)=>{
    switch(projectType){
        case 'business':
            return 0, $7ZZxN.CORE_PROJECT;
        case 'software':
            return 0, $7ZZxN.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $7ZZxN.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $4c7bf04e2602d89a$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $eWsAG.extractData)(projectNavInfo);
    const scope = $4c7bf04e2602d89a$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $4c7bf04e2602d89a$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $eWsAG.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});



parcelRegister("3tm9R", function(module, exports) {

$parcel$export(module.exports, "default", () => $f33edb1cb3f6ee48$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bd1K7 = parcelRequire("bd1K7");

var $1Qivz = parcelRequire("1Qivz");

var $5BRby = parcelRequire("5BRby");

var $cA8OV = parcelRequire("cA8OV");

var $eCmes = parcelRequire("eCmes");

var $2KWqG = parcelRequire("2KWqG");

var $iDUaT = parcelRequire("iDUaT");

var $cEzlf = parcelRequire("cEzlf");

var $cPHOs = parcelRequire("cPHOs");
// eslint-disable-next-line jira/react/no-class-components
class $f33edb1cb3f6ee48$var$ServiceDeskSubApp extends (0, $eUqFw.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            children: null,
            onErrorHandler: null
        };
    }
    static{
        this.childContextTypes = {
            monolithNavigationBridge: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired
        };
    }
    constructor(props){
        super(props);
        this.onNavigationReject = ()=>{
            this.monolithNavigationBridge && this.monolithNavigationBridge.rejectNavigation();
        };
        this.onNavigationConfirm = ()=>{
            this.monolithNavigationBridge && this.monolithNavigationBridge.confirmNavigation();
        };
        this.monolithNavigationBridge = (0, $eCmes.createMonolithNavigationBridge)();
        const navigationBridgeEpic = (0, $2KWqG.default)(this.onNavigationConfirm, this.onNavigationReject);
        this.store = (0, $cPHOs.createStore)(this.props.appName, this.props.initialState, this.props.rootReducer, this.props.extraMiddleware, (0, $bd1K7.combineEpics)(navigationBridgeEpic, this.props.rootEpic));
    }
    getChildContext() {
        return {
            monolithNavigationBridge: this.monolithNavigationBridge
        };
    }
    shouldComponentUpdate(nextProps) {
        const { appName: appName, rootReducer: rootReducer, rootEpic: rootEpic, children: children, extraMiddleware: extraMiddleware, onErrorHandler: onErrorHandler } = this.props;
        // If any prop other than initialState has changed
        return appName !== nextProps.appName || rootReducer !== nextProps.rootReducer || rootEpic !== nextProps.rootEpic || children !== nextProps.children || extraMiddleware !== nextProps.extraMiddleware || onErrorHandler !== nextProps.onErrorHandler;
    }
    // This state update must happens before render() is called to avoid the wrong queue from loading
    UNSAFE_componentWillUpdate(nextProps) {
        this.resetAppPropsState(this.props.initialState.appProps.projectKey, nextProps.initialState.appProps.projectKey, nextProps.initialState.appProps);
    }
    componentWillUnmount() {
        this.monolithNavigationBridge && this.monolithNavigationBridge.disable();
    }
    resetAppPropsState(currentProjectKey, nextProjectKey, appProps) {
        const { resetProjectContextAction: resetProjectContextAction } = this.props;
        if (!resetProjectContextAction) return;
        if (currentProjectKey !== nextProjectKey) this.store.dispatch(resetProjectContextAction(appProps));
    }
    render() {
        const { children: children, appName: appName, onErrorHandler: onErrorHandler, ErrorView: ErrorView } = this.props;
        // We put the error boundary below <AppBase>, to intercept errors before the error boundary
        // provided by AppBase
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cA8OV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEzlf.ServiceDeskErrorBoundary), {
            appName: appName,
            onErrorHandler: onErrorHandler,
            ErrorView: ErrorView
        }, children)));
    }
}
var $f33edb1cb3f6ee48$export$2e2bcd8739ae039 = (0, $iDUaT.withExtraMiddleware)($f33edb1cb3f6ee48$var$ServiceDeskSubApp);

});
parcelRegister("cA8OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0809371ccd3c77a9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0809371ccd3c77a9$export$2e2bcd8739ae039 = (0, $kwce8.default).div.withConfig({
    componentId: "h5xpn2-0"
})({
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $c9TLT.fontSize)}px`,
    height: 'inherit',
    letterSpacing: 'normal'
});

});

parcelRegister("eCmes", function(module, exports) {

$parcel$export(module.exports, "createMonolithNavigationBridge", () => $1a242bdd80eb6d58$export$e8afb3901df5306d);

var $lFVIh = parcelRequire("lFVIh");
class $1a242bdd80eb6d58$export$dfd89a95c7765d38 {
    cleanUpPromiseCallBack() {
        delete this.resolveFn;
        delete this.rejectFn;
    }
    /**
	 * Calling setBeforeNavigateListener is deferred to here, so that we don't go through a state
	 * where setBeforeNavigateListener fails to register the new listener because there is already
	 * a listener from another page that hasn't finished cleaning up yet.
	 * This is because an instance of the old page and the new page will both be active during a
	 * navigation. I.e. we need componentWillUnmount of the old page to call #disable before setting
	 * the new listener.
	 */ block(beforeNavigateCallback) {
        (0, $lFVIh.RouterManager).deleteBeforeNavigateListener();
        (0, $lFVIh.RouterManager).setBeforeNavigateListener(this.onBeforeNavigate);
        this.beforeNavigateCallback = beforeNavigateCallback;
    }
    unblock() {
        this.beforeNavigateCallback = undefined;
    }
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onBeforeNavigate = (fragment)=>{
            if (!this.beforeNavigateCallback) return Promise.resolve(null);
            this.promise = new Promise((resolve, reject)=>{
                this.resolveFn = resolve;
                this.rejectFn = reject;
            });
            this.beforeNavigateCallback(fragment);
            return this.promise;
        };
        this.confirmNavigation = ()=>{
            this.resolveFn && this.resolveFn();
            this.cleanUpPromiseCallBack();
        };
        this.rejectNavigation = ()=>{
            this.rejectFn && this.rejectFn();
            this.cleanUpPromiseCallBack();
        };
        this.disable = ()=>{
            (0, $lFVIh.RouterManager).deleteBeforeNavigateListener();
        };
    }
}
const $1a242bdd80eb6d58$export$e8afb3901df5306d = ()=>new $1a242bdd80eb6d58$export$dfd89a95c7765d38();

});
parcelRegister("lFVIh", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        function t(r) {
            if (n[r]) return n[r].exports;
            var o = n[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
        }
        var n = {};
        return t.m = e, t.c = n, t.d = function(e, n, r) {
            t.o(e, n) || Object.defineProperty(e, n, {
                configurable: !1,
                enumerable: !0,
                get: r
            });
        }, t.n = function(e) {
            var n = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(n, "a", n), n;
        }, t.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, t.p = "", t(t.s = 3);
    }([
        function(e, t) {
            var n;
            n = function() {
                return this;
            }();
            try {
                n = n || Function("return this")() || (0, eval)("this");
            } catch (e) {
                "object" == typeof window && (n = window);
            }
            e.exports = n;
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n() {
                    return e.window._jsdFeRouting = e.window._jsdFeRouting || {}, e.window._jsdFeRouting;
                }
                function r() {
                    var t = n();
                    !t || t.feRouteFn || t.beforeNavigateListener || t.willNavigateListener || delete e.window._jsdFeRouting;
                }
                function o() {
                    return n().feRouteFn;
                }
                function i() {
                    delete n().feRouteFn, r();
                }
                function u(e) {
                    o() && console.error("Warning: [Service Desk Frontend routing] FeRouteFunction already exists. This function should be set only once per app."), n().feRouteFn = e;
                }
                function a() {
                    return n().beforeNavigateListener;
                }
                function s(e) {
                    a() && console.error("[Service Desk Frontend routing] beforeNavigateListener already exists. Listener should be set only once per app. Make sure you don't set it twice, or forget to unset it when your app unmounts"), n().beforeNavigateListener = e;
                }
                function c() {
                    delete n().beforeNavigateListener, r();
                }
                function l(e) {
                    var t = a();
                    return t ? t(e) : Promise.resolve();
                }
                function g() {
                    delete n().willNavigateListener, r();
                }
                function f() {
                    return n().willNavigateListener;
                }
                function d(e) {
                    f() && console.error("[Service Desk Frontend routing] willNavigateListener already exists. Listener should be set only once per app. Make sure you don't set it twice, or forget to unset it when your app unmounts"), n().willNavigateListener = e;
                }
                function y() {
                    var e = f();
                    if (!e) return void console.warn("[Service Desk Frontend routing] willNavigateListener is not defined. You should unmountComponentAtNode within a willNavigateListener. This is probably a memory leak.");
                    e();
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getFeRouteFunction = o, t.deleteFeRouteFunction = i, t.setFeRouteFunction = u, t.setBeforeNavigateListener = s, t.deleteBeforeNavigateListener = c, t.onBeforeNavigate = l, t.deleteWillNavigateListener = g, t.setWillNavigateListener = d, t.onWillNavigate = y;
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n() {
                    return e.window._jsdFeComponentRegistry = e.window._jsdFeComponentRegistry || {}, e.window._jsdFeComponentRegistry;
                }
                function r(e, t) {
                    n()[e] = t;
                }
                function o(e, t, n) {
                    return new Promise(function(r, o) {
                        a(e, t, n, i, r, o);
                    });
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.registerFeComponent = r, t.renderFeComponentAsync = o;
                var i = 20, u = t.renderFeComponent = function(e, t, r) {
                    var o = n()[e];
                    if (o) return o(t, r);
                    throw new Error("FE component not found: '" + String(e) + "'");
                }, a = function e(t, n, r, o, i, a) {
                    try {
                        var s = u(t, n, r);
                        i(s);
                    } catch (u) {
                        o <= 0 ? a(u) : setTimeout(function() {
                            return e(t, n, r, o - 1, i, a);
                        }, 500);
                    }
                };
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            function r(e) {
                if (e && e.__esModule) return e;
                var t = {};
                if (null != e) for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                return t.default = e, t;
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Events = t.LegacyModuleRegistry = t.LegacyPageRegistry = t.ComponentRegistry = t.PageEnabler = t.RouterManager = void 0;
            var o = n(1), i = r(o), u = n(2), a = r(u), s = n(4), c = r(s), l = n(5), g = r(l), f = n(6), d = r(f), y = n(7), v = function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }(y);
            t.RouterManager = i, t.PageEnabler = v.default, t.ComponentRegistry = a, t.LegacyPageRegistry = c, t.LegacyModuleRegistry = d, t.Events = g;
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n(e, t) {
                    var n = e && e.getPage && e.getPage(t);
                    return n ? n.controllerForJiraFrontend ? n && n.controllerForJiraFrontend() : Promise.reject("Page doesn't have a suitable controller method '" + t + "'") : Promise.reject("Trying to access a page that doesn't exist: '" + t + "'");
                }
                function r() {
                    return e._jsdLegacyAgentPageRegistry;
                }
                function o(t) {
                    e._jsdLegacyAgentPageRegistry = t;
                }
                function i(e) {
                    return n(r(), e);
                }
                function u() {
                    return e._jsdLegacySettingsPageRegistry;
                }
                function a(t) {
                    e._jsdLegacySettingsPageRegistry = t;
                }
                function s(e) {
                    var t = u();
                    return t ? n(t, e) : Promise.reject("Registry does not exist");
                }
                function c() {
                    e._jsdLegacyAgentPageRegistry = {}, e._jsdLegacySettingsPageRegistry = {};
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getGlobalLegacyAgentPageRegistry = r, t.registerLegacyAgentPageRegistry = o, t.runLegacyAgentPageController = i, t.getGlobalLegacySettingsPageRegistry = u, t.registerLegacySettingsPageRegistry = a, t.runLegacySettingsPageController = s, t.clearLegacyPageRegistries = c;
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n() {
                    return e.__jsdLegacyEventBus = e.__jsdLegacyEventBus || {}, e.__jsdLegacyEventBus;
                }
                function r(e) {
                    return n()[e] || [];
                }
                function o(e, t) {
                    var o = n(), i = r(e);
                    i.push(t), o[e] = i;
                }
                function i(e, t) {
                    if (t) {
                        var o = n(), i = r(e);
                        o[e] = i.filter(function(e) {
                            return e !== t;
                        });
                    } else n()[e] = [];
                }
                function u(e, t) {
                    r(e).forEach(function(e) {
                        return e(t);
                    });
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.on = o, t.off = i, t.trigger = u;
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = t.getLegacyModuleRegistry = function() {
                    return e._jsdLegacyModuleRegistry = e._jsdLegacyModuleRegistry || {}, e._jsdLegacyModuleRegistry;
                };
                t.registerLegacyModule = function(e, t) {
                    n()[e] = t;
                };
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function r(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function o(t) {
                    var n = new URL(e.window.location.href), r = n.href.slice(n.origin.length), o = new URL(t), i = o.href.slice(o.origin.length), u = n.hostname === o.hostname && r.startsWith(i) ? r.slice(i.length) : r;
                    return "/" === u[0] ? u : "/" + u;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var i = function() {
                    function e(e, t) {
                        for(var n = 0; n < t.length; n++){
                            var r = t[n];
                            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                        }
                    }
                    return function(t, n, r) {
                        return n && e(t.prototype, n), r && e(t, r), t;
                    };
                }(), u = n(1), a = n(2), s = function() {
                    function e() {
                        r(this, e);
                    }
                    return i(e, [
                        {
                            key: "enablePage",
                            value: function(e, t) {
                                (0, u.deleteFeRouteFunction)();
                                try {
                                    return (0, a.renderFeComponent)(e.feComponentId, t[0], {});
                                } catch (e) {
                                    return Promise.reject(e);
                                }
                            }
                        },
                        {
                            key: "updatePage",
                            value: function(e, t) {
                                var n = (0, u.getFeRouteFunction)();
                                if (t.feComponentId && n) n(o(e));
                                return Promise.resolve();
                            }
                        },
                        {
                            key: "disablePage",
                            value: function() {
                                (0, u.deleteFeRouteFunction)(), (0, u.deleteBeforeNavigateListener)(), (0, u.onWillNavigate)(), (0, u.deleteWillNavigateListener)();
                            }
                        },
                        {
                            key: "beforeNavigate",
                            value: function(e) {
                                return (0, u.onBeforeNavigate)(e);
                            }
                        }
                    ]), e;
                }();
                t.default = s;
            }).call(t, n(0));
        }
    ]);
});

});


parcelRegister("2KWqG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1cc659e32bf1896$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("3wBUP");

var $1ZfCW = parcelRequire("1ZfCW");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d1cc659e32bf1896$export$2e2bcd8739ae039 = (onNavigationConfirm, onNavigationReject)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (action$)=>action$.ofType((0, $1ZfCW.REJECT_NAVIGATION), (0, $1ZfCW.CONFIRM_NAVIGATION)).switchMap((action)=>{
            switch(action.type){
                case 0, $1ZfCW.REJECT_NAVIGATION:
                    onNavigationReject();
                    break;
                case 0, $1ZfCW.CONFIRM_NAVIGATION:
                    onNavigationConfirm();
                    break;
                default:
                    return (0, $3JafE.Observable).empty();
            }
            return (0, $3JafE.Observable).empty();
        });

});
parcelRegister("1ZfCW", function(module, exports) {

$parcel$export(module.exports, "REJECT_NAVIGATION", () => $1432693deb1ed95b$export$c3435b1d4d47dde6);
$parcel$export(module.exports, "rejectNavigationAction", () => $1432693deb1ed95b$export$ce226bb73ade3056);
$parcel$export(module.exports, "CONFIRM_NAVIGATION", () => $1432693deb1ed95b$export$612d6f3c633890da);
$parcel$export(module.exports, "confirmNavigationAction", () => $1432693deb1ed95b$export$949b9bb33ccd5cc0);
// REJECT_NAVIGATION
const $1432693deb1ed95b$export$c3435b1d4d47dde6 = 'navigation.bridge.epic.REJECT_NAVIGATION';
const $1432693deb1ed95b$export$ce226bb73ade3056 = ()=>({
        type: $1432693deb1ed95b$export$c3435b1d4d47dde6
    });
const $1432693deb1ed95b$export$612d6f3c633890da = 'navigation.bridge.epic.CONFIRM_NAVIGATION';
const $1432693deb1ed95b$export$949b9bb33ccd5cc0 = ()=>({
        type: $1432693deb1ed95b$export$612d6f3c633890da
    });

});


parcelRegister("iDUaT", function(module, exports) {

$parcel$export(module.exports, "ExtraMiddlewareProvider", () => $5c103da0d18cd92d$export$b1e1f11078a18473);
$parcel$export(module.exports, "withExtraMiddleware", () => $5c103da0d18cd92d$export$a6e9f53935284a11);
/* eslint-disable max-classes-per-file */ 
var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");
class $5c103da0d18cd92d$export$b1e1f11078a18473 extends (0, $eUqFw.Component) {
    static{
        this.contextTypes = {
            extraMiddleware: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).array
        };
    }
    static{
        this.childContextTypes = {
            extraMiddleware: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).array
        };
    }
    getChildContext() {
        const extraMiddleware = this.props.extraMiddleware;
        // @ts-expect-error - TS2571 - Object is of type 'unknown'. Caused by 3rd party lib
        const existingExtraMiddleware = this.context.extraMiddleware || [];
        return {
            extraMiddleware: [
                ...existingExtraMiddleware,
                ...extraMiddleware
            ]
        };
    }
    render() {
        return (0, $eUqFw.Children).only(this.props.children);
    }
}
const $5c103da0d18cd92d$export$a6e9f53935284a11 = (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any
    class ExtraMiddlewareConsumer extends (0, $eUqFw.Component) {
        static{
            this.contextTypes = {
                extraMiddleware: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).array
            };
        }
        render() {
            // @ts-expect-error - TS2339 - Property 'extraMiddleware' does not exist on type 'unknown'. Caused by 3rd party lib
            const { extraMiddleware: extraMiddleware } = this.context;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                extraMiddleware: extraMiddleware || [],
                ...this.props
            });
        }
    };

});

parcelRegister("cEzlf", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskErrorBoundary", () => $65565c9fe9c34504$export$d999c9325a45f4cf);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $frZnw = parcelRequire("frZnw");
/**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ const $65565c9fe9c34504$var$triggerAnalyticsEvent = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $65565c9fe9c34504$var$toErrorOrUndefined = (error)=>{
    if (error instanceof Error) return error;
    if (typeof error === 'string') return new Error(error);
    return undefined;
};
class $65565c9fe9c34504$export$d999c9325a45f4cf extends (0, $eUqFw.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
        this.triggerEvent = $65565c9fe9c34504$var$triggerAnalyticsEvent(`${props.appName}`);
    }
    componentDidCatch(error) {
        const { onErrorHandler: onErrorHandler, ErrorView: ErrorView, appName: appName } = this.props;
        const data = error instanceof Error ? {
            message: error.message,
            stack: error.stack
        } : {
            message: error
        };
        this.triggerEvent('error-boundary.error-caught', data);
        (0, $guiFP.default)({
            meta: {
                id: 'unhandled',
                packageName: (0, $frZnw.toPackageName)(appName) || 'jiraServicedeskCommon'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            event: this.triggerEvent,
            error: $65565c9fe9c34504$var$toErrorOrUndefined(error),
            sendToPrivacyUnsafeSplunk: true
        });
        // If error view is present then allow error view to handle errors.
        if (ErrorView) return;
        // Some of the non spa apps uses this call back function which doesn't have any error view
        if (onErrorHandler) onErrorHandler(error);
        else // Rethrow for error boundary handling by app-base
        throw error;
    }
    render() {
        const { hasError: hasError } = this.state;
        const { ErrorView: ErrorView, children: children } = this.props;
        if (hasError && ErrorView) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ErrorView, null);
        return children;
    }
}

});

parcelRegister("cPHOs", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $c5b2496c5b3cd0a2$export$f51a9068ac82ea43);
parcelRequire("kprpD");
var $iXVe4 = parcelRequire("iXVe4");
var $kTklP = parcelRequire("kTklP");

var $8FRHo = parcelRequire("8FRHo");

var $lFVIh = parcelRequire("lFVIh");
const $c5b2496c5b3cd0a2$var$combineMiddleWare = (extraMiddleware, history)=>{
    const middlewares = extraMiddleware.slice(0);
    if (history) middlewares.push((0, $kTklP.default)(history));
    return middlewares;
};
const $c5b2496c5b3cd0a2$var$initStore = (storeName, initialState, rootReducer, extraMiddleware, rootEpic, history)=>{
    const middlewares = $c5b2496c5b3cd0a2$var$combineMiddleWare(extraMiddleware, history);
    return (0, $8FRHo.default)({
        appName: storeName,
        initialState: initialState,
        rootReducer: rootReducer,
        rootEpic: rootEpic,
        middlewares: middlewares
    });
};
const $c5b2496c5b3cd0a2$export$f51a9068ac82ea43 = (storeName, initialState, rootReducer, extraMiddleware = [], rootEpic, history, basename)=>{
    const store = $c5b2496c5b3cd0a2$var$initStore(storeName, initialState, rootReducer, extraMiddleware, rootEpic, history);
    // Expose a route function to the JSD monolith, allowing its page-enabler
    // to manage routing.  We 'replace' the history here as JSD already
    // provides us with a history mechanism; avoids double-up.
    if (history) (0, $lFVIh.RouterManager).setFeRouteFunction((url)=>store.dispatch((0, $iXVe4.replace)(url.replace(basename || '', ''))));
    return store;
};

});
parcelRegister("kprpD", function(module, exports) {

$parcel$export(module.exports, "ConnectedRouter", () => (parcelRequire("lCspU")).default);
$parcel$export(module.exports, "routerReducer", () => (parcelRequire("eI5PE")).routerReducer);
$parcel$export(module.exports, "push", () => (parcelRequire("iXVe4")).push);
$parcel$export(module.exports, "replace", () => (parcelRequire("iXVe4")).replace);
$parcel$export(module.exports, "routerMiddleware", () => (parcelRequire("kTklP")).default);

var $lCspU = parcelRequire("lCspU");

var $7VeUU = parcelRequire("7VeUU");

var $eI5PE = parcelRequire("eI5PE");

var $iXVe4 = parcelRequire("iXVe4");

var $kTklP = parcelRequire("kTklP");

});
parcelRegister("lCspU", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd330951acad9f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $aTrRe = parcelRequire("aTrRe");

var $eI5PE = parcelRequire("eI5PE");
function $fbd330951acad9f7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fbd330951acad9f7$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $fbd330951acad9f7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $fbd330951acad9f7$var$ConnectedRouter = function(_Component) {
    $fbd330951acad9f7$var$_inherits(ConnectedRouter, _Component);
    function ConnectedRouter() {
        var _temp, _this, _ret;
        $fbd330951acad9f7$var$_classCallCheck(this, ConnectedRouter);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $fbd330951acad9f7$var$_possibleConstructorReturn(this, _Component.call.apply(_Component, [
            this
        ].concat(args))), _this), _this.handleLocationChange = function(location) {
            _this.store.dispatch({
                type: (0, $eI5PE.LOCATION_CHANGE),
                payload: location
            });
        }, _temp), $fbd330951acad9f7$var$_possibleConstructorReturn(_this, _ret);
    }
    ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
        var _props = this.props, propsStore = _props.store, history = _props.history, isSSR = _props.isSSR;
        this.store = propsStore || this.context.store;
        this.handleLocationChange(history.location);
        if (!isSSR) this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
    };
    ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
    };
    ConnectedRouter.prototype.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTrRe.default), this.props);
    };
    return ConnectedRouter;
}((0, $eUqFw.Component));
$fbd330951acad9f7$var$ConnectedRouter.propTypes = {
    store: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    history: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    isSSR: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool
};
$fbd330951acad9f7$var$ConnectedRouter.contextTypes = {
    store: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
};
var $fbd330951acad9f7$export$2e2bcd8739ae039 = $fbd330951acad9f7$var$ConnectedRouter;

});
parcelRegister("aTrRe", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ee4a658adeb8d1a$export$2e2bcd8739ae039);

var $k6muC = parcelRequire("k6muC");

var $h8TzT = parcelRequire("h8TzT");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");
var $7ee4a658adeb8d1a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $7ee4a658adeb8d1a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7ee4a658adeb8d1a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7ee4a658adeb8d1a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for putting history on context.
 */ var $7ee4a658adeb8d1a$var$Router = function(_React$Component) {
    $7ee4a658adeb8d1a$var$_inherits(Router, _React$Component);
    function Router() {
        var _temp, _this, _ret;
        $7ee4a658adeb8d1a$var$_classCallCheck(this, Router);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $7ee4a658adeb8d1a$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props.history.location.pathname)
        }, _temp), $7ee4a658adeb8d1a$var$_possibleConstructorReturn(_this, _ret);
    }
    Router.prototype.getChildContext = function getChildContext() {
        return {
            router: $7ee4a658adeb8d1a$var$_extends({}, this.context.router, {
                history: this.props.history,
                route: {
                    location: this.props.history.location,
                    match: this.state.match
                }
            })
        };
    };
    Router.prototype.computeMatch = function computeMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    Router.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var _props = this.props, children = _props.children, history = _props.history;
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(children == null || (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.count(children) === 1, "A <Router> may have only one child element");
        // Do this here so we can setState when a <Redirect> changes the
        // location in componentWillMount. This happens e.g. when doing
        // server rendering using a <StaticRouter>.
        this.unlisten = history.listen(function() {
            _this2.setState({
                match: _this2.computeMatch(history.location.pathname)
            });
        });
    };
    Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(this.props.history === nextProps.history, "You cannot change <Router history>");
    };
    Router.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unlisten();
    };
    Router.prototype.render = function render() {
        var children = this.props.children;
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(children) : null;
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$7ee4a658adeb8d1a$var$Router.propTypes = {
    history: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node
};
$7ee4a658adeb8d1a$var$Router.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
};
$7ee4a658adeb8d1a$var$Router.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired
};
var $7ee4a658adeb8d1a$export$2e2bcd8739ae039 = $7ee4a658adeb8d1a$var$Router;

});

parcelRegister("eI5PE", function(module, exports) {

$parcel$export(module.exports, "LOCATION_CHANGE", () => $ab59b2e362a352c4$export$be84bd1ba815d4c2);
$parcel$export(module.exports, "routerReducer", () => $ab59b2e362a352c4$export$a6e30f0f4d30936a);
var $ab59b2e362a352c4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ab59b2e362a352c4$export$be84bd1ba815d4c2 = '@@router/LOCATION_CHANGE';
var $ab59b2e362a352c4$var$initialState = {
    location: null
};
function $ab59b2e362a352c4$export$a6e30f0f4d30936a() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $ab59b2e362a352c4$var$initialState;
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, type = _ref.type, payload = _ref.payload;
    if (type === $ab59b2e362a352c4$export$be84bd1ba815d4c2) return $ab59b2e362a352c4$var$_extends({}, state, {
        location: payload
    });
    return state;
}

});


parcelRegister("7VeUU", function(module, exports) {

var $1d3eD = parcelRequire("1d3eD");
var $5c496d7264a4adcf$export$e7fd20fad3cf4b5f = function getLocation(state) {
    return state.router.location;
};
var $5c496d7264a4adcf$export$a7b4d762fce9f62a = function createMatchSelector(path) {
    var lastPathname = null;
    var lastMatch = null;
    return function(state) {
        var _ref = $5c496d7264a4adcf$export$e7fd20fad3cf4b5f(state) || {}, pathname = _ref.pathname;
        if (pathname === lastPathname) return lastMatch;
        lastPathname = pathname;
        var match = (0, $1d3eD.default)(pathname, path);
        if (!match || !lastMatch || match.url !== lastMatch.url) lastMatch = match;
        return lastMatch;
    };
};

});

parcelRegister("iXVe4", function(module, exports) {

$parcel$export(module.exports, "CALL_HISTORY_METHOD", () => $dcea208c4f15d98a$export$d035cdafa5d37a89);
$parcel$export(module.exports, "push", () => $dcea208c4f15d98a$export$4cbf152802aa238);
$parcel$export(module.exports, "replace", () => $dcea208c4f15d98a$export$77ad94ebf1c2b9ed);
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */ var $dcea208c4f15d98a$export$d035cdafa5d37a89 = '@@router/CALL_HISTORY_METHOD';
function $dcea208c4f15d98a$var$updateLocation(method) {
    return function() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return {
            type: $dcea208c4f15d98a$export$d035cdafa5d37a89,
            payload: {
                method: method,
                args: args
            }
        };
    };
}
var $dcea208c4f15d98a$export$4cbf152802aa238 = $dcea208c4f15d98a$var$updateLocation('push');
var $dcea208c4f15d98a$export$77ad94ebf1c2b9ed = $dcea208c4f15d98a$var$updateLocation('replace');
var $dcea208c4f15d98a$export$93bb224d05b3906d = $dcea208c4f15d98a$var$updateLocation('go');
var $dcea208c4f15d98a$export$28fca2ccfd38b8f = $dcea208c4f15d98a$var$updateLocation('goBack');
var $dcea208c4f15d98a$export$994d0e87e52ba8e3 = $dcea208c4f15d98a$var$updateLocation('goForward');
var $dcea208c4f15d98a$export$95755023e698c378 = {
    push: $dcea208c4f15d98a$export$4cbf152802aa238,
    replace: $dcea208c4f15d98a$export$77ad94ebf1c2b9ed,
    go: $dcea208c4f15d98a$export$93bb224d05b3906d,
    goBack: $dcea208c4f15d98a$export$28fca2ccfd38b8f,
    goForward: $dcea208c4f15d98a$export$994d0e87e52ba8e3
};

});

parcelRegister("kTklP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f358bafd6d07a83f$export$2e2bcd8739ae039);

var $iXVe4 = parcelRequire("iXVe4");
function $f358bafd6d07a83f$export$2e2bcd8739ae039(history) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type !== (0, $iXVe4.CALL_HISTORY_METHOD)) return next(action);
                var _action$payload = action.payload, method = _action$payload.method, args = _action$payload.args;
                history[method].apply(history, args);
            };
        };
    };
}

});




parcelRegister("eZfBZ", function(module, exports) {

$parcel$export(module.exports, "ANALYTIC_CONTEXTS", () => $6d93f232242cadb5$export$ca021921d5c56515);
$parcel$export(module.exports, "ttiRecommendedSlo", () => $6d93f232242cadb5$export$dc391c7d81907d3a);
$parcel$export(module.exports, "trackJsdFetchErrors", () => $6d93f232242cadb5$export$ebdbd98df5a27905);
$parcel$export(module.exports, "fireJsonOnlyErrorAnalytics", () => $6d93f232242cadb5$export$32233c6edb041cf2);

var $guiFP = parcelRequire("guiFP");

var $fV97Z = parcelRequire("fV97Z");
const $6d93f232242cadb5$export$ca021921d5c56515 = {
    AUTOMATION_SETTINGS: 'AutomationSettings',
    KNOWLEDGE: 'Knowledge',
    QUEUES: 'Queues',
    CSAT: 'Csat'
};
const $6d93f232242cadb5$export$cca3c4e11cb0a5ce = 1000;
const $6d93f232242cadb5$export$dc391c7d81907d3a = 4000;
const $6d93f232242cadb5$export$ebdbd98df5a27905 = async (payload)=>{
    const { error: error, attributes: attributes } = payload;
    if (error instanceof (0, $fV97Z.JsdFetchError)) {
        const { reasonKey: reasonKey } = error;
        (0, $guiFP.trackFetchErrors)({
            ...payload,
            attributes: {
                ...attributes,
                reasonKey: reasonKey
            }
        });
        return;
    }
    (0, $guiFP.trackFetchErrors)(payload);
};
function $6d93f232242cadb5$export$32233c6edb041cf2({ error: error, ...rest }) {
    let useError = false;
    if (error instanceof Error) try {
        JSON.parse(error.message);
        useError = true;
    } catch (e) {
        useError = false;
    }
    (0, $guiFP.default)({
        error: error instanceof Error && useError ? error : undefined,
        ...rest
    });
}

});
parcelRegister("fV97Z", function(module, exports) {

$parcel$export(module.exports, "JsdFetchError", () => $c9869c00ba1fbd5b$export$fee0012ae6cb3438);
$parcel$export(module.exports, "performGetRequest", () => $c9869c00ba1fbd5b$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $c9869c00ba1fbd5b$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $c9869c00ba1fbd5b$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $c9869c00ba1fbd5b$export$8ef51cba9d28f819);

var $8blac = parcelRequire("8blac");

var $kkgbD = parcelRequire("kkgbD");

var $fVqUX = parcelRequire("fVqUX");


var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $lRmyA = parcelRequire("lRmyA");
const $c9869c00ba1fbd5b$var$VALIDATION_ERROR_KEY = 'validation.error';
class $c9869c00ba1fbd5b$export$fee0012ae6cb3438 extends (0, $7byHA.default) {
    constructor(statusCode, message, reasonKey, response){
        super(statusCode, (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(message) ? `Fetch call failed with status code: ${statusCode}` : message);
        this.name = 'JsdFetchError';
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(reasonKey)) this.reasonKey = reasonKey;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(response)) this.response = response;
    }
}
const $c9869c00ba1fbd5b$var$transformMessageErrorsFromServer = (errors = [])=>errors.reduce((messages, { errorMessage: errorMessage })=>{
        messages.push(errorMessage);
        return messages;
    }, []).join(' ');
const $c9869c00ba1fbd5b$var$putOptions = {
    ...(0, $fVqUX.default),
    method: 'PUT'
};
const $c9869c00ba1fbd5b$var$postOptions = {
    ...(0, $fVqUX.default),
    method: 'POST'
};
const $c9869c00ba1fbd5b$var$deleteOptions = {
    ...(0, $fVqUX.default),
    method: 'DELETE'
};
const $c9869c00ba1fbd5b$var$patchOptions = {
    ...(0, $fVqUX.default),
    method: 'PATCH'
};
const $c9869c00ba1fbd5b$var$processResponse = async (response)=>{
    if ((0, $1c3fbb431a173cc6$export$9de493bcd9b1d977) === response.status) {
        const jsonResponse = await response.json();
        const { errors: errors, reasonKey: reasonKey } = jsonResponse;
        if (reasonKey === $c9869c00ba1fbd5b$var$VALIDATION_ERROR_KEY) throw (0, $lRmyA.transformValidationErrorFromServer)(jsonResponse);
        const message = $c9869c00ba1fbd5b$var$transformMessageErrorsFromServer(errors);
        throw new $c9869c00ba1fbd5b$export$fee0012ae6cb3438(response.status, message, reasonKey, jsonResponse);
    }
    if (!response.ok) {
        const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
        if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`, traceId);
        else throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`);
    }
    if (response.status === (0, $1c3fbb431a173cc6$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $c9869c00ba1fbd5b$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch(url, {
        ...(0, $fVqUX.default),
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$9ead1f9103e6de6b = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$putOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$692a4d9808143175 = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$postOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$8ef51cba9d28f819 = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$deleteOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$52be6ab13d7e758d = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$patchOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);

});


parcelRegister("bN0JP", function(module, exports) {

$parcel$export(module.exports, "SHOW_PROJECT_BUILDER_QUERY_PARAM", () => $d990083b1b77fb66$export$ca06930325b64075);
$parcel$export(module.exports, "SHOW_PROJECT_BUILDER_QUERY_PARAM_DEV", () => $d990083b1b77fb66$export$bdaa4b82186a5b44);
$parcel$export(module.exports, "BLANK_PROJECT_TEMPLATES", () => $d990083b1b77fb66$export$26b62c0869751109);
const $d990083b1b77fb66$export$ca06930325b64075 = 'showProjectBuilder';
const $d990083b1b77fb66$export$bdaa4b82186a5b44 = 'showProjectBuilderDev';
const $d990083b1b77fb66$export$26b62c0869751109 = [
    'com.atlassian.servicedesk:simplified-blank-project-it',
    'com.atlassian.servicedesk:simplified-blank-project-business',
    'com.atlassian.servicedesk:company-managed-blank-service-project',
    'com.atlassian.servicedesk:team-managed-blank-service-project'
];

});

parcelRegister("8VKaY", function(module, exports) {

$parcel$export(module.exports, "QueuesErrorView", () => $80e5171fc4104445$export$456ee24992efc4a0);

var $eUqFw = parcelRequire("eUqFw");

var $3NCZx = parcelRequire("3NCZx");

var $giAhk = parcelRequire("giAhk");

var $j0tav = parcelRequire("j0tav");
const $80e5171fc4104445$var$onReloadWindow = ()=>{
    window.location.reload();
};
function $80e5171fc4104445$var$Error(props) {
    const { onRetry: onRetry, intl: intl, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3NCZx.default), {
        // @ts-expect-error - TS2322 - Type '{ intl: IntlShapeV2; onRetry: (() => void) | undefined; header: string; description: string; retryMessage: MessageDescriptorV2; }' is not assignable to type 'IntrinsicAttributes & Omit<Pick<Props, "description" | "intl" | "onRetry" | "imageWidth" | "maxImageHeight" | "errorImage"> & Partial<Pick<Props, "header" | ... 3 more ... | "isSubtle">> & Partial<...>, "intl"> & { ...; } & { ...; }'. Caused by 2nd party lib
        intl: intl,
        onRetry: onRetry,
        header: formatMessage((0, $j0tav.default).errorHeader),
        description: formatMessage((0, $j0tav.default).errorMessage),
        retryMessage: (0, $j0tav.default).retry
    });
}
$80e5171fc4104445$var$Error.defaultProps = {
    onRetry: $80e5171fc4104445$var$onReloadWindow
};
const $80e5171fc4104445$export$456ee24992efc4a0 = (0, $giAhk.injectIntlV2)($80e5171fc4104445$var$Error);

});
parcelRegister("j0tav", function(module, exports) {

$parcel$export(module.exports, "default", () => $9973359ea1fe4627$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9973359ea1fe4627$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorHeader: {
        "id": "servicedesk.queues.agent-view.layout.queues-error-boundary.error-header",
        "defaultMessage": "We couldn't load your queue"
    },
    errorMessage: {
        "id": "servicedesk.queues.agent-view.layout.queues-error-boundary.error-message",
        "defaultMessage": "Check your network connection, then try loading the queue again."
    },
    retry: {
        "id": "servicedesk.queues.agent-view.layout.queues-error-boundary.retry",
        "defaultMessage": "Reload queue"
    }
});

});


parcelRegister("eV5Y9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bf02622f5c7cd0c$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $guiFP = parcelRequire("guiFP");

var $2IspF = parcelRequire("2IspF");

var $33hHe = parcelRequire("33hHe");

var $g1oxe = parcelRequire("g1oxe");

var $emmTs = parcelRequire("emmTs");

var $g12Bm = parcelRequire("g12Bm");

var $hpSOY = parcelRequire("hpSOY");

var $lwWKa = parcelRequire("lwWKa");

var $fpcBY = parcelRequire("fpcBY");

var $chIK6 = parcelRequire("chIK6");

var $hXmQu = parcelRequire("hXmQu");

var $e6X8V = parcelRequire("e6X8V");

var $6OKfY = parcelRequire("6OKfY");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2bf02622f5c7cd0c$export$2e2bcd8739ae039 = (push)=>{
    const epic = (0, $bd1K7.combineEpics)((0, $fpcBY.default)(push), (0, $emmTs.default)(push), (0, $hpSOY.default), (0, $lwWKa.default)(), (0, $e6X8V.default), // @ts-expect-error - No overload matches this call.
    (0, $g12Bm.default), (0, $chIK6.default), (0, $hXmQu.default), (0, $6OKfY.default), (0, $g1oxe.default));
    return (action$, store)=>// @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type. | TS7006 - Parameter 'stream' implicitly has an 'any' type.
        epic((0, $33hHe.withUnpackedBatchActions)(action$), store).catch((error, stream)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'agentViewOps',
                    packageName: 'jiraServicedeskQueuesAgentView',
                    teamName: 'jsd-shield'
                },
                error: new Error(error)
            });
            (0, $2IspF.default).safeErrorWithoutCustomerData('servicedesk.queues.agent-view.ops', `Unhandled error: ${error}`);
            return stream;
        });
};

});
parcelRegister("33hHe", function(module, exports) {

$parcel$export(module.exports, "withUnpackedBatchActions", () => $f096a93a33e60ba1$export$25f000f90e13af6b);

var $MYW4e = parcelRequire("MYW4e");
parcelRequire("jyKN9");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");
const $f096a93a33e60ba1$export$25f000f90e13af6b = (action$)=>action$.mergeMap((action)=>{
        if (action.type === (0, $MYW4e.BATCH)) return (0, $3JafE.Observable).of(...action.payload);
        return (0, $3JafE.Observable).of(action);
    });

});

parcelRegister("g1oxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cfe315154fe7bd5$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("3wBUP");


var $8N2pO = parcelRequire("8N2pO");

var $3ztB9 = parcelRequire("3ztB9");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4cfe315154fe7bd5$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $8N2pO.FILTER_QUERY_SUBMITTED)).switchMap((action)=>{
        const source = action.payload.filterQuery === null || action.payload.filterQuery === '' ? (0, $34edc5e681269c4f$export$347de2d26274ffda) : (0, $34edc5e681269c4f$export$be4c1ea173a5271a);
        return (0, $3JafE.Observable).of((0, $8N2pO.filterQueryChangedAction)(action.payload.filterQuery), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $3ztB9.loadIssuesAction)(0, source));
    });

});
const $34edc5e681269c4f$export$f162a928a40c7ab8 = 'PAGE';
const $34edc5e681269c4f$export$3de6d8bdd297654b = 'VIEW';
const $34edc5e681269c4f$export$fa4dae241333de34 = 'POLL';
const $34edc5e681269c4f$export$d4d94a8c13e2df1d = 'SCROLL';
const $34edc5e681269c4f$export$2003e3fdddd4c35b = 'SORT';
const $34edc5e681269c4f$export$347de2d26274ffda = 'FORCE_UPDATE';
const $34edc5e681269c4f$export$be4c1ea173a5271a = 'FILTER';
const $34edc5e681269c4f$export$217a2381e50d4bff = 'SIDEBAR';
const $34edc5e681269c4f$export$b5ad9376033e98b2 = 'UP';
const $34edc5e681269c4f$export$28a694fb106a7f62 = 'DOWN';
const $34edc5e681269c4f$export$57022ca1771ad970 = 'UNCHANGED';

parcelRegister("8N2pO", function(module, exports) {

$parcel$export(module.exports, "FILTER_QUERY_CHANGED", () => $0b6383e58e202123$export$9e0f2488271e98d0);
$parcel$export(module.exports, "filterQueryChangedAction", () => $0b6383e58e202123$export$5fa47224179ff864);
$parcel$export(module.exports, "FILTER_QUERY_SUBMITTED", () => $0b6383e58e202123$export$6a1c1f3d64af9a47);
$parcel$export(module.exports, "filterQuerySubmittedAction", () => $0b6383e58e202123$export$d1c2b6692ed10481);
$parcel$export(module.exports, "IS_NEW_FILTER_QUERY_PENDING", () => $0b6383e58e202123$export$8a6c9cbc89786426);
$parcel$export(module.exports, "isNewFilterQueryPendingAction", () => $0b6383e58e202123$export$ea018c090643753b);
$parcel$export(module.exports, "IS_FILTER_FOCUSED", () => $0b6383e58e202123$export$ec8ded223992d792);
$parcel$export(module.exports, "isFilterFocusedAction", () => $0b6383e58e202123$export$6fd90bc7d8a253ba);
$parcel$export(module.exports, "IS_FILTER_FAILED", () => $0b6383e58e202123$export$963953e34e913763);
$parcel$export(module.exports, "filterBadQueryAction", () => $0b6383e58e202123$export$d0b1a5137ee88e41);
// FILTER_QUERY_CHANGED
const $0b6383e58e202123$export$9e0f2488271e98d0 = 'state.actions.filter.FILTER_QUERY_CHANGED';
const $0b6383e58e202123$export$5fa47224179ff864 = (filterQuery)=>({
        type: $0b6383e58e202123$export$9e0f2488271e98d0,
        payload: {
            filterQuery: filterQuery
        }
    });
const $0b6383e58e202123$export$6a1c1f3d64af9a47 = 'state.actions.filter.FILTER_QUERY_SUBMITTED';
const $0b6383e58e202123$export$d1c2b6692ed10481 = (filterQuery)=>({
        type: $0b6383e58e202123$export$6a1c1f3d64af9a47,
        payload: {
            filterQuery: filterQuery
        }
    });
const $0b6383e58e202123$export$8a6c9cbc89786426 = 'state.actions.filter.IS_NEW_FILTER_QUERY_PENDING';
const $0b6383e58e202123$export$ea018c090643753b = (isNewFilterQueryPending)=>({
        type: $0b6383e58e202123$export$8a6c9cbc89786426,
        payload: {
            isNewFilterQueryPending: isNewFilterQueryPending
        }
    });
const $0b6383e58e202123$export$ec8ded223992d792 = 'state.actions.filter.IS_FILTER_FOCUSED';
const $0b6383e58e202123$export$6fd90bc7d8a253ba = (isFilterFocused)=>({
        type: $0b6383e58e202123$export$ec8ded223992d792,
        payload: {
            isFilterFocused: isFilterFocused
        }
    });
const $0b6383e58e202123$export$963953e34e913763 = 'state.actions.filter.IS_FILTER_FAILED';
const $0b6383e58e202123$export$d0b1a5137ee88e41 = (isNewFilterQueryPending)=>({
        type: $0b6383e58e202123$export$963953e34e913763,
        payload: {
            isNewFilterQueryPending: isNewFilterQueryPending
        }
    });

});

parcelRegister("3ztB9", function(module, exports) {

$parcel$export(module.exports, "OPEN_ISSUE", () => $3dccfdea4fc7a859$export$1e8a1b726c043d27);
$parcel$export(module.exports, "openIssueAction", () => $3dccfdea4fc7a859$export$d5542de2015b0d5f);
$parcel$export(module.exports, "LOAD_ISSUES", () => $3dccfdea4fc7a859$export$447a39ee503b31ea);
$parcel$export(module.exports, "loadIssuesAction", () => $3dccfdea4fc7a859$export$3eef863aa89b92c2);
$parcel$export(module.exports, "loadIssuesActionForPage", () => $3dccfdea4fc7a859$export$34fd96b3e33e0d2d);
$parcel$export(module.exports, "LOAD_ISSUES_INTERNAL", () => $3dccfdea4fc7a859$export$e13e56ae077f63d6);
$parcel$export(module.exports, "loadIssuesInternalAction", () => $3dccfdea4fc7a859$export$71ac868813e1a9ac);
$parcel$export(module.exports, "LOAD_ISSUES_SUCCESS", () => $3dccfdea4fc7a859$export$5a92ff25027c7f22);
$parcel$export(module.exports, "loadIssuesSuccessAction", () => $3dccfdea4fc7a859$export$c552dcd13b2a0c6b);
$parcel$export(module.exports, "LOAD_ISSUES_FAILURE", () => $3dccfdea4fc7a859$export$e91cdeca4d2aea23);
$parcel$export(module.exports, "loadIssuesFailureAction", () => $3dccfdea4fc7a859$export$6b830be58d650030);


var $9U7QG = parcelRequire("9U7QG");

const $3dccfdea4fc7a859$export$1e8a1b726c043d27 = 'state.actions.issue.OPEN_ISSUE';
const $3dccfdea4fc7a859$export$d5542de2015b0d5f = ()=>({
        type: $3dccfdea4fc7a859$export$1e8a1b726c043d27
    });
const $3dccfdea4fc7a859$export$447a39ee503b31ea = 'state.actions.issue.LOAD_ISSUES';
const $3dccfdea4fc7a859$export$3eef863aa89b92c2 = (startIndex, source, bypassCache = false)=>{
    const endIndex = startIndex + (0, $9U7QG.FETCH_BATCH_SIZE) - 1;
    return {
        type: $3dccfdea4fc7a859$export$447a39ee503b31ea,
        payload: {
            startIndex: startIndex,
            endIndex: endIndex,
            source: source,
            bypassCache: bypassCache
        }
    };
};
const $3dccfdea4fc7a859$export$34fd96b3e33e0d2d = (currentPage)=>{
    const startIndex = (currentPage - 1) * (0, $6e1a998ae5fb6552$export$f88f58d1a4b2078b);
    return $3dccfdea4fc7a859$export$3eef863aa89b92c2(startIndex, (0, $34edc5e681269c4f$export$f162a928a40c7ab8));
};
const $3dccfdea4fc7a859$export$e13e56ae077f63d6 = 'state.actions.issue.LOAD_ISSUES_INTERNAL';
const $3dccfdea4fc7a859$export$71ac868813e1a9ac = (startIndex, endIndex, source, bypassCache = false)=>({
        type: $3dccfdea4fc7a859$export$e13e56ae077f63d6,
        payload: {
            startIndex: startIndex,
            endIndex: endIndex,
            source: source,
            bypassCache: bypassCache
        }
    });
const $3dccfdea4fc7a859$export$5a92ff25027c7f22 = 'state.actions.issue.LOAD_ISSUES_SUCCESS';
const $3dccfdea4fc7a859$export$c552dcd13b2a0c6b = (loadedIssuesResponse, queueId, startIndex, source)=>({
        type: $3dccfdea4fc7a859$export$5a92ff25027c7f22,
        payload: {
            loadedIssuesResponse: loadedIssuesResponse,
            queueId: queueId,
            startIndex: startIndex,
            source: source
        }
    });
const $3dccfdea4fc7a859$export$e91cdeca4d2aea23 = 'state.actions.issue.LOAD_ISSUES_FAILURE';
const $3dccfdea4fc7a859$export$6b830be58d650030 = (source, error, statusCode, isQueueEmpty, traceId)=>({
        type: $3dccfdea4fc7a859$export$e91cdeca4d2aea23,
        payload: {
            source: source,
            error: error,
            statusCode: statusCode,
            isQueueEmpty: isQueueEmpty,
            traceId: traceId
        }
    });

});
/**
 * Default Props for Table component
 */ const $6e1a998ae5fb6552$export$258441c8a79bb589 = 40;
const $6e1a998ae5fb6552$export$80fc56c6cdbfffed = true;
const $6e1a998ae5fb6552$export$6fd8e343a23be522 = false;
const $6e1a998ae5fb6552$export$f88f58d1a4b2078b = 10000;
const $6e1a998ae5fb6552$export$ad4eb70d85e8e21f = 100;



parcelRegister("emmTs", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1dddce4a28e99f8$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $4Kl8h = parcelRequire("4Kl8h");

var $aIlWw = parcelRequire("aIlWw");

var $gKZmz = parcelRequire("gKZmz");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f1dddce4a28e99f8$export$2e2bcd8739ae039 = (push)=>(0, $bd1K7.combineEpics)((0, $aIlWw.default), (0, $4Kl8h.default), (0, $gKZmz.default)(push));

});
parcelRegister("4Kl8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a984a8c8ca8a47c$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $3ztB9 = parcelRequire("3ztB9");

var $8vuXb = parcelRequire("8vuXb");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6a984a8c8ca8a47c$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $3ztB9.LOAD_ISSUES)).mergeMap((action)=>(0, $3JafE.Observable).of((0, $8vuXb.stopPollAction)(), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $3ztB9.loadIssuesInternalAction)(action.payload.startIndex, action.payload.endIndex, // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'Action'.
        action.payload.source, action.payload.bypassCache)));

});
parcelRegister("8vuXb", function(module, exports) {

$parcel$export(module.exports, "STOP_POLL", () => $9dd32e618ccb0401$export$beabbea0833100ca);
$parcel$export(module.exports, "stopPollAction", () => $9dd32e618ccb0401$export$2b79fcb148191d1);
$parcel$export(module.exports, "RESTART_POLL", () => $9dd32e618ccb0401$export$ea1ead92e01d02d1);
$parcel$export(module.exports, "restartPollAction", () => $9dd32e618ccb0401$export$ef03a991480cfcdf);
$parcel$export(module.exports, "POLL_SUCCESS", () => $9dd32e618ccb0401$export$270005d7201abd12);
$parcel$export(module.exports, "pollSuccessAction", () => $9dd32e618ccb0401$export$77220b17516f6c17);
$parcel$export(module.exports, "pollContentNotModifiedAction", () => $9dd32e618ccb0401$export$5dda10bc6b4052b9);
$parcel$export(module.exports, "POLL_FAILURE", () => $9dd32e618ccb0401$export$8cce70f9c508c33);
$parcel$export(module.exports, "pollFailureAction", () => $9dd32e618ccb0401$export$b98aa82aec1f8949);
$parcel$export(module.exports, "RESET_PROJECT_STATE_HASH", () => $9dd32e618ccb0401$export$22d4fc20a9bcbb3c);
$parcel$export(module.exports, "DISPLAY_UNSUCCESSFUL_POLL_WARNING", () => $9dd32e618ccb0401$export$e03796746e3f4a62);
$parcel$export(module.exports, "displayUnsuccessfulPollWarningAction", () => $9dd32e618ccb0401$export$9bb3518e0ef04f1a);
$parcel$export(module.exports, "DISMISS_ALL_FLAGS", () => $9dd32e618ccb0401$export$8dde630a1a89a61d);
$parcel$export(module.exports, "dismissAllFlagsAction", () => $9dd32e618ccb0401$export$3a102aa35c9fa2b1);
$parcel$export(module.exports, "DISMISS_WARNING_FLAG", () => $9dd32e618ccb0401$export$ae3da4b73c471af0);
$parcel$export(module.exports, "dismissWarningFlagAction", () => $9dd32e618ccb0401$export$6902f66f812ce9cd);
// STOP_POLL
const $9dd32e618ccb0401$export$beabbea0833100ca = 'state.actions.update-metadata.STOP_POLL';
const $9dd32e618ccb0401$export$2b79fcb148191d1 = ()=>({
        type: $9dd32e618ccb0401$export$beabbea0833100ca
    });
const $9dd32e618ccb0401$export$ea1ead92e01d02d1 = 'state.actions.update-metadata.RESTART_POLL';
const $9dd32e618ccb0401$export$ef03a991480cfcdf = (skipInitialDelay = false)=>({
        type: $9dd32e618ccb0401$export$ea1ead92e01d02d1,
        payload: {
            skipInitialDelay: skipInitialDelay
        }
    });
const $9dd32e618ccb0401$export$270005d7201abd12 = 'state.actions.update-metadata.POLL_SUCCESS';
const $9dd32e618ccb0401$export$77220b17516f6c17 = (projectStateHash)=>({
        type: $9dd32e618ccb0401$export$270005d7201abd12,
        payload: {
            projectStateHash: projectStateHash
        }
    });
const $9dd32e618ccb0401$export$307cef20083545bd = 'state.actions.update-metadata.POLL_CONTENT_NOT_MODIFIED';
const $9dd32e618ccb0401$export$5dda10bc6b4052b9 = ()=>({
        type: $9dd32e618ccb0401$export$307cef20083545bd
    });
const $9dd32e618ccb0401$export$8cce70f9c508c33 = 'state.actions.update-metadata.POLL_FAILURE';
const $9dd32e618ccb0401$export$b98aa82aec1f8949 = ()=>({
        type: $9dd32e618ccb0401$export$8cce70f9c508c33
    });
const $9dd32e618ccb0401$export$22d4fc20a9bcbb3c = 'state.actions.update-metadata.RESET_PROJECT_STATE_HASH';
const $9dd32e618ccb0401$export$b3d5f4d178d2f21e = ()=>({
        type: $9dd32e618ccb0401$export$22d4fc20a9bcbb3c
    });
const $9dd32e618ccb0401$export$e03796746e3f4a62 = 'state.actions.update-metadata.DISPLAY_UNSUCCESSFUL_POLL_WARNING';
const $9dd32e618ccb0401$export$9bb3518e0ef04f1a = ()=>({
        type: $9dd32e618ccb0401$export$e03796746e3f4a62
    });
const $9dd32e618ccb0401$export$8dde630a1a89a61d = 'state.actions.update-metadata.DISMISS_ALL_FLAGS';
const $9dd32e618ccb0401$export$3a102aa35c9fa2b1 = ()=>({
        type: $9dd32e618ccb0401$export$8dde630a1a89a61d
    });
const $9dd32e618ccb0401$export$ae3da4b73c471af0 = 'state.actions.update-metadata.DISMISS_WARNING_FLAG';
const $9dd32e618ccb0401$export$6902f66f812ce9cd = ()=>({
        type: $9dd32e618ccb0401$export$ae3da4b73c471af0
    });

});


parcelRegister("aIlWw", function(module, exports) {

$parcel$export(module.exports, "default", () => $468f255149f53734$export$2e2bcd8739ae039);

var $MYW4e = parcelRequire("MYW4e");

var $3JafE = parcelRequire("3JafE");

var $9oL1R = parcelRequire("9oL1R");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $7byHA = parcelRequire("7byHA");

var $JRB5w = parcelRequire("JRB5w");
parcelRequire("jyKN9");

var $jkkH8 = parcelRequire("jkkH8");


var $7Tdtn = parcelRequire("7Tdtn");

var $8N2pO = parcelRequire("8N2pO");

var $3ztB9 = parcelRequire("3ztB9");

var $8vuXb = parcelRequire("8vuXb");

var $03V54 = parcelRequire("03V54");

var $8UPn4 = parcelRequire("8UPn4");

var $8GAE5 = parcelRequire("8GAE5");

var $3KNsL = parcelRequire("3KNsL");

var $b60vU = parcelRequire("b60vU");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$468f255149f53734$export$2e2bcd8739ae039 = (action$, store)=>(0, $jkkH8.withConcurrencyLimiting)(action$.ofType((0, $3ztB9.LOAD_ISSUES_INTERNAL)), 3, (action)=>{
        const state = store.getState();
        const queueId = (0, $3KNsL.getQueueId)(state);
        const shouldFireGenericErrorAnalytics = (error)=>{
            if ((0, $guiFP.getStatusCodeGroup)(new (0, $7byHA.default)(error.statusCode)) === 'unknown' || (0, $JRB5w.isClientFetchError)(error)) return false;
            return true;
        };
        const sendGenericErrorAnalytics = (error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'jsmIssueListLoading',
                    packageName: 'jiraServicedeskQueuesAgentView',
                    teamName: 'jsd-shield'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: new (0, $7byHA.default)(error.statusCode),
                attributes: {
                    reasonKey: error.response.reasonKey,
                    reasonCode: error.response.reasonCode
                }
            });
        };
        const sendGenericErrorAnalyticsConditionally = (error)=>{
            if (shouldFireGenericErrorAnalytics(error)) sendGenericErrorAnalytics(error);
        };
        const sendSearchErrorAnalytics = (error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'jsmIssueListLoadingFilter',
                    packageName: 'jiraServicedeskQueuesAgentView',
                    teamName: 'jsd-shield'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: new (0, $7byHA.default)(error.statusCode),
                attributes: {
                    hasPassed: false
                }
            });
        };
        const shouldFireSearchErrorAnalytics = (error)=>{
            const statusCodeGroup = (0, $guiFP.getStatusCodeGroup)(new (0, $7byHA.default)(error.statusCode));
            return action.payload.source === (0, $34edc5e681269c4f$export$be4c1ea173a5271a) && (statusCodeGroup === '5xx' || statusCodeGroup === '4xx') && !(0, $JRB5w.isClientFetchError)(error);
        };
        const sendErrorAnalytics = (error)=>{
            if (shouldFireSearchErrorAnalytics(error)) sendSearchErrorAnalytics(error);
            sendGenericErrorAnalyticsConditionally(error);
        };
        const isUpdate = [
            (0, $34edc5e681269c4f$export$fa4dae241333de34),
            (0, $34edc5e681269c4f$export$3de6d8bdd297654b)
        ].includes(// @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'Action'.
        action.payload.source);
        const isQueueFiltering = action.payload.source === (0, $34edc5e681269c4f$export$be4c1ea173a5271a);
        const isPageLoad = action.payload.source === (0, $34edc5e681269c4f$export$f162a928a40c7ab8);
        const dispatchRestartPollActionWhenAppIdleInInitialLoad = ()=>{
            // only run this in initial load
            if (isPageLoad && action.payload.startIndex === 0 && !isUpdate && !isQueueFiltering && (0, $b60vU.getIsInitialLoad)(state)) (0, $9oL1R.unstable_scheduleCallback)((0, $9oL1R.unstable_IdlePriority), ()=>{
                // @ts-expect-error - TS2345 - Argument of type 'RestartPollAction' is not assignable to parameter of type 'State'. Type 'RestartPollAction' is missing the following properties from type 'State': appProps, ui, persisted
                store.dispatch((0, $8vuXb.restartPollAction)(true));
            });
        };
        // @ts-expect-error - TS2345 - rgument of type 'UnsetIsInitialLoad' is not assignable to parameter of type 'State'. Type 'UnsetIsInitialLoad' is missing the following properties from type 'State': appProps, ui, persisted
        const dispatchUnsetIsInitialLoadAction = ()=>store.dispatch((0, $03V54.unsetIsInitialLoad)());
        return (0, $7Tdtn.default)(action.payload.startIndex, action.payload.endIndex, isUpdate, action.payload.source === (0, $34edc5e681269c4f$export$f162a928a40c7ab8), action.payload.bypassCache, state, action.payload.source === (0, $34edc5e681269c4f$export$be4c1ea173a5271a), dispatchUnsetIsInitialLoadAction).flatMap((result)=>{
            // dispatch only in initial load
            if ((0, $eI5EY.fg)('ssr_view_queues_issuelist')) dispatchRestartPollActionWhenAppIdleInInitialLoad();
            return (0, $3JafE.Observable).of((0, $MYW4e.batchActions)([
                (0, $8vuXb.restartPollAction)(),
                (0, $3ztB9.loadIssuesSuccessAction)(result, queueId, action.payload.startIndex, action.payload.source)
            ]));
        })// @ts-expect-error - TS2345 - Argument of type '(error: ErrorResponse) => Observable<BatchAction> | Observable<RestartPollAction>' is not assignable to parameter of type '(err: any, caught: Observable<BatchAction>) => ObservableInput<BatchAction>'.
        .catch((error)=>{
            if (error.statusCode === 304) return (0, $3JafE.Observable).of((0, $8vuXb.restartPollAction)());
            if (// Bad query request
            error.statusCode === 400 && action.payload.source === (0, $34edc5e681269c4f$export$be4c1ea173a5271a)) {
                const isNewFilterQueryPendingAction = (0, $8UPn4.getIsNewFilterQueryPending)(state);
                return (0, $3JafE.Observable).of((0, $MYW4e.batchActions)([
                    (0, $8vuXb.restartPollAction)(),
                    (0, $8N2pO.filterBadQueryAction)(isNewFilterQueryPendingAction)
                ]));
            }
            sendErrorAnalytics(error);
            return (0, $3JafE.Observable).of((0, $MYW4e.batchActions)([
                (0, $8vuXb.restartPollAction)(),
                (0, $3ztB9.loadIssuesFailureAction)(action.payload.source, error.response, error.statusCode, (0, $8GAE5.getIssueCacheSize)(state) === 0, error.traceId)
            ]));
        });
    });

});
parcelRegister("jkkH8", function(module, exports) {

$parcel$export(module.exports, "withConcurrencyLimiting", () => $8e34c775c88f4bea$export$1c063aa9514214db);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("gY5tY");
parcelRequire("1Lcr1");
parcelRequire("l5lul");
parcelRequire("8OtG5");
parcelRequire("iects");
parcelRequire("3wBUP");

var $gUUjF = parcelRequire("gUUjF");

var $awVZg = parcelRequire("awVZg");

var $teVwp = parcelRequire("teVwp");
const $8e34c775c88f4bea$var$LOCATION = 'servicedesk.common.epic-util.concurrency-limiter';
const $8e34c775c88f4bea$var$EMPTY_SENTINEL = 'EMPTY_SENTINEL';
const $8e34c775c88f4bea$var$defaultOperator = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
source, // eslint-disable-next-line @typescript-eslint/no-explicit-any
inner)=>source.switchMap(inner);
const $8e34c775c88f4bea$export$1c063aa9514214db = (source, availableTokenCount, inner, operator = $8e34c775c88f4bea$var$defaultOperator, leaseTime)=>{
    if (availableTokenCount < 1) throw new Error(`${$8e34c775c88f4bea$var$LOCATION}: availableTokenCount must be at least 1`);
    const { injectableSource$: injectableSource$, inject: inject } = (0, $teVwp.createInjectableSource)(source);
    const stateContainer = new (0, $awVZg.default)(availableTokenCount, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    inject, leaseTime);
    const withToken = (v)=>stateContainer.withToken.call(stateContainer, v);
    return operator(injectableSource$.mergeMap(withToken), ({ returnToken: returnToken, value: value })=>inner(value) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        .defaultIfEmpty($8e34c775c88f4bea$var$EMPTY_SENTINEL).do(returnToken, returnToken, returnToken).catch((err)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData($8e34c775c88f4bea$var$LOCATION, err);
            return (0, $3JafE.Observable).empty();
        }).do((v)=>{
            if (v === $8e34c775c88f4bea$var$EMPTY_SENTINEL) (0, $gUUjF.default).safeWarnWithoutCustomerData($8e34c775c88f4bea$var$LOCATION, 'Empty observable detected. Do not use the concurrency-limiter with empty observables.');
        }).filter((v)=>v !== $8e34c775c88f4bea$var$EMPTY_SENTINEL));
};

});
parcelRegister("gY5tY", function(module, exports) {
"use strict";

var $3JafE = parcelRequire("3JafE");

var $1Cfqf = parcelRequire("1Cfqf");
$3JafE.Observable.prototype.defaultIfEmpty = $1Cfqf.defaultIfEmpty;

});
parcelRegister("1Cfqf", function(module, exports) {

$parcel$export(module.exports, "defaultIfEmpty", () => $12d54d9d6deb5093$export$e4ca6d7b7a6dcf9b, (v) => $12d54d9d6deb5093$export$e4ca6d7b7a6dcf9b = v);
var $12d54d9d6deb5093$export$e4ca6d7b7a6dcf9b;
"use strict";

var $kyjNq = parcelRequire("kyjNq");
/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $12d54d9d6deb5093$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return $kyjNq.defaultIfEmpty(defaultValue)(this);
}
$12d54d9d6deb5093$export$e4ca6d7b7a6dcf9b = $12d54d9d6deb5093$var$defaultIfEmpty;

});


parcelRegister("awVZg", function(module, exports) {

$parcel$export(module.exports, "default", () => $99ec7a104d814b35$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("3wBUP");

var $6l6Xk = parcelRequire("6l6Xk");

var $3JafE = parcelRequire("3JafE");

var $fuEOp = parcelRequire("fuEOp");
const $99ec7a104d814b35$var$DEFAULT_LEASE_TIME = 10000;
class $99ec7a104d814b35$export$2e2bcd8739ae039 {
    constructor(availableTokenCount, injectCallback, leaseTime = $99ec7a104d814b35$var$DEFAULT_LEASE_TIME){
        this.bufferedValue = null;
        this.onReturnToken = ()=>{
            if (this.bufferedValue) {
                const value = this.bufferedValue;
                this.bufferedValue = null;
                this.injectCallback(value);
            }
        };
        this.tokenDispenser = (0, $fuEOp.default)(availableTokenCount);
        this.injectCallback = injectCallback;
        this.leaseTime = leaseTime;
        this.availableTokenCount = availableTokenCount;
    }
    areAllTokensTaken() {
        return this.tokenDispenser.getAvailableTokenCount() === 0;
    }
    withToken(value) {
        if (this.areAllTokensTaken()) {
            this.bufferedValue = value;
            return (0, $3JafE.Observable).empty();
        }
        return this.tokenDispenser.takeToken().switchMap((token)=>{
            const returnToken = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(()=>{
                token.returnToken();
                this.onReturnToken();
            });
            const leaseTimeoutId = window.setTimeout(returnToken, this.leaseTime);
            return (0, $3JafE.Observable).of({
                returnToken: ()=>{
                    window.clearTimeout(leaseTimeoutId);
                    returnToken();
                },
                value: value
            });
        });
    }
}

});
parcelRegister("fuEOp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a973bc30e2f488e$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("jnCPY");
parcelRequire("jyKN9");
parcelRequire("iects");

var $6l6Xk = parcelRequire("6l6Xk");

var $3JafE = parcelRequire("3JafE");
const $2a973bc30e2f488e$var$tokenDispenser = (initialTokens)=>{
    let availableTokens = initialTokens;
    const obs$ = (0, $3JafE.Observable).create((observer)=>{
        availableTokens -= 1;
        observer.next('TOKEN');
    });
    const returnToken = ()=>{
        availableTokens += 1;
    };
    return {
        takeToken: ()=>{
            if (availableTokens) return obs$.take(1).mergeMap(()=>(0, $3JafE.Observable).of({
                    returnToken: (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(returnToken)
                }));
            return (0, $3JafE.Observable).empty();
        },
        getAvailableTokenCount: ()=>availableTokens
    };
};
var $2a973bc30e2f488e$export$2e2bcd8739ae039 = $2a973bc30e2f488e$var$tokenDispenser;

});


parcelRegister("teVwp", function(module, exports) {

$parcel$export(module.exports, "createInjectableSource", () => $a8f1edc91a34c304$export$81fae18a40db9d6c);

var $jG2Eu = parcelRequire("jG2Eu");

var $3JafE = parcelRequire("3JafE");
parcelRequire("ihTrY");

var $70s4u = parcelRequire("70s4u");
parcelRequire("YLEHo");
parcelRequire("l5lul");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a8f1edc91a34c304$var$COMPLETE = 'servicedesk.common.epic-util.concurrency-limiter.COMPLETE_VALUE';
const $a8f1edc91a34c304$export$81fae18a40db9d6c = (source)=>{
    const buffer$ = new (0, $70s4u.Subject)();
    const completeStream = ()=>{
        buffer$.next($a8f1edc91a34c304$var$COMPLETE);
    };
    return {
        // When the source completes, we must also complete the buffer.
        injectableSource$: (0, $3JafE.Observable).merge(source.do((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), completeStream, completeStream), buffer$.takeWhile((v)=>v !== $a8f1edc91a34c304$var$COMPLETE)),
        inject: (value)=>{
            buffer$.next(value);
        }
    };
};

});


parcelRegister("7Tdtn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a4ee43037f4cad9$export$2e2bcd8739ae039);

var $8i1R8 = parcelRequire("8i1R8");

var $3JafE = parcelRequire("3JafE");

var $6iz4v = parcelRequire("6iz4v");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");

var $8Obc6 = parcelRequire("8Obc6");

var $aNBkj = parcelRequire("aNBkj");

var $kdPoh = parcelRequire("kdPoh");

var $3nTcJ = parcelRequire("3nTcJ");

var $fYqUr = parcelRequire("fYqUr");
parcelRequire("dM0Xt");
parcelRequire("8jBvP");
parcelRequire("cpH8E");
parcelRequire("jyKN9");
parcelRequire("bI4RP");
parcelRequire("1Lcr1");
parcelRequire("8SBcT");
parcelRequire("flmol");
parcelRequire("iects");
parcelRequire("buH2V");

var $i676h = parcelRequire("i676h");

var $JlScu = parcelRequire("JlScu");

var $5sNW7 = parcelRequire("5sNW7");

var $8UPn4 = parcelRequire("8UPn4");

var $3KNsL = parcelRequire("3KNsL");

var $6ycyf = parcelRequire("6ycyf");

var $b60vU = parcelRequire("b60vU");

var $3s9hs = parcelRequire("3s9hs");

var $7AwFA = parcelRequire("7AwFA");

var $b7YH5 = parcelRequire("b7YH5");

var $iUdsz = parcelRequire("iUdsz");

var $cxLLZ = parcelRequire("cxLLZ");
// Number of retries. Excludes the first call.
const $7a4ee43037f4cad9$var$NUMBER_OF_RETRIES = 2;
const $7a4ee43037f4cad9$var$ISSUES_FETCH_STARTED_MARK = 'jsd.performance.profile.queues.issues.fetch.from.server.started';
const $7a4ee43037f4cad9$var$ISSUES_FETCH_COMPLETED_MARK = 'jsd.performance.profile.queues.issues.fetch.from.server.completed';
/**
 * Due to various reason (sorting field id is not longer valid, custom field has been removed, sorting field is no longer
 * visible in the queue, etc), the sorting returned from the /issuelist endpoint maybe different from what we
 * stored in the local storage. We should keep them in sync after every ajax call.
 */ const $7a4ee43037f4cad9$var$updateManualSortingInLocalStorage = (queueId, result)=>{
    const { columns: columns, isUsingDefaultSorting: isUsingDefaultSorting } = result;
    const manualSortingColumn = isUsingDefaultSorting ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(columns, (column)=>column.sortOrder != null);
    if (manualSortingColumn != null) (0, $7AwFA.storeSortOrderInLocalStorage)(queueId, manualSortingColumn.fieldId, // @ts-expect-error - TS2345 - Argument of type 'SortOrder | undefined' is not assignable to parameter of type 'SortOrder'.
    manualSortingColumn.sortOrder);
    else (0, $7AwFA.removeSortOrderInLocalStorage)(queueId);
};
const $7a4ee43037f4cad9$var$isRetryableStatusCode = (statusCode)=>statusCode === 429 || statusCode >= 500;
const $7a4ee43037f4cad9$var$MAX_RETRY_DELAY_MS = 15000;
const $7a4ee43037f4cad9$var$BASE_DELAY_MS = 5000;
/**
 * Exponential backoff with max delay and jitter
 * https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter/
 */ const $7a4ee43037f4cad9$var$maxExpBackoffWithJitter = (retries, baseDelay, maxDelay)=>{
    const exponential = Math.pow(2, retries) * baseDelay;
    const delay = Math.min(exponential, maxDelay);
    const jitter = Math.random();
    const delayWithJitter = Math.floor(jitter * delay);
    return delayWithJitter;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7a4ee43037f4cad9$export$2e2bcd8739ae039 = (startIndex, endIndex, isUpdate, isSourceFromPage, bypassCache, state, isQueueFiltering = false, unsetIsInitialLoad)=>{
    const queueId = (0, $3KNsL.getQueueId)(state);
    const columnIds = (0, $3KNsL.getColumnIds)(state);
    const columns = (0, $3KNsL.getColumns)(state);
    const jql = (0, $3KNsL.getJql)(state);
    const columnTypesAsJson = (0, $8Obc6.getFieldTypesEligibleForJsonData)();
    const issuesPerPage = endIndex - startIndex + 1;
    const baseUrl = (0, $3nTcJ.getBaseUrl)(state);
    const projectKey = (0, $3nTcJ.getProjectKey)(state);
    const sortedBy = (0, $6ycyf.getSortedByColumn)(state);
    const isAscendingOrder = (0, $6ycyf.getIsAscendingOrder)(state);
    const sortOrder = (0, $6ycyf.getSortOrder)(state);
    const category = (0, $3KNsL.getCategory)(state);
    const filterQuery = (0, $8UPn4.getCurrentFilterQuery)(state);
    const isFilterRequested = filterQuery !== null;
    let retries = 0;
    const storeAndTransform = (result, source)=>{
        $7a4ee43037f4cad9$var$updateManualSortingInLocalStorage(queueId, result);
        if (startIndex === 0 && !isFilterRequested) {
            let createAnalyticsEvent;
            if ((0, $eI5EY.fg)('view_queues_local_storage_data_updated')) createAnalyticsEvent = (0, $5sNW7.getCreateAnalyticsEvent)(state);
            (0, $b7YH5.storeIssuesInLocalStorage)(result, jql, queueId, sortedBy, sortOrder, isUpdate, createAnalyticsEvent);
        }
        return (0, $iUdsz.default)(result, source, isFilterRequested, isFilterRequested);
    };
    const fireQueueFilteringAnalytics = (result)=>{
        const createAnalyticsEvent = (0, $5sNW7.getCreateAnalyticsEvent)(state);
        if (createAnalyticsEvent) {
            // extract the query text from the filter query
            const queryText = filterQuery?.match(/"([^"]*)\*"/);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueFiltering searched', {
                filteredQueueLength: result.issues.length,
                filterLength: queryText ? queryText[1].length : 0
            });
        }
    };
    const fireIssueListRetryAnalyticsSuccess = (numberOfRetries)=>{
        const createAnalyticsEvent = (0, $5sNW7.getCreateAnalyticsEvent)(state);
        if (createAnalyticsEvent) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jsmIssueList retrySucceeded', {
            numberOfRetries: numberOfRetries
        });
    };
    const fireIssueListRetryAnalyticsFailed = (statusCode)=>{
        const createAnalyticsEvent = (0, $5sNW7.getCreateAnalyticsEvent)(state);
        if (createAnalyticsEvent) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jsmIssueList retryFailed', {
            statusCode: statusCode
        });
    };
    const requestData = {
        projectKey: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string' for projectKey.
        projectKey,
        baseUrl: baseUrl,
        jql: jql,
        columnNames: columnIds,
        columnTypesAsJson: columnTypesAsJson,
        startIndex: startIndex,
        issuesPerPage: issuesPerPage,
        orderBy: sortedBy,
        isAscendingOrder: isAscendingOrder,
        category: category,
        filterClause: filterQuery
    };
    const getIssuesFromLocalStorage = ()=>bypassCache || startIndex !== 0 || filterQuery !== null ? (0, $3JafE.Observable).empty() : (0, $b7YH5.getIssuesInLocalStorage)(queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder);
    const ssrIssuesData = state.persisted.ssrIssuesData?.ssrIssueList;
    const fetchRequestHandler = ()=>{
        (0, $6iz4v.setMark)($7a4ee43037f4cad9$var$ISSUES_FETCH_STARTED_MARK);
        const fetchStartTime = performance.now();
        return (0, $i676h.default)(requestData).flatMap((result)=>{
            if ((0, $eI5EY.fg)('send_queue_metrics_to_perf_portal')) (0, $fYqUr.addSpanToAll)('fetch', 'rest/servicedesk/1/servicedesk/projectKey/issuelist', [
                {
                    name: 'network'
                }
            ], fetchStartTime, performance.now());
            (0, $6iz4v.setMark)($7a4ee43037f4cad9$var$ISSUES_FETCH_COMPLETED_MARK);
            (0, $cxLLZ.sendIssuelistStalenessAnalytics)(result, false);
            if (isQueueFiltering) fireQueueFilteringAnalytics(result);
            if (retries > 0) fireIssueListRetryAnalyticsSuccess(retries);
            return (0, $3JafE.Observable).of(storeAndTransform(result, (0, $aNBkj.REST_SOURCE)));
        }).retryWhen((errors)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            errors.mergeMap((error)=>{
                retries += 1;
                if (!$7a4ee43037f4cad9$var$isRetryableStatusCode(error?.statusCode) || retries > $7a4ee43037f4cad9$var$NUMBER_OF_RETRIES) {
                    fireIssueListRetryAnalyticsFailed(error.statusCode);
                    return (0, $3JafE.Observable).throw(error);
                }
                return (0, $3JafE.Observable).of(error.statusCode).delay($7a4ee43037f4cad9$var$maxExpBackoffWithJitter(retries, $7a4ee43037f4cad9$var$BASE_DELAY_MS, $7a4ee43037f4cad9$var$MAX_RETRY_DELAY_MS));
            }));
    };
    const getIssuesFromPrefetcher = (prefetchedIssuePromise)=>(0, $3JafE.Observable).fromPromise(prefetchedIssuePromise).map((response)=>{
            (0, $6iz4v.setMark)('jsd.performance.profile.queues.prefetch.resolved');
            (0, $kdPoh.unsetPrefetchedIssuePromise)(queueId);
            return storeAndTransform(response.data, (0, $aNBkj.PREFETCHER_SOURCE));
        }).catch(()=>fetchRequestHandler());
    if (sortedBy) (0, $7AwFA.storeSortOrderInLocalStorage)(queueId, sortedBy, sortOrder);
    else (0, $7AwFA.removeSortOrderInLocalStorage)(queueId);
    if (isUpdate) return (0, $JlScu.default)({
        ...requestData,
        issueHash: (0, $3s9hs.getIssueHash)(state)
    }).flatMap((result)=>{
        (0, $cxLLZ.sendIssuelistStalenessAnalytics)(result, true);
        if (isQueueFiltering) fireQueueFilteringAnalytics(result);
        return (0, $3JafE.Observable).of(storeAndTransform(result, (0, $aNBkj.REST_SOURCE)));
    });
    const prefetchedIssuePromise = (0, $kdPoh.getPrefetchedIssuePromise)(queueId);
    if ((0, $eI5EY.fg)('ssr_view_queues_issuelist')) {
        const isInitialLoad = startIndex === 0 && isSourceFromPage && sortedBy === undefined && !isFilterRequested && !isUpdate && (0, $b60vU.getIsInitialLoad)(state);
        if (isInitialLoad) {
            // unset isInitialLoad state
            unsetIsInitialLoad();
            if (ssrIssuesData) {
                const loadedIssueListData = storeAndTransform(ssrIssuesData, (0, $aNBkj.SSR_SOURCE));
                return (0, $3JafE.Observable).of(loadedIssueListData);
            }
            const localStorageData = (0, $b7YH5.maybeIssuesInLocalStorage)(queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder);
            if (localStorageData.isSome()) return localStorageData.cata((0, $3JafE.Observable).empty, (0, $3JafE.Observable).of);
        }
    }
    const issueListObservable = prefetchedIssuePromise.isSome() && !filterQuery ? prefetchedIssuePromise// @ts-expect-error - TS7006 - Parameter 'promise' implicitly has an 'any' type.
    .map((promise)=>getIssuesFromPrefetcher(promise)).orSome((0, $3JafE.Observable).empty()) : fetchRequestHandler();
    // The concat operator is best used when you need to combine multiple observables,
    // but you want their emissions to be in a specific order, one after the other.
    return (0, $3JafE.Observable).concat(getIssuesFromLocalStorage(), issueListObservable);
};

});
parcelRegister("8Obc6", function(module, exports) {

$parcel$export(module.exports, "getFieldTypesEligibleForJsonData", () => $ce0cd4b78f8fa5ab$export$e2bd4328395b4df7);
$parcel$export(module.exports, "getFieldTypesEligibleForJsonDataAsSet", () => $ce0cd4b78f8fa5ab$export$740140e54d80c734);
$parcel$export(module.exports, "getFieldTypesToOverrideHtmlDataForAsSet", () => $ce0cd4b78f8fa5ab$export$dacb9fc482fbe93);

var $8nrDO = parcelRequire("8nrDO");

var $3LiTJ = parcelRequire("3LiTJ");

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");
const $ce0cd4b78f8fa5ab$var$getFieldTypesFromFeatureFlagMap = (featureFlagMap)=>(0, (/*@__PURE__*/$parcel$interopDefault($8nrDO)))((0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))(featureFlagMap, (isAlwaysJsonOrFFKey)=>{
        if (typeof isAlwaysJsonOrFFKey === 'boolean') return isAlwaysJsonOrFFKey;
        // eslint-disable-next-line jira/ff/static-feature-flags
        return (0, $1ybV0.ff)(isAlwaysJsonOrFFKey);
    }));
const $ce0cd4b78f8fa5ab$export$c394db035bb5cf7d = {
    assignee: true,
    'com.atlassian.servicedesk:sd-sla-field': true,
    status: true,
    issuetype: true,
    reporter: true,
    summary: true,
    'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype': true,
    labels: true,
    'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype': true,
    'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype': true,
    'com.atlassian.jira.plugins.work-category-field:work-category-field-cftype': 'jsm-unscreenable-field-phase-2_5uafe',
    'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multiselect': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker': true,
    'com.atlassian.servicedesk:sd-request-participants': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multiversion': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker': true,
    'com.atlassian.servicedesk.customer-context:sd-csm-entitlement': true,
    'com.atlassian.servicedesk.sentiment:sd-sentiment': 'sentiment-custom-field'
};
const $ce0cd4b78f8fa5ab$export$e2bd4328395b4df7 = (0, $5iWql.default)(()=>$ce0cd4b78f8fa5ab$var$getFieldTypesFromFeatureFlagMap($ce0cd4b78f8fa5ab$export$c394db035bb5cf7d));
const $ce0cd4b78f8fa5ab$export$740140e54d80c734 = (0, $5iWql.default)(()=>new Set($ce0cd4b78f8fa5ab$export$e2bd4328395b4df7()));
// @ts-expect-error(PARTIAL_RECORD) TS2740 | TS2740 - Type '{ issuekey: true; }' is missing the following properties from type 'FeatureFlagMap': summary, status, reporter, date, and 13 more. | Type '{ issuekey: true; }' is missing the following properties from type 'FeatureFlagMap': summary, date, labels, assignee, and 13 more.
const $ce0cd4b78f8fa5ab$var$FIELD_TYPES_TO_OVERRIDE_HTML_DATA_FOR_FF_KEYS = {
    issuekey: true,
    priority: true
};
const $ce0cd4b78f8fa5ab$export$8e81e0bb2e4fc09e = (0, $5iWql.default)(()=>$ce0cd4b78f8fa5ab$var$getFieldTypesFromFeatureFlagMap($ce0cd4b78f8fa5ab$var$FIELD_TYPES_TO_OVERRIDE_HTML_DATA_FOR_FF_KEYS));
const $ce0cd4b78f8fa5ab$export$dacb9fc482fbe93 = (0, $5iWql.default)(()=>new Set($ce0cd4b78f8fa5ab$export$8e81e0bb2e4fc09e()));

});

parcelRegister("kdPoh", function(module, exports) {

$parcel$export(module.exports, "transformColumns", () => $93af1561a9af230a$export$6e8deebce7129a99);
$parcel$export(module.exports, "transformIssues", () => $93af1561a9af230a$export$a26a6de2e9ae64a0);
$parcel$export(module.exports, "getPrefetchedIssuePromise", () => $93af1561a9af230a$export$13bba225866f1e46);
$parcel$export(module.exports, "unsetPrefetchedIssuePromise", () => $93af1561a9af230a$export$56d44580e340f1f4);
$parcel$export(module.exports, "default", () => $93af1561a9af230a$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("iects");

var $3aUuh = parcelRequire("3aUuh");

var $7Oh8q = parcelRequire("7Oh8q");

var $3JafE = parcelRequire("3JafE");

var $aNBkj = parcelRequire("aNBkj");
const $93af1561a9af230a$export$6e8deebce7129a99 = (responseColumns)=>responseColumns.map((responseColumn)=>{
        const column = {
            id: responseColumn.fieldId,
            title: responseColumn.columnHeaderText,
            fieldType: responseColumn.fieldType,
            sortable: responseColumn.sortable
        };
        if (responseColumn.sortOrder) return {
            ...column,
            currentSorting: responseColumn.sortOrder
        };
        return column;
    });
const $93af1561a9af230a$var$mapFieldsByColumnId = (fields)=>// @ts-expect-error - TS2322 - Type 'Dictionary<number | ResponseField | { (callbackfn: (previousValue: ResponseField, currentValue: ResponseField, currentIndex: number, array: ResponseField[]) => ResponseField): ResponseField; (callbackfn: (previousValue: ResponseField, currentValue: ResponseField, currentIndex: number, array: ResponseField[]) => Resp...' is not assignable to type 'FieldsById'. | TS2339 - Property 'fieldId' does not exist on type 'ResponseField'. | TS2339 - Property 'fieldCssClass' does not exist on type 'ResponseField'.
    (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(fields, (field)=>field.fieldId || field.fieldCssClass);
const $93af1561a9af230a$export$a26a6de2e9ae64a0 = (issues)=>issues.map((issue)=>({
            id: issue.id,
            key: issue.key,
            fields: $93af1561a9af230a$var$mapFieldsByColumnId(issue.fields),
            position: issue.position
        }));
const $93af1561a9af230a$export$13bba225866f1e46 = (queueId)=>(0, $7Oh8q.Maybe).fromNull(window.JSD_QUEUES_PRELOAD_PROMISES && window.JSD_QUEUES_PRELOAD_PROMISES[`queueIssues_${(0, $aNBkj.fromQueueId)(queueId)}`]);
const $93af1561a9af230a$export$56d44580e340f1f4 = (queueId)=>{
    if (window.JSD_QUEUES_PRELOAD_PROMISES) window.JSD_QUEUES_PRELOAD_PROMISES[`queueIssues_${(0, $aNBkj.fromQueueId)(queueId)}`] = undefined;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$93af1561a9af230a$export$2e2bcd8739ae039 = (rest, transformFunc)=>rest.mergeMap((payload)=>(0, $3JafE.Observable).of(transformFunc(payload)));

});
parcelRegister("7Oh8q", function(module, exports) {
//     Monet.js 0.8.10
//     (c) 2012-2016 Chris Myers
//     Monet.js may be freely distributed under the MIT license.
//     For all details and documentation:
//     https://cwmyers.github.com/monet.js
(function(root, factory) {
    module.exports = factory(root);
})(module.exports, function(root) {
    "use strict";
    var curry = function(fn, args) {
        return function() {
            var args1 = args.append(List.fromArray(Array.prototype.slice.call(arguments)));
            return args1.size() >= fn.length ? fn.apply(this, args1.toArray().slice(0, args1.size())) : curry(fn, args1);
        };
    };
    var isFunction = function(f) {
        return !!(f && f.constructor && f.call && f.apply);
    };
    var idFunction = function(value) {
        return value;
    };
    var trueFunction = function() {
        return true;
    };
    var falseFunction = function() {
        return false;
    };
    var Monet = root.Monet = {};
    var swap = Monet.swap = function(f) {
        return function(a, b) {
            return f(b, a);
        };
    };
    var map = function(fn) {
        return this.bind(this.of.compose(fn));
    };
    var apply2 = Monet.apply2 = function(a1, a2, f) {
        return a2.ap(a1.map(f.curry()));
    };
    Monet.curry = function(fn) {
        return curry(fn, Nil);
    };
    Function.prototype.curry = function() {
        return curry(this, Nil);
    };
    // List monad
    var list;
    var List = list = root.List = function(head, tail) {
        return new List.fn.init(head, tail);
    };
    var listMap = function(fn, l) {
        return listMapC(fn, l).run();
    };
    var listMapC = function(fn, l) {
        return l.isNil ? Return(l) : Suspend(function() {
            return listMapC(fn, l.tail());
        }).map(cons.curry()(fn(l.head())));
    };
    var listEach = function(effectFn, l) {
        if (!l.isNil) {
            effectFn(l.head());
            listEach(effectFn, l.tail());
        }
    };
    var foldLeft = function(fn, acc, l) {
        function fL(acc, l) {
            return l.isNil ? Return(acc) : Suspend(function() {
                return fL(fn(acc, l.head()), l.tail());
            });
        }
        return fL(acc, l).run();
    };
    var foldRight = function(fn, l, acc) {
        function fR(l, acc) {
            return l.isNil ? Return(acc) : Suspend(function() {
                return fR(l.tail(), acc);
            }).map(function(acc1) {
                return fn(l.head(), acc1);
            });
        }
        return fR(l, acc).run();
    };
    var append = function(list1, list2) {
        function append1(list1, list2) {
            return list1.isNil ? Return(list2) : Suspend(function() {
                return append1(list1.tail(), list2).map(function(list) {
                    return list.cons(list1.head());
                });
            });
        }
        return append1(list1, list2).run();
    };
    var sequence = function(list, type) {
        return list.foldRight(type.of(Nil))(type.map2(cons));
    };
    var sequenceValidation = function(list) {
        return list.foldLeft(Success(Nil))(function(acc, a) {
            return acc.ap(a.map(function(v) {
                return function(t) {
                    return cons(v, t);
                };
            }));
        }).map(listReverse);
    };
    var listReverse = function(list) {
        return list.foldLeft(Nil)(swap(cons));
    };
    var listFilter = function(list, fn) {
        return list.foldRight(Nil)(function(a, acc) {
            return fn(a) ? cons(a, acc) : acc;
        });
    };
    var listAp = function(list1, list2) {
        return list1.bind(function(x) {
            return list2.map(function(f) {
                return f(x);
            });
        });
    };
    var cons = function(head, tail) {
        return tail.cons(head);
    };
    List.fn = List.prototype = {
        init: function(head, tail) {
            if (head == null) {
                this.isNil = true;
                this.size_ = 0;
            } else {
                this.isNil = false;
                this.head_ = head;
                this.tail_ = tail == null ? Nil : tail;
                this.size_ = tail == null ? 0 : tail.size() + 1;
            }
        },
        of: function(value) {
            return new List(value);
        },
        size: function() {
            return this.size_;
        },
        cons: function(head) {
            return List(head, this);
        },
        snoc: function(element) {
            return this.concat(List(element));
        },
        map: function(fn) {
            return listMap(fn, this);
        },
        toArray: function() {
            return foldLeft(function(acc, e) {
                acc.push(e);
                return acc;
            }, [], this);
        },
        foldLeft: function(initialValue) {
            var self = this;
            return function(fn) {
                return foldLeft(fn, initialValue, self);
            };
        },
        foldRight: function(initialValue) {
            var self = this;
            return function(fn) {
                return foldRight(fn, self, initialValue);
            };
        },
        append: function(list2) {
            return append(this, list2);
        },
        filter: function(fn) {
            return listFilter(this, fn);
        },
        flatten: function() {
            return foldRight(append, this, Nil);
        },
        flattenMaybe: function() {
            return this.flatMap(Maybe.toList);
        },
        reverse: function() {
            return listReverse(this);
        },
        bind: function(fn) {
            return this.map(fn).flatten();
        },
        each: function(effectFn) {
            listEach(effectFn, this);
        },
        // transforms a list of Maybes to a Maybe list
        sequenceMaybe: function() {
            return sequence(this, Maybe);
        },
        sequenceValidation: function() {
            return sequenceValidation(this);
        },
        sequenceEither: function() {
            return sequence(this, Either);
        },
        sequenceIO: function() {
            return sequence(this, IO);
        },
        sequenceReader: function() {
            return sequence(this, Reader);
        },
        sequence: function(monadType) {
            return sequence(this, monadType);
        },
        head: function() {
            return this.head_;
        },
        headMaybe: function() {
            return this.isNil ? None() : Some(this.head_);
        },
        tail: function() {
            return this.isNil ? Nil : this.tail_;
        },
        tails: function() {
            return this.isNil ? List(Nil, Nil) : this.tail().tails().cons(this);
        },
        ap: function(list) {
            return listAp(this, list);
        },
        isNEL: falseFunction
    };
    List.fn.init.prototype = List.fn;
    var Nil = root.Nil = new List.fn.init();
    // Aliases
    List.prototype.empty = function() {
        return Nil;
    };
    List.fromArray = function(array) {
        var l = Nil;
        for(var i = array.length; i--; i)l = l.cons(array[i]);
        return l;
    };
    List.of = function(a) {
        return new List(a, Nil);
    };
    /*
     * Non-Empty List monad
     * This is also a comonad because there exists the implementation of extract(copure), which is just head
     * and cobind and cojoin.
     *
     */ var NonEmptyList;
    var NEL = root.NEL = NonEmptyList = root.NonEmptyList = function(head, tail) {
        if (head == null) throw "Cannot create an empty Non-Empty List.";
        return new NEL.fn.init(head, tail);
    };
    NEL.of = function(a) {
        return NEL(a, Nil);
    };
    NEL.fn = NEL.prototype = {
        init: function(head, tail) {
            if (head == null) {
                this.isNil = true;
                this.size_ = 0;
            } else {
                this.isNil = false;
                this.head_ = head;
                this.tail_ = tail == null ? Nil : tail;
                this.size_ = this.tail_.size() + 1;
            }
        },
        map: function(fn) {
            return NEL(fn(this.head_), listMap(fn, this.tail_));
        },
        bind: function(fn) {
            var p = fn(this.head_);
            if (!p.isNEL()) throw "function must return a NonEmptyList.";
            var list = this.tail().foldLeft(Nil.snoc(p.head()).append(p.tail()))(function(acc, e) {
                var list2 = fn(e).toList();
                return acc.snoc(list2.head()).append(list2.tail());
            });
            return new NEL(list.head(), list.tail());
        },
        head: function() {
            return this.head_;
        },
        tail: function() {
            return this.tail_;
        },
        //NEL[A] -> NEL[NEL[A]]
        tails: function() {
            var listsOfNels = this.toList().tails().map(NEL.fromList).flattenMaybe();
            return NEL(listsOfNels.head(), listsOfNels.tail());
        },
        toList: function() {
            return List(this.head_, this.tail_);
        },
        reverse: function() {
            if (this.tail().isNil) return this;
            else {
                var reversedTail = this.tail().reverse();
                return NEL(reversedTail.head(), reversedTail.tail().append(List(this.head())));
            }
        },
        foldLeft: function(initialValue) {
            return this.toList().foldLeft(initialValue);
        },
        foldRight: function(initialValue) {
            return this.toList().foldRight(initialValue);
        },
        reduceLeft: function(fn) {
            return this.tail().foldLeft(this.head())(fn);
        },
        filter: function(fn) {
            return listFilter(this.toList(), fn);
        },
        append: function(list2) {
            return NEL.fromList(this.toList().append(list2.toList())).some();
        },
        // NEL[A] -> (NEL[A] -> B) -> NEL[B]
        cobind: function(fn) {
            return this.cojoin().map(fn);
        },
        size: function() {
            return this.size_;
        },
        isNEL: trueFunction
    };
    NEL.fromList = function(list) {
        return list.isNil ? None() : Some(NEL(list.head(), list.tail()));
    };
    NEL.fn.init.prototype = NEL.fn;
    NEL.prototype.toArray = List.prototype.toArray;
    NEL.prototype.extract = NEL.prototype.copure = NEL.prototype.head;
    NEL.prototype.cojoin = NEL.prototype.tails;
    NEL.prototype.coflatMap = NEL.prototype.mapTails = NEL.prototype.cobind;
    NEL.prototype.ap = List.prototype.ap;
    /* Maybe Monad */ var Maybe = root.Maybe = {};
    Maybe.fromNull = function(val) {
        return val == null ? Maybe.None() : Maybe.Some(val);
    };
    Maybe.of = function(a) {
        return Some(a);
    };
    var Just;
    var Some = Just = Maybe.Just = Maybe.Some = root.Some = root.Just = function(val) {
        return new Maybe.fn.init(true, val);
    };
    var Nothing;
    var None = Nothing = Maybe.Nothing = Maybe.None = root.None = function() {
        return new Maybe.fn.init(false, null);
    };
    Maybe.toList = function(maybe) {
        return maybe.toList();
    };
    Maybe.fn = Maybe.prototype = {
        init: function(isValue, val) {
            this.isValue = isValue;
            if (val == null && isValue) throw "Illegal state exception";
            this.val = val;
        },
        isSome: function() {
            return this.isValue;
        },
        isNone: function() {
            return !this.isSome();
        },
        bind: function(bindFn) {
            return this.isValue ? bindFn(this.val) : this;
        },
        some: function() {
            if (this.isValue) return this.val;
            else throw "Illegal state exception";
        },
        orSome: function(otherValue) {
            return this.isValue ? this.val : otherValue;
        },
        orElse: function(maybe) {
            return this.isValue ? this : maybe;
        },
        ap: function(maybeWithFunction) {
            var value = this.val;
            return this.isValue ? maybeWithFunction.map(function(fn) {
                return fn(value);
            }) : this;
        },
        toList: function() {
            return this.map(List).orSome(Nil);
        },
        toEither: function(failVal) {
            return this.isSome() ? Right(this.val) : Left(failVal);
        },
        toValidation: function(failVal) {
            return this.isSome() ? Success(this.val) : Fail(failVal);
        },
        fold: function(defaultValue) {
            var self = this;
            return function(fn) {
                return self.isSome() ? fn(self.val) : defaultValue;
            };
        },
        cata: function(none, some) {
            return this.isSome() ? some(this.val) : none();
        },
        filter: function(fn) {
            var self = this;
            return self.flatMap(function(a) {
                return fn(a) ? self : None();
            });
        }
    };
    // aliases
    Maybe.prototype.orJust = Maybe.prototype.orSome;
    Maybe.prototype.just = Maybe.prototype.some;
    Maybe.prototype.isJust = Maybe.prototype.isSome;
    Maybe.prototype.isNothing = Maybe.prototype.isNone;
    Maybe.fn.init.prototype = Maybe.fn;
    var Validation = root.Validation = {};
    var Success = Validation.Success = Validation.success = root.Success = function(val) {
        return new Validation.fn.init(val, true);
    };
    var Fail = Validation.Fail = Validation.fail = root.Fail = function(error) {
        return new Validation.fn.init(error, false);
    };
    Validation.of = function(v) {
        return Success(v);
    };
    Validation.fn = Validation.prototype = {
        init: function(val, success) {
            this.val = val;
            this.isSuccessValue = success;
        },
        success: function() {
            if (this.isSuccess()) return this.val;
            else throw 'Illegal state. Cannot call success() on a Validation.fail';
        },
        isSuccess: function() {
            return this.isSuccessValue;
        },
        isFail: function() {
            return !this.isSuccessValue;
        },
        fail: function() {
            if (this.isSuccess()) throw 'Illegal state. Cannot call fail() on a Validation.success';
            else return this.val;
        },
        bind: function(fn) {
            return this.isSuccess() ? fn(this.val) : this;
        },
        ap: function(validationWithFn) {
            var value = this.val;
            return this.isSuccess() ? validationWithFn.map(function(fn) {
                return fn(value);
            }) : validationWithFn.isFail() ? Validation.Fail(Semigroup.append(value, validationWithFn.fail())) : this;
        },
        acc: function() {
            var x = function() {
                return x;
            };
            return this.isSuccessValue ? Validation.success(x) : this;
        },
        cata: function(fail, success) {
            return this.isSuccessValue ? success(this.val) : fail(this.val);
        },
        failMap: function(fn) {
            return this.isFail() ? Fail(fn(this.val)) : this;
        },
        bimap: function(fail, success) {
            return this.isSuccessValue ? this.map(success) : this.failMap(fail);
        },
        toMaybe: function() {
            return this.isSuccess() ? Some(this.val) : None();
        },
        toEither: function() {
            return (this.isSuccess() ? Right : Left)(this.val);
        }
    };
    Validation.fn.init.prototype = Validation.fn;
    var Semigroup = root.Semigroup = {};
    Semigroup.append = function(a, b) {
        if (a instanceof Array) return a.concat(b);
        if (typeof a === "string") return a + b;
        if (isFunction(a.concat)) return a.concat(b);
        throw "Couldn't find a semigroup appender in the environment, please specify your own append function";
    };
    var monadT, monadTransformer, MonadTransformer;
    var MonadT = monadT = monadTransformer = MonadTransformer = root.monadTransformer = root.MonadT = root.monadT = function(monad) {
        return new MonadT.fn.init(monad);
    };
    MonadT.of = function(m) {
        return MonadT(m);
    };
    MonadT.fn = MonadT.prototype = {
        init: function(monad) {
            this.monad = monad;
        },
        map: function(fn) {
            return monadT(this.monad.map(function(v) {
                return v.map(fn);
            }));
        },
        bind: function(fn) {
            return monadT(this.monad.map(function(v) {
                return v.flatMap(fn);
            }));
        },
        ap: function(monadWithFn) {
            return monadT(this.monad.flatMap(function(v) {
                return monadWithFn.perform().map(function(v2) {
                    return v.ap(v2);
                });
            }));
        },
        perform: function() {
            return this.monad;
        }
    };
    MonadT.fn.init.prototype = MonadT.fn;
    var io;
    var IO = io = root.IO = root.io = function(effectFn) {
        return new IO.fn.init(effectFn);
    };
    IO.of = function(a) {
        return IO(function() {
            return a;
        });
    };
    IO.fn = IO.prototype = {
        init: function(effectFn) {
            if (!isFunction(effectFn)) throw "IO requires a function";
            this.effectFn = effectFn;
        },
        map: function(fn) {
            var self = this;
            return IO(function() {
                return fn(self.effectFn());
            });
        },
        bind: function(fn) {
            var self = this;
            return IO(function() {
                return fn(self.effectFn()).run();
            });
        },
        ap: function(ioWithFn) {
            var self = this;
            return ioWithFn.map(function(fn) {
                return fn(self.effectFn());
            });
        },
        run: function() {
            return this.effectFn();
        }
    };
    IO.fn.init.prototype = IO.fn;
    IO.prototype.perform = IO.prototype.performUnsafeIO = IO.prototype.run;
    /* Either Monad */ var Either = root.Either = {};
    Either.of = function(a) {
        return Right(a);
    };
    var Right = Either.Right = root.Right = function(val) {
        return new Either.fn.init(val, true);
    };
    var Left = Either.Left = root.Left = function(val) {
        return new Either.fn.init(val, false);
    };
    Either.fn = Either.prototype = {
        init: function(val, isRightValue) {
            this.isRightValue = isRightValue;
            this.value = val;
        },
        bind: function(fn) {
            return this.isRightValue ? fn(this.value) : this;
        },
        ap: function(eitherWithFn) {
            var self = this;
            return this.isRightValue ? eitherWithFn.map(function(fn) {
                return fn(self.value);
            }) : this;
        },
        leftMap: function(fn) {
            return this.isLeft() ? Left(fn(this.value)) : this;
        },
        isRight: function() {
            return this.isRightValue;
        },
        isLeft: function() {
            return !this.isRight();
        },
        right: function() {
            if (this.isRightValue) return this.value;
            else throw "Illegal state. Cannot call right() on a Either.left";
        },
        left: function() {
            if (this.isRightValue) throw "Illegal state. Cannot call left() on a Either.right";
            else return this.value;
        },
        cata: function(leftFn, rightFn) {
            return this.isRightValue ? rightFn(this.value) : leftFn(this.value);
        },
        bimap: function(leftFn, rightFn) {
            return this.isRightValue ? this.map(rightFn) : this.leftMap(leftFn);
        },
        toMaybe: function() {
            return this.isRight() ? Some(this.value) : None();
        },
        toValidation: function() {
            return this.isRight() ? Success(this.value) : Fail(this.value);
        }
    };
    Either.fn.init.prototype = Either.fn;
    var reader;
    var Reader = reader = root.Reader = function(fn) {
        return new Reader.fn.init(fn);
    };
    Reader.of = function(x) {
        return Reader(function(_) {
            return x;
        });
    };
    Reader.ask = function() {
        return Reader(idFunction);
    };
    Reader.fn = Reader.prototype = {
        init: function(fn) {
            this.f = fn;
        },
        run: function(config) {
            return this.f(config);
        },
        bind: function(fn) {
            var self = this;
            return Reader(function(config) {
                return fn(self.run(config)).run(config);
            });
        },
        ap: function(readerWithFn) {
            var self = this;
            return readerWithFn.bind(function(fn) {
                return Reader(function(config) {
                    return fn(self.run(config));
                });
            });
        },
        map: function(fn) {
            var self = this;
            return Reader(function(config) {
                return fn(self.run(config));
            });
        },
        local: function(fn) {
            var self = this;
            return Reader(function(c) {
                return self.run(fn(c));
            });
        }
    };
    Reader.fn.init.prototype = Reader.fn;
    var Free = root.Free = {};
    var Suspend = Free.Suspend = root.Suspend = function(functor) {
        return new Free.fn.init(functor, true);
    };
    var Return = Free.Return = root.Return = function(val) {
        return new Free.fn.init(val, false);
    };
    Free.of = function(a) {
        return Return(a);
    };
    Free.liftF = function(functor) {
        return Suspend(functor.map(Return));
    };
    Free.fn = Free.prototype = {
        init: function(val, isSuspend) {
            this.isSuspend = isSuspend;
            if (isSuspend) this.functor = val;
            else this.val = val;
        },
        run: function() {
            return this.go(function(f) {
                return f();
            });
        },
        bind: function(fn) {
            return this.isSuspend ? Suspend(this.functor.map(function(free) {
                return free.bind(fn);
            })) : fn(this.val);
        },
        ap: function(ff) {
            return this.bind(function(x) {
                return ff.map(function(f) {
                    return f(x);
                });
            });
        },
        resume: function() {
            return this.isSuspend ? Left(this.functor) : Right(this.val);
        },
        go1: function(f) {
            function go2(t) {
                return t.resume().cata(function(functor) {
                    return go2(f(functor));
                }, idFunction);
            }
            return go2(this);
        },
        go: function(f) {
            var result = this.resume();
            while(result.isLeft()){
                var next = f(result.left());
                result = next.resume();
            }
            return result.right();
        }
    };
    Free.fn.init.prototype = Free.fn;
    var Identity = root.Identity = function(a) {
        return new Identity.fn.init(a);
    };
    Identity.of = function(a) {
        return new Identity(a);
    };
    Identity.fn = Identity.prototype = {
        init: function(val) {
            this.val = val;
        },
        bind: function(fn) {
            return fn(this.val);
        },
        get: function() {
            return this.val;
        }
    };
    Identity.fn.init.prototype = Identity.fn;
    Function.prototype.io = function() {
        return IO(this);
    };
    Function.prototype.io1 = function() {
        var f = this;
        return function(x) {
            return IO(function() {
                return f(x);
            });
        };
    };
    Function.prototype.reader = function() {
        var f = this;
        var wrapReader = function(fn, args) {
            return function() {
                var args1 = args.append(List.fromArray(Array.prototype.slice.call(arguments)));
                var self = this;
                return args1.size() + 1 == fn.length ? Reader(function(c) {
                    return fn.apply(self, args1.append(List(c)).toArray());
                }) : wrapReader(fn, args1);
            };
        };
        return wrapReader(f, Nil);
    };
    Function.prototype.compose = Function.prototype.o = function(g) {
        var f = this;
        return function(x) {
            return f(g(x));
        };
    };
    Function.prototype.andThen = Function.prototype.map = function(g) {
        var f = this;
        return function(x) {
            return g(f(x));
        };
    };
    function addAliases(type) {
        type.prototype.flatMap = type.prototype.chain = type.prototype.bind;
        type.pure = type.unit = type.of;
        type.prototype.of = type.of;
        if (type.prototype.append != null) type.prototype.concat = type.prototype.append;
        type.prototype.point = type.prototype.pure = type.prototype.unit = type.prototype.of;
    }
    // Wire up aliases
    function addMonadOps(type) {
        type.prototype.join = function() {
            return this.flatMap(idFunction);
        };
        type.map2 = function(fn) {
            return function(ma, mb) {
                return ma.flatMap(function(a) {
                    return mb.map(function(b) {
                        return fn(a, b);
                    });
                });
            };
        };
    }
    function addFunctorOps(type) {
        if (type.prototype.map == null) type.prototype.map = function(fn) {
            return map.call(this, fn);
        };
    }
    function addApplicativeOps(type) {
        type.prototype.takeLeft = function(m) {
            return apply2(this, m, function(a, b) {
                return a;
            });
        };
        type.prototype.takeRight = function(m) {
            return apply2(this, m, function(a, b) {
                return b;
            });
        };
    }
    function decorate(type) {
        addAliases(type);
        addMonadOps(type);
        addFunctorOps(type);
        addApplicativeOps(type);
    }
    decorate(MonadT);
    decorate(Either);
    decorate(Maybe);
    decorate(IO);
    decorate(NEL);
    decorate(List);
    decorate(Validation);
    decorate(Reader);
    decorate(Free);
    decorate(Identity);
    return root;
});

});


parcelRegister("3nTcJ", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $32d7784f0c224d00$export$f654b28f82155665);
$parcel$export(module.exports, "getCloudId", () => $32d7784f0c224d00$export$fdd2c0ba94025c3c);
$parcel$export(module.exports, "getFabricPfDirUrl", () => $32d7784f0c224d00$export$505ebc60b5fc3b2e);
$parcel$export(module.exports, "getAtlassianAccountId", () => $32d7784f0c224d00$export$f5baf4f0aaa47428);
$parcel$export(module.exports, "getProjectKey", () => $32d7784f0c224d00$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectName", () => $32d7784f0c224d00$export$2cd058184eb75757);
$parcel$export(module.exports, "getLocale", () => $32d7784f0c224d00$export$180605366c04f0cd);
$parcel$export(module.exports, "getIsAdmin", () => $32d7784f0c224d00$export$7d046765d192af80);
$parcel$export(module.exports, "getProjectId", () => $32d7784f0c224d00$export$89040d072f281f85);
$parcel$export(module.exports, "getAppPropsForIssueTable", () => $32d7784f0c224d00$export$78632e066216024);

var $df4Sl = parcelRequire("df4Sl");

var $6vrw7 = parcelRequire("6vrw7");
const $32d7784f0c224d00$export$876089ea65adc54 = (state)=>state.appProps;
const $32d7784f0c224d00$export$f654b28f82155665 = (_)=>'';
const $32d7784f0c224d00$export$fdd2c0ba94025c3c = (state)=>$32d7784f0c224d00$export$876089ea65adc54(state).cloudId;
const $32d7784f0c224d00$export$505ebc60b5fc3b2e = (state)=>$32d7784f0c224d00$export$876089ea65adc54(state).fabricPfDirUrl;
const $32d7784f0c224d00$export$f5baf4f0aaa47428 = (state)=>$32d7784f0c224d00$export$876089ea65adc54(state).atlassianAccountId;
const $32d7784f0c224d00$export$667f2a0f99c75faa = (state)=>$32d7784f0c224d00$export$876089ea65adc54(state).projectKey;
const $32d7784f0c224d00$export$2cd058184eb75757 = (state)=>$32d7784f0c224d00$export$876089ea65adc54(state).projectName;
const $32d7784f0c224d00$export$180605366c04f0cd = (state)=>$32d7784f0c224d00$export$876089ea65adc54(state).locale;
const $32d7784f0c224d00$export$7d046765d192af80 = (state)=>$32d7784f0c224d00$export$876089ea65adc54(state).isAdmin;
const $32d7784f0c224d00$export$89040d072f281f85 = (state)=>$32d7784f0c224d00$export$876089ea65adc54(state).projectId;
const $32d7784f0c224d00$export$78632e066216024 = (0, $df4Sl.createSelector)($32d7784f0c224d00$export$f654b28f82155665, $32d7784f0c224d00$export$fdd2c0ba94025c3c, $32d7784f0c224d00$export$505ebc60b5fc3b2e, $32d7784f0c224d00$export$f5baf4f0aaa47428, (baseUrl, cloudId, fabricPfDirUrl, atlassianAccountId)=>({
        baseUrl: '',
        // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        cloudId: (0, $6vrw7.toCloudId)(cloudId),
        fabricPfDirUrl: fabricPfDirUrl,
        atlassianAccountId: atlassianAccountId
    }));

});

parcelRegister("i676h", function(module, exports) {

$parcel$export(module.exports, "switchingFetch", () => $46afc585dd532bab$export$cffbcfdbac9406a3);
$parcel$export(module.exports, "default", () => $46afc585dd532bab$export$2e2bcd8739ae039);

var $5SOXK = parcelRequire("5SOXK");

var $f1lMr = parcelRequire("f1lMr");
const $46afc585dd532bab$var$postParams = (jql, columnNames, columnTypesAsJson, startIndex, issuesPerPage, currentIssueHash, orderBy, isAscendingOrder, category, filterClause)=>({
        jql: jql,
        columnNames: columnNames,
        columnTypesAsJson: columnTypesAsJson,
        startIndex: startIndex,
        issuesPerPage: issuesPerPage,
        currentIssueHash: currentIssueHash || '',
        ...orderBy ? {
            orderBy: orderBy,
            isAscendingOrder: isAscendingOrder
        } : {},
        ...category && category !== (0, $f1lMr.NO_CATEGORY) ? {
            category: category
        } : {},
        filterClause: filterClause
    });
const $46afc585dd532bab$export$cffbcfdbac9406a3 = (args)=>{
    const { projectKey: projectKey, baseUrl: baseUrl, jql: jql, columnNames: columnNames, columnTypesAsJson: columnTypesAsJson, startIndex: startIndex, issuesPerPage: issuesPerPage, orderBy: orderBy, isAscendingOrder: isAscendingOrder, category: category, filterClause: filterClause } = args;
    // @ts-expect-error - TS2339 - Property 'issueHash' does not exist on type 'IssueListFetchArgs | UpdatedFetchArgs'.
    const issueHash = args.issueHash || null;
    const fetchUrl = `${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/issuelist${issueHash ? '/updated' : ''}`;
    const fetchOptions = {
        method: 'POST',
        body: JSON.stringify($46afc585dd532bab$var$postParams(jql, columnNames, columnTypesAsJson, startIndex, issuesPerPage, issueHash, orderBy, isAscendingOrder, category, filterClause))
    };
    return (0, $5SOXK.fetchJson$)(fetchUrl, fetchOptions);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$46afc585dd532bab$export$2e2bcd8739ae039 = (args)=>$46afc585dd532bab$export$cffbcfdbac9406a3(args);

});
parcelRegister("5SOXK", function(module, exports) {

$parcel$export(module.exports, "fetchJson$", () => $14949259afbc8828$export$2ba52855e389d39e);
$parcel$export(module.exports, "fetchText$", () => $14949259afbc8828$export$64ab95a52860b608);
parcelRequire("bI4RP");
parcelRequire("1Lcr1");

var $6G5mG = parcelRequire("6G5mG");

var $3JafE = parcelRequire("3JafE");

var $aiRd8 = parcelRequire("aiRd8");

var $2OdyW = parcelRequire("2OdyW");

var $5G2eQ = parcelRequire("5G2eQ");
const $14949259afbc8828$var$buildErrorResponse = (message, statusCode, traceId)=>({
        response: {
            errors: [
                {
                    errorMessage: message
                }
            ],
            reasonKey: 'generic.error',
            reasonCode: `${statusCode}`
        },
        statusCode: statusCode,
        traceId: traceId
    });
const $14949259afbc8828$var$toAnError = (error)=>{
    const traceId = error.traceId;
    try {
        // ServiceDesk REST errors be usually be in the form of a JSON
        // object (e.g., AnError).  We'll try to parse it.
        const response = JSON.parse(error.message);
        // Normalize the shape of "simple" JSON error responses containing
        // message and status-code, as used in e.g., standard Jira
        // unauthorized response.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(response, 'message') && (0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(response, 'status-code')) return $14949259afbc8828$var$buildErrorResponse(response.message, parseInt(response['status-code'], 10), traceId);
        return {
            response: response,
            statusCode: error.statusCode,
            traceId: traceId
        };
    } catch (e) {
        // Message didn't parse as JSON; assume it's a plain ol' string, and
        // we'll produce an AnError-like object with it.
        return $14949259afbc8828$var$buildErrorResponse(error.message, error.statusCode, traceId);
    }
};
const $14949259afbc8828$export$6d71b655afe1638d = (url, opts)=>(0, $2OdyW.default)(url, opts).catch((error)=>Promise.reject($14949259afbc8828$var$toAnError(error)));
const $14949259afbc8828$export$2ba52855e389d39e = (url, opts)=>(0, $aiRd8.default)(url, opts).catch((error)=>(0, $3JafE.Observable).throw($14949259afbc8828$var$toAnError(error)));
const $14949259afbc8828$export$64ab95a52860b608 = (url, opts)=>(0, $5G2eQ.default)(url, opts).catch((error)=>(0, $3JafE.Observable).throw($14949259afbc8828$var$toAnError(error)));

});
parcelRegister("aiRd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6464cf3e92eca984$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("1Lcr1");
parcelRequire("8OtG5");
parcelRequire("flmol");
parcelRequire("iects");

var $fVqUX = parcelRequire("fVqUX");

var $6iz4v = parcelRequire("6iz4v");

var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $bH2vr = parcelRequire("bH2vr");

var $etaBp = parcelRequire("etaBp");
const $6464cf3e92eca984$var$noContentStatus = 204;
const $6464cf3e92eca984$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $6464cf3e92eca984$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$6464cf3e92eca984$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $6iz4v.setMark)(`BEGIN_${key}`);
    }
    return (0, $3JafE.Observable).of(url).mergeMap(()=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $6HC1D.merge)((0, $6HC1D.merge)((0, $fVqUX.default), opts), (0, $etaBp.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $6iz4v.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(status, str, traceId);
                else throw new (0, $7byHA.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $6464cf3e92eca984$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $3JafE.Observable).of(null);
        return response.json();
    });
}
var $6464cf3e92eca984$export$2e2bcd8739ae039 = $6464cf3e92eca984$var$fetchJson$;

});

parcelRegister("5G2eQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d9fb25724578ccf$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");

var $fVqUX = parcelRequire("fVqUX");

var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $bH2vr = parcelRequire("bH2vr");

var $etaBp = parcelRequire("etaBp");
const $0d9fb25724578ccf$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$0d9fb25724578ccf$export$2e2bcd8739ae039 = (url, options = {})=>(0, $3JafE.Observable).of(url).mergeMap(()=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $6HC1D.merge)((0, $6HC1D.merge)((0, $fVqUX.default), options), (0, $etaBp.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $7byHA.default)(status);
        }
        if (response.status === $0d9fb25724578ccf$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $3JafE.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $3JafE.Observable).of(response.responseText || 'OK');
    });

});



parcelRegister("JlScu", function(module, exports) {

$parcel$export(module.exports, "default", () => $088b95748c367b0b$export$2e2bcd8739ae039);

var $i676h = parcelRequire("i676h");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$088b95748c367b0b$export$2e2bcd8739ae039 = (args)=>(0, $i676h.switchingFetch)(args);

});

parcelRegister("5sNW7", function(module, exports) {

$parcel$export(module.exports, "getCreateAnalyticsEvent", () => $58caa48517f33ec3$export$da28c0e4cac33548);

var $3i6VQ = parcelRequire("3i6VQ");
const $58caa48517f33ec3$export$da28c0e4cac33548 = (state)=>(0, $3i6VQ.getPersisted)(state).analytic.createAnalyticsEvent;

});
parcelRegister("3i6VQ", function(module, exports) {

$parcel$export(module.exports, "getPersisted", () => $e8b4ef5930a5c6ca$export$5239a0a7977ca4de);
$parcel$export(module.exports, "getAppProps", () => $e8b4ef5930a5c6ca$export$876089ea65adc54);
const $e8b4ef5930a5c6ca$export$5239a0a7977ca4de = (state)=>state.persisted;
const $e8b4ef5930a5c6ca$export$876089ea65adc54 = (state)=>state.appProps;
const $e8b4ef5930a5c6ca$export$180605366c04f0cd = (state)=>state.appProps.locale;

});


parcelRegister("8UPn4", function(module, exports) {

$parcel$export(module.exports, "getCurrentFilterQuery", () => $6b29a92359301286$export$cc320d7c20cf1c31);
$parcel$export(module.exports, "getIsCurrentDataFiltered", () => $6b29a92359301286$export$20650273aeda865c);
$parcel$export(module.exports, "getIsNewFilterQueryPending", () => $6b29a92359301286$export$43771ef8a5224920);
$parcel$export(module.exports, "getIsFilterFocused", () => $6b29a92359301286$export$6c44b9a0531900b1);

var $3i6VQ = parcelRequire("3i6VQ");
const $6b29a92359301286$export$cc320d7c20cf1c31 = (state)=>(0, $3i6VQ.getPersisted)(state).filter.filterQuery;
const $6b29a92359301286$export$20650273aeda865c = (state)=>(0, $3i6VQ.getPersisted)(state).filter.isCurrentDataFiltered;
const $6b29a92359301286$export$43771ef8a5224920 = (state)=>(0, $3i6VQ.getPersisted)(state).filter.isNewFilterQueryPending;
const $6b29a92359301286$export$6c44b9a0531900b1 = (state)=>(0, $3i6VQ.getPersisted)(state).filter.isFilterFocused;

});

parcelRegister("3KNsL", function(module, exports) {

$parcel$export(module.exports, "getQueuePageData", () => $fded63d7f97e0097$export$c60f26b8eba0a78a);
$parcel$export(module.exports, "getCategory", () => $fded63d7f97e0097$export$410364bbb673ddbc);
$parcel$export(module.exports, "getMetricKey", () => $fded63d7f97e0097$export$cb832de761ecab61);
$parcel$export(module.exports, "getQueueId", () => $fded63d7f97e0097$export$aed39b3e342d0167);
$parcel$export(module.exports, "getQueueName", () => $fded63d7f97e0097$export$6b633f8a8623b3f1);
$parcel$export(module.exports, "getJql", () => $fded63d7f97e0097$export$2720d348d2cbc9fe);
$parcel$export(module.exports, "getCompleteJql", () => $fded63d7f97e0097$export$6578bd82b9fd6840);
$parcel$export(module.exports, "isQueueTransient", () => $fded63d7f97e0097$export$a55400a65ac36e18);
$parcel$export(module.exports, "canManageQueue", () => $fded63d7f97e0097$export$8a3ca2900db73d42);
$parcel$export(module.exports, "getColumns", () => $fded63d7f97e0097$export$978e30a0fb8610d8);
$parcel$export(module.exports, "getColumnIds", () => $fded63d7f97e0097$export$3d88032e6be0ee47);
$parcel$export(module.exports, "getColumnType", () => $fded63d7f97e0097$export$bf02abf02e552bba);
$parcel$export(module.exports, "getColumnsInOrder", () => $fded63d7f97e0097$export$27292d0b079cd285);
$parcel$export(module.exports, "getNumberOfColumns", () => $fded63d7f97e0097$export$a3141f11a33b8412);
$parcel$export(module.exports, "getAllFieldTypes", () => $fded63d7f97e0097$export$e331c771e0c96919);
$parcel$export(module.exports, "getFetchStartIndex", () => $fded63d7f97e0097$export$4050fbf2b3dcb166);
$parcel$export(module.exports, "getCurrentQueueOrder", () => $fded63d7f97e0097$export$81ce441046ce0dc9);
$parcel$export(module.exports, "isQueueMateriallyDifferent", () => $fded63d7f97e0097$export$fd4ec8b47c12049f);

var $df4Sl = parcelRequire("df4Sl");

var $3aUuh = parcelRequire("3aUuh");

var $aNBkj = parcelRequire("aNBkj");

var $3nTcJ = parcelRequire("3nTcJ");

var $f1lMr = parcelRequire("f1lMr");

var $3i6VQ = parcelRequire("3i6VQ");

var $1RqtY = parcelRequire("1RqtY");
const $fded63d7f97e0097$export$c60f26b8eba0a78a = (state)=>(0, $3i6VQ.getPersisted)(state).queue;
const $fded63d7f97e0097$export$410364bbb673ddbc = (state)=>$fded63d7f97e0097$export$c60f26b8eba0a78a(state).category;
const $fded63d7f97e0097$export$cb832de761ecab61 = (0, $df4Sl.createSelector)($fded63d7f97e0097$export$410364bbb673ddbc, (category)=>category && category !== (0, $f1lMr.NO_CATEGORY) ? `servicedesk.queues.${category}.view` : 'servicedesk.queues.view');
const $fded63d7f97e0097$export$aed39b3e342d0167 = (state)=>{
    const queue = (0, $1RqtY.getCurrentQueue)(state);
    return queue ? queue.id : (0, $aNBkj.toQueueId)(-1);
};
const $fded63d7f97e0097$export$6b633f8a8623b3f1 = (state)=>{
    const queue = (0, $1RqtY.getCurrentQueue)(state);
    return queue ? queue.name : '';
};
const $fded63d7f97e0097$export$2720d348d2cbc9fe = (state)=>{
    const queue = (0, $1RqtY.getCurrentQueue)(state);
    return queue ? queue.jql : '';
};
const $fded63d7f97e0097$export$6578bd82b9fd6840 = (state)=>{
    const queue = (0, $1RqtY.getCurrentQueue)(state);
    return queue ? queue.completeJql : '';
};
const $fded63d7f97e0097$export$a55400a65ac36e18 = (state)=>{
    const queue = (0, $1RqtY.getCurrentQueue)(state);
    return !!(queue && queue.isTransient);
};
const $fded63d7f97e0097$export$8a3ca2900db73d42 = (state)=>(0, $3nTcJ.getIsAdmin)(state) && !$fded63d7f97e0097$export$a55400a65ac36e18(state);
const $fded63d7f97e0097$export$978e30a0fb8610d8 = (state)=>{
    const queue = (0, $1RqtY.getCurrentQueue)(state);
    return queue ? queue.columns : [];
};
const $fded63d7f97e0097$export$3d88032e6be0ee47 = (0, $df4Sl.createSelector)($fded63d7f97e0097$export$978e30a0fb8610d8, (columns)=>columns.map((column)=>column.id));
const $fded63d7f97e0097$export$8b87fd0c3c045ba7 = (0, $df4Sl.createSelector)($fded63d7f97e0097$export$978e30a0fb8610d8, (columns)=>(0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(columns, 'id'));
const $fded63d7f97e0097$var$getColumnById = (state, columnId)=>$fded63d7f97e0097$export$8b87fd0c3c045ba7(state)[columnId];
const $fded63d7f97e0097$export$bf02abf02e552bba = (state, columnId)=>{
    const column = $fded63d7f97e0097$var$getColumnById(state, columnId);
    return column && column.fieldType;
};
const $fded63d7f97e0097$export$27292d0b079cd285 = (0, $df4Sl.createSelector)($fded63d7f97e0097$export$3d88032e6be0ee47, $fded63d7f97e0097$export$8b87fd0c3c045ba7, (columnIds, columnsById)=>{
    // To prevent scenario where columnIds exist but columnsById do not
    if (columnIds.length === Object.keys(columnsById).length) {
        const checkbox = {
            id: 'checkbox',
            title: '',
            fieldType: 'checkbox',
            sortable: false
        };
        return [
            checkbox
        ].concat(columnIds.map((colId)=>columnsById[colId]));
    }
    return [];
});
const $fded63d7f97e0097$export$a3141f11a33b8412 = (state)=>$fded63d7f97e0097$export$978e30a0fb8610d8(state).length;
const $fded63d7f97e0097$export$e331c771e0c96919 = (state)=>$fded63d7f97e0097$export$978e30a0fb8610d8(state).map((column)=>column.fieldType);
const $fded63d7f97e0097$export$4050fbf2b3dcb166 = (state)=>$fded63d7f97e0097$export$c60f26b8eba0a78a(state).fetchStartIndex;
const $fded63d7f97e0097$export$81ce441046ce0dc9 = (state)=>{
    const current = (0, $1RqtY.getCurrentQueue)(state);
    return current ? current.order : -1;
};
const $fded63d7f97e0097$export$fd4ec8b47c12049f = (state, otherQueue)=>otherQueue.id !== $fded63d7f97e0097$export$aed39b3e342d0167(state) || otherQueue.jql !== $fded63d7f97e0097$export$2720d348d2cbc9fe(state) || otherQueue.columns !== $fded63d7f97e0097$export$978e30a0fb8610d8(state) || otherQueue.category !== $fded63d7f97e0097$export$410364bbb673ddbc(state);

});
parcelRegister("1RqtY", function(module, exports) {

$parcel$export(module.exports, "getCurrentQueue", () => $ba7459af616959a8$export$6b47bf3b28f515da);
$parcel$export(module.exports, "getOnboardingResolved", () => $ba7459af616959a8$export$edc47c0083cde3ab);
$parcel$export(module.exports, "getDeletingQueue", () => $ba7459af616959a8$export$379fa75ab7e97f42);
$parcel$export(module.exports, "getDeleteModalOpen", () => $ba7459af616959a8$export$fd306a625859a9fe);
$parcel$export(module.exports, "getIssueKeyContext", () => $ba7459af616959a8$export$c0db69db702258b7);
$parcel$export(module.exports, "getSidebarIssueKey", () => $ba7459af616959a8$export$df932d2672780b0c);
$parcel$export(module.exports, "getSidebarReactKey", () => $ba7459af616959a8$export$ddbf1ddffbf956f2);
$parcel$export(module.exports, "isQueueVisible", () => $ba7459af616959a8$export$acdb497766d87546);
$parcel$export(module.exports, "isInitialized", () => $ba7459af616959a8$export$3f95c6f800b78024);
$parcel$export(module.exports, "isLoadingIssues", () => $ba7459af616959a8$export$bd765e2c10f9e4dc);
$parcel$export(module.exports, "isQueueEmpty", () => $ba7459af616959a8$export$f76a0ecd13927ba1);
$parcel$export(module.exports, "hasPageError", () => $ba7459af616959a8$export$3d27fec59f3b6313);
$parcel$export(module.exports, "showIssueFailureError", () => $ba7459af616959a8$export$98fc822d2fef9708);
$parcel$export(module.exports, "isRetrying", () => $ba7459af616959a8$export$2d2253a53b38e901);
$parcel$export(module.exports, "shouldShowBadFilterQueryError", () => $ba7459af616959a8$export$f972e8db29021436);
$parcel$export(module.exports, "isQueuesErrorHeaderDisplayed", () => $ba7459af616959a8$export$4a6666492f1d4010);
// @ts-expect-error - TS2305 - Module '"monet"' has no exported member 'MaybeType'.

var $7Oh8q = parcelRequire("7Oh8q");

var $8UPn4 = parcelRequire("8UPn4");

var $8GAE5 = parcelRequire("8GAE5");
const $ba7459af616959a8$var$getUIState = (state)=>state.ui;
const $ba7459af616959a8$export$6b47bf3b28f515da = (state)=>$ba7459af616959a8$var$getUIState(state).currentQueue;
const $ba7459af616959a8$export$edc47c0083cde3ab = (state)=>$ba7459af616959a8$var$getUIState(state).onboardingResolved;
const $ba7459af616959a8$export$379fa75ab7e97f42 = (state)=>// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
    (0, $7Oh8q.Maybe).fromNull($ba7459af616959a8$var$getUIState(state).deletingQueue).orSome(false);
const $ba7459af616959a8$export$fd306a625859a9fe = (state)=>// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
    (0, $7Oh8q.Maybe).fromNull($ba7459af616959a8$var$getUIState(state).deleteModalOpen).orSome(false);
const $ba7459af616959a8$export$c0db69db702258b7 = (state)=>$ba7459af616959a8$var$getUIState(state).issueKeyContext;
const $ba7459af616959a8$export$df932d2672780b0c = (state)=>$ba7459af616959a8$var$getUIState(state).sidebarIssueKey;
const $ba7459af616959a8$export$ddbf1ddffbf956f2 = (state)=>$ba7459af616959a8$var$getUIState(state).sidebarReactKey;
const $ba7459af616959a8$export$5e52d79ee962d3c1 = (state)=>$ba7459af616959a8$var$getUIState(state).selectedIssueKeys;
const $ba7459af616959a8$export$acdb497766d87546 = (state)=>// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
    (0, $7Oh8q.Maybe).fromNull($ba7459af616959a8$var$getUIState(state).isQueueVisible).orSome(true);
const $ba7459af616959a8$export$3f95c6f800b78024 = (state)=>!!$ba7459af616959a8$export$6b47bf3b28f515da(state);
const $ba7459af616959a8$export$4814741d778a48d7 = (state)=>// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
    (0, $7Oh8q.Maybe).fromNull($ba7459af616959a8$var$getUIState(state).isLoadingPage).orSome(false);
const $ba7459af616959a8$export$bd765e2c10f9e4dc = (state)=>(0, $7Oh8q.Maybe).fromNull($ba7459af616959a8$var$getUIState(state).isLoadingIssues).orSome(true) || (0, $8UPn4.getIsNewFilterQueryPending)(state);
const $ba7459af616959a8$export$f76a0ecd13927ba1 = (state)=>!$ba7459af616959a8$export$bd765e2c10f9e4dc(state) && (0, $8GAE5.getIssueCount)(state) === 0;
const $ba7459af616959a8$var$getPageError = (state)=>(0, $7Oh8q.Maybe).fromNull($ba7459af616959a8$var$getUIState(state).pageError);
const $ba7459af616959a8$export$3d27fec59f3b6313 = (state)=>$ba7459af616959a8$var$getPageError(state).isSome();
const $ba7459af616959a8$export$98fc822d2fef9708 = (state)=>// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
    (0, $7Oh8q.Maybe).fromNull($ba7459af616959a8$var$getUIState(state).showIssueFailureError).orSome(false);
const $ba7459af616959a8$export$2d2253a53b38e901 = (state)=>$ba7459af616959a8$export$3d27fec59f3b6313(state) && $ba7459af616959a8$export$4814741d778a48d7(state);
const $ba7459af616959a8$export$f972e8db29021436 = (state)=>// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
    (0, $7Oh8q.Maybe).fromNull($ba7459af616959a8$var$getUIState(state).shouldShowBadFilterQueryError).orSome(false);
const $ba7459af616959a8$export$4a6666492f1d4010 = (state)=>$ba7459af616959a8$var$getUIState(state).isQueuesErrorHeaderDisplayed || false;

});
parcelRegister("8GAE5", function(module, exports) {

$parcel$export(module.exports, "getIssueCount", () => $7ebe7de4c092b40a$export$56d545f19dc75191);
$parcel$export(module.exports, "getCollection", () => $7ebe7de4c092b40a$export$2716f3327981be5);
$parcel$export(module.exports, "getTimeWhenLastInitialized", () => $7ebe7de4c092b40a$export$a139a3296053f37d);
$parcel$export(module.exports, "getIssueCacheSize", () => $7ebe7de4c092b40a$export$da3bb4024398ace7);
$parcel$export(module.exports, "isFirstFieldInTable", () => $7ebe7de4c092b40a$export$7451b0120e7484bc);
$parcel$export(module.exports, "isFieldToExperienceTrack", () => $7ebe7de4c092b40a$export$9c6d1a54838b7308);
$parcel$export(module.exports, "getFieldPropsSelector", () => $7ebe7de4c092b40a$export$13c62ee6bac293a0);
$parcel$export(module.exports, "getIssueStatusIdsCounts", () => $7ebe7de4c092b40a$export$ef679118f03c956b);
$parcel$export(module.exports, "getIssueCountByAssignee", () => $7ebe7de4c092b40a$export$337304d202b8d38e);

var $6HC1D = parcelRequire("6HC1D");

var $df4Sl = parcelRequire("df4Sl");

var $gHHen = parcelRequire("gHHen");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $65uQX = parcelRequire("65uQX");

var $48mPv = parcelRequire("48mPv");

var $d7Wfe = parcelRequire("d7Wfe");

var $3FiBf = parcelRequire("3FiBf");

var $3i6VQ = parcelRequire("3i6VQ");

var $3KNsL = parcelRequire("3KNsL");
const $7ebe7de4c092b40a$var$isEcClientEnabled = ()=>{
    const experiences = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $1ybV0.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-inline');
};
const $7ebe7de4c092b40a$var$STATUS_COLUMN = 'status';
const $7ebe7de4c092b40a$var$ASSIGNEE_COLUMN = 'assignee';
const $7ebe7de4c092b40a$var$ROWS_TO_MOUNT_EXPERIENCE_TRACKERS = 50;
const $7ebe7de4c092b40a$var$FIELD_TYPES_TO_MOUNT_EXPERIENCE_TRACKERS = new Set([
    'status',
    'summary',
    'issuetype',
    'issuekey'
]);
const $7ebe7de4c092b40a$var$getIssues = (state)=>(0, $3i6VQ.getPersisted)(state).issues;
const $7ebe7de4c092b40a$export$56d545f19dc75191 = (state)=>$7ebe7de4c092b40a$var$getIssues(state).totalCount;
const $7ebe7de4c092b40a$export$2716f3327981be5 = (state)=>$7ebe7de4c092b40a$var$getIssues(state).collection;
const $7ebe7de4c092b40a$var$getIssueKeys = (0, $df4Sl.createSelector)($7ebe7de4c092b40a$export$2716f3327981be5, (collection)=>{
    const issueKeys = [];
    collection.forEach((issue, idx)=>{
        if (issue) issueKeys[idx] = issue.key;
    });
    return issueKeys;
});
const $7ebe7de4c092b40a$var$getIndex = (state)=>$7ebe7de4c092b40a$var$getIssues(state).index;
const $7ebe7de4c092b40a$export$a139a3296053f37d = (state)=>$7ebe7de4c092b40a$var$getIssues(state).timeWhenLastInitialized;
const $7ebe7de4c092b40a$export$da3bb4024398ace7 = (0, $df4Sl.createSelector)($7ebe7de4c092b40a$var$getIndex, (index)=>Object.keys(index).length);
const $7ebe7de4c092b40a$var$doesFirstMatch = (array, expectedFirst)=>array.length > 0 && array[0] === expectedFirst;
const $7ebe7de4c092b40a$export$7451b0120e7484bc = (state, issueKey, fieldId)=>{
    const issues = $7ebe7de4c092b40a$var$getIssueKeys(state);
    const columns = (0, $3KNsL.getColumnIds)(state);
    return $7ebe7de4c092b40a$var$doesFirstMatch(issues, issueKey) && $7ebe7de4c092b40a$var$doesFirstMatch(columns, fieldId);
};
const $7ebe7de4c092b40a$export$9c6d1a54838b7308 = (state, issueKey, fieldId)=>{
    const positionIndex = $7ebe7de4c092b40a$var$getIndex(state)[issueKey];
    const columnType = (0, $3KNsL.getColumnType)(state, fieldId);
    const isInFirstRows = positionIndex != null && positionIndex < $7ebe7de4c092b40a$var$ROWS_TO_MOUNT_EXPERIENCE_TRACKERS;
    const isExperienceTrackingFieldType = columnType != null && $7ebe7de4c092b40a$var$FIELD_TYPES_TO_MOUNT_EXPERIENCE_TRACKERS.has(columnType);
    return isInFirstRows && isExperienceTrackingFieldType;
};
const $7ebe7de4c092b40a$export$13c62ee6bac293a0 = (0, $df4Sl.createSelector)($7ebe7de4c092b40a$var$getIssues, (issues)=>({ issueKey: issueKey, fieldDescriptor: { fieldId: fieldId, fieldType: fieldType } }, issueFieldDispatcher)=>{
        const indexOfIssue = issues.index[issueKey];
        if (indexOfIssue >= 0) {
            const issue = issues.collection[indexOfIssue];
            if (issue && issue.key === issueKey) {
                const storedFieldValue = issue.fields[fieldId];
                const issueID = issue.id;
                if (storedFieldValue != null) {
                    // @ts-expect-error - TS7006 - Parameter 'newVal' implicitly has an 'any' type.
                    const onFieldCellChange = (newVal)=>{
                        issueFieldDispatcher(issueKey, fieldId, newVal);
                        try {
                            if ($7ebe7de4c092b40a$var$isEcClientEnabled()) {
                                const jsisECClient = (0, $65uQX.getEcClient)();
                                const mutationObj = new (0, $48mPv.default)(issueID.toString(), (0, $d7Wfe.MutationSource).CREATE, '1', []);
                                const analyticsEventObj = {
                                    analyticsMetadata: {
                                        scenario: 'jsm-inline'
                                    }
                                };
                                jsisECClient.saveIssueMutationToCache(mutationObj, analyticsEventObj, {
                                    errorMsg: 'FAILED_JSM_INLINE',
                                    error: true
                                });
                            }
                        } catch (e) {
                            (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', `jsm-inline-err : ${e?.toString() || ''}`);
                        }
                    };
                    return (0, $3FiBf.transformField)(issue, storedFieldValue, fieldType, onFieldCellChange);
                }
            }
        }
        return null;
    });
const $7ebe7de4c092b40a$export$ef679118f03c956b = (0, $df4Sl.createSelector)($7ebe7de4c092b40a$export$2716f3327981be5, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($gHHen)))(collection.map((issue)=>(0, $6HC1D.getIn)(issue, [
            'fields',
            $7ebe7de4c092b40a$var$STATUS_COLUMN,
            'value',
            'id'
        ])).filter((id)=>id)));
const $7ebe7de4c092b40a$var$getIssueCountsByAssignee = (0, $df4Sl.createSelector)($7ebe7de4c092b40a$export$2716f3327981be5, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($gHHen)))(collection.map((issue)=>(0, $6HC1D.getIn)(issue, [
            'fields',
            $7ebe7de4c092b40a$var$ASSIGNEE_COLUMN,
            'value',
            'accountId'
        ])).filter((id)=>id)));
const $7ebe7de4c092b40a$export$337304d202b8d38e = (state, assigneeId)=>assigneeId ? $7ebe7de4c092b40a$var$getIssueCountsByAssignee(state)[assigneeId] || 0 : 0;

});
parcelRegister("gHHen", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $f2sQe = parcelRequire("f2sQe");
/** Used for built-in method references. */ var $c292323d8f404a9d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c292323d8f404a9d$var$hasOwnProperty = $c292323d8f404a9d$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var $c292323d8f404a9d$var$countBy = $f2sQe(function(result, value, key) {
    if ($c292323d8f404a9d$var$hasOwnProperty.call(result, key)) ++result[key];
    else $3pSMu(result, key, 1);
});
module.exports = $c292323d8f404a9d$var$countBy;

});

parcelRegister("65uQX", function(module, exports) {

$parcel$export(module.exports, "EcClient", () => $9d182d4720e39d79$export$a736992aaac2307a);
$parcel$export(module.exports, "getEcClient", () => $9d182d4720e39d79$export$c9342bd32f51406b);
$parcel$export(module.exports, "default", () => $9d182d4720e39d79$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");

var $3FyZ4 = parcelRequire("3FyZ4");

var $fqqil = parcelRequire("fqqil");

var $7S3WE = parcelRequire("7S3WE");

var $d7Wfe = parcelRequire("d7Wfe");

var $4qvSX = parcelRequire("4qvSX");
class $9d182d4720e39d79$export$a736992aaac2307a {
    #issueCache;
    #config;
    constructor(){
        this.#issueCache = new (0, $7S3WE.default)('issue-cache-v1');
        this.#config = {};
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, atlassianAccountId) {
        (0, $7S3WE.default).setTenantDetails(activationID, cloudID, atlassianAccountId);
    }
    /**
	 * A method to fire analytics events for both success and failure
	 */ static fireAnalyticsEvents(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, isSaved, analyticsFailureEventObj = {}) {
        try {
            // let mutationAnalyticsObj: any = [];
            let trackingId = '-1';
            if (Array.isArray(issueMutations)) //   mutationAnalyticsObj = issueMutations.map((item: IssueMutation) => item.issueId);
            trackingId = String(new Date(issueMutations[0]?.lastModified).valueOf()) + (0, $7S3WE.default).userID;
            else trackingId = String(new Date(issueMutations.lastModified).valueOf()) + (0, $7S3WE.default).userID;
            const payload = {
                action: 'mutated',
                actionSubject: 'issue',
                source: key?.analyticsMetadata?.scenario || 'unknown',
                attributes: {
                    ...key.analyticsMetadata,
                    trackingId: // issueMutationDetails: mutationAnalyticsObj,
                    trackingId
                }
            };
            // Error condition
            if (!isSaved) {
                if (!analyticsFailureEventObj) // eslint-disable-next-line no-param-reassign
                analyticsFailureEventObj = {
                    error: true,
                    errorMsg: payload.source
                };
                payload.attributes = {
                    ...payload.attributes,
                    ...analyticsFailureEventObj
                };
            }
            if (Object.prototype.hasOwnProperty.call(key, 'analyticsEventObj')) (0, $jMP2a.fireTrackAnalytics)(// @ts-expect-error - Argument of type 'Object' is not assignable to parameter of type 'UIAnalyticsEvent'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            key.analyticsEventObj, `${payload.actionSubject} ${payload.action}`, payload.attributes);
            else // if there is no UI component that triggers the event then we manually fire the event
            (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
                client.getInstance().sendTrackEvent(payload);
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', e);
        }
    }
    /**
	 * A method to save a single issue mutations in cache
	 */ async saveIssueMutationToCache(issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $7S3WE.default).setBackendCache(issueMutation);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return isSaved;
        }
        return this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
            let isSaved = false;
            if (issueMutation.mutationType === (0, $d7Wfe.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
            else if (result || issueMutation.mutationType === (0, $d7Wfe.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
            else isSaved = await this.#issueCache.create(issueMutation.issueId);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return new Promise((resolve)=>resolve(isSaved));
        });
    }
    /**
	 * A method to save multiple issue mutations in cache
	 */ async saveIssueMutationsToCache(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        const data = [];
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $7S3WE.default).setBackendCache(issueMutations);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            return [
                isSaved
            ];
        }
        issueMutations.forEach(async (issueMutation)=>{
            this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
                let isSaved = false;
                if (issueMutation.mutationType === (0, $d7Wfe.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
                else if (result || issueMutation.mutationType === (0, $d7Wfe.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
                else isSaved = await this.#issueCache.create(issueMutation.issueId);
                data.push(isSaved);
                $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            });
        });
        return new Promise((resolve)=>resolve(data));
    }
    /**
	 * A method to get issue mutations in saved in cache
	 */ getIssueMutationFromCache(key) {
        return this.#issueCache.get(key);
    }
    /**
	 * A method to remove the deleted issues from the search API
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async filterData(data) {
        const localStorageData = await this.getIssueMutationFromCache(null);
        const deletedData = new Set();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(localStorageData).forEach((element)=>{
            if (element.mutationType === (0, $d7Wfe.MutationSource).DELETE) deletedData.add(element.issueId);
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredData = [];
        let success = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(data).forEach((element)=>{
            if (!element.id || typeof element.id !== 'number') success = false;
            else if (!deletedData.has(element.id.toString())) filteredData.push(element);
        });
        return new Promise((// eslint-disable-next-line @typescript-eslint/no-explicit-any
        resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reject)=>{
            if (success) resolve(filteredData);
            else reject(new Error());
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async constructMatchRequest() {
        const issueData = {
            issues: [],
            hydrationMode: 0
        };
        const data = await this.getIssueMutationFromCache(null);
        Object.values(data).forEach((issueMutation)=>{
            const element = {
                issueId: issueMutation.issueId,
                version: issueMutation.version
            };
            issueData.issues.push(element);
        });
        const options = {
            method: 'POST',
            headers: {
                content_type: 'application/json',
                // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
                'x-atlassian-capability': (0, $fqqil.getEnhancedCapabilityHeader)(this.#config.capability)
            },
            body: JSON.stringify(issueData)
        };
        return new Promise((resolve)=>resolve(options));
    }
    /**
	 * A method to get the relevant search data from the parsing function that the user has provided
	 */ static getIssueDataFromSearch(data, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData) {
        const result = parseIssueData(data);
        if (result == null) return [];
        return result;
    }
    /**
	 * A method to get the search data and reconcile it with the data present in cache
	 */ async searchAndReconcile(matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability) {
        // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
        this.#config.capability = capability;
        const matchRequest = await this.constructMatchRequest();
        if (matchRequest && matchRequest.body && matchRequest.body.issues && matchRequest.body.issues.length === 0) return search.then((data)=>new Promise((resolve)=>resolve({
                    reconciledIssues: $9d182d4720e39d79$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData),
                    matchAPIResponse: {
                        response: {
                            resultsByIssueId: {}
                        },
                        issue: {
                            issuesResponse: {}
                        }
                    }
                })));
        const matchPromise = (0, $2OdyW.default)(matchApiUrl, matchRequest);
        return Promise.all([
            search,
            matchPromise
        ]).then(([data, response])=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const structuredData = $9d182d4720e39d79$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData);
            return this.filterData(structuredData) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((filteredSearchData)=>{
                if (response == null || response.response == null || response.response.resultsByIssueId == null) throw new Error('Match response is invalid!');
                const matchedIssueIds = response.response.resultsByIssueId;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const filteredMatchedIssueIdsData = [];
                Object.entries(matchedIssueIds).forEach(([key, value])=>{
                    if (value === 'RESULT_MATCH') filteredMatchedIssueIdsData.push({
                        id: parseInt(key, 10)
                    });
                });
                return new Promise((resolve)=>{
                    resolve({
                        reconciledIssues: (0, $4qvSX.mergeResponseData)(filteredSearchData, filteredMatchedIssueIdsData),
                        matchAPIResponse: response
                    });
                });
            }).catch(()=>new Promise((resolve)=>resolve({
                        reconciledIssues: structuredData,
                        matchAPIResponse: response
                    })));
        });
    }
}
const $9d182d4720e39d79$var$ecClient = new $9d182d4720e39d79$export$a736992aaac2307a();
function $9d182d4720e39d79$export$c9342bd32f51406b(tenantContext = {}) {
    $9d182d4720e39d79$export$a736992aaac2307a.setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    return $9d182d4720e39d79$var$ecClient;
}
var $9d182d4720e39d79$export$2e2bcd8739ae039 = $9d182d4720e39d79$var$ecClient;

});
parcelRegister("7S3WE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed861ad8bfcfb81a$export$2e2bcd8739ae039);
// Issue Cache API is an internal tool and this file should not be edited. Please contact Odin team for any modifications.

var $kBiqn = parcelRequire("kBiqn");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $48mPv = parcelRequire("48mPv");

var $d7Wfe = parcelRequire("d7Wfe");

var $4qvSX = parcelRequire("4qvSX");
const $ed861ad8bfcfb81a$var$MAX_AGE_MIN = 5;
const $ed861ad8bfcfb81a$var$MAX_AGE = $ed861ad8bfcfb81a$var$MAX_AGE_MIN * 60000;
const $ed861ad8bfcfb81a$var$CACHE_SIZE = 100;
const $ed861ad8bfcfb81a$var$CACHE_KEY_PREFIX = '__storejs';
const $ed861ad8bfcfb81a$var$BE_CACHE_SAVE_ISSUE_MUTATION = '/gateway/api/jira-jql-service/api/v1/issue-mutation';
class $ed861ad8bfcfb81a$export$2e2bcd8739ae039 {
    #localCache;
    #sessionCache;
    constructor(namespace, maxAge = $ed861ad8bfcfb81a$var$MAX_AGE){
        this.maxAge = maxAge;
        this.namespace = namespace;
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#localCache = new (0, $kBiqn.Cache)({
            size: $ed861ad8bfcfb81a$var$CACHE_SIZE,
            storageType: (0, $d7Wfe.CacheType).LOCAL,
            cacheKey: namespace
        });
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#sessionCache = new (0, $kBiqn.Cache)({
            size: $ed861ad8bfcfb81a$var$CACHE_SIZE,
            storageType: (0, $d7Wfe.CacheType).SESSION,
            cacheKey: namespace
        });
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, userID) {
        if (activationID && activationID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID = activationID;
        if (cloudID && cloudID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID = cloudID;
        if (userID && userID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID = userID;
    }
    /**
	 * A util method to decide whether an issue mutation in cache is stale or not
	 */ static isIssueMutationStale(issueMutation) {
        const lastModified = new Date(issueMutation.lastModified).getTime();
        return Date.now() - lastModified < $ed861ad8bfcfb81a$var$MAX_AGE;
    }
    /**
	 * A util method to generate partial key containing username for storing in cache
	 */ static generateKey() {
        let anonymousId = window.localStorage.getItem('ajs_anonymous_id');
        anonymousId = anonymousId ? `.${anonymousId}` : '';
        anonymousId = anonymousId.replace(/["]+/g, '');
        // TODO : Replace this with something more generic
        return `jsis.ecCache.data${anonymousId}.newIssuesMutationList`;
    }
    /**
	 * A method to generate key containing username as well as namespace for storing in cache
	 */ generateReadKey() {
        return `${$ed861ad8bfcfb81a$var$CACHE_KEY_PREFIX}_${this.namespace}_${$ed861ad8bfcfb81a$export$2e2bcd8739ae039.generateKey()}`;
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds and returns corresponding issue mutations
	 * Returns all the issue mutations when provided with null argument in form of an array
	 * Cleans the cache before accessing issue mutations in order to avoid stale data
	 */ async get(key) {
        return this.cleanCache().then(()=>this.getWithoutClean(key));
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds to return selective issue mutations
	 * Returns all the issue mutations when provided with null argument
	 */ async getWithoutClean(key) {
        if (key == null) return new Promise((resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>data ? resolve(data) : resolve({}));
        });
        return new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>{
                if (!data) resolve({});
                else {
                    const iterableData = data;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const newData = {};
                    if (typeof key === 'string') newData[key] = iterableData[key];
                    else if (Array.isArray(key)) key.forEach((issueId)=>{
                        newData[issueId] = iterableData[issueId];
                    });
                    resolve(newData);
                }
            });
        });
    }
    /**
	 * A method to construct object to be stored in backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static constructBackendCacheObject(value) {
        if (value instanceof (0, $48mPv.default)) return {
            issueId: value.issueId,
            mutationType: value.mutationType,
            mutationTimestamp: value.lastModified
        };
        const result = [];
        value.forEach((data)=>{
            result.push($ed861ad8bfcfb81a$export$2e2bcd8739ae039.constructBackendCacheObject(data));
        });
        return result;
    }
    /**
	 * A method to save the issue mutations in the backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static setBackendCache(data) {
        try {
            let issueBody = $ed861ad8bfcfb81a$export$2e2bcd8739ae039.constructBackendCacheObject(data);
            let trackingId = '-1';
            if (data instanceof (0, $48mPv.default)) {
                trackingId = String(new Date(data.lastModified).valueOf()) + ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID || '');
                issueBody = [
                    issueBody
                ];
            } else trackingId = String(new Date(data[0].lastModified).valueOf()) + ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID || '');
            (0, $2OdyW.default)($ed861ad8bfcfb81a$var$BE_CACHE_SAVE_ISSUE_MUTATION, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'ATL-activationId': $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID || '',
                    'atl-CloudId': $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID || '',
                    trackingId: trackingId
                },
                body: JSON.stringify({
                    issueMutations: issueBody
                })
            });
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', `${e?.toString() || ''}mutationObj: ${data}`);
            return false;
        }
    }
    /**
	 * A method to save the issue mutations in the cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ async set(value) {
        return this.getWithoutClean().then(async (cacheData)=>{
            if (value instanceof (0, $48mPv.default)) {
                const storeValue = {
                    [value.issueId]: value
                };
                return new Promise((resolve)=>{
                    try {
                        this.#localCache.set(this.generateReadKey(), (0, $4qvSX.mergeData)(cacheData, storeValue));
                        resolve(true);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (e) {
                        resolve(false);
                    }
                });
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const storeData = {};
            value.forEach((data)=>{
                storeData[data.issueId] = data;
            });
            return new Promise((resolve)=>{
                try {
                    this.#localCache.set(this.generateReadKey(), (0, $4qvSX.mergeData)(cacheData, storeData));
                    resolve(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    resolve(false);
                }
            });
        });
    }
    /**
	 * A method to create a new issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be created in cache
	 */ async create(value) {
        return this.cleanCache().then(()=>{
            if (!Array.isArray(value)) return this.set(new (0, $48mPv.default)(value, (0, $d7Wfe.MutationSource).CREATE, '1', [], new Date().toISOString()));
            const storeData = value.map((data)=>new (0, $48mPv.default)(data, (0, $d7Wfe.MutationSource).CREATE, '1', [], new Date().toISOString()));
            return this.set(storeData);
        });
    }
    /**
	 * A method to update an already existing issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be updated in cache
	 */ async update(value) {
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            if (typeof value === 'string') return this.set(new (0, $48mPv.default)(value, (0, $d7Wfe.MutationSource).UPDATE, '1', []));
            return this.set(value.map((issueId)=>new (0, $48mPv.default)(issueId, (0, $d7Wfe.MutationSource).UPDATE, '1', [])));
        }
        return this.getWithoutClean(value).then((data)=>{
            const valueToUpdate = [];
            Object.entries(data).forEach(([issueId, issueMutationObj])=>{
                if (issueMutationObj instanceof (0, $48mPv.default)) {
                    if ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).UPDATE, issueMutationObj.version, issueMutationObj.matchStatus, new Date().toISOString()));
                    else valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).CREATE, '1', issueMutationObj.matchStatus, new Date().toISOString()));
                } else valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).UPDATE, // TODO: Incorporate the version and match status and change the update method signature
                '1', [], new Date().toISOString()));
            });
            return this.set(valueToUpdate);
        });
    }
    /**
	 * A method to delete an issue mutation in cache
	 */ async delete(key) {
        if (typeof key === 'string') return this.set(new (0, $48mPv.default)(key, (0, $d7Wfe.MutationSource).DELETE, '', [], new Date().toISOString()));
        const storeData = key.map((data)=>new (0, $48mPv.default)(data, (0, $d7Wfe.MutationSource).DELETE, '', [], new Date().toISOString()));
        return this.set(storeData);
    }
    /**
	 * A method to clear the cache
	 */ async clear() {
        return this.#localCache.clear();
    }
    /**
	 * A method that selectively deletes the stale cache entries
	 */ async cleanCache() {
        // We don't clean the backend cache
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) return Promise.resolve(true);
        return this.getWithoutClean(null).then((data)=>{
            const issuesToKeep = [];
            if (data && Object.keys(data).length !== 0 && Object.getPrototypeOf(data) === Object.prototype) Object.keys(data).forEach((issueId)=>{
                const issueMutationObj = data[issueId];
                if ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) issuesToKeep.push(issueMutationObj);
            });
            return this.clear().then(()=>this.set(issuesToKeep));
        });
    }
    /**
	 * A method to check if an issue id is present in the cache
	 */ isPresent(issueId) {
        return this.get(issueId).then((data)=>!!data && !!Object.values(data)[0]);
    }
    /**
	 * A method to check if any mutation is present in the cache
	 */ isEmpty() {
        return this.get(null).then((data)=>Object.keys(data).length === 0);
    }
    /**
	 * A method to find the size of the local storage for any given key
	 */ static getLocalStorageSizeForGivenKey(key) {
        const value = localStorage.getItem(key);
        if (value != null) {
            const keySize = value.length;
            return keySize;
        }
        return 0;
    }
    /**
	 * A method to find the size of the local storage for any given key
	 * It returns size of all the keys when provided with no key
	 */ static getLocalStorageSize(key) {
        if (key != null) return $ed861ad8bfcfb81a$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(key);
        let totalSize = 0;
        Object.keys(localStorage).forEach((keys)=>{
            totalSize += $ed861ad8bfcfb81a$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(keys);
        });
        return totalSize;
    }
}

});
parcelRegister("kBiqn", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $32f02625ea3a7ccc$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $32f02625ea3a7ccc$export$2e2bcd8739ae039);

var $aZaPn = parcelRequire("aZaPn");

var $89bO2 = parcelRequire("89bO2");

var $gUUjF = parcelRequire("gUUjF");


var $48k9t = parcelRequire("48k9t");
const $32f02625ea3a7ccc$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $32f02625ea3a7ccc$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $48k9t.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $32f02625ea3a7ccc$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $32f02625ea3a7ccc$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$2670cb7d5d4f7184)) storage = (0, $aZaPn.createLocalStorageProvider)((0, $48k9t.CACHE_PREFIX));
        else storage = (0, $89bO2.createSessionStorageProvider)((0, $48k9t.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $834cc2f16be60bc5$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $834cc2f16be60bc5$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $gUUjF.default).safeWarnWithoutCustomerData((0, $834cc2f16be60bc5$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $834cc2f16be60bc5$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $834cc2f16be60bc5$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $48k9t.default).scopes.current !== (0, $48k9t.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32f02625ea3a7ccc$var$cacheMap = {};
const $32f02625ea3a7ccc$var$getCache = async (props)=>{
    await (0, $48k9t.scopeGuard)().catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $32f02625ea3a7ccc$var$cacheMap[cacheKey] = $32f02625ea3a7ccc$var$cacheMap[cacheKey] || new $32f02625ea3a7ccc$export$94affb487e701bf2(props);
    return $32f02625ea3a7ccc$var$cacheMap[cacheKey];
};
const $32f02625ea3a7ccc$export$710d301bf26d9700 = ()=>{
    Object.values($32f02625ea3a7ccc$var$cacheMap).forEach((cache)=>cache.clear());
};
var $32f02625ea3a7ccc$export$2e2bcd8739ae039 = $32f02625ea3a7ccc$var$getCache;

});
parcelRegister("89bO2", function(module, exports) {

$parcel$export(module.exports, "createSessionStorageProvider", () => $eaaf8012779da3f6$export$a922b987e648d2fa);
$parcel$export(module.exports, "createSessionExpirableStorageProvider", () => $eaaf8012779da3f6$export$e0a2e9a062c6a695);

var $jqvCZ = parcelRequire("jqvCZ");

var $avHyR = parcelRequire("avHyR");

var $8zsxt = parcelRequire("8zsxt");
const $eaaf8012779da3f6$export$a922b987e648d2fa = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>(0, $avHyR.createStorageProvider)(appPrefix, (0, $8zsxt.makeSessionStore)()));
const $eaaf8012779da3f6$export$e0a2e9a062c6a695 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const store = (0, $8zsxt.makeSessionExpirableStore)();
    return store.namespace(appPrefix);
});

});
parcelRegister("8zsxt", function(module, exports) {

$parcel$export(module.exports, "makeSessionStore", () => $dffa4c0ba19d0eb7$export$fb690882d627b3b5);
$parcel$export(module.exports, "makeSessionExpirableStore", () => $dffa4c0ba19d0eb7$export$a8f626c8ded9a06c);

var $2y3XF = parcelRequire("2y3XF");

var $gleLd = parcelRequire("gleLd");

var $ZGlKn = parcelRequire("ZGlKn");

var $gpWeB = parcelRequire("gpWeB");

var $lyUHD = parcelRequire("lyUHD");

var $avHyR = parcelRequire("avHyR");
const $dffa4c0ba19d0eb7$export$fb690882d627b3b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($lyUHD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], (0, $avHyR.plugins));
const $dffa4c0ba19d0eb7$export$a8f626c8ded9a06c = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($lyUHD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($2y3XF))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gleLd)))
    ]);

});


const $834cc2f16be60bc5$export$7271276960377470 = 'common-cache';
const $834cc2f16be60bc5$export$a61768fefd33fcb1 = 'capacity exceeded';
const $834cc2f16be60bc5$export$6c4d37c7f376a1de = 'clear';
const $834cc2f16be60bc5$export$e271b26eefe41db8 = 'update';
const $834cc2f16be60bc5$export$4bd2facc4a3e6aa1 = 'delete';
const $834cc2f16be60bc5$export$26d12233004a7a60 = 'delete stale entry';
const $834cc2f16be60bc5$export$1bb358554aac31c1 = 'get';
const $834cc2f16be60bc5$export$61f74127e2b53cbe = 'hydrate';
const $834cc2f16be60bc5$export$5e8f180ef0142226 = 'set';
const $834cc2f16be60bc5$export$9eb68924983e00fb = 'get entries';
const $834cc2f16be60bc5$export$bf340b99118a1511 = 'memory';
const $834cc2f16be60bc5$export$2670cb7d5d4f7184 = 'local';
const $834cc2f16be60bc5$export$b796061ff0c82e1a = 'session';

parcelRegister("48k9t", function(module, exports) {

$parcel$export(module.exports, "CACHE_PREFIX", () => $619b603377692131$export$69ca515e4489d790);
$parcel$export(module.exports, "scopeGuard", () => $619b603377692131$export$653cd03438bb0386);
$parcel$export(module.exports, "default", () => $619b603377692131$export$2e2bcd8739ae039);

var $aZaPn = parcelRequire("aZaPn");
let $619b603377692131$var$resolveCachePromise;
const $619b603377692131$var$cachePromise = new Promise((resolve)=>{
    $619b603377692131$var$resolveCachePromise = resolve;
});
const $619b603377692131$export$27be962d708928a = '__scope_key__';
const $619b603377692131$export$69ca515e4489d790 = 'cache_prefix';
const $619b603377692131$var$TIMEOUT = 10000;
const $619b603377692131$var$promiseWithMaxExecutionTime = (ms, promise)=>{
    let id;
    const timeout = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        id = setTimeout(()=>{
            const storage = (0, $aZaPn.createLocalStorageProvider)($619b603377692131$export$69ca515e4489d790);
            storage.clearAll();
            reject(new Error(`Cache scope was not set within ${$619b603377692131$var$TIMEOUT}ms`));
        }, ms);
    });
    return Promise.race([
        promise,
        timeout
    ]).then((result)=>{
        clearTimeout(id);
        return result;
    });
};
const $619b603377692131$export$653cd03438bb0386 = ()=>$619b603377692131$var$promiseWithMaxExecutionTime($619b603377692131$var$TIMEOUT, $619b603377692131$var$cachePromise);
const $619b603377692131$var$config = {
    devTools: false,
    scopes: {
        prev: null,
        current: null
    },
    set (scopeKey) {
        const storage = (0, $aZaPn.createLocalStorageProvider)($619b603377692131$export$69ca515e4489d790);
        const scopeKeyInStorage = storage.get($619b603377692131$export$27be962d708928a);
        // init value
        if (this.scopes.prev === null && this.scopes.current === null) {
            if (scopeKeyInStorage) {
                // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
                this.scopes.prev = scopeKeyInStorage;
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.scopes.current = scopeKeyInStorage;
            }
        }
        // same account id
        if (this.scopes.current !== scopeKey) {
            // diffrent account id
            if (this.scopes.current !== null) // scope has changed during session
            storage.clearAll();
            // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
            this.scopes.prev = this.scopes.current;
            // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.scopes.current = scopeKey;
            storage.set($619b603377692131$export$27be962d708928a, scopeKey);
        }
        // @ts-expect-error - TS7005 - Variable 'resolveCachePromise' implicitly has an 'any' type.
        $619b603377692131$var$resolveCachePromise();
    },
    get () {
        return this.scopes.current;
    }
};
var $619b603377692131$export$2e2bcd8739ae039 = $619b603377692131$var$config;

});


parcelRegister("48mPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce578c493ad96d9e$export$2e2bcd8739ae039);
class $ce578c493ad96d9e$export$2e2bcd8739ae039 {
    constructor(issueId, mutationType, version = '1', matchStatus = [], // eslint-disable-next-line @typescript-eslint/no-unused-vars
    lastModified){
        this.issueId = issueId;
        this.mutationType = mutationType;
        this.version = version;
        this.matchStatus = matchStatus;
        // create a new timeStamp whenever an object is initialized
        this.lastModified = new Date().toISOString();
    }
}

});

parcelRegister("d7Wfe", function(module, exports) {

$parcel$export(module.exports, "MutationSource", () => $598bd411eca1df87$export$17f28c4c94a74282);
$parcel$export(module.exports, "CacheType", () => $598bd411eca1df87$export$ba193b555633db78);
const $598bd411eca1df87$export$17f28c4c94a74282 = {
    CREATE: 0,
    UPDATE: 1,
    DELETE: 2
};
const $598bd411eca1df87$export$ba193b555633db78 = {
    LOCAL: 'local',
    SESSION: 'session'
};

});

parcelRegister("4qvSX", function(module, exports) {

$parcel$export(module.exports, "mergeData", () => $1b463beed4d472c8$export$696bf4df45a0ddde);
$parcel$export(module.exports, "mergeResponseData", () => $1b463beed4d472c8$export$71923bad28063cb1);
$parcel$export(module.exports, "createAnalyticsMetadata", () => $1b463beed4d472c8$export$eeaad9fa1f02ef4a);

var $6rW04 = parcelRequire("6rW04");
function $1b463beed4d472c8$export$696bf4df45a0ddde(oldData, newData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    Object.keys(oldData).forEach((issueId)=>{
        result[issueId] = oldData[issueId];
    });
    Object.keys(newData).forEach((issueId)=>{
        result[issueId] = newData[issueId];
    });
    return result;
}
function $1b463beed4d472c8$export$71923bad28063cb1(searchData, matchData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mergedData = [];
    const issueData = new Map();
    if (matchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    matchData.forEach((element)=>{
        issueData.set(element.id, element);
    });
    if (searchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchData.forEach((element)=>{
        // TODO: if issueVersion in Match is less than Search, we should not be overwriting that issueID.
        if (issueData.has(element.id)) {
            mergedData.push(issueData.get(element.id));
            issueData.delete(element.id);
        } else mergedData.push(element);
    });
    if (issueData.size) issueData.forEach((value)=>{
        mergedData.push(value);
    });
    return mergedData;
}
function $1b463beed4d472c8$export$eeaad9fa1f02ef4a(customKeys) {
    return {
        shard: (0, $6rW04.default)('ajs-shard') || '',
        userId: (0, $6rW04.default)('ajs-atlassian-account-id') || '',
        projectId: (0, $6rW04.default)('ajs-project-key') || '',
        ...customKeys
    };
}

});



parcelRegister("3FiBf", function(module, exports) {

$parcel$export(module.exports, "transformField", () => $6c6768d1dbec60b7$export$fbce423ada1f57a0);

var $guiFP = parcelRequire("guiFP");

var $2IspF = parcelRequire("2IspF");

var $3UBOQ = parcelRequire("3UBOQ");

var $3L7Sr = parcelRequire("3L7Sr");
const $6c6768d1dbec60b7$var$LOCATION = 'servicedesk.queues.selectors.fields-transformers';
const $6c6768d1dbec60b7$var$skipTransformer = (fieldType, field)=>{
    const errMessage = `No transformer for the field of type '${fieldType}', passing it straight to issue-table from redux`;
    (0, $guiFP.default)({
        meta: {
            id: 'selectorsFieldsTransformers',
            packageName: 'jiraServicedeskQueuesAgentView',
            teamName: 'jsd-shield'
        },
        error: new Error(errMessage)
    });
    (0, $2IspF.default).safeErrorWithoutCustomerData($6c6768d1dbec60b7$var$LOCATION, errMessage);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        // @ts-expect-error - TS2352 - Conversion of type '{ fieldId: string; value: User | null; isEditable: boolean; noJsonFieldTransformer: boolean; fieldType: string; } | { fieldId: string; value: User; isEditable: boolean; noJsonFieldTransformer: boolean; fieldType: string; } | ... 9 more ... | { ...; }' to type 'FieldDataSelectorChildrenProps' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
        noJsonFieldTransformer: true,
        fieldType: fieldType,
        ...field
    };
};
const $6c6768d1dbec60b7$export$fbce423ada1f57a0 = (issue, field, fieldType, storedFieldUpdater)=>{
    const htmlOverrideFieldTransformer = (0, $3L7Sr.getHtmlOverrideFieldTransformer)(fieldType);
    if (htmlOverrideFieldTransformer) return htmlOverrideFieldTransformer(issue, field);
    // @ts-expect-error - TS2339 - Property 'fieldAsHtml' does not exist on type 'ResponseField'. | TS2339 - Property 'fieldCssClass' does not exist on type 'ResponseField'.
    if (field.fieldAsHtml != null || field.fieldCssClass != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $3UBOQ.htmlTransformer)(field);
    const jsonFieldTransformer = (0, $3L7Sr.getJsonTransformer)(fieldType);
    if (!jsonFieldTransformer) return $6c6768d1dbec60b7$var$skipTransformer(fieldType, field);
    const transformerInputParams = {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        storedValue: field,
        storedFieldUpdater: storedFieldUpdater
    };
    // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'GenericFieldDataTransformerInput<AssigneeFieldResponse> & GenericFieldDataTransformerInput<CreatorFieldResponse> & ... 9 more ... & GenericFieldDataTransformerInput<...>'.
    return jsonFieldTransformer(transformerInputParams);
};

});
parcelRegister("3UBOQ", function(module, exports) {

$parcel$export(module.exports, "htmlTransformer", () => $e63a52c537f46dd4$export$7237dba103a5f934);
const $e63a52c537f46dd4$export$7237dba103a5f934 = (storedValue)=>{
    const { fieldAsHtml: fieldRenderedValue, fieldCssClass: fieldCssClass } = storedValue;
    return {
        fieldRenderedValue: fieldRenderedValue,
        fieldCssClass: fieldCssClass
    };
};

});

parcelRegister("3L7Sr", function(module, exports) {

$parcel$export(module.exports, "getJsonTransformer", () => $53d29cbbdb54d491$export$437c449f44600e71);
$parcel$export(module.exports, "getHtmlOverrideFieldTransformer", () => $53d29cbbdb54d491$export$bd0e12633e105768);

var $8Obc6 = parcelRequire("8Obc6");

var $k2wRA = parcelRequire("k2wRA");

var $P5t8k = parcelRequire("P5t8k");
const $53d29cbbdb54d491$var$FIELD_DATA_TRANSFORMERS = {
    assignee: (0, $P5t8k.assigneeFieldTransformer),
    creator: (0, $P5t8k.creatorFieldTransformer),
    'com.atlassian.servicedesk:sd-sla-field': (0, $k2wRA.SlaFieldTransformer),
    status: (0, $P5t8k.statusFieldTransformer),
    issuetype: (0, $P5t8k.issueTypeTransformer),
    reporter: (0, $P5t8k.reporterFieldTransformer),
    summary: (0, $P5t8k.summaryFieldTransformer),
    labels: (0, $P5t8k.labelsFieldTransformer),
    'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype': (0, $k2wRA.serviceEntityFieldTransformer),
    'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype': (0, $k2wRA.cmdbFieldTransformer),
    'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype': (0, $k2wRA.respondersFieldTransformer),
    'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype': (0, $k2wRA.majorIncidentFieldTransformer),
    'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker': (0, $k2wRA.multiUserPickerTransformer),
    'com.atlassian.servicedesk:sd-request-participants': (0, $P5t8k.requestParticipantsPickerTransformer),
    'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes': (0, $k2wRA.multiCheckBoxesFieldTransformer),
    'com.atlassian.jira.plugin.system.customfieldtypes:multiselect': (0, $k2wRA.multiSelectFieldTransformer),
    'com.atlassian.jira.plugin.system.customfieldtypes:multiversion': (0, $k2wRA.multiVersionFieldTransformer),
    'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker': (0, $k2wRA.multiGroupPickerTransformer),
    'com.atlassian.servicedesk.customer-context:sd-csm-entitlement': (0, $k2wRA.entitlementFieldTransformer),
    'com.atlassian.servicedesk.sentiment:sd-sentiment': (0, $k2wRA.sentimentFieldTransformer)
};
const $53d29cbbdb54d491$export$437c449f44600e71 = (fieldType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'FieldDataTransformers'.
    const transformer = $53d29cbbdb54d491$var$FIELD_DATA_TRANSFORMERS[fieldType];
    return transformer;
};
const $53d29cbbdb54d491$var$HTML_OVERRIDE_TRANSFORMERS = {
    issuekey: (0, $P5t8k.issueKeyTransformer),
    priority: (0, $P5t8k.priorityTransformer)
};
const $53d29cbbdb54d491$export$bd0e12633e105768 = (fieldType)=>(0, $8Obc6.getFieldTypesToOverrideHtmlDataForAsSet)().has(fieldType) ? $53d29cbbdb54d491$var$HTML_OVERRIDE_TRANSFORMERS[fieldType] : undefined;

});
parcelRegister("k2wRA", function(module, exports) {

$parcel$export(module.exports, "SlaFieldTransformer", () => $906fb11a4b58ee6a$export$631ca5fe503ed873);
$parcel$export(module.exports, "serviceEntityFieldTransformer", () => $906fb11a4b58ee6a$export$71a2c8878bbf90c0);
$parcel$export(module.exports, "cmdbFieldTransformer", () => $906fb11a4b58ee6a$export$29b1e5041a029737);
$parcel$export(module.exports, "respondersFieldTransformer", () => $906fb11a4b58ee6a$export$7cbfbf5c2db25ae9);
$parcel$export(module.exports, "majorIncidentFieldTransformer", () => $906fb11a4b58ee6a$export$61023cbab62d778a);
$parcel$export(module.exports, "multiCheckBoxesFieldTransformer", () => $906fb11a4b58ee6a$export$ff4e3a9e8bd4c54e);
$parcel$export(module.exports, "multiSelectFieldTransformer", () => $906fb11a4b58ee6a$export$b2cbc32d83bc65fc);
$parcel$export(module.exports, "multiUserPickerTransformer", () => $906fb11a4b58ee6a$export$80f3565c0e85deed);
$parcel$export(module.exports, "multiVersionFieldTransformer", () => $906fb11a4b58ee6a$export$63aceefa091c51d7);
$parcel$export(module.exports, "multiGroupPickerTransformer", () => $906fb11a4b58ee6a$export$4ae5e1efce8cc8a3);
$parcel$export(module.exports, "entitlementFieldTransformer", () => $906fb11a4b58ee6a$export$38764a4ff2cdd62e);
$parcel$export(module.exports, "sentimentFieldTransformer", () => $906fb11a4b58ee6a$export$2a202309361bd23b);

var $6wqPF = parcelRequire("6wqPF");
var $3jYzf = parcelRequire("3jYzf");
var $9FEvp = parcelRequire("9FEvp");

var $4p54N = parcelRequire("4p54N");
var $bbmZl = parcelRequire("bbmZl");

var $gUUjF = parcelRequire("gUUjF");

var $5JgJ2 = parcelRequire("5JgJ2");



var $4xHig = parcelRequire("4xHig");

var $lGLse = parcelRequire("lGLse");

var $krSiK = parcelRequire("krSiK");
const $906fb11a4b58ee6a$var$LOCATION = 'servicedesk.queues.selectors.fields-transformers.json-fields.custom-fields';
const $906fb11a4b58ee6a$var$checkCycleValidity = (cycle)=>{
    const { remainingTime: remainingTime, goalDuration: goalDuration, elapsedTime: elapsedTime } = cycle;
    const undefinedValues = [];
    if (!remainingTime) undefinedValues.push('remainingTime');
    if (!goalDuration) undefinedValues.push('goalDuration');
    if (!elapsedTime) undefinedValues.push('elapsedTime');
    return undefinedValues;
};
const $906fb11a4b58ee6a$var$isCompletedCycleValid = (cycle)=>{
    const undefinedValues = $906fb11a4b58ee6a$var$checkCycleValidity(cycle);
    if (undefinedValues.length > 0) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData($906fb11a4b58ee6a$var$LOCATION, `[FD-4303] CompletedCycle data is invalid: ${String(undefinedValues)}`);
        return false;
    }
    return true;
};
const $906fb11a4b58ee6a$var$isOngoingCycleValid = (cycle)=>{
    const undefinedValues = $906fb11a4b58ee6a$var$checkCycleValidity(cycle);
    if (undefinedValues.length > 0) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData($906fb11a4b58ee6a$var$LOCATION, `[FD-4303] OngoingCycle data is invalid: ${String(undefinedValues)}`);
        return false;
    }
    return true;
};
const $906fb11a4b58ee6a$var$getLastCompletedCycle = (completedCycles)=>{
    let lastCompletedCycle = completedCycles[0];
    completedCycles.forEach((cycle)=>{
        if (cycle.stopTime.epochMillis > lastCompletedCycle.stopTime.epochMillis) lastCompletedCycle = cycle;
    });
    return lastCompletedCycle;
};
const $906fb11a4b58ee6a$var$getDays = (timezone)=>{
    const date = (0, $bbmZl.default)(new Date(), timezone);
    return [
        (0, $3jYzf.default)(date),
        (0, $3jYzf.default)((0, $6wqPF.default)(date, 1)),
        (0, $3jYzf.default)((0, $9FEvp.default)(date, 1))
    ];
};
// This shall be deleted when localised time shown feature is fully rolled out
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $906fb11a4b58ee6a$var$getMatchingDay = (receivedDate, timezone, formatMessage)=>{
    const [today, tomorrow, yesterday] = $906fb11a4b58ee6a$var$getDays(timezone);
    const isSame = (dateOne, dateTwo)=>dateOne.getDate() === dateTwo.getDate() && dateOne.getMonth() === dateTwo.getMonth() && dateOne.getFullYear() === dateTwo.getFullYear();
    const isToday = isSame(today, receivedDate);
    const isTomorrow = isSame(tomorrow, receivedDate);
    const isYesterday = isSame(yesterday, receivedDate);
    let defaultDayFormat = (0, $4p54N.default)(receivedDate, 'd MMM');
    isToday && (defaultDayFormat = formatMessage((0, $krSiK.default).today));
    isTomorrow && (defaultDayFormat = formatMessage((0, $krSiK.default).tomorrow));
    isYesterday && (defaultDayFormat = formatMessage((0, $krSiK.default).yesterday));
    return defaultDayFormat;
};
const $906fb11a4b58ee6a$export$9015300e6978c54b = (timeInEpochMillis, userTimezone, formatMessage)=>{
    if (timeInEpochMillis) {
        const breachTimeTz = (0, $bbmZl.default)(timeInEpochMillis, userTimezone);
        return `${$906fb11a4b58ee6a$var$getMatchingDay(breachTimeTz, userTimezone, formatMessage)} ${(0, $4p54N.default)(breachTimeTz, 'hh:mm a', {
            timeZone: userTimezone
        })}`;
    }
    return '';
};
const $906fb11a4b58ee6a$export$631ca5fe503ed873 = ({ storedValue: storedValue })=>{
    const { value: responseValue } = storedValue;
    const [{ data: loggedInUser }] = (0, $lGLse.useUserSubscriber)();
    const userTimezone = loggedInUser?.timeZone || 'America/Toronto';
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5JgJ2.default)();
    let locale = (0, $4xHig.useLocale)();
    if (locale === undefined) locale = 'en_US';
    const localeString = locale.replace('_', '-');
    const dateTimeFormat = new Intl.DateTimeFormat(localeString, {
        hour: 'numeric'
    });
    const isBrowserLocale24h = ()=>!dateTimeFormat.format(0).match(/[A/P]M/);
    const getMatchingDayForLocale = (receivedDate, timeInEpochMillis)=>{
        const [today, tomorrow, yesterday] = $906fb11a4b58ee6a$var$getDays(userTimezone);
        const isSame = (dateOne, dateTwo)=>dateOne.getDate() === dateTwo.getDate() && dateOne.getMonth() === dateTwo.getMonth() && dateOne.getFullYear() === dateTwo.getFullYear();
        const isToday = isSame(today, receivedDate);
        const isTomorrow = isSame(tomorrow, receivedDate);
        const isYesterday = isSame(yesterday, receivedDate);
        let defaultDayFormat = formatDate(timeInEpochMillis, {
            timeZone: userTimezone,
            day: '2-digit',
            month: 'short'
        });
        isToday && (defaultDayFormat = formatMessage((0, $krSiK.default).today));
        isTomorrow && (defaultDayFormat = formatMessage((0, $krSiK.default).tomorrow));
        isYesterday && (defaultDayFormat = formatMessage((0, $krSiK.default).yesterday));
        return defaultDayFormat;
    };
    const getTimeInSlaFriendlierFormatForLocale = (timeInEpochMillis)=>{
        if (timeInEpochMillis) {
            const breachTimeTz = (0, $bbmZl.default)(timeInEpochMillis, userTimezone);
            return `${getMatchingDayForLocale(breachTimeTz, timeInEpochMillis)} ${formatDate(timeInEpochMillis, {
                hour12: !isBrowserLocale24h(),
                timeZone: userTimezone,
                hour: '2-digit',
                minute: '2-digit'
            })}`;
        }
        return '';
    };
    const getTimeRemainingInMinutes = (timeInHourSpaceMinutes)=>{
        const isTimeInMinus = timeInHourSpaceMinutes.indexOf('-') === 0;
        const absoluteTime = isTimeInMinus ? timeInHourSpaceMinutes.substring(1) : timeInHourSpaceMinutes;
        const millis = parseInt(absoluteTime, 10);
        const totalMinutes = millis / 60000;
        return isTimeInMinus ? -1 * totalMinutes : totalMinutes;
    };
    const getPercentageOfTimeTaken = (goalTime, remainingTime)=>{
        const goalTimeInMinutes = getTimeRemainingInMinutes(goalTime);
        const remainingTimeInMinutes = getTimeRemainingInMinutes(remainingTime);
        let percentage = (goalTimeInMinutes - remainingTimeInMinutes) / goalTimeInMinutes;
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'number'.
        percentage = (percentage * 100).toFixed(2);
        // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
        return Math.round(parseInt(percentage, 10)).toString();
    };
    const getBreachTimeInLocalStringForLocale = (breachTimeInEpochMillis)=>{
        if (breachTimeInEpochMillis) {
            const BREACH_DATE = (0, $bbmZl.default)(breachTimeInEpochMillis, userTimezone);
            return `${formatDate(breachTimeInEpochMillis, {
                hour12: !isBrowserLocale24h(),
                timeZone: userTimezone,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            })} GMT${(0, $4p54N.default)(BREACH_DATE, 'xx', {
                timeZone: userTimezone
            })}`;
        }
        return `${formatMessage((0, $krSiK.default).notApplicable)}`;
    };
    const getHoverContent = (closed, remainingTimeMillis, breachTime, goalTimeMillis, goalTimeLongFriendly, remainingTimeFriendly)=>{
        const isTimeInMinus = remainingTimeFriendly.indexOf('-') === 0;
        let remainingTimeString;
        let timeStatus;
        if (isTimeInMinus) {
            remainingTimeString = remainingTimeFriendly.substring(1);
            timeStatus = formatMessage((0, $krSiK.default).past);
        } else {
            remainingTimeString = remainingTimeFriendly;
            timeStatus = formatMessage((0, $krSiK.default).left);
        }
        if (closed === true) {
            timeStatus = isTimeInMinus ? formatMessage((0, $krSiK.default).breached) : formatMessage((0, $krSiK.default).met);
            const percentage = getPercentageOfTimeTaken(goalTimeMillis, remainingTimeMillis);
            const hoverContentCompleted = `${isTimeInMinus ? `-${remainingTimeString}` : remainingTimeString} ${timeStatus ?? ''} ${String.fromCodePoint(0x2022)} ${percentage}% of ${goalTimeLongFriendly} ${String.fromCodePoint(0x2022)} ${getBreachTimeInLocalStringForLocale(breachTime)}`;
            return hoverContentCompleted;
        }
        const hoverContent = `${remainingTimeString} ${timeStatus ?? ''} ${String.fromCodePoint(0x2022)} ${formatMessage((0, $krSiK.default).due) ?? ''}: ${getBreachTimeInLocalStringForLocale(breachTime)}`;
        return hoverContent;
    };
    const friendlierHoverContent = (closed, remainingTimeMillis, breachTime, goalTimeMillis, goalTimeLongFriendly, remainingTimeFriendly, slaDisplayFormat)=>slaDisplayFormat === (0, $feae9f437bfca243$export$13ecaaf97b049384) ? getHoverContent(closed, remainingTimeMillis, breachTime, goalTimeMillis, goalTimeLongFriendly, remainingTimeFriendly) : undefined;
    // @ts-expect-error - TS2339 - Property 'errorMessage' does not exist on type 'Sla | SlaError'.
    if (responseValue && responseValue.errorMessage) return {
        fieldType: (0, $eb1896b876bf2c2c$export$f790c24298ed441b),
        value: responseValue
    };
    if (responseValue && // @ts-expect-error - TS2339 - Property 'ongoingCycle' does not exist on type 'Sla | SlaError'.
    responseValue.ongoingCycle && // @ts-expect-error - TS2339 - Property 'ongoingCycle' does not exist on type 'Sla | SlaError'.
    $906fb11a4b58ee6a$var$isOngoingCycleValid(responseValue.ongoingCycle)) {
        const { paused: paused, remainingTime: remainingTime, breached: breached, breachTime: breachTime, goalDuration: goalDuration, elapsedTime: elapsedTime, withinCalendarHours: withinCalendarHours } = responseValue.ongoingCycle;
        const slaDisplayFormat = // @ts-expect-error - TS2339 - Property 'slaDisplayFormat' does not exist on type 'Sla | SlaError'.
        responseValue.slaDisplayFormat ?? (0, $feae9f437bfca243$export$13ecaaf97b049384);
        // When an SLA is paused due to being outside of working hours, the paused value is false
        const status = paused || !withinCalendarHours ? (0, $eb1896b876bf2c2c$export$3ad39751a33c16b8) : (0, $eb1896b876bf2c2c$export$d1917132a74c7b93);
        const timeRemainingInMinutes = Math.floor(remainingTime.millis / 60000);
        const breachTimeFriendly = breachTime ? breachTime.friendly : undefined;
        const timeInFriendlyFormat = ()=>getTimeInSlaFriendlierFormatForLocale(breachTime?.epochMillis).toString();
        return {
            fieldType: (0, $eb1896b876bf2c2c$export$f790c24298ed441b),
            value: {
                status: status,
                timeRemainingFriendly: slaDisplayFormat === (0, $feae9f437bfca243$export$13ecaaf97b049384) ? timeInFriendlyFormat() : remainingTime.friendly,
                isBreached: breached,
                timeRemainingInMinutes: timeRemainingInMinutes,
                breachTime: breachTimeFriendly,
                elapsedTime: elapsedTime.friendly,
                goalDuration: goalDuration.friendly,
                withinCalendarHours: withinCalendarHours,
                hoverContent: friendlierHoverContent(false, `${remainingTime.millis}`, breachTime?.epochMillis, goalDuration.millis, goalDuration.friendly, remainingTime.friendly, slaDisplayFormat),
                slaDisplayFormat: slaDisplayFormat
            }
        };
    }
    if (responseValue && // @ts-expect-error - TS2339 - Property 'completedCycles' does not exist on type 'Sla | SlaError'.
    responseValue.completedCycles && // @ts-expect-error - TS2339 - Property 'completedCycles' does not exist on type 'Sla | SlaError'.
    responseValue.completedCycles.length !== 0) {
        const slaDisplayFormat = // @ts-expect-error - TS2339 - Property 'slaDisplayFormat' does not exist on type 'Sla | SlaError'.
        responseValue.slaDisplayFormat ?? (0, $feae9f437bfca243$export$13ecaaf97b049384);
        // @ts-expect-error - TS2339 - Property 'completedCycles' does not exist on type 'Sla | SlaError'.
        const lastCompletedCycle = $906fb11a4b58ee6a$var$getLastCompletedCycle(responseValue.completedCycles);
        if (!$906fb11a4b58ee6a$var$isCompletedCycleValid(lastCompletedCycle)) return {
            fieldType: (0, $eb1896b876bf2c2c$export$f790c24298ed441b)
        };
        const timeRemainingInMinutes = Math.floor(lastCompletedCycle.remainingTime.millis / 60000);
        const { remainingTime: remainingTime, breached: breached, goalDuration: goalDuration, elapsedTime: elapsedTime, stopTime: stopTime, breachTime: breachTime } = lastCompletedCycle;
        const timeInFriendlyFormat = ()=>getTimeInSlaFriendlierFormatForLocale(stopTime.epochMillis).toString();
        return {
            fieldType: (0, $eb1896b876bf2c2c$export$f790c24298ed441b),
            value: {
                status: (0, $eb1896b876bf2c2c$export$fc332a617fd34192),
                timeRemainingFriendly: slaDisplayFormat === (0, $feae9f437bfca243$export$13ecaaf97b049384) ? timeInFriendlyFormat() : remainingTime.friendly,
                isBreached: breached,
                timeRemainingInMinutes: timeRemainingInMinutes,
                // A completed cycle doesn't have a breachTime value
                breachTime: undefined,
                elapsedTime: elapsedTime.friendly,
                goalDuration: goalDuration.friendly,
                withinCalendarHours: undefined,
                hoverContent: friendlierHoverContent(true, `${remainingTime.millis}`, breachTime?.epochMillis, `${goalDuration.millis}`, goalDuration.friendly, remainingTime.friendly, slaDisplayFormat),
                slaDisplayFormat: slaDisplayFormat
            }
        };
    }
    return {
        fieldType: (0, $eb1896b876bf2c2c$export$f790c24298ed441b)
    };
};
const $906fb11a4b58ee6a$export$71a2c8878bbf90c0 = ({ storedValue: { value: value } })=>({
        fieldType: (0, $eb1896b876bf2c2c$export$991960fb6e9ea7dd),
        value: value ? value.map((obj)=>obj.id) : []
    });
const $906fb11a4b58ee6a$export$29b1e5041a029737 = ({ storedValue: { value: value } })=>({
        fieldType: (0, $eb1896b876bf2c2c$export$b84257e6dcaab24d),
        value: value
    });
const $906fb11a4b58ee6a$export$7cbfbf5c2db25ae9 = ({ storedValue: { value: value } })=>({
        fieldType: (0, $eb1896b876bf2c2c$export$dd2fa454b47497da),
        value: value
    });
const $906fb11a4b58ee6a$export$61023cbab62d778a = ({ storedValue: { value: value } })=>({
        fieldType: (0, $eb1896b876bf2c2c$export$f0f60e2d773695fc),
        value: value
    });
const $906fb11a4b58ee6a$export$ff4e3a9e8bd4c54e = ({ storedValue: { value: value } })=>({
        fieldType: (0, $eb1896b876bf2c2c$export$d8fae0f9b622e615),
        value: value || []
    });
const $906fb11a4b58ee6a$export$b2cbc32d83bc65fc = ({ storedValue: { value: value } })=>({
        fieldType: (0, $eb1896b876bf2c2c$export$155ae54d06c908ea),
        value: value || []
    });
const $906fb11a4b58ee6a$export$80f3565c0e85deed = ({ storedValue: { value: value } })=>({
        fieldType: (0, $eb1896b876bf2c2c$export$2ddc21f5fedfaf92),
        value: value ? value.map((user)=>({
                name: user.displayName,
                email: user.emailAddress,
                avatarUrl: user.avatarUrls['48x48']
            })) : []
    });
const $906fb11a4b58ee6a$export$63aceefa091c51d7 = ({ storedValue: { value: value } })=>({
        fieldType: (0, $eb1896b876bf2c2c$export$5ae60777f05f3dfa),
        value: value ? value.map((version)=>({
                value: version.name,
                self: version.self,
                id: version.id
            })) : []
    });
const $906fb11a4b58ee6a$export$4ae5e1efce8cc8a3 = ({ storedValue: { value: value } })=>({
        fieldType: (0, $eb1896b876bf2c2c$export$734a41c9fe85799a),
        value: value ? value.map((group)=>({
                value: group.name,
                self: group.self,
                id: group.groupId
            })) : []
    });
const $906fb11a4b58ee6a$export$38764a4ff2cdd62e = ({ storedValue: { value: value } })=>({
        fieldType: (0, $eb1896b876bf2c2c$export$80b6ff34fe6a6e00),
        value: value
    });
const $906fb11a4b58ee6a$export$2a202309361bd23b = ({ storedValue: { value: value } })=>({
        fieldType: (0, $eb1896b876bf2c2c$export$37cb0de8d249ef22),
        value: value
    });

});
const $eb1896b876bf2c2c$export$d1917132a74c7b93 = 'ONGOING';
const $eb1896b876bf2c2c$export$fc332a617fd34192 = 'COMPLETED';
const $eb1896b876bf2c2c$export$3ad39751a33c16b8 = 'PAUSED';
const $eb1896b876bf2c2c$export$f790c24298ed441b = 'com.atlassian.servicedesk:sd-sla-field';
const $eb1896b876bf2c2c$export$991960fb6e9ea7dd = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $eb1896b876bf2c2c$export$b84257e6dcaab24d = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $eb1896b876bf2c2c$export$dd2fa454b47497da = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $eb1896b876bf2c2c$export$f0f60e2d773695fc = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $eb1896b876bf2c2c$export$794539092c70e595 = 'com.atlassian.jira.plugins.work-category-field:work-category-field-cftype';
const $eb1896b876bf2c2c$export$2ddc21f5fedfaf92 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $eb1896b876bf2c2c$export$d8fae0f9b622e615 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $eb1896b876bf2c2c$export$155ae54d06c908ea = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $eb1896b876bf2c2c$export$5ae60777f05f3dfa = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $eb1896b876bf2c2c$export$734a41c9fe85799a = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $eb1896b876bf2c2c$export$80b6ff34fe6a6e00 = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $eb1896b876bf2c2c$export$37cb0de8d249ef22 = 'com.atlassian.servicedesk.sentiment:sd-sentiment';

const $feae9f437bfca243$export$aad60a8e044b5914 = 'OLD_SLA_FORMAT';
const $feae9f437bfca243$export$13ecaaf97b049384 = 'NEW_SLA_FORMAT';

parcelRegister("krSiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $22c340723135972f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $22c340723135972f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.title",
        "defaultMessage": "SLAs"
    },
    past: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.past",
        "defaultMessage": "past"
    },
    left: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.left",
        "defaultMessage": "left"
    },
    met: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.met",
        "defaultMessage": "met"
    },
    breached: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.breached",
        "defaultMessage": "breached"
    },
    due: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.due",
        "defaultMessage": "Due"
    },
    today: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.today",
        "defaultMessage": "Today"
    },
    tomorrow: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.tomorrow",
        "defaultMessage": "Tomorrow"
    },
    yesterday: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.yesterday",
        "defaultMessage": "Yesterday"
    },
    notApplicable: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.not-applicable",
        "defaultMessage": "Breach time not found"
    }
});

});


parcelRegister("P5t8k", function(module, exports) {

$parcel$export(module.exports, "assigneeFieldTransformer", () => $fc82e5b4240b9cf2$export$c06a1d947706df0d);
$parcel$export(module.exports, "creatorFieldTransformer", () => $fc82e5b4240b9cf2$export$e084c35a52aac478);
$parcel$export(module.exports, "issueKeyTransformer", () => $fc82e5b4240b9cf2$export$f2658e11d37b4233);
$parcel$export(module.exports, "priorityTransformer", () => $fc82e5b4240b9cf2$export$c94a7bc669e96e93);
$parcel$export(module.exports, "issueTypeTransformer", () => $fc82e5b4240b9cf2$export$fb98dd6a5625192e);
$parcel$export(module.exports, "statusFieldTransformer", () => $fc82e5b4240b9cf2$export$72090e970546b9fd);
$parcel$export(module.exports, "reporterFieldTransformer", () => $fc82e5b4240b9cf2$export$e3cfac85b17dd6f4);
$parcel$export(module.exports, "summaryFieldTransformer", () => $fc82e5b4240b9cf2$export$7eadf4b26c5ed08);
$parcel$export(module.exports, "labelsFieldTransformer", () => $fc82e5b4240b9cf2$export$6e9eafdaf42a340d);
$parcel$export(module.exports, "requestParticipantsPickerTransformer", () => $fc82e5b4240b9cf2$export$1d7e6e4518ca808f);

const $fc82e5b4240b9cf2$var$onChangeAssignee = (originalStoredValue, storedFieldUpdater)=>(issueKey, newValue)=>{
        let newValueReverseTransformed = null;
        if (newValue) {
            const { displayName: displayName, avatarUrl: avatarUrl, accountId: accountId, emailAddress: emailAddress } = newValue;
            newValueReverseTransformed = {
                displayName: displayName,
                avatarUrls: {
                    '48x48': avatarUrl
                },
                accountId: accountId,
                emailAddress: emailAddress
            };
        }
        storedFieldUpdater({
            value: newValueReverseTransformed
        }, originalStoredValue);
    };
const $fc82e5b4240b9cf2$export$c06a1d947706df0d = ({ storedValue: storedValue, storedFieldUpdater: storedFieldUpdater })=>{
    const { isEditable: isEditable, value: responseValue } = storedValue;
    let value;
    if (responseValue) {
        const { accountId: accountId, emailAddress: emailAddress, displayName: displayName, avatarUrls: { '48x48': avatarUrl } } = responseValue;
        value = {
            displayName: displayName,
            avatarUrl: avatarUrl,
            accountId: accountId,
            emailAddress: emailAddress
        };
    }
    return {
        fieldType: 'assignee',
        value: value,
        key: responseValue ? responseValue.key : undefined,
        isEditable: isEditable,
        onChange: $fc82e5b4240b9cf2$var$onChangeAssignee(storedValue, storedFieldUpdater)
    };
};
const $fc82e5b4240b9cf2$export$e084c35a52aac478 = ({ storedValue: storedValue })=>{
    const { value: { accountId: accountId, emailAddress: emailAddress, displayName: displayName, avatarUrls: { '48x48': avatarUrl } } } = storedValue;
    const value = {
        displayName: displayName,
        avatarUrl: avatarUrl,
        accountId: accountId,
        emailAddress: emailAddress
    };
    return {
        fieldType: 'creator',
        value: value
    };
};
const $fc82e5b4240b9cf2$export$f2658e11d37b4233 = (issue)=>({
        fieldType: 'issuekey',
        value: issue.key
    });
const $fc82e5b4240b9cf2$export$c94a7bc669e96e93 = (issue)=>{
    const parser = new DOMParser();
    // @ts-expect-error: Property 'fieldAsHtml' does not exist on type 'ResponseField'.
    const doc = parser.parseFromString(issue.fields.priority.fieldAsHtml, 'text/html');
    const priorityHtml = doc.querySelector('img');
    if (!priorityHtml) return {
        fieldType: 'priority',
        value: undefined
    };
    return {
        fieldType: 'priority',
        value: {
            name: priorityHtml.title,
            iconUrl: priorityHtml.src
        }
    };
};
const $fc82e5b4240b9cf2$var$onChangeStatus = (originalStoredValue, storedFieldUpdater)=>(issueKey, newValue)=>{
        let newValueReverseTransformed = null;
        const { description: description, name: name, id: id, statusCategory: { id: statusCategoryId } } = newValue;
        newValueReverseTransformed = {
            id: id,
            description: description,
            name: name,
            statusCategory: {
                id: statusCategoryId
            }
        };
        storedFieldUpdater({
            value: newValueReverseTransformed
        }, originalStoredValue);
    };
const $fc82e5b4240b9cf2$export$fb98dd6a5625192e = ({ storedValue: storedValue })=>{
    const { value: { name: name, iconUrl: iconUrl, description: description } } = storedValue;
    const value = {
        name: name,
        iconUrl: iconUrl,
        description: description
    };
    return {
        fieldType: 'issuetype',
        value: value
    };
};
const $fc82e5b4240b9cf2$export$72090e970546b9fd = ({ storedValue: storedValue, storedFieldUpdater: storedFieldUpdater })=>{
    const { value: { id: id, name: name, description: description, statusCategory: { id: statusCategoryId } }, isEditable: isEditable } = storedValue;
    const value = {
        id: id,
        name: name,
        description: description,
        statusCategory: {
            id: statusCategoryId
        }
    };
    return {
        key: value.id.toString(),
        fieldType: 'status',
        value: value,
        onChange: $fc82e5b4240b9cf2$var$onChangeStatus(storedValue, storedFieldUpdater),
        isEditable: isEditable
    };
};
const $fc82e5b4240b9cf2$export$e3cfac85b17dd6f4 = ({ storedValue: storedValue })=>{
    const { value: value } = storedValue;
    if (!value) return {
        fieldType: 'reporter',
        value: null
    };
    const { displayName: displayName, emailAddress: emailAddress, active: active } = value;
    const transformedValue = {
        displayName: displayName,
        emailAddress: emailAddress,
        active: !!active
    };
    return {
        fieldType: 'reporter',
        value: transformedValue
    };
};
const $fc82e5b4240b9cf2$export$7eadf4b26c5ed08 = ({ storedValue: storedValue })=>({
        fieldType: 'summary',
        value: storedValue.value
    });
const $fc82e5b4240b9cf2$export$6e9eafdaf42a340d = ({ storedValue: storedValue })=>({
        fieldType: 'labels',
        value: storedValue.value.map((label)=>({
                name: label,
                href: `/issues/?jql=labels+%3D+${label}`
            }))
    });
const $fc82e5b4240b9cf2$export$1d7e6e4518ca808f = ({ storedValue: { value: value } })=>({
        fieldType: (0, $566af5fde20232d3$export$e918afe651ac9e7a),
        value: value ? value.map((user)=>({
                name: user.displayName,
                email: user.emailAddress,
                avatarUrl: user.avatarUrls['48x48']
            })) : []
    });

});
const $566af5fde20232d3$export$e918afe651ac9e7a = 'com.atlassian.servicedesk:sd-request-participants';







parcelRegister("6ycyf", function(module, exports) {

$parcel$export(module.exports, "getSortedByColumn", () => $5160142e96637127$export$89e3e8c1d19874d1);
$parcel$export(module.exports, "getSortFieldType", () => $5160142e96637127$export$8d69ea9f7db079ef);
$parcel$export(module.exports, "getSortOrder", () => $5160142e96637127$export$c11dbba94a24125);
$parcel$export(module.exports, "isManuallySorted", () => $5160142e96637127$export$abe45b95ac16d893);
$parcel$export(module.exports, "getIsAscendingOrder", () => $5160142e96637127$export$19e36eff55595869);
// @ts-expect-error - TS2305 - Module '"monet"' has no exported member 'MaybeType'.

var $7Oh8q = parcelRequire("7Oh8q");


var $3KNsL = parcelRequire("3KNsL");

var $1RqtY = parcelRequire("1RqtY");
const $5160142e96637127$var$maybeManualSorting = (state)=>{
    const queue = (0, $1RqtY.getCurrentQueue)(state);
    return (0, $7Oh8q.Maybe).fromNull(queue && queue.manualSorting || (0, $3KNsL.getQueuePageData)(state).manualSorting);
};
const $5160142e96637127$export$89e3e8c1d19874d1 = (state)=>$5160142e96637127$var$maybeManualSorting(state)// @ts-expect-error - TS7006 - Parameter 'manualSorting' implicitly has an 'any' type.
    .map((manualSorting)=>manualSorting.sortedBy).orSome(undefined);
const $5160142e96637127$export$8d69ea9f7db079ef = (state)=>{
    const sortedColumn = (0, $3KNsL.getColumns)(state).find((column)=>Boolean(column.currentSorting));
    return sortedColumn ? sortedColumn.fieldType : undefined;
};
const $5160142e96637127$export$c11dbba94a24125 = (state)=>$5160142e96637127$var$maybeManualSorting(state)// @ts-expect-error - TS7006 - Parameter 'manualSorting' implicitly has an 'any' type.
    .map((manualSorting)=>manualSorting.sortOrder).orSome((0, $e6571ec563c0baf9$export$1dee026a19752d6b));
const $5160142e96637127$export$abe45b95ac16d893 = (state)=>$5160142e96637127$export$89e3e8c1d19874d1(state) !== undefined;
const $5160142e96637127$export$19e36eff55595869 = (state)=>$5160142e96637127$export$c11dbba94a24125(state) === (0, $e6571ec563c0baf9$export$1dee026a19752d6b);

});
const $e6571ec563c0baf9$export$1dee026a19752d6b = 'ASC';
const $e6571ec563c0baf9$export$b6abcf7fa1d94f65 = 'DESC';
const $e6571ec563c0baf9$export$c53d0f541b41b88e = 'NONE';


parcelRegister("b60vU", function(module, exports) {

$parcel$export(module.exports, "getIsInitialLoad", () => $b85dfe33ce8346b9$export$f4ff973e05a3a506);
const $b85dfe33ce8346b9$export$b00c26bb659fae04 = (state)=>state.persisted.ssrIssuesData?.ssrIssueList;
const $b85dfe33ce8346b9$export$f4ff973e05a3a506 = (state)=>state.persisted.ssrIssuesData?.isInitialLoading;

});

parcelRegister("3s9hs", function(module, exports) {

$parcel$export(module.exports, "getProjectStateHash", () => $4d9a0ca4622d0780$export$6b15279c446fd00d);
$parcel$export(module.exports, "getIssueHash", () => $4d9a0ca4622d0780$export$57f7822280b6c408);
// @ts-expect-error - TS2305 - Module '"monet"' has no exported member 'MaybeType'.

var $7Oh8q = parcelRequire("7Oh8q");

var $3i6VQ = parcelRequire("3i6VQ");
const $4d9a0ca4622d0780$var$maybeUpdateMetadata = (state)=>(0, $7Oh8q.Maybe).fromNull((0, $3i6VQ.getPersisted)(state).updateMetadata);
const $4d9a0ca4622d0780$export$6b15279c446fd00d = (state)=>$4d9a0ca4622d0780$var$maybeUpdateMetadata(state)// @ts-expect-error - TS7006 - Parameter 'updateMetadata' implicitly has an 'any' type.
    .flatMap((updateMetadata)=>(0, $7Oh8q.Maybe).fromNull(updateMetadata.projectStateHash)).orSome('');
const $4d9a0ca4622d0780$export$57f7822280b6c408 = (state)=>$4d9a0ca4622d0780$var$maybeUpdateMetadata(state)// @ts-expect-error - TS7006 - Parameter 'updateMetadata' implicitly has an 'any' type.
    .flatMap((updateMetadata)=>(0, $7Oh8q.Maybe).fromNull(updateMetadata.issueHash)).orSome('');

});

parcelRegister("7AwFA", function(module, exports) {

$parcel$export(module.exports, "storeSortOrderInLocalStorage", () => $f550955e1d0fb70f$export$70ad8071224202a8);
$parcel$export(module.exports, "removeSortOrderInLocalStorage", () => $f550955e1d0fb70f$export$27624a2b25e61084);
$parcel$export(module.exports, "addSortingToQueues", () => $f550955e1d0fb70f$export$406ba23a25949900);
$parcel$export(module.exports, "createSortedQueue", () => $f550955e1d0fb70f$export$e8964ed223410f32);

var $6HC1D = parcelRequire("6HC1D");

var $8i1R8 = parcelRequire("8i1R8");

var $1LYxF = parcelRequire("1LYxF");

var $7Oh8q = parcelRequire("7Oh8q");

var $guiFP = parcelRequire("guiFP");


var $jMP2a = parcelRequire("jMP2a");

var $2IspF = parcelRequire("2IspF");

var $aNBkj = parcelRequire("aNBkj");
const $f550955e1d0fb70f$export$380a2d1eea3be734 = 'QUEUE_ORDER_BY_';
const $f550955e1d0fb70f$var$getKey = (queueId)=>`${$f550955e1d0fb70f$export$380a2d1eea3be734}${queueId}`;
const $f550955e1d0fb70f$export$70ad8071224202a8 = (queueId, fieldId, sortOrder)=>{
    try {
        window.localStorage.setItem($f550955e1d0fb70f$var$getKey((0, $aNBkj.fromQueueId)(queueId).toString()), JSON.stringify({
            fieldId: fieldId,
            sortOrder: sortOrder
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        const errMessage = 'Local storage failure for sorting';
        (0, $guiFP.default)({
            meta: {
                id: 'servicesSort',
                packageName: 'jiraServicedeskQueuesAgentView',
                teamName: 'jsd-shield'
            },
            attributes: {
                type: 'localStorageFull'
            },
            error: new Error(errMessage)
        });
        (0, $2IspF.default).safeErrorWithoutCustomerData('servicedesk.queues.agent-view.services', errMessage);
    }
};
const $f550955e1d0fb70f$export$27624a2b25e61084 = (queueId)=>{
    try {
        window.localStorage.removeItem($f550955e1d0fb70f$var$getKey((0, $aNBkj.fromQueueId)(queueId).toString()));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        const errMessage = 'Local storage deletion failure for sorting';
        (0, $guiFP.default)({
            meta: {
                id: 'servicesSortLocalstorageDelete',
                packageName: 'jiraServiceDeskQueuesAgentView',
                teamName: 'jsd-shield'
            },
            attributes: {
                type: 'localStorageDelete'
            },
            error: new Error(errMessage)
        });
        (0, $2IspF.default).safeErrorWithoutCustomerData('servicedesk.queues.agent-view.services', errMessage);
    }
};
const $f550955e1d0fb70f$export$b0fb563b02669fb1 = (queueId, createAnalyticsEvent)=>{
    try {
        const stored = typeof window !== 'undefined' ? window.localStorage.getItem($f550955e1d0fb70f$var$getKey(queueId)) : null;
        if (createAnalyticsEvent) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'viewQueuesSortingFromLocalStorage updated', {
            hasSorting: stored !== null
        });
        if (stored !== null) {
            const storedSortOrder = JSON.parse(stored);
            if (storedSortOrder.fieldId && storedSortOrder.fieldId.length > 0 && (storedSortOrder.sortOrder === (0, $e6571ec563c0baf9$export$1dee026a19752d6b) || storedSortOrder.sortOrder === (0, $e6571ec563c0baf9$export$b6abcf7fa1d94f65))) return (0, $7Oh8q.Maybe).of({
                sortedBy: storedSortOrder.fieldId,
                sortOrder: storedSortOrder.sortOrder
            });
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        const errMessage = 'Local storage for sorting getItem failure';
        (0, $guiFP.default)({
            meta: {
                id: 'servicesSortLocalstorageGet',
                packageName: 'jiraServiceDeskQueuesAgentView',
                teamName: 'jsd-shield'
            },
            attributes: {
                type: 'localStorageGet'
            },
            error: new Error(errMessage)
        });
        (0, $2IspF.default).safeErrorWithoutCustomerData('servicedesk.queues.agent-view.services', errMessage);
    }
    return (0, $7Oh8q.Maybe).None();
};
const $f550955e1d0fb70f$var$applyManualSortingToColumns = (columns, manualSorting)=>columns.map((column)=>{
        if (column.id === manualSorting.sortedBy) return (0, $6HC1D.assoc)(column, 'currentSorting', manualSorting.sortOrder);
        return (0, $6HC1D.dissoc)(column, 'currentSorting');
    });
const $f550955e1d0fb70f$export$bdc8ae2ac7632444 = (queue, maybeManualSorting)=>maybeManualSorting.cata(()=>queue, // @ts-expect-error - TS7006 - Parameter 'manualSorting' implicitly has an 'any' type.
    (manualSorting)=>(0, $6HC1D.updateIn)(queue, [
            'columns'
        ], (columns)=>// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'Column[]'.
            $f550955e1d0fb70f$var$applyManualSortingToColumns(columns, manualSorting)));
const $f550955e1d0fb70f$var$addSortingToQueuesInternal = (currentQueueId, queues)=>// @ts-expect-error - TS2322 - Type '[string, SortedQueue]' is not assignable to type 'SortedQueues'. | TS2345 - Argument of type '(acc: Record<string, any>, [queueId, queue]: [number, Queue]) => Record<string, any>' is not assignable to parameter of type '(previousValue: Record<string, any>, currentValue: [string, SortedQueue], currentIndex: number, array: [string, SortedQueue][]) => Record<string, any>'. | TS2304 - Cannot find name 'Queue'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, (/*@__PURE__*/$parcel$interopDefault($1LYxF)))(queues).reduce((acc, [queueId, queue])=>{
        // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
        const maybeManualSorting = $f550955e1d0fb70f$export$b0fb563b02669fb1(queueId);
        const newQueue = $f550955e1d0fb70f$export$bdc8ae2ac7632444(queue, maybeManualSorting);
        acc[queueId] = newQueue;
        return acc;
    }, {});
const $f550955e1d0fb70f$export$406ba23a25949900 = (currentQueueId, queues)=>{
    const updatedQueues = $f550955e1d0fb70f$var$addSortingToQueuesInternal(currentQueueId, queues);
    const currentQueueIdString = (0, $aNBkj.fromQueueId)(currentQueueId).toString();
    if (!updatedQueues[currentQueueIdString]) return {
        queues: updatedQueues
    };
    const manualSortColumn = updatedQueues[currentQueueIdString].columns.find((column)=>column.currentSorting);
    if (!manualSortColumn || !manualSortColumn.currentSorting) return {
        queues: updatedQueues
    };
    return {
        queues: updatedQueues,
        manualSorting: {
            sortedBy: manualSortColumn.id,
            sortOrder: manualSortColumn.currentSorting
        }
    };
};
// SHIELD-3415 Methods used by queue quality only
const $f550955e1d0fb70f$var$createQueueFromManualSorting = (queue, manualSorting)=>{
    const { columns: columns } = queue;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(columns, {
        id: manualSorting.sortedBy
    })) return {
        ...queue,
        columns: $f550955e1d0fb70f$var$applyManualSortingToColumns(columns, manualSorting),
        manualSorting: manualSorting
    };
    return queue;
};
const $f550955e1d0fb70f$export$e8964ed223410f32 = (queue, createAnalyticsEvent)=>$f550955e1d0fb70f$export$b0fb563b02669fb1((0, $aNBkj.fromQueueIdString)(queue.id), createAnalyticsEvent).cata(()=>queue, // @ts-expect-error - TS7006 - Parameter 'manualSorting' implicitly has an 'any' type.
    (manualSorting)=>{
        const sortedQueue = $f550955e1d0fb70f$var$createQueueFromManualSorting(queue, manualSorting);
        if (!sortedQueue.manualSorting) $f550955e1d0fb70f$export$27624a2b25e61084(sortedQueue.id);
        return sortedQueue;
    });

});
parcelRegister("1LYxF", function(module, exports) {

var $f0Qik = parcelRequire("f0Qik");

var $8nrDO = parcelRequire("8nrDO");
/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */ var $14a9249b93e30822$var$toPairs = $f0Qik($8nrDO);
module.exports = $14a9249b93e30822$var$toPairs;

});
parcelRegister("f0Qik", function(module, exports) {

var $4dCzV = parcelRequire("4dCzV");

var $fjnSB = parcelRequire("fjnSB");

var $c1eMI = parcelRequire("c1eMI");

var $2AxbH = parcelRequire("2AxbH");
/** `Object#toString` result references. */ var $aedf6bba724c18f3$var$mapTag = '[object Map]', $aedf6bba724c18f3$var$setTag = '[object Set]';
/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */ function $aedf6bba724c18f3$var$createToPairs(keysFunc) {
    return function(object) {
        var tag = $fjnSB(object);
        if (tag == $aedf6bba724c18f3$var$mapTag) return $c1eMI(object);
        if (tag == $aedf6bba724c18f3$var$setTag) return $2AxbH(object);
        return $4dCzV(object, keysFunc(object));
    };
}
module.exports = $aedf6bba724c18f3$var$createToPairs;

});
parcelRegister("4dCzV", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");
/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */ function $31264d32be0bf953$var$baseToPairs(object, props) {
    return $kJvGp(props, function(key) {
        return [
            key,
            object[key]
        ];
    });
}
module.exports = $31264d32be0bf953$var$baseToPairs;

});

parcelRegister("2AxbH", function(module, exports) {
/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */ function $1e28aff43f3b3e8e$var$setToPairs(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = [
            value,
            value
        ];
    });
    return result;
}
module.exports = $1e28aff43f3b3e8e$var$setToPairs;

});




parcelRegister("b7YH5", function(module, exports) {

$parcel$export(module.exports, "storeIssuesInLocalStorage", () => $ab2a05af3904e483$export$265b10942ef9ca4d);
$parcel$export(module.exports, "maybeIssuesInLocalStorage", () => $ab2a05af3904e483$export$889a3e4f0169c0d7);
$parcel$export(module.exports, "getIssuesInLocalStorage", () => $ab2a05af3904e483$export$a260c6806177a9f6);

var $iVIEg = parcelRequire("iVIEg");

var $hTLlD = parcelRequire("hTLlD");

var $7Oh8q = parcelRequire("7Oh8q");

var $3JafE = parcelRequire("3JafE");

var $6iz4v = parcelRequire("6iz4v");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");

var $7QneT = parcelRequire("7QneT");

var $8Obc6 = parcelRequire("8Obc6");

var $aNBkj = parcelRequire("aNBkj");

var $kdPoh = parcelRequire("kdPoh");

var $a2MDL = parcelRequire("a2MDL");

var $iUdsz = parcelRequire("iUdsz");
const $ab2a05af3904e483$var$ISSUES_KEY = 'issues';
const $ab2a05af3904e483$var$LOCAL_STORAGE_ANALYTICS_KEY = 'agent-view.issuelist.local-storage.status';
const $ab2a05af3904e483$var$getLocalStorageData = (queueId)=>(0, $7Oh8q.Maybe).fromNull((0, $a2MDL.getFromLocalStorage)(`${$ab2a05af3904e483$var$ISSUES_KEY}_${(0, $aNBkj.fromQueueId)(queueId)}`));
const $ab2a05af3904e483$var$localStorageMatchesIssueListResponse = (localStorage, issueListResponse, jql, sortedBy, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
sortOrder)=>(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(localStorage.jql, jql) && (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(localStorage.issueListResponse.issueHash, issueListResponse.issueHash) && (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(localStorage.issueListResponse.columns, issueListResponse.columns) && (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(localStorage.sortedBy, sortedBy) && (!sortedBy || (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(localStorage.sortOrder, sortOrder));
const $ab2a05af3904e483$export$265b10942ef9ca4d = (issueListResponse, jql, queueId, sortedBy, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
sortOrder, isUpdate, createAnalyticsEvent)=>{
    if (!isUpdate) {
        const localStorageData = $ab2a05af3904e483$var$getLocalStorageData(queueId);
        const hasData = localStorageData.isSome();
        const hasLatestData = localStorageData.cata(()=>false, // @ts-expect-error - TS7006 - Parameter 'localStorage' implicitly has an 'any' type.
        (localStorage)=>$ab2a05af3904e483$var$localStorageMatchesIssueListResponse(localStorage, issueListResponse, jql, sortedBy, sortOrder));
        // remove outdated analytics event with FF cleanup `view_queues_local_storage_data_updated`
        (0, $7QneT.default)($ab2a05af3904e483$var$LOCAL_STORAGE_ANALYTICS_KEY, {
            hasData: hasData,
            hasLatestData: hasLatestData
        });
        const localStorageFeatureGate = (0, $eI5EY.fg)('view_queues_local_storage_data_updated');
        if (createAnalyticsEvent && localStorageFeatureGate) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'viewQueuesLocalStorageData updated', {
            hasData: hasData,
            hasLatestData: hasLatestData
        });
    }
    (0, $a2MDL.setInLocalStorage)(`${$ab2a05af3904e483$var$ISSUES_KEY}_${(0, $aNBkj.fromQueueId)(queueId)}`, {
        jql: jql,
        issueListResponse: issueListResponse,
        jsonColumns: (0, $8Obc6.getFieldTypesEligibleForJsonData)(),
        sortedBy: sortedBy,
        sortOrder: sortOrder
    });
};
const $ab2a05af3904e483$var$localStorageMatchesStore = (localStorage, jql, columns, columnTypesAsJson, sortedBy, sortOrder)=>(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(localStorage.jql, jql) && (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))((0, $kdPoh.transformColumns)(localStorage.issueListResponse.columns), columns) && (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(localStorage.jsonColumns, columnTypesAsJson).length === 0 && (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(localStorage.sortedBy, sortedBy) && (!sortedBy || (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(localStorage.sortOrder, sortOrder));
const $ab2a05af3904e483$var$maybeIssuesInLocalStorageInternal = (queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder)=>{
    try {
        return $ab2a05af3904e483$var$getLocalStorageData(queueId)// @ts-expect-error - TS7006 - Parameter 'localStorage' implicitly has an 'any' type.
        .map((localStorage)=>{
            if ($ab2a05af3904e483$var$localStorageMatchesStore(localStorage, jql, columns, columnTypesAsJson, sortedBy, sortOrder)) {
                (0, $6iz4v.setMark)('jsd.performance.profile.queues.localstorage.received');
                return (0, $7Oh8q.Maybe).Some((0, $iUdsz.default)(localStorage.issueListResponse, (0, $aNBkj.LOCAL_STORAGE_SOURCE), filterQuery !== null, false));
            }
            return (0, $7Oh8q.Maybe).None();
        }).orSome((0, $7Oh8q.Maybe).None());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        return (0, $7Oh8q.Maybe).None();
    }
};
const $ab2a05af3904e483$export$889a3e4f0169c0d7 = (queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder)=>{
    const maybeIssueList = $ab2a05af3904e483$var$maybeIssuesInLocalStorageInternal(queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder);
    return maybeIssueList;
};
const $ab2a05af3904e483$export$a260c6806177a9f6 = (queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder)=>$ab2a05af3904e483$export$889a3e4f0169c0d7(queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder).cata((0, $3JafE.Observable).empty, (0, $3JafE.Observable).of);

});
parcelRegister("7QneT", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f8478a69a2d271$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getAgentViewMarks", () => $37f8478a69a2d271$export$551d840952c7afcf);

var $illlw = parcelRequire("illlw");

var $6iz4v = parcelRequire("6iz4v");

var $5yh8X = parcelRequire("5yh8X");

var $1cNJ6 = parcelRequire("1cNJ6");
const $37f8478a69a2d271$var$PREFIX = 'servicedesk.queues';
/**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ const $37f8478a69a2d271$var$triggerAnalyticsEvent = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $37f8478a69a2d271$var$triggerAnalyticsFunction = $37f8478a69a2d271$var$triggerAnalyticsEvent($37f8478a69a2d271$var$PREFIX);
var /**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$37f8478a69a2d271$export$2e2bcd8739ae039 = (eventNameSuffix, data)=>{
    $37f8478a69a2d271$var$triggerAnalyticsFunction(eventNameSuffix, data);
};
const $37f8478a69a2d271$var$getName = (mark)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(mark, 'name', undefined);
const $37f8478a69a2d271$export$551d840952c7afcf = ()=>[
        (0, $5yh8X.appBundleReadyMark),
        (0, $5yh8X.prefetchApiReadyMark),
        $37f8478a69a2d271$var$getName((0, $6iz4v.getMark)('jsd.performance.profile.queues.issuetable.mount')),
        $37f8478a69a2d271$var$getName((0, $6iz4v.getMark)('jsd.performance.profile.queues.firstfield.render')),
        $37f8478a69a2d271$var$getName((0, $6iz4v.getMark)('jsd.performance.profile.queues.issues.loaded')),
        $37f8478a69a2d271$var$getName((0, $6iz4v.getMark)('jsd.performance.profile.queues.localstorage.received'))
    ].filter(Boolean).map((0, $1cNJ6.getPrefixedMarkName));

});

parcelRegister("iUdsz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba844cdd2cf6d454$export$2e2bcd8739ae039);

var $kdPoh = parcelRequire("kdPoh");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ba844cdd2cf6d454$export$2e2bcd8739ae039 = (issueListResponse, source, isFilterRequested, isFiltered)=>({
        issues: (0, $kdPoh.transformIssues)(issueListResponse.issues),
        issueHash: issueListResponse.issueHash,
        totalCount: issueListResponse.total,
        columns: (0, $kdPoh.transformColumns)(issueListResponse.columns),
        isUsingDefaultSorting: issueListResponse.isUsingDefaultSorting,
        source: source,
        isFilterRequested: isFilterRequested,
        isFiltered: isFiltered
    });

});


parcelRegister("cxLLZ", function(module, exports) {

$parcel$export(module.exports, "sendIssuelistStalenessAnalytics", () => $f2137f8fcd480cb1$export$63318741cbb194f3);

var $6rW04 = parcelRequire("6rW04");

var $3DOEL = parcelRequire("3DOEL");
const $f2137f8fcd480cb1$var$STALENESS_THRESHOLD_FOR_FETCH = 3600000;
const $f2137f8fcd480cb1$var$STALENESS_THRESHOLD_FOR_UPDATE = 180000;
// @ts-expect-error - TS7006 - Parameter 'payload' implicitly has an 'any' type.
const $f2137f8fcd480cb1$var$fireManualOperationalAnalytics = (payload)=>(0, $3DOEL.getAnalyticsWebClient)().getInstance().sendOperationalEvent(payload);
const $f2137f8fcd480cb1$export$63318741cbb194f3 = (result, isUpdate)=>{
    const { metadata: metadata } = result;
    const currentTimeInMs = Date.now();
    const delayInMs = currentTimeInMs - metadata.lastUpdatedTimeInMs;
    const thresholdInMs = isUpdate ? $f2137f8fcd480cb1$var$STALENESS_THRESHOLD_FOR_UPDATE : $f2137f8fcd480cb1$var$STALENESS_THRESHOLD_FOR_FETCH;
    const jiraShard = (0, $6rW04.default)('ajs-shard') || '';
    $f2137f8fcd480cb1$var$fireManualOperationalAnalytics({
        source: 'viewQueueScreen',
        actionSubject: 'issuelist',
        action: isUpdate ? 'updated' : 'fetched',
        attributes: {
            issuelistStale: delayInMs > thresholdInMs,
            delayInMs: delayInMs,
            currentTimeInMs: currentTimeInMs,
            thresholdInMs: thresholdInMs,
            browserTabVisibilityState: document.visibilityState,
            jiraShard: jiraShard,
            ...metadata
        }
    });
};

});


parcelRegister("03V54", function(module, exports) {

$parcel$export(module.exports, "unsetIsInitialLoad", () => $c251df387a37b9b7$export$2fa696454aa7ac86);
$parcel$export(module.exports, "default", () => $c251df387a37b9b7$export$2e2bcd8739ae039);
const $c251df387a37b9b7$var$UNSET_IS_INITIAL_LOAD = 'state.actions.page.UNSET_IS_INITIAL_LOAD';
const $c251df387a37b9b7$export$2fa696454aa7ac86 = ()=>({
        type: $c251df387a37b9b7$var$UNSET_IS_INITIAL_LOAD
    });
const $c251df387a37b9b7$export$1650419e431d3ba3 = (state = null, action)=>{
    switch(action.type){
        case $c251df387a37b9b7$var$UNSET_IS_INITIAL_LOAD:
            return {
                ...state,
                isInitialLoading: false
            };
        default:
            return state || null;
    }
};
var $c251df387a37b9b7$export$2e2bcd8739ae039 = $c251df387a37b9b7$export$1650419e431d3ba3;

});


parcelRegister("gKZmz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4f10b0f6027b6dc$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $2bMHt = parcelRequire("2bMHt");

var $aNBkj = parcelRequire("aNBkj");

var $3nTcJ = parcelRequire("3nTcJ");

var $3ztB9 = parcelRequire("3ztB9");

var $3KNsL = parcelRequire("3KNsL");

var $1RqtY = parcelRequire("1RqtY");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d4f10b0f6027b6dc$export$2e2bcd8739ae039 = (push)=>(action$, store)=>action$.ofType((0, $3ztB9.OPEN_ISSUE)).switchMap(()=>{
            const state = store.getState();
            const projectKey = (0, $3nTcJ.getProjectKey)(state);
            const queueId = (0, $3KNsL.getQueueId)(state);
            const issueKey = (0, $1RqtY.getIssueKeyContext)(state);
            const category = (0, $3KNsL.getCategory)(state);
            if (issueKey != null && issueKey !== '') {
                if (push) return push((0, $2bMHt.getQueueIssueFragment)((0, $aNBkj.fromQueueId)(queueId), issueKey, category));
                // Fallback to push state navigator.
                return (0, $2bMHt.navigate)(// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                projectKey, (0, $2bMHt.getQueueIssueFragment)((0, $aNBkj.fromQueueId)(queueId), issueKey, category));
            }
            return (0, $3JafE.Observable).empty();
        });

});


parcelRegister("g12Bm", function(module, exports) {

$parcel$export(module.exports, "default", () => $465bcf91304b710f$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("dM0Xt");
parcelRequire("jyKN9");
parcelRequire("l5lul");
parcelRequire("8SBcT");
parcelRequire("8OtG5");
parcelRequire("3wBUP");

var $aNBkj = parcelRequire("aNBkj");


var $3ztB9 = parcelRequire("3ztB9");

var $bfxje = parcelRequire("bfxje");

var $8vuXb = parcelRequire("8vuXb");
const $465bcf91304b710f$export$68fb821c332f6a6 = 600000;
const $465bcf91304b710f$export$e6b4578b8d511a17 = 2000;
const $465bcf91304b710f$export$a2949fb7526d3e7a = 500;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$465bcf91304b710f$export$2e2bcd8739ae039 = (action$)=>{
    let isFailing = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isSuccess = (action)=>action.type === (0, $3ztB9.LOAD_ISSUES_SUCCESS) && action.payload.loadedIssuesResponse.source !== (0, $aNBkj.LOCAL_STORAGE_SOURCE);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isFirstPollFailure = (action)=>action.type === (0, $8vuXb.POLL_FAILURE) && isFailing === false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isFetchFailureInCachedQueue = (action)=>action.type === (0, $3ztB9.LOAD_ISSUES_FAILURE) && action.payload.source === (0, $34edc5e681269c4f$export$f162a928a40c7ab8) && !action.payload.isQueueEmpty;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isFetchFailureInEmptyQueue = (action)=>action.type === (0, $3ztB9.LOAD_ISSUES_FAILURE) && action.payload.source === (0, $34edc5e681269c4f$export$f162a928a40c7ab8) && action.payload.isQueueEmpty;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isFetchFailureInSortQueue = (action)=>action.type === (0, $3ztB9.LOAD_ISSUES_FAILURE) && action.payload.source === (0, $34edc5e681269c4f$export$2003e3fdddd4c35b);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const shouldShowWarning = (action)=>isFetchFailureInCachedQueue(action) || isFetchFailureInSortQueue(action) || isFirstPollFailure(action);
    // show error flag only in case of failure during scroll. Show warning in all other cases
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const shouldShowError = (action)=>action.type === (0, $3ztB9.LOAD_ISSUES_FAILURE) && action.payload.source === (0, $34edc5e681269c4f$export$d4d94a8c13e2df1d);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const shouldDismissAllFlags = (action)=>isSuccess(action) || isFetchFailureInEmptyQueue(action);
    return action$.ofType((0, $8vuXb.POLL_FAILURE), (0, $3ztB9.LOAD_ISSUES_SUCCESS), (0, $3ztB9.LOAD_ISSUES_FAILURE)).filter((action)=>shouldDismissAllFlags(action) || shouldShowWarning(action) || shouldShowError(action))// @ts-expect-error - TS2345: Types of property 'type' are incompatible. Type 'state.actions.update-metadata.DISMISS_ALL_FLAGS' is not assignable to type 'state.actions.update-metadata.DISPLAY_UNSUCCESSFUL_POLL_WARNING'.
    .switchMap((action)=>{
        if (shouldShowWarning(action) || shouldShowError(action)) {
            let returnObservable = (0, $3JafE.Observable).of((0, $8vuXb.displayUnsuccessfulPollWarningAction)());
            if (shouldShowError(action)) // @ts-expect-error - TS2322 - Type 'Observable<DisplayUnsuccessfulFetchErrorOnScrollAction | DismissWarningFlagAction>' is not assignable to type 'Observable<DisplayUnsuccessfulPollWarningAction>'.
            returnObservable = (0, $3JafE.Observable).concat((0, $3JafE.Observable).of((0, $8vuXb.dismissWarningFlagAction)()), (0, $3JafE.Observable).of((0, $bfxje.displayUnsuccessfulFetchErrorOnScrollAction)()).delay($465bcf91304b710f$export$a2949fb7526d3e7a));
            else if (isFetchFailureInCachedQueue(action)) // @ts-expect-error - TS2322 - Type 'Observable<DisplayUnsuccessfulFetchWarningAction>' is not assignable to type 'Observable<DisplayUnsuccessfulPollWarningAction>'.
            returnObservable = (0, $3JafE.Observable).of((0, $bfxje.displayUnsuccessfulFetchWarningAction)());
            return returnObservable.do(()=>{
                isFailing = true;
            }).delay(isFirstPollFailure(action) ? $465bcf91304b710f$export$68fb821c332f6a6 : $465bcf91304b710f$export$e6b4578b8d511a17);
        }
        if (shouldDismissAllFlags(action)) {
            isFailing = false;
            return (0, $3JafE.Observable).of((0, $8vuXb.dismissAllFlagsAction)());
        }
        return (0, $3JafE.Observable).empty();
    });
};

});
parcelRegister("bfxje", function(module, exports) {

$parcel$export(module.exports, "TABLE_CHANGED", () => $cd53db786749d194$export$68b362e6b981d575);
$parcel$export(module.exports, "tableChangedAction", () => $cd53db786749d194$export$3c516629fbb0d924);
$parcel$export(module.exports, "activeItemChangedAction", () => $cd53db786749d194$export$ce58420b2705f9ee);
$parcel$export(module.exports, "activeItemRemovedAction", () => $cd53db786749d194$export$42120e4638639b68);
$parcel$export(module.exports, "PAGE_CHANGED", () => $cd53db786749d194$export$e09b596b5ad52fee);
$parcel$export(module.exports, "pageChangedAction", () => $cd53db786749d194$export$ef479dcaff4dd067);
$parcel$export(module.exports, "SORT_ORDER_CHANGED", () => $cd53db786749d194$export$25e584dfc9e3eff4);
$parcel$export(module.exports, "sortOrderChangedAction", () => $cd53db786749d194$export$6053015c901f4a6f);
$parcel$export(module.exports, "SORT_ORDER_OPTIMISTIC_UPDATE", () => $cd53db786749d194$export$acc4e88a28a7b0a0);
$parcel$export(module.exports, "sortOrderOptimisticUpdateAction", () => $cd53db786749d194$export$fc03e6e4f23c5a8f);
$parcel$export(module.exports, "RESET_SORT_ORDER", () => $cd53db786749d194$export$2f4dfac96c2f056a);
$parcel$export(module.exports, "resetSortOrderAction", () => $cd53db786749d194$export$203744a3e48fd32);
$parcel$export(module.exports, "TOGGLE_QUEUE_HEADER", () => $cd53db786749d194$export$4ee6cf3ac95ffd6f);
$parcel$export(module.exports, "toggleQueueHeaderAction", () => $cd53db786749d194$export$246f86636f1800cd);
$parcel$export(module.exports, "FETCH_ISSUE_DATA_ONSCROLL", () => $cd53db786749d194$export$5b6c833dfdf472fa);
$parcel$export(module.exports, "fetchIssueDataOnScrollAction", () => $cd53db786749d194$export$1ebcd0c4bc8d1a17);
$parcel$export(module.exports, "DISPLAY_UNSUCCESSFUL_FETCH_WARNING", () => $cd53db786749d194$export$b01127fa720badfd);
$parcel$export(module.exports, "displayUnsuccessfulFetchWarningAction", () => $cd53db786749d194$export$533da0160b901b24);
$parcel$export(module.exports, "DISPLAY_UNSUCCESSFUL_FETCH_ERROR", () => $cd53db786749d194$export$9288a47530ff1e41);
$parcel$export(module.exports, "displayUnsuccessfulFetchErrorOnScrollAction", () => $cd53db786749d194$export$9af7482c09c5cf94);
const $cd53db786749d194$export$68b362e6b981d575 = 'state.actions.table.TABLE_CHANGED';
const $cd53db786749d194$export$3c516629fbb0d924 = (analyticsEvent)=>({
        type: $cd53db786749d194$export$68b362e6b981d575,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $cd53db786749d194$export$bf878f94e95fcc5d = 'state.actions.table.ACTIVE_ITEM_CHANGED';
const $cd53db786749d194$export$ce58420b2705f9ee = (rowId, colId)=>({
        type: $cd53db786749d194$export$bf878f94e95fcc5d,
        payload: {
            rowId: rowId,
            colId: colId
        }
    });
const $cd53db786749d194$export$dff3d0f13dc2a535 = 'state.actions.table.ACTIVE_ITEM_REMOVED';
const $cd53db786749d194$export$42120e4638639b68 = ()=>({
        type: $cd53db786749d194$export$dff3d0f13dc2a535
    });
const $cd53db786749d194$export$e09b596b5ad52fee = 'state.actions.table.PAGE_CHANGED';
const $cd53db786749d194$export$ef479dcaff4dd067 = (currentPage)=>({
        type: $cd53db786749d194$export$e09b596b5ad52fee,
        payload: {
            currentPage: currentPage
        }
    });
const $cd53db786749d194$export$25e584dfc9e3eff4 = 'state.actions.table.SORT_ORDER_CHANGED';
const $cd53db786749d194$export$6053015c901f4a6f = (sortedBy, sortOrder)=>({
        type: $cd53db786749d194$export$25e584dfc9e3eff4,
        payload: {
            sortedBy: sortedBy,
            sortOrder: sortOrder
        }
    });
const $cd53db786749d194$export$acc4e88a28a7b0a0 = 'state.actions.table.SORT_ORDER_OPTIMISTIC_UPDATE';
const $cd53db786749d194$export$fc03e6e4f23c5a8f = (queueId, sortedBy, sortOrder)=>({
        type: $cd53db786749d194$export$acc4e88a28a7b0a0,
        payload: {
            queueId: queueId,
            sortedBy: sortedBy,
            sortOrder: sortOrder
        }
    });
const $cd53db786749d194$export$2f4dfac96c2f056a = 'state.actions.table.RESET_SORT_ORDER';
const $cd53db786749d194$export$203744a3e48fd32 = ()=>({
        type: $cd53db786749d194$export$2f4dfac96c2f056a
    });
const $cd53db786749d194$export$4ee6cf3ac95ffd6f = 'state.actions.table.TOGGLE_QUEUE_HEADER';
const $cd53db786749d194$export$246f86636f1800cd = (scrollDirection)=>({
        type: $cd53db786749d194$export$4ee6cf3ac95ffd6f,
        payload: scrollDirection
    });
const $cd53db786749d194$export$5b6c833dfdf472fa = 'state.actions.table.FETCH_ISSUE_DATA_ONSCROLL';
const $cd53db786749d194$export$1ebcd0c4bc8d1a17 = (startIndex)=>({
        type: $cd53db786749d194$export$5b6c833dfdf472fa,
        payload: startIndex
    });
const $cd53db786749d194$export$b01127fa720badfd = 'state.actions.table.DISPLAY_UNSUCCESSFUL_FETCH_WARNING';
const $cd53db786749d194$export$533da0160b901b24 = ()=>({
        type: $cd53db786749d194$export$b01127fa720badfd
    });
const $cd53db786749d194$export$9288a47530ff1e41 = 'state.actions.table.DISPLAY_UNSUCCESSFUL_FETCH_ERROR';
const $cd53db786749d194$export$9af7482c09c5cf94 = ()=>({
        type: $cd53db786749d194$export$9288a47530ff1e41
    });

});


parcelRegister("hpSOY", function(module, exports) {

$parcel$export(module.exports, "default", () => $381404b46125c1b8$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $i5lw4 = parcelRequire("i5lw4");

var $coyKE = parcelRequire("coyKE");

var $1ABct = parcelRequire("1ABct");
var // @ts-expect-error - TS2345: Type 'unknown' is not assignable to type 'Action'.
$381404b46125c1b8$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $coyKE.default), (0, $1ABct.default), (0, $i5lw4.default));

});
parcelRegister("i5lw4", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ae9c299aceff70f$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("cK7Id");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");


var $3ztB9 = parcelRequire("3ztB9");

var $9mlBv = parcelRequire("9mlBv");

var $3KNsL = parcelRequire("3KNsL");

var $1RqtY = parcelRequire("1RqtY");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$4ae9c299aceff70f$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $9mlBv.CHANGE_VISIBILITY)).switchMap((action)=>{
        const state = store.getState();
        const newVisibility = action.payload.isQueueVisible;
        if ((0, $1RqtY.isQueueVisible)(state) === newVisibility) return (0, $3JafE.Observable).of();
        const result = (0, $3JafE.Observable).of((0, $9mlBv.setQueueVisibilityAction)(newVisibility));
        if (newVisibility) return result.concat((0, $3JafE.Observable).of((0, $3ztB9.loadIssuesAction)((0, $3KNsL.getFetchStartIndex)(state), (0, $34edc5e681269c4f$export$3de6d8bdd297654b))));
        return result;
    });

});
parcelRegister("9mlBv", function(module, exports) {

$parcel$export(module.exports, "SET_QUEUE_VISIBILITY", () => $956b8c9e9f43545e$export$92fe62de9bdb5843);
$parcel$export(module.exports, "setQueueVisibilityAction", () => $956b8c9e9f43545e$export$64da69d76b8c2108);
$parcel$export(module.exports, "CHANGE_VISIBILITY", () => $956b8c9e9f43545e$export$9c635dbaffb42239);
$parcel$export(module.exports, "changeVisibilityAction", () => $956b8c9e9f43545e$export$dcdfcd96c3c9f5d1);
$parcel$export(module.exports, "RESET_STATE", () => $956b8c9e9f43545e$export$7431817582ed8a25);
$parcel$export(module.exports, "resetStateAction", () => $956b8c9e9f43545e$export$d6c39c41a445a29f);
$parcel$export(module.exports, "LOAD_PAGE_DATA", () => $956b8c9e9f43545e$export$1b8361138f3b24e8);
$parcel$export(module.exports, "loadPageDataAction", () => $956b8c9e9f43545e$export$68ce54e2208e7a36);
$parcel$export(module.exports, "RELOAD_PAGE_DATA", () => $956b8c9e9f43545e$export$54fb7345a7b2e0f3);
$parcel$export(module.exports, "reloadPageDataAction", () => $956b8c9e9f43545e$export$9455bc428956d0f);
$parcel$export(module.exports, "LOAD_PAGE_DATA_SUCCESS", () => $956b8c9e9f43545e$export$6fd4caf8424e356b);
$parcel$export(module.exports, "loadPageDataSuccessAction", () => $956b8c9e9f43545e$export$308c96ca263cb52);
$parcel$export(module.exports, "LOAD_PAGE_DATA_FAILURE", () => $956b8c9e9f43545e$export$65b7c02925f4c6d8);
$parcel$export(module.exports, "loadPageDataFailureAction", () => $956b8c9e9f43545e$export$3fbdb12567de364c);
$parcel$export(module.exports, "DISPLAY_QUEUES_ERROR_HEADER", () => $956b8c9e9f43545e$export$464be1c8e7c172ad);
$parcel$export(module.exports, "displayQueuesErrorHeaderAction", () => $956b8c9e9f43545e$export$da47c211f950cb59);
const $956b8c9e9f43545e$export$92fe62de9bdb5843 = 'state.actions.page.SET_QUEUE_VISIBILITY';
const $956b8c9e9f43545e$export$64da69d76b8c2108 = (isQueueVisible)=>({
        type: $956b8c9e9f43545e$export$92fe62de9bdb5843,
        payload: {
            isQueueVisible: isQueueVisible
        }
    });
const $956b8c9e9f43545e$export$9c635dbaffb42239 = 'state.actions.page.CHANGE_VISIBILITY';
const $956b8c9e9f43545e$export$dcdfcd96c3c9f5d1 = (isQueueVisible)=>({
        type: $956b8c9e9f43545e$export$9c635dbaffb42239,
        payload: {
            isQueueVisible: isQueueVisible
        }
    });
const $956b8c9e9f43545e$export$7431817582ed8a25 = 'state.actions.page.RESET_STATE';
const $956b8c9e9f43545e$export$d6c39c41a445a29f = (queueId)=>({
        type: $956b8c9e9f43545e$export$7431817582ed8a25,
        payload: {
            queueId: queueId
        }
    });
const $956b8c9e9f43545e$export$1b8361138f3b24e8 = 'state.actions.page.LOAD_PAGE_DATA';
const $956b8c9e9f43545e$export$68ce54e2208e7a36 = (queueId)=>({
        type: $956b8c9e9f43545e$export$1b8361138f3b24e8,
        payload: {
            queueId: queueId
        }
    });
const $956b8c9e9f43545e$export$54fb7345a7b2e0f3 = 'state.actions.page.RELOAD_PAGE_DATA';
const $956b8c9e9f43545e$export$9455bc428956d0f = (queueId)=>({
        type: $956b8c9e9f43545e$export$54fb7345a7b2e0f3,
        payload: {
            queueId: queueId
        }
    });
const $956b8c9e9f43545e$export$6fd4caf8424e356b = 'state.actions.page.LOAD_PAGE_DATA_SUCCESS';
const $956b8c9e9f43545e$export$308c96ca263cb52 = (queuesWithSorting)=>({
        type: $956b8c9e9f43545e$export$6fd4caf8424e356b,
        payload: {
            queuesWithSorting: queuesWithSorting
        }
    });
const $956b8c9e9f43545e$export$65b7c02925f4c6d8 = 'state.actions.page.LOAD_PAGE_DATA_FAILURE';
const $956b8c9e9f43545e$export$3fbdb12567de364c = (error, statusCode)=>({
        type: $956b8c9e9f43545e$export$65b7c02925f4c6d8,
        payload: {
            error: error,
            statusCode: statusCode
        }
    });
const $956b8c9e9f43545e$export$464be1c8e7c172ad = 'state.actions.page.DISPLAY_QUEUES_ERROR_HEADER';
const $956b8c9e9f43545e$export$da47c211f950cb59 = ()=>({
        type: $956b8c9e9f43545e$export$464be1c8e7c172ad
    });

});


parcelRegister("coyKE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9a56a2de86c766a$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("3wBUP");
parcelRequire("flmol");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");


var $gUIy6 = parcelRequire("gUIy6");

var $3ztB9 = parcelRequire("3ztB9");

var $9mlBv = parcelRequire("9mlBv");

var $iW0TR = parcelRequire("iW0TR");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a9a56a2de86c766a$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $9mlBv.LOAD_PAGE_DATA)).switchMap((action)=>{
        const state = store.getState();
        return (0, $gUIy6.default)(action.payload.queueId, state).flatMap((result)=>(0, $3JafE.Observable).of((0, $9mlBv.loadPageDataSuccessAction)(result), // @ts-expect-error - TS2769 - No overload matches this call.
            (0, $3ztB9.loadIssuesAction)((0, $iW0TR.getCurrentPageStartIndex)(state), (0, $34edc5e681269c4f$export$f162a928a40c7ab8)))).catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'opsPageLoad',
                    packageName: 'jiraServicedeskQueuesAgentView',
                    teamName: 'jsd-shield'
                },
                // @ts-expect-error - TS2345 - Argument of type 'ErrorResponse' is not assignable to parameter of type 'string'.
                error: new Error(error)
            });
            (0, $gUUjF.default).safeErrorWithoutCustomerData('servicedesk.queues.agent-view.ops.page.load', `[FD-3358] Error while trying to load page data: ${JSON.stringify(error.response.errors)}`);
            return (0, $3JafE.Observable).of((0, $9mlBv.loadPageDataFailureAction)(error.response, error.statusCode));
        });
    });

});
parcelRegister("gUIy6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d63c19d05d21417$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("cpH8E");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $kdPoh = parcelRequire("kdPoh");

var $3nTcJ = parcelRequire("3nTcJ");

var $19AyN = parcelRequire("19AyN");

var $bKTFQ = parcelRequire("bKTFQ");

var $7AwFA = parcelRequire("7AwFA");
const $2d63c19d05d21417$var$prefetcherTransformFunc = (queueId, prefetcherPageResponse)=>(0, $7AwFA.addSortingToQueues)(queueId, (0, $bKTFQ.pageToQueues)(prefetcherPageResponse.data.queues));
const $2d63c19d05d21417$var$pageResponseTransformFunc = (queueId)=>(pageResponse)=>(0, $7AwFA.addSortingToQueues)(queueId, (0, $bKTFQ.pageToQueues)(pageResponse.queues));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2d63c19d05d21417$export$2e2bcd8739ae039 = (queueId, state)=>{
    const prefetchedPagePromise = (0, $bKTFQ.getPrefetchedPagePromise)();
    if (prefetchedPagePromise.isSome()) return (0, $3JafE.Observable).fromPromise(prefetchedPagePromise.some()).map((data)=>{
        (0, $bKTFQ.unsetPrefetchedPagePromise)();
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'PrefetcherPageResponse'.
        return $2d63c19d05d21417$var$prefetcherTransformFunc(queueId, data);
    }).catch(()=>(0, $kdPoh.default)(// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        (0, $19AyN.default)((0, $3nTcJ.getProjectKey)(state), (0, $3nTcJ.getBaseUrl)(state)), $2d63c19d05d21417$var$pageResponseTransformFunc(queueId)));
    return (0, $kdPoh.default)(// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    (0, $19AyN.default)((0, $3nTcJ.getProjectKey)(state), (0, $3nTcJ.getBaseUrl)(state)), $2d63c19d05d21417$var$pageResponseTransformFunc(queueId));
};

});
parcelRegister("19AyN", function(module, exports) {

$parcel$export(module.exports, "default", () => $af82b431255f4385$export$2e2bcd8739ae039);

var $5SOXK = parcelRequire("5SOXK");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$af82b431255f4385$export$2e2bcd8739ae039 = (projectKey, baseUrl)=>(0, $5SOXK.fetchJson$)(`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues/page`, {
        method: 'GET'
    });

});

parcelRegister("bKTFQ", function(module, exports) {

$parcel$export(module.exports, "pageToQueues", () => $395dbcdcfb786dd5$export$8ada91ce992fa66f);
$parcel$export(module.exports, "getPrefetchedPagePromise", () => $395dbcdcfb786dd5$export$4906aa3ec3919ad9);
$parcel$export(module.exports, "unsetPrefetchedPagePromise", () => $395dbcdcfb786dd5$export$17bdd949b6a9952);
// @ts-expect-error - TS2305 - Module '"monet"' has no exported member 'MaybeType'.

var $7Oh8q = parcelRequire("7Oh8q");

var $aNBkj = parcelRequire("aNBkj");
const $395dbcdcfb786dd5$var$transformColumns = (responseColumns)=>responseColumns.map((responseColumn)=>{
        const column = {
            id: responseColumn.fieldId,
            title: responseColumn.title,
            fieldType: responseColumn.fieldType,
            sortable: responseColumn.sortable
        };
        if (responseColumn.sortOrder) return {
            ...column,
            currentSorting: responseColumn.sortOrder
        };
        return column;
    });
const $395dbcdcfb786dd5$export$8ada91ce992fa66f = (page)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    page.reduce((acc, queue)=>{
        acc[queue.id] = {
            id: (0, $aNBkj.toQueueId)(queue.id),
            name: queue.name,
            jql: queue.jql,
            completeJql: queue.completeJql,
            order: queue.order,
            columns: $395dbcdcfb786dd5$var$transformColumns(queue.columnsDetails),
            // British spelling from legacy Backend code
            isFavorite: queue.favourite
        };
        return acc;
    }, {});
const $395dbcdcfb786dd5$export$4906aa3ec3919ad9 = ()=>(0, $7Oh8q.Maybe).fromNull(window.JSD_QUEUES_PRELOAD_PROMISES && window.JSD_QUEUES_PRELOAD_PROMISES.queues);
const $395dbcdcfb786dd5$export$17bdd949b6a9952 = ()=>{
    if (window.JSD_QUEUES_PRELOAD_PROMISES) window.JSD_QUEUES_PRELOAD_PROMISES.queues = undefined;
};

});


parcelRegister("iW0TR", function(module, exports) {

$parcel$export(module.exports, "getCurrentPage", () => $d4d0d91697a07a6f$export$7945ba8eb1c827e6);
$parcel$export(module.exports, "getCurrentPageStartIndex", () => $d4d0d91697a07a6f$export$e4d555459a632790);
$parcel$export(module.exports, "getTotalPages", () => $d4d0d91697a07a6f$export$652b307566494a6);
$parcel$export(module.exports, "getIssueKeysForPage", () => $d4d0d91697a07a6f$export$c1360f0f194316c8);

var $df4Sl = parcelRequire("df4Sl");


var $8GAE5 = parcelRequire("8GAE5");

var $3KNsL = parcelRequire("3KNsL");

var $1RqtY = parcelRequire("1RqtY");
const $d4d0d91697a07a6f$var$LOADING_ROW_COUNT = 10;
const $d4d0d91697a07a6f$export$7107d372eaf3477f = (state)=>(0, $3KNsL.getQueuePageData)(state).pagination;
const $d4d0d91697a07a6f$export$7945ba8eb1c827e6 = (state)=>$d4d0d91697a07a6f$export$7107d372eaf3477f(state).currentPage;
const $d4d0d91697a07a6f$export$e4d555459a632790 = (state)=>($d4d0d91697a07a6f$export$7945ba8eb1c827e6(state) - 1) * (0, $6e1a998ae5fb6552$export$f88f58d1a4b2078b);
const $d4d0d91697a07a6f$export$652b307566494a6 = (state)=>Math.max(1, Math.ceil((0, $8GAE5.getIssueCount)(state) / (0, $6e1a998ae5fb6552$export$f88f58d1a4b2078b)));
const $d4d0d91697a07a6f$export$303dbf47f10892ce = (state)=>$d4d0d91697a07a6f$export$7945ba8eb1c827e6(state) * (0, $6e1a998ae5fb6552$export$f88f58d1a4b2078b) - 1;
const $d4d0d91697a07a6f$export$e81b7cdc3b6d6b1f = (state)=>{
    const maxPageEndIndex = $d4d0d91697a07a6f$export$303dbf47f10892ce(state);
    const minPageEndIndex = $d4d0d91697a07a6f$export$e4d555459a632790(state) - 1;
    return Math.min(Math.max((0, $8GAE5.getIssueCount)(state) - 1, minPageEndIndex), maxPageEndIndex);
};
const $d4d0d91697a07a6f$export$c1360f0f194316c8 = (0, $df4Sl.createSelector)((0, $8GAE5.getCollection), $d4d0d91697a07a6f$export$e4d555459a632790, $d4d0d91697a07a6f$export$e81b7cdc3b6d6b1f, (0, $1RqtY.isLoadingIssues), (issues, startIndex, endIndex, isLoading)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issueKeys = [];
    const isNewDataSet = isLoading && issues.length === 0;
    // If we are expecting data from a new source like a queue or a page.
    // If the collection has not been cleared we want to show
    // existing row until loading is complete
    if (isNewDataSet) {
        issueKeys.length = $d4d0d91697a07a6f$var$LOADING_ROW_COUNT;
        if (endIndex - startIndex + 1 === (0, $6e1a998ae5fb6552$export$f88f58d1a4b2078b)) issueKeys.length = (0, $6e1a998ae5fb6552$export$f88f58d1a4b2078b);
        return issueKeys;
    }
    issueKeys.length = endIndex - startIndex + 1;
    for(let i = startIndex; i <= endIndex; i += 1){
        const issue = issues[i];
        if (issue) issueKeys[i - startIndex] = issue.key;
    }
    return issueKeys;
});

});


parcelRegister("1ABct", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9635f4d9da099ba$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("3wBUP");

var $9mlBv = parcelRequire("9mlBv");

var $8vuXb = parcelRequire("8vuXb");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$a9635f4d9da099ba$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $9mlBv.RELOAD_PAGE_DATA)).switchMap((action)=>{
        const { queueId: queueId } = action.payload;
        return (0, $3JafE.Observable).of((0, $8vuXb.stopPollAction)(), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $9mlBv.resetStateAction)(queueId), (0, $9mlBv.loadPageDataAction)(queueId));
    });

});


parcelRegister("lwWKa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6571497cff8b7846$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("1NUMQ");
parcelRequire("8jBvP");
parcelRequire("iects");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $1JMwO = parcelRequire("1JMwO");

var $3JafE = parcelRequire("3JafE");


var $cZrQz = parcelRequire("cZrQz");

var $3ztB9 = parcelRequire("3ztB9");

var $hLmJ9 = parcelRequire("hLmJ9");

var $8vuXb = parcelRequire("8vuXb");

var $8UPn4 = parcelRequire("8UPn4");

var $3KNsL = parcelRequire("3KNsL");
const $6571497cff8b7846$var$INITIAL_POLLING_INTERVAL = 5000;
const $6571497cff8b7846$export$8201d195ec654b2c = 60000;
const $6571497cff8b7846$export$acdfd55989a32c36 = 2000;
const $6571497cff8b7846$var$BROWSER_TAB_VISIBLE_STATE = 'visible';
const $6571497cff8b7846$var$getInterval = (initialInterval)=>{
    if (document.visibilityState !== $6571497cff8b7846$var$BROWSER_TAB_VISIBLE_STATE) return $6571497cff8b7846$export$acdfd55989a32c36;
    return initialInterval;
};
const $6571497cff8b7846$var$getNextInterval = (interval)=>{
    const nextInterval = interval * 1.1;
    return Math.min($6571497cff8b7846$export$8201d195ec654b2c, nextInterval);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6571497cff8b7846$export$2e2bcd8739ae039 = (initialInterval = $6571497cff8b7846$var$INITIAL_POLLING_INTERVAL, scheduler)=>(action$, store)=>{
        let isShutdown = false;
        return action$.ofType((0, $hLmJ9.SHUTDOWN), (0, $8vuXb.STOP_POLL), (0, $8vuXb.RESTART_POLL)).switchMap((action)=>{
            if (action.type === (0, $hLmJ9.SHUTDOWN) || isShutdown) {
                isShutdown = true;
                return (0, $3JafE.Observable).empty();
            }
            if (action.type === (0, $8vuXb.STOP_POLL)) return (0, $3JafE.Observable).empty();
            const pollingInterval$ = new (0, $1JMwO.BehaviorSubject)($6571497cff8b7846$var$getInterval(initialInterval));
            return pollingInterval$.switchMap((interval)=>{
                let initialDelay = interval;
                if (action.payload?.skipInitialDelay) initialDelay = 0;
                return (0, $3JafE.Observable).timer(initialDelay, interval, scheduler).switchMap(()=>(0, $3JafE.Observable).of(interval));
            }).switchMap((interval)=>{
                const state = store.getState();
                // If browser tab is not visible, do nothing.
                if (document.visibilityState !== $6571497cff8b7846$var$BROWSER_TAB_VISIBLE_STATE) {
                    pollingInterval$.next($6571497cff8b7846$var$getInterval(initialInterval));
                    return (0, $3JafE.Observable).empty();
                }
                return (0, $cZrQz.default)(state).mergeMap((result)=>{
                    // going back to the original interval if there is new data
                    pollingInterval$.next($6571497cff8b7846$var$getInterval(initialInterval));
                    if ((0, $8UPn4.getIsCurrentDataFiltered)(state)) return (0, $3JafE.Observable).of((0, $8vuXb.pollSuccessAction)(result.projectStateHash));
                    return (0, $3JafE.Observable).of((0, $8vuXb.pollSuccessAction)(result.projectStateHash), // @ts-expect-error - TS2769 - No overload matches this call.
                    (0, $3ztB9.loadIssuesAction)((0, $3KNsL.getFetchStartIndex)(state), (0, $34edc5e681269c4f$export$fa4dae241333de34)));
                })// 304 returned by endpoint
                // @ts-expect-error - TS2345 - Argument of type '(error: ErrorResponse) => Observable<PollContentNotModifiedAction> | Observable<PollFailureAction>' is not assignable to parameter of type '(err: any, caught: Observable<PollSuccessAction>) => ObservableInput<PollContentNotModifiedAction>'.
                .catch((error)=>{
                    // going back to the original interval if there is new data
                    pollingInterval$.next($6571497cff8b7846$var$getNextInterval(interval));
                    if (error.statusCode === 304) return (0, $3JafE.Observable).of((0, $8vuXb.pollContentNotModifiedAction)());
                    return (0, $3JafE.Observable).of((0, $8vuXb.pollFailureAction)());
                });
            });
        });
    };

});
parcelRegister("cZrQz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d80efad0f5b9ea19$export$2e2bcd8739ae039);

var $kdPoh = parcelRequire("kdPoh");

var $3nTcJ = parcelRequire("3nTcJ");

var $8SLa2 = parcelRequire("8SLa2");

var $3s9hs = parcelRequire("3s9hs");
const $d80efad0f5b9ea19$var$transformFunction = (pollResponse)=>pollResponse;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d80efad0f5b9ea19$export$2e2bcd8739ae039 = (state)=>(0, $kdPoh.default)(// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    (0, $8SLa2.default)((0, $3nTcJ.getProjectKey)(state), (0, $3nTcJ.getBaseUrl)(state), (0, $3s9hs.getProjectStateHash)(state)), $d80efad0f5b9ea19$var$transformFunction);

});
parcelRegister("8SLa2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f65c016f766527b$export$2e2bcd8739ae039);

var $5SOXK = parcelRequire("5SOXK");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1f65c016f766527b$export$2e2bcd8739ae039 = (projectKey, baseUrl, projectStateHash)=>{
    const hashString = projectStateHash ? `?projectStateHash=${projectStateHash}` : '';
    return (0, $5SOXK.fetchJson$)(`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues/poll${hashString}`, {
        method: 'GET'
    });
};

});


parcelRegister("hLmJ9", function(module, exports) {

$parcel$export(module.exports, "SHUTDOWN", () => $962b5e3bb2ad0266$export$9d68ba11045ae7c3);
$parcel$export(module.exports, "shutdownAction", () => $962b5e3bb2ad0266$export$d45c0b180c9b57f7);
// SHUTDOWN
const $962b5e3bb2ad0266$export$9d68ba11045ae7c3 = 'state.actions.lifecycle.SHUTDOWN';
const $962b5e3bb2ad0266$export$d45c0b180c9b57f7 = ()=>({
        type: $962b5e3bb2ad0266$export$9d68ba11045ae7c3
    });

});


parcelRegister("fpcBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd6c1667e15b2c86$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $j3zgi = parcelRequire("j3zgi");

var $5hKCP = parcelRequire("5hKCP");

var $9lk0L = parcelRequire("9lk0L");

var $ePkRw = parcelRequire("ePkRw");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fd6c1667e15b2c86$export$2e2bcd8739ae039 = (push)=>// @ts-expect-error - TS2322: Type 'unknown' is not assignable to type 'Action'.
    (0, $bd1K7.combineEpics)((0, $9lk0L.default)(push), (0, $ePkRw.default)(push), (0, $5hKCP.default)(push), (0, $j3zgi.default));

});
parcelRegister("j3zgi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a70253809ef08d2$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("3wBUP");

var $MYW4e = parcelRequire("MYW4e");

var $3JafE = parcelRequire("3JafE");

var $eI5EY = parcelRequire("eI5EY");

var $8Obc6 = parcelRequire("8Obc6");


var $b7YH5 = parcelRequire("b7YH5");

var $7AwFA = parcelRequire("7AwFA");

var $ibkcv = parcelRequire("ibkcv");

var $8N2pO = parcelRequire("8N2pO");

var $3ztB9 = parcelRequire("3ztB9");

var $9mlBv = parcelRequire("9mlBv");

var $9CKPh = parcelRequire("9CKPh");

var $bfxje = parcelRequire("bfxje");

var $5sNW7 = parcelRequire("5sNW7");

var $3KNsL = parcelRequire("3KNsL");

var $1RqtY = parcelRequire("1RqtY");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7a70253809ef08d2$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $9CKPh.QUEUE_CHANGED)).switchMap((action)=>{
        const state = store.getState();
        const { queue: queue } = action.payload;
        let createAnalyticsEvent;
        if ((0, $eI5EY.fg)('view_queues_local_storage_data_updated')) createAnalyticsEvent = (0, $5sNW7.getCreateAnalyticsEvent)(state);
        const sortedQueue = (0, $7AwFA.createSortedQueue)(queue, createAnalyticsEvent);
        const queueId = sortedQueue.id;
        if ((0, $1RqtY.hasPageError)(state)) return (0, $3JafE.Observable).of((0, $9mlBv.reloadPageDataAction)(queueId));
        if (!(0, $3KNsL.isQueueMateriallyDifferent)(state, sortedQueue)) return (0, $3JafE.Observable).of((0, $9CKPh.setQueueAction)(sortedQueue));
        const columnTypesAsJson = (0, $8Obc6.getFieldTypesEligibleForJsonData)();
        const { columns: columns, jql: jql, manualSorting: manualSorting } = sortedQueue;
        const actions = [
            (0, $ibkcv.experienceTrackingResetAction)(),
            (0, $8N2pO.filterQueryChangedAction)(null),
            (0, $9CKPh.setQueueAction)(sortedQueue),
            (0, $bfxje.pageChangedAction)(1),
            (0, $3ztB9.loadIssuesAction)(0, (0, $34edc5e681269c4f$export$f162a928a40c7ab8), true)
        ];
        const sortedBy = manualSorting && manualSorting.sortedBy;
        const sortOrder = manualSorting && manualSorting.sortOrder;
        return (0, $b7YH5.maybeIssuesInLocalStorage)(queueId, jql, columns, columnTypesAsJson, null, sortedBy, sortOrder).cata(()=>(0, $3JafE.Observable).of((0, $MYW4e.batchActions)(actions)), // @ts-expect-error - TS7006 - Parameter 'issues' implicitly has an 'any' type.
        (issues)=>(0, $3JafE.Observable).of((0, $MYW4e.batchActions)([
                ...actions,
                (0, $3ztB9.loadIssuesSuccessAction)(issues, queueId, 0, (0, $34edc5e681269c4f$export$f162a928a40c7ab8))
            ])));
    });

});
parcelRegister("ibkcv", function(module, exports) {

$parcel$export(module.exports, "EXPERIENCE_TRACKING_RESET", () => $12e81148e9a507f3$export$70281a0b6f2c039e);
$parcel$export(module.exports, "experienceTrackingResetAction", () => $12e81148e9a507f3$export$ce671cb9c43406e2);
// EXPERIENCE_TRACKING_RESET
const $12e81148e9a507f3$export$70281a0b6f2c039e = 'state.actions.experience-tracking.EXPERIENCE_TRACKING_RESET';
const $12e81148e9a507f3$export$ce671cb9c43406e2 = ()=>({
        type: $12e81148e9a507f3$export$70281a0b6f2c039e
    });

});

parcelRegister("9CKPh", function(module, exports) {

$parcel$export(module.exports, "EDIT_QUEUE", () => $dd2ebce55fa74d54$export$e6f7be4f3096aeae);
$parcel$export(module.exports, "editQueueAction", () => $dd2ebce55fa74d54$export$f6652267a5390fe1);
$parcel$export(module.exports, "CLONE_QUEUE", () => $dd2ebce55fa74d54$export$83e90b00e7702db8);
$parcel$export(module.exports, "cloneQueueAction", () => $dd2ebce55fa74d54$export$1db711c2821ce3f4);
$parcel$export(module.exports, "QUEUE_CHANGED", () => $dd2ebce55fa74d54$export$6c2e1579a5716bb5);
$parcel$export(module.exports, "queueChangedAction", () => $dd2ebce55fa74d54$export$1e1b815e3dd544e);
$parcel$export(module.exports, "SET_QUEUE", () => $dd2ebce55fa74d54$export$45923f75df5860e7);
$parcel$export(module.exports, "setQueueAction", () => $dd2ebce55fa74d54$export$a22fe719d6fd366f);
const $dd2ebce55fa74d54$export$e6f7be4f3096aeae = 'state.actions.queue.EDIT_QUEUE';
const $dd2ebce55fa74d54$export$f6652267a5390fe1 = ()=>({
        type: $dd2ebce55fa74d54$export$e6f7be4f3096aeae
    });
const $dd2ebce55fa74d54$export$83e90b00e7702db8 = 'state.actions.queue.CLONE_QUEUE';
const $dd2ebce55fa74d54$export$1db711c2821ce3f4 = (category)=>({
        type: $dd2ebce55fa74d54$export$83e90b00e7702db8,
        payload: {
            category: category
        }
    });
const $dd2ebce55fa74d54$export$6c2e1579a5716bb5 = 'state.actions.queue.QUEUE_CHANGED';
const $dd2ebce55fa74d54$export$1e1b815e3dd544e = (queue)=>({
        type: $dd2ebce55fa74d54$export$6c2e1579a5716bb5,
        payload: {
            queue: queue
        }
    });
const $dd2ebce55fa74d54$export$45923f75df5860e7 = 'state.actions.queue.SET_QUEUE';
const $dd2ebce55fa74d54$export$a22fe719d6fd366f = (queue)=>({
        type: $dd2ebce55fa74d54$export$45923f75df5860e7,
        payload: {
            queue: queue
        }
    });

});


parcelRegister("5hKCP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5c7b5669789067e$export$2e2bcd8739ae039);
parcelRequire("3wBUP");

var $2bMHt = parcelRequire("2bMHt");

var $aNBkj = parcelRequire("aNBkj");

var $3nTcJ = parcelRequire("3nTcJ");

var $9CKPh = parcelRequire("9CKPh");

var $3KNsL = parcelRequire("3KNsL");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d5c7b5669789067e$export$2e2bcd8739ae039 = (push)=>(action$, store)=>action$.ofType((0, $9CKPh.CLONE_QUEUE)).switchMap((action)=>{
            const { payload: { category: category } } = action;
            const state = store.getState();
            const projectKey = (0, $3nTcJ.getProjectKey)(state);
            const queueId = (0, $3KNsL.getQueueId)(state);
            if (push) return push((0, $2bMHt.getCloneQueueFragment)((0, $aNBkj.fromQueueId)(queueId), category));
            // fallback to push state nav in case anything goes wrong.
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            return (0, $2bMHt.navigate)(projectKey, (0, $2bMHt.getCloneQueueFragment)((0, $aNBkj.fromQueueId)(queueId), category));
        });

});

parcelRegister("9lk0L", function(module, exports) {

$parcel$export(module.exports, "default", () => $a98cf7182a58f421$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $jUhyG = parcelRequire("jUhyG");

var $2bMHt = parcelRequire("2bMHt");

var $3nTcJ = parcelRequire("3nTcJ");

var $5czrO = parcelRequire("5czrO");

var $kBhD3 = parcelRequire("kBhD3");

var $3KNsL = parcelRequire("3KNsL");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a98cf7182a58f421$export$2e2bcd8739ae039 = (push)=>(action$, store)=>action$.ofType((0, $kBhD3.DELETE_QUEUE)).switchMap((action)=>{
            const state = store.getState();
            const { payload: { queueId: queueId, onDeleteComplete: onDeleteComplete }, meta: { analyticsEvent: analyticsEvent } } = action;
            const queueName = (0, $3KNsL.getQueueName)(state);
            const payload = {
                deleted: [
                    queueId
                ]
            };
            return (0, $5czrO.default)(payload, state).flatMap(()=>{
                const analyticsProperties = {
                    action: 'deleted',
                    containerType: 'project',
                    containerId: (0, $3nTcJ.getProjectId)(state).toString(),
                    objectType: 'queue',
                    objectId: queueId,
                    attributes: {
                        redesign: true
                    }
                };
                // @ts-expect-error TS2345 | TS2345 - Argument of type '{ action: string; containerType: string; containerId: string; objectType: string; objectId: number; attributes: { redesign: boolean; }; }' is not assignable to parameter of type 'Readonly<Readonly<{ name?: string | undefined; containerId?: string | undefined; containers?: Containers | undefined; containerType?: string | undefined; objectType?: string | undefined; objectId?: string | undefined; readonly tags?: readonly string[] | undefined; attributes?: Readonly<...> | undefined; }> & { ...; }>'. | Argument of type '{ action: string; containerType: string; containerId: string; objectType: string; objectId: number; attributes: { redesign: boolean; }; }' is not assignable to parameter of type 'Readonly<Readonly<{ name?: string | undefined; containerId?: string | undefined; containers?: Containers | undefined; containerType?: string | undefined; objectType?: string | undefined; objectId?: string | undefined; readonly tags?: readonly string[] | undefined; attributes?: Readonly<...> | undefined; }> & { ...; }>'.
                (0, $jUhyG.fireTrackAnalytics)(analyticsEvent, analyticsProperties);
                onDeleteComplete(queueId);
                if (push) {
                    const category = (0, $3KNsL.getCategory)(state);
                    return push((0, $2bMHt.getQueueFragment)(undefined, category));
                }
                return (0, $3JafE.Observable).of((0, $kBhD3.setDeleteModalVisibilityAction)(false), // @ts-expect-error - TS2769 - No overload matches this call.
                (0, $kBhD3.setModalIsDeletingAction)(false));
            }).catch((error)=>(0, $3JafE.Observable).of((0, $kBhD3.setDeleteModalVisibilityAction)(false), // @ts-expect-error - TS2769 - No overload matches this call.
                (0, $kBhD3.deleteQueueFailureAction)(queueName, error.response), (0, $kBhD3.setModalIsDeletingAction)(false)));
        });

});
parcelRegister("5czrO", function(module, exports) {

$parcel$export(module.exports, "default", () => $18cdf18c661bd4e1$export$2e2bcd8739ae039);

var $kdPoh = parcelRequire("kdPoh");

var $3nTcJ = parcelRequire("3nTcJ");

var $apcFF = parcelRequire("apcFF");

var $bKTFQ = parcelRequire("bKTFQ");
const $18cdf18c661bd4e1$export$7adc0d541825d917 = (page)=>(0, $bKTFQ.pageToQueues)(page);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$18cdf18c661bd4e1$export$2e2bcd8739ae039 = (payload, state)=>// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    (0, $kdPoh.default)((0, $apcFF.default)((0, $3nTcJ.getProjectKey)(state), (0, $3nTcJ.getBaseUrl)(state), payload), $18cdf18c661bd4e1$export$7adc0d541825d917);

});
parcelRegister("apcFF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1146c0823c83e34$export$2e2bcd8739ae039);

var $5SOXK = parcelRequire("5SOXK");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c1146c0823c83e34$export$2e2bcd8739ae039 = (projectKey, baseUrl, payload)=>(0, $5SOXK.fetchJson$)(`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues`, {
        method: 'PUT',
        body: JSON.stringify(payload)
    });

});


parcelRegister("kBhD3", function(module, exports) {

$parcel$export(module.exports, "ONBOARDING_RESOLVED", () => $14cbe0c161e083ce$export$bc6edc14c190bba8);
$parcel$export(module.exports, "onboardingResolvedAction", () => $14cbe0c161e083ce$export$796732fe0ca79daa);
$parcel$export(module.exports, "SET_DELETE_MODAL_VISIBILITY", () => $14cbe0c161e083ce$export$f22130204a023293);
$parcel$export(module.exports, "setDeleteModalVisibilityAction", () => $14cbe0c161e083ce$export$190dceccabe571f5);
$parcel$export(module.exports, "SET_MODAL_IS_DELETING", () => $14cbe0c161e083ce$export$f95c039bb3ac7543);
$parcel$export(module.exports, "setModalIsDeletingAction", () => $14cbe0c161e083ce$export$99f97fd8f5eb3051);
$parcel$export(module.exports, "DELETE_QUEUE", () => $14cbe0c161e083ce$export$5ab05b9e296b458f);
$parcel$export(module.exports, "deleteQueueAction", () => $14cbe0c161e083ce$export$582ac7ef548f7ea3);
$parcel$export(module.exports, "DELETE_QUEUE_FAILURE", () => $14cbe0c161e083ce$export$c87901f527c6ecbf);
$parcel$export(module.exports, "deleteQueueFailureAction", () => $14cbe0c161e083ce$export$c9318fa931763930);
$parcel$export(module.exports, "SET_NAV_COLLAPSED", () => $14cbe0c161e083ce$export$a3657f3e279415da);
$parcel$export(module.exports, "setNavCollapsedAction", () => $14cbe0c161e083ce$export$24eece95a2a56eca);
$parcel$export(module.exports, "SET_ISSUE_KEY_CONTEXT", () => $14cbe0c161e083ce$export$ad460ac72e5ca5db);
$parcel$export(module.exports, "setIssueKeyContext", () => $14cbe0c161e083ce$export$e203161ddfaf33fa);
$parcel$export(module.exports, "SET_SIDEBAR_ISSUE_KEY", () => $14cbe0c161e083ce$export$8d3ef3d3f35457dd);
$parcel$export(module.exports, "setSidebarIssueKey", () => $14cbe0c161e083ce$export$31f0fd7bef8d8084);
$parcel$export(module.exports, "SET_SIDEBAR_REACT_KEY", () => $14cbe0c161e083ce$export$e61a8facd12c5b11);
$parcel$export(module.exports, "SET_SELECTED_ISSUE_KEYS", () => $14cbe0c161e083ce$export$ff2fe70017e5b8bb);
$parcel$export(module.exports, "setSelectedIssueKeys", () => $14cbe0c161e083ce$export$bf3ca5f3d49d924b);
$parcel$export(module.exports, "REFRESH_SIDEBAR_ISSUE_VIEW", () => $14cbe0c161e083ce$export$1801c47649c78d8c);
$parcel$export(module.exports, "refreshSidebarIssueView", () => $14cbe0c161e083ce$export$38079ab67858e297);
const $14cbe0c161e083ce$export$bc6edc14c190bba8 = 'state.actions.ui.ONBOARDING_RESOLVED';
const $14cbe0c161e083ce$export$796732fe0ca79daa = (onboardingResolved)=>({
        type: $14cbe0c161e083ce$export$bc6edc14c190bba8,
        payload: {
            onboardingResolved: onboardingResolved
        }
    });
const $14cbe0c161e083ce$export$f22130204a023293 = 'state.actions.ui.SET_DELETE_MODAL_VISIBILITY';
const $14cbe0c161e083ce$export$190dceccabe571f5 = (isVisible)=>({
        type: $14cbe0c161e083ce$export$f22130204a023293,
        payload: {
            isVisible: isVisible
        }
    });
const $14cbe0c161e083ce$export$f95c039bb3ac7543 = 'state.actions.ui.SET_MODAL_IS_DELETING';
const $14cbe0c161e083ce$export$99f97fd8f5eb3051 = (isDeleting)=>({
        type: $14cbe0c161e083ce$export$f95c039bb3ac7543,
        payload: {
            isDeleting: isDeleting
        }
    });
const $14cbe0c161e083ce$export$5ab05b9e296b458f = 'state.actions.ui.DELETE_QUEUE';
const $14cbe0c161e083ce$export$582ac7ef548f7ea3 = (queueId, onDeleteComplete, analyticsEvent)=>({
        type: $14cbe0c161e083ce$export$5ab05b9e296b458f,
        payload: {
            queueId: queueId,
            onDeleteComplete: onDeleteComplete
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $14cbe0c161e083ce$export$c87901f527c6ecbf = 'state.actions.ui.DELETE_QUEUE_FAILURE';
const $14cbe0c161e083ce$export$c9318fa931763930 = (queueName, error)=>({
        type: $14cbe0c161e083ce$export$c87901f527c6ecbf,
        payload: {
            error: error,
            queueName: queueName
        }
    });
const $14cbe0c161e083ce$export$a3657f3e279415da = 'state.actions.ui.SET_NAV_COLLAPSED';
const $14cbe0c161e083ce$export$24eece95a2a56eca = (isNavCollapsed)=>({
        type: $14cbe0c161e083ce$export$a3657f3e279415da,
        payload: {
            isNavCollapsed: isNavCollapsed
        }
    });
const $14cbe0c161e083ce$export$ad460ac72e5ca5db = 'state.actions.ui.SET_ISSUE_KEY_CONTEXT';
const $14cbe0c161e083ce$export$e203161ddfaf33fa = (issueKey)=>({
        type: $14cbe0c161e083ce$export$ad460ac72e5ca5db,
        payload: {
            issueKey: issueKey
        }
    });
const $14cbe0c161e083ce$export$8d3ef3d3f35457dd = 'state.actions.ui.SET_SIDEBAR_ISSUE_KEY';
const $14cbe0c161e083ce$export$31f0fd7bef8d8084 = (sidebarIssueKey)=>({
        type: $14cbe0c161e083ce$export$8d3ef3d3f35457dd,
        payload: {
            sidebarIssueKey: sidebarIssueKey
        }
    });
const $14cbe0c161e083ce$export$e61a8facd12c5b11 = 'state.actions.ui.SET_SIDEBAR_REACT_KEY';
const $14cbe0c161e083ce$export$f3d2a7eb1d1eb1db = (sidebarReactKey)=>({
        type: $14cbe0c161e083ce$export$e61a8facd12c5b11,
        payload: {
            sidebarReactKey: sidebarReactKey
        }
    });
const $14cbe0c161e083ce$export$ff2fe70017e5b8bb = 'state.actions.ui.SET_SELECTED_ISSUE_KEYS';
const $14cbe0c161e083ce$export$bf3ca5f3d49d924b = (selectedIssueKeys)=>({
        type: $14cbe0c161e083ce$export$ff2fe70017e5b8bb,
        payload: {
            selectedIssueKeys: selectedIssueKeys
        }
    });
const $14cbe0c161e083ce$export$1801c47649c78d8c = 'state.actions.ui.REFRESH_SIDEBAR_ISSUE_VIEW';
const $14cbe0c161e083ce$export$38079ab67858e297 = ({ issueKey: issueKey } = {})=>({
        type: $14cbe0c161e083ce$export$1801c47649c78d8c,
        payload: {
            issueKey: issueKey
        }
    });

});


parcelRegister("ePkRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f17c3afa827b177$export$2e2bcd8739ae039);
parcelRequire("3wBUP");

var $2bMHt = parcelRequire("2bMHt");

var $aNBkj = parcelRequire("aNBkj");

var $3nTcJ = parcelRequire("3nTcJ");

var $9CKPh = parcelRequire("9CKPh");

var $3KNsL = parcelRequire("3KNsL");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3f17c3afa827b177$export$2e2bcd8739ae039 = (push)=>(action$, store)=>action$.ofType((0, $9CKPh.EDIT_QUEUE)).switchMap(()=>{
            const state = store.getState();
            const projectKey = (0, $3nTcJ.getProjectKey)(state);
            const queueId = (0, $3KNsL.getQueueId)(state);
            const category = (0, $3KNsL.getCategory)(state);
            if (push) return push((0, $2bMHt.getEditQueueFragment)((0, $aNBkj.fromQueueId)(queueId), category));
            // fallback to push state nav in case anything goes wrong.
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            return (0, $2bMHt.navigate)(projectKey, (0, $2bMHt.getEditQueueFragment)((0, $aNBkj.fromQueueId)(queueId), category));
        });

});


parcelRegister("chIK6", function(module, exports) {

$parcel$export(module.exports, "default", () => $eea1ab3951c78d5e$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $2IspF = parcelRequire("2IspF");

var $3nTcJ = parcelRequire("3nTcJ");

var $1oAf3 = parcelRequire("1oAf3");

var $9mlBv = parcelRequire("9mlBv");

var $9CKPh = parcelRequire("9CKPh");

var $3KNsL = parcelRequire("3KNsL");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eea1ab3951c78d5e$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $9mlBv.LOAD_PAGE_DATA), (0, $9CKPh.QUEUE_CHANGED)).switchMap((action)=>{
        const { payload: payload, type: type } = action;
        const queueId = type === (0, $9mlBv.LOAD_PAGE_DATA) ? payload.queueId : payload.queue.id;
        const state = store.getState();
        const baseUrl = (0, $3nTcJ.getBaseUrl)(state);
        const projectKey = (0, $3nTcJ.getProjectKey)(state);
        if ((0, $3KNsL.isQueueTransient)(state)) return (0, $3JafE.Observable).empty();
        // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        return (0, $1oAf3.default)(baseUrl, projectKey, queueId).switchMap(()=>(0, $3JafE.Observable).empty()).catch((error)=>{
            (0, $2IspF.default).safeWarnWithoutCustomerData('servicedesk.queues.agent-view.ops.recent.add', `Failed to add recent queue - error: ${JSON.stringify(error)}`, {
                queueId: queueId
            });
            return (0, $3JafE.Observable).empty();
        });
    });

});
parcelRegister("1oAf3", function(module, exports) {

$parcel$export(module.exports, "default", () => $da22775e938df4a9$export$2e2bcd8739ae039);

var $5SOXK = parcelRequire("5SOXK");

var $aNBkj = parcelRequire("aNBkj");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$da22775e938df4a9$export$2e2bcd8739ae039 = (baseUrl, projectKey, queueId)=>(0, $5SOXK.fetchJson$)(`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues-history?queueId=${(0, $aNBkj.fromQueueId)(queueId)}`, {
        method: 'POST'
    });

});


parcelRegister("hXmQu", function(module, exports) {

$parcel$export(module.exports, "default", () => $13a116a27e8d4b5f$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("3wBUP");


var $3ztB9 = parcelRequire("3ztB9");

var $bfxje = parcelRequire("bfxje");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$13a116a27e8d4b5f$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $bfxje.FETCH_ISSUE_DATA_ONSCROLL)).switchMap((action)=>(0, $3JafE.Observable).of((0, $3ztB9.loadIssuesAction)(action.payload, (0, $34edc5e681269c4f$export$d4d94a8c13e2df1d))));

});

parcelRegister("e6X8V", function(module, exports) {

$parcel$export(module.exports, "default", () => $b91de8baf7bb4bac$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $9vMbP = parcelRequire("9vMbP");

var $20fPE = parcelRequire("20fPE");
var $b91de8baf7bb4bac$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $9vMbP.default), (0, $20fPE.default));

});
parcelRegister("9vMbP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4c8035fd80e0f2e$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");


var $3ztB9 = parcelRequire("3ztB9");

var $bfxje = parcelRequire("bfxje");

var $3KNsL = parcelRequire("3KNsL");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a4c8035fd80e0f2e$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $bfxje.SORT_ORDER_CHANGED)).switchMap((action)=>{
        const state = store.getState();
        const queueId = (0, $3KNsL.getQueueId)(state);
        const { sortedBy: sortedBy, sortOrder: sortOrder } = action.payload;
        return (0, $3JafE.Observable).of((0, $bfxje.sortOrderOptimisticUpdateAction)(queueId, sortedBy, sortOrder), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $3ztB9.loadIssuesAction)(0, (0, $34edc5e681269c4f$export$2003e3fdddd4c35b)));
    });

});

parcelRegister("20fPE", function(module, exports) {

$parcel$export(module.exports, "default", () => $71953384570a7003$export$2e2bcd8739ae039);
parcelRequire("flmol");


var $3ztB9 = parcelRequire("3ztB9");

var $bfxje = parcelRequire("bfxje");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$71953384570a7003$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $bfxje.RESET_SORT_ORDER)).map(()=>(0, $3ztB9.loadIssuesAction)(0, (0, $34edc5e681269c4f$export$2003e3fdddd4c35b)));

});


parcelRegister("6OKfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7220ae4cbf8aaca$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $jUhyG = parcelRequire("jUhyG");

var $aNBkj = parcelRequire("aNBkj");

var $3nTcJ = parcelRequire("3nTcJ");

var $bfxje = parcelRequire("bfxje");

var $8GAE5 = parcelRequire("8GAE5");

var $iW0TR = parcelRequire("iW0TR");

var $cip5U = parcelRequire("cip5U");

var $3KNsL = parcelRequire("3KNsL");

var $6ycyf = parcelRequire("6ycyf");

var $1RqtY = parcelRequire("1RqtY");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b7220ae4cbf8aaca$var$onTableChange = (state, analyticsEvent)=>{
    const queueId = (0, $3KNsL.getQueueId)(state);
    const issueKeys = (0, $iW0TR.getIssueKeysForPage)(state);
    const sortedBy = (0, $6ycyf.getSortedByColumn)(state);
    const sortOrder = (0, $6ycyf.getSortOrder)(state);
    const atlassianAccountId = (0, $3nTcJ.getAtlassianAccountId)(state);
    const issueStatusIdsCountsInQueue = (0, $8GAE5.getIssueStatusIdsCounts)(state);
    const numberOfIssuesAssignedToCurrentUser = (0, $8GAE5.getIssueCountByAssignee)(state, atlassianAccountId);
    !(0, $1RqtY.isLoadingIssues)(state) && (0, $jUhyG.fireTrackAnalytics)(analyticsEvent, {
        containerType: 'project',
        containerId: `${(0, $3nTcJ.getProjectId)(state)}`,
        action: 'viewed',
        objectType: 'queue',
        objectId: `${(0, $aNBkj.fromQueueId)(queueId)}`,
        actionSubjectId: `${(0, $aNBkj.fromQueueId)(queueId)}`,
        attributes: {
            isAdmin: (0, $3nTcJ.getIsAdmin)(state),
            isTransient: (0, $3KNsL.isQueueTransient)(state),
            numberOfIssuesDisplayed: issueKeys.length,
            numberOfColumnsDisplayed: (0, $3KNsL.getNumberOfColumns)(state),
            displayedColumnsInOrder: (0, $3KNsL.getAllFieldTypes)(state),
            sortedByColumnId: sortedBy,
            sortOrder: sortOrder,
            // store as a list of 1 to prevent amplitude creating too many attributes
            issueStatusIdsCountsInQueue: [
                issueStatusIdsCountsInQueue
            ],
            numberOfIssuesAssignedToCurrentUser: numberOfIssuesAssignedToCurrentUser,
            ...(0, $cip5U.isItsmProject)(state) ? {
                itsmPractices: (0, $cip5U.getEnabledPractices)(state)
            } : {}
        }
    });
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$b7220ae4cbf8aaca$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $bfxje.TABLE_CHANGED)).switchMap((action)=>{
        $b7220ae4cbf8aaca$var$onTableChange(store.getState(), action.meta.analyticsEvent);
        return (0, $3JafE.Observable).empty();
    });

});
parcelRegister("cip5U", function(module, exports) {

$parcel$export(module.exports, "getEnabledPractices", () => $44fe4480d523277a$export$8f33cbf43c24a6e7);
$parcel$export(module.exports, "isItsmProject", () => $44fe4480d523277a$export$90859dc8800b0a1b);

var $df4Sl = parcelRequire("df4Sl");

var $7GXrf = parcelRequire("7GXrf");

var $f1lMr = parcelRequire("f1lMr");

var $3i6VQ = parcelRequire("3i6VQ");

var $3KNsL = parcelRequire("3KNsL");
const $44fe4480d523277a$var$getProjectPractices = (state)=>(0, $3i6VQ.getPersisted)(state).practices;
const $44fe4480d523277a$export$8f33cbf43c24a6e7 = (0, $df4Sl.createSelector)((0, $3KNsL.getCategory), (category = (0, $f1lMr.NO_CATEGORY))=>category === (0, $f1lMr.NO_CATEGORY) ? [] : [
        category
    ]);
const $44fe4480d523277a$export$90859dc8800b0a1b = (0, $df4Sl.createSelector)($44fe4480d523277a$var$getProjectPractices, (practiceList)=>(0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))(practiceList, (0, $f1lMr.NO_CATEGORY)).length > 0);

});
parcelRegister("7GXrf", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $9eFtX = parcelRequire("9eFtX");

var $cRpul = parcelRequire("cRpul");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $599a8fe1eb632ef8$var$without = $9eFtX(function(array, values) {
    return $cRpul(array) ? $fa0Ox(array, values) : [];
});
module.exports = $599a8fe1eb632ef8$var$without;

});




parcelRegister("9pWLn", function(module, exports) {

$parcel$export(module.exports, "useSSRIssuesData", () => $b9f075816bbd91de$export$48d89bc2a863f675);

var $iZJHG = parcelRequire("iZJHG");

var $hRe6W = parcelRequire("hRe6W");
const $b9f075816bbd91de$export$48d89bc2a863f675 = (customContext)=>{
    const { data: data, error: error } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $hRe6W.issueListSsrResource), customContext);
    if (!data || error) return null;
    return data;
};

});

parcelRegister("23fNU", function(module, exports) {

$parcel$export(module.exports, "SEND_ANALYTIC_CREATOR", () => $df958dc9a1b531e2$export$2f4a111814bf0140);
$parcel$export(module.exports, "sendAnalyticCreatorAction", () => $df958dc9a1b531e2$export$632dfc648efd02eb);
const $df958dc9a1b531e2$export$2f4a111814bf0140 = 'state.actions.analytic.SEND_ANALYTIC_CREATOR';
const $df958dc9a1b531e2$export$632dfc648efd02eb = (createAnalyticsEvent)=>({
        type: $df958dc9a1b531e2$export$2f4a111814bf0140,
        payload: {
            createAnalyticsEvent: createAnalyticsEvent
        }
    });

});

parcelRegister("1GlEk", function(module, exports) {

$parcel$export(module.exports, "RESET_PROJECT_CONTEXT", () => $396b96eff75cd4be$export$dfc3064c33d1270a);
$parcel$export(module.exports, "resetProjectContextAction", () => $396b96eff75cd4be$export$6a8d4f70c30642d0);
const $396b96eff75cd4be$export$dfc3064c33d1270a = 'state.actions.page.RESET_PROJECT_CONTEXT';
const $396b96eff75cd4be$export$6a8d4f70c30642d0 = (projectContext)=>({
        type: $396b96eff75cd4be$export$dfc3064c33d1270a,
        payload: {
            projectContext: projectContext
        }
    });

});

parcelRegister("brVi3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e7275ed96e209d5$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $8esbL = parcelRequire("8esbL");

var $fQji7 = parcelRequire("fQji7");

var $hloYl = parcelRequire("hloYl");
const $3e7275ed96e209d5$var$combinedReducer = (0, $huRi7.combineReducers)({
    appProps: $8esbL.default,
    persisted: $fQji7.default,
    ui: $hloYl.default
});
var $3e7275ed96e209d5$export$2e2bcd8739ae039 = $3e7275ed96e209d5$var$combinedReducer;

});
parcelRegister("8esbL", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e151cd0129fd9b5$export$2e2bcd8739ae039);

var $1GlEk = parcelRequire("1GlEk");
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $7e151cd0129fd9b5$var$reducer = (state, action)=>{
    switch(action.type){
        case 0, $1GlEk.RESET_PROJECT_CONTEXT:
            return {
                ...state,
                ...action.payload.projectContext
            };
        default:
            {
                // @ts-expect-error - TS2322 - Type 'ResetProjectContextAction' is not assignable to type 'never'.
                const _exhaustiveCheck = action;
                return state || null;
            }
    }
};
var $7e151cd0129fd9b5$export$2e2bcd8739ae039 = $7e151cd0129fd9b5$var$reducer;

});

parcelRegister("fQji7", function(module, exports) {

$parcel$export(module.exports, "default", () => $985f4f8f61ee8c4f$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $5VfcS = parcelRequire("5VfcS");

var $7FkMH = parcelRequire("7FkMH");

var $itGpq = parcelRequire("itGpq");

var $YoJ7Y = parcelRequire("YoJ7Y");

var $bxFt3 = parcelRequire("bxFt3");

var $9qPJP = parcelRequire("9qPJP");

var $03V54 = parcelRequire("03V54");

var $9AIVO = parcelRequire("9AIVO");
const $985f4f8f61ee8c4f$var$combinedReducer = (0, $huRi7.combineReducers)({
    issues: $YoJ7Y.default,
    queue: $9qPJP.default,
    updateMetadata: $9AIVO.default,
    experienceTracking: $7FkMH.default,
    practices: $bxFt3.default,
    filter: $itGpq.default,
    analytic: $5VfcS.default,
    ssrIssuesData: $03V54.default
});
var $985f4f8f61ee8c4f$export$2e2bcd8739ae039 = $985f4f8f61ee8c4f$var$combinedReducer;

});
parcelRegister("5VfcS", function(module, exports) {

$parcel$export(module.exports, "default", () => $714401bcc1c97264$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $23fNU = parcelRequire("23fNU");

var $evCSf = parcelRequire("evCSf");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$714401bcc1c97264$export$2e2bcd8739ae039 = (state = (0, $evCSf.initialState), action)=>{
    switch(action.type){
        case 0, $23fNU.SEND_ANALYTIC_CREATOR:
            {
                const { createAnalyticsEvent: createAnalyticsEvent } = action.payload;
                return (0, $6HC1D.assoc)(state, 'createAnalyticsEvent', createAnalyticsEvent);
            }
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});
parcelRegister("evCSf", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $f487814bb8c45ec1$export$d4c72bab9d6cc13a);
const $f487814bb8c45ec1$export$d4c72bab9d6cc13a = {
    createAnalyticsEvent: undefined
};

});


parcelRegister("7FkMH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a83754d67386f7e8$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $eI5EY = parcelRequire("eI5EY");

var $aNBkj = parcelRequire("aNBkj");



var $ibkcv = parcelRequire("ibkcv");

var $3ztB9 = parcelRequire("3ztB9");

var $9mlBv = parcelRequire("9mlBv");
const $a83754d67386f7e8$var$initialExperienceTrackingState = {
    initialDataLoadStatus: (0, $749205be6d2f0e96$export$2fc553b73365b8c4),
    hasLoadedIssueDataFromCache: false
};
const $a83754d67386f7e8$var$ERROR_STATUS_CODE_ALLOWLIST = [
    403,
    401,
    429
];
// We don't want to cover all 400 errors because some might be a bug, in most cases issuelist shouldn't return 400.
const $a83754d67386f7e8$var$NON_EXPERIENCE_FAILURE_REASON_KEY = [
    'sd.issue.search.invalid.project',
    'Invalid category'
];
const $a83754d67386f7e8$var$isStatusCodeAnExperienceFailure = (statusCode)=>// This indicates that browser has no connectivity
    // @ts-expect-error - TS2345 - Argument of type 'number | undefined' is not assignable to parameter of type 'number'.
    Boolean(statusCode) && !$a83754d67386f7e8$var$ERROR_STATUS_CODE_ALLOWLIST.includes(statusCode);
const $a83754d67386f7e8$var$isProjectOrCategoryNotFound = (error, statusCode)=>statusCode === 400 && $a83754d67386f7e8$var$NON_EXPERIENCE_FAILURE_REASON_KEY.includes(error?.reasonKey);
const $a83754d67386f7e8$var$isAnExperienceFailure = (error, statusCode)=>$a83754d67386f7e8$var$isStatusCodeAnExperienceFailure(statusCode) && !$a83754d67386f7e8$var$isProjectOrCategoryNotFound(error, statusCode);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a83754d67386f7e8$export$2e2bcd8739ae039 = (state = $a83754d67386f7e8$var$initialExperienceTrackingState, action)=>{
    switch(action.type){
        case 0, $3ztB9.LOAD_ISSUES_SUCCESS:
            {
                let newStateChain = (0, $6HC1D.chain)(state);
                if (action.payload.loadedIssuesResponse.source === (0, $aNBkj.LOCAL_STORAGE_SOURCE)) newStateChain = newStateChain.assoc('hasLoadedIssueDataFromCache', true);
                else if (action.payload.source === (0, $34edc5e681269c4f$export$f162a928a40c7ab8)) // Do no set status to true if the payload is from localstorage, that doesn't count
                newStateChain = newStateChain.assoc('initialDataLoadStatus', (0, $749205be6d2f0e96$export$d3ab616c5a76689d));
                return newStateChain.value();
            }
        case 0, $3ztB9.LOAD_ISSUES_FAILURE:
            if (action.payload.source === (0, $34edc5e681269c4f$export$f162a928a40c7ab8)) {
                if ($a83754d67386f7e8$var$isAnExperienceFailure(action.payload.error, action.payload.statusCode)) {
                    if ((0, $eI5EY.fg)('adding-more-data-for-viewqueue-and-viewnav-event')) return {
                        ...state,
                        initialDataLoadStatus: (0, $749205be6d2f0e96$export$70ef9aa03c29b42b),
                        errorStatusCode: action.payload.statusCode,
                        errorMessages: action.payload.error?.errors,
                        errorKey: action.payload.error?.reasonKey,
                        traceId: action.payload.traceId
                    };
                    return {
                        ...state,
                        initialDataLoadStatus: (0, $749205be6d2f0e96$export$70ef9aa03c29b42b),
                        errorStatusCode: action.payload.statusCode
                    };
                }
                return (0, $6HC1D.assoc)(state, 'initialDataLoadStatus', (0, $749205be6d2f0e96$export$d3ab616c5a76689d));
            }
            return state;
        case 0, $9mlBv.LOAD_PAGE_DATA_FAILURE:
            if ($a83754d67386f7e8$var$isStatusCodeAnExperienceFailure(action.payload.statusCode)) return (0, $6HC1D.assoc)(state, 'initialDataLoadStatus', (0, $749205be6d2f0e96$export$70ef9aa03c29b42b));
            return state;
        case 0, $9mlBv.RESET_STATE:
        case 0, $ibkcv.EXPERIENCE_TRACKING_RESET:
            return $a83754d67386f7e8$var$initialExperienceTrackingState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
// pagination would be rendered if the queue has > 10K records.
// Used for Queue Header expand/collapse animation
const $749205be6d2f0e96$export$fdd30d204cbe80e6 = 200;
const $749205be6d2f0e96$export$2fc553b73365b8c4 = 'pending';
const $749205be6d2f0e96$export$70ef9aa03c29b42b = 'failed';
const $749205be6d2f0e96$export$d3ab616c5a76689d = 'succeeded';


parcelRegister("itGpq", function(module, exports) {

$parcel$export(module.exports, "default", () => $344728ec8fd277b4$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $8N2pO = parcelRequire("8N2pO");

var $3ztB9 = parcelRequire("3ztB9");

var $91ofX = parcelRequire("91ofX");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$344728ec8fd277b4$export$2e2bcd8739ae039 = (state = (0, $91ofX.initialState), action)=>{
    switch(action.type){
        case 0, $3ztB9.LOAD_ISSUES_SUCCESS:
            {
                const filtered = action.payload.loadedIssuesResponse.isFiltered;
                return (0, $6HC1D.chain)(state).assoc('isCurrentDataFiltered', filtered).assoc('isNewFilterQueryPending', false).value();
            }
        case 0, $8N2pO.FILTER_QUERY_CHANGED:
            {
                const { filterQuery: filterQuery } = action.payload;
                return (0, $6HC1D.assoc)(state, 'filterQuery', filterQuery);
            }
        case 0, $8N2pO.IS_NEW_FILTER_QUERY_PENDING:
            {
                const { isNewFilterQueryPending: isNewFilterQueryPending } = action.payload;
                return (0, $6HC1D.assoc)(state, 'isNewFilterQueryPending', isNewFilterQueryPending);
            }
        case 0, $8N2pO.IS_FILTER_FOCUSED:
            {
                const { isFilterFocused: isFilterFocused } = action.payload;
                return (0, $6HC1D.assoc)(state, 'isFilterFocused', isFilterFocused);
            }
        case 0, $8N2pO.IS_FILTER_FAILED:
            return (0, $6HC1D.chain)(state).assoc('isCurrentDataFiltered', true).assoc('isNewFilterQueryPending', false).value();
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("91ofX", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $c82fc670ccbd1bd1$export$d4c72bab9d6cc13a);
const $c82fc670ccbd1bd1$export$d4c72bab9d6cc13a = {
    filterQuery: null,
    isNewFilterQueryPending: false,
    isCurrentDataFiltered: false,
    isFilterFocused: false
};

});


parcelRegister("YoJ7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $de23cc2ccba30d73$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $hTLlD = parcelRequire("hTLlD");

var $kFGm5 = parcelRequire("kFGm5");

var $6iz4v = parcelRequire("6iz4v");

var $hgcvd = parcelRequire("hgcvd");

var $4gs2G = parcelRequire("4gs2G");

var $8N2pO = parcelRequire("8N2pO");

var $3ztB9 = parcelRequire("3ztB9");

var $9mlBv = parcelRequire("9mlBv");

var $bfxje = parcelRequire("bfxje");
const $de23cc2ccba30d73$var$DEFAULT_ISSUES_STATE = {
    collection: [],
    index: {},
    totalCount: 0
};
const $de23cc2ccba30d73$var$resetIssuesState = ()=>({
        ...$de23cc2ccba30d73$var$DEFAULT_ISSUES_STATE,
        timeWhenLastInitialized: (0, $hgcvd.default).now()
    });
// Removes issue from its old position in collection, and adds it to its new position
const $de23cc2ccba30d73$var$updateCollection = (collection, index, issue, startIndex)=>{
    const { key: key } = issue;
    const position = issue.position + startIndex;
    const newCollection = collection;
    // Find where the issue used to live in the collection, and delete if it exists
    if (index[key] != null) {
        const oldPosition = index[key];
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        if (newCollection[oldPosition] != null && newCollection[oldPosition].key === key) delete newCollection[oldPosition];
    }
    newCollection[position] = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(issue, 'position');
    return newCollection;
};
const $de23cc2ccba30d73$var$updateIndex = (index, issue, startIndex)=>{
    const { key: key } = issue;
    const position = startIndex + issue.position;
    const newIndex = index;
    newIndex[key] = position;
    return newIndex;
};
// @ts-expect-error - TS2314 - Generic type 'Reducer' requires 1 type argument(s). | TS1016 - A required parameter cannot follow an optional parameter.
const $de23cc2ccba30d73$var$reducer = (state, action)=>{
    if (state === undefined) return $de23cc2ccba30d73$var$resetIssuesState();
    switch(action.type){
        case 0, $9mlBv.RESET_STATE:
            return $de23cc2ccba30d73$var$resetIssuesState();
        case 0, $bfxje.PAGE_CHANGED:
            return (0, $6HC1D.chain)(state).assoc('collection', []).assoc('index', {}).assoc('timeWhenLastInitialized', (0, $hgcvd.default).now()).value();
        case 0, $8N2pO.IS_FILTER_FAILED:
            return (0, $6HC1D.chain)(state).assoc('totalCount', 0).value();
        case 0, $3ztB9.LOAD_ISSUES_SUCCESS:
            {
                // This is here because setting the mark in a side effect
                // doesn't guarantee this is fired straight away.
                if (!(0, $6iz4v.getMark)('jsd.performance.profile.queues.issues.loaded')) (0, $6iz4v.setMark)('jsd.performance.profile.queues.issues.loaded');
                const { startIndex: startIndex, loadedIssuesResponse: { totalCount: totalCount, isUsingDefaultSorting: isUsingDefaultSorting } } = action.payload;
                const issuesPayload = action.payload.loadedIssuesResponse.issues;
                // Slice as any issues in collection that exist beyond totalCount need to be deleted
                const collection = state.collection.slice(0, totalCount);
                const index = {
                    ...state.index
                };
                issuesPayload.forEach((newIssue)=>{
                    $de23cc2ccba30d73$var$updateCollection(collection, index, newIssue, startIndex);
                    $de23cc2ccba30d73$var$updateIndex(index, newIssue, startIndex);
                });
                if (state.totalCount === totalCount && state.isUsingDefaultSorting === isUsingDefaultSorting && (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(state.index, index) && (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(state.collection, collection)) return state;
                return (0, $6HC1D.chain)(state).assoc('collection', collection).assoc('index', index).assoc('totalCount', totalCount).assoc('isUsingDefaultSorting', isUsingDefaultSorting).value();
            }
        case 0, $4gs2G.CHANGE_ISSUE_FIELD_VALUE:
            {
                const { issueKey: issueKey, columnId: columnId, newValue: newValue } = action.payload;
                const issueIndex = state.index[issueKey];
                return (0, $6HC1D.updateIn)(state, [
                    'collection'
                ], (issueCollection)=>{
                    // TODO FREE-2659 - unfortunately need to ensure the index entry wasn't stale, restructure issue object array + index -> a store where issues can be accessed by key
                    const issue = issueCollection[issueIndex];
                    if (issue && issue.key === issueKey) {
                        const newIssueValue = (0, $6HC1D.updateIn)(issue, [
                            'fields',
                            columnId
                        ], (storedValue)=>(0, $6HC1D.merge)(storedValue, newValue));
                        return (0, $6HC1D.chain)(issueCollection).set(issueIndex, newIssueValue).value();
                    }
                    return issueCollection;
                });
            }
        case 0, $bfxje.SORT_ORDER_CHANGED:
            return (0, $6HC1D.assoc)(state, 'timeWhenLastInitialized', (0, $hgcvd.default).now());
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $de23cc2ccba30d73$export$2e2bcd8739ae039 = $de23cc2ccba30d73$var$reducer;

});
parcelRegister("4gs2G", function(module, exports) {

$parcel$export(module.exports, "CHANGE_ISSUE_FIELD_VALUE", () => $54283315f6a440fb$export$cfdceb3f950b2ccc);
$parcel$export(module.exports, "changeIssueFieldValueAction", () => $54283315f6a440fb$export$138172374138566d);
// CHANGE_ISSUE_FIELD_VALUE
const $54283315f6a440fb$export$cfdceb3f950b2ccc = 'state.actions.issue.field.CHANGE_ISSUE_FIELD_VALUE';
const $54283315f6a440fb$export$138172374138566d = (issueKey, columnId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
newValue)=>({
        type: $54283315f6a440fb$export$cfdceb3f950b2ccc,
        payload: {
            issueKey: issueKey,
            columnId: columnId,
            newValue: newValue
        }
    });

});


parcelRegister("bxFt3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d8916c062ce05c6$export$2e2bcd8739ae039);

var $5KU0G = parcelRequire("5KU0G");
const $4d8916c062ce05c6$var$defaultPracticesState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4d8916c062ce05c6$export$2e2bcd8739ae039 = (state = $4d8916c062ce05c6$var$defaultPracticesState, action)=>{
    switch(action.type){
        case 0, $5KU0G.SET_ENABLED_PRACTICES:
            return action.payload.practices;
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});
parcelRegister("5KU0G", function(module, exports) {

$parcel$export(module.exports, "SET_ENABLED_PRACTICES", () => $7c7aa50a572d38af$export$2c78e2c3ded512ec);
$parcel$export(module.exports, "setEnabledPracticesAction", () => $7c7aa50a572d38af$export$d050127f311d3c95);
const $7c7aa50a572d38af$export$2c78e2c3ded512ec = 'state.actions.practices.SET_ENABLED_PRACTICES';
const $7c7aa50a572d38af$export$d050127f311d3c95 = (practices)=>({
        type: $7c7aa50a572d38af$export$2c78e2c3ded512ec,
        payload: {
            practices: practices
        }
    });

});


parcelRegister("9qPJP", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ff2516f597d9568$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $21l2t = parcelRequire("21l2t");


var $3ztB9 = parcelRequire("3ztB9");

var $9mlBv = parcelRequire("9mlBv");

var $9CKPh = parcelRequire("9CKPh");

var $bfxje = parcelRequire("bfxje");
const $8ff2516f597d9568$var$DEFAULT_QUEUE_STATE = {
    pagination: {
        currentPage: 1
    },
    fetchStartIndex: 0,
    category: undefined
};
var // SHIELD-3575 This reducer describes queue page data and should be renamed to
// avoid ambiguity with state in ui/current-queue
// eslint-disable-next-line jira/import/no-anonymous-default-export
$8ff2516f597d9568$export$2e2bcd8739ae039 = (state = $8ff2516f597d9568$var$DEFAULT_QUEUE_STATE, action)=>{
    switch(action.type){
        case 0, $9mlBv.LOAD_PAGE_DATA:
        case 0, $9mlBv.RESET_STATE:
            {
                const { queueId: queueId } = action.payload;
                return (0, $6HC1D.assoc)($8ff2516f597d9568$var$DEFAULT_QUEUE_STATE, 'queueId', queueId);
            }
        case 0, $9mlBv.LOAD_PAGE_DATA_SUCCESS:
            if (action.payload.queuesWithSorting.manualSorting) return (0, $6HC1D.assoc)(state, 'manualSorting', action.payload.queuesWithSorting.manualSorting);
            return state;
        case 0, $bfxje.PAGE_CHANGED:
            {
                const { currentPage: actionPage } = action.payload;
                let currentPage = Math.max(1, Math.ceil(actionPage));
                if ((0, (/*@__PURE__*/$parcel$interopDefault($21l2t)))(currentPage)) currentPage = 1;
                return (0, $6HC1D.assocIn)(state, [
                    'pagination',
                    'currentPage'
                ], currentPage);
            }
        case 0, $bfxje.SORT_ORDER_CHANGED:
            return (0, $6HC1D.assoc)(state, 'manualSorting', undefined);
        case 0, $bfxje.RESET_SORT_ORDER:
            return (0, $6HC1D.dissoc)(state, 'manualSorting');
        case 0, $3ztB9.LOAD_ISSUES_SUCCESS:
            /* Due to various reason (sorting field id is not longer valid, custom field has been removed, sorting field
    is no longer visible in the queue, etc), the sorting returned from the /issuelist endpoint maybe different
    from what we stored in the state. We should keep them in sync after we got the response. */ return action.payload.source === (0, $34edc5e681269c4f$export$2003e3fdddd4c35b) || action.payload.source === (0, $34edc5e681269c4f$export$be4c1ea173a5271a) ? (0, $6HC1D.assocIn)(state, [
                'pagination',
                'currentPage'
            ], 1) : state;
        case 0, $bfxje.FETCH_ISSUE_DATA_ONSCROLL:
            return (0, $6HC1D.assoc)(state, 'fetchStartIndex', action.payload);
        case 0, $9CKPh.QUEUE_CHANGED:
            return (0, $6HC1D.assoc)(state, 'category', action.payload.queue.category);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("21l2t", function(module, exports) {

var $lzTt0 = parcelRequire("lzTt0");
/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $178bfea3ddcf2651$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $lzTt0(value) && value != +value;
}
module.exports = $178bfea3ddcf2651$var$isNaN;

});


parcelRegister("9AIVO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f8e7899e5fd2fab$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $3ztB9 = parcelRequire("3ztB9");

var $8vuXb = parcelRequire("8vuXb");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1f8e7899e5fd2fab$export$2e2bcd8739ae039 = (state = {}, action)=>{
    switch(action.type){
        case 0, $3ztB9.LOAD_ISSUES_SUCCESS:
            {
                const { issueHash: issueHash } = action.payload.loadedIssuesResponse;
                return (0, $6HC1D.assoc)(state, 'issueHash', issueHash);
            }
        case 0, $8vuXb.POLL_SUCCESS:
            return (0, $6HC1D.assoc)(state, 'projectStateHash', action.payload.projectStateHash);
        case 0, $8vuXb.RESET_PROJECT_STATE_HASH:
            return (0, $6HC1D.unset)(state, 'projectStateHash');
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});


parcelRegister("hloYl", function(module, exports) {

$parcel$export(module.exports, "default", () => $de971cf0817bca50$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $aNBkj = parcelRequire("aNBkj");


var $8N2pO = parcelRequire("8N2pO");

var $3ztB9 = parcelRequire("3ztB9");

var $9mlBv = parcelRequire("9mlBv");

var $bfxje = parcelRequire("bfxje");

var $kBhD3 = parcelRequire("kBhD3");

var $2AulU = parcelRequire("2AulU");
const $de971cf0817bca50$var$DEFAULT_UI_STATE = {
    onboardingResolved: false,
    isNavCollapsed: true,
    isHeaderCollapsed: false,
    sidebarIssueKey: null,
    isQueuesErrorHeaderDisplayed: false,
    sidebarReactKey: Math.random().toString()
};
const $de971cf0817bca50$var$rootUiReducer = (state, action)=>{
    switch(action.type){
        case 0, $9mlBv.SET_QUEUE_VISIBILITY:
            return (0, $6HC1D.assoc)(state, 'isQueueVisible', action.payload.isQueueVisible);
        case 0, $kBhD3.ONBOARDING_RESOLVED:
            return (0, $6HC1D.assoc)(state, 'onboardingResolved', action.payload.onboardingResolved);
        case 0, $kBhD3.SET_NAV_COLLAPSED:
            return (0, $6HC1D.assoc)(state, 'isNavCollapsed', action.payload.isNavCollapsed);
        case 0, $kBhD3.SET_DELETE_MODAL_VISIBILITY:
            return (0, $6HC1D.chain)(state).setIn([
                'deleteModalOpen'
            ], action.payload.isVisible).value();
        case 0, $kBhD3.SET_ISSUE_KEY_CONTEXT:
            return (0, $6HC1D.assoc)(state, 'issueKeyContext', action.payload.issueKey);
        case 0, $kBhD3.SET_SIDEBAR_ISSUE_KEY:
            return (0, $6HC1D.assoc)(state, 'sidebarIssueKey', action.payload.sidebarIssueKey);
        case 0, $kBhD3.SET_SIDEBAR_REACT_KEY:
            return (0, $6HC1D.assoc)(state, 'sidebarReactKey', action.payload.sidebarReactKey);
        case 0, $kBhD3.SET_SELECTED_ISSUE_KEYS:
            return (0, $6HC1D.assoc)(state, 'selectedIssueKeys', action.payload.selectedIssueKeys);
        case 0, $kBhD3.REFRESH_SIDEBAR_ISSUE_VIEW:
            if (state.sidebarIssueKey && (state.selectedIssueKeys?.includes(state.sidebarIssueKey) || state.sidebarIssueKey === action.payload.issueKey)) return (0, $6HC1D.assoc)(state, 'sidebarReactKey', Math.random().toString());
            return state;
        case 0, $kBhD3.DELETE_QUEUE:
            return (0, $6HC1D.assoc)(state, 'deletingQueue', true);
        case 0, $kBhD3.SET_MODAL_IS_DELETING:
            return (0, $6HC1D.assoc)(state, 'deletingQueue', action.payload.isDeleting);
        case 0, $bfxje.PAGE_CHANGED:
        case 0, $9mlBv.LOAD_PAGE_DATA:
        case 0, $bfxje.SORT_ORDER_CHANGED:
        case 0, $8N2pO.FILTER_QUERY_SUBMITTED:
        case 0, $bfxje.RESET_SORT_ORDER:
            return (0, $6HC1D.assoc)(state, 'isLoadingIssues', true);
        case 0, $9mlBv.LOAD_PAGE_DATA_FAILURE:
            {
                const { error: error } = action.payload;
                return (0, $6HC1D.chain)(state).assoc('isLoadingPage', false).assoc('pageError', error).value();
            }
        case 0, $9mlBv.LOAD_PAGE_DATA_SUCCESS:
            return (0, $6HC1D.chain)(state).assoc('isLoadingPage', false).dissoc('pageError').value();
        case 0, $3ztB9.LOAD_ISSUES_SUCCESS:
            {
                const { isFiltered: isFiltered, isFilterRequested: isFilterRequested } = action.payload.loadedIssuesResponse;
                const isLoadingIssues = isFilterRequested !== isFiltered;
                const areIssuesLoadedFromServer = action.payload.loadedIssuesResponse.source === (0, $aNBkj.REST_SOURCE);
                return (0, $6HC1D.chain)(state).assoc('isLoadingIssues', isLoadingIssues).assoc('areIssuesLoadedFromServer', areIssuesLoadedFromServer).dissoc('showIssueFailureError').dissoc('shouldShowBadFilterQueryError').value();
            }
        case 0, $3ztB9.LOAD_ISSUES_FAILURE:
            {
                const { source: source, isQueueEmpty: isQueueEmpty } = action.payload;
                const updatedState = (0, $6HC1D.chain)(state).assoc('isLoadingIssues', false);
                if (source === (0, $34edc5e681269c4f$export$f162a928a40c7ab8) && isQueueEmpty) updatedState.assoc('showIssueFailureError', true);
                return updatedState.value();
            }
        case 0, $9mlBv.RESET_STATE:
            return (0, $6HC1D.chain)(state).assoc('isLoadingPage', true).assoc('isLoadingIssues', true).assoc('areIssuesLoadedFromServer', false).assoc('isQueueVisible', true).dissoc('showIssueFailureError').dissoc('shouldShowBadFilterQueryError').value();
        case 0, $bfxje.TOGGLE_QUEUE_HEADER:
            {
                const direction = action.payload;
                if (direction === (0, $34edc5e681269c4f$export$57022ca1771ad970)) return state;
                return (0, $6HC1D.assoc)(state, 'isHeaderCollapsed', direction === (0, $34edc5e681269c4f$export$28a694fb106a7f62));
            }
        case 0, $8N2pO.IS_FILTER_FAILED:
            return (0, $6HC1D.chain)(state).assoc('isLoadingIssues', false).assoc('issueCount', 0).assoc('shouldShowBadFilterQueryError', true).value();
        case 0, $9mlBv.DISPLAY_QUEUES_ERROR_HEADER:
            return (0, $6HC1D.assoc)(state, 'isQueuesErrorHeaderDisplayed', true);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$de971cf0817bca50$export$2e2bcd8739ae039 = (state = $de971cf0817bca50$var$DEFAULT_UI_STATE, action)=>{
    const { currentQueue: currentQueue } = state;
    const nextState = $de971cf0817bca50$var$rootUiReducer(state, action);
    const nextQueue = (0, $2AulU.default)(currentQueue, action);
    // Do not return a new object if no changes are made.
    // Or else anything using this state as reference will
    // cause a re-render even if leaf values are the same
    if (state === nextState && currentQueue === nextQueue) return state;
    return {
        ...nextState,
        currentQueue: nextQueue
    };
};

});
parcelRegister("2AulU", function(module, exports) {

$parcel$export(module.exports, "default", () => $88488a6c57f1135d$export$2e2bcd8739ae039);

var $hTLlD = parcelRequire("hTLlD");

var $94zjC = parcelRequire("94zjC");

var $3ztB9 = parcelRequire("3ztB9");

var $9CKPh = parcelRequire("9CKPh");

var $bfxje = parcelRequire("bfxje");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$88488a6c57f1135d$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 0, $9CKPh.SET_QUEUE:
            return action.payload.queue;
        case 0, $3ztB9.LOAD_ISSUES_SUCCESS:
            {
                const { loadedIssuesResponse: { columns: columns, isUsingDefaultSorting: isUsingDefaultSorting } } = action.payload;
                const newState = (0, $94zjC.chainUnsafe)(state);
                if (state && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(columns, state.columns)) newState.assoc('columns', columns);
                return isUsingDefaultSorting ? newState.dissoc('manualSorting').value() : newState.value();
            }
        case 0, $bfxje.SORT_ORDER_CHANGED:
            return (0, $94zjC.assocUnsafe)(state, 'manualSorting', action.payload);
        case 0, $bfxje.SORT_ORDER_OPTIMISTIC_UPDATE:
            {
                const { sortedBy: sortedBy, sortOrder: sortOrder } = action.payload;
                return (0, $94zjC.updateInUnsafe)(state, [
                    'columns'
                ], (columns)=>// @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'column' implicitly has an 'any' type.
                    columns.map((column)=>(0, $94zjC.assocUnsafe)(column, 'currentSorting', column.id === sortedBy ? sortOrder : undefined)));
            }
        case 0, $bfxje.RESET_SORT_ORDER:
            return (0, $94zjC.dissocUnsafe)(state, 'manualSorting');
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("94zjC", function(module, exports) {

$parcel$export(module.exports, "assocUnsafe", () => $56ee753086711575$export$a759ec8fde46de77);
$parcel$export(module.exports, "dissocUnsafe", () => $56ee753086711575$export$e0867c1b5da854fe);
$parcel$export(module.exports, "assocInUnsafe", () => $56ee753086711575$export$1bfac1118aad2c2f);
$parcel$export(module.exports, "updateInUnsafe", () => $56ee753086711575$export$f920b8c255ec1192);
$parcel$export(module.exports, "chainUnsafe", () => $56ee753086711575$export$181c753256d1c9a0);

var $6HC1D = parcelRequire("6HC1D");
const $56ee753086711575$export$a759ec8fde46de77 = (collection, key, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $6HC1D.assoc(collection, key, value);
const $56ee753086711575$export$9b65d21cdbb50a87 = (collection, key, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $6HC1D.set(collection, key, value);
const $56ee753086711575$export$e0867c1b5da854fe = (collection, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $6HC1D.dissoc(collection, key);
const $56ee753086711575$export$958195bad0a3dbcf = (collection, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $6HC1D.unset(collection, key);
const $56ee753086711575$export$1bfac1118aad2c2f = (collection, path, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $6HC1D.assocIn(collection, path, value);
const $56ee753086711575$export$565e6fa2e54b66b3 = (collection, path, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $6HC1D.setIn(collection, path, value);
const $56ee753086711575$export$75197f11bfe5de5f = (collection, path)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $6HC1D.getIn(collection, path);
const $56ee753086711575$export$f920b8c255ec1192 = (collection, path, callback)=>$6HC1D.updateIn(collection, path, callback);
class $56ee753086711575$var$IcepickUnsafeWrapper {
    constructor(collection){
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        this.wrapper = $6HC1D.chain(collection);
    }
    value() {
        return this.wrapper.value();
    }
    freeze() {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.freeze().value());
    }
    assoc(key, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.assoc(key, value).value());
    }
    set(key, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.set(key, value).value());
    }
    dissoc(key) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.dissoc(key).value());
    }
    unset(key) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.unset(key).value());
    }
    assocIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.assocIn(path, value).value());
    }
    setIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.setIn(path, value).value());
    }
    getIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.getIn(path, value).value());
    }
    updateIn(path, callback) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.updateIn(path, callback).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(source) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.assign(source).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2, s3) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2, s3).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2, s3, s4) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2, s3, s4).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(source) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.extend(source).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2, s3) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2, s3).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2, s3, s4) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2, s3, s4).value());
    }
    merge(source) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.merge(source).value());
    }
    thru(val) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.thru(val).value());
    }
}
const $56ee753086711575$export$181c753256d1c9a0 = (collection)=>new $56ee753086711575$var$IcepickUnsafeWrapper(collection);

});




parcelRegister("lEA7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d893d3ca6dc80a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $df4Sl = parcelRequire("df4Sl");

var $5iWql = parcelRequire("5iWql");

var $jPfP5 = parcelRequire("jPfP5");

var $1ybV0 = parcelRequire("1ybV0");

var $2hox0 = parcelRequire("2hox0");

var $hbusP = parcelRequire("hbusP");

var $lNNXV = parcelRequire("lNNXV");

var $8HMCF = parcelRequire("8HMCF");


var $8N2pO = parcelRequire("8N2pO");

var $3ztB9 = parcelRequire("3ztB9");

var $hLmJ9 = parcelRequire("hLmJ9");

var $9mlBv = parcelRequire("9mlBv");

var $9CKPh = parcelRequire("9CKPh");

var $kBhD3 = parcelRequire("kBhD3");

var $8vuXb = parcelRequire("8vuXb");

var $5sNW7 = parcelRequire("5sNW7");

var $3i6VQ = parcelRequire("3i6VQ");

var $8UPn4 = parcelRequire("8UPn4");

var $8GAE5 = parcelRequire("8GAE5");

var $cip5U = parcelRequire("cip5U");

var $3KNsL = parcelRequire("3KNsL");

var $1RqtY = parcelRequire("1RqtY");

var $iDw5z = parcelRequire("iDw5z");

var $f8SUF = parcelRequire("f8SUF");

var $bzie7 = parcelRequire("bzie7");

var $1FxsB = parcelRequire("1FxsB");

var $eFzWc = parcelRequire("eFzWc");

var $qroR3 = parcelRequire("qroR3");

var $6gHnM = parcelRequire("6gHnM");

var $ijIX7 = parcelRequire("ijIX7");

var $qJUKW = parcelRequire("qJUKW");

var $heWnU = parcelRequire("heWnU");

var $kJKzX = parcelRequire("kJKzX");
const $d6d893d3ca6dc80a$var$getColumnsMemoized = ()=>(0, $df4Sl.createSelector)((0, $3KNsL.getColumns), (res)=>res);
const $d6d893d3ca6dc80a$var$EMPTY_LIST = [];
const $d6d893d3ca6dc80a$var$mapStateToPropsFactory = ()=>{
    const getColumnsInstance = $d6d893d3ca6dc80a$var$getColumnsMemoized();
    return (state)=>({
            Header: $1FxsB.default,
            UsageSampler: $heWnU.default,
            EmptyQueue: $f8SUF.default,
            ErrorState: $bzie7.default,
            isQueueEmpty: (0, $1RqtY.isQueueEmpty)(state),
            showIssueFailureError: (0, $1RqtY.showIssueFailureError)(state),
            isLoadingIssues: (0, $1RqtY.isLoadingIssues)(state),
            issueCount: (0, $8GAE5.getIssueCount)(state),
            onboardingResolved: (0, $1RqtY.getOnboardingResolved)(state),
            isCurrentDataFiltered: (0, $8UPn4.getIsCurrentDataFiltered)(state),
            Table: $qJUKW.default,
            EmptyFilteredQueue: $iDw5z.default,
            NavUpdater: $6gHnM.default,
            ViewTracker: $jPfP5.default,
            QueuesBreadcrumb: $ijIX7.default,
            IssueContextListener: $eFzWc.default,
            ItsmContextListener: $qroR3.default,
            UpFlowPersistentUpgradeBanner: $8HMCF.UpFlowPersistentUpgradeBanner,
            baseUrl: '',
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            projectKey: (0, $3i6VQ.getAppProps)(state).projectKey,
            isInitialized: (0, $1RqtY.isInitialized)(state),
            category: (0, $3KNsL.getCategory)(state),
            itsmPractices: (0, $cip5U.isItsmProject)(state) ? (0, $cip5U.getEnabledPractices)(state) : $d6d893d3ca6dc80a$var$EMPTY_LIST,
            issueCollection: (0, $8GAE5.getCollection)(state),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            projectId: (0, $3i6VQ.getAppProps)(state).projectId,
            columns: getColumnsInstance(state),
            jql: (0, $3KNsL.getJql)(state),
            shouldShowBadFilterQueryError: (0, $1RqtY.shouldShowBadFilterQueryError)(state),
            createAnalyticsEvent: (0, $5sNW7.getCreateAnalyticsEvent)(state),
            sidebarIssueKey: (0, $1RqtY.getSidebarIssueKey)(state),
            sidebarReactKey: (0, $1ybV0.ff)('jsm-queue-sidebar-bulk-edit-bug-fix_jx9ff', false) ? (0, $1RqtY.getSidebarReactKey)(state) : null,
            isQueuesErrorHeaderDisplayed: (0, $1RqtY.isQueuesErrorHeaderDisplayed)(state)
        });
};
const $d6d893d3ca6dc80a$var$mapDispatchToProps = (dispatch)=>({
        onPageVisibilityChanged: (isQueueVisible)=>{
            dispatch((0, $9mlBv.changeVisibilityAction)(isQueueVisible));
            if (!isQueueVisible) dispatch((0, $8vuXb.stopPollAction)());
        },
        onUnmount: ()=>{
            dispatch((0, $hLmJ9.shutdownAction)());
        },
        onQueueChanged: (queue)=>{
            dispatch((0, $9CKPh.queueChangedAction)(queue));
        },
        onOnboardingResolved: (resolved)=>dispatch((0, $kBhD3.onboardingResolvedAction)(resolved)),
        onNavCollapseChange: (isNavCollapsed)=>{
            dispatch((0, $kBhD3.setNavCollapsedAction)(isNavCollapsed));
        },
        onWindowFocus: ()=>{
            dispatch((0, $8vuXb.restartPollAction)());
        },
        onFilterClear: ()=>{
            dispatch((0, $8N2pO.filterQueryChangedAction)(null));
            dispatch((0, $8N2pO.filterQuerySubmittedAction)(null));
        },
        onIssueChange: ()=>{
            dispatch((0, $8N2pO.isNewFilterQueryPendingAction)(true));
            dispatch((0, $3ztB9.loadIssuesAction)(0, (0, $34edc5e681269c4f$export$217a2381e50d4bff)));
        },
        onSetIssueKey: (key)=>{
            dispatch((0, $kBhD3.setSidebarIssueKey)(key));
        },
        onNonPremiumSLAColumnError: ()=>(0, $9mlBv.displayQueuesErrorHeaderAction)
    });
const $d6d893d3ca6dc80a$var$getSidebarApiProps = (0, $5iWql.default)((sidebarApiProps)=>sidebarApiProps);
const $d6d893d3ca6dc80a$var$LayoutWithSidebarApi = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2hox0.UIControllerSubscriber), null, ({ state: sidebarState })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hbusP.NavigationUISubscriber), null, (_, navActions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJKzX.default), {
                ...props,
                sidebarApi: $d6d893d3ca6dc80a$var$getSidebarApiProps({
                    navActions: navActions,
                    isCollapsed: sidebarState.isCollapsed
                })
            })));
const $d6d893d3ca6dc80a$var$ConnectedLayout = (0, $lNNXV.connect)($d6d893d3ca6dc80a$var$mapStateToPropsFactory, $d6d893d3ca6dc80a$var$mapDispatchToProps)($d6d893d3ca6dc80a$var$LayoutWithSidebarApi);
var $d6d893d3ca6dc80a$export$2e2bcd8739ae039 = $d6d893d3ca6dc80a$var$ConnectedLayout;

});
parcelRegister("jPfP5", function(module, exports) {

$parcel$export(module.exports, "default", () => $87fa35216d96bc0f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $etqm0 = parcelRequire("etqm0");
// eslint-disable-next-line jira/react/no-class-components
class $87fa35216d96bc0f$var$ViewTracker extends (0, $eUqFw.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $87fa35216d96bc0f$var$ViewTrackerWithAnalytics = (0, $1ngde.default)({
    componentName: 'view-tracker'
})((0, $2jDha.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $etqm0.PAGE_EVENT_ACTION)
        }).fire()
})($87fa35216d96bc0f$var$ViewTracker));
var // without onMount={noop} it won't work, defaultProps won't help
// @ts-expect-error - TS2322 - Type '{ onMount: (...args: any[]) => void; }' is not assignable to type 'IntrinsicAttributes & Pick<Pick<WithAnalyticsEventsProps, never> & RefAttributes<any> & WithContextProps, "key" | "analyticsContext"> & RefAttributes<...>'.
// eslint-disable-next-line jira/import/no-anonymous-default-export
$87fa35216d96bc0f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($87fa35216d96bc0f$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    });

});

parcelRegister("2hox0", function(module, exports) {

$parcel$export(module.exports, "UIControllerSubscriber", () => $b52525162b6724ab$export$8e3db525e646de2c);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $9zysr = parcelRequire("9zysr");

var $kpmC0 = parcelRequire("kpmC0");

var $6FP8W = parcelRequire("6FP8W");

var $iP6ac = parcelRequire("iP6ac");
// Nav3
const $b52525162b6724ab$var$UIControllerSubscriberOld = ({ children: children })=>{
    const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, $kpmC0.useLeftSidebarController)();
    const { isCollapsed: isCollapsed, width: width } = (0, $kpmC0.useLeftSidebarState)();
    const stateRef = (0, $eUqFw.useRef)({
        state: {
            isCollapsed: isCollapsed,
            isResizing: false,
            isResizeDisabled: false,
            productNavWidth: width
        },
        collapse: collapseLeftSidebar,
        expand: expandLeftSidebar,
        toggleCollapse: ()=>isCollapsed ? expandLeftSidebar() : collapseLeftSidebar()
    });
    const navigationUIController = (0, $eUqFw.useMemo)(()=>({
            state: {
                isCollapsed: isCollapsed,
                isResizing: false,
                isResizeDisabled: false,
                productNavWidth: width
            },
            collapse: collapseLeftSidebar,
            expand: expandLeftSidebar,
            toggleCollapse: ()=>isCollapsed ? expandLeftSidebar() : collapseLeftSidebar()
        }), [
        collapseLeftSidebar,
        expandLeftSidebar,
        isCollapsed,
        width
    ]);
    stateRef.current = Object.assign(stateRef.current, navigationUIController);
    return children(stateRef.current);
};
const $b52525162b6724ab$var$defaultState = {
    state: {
        isCollapsed: false,
        isResizing: false,
        isResizeDisabled: false,
        productNavWidth: 0
    },
    collapse: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    expand: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    toggleCollapse: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
// Nav4
const $b52525162b6724ab$var$UIControllerSubscriberNew = ({ children: children })=>{
    const toggleSideNav = (0, $iP6ac.useToggleSideNav)();
    const stateRef = (0, $eUqFw.useRef)({
        ...$b52525162b6724ab$var$defaultState,
        toggleCollapse: toggleSideNav
    });
    const navigationUIController = (0, $eUqFw.useMemo)(()=>({
            ...$b52525162b6724ab$var$defaultState,
            toggleCollapse: toggleSideNav
        }), [
        toggleSideNav
    ]);
    stateRef.current = Object.assign(stateRef.current, navigationUIController);
    return children(stateRef.current);
};
const $b52525162b6724ab$export$8e3db525e646de2c = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), $b52525162b6724ab$var$UIControllerSubscriberNew, $b52525162b6724ab$var$UIControllerSubscriberOld);

});

parcelRegister("8HMCF", function(module, exports) {

$parcel$export(module.exports, "UpFlowPersistentUpgradeBanner", () => $1ded51f6d1fe0671$export$39832316603e4613);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

var $bNa2U = parcelRequire("bNa2U");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1ded51f6d1fe0671$var$LazyUpFlowPersistentUpgradeBanner = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("h5kof")), {
    ssr: false,
    moduleId: "./src/packages/growth/up-flow/persistent-upgrade-banner/src/main.tsx"
});
const $1ded51f6d1fe0671$export$39832316603e4613 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: (0, $bNa2U.PERSISTENT_UPGRADE_ANALYTICS_SOURCE),
        packageName: (0, $bNa2U.PERSISTENT_UPGRADE_TOUCHPOINT_BANNER),
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "up-flow-persistent-upgrade-banner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ded51f6d1fe0671$var$LazyUpFlowPersistentUpgradeBanner, props)));

});
parcelRegister("bNa2U", function(module, exports) {

$parcel$export(module.exports, "PERSISTENT_UPGRADE_PRE_TRIAL_FREE_EDITION", () => $d4c4bcb569ddbdc8$export$75e961f06f21e171);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_ANALYTICS_SOURCE", () => $d4c4bcb569ddbdc8$export$bebf43b5d37dab0);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_ANALYTICS_UPGRADE_FLOW", () => $d4c4bcb569ddbdc8$export$cbfd75a8d4af5ce5);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_UPFLOW_MODAL_FLOW", () => $d4c4bcb569ddbdc8$export$a2684b22124cc502);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_TOUCHPOINT_BANNER", () => $d4c4bcb569ddbdc8$export$e54a73280ddbd89);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_TOUCHPOINT_BANNER_VIEWED", () => $d4c4bcb569ddbdc8$export$96913d5371f745ad);
$parcel$export(module.exports, "MAX_CADENCE_INDEX", () => $d4c4bcb569ddbdc8$export$b8743c23616e54ee);
$parcel$export(module.exports, "KEY_USER_PROPERTIES_JSW", () => $d4c4bcb569ddbdc8$export$6a69b5601e7d435);
$parcel$export(module.exports, "KEY_USER_PROPERTIES_JSM", () => $d4c4bcb569ddbdc8$export$364c2b43630f5cb5);
$parcel$export(module.exports, "BANNER_CADENCE_INFO", () => $d4c4bcb569ddbdc8$export$ec6ce1b450620e5c);
$parcel$export(module.exports, "SEND_OPERATIONAL_EVENT", () => $d4c4bcb569ddbdc8$export$8b4682bf35504518);
$parcel$export(module.exports, "API_SUCCESS", () => $d4c4bcb569ddbdc8$export$6d01cae610456af2);
$parcel$export(module.exports, "API_FAIL", () => $d4c4bcb569ddbdc8$export$6a238c78062d3b8d);
$parcel$export(module.exports, "GET_USER_PROPERTY_API_CALL", () => $d4c4bcb569ddbdc8$export$d094ee3fcda994eb);
$parcel$export(module.exports, "GET_USER_PROPERTY_API_CALL_SUCCESS", () => $d4c4bcb569ddbdc8$export$8357ebd56fd8e5ea);
$parcel$export(module.exports, "GET_USER_PROPERTY_API_CALL_FAIL", () => $d4c4bcb569ddbdc8$export$252ee5e4ed4943dc);
$parcel$export(module.exports, "SET_USER_PROPERTY_API_CALL", () => $d4c4bcb569ddbdc8$export$f3310dd86ae4284b);
$parcel$export(module.exports, "SET_USER_PROPERTY_API_CALL_SUCCESS", () => $d4c4bcb569ddbdc8$export$5e4635b476d2b497);
$parcel$export(module.exports, "SET_USER_PROPERTY_API_CALL_FAIL", () => $d4c4bcb569ddbdc8$export$b49d6161d5ea4a0a);
$parcel$export(module.exports, "PERSISTENT_PRETRIAL_BANNER_CADENCES_MS", () => $d4c4bcb569ddbdc8$export$55aa1fd7f74b53);
const $d4c4bcb569ddbdc8$export$75e961f06f21e171 = 'pre-trial';
const $d4c4bcb569ddbdc8$export$bebf43b5d37dab0 = 'persistentUpgrade';
const $d4c4bcb569ddbdc8$export$cbfd75a8d4af5ce5 = 'upgradeFlow';
const $d4c4bcb569ddbdc8$export$a2684b22124cc502 = 'persistent-upgrade';
const $d4c4bcb569ddbdc8$export$e54a73280ddbd89 = 'persistentUpgradeBanner';
const $d4c4bcb569ddbdc8$export$96913d5371f745ad = 'persistentUpgradeBanner viewed';
const $d4c4bcb569ddbdc8$export$b8743c23616e54ee = 3;
const $d4c4bcb569ddbdc8$export$6a69b5601e7d435 = 'growth-puet-banner-cadence';
const $d4c4bcb569ddbdc8$export$364c2b43630f5cb5 = 'growth-puet-banner-cadence-jsm';
const $d4c4bcb569ddbdc8$export$ec6ce1b450620e5c = 'Banner Cadence Info';
const $d4c4bcb569ddbdc8$export$8b4682bf35504518 = 'sendOperationalEvent';
const $d4c4bcb569ddbdc8$export$6d01cae610456af2 = 'success';
const $d4c4bcb569ddbdc8$export$6a238c78062d3b8d = 'failed';
const $d4c4bcb569ddbdc8$export$d094ee3fcda994eb = 'getUserPropertyApiCall';
const $d4c4bcb569ddbdc8$export$8357ebd56fd8e5ea = 'getUserPropertyApiCall success';
const $d4c4bcb569ddbdc8$export$252ee5e4ed4943dc = 'getUserPropertyApiCall failed';
const $d4c4bcb569ddbdc8$export$f3310dd86ae4284b = 'setUserPropertyApiCall';
const $d4c4bcb569ddbdc8$export$5e4635b476d2b497 = 'setUserPropertyApiCall success';
const $d4c4bcb569ddbdc8$export$b49d6161d5ea4a0a = 'setUserPropertyApiCall failed';
const $d4c4bcb569ddbdc8$export$55aa1fd7f74b53 = [
    0,
    604800000,
    1814400000,
    3628800000
];

});

parcelRegister("h5kof", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("g8JKE").then(()=>parcelRequire('27Md7'));

});


parcelRegister("iDw5z", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aded874fabdd997$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $eI5EY = parcelRequire("eI5EY");

var $hgbp4 = parcelRequire("hgbp4");

var $4Es8k = parcelRequire("4Es8k");

var $5JgJ2 = parcelRequire("5JgJ2");

var $37oT1 = parcelRequire("37oT1");

var $lvYHo = parcelRequire("lvYHo");
const $9aded874fabdd997$var$EmptyView = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const consolidateFeatureGate = (0, $eI5EY.fg)('jsm_queues_consolidate_jfe_assets');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: consolidateFeatureGate ? (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $hgbp4.default)) : undefined,
        imageUrl: consolidateFeatureGate ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($37oT1))),
        header: formatMessage((0, $lvYHo.default).header),
        description: formatMessage((0, $lvYHo.default).description),
        headingLevel: 2
    });
};
var $9aded874fabdd997$export$2e2bcd8739ae039 = $9aded874fabdd997$var$EmptyView;

});
parcelRegister("hgbp4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2d2ebe01d4784a8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1lasE")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $9TZf5 = parcelRequire("9TZf5");

var $gMIRj = parcelRequire("gMIRj");

var $1lasE = parcelRequire("1lasE");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $d2d2ebe01d4784a8$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1lasE)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($gMIRj))
});
var $d2d2ebe01d4784a8$export$2e2bcd8739ae039 = $d2d2ebe01d4784a8$var$Illustration;
// for advanced use only
const $d2d2ebe01d4784a8$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("gMIRj", function(module, exports) {
module.exports = new URL("search-no-results-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("1lasE", function(module, exports) {
module.exports = new URL("search-no-results.10b14394.svg", import.meta.url).toString();

});


parcelRegister("37oT1", function(module, exports) {
module.exports = new URL("no-search-results.6374065e.svg", import.meta.url).toString();

});

parcelRegister("lvYHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $106c38e4ac760201$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $106c38e4ac760201$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    header: {
        "id": "servicedesk.queues.agent-view.layout.empty-filtered-queue.header",
        "defaultMessage": "We couldn't find any requests that match your search"
    },
    description: {
        "id": "servicedesk.queues.agent-view.layout.empty-filtered-queue.description",
        "defaultMessage": "Check for typos, or try another search term"
    }
});

});


parcelRegister("f8SUF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e07716d53d824f2$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $3nTcJ = parcelRequire("3nTcJ");

var $gaYiJ = parcelRequire("gaYiJ");

var $bXcRu = parcelRequire("bXcRu");

var $3KNsL = parcelRequire("3KNsL");

var $1RqtY = parcelRequire("1RqtY");

var $lsHr9 = parcelRequire("lsHr9");

var $gxSBQ = parcelRequire("gxSBQ");

var $4XHcr = parcelRequire("4XHcr");
const $2e07716d53d824f2$var$mapStateToProps = (state)=>({
        emptyStateMessage: (0, $gxSBQ.getEmptyStateMessage)(state),
        projectId: (0, $3nTcJ.getProjectId)(state),
        queueId: (0, $3KNsL.getQueueId)(state),
        isQueueVisible: (0, $1RqtY.isQueueVisible)(state),
        category: (0, $3KNsL.getCategory)(state),
        EmptyQueueComponent: $bXcRu.default,
        DemoDripFeed: $lsHr9.default,
        ReadyForUser: $gaYiJ.ReadyForUser,
        metricKey: (0, $3KNsL.getMetricKey)(state)
    });
var $2e07716d53d824f2$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($2e07716d53d824f2$var$mapStateToProps, {})((0, $4XHcr.default));

});
parcelRegister("gaYiJ", function(module, exports) {

$parcel$export(module.exports, "ReadyForUser", () => $2ae16e399fd6c043$export$c05d1149dfea94a1);

var $eUqFw = parcelRequire("eUqFw");

var $6iz4v = parcelRequire("6iz4v");

var $b3V2m = parcelRequire("b3V2m");
const $2ae16e399fd6c043$export$c05d1149dfea94a1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ae16e399fd6c043$export$5efccbb976d3d994, props);
class $2ae16e399fd6c043$export$5efccbb976d3d994 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            context: undefined,
            onLoadEnd: (0, $b3V2m.end)
        };
    }
    componentDidMount() {
        this.recordEndMetric();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.context !== this.props.context) this.recordEndMetric();
    }
    recordEndMetric() {
        const { onLoadEnd: onLoadEnd } = this.props;
        const location = window.location.pathname;
        (0, $6iz4v.setMark)('jsd.performance.profile.record.metric.end');
        onLoadEnd(location);
        var emitSignal;
    }
    render() {
        return null;
    }
}

});
parcelRegister("b3V2m", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    return function(t) {
        function e(n) {
            if (r[n]) return r[n].exports;
            var o = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return t[n].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
        }
        var r = {};
        return e.m = t, e.c = r, e.d = function(t, r, n) {
            e.o(t, r) || Object.defineProperty(t, r, {
                configurable: !1,
                enumerable: !0,
                get: n
            });
        }, e.n = function(t) {
            var r = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return e.d(r, "a", r), r;
        }, e.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, e.p = "", e(e.s = 43);
    }([
        function(t, e) {
            var r = Array.isArray;
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(22), o = "object" == typeof self && self && self.Object === Object && self, u = n || o || Function("return this")();
            t.exports = u;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = u(t, e);
                return o(r) ? r : void 0;
            }
            var o = r(75), u = r(78);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return null == t ? void 0 === t ? a : c : f && f in Object(t) ? u(t) : i(t);
            }
            var o = r(5), u = r(52), i = r(53), c = "[object Null]", a = "[object Undefined]", f = o ? o.toStringTag : void 0;
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return null != t && "object" == typeof t;
            }
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(1), o = n.Symbol;
            t.exports = o;
        },
        function(t, e, r) {
            function n(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.clear(); ++e < r;){
                    var n = t[e];
                    this.set(n[0], n[1]);
                }
            }
            var o = r(65), u = r(66), i = r(67), c = r(68), a = r(69);
            n.prototype.clear = o, n.prototype.delete = u, n.prototype.get = i, n.prototype.has = c, n.prototype.set = a, t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                for(var r = t.length; r--;)if (o(t[r][0], e)) return r;
                return -1;
            }
            var o = r(31);
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(2), o = n(Object, "create");
            t.exports = o;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = t.__data__;
                return o(e) ? r["string" == typeof e ? "string" : "hash"] : r.map;
            }
            var o = r(87);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                if ("string" == typeof t || o(t)) return t;
                var e = t + "";
                return "0" == e && 1 / t == -u ? "-0" : e;
            }
            var o = r(18), u = 1 / 0;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return i(t) ? o(t) : u(t);
            }
            var o = r(49), u = r(58), i = r(13);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return "number" == typeof t && t > -1 && t % 1 == 0 && t <= n;
            }
            var n = 9007199254740991;
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return null != t && u(t.length) && !o(t);
            }
            var o = r(28), u = r(12);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = typeof t;
                return null != t && ("object" == e || "function" == e);
            }
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "Map");
            t.exports = u;
        },
        function(t, e, r) {
            function n(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.clear(); ++e < r;){
                    var n = t[e];
                    this.set(n[0], n[1]);
                }
            }
            var o = r(79), u = r(86), i = r(88), c = r(89), a = r(90);
            n.prototype.clear = o, n.prototype.delete = u, n.prototype.get = i, n.prototype.has = c, n.prototype.set = a, t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                if (o(t)) return !1;
                var r = typeof t;
                return !("number" != r && "symbol" != r && "boolean" != r && null != t && !u(t)) || c.test(t) || !i.test(t) || null != e && t in Object(e);
            }
            var o = r(0), u = r(18), i = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, c = /^\w*$/;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return "symbol" == typeof t || u(t) && o(t) == i;
            }
            var o = r(3), u = r(4), i = "[object Symbol]";
            t.exports = n;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }
            function o(t) {
                return !isNaN(parseInt(t, 10));
            }
            function u(t) {
                return new RegExp("[A-Z0-9]+-\\d+").test(t);
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var i = r(44), c = n(i), a = r(127), f = n(a), s = r(129), p = n(s), l = r(42);
            e.default = function(t) {
                var e = (0, p.default)([
                    t.module,
                    t.item,
                    t.secondaryItem,
                    t.tertiaryItem,
                    t.quaternaryItem,
                    t.quinternaryItem
                ]), r = (0, f.default)(e, function(t) {
                    return o(t) ? "ENTITY_ID" : u(t) ? "ISSUE_KEY" : t;
                }).join(".");
                return (0, c.default)((0, l.getKeyTransformers)(), function(t, e) {
                    return e(t);
                }, r);
            };
        },
        function(t, e, r) {
            var n = r(46), o = r(62), u = o(n);
            t.exports = u;
        },
        function(t, e, r) {
            var n = r(51), o = r(4), u = Object.prototype, i = u.hasOwnProperty, c = u.propertyIsEnumerable, a = n(function() {
                return arguments;
            }()) ? n : function(t) {
                return o(t) && i.call(t, "callee") && !c.call(t, "callee");
            };
            t.exports = a;
        },
        function(t, e, r) {
            (function(e) {
                var r = "object" == typeof e && e && e.Object === Object && e;
                t.exports = r;
            }).call(e, r(23));
        },
        function(t, e) {
            var r;
            r = function() {
                return this;
            }();
            try {
                r = r || Function("return this")() || (0, eval)("this");
            } catch (t) {
                "object" == typeof window && (r = window);
            }
            t.exports = r;
        },
        function(t, e, r) {
            (function(t) {
                var n = r(1), o = r(54), u = "object" == typeof e && e && !e.nodeType && e, i = u && "object" == typeof t && t && !t.nodeType && t, c = i && i.exports === u, a = c ? n.Buffer : void 0, f = a ? a.isBuffer : void 0, s = f || o;
                t.exports = s;
            }).call(e, r(25)(t));
        },
        function(t, e) {
            t.exports = function(t) {
                return t.webpackPolyfill || (t.deprecate = function() {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
                    enumerable: !0,
                    get: function() {
                        return t.l;
                    }
                }), Object.defineProperty(t, "id", {
                    enumerable: !0,
                    get: function() {
                        return t.i;
                    }
                }), t.webpackPolyfill = 1), t;
            };
        },
        function(t, e) {
            function r(t, e) {
                var r = typeof t;
                return !!(e = null == e ? n : e) && ("number" == r || "symbol" != r && o.test(t)) && t > -1 && t % 1 == 0 && t < e;
            }
            var n = 9007199254740991, o = /^(?:0|[1-9]\d*)$/;
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(55), o = r(56), u = r(57), i = u && u.isTypedArray, c = i ? o(i) : n;
            t.exports = c;
        },
        function(t, e, r) {
            function n(t) {
                if (!u(t)) return !1;
                var e = o(t);
                return e == c || e == a || e == i || e == f;
            }
            var o = r(3), u = r(14), i = "[object AsyncFunction]", c = "[object Function]", a = "[object GeneratorFunction]", f = "[object Proxy]";
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return "function" == typeof t ? t : null == t ? i : "object" == typeof t ? c(t) ? u(t[0], t[1]) : o(t) : a(t);
            }
            var o = r(63), u = r(114), i = r(41), c = r(0), a = r(123);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__ = new o(t);
                this.size = e.size;
            }
            var o = r(6), u = r(70), i = r(71), c = r(72), a = r(73), f = r(74);
            n.prototype.clear = u, n.prototype.delete = i, n.prototype.get = c, n.prototype.has = a, n.prototype.set = f, t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                return t === e || t !== t && e !== e;
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                if (null != t) {
                    try {
                        return o.call(t);
                    } catch (t) {}
                    try {
                        return t + "";
                    } catch (t) {}
                }
                return "";
            }
            var n = Function.prototype, o = n.toString;
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e, r, i, c) {
                return t === e || (null == t || null == e || !u(t) && !u(e) ? t !== t && e !== e : o(t, e, r, i, n, c));
            }
            var o = r(91), u = r(4);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r, n, f, s) {
                var p = r & c, l = t.length, v = e.length;
                if (l != v && !(p && v > l)) return !1;
                var d = s.get(t);
                if (d && s.get(e)) return d == e;
                var y = -1, h = !0, b = r & a ? new o : void 0;
                for(s.set(t, e), s.set(e, t); ++y < l;){
                    var x = t[y], _ = e[y];
                    if (n) var j = p ? n(_, x, y, e, t, s) : n(x, _, y, t, e, s);
                    if (void 0 !== j) {
                        if (j) continue;
                        h = !1;
                        break;
                    }
                    if (b) {
                        if (!u(e, function(t, e) {
                            if (!i(b, e) && (x === t || f(x, t, r, n, s))) return b.push(e);
                        })) {
                            h = !1;
                            break;
                        }
                    } else if (x !== _ && !f(x, _, r, n, s)) {
                        h = !1;
                        break;
                    }
                }
                return s.delete(t), s.delete(e), h;
            }
            var o = r(92), u = r(95), i = r(96), c = 1, a = 2;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return t === t && !o(t);
            }
            var o = r(14);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                return function(r) {
                    return null != r && r[t] === e && (void 0 !== e || t in Object(r));
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                e = o(e, t);
                for(var r = 0, n = e.length; null != t && r < n;)t = t[u(e[r++])];
                return r && r == n ? t : void 0;
            }
            var o = r(38), u = r(10);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                return o(t) ? t : u(t, e) ? [
                    t
                ] : i(c(t));
            }
            var o = r(0), u = r(17), i = r(116), c = r(119);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = null == t ? 0 : t.length, o = Array(n); ++r < n;)o[r] = e(t[r], r, t);
                return o;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e, r) {
                e = o(e, t);
                for(var n = -1, s = e.length, p = !1; ++n < s;){
                    var l = f(e[n]);
                    if (!(p = null != t && r(t, l))) break;
                    t = t[l];
                }
                return p || ++n != s ? p : !!(s = null == t ? 0 : t.length) && a(s) && c(l, s) && (i(t) || u(t));
            }
            var o = r(38), u = r(21), i = r(0), c = r(26), a = r(12), f = r(10);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return t;
            }
            t.exports = r;
        },
        function(t, e, r) {
            "use strict";
            (function(t) {
                function n(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                }
                function o(t, e, r) {
                    return e in t ? Object.defineProperty(t, e, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t[e] = r, t;
                }
                function u(e, r) {
                    t.window._jsdApdex ? (0, d.default)(t.window._jsdApdex, e) || (t.window._jsdApdex[e] = r) : t.window._jsdApdex = o({}, e, r);
                }
                function i() {
                    return t.window._jsdApdex || {};
                }
                function c(t) {
                    u("metricsRecorder", t);
                }
                function a() {
                    return i().metricsRecorder ? i().metricsRecorder : (console.error("APDEX metrics recorder not initialized. Not recording APDEX."), {
                        start: l.default,
                        end: l.default
                    });
                }
                function f(t) {
                    u("keyTransformers", t);
                }
                function s() {
                    return i().keyTransformers || [];
                }
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var p = r(41), l = n(p), v = r(130), d = n(v);
                e.installMetricsRecorder = c, e.getMetricsRecorder = a, e.installKeyTransformers = f, e.getKeyTransformers = s;
            }).call(e, r(23));
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }
            function o(t) {
                return "object" === (void 0 === t ? "undefined" : f(t)) ? (0, p.default)(t) : "string" == typeof t ? (0, v.default)(t) : "";
            }
            function u(t, e) {
                (0, y.installMetricsRecorder)(t), (0, y.installKeyTransformers)(e);
            }
            function i(t, e) {
                var r = o(t);
                return (0, d.withStartEventFiltering)(r, function(t) {
                    (0, y.getMetricsRecorder)().start(t, e);
                });
            }
            function c(t) {
                var e = o(t);
                return (0, d.withEndEventFiltering)(e, function(t) {
                    (0, y.getMetricsRecorder)().end(t);
                });
            }
            function a(t) {
                return c(t);
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.getExpectedRedirect = e.hasExpectedRedirect = e.hasExpectedRedirectOf = void 0;
            var f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            };
            e.install = u, e.start = i, e.end = c, e.readyForUser = a;
            var s = r(19), p = n(s), l = r(132), v = n(l), d = r(133), y = r(42);
            e.hasExpectedRedirectOf = d.hasExpectedRedirectOf, e.hasExpectedRedirect = d.hasExpectedRedirect, e.getExpectedRedirect = d.getExpectedRedirect;
        },
        function(t, e, r) {
            function n(t, e, r) {
                var n = a(t) ? o : c, f = arguments.length < 3;
                return n(t, i(e, 4), r, f, u);
            }
            var o = r(45), u = r(20), i = r(29), c = r(126), a = r(0);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e, r, n) {
                var o = -1, u = null == t ? 0 : t.length;
                for(n && u && (r = t[++o]); ++o < u;)r = e(r, t[o], o, t);
                return r;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                return t && o(t, e, u);
            }
            var o = r(47), u = r(11);
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(48), o = n();
            t.exports = o;
        },
        function(t, e) {
            function r(t) {
                return function(e, r, n) {
                    for(var o = -1, u = Object(e), i = n(e), c = i.length; c--;){
                        var a = i[t ? c : ++o];
                        if (!1 === r(u[a], a, u)) break;
                    }
                    return e;
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = i(t), n = !r && u(t), s = !r && !n && c(t), l = !r && !n && !s && f(t), v = r || n || s || l, d = v ? o(t.length, String) : [], y = d.length;
                for(var h in t)!e && !p.call(t, h) || v && ("length" == h || s && ("offset" == h || "parent" == h) || l && ("buffer" == h || "byteLength" == h || "byteOffset" == h) || a(h, y)) || d.push(h);
                return d;
            }
            var o = r(50), u = r(21), i = r(0), c = r(24), a = r(26), f = r(27), s = Object.prototype, p = s.hasOwnProperty;
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = Array(t); ++r < t;)n[r] = e(r);
                return n;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return u(t) && o(t) == i;
            }
            var o = r(3), u = r(4), i = "[object Arguments]";
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = i.call(t, a), r = t[a];
                try {
                    t[a] = void 0;
                    var n = !0;
                } catch (t) {}
                var o = c.call(t);
                return n && (e ? t[a] = r : delete t[a]), o;
            }
            var o = r(5), u = Object.prototype, i = u.hasOwnProperty, c = u.toString, a = o ? o.toStringTag : void 0;
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return o.call(t);
            }
            var n = Object.prototype, o = n.toString;
            t.exports = r;
        },
        function(t, e) {
            function r() {
                return !1;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return i(t) && u(t.length) && !!c[o(t)];
            }
            var o = r(3), u = r(12), i = r(4), c = {};
            c["[object Float32Array]"] = c["[object Float64Array]"] = c["[object Int8Array]"] = c["[object Int16Array]"] = c["[object Int32Array]"] = c["[object Uint8Array]"] = c["[object Uint8ClampedArray]"] = c["[object Uint16Array]"] = c["[object Uint32Array]"] = !0, c["[object Arguments]"] = c["[object Array]"] = c["[object ArrayBuffer]"] = c["[object Boolean]"] = c["[object DataView]"] = c["[object Date]"] = c["[object Error]"] = c["[object Function]"] = c["[object Map]"] = c["[object Number]"] = c["[object Object]"] = c["[object RegExp]"] = c["[object Set]"] = c["[object String]"] = c["[object WeakMap]"] = !1, t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return function(e) {
                    return t(e);
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            (function(t) {
                var n = r(22), o = "object" == typeof e && e && !e.nodeType && e, u = o && "object" == typeof t && t && !t.nodeType && t, i = u && u.exports === o, c = i && n.process, a = function() {
                    try {
                        var t = u && u.require && u.require("util").types;
                        return t || c && c.binding && c.binding("util");
                    } catch (t) {}
                }();
                t.exports = a;
            }).call(e, r(25)(t));
        },
        function(t, e, r) {
            function n(t) {
                if (!o(t)) return u(t);
                var e = [];
                for(var r in Object(t))c.call(t, r) && "constructor" != r && e.push(r);
                return e;
            }
            var o = r(59), u = r(60), i = Object.prototype, c = i.hasOwnProperty;
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = t && t.constructor;
                return t === ("function" == typeof e && e.prototype || n);
            }
            var n = Object.prototype;
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(61), o = n(Object.keys, Object);
            t.exports = o;
        },
        function(t, e) {
            function r(t, e) {
                return function(r) {
                    return t(e(r));
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                return function(r, n) {
                    if (null == r) return r;
                    if (!o(r)) return t(r, n);
                    for(var u = r.length, i = e ? u : -1, c = Object(r); (e ? i-- : ++i < u) && !1 !== n(c[i], i, c););
                    return r;
                };
            }
            var o = r(13);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = u(t);
                return 1 == e.length && e[0][2] ? i(e[0][0], e[0][1]) : function(r) {
                    return r === t || o(r, t, e);
                };
            }
            var o = r(64), u = r(113), i = r(36);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r, n) {
                var a = r.length, f = a, s = !n;
                if (null == t) return !f;
                for(t = Object(t); a--;){
                    var p = r[a];
                    if (s && p[2] ? p[1] !== t[p[0]] : !(p[0] in t)) return !1;
                }
                for(; ++a < f;){
                    p = r[a];
                    var l = p[0], v = t[l], d = p[1];
                    if (s && p[2]) {
                        if (void 0 === v && !(l in t)) return !1;
                    } else {
                        var y = new o;
                        if (n) var h = n(v, d, l, t, e, y);
                        if (!(void 0 === h ? u(d, v, i | c, n, y) : h)) return !1;
                    }
                }
                return !0;
            }
            var o = r(30), u = r(33), i = 1, c = 2;
            t.exports = n;
        },
        function(t, e) {
            function r() {
                this.__data__ = [], this.size = 0;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__, r = o(e, t);
                return !(r < 0) && (r == e.length - 1 ? e.pop() : i.call(e, r, 1), --this.size, !0);
            }
            var o = r(7), u = Array.prototype, i = u.splice;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__, r = o(e, t);
                return r < 0 ? void 0 : e[r][1];
            }
            var o = r(7);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return o(this.__data__, t) > -1;
            }
            var o = r(7);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = this.__data__, n = o(r, t);
                return n < 0 ? (++this.size, r.push([
                    t,
                    e
                ])) : r[n][1] = e, this;
            }
            var o = r(7);
            t.exports = n;
        },
        function(t, e, r) {
            function n() {
                this.__data__ = new o, this.size = 0;
            }
            var o = r(6);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = this.__data__, r = e.delete(t);
                return this.size = e.size, r;
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                return this.__data__.get(t);
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                return this.__data__.has(t);
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = this.__data__;
                if (r instanceof o) {
                    var n = r.__data__;
                    if (!u || n.length < c - 1) return n.push([
                        t,
                        e
                    ]), this.size = ++r.size, this;
                    r = this.__data__ = new i(n);
                }
                return r.set(t, e), this.size = r.size, this;
            }
            var o = r(6), u = r(15), i = r(16), c = 200;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return !(!i(t) || u(t)) && (o(t) ? d : f).test(c(t));
            }
            var o = r(28), u = r(76), i = r(14), c = r(32), a = /[\\^$.*+?()[\]{}|]/g, f = /^\[object .+?Constructor\]$/, s = Function.prototype, p = Object.prototype, l = s.toString, v = p.hasOwnProperty, d = RegExp("^" + l.call(v).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return !!u && u in t;
            }
            var o = r(77), u = function() {
                var t = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "");
                return t ? "Symbol(src)_1." + t : "";
            }();
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(1), o = n["__core-js_shared__"];
            t.exports = o;
        },
        function(t, e) {
            function r(t, e) {
                return null == t ? void 0 : t[e];
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n() {
                this.size = 0, this.__data__ = {
                    hash: new o,
                    map: new (i || u),
                    string: new o
                };
            }
            var o = r(80), u = r(6), i = r(15);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.clear(); ++e < r;){
                    var n = t[e];
                    this.set(n[0], n[1]);
                }
            }
            var o = r(81), u = r(82), i = r(83), c = r(84), a = r(85);
            n.prototype.clear = o, n.prototype.delete = u, n.prototype.get = i, n.prototype.has = c, n.prototype.set = a, t.exports = n;
        },
        function(t, e, r) {
            function n() {
                this.__data__ = o ? o(null) : {}, this.size = 0;
            }
            var o = r(8);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = this.has(t) && delete this.__data__[t];
                return this.size -= e ? 1 : 0, e;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__;
                if (o) {
                    var r = e[t];
                    return r === u ? void 0 : r;
                }
                return c.call(e, t) ? e[t] : void 0;
            }
            var o = r(8), u = "__lodash_hash_undefined__", i = Object.prototype, c = i.hasOwnProperty;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__;
                return o ? void 0 !== e[t] : i.call(e, t);
            }
            var o = r(8), u = Object.prototype, i = u.hasOwnProperty;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = this.__data__;
                return this.size += this.has(t) ? 0 : 1, r[t] = o && void 0 === e ? u : e, this;
            }
            var o = r(8), u = "__lodash_hash_undefined__";
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = o(this, t).delete(t);
                return this.size -= e ? 1 : 0, e;
            }
            var o = r(9);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = typeof t;
                return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return o(this, t).get(t);
            }
            var o = r(9);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return o(this, t).has(t);
            }
            var o = r(9);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = o(this, t), n = r.size;
                return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
            }
            var o = r(9);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r, n, h, x) {
                var _ = f(t), j = f(e), g = _ ? d : a(t), m = j ? d : a(e);
                g = g == v ? y : g, m = m == v ? y : m;
                var w = g == y, O = m == y, A = g == m;
                if (A && s(t)) {
                    if (!s(e)) return !1;
                    _ = !0, w = !1;
                }
                if (A && !w) return x || (x = new o), _ || p(t) ? u(t, e, r, n, h, x) : i(t, e, g, r, n, h, x);
                if (!(r & l)) {
                    var E = w && b.call(t, "__wrapped__"), P = O && b.call(e, "__wrapped__");
                    if (E || P) {
                        var R = E ? t.value() : t, S = P ? e.value() : e;
                        return x || (x = new o), h(R, S, r, n, x);
                    }
                }
                return !!A && (x || (x = new o), c(t, e, r, n, h, x));
            }
            var o = r(30), u = r(34), i = r(97), c = r(101), a = r(108), f = r(0), s = r(24), p = r(27), l = 1, v = "[object Arguments]", d = "[object Array]", y = "[object Object]", h = Object.prototype, b = h.hasOwnProperty;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.__data__ = new o; ++e < r;)this.add(t[e]);
            }
            var o = r(16), u = r(93), i = r(94);
            n.prototype.add = n.prototype.push = u, n.prototype.has = i, t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return this.__data__.set(t, n), this;
            }
            var n = "__lodash_hash_undefined__";
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                return this.__data__.has(t);
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = null == t ? 0 : t.length; ++r < n;)if (e(t[r], r, t)) return !0;
                return !1;
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t, e) {
                return t.has(e);
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e, r, n, o, w, A) {
                switch(r){
                    case m:
                        if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
                        t = t.buffer, e = e.buffer;
                    case g:
                        return !(t.byteLength != e.byteLength || !w(new u(t), new u(e)));
                    case l:
                    case v:
                    case h:
                        return i(+t, +e);
                    case d:
                        return t.name == e.name && t.message == e.message;
                    case b:
                    case _:
                        return t == e + "";
                    case y:
                        var E = a;
                    case x:
                        var P = n & s;
                        if (E || (E = f), t.size != e.size && !P) return !1;
                        var R = A.get(t);
                        if (R) return R == e;
                        n |= p, A.set(t, e);
                        var S = c(E(t), E(e), n, o, w, A);
                        return A.delete(t), S;
                    case j:
                        if (O) return O.call(t) == O.call(e);
                }
                return !1;
            }
            var o = r(5), u = r(98), i = r(31), c = r(34), a = r(99), f = r(100), s = 1, p = 2, l = "[object Boolean]", v = "[object Date]", d = "[object Error]", y = "[object Map]", h = "[object Number]", b = "[object RegExp]", x = "[object Set]", _ = "[object String]", j = "[object Symbol]", g = "[object ArrayBuffer]", m = "[object DataView]", w = o ? o.prototype : void 0, O = w ? w.valueOf : void 0;
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(1), o = n.Uint8Array;
            t.exports = o;
        },
        function(t, e) {
            function r(t) {
                var e = -1, r = Array(t.size);
                return t.forEach(function(t, n) {
                    r[++e] = [
                        n,
                        t
                    ];
                }), r;
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                var e = -1, r = Array(t.size);
                return t.forEach(function(t) {
                    r[++e] = t;
                }), r;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e, r, n, i, a) {
                var f = r & u, s = o(t), p = s.length;
                if (p != o(e).length && !f) return !1;
                for(var l = p; l--;){
                    var v = s[l];
                    if (!(f ? v in e : c.call(e, v))) return !1;
                }
                var d = a.get(t);
                if (d && a.get(e)) return d == e;
                var y = !0;
                a.set(t, e), a.set(e, t);
                for(var h = f; ++l < p;){
                    v = s[l];
                    var b = t[v], x = e[v];
                    if (n) var _ = f ? n(x, b, v, e, t, a) : n(b, x, v, t, e, a);
                    if (!(void 0 === _ ? b === x || i(b, x, r, n, a) : _)) {
                        y = !1;
                        break;
                    }
                    h || (h = "constructor" == v);
                }
                if (y && !h) {
                    var j = t.constructor, g = e.constructor;
                    j != g && "constructor" in t && "constructor" in e && !("function" == typeof j && j instanceof j && "function" == typeof g && g instanceof g) && (y = !1);
                }
                return a.delete(t), a.delete(e), y;
            }
            var o = r(102), u = 1, i = Object.prototype, c = i.hasOwnProperty;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return o(t, i, u);
            }
            var o = r(103), u = r(105), i = r(11);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r) {
                var n = e(t);
                return u(t) ? n : o(n, r(t));
            }
            var o = r(104), u = r(0);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = e.length, o = t.length; ++r < n;)t[o + r] = e[r];
                return t;
            }
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(106), o = r(107), u = Object.prototype, i = u.propertyIsEnumerable, c = Object.getOwnPropertySymbols, a = c ? function(t) {
                return null == t ? [] : (t = Object(t), n(c(t), function(e) {
                    return i.call(t, e);
                }));
            } : o;
            t.exports = a;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = null == t ? 0 : t.length, o = 0, u = []; ++r < n;){
                    var i = t[r];
                    e(i, r, t) && (u[o++] = i);
                }
                return u;
            }
            t.exports = r;
        },
        function(t, e) {
            function r() {
                return [];
            }
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(109), o = r(15), u = r(110), i = r(111), c = r(112), a = r(3), f = r(32), s = f(n), p = f(o), l = f(u), v = f(i), d = f(c), y = a;
            (n && "[object DataView]" != y(new n(new ArrayBuffer(1))) || o && "[object Map]" != y(new o) || u && "[object Promise]" != y(u.resolve()) || i && "[object Set]" != y(new i) || c && "[object WeakMap]" != y(new c)) && (y = function(t) {
                var e = a(t), r = "[object Object]" == e ? t.constructor : void 0, n = r ? f(r) : "";
                if (n) switch(n){
                    case s:
                        return "[object DataView]";
                    case p:
                        return "[object Map]";
                    case l:
                        return "[object Promise]";
                    case v:
                        return "[object Set]";
                    case d:
                        return "[object WeakMap]";
                }
                return e;
            }), t.exports = y;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "DataView");
            t.exports = u;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "Promise");
            t.exports = u;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "Set");
            t.exports = u;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "WeakMap");
            t.exports = u;
        },
        function(t, e, r) {
            function n(t) {
                for(var e = u(t), r = e.length; r--;){
                    var n = e[r], i = t[n];
                    e[r] = [
                        n,
                        i,
                        o(i)
                    ];
                }
                return e;
            }
            var o = r(35), u = r(11);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                return c(t) && a(e) ? f(s(t), e) : function(r) {
                    var n = u(r, t);
                    return void 0 === n && n === e ? i(r, t) : o(e, n, p | l);
                };
            }
            var o = r(33), u = r(115), i = r(121), c = r(17), a = r(35), f = r(36), s = r(10), p = 1, l = 2;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r) {
                var n = null == t ? void 0 : o(t, e);
                return void 0 === n ? r : n;
            }
            var o = r(37);
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(117), o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, u = /\\(\\)?/g, i = n(function(t) {
                var e = [];
                return 46 === t.charCodeAt(0) && e.push(""), t.replace(o, function(t, r, n, o) {
                    e.push(n ? o.replace(u, "$1") : r || t);
                }), e;
            });
            t.exports = i;
        },
        function(t, e, r) {
            function n(t) {
                var e = o(t, function(t) {
                    return r.size === u && r.clear(), t;
                }), r = e.cache;
                return e;
            }
            var o = r(118), u = 500;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError(u);
                var r = function() {
                    var n = arguments, o = e ? e.apply(this, n) : n[0], u = r.cache;
                    if (u.has(o)) return u.get(o);
                    var i = t.apply(this, n);
                    return r.cache = u.set(o, i) || u, i;
                };
                return r.cache = new (n.Cache || o), r;
            }
            var o = r(16), u = "Expected a function";
            n.Cache = o, t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return null == t ? "" : o(t);
            }
            var o = r(120);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                if ("string" == typeof t) return t;
                if (i(t)) return u(t, n) + "";
                if (c(t)) return s ? s.call(t) : "";
                var e = t + "";
                return "0" == e && 1 / t == -a ? "-0" : e;
            }
            var o = r(5), u = r(39), i = r(0), c = r(18), a = 1 / 0, f = o ? o.prototype : void 0, s = f ? f.toString : void 0;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                return null != t && u(t, e, o);
            }
            var o = r(122), u = r(40);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                return null != t && e in Object(t);
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return i(t) ? o(c(t)) : u(t);
            }
            var o = r(124), u = r(125), i = r(17), c = r(10);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return function(e) {
                    return null == e ? void 0 : e[t];
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return function(e) {
                    return o(e, t);
                };
            }
            var o = r(37);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e, r, n, o) {
                return o(t, function(t, o, u) {
                    r = n ? (n = !1, t) : e(r, t, o, u);
                }), r;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                return (c(t) ? o : i)(t, u(e, 3));
            }
            var o = r(39), u = r(29), i = r(128), c = r(0);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = -1, n = u(t) ? Array(t.length) : [];
                return o(t, function(t, o, u) {
                    n[++r] = e(t, o, u);
                }), n;
            }
            var o = r(20), u = r(13);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                for(var e = -1, r = null == t ? 0 : t.length, n = 0, o = []; ++e < r;){
                    var u = t[e];
                    u && (o[n++] = u);
                }
                return o;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                return null != t && u(t, e, o);
            }
            var o = r(131), u = r(40);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                return null != t && o.call(t, e);
            }
            var n = Object.prototype, o = n.hasOwnProperty;
            t.exports = r;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                if (Array.isArray(t)) {
                    for(var e = 0, r = Array(t.length); e < t.length; e++)r[e] = t[e];
                    return r;
                }
                return Array.from(t);
            }
            function o(t) {
                return f.test(t) ? t.replace(f, "") : s.test(t) ? t.replace(s, "") : p.test(t) ? t.replace(p, "") : t.substr(1);
            }
            function u(t, e, r, n, o, u) {
                return {
                    module: t,
                    item: e,
                    secondaryItem: r,
                    tertiaryItem: n,
                    quaternaryItem: o,
                    quinternaryItem: u
                };
            }
            function i(t) {
                var e = o(t);
                return u.apply(void 0, n(e.split("/")));
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.stateFromRoute = i;
            var c = r(19), a = function(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }(c), f = /^\/servicedesk\/admin\/[A-Z][A-Z0-9]{1,9}\//, s = /^\/projects\/[A-Z][A-Z0-9]{1,9}\//, p = /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]{1,9}\//;
            e.default = function(t) {
                return (0, a.default)(i(t));
            };
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = RegExp("\\.REDIRECT$"), o = void 0, u = e.getExpectedRedirect = function(t) {
                return t.replace(n, "");
            }, i = e.hasExpectedRedirect = function(t) {
                return n.test(t);
            }, c = (e.hasExpectedRedirectOf = function(t) {
                return t + ".REDIRECT";
            }, function(t) {
                return i(t) ? o = u(t) : (o = void 0, t);
            });
            e.resetSuppressedEvent = function() {
                o = void 0;
            }, e.withStartEventFiltering = function(t, e) {
                if (u(t) === o) return c(t);
                var r = c(t);
                return e(r), r;
            }, e.withEndEventFiltering = function(t, e) {
                return i(t) ? u(t) : (e(t), t);
            };
        }
    ]);
});

});


parcelRegister("bXcRu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f03ee64bae1c8b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $4q38b = parcelRequire("4q38b");

var $3QLcd = parcelRequire("3QLcd");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $1MRnf = parcelRequire("1MRnf");

var $ctR9z = parcelRequire("ctR9z");

var $jMP2a = parcelRequire("jMP2a");

var $1L8BM = parcelRequire("1L8BM");

var $1digo = parcelRequire("1digo");

var $9i2A3 = parcelRequire("9i2A3");

var $8kDTt = parcelRequire("8kDTt");


var $f1xGd = parcelRequire("f1xGd");
const $6f03ee64bae1c8b5$export$fdbb6e83492670a7 = (props)=>{
    const { category: category, projectId: projectId, showCTA: showCTA = true } = props;
    const [practices] = (0, $1L8BM.usePracticeList)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const isDarkMode = colorMode === 'dark';
    const openCreateIssueDialogModern = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'emptyQueueCreateIssueButton', {
            isAnyWorkCategoryEnabled: false
        });
        openIssueCreateModal({
            triggerPointKey: (0, $1MRnf.JSM_EMPTY_QUEUE_CREATE_REQUEST)
        });
    }, [
        openIssueCreateModal
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // If ITSM Project, render the ITSM empty states
    if (category !== undefined && practices && practices.length > 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8kDTt.EmptyPracticeQueue), {
        projectId: projectId
    });
    const IPHButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
        articleId: "5b7BuVaVJqmbyCZ2mbMYHD",
        appearance: "link",
        spacing: "none",
        fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            target: "_blank",
            href: (0, $522cdb54b2056500$export$f960f87b7b043226)
        }, formatMessage((0, $f1xGd.default).emptyQueueLearnMoreText))
    }, formatMessage((0, $f1xGd.default).emptyQueueLearnMoreText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $f1xGd.default).emptyQueueHeader),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $f1xGd.default).emptyQueueDescription,
            values: {
                // @ts-expect-error - Type '(chunks: string) => JSX.Element' is not assignable to type 'ReactNode'.
                p: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, chunks),
                IPHArticle: IPHButton,
                break: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null)
            }
        }),
        imageUrl: isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($9i2A3))) : (0, (/*@__PURE__*/$parcel$interopDefault($1digo))),
        maxImageWidth: (0, $522cdb54b2056500$export$caaf33f9dba14d10),
        maxImageHeight: (0, $522cdb54b2056500$export$3465603c26b84396),
        primaryAction: showCTA ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            onClick: openCreateIssueDialogModern,
            "data-pid": projectId,
            testId: "servicedesk-queues-empty-queue.create-issue-button"
        }, formatMessage((0, $f1xGd.default).emptyQueueButtonLabel)) : undefined
    });
};
var $6f03ee64bae1c8b5$export$2e2bcd8739ae039 = $6f03ee64bae1c8b5$export$fdbb6e83492670a7;

});
parcelRegister("3QLcd", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $82adde900735644c$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $82adde900735644c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $cEaY5 = parcelRequire("cEaY5");

var $zcJ0y = parcelRequire("zcJ0y");

var $1ybV0 = parcelRequire("1ybV0");

var $f2Poq = parcelRequire("f2Poq");

var $1zRTT = parcelRequire("1zRTT");

var $bUi2Q = parcelRequire("bUi2Q");
const $82adde900735644c$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $1zRTT.useHelpPanelActions)();
    const isIphEnabled = (0, $1ybV0.ff)('iph.enabled') && !(0, $zcJ0y.isIE11)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $f2Poq.HELP_PANEL_ID), (0, $f2Poq.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            }
        });
    };
    return isIphEnabled ? handleOnClick : undefined;
};
const $82adde900735644c$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, ...props })=>{
    const onOpenInProductHelpArticle = $82adde900735644c$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle?.(articleId, (0, $cEaY5.ARTICLE_TYPE)[type]);
    };
    return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $7JEyt.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallbackComponent);
};
var $82adde900735644c$export$2e2bcd8739ae039 = $82adde900735644c$var$HelpPanelLink;
const $82adde900735644c$var$buttonWrapperStyles = null;

});

parcelRegister("1MRnf", function(module, exports) {

$parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", () => $33ffe55cb7bcdadc$export$a05673a22505d5ee);
$parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", () => $33ffe55cb7bcdadc$export$c78d329777576aa0);
$parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", () => $33ffe55cb7bcdadc$export$affdc3af7a9a4677);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", () => $33ffe55cb7bcdadc$export$7e9cfd1f59e60910);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", () => $33ffe55cb7bcdadc$export$708499dcd016e5e9);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", () => $33ffe55cb7bcdadc$export$e1c8789144c4c810);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", () => $33ffe55cb7bcdadc$export$c5afabb7a17e802);
$parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$2086a63173b79b56);
$parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$fe1e5e4597147709);
$parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$9bc326812a93707);
$parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", () => $33ffe55cb7bcdadc$export$f352934e06f44599);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", () => $33ffe55cb7bcdadc$export$6ae07c77acc64360);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", () => $33ffe55cb7bcdadc$export$b41d0684e4b6ab1);
$parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", () => $33ffe55cb7bcdadc$export$be9b2b1329ff7ec9);
$parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", () => $33ffe55cb7bcdadc$export$aa348159181703a0);
$parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", () => $33ffe55cb7bcdadc$export$f90eec3841adf619);
$parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", () => $33ffe55cb7bcdadc$export$718822a309bffada);
$parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", () => $33ffe55cb7bcdadc$export$2753dafac81e805c);
$parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", () => $33ffe55cb7bcdadc$export$7c4d5cc5711d9294);
$parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", () => $33ffe55cb7bcdadc$export$998dfc72404b9e14);
$parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", () => $33ffe55cb7bcdadc$export$fc180a4b5785d2f4);
$parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", () => $33ffe55cb7bcdadc$export$946ec0b21cb84fd0);
$parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", () => $33ffe55cb7bcdadc$export$5b97e2844e620e54);
$parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", () => $33ffe55cb7bcdadc$export$b99842c2cf46f6be);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", () => $33ffe55cb7bcdadc$export$8d987f6e80b74000);
$parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$8de9fa43731c4b5b);
$parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", () => $33ffe55cb7bcdadc$export$87249ccbfd10fb78);
$parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", () => $33ffe55cb7bcdadc$export$c0eeeb31d264de76);
$parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", () => $33ffe55cb7bcdadc$export$f546e18e46478c84);
$parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", () => $33ffe55cb7bcdadc$export$1784e634ba79f1f9);
$parcel$export(module.exports, "JWM_INLINE_CREATE", () => $33ffe55cb7bcdadc$export$145eb8935a34e85e);
$parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", () => $33ffe55cb7bcdadc$export$32648b574a536c8b);
$parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", () => $33ffe55cb7bcdadc$export$c0e2ab74dfaa67cc);
const $33ffe55cb7bcdadc$export$a05673a22505d5ee = 'forge-open-issue-create';
const $33ffe55cb7bcdadc$export$c78d329777576aa0 = 'global-create-button';
const $33ffe55cb7bcdadc$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $33ffe55cb7bcdadc$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $33ffe55cb7bcdadc$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $33ffe55cb7bcdadc$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $33ffe55cb7bcdadc$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $33ffe55cb7bcdadc$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $33ffe55cb7bcdadc$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $33ffe55cb7bcdadc$export$9bc326812a93707 = 'jsw-security-create-issue';
const $33ffe55cb7bcdadc$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $33ffe55cb7bcdadc$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $33ffe55cb7bcdadc$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $33ffe55cb7bcdadc$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $33ffe55cb7bcdadc$export$235b856f54db8916 = 'jwm-board-create-issue';
const $33ffe55cb7bcdadc$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $33ffe55cb7bcdadc$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $33ffe55cb7bcdadc$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $33ffe55cb7bcdadc$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $33ffe55cb7bcdadc$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $33ffe55cb7bcdadc$export$aa348159181703a0 = 'software-create-issue-dialog';
const $33ffe55cb7bcdadc$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $33ffe55cb7bcdadc$export$718822a309bffada = 'create-linked-issue-command-palette';
const $33ffe55cb7bcdadc$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $33ffe55cb7bcdadc$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $33ffe55cb7bcdadc$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $33ffe55cb7bcdadc$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $33ffe55cb7bcdadc$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $33ffe55cb7bcdadc$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $33ffe55cb7bcdadc$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $33ffe55cb7bcdadc$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $33ffe55cb7bcdadc$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $33ffe55cb7bcdadc$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $33ffe55cb7bcdadc$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $33ffe55cb7bcdadc$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $33ffe55cb7bcdadc$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $33ffe55cb7bcdadc$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $33ffe55cb7bcdadc$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $33ffe55cb7bcdadc$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $33ffe55cb7bcdadc$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $33ffe55cb7bcdadc$export$145eb8935a34e85e = 'jwm-inline-create';
const $33ffe55cb7bcdadc$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
const $33ffe55cb7bcdadc$export$818f24c6c32e18a = 'jira-calendar-create-issue';
const $33ffe55cb7bcdadc$export$f352408886aa304b = 'connect-app-ecosystem';
const $33ffe55cb7bcdadc$export$c0e2ab74dfaa67cc = {
    FIELD_IDS: [
        'description'
    ],
    TRIGGER_POINTS: [
        'service-desk-gen-ai-pir'
    ]
};

});

parcelRegister("ctR9z", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $bd445758cecbab8c$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $bd445758cecbab8c$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $bd445758cecbab8c$export$558a195c5bfe3787);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $dfh7z = parcelRequire("dfh7z");

var $dEMIg = parcelRequire("dEMIg");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ellXt = parcelRequire("ellXt");

var $lB25E = parcelRequire("lB25E");

var $WBLbN = parcelRequire("WBLbN");

var $1MRnf = parcelRequire("1MRnf");

var $4SS5k = parcelRequire("4SS5k");

var $dgsxZ = parcelRequire("dgsxZ");
const $bd445758cecbab8c$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $dEMIg.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $1MRnf.TRIGGER_POINT_KEY_NOT_DEFINED),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // optional component - Renders external component above form fields
    ExternalControls: undefined,
    // Analytics property for board with custom filter and icc enabled
    isCustomBoardWithIcc: false,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // Analytics property for board with swimlane enabled
    swimlaneMode: undefined,
    // prefilled custom Fields if any
    prefilledCustomFields: {}
};
const $bd445758cecbab8c$export$e324594224ef24da = {
    restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) (0, $dgsxZ.startGlobalIssueCreateMetrics)(isSubsequentLoad);
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $dgsxZ.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $bd445758cecbab8c$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...isDiscoverabilityPushEnabled && {
                        minimizableModalView: nextModalView,
                        persistentModalView: currentState.persistentModalView,
                        ...(0, $dgsxZ.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                    },
                    inProgressIssueID: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: currentState.isModalOpen,
                    ...nextState
                });
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                callbackPayload: undefined,
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $dfh7z.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            if (!(0, $1ybV0.ff)('linked-alerts-in-gic_onvr6')) return;
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $bd445758cecbab8c$var$store = (0, $WBLbN.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $bd445758cecbab8c$export$d4c72bab9d6cc13a,
    actions: $bd445758cecbab8c$export$e324594224ef24da
});
const $bd445758cecbab8c$var$useTriggerIssueCreateModalState = (0, $WBLbN.createStateHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$var$useTriggerIssueCreateModalActions = (0, $WBLbN.createActionsHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$export$71e0eb7b8a91a156 = ()=>{
    const createState = $bd445758cecbab8c$var$useTriggerIssueCreateModalState();
    const createActions = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $bd445758cecbab8c$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setSitePickerState: setSitePickerState }] = (0, $4SS5k.useSitePickerContext)();
    return (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        // overrideCloudId only used for embedded GIC
        if (nextState?.payload?.overrideCloudId && (0, $eI5EY.fg)('jira_ai_issue_create_site_user_preference')) // set cloudId inside the state if there's an override
        setSitePickerState({
            selectedCloudId: nextState?.payload?.overrideCloudId
        });
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal,
        setSitePickerState
    ]);
};
const $bd445758cecbab8c$export$4c674fe824b8f278 = (0, $WBLbN.createSubscriber)($bd445758cecbab8c$var$store);
function $bd445758cecbab8c$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $bd445758cecbab8c$export$71e0eb7b8a91a156();
        const { data: data } = (0, $lB25E.useResource)((0, $ellXt.gicOptInStatusResources));
        const currentIssueCreateVisibility = data && data?.gicOptInStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
            ...props
        });
    };
}

});
parcelRegister("dfh7z", function(module, exports) {

$parcel$export(module.exports, "CreateIssueUFOExperience", () => $5fd686e53a19cbe0$export$cd75c112ac11a83b);
$parcel$export(module.exports, "StatusFieldLoad", () => $5fd686e53a19cbe0$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $5fd686e53a19cbe0$export$70208657c8d471a7);
$parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", () => $5fd686e53a19cbe0$export$b2d8f8edec75f571);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $5fd686e53a19cbe0$export$cd75c112ac11a83b = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $5fd686e53a19cbe0$export$e890e797a25e655c = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $5fd686e53a19cbe0$export$70208657c8d471a7 = new (0, $kDfSL.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'modern-global-issue-create.modal.issue-submit'
});
const $5fd686e53a19cbe0$export$b2d8f8edec75f571 = new (0, $kDfSL.UFOExperience)('ecosystem-api-new-gic-prefilling', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'ecosystem-api-new-gic-prefilling'
});

});

parcelRegister("dEMIg", function(module, exports) {

$parcel$export(module.exports, "REQUIRED", () => $dd9f36fe091541c8$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $dd9f36fe091541c8$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $dd9f36fe091541c8$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $dd9f36fe091541c8$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $dd9f36fe091541c8$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $dd9f36fe091541c8$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $dd9f36fe091541c8$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $dd9f36fe091541c8$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $dd9f36fe091541c8$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $dd9f36fe091541c8$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $dd9f36fe091541c8$export$8170252f0ea43511);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $dd9f36fe091541c8$export$17bcab948893a9ba = 'worklog';
const $dd9f36fe091541c8$export$b1c05b34d317c074 = 'REQUIRED';
const $dd9f36fe091541c8$export$f10b32dfda12e96e = 'unknown';
const $dd9f36fe091541c8$export$e5e4b8c32e68dd0b = 'networkError';
const $dd9f36fe091541c8$export$2d06efb8146cd043 = 'graphQLError';
const $dd9f36fe091541c8$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $dd9f36fe091541c8$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $dd9f36fe091541c8$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $dd9f36fe091541c8$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $dd9f36fe091541c8$export$aac4661200ba4104 = 'worklog_startDate';
const $dd9f36fe091541c8$export$a23c32d5cf54cba0 = 'worklog_description';
const $dd9f36fe091541c8$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $dd9f36fe091541c8$export$63fd567c1d0aca19 = [
    ...$dd9f36fe091541c8$export$74ab3898ae683660,
    $dd9f36fe091541c8$export$a1a7caa1e4a73c9f,
    $dd9f36fe091541c8$export$cf70f9220e6a2f50,
    $dd9f36fe091541c8$export$aac4661200ba4104,
    $dd9f36fe091541c8$export$a23c32d5cf54cba0
];
const $dd9f36fe091541c8$export$983715bb9b0f9b2c = {
    [$dd9f36fe091541c8$export$17bcab948893a9ba]: $dd9f36fe091541c8$export$63fd567c1d0aca19
};
const $dd9f36fe091541c8$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $dd9f36fe091541c8$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $dd9f36fe091541c8$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $dd9f36fe091541c8$export$8170252f0ea43511 = 'QuickCreateIssue';

});

parcelRegister("4SS5k", function(module, exports) {

$parcel$export(module.exports, "useSitePickerContext", () => $fda55b41d7d37cf0$export$f8b5aae013e4cf77);

var $WBLbN = parcelRequire("WBLbN");
const $fda55b41d7d37cf0$export$d4c72bab9d6cc13a = {
    selectedCloudId: '',
    siteDomain: ''
};
const $fda55b41d7d37cf0$export$e324594224ef24da = {
    setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                selectedCloudId: selectedCloudId || '',
                siteDomain: siteDomain || ''
            });
        }
};
const $fda55b41d7d37cf0$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    name: 'issue.fields.site-picker',
    initialState: $fda55b41d7d37cf0$export$d4c72bab9d6cc13a,
    actions: $fda55b41d7d37cf0$export$e324594224ef24da
});
const $fda55b41d7d37cf0$export$f8b5aae013e4cf77 = (0, $WBLbN.createHook)($fda55b41d7d37cf0$export$6f57813fe9f31bf9);

});

parcelRegister("dgsxZ", function(module, exports) {

$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $b8d8e5356c7976a6$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $b8d8e5356c7976a6$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $b8d8e5356c7976a6$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $b8d8e5356c7976a6$export$720579602bb055a2);

var $dfh7z = parcelRequire("dfh7z");

var $fqKjL = parcelRequire("fqKjL");

var $hBkQt = parcelRequire("hBkQt");

var $75e8i = parcelRequire("75e8i");
const $b8d8e5356c7976a6$export$550b19803bc962ec = (isSubsequentLoad)=>{
    (0, $dfh7z.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $fqKjL.globalIssueCreateModalLoadSubsequent) : (0, $fqKjL.globalIssueCreateModalLoad);
    if (isSubsequentLoad) (0, $75e8i.default)('global-issue.create-modal-subsequent');
    else (0, $75e8i.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $hBkQt.startGlobalIssueCreateTTIWithAdjustments)();
};
const $b8d8e5356c7976a6$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $b8d8e5356c7976a6$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $b8d8e5356c7976a6$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};

});
parcelRegister("fqKjL", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $de2993c8c3fea479$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $de2993c8c3fea479$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $de2993c8c3fea479$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $de2993c8c3fea479$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $de2993c8c3fea479$export$c1592e4d8d98963e);

var $lNfG4 = parcelRequire("lNfG4");
const $de2993c8c3fea479$export$5a01a7fa84b239c8 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $de2993c8c3fea479$export$c50ad3c31b6fcfc6 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $de2993c8c3fea479$export$4b2382574525bb0f = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $de2993c8c3fea479$export$7839bdaa2f6a2385 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $de2993c8c3fea479$export$c1592e4d8d98963e = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("hBkQt", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $362542d6dd943f24$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $362542d6dd943f24$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $362542d6dd943f24$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $362542d6dd943f24$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $362542d6dd943f24$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $362542d6dd943f24$export$d86f4868694f2aa7);

var $lNfG4 = parcelRequire("lNfG4");

var $gGRYc = parcelRequire("gGRYc");
const $362542d6dd943f24$export$9f3d6f17e1da7874 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $362542d6dd943f24$export$457c9fb71ad5b3a9 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.start();
};
const $362542d6dd943f24$export$ef664dac649a716c = ()=>$362542d6dd943f24$export$9f3d6f17e1da7874.mark('gic-tti');
const $362542d6dd943f24$export$30ca4c461fab486c = (customData)=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $362542d6dd943f24$export$27f2445288b528c = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.cancel();
};
const $362542d6dd943f24$export$7a2709fc1e33401a = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $362542d6dd943f24$export$cf3893335c93e33b = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $362542d6dd943f24$export$d86f4868694f2aa7 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});
parcelRegister("gGRYc", function(module, exports) {

$parcel$export(module.exports, "TTIFFs", () => $05ae9ccc47102fc0$export$c396ba1504d97f3f);
const $05ae9ccc47102fc0$export$c396ba1504d97f3f = [];

});




parcelRegister("1digo", function(module, exports) {
module.exports = new URL("generic.28da7925.svg", import.meta.url).toString();

});

parcelRegister("9i2A3", function(module, exports) {
module.exports = new URL("genericDark.a2b43fbb.svg", import.meta.url).toString();

});

parcelRegister("8kDTt", function(module, exports) {

$parcel$export(module.exports, "EmptyPracticeQueue", () => $51b3faac207de34d$export$b66e73d71b13aaba);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $4Bees = parcelRequire("4Bees");

var $4q38b = parcelRequire("4q38b");

var $2BvS3 = parcelRequire("2BvS3");

var $eI5EY = parcelRequire("eI5EY");

var $4Es8k = parcelRequire("4Es8k");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1MRnf = parcelRequire("1MRnf");

var $ctR9z = parcelRequire("ctR9z");

var $jMP2a = parcelRequire("jMP2a");

var $9JkqP = parcelRequire("9JkqP");

var $f1lMr = parcelRequire("f1lMr");

var $fDE9L = parcelRequire("fDE9L");

var $lB25E = parcelRequire("lB25E");


var $agPZt = parcelRequire("agPZt");

var $beFnx = parcelRequire("beFnx");
const $51b3faac207de34d$var$openCreateIssueDialog = (queueCategory = (0, $f1lMr.NO_CATEGORY))=>(event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'emptyQueueCreateIssueButton', {
            queueCategory: queueCategory
        });
        const buttonElement = event.currentTarget;
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $2BvS3.loadBridge)({
            name: 'quick-edit/init/create-dialogs',
            wrmKeys: 'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue-bootstrap'
        }).then(({ showCreateDialog: showCreateDialog })=>{
            // the issue create dialog will read attributes off the event's target,
            // which in the case of our AK button could be the outer `button`, outer `span` or
            // or inner `span` so we reassign the target to the button so that those attributes
            // will always be present
            const eventWithButtonTarget = {
                ...event,
                target: buttonElement
            };
            showCreateDialog(eventWithButtonTarget);
        });
    };
const $51b3faac207de34d$export$6c775f6de634e0f7 = ()=>Boolean(window.IssueCreate && window.IssueCreate.Visibility && window.IssueCreate.Visibility.isEnabled);
const $51b3faac207de34d$export$b66e73d71b13aaba = (props)=>{
    const { projectId: projectId } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [practiceType] = (0, $lB25E.usePathParam)('practiceType');
    const practice = (0, $fDE9L.toItsmPractice)(practiceType);
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const openCreateIssueDialogModern = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'emptyQueueCreateIssueButton', {
            queueCategory: practice
        });
        openIssueCreateModal({
            triggerPointKey: (0, $1MRnf.JSM_EMPTY_QUEUE_CREATE_REQUEST)
        });
    }, [
        openIssueCreateModal,
        practice
    ]);
    const { data: data, loading: loading, error: error } = (0, $9JkqP.default)(projectId, practice);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($51b3faac207de34d$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large"
    }));
    if (practice !== (0, $f1lMr.NO_CATEGORY) && data && !data.ticketTypes.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $beFnx.EmptyUnconfiguredPracticeQueue), null);
    const { headerMessage: headerMessage, descriptionMessage: descriptionMessage, buttonLabel: buttonLabel, getImageUrl: getImageUrl, renderImage: renderImage } = (0, $agPZt.PRACTICE_DATA)[practice];
    const itsmCategoryToPreSelect = practice !== (0, $f1lMr.NO_CATEGORY) ? (0, $fDE9L.toItsmPractice)(practice) : undefined;
    const renderImageWithSize = ()=>(0, $4Es8k.getAkEmptyStateRenderImageFn)(renderImage)({
            maxImageHeight: 250,
            maxImageWidth: 250
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        imageUrl: (0, $eI5EY.fg)('jsm_queues_consolidate_jfe_assets') ? undefined : getImageUrl(colorMode),
        renderImage: (0, $eI5EY.fg)('jsm_queues_consolidate_jfe_assets') ? renderImageWithSize : undefined,
        header: formatMessage(headerMessage),
        description: formatMessage(descriptionMessage),
        headingLevel: 2,
        primaryAction: error ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            onClick: $51b3faac207de34d$export$6c775f6de634e0f7() ? openCreateIssueDialogModern : $51b3faac207de34d$var$openCreateIssueDialog(practice),
            "data-pid": projectId,
            "data-itsm-category": itsmCategoryToPreSelect,
            testId: "servicedesk-queues-empty-queue.common.ui.empty-practice-queue.create-issue-button"
        }, formatMessage(buttonLabel)),
        maxImageWidth: (0, $522cdb54b2056500$export$caaf33f9dba14d10),
        maxImageHeight: (0, $522cdb54b2056500$export$3465603c26b84396),
        testId: "servicedesk-queues-empty-queue.common.ui.empty-practice-queue.empty-practice-queue"
    });
};
// matches the margin and max-width of atlaskit EmptyState component
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $51b3faac207de34d$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81h9n _p12f1pl1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9JkqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f23b015272b05ac7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fV97Z = parcelRequire("fV97Z");

var $f1lMr = parcelRequire("f1lMr");
const $f23b015272b05ac7$var$usePracticeRequestTypesService = (projectId, practice)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const request = (0, $eUqFw.useCallback)(()=>(0, $fV97Z.performGetRequest)(`/rest/servicedesk/1/servicedesk/${projectId}/request-types?practices=${practice}`), [
        projectId,
        practice
    ]);
    const { data: data, loading: loading, error: error, fetch: fetch } = (0, $eEzyV.useService)(request);
    (0, $eUqFw.useEffect)(()=>{
        if (practice !== (0, $f1lMr.NO_CATEGORY)) fetch();
    }, [
        practice,
        fetch
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (data) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'practiceRequestTypes fetched');
    }, [
        data,
        createAnalyticsEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) (0, $guiFP.default)({
            meta: {
                id: 'practiceRequestTypes',
                packageName: 'jiraServicedeskQueuesCommon'
            },
            error: error,
            event: createAnalyticsEvent({}),
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        error,
        createAnalyticsEvent
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
};
var $f23b015272b05ac7$export$2e2bcd8739ae039 = $f23b015272b05ac7$var$usePracticeRequestTypesService;

});

const $522cdb54b2056500$export$3465603c26b84396 = 250;
const $522cdb54b2056500$export$caaf33f9dba14d10 = 400;
const $522cdb54b2056500$export$f960f87b7b043226 = 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-queues/';

parcelRegister("agPZt", function(module, exports) {

$parcel$export(module.exports, "PRACTICE_DATA", () => $aacd4aad7c26bac1$export$cda75610eb70fde9);

var $d9KXp = parcelRequire("d9KXp");

var $20bJF = parcelRequire("20bJF");

var $fqPcp = parcelRequire("fqPcp");

var $g7Hng = parcelRequire("g7Hng");

var $4okN2 = parcelRequire("4okN2");

var $ijRkr = parcelRequire("ijRkr");

var $f1lMr = parcelRequire("f1lMr");

var $9oRI8 = parcelRequire("9oRI8");

var $cOska = parcelRequire("cOska");

var $fO6PY = parcelRequire("fO6PY");

var $1vQ9C = parcelRequire("1vQ9C");

var $6rURC = parcelRequire("6rURC");

var $e36is = parcelRequire("e36is");

var $ew1tl = parcelRequire("ew1tl");

var $k3lQa = parcelRequire("k3lQa");

var $6kK51 = parcelRequire("6kK51");

var $conjx = parcelRequire("conjx");

var $1fwKm = parcelRequire("1fwKm");

var $4vRC7 = parcelRequire("4vRC7");

var $ezb38 = parcelRequire("ezb38");
const $aacd4aad7c26bac1$export$61582641a3c37669 = 'light';
const $aacd4aad7c26bac1$export$af4146eb5bbb1672 = 'dark';
const $aacd4aad7c26bac1$export$97c0a36af1d48540 = 'auto';
const $aacd4aad7c26bac1$export$cda75610eb70fde9 = {
    [(0, $f1lMr.SERVICE_REQUEST)]: {
        headerMessage: (0, $ezb38.default).serviceRequestsHeader,
        descriptionMessage: (0, $ezb38.default).serviceRequestsDescription,
        buttonLabel: (0, $ezb38.default).serviceRequestsCreateIssueButtonText,
        renderImage: (0, $g7Hng.default),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($1fwKm))),
        getImageUrl: (currentTheme)=>currentTheme === $aacd4aad7c26bac1$export$af4146eb5bbb1672 ? (0, (/*@__PURE__*/$parcel$interopDefault($4vRC7))) : (0, (/*@__PURE__*/$parcel$interopDefault($1fwKm))),
        learnMoreUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-service-requests/'
    },
    [(0, $f1lMr.INCIDENTS)]: {
        headerMessage: (0, $ezb38.default).incidentsHeader,
        descriptionMessage: (0, $ezb38.default).incidentsDescription,
        buttonLabel: (0, $ezb38.default).incidentsCreateIssueButtonText,
        renderImage: (0, $ijRkr.default),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6rURC))),
        getImageUrl: (currentTheme)=>currentTheme === $aacd4aad7c26bac1$export$af4146eb5bbb1672 ? (0, (/*@__PURE__*/$parcel$interopDefault($e36is))) : (0, (/*@__PURE__*/$parcel$interopDefault($6rURC))),
        learnMoreUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-incidents/'
    },
    [(0, $f1lMr.PROBLEMS)]: {
        headerMessage: (0, $ezb38.default).problemsHeader,
        descriptionMessage: (0, $ezb38.default).problemsDescription,
        buttonLabel: (0, $ezb38.default).problemsCreateIssueButtonText,
        renderImage: (0, $20bJF.default),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6kK51))),
        getImageUrl: (currentTheme)=>currentTheme === $aacd4aad7c26bac1$export$af4146eb5bbb1672 ? (0, (/*@__PURE__*/$parcel$interopDefault($conjx))) : (0, (/*@__PURE__*/$parcel$interopDefault($6kK51))),
        learnMoreUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-problems/'
    },
    [(0, $f1lMr.CHANGES)]: {
        headerMessage: (0, $ezb38.default).changesHeader,
        descriptionMessage: (0, $ezb38.default).changesDescription,
        buttonLabel: (0, $ezb38.default).changesCreateIssueButtonText,
        renderImage: (0, $d9KXp.default),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($fO6PY))),
        getImageUrl: (currentTheme)=>currentTheme === $aacd4aad7c26bac1$export$af4146eb5bbb1672 ? (0, (/*@__PURE__*/$parcel$interopDefault($1vQ9C))) : (0, (/*@__PURE__*/$parcel$interopDefault($fO6PY))),
        learnMoreUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-changes/'
    },
    [(0, $f1lMr.POST_INCIDENT_REVIEWS)]: {
        headerMessage: (0, $ezb38.default).postIncidentReviewsHeader,
        descriptionMessage: (0, $ezb38.default).postIncidentReviewsDescription,
        buttonLabel: (0, $ezb38.default).postIncidentReviewsCreateIssueButtonText,
        renderImage: (0, $4okN2.default),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ew1tl))),
        getImageUrl: (currentTheme)=>currentTheme === $aacd4aad7c26bac1$export$af4146eb5bbb1672 ? (0, (/*@__PURE__*/$parcel$interopDefault($k3lQa))) : (0, (/*@__PURE__*/$parcel$interopDefault($ew1tl))),
        learnMoreUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-post-incident-reviews/'
    },
    [(0, $f1lMr.NO_CATEGORY)]: {
        headerMessage: (0, $ezb38.default).allTicketsHeader,
        descriptionMessage: (0, $ezb38.default).allTicketsDescription,
        buttonLabel: (0, $ezb38.default).allTicketsCreateIssueButtonText,
        renderImage: (0, $fqPcp.default),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($9oRI8))),
        getImageUrl: (currentTheme)=>currentTheme === $aacd4aad7c26bac1$export$af4146eb5bbb1672 ? (0, (/*@__PURE__*/$parcel$interopDefault($cOska))) : (0, (/*@__PURE__*/$parcel$interopDefault($9oRI8))),
        learnMoreUrl: undefined
    }
};

});
parcelRegister("d9KXp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9118bdc19dd96bf$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = g4nfj272vxmnnng6jh384m
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/g4nfj272vxmnnng6jh384m

var $9TZf5 = parcelRequire("9TZf5");

var $3Ujhd = parcelRequire("3Ujhd");
const $b9118bdc19dd96bf$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3Ujhd)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3Ujhd))
});
var $b9118bdc19dd96bf$export$2e2bcd8739ae039 = $b9118bdc19dd96bf$var$Illustration;
// for advanced use only
const $b9118bdc19dd96bf$export$a179c88182cb9d56 = [
    0,
    0,
    497,
    318
];

});
parcelRegister("3Ujhd", function(module, exports) {
module.exports = new URL("software-development.a5df06ef.svg", import.meta.url).toString();

});


parcelRegister("20bJF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c5a9cbc8b10f90d$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = q7cns859w734758qv5wmgpm
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/q7cns859w734758qv5wmgpm

var $9TZf5 = parcelRequire("9TZf5");

var $4gNXN = parcelRequire("4gNXN");

var $iKYQB = parcelRequire("iKYQB");
const $9c5a9cbc8b10f90d$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($iKYQB)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($4gNXN))
});
var $9c5a9cbc8b10f90d$export$2e2bcd8739ae039 = $9c5a9cbc8b10f90d$var$Illustration;
// for advanced use only
const $9c5a9cbc8b10f90d$export$a179c88182cb9d56 = [
    0,
    0,
    223,
    189
];

});
parcelRegister("4gNXN", function(module, exports) {
module.exports = new URL("target-single-darkmode.5d8fc324.svg", import.meta.url).toString();

});

parcelRegister("iKYQB", function(module, exports) {
module.exports = new URL("target-single.a1a07a4f.svg", import.meta.url).toString();

});


parcelRegister("fqPcp", function(module, exports) {

$parcel$export(module.exports, "default", () => $566c2562917695b2$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = hrv73kh63rncntxr5mpzh
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/hrv73kh63rncntxr5mpzh

var $9TZf5 = parcelRequire("9TZf5");

var $1grnK = parcelRequire("1grnK");
const $566c2562917695b2$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1grnK)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($1grnK))
});
var $566c2562917695b2$export$2e2bcd8739ae039 = $566c2562917695b2$var$Illustration;
// for advanced use only
const $566c2562917695b2$export$a179c88182cb9d56 = [
    0,
    0,
    233,
    235
];

});
parcelRegister("1grnK", function(module, exports) {
module.exports = new URL("ticket-dispensor.f4a024b2.svg", import.meta.url).toString();

});


parcelRegister("g7Hng", function(module, exports) {

$parcel$export(module.exports, "default", () => $46ed164bf6a93453$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $lw5Am = parcelRequire("lw5Am");

var $kPrQr = parcelRequire("kPrQr");
const $46ed164bf6a93453$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($kPrQr)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($lw5Am))
});
var $46ed164bf6a93453$export$2e2bcd8739ae039 = $46ed164bf6a93453$var$Illustration;
// for advanced use only
const $46ed164bf6a93453$export$a179c88182cb9d56 = [
    0,
    0,
    595,
    601
];

});
parcelRegister("lw5Am", function(module, exports) {
module.exports = new URL("balloons-darkmode.7d1967f8.svg", import.meta.url).toString();

});

parcelRegister("kPrQr", function(module, exports) {
module.exports = new URL("balloons.8acbde79.svg", import.meta.url).toString();

});


parcelRegister("4okN2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e76e03a44d57bce5$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $hceed = parcelRequire("hceed");
const $e76e03a44d57bce5$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($hceed)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($hceed))
});
var $e76e03a44d57bce5$export$2e2bcd8739ae039 = $e76e03a44d57bce5$var$Illustration;
// for advanced use only
const $e76e03a44d57bce5$export$a179c88182cb9d56 = [
    0,
    0,
    600,
    282
];

});
parcelRegister("hceed", function(module, exports) {
module.exports = new URL("people-working-on-computers.8a5759a8.svg", import.meta.url).toString();

});


parcelRegister("ijRkr", function(module, exports) {

$parcel$export(module.exports, "default", () => $61fab21a696705ca$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $6ng2U = parcelRequire("6ng2U");
const $61fab21a696705ca$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6ng2U)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6ng2U))
});
var $61fab21a696705ca$export$2e2bcd8739ae039 = $61fab21a696705ca$var$Illustration;
// for advanced use only
const $61fab21a696705ca$export$a179c88182cb9d56 = [
    0,
    0,
    600,
    386
];

});
parcelRegister("6ng2U", function(module, exports) {
module.exports = new URL("task-board-with-people.e468116d.svg", import.meta.url).toString();

});


parcelRegister("9oRI8", function(module, exports) {
module.exports = new URL("all-tickets.e438cf2e.svg", import.meta.url).toString();

});

parcelRegister("cOska", function(module, exports) {
module.exports = new URL("all-ticketsDark.5aecc647.svg", import.meta.url).toString();

});

parcelRegister("fO6PY", function(module, exports) {
module.exports = new URL("changes.2587d023.svg", import.meta.url).toString();

});

parcelRegister("1vQ9C", function(module, exports) {
module.exports = new URL("changesDark.c4f3eb80.svg", import.meta.url).toString();

});

parcelRegister("6rURC", function(module, exports) {
module.exports = new URL("incidents.c1cdd3ac.svg", import.meta.url).toString();

});

parcelRegister("e36is", function(module, exports) {
module.exports = new URL("incidentsDark.aba376a8.svg", import.meta.url).toString();

});

parcelRegister("ew1tl", function(module, exports) {
module.exports = new URL("post-incident-reviews.e1460fe9.svg", import.meta.url).toString();

});

parcelRegister("k3lQa", function(module, exports) {
module.exports = new URL("post-incident-reviewsDark.1fbf276d.svg", import.meta.url).toString();

});

parcelRegister("6kK51", function(module, exports) {
module.exports = new URL("problems.9524f82d.svg", import.meta.url).toString();

});

parcelRegister("conjx", function(module, exports) {
module.exports = new URL("problemsDark.2e76c8e2.svg", import.meta.url).toString();

});

parcelRegister("1fwKm", function(module, exports) {
module.exports = new URL("service-requests.266aad3f.svg", import.meta.url).toString();

});

parcelRegister("4vRC7", function(module, exports) {
module.exports = new URL("service-requestsDark.ce6d6e11.svg", import.meta.url).toString();

});

parcelRegister("ezb38", function(module, exports) {

$parcel$export(module.exports, "default", () => $efe4f731f5840494$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $efe4f731f5840494$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    allTicketsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.all-tickets-header",
        "defaultMessage": "All of your requests will show up here"
    },
    allTicketsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.all-tickets-description",
        "defaultMessage": "Talk with customers, notify your teammates and track work all in one place. Create a request of your own to see it in action."
    },
    allTicketsDescriptionForJsmImporterSurvey: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.all-tickets-description-for-jsm-importer-survey",
        "defaultMessage": "Talk with customers, notify your teammates and track work all in one place. Create or import issues to see them in action."
    },
    allTicketsCreateIssueButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.all-tickets-create-issue-button-text",
        "defaultMessage": "Create a request"
    },
    serviceRequestsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.service-requests-header",
        "defaultMessage": "Solve service requests"
    },
    serviceRequestsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.service-requests-description",
        "defaultMessage": "Track requests for support, monitor SLAs, and communicate with help seekers."
    },
    serviceRequestsCreateIssueButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.service-requests-create-issue-button-text",
        "defaultMessage": "Create a service request"
    },
    incidentsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.incidents-header",
        "defaultMessage": "Resolve disruptions"
    },
    incidentsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.incidents-description",
        "defaultMessage": "Detect, respond to and resolve incidents. Catch issues early with alerts and on-call scheduling, and keep stakeholders updated at every step."
    },
    incidentsCreateIssueButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.incidents-create-issue-button-text",
        "defaultMessage": "Report an incident"
    },
    problemsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.problems-header",
        "defaultMessage": "Fix all the things"
    },
    problemsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.problems-description",
        "defaultMessage": "Investigate the root cause of repeat incidents and track their resolution from start to finish."
    },
    problemsCreateIssueButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.problems-create-issue-button-text",
        "defaultMessage": "Investigate a problem"
    },
    changesHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.changes-header",
        "defaultMessage": "Make things happen"
    },
    changesDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.changes-description",
        "defaultMessage": "Get full visibility of scheduled changes. Set approval steps, minimize disruption, create change records, and keep impacted stakeholders updated."
    },
    changesCreateIssueButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.changes-create-issue-button-text",
        "defaultMessage": "Create a change request"
    },
    postIncidentReviewsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.post-incident-reviews-header",
        "defaultMessage": "Learn from post-incident reviews"
    },
    postIncidentReviewsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.post-incident-reviews-description",
        "defaultMessage": "Bring your team together to capture the causes and impacts of an incident, and learn how to prevent similar incidents from happening again."
    },
    postIncidentReviewsCreateIssueButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.post-incident-reviews-create-issue-button-text",
        "defaultMessage": "Start a post-incident review"
    }
});

});


parcelRegister("beFnx", function(module, exports) {

$parcel$export(module.exports, "EmptyUnconfiguredPracticeQueue", () => $f17b1868bcacf2ff$export$da55df0aa01118ce);

var $eUqFw = parcelRequire("eUqFw");

var $jyTef = parcelRequire("jyTef");

var $ivGVW = parcelRequire("ivGVW");

var $3Z3ws = parcelRequire("3Z3ws");
const $f17b1868bcacf2ff$export$da55df0aa01118ce = ()=>{
    const [{ data: data }] = (0, $jyTef.useServiceDeskContext)();
    const isAgentAdmin = data?.userRole === 'agent-project-admin';
    return isAgentAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ivGVW.EmptyQueueAdminView), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Z3ws.EmptyQueueAgentView), null);
};

});
parcelRegister("ivGVW", function(module, exports) {

$parcel$export(module.exports, "EmptyQueueAdminView", () => $6aac60d2a8021c89$export$c52b9754879a0252);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $4q38b = parcelRequire("4q38b");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $fDE9L = parcelRequire("fDE9L");

var $lB25E = parcelRequire("lB25E");


var $283bn = parcelRequire("283bn");

var $cVPlM = parcelRequire("cVPlM");

var $j369F = parcelRequire("j369F");
const $6aac60d2a8021c89$export$c52b9754879a0252 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const baseUrl = '';
    const [practice] = (0, $lB25E.usePathParam)('practiceType');
    const [projectKey] = (0, $lB25E.usePathParam)('projectKey');
    const { colorMode: colorMode } = (0, $4q38b.default)();
    // practice should always be set in case of an unconfigured queue, if not this is a wrong route
    if (practice === undefined) return null;
    const { headerMessage: headerMessage, descriptionMessage: descriptionMessage, getImageUrl: getImageUrl, learnMoreText: learnMoreText, learnMoreUrl: learnMoreUrl } = (0, $283bn.EMPTY_STATE_DATA)[(0, $fDE9L.toItsmPractice)(practice)];
    const getHref = ()=>{
        if (projectKey == null) return undefined;
        return `${baseUrl}/jira/servicedesk/projects/${projectKey}/settings/request-types/category/${practice}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage(headerMessage),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j369F.Description), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...descriptionMessage,
            values: {
                p: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, chunks),
                a: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                        target: "_blank",
                        href: learnMoreUrl
                    }, learnMoreText && formatMessage(learnMoreText))
            }
        })),
        imageUrl: getImageUrl(colorMode),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            href: getHref()
        }, formatMessage((0, $cVPlM.default).addRequestTypeButtonText)),
        maxImageWidth: (0, $522cdb54b2056500$export$caaf33f9dba14d10),
        maxImageHeight: (0, $522cdb54b2056500$export$3465603c26b84396),
        testId: "servicedesk-queues-empty-queue.common.ui.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.empty-queue-admin-view"
    });
};

});
parcelRegister("283bn", function(module, exports) {

$parcel$export(module.exports, "EMPTY_STATE_DATA", () => $7fe61899173b586f$export$cfb3b7ce372d6279);

var $f1lMr = parcelRequire("f1lMr");

var $agPZt = parcelRequire("agPZt");

var $1b4zP = parcelRequire("1b4zP");

var $cVPlM = parcelRequire("cVPlM");
const $7fe61899173b586f$export$cfb3b7ce372d6279 = {
    [(0, $f1lMr.SERVICE_REQUEST)]: {
        headerMessage: (0, $cVPlM.default).serviceRequestsHeader,
        descriptionMessage: (0, $cVPlM.default).serviceRequestsDescription,
        imageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.SERVICE_REQUEST].imageUrl,
        getImageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.SERVICE_REQUEST].getImageUrl,
        learnMoreUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.SERVICE_REQUEST].learnMoreUrl,
        learnMoreText: (0, $1b4zP.default).serviceRequestsLearnMore
    },
    [(0, $f1lMr.INCIDENTS)]: {
        headerMessage: (0, $cVPlM.default).incidentsHeader,
        descriptionMessage: (0, $cVPlM.default).incidentsDescription,
        imageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.INCIDENTS].imageUrl,
        getImageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.INCIDENTS].getImageUrl,
        learnMoreUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.INCIDENTS].learnMoreUrl,
        learnMoreText: (0, $1b4zP.default).incidentsLearnMore
    },
    [(0, $f1lMr.PROBLEMS)]: {
        headerMessage: (0, $cVPlM.default).problemsHeader,
        descriptionMessage: (0, $cVPlM.default).problemsDescription,
        imageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.PROBLEMS].imageUrl,
        getImageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.PROBLEMS].getImageUrl,
        learnMoreUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.PROBLEMS].learnMoreUrl,
        learnMoreText: (0, $1b4zP.default).problemsLearnMore
    },
    [(0, $f1lMr.CHANGES)]: {
        headerMessage: (0, $cVPlM.default).changesHeader,
        descriptionMessage: (0, $cVPlM.default).changesDescription,
        imageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.CHANGES].imageUrl,
        getImageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.CHANGES].getImageUrl,
        learnMoreUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.CHANGES].learnMoreUrl,
        learnMoreText: (0, $1b4zP.default).changesLearnMore
    },
    [(0, $f1lMr.POST_INCIDENT_REVIEWS)]: {
        headerMessage: (0, $cVPlM.default).postIncidentReviewsHeader,
        descriptionMessage: (0, $cVPlM.default).postIncidentReviewsDescription,
        imageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.POST_INCIDENT_REVIEWS].imageUrl,
        getImageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.POST_INCIDENT_REVIEWS].getImageUrl,
        learnMoreUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.POST_INCIDENT_REVIEWS].learnMoreUrl,
        learnMoreText: (0, $1b4zP.default).postIncidentReviewsLearnMore
    },
    // NO_CATEGORY will never be a valid case in case of unconfigured queue, need to do this to keep Flow happy
    [(0, $f1lMr.NO_CATEGORY)]: {
        ...(0, $agPZt.PRACTICE_DATA)[0, $f1lMr.NO_CATEGORY],
        learnMoreText: undefined
    }
};

});
parcelRegister("1b4zP", function(module, exports) {

$parcel$export(module.exports, "default", () => $59fcb3af7150d03f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $59fcb3af7150d03f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    serviceRequestsLearnMore: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.service-requests-learn-more",
        "defaultMessage": "Learn more about service requests"
    },
    incidentsLearnMore: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.incidents-learn-more",
        "defaultMessage": "Learn more about incident management"
    },
    problemsLearnMore: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.problems-learn-more",
        "defaultMessage": "Learn more about problem management"
    },
    changesLearnMore: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.changes-learn-more",
        "defaultMessage": "Learn more about change management"
    },
    postIncidentReviewsLearnMore: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.post-incident-reviews-learn-more",
        "defaultMessage": "Learn more about post-incident reviews"
    }
});

});

parcelRegister("cVPlM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3481fc94cb1dc0cb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3481fc94cb1dc0cb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    serviceRequestsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.service-requests-header",
        "defaultMessage": "Get started with service requests"
    },
    serviceRequestsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.service-requests-description",
        "defaultMessage": "<p>To start using your new queue, add a request type to the service requests category. You can create a new request type, or assign an existing request type from this project. <a></a>.</p>"
    },
    incidentsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.incidents-header",
        "defaultMessage": "Get started with incident management"
    },
    incidentsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.incidents-description",
        "defaultMessage": "<p>To start using your new queue, add a request type to the incidents category. You can create a new request type, or assign an existing request type from this project. <a></a>.</p>"
    },
    problemsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.problems-header",
        "defaultMessage": "Get started with problem management"
    },
    problemsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.problems-description",
        "defaultMessage": "<p>To start using your new queue, add a request type to the problems category. You can create a new request type, or assign an existing request type from this project. <a></a>.</p>"
    },
    changesHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.changes-header",
        "defaultMessage": "Get started with change management"
    },
    changesDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.changes-description",
        "defaultMessage": "<p>To start using your new queue, add a request type to the changes category. You can create a new request type, or assign an existing request type from this project. <a></a>.</p>"
    },
    postIncidentReviewsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.post-incident-reviews-header",
        "defaultMessage": "Get started with post-incident reviews"
    },
    postIncidentReviewsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.post-incident-reviews-description",
        "defaultMessage": "<p>To start using your new queue, create a new request type, or assign an existing request type to the post-incident review category. <a></a>.</p>"
    },
    addRequestTypeButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.add-request-type-button-text",
        "defaultMessage": "Add request types"
    }
});

});


parcelRegister("j369F", function(module, exports) {

$parcel$export(module.exports, "Description", () => $c848a2cb8911a449$export$393edc798c47379d);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $c848a2cb8911a449$export$393edc798c47379d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8gx6n _y3gn1e5h",
            __cmplp.className
        ])
    });
});

});


parcelRegister("3Z3ws", function(module, exports) {

$parcel$export(module.exports, "EmptyQueueAgentView", () => $b36399c01c953669$export$c7fde069a1782c75);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $4q38b = parcelRequire("4q38b");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fDE9L = parcelRequire("fDE9L");

var $lB25E = parcelRequire("lB25E");


var $7MXPv = parcelRequire("7MXPv");

var $eOMjy = parcelRequire("eOMjy");
const $b36399c01c953669$export$c7fde069a1782c75 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [practice] = (0, $lB25E.usePathParam)('practiceType');
    const { colorMode: colorMode } = (0, $4q38b.default)();
    // practice should always be set in case of an unconfigured queue, if not this is a wrong route
    if (practice === undefined) return null;
    const { headerMessage: headerMessage, descriptionMessage: descriptionMessage, getImageUrl: getImageUrl, learnMoreText: learnMoreText, learnMoreUrl: learnMoreUrl } = (0, $7MXPv.EMPTY_STATE_DATA)[(0, $fDE9L.toItsmPractice)(practice)];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage(headerMessage),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eOMjy.Description), null, formatMessage(descriptionMessage)),
        imageUrl: getImageUrl(colorMode),
        primaryAction: learnMoreText && learnMoreUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eOMjy.LearnMoreLink), {
            target: "_blank",
            href: learnMoreUrl
        }, formatMessage(learnMoreText)),
        maxImageWidth: (0, $522cdb54b2056500$export$caaf33f9dba14d10),
        maxImageHeight: (0, $522cdb54b2056500$export$3465603c26b84396),
        testId: "servicedesk-queues-empty-queue.common.ui.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.empty-queue-agent-view"
    });
};

});
parcelRegister("7MXPv", function(module, exports) {

$parcel$export(module.exports, "EMPTY_STATE_DATA", () => $371e3e0573b1c29b$export$cfb3b7ce372d6279);

var $f1lMr = parcelRequire("f1lMr");

var $agPZt = parcelRequire("agPZt");

var $1b4zP = parcelRequire("1b4zP");

var $cYHKc = parcelRequire("cYHKc");
const $371e3e0573b1c29b$export$cfb3b7ce372d6279 = {
    [(0, $f1lMr.SERVICE_REQUEST)]: {
        headerMessage: (0, $cYHKc.default).serviceRequestsHeader,
        descriptionMessage: (0, $cYHKc.default).serviceRequestsDescription,
        imageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.SERVICE_REQUEST].imageUrl,
        getImageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.SERVICE_REQUEST].getImageUrl,
        learnMoreUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.SERVICE_REQUEST].learnMoreUrl,
        learnMoreText: (0, $1b4zP.default).serviceRequestsLearnMore
    },
    [(0, $f1lMr.INCIDENTS)]: {
        headerMessage: (0, $cYHKc.default).incidentsHeader,
        descriptionMessage: (0, $cYHKc.default).incidentsDescription,
        imageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.INCIDENTS].imageUrl,
        getImageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.INCIDENTS].getImageUrl,
        learnMoreUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.INCIDENTS].learnMoreUrl,
        learnMoreText: (0, $1b4zP.default).incidentsLearnMore
    },
    [(0, $f1lMr.PROBLEMS)]: {
        headerMessage: (0, $cYHKc.default).problemsHeader,
        descriptionMessage: (0, $cYHKc.default).problemsDescription,
        imageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.PROBLEMS].imageUrl,
        getImageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.PROBLEMS].getImageUrl,
        learnMoreUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.PROBLEMS].learnMoreUrl,
        learnMoreText: (0, $1b4zP.default).problemsLearnMore
    },
    [(0, $f1lMr.CHANGES)]: {
        headerMessage: (0, $cYHKc.default).changesHeader,
        descriptionMessage: (0, $cYHKc.default).changesDescription,
        imageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.CHANGES].imageUrl,
        getImageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.CHANGES].getImageUrl,
        learnMoreUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.CHANGES].learnMoreUrl,
        learnMoreText: (0, $1b4zP.default).changesLearnMore
    },
    [(0, $f1lMr.POST_INCIDENT_REVIEWS)]: {
        headerMessage: (0, $cYHKc.default).postIncidentReviewsHeader,
        descriptionMessage: (0, $cYHKc.default).postIncidentReviewsDescription,
        imageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.POST_INCIDENT_REVIEWS].imageUrl,
        getImageUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.POST_INCIDENT_REVIEWS].getImageUrl,
        learnMoreUrl: (0, $agPZt.PRACTICE_DATA)[0, $f1lMr.POST_INCIDENT_REVIEWS].learnMoreUrl,
        learnMoreText: (0, $1b4zP.default).postIncidentReviewsLearnMore
    },
    // NO_CATEGORY will never be a valid case in case of unconfigured queue, need to do this to keep Flow happy
    [(0, $f1lMr.NO_CATEGORY)]: {
        ...(0, $agPZt.PRACTICE_DATA)[0, $f1lMr.NO_CATEGORY],
        learnMoreText: undefined
    }
};

});
parcelRegister("cYHKc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7732165940911339$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7732165940911339$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    serviceRequestsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.service-requests-header",
        "defaultMessage": "Welcome to your new service requests queue"
    },
    serviceRequestsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.service-requests-description",
        "defaultMessage": "Your admin is setting up a service request management workflow to help you deliver great service experiences. To start using your new queue, your admin will need to add request types to the service requests category. Contact your admin for more information."
    },
    incidentsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.incidents-header",
        "defaultMessage": "Welcome to your new incidents queue"
    },
    incidentsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.incidents-description",
        "defaultMessage": "Your admin is setting up an incident management workflow to help you deliver great service experiences. To start using your new queue, your admin will need to add request types to the incidents category. Contact your admin for more information."
    },
    problemsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.problems-header",
        "defaultMessage": "Welcome to your new problems queue"
    },
    problemsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.problems-description",
        "defaultMessage": "Your admin is setting up a problem management workflow to help you deliver great service experiences. To start using your new queue, your admin will need to add request types to the problems category. Contact your admin for more information."
    },
    changesHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.changes-header",
        "defaultMessage": "Welcome to your new changes queue"
    },
    changesDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.changes-description",
        "defaultMessage": "Your admin is setting up a change management workflow to help you deliver great service experiences. To start using your new queue, your admin will need to add request types to the changes category. Contact your admin for more information."
    },
    postIncidentReviewsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.post-incident-reviews-header",
        "defaultMessage": "Get started with post-incident reviews"
    },
    postIncidentReviewsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.post-incident-reviews-description",
        "defaultMessage": "Your admin is setting up a post-incident review queue to help you deliver great service experiences. To start using your new queue, your admin will need to add request types to the post-incident review category. Contact your admin for more information."
    }
});

});


parcelRegister("eOMjy", function(module, exports) {

$parcel$export(module.exports, "Description", () => $d5ea6d999259f709$export$393edc798c47379d);
$parcel$export(module.exports, "LearnMoreLink", () => $d5ea6d999259f709$export$d608ae2ec728a3cf);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $d5ea6d999259f709$export$393edc798c47379d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8gx6n _y3gn1e5h _1bsb189v",
            __cmplp.className
        ])
    });
});
const $d5ea6d999259f709$export$d608ae2ec728a3cf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _otyrgx6n _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});




parcelRegister("f1xGd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4830149955ed231$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f4830149955ed231$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyQueueHeader: {
        "id": "servicedesk-queues-empty-queue.empty-queue-header",
        "defaultMessage": "Your queue is empty"
    },
    emptyQueueDescription: {
        "id": "servicedesk-queues-empty-queue.empty-queue-description",
        "defaultMessage": "<p>Incoming requests from multiple channels are filtered and displayed in your queues as issues, ready to be triaged and assigned. {break} {IPHArticle} </p>"
    },
    emptyQueueButtonLabel: {
        "id": "servicedesk-queues-empty-queue.empty-queue-button-label",
        "defaultMessage": "Create an issue"
    },
    emptyQueueLearnMoreText: {
        "id": "servicedesk-queues-empty-queue.empty-queue-learn-more-text",
        "defaultMessage": "Learn more about queues"
    }
});

});


parcelRegister("lsHr9", function(module, exports) {

$parcel$export(module.exports, "default", () => $bea1ee19e8f4bd4b$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $3nTcJ = parcelRequire("3nTcJ");

var $3KNsL = parcelRequire("3KNsL");

var $1RqtY = parcelRequire("1RqtY");

var $fANg9 = parcelRequire("fANg9");
const $bea1ee19e8f4bd4b$var$mapStateToProps = (state)=>({
        queueOrder: (0, $3KNsL.getCurrentQueueOrder)(state),
        isQueueVisible: (0, $1RqtY.isQueueVisible)(state),
        isLoadingIssues: (0, $1RqtY.isLoadingIssues)(state),
        projectId: (0, $3nTcJ.getProjectId)(state),
        baseUrl: (0, $3nTcJ.getBaseUrl)(state)
    });
var $bea1ee19e8f4bd4b$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($bea1ee19e8f4bd4b$var$mapStateToProps, {})((0, $fANg9.default));

});
parcelRegister("fANg9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dcd5b90b58b94af$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $dFF9i = parcelRequire("dFF9i");
class $0dcd5b90b58b94af$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    shouldDripFeed() {
        const { queueOrder: queueOrder, isQueueVisible: isQueueVisible, isLoadingIssues: isLoadingIssues } = this.props;
        // Ideally, we would like to drip-feed further issues only on the "All Open" queue of a demo project.
        // However, there is no reliable way to figure out the exact queue we are on. Thus, we rely on the initial
        // ordering of the queues. We accept the risk of users missing the drip-feed altogether when they re-order
        // their queues. The DemoProjectDripFeed component itself will check if we are actually on a demo project.
        // Also make sure that queues page is visible.
        if (queueOrder !== 0 || !isQueueVisible || isLoadingIssues) return false;
        return true;
    }
    render() {
        return this.shouldDripFeed() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dFF9i.DemoProjectDripFeed), {
            baseUrl: this.props.baseUrl,
            projectId: this.props.projectId
        }) : null;
    }
}

});
parcelRegister("dFF9i", function(module, exports) {

$parcel$export(module.exports, "DemoProjectDripFeed", () => $b6e35d5bb02d95d3$export$3fb4ae8058b3efa3);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $f7V0E = parcelRequire("f7V0E");

var $gEZA0 = parcelRequire("gEZA0");

var $cXNZ5 = parcelRequire("cXNZ5");
const $b6e35d5bb02d95d3$export$3fb4ae8058b3efa3 = ({ baseUrl: baseUrl, projectId: projectId })=>{
    const { data: isDemoProject } = (0, $f7V0E.useIsDemoProject)();
    const { data: isItsmSampleProject } = (0, $gEZA0.useIsItsmSampleProject)();
    const [isRequestCreated, setIsRequestCreated] = (0, $eUqFw.useState)(false);
    const shouldCreateRequest = // Allow request creation for demo and non ITSM sample project
    !isRequestCreated && isDemoProject === true && isItsmSampleProject === false;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (shouldCreateRequest) {
            setIsRequestCreated(true);
            (0, $cXNZ5.default)({
                baseUrl: baseUrl,
                projectId: projectId,
                analyticsEvent: createAnalyticsEvent({})
            });
        }
    }, [
        shouldCreateRequest,
        setIsRequestCreated,
        baseUrl,
        projectId,
        createAnalyticsEvent
    ]);
    return null;
};

});
parcelRegister("f7V0E", function(module, exports) {

$parcel$export(module.exports, "useIsDemoProject", () => $8aa166fc00256124$export$9b4078600f2ad4d2);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $SEaoU = parcelRequire("SEaoU");

var $6vrw7 = parcelRequire("6vrw7");

var $WBLbN = parcelRequire("WBLbN");

var $7kN7I = parcelRequire("7kN7I");

var $au7K4 = parcelRequire("au7K4");
const $8aa166fc00256124$export$d4c72bab9d6cc13a = {};
const $8aa166fc00256124$export$bf108b10a3a0ab90 = (0, $WBLbN.createStore)({
    name: 'IsDemoProject',
    initialState: $8aa166fc00256124$export$d4c72bab9d6cc13a,
    actions: (0, $7kN7I.actions)
});
const $8aa166fc00256124$var$useIsDemoProjectStore = (0, $WBLbN.createHook)($8aa166fc00256124$export$bf108b10a3a0ab90);
// @ts-expect-error - TS7031 - Binding element 'data' implicitly has an 'any' type. | TS7031 - Binding element 'loading' implicitly has an 'any' type. | TS7031 - Binding element 'error' implicitly has an 'any' type.
const $8aa166fc00256124$var$useStateMemo = ({ data: data, loading: loading, error: error })=>(0, $eUqFw.useMemo)(()=>({
            data: data,
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
const $8aa166fc00256124$export$9b4078600f2ad4d2 = ()=>{
    const [{ data: contextData }] = (0, $SEaoU.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'. | TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const numProjectId = contextData && contextData.project && contextData.project.id;
    const projectId = (0, $6vrw7.toProjectId)(String(numProjectId));
    const baseUrl = (0, $6vrw7.toBaseUrl)('');
    const [state, { fetchIsDemoProject: fetchIsDemoProject }] = $8aa166fc00256124$var$useIsDemoProjectStore();
    const memoizedState = $8aa166fc00256124$var$useStateMemo({
        ...state[projectId] ?? (0, $au7K4.initialIsDemoProjectState)
    });
    const { data: data } = memoizedState;
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(numProjectId) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(data)) // @ts-expect-error - TS2349 - This expression is not callable.
        fetchIsDemoProject({
            baseUrl: baseUrl,
            projectId: projectId
        })();
    }, [
        fetchIsDemoProject,
        baseUrl,
        numProjectId,
        projectId,
        data
    ]);
    return memoizedState;
};

});
parcelRegister("7kN7I", function(module, exports) {

$parcel$export(module.exports, "actions", () => $284bc3e2d216ef40$export$e324594224ef24da);

var $eQBT8 = parcelRequire("eQBT8");
const $284bc3e2d216ef40$export$e324594224ef24da = {
    fetchIsDemoProject: $eQBT8.fetchIsDemoProject
};

});
parcelRegister("eQBT8", function(module, exports) {

$parcel$export(module.exports, "fetchIsDemoProject", () => $5aa4af5bc33ec272$export$feaee63a215b34da);

var $ldoFd = parcelRequire("ldoFd");

var $iUq1J = parcelRequire("iUq1J");

var $au7K4 = parcelRequire("au7K4");
const $5aa4af5bc33ec272$export$feaee63a215b34da = ({ baseUrl: baseUrl, projectId: projectId })=>// @ts-expect-error - TS2322 - Type '({ getState, setState }: StoreActionApi<Partial<Record<string, DataState<boolean>>>>) => () => Promise<void>' is not assignable to type 'Action<Partial<Record<string, DataState<boolean>>>, void, void | Promise<void>>'.
    ({ getState: getState, setState: setState })=>async ()=>{
            const projectState = getState()[projectId] ?? (0, $au7K4.initialIsDemoProjectState);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(projectState.data) || projectState.loading) return;
            setState({
                ...getState(),
                [String(projectId)]: {
                    ...projectState,
                    loading: true
                }
            });
            try {
                const isDemo = await (0, $iUq1J.isDemoProject)({
                    baseUrl: baseUrl,
                    projectId: projectId
                });
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        data: isDemo,
                        error: null,
                        loading: false
                    }
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        error: error,
                        loading: false
                    }
                });
                throw error;
            }
        };

});
parcelRegister("iUq1J", function(module, exports) {

$parcel$export(module.exports, "isDemoProject", () => $e1be306bebb9e883$export$cf7813449d38d4ac);
$parcel$export(module.exports, "getItsmSampleProject", () => $e1be306bebb9e883$export$c498e29d716efe7a);

var $lRmyA = parcelRequire("lRmyA");
const $e1be306bebb9e883$export$cf7813449d38d4ac = async ({ baseUrl: baseUrl, projectId: projectId })=>{
    try {
        const response = await (0, $lRmyA.performGetRequest)(`${baseUrl}/rest/api/3/project/${projectId}/properties/isDemo`);
        return !!response && !!response.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) /**
			 * Expected when project property is not found.
			 * Demo project has project property "isDemo = true",
			 * otherwise property does not exist
			 * and response status will be 404
			 */ return false;
        throw error;
    }
};
const $e1be306bebb9e883$export$c498e29d716efe7a = async ({ baseUrl: baseUrl })=>{
    try {
        const response = await (0, $lRmyA.performGetRequest)(`${baseUrl}/rest/servicedesk/onboarding/1/itsm/sample-project`);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) return undefined;
        throw error;
    }
};

});

parcelRegister("au7K4", function(module, exports) {

$parcel$export(module.exports, "initialIsDemoProjectState", () => $099e9baa7e7daa22$export$f6365b0f25aeae62);
const $099e9baa7e7daa22$export$f6365b0f25aeae62 = {
    data: null,
    loading: false,
    error: null
};

});




parcelRegister("gEZA0", function(module, exports) {

$parcel$export(module.exports, "useIsItsmSampleProject", () => $d550131522ea0515$export$b8afdaba4bd6f483);

var $ldoFd = parcelRequire("ldoFd");

var $IsF0v = parcelRequire("IsF0v");

var $f7V0E = parcelRequire("f7V0E");
const $d550131522ea0515$export$b8afdaba4bd6f483 = ()=>{
    const { data: isDemoProject, loading: loadingIsDemoProject, error: errorIsDemoProject } = (0, $f7V0E.useIsDemoProject)();
    const { data: isItsmProject, loading: loadingIsItsmProject, error: errorIsItsmProject } = (0, $IsF0v.useIsItsmTemplateProject)();
    return {
        data: !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isDemoProject) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isItsmProject) ? isDemoProject === true && isItsmProject === true : null,
        loading: loadingIsDemoProject || loadingIsItsmProject,
        error: errorIsDemoProject || errorIsItsmProject
    };
};

});

parcelRegister("cXNZ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d67cc96eb9fa4423$export$2e2bcd8739ae039);

var $8eB9r = parcelRequire("8eB9r");

var $cR8gw = parcelRequire("cR8gw");

var $dx0or = parcelRequire("dx0or");
const $d67cc96eb9fa4423$var$service = async ({ baseUrl: baseUrl, projectId: projectId, analyticsEvent: analyticsEvent })=>{
    const createdAliases = await (0, $cR8gw.default)({
        baseUrl: baseUrl,
        projectId: projectId
    });
    const requestAlias = (0, $dx0or.default)({
        createdAliases: createdAliases
    });
    if (!requestAlias) return;
    await (0, $8eB9r.default)({
        baseUrl: baseUrl,
        projectId: projectId,
        requestAlias: requestAlias,
        analyticsEvent: analyticsEvent
    });
};
var $d67cc96eb9fa4423$export$2e2bcd8739ae039 = $d67cc96eb9fa4423$var$service;

});
parcelRegister("8eB9r", function(module, exports) {

$parcel$export(module.exports, "default", () => $113c2c1a11c83a3f$export$2e2bcd8739ae039);

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");

var $jMP2a = parcelRequire("jMP2a");

var $k2iew = parcelRequire("k2iew");

var $6vdRh = parcelRequire("6vdRh");
const $113c2c1a11c83a3f$var$service = async ({ baseUrl: baseUrl, projectId: projectId, requestAlias: requestAlias, analyticsEvent: analyticsEvent })=>{
    try {
        await (0, $6vdRh.post)(baseUrl, projectId, requestAlias);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        !(0, $JRB5w.isClientFetchError)(error) && (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'createRequest',
                packageName: (0, $k2iew.PACKAGE_NAME),
                teamName: 'jsm-getting-started'
            },
            attributes: {
                demoDripFeedRequestAlias: requestAlias
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return false;
    }
    analyticsEvent && (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `${(0, $k2iew.PACKAGE_NAME)} requestCreated`, {
        demoDripFeedRequestAlias: requestAlias
    });
    return true;
};
var $113c2c1a11c83a3f$export$2e2bcd8739ae039 = $113c2c1a11c83a3f$var$service;

});
parcelRegister("k2iew", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $ea21738ab6db97c2$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "CREATED_DEMO_REQUESTS_PROPERTY_KEY", () => $ea21738ab6db97c2$export$e5714b96e7139e44);
$parcel$export(module.exports, "REQUEST_CREATION_ORDER", () => $ea21738ab6db97c2$export$b3140adec43d0709);
const $ea21738ab6db97c2$export$b8b9d90f9e5bd72b = 'jiraServicedeskQueuesDemoProjectDripFeed';
const $ea21738ab6db97c2$export$e5714b96e7139e44 = 'jsd.demo-project.created-demo-requests';
const $ea21738ab6db97c2$export$c2fc572f1ae12c8 = {
    triageRequests: 'TRIAGE_REQUESTS',
    highPriority: 'HIGH_PRIORITY',
    trackPerformance: 'TRACK_PERFORMANCE'
};
const $ea21738ab6db97c2$export$b3140adec43d0709 = [
    $ea21738ab6db97c2$export$c2fc572f1ae12c8.triageRequests,
    $ea21738ab6db97c2$export$c2fc572f1ae12c8.highPriority,
    $ea21738ab6db97c2$export$c2fc572f1ae12c8.trackPerformance
];

});

parcelRegister("6vdRh", function(module, exports) {

$parcel$export(module.exports, "post", () => $31bd7e00d7741d43$export$299ba2dee77727e9);

var $lRmyA = parcelRequire("lRmyA");
const $31bd7e00d7741d43$var$constructEndpoint = (baseUrl, projectId, requestAlias)=>`${baseUrl}/rest/servicedesk/onboarding/1/create-demo-requests/${projectId}/${requestAlias}`;
const $31bd7e00d7741d43$export$299ba2dee77727e9 = (baseUrl, projectId, requestAlias)=>{
    const url = $31bd7e00d7741d43$var$constructEndpoint(baseUrl, projectId, requestAlias);
    return (0, $lRmyA.performPostRequest)(url);
};

});


parcelRegister("cR8gw", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c19de935cb030a8$export$2e2bcd8739ae039);

var $k2iew = parcelRequire("k2iew");

var $1BiHC = parcelRequire("1BiHC");
const $1c19de935cb030a8$var$service = async ({ baseUrl: baseUrl, projectId: projectId })=>{
    try {
        const response = await (0, $1BiHC.get)(baseUrl, projectId, (0, $k2iew.CREATED_DEMO_REQUESTS_PROPERTY_KEY));
        return response.value || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return [];
    }
};
var $1c19de935cb030a8$export$2e2bcd8739ae039 = $1c19de935cb030a8$var$service;

});
parcelRegister("1BiHC", function(module, exports) {

$parcel$export(module.exports, "get", () => $71e21eedfda138bb$export$3988ae62b71be9a3);

var $lRmyA = parcelRequire("lRmyA");
const $71e21eedfda138bb$export$a5b7a8c3b1c6e775 = (baseUrl, projectId, propertyKey)=>`${baseUrl}/rest/api/3/project/${projectId}/properties/${propertyKey}`;
const $71e21eedfda138bb$export$3988ae62b71be9a3 = (baseUrl, projectId, propertyKey)=>{
    const url = $71e21eedfda138bb$export$a5b7a8c3b1c6e775(baseUrl, projectId, propertyKey);
    return (0, $lRmyA.performGetRequest)(url);
};

});


parcelRegister("dx0or", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c731095eb596098$export$2e2bcd8739ae039);

var $3OXzs = parcelRequire("3OXzs");

var $k2iew = parcelRequire("k2iew");
const $0c731095eb596098$var$service = ({ createdAliases: createdAliases })=>(0, $k2iew.REQUEST_CREATION_ORDER).find((issueAlias)=>!(0, (/*@__PURE__*/$parcel$interopDefault($3OXzs)))(createdAliases, issueAlias));
var $0c731095eb596098$export$2e2bcd8739ae039 = $0c731095eb596098$var$service;

});





parcelRegister("gxSBQ", function(module, exports) {

$parcel$export(module.exports, "getEmptyStateMessage", () => $2608ab5a67b8abc7$export$383ed4a3403ea4fc);

var $jqvCZ = parcelRequire("jqvCZ");

var $3KNsL = parcelRequire("3KNsL");

var $7n2Uf = parcelRequire("7n2Uf");
const $2608ab5a67b8abc7$export$6d2dfff2bbcb7a21 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(()=>{
    const randomNumber = Math.floor(Math.random() * Math.floor(4));
    switch(randomNumber){
        case 0:
            return {
                header: (0, $7n2Uf.default).emptyQueueHeaderOne,
                description: (0, $7n2Uf.default).emptyQueueDescriptionOne
            };
        case 1:
            return {
                header: (0, $7n2Uf.default).emptyQueueHeaderTwo,
                description: (0, $7n2Uf.default).emptyQueueDescriptionTwo
            };
        case 2:
            return {
                header: (0, $7n2Uf.default).emptyQueueHeaderThree,
                description: (0, $7n2Uf.default).emptyQueueDescriptionThree
            };
        default:
            return {
                header: (0, $7n2Uf.default).emptyQueueHeaderFour,
                description: (0, $7n2Uf.default).emptyQueueDescriptionFour
            };
    }
});
const $2608ab5a67b8abc7$export$383ed4a3403ea4fc = (state)=>// @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
    $2608ab5a67b8abc7$export$6d2dfff2bbcb7a21((0, $3KNsL.getQueueId)(state));

});
parcelRegister("7n2Uf", function(module, exports) {

$parcel$export(module.exports, "default", () => $afd4ee1592958e20$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $afd4ee1592958e20$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyQueueHeaderOne: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-header-one",
        "defaultMessage": "Your queue is empty but what is empty?"
    },
    emptyQueueDescriptionOne: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-description-one",
        "defaultMessage": "Time to ponder the mysteries of the Universe."
    },
    emptyQueueHeaderTwo: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-header-two",
        "defaultMessage": "You\u2019ve cleaned up here perfectly!"
    },
    emptyQueueDescriptionTwo: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-description-two",
        "defaultMessage": "The only thing left to clean is your computer screen."
    },
    emptyQueueHeaderThree: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-header-three",
        "defaultMessage": "Queue\u2019s empty! Dance party!"
    },
    emptyQueueDescriptionThree: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-description-three",
        "defaultMessage": "Congratulate yourself on a job well done!"
    },
    emptyQueueHeaderFour: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-header-four",
        "defaultMessage": "Your queue is empty."
    },
    emptyQueueDescriptionFour: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-description-four",
        "defaultMessage": "Cupcakes for all!"
    }
});

});


parcelRegister("4XHcr", function(module, exports) {

$parcel$export(module.exports, "default", () => $9be013f3c7074e80$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $giAhk = parcelRequire("giAhk");

var $be3PE = parcelRequire("be3PE");

var $7QneT = parcelRequire("7QneT");

var $aNBkj = parcelRequire("aNBkj");

var $iJHZm = parcelRequire("iJHZm");

var $lbc5S = parcelRequire("lbc5S");
function $9be013f3c7074e80$export$fdbb6e83492670a7({ intl: { formatMessage: formatMessage }, projectId: projectId, isQueueVisible: isQueueVisible, queueId: queueId, EmptyQueueComponent: EmptyQueueComponent, DemoDripFeed: DemoDripFeed, emptyStateMessage: { header: header, description: description }, metricKey: metricKey, category: category }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isQueueVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReadyOnUpdate), {
        comparer: [
            queueId
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(EmptyQueueComponent, {
        projectId: projectId,
        header: formatMessage(header),
        description: formatMessage(description),
        category: category
    }), isQueueVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $be3PE.JsmPageInteractiveEvent), {
        key: (0, $aNBkj.fromQueueIdString)(queueId),
        metricKey: metricKey,
        withMarks: (0, $7QneT.getAgentViewMarks)(),
        // @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
        metric: (0, $lbc5S.serviceViewPageLoad),
        extra: {
            category: category || 'no-category',
            empty: true
        }
    }), DemoDripFeed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DemoDripFeed, null) : null);
}
var $9be013f3c7074e80$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($9be013f3c7074e80$export$fdbb6e83492670a7);

});
parcelRegister("be3PE", function(module, exports) {

$parcel$export(module.exports, "JsmPageInteractiveEvent", () => $695cc37a0df2f37c$export$c4ba40c380ee9a11);

var $eUqFw = parcelRequire("eUqFw");

var $7vf5z = parcelRequire("7vf5z");
const $695cc37a0df2f37c$export$c4ba40c380ee9a11 = (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), args);
$695cc37a0df2f37c$export$c4ba40c380ee9a11.defaultProps = {
    isExpectedToHaveSsr: false,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    withMarks: [],
    extra: {}
};
$695cc37a0df2f37c$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("3iMaY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac8385c71ad69743$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $ac8385c71ad69743$export$d12f56a472cdbe6c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $ac8385c71ad69743$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    (0, $eUqFw.useMemo)(()=>{
        if (!interactionContext) return;
        interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $ac8385c71ad69743$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $fYqUr.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("6xYPC", function(module, exports) {

$parcel$export(module.exports, "stopLowPriorityEventDelay", () => $4b25e5ad6cfac913$export$a928755af449867);
$parcel$export(module.exports, "startLowPriorityEventDelay", () => $4b25e5ad6cfac913$export$8bb8df5a93e9525);
$parcel$export(module.exports, "default", () => $4b25e5ad6cfac913$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ICvxP = parcelRequire("ICvxP");

var $6iz4v = parcelRequire("6iz4v");

var $cbwiM = parcelRequire("cbwiM");

var $3FyZ4 = parcelRequire("3FyZ4");

var $epT40 = parcelRequire("epT40");

var $87isp = parcelRequire("87isp");

const $4b25e5ad6cfac913$var$STOP_DELAY_TIMEOUT = 10000;
let $4b25e5ad6cfac913$var$stopDelayTimeout;
let $4b25e5ad6cfac913$var$lastDelayActionPromise = (0, $3FyZ4.getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
const $4b25e5ad6cfac913$export$a928755af449867 = ()=>{
    $4b25e5ad6cfac913$var$lastDelayActionPromise = $4b25e5ad6cfac913$var$lastDelayActionPromise.then((client)=>{
        if (!(0, $cbwiM.isEventDelayActive)()) return client;
        clearTimeout($4b25e5ad6cfac913$var$stopDelayTimeout);
        // stopLowPriorityEventDelay performs a flush of the delayed events,
        // so the delayed period needs to be marked as ended _before_ calling that method.
        (0, $6iz4v.setMark)((0, $9f18a423c52d71b6$export$2d91d3eed1108e72));
        (0, $cbwiM.setEventDelayActive)(false);
        client.stopLowPriorityEventDelay();
        return client;
    });
};
const $4b25e5ad6cfac913$export$8bb8df5a93e9525 = ()=>{
    $4b25e5ad6cfac913$var$lastDelayActionPromise = $4b25e5ad6cfac913$var$lastDelayActionPromise.then((client)=>{
        // If startLowPriorityEventDelay is called when it's already active, then we are just extending
        // the delay period, so we don't want to reset any metadata we have captured about the original start.
        if (!(0, $cbwiM.isEventDelayActive)()) {
            (0, $ICvxP.default)((0, $9f18a423c52d71b6$export$358721a9d6125914));
            (0, $6iz4v.setMark)((0, $9f18a423c52d71b6$export$b2122dce85a27912));
        }
        client.startLowPriorityEventDelay();
        (0, $cbwiM.setEventDelayActive)(true);
        clearTimeout($4b25e5ad6cfac913$var$stopDelayTimeout);
        $4b25e5ad6cfac913$var$stopDelayTimeout = setTimeout($4b25e5ad6cfac913$export$a928755af449867, $4b25e5ad6cfac913$var$STOP_DELAY_TIMEOUT);
        return client;
    });
};
const $4b25e5ad6cfac913$export$778ebe2a4fab1ba7 = ()=>$4b25e5ad6cfac913$var$lastDelayActionPromise;
const $4b25e5ad6cfac913$var$EventDelayController = ()=>{
    const [loadedState] = (0, $epT40.default)();
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * The delay mechanism is currently locked so that only automatic exposure events
		 * can leverage it.
		 * We can remove the performance overhead of starting and stopping critical sections when
		 * these events won't be getting fired.
		 */ if (!loadedState.hasLoaded && (0, $87isp.isAutomaticExposureCollectionEnabled)()) $4b25e5ad6cfac913$export$8bb8df5a93e9525();
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
var $4b25e5ad6cfac913$export$2e2bcd8739ae039 = $4b25e5ad6cfac913$var$EventDelayController;

});
parcelRegister("ICvxP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dab3f6273aaa3f2$export$2e2bcd8739ae039);

var $hgcvd = parcelRequire("hgcvd");
var /*
 * This utility finds all performance entries that is prefixed
 * with the `prefix` and does clearMarks on each entry.
 * All the entries that are cleared will be returned
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$5dab3f6273aaa3f2$export$2e2bcd8739ae039 = (prefix)=>{
    // @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    if ((0, $hgcvd.default) && (0, $hgcvd.default).getEntries && (0, $hgcvd.default).clearMarks) return (0, $hgcvd.default)// @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    .getEntries()// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .filter((mark)=>mark.name.startsWith(prefix))// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .map((mark)=>{
        (0, $hgcvd.default).clearMarks(mark.name);
        return mark;
    });
    return [];
};

});

parcelRegister("cbwiM", function(module, exports) {

$parcel$export(module.exports, "setEventDelayActive", () => $00304183c2d9ac4d$export$9a4add6d6ddcc1a);
$parcel$export(module.exports, "isEventDelayActive", () => $00304183c2d9ac4d$export$3536b0184fa98d19);
let $00304183c2d9ac4d$var$eventDelayActive = false;
const $00304183c2d9ac4d$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
    $00304183c2d9ac4d$var$eventDelayActive = isEventDelayActive;
};
const $00304183c2d9ac4d$export$3536b0184fa98d19 = ()=>$00304183c2d9ac4d$var$eventDelayActive;

});

parcelRegister("epT40", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9158c027ae7ce81$export$2e2bcd8739ae039);

var $WBLbN = parcelRequire("WBLbN");


var $cfLkw = parcelRequire("cfLkw");
const $c9158c027ae7ce81$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    const determineHasLoaded = ()=>{
        /*
		 * During a transition, the top navigation is the only app loading. Additionally, legacy pages generally
		 * render a LegacyPage component, analytics, or nothing at all.
		 *
		 * This code ensures that the page is considered loaded when the content has finished loading in the
		 * SPA, or when the top navigation has finished loading for legacy pages.
		 *
		 * Ideally the LegacyPage component should include an app for the content, but the usage of route components
		 * in legacy routes is inconsistent and would need thorough testing. This should be good enough for now.
		 */ if (appIds.length === 1 && appIds[0] === (0, $9c22638d2f17f9db$export$3a54edb6ba4daa82)) return !__SPA__;
        return appIds.length ? appIds.filter((id)=>id !== (0, $9c22638d2f17f9db$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
    };
    const hasLoaded = determineHasLoaded();
    return {
        hasLoaded: hasLoaded
    };
};
const $c9158c027ae7ce81$var$usePageLoadedSubscriber = (0, $WBLbN.createHook)((0, $cfLkw.default), {
    selector: $c9158c027ae7ce81$export$4a361c7505f72f5c
});
var $c9158c027ae7ce81$export$2e2bcd8739ae039 = $c9158c027ae7ce81$var$usePageLoadedSubscriber;

});
const $9c22638d2f17f9db$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $9c22638d2f17f9db$export$2ee9e5a3556c1e43 = 'SIDEBAR';


const $9f18a423c52d71b6$export$358721a9d6125914 = 'event-delay-controller.';
const $9f18a423c52d71b6$export$b2122dce85a27912 = `${$9f18a423c52d71b6$export$358721a9d6125914}start`;
const $9f18a423c52d71b6$export$2d91d3eed1108e72 = `${$9f18a423c52d71b6$export$358721a9d6125914}end`;


parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("lbc5S", function(module, exports) {

$parcel$export(module.exports, "serviceViewPageLoad", () => $2d660796ffe57cd2$export$61008c925a90a363);

var $lNfG4 = parcelRequire("lNfG4");
const $2d660796ffe57cd2$export$61008c925a90a363 = (0, $lNfG4.metrics).pageLoad({
    key: 'service-management.queues.view'
});

});



parcelRegister("bzie7", function(module, exports) {

$parcel$export(module.exports, "default", () => $992c36445fa894d4$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $1RqtY = parcelRequire("1RqtY");

var $jLdzJ = parcelRequire("jLdzJ");
const $992c36445fa894d4$var$reloadWindow = ()=>window.location.reload();
const $992c36445fa894d4$var$mapStateToProps = (state)=>({
        isLoading: (0, $1RqtY.isRetrying)(state)
    });
const $992c36445fa894d4$var$mapDispatchToProps = ()=>({
        onRetry: $992c36445fa894d4$var$reloadWindow
    });
var $992c36445fa894d4$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($992c36445fa894d4$var$mapStateToProps, $992c36445fa894d4$var$mapDispatchToProps)((0, $jLdzJ.default));

});
parcelRegister("jLdzJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $61b614b1015a8591$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3NCZx = parcelRequire("3NCZx");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aLnof = parcelRequire("aLnof");
function $61b614b1015a8591$var$Error(props) {
    const { isLoading: isLoading, onRetry: onRetry } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3NCZx.default), {
        isLoading: isLoading,
        onRetry: onRetry,
        header: formatMessage((0, $aLnof.default).errorHeader),
        description: formatMessage((0, $aLnof.default).errorMessage)
    });
}
$61b614b1015a8591$var$Error.defaultProps = {
    isLoading: false
};
var $61b614b1015a8591$export$2e2bcd8739ae039 = $61b614b1015a8591$var$Error;

});
parcelRegister("aLnof", function(module, exports) {

$parcel$export(module.exports, "default", () => $daa3ac80c26b9ddf$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $daa3ac80c26b9ddf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorHeader: {
        "id": "servicedesk.queues.agent-view.layout.error-state.error-header",
        "defaultMessage": "We couldn't load your queue"
    },
    errorMessage: {
        "id": "servicedesk.queues.agent-view.layout.error-state.error-message",
        "defaultMessage": "Give it a few seconds, then try again."
    },
    reload: {
        "id": "servicedesk.queues.agent-view.layout.error-state.reload",
        "defaultMessage": "Reload"
    }
});

});



parcelRegister("1FxsB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c9db6bdc39fc27f$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $9mlBv = parcelRequire("9mlBv");

var $3KNsL = parcelRequire("3KNsL");

var $1RqtY = parcelRequire("1RqtY");

var $9aZuW = parcelRequire("9aZuW");

var $cv4q4 = parcelRequire("cv4q4");

var $9pSgL = parcelRequire("9pSgL");

var $ljZQ6 = parcelRequire("ljZQ6");
const $3c9db6bdc39fc27f$var$mapStateToProps = (state)=>({
        Actions: $9aZuW.default,
        IssueCount: $9pSgL.default,
        IssueSearch: $cv4q4.default,
        queueName: (0, $3KNsL.getQueueName)(state),
        isQueuesErrorHeaderDisplayed: (0, $1RqtY.isQueuesErrorHeaderDisplayed)(state)
    });
const $3c9db6bdc39fc27f$var$mapDispatchToProps = {
    renderDisplayError: (0, $9mlBv.displayQueuesErrorHeaderAction)
};
var $3c9db6bdc39fc27f$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($3c9db6bdc39fc27f$var$mapStateToProps, $3c9db6bdc39fc27f$var$mapDispatchToProps)((0, $ljZQ6.default));

});
parcelRegister("9aZuW", function(module, exports) {

$parcel$export(module.exports, "default", () => $97e99fdbae75a7d3$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $3KNsL = parcelRequire("3KNsL");

var $6ycyf = parcelRequire("6ycyf");

var $1RqtY = parcelRequire("1RqtY");

var $ke2NT = parcelRequire("ke2NT");

var $hrfIp = parcelRequire("hrfIp");

var $85rOK = parcelRequire("85rOK");

var $fhkjf = parcelRequire("fhkjf");

var $bHoUd = parcelRequire("bHoUd");
const $97e99fdbae75a7d3$var$mapStateToProps = (state)=>({
        ActionsMenu: $ke2NT.default,
        ResetSortingButton: $fhkjf.default,
        FavoriteButton: $hrfIp.default,
        OpenInIssueNavButton: $85rOK.default,
        canManageQueue: (0, $3KNsL.canManageQueue)(state),
        isManuallySorted: (0, $6ycyf.isManuallySorted)(state),
        isFavoriteEnabled: !(0, $3KNsL.isQueueTransient)(state),
        showIssueFailureError: (0, $1RqtY.showIssueFailureError)(state)
    });
var $97e99fdbae75a7d3$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($97e99fdbae75a7d3$var$mapStateToProps, {})((0, $bHoUd.default));

});
parcelRegister("ke2NT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b30cbb286c016fd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $4Bees = parcelRequire("4Bees");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7b30cbb286c016fd$var$LazyComponent = (0, $7rh0R.lazy)(()=>(parcelRequire("b773t")), {
    moduleId: "./src/packages/servicedesk/queues-agent-view/src/view/layout/header/actions/async-actions-menu/actions-menu/index.tsx"
});
const $7b30cbb286c016fd$var$Component = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "queues-agent-view-actions-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b30cbb286c016fd$var$LoadingComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "small"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b30cbb286c016fd$var$LazyComponent, props));
var $7b30cbb286c016fd$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $7b30cbb286c016fd$var$Component;
const $7b30cbb286c016fd$var$LoadingComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb14no _4t3i1tcg _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("b773t", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("l5X5Y")
]).then(()=>parcelRequire('g2VN7'));

});


parcelRegister("hrfIp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0564da7be3fce5d$export$2e2bcd8739ae039);

var $c8Guq = parcelRequire("c8Guq");

var $6rCaY = parcelRequire("6rCaY");

var $lNNXV = parcelRequire("lNNXV");

var $2dkjn = parcelRequire("2dkjn");

var $3KNsL = parcelRequire("3KNsL");

var $1y2Qd = parcelRequire("1y2Qd");
const $f0564da7be3fce5d$var$mapStateToProps = (state)=>({
        isFavorite: (0, $2dkjn.isQueueFavorited)(state),
        queueId: (0, $3KNsL.getQueueId)(state)
    });
var $f0564da7be3fce5d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $6rCaY.default)((state)=>({
        attributes: {
            queueId: (0, $3KNsL.getQueueId)(state),
            isFavorite: !(0, $2dkjn.isQueueFavorited)(state)
        }
    })), (0, $lNNXV.connect)($f0564da7be3fce5d$var$mapStateToProps, {}))(// @ts-expect-error - Argument of type '({ isFavorite, queueId }: Props) => JSX.Element' is not assignable to parameter of type 'ComponentType<unknown>'.
(0, $1y2Qd.default));

});
parcelRegister("6rCaY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b495978a3e51511d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $aw5Sy = parcelRequire("aw5Sy");

var $lNNXV = parcelRequire("lNNXV");

var $hZVJT = parcelRequire("hZVJT");

var $klunD = parcelRequire("klunD");
const $b495978a3e51511d$var$ReduxAnalyticsData = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToAnalytics, connectOptions = {})=>(WrappedComponent)=>{
        // eslint-disable-next-line jira/react/no-class-components
        class ComponentWrappedInAnalytics extends (0, $eUqFw.Component) {
            static{
                this.displayName = `ReduxAnalyticsData(${WrappedComponent.displayName || WrappedComponent.name})`;
            }
            static{
                this.defaultProps = {
                    analyticsContext: {}
                };
            }
            render() {
                const { analyticsContext: analyticsContext, ...componentProps } = this.props;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
                    data: analyticsContext
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, componentProps));
            }
        }
        const mapStateToPropsFactory = ()=>{
            const analyticsContextSelectorInstance = (0, $5iWql.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (state, ownProps)=>(0, $klunD.default)(mapStateToAnalytics(state, ownProps)));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (state, ownProps)=>({
                    analyticsContext: analyticsContextSelectorInstance(state, ownProps)
                });
        };
        return (0, $lNNXV.connect)(mapStateToPropsFactory, ()=>({}), null, {
            // to prevent connected component from unnecessary re-render
            areStatePropsEqual: (nextProps, prevProps)=>{
                const { attributes: prevAttributes, ...prevFields } = prevProps.analyticsContext;
                const { attributes: nextAttributes, ...nextFields } = nextProps.analyticsContext;
                return (0, $hZVJT.default)(prevAttributes, nextAttributes) && (0, $hZVJT.default)(prevFields, nextFields);
            },
            ...connectOptions
        })(ComponentWrappedInAnalytics);
    };
var $b495978a3e51511d$export$2e2bcd8739ae039 = $b495978a3e51511d$var$ReduxAnalyticsData;

});
parcelRegister("hZVJT", function(module, exports) {

$parcel$export(module.exports, "default", () => $831c3a9dcafdabca$export$2e2bcd8739ae039);
const $831c3a9dcafdabca$var$isArrayEqual = (array1 = [], array2 = [])=>{
    if (array1 === array2) return true;
    // check one level deep
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};
var // one level check to see if object references are equal
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$831c3a9dcafdabca$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'never[]'.
    if (!$831c3a9dcafdabca$var$isArrayEqual(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        const value = obj1[key];
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        // @ts-expect-error - TS2345 - Argument of type 'any[]' is not assignable to parameter of type 'never[]'.
        return Array.isArray(nextValue) && Array.isArray(value) && $831c3a9dcafdabca$var$isArrayEqual(value, nextValue);
    });
    return areValuesEqual;
};

});


parcelRegister("2dkjn", function(module, exports) {

$parcel$export(module.exports, "isQueueFavorited", () => $8112664937854ef6$export$a8538c0c3c892848);

var $1RqtY = parcelRequire("1RqtY");
const $8112664937854ef6$export$a8538c0c3c892848 = (state)=>{
    const queue = (0, $1RqtY.getCurrentQueue)(state);
    return queue ? queue.isFavorite : false;
};

});

parcelRegister("1y2Qd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc86c47e8bd0e12d$export$2e2bcd8739ae039);
/* eslint-disable jira/react-no-inline-function-prop */ 
var $eUqFw = parcelRequire("eUqFw");

var $ktkCe = parcelRequire("ktkCe");

var $jrdvV = parcelRequire("jrdvV");

var $dQZ5c = parcelRequire("dQZ5c");

var $aS6XE = parcelRequire("aS6XE");

var $aNBkj = parcelRequire("aNBkj");
const $bc86c47e8bd0e12d$var$FavoriteButton = ({ isFavorite: isFavorite, queueId: queueId })=>{
    const { changeFavorite: changeFavorite, items: items } = (0, $eUqFw.useContext)((0, $dQZ5c.FavoriteChangeContext));
    const getIsPending = ()=>{
        const queueItemChanges = items[0, $jrdvV.QUEUES_ITEM_TYPE];
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        const itemChanged = queueItemChanges[(0, $aNBkj.fromQueueIdString)(queueId)];
        return itemChanged ? itemChanged.pending : false;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aS6XE.AvailableQueuesConsumer), null, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ktkCe.default), {
            isFavorite: isFavorite,
            pending: getIsPending(),
            onClick: (analyticsEvent)=>{
                changeFavorite({
                    id: (0, $aNBkj.fromQueueIdString)(queueId),
                    value: !isFavorite,
                    type: (0, $jrdvV.QUEUES_ITEM_TYPE)
                }, analyticsEvent);
            }
        }));
};
var $bc86c47e8bd0e12d$export$2e2bcd8739ae039 = $bc86c47e8bd0e12d$var$FavoriteButton;

});
parcelRegister("ktkCe", function(module, exports) {

$parcel$export(module.exports, "FavoriteButtonWrapper", () => $3e4b24f33924a6f9$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $3e4b24f33924a6f9$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c8Guq = parcelRequire("c8Guq");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $23Ou2 = parcelRequire("23Ou2");

var $7jsaI = parcelRequire("7jsaI");

var $daM3L = parcelRequire("daM3L");

var $hlWtt = parcelRequire("hlWtt");

var $8L5aC = parcelRequire("8L5aC");

var $cc1Cw = parcelRequire("cc1Cw");

var $2eG9N = parcelRequire("2eG9N");

var $8un0w = parcelRequire("8un0w");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $giAhk = parcelRequire("giAhk");

var $8rQuz = parcelRequire("8rQuz");

var $apShl = parcelRequire("apShl");

var $ivkNG = parcelRequire("ivkNG");
const $3e4b24f33924a6f9$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $3e4b24f33924a6f9$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper';
class $3e4b24f33924a6f9$export$f8ad2acf0ec4860f extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $3e4b24f33924a6f9$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$export$db65185b5889c83, {
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') ? {
                'data-testid': $3e4b24f33924a6f9$var$SKELETON_TEST_ID
            } : {
                'data-test-id': $3e4b24f33924a6f9$var$SKELETON_TEST_ID
            },
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$3e4b24f33924a6f9$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $3e4b24f33924a6f9$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const sizeProps = isSmall ? {
            size: 'small'
        } : {};
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') ? {
                'data-testid': iconWrapperTestId
            } : {
                'data-test-id': iconWrapperTestId
            },
            isSmall: isSmall
        }, isFavorite ? // @ts-expect-error - TS2769 - No overload matches this call. | TS2769 - No overload matches this call.
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hlWtt))), {
            ...sizeProps,
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') && {
                label: formatMessage((0, $ivkNG.default).removeFromStarred)
            }
        }) : // @ts-expect-error - TS2769 - No overload matches this call. | TS2769 - No overload matches this call.
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($daM3L))), {
            ...sizeProps,
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') && {
                label: formatMessage((0, $ivkNG.default).addToStarred)
            }
        }));
        const renderIcon = ()=>{
            let label = '';
            if ((0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts')) {
                if (isFavorite) label = formatMessage((0, $ivkNG.default).removeFromStarred);
                else label = formatMessage((0, $ivkNG.default).addToStarred);
            }
            let StarIconComponent;
            if (isSmall) StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($8L5aC))) : (0, (/*@__PURE__*/$parcel$interopDefault($cc1Cw)));
            else StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($23Ou2))) : (0, (/*@__PURE__*/$parcel$interopDefault($7jsaI)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') ? {
                'data-testid': iconWrapperTestId
            } : {
                'data-test-id': iconWrapperTestId
            },
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $ivkNG.default).removeFromStarred) : formatMessage((0, $ivkNG.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $ivkNG.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $ivkNG.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        }, (0, $8rQuz.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isAnimating: false
        };
        this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        };
        this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $3e4b24f33924a6f9$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $8un0w.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $giAhk.injectIntlV2))($3e4b24f33924a6f9$export$f8ad2acf0ec4860f);
const $3e4b24f33924a6f9$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3e4b24f33924a6f9$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e4b24f33924a6f9$var$FavoriteIconWrapperBaseOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn1ssb _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e4b24f33924a6f9$var$FavoriteIconWrapperBaseNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
});
const $3e4b24f33924a6f9$var$FavoriteIconWrapperBase = (0, $9zysr.componentWithCondition)((0, $8rQuz.isVisualRefreshEnabled), $3e4b24f33924a6f9$var$FavoriteIconWrapperBaseNew, $3e4b24f33924a6f9$var$FavoriteIconWrapperBaseOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e4b24f33924a6f9$var$FavIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $3e4b24f33924a6f9$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isFavorite ? "_syaz2kyj" : "_syaz2u25",
            __cmplp.isFavorite ? "_30l31ebw" : "_30l3w9a8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3e4b24f33924a6f9$export$db65185b5889c83 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8un0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $da3e17e369dbbaa5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $etqm0 = parcelRequire("etqm0");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $da3e17e369dbbaa5$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $eUqFw.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $da3e17e369dbbaa5$export$2e2bcd8739ae039 = $da3e17e369dbbaa5$var$fireWithUIAnalytics;

});

parcelRegister("ivkNG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d79b2c2cf8a78bb3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d79b2c2cf8a78bb3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});

});




parcelRegister("85rOK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d332e9dfa91e1c06$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $3nTcJ = parcelRequire("3nTcJ");

var $3KNsL = parcelRequire("3KNsL");

var $8IO1r = parcelRequire("8IO1r");
const $d332e9dfa91e1c06$var$mapStateToProps = (state)=>({
        projectKey: (0, $3nTcJ.getProjectKey)(state),
        queueJql: (0, $3KNsL.getCompleteJql)(state)
    });
var $d332e9dfa91e1c06$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($d332e9dfa91e1c06$var$mapStateToProps, {})((0, $8IO1r.OpenInIssueNavButton));

});
parcelRegister("8IO1r", function(module, exports) {

$parcel$export(module.exports, "OpenInIssueNavButton", () => $f94791ae82302623$export$72e8ee1dd9380293);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $23NQ5 = parcelRequire("23NQ5");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $6TlNX = parcelRequire("6TlNX");
const $f94791ae82302623$var$getIssueNavUrl = (projectKey, queueJql)=>projectKey ? `/jira/servicedesk/projects/${projectKey}/issues/?jql=${encodeURIComponent(queueJql)}` : `/issues/?jql=${encodeURIComponent(queueJql)}`;
const $f94791ae82302623$export$72e8ee1dd9380293 = (_props)=>{
    const { projectKey: projectKey, queueJql: queueJql } = _props;
    const issueNavUrl = $f94791ae82302623$var$getIssueNavUrl(projectKey, queueJql);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onClick = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'navigateToIssueNavFromQueues', {
            hasProjectKey: typeof projectKey === 'string'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $6TlNX.default).openWithIssueNav)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "servicedesk-queues-agent-view.layout.header.actions.open-in-issue-nav-button.open-in-issue-nav-button",
        href: issueNavUrl,
        target: "_blank",
        onClick: onClick,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
            label: "",
            size: "medium"
        }),
        appearance: "subtle"
    }));
};

});
parcelRegister("6TlNX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0207bd56d09ef63$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f0207bd56d09ef63$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    deleteQueue: {
        "id": "servicedesk.queues.common.delete-queue",
        "defaultMessage": "Delete queue"
    },
    resetSorting: {
        "id": "servicedesk.queues.common.reset-sorting",
        "defaultMessage": "Reset sorting"
    },
    openWithIssueNav: {
        "id": "servicedesk.queues.common.open-with-issue-nav",
        "defaultMessage": "Open in issue navigator"
    }
});

});



parcelRegister("fhkjf", function(module, exports) {

$parcel$export(module.exports, "default", () => $907f84468754da3d$export$2e2bcd8739ae039);

var $c8Guq = parcelRequire("c8Guq");

var $6rCaY = parcelRequire("6rCaY");

var $8un0w = parcelRequire("8un0w");

var $lNNXV = parcelRequire("lNNXV");

var $bfxje = parcelRequire("bfxje");

var $6ycyf = parcelRequire("6ycyf");

var $jg3At = parcelRequire("jg3At");
var $907f84468754da3d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $8un0w.default)({
    onResetSorting: 'resetSorting'
}), (0, $6rCaY.default)((state)=>({
        attributes: {
            fieldId: (0, $6ycyf.getSortedByColumn)(state),
            sortOrder: (0, $6ycyf.getSortOrder)(state)
        }
    })), (0, $lNNXV.connect)(null, {
    onResetSorting: (0, $bfxje.resetSortOrderAction)
}))((0, $jg3At.default));

});
parcelRegister("jg3At", function(module, exports) {

$parcel$export(module.exports, "default", () => $0109427fdbe2f611$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $giAhk = parcelRequire("giAhk");

var $6TlNX = parcelRequire("6TlNX");
function $0109427fdbe2f611$export$ce3eb8345b6d11e3(props) {
    const { intl: { formatMessage: formatMessage }, onResetSorting: onResetSorting } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onResetSorting
    }, formatMessage((0, $6TlNX.default).resetSorting));
}
var $0109427fdbe2f611$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($0109427fdbe2f611$export$ce3eb8345b6d11e3);

});


parcelRegister("bHoUd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0410fdd29e0bf142$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dHiWd = parcelRequire("dHiWd");
function $0410fdd29e0bf142$export$2e2bcd8739ae039({ canManageQueue: canManageQueue, isManuallySorted: isManuallySorted, isFavoriteEnabled: isFavoriteEnabled, onDeleteComplete: onDeleteComplete, showIssueFailureError: showIssueFailureError, ActionsMenu: ActionsMenu, FavoriteButton: FavoriteButton, ResetSortingButton: ResetSortingButton, OpenInIssueNavButton: OpenInIssueNavButton }) {
    const shouldShowResetSortingButton = !showIssueFailureError && !canManageQueue && isManuallySorted;
    const hasMultipleActions = isFavoriteEnabled && (canManageQueue || shouldShowResetSortingButton);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0410fdd29e0bf142$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dHiWd.AsyncQueuesAutomationMenu), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(OpenInIssueNavButton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0410fdd29e0bf142$var$Spacer, null)), isFavoriteEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FavoriteButton, null), hasMultipleActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0410fdd29e0bf142$var$Spacer, null), canManageQueue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ActionsMenu, {
        onDeleteComplete: onDeleteComplete
    }), shouldShowResetSortingButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ResetSortingButton, null));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0410fdd29e0bf142$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $0410fdd29e0bf142$var$Spacer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbftgi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dHiWd", function(module, exports) {

$parcel$export(module.exports, "AsyncQueuesAutomationMenu", () => $93f6b17754893dd7$export$a6b9948799694c4f);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");


var $2jIxA = parcelRequire("2jIxA");
const $93f6b17754893dd7$var$runtimeProps = {};
const $93f6b17754893dd7$var$entryPointParams = {};
const $93f6b17754893dd7$export$a6b9948799694c4f = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $2jIxA.queuesAutomationMenuEntryPoint), $93f6b17754893dd7$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jsm.queues.automation.menu",
        packageName: (0, $61442b9b521c7056$export$b8b9d90f9e5bd72b),
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $93f6b17754893dd7$var$runtimeProps,
        errorFallback: "flag"
    });
};

});
const $61442b9b521c7056$export$b8b9d90f9e5bd72b = 'jiraServicedeskQueuesAutomationMenu';
const $61442b9b521c7056$export$d57b6b390e78d90f = 'jsd-shield';

parcelRegister("2jIxA", function(module, exports) {

$parcel$export(module.exports, "queuesAutomationMenuEntryPoint", () => $c767015f3968c1fc$export$3165d8c5913e99eb);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $c767015f3968c1fc$export$3165d8c5913e99eb = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("hnxbU")), {
        moduleId: "2f0e15f7"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hnxbU", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kUryh")
]).then(()=>parcelRequire('8GSma'));

});





parcelRegister("cv4q4", function(module, exports) {

$parcel$export(module.exports, "default", () => $513029ea93cd2562$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $9VPEO = parcelRequire("9VPEO");

var $gGtKh = parcelRequire("gGtKh");

var $5dGTN = parcelRequire("5dGTN");

const $513029ea93cd2562$var$LazyComponent = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("ap5dA")), {
    moduleId: "./src/packages/servicedesk/queues-agent-view/src/view/layout/header/async-issue-search/issue-search/index.tsx"
});
const $513029ea93cd2562$var$Component = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "queues-agent-view-issue-search",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5dGTN.SkeletonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
            height: "32px",
            width: "240px"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($513029ea93cd2562$var$LazyComponent, props));
var $513029ea93cd2562$export$2e2bcd8739ae039 = $513029ea93cd2562$var$Component;

});
parcelRegister("9VPEO", function(module, exports) {

$parcel$export(module.exports, "getKeyframes", () => $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec);
$parcel$export(module.exports, "Skeleton", () => $fdf3dd89d5b95a51$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "Spacer", () => $fdf3dd89d5b95a51$export$d7a54cba636a8cd6);
$parcel$export(module.exports, "SkeletonCompiled", () => $fdf3dd89d5b95a51$export$dc84d515085190e);
$parcel$export(module.exports, "SpacerCompiled", () => $fdf3dd89d5b95a51$export$e477bb7d17087f28);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

const $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
    const fromPositionX = -Math.abs(offsetX) - 300;
    const toPositionX = fromPositionX + 2000;
    return (0, $kwce8.keyframes)({
        '0%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${fromPositionX}px 0`
        },
        '100%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${toPositionX}px 0`
        }
    });
};
const $fdf3dd89d5b95a51$var$shimmer = $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec();
const $fdf3dd89d5b95a51$export$8f31e4c4a37b8e9c = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ieqbub-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationDelay: props.theme.animationDelay || '0s',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationName: props.theme.animationName || $fdf3dd89d5b95a51$var$shimmer,
        animationTimingFunction: 'linear',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$exports).N30})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundImage: `linear-gradient( to right, ${`var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$exports).N30})`} 10%, ${`var(--ds-skeleton-subtle, ${(0, $73a5c9d720aa66e1$exports).N20})`} 30%, ${`var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$exports).N30})`} 50% )`,
        backgroundRepeat: 'no-repeat',
        borderRadius: '2px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width
    }));
const $fdf3dd89d5b95a51$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ieqbub-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height
    }));
const $fdf3dd89d5b95a51$export$dc84d515085190e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height),
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk _2rkoyh40 _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $fdf3dd89d5b95a51$export$e477bb7d17087f28 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';


parcelRegister("5dGTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $1324adf13f3bbb3d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "SkeletonWrapper", () => $1324adf13f3bbb3d$export$6069cbe61f690103);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dxIU5 = parcelRequire("dxIU5");

var $SD4Im = parcelRequire("SD4Im");

var $bPZtE = parcelRequire("bPZtE");

var $cf2Y4 = parcelRequire("cf2Y4");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lVJi9 = parcelRequire("lVJi9");
const $1324adf13f3bbb3d$var$TextFieldWidth = 240;
const $1324adf13f3bbb3d$var$createJQLClause = (text)=>`summary ~ "${text}*" OR description ~ "${text}*"`;
const $1324adf13f3bbb3d$var$IssueSearchView = ({ onChange: onChange, onChangedIsPendingSubmission: onChangedIsPendingSubmission, onFocusChange: onFocusChange, queueId: queueId, filterQuery: filterQuery })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { placeholder: placeholder } = (0, $lVJi9.default);
    const [value, setValue] = (0, $eUqFw.useState)('');
    const [isIconHovered, setHovered] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        setValue('');
    }, [
        queueId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (filterQuery === null) setValue('');
    }, [
        filterQuery
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            onFocusChange(false);
        }, [
        onFocusChange
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'queueSearchBox'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'queueSearchBoxViewed');
    }, [
        createAnalyticsEvent
    ]); // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedSearch = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((query)=>{
        const filterJQL = query === '' ? null : $1324adf13f3bbb3d$var$createJQLClause(query);
        onChange(filterJQL);
        onChangedIsPendingSubmission(true);
    }, 2000), [
        onChange
    ]); // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    const handleSearchChange = (event)=>{
        setValue(event.target.value);
        debouncedSearch(event.target.value);
    };
    const onFocusHandle = ()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueFiltering clicked');
        onFocusChange(true);
    };
    const onBlurHandle = ()=>onFocusChange(false);
    const onMouseEnterButton = (0, $eUqFw.useCallback)(()=>setHovered(true), []);
    const onMouseLeaveButton = (0, $eUqFw.useCallback)(()=>setHovered(false), []);
    const clearSearch = ()=>{
        setValue('');
        onChange(null);
        onChangedIsPendingSubmission(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1324adf13f3bbb3d$var$MinWidthWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        isCompact: true,
        width: $1324adf13f3bbb3d$var$TextFieldWidth,
        placeholder: formatMessage(placeholder),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bPZtE))), {
            label: ""
        }),
        onChange: handleSearchChange,
        value: value,
        onFocus: onFocusHandle,
        onBlur: onBlurHandle,
        elemAfterInput: value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: formatMessage((0, $lVJi9.default).clearSearch)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1324adf13f3bbb3d$var$ClearSearchWrapper, {
            onClick: clearSearch,
            onMouseEnter: onMouseEnterButton,
            onMouseLeave: onMouseLeaveButton,
            "data-testid": "servicedesk-queues-agent-view.layout.header.async-issue-search.issue-search.clear-search"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($SD4Im))), {
            color: isIconHovered ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-disabled, #091E424F)",
            label: formatMessage((0, $lVJi9.default).clearSearch),
            spacing: "none"
        })))
    }));
};
var $1324adf13f3bbb3d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $1324adf13f3bbb3d$var$IssueSearchView;
const $1324adf13f3bbb3d$var$ClearSearchWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _80omtlke _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); /*
     * these styles are used for accomodating smaller screen sizes with the introduction of the split filters
     *
     * the min-width is needed to prevent the text area from shrinking to 0 size
     * the flex-shrink is used to give width priority to the active issue types / portal groups filters
     * the text-overflow is used when the text input is shrunken
     */ 
const $1324adf13f3bbb3d$var$MinWidthWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkx0bf _1bsbp3fh _1ul953f4 _1o9z15gg _509t1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $1324adf13f3bbb3d$export$6069cbe61f690103 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkx0bf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("SD4Im", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f38a712ca2a7ec6c029336fe6611116d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0a435abfd51fcd89$var$_react = $0a435abfd51fcd89$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $0a435abfd51fcd89$var$_crossCircle = $0a435abfd51fcd89$var$_interopRequireDefault((parcelRequire("hsyGm")));

var $0a435abfd51fcd89$var$_selectClear = $0a435abfd51fcd89$var$_interopRequireDefault((parcelRequire("hUbUe")));
function $0a435abfd51fcd89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0a435abfd51fcd89$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $0a435abfd51fcd89$var$_react.default.createElement($0a435abfd51fcd89$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $0a435abfd51fcd89$var$_selectClear.default
    }, props));
$0a435abfd51fcd89$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $0a435abfd51fcd89$var$_default = module.exports.default = $0a435abfd51fcd89$var$CrossCircleIcon;

});
parcelRegister("hsyGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb5ff45e92d98b0f$var$_react = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cb5ff45e92d98b0f$var$_UNSAFE_baseNew = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cb5ff45e92d98b0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb5ff45e92d98b0f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $cb5ff45e92d98b0f$var$_react.default.createElement($cb5ff45e92d98b0f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$cb5ff45e92d98b0f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $cb5ff45e92d98b0f$var$_default = module.exports.default = $cb5ff45e92d98b0f$var$CrossCircleIcon;

});

parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d090e6e9cc89e346$var$_crossCircle = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $d090e6e9cc89e346$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $d090e6e9cc89e346$var$_crossCircle.default
    }));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = module.exports.default = $d090e6e9cc89e346$var$SelectClearIcon;

});


parcelRegister("bPZtE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89e4253a013a6022$var$_react = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $89e4253a013a6022$var$_search = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("9IsWp")));
function $89e4253a013a6022$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $89e4253a013a6022$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $89e4253a013a6022$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $89e4253a013a6022$var$_search.default
    }));
$89e4253a013a6022$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $89e4253a013a6022$var$_default = module.exports.default = $89e4253a013a6022$var$EditorSearchIcon;

});

parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("lVJi9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e09de545fe6abe78$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e09de545fe6abe78$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "servicedesk.queues.agent-view.layout.header.async-issue-search.issue-search.placeholder",
        "defaultMessage": "Search for issues"
    },
    clearSearch: {
        "id": "servicedesk.queues.agent-view.layout.header.async-issue-search.issue-search.clear-search",
        "defaultMessage": "Clear search"
    }
});

});


parcelRegister("ap5dA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gqwte").then(()=>parcelRequire('kwi6F'));

});


parcelRegister("9pSgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99362fb86e0e89d$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");


var $8N2pO = parcelRequire("8N2pO");

var $3ztB9 = parcelRequire("3ztB9");

var $8UPn4 = parcelRequire("8UPn4");

var $8GAE5 = parcelRequire("8GAE5");

var $1RqtY = parcelRequire("1RqtY");

var $7cH03 = parcelRequire("7cH03");
const $b99362fb86e0e89d$var$mapDispatchToProps = (dispatch)=>({
        onFilterReloadClick: ()=>{
            dispatch((0, $8N2pO.isNewFilterQueryPendingAction)(true));
            dispatch((0, $3ztB9.loadIssuesAction)(0, (0, $34edc5e681269c4f$export$be4c1ea173a5271a)));
        }
    });
const $b99362fb86e0e89d$var$mapStateToProps = (state)=>({
        issueCount: (0, $8GAE5.getIssueCount)(state),
        isCurrentDataFiltered: (0, $8UPn4.getIsCurrentDataFiltered)(state),
        isLoadingIssues: (0, $1RqtY.isLoadingIssues)(state)
    });
var $b99362fb86e0e89d$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($b99362fb86e0e89d$var$mapStateToProps, $b99362fb86e0e89d$var$mapDispatchToProps)((0, $7cH03.default));

});
parcelRegister("7cH03", function(module, exports) {

$parcel$export(module.exports, "default", () => $e46f185a1db59ef5$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $iPlKJ = parcelRequire("iPlKJ");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $2eG9N = parcelRequire("2eG9N");

var $9VPEO = parcelRequire("9VPEO");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $1NuK6 = parcelRequire("1NuK6");
const $e46f185a1db59ef5$export$542fba90cc9c1bd1 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { issueCount: issueCount, isCurrentDataFiltered: isCurrentDataFiltered, isLoadingIssues: isLoadingIssues, onFilterReloadClick: onFilterReloadClick } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleReloadClick = ()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueFiltering reloaded');
        onFilterReloadClick();
    };
    if (!isCurrentDataFiltered && issueCount !== 0 && !isLoadingIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e46f185a1db59ef5$export$e6dfd72ab29f8598, null, formatMessage((0, $1NuK6.default).numberOfIssues, {
        issueCount: issueCount
    }));
    if (isCurrentDataFiltered && !isLoadingIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e46f185a1db59ef5$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e46f185a1db59ef5$var$Layout, null, formatMessage((0, $1NuK6.default).numberOfFilteredIssues, {
        filteredIssueCount: issueCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $e46f185a1db59ef5$var$spacerStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        position: "bottom",
        content: formatMessage((0, $1NuK6.default).refreshResults)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": formatMessage((0, $1NuK6.default).refreshResults),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iPlKJ))), {
            label: formatMessage((0, $1NuK6.default).refreshResults),
            size: "small"
        }),
        "data-testId": "servicedesk-queues-agent-view.layout.header.issue-count.reload-button",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleReloadClick
    }))));
    return isLoadingIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e46f185a1db59ef5$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "24px",
        width: "100px",
        "data-testid": "servicedesk-queues-agent-view.layout.header.issue-count.skeleton"
    })) : null;
};
var $e46f185a1db59ef5$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = $e46f185a1db59ef5$export$542fba90cc9c1bd1;
const $e46f185a1db59ef5$var$Layout = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $e46f185a1db59ef5$var$spacerStyles = (0, $1ZAYh.xcss)({
    width: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $e46f185a1db59ef5$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1a45 _19pkutpp _otyr1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iPlKJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db4ddd0d819bf555$var$_react = $db4ddd0d819bf555$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $db4ddd0d819bf555$var$_refresh = $db4ddd0d819bf555$var$_interopRequireDefault((parcelRequire("h1qCH")));
function $db4ddd0d819bf555$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $db4ddd0d819bf555$var$RefreshIcon = (props)=>/*#__PURE__*/ $db4ddd0d819bf555$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $db4ddd0d819bf555$var$_refresh.default
    }));
$db4ddd0d819bf555$var$RefreshIcon.displayName = 'RefreshIcon';
var $db4ddd0d819bf555$var$_default = module.exports.default = $db4ddd0d819bf555$var$RefreshIcon;

});
parcelRegister("h1qCH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53a1e2fd011260ddfe6bcff1f1f84f50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6472e7a17144be6$var$_react = $c6472e7a17144be6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c6472e7a17144be6$var$_UNSAFE_baseNew = $c6472e7a17144be6$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c6472e7a17144be6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6472e7a17144be6$var$RefreshIcon = (props)=>/*#__PURE__*/ $c6472e7a17144be6$var$_react.default.createElement($c6472e7a17144be6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6V1.75H2m5.5 12.48c-3.218-.254-5.75-2.447-5.75-5.73 0-3.368 2.42-4.921 4-6.29m4 7.77v4.25H14M8.5 1.75c3.218.255 5.75 2.447 5.75 5.73 0 3.352-2.397 4.906-3.977 6.27"/>`
    }, props));
$c6472e7a17144be6$var$RefreshIcon.displayName = 'RefreshIcon';
var $c6472e7a17144be6$var$_default = module.exports.default = $c6472e7a17144be6$var$RefreshIcon;

});


parcelRegister("1NuK6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1288dd0515da7c7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c1288dd0515da7c7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    numberOfIssues: {
        "id": "servicedesk.queues.agent-view.layout.header.issue-count.number-of-issues",
        "defaultMessage": "{issueCount, plural,\n            =1 {{issueCount, number} issue}\n            other {{issueCount, number} issues}\n            }"
    },
    numberOfFilteredIssues: {
        "id": "servicedesk.queues.agent-view.layout.header.issue-count.number-of-filtered-issues",
        "defaultMessage": "{filteredIssueCount, plural,\n            =1 {{filteredIssueCount, number} issue found}\n            other {{filteredIssueCount, number} issues found}\n            }"
    },
    refreshResults: {
        "id": "servicedesk.queues.agent-view.layout.header.issue-count.refresh-results",
        "defaultMessage": "Refresh results"
    }
});

});



parcelRegister("ljZQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e939da96688dbb59$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $lRvnl = parcelRequire("lRvnl");
var $cEUHb = parcelRequire("cEUHb");

var $3a8wJ = parcelRequire("3a8wJ");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $55Wlg = parcelRequire("55Wlg");

var $g039U = parcelRequire("g039U");

var $3b8jW = parcelRequire("3b8jW");
function $e939da96688dbb59$export$2e2bcd8739ae039(props) {
    const [addTopMargin, setAddTopMargin] = (0, $eUqFw.useState)(false);
    const { queueName: queueName, onDeleteComplete: onDeleteComplete, renderDisplayError: renderDisplayError, Actions: Actions, IssueCount: IssueCount, IssueSearch: IssueSearch, isQueuesErrorHeaderDisplayed: isQueuesErrorHeaderDisplayed } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleError = (location)=>{
        if (location === 'common.error-boundary.queue-page-header') setAddTopMargin(true);
        renderDisplayError();
    };
    const handleReload = ()=>{
        window.location.reload();
    };
    const errorSectionDefaultStyles = (0, $1ZAYh.xcss)({
        marginTop: 'space.0'
    });
    const errorMarginTopStyles = (0, $1ZAYh.xcss)({
        marginTop: 'space.400'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g039U.FFErrorBoundary), {
        onError: handleError,
        id: "queue-page-header-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g039U.FFErrorBoundary), {
        onError: handleError,
        id: "queue-page-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
        truncateTitle: true,
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Actions, {
            onDeleteComplete: onDeleteComplete
        }),
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55Wlg.default), null)
    }, queueName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.400",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: [
            errorSectionDefaultStyles,
            addTopMargin && errorMarginTopStyles
        ]
    }, isQueuesErrorHeaderDisplayed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        title: formatMessage((0, $3b8jW.messages).errorSectionTitle),
        appearance: "error",
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEUHb.default), {
            onClick: handleReload
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3b8jW.messages).reloadPageLinkText))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3b8jW.messages).errorSectionBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g039U.FFErrorBoundary), {
        onError: renderDisplayError,
        id: "queue-issue-search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueSearch, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueCount, null)))));
}

});
parcelRegister("cEUHb", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8e69e42130a2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $6eba8e69e42130a2$var$SectionMessageAction = /*#__PURE__*/ (0, $eUqFw.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
    // FIXME: This path doesn't make sense
    // If the intent of the design for this component is to use an action, not providing `href` or `onClick`
    // makes the use case invalid. This should be addressed.
    return onClick || href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
});
$6eba8e69e42130a2$var$SectionMessageAction.displayName = 'SectionMessageAction';
var $6eba8e69e42130a2$export$2e2bcd8739ae039 = $6eba8e69e42130a2$var$SectionMessageAction;

});

parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hFGUl = parcelRequire("hFGUl");
const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $fce98fdc5842132f$var$titleStyles,
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});



parcelRegister("55Wlg", function(module, exports) {

$parcel$export(module.exports, "default", () => $17d017bcc8a3d97e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $c76ap = parcelRequire("c76ap");

var $dnJL9 = parcelRequire("dnJL9");
const $17d017bcc8a3d97e$var$QueuesBreadcrumbRendererLegacy = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $17d017bcc8a3d97e$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null));
const $17d017bcc8a3d97e$var$QueuesBreadcrumbRendererNew = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null);
var $17d017bcc8a3d97e$export$2e2bcd8739ae039 = (0, $dnJL9.componentWithFG)('jsm-fission-decompose-queue-page-header', $17d017bcc8a3d97e$var$QueuesBreadcrumbRendererNew, $17d017bcc8a3d97e$var$QueuesBreadcrumbRendererLegacy);
const $17d017bcc8a3d97e$var$wrapperStyles = (0, $1ZAYh.xcss)({
    /* negates margin added by original component */ marginLeft: 'space.negative.050'
});

});

parcelRegister("g039U", function(module, exports) {

$parcel$export(module.exports, "FFErrorBoundary", () => $187eedd016ef0cbb$export$1a99c46b1b67cad6);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");
const $187eedd016ef0cbb$export$1a99c46b1b67cad6 = ({ children: children, onError: onError, id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        onError: onError,
        id: id,
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount",
        teamName: "jsd-shield"
    }, children);

});

parcelRegister("3b8jW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3b1c24b8300355f7$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $3b1c24b8300355f7$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    errorSectionTitle: {
        "id": "servicedesk.queues.agent-view.layout.header.error-section-title",
        "defaultMessage": "We currently have an outage"
    },
    errorSectionBody: {
        "id": "servicedesk.queues.agent-view.layout.header.error-section-body",
        "defaultMessage": "We're working hard to resolve temporary glitches with this page. But rest assured, the key functions on this page remain fully operational."
    },
    reloadPageLinkText: {
        "id": "servicedesk.queues.agent-view.layout.header.reload-page-link-text",
        "defaultMessage": "Reload the page"
    }
});

});



parcelRegister("eFzWc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e667eb7d53fab943$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $kBhD3 = parcelRequire("kBhD3");

var $c4xFA = parcelRequire("c4xFA");
const $e667eb7d53fab943$var$mapDispatchToProps = {
    onSetIssueKeyContext: (0, $kBhD3.setIssueKeyContext)
};
var $e667eb7d53fab943$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, $e667eb7d53fab943$var$mapDispatchToProps)((0, $c4xFA.IssueContextListener));

});
parcelRegister("c4xFA", function(module, exports) {

$parcel$export(module.exports, "IssueContextListener", () => $32fe032d9b1ecffb$export$3581168f8217134);

var $eUqFw = parcelRequire("eUqFw");

var $jRTJE = parcelRequire("jRTJE");
function $32fe032d9b1ecffb$export$3581168f8217134({ onSetIssueKeyContext: onSetIssueKeyContext }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRTJE.IssueContextSubscriber), null, ({ issueKeyContext: issueKeyContext })=>{
        onSetIssueKeyContext(issueKeyContext);
        return null;
    });
}

});
parcelRegister("jRTJE", function(module, exports) {

$parcel$export(module.exports, "IssueContextSubscriber", () => $41a96a192f387ad1$export$d5fe934bda9e4605);

var $WBLbN = parcelRequire("WBLbN");

var $cpDTy = parcelRequire("cpDTy");
const $41a96a192f387ad1$export$93db6a8f3342dddf = (0, $WBLbN.createContainer)((0, $cpDTy.default));
const $41a96a192f387ad1$export$d5fe934bda9e4605 = (0, $WBLbN.createSubscriber)((0, $cpDTy.default));
const $41a96a192f387ad1$export$95e128ed686255dc = (0, $WBLbN.createHook)((0, $cpDTy.default));

});
parcelRegister("cpDTy", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f2c4a299415092e$export$2e2bcd8739ae039);

var $WBLbN = parcelRequire("WBLbN");

var $1bOeB = parcelRequire("1bOeB");
const $7f2c4a299415092e$var$initialState = {
    issueKeyContext: undefined
};
var $7f2c4a299415092e$export$2e2bcd8739ae039 = (0, $WBLbN.createStore)({
    name: 'issue-context',
    initialState: $7f2c4a299415092e$var$initialState,
    actions: $1bOeB.default
});

});
parcelRegister("1bOeB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b38b28538f8a947$export$2e2bcd8739ae039);
const $2b38b28538f8a947$var$actions = {
    setIssueKeyContext: (issueKey)=>({ setState: setState })=>setState({
                issueKeyContext: issueKey
            })
};
var $2b38b28538f8a947$export$2e2bcd8739ae039 = $2b38b28538f8a947$var$actions;

});





parcelRegister("qroR3", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a572cae62ddba8b$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $5KU0G = parcelRequire("5KU0G");

var $59lQ2 = parcelRequire("59lQ2");
var $2a572cae62ddba8b$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, (dispatch)=>({
        onUpdatePractices: (practiceList)=>{
            dispatch((0, $5KU0G.setEnabledPracticesAction)(practiceList));
        }
    }))((0, $59lQ2.default));

});
parcelRegister("59lQ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d60416e36d46b9aa$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $1L8BM = parcelRequire("1L8BM");
const $d60416e36d46b9aa$var$ItsmContextListener = ({ projectKey: projectKey, onUpdatePractices: onUpdatePractices })=>{
    const practicesBelongsToRef = (0, $eUqFw.useRef)('');
    const [practices, loading, error] = (0, $1L8BM.usePracticeList)();
    (0, $eUqFw.useLayoutEffect)(()=>{
        const canUpdatePractices = !loading && !error && practicesBelongsToRef.current !== projectKey;
        if (canUpdatePractices) {
            practicesBelongsToRef.current = projectKey;
            onUpdatePractices(practices || []);
        }
    }, [
        projectKey,
        loading,
        error,
        onUpdatePractices,
        practices
    ]);
    return null;
};
$d60416e36d46b9aa$var$ItsmContextListener.defaultProps = {
    projectKey: '',
    onUpdatePractices: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $d60416e36d46b9aa$export$2e2bcd8739ae039 = $d60416e36d46b9aa$var$ItsmContextListener;

});


parcelRegister("6gHnM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c52a31844947ef1$export$2e2bcd8739ae039);

var $c8Guq = parcelRequire("c8Guq");

var $g8JvH = parcelRequire("g8JvH");

var $lNNXV = parcelRequire("lNNXV");

var $8UPn4 = parcelRequire("8UPn4");

var $8GAE5 = parcelRequire("8GAE5");

var $3s9hs = parcelRequire("3s9hs");

var $iEv2A = parcelRequire("iEv2A");
const $7c52a31844947ef1$var$mapStateToProps = (state)=>({
        issueCount: (0, $8GAE5.getIssueCount)(state),
        projectStateHash: (0, $3s9hs.getProjectStateHash)(state),
        isCurrentDataFiltered: (0, $8UPn4.getIsCurrentDataFiltered)(state)
    });
var $7c52a31844947ef1$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $lNNXV.connect)($7c52a31844947ef1$var$mapStateToProps, {}), (0, $g8JvH.AnalyticsEventToProps)('navUpdate', {
    onProjectStateHashUpdate: 'queuesCountsRefreshed'
}))((0, $iEv2A.default));

});
parcelRegister("g8JvH", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $4e66802e461455f0$export$3e9ef96ba97ea9dc);

var $2jDha = parcelRequire("2jDha");
const $4e66802e461455f0$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $4e66802e461455f0$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $2jDha.default)($4e66802e461455f0$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

parcelRegister("iEv2A", function(module, exports) {

$parcel$export(module.exports, "default", () => $e39652d05ac4a1a0$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");
class $e39652d05ac4a1a0$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            onQueueIssueCountUpdated: undefined,
            onProjectStateHashUpdate: undefined
        };
    }
    componentDidMount() {
        this.updateIssueCount();
    }
    componentDidUpdate(prevProps) {
        const { projectStateHash: projectStateHash, onProjectStateHashUpdate: onProjectStateHashUpdate, issueCount: issueCount } = this.props;
        if (prevProps.issueCount !== issueCount) this.updateIssueCount();
        if (// Only call again if it isn't immediately following an initialization call (projectStateHash = null)
        !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(prevProps.projectStateHash) && prevProps.projectStateHash !== projectStateHash && onProjectStateHashUpdate) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        onProjectStateHashUpdate();
    }
    updateIssueCount() {
        const { queueId: queueId, issueCount: issueCount, onQueueIssueCountUpdated: onQueueIssueCountUpdated, isCurrentDataFiltered: isCurrentDataFiltered } = this.props;
        !isCurrentDataFiltered && onQueueIssueCountUpdated && onQueueIssueCountUpdated(queueId, issueCount);
    }
    render() {
        return null;
    }
}

});


parcelRegister("ijIX7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0648ed10cfbfeb8e$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $3nTcJ = parcelRequire("3nTcJ");

var $3KNsL = parcelRequire("3KNsL");

var $kUqFo = parcelRequire("kUqFo");
var $0648ed10cfbfeb8e$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        projectKey: (0, $3nTcJ.getProjectKey)(state),
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        projectName: (0, $3nTcJ.getProjectName)(state),
        baseUrl: (0, $3nTcJ.getBaseUrl)(state),
        category: (0, $3KNsL.getCategory)(state)
    }), {})((0, $kUqFo.default));

});
parcelRegister("kUqFo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4595a307e4969262$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2bMHt = parcelRequire("2bMHt");

var $foIkM = parcelRequire("foIkM");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4595a307e4969262$export$2e2bcd8739ae039 = ({ children: children, category: category, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foIkM.default), {
        ...rest,
        category: category,
        href: (0, $2bMHt.getQueueUrl)({
            projectKey: rest.projectKey,
            category: category,
            queueId: null
        })
    }, children);

});
parcelRegister("foIkM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a5999aa65e4e2b$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $2oqNI = parcelRequire("2oqNI");
var $c5a5999aa65e4e2b$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $2oqNI.default));

});
parcelRegister("2oqNI", function(module, exports) {

$parcel$export(module.exports, "default", () => $037e3fc76d984285$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7ehAr = parcelRequire("7ehAr");

var $aTgXo = parcelRequire("aTgXo");

var $dpXKE = parcelRequire("dpXKE");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1L8BM = parcelRequire("1L8BM");

var $f1lMr = parcelRequire("f1lMr");

var $edAb7 = parcelRequire("edAb7");

var $bDVHP = parcelRequire("bDVHP");
const $037e3fc76d984285$var$getBreadcrumbText = (category)=>{
    if (!category) return (0, $bDVHP.default).queues;
    switch(category){
        case 0, $f1lMr.INCIDENTS:
            return (0, $edAb7.default).incidents;
        case 0, $f1lMr.CHANGES:
            return (0, $edAb7.default).changes;
        case 0, $f1lMr.SERVICE_REQUEST:
            return (0, $edAb7.default).serviceRequests;
        case 0, $f1lMr.PROBLEMS:
            return (0, $edAb7.default).problems;
        case 0, $f1lMr.POST_INCIDENT_REVIEWS:
            return (0, $edAb7.default).postIncidentReviews;
        default:
            return (0, $edAb7.default).queues;
    }
};
const $037e3fc76d984285$var$QueuesBreadcrumbManager = ({ children: children, projectKey: projectKey, projectName: projectName, baseUrl: baseUrl, href: href, text: text, type: type, category: category })=>{
    const [practiceList] = (0, $1L8BM.usePracticeList)();
    const hasPractices = Boolean(practiceList && practiceList.length > 1);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ehAr.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            href: href,
            text: text || formatMessage($037e3fc76d984285$var$getBreadcrumbText(hasPractices ? category : undefined)),
            type: type
        }
    }, children)));
};
$037e3fc76d984285$var$QueuesBreadcrumbManager.defaultProps = {
    type: 'queues',
    text: '',
    category: undefined
};
var $037e3fc76d984285$export$2e2bcd8739ae039 = $037e3fc76d984285$var$QueuesBreadcrumbManager;

});
parcelRegister("bDVHP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ff92c4862c12e1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b6ff92c4862c12e1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    queues: {
        "id": "servicedesk-queues-breadcrumb.queues-breadcrumb-manager.queues",
        "defaultMessage": "Queues"
    }
});

});





parcelRegister("qJUKW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8502b2f60602815b$export$2e2bcd8739ae039);

var $c8Guq = parcelRequire("c8Guq");

var $5iWql = parcelRequire("5iWql");

var $hFmdR = parcelRequire("hFmdR");

var $8un0w = parcelRequire("8un0w");

var $1ybV0 = parcelRequire("1ybV0");

var $ldoUY = parcelRequire("ldoUY");

var $fBSce = parcelRequire("fBSce");


var $lNNXV = parcelRequire("lNNXV");

var $c9rDh = parcelRequire("c9rDh");

var $3nTcJ = parcelRequire("3nTcJ");

var $3ztB9 = parcelRequire("3ztB9");

var $9mlBv = parcelRequire("9mlBv");

var $bfxje = parcelRequire("bfxje");

var $kBhD3 = parcelRequire("kBhD3");

var $8vuXb = parcelRequire("8vuXb");

var $5Aqh1 = parcelRequire("5Aqh1");

var $8UPn4 = parcelRequire("8UPn4");

var $8GAE5 = parcelRequire("8GAE5");

var $iW0TR = parcelRequire("iW0TR");

var $3KNsL = parcelRequire("3KNsL");

var $6ycyf = parcelRequire("6ycyf");

var $ihzrq = parcelRequire("ihzrq");

var $1RqtY = parcelRequire("1RqtY");

var $lsHr9 = parcelRequire("lsHr9");

var $1sob9 = parcelRequire("1sob9");

var $2RpFV = parcelRequire("2RpFV");

var $kNLgh = parcelRequire("kNLgh");

var $7TXwS = parcelRequire("7TXwS");
const $8502b2f60602815b$var$onActiveItemChanged = (payload)=>payload && (0, $bfxje.activeItemChangedAction)(payload.rowId, payload.columnId) || (0, $bfxje.activeItemRemovedAction)();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8502b2f60602815b$var$mapStateToProps = (state, ownProps)=>{
    const isLoading = (0, $1RqtY.isLoadingIssues)(state);
    return {
        appProps: (0, $ihzrq.getIssueTableAppProps)(state),
        queueId: (0, $3KNsL.getQueueId)(state),
        queueCategory: (0, $3KNsL.getCategory)(state),
        columns: (0, $3KNsL.getColumnsInOrder)(state),
        DemoDripFeed: $lsHr9.default,
        FieldDataSelector: $1sob9.default,
        issueKeys: (0, $iW0TR.getIssueKeysForPage)(state),
        IssueTable: $ldoUY.default,
        KeyboardShortcutListener: $2RpFV.default,
        AsyncBulkActionToolbar: $c9rDh.AsyncBulkActionToolbar,
        SelectedIssuesSubscriber: $fBSce.SelectedIssuesSubscriber,
        currentPage: (0, $iW0TR.getCurrentPage)(state),
        totalPages: (0, $iW0TR.getTotalPages)(state),
        sortedBy: (0, $6ycyf.getSortedByColumn)(state),
        sortOrder: (0, $6ycyf.getSortOrder)(state),
        isQueueVisible: (0, $1RqtY.isQueueVisible)(state),
        isQueueTransient: (0, $3KNsL.isQueueTransient)(state),
        projectKey: (0, $3nTcJ.getProjectKey)(state),
        isLoading: isLoading,
        isContentStale: isLoading && (0, $8GAE5.getCollection)(state).length > 0,
        metricKey: (0, $3KNsL.getMetricKey)(state),
        hasLoadedIssueDataFromCache: (0, $5Aqh1.getHasLoadedIssueDataFromCache)(state),
        canFocusTable: !(0, $8UPn4.getIsFilterFocused)(state),
        useJSMQueueDurationEvent: ownProps.useJSMQueueDurationEvent,
        renderSidebarIcon: ownProps.renderSidebarIcon,
        shouldRerenderRowOnHover: ownProps.shouldRerenderRowOnHover,
        width: ownProps.width,
        tableWidth: ownProps.tableWidth
    };
};
// We want to avoid creating a new anonymous function every time the state has changed, so that later in `issue-table`
// we can compare the prop to decide whether we should update the component.
const $8502b2f60602815b$var$onSortOrderChangedGenerator = (0, $5iWql.default)((dispatch)=>(sortedBy, sortOrder)=>dispatch((0, $bfxje.sortOrderChangedAction)(sortedBy, sortOrder)));
const $8502b2f60602815b$var$mapDispatchToProps = (dispatch)=>({
        // @ts-expect-error - TS7006 - Parameter 'payload' implicitly has an 'any' type.
        onActiveItemChanged: (payload)=>dispatch($8502b2f60602815b$var$onActiveItemChanged(payload)),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onPageChange: (event, newPage)=>{
            dispatch((0, $bfxje.pageChangedAction)(newPage));
            dispatch((0, $3ztB9.loadIssuesActionForPage)(newPage));
        },
        onSortOrderChanged: $8502b2f60602815b$var$onSortOrderChangedGenerator(dispatch),
        onIssueDataRequested: (startIndex)=>dispatch((0, $bfxje.fetchIssueDataOnScrollAction)(startIndex)),
        onVerticalScrollChanged: (verticalPosition)=>dispatch((0, $bfxje.toggleQueueHeaderAction)(verticalPosition.direction)),
        onTableChange: (analyticsEvent)=>dispatch((0, $bfxje.tableChangedAction)(analyticsEvent)),
        onSetSelectedIssueKeys: (selectedIssueKeys)=>(0, $1ybV0.ff)('jsm-queue-sidebar-bulk-edit-bug-fix_jx9ff', false) ? dispatch((0, $kBhD3.setSelectedIssueKeys)(selectedIssueKeys)) : // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{},
        onRefreshSidebar: ({ issueKey: issueKey } = {})=>{
            dispatch((0, $kBhD3.refreshSidebarIssueView)({
                issueKey: issueKey
            }));
        },
        onSetIssueKey: (key)=>{
            dispatch((0, $kBhD3.setSidebarIssueKey)(key));
        },
        onNonPremiumSLAColumnError: ()=>dispatch((0, $9mlBv.displayQueuesErrorHeaderAction)()),
        controlPolling: {
            restartPolling: ()=>{
                if ((0, $1ybV0.ff)('jsm-queue-sidebar-bulk-edit-bug-fix_jx9ff', false)) dispatch((0, $kBhD3.refreshSidebarIssueView)());
                dispatch((0, $8vuXb.restartPollAction)());
            },
            stopPolling: ()=>dispatch((0, $8vuXb.stopPollAction)())
        }
    });
const $8502b2f60602815b$var$getColumnsForIssueTableFactory = (0, $5iWql.default)((columns, onSortOrderChanged)=>(0, $kNLgh.getColumnsForIssueTable)(columns, onSortOrderChanged));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8502b2f60602815b$var$mergeProps = (stateProps, dispatchProps)=>({
        ...stateProps,
        ...dispatchProps,
        columns: $8502b2f60602815b$var$getColumnsForIssueTableFactory(stateProps.columns, dispatchProps.onSortOrderChanged)
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8502b2f60602815b$var$connectedTable = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $8un0w.default)({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onPageChange: (event, newPage)=>({
            name: 'queue',
            pageNumber: newPage,
            startIndex: (0, $6e1a998ae5fb6552$export$f88f58d1a4b2078b) * (newPage - 1) + 1
        })
}), (0, $lNNXV.connect)($8502b2f60602815b$var$mapStateToProps, $8502b2f60602815b$var$mapDispatchToProps, $8502b2f60602815b$var$mergeProps), (0, $hFmdR.AnalyticsSubject)('queue'))((0, $7TXwS.default));
var $8502b2f60602815b$export$2e2bcd8739ae039 = $8502b2f60602815b$var$connectedTable;

});
parcelRegister("ldoUY", function(module, exports) {

$parcel$export(module.exports, "default", () => $74a85d8f5c7953c9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $1ybV0 = parcelRequire("1ybV0");

var $6Sjez = parcelRequire("6Sjez");

var $fBSce = parcelRequire("fBSce");

var $bLec0 = parcelRequire("bLec0");

var $7juUU = parcelRequire("7juUU");

var $8QWSq = parcelRequire("8QWSq");

var $88MUq = parcelRequire("88MUq");

var $9aFsj = parcelRequire("9aFsj");

var $8MLGs = parcelRequire("8MLGs");

var $2SRkQ = parcelRequire("2SRkQ");

var $b5o6E = parcelRequire("b5o6E");

var $iIfHk = parcelRequire("iIfHk");

var $47a3k = parcelRequire("47a3k");

var $h0Rgs = parcelRequire("h0Rgs");

var $7f2nY = parcelRequire("7f2nY");

var $1Rt1q = parcelRequire("1Rt1q");

var $fECcE = parcelRequire("fECcE");





// @ts-expect-error - TS7031 - Binding element 'store' implicitly has an 'any' type. | TS7031 - Binding element 'tableProps' implicitly has an 'any' type.
const $74a85d8f5c7953c9$var$BulkSelectionAwareTableStateUpdater = ({ store: store, tableProps: tableProps })=>{
    const { dispatch: dispatch } = store;
    const state = store.getState();
    const { columns: columns, issueKeys: issueKeys, currentPage: currentPage, isDisabled: isDisabled, contentKey: contentKey, onIssueViewTransition: onIssueViewTransition, useJSMQueueDurationEvent: useJSMQueueDurationEvent, renderSidebarIcon: renderSidebarIcon, refreshSidebar: refreshSidebar } = tableProps;
    const [{ issueKeys: selectedIssueKeys }, actions] = (0, $fBSce.useSelectedIssues)();
    const hasBulkSelection = selectedIssueKeys.length > 0;
    (0, $eUqFw.useEffect)(()=>{
        actions.refreshSelection([]);
    }, [
        actions,
        contentKey
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2322 - Type 'BoundActions<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/issue-table-selection/src/services/actions/index")>' is not assignable to type 'typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/issue-table-selection/src/services/actions/index")'.
        dispatch((0, $8QWSq.setSelectionServiceActionsAction)({
            actions: actions
        }));
        dispatch((0, $8QWSq.setHasSelectionAction)({
            hasSelection: hasBulkSelection
        }));
        if (hasBulkSelection) {
            dispatch(// @ts-expect-error - TS7006 - Parameter 'c' implicitly has an 'any' type.
            (0, $88MUq.updateColumnsAction)(columns.map((c)=>({
                    ...c,
                    isDisabled: hasBulkSelection
                }))));
            dispatch((0, $b5o6E.setIsTableDisabled)(hasBulkSelection));
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(columns, (0, $47a3k.getColumns)(state)) && !hasBulkSelection) {
            dispatch((0, $88MUq.updateColumnsAction)(columns));
            dispatch((0, $9aFsj.unlockAllFieldsAction)());
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(issueKeys, (0, $h0Rgs.getProvidedIssueKeys)(state))) dispatch((0, $8MLGs.updateProvidedIssueKeysAction)(issueKeys));
        if (currentPage !== (0, $7f2nY.getCurrentPage)(state)) {
            dispatch((0, $9aFsj.unlockAllFieldsAction)());
            dispatch((0, $b5o6E.setCurrentPageAction)(currentPage));
        }
        if (isDisabled !== (0, $7f2nY.isTableDisabled)(state) && !hasBulkSelection) dispatch((0, $b5o6E.setIsTableDisabled)(isDisabled || false));
    }, [
        actions,
        columns,
        currentPage,
        dispatch,
        hasBulkSelection,
        isDisabled,
        issueKeys,
        state
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (onIssueViewTransition && onIssueViewTransition !== (0, $7f2nY.getOnIssueViewTransition)(state)) dispatch((0, $b5o6E.setOnIssueViewTransition)(onIssueViewTransition));
    }, [
        dispatch,
        onIssueViewTransition,
        state,
        tableProps
    ]);
    (0, $eUqFw.useEffect)(()=>{
        useJSMQueueDurationEvent && dispatch((0, $b5o6E.setJSMQueueDurationEvent)(useJSMQueueDurationEvent));
    }, [
        dispatch,
        useJSMQueueDurationEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        renderSidebarIcon && dispatch((0, $b5o6E.setRenderSidebarIcon)(renderSidebarIcon));
    }, [
        dispatch,
        renderSidebarIcon
    ]);
    if ((0, $1ybV0.ff)('jsm-queue-sidebar-bulk-edit-bug-fix_jx9ff', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eUqFw.useEffect)(()=>{
        refreshSidebar && dispatch((0, $b5o6E.setRefreshSidebar)(refreshSidebar));
    }, [
        dispatch,
        refreshSidebar
    ]);
    return null;
};
class $74a85d8f5c7953c9$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    focusContent() {
        this.tableFocusFunction && this.tableFocusFunction();
    }
    scrollToTop() {
        this.tableRef && this.tableRef.resetVerticalScrollOffset();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Rt1q.Provider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Sjez.AsyncFlagsDispatcher), {
            store: this.store,
            mapper: (0, $bLec0.default)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($74a85d8f5c7953c9$var$BulkSelectionAwareTableStateUpdater, {
            store: this.store,
            tableProps: this.props
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fECcE.default), {
            ...this.props,
            tableRef: this.onSetTableRef,
            onTableFocusFunctionChanged: this.onTableFocusFunctionChanged,
            onTableRefChanged: this.onTableRefChanged
        })));
    }
    constructor(...args){
        super(...args);
        this.onTableFocusFunctionChanged = (tableFocusFunction)=>{
            this.tableFocusFunction = tableFocusFunction;
        };
        this.onTableRefChanged = (ref)=>{
            this.store.dispatch((0, $2SRkQ.setRowListRefAction)(ref));
        };
        this.onSetTableRef = (ref)=>{
            this.tableRef = ref;
        };
        this.store = (0, $1Rt1q.createStore)((0, $7juUU.default), {
            initialAppProps: this.props.appProps,
            ui: {
                ...(0, $iIfHk.DEFAULT_STATE),
                onIssueViewTransition: this.props.onIssueViewTransition,
                useJSMQueueDurationEvent: this.props.useJSMQueueDurationEvent
            },
            persisted: {
                columns: false ? this.props.columns : [],
                providedIssueKeys: this.props.issueKeys,
                lockedIssues: {},
                offsets: {
                    verticalScrollOffset: 0,
                    horizontalScrollOffset: 0
                },
                rowListRef: undefined
            }
        });
    }
}

});
parcelRegister("6Sjez", function(module, exports) {

$parcel$export(module.exports, "AsyncFlagsDispatcher", () => $cb6d096ac74e57fc$export$7bcb9f5644d87fa4);

var $eUqFw = parcelRequire("eUqFw");

var $jqvCZ = parcelRequire("jqvCZ");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

var $gGtKh = parcelRequire("gGtKh");

var $eo17r = parcelRequire("eo17r");
const $cb6d096ac74e57fc$var$createFlagsDispatcherImpl = (mapperFactory, props, { FlagsDispatcher: FlagsDispatcher, toFlagId: toFlagId, dismissFlag: dismissFlag })=>{
    const mapper = mapperFactory({
        dismissFlag: dismissFlag,
        toFlagId: toFlagId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FlagsDispatcher, {
        ...props,
        mapper: mapper
    });
};
// We create flags mappers dynamically, in part, to allow a closure to be established.
// This is memoized to retain any state provided via a closure.
const $cb6d096ac74e57fc$var$createFlagsDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))($cb6d096ac74e57fc$var$createFlagsDispatcherImpl);
const $cb6d096ac74e57fc$var$getFlagsDispatcher = (module, props)=>{
    if ('mapperFactory' in props) {
        const { mapperFactory: mapperFactory, ...dispatcherProps } = props;
        const flagsDispatcher = $cb6d096ac74e57fc$var$createFlagsDispatcher(mapperFactory, dispatcherProps, module);
        return flagsDispatcher;
    }
    const { FlagsDispatcher: FlagsDispatcher } = module;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FlagsDispatcher, props);
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cb6d096ac74e57fc$var$LazyFlagsDispatcher = (0, $7rh0R.lazy)(()=>(parcelRequire("8ZKE5")).then((module)=>(props)=>$cb6d096ac74e57fc$var$getFlagsDispatcher(module, props)), {
    moduleId: "./src/packages/platform/ui/flags/src/index.tsx"
});
const $cb6d096ac74e57fc$export$7bcb9f5644d87fa4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-flags-dispatcher",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: "async-flags-dispatcher"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb6d096ac74e57fc$var$LazyFlagsDispatcher, props)));

});
parcelRegister("8ZKE5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("buY5f").then(()=>parcelRequire('g7mrB'));

});


parcelRegister("fBSce", function(module, exports) {

$parcel$export(module.exports, "SelectedIssuesContainer", () => $1c3108e4bef20040$export$738cdb08d2b14320);
$parcel$export(module.exports, "SelectedIssuesSubscriber", () => $1c3108e4bef20040$export$e95e49d0cb3be823);
$parcel$export(module.exports, "useSelectedIssues", () => $1c3108e4bef20040$export$a435421a00d3bee);

var $WBLbN = parcelRequire("WBLbN");

var $1ESei = parcelRequire("1ESei");

const $1c3108e4bef20040$export$d4c72bab9d6cc13a = {
    issueKeys: [],
    limit: (0, $aaf3e14612d6f36e$export$81a88ed305997a6d),
    isLocked: false
};
const $1c3108e4bef20040$var$Store = (0, $WBLbN.createStore)({
    name: 'issue-table-selection',
    initialState: $1c3108e4bef20040$export$d4c72bab9d6cc13a,
    actions: $1ESei
});
const $1c3108e4bef20040$export$738cdb08d2b14320 = (0, $WBLbN.createContainer)($1c3108e4bef20040$var$Store);
const $1c3108e4bef20040$export$e95e49d0cb3be823 = (0, $WBLbN.createSubscriber)($1c3108e4bef20040$var$Store, {
    displayName: 'SelectedIssuesSubscriber'
});
const $1c3108e4bef20040$export$ded196a925e981e1 = (0, $WBLbN.createSubscriber)($1c3108e4bef20040$var$Store, {
    displayName: 'SelectedIssuesActionsSubscriber',
    selector: null
});
const $1c3108e4bef20040$export$a435421a00d3bee = (0, $WBLbN.createHook)($1c3108e4bef20040$var$Store);
var $1c3108e4bef20040$export$2e2bcd8739ae039 = $1c3108e4bef20040$var$Store;

});
parcelRegister("1ESei", function(module, exports) {

$parcel$export(module.exports, "selectIssues", () => (parcelRequire("cS2al")).selectIssues);
$parcel$export(module.exports, "deselectIssues", () => (parcelRequire("fu1hv")).deselectIssues);
$parcel$export(module.exports, "deselectAllIssues", () => (parcelRequire("7UbwY")).deselectAllIssues);
$parcel$export(module.exports, "refreshSelection", () => (parcelRequire("9BMBh")).refreshSelection);
$parcel$export(module.exports, "getCurrentlySelectedIssues", () => (parcelRequire("fGXOO")).getCurrentlySelectedIssues);
$parcel$export(module.exports, "lockSelection", () => (parcelRequire("1TmIg")).lockSelection);
$parcel$export(module.exports, "unlockSelection", () => (parcelRequire("1Zu9L")).unlockSelection);
$parcel$export(module.exports, "refreshSelectionLimit", () => (parcelRequire("In7A6")).refreshSelectionLimit);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $cS2al = parcelRequire("cS2al");

var $fu1hv = parcelRequire("fu1hv");

var $7UbwY = parcelRequire("7UbwY");

var $9BMBh = parcelRequire("9BMBh");

var $fGXOO = parcelRequire("fGXOO");

var $1TmIg = parcelRequire("1TmIg");

var $1Zu9L = parcelRequire("1Zu9L");

var $In7A6 = parcelRequire("In7A6");

});
parcelRegister("cS2al", function(module, exports) {

$parcel$export(module.exports, "selectIssues", () => $59ff284e0df15282$export$1e9b66e71acaf40b);

var $iVIEg = parcelRequire("iVIEg");

var $8blac = parcelRequire("8blac");

var $6kliL = parcelRequire("6kliL");

var $jMP2a = parcelRequire("jMP2a");
const $59ff284e0df15282$export$1e9b66e71acaf40b = (selectedIssueKeys, analyticsEvent)=>({ getState: getState, setState: setState })=>{
        const { issueKeys: issueKeys, limit: limit } = getState();
        const newlySelectedIssueKeys = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(selectedIssueKeys, issueKeys);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(newlySelectedIssueKeys)) {
            const newIssueKeys = issueKeys.concat(...newlySelectedIssueKeys);
            setState({
                issueKeys: (0, (/*@__PURE__*/$parcel$interopDefault($6kliL)))(newIssueKeys, limit)
            });
            analyticsEvent && (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'bulkSelection added', {
                selectionTruncated: newIssueKeys.length > limit,
                desiredIssuesCount: newIssueKeys.length,
                selectedIssuesCount: Math.min(newIssueKeys.length, limit),
                previousSelectedIssuesCount: issueKeys.length
            });
        }
    };

});
parcelRegister("6kliL", function(module, exports) {

var $jADKY = parcelRequire("jADKY");

var $hNahz = parcelRequire("hNahz");
/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */ function $49b52260d8bf0b18$var$take(array, n, guard) {
    if (!(array && array.length)) return [];
    n = guard || n === undefined ? 1 : $hNahz(n);
    return $jADKY(array, 0, n < 0 ? 0 : n);
}
module.exports = $49b52260d8bf0b18$var$take;

});


parcelRegister("fu1hv", function(module, exports) {

$parcel$export(module.exports, "deselectIssues", () => $a091b1f8111a7325$export$2d010dfcbbe2bfe4);

var $kG4jb = parcelRequire("kG4jb");

var $8blac = parcelRequire("8blac");

var $7GXrf = parcelRequire("7GXrf");

var $jMP2a = parcelRequire("jMP2a");
const $a091b1f8111a7325$export$2d010dfcbbe2bfe4 = (deselectedIssueKeys, analyticsEvent)=>({ getState: getState, setState: setState })=>{
        const { issueKeys: issueKeys } = getState();
        const newlyDeselectedIssueKeys = (0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(deselectedIssueKeys, issueKeys);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(newlyDeselectedIssueKeys)) {
            const newIssueKeys = (0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))(issueKeys, ...newlyDeselectedIssueKeys);
            setState({
                issueKeys: newIssueKeys
            });
            analyticsEvent && (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'bulkSelection reduced', {
                selectedIssuesCount: newIssueKeys.length,
                previousSelectedIssuesCount: issueKeys.length
            });
        }
    };

});
parcelRegister("kG4jb", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $kIBQX = parcelRequire("kIBQX");

var $9eFtX = parcelRequire("9eFtX");

var $arA63 = parcelRequire("arA63");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $f0db1270e02fec98$var$intersection = $9eFtX(function(arrays) {
    var mapped = $kJvGp(arrays, $arA63);
    return mapped.length && mapped[0] === arrays[0] ? $kIBQX(mapped) : [];
});
module.exports = $f0db1270e02fec98$var$intersection;

});
parcelRegister("kIBQX", function(module, exports) {

var $lYFvJ = parcelRequire("lYFvJ");

var $lqZWH = parcelRequire("lqZWH");

var $6v6uu = parcelRequire("6v6uu");

var $kJvGp = parcelRequire("kJvGp");

var $74vSq = parcelRequire("74vSq");

var $8AO5Q = parcelRequire("8AO5Q");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f155478e4676feef$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $f155478e4676feef$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $6v6uu : $lqZWH, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $kJvGp(array, $74vSq(iteratee));
        maxLength = $f155478e4676feef$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $lYFvJ(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $8AO5Q(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $8AO5Q(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $f155478e4676feef$var$baseIntersection;

});

parcelRegister("arA63", function(module, exports) {

var $cRpul = parcelRequire("cRpul");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $79a86d09190de0cd$var$castArrayLikeObject(value) {
    return $cRpul(value) ? value : [];
}
module.exports = $79a86d09190de0cd$var$castArrayLikeObject;

});



parcelRegister("7UbwY", function(module, exports) {

$parcel$export(module.exports, "deselectAllIssues", () => $aefc73cb2f7983d1$export$dd4a406c0382217f);

var $8blac = parcelRequire("8blac");

var $jMP2a = parcelRequire("jMP2a");
const $aefc73cb2f7983d1$export$dd4a406c0382217f = (analyticsEvent)=>({ getState: getState, setState: setState })=>{
        const { issueKeys: issueKeys } = getState();
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(issueKeys)) {
            setState({
                issueKeys: []
            });
            analyticsEvent && (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'bulkSelection reduced', {
                selectedIssuesCount: 0,
                previousSelectedIssuesCount: issueKeys.length
            });
        }
    };

});

parcelRegister("9BMBh", function(module, exports) {

$parcel$export(module.exports, "refreshSelection", () => $b23f65d1b916c5df$export$86ff8cf593d1a265);

var $iVIEg = parcelRequire("iVIEg");

var $8blac = parcelRequire("8blac");

var $6kliL = parcelRequire("6kliL");

var $7GXrf = parcelRequire("7GXrf");

const $b23f65d1b916c5df$export$86ff8cf593d1a265 = (existingIssueKeys)=>({ getState: getState, setState: setState })=>{
        const { issueKeys: issueKeys } = getState();
        const deselectIssueKeys = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(issueKeys, existingIssueKeys);
        !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(deselectIssueKeys) && setState({
            issueKeys: (0, (/*@__PURE__*/$parcel$interopDefault($6kliL)))((0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))(issueKeys, ...deselectIssueKeys), (0, $aaf3e14612d6f36e$export$81a88ed305997a6d))
        });
    };

});
const $aaf3e14612d6f36e$export$81a88ed305997a6d = 150;


parcelRegister("fGXOO", function(module, exports) {

$parcel$export(module.exports, "getCurrentlySelectedIssues", () => $2521ca61b6c88e87$export$d6e9b99bcd1d7d6c);
const $2521ca61b6c88e87$export$d6e9b99bcd1d7d6c = ()=>({ getState: getState })=>{
        const { issueKeys: issueKeys } = getState();
        return issueKeys;
    };

});

parcelRegister("1TmIg", function(module, exports) {

$parcel$export(module.exports, "lockSelection", () => $fa7d6863ada4e348$export$790a7f6053d9b4a1);
const $fa7d6863ada4e348$export$790a7f6053d9b4a1 = ()=>({ setState: setState })=>setState({
            isLocked: true
        });

});

parcelRegister("1Zu9L", function(module, exports) {

$parcel$export(module.exports, "unlockSelection", () => $4f17475df8b53406$export$a90d629fd06371e4);
const $4f17475df8b53406$export$a90d629fd06371e4 = ()=>({ setState: setState })=>setState({
            isLocked: false
        });

});

parcelRegister("In7A6", function(module, exports) {

$parcel$export(module.exports, "refreshSelectionLimit", () => $958d4e64fe5342bb$export$53f550a8d1ce7a3c);

const $958d4e64fe5342bb$export$53f550a8d1ce7a3c = (numSelected)=>({ setState: setState })=>{
        if (numSelected > 0) setState({
            limit: Math.max((0, $aaf3e14612d6f36e$export$81a88ed305997a6d) - numSelected, 0)
        });
    };

});



parcelRegister("bLec0", function(module, exports) {

$parcel$export(module.exports, "default", () => $274d2340252d7eb8$export$2e2bcd8739ae039);

var $gjOW8 = parcelRequire("gjOW8");

var $b5o6E = parcelRequire("b5o6E");

var $8t8mi = parcelRequire("8t8mi");

var $gcDtA = parcelRequire("gcDtA");
const $274d2340252d7eb8$var$decodeFailure = (stringThatMayBeJson)=>{
    try {
        const obj = JSON.parse(stringThatMayBeJson);
        if (obj.errorMessages && obj.errorMessages[0]) return obj.errorMessages[0];
        if (obj.errors) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return Object.values(obj.errors)[0];
        return undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return stringThatMayBeJson;
    }
};
// @ts-expect-error - TS7006 - Parameter 'failureReason' implicitly has an 'any' type.
const $274d2340252d7eb8$var$isPresentableFailureReason = (failureReason)=>failureReason.statusCode && failureReason.message && failureReason.message.indexOf(`: ${failureReason.statusCode}`) === -1;
const $274d2340252d7eb8$var$flagsMapper = (action)=>{
    switch(action.type){
        case 0, $gjOW8.FIELD_UPDATE_FAILURE:
            {
                const { fieldName: fieldName, issueKey: issueKey, failureReason: failureReason } = action.payload;
                return (0, $gcDtA.default)({
                    fieldName: fieldName,
                    issueKey: issueKey,
                    reasonMessage: failureReason.message && $274d2340252d7eb8$var$isPresentableFailureReason(failureReason) ? $274d2340252d7eb8$var$decodeFailure(failureReason.message) : undefined
                });
            }
        case 0, $b5o6E.DISABLE_USER_PICKER:
            return (0, $8t8mi.default)();
        default:
            {
                const _exhaustiveCheck = action;
                return undefined;
            }
    }
};
var $274d2340252d7eb8$export$2e2bcd8739ae039 = $274d2340252d7eb8$var$flagsMapper;

});
parcelRegister("gjOW8", function(module, exports) {

$parcel$export(module.exports, "FIELD_UPDATE_SUBMIT", () => $679605fe5814d7fd$export$d8a6a3dbb4cd0e2b);
$parcel$export(module.exports, "submitFieldUpdateAction", () => $679605fe5814d7fd$export$94f231b4f54796b);
$parcel$export(module.exports, "updateFieldSuccessAction", () => $679605fe5814d7fd$export$cf3e633d76bec1c0);
$parcel$export(module.exports, "ERROR_RESPONSE", () => $679605fe5814d7fd$export$e7c20800d1dc6c31);
$parcel$export(module.exports, "FIELD_UPDATE_FAILURE", () => $679605fe5814d7fd$export$f6339a854154c99e);
$parcel$export(module.exports, "updateFieldFailureErrorResponseAction", () => $679605fe5814d7fd$export$80effa926bcee3a6);
// LOCK_FIELD
const $679605fe5814d7fd$export$d8a6a3dbb4cd0e2b = 'state.actions.field.update.FIELD_UPDATE_SUBMIT';
const $679605fe5814d7fd$export$94f231b4f54796b = (issueKey, fieldId, fieldValue, onSuccess, onFailure)=>({
        type: $679605fe5814d7fd$export$d8a6a3dbb4cd0e2b,
        payload: {
            issueKey: issueKey,
            fieldId: fieldId,
            fieldValue: fieldValue,
            onSuccess: onSuccess,
            onFailure: onFailure
        }
    });
const $679605fe5814d7fd$export$4374b1b680dead41 = 'state.actions.field.update.FIELD_UPDATE_SUCCESS';
const $679605fe5814d7fd$export$cf3e633d76bec1c0 = (issueKey, fieldId)=>({
        type: $679605fe5814d7fd$export$4374b1b680dead41,
        payload: {
            issueKey: issueKey,
            fieldId: fieldId
        }
    });
const $679605fe5814d7fd$export$e7c20800d1dc6c31 = 'ERROR_RESPONSE';
const $679605fe5814d7fd$export$f6339a854154c99e = 'state.actions.field.update.FIELD_UPDATE_FAILURE';
const $679605fe5814d7fd$export$80effa926bcee3a6 = (issueKey, fieldId, fieldType, fieldName, error)=>({
        type: $679605fe5814d7fd$export$f6339a854154c99e,
        payload: {
            issueKey: issueKey,
            fieldId: fieldId,
            fieldType: fieldType,
            fieldName: fieldName,
            failureReason: {
                type: $679605fe5814d7fd$export$e7c20800d1dc6c31,
                statusCode: error.statusCode,
                message: error.message
            }
        }
    });

});

parcelRegister("b5o6E", function(module, exports) {

$parcel$export(module.exports, "SHOW_PAGINATION", () => $16ba6de3c867424d$export$5d9390342a7644ac);
$parcel$export(module.exports, "setPaginationVisibility", () => $16ba6de3c867424d$export$c1bc18f3f5aacbab);
$parcel$export(module.exports, "SET_EDITING_FIELD_POSITION", () => $16ba6de3c867424d$export$c89eb1efa157bec9);
$parcel$export(module.exports, "setEditingFieldPositionAction", () => $16ba6de3c867424d$export$300d660c6d75f0cc);
$parcel$export(module.exports, "SET_CURRENT_PAGE", () => $16ba6de3c867424d$export$483508f263cba397);
$parcel$export(module.exports, "setCurrentPageAction", () => $16ba6de3c867424d$export$6f9713cf11255bd4);
$parcel$export(module.exports, "SET_IS_TABLE_DISABLED", () => $16ba6de3c867424d$export$a871a4533fe0415c);
$parcel$export(module.exports, "setIsTableDisabled", () => $16ba6de3c867424d$export$adbd404608132b43);
$parcel$export(module.exports, "DISABLE_USER_PICKER", () => $16ba6de3c867424d$export$a3bc24c2e3b7c2a2);
$parcel$export(module.exports, "disableUserPickerAction", () => $16ba6de3c867424d$export$da8d58cd19fa9174);
$parcel$export(module.exports, "SET_ON_ISSUE_VIEW_TRANSITION", () => $16ba6de3c867424d$export$91f1228c532af4);
$parcel$export(module.exports, "setOnIssueViewTransition", () => $16ba6de3c867424d$export$fa4a37077fc8610b);
$parcel$export(module.exports, "SET_JSM_QUEUE_DURATION_EVENT", () => $16ba6de3c867424d$export$c00a50fc22eee33c);
$parcel$export(module.exports, "setJSMQueueDurationEvent", () => $16ba6de3c867424d$export$834790f742597c01);
$parcel$export(module.exports, "SET_RENDER_SIDE_BAR_ICON", () => $16ba6de3c867424d$export$9699e624bf23e2bb);
$parcel$export(module.exports, "setRenderSidebarIcon", () => $16ba6de3c867424d$export$28433d58f8f5bf2);
$parcel$export(module.exports, "SET_REFRESH_SIDE_BAR", () => $16ba6de3c867424d$export$dd236613845bdbce);
$parcel$export(module.exports, "setRefreshSidebar", () => $16ba6de3c867424d$export$a6ee15011295b023);
const $16ba6de3c867424d$export$5d9390342a7644ac = 'state.actions.ui.SHOW_PAGINATION';
const $16ba6de3c867424d$export$c1bc18f3f5aacbab = (payload)=>({
        type: $16ba6de3c867424d$export$5d9390342a7644ac,
        payload: payload
    });
const $16ba6de3c867424d$export$c89eb1efa157bec9 = 'state.actions.ui.SET_EDITING_FIELD_POSITION';
const $16ba6de3c867424d$export$300d660c6d75f0cc = (horizontalOffset, verticalOffset, fieldWidth, tableWidth, tableHeight)=>({
        type: $16ba6de3c867424d$export$c89eb1efa157bec9,
        payload: {
            horizontalOffset: horizontalOffset,
            verticalOffset: verticalOffset,
            fieldWidth: fieldWidth,
            tableWidth: tableWidth,
            tableHeight: tableHeight
        }
    });
const $16ba6de3c867424d$export$483508f263cba397 = 'state.actions.ui.SET_CURRENT_PAGE';
const $16ba6de3c867424d$export$6f9713cf11255bd4 = (payload)=>({
        type: $16ba6de3c867424d$export$483508f263cba397,
        payload: payload
    });
const $16ba6de3c867424d$export$a871a4533fe0415c = 'state.actions.ui.SET_IS_TABLE_DISABLED';
const $16ba6de3c867424d$export$adbd404608132b43 = (isDisabled)=>({
        type: $16ba6de3c867424d$export$a871a4533fe0415c,
        payload: isDisabled
    });
const $16ba6de3c867424d$export$a3bc24c2e3b7c2a2 = 'state.actions.ui.DISABLE_USER_PICKER';
const $16ba6de3c867424d$export$da8d58cd19fa9174 = ()=>({
        type: $16ba6de3c867424d$export$a3bc24c2e3b7c2a2
    });
const $16ba6de3c867424d$export$91f1228c532af4 = 'state.actions.ui.SET_ON_ISSUE_VIEW_TRANSITION';
const $16ba6de3c867424d$export$fa4a37077fc8610b = (onIssueViewTransition)=>({
        type: $16ba6de3c867424d$export$91f1228c532af4,
        payload: onIssueViewTransition
    });
const $16ba6de3c867424d$export$c00a50fc22eee33c = 'state.actions.ui.SET_JSM_QUEUE_DURATION_EVENT';
const $16ba6de3c867424d$export$834790f742597c01 = (useJSMQueueDurationEvent)=>({
        type: $16ba6de3c867424d$export$c00a50fc22eee33c,
        payload: useJSMQueueDurationEvent
    });
const $16ba6de3c867424d$export$9699e624bf23e2bb = 'state.actions.ui.SET_RENDER_SIDE_BAR_ICON';
const $16ba6de3c867424d$export$28433d58f8f5bf2 = (renderSidebarIcon)=>({
        type: $16ba6de3c867424d$export$9699e624bf23e2bb,
        payload: renderSidebarIcon
    });
const $16ba6de3c867424d$export$dd236613845bdbce = 'state.actions.ui.SET_REFRESH_SIDE_BAR';
const $16ba6de3c867424d$export$a6ee15011295b023 = (refreshSidebar)=>({
        type: $16ba6de3c867424d$export$dd236613845bdbce,
        payload: refreshSidebar
    });

});

parcelRegister("8t8mi", function(module, exports) {

$parcel$export(module.exports, "default", () => $de3d5e88822a9c46$export$2e2bcd8739ae039);

var $49HdW = parcelRequire("49HdW");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$de3d5e88822a9c46$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: (0, $49HdW.default).title,
        description: (0, $49HdW.default).description,
        actions: [
            {
                content: (0, $49HdW.default).refresh,
                onClick: ()=>window.location.reload()
            }
        ]
    });

});
parcelRegister("49HdW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea8d8296100c1696$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ea8d8296100c1696$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue-table.flags.field.assignee.error.title",
        "defaultMessage": "Looks like there was a problem"
    },
    description: {
        "id": "issue-table.flags.field.assignee.error.description",
        "defaultMessage": "The assignee field cannot be edited. Try refreshing the page."
    },
    refresh: {
        "id": "issue-table.flags.field.assignee.error.refresh",
        "defaultMessage": "Refresh"
    }
});

});


parcelRegister("gcDtA", function(module, exports) {

$parcel$export(module.exports, "default", () => $68f2d495efe291c7$export$2e2bcd8739ae039);

var $lBDe7 = parcelRequire("lBDe7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$68f2d495efe291c7$export$2e2bcd8739ae039 = ({ issueKey: issueKey, fieldName: fieldName, reasonMessage: reasonMessage })=>{
    if (reasonMessage) return {
        type: 'error',
        title: (0, $lBDe7.default).title,
        description: [
            (0, $lBDe7.default).description,
            {
                issueKey: issueKey,
                fieldName: fieldName.toLowerCase(),
                reasonMessage: reasonMessage
            }
        ]
    };
    return {
        type: 'error',
        title: (0, $lBDe7.default).title,
        description: [
            (0, $lBDe7.default).simpleDescription,
            {
                issueKey: issueKey,
                fieldName: fieldName.toLowerCase()
            }
        ]
    };
};

});
parcelRegister("lBDe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3efec64d7e23e7a6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3efec64d7e23e7a6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue-table.flags.field.update.error.title",
        "defaultMessage": "Issue could not be updated"
    },
    description: {
        "id": "issue-table.flags.field.update.error.description",
        "defaultMessage": "The ''{fieldName}'' field of {issueKey} could not be updated. {reasonMessage}"
    },
    simpleDescription: {
        "id": "issue-table.flags.field.update.error.simple-description",
        "defaultMessage": "The ''{fieldName}'' field of {issueKey} could not be updated. Please try again later."
    }
});

});



parcelRegister("7juUU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c9b99df481ac41f$export$2e2bcd8739ae039);
parcelRequire("1Lcr1");

var $bd1K7 = parcelRequire("bd1K7");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $87B3o = parcelRequire("87B3o");

var $50JL0 = parcelRequire("50JL0");

var $ckmCH = parcelRequire("ckmCH");

var $iTXqj = parcelRequire("iTXqj");

var $e9G4b = parcelRequire("e9G4b");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$0c9b99df481ac41f$export$2e2bcd8739ae039 = (action$, store)=>(0, $bd1K7.combineEpics)(...[
        (0, $ckmCH.default),
        (0, $50JL0.default),
        (0, $e9G4b.default),
        (0, $iTXqj.default),
        (0, $87B3o.default)
    ])(action$, store).catch((error, stream)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-table.ops', 'Unhandled error');
        (0, $guiFP.default)({
            meta: {
                id: 'opsUnhandledError',
                packageName: 'jiraIssueTable',
                teamName: 'jsd-shield'
            },
            error: new Error(error)
        });
        return stream;
    });

});
parcelRegister("87B3o", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5a31a6e6aaa1bbe$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $bCsJb = parcelRequire("bCsJb");

var $dwqCC = parcelRequire("dwqCC");
var // @ts-expect-error - No overload matches this call
$a5a31a6e6aaa1bbe$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $dwqCC.default), (0, $bCsJb.default));

});
parcelRegister("bCsJb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd6152bb19cab49b$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $6vrw7 = parcelRequire("6vrw7");

var $8QWSq = parcelRequire("8QWSq");

var $9aFsj = parcelRequire("9aFsj");

var $8MLGs = parcelRequire("8MLGs");

var $lP7g0 = parcelRequire("lP7g0");

var $h0Rgs = parcelRequire("h0Rgs");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$cd6152bb19cab49b$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $9aFsj.UNLOCK_FIELD), (0, $9aFsj.LOCK_FIELD), (0, $9aFsj.UNLOCK_ALL_FIELDS), (0, $8MLGs.UPDATE_PROVIDED_ISSUE_KEYS)).switchMap(()=>{
        const state = store.getState();
        const selectionServiceActions = (0, $lP7g0.getSelectionServiceActions)(state);
        if (!selectionServiceActions) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-table.ops.bulk-select.refresh-selection', 'selectionServiceActions is not set.');
            (0, $guiFP.default)({
                meta: {
                    id: 'opsRefreshSelection',
                    packageName: 'jiraIssueTable',
                    teamName: 'jsd-shield'
                }
            });
            return (0, $3JafE.Observable).empty();
        }
        const { refreshSelection: refreshSelection } = selectionServiceActions;
        const issues = (0, $h0Rgs.mergeIssueKeysWithLockedIssues)(state);
        refreshSelection(issues.map((0, $6vrw7.toIssueKey)));
        return (0, $3JafE.Observable).of((0, $8QWSq.setHasSelectionAction)({
            hasSelection: issues.length > 0
        }));
    });

});
parcelRegister("8QWSq", function(module, exports) {

$parcel$export(module.exports, "SELECT_ROW", () => $0928da39c2b421f4$export$23dac9ed99690a9c);
$parcel$export(module.exports, "selectRowAction", () => $0928da39c2b421f4$export$dd5cc62656892181);
$parcel$export(module.exports, "SET_LAST_CLICKED_ROW", () => $0928da39c2b421f4$export$30e11d52d9d0165c);
$parcel$export(module.exports, "setLastClickedRowAction", () => $0928da39c2b421f4$export$18aafbbe21119db1);
$parcel$export(module.exports, "SET_SELECTION_SERVICE_ACTIONS", () => $0928da39c2b421f4$export$b0dea82abc030a23);
$parcel$export(module.exports, "setSelectionServiceActionsAction", () => $0928da39c2b421f4$export$b43829a128a6202f);
$parcel$export(module.exports, "SET_HAS_SELECTION", () => $0928da39c2b421f4$export$7e3b4dceab941566);
$parcel$export(module.exports, "setHasSelectionAction", () => $0928da39c2b421f4$export$6647d68ebe704b97);
const $0928da39c2b421f4$export$23dac9ed99690a9c = 'state.actions.bulk-selection.SELECT_ROW';
const $0928da39c2b421f4$export$dd5cc62656892181 = (data, analyticsEvent)=>({
        type: $0928da39c2b421f4$export$23dac9ed99690a9c,
        payload: data,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $0928da39c2b421f4$export$30e11d52d9d0165c = 'state.actions.bulk-selection.SET_LAST_CLICKED_ROW';
const $0928da39c2b421f4$export$18aafbbe21119db1 = (data)=>({
        type: $0928da39c2b421f4$export$30e11d52d9d0165c,
        payload: data
    });
const $0928da39c2b421f4$export$b0dea82abc030a23 = 'state.actions.bulk-selection.SET_SELECTION_SERVICE_ACTIONS';
const $0928da39c2b421f4$export$b43829a128a6202f = (data)=>({
        type: $0928da39c2b421f4$export$b0dea82abc030a23,
        payload: data
    });
const $0928da39c2b421f4$export$7e3b4dceab941566 = 'state.actions.bulk-selection.SET_HAS_SELECTION';
const $0928da39c2b421f4$export$6647d68ebe704b97 = (data)=>({
        type: $0928da39c2b421f4$export$7e3b4dceab941566,
        payload: data
    });

});

parcelRegister("9aFsj", function(module, exports) {

$parcel$export(module.exports, "LOCK_FIELD", () => $57801d20446d3c14$export$9577624537ff74ab);
$parcel$export(module.exports, "lockFieldAction", () => $57801d20446d3c14$export$293db56aa8facb7a);
$parcel$export(module.exports, "UNLOCK_FIELD", () => $57801d20446d3c14$export$aa4a28625eb23c44);
$parcel$export(module.exports, "unlockFieldAction", () => $57801d20446d3c14$export$539db32098e03442);
$parcel$export(module.exports, "UNLOCK_ALL_FIELDS", () => $57801d20446d3c14$export$43011103b4549dc1);
$parcel$export(module.exports, "unlockAllFieldsAction", () => $57801d20446d3c14$export$4db21b2c60d7d96);
// LOCK_FIELD
const $57801d20446d3c14$export$9577624537ff74ab = 'state.actions.field.lock.LOCK_FIELD';
const $57801d20446d3c14$export$293db56aa8facb7a = (issueKey, fieldId, positionIndex)=>({
        type: $57801d20446d3c14$export$9577624537ff74ab,
        payload: {
            issueKey: issueKey,
            positionIndex: positionIndex,
            fieldId: fieldId
        }
    });
const $57801d20446d3c14$export$aa4a28625eb23c44 = 'state.actions.field.lock.UNLOCK_FIELD';
const $57801d20446d3c14$export$539db32098e03442 = (issueKey, fieldId)=>({
        type: $57801d20446d3c14$export$aa4a28625eb23c44,
        payload: {
            issueKey: issueKey,
            fieldId: fieldId
        }
    });
const $57801d20446d3c14$export$43011103b4549dc1 = 'state.actions.field.lock.UNLOCK_ALL_FIELDS';
const $57801d20446d3c14$export$4db21b2c60d7d96 = ()=>({
        type: $57801d20446d3c14$export$43011103b4549dc1
    });

});

parcelRegister("8MLGs", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PROVIDED_ISSUE_KEYS", () => $694ce1b5336e59cf$export$c3876599022b4e78);
$parcel$export(module.exports, "updateProvidedIssueKeysAction", () => $694ce1b5336e59cf$export$7435108bc993705e);
$parcel$export(module.exports, "ISSUE_EDIT_STARTED", () => $694ce1b5336e59cf$export$1e3bdce3d6fbd74a);
$parcel$export(module.exports, "issueEditStartedAction", () => $694ce1b5336e59cf$export$f5109cd21d1574dd);
const $694ce1b5336e59cf$export$c3876599022b4e78 = 'state.actions.issues.UPDATE_PROVIDED_ISSUE_KEYS';
const $694ce1b5336e59cf$export$7435108bc993705e = (issueKeys)=>({
        type: $694ce1b5336e59cf$export$c3876599022b4e78,
        payload: {
            issueKeys: issueKeys
        }
    });
const $694ce1b5336e59cf$export$1e3bdce3d6fbd74a = 'state.actions.issues.ISSUE_EDIT_STARTED';
const $694ce1b5336e59cf$export$f5109cd21d1574dd = (fieldType, issueKey, analyticsEvent)=>({
        type: $694ce1b5336e59cf$export$1e3bdce3d6fbd74a,
        payload: {
            issueKey: issueKey,
            fieldType: fieldType
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });

});

parcelRegister("lP7g0", function(module, exports) {

$parcel$export(module.exports, "getLastClickedRow", () => $ec5eaa1c5b5a2f44$export$ec93017dc2536f2e);
$parcel$export(module.exports, "getSelectionServiceActions", () => $ec5eaa1c5b5a2f44$export$e9a1d97035e6d261);
const $ec5eaa1c5b5a2f44$export$ec93017dc2536f2e = (state)=>state.bulkSelection.lastClickedRow;
const $ec5eaa1c5b5a2f44$export$e9a1d97035e6d261 = (state)=>state.bulkSelection.selectionServiceActions;
const $ec5eaa1c5b5a2f44$export$2cf0f4905f25f4a4 = (state)=>state.bulkSelection.hasSelection;

});

parcelRegister("h0Rgs", function(module, exports) {

$parcel$export(module.exports, "getProvidedIssueKeys", () => $9624eada5bd00a2d$export$af07af04b01adfd5);
$parcel$export(module.exports, "mergeIssueKeysWithLockedIssues", () => $9624eada5bd00a2d$export$12a917ff04fbe0e8);
$parcel$export(module.exports, "getAllKnownIssueKeys", () => $9624eada5bd00a2d$export$ef16b3729204077d);
$parcel$export(module.exports, "getIssueKeyPositionIndex", () => $9624eada5bd00a2d$export$7424fd062ec0b8e4);
$parcel$export(module.exports, "isIssueKnown", () => $9624eada5bd00a2d$export$46d566aafca01d9e);

var $df4Sl = parcelRequire("df4Sl");

var $8blac = parcelRequire("8blac");

var $3G3gn = parcelRequire("3G3gn");

var $5iWql = parcelRequire("5iWql");

var $6vrw7 = parcelRequire("6vrw7");

var $9jIiv = parcelRequire("9jIiv");

var $fMHj9 = parcelRequire("fMHj9");

var $1DYlI = parcelRequire("1DYlI");
const $9624eada5bd00a2d$export$af07af04b01adfd5 = (state)=>(0, $9jIiv.getPersisted)(state).providedIssueKeys;
const $9624eada5bd00a2d$export$48c3724a62ab72dc = (0, $5iWql.default)((0, $1DYlI.getIndexesOfStringArray));
const $9624eada5bd00a2d$var$areLockedIssuesAlreadyInPosition = (lockedIssuesByKey, originalIssueKeys)=>Object.entries(lockedIssuesByKey).every(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    ([issueKey, lockedIssue])=>originalIssueKeys[lockedIssue.positionIndex] === issueKey);
const $9624eada5bd00a2d$var$desparsify = (issueKeys)=>{
    const resultArray = [];
    issueKeys.forEach((issueKey, positionIndex)=>resultArray.push({
            issueKey: issueKey,
            positionIndex: positionIndex
        }));
    return resultArray;
};
const $9624eada5bd00a2d$export$12a917ff04fbe0e8 = (0, $df4Sl.createSelector)((0, $fMHj9.getLockedIssues), $9624eada5bd00a2d$export$af07af04b01adfd5, (lockedIssuesByKey, originalIssueKeys)=>{
    // Performance shortcut
    if ($9624eada5bd00a2d$var$areLockedIssuesAlreadyInPosition(lockedIssuesByKey, originalIssueKeys)) return originalIssueKeys;
    const resultIssueKeys = [];
    const originalIssueKeysIterator = new (0, $1DYlI.IteratorWrapper)($9624eada5bd00a2d$var$desparsify(originalIssueKeys));
    const lockedRowsIterator = new (0, $1DYlI.IteratorWrapper)((0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(lockedIssuesByKey, (lockedIssue)=>lockedIssue.positionIndex));
    let issueIndexOffset = 0;
    let newArrayLength = originalIssueKeys.length + issueIndexOffset;
    do {
        const nextIssue = originalIssueKeysIterator.current;
        const nextLockedIssue = lockedRowsIterator.current;
        if (nextIssue.done) {
            if (!nextLockedIssue.done) {
                const latestPossibleInsertionPoint = Math.min(nextLockedIssue.value.positionIndex, newArrayLength);
                resultIssueKeys[latestPossibleInsertionPoint] = nextLockedIssue.value.issueKey;
                lockedRowsIterator.next();
                issueIndexOffset += 1;
            }
        } else {
            const realNextIssueIndex = nextIssue.value.positionIndex + issueIndexOffset;
            if (nextLockedIssue.done) {
                if (!lockedIssuesByKey[nextIssue.value.issueKey]) resultIssueKeys[realNextIssueIndex] = nextIssue.value.issueKey;
                else issueIndexOffset -= 1;
                originalIssueKeysIterator.next();
            } else if (realNextIssueIndex >= nextLockedIssue.value.positionIndex) {
                if (realNextIssueIndex === nextLockedIssue.value.positionIndex && nextLockedIssue.value.issueKey === nextIssue.value.issueKey) {
                    resultIssueKeys[nextLockedIssue.value.positionIndex] = nextLockedIssue.value.issueKey;
                    originalIssueKeysIterator.next();
                    lockedRowsIterator.next();
                } else {
                    resultIssueKeys[nextLockedIssue.value.positionIndex] = nextLockedIssue.value.issueKey;
                    lockedRowsIterator.next();
                    issueIndexOffset += 1;
                }
            } else if (lockedIssuesByKey[nextIssue.value.issueKey]) {
                originalIssueKeysIterator.next();
                issueIndexOffset -= 1;
            } else {
                resultIssueKeys[realNextIssueIndex] = nextIssue.value.issueKey;
                originalIssueKeysIterator.next();
            }
        }
        newArrayLength = originalIssueKeys.length + issueIndexOffset;
    }while (!originalIssueKeysIterator.current.done || !lockedRowsIterator.current.done);
    resultIssueKeys.length = Math.max(0, newArrayLength);
    return resultIssueKeys;
});
const $9624eada5bd00a2d$export$ef16b3729204077d = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    $9624eada5bd00a2d$export$12a917ff04fbe0e8(state).reduce((result, issueKey)=>{
        !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(issueKey) && result.push((0, $6vrw7.toIssueKey)(issueKey));
        return result;
    }, []);
const $9624eada5bd00a2d$export$7424fd062ec0b8e4 = (0, $df4Sl.createSelector)($9624eada5bd00a2d$export$12a917ff04fbe0e8, // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type. | TS7006 - Parameter 'issueKeyToFind' implicitly has an 'any' type.
(state, issueKeyToFind)=>issueKeyToFind, (issueKeys, issueKeyToFind)=>$9624eada5bd00a2d$export$48c3724a62ab72dc(issueKeys)[issueKeyToFind]);
const $9624eada5bd00a2d$export$46d566aafca01d9e = (state, issueKey)=>$9624eada5bd00a2d$export$7424fd062ec0b8e4(state, issueKey) !== undefined;

});
parcelRegister("9jIiv", function(module, exports) {

$parcel$export(module.exports, "getPersisted", () => $c929ed699042e3a5$export$5239a0a7977ca4de);
$parcel$export(module.exports, "getFieldInitialization", () => $c929ed699042e3a5$export$4b5927991797d9ed);
$parcel$export(module.exports, "getInitialAppProps", () => $c929ed699042e3a5$export$776ca926a037ba63);
const $c929ed699042e3a5$export$5239a0a7977ca4de = (state)=>state.persisted;
const $c929ed699042e3a5$export$4b5927991797d9ed = (state)=>state.fieldInitialization;
const $c929ed699042e3a5$export$776ca926a037ba63 = (state)=>state.initialAppProps;

});

parcelRegister("fMHj9", function(module, exports) {

$parcel$export(module.exports, "getLockedIssues", () => $eaae78e9bfad0548$export$a17d008b40b9a206);
$parcel$export(module.exports, "getLockedIssueCountAssumingIssueKeyWillBeLocked", () => $eaae78e9bfad0548$export$d1184755c39ce1f8);
$parcel$export(module.exports, "getIsFieldLocked", () => $eaae78e9bfad0548$export$3954fe8afa4b46a);

var $9jIiv = parcelRequire("9jIiv");
const $eaae78e9bfad0548$export$a17d008b40b9a206 = (state)=>(0, $9jIiv.getPersisted)(state).lockedIssues;
const $eaae78e9bfad0548$export$d1184755c39ce1f8 = (state, issueKey)=>{
    const issueKeys = Object.keys($eaae78e9bfad0548$export$a17d008b40b9a206(state));
    issueKeys.push(issueKey);
    return new Set(issueKeys).size;
};
const $eaae78e9bfad0548$export$3954fe8afa4b46a = (state, props)=>{
    const { issueKey: issueKey, fieldDescriptor: { fieldId: fieldId } } = props;
    const lockedIssue = $eaae78e9bfad0548$export$a17d008b40b9a206(state)[issueKey];
    return lockedIssue && !!lockedIssue.fields[fieldId];
};

});

parcelRegister("1DYlI", function(module, exports) {

$parcel$export(module.exports, "getIndexesOfStringArray", () => $10f36698f3c7267e$export$2b158dd2191953a2);
$parcel$export(module.exports, "IteratorWrapper", () => $10f36698f3c7267e$export$8dbb1a760abb7548);
const $10f36698f3c7267e$export$2b158dd2191953a2 = (issueKeys)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const positionIndexByIssueKey = {};
    issueKeys.forEach((value, index)=>{
        positionIndexByIssueKey[value] = index;
    });
    return positionIndexByIssueKey;
};
class $10f36698f3c7267e$export$8dbb1a760abb7548 {
    constructor(sourceArray){
        this.iterator = sourceArray.values();
        // @ts-expect-error - TS2322 - Type 'IteratorResult<T, any>' is not assignable to type 'IteratorResult<T>'.
        this.current = this.iterator.next();
        this.lastNonDoneValue = this.current.done ? undefined : this.current.value;
    }
    next() {
        // @ts-expect-error - TS2322 - Type 'IteratorResult<T, any>' is not assignable to type 'IteratorResult<T>'.
        this.current = this.iterator.next();
        return this.current;
    }
}

});



parcelRegister("dwqCC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f57711d483710af7$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("3wBUP");

var $3G3gn = parcelRequire("3G3gn");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $6vrw7 = parcelRequire("6vrw7");

var $8QWSq = parcelRequire("8QWSq");

var $lP7g0 = parcelRequire("lP7g0");

var $h0Rgs = parcelRequire("h0Rgs");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$f57711d483710af7$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $8QWSq.SELECT_ROW)).switchMap((action)=>{
        const state = store.getState();
        const selectionServiceActions = (0, $lP7g0.getSelectionServiceActions)(state);
        if (!selectionServiceActions) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-table.ops.bulk-select.select-rows', 'selectionServiceActions is not set.');
            (0, $guiFP.default)({
                meta: {
                    id: 'opsSelectRows',
                    packageName: 'jiraIssueTable',
                    teamName: 'jsd-shield'
                }
            });
            return (0, $3JafE.Observable).empty();
        }
        const { selectIssues: selectIssues, deselectIssues: deselectIssues } = selectionServiceActions;
        const { rowId: rowId, selection: selection, isShiftKeyDown: isShiftKeyDown } = action.payload;
        const { analyticsEvent: analyticsEvent } = action.meta;
        const lastClickedRow = (0, $lP7g0.getLastClickedRow)(state);
        if (isShiftKeyDown && !!lastClickedRow) {
            const allIssues = (0, $h0Rgs.getAllKnownIssueKeys)(state);
            const [start, end] = (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))([
                allIssues.indexOf((0, $6vrw7.toIssueKey)(rowId)),
                allIssues.indexOf((0, $6vrw7.toIssueKey)(lastClickedRow))
            ]);
            const issuesIncluded = allIssues.slice(start, end + 1);
            (selection ? selectIssues : deselectIssues)(issuesIncluded, analyticsEvent);
            return (0, $3JafE.Observable).of((0, $8QWSq.setLastClickedRowAction)({
                rowId: rowId
            }));
        }
        (selection ? selectIssues : deselectIssues)([
            (0, $6vrw7.toIssueKey)(rowId)
        ], analyticsEvent);
        return (0, $3JafE.Observable).of((0, $8QWSq.setLastClickedRowAction)({
            rowId: rowId
        }));
    });

});


parcelRegister("50JL0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d33b7b05bc23ad6$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $18P8I = parcelRequire("18P8I");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$2d33b7b05bc23ad6$export$2e2bcd8739ae039 = (action$, store)=>(0, $bd1K7.combineEpics)((0, $18P8I.default)())(action$, store);

});
parcelRegister("18P8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $98b0fcb4cf628a37$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("9u6v2");
parcelRequire("3wBUP");

var $88MUq = parcelRequire("88MUq");

var $fljl6 = parcelRequire("fljl6");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$98b0fcb4cf628a37$export$2e2bcd8739ae039 = ()=>{
    const initializeActionDispatchedFields = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (action$)=>action$.ofType((0, $88MUq.UPDATE_COLUMNS)).switchMap((action)=>{
            const initializationColumnsArray = action.payload.columns// @ts-expect-error - TS7006 - Parameter 'columnProp' implicitly has an 'any' type.
            .filter((columnProp)=>{
                const fieldConfiguration = (0, $fljl6.getJsonColumnConfiguration)(columnProp.fieldType);
                return fieldConfiguration && fieldConfiguration.needsInitialization;
            })// @ts-expect-error - TS7006 - Parameter 'columnProp' implicitly has an 'any' type.
            .filter((columnProp)=>{
                const fieldIdSet = initializeActionDispatchedFields[columnProp.fieldType];
                const needsInitialize = !fieldIdSet || !fieldIdSet.has(columnProp.id);
                if (fieldIdSet) fieldIdSet.add(columnProp.id);
                else initializeActionDispatchedFields[columnProp.fieldType] = new Set([
                    columnProp.id
                ]);
                return needsInitialize;
            }).map((0, $88MUq.initializeColumnAction));
            return (0, $3JafE.Observable).from(initializationColumnsArray);
        });
};

});
parcelRegister("88MUq", function(module, exports) {

$parcel$export(module.exports, "UPDATE_COLUMNS", () => $9deb002fd9e7fa55$export$c9ad0e7c9c02af77);
$parcel$export(module.exports, "updateColumnsAction", () => $9deb002fd9e7fa55$export$3d6d47022c85b605);
$parcel$export(module.exports, "INITIALIZE_COLUMN", () => $9deb002fd9e7fa55$export$8531a79f419258d8);
$parcel$export(module.exports, "initializeColumnAction", () => $9deb002fd9e7fa55$export$12f5c79cbb2fd6b4);
const $9deb002fd9e7fa55$export$c9ad0e7c9c02af77 = 'state.actions.columns.UPDATE_COLUMNS';
const $9deb002fd9e7fa55$export$3d6d47022c85b605 = (columns)=>({
        type: $9deb002fd9e7fa55$export$c9ad0e7c9c02af77,
        payload: {
            columns: columns
        }
    });
const $9deb002fd9e7fa55$export$8531a79f419258d8 = 'state.actions.columns.INITIALIZE_COLUMN';
const $9deb002fd9e7fa55$export$12f5c79cbb2fd6b4 = (column)=>({
        type: $9deb002fd9e7fa55$export$8531a79f419258d8,
        payload: {
            column: column
        }
    });

});

parcelRegister("fljl6", function(module, exports) {

$parcel$export(module.exports, "getJsonColumnConfiguration", () => $8d45d47905782f26$export$34c320c31bc4122b);
$parcel$export(module.exports, "default", () => $8d45d47905782f26$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $illlw = parcelRequire("illlw");

var $9xoK9 = parcelRequire("9xoK9");

var $bQN0o = parcelRequire("bQN0o");

var $pbZdv = parcelRequire("pbZdv");

var $jU4ta = parcelRequire("jU4ta");

var $2GeIJ = parcelRequire("2GeIJ");
const $8d45d47905782f26$var$getAdditionalColumnWidth = (index, totalColumns)=>(index > 0 ? (0, $jU4ta.COLUMN_GUTTER).left : 0) + (index < totalColumns - 1 ? (0, $jU4ta.COLUMN_GUTTER).right : 0);
const $8d45d47905782f26$var$finaliseColumnConfiguration = (config, index, totalColumns)=>{
    const additionalWidth = $8d45d47905782f26$var$getAdditionalColumnWidth(index, totalColumns);
    return (0, $6HC1D.chain)(config)// @ts-expect-error - TS2571 - Object is of type 'unknown'.
    .updateIn([
        'minWidth'
    ], (minWidth)=>Math.max((0, $9xoK9.MIN_WIDTH), minWidth + additionalWidth))// @ts-expect-error - TS2571 - Object is of type 'unknown'.
    .updateIn([
        'maxWidth'
    ], (maxWidth)=>Math.max((0, $9xoK9.MIN_WIDTH), maxWidth + additionalWidth)).value();
};
const $8d45d47905782f26$var$getKnownFieldType = (fieldType)=>// @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'keyof DataSelectorPropsMap | null'.
    (0, $9xoK9.BUILTIN_COLUMN_CONFIGURATIONS)[fieldType] ? fieldType : null;
const $8d45d47905782f26$export$34c320c31bc4122b = (fieldType)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))((0, $9xoK9.BUILTIN_COLUMN_CONFIGURATIONS), fieldType);
const $8d45d47905782f26$var$getJsonColumnProps = (fieldType, columnProps)=>{
    const builtinJsonColumnConfiguration = $8d45d47905782f26$export$34c320c31bc4122b(fieldType);
    return {
        ...builtinJsonColumnConfiguration,
        fieldId: columnProps.id,
        fieldType: fieldType
    };
};
const $8d45d47905782f26$var$getHtmlColumnProps = (columnProps)=>{
    const { fieldType: fieldType } = columnProps;
    const columnConfiguration = (0, $9xoK9.BUILTIN_HTML_COLUMN_CONFIGURATIONS)[fieldType] || (0, $9xoK9.FALLBACK_COLUMN_CONFIGURATION);
    return {
        ...columnConfiguration,
        fieldId: columnProps.id,
        fieldType: fieldType
    };
};
const $8d45d47905782f26$var$transformJsonColumnProps = (fieldType, columnProps, FieldDataSelector, HeaderComponent, createCell)=>{
    const { id: id, title: title } = columnProps;
    const mergedColumnProps = $8d45d47905782f26$var$getJsonColumnProps(fieldType, columnProps);
    const { minWidth: minWidth, maxWidth: maxWidth, canBeMultiLine: canBeMultiLine, FieldComponent: FieldComponent } = mergedColumnProps;
    const jsonComponentArgs = {
        fieldType: fieldType,
        FieldComponent: FieldComponent
    };
    return {
        id: id,
        title: title,
        minWidth: columnProps.minWidth || minWidth,
        maxWidth: columnProps.maxWidth || maxWidth,
        canBeMultiLine: canBeMultiLine,
        // @ts-expect-error - TS2345 - Argument of type '{ fieldType: T; FieldComponent: ComponentType<JsonComponentProps<T>>; }' is not assignable to parameter of type 'JsonComponentArgs<keyof DataSelectorPropsMap>'.
        CellComponent: createCell(jsonComponentArgs, mergedColumnProps, FieldDataSelector),
        HeaderComponent: HeaderComponent
    };
};
const $8d45d47905782f26$var$transformHtmlColumnProps = (// @ts-expect-error - TS7006 - Parameter 'columnProps' implicitly has an 'any' type.
columnProps, FieldDataSelector, HeaderComponent, createCell)=>{
    const { id: id, title: title } = columnProps;
    const mergedColumnProps = $8d45d47905782f26$var$getHtmlColumnProps(columnProps);
    const { minWidth: minWidth, maxWidth: maxWidth, canBeMultiLine: canBeMultiLine } = mergedColumnProps;
    return {
        id: id,
        title: title,
        minWidth: columnProps.minWidth || minWidth,
        maxWidth: columnProps.maxWidth || maxWidth,
        canBeMultiLine: canBeMultiLine,
        CellComponent: createCell(null, mergedColumnProps, FieldDataSelector),
        HeaderComponent: HeaderComponent
    };
};
const $8d45d47905782f26$export$6e8deebce7129a99 = (FieldDataSelector, columns, createCell)=>columns.map((column)=>{
        const knownFieldType = $8d45d47905782f26$var$getKnownFieldType(column.fieldType);
        if (column.fieldType === 'checkbox') return {
            id: 'checkbox',
            title: '',
            minWidth: 25,
            maxWidth: 25,
            CellComponent: (0, $bQN0o.default),
            HeaderComponent: (0, $pbZdv.default)
        };
        if (knownFieldType) return $8d45d47905782f26$var$transformJsonColumnProps(knownFieldType, column, FieldDataSelector, // @ts-expect-error - Argument of type 'ConnectedComponent<ComponentType<any>, { [x: string]: any; [x: number]: any; [x: symbol]: any; context?: Context<ReactReduxContextValue<any, AnyAction>> | undefined; store?: Store<...> | undefined; } | { ...; }>' is not assignable to parameter of type 'ComponentType<HeaderComponentProps>'.
        (0, $2GeIJ.default), createCell);
        return $8d45d47905782f26$var$transformHtmlColumnProps(column, FieldDataSelector, // @ts-expect-error - Argument of type 'ConnectedComponent<ComponentType<any>, { [x: string]: any; [x: number]: any; [x: symbol]: any; context?: Context<ReactReduxContextValue<any, AnyAction>> | undefined; store?: Store<...> | undefined; } | { ...; }>' is not assignable to parameter of type 'ComponentType<HeaderComponentProps>'.
        (0, $2GeIJ.default), createCell);
    })// @ts-expect-error - TS2345 - Argument of type '(column: TableColumn, index: number) => TableColumn' is not assignable to parameter of type '(value: { id: any; title: any; minWidth: any; maxWidth: any; canBeMultiLine: boolean | undefined; CellComponent: CellComponentType; HeaderComponent: ComponentType<HeaderComponentProps>; } | { ...; }, index: number, array: ({ ...; } | { ...; })[]) => TableColumn'.
    .map((column, index)=>$8d45d47905782f26$var$finaliseColumnConfiguration(column, index, columns.length));
var $8d45d47905782f26$export$2e2bcd8739ae039 = $8d45d47905782f26$export$6e8deebce7129a99;

});
parcelRegister("9xoK9", function(module, exports) {

$parcel$export(module.exports, "FALLBACK_COLUMN_CONFIGURATION", () => $1e5c93e53e5234e5$export$9b544c2606a30a3a);
$parcel$export(module.exports, "MIN_WIDTH", () => $1e5c93e53e5234e5$export$1d9fdc71b83a8eac);
$parcel$export(module.exports, "BUILTIN_COLUMN_CONFIGURATIONS", () => $1e5c93e53e5234e5$export$a7c09d12ef8597c0);
$parcel$export(module.exports, "BUILTIN_HTML_COLUMN_CONFIGURATIONS", () => $1e5c93e53e5234e5$export$9f3c8ab747beea8);

var $6HC1D = parcelRequire("6HC1D");

var $c9TLT = parcelRequire("c9TLT");



var $4NNeI = parcelRequire("4NNeI");

var $9n9RE = parcelRequire("9n9RE");

var $d8iCB = parcelRequire("d8iCB");

var $6Gt0Q = parcelRequire("6Gt0Q");

var $7YT7G = parcelRequire("7YT7G");

var $6QN02 = parcelRequire("6QN02");

var $1f6RV = parcelRequire("1f6RV");

var $2UzBs = parcelRequire("2UzBs");

var $dFiWK = parcelRequire("dFiWK");

var $8fFF2 = parcelRequire("8fFF2");

var $8JJio = parcelRequire("8JJio");

var $7vcYl = parcelRequire("7vcYl");

var $3cZ4e = parcelRequire("3cZ4e");

var $7C4bN = parcelRequire("7C4bN");

var $85LCN = parcelRequire("85LCN");

var $60SBI = parcelRequire("60SBI");

var $neNmT = parcelRequire("neNmT");

var $02WRG = parcelRequire("02WRG");

var $4zvpq = parcelRequire("4zvpq");

var $3hRMA = parcelRequire("3hRMA");

var $k2XWr = parcelRequire("k2XWr");
const $1e5c93e53e5234e5$export$9b544c2606a30a3a = (0, $6HC1D.freeze)({
    minWidth: (0, $c9TLT.gridSize) * 20,
    maxWidth: (0, $c9TLT.gridSize) * 20,
    canBeMultiLine: true
});
const $1e5c93e53e5234e5$var$USER_FIELD_CONFIGURATION = {
    minWidth: 100,
    maxWidth: 300,
    canBeMultiLine: true
};
const $1e5c93e53e5234e5$var$USER_FIELD_TYPES = [
    'creator',
    'reporter',
    'com.atlassian.jira.plugin.system.customfieldtypes:userpicker'
];
const $1e5c93e53e5234e5$var$MULTI_USER_FIELD_CONFIGURATION = {
    minWidth: 100,
    maxWidth: 200,
    canBeMultiLine: true
};
const $1e5c93e53e5234e5$var$MULTI_USER_FIELD_TYPES = [
    'com.atlassian.servicedesk:sd-request-participants',
    'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker'
];
const $1e5c93e53e5234e5$var$FEATURED_DATE_FIELD_CONFIGURATION = {
    minWidth: 90,
    maxWidth: 90,
    doNotRenderTooltip: true,
    canBeMultiLine: true
};
const $1e5c93e53e5234e5$var$FEATURED_DATE_FIELD_TYPES = [
    'created',
    'updated',
    'com.atlassian.jira.plugin.system.customfieldtypes:datepicker'
];
const $1e5c93e53e5234e5$var$STANDARD_DATE_FIELD_CONFIGURATION = {
    minWidth: 90,
    maxWidth: 90,
    canBeMultiLine: true
};
const $1e5c93e53e5234e5$var$STANDARD_DATE_FIELD_TYPES = [
    'duedate',
    'resolutiondate'
];
const $1e5c93e53e5234e5$var$DATETIME_FIELD_CONFIGURATION = {
    minWidth: (0, $c9TLT.gridSize) * 11,
    maxWidth: (0, $c9TLT.gridSize) * 18,
    doNotRenderTooltip: true
};
const $1e5c93e53e5234e5$var$DATETIME_FIELD_TYPES = [
    'lastViewed',
    'com.atlassian.jira.plugin.system.customfieldtypes:datetime'
];
const $1e5c93e53e5234e5$var$SHORT_TEXT_FIELD_CONFIGURATION = {
    minWidth: (0, $c9TLT.gridSize) * 12,
    maxWidth: (0, $c9TLT.gridSize) * 25,
    canBeMultiLine: true
};
const $1e5c93e53e5234e5$var$SHORT_TEXT_FIELD_TYPES = [
    'com.atlassian.servicedesk:vp-origin',
    'components',
    'com.atlassian.jira.plugin.system.customfieldtypes:select',
    'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons',
    'resolution',
    'timespent',
    'aggregatetimespent',
    'timeoriginalestimate',
    'com.atlassian.servicedesk.customer-context:sd-csm-entitlement',
    'com.atlassian.servicedesk.sentiment:sd-sentiment'
];
const $1e5c93e53e5234e5$var$LONG_TEXT_FIELD_CONFIGURATION = {
    minWidth: (0, $c9TLT.gridSize) * 20,
    maxWidth: (0, $c9TLT.gridSize) * 75,
    canBeMultiLine: true
};
const $1e5c93e53e5234e5$var$LONG_TEXT_FIELD_TYPES = [
    'summary',
    'com.atlassian.jira.plugin.system.customfieldtypes:textfield'
];
const $1e5c93e53e5234e5$var$MULTI_SELECT_FIELD_CONFIGURATION = {
    minWidth: (0, $c9TLT.gridSize) * 12,
    maxWidth: (0, $c9TLT.gridSize) * 20,
    canBeMultiLine: true
};
// Atlaskit/Tag doesn't truncate long tags until 180px
const $1e5c93e53e5234e5$var$JSON_MULTI_SELECT_FIELD_CONFIGURATION = {
    minWidth: (0, $c9TLT.gridSize) * 21,
    maxWidth: (0, $c9TLT.gridSize) * 21,
    canBeMultiLine: true
};
const $1e5c93e53e5234e5$var$MULTI_SELECT_FIELD_TYPES = [
    'com.atlassian.servicedesk:sd-customer-organizations',
    'com.atlassian.jira.plugin.system.customfieldtypes:labels',
    'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect',
    'fixVersions',
    'issuelinks'
];
const $1e5c93e53e5234e5$var$JSON_MULTI_SELECT_FIELD_TYPES = [
    'labels',
    'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype',
    'com.atlassian.jira.plugin.system.customfieldtypes:multiselect',
    'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes',
    'com.atlassian.jira.plugin.system.customfieldtypes:multiversion',
    'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker'
];
const $1e5c93e53e5234e5$var$MULTILINE_TEXT_FIELD_CONFIGURATION = {
    minWidth: (0, $c9TLT.gridSize) * 20,
    maxWidth: (0, $c9TLT.gridSize) * 75,
    canBeMultiLine: true
};
const $1e5c93e53e5234e5$var$MULTILINE_TEXT_FIELD_TYPES = [
    'description',
    'com.atlassian.jira.plugin.system.customfieldtypes:textarea'
];
const $1e5c93e53e5234e5$var$NUMERIC_FIELD_CONFIGURATION = {
    minWidth: (0, $c9TLT.gridSize) * 8,
    maxWidth: (0, $c9TLT.gridSize) * 16
};
const $1e5c93e53e5234e5$var$NUMERIC_FIELD_TYPES = [
    'com.atlassian.jira.plugin.system.customfieldtypes:float'
];
const $1e5c93e53e5234e5$var$FIELD_CONFIGURATION_CATEGORIES = [
    {
        fieldTypes: $1e5c93e53e5234e5$var$USER_FIELD_TYPES,
        configuration: $1e5c93e53e5234e5$var$USER_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $1e5c93e53e5234e5$var$MULTI_USER_FIELD_TYPES,
        configuration: $1e5c93e53e5234e5$var$MULTI_USER_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $1e5c93e53e5234e5$var$FEATURED_DATE_FIELD_TYPES,
        configuration: $1e5c93e53e5234e5$var$FEATURED_DATE_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $1e5c93e53e5234e5$var$STANDARD_DATE_FIELD_TYPES,
        configuration: $1e5c93e53e5234e5$var$STANDARD_DATE_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $1e5c93e53e5234e5$var$DATETIME_FIELD_TYPES,
        configuration: $1e5c93e53e5234e5$var$DATETIME_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $1e5c93e53e5234e5$var$SHORT_TEXT_FIELD_TYPES,
        configuration: $1e5c93e53e5234e5$var$SHORT_TEXT_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $1e5c93e53e5234e5$var$LONG_TEXT_FIELD_TYPES,
        configuration: $1e5c93e53e5234e5$var$LONG_TEXT_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $1e5c93e53e5234e5$var$MULTILINE_TEXT_FIELD_TYPES,
        configuration: $1e5c93e53e5234e5$var$MULTILINE_TEXT_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $1e5c93e53e5234e5$var$MULTI_SELECT_FIELD_TYPES,
        configuration: $1e5c93e53e5234e5$var$MULTI_SELECT_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $1e5c93e53e5234e5$var$JSON_MULTI_SELECT_FIELD_TYPES,
        configuration: $1e5c93e53e5234e5$var$JSON_MULTI_SELECT_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $1e5c93e53e5234e5$var$NUMERIC_FIELD_TYPES,
        configuration: $1e5c93e53e5234e5$var$NUMERIC_FIELD_CONFIGURATION
    }
];
const $1e5c93e53e5234e5$var$buildFieldConfigurationsFromCategories = (categories)=>categories.reduce((acc, { fieldTypes: fieldTypes, configuration: configuration })=>{
        fieldTypes.forEach((fieldType)=>{
            if (acc[fieldType] != null) throw new Error(`Field configuration for ${fieldType} already defined`);
            acc[fieldType] = configuration;
        });
        return acc;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
const $1e5c93e53e5234e5$export$ec8fde615467a6e1 = (0, $6HC1D.freeze)({
    ...$1e5c93e53e5234e5$var$buildFieldConfigurationsFromCategories($1e5c93e53e5234e5$var$FIELD_CONFIGURATION_CATEGORIES),
    issuekey: {
        minWidth: 85,
        maxWidth: 100
    },
    issuetype: {
        minWidth: 16,
        maxWidth: 16,
        // Prevent ellipsis from rendering in IE & Edge
        canBeMultiLine: true
    },
    status: {
        minWidth: 150,
        maxWidth: 200,
        doNotRenderTooltip: true
    },
    priority: {
        minWidth: 16,
        maxWidth: 16
    },
    assignee: {
        minWidth: 100,
        maxWidth: 220,
        canBeMultiLine: true,
        needsInitialization: true
    },
    'com.atlassian.servicedesk:sd-sla-field': {
        minWidth: 182,
        maxWidth: 200
    },
    'com.atlassian.servicedesk:sd-request-feedback': {
        minWidth: (0, $c9TLT.gridSize) * 11,
        maxWidth: (0, $c9TLT.gridSize) * 11
    },
    summary: {
        minWidth: (0, $c9TLT.gridSize) * 20,
        maxWidth: (0, $c9TLT.gridSize) * 75,
        canBeMultiLine: true
    },
    date: {
        minWidth: (0, $c9TLT.gridSize) * 25,
        maxWidth: (0, $c9TLT.gridSize) * 25,
        doNotRenderTooltip: true
    },
    'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype': {
        minWidth: (0, $c9TLT.gridSize) * 25,
        maxWidth: (0, $c9TLT.gridSize) * 25,
        doNotRenderTooltip: true
    },
    'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype': {
        minWidth: (0, $c9TLT.gridSize) * 25,
        maxWidth: (0, $c9TLT.gridSize) * 25
    },
    meatball: {
        minWidth: (0, $c9TLT.gridSize) * 3,
        maxWidth: (0, $c9TLT.gridSize) * 3
    },
    'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype': {
        minWidth: (0, $c9TLT.gridSize) * 22,
        maxWidth: (0, $c9TLT.gridSize) * 25
    },
    'com.atlassian.jira.plugins.work-category-field:work-category-field-cftype': {
        minWidth: (0, $c9TLT.gridSize) * 15,
        maxWidth: (0, $c9TLT.gridSize) * 20
    }
});
const $1e5c93e53e5234e5$export$1d9fdc71b83a8eac = 48;
const $1e5c93e53e5234e5$export$a7c09d12ef8597c0 = (0, $6HC1D.freeze)({
    assignee: {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1.assignee,
        canBeMultiLine: false,
        FieldComponent: (0, $9n9RE.default)
    },
    reporter: {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1.reporter,
        FieldComponent: (0, $85LCN.default)
    },
    reporterWithIcon: {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1.assignee,
        canBeMultiLine: false,
        FieldComponent: (0, $9n9RE.default)
    },
    creator: {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1.creator,
        FieldComponent: (0, $6Gt0Q.default)
    },
    issuekey: {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1.issuekey,
        FieldComponent: (0, $1f6RV.default)
    },
    issuetype: {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1.issuetype,
        FieldComponent: (0, $dFiWK.default)
    },
    'com.atlassian.servicedesk:sd-sla-field': {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1[0, $eb1896b876bf2c2c$export$f790c24298ed441b],
        FieldComponent: (0, $02WRG.default)
    },
    'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype': {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1[0, $eb1896b876bf2c2c$export$991960fb6e9ea7dd],
        FieldComponent: (0, $4NNeI.AsyncAffectedServices)
    },
    labels: {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1.labels,
        FieldComponent: (0, $8fFF2.default)
    },
    status: {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1.status,
        FieldComponent: (0, $4zvpq.default)
    },
    summary: {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1.summary,
        FieldComponent: (0, $3hRMA.default)
    },
    priority: {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1.priority,
        FieldComponent: (0, $7C4bN.default)
    },
    date: {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1.date,
        FieldComponent: (0, $7YT7G.default)
    },
    'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype': {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1[0, $eb1896b876bf2c2c$export$b84257e6dcaab24d],
        FieldComponent: (0, $d8iCB.CmdbObjects)
    },
    'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype': {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1[0, $eb1896b876bf2c2c$export$dd2fa454b47497da],
        FieldComponent: (0, $60SBI.default)
    },
    meatball: {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1.meatball,
        FieldComponent: (0, $2UzBs.default)
    },
    'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype': {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1[0, $eb1896b876bf2c2c$export$f0f60e2d773695fc],
        FieldComponent: (0, $8JJio.default)
    },
    'com.atlassian.jira.plugins.work-category-field:work-category-field-cftype': {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1[0, $eb1896b876bf2c2c$export$794539092c70e595],
        FieldComponent: (0, $k2XWr.default)
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes': {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1[0, $eb1896b876bf2c2c$export$d8fae0f9b622e615],
        FieldComponent: (0, $3cZ4e.default)
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multiselect': {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1[0, $eb1896b876bf2c2c$export$155ae54d06c908ea],
        FieldComponent: (0, $3cZ4e.default)
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker': {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1[0, $eb1896b876bf2c2c$export$2ddc21f5fedfaf92],
        FieldComponent: (0, $7vcYl.default)
    },
    'com.atlassian.servicedesk:sd-request-participants': {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1[0, $566af5fde20232d3$export$e918afe651ac9e7a],
        FieldComponent: (0, $7vcYl.default)
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multiversion': {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1[0, $eb1896b876bf2c2c$export$5ae60777f05f3dfa],
        FieldComponent: (0, $3cZ4e.default)
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker': {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1[0, $eb1896b876bf2c2c$export$734a41c9fe85799a],
        FieldComponent: (0, $3cZ4e.default)
    },
    'com.atlassian.servicedesk.customer-context:sd-csm-entitlement': {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1[0, $eb1896b876bf2c2c$export$80b6ff34fe6a6e00],
        FieldComponent: (0, $6QN02.default)
    },
    'com.atlassian.servicedesk.sentiment:sd-sentiment': {
        ...$1e5c93e53e5234e5$export$ec8fde615467a6e1[0, $eb1896b876bf2c2c$export$37cb0de8d249ef22],
        FieldComponent: (0, $neNmT.default)
    }
});
const $1e5c93e53e5234e5$export$9f3c8ab747beea8 = (0, $6HC1D.freeze)({
    ...$1e5c93e53e5234e5$export$ec8fde615467a6e1
});
// @ts-expect-error - Property 'parent' is missing
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
({
    ...$1e5c93e53e5234e5$export$a7c09d12ef8597c0
});

});
parcelRegister("4NNeI", function(module, exports) {

$parcel$export(module.exports, "AsyncAffectedServices", () => $0ffa7e9c4c958719$export$6f7aec38b8acafe4);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $0ffa7e9c4c958719$var$LazyAffectedServices = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("dJSZ5")).then((module)=>module.AffectedServices), {
    moduleId: "./src/packages/issue-table/src/common/fields/affected-services/index.tsx"
});
const $0ffa7e9c4c958719$export$6f7aec38b8acafe4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "affectedServicesField",
        packageName: "jiraIssueTable",
        teamName: "jsd-shield",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-affected-services",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0ffa7e9c4c958719$var$LazyAffectedServices, props)));

});
parcelRegister("dJSZ5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5HNjd").then(()=>parcelRequire('lhWM2'));

});


parcelRegister("9n9RE", function(module, exports) {

$parcel$export(module.exports, "default", () => $632d90d75c5ec763$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $7f2nY = parcelRequire("7f2nY");

var $1Rt1q = parcelRequire("1Rt1q");

var $b0UTk = parcelRequire("b0UTk");

var $8z6xl = parcelRequire("8z6xl");
const $632d90d75c5ec763$var$mapStateToProps = (state)=>({
        onRefreshSidebar: (0, $7f2nY.getRefreshSidebar)(state)
    });
// @ts-expect-error - TS2345 - Argument of type '<T extends UserFieldType>(props: FieldComponentProps<T>) => JSX.Element' is not assignable to parameter of type 'ComponentType<FieldComponentProps<"assignee" | "reporterWithIcon">>'.
const $632d90d75c5ec763$var$AssigneeField = (0, $b0UTk.default)((0, $8z6xl.default));
var $632d90d75c5ec763$export$2e2bcd8739ae039 = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('jsm-queue-sidebar-bulk-edit-bug-fix_jx9ff'), (0, $1Rt1q.connect)($632d90d75c5ec763$var$mapStateToProps, {})($632d90d75c5ec763$var$AssigneeField), $632d90d75c5ec763$var$AssigneeField);

});
parcelRegister("7f2nY", function(module, exports) {

$parcel$export(module.exports, "shouldShowPagination", () => $84ee203dd91d3341$export$6e158a7480642df3);
$parcel$export(module.exports, "getCurrentPage", () => $84ee203dd91d3341$export$7945ba8eb1c827e6);
$parcel$export(module.exports, "getEditingFieldHorizontalOffset", () => $84ee203dd91d3341$export$ea5cb0fb82c4318e);
$parcel$export(module.exports, "getEditingFieldVerticalOffset", () => $84ee203dd91d3341$export$446d316b4302b660);
$parcel$export(module.exports, "getEditingFieldWidth", () => $84ee203dd91d3341$export$9d6a956ae977aa72);
$parcel$export(module.exports, "getTableWidth", () => $84ee203dd91d3341$export$4910020ffe58186f);
$parcel$export(module.exports, "getTableHeight", () => $84ee203dd91d3341$export$81ff4c821ba5ba90);
$parcel$export(module.exports, "isUserPickerDisabled", () => $84ee203dd91d3341$export$dd971882ae58428);
$parcel$export(module.exports, "isTableDisabled", () => $84ee203dd91d3341$export$739fac98c5c8c5b1);
$parcel$export(module.exports, "getOnIssueViewTransition", () => $84ee203dd91d3341$export$91f8b9de4d443a00);
$parcel$export(module.exports, "getOnIssueViewTransitionCallback", () => $84ee203dd91d3341$export$2cdb474716074fd9);
$parcel$export(module.exports, "getUseJSMQueueDurationEvent", () => $84ee203dd91d3341$export$95f35106d46731dd);
$parcel$export(module.exports, "getRenderSidebarIcon", () => $84ee203dd91d3341$export$a0841f9badd7cdca);
$parcel$export(module.exports, "getRefreshSidebar", () => $84ee203dd91d3341$export$c193060edd582f66);

var $7Oh8q = parcelRequire("7Oh8q");
const $84ee203dd91d3341$export$f636b7a9195cdaf0 = (state)=>state.ui;
const $84ee203dd91d3341$export$6e158a7480642df3 = (state)=>$84ee203dd91d3341$export$f636b7a9195cdaf0(state).showPagination;
const $84ee203dd91d3341$export$7945ba8eb1c827e6 = (state)=>$84ee203dd91d3341$export$f636b7a9195cdaf0(state).currentPage;
const $84ee203dd91d3341$var$maybeEditingFieldPosition = (state)=>(0, $7Oh8q.Maybe).fromNull($84ee203dd91d3341$export$f636b7a9195cdaf0(state).editingFieldPosition);
const $84ee203dd91d3341$export$ea5cb0fb82c4318e = (state)=>$84ee203dd91d3341$var$maybeEditingFieldPosition(state)// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    .map((position)=>position.horizontalOffset).orSome(0);
const $84ee203dd91d3341$export$446d316b4302b660 = (state)=>$84ee203dd91d3341$var$maybeEditingFieldPosition(state)// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    .map((position)=>position.verticalOffset).orSome(0);
const $84ee203dd91d3341$export$9d6a956ae977aa72 = (state)=>$84ee203dd91d3341$var$maybeEditingFieldPosition(state)// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    .map((position)=>position.fieldWidth).orSome(0);
const $84ee203dd91d3341$export$4910020ffe58186f = (state)=>$84ee203dd91d3341$var$maybeEditingFieldPosition(state)// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    .map((position)=>position.tableWidth).orSome(0);
const $84ee203dd91d3341$export$81ff4c821ba5ba90 = (state)=>$84ee203dd91d3341$var$maybeEditingFieldPosition(state)// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    .map((position)=>position.tableHeight).orSome(0);
const $84ee203dd91d3341$export$dd971882ae58428 = (state)=>$84ee203dd91d3341$export$f636b7a9195cdaf0(state).userPickerDisabled;
const $84ee203dd91d3341$export$739fac98c5c8c5b1 = (state)=>$84ee203dd91d3341$export$f636b7a9195cdaf0(state).isTableDisabled;
const $84ee203dd91d3341$export$91f8b9de4d443a00 = (state)=>$84ee203dd91d3341$export$f636b7a9195cdaf0(state).onIssueViewTransition;
const $84ee203dd91d3341$export$2cdb474716074fd9 = (state, issueKey)=>{
    const onIssueViewTransition = $84ee203dd91d3341$export$91f8b9de4d443a00(state);
    return onIssueViewTransition ? (event)=>onIssueViewTransition(issueKey, event) : undefined;
};
const $84ee203dd91d3341$export$95f35106d46731dd = (state)=>$84ee203dd91d3341$export$f636b7a9195cdaf0(state).useJSMQueueDurationEvent;
const $84ee203dd91d3341$export$a0841f9badd7cdca = (state)=>$84ee203dd91d3341$export$f636b7a9195cdaf0(state).renderSidebarIcon;
const $84ee203dd91d3341$export$c193060edd582f66 = (state)=>$84ee203dd91d3341$export$f636b7a9195cdaf0(state).refreshSidebar;

});

parcelRegister("1Rt1q", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $83569aea30279e06$export$f51a9068ac82ea43);
$parcel$export(module.exports, "IssueTableContext", () => $83569aea30279e06$export$75838b369936001);
$parcel$export(module.exports, "Provider", () => $83569aea30279e06$export$2881499e37b75b9a);
$parcel$export(module.exports, "connect", () => $83569aea30279e06$export$64605811ab45167f);

var $eUqFw = parcelRequire("eUqFw");

var $MYW4e = parcelRequire("MYW4e");

var $8FRHo = parcelRequire("8FRHo");

var $lNNXV = parcelRequire("lNNXV");


var $7sBLF = parcelRequire("7sBLF");
const $83569aea30279e06$export$f51a9068ac82ea43 = (rootEpic, initialState)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $8FRHo.default)({
        appName: 'IssueTable',
        initialState: // @ts-expect-error - Type 'Partial<State>' is not assignable to type '{ readonly initialAppProps: { cloudId?: string | undefined; atlassianAccountId?: string | undefined; fabricPfDirUrl?: string | undefined; }; readonly persisted: { lockedIssues: { [x: string]: { issueKey: string; positionIndex: number; fields: { ...; }; } | undefined; }; columns: { ...; }[]; providedIssueKeys: string...'.
        initialState,
        rootReducer: (0, $MYW4e.enableBatching)((0, $7sBLF.default)),
        rootEpic: rootEpic
    });
const $83569aea30279e06$export$75838b369936001 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $83569aea30279e06$export$2881499e37b75b9a = (0, $lNNXV.createProvider)($83569aea30279e06$export$75838b369936001);
const $83569aea30279e06$export$64605811ab45167f = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mapDispatchToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mergeProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
options = {})=>(0, $lNNXV.connect)(mapStateToProps, mapDispatchToProps, mergeProps, {
        ...options,
        context: $83569aea30279e06$export$75838b369936001,
        storeKey: (0, $9187c4bde54673a4$export$b94951a11282ae6a)
    });

});
const $9187c4bde54673a4$export$b94951a11282ae6a = 'issueTableStore';

parcelRegister("7sBLF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ee1b3f30286807c$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $4bkzS = parcelRequire("4bkzS");

var $icz0w = parcelRequire("icz0w");

var $8QJr9 = parcelRequire("8QJr9");

var $iIfHk = parcelRequire("iIfHk");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8ee1b3f30286807c$var$noopReducer = (state)=>state || {};
var $8ee1b3f30286807c$export$2e2bcd8739ae039 = (0, $huRi7.combineReducers)({
    persisted: $8QJr9.default,
    ui: $iIfHk.default,
    fieldInitialization: $icz0w.default,
    bulkSelection: $4bkzS.default,
    initialAppProps: $8ee1b3f30286807c$var$noopReducer
});

});
parcelRegister("4bkzS", function(module, exports) {

$parcel$export(module.exports, "default", () => $587c7fd150d16196$export$2e2bcd8739ae039);

var $8QWSq = parcelRequire("8QWSq");
const $587c7fd150d16196$export$c9e0737591e76440 = {
    lastClickedRow: undefined,
    selectionServiceActions: undefined,
    hasSelection: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$587c7fd150d16196$export$2e2bcd8739ae039 = (state = $587c7fd150d16196$export$c9e0737591e76440, action)=>{
    switch(action.type){
        case 0, $8QWSq.SET_LAST_CLICKED_ROW:
            {
                const { rowId: lastClickedRow } = action.payload;
                return {
                    ...state,
                    lastClickedRow: lastClickedRow
                };
            }
        case 0, $8QWSq.SET_SELECTION_SERVICE_ACTIONS:
            {
                const { actions: actions } = action.payload;
                return {
                    ...state,
                    selectionServiceActions: actions
                };
            }
        // @ts-expect-error - TS2678 - Type '"state.actions.bulk-selection.SET_HAS_SELECTION"' is not comparable to type '"state.actions.bulk-selection.SET_LAST_CLICKED_ROW" | "state.actions.bulk-selection.SET_SELECTION_SERVICE_ACTIONS"'.
        case 0, $8QWSq.SET_HAS_SELECTION:
            {
                // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'never'.
                const { hasSelection: hasSelection } = action.payload;
                return {
                    ...state,
                    hasSelection: hasSelection
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("icz0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $f584b116ff2f59a6$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $d7xzx = parcelRequire("d7xzx");
const $f584b116ff2f59a6$var$DEFAULT_FIELD_INITIALIZATION = {
    assignee: {}
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f584b116ff2f59a6$export$2e2bcd8739ae039 = (state = $f584b116ff2f59a6$var$DEFAULT_FIELD_INITIALIZATION, action)=>{
    switch(action.type){
        case 0, $d7xzx.SET_ASSIGNEE_INITIALIZATION_STATE:
            {
                const { avatarUrl: avatarUrl, displayName: displayName, emailAddress: emailAddress } = action.payload;
                return (0, $6HC1D.assoc)(state, 'assignee', {
                    avatarUrl: avatarUrl,
                    displayName: displayName,
                    emailAddress: emailAddress
                });
            }
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});
parcelRegister("d7xzx", function(module, exports) {

$parcel$export(module.exports, "SET_ASSIGNEE_INITIALIZATION_STATE", () => $3112f31c763d76d8$export$9b3381a1fe204800);
$parcel$export(module.exports, "setAssigneeInitializationStateAction", () => $3112f31c763d76d8$export$50a032c03fced60e);
const $3112f31c763d76d8$export$9b3381a1fe204800 = 'state.actions.field.initialization.SET_ASSIGNEE_INITIALIZATION_STATE';
const $3112f31c763d76d8$export$50a032c03fced60e = (assigneeInitialization)=>({
        type: $3112f31c763d76d8$export$9b3381a1fe204800,
        payload: assigneeInitialization
    });

});


parcelRegister("8QJr9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6b9f12dd1a6a44f$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $8blac = parcelRequire("8blac");

var $hTLlD = parcelRequire("hTLlD");

var $i7Fym = parcelRequire("i7Fym");

var $1dO2y = parcelRequire("1dO2y");

var $88MUq = parcelRequire("88MUq");

var $9aFsj = parcelRequire("9aFsj");

var $8MLGs = parcelRequire("8MLGs");

var $jyIFK = parcelRequire("jyIFK");

var $2SRkQ = parcelRequire("2SRkQ");
const $a6b9f12dd1a6a44f$var$DEFAULT_PERSISTED_STATE = {
    columns: [],
    providedIssueKeys: [],
    lockedIssues: {},
    offsets: {
        verticalScrollOffset: 0,
        horizontalScrollOffset: 0
    },
    rowListRef: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a6b9f12dd1a6a44f$export$2e2bcd8739ae039 = (state = $a6b9f12dd1a6a44f$var$DEFAULT_PERSISTED_STATE, action)=>{
    switch(action.type){
        case 0, $9aFsj.UNLOCK_FIELD:
            {
                const { issueKey: issueKey, fieldId: fieldId } = action.payload;
                const newLockedIssues = (0, $1dO2y.default)(state, [
                    'lockedIssues',
                    issueKey,
                    'fields',
                    fieldId
                ]);
                const newLockedIssue = newLockedIssues.lockedIssues[issueKey];
                if (newLockedIssue && (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(newLockedIssue.fields)) return (0, $1dO2y.default)(state, [
                    'lockedIssues',
                    issueKey
                ]);
                return newLockedIssues;
            }
        case 0, $9aFsj.LOCK_FIELD:
            {
                const { issueKey: issueKey, fieldId: fieldId, positionIndex: positionIndex } = action.payload;
                return (0, $6HC1D.updateIn)(state, [
                    'lockedIssues'
                ], (lockedIssues)=>{
                    // Clean up any other issues with the same position
                    const newLockedIssues = (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))(// @ts-expect-error - TS2769 - No overload matches this call.
                    lockedIssues, (lockedIssue)=>lockedIssue.positionIndex === positionIndex && lockedIssue.issueKey !== issueKey);
                    // Overwrite/update the current locked issue details
                    return (0, $6HC1D.updateIn)(newLockedIssues, [
                        issueKey
                    ], (lockedIssue)=>{
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const fields = {};
                        fields[fieldId] = true;
                        return (0, $6HC1D.merge)(lockedIssue || {}, {
                            issueKey: issueKey,
                            positionIndex: positionIndex,
                            fields: fields
                        });
                    });
                });
            }
        case 0, $9aFsj.UNLOCK_ALL_FIELDS:
            return (0, $6HC1D.assoc)(state, 'lockedIssues', {});
        case 0, $88MUq.UPDATE_COLUMNS:
            {
                const { columns: columns } = action.payload;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(state.columns, columns)) return state;
                return (0, $6HC1D.assoc)(state, 'columns', columns);
            }
        case 0, $8MLGs.UPDATE_PROVIDED_ISSUE_KEYS:
            {
                const { issueKeys: issueKeys } = action.payload;
                return (0, $6HC1D.assoc)(state, 'providedIssueKeys', issueKeys);
            }
        case 0, $jyIFK.SET_HORIZONTAL_OFFSET:
            {
                const { horizontalOffset: horizontalOffset } = action.payload;
                return (0, $6HC1D.assocIn)(state, [
                    'offsets',
                    'horizontalScrollOffset'
                ], horizontalOffset);
            }
        case 0, $jyIFK.SET_VERTICAL_OFFSET:
            {
                const { verticalOffset: verticalOffset } = action.payload;
                return (0, $6HC1D.assocIn)(state, [
                    'offsets',
                    'verticalScrollOffset'
                ], verticalOffset);
            }
        case 0, $2SRkQ.SET_ROW_LIST_REF:
            return (0, $6HC1D.assoc)(state, 'rowListRef', action.payload);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("1dO2y", function(module, exports) {

$parcel$export(module.exports, "default", () => $427325626a31a3d6$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $427325626a31a3d6$var$unsetInSingle = (state, pathToParent, key)=>{
    if (pathToParent.length === 0) return (0, $6HC1D.unset)(state, key);
    const ret = (0, $6HC1D.updateIn)(state, pathToParent, (parent)=>parent ? (0, $6HC1D.unset)(parent, key) : undefined);
    return ret;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $427325626a31a3d6$var$unsetInMulti = (state, pathToParent, keys)=>// @ts-expect-error - TS7006 - Parameter 'folded' implicitly has an 'any' type. | TS7006 - Parameter 'subkey' implicitly has an 'any' type.
    keys.reduce((folded, subkey)=>$427325626a31a3d6$var$unsetInSingle(folded, pathToParent, subkey), state);
var //   ['a', 'b', 'c'] - removes values at 'a/b/c'
//   ['a', ['b', 'c']] - removes values at 'a/b' and 'a/c'
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$427325626a31a3d6$export$2e2bcd8739ae039 = (state, path)=>{
    if (path.length === 0) return state;
    const pathToParent = path.slice(0, path.length - 1);
    const lastPathItem = path.slice(-1)[0];
    if (Array.isArray(lastPathItem)) return $427325626a31a3d6$var$unsetInMulti(state, pathToParent, lastPathItem);
    return $427325626a31a3d6$var$unsetInSingle(state, pathToParent, lastPathItem);
};

});

parcelRegister("jyIFK", function(module, exports) {

$parcel$export(module.exports, "UPDATE_VERTICAL_OFFSET", () => $5fe501f495f36fed$export$676d1c528632e526);
$parcel$export(module.exports, "updateVerticalOffsetAction", () => $5fe501f495f36fed$export$18b97acfb3435930);
$parcel$export(module.exports, "SET_VERTICAL_OFFSET", () => $5fe501f495f36fed$export$377cee6e888818c4);
$parcel$export(module.exports, "setVerticalOffsetAction", () => $5fe501f495f36fed$export$d4159e3b6bc6e867);
$parcel$export(module.exports, "SET_HORIZONTAL_OFFSET", () => $5fe501f495f36fed$export$d3a9fff38ab5d354);
$parcel$export(module.exports, "setHorizontalOffsetAction", () => $5fe501f495f36fed$export$3ed7387f47277f6a);
const $5fe501f495f36fed$export$676d1c528632e526 = 'state.actions.offsets.UPDATE_VERTICAL_OFFSET';
const $5fe501f495f36fed$export$18b97acfb3435930 = (totalPages, verticalPosition, onVerticalScrollOffsetChanged)=>({
        type: $5fe501f495f36fed$export$676d1c528632e526,
        payload: {
            totalPages: totalPages,
            verticalPosition: verticalPosition,
            onVerticalScrollOffsetChanged: onVerticalScrollOffsetChanged
        }
    });
const $5fe501f495f36fed$export$377cee6e888818c4 = 'state.actions.offsets.SET_VERTICAL_OFFSET';
const $5fe501f495f36fed$export$d4159e3b6bc6e867 = (verticalOffset)=>({
        type: $5fe501f495f36fed$export$377cee6e888818c4,
        payload: {
            verticalOffset: verticalOffset
        }
    });
const $5fe501f495f36fed$export$d3a9fff38ab5d354 = 'state.actions.offsets.SET_HORIZONTAL_OFFSET';
const $5fe501f495f36fed$export$3ed7387f47277f6a = (horizontalOffset)=>({
        type: $5fe501f495f36fed$export$d3a9fff38ab5d354,
        payload: {
            horizontalOffset: horizontalOffset
        }
    });

});

parcelRegister("2SRkQ", function(module, exports) {

$parcel$export(module.exports, "SET_ROW_LIST_REF", () => $be821c6c49b99dc0$export$bb9e2ef2ff07df11);
$parcel$export(module.exports, "setRowListRefAction", () => $be821c6c49b99dc0$export$9264a3dd68126495);
const $be821c6c49b99dc0$export$bb9e2ef2ff07df11 = 'state.actions.table.SET_ROW_LIST_REF';
const $be821c6c49b99dc0$export$9264a3dd68126495 = (payload)=>({
        type: $be821c6c49b99dc0$export$bb9e2ef2ff07df11,
        payload: payload
    });

});


parcelRegister("iIfHk", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_STATE", () => $5c86af8ab6ba7651$export$a3a6a28ae8823b06);
$parcel$export(module.exports, "default", () => $5c86af8ab6ba7651$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $b5o6E = parcelRequire("b5o6E");
const $5c86af8ab6ba7651$export$a3a6a28ae8823b06 = {
    showPagination: false,
    currentPage: 1,
    userPickerDisabled: false,
    isTableDisabled: false,
    onIssueViewTransition: undefined,
    useJSMQueueDurationEvent: undefined,
    renderSidebarIcon: undefined,
    refreshSidebar: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5c86af8ab6ba7651$export$2e2bcd8739ae039 = (state = $5c86af8ab6ba7651$export$a3a6a28ae8823b06, action)=>{
    switch(action.type){
        case 0, $b5o6E.SHOW_PAGINATION:
            return (0, $6HC1D.assoc)(state, 'showPagination', action.payload);
        case 0, $b5o6E.SET_EDITING_FIELD_POSITION:
            return (0, $6HC1D.assoc)(state, 'editingFieldPosition', {
                horizontalOffset: action.payload.horizontalOffset,
                verticalOffset: action.payload.verticalOffset,
                fieldWidth: action.payload.fieldWidth,
                tableWidth: action.payload.tableWidth,
                tableHeight: action.payload.tableHeight
            });
        case 0, $b5o6E.SET_CURRENT_PAGE:
            return (0, $6HC1D.assoc)(state, 'currentPage', action.payload);
        case 0, $b5o6E.SET_IS_TABLE_DISABLED:
            return (0, $6HC1D.assoc)(state, 'isTableDisabled', action.payload);
        case 0, $b5o6E.DISABLE_USER_PICKER:
            return (0, $6HC1D.assoc)(state, 'userPickerDisabled', true);
        case 0, $b5o6E.SET_ON_ISSUE_VIEW_TRANSITION:
            return (0, $6HC1D.assoc)(state, 'onIssueViewTransition', action.payload);
        case 0, $b5o6E.SET_JSM_QUEUE_DURATION_EVENT:
            return (0, $6HC1D.assoc)(state, 'useJSMQueueDurationEvent', action.payload);
        case 0, $b5o6E.SET_RENDER_SIDE_BAR_ICON:
            return (0, $6HC1D.assoc)(state, 'renderSidebarIcon', action.payload);
        case 0, $b5o6E.SET_REFRESH_SIDE_BAR:
            return (0, $6HC1D.assoc)(state, 'refreshSidebar', action.payload);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});



parcelRegister("b0UTk", function(module, exports) {

$parcel$export(module.exports, "default", () => $00ba80989caf5281$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");

var $5oqGi = parcelRequire("5oqGi");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $c6dcs = parcelRequire("c6dcs");

var $7hM0m = parcelRequire("7hM0m");

var $5KGFD = parcelRequire("5KGFD");
const $00ba80989caf5281$var$OVERLAY_TIMEOUT = 1000;
const $00ba80989caf5281$var$LOCATION = 'issue-table.view.fields.common.editable-field';
const $00ba80989caf5281$var$AUTOMATIC_ID_VALUE = '-1';
const $00ba80989caf5281$export$ae8818331f1797ff = (response)=>{
    // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    const { assignee: assignee } = response ? response.fields || {} : {};
    if (assignee !== null && assignee !== undefined) {
        const currentAssignee = {
            accountId: assignee.accountId,
            displayName: assignee.displayName || '',
            emailAddress: assignee.emailAddress,
            avatarUrl: assignee.avatarUrls['48x48'] || ''
        };
        return currentAssignee;
    }
    return undefined;
};
function $00ba80989caf5281$export$2e2bcd8739ae039(ChildComponent) {
    // eslint-disable-next-line jira/react/no-class-components
    return class EditableField extends (0, $eUqFw.Component) {
        static getDerivedStateFromProps(props, state) {
            const { dataSelectorProps: { key: key } } = props;
            if (key !== state.key) return {
                overlay: undefined,
                key: key
            };
            return null;
        }
        constructor(props){
            super(props);
            this.onSuccess = (fieldValue, event)=>{
                const { dataSelectorProps: { onChange: onChange, value: value, fieldType: fieldType }, tableInjectedProps: { issueKey: issueKey, issueFieldLockControls: issueFieldLockControls }, onRefreshSidebar: onRefreshSidebar } = this.props;
                this.timeoutOverlay();
                if (fieldValue && fieldValue.accountId === $00ba80989caf5281$var$AUTOMATIC_ID_VALUE) (0, $5KGFD.getCurrentAssignee)(issueKey).then((response)=>{
                    onChange && onChange(issueKey, $00ba80989caf5281$export$ae8818331f1797ff(response));
                    issueFieldLockControls.onFieldUnlock();
                }).catch((err)=>{
                    (0, $guiFP.default)({
                        meta: {
                            id: 'getCurrentAssigneeFailure',
                            packageName: 'jiraIssueTable',
                            teamName: 'jsd-shield'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    onChange && onChange(issueKey, fieldValue);
                    issueFieldLockControls.onFieldUnlock();
                });
                else {
                    onChange && onChange(issueKey, fieldValue);
                    issueFieldLockControls.onFieldUnlock();
                }
                (0, $1ybV0.ff)('jsm-queue-sidebar-bulk-edit-bug-fix_jx9ff') && onRefreshSidebar?.({
                    issueKey: issueKey
                });
                if (fieldType) (0, $c6dcs.trackUpdatedField)(event, fieldType, this.getAccountIds(fieldValue, value));
            };
            this.onFailure = ()=>{
                this.setState({
                    overlay: undefined
                });
                const { tableInjectedProps: { issueFieldLockControls: issueFieldLockControls } } = this.props;
                issueFieldLockControls.onFieldUnlock();
            };
            this.onEditStart = ()=>{
                const { tableInjectedProps: { issueFieldLockControls: issueFieldLockControls, onEditStart: onEditStart, issueKey: issueKey }, dataSelectorProps: { fieldType: fieldType } } = this.props;
                issueFieldLockControls.onFieldLock();
                onEditStart(fieldType, issueKey);
                this.isSelection = false;
                this.setState({
                    inEditState: true
                });
            };
            this.onEditCancel = ()=>{
                if (!this.isSelection) {
                    this.setState({
                        overlay: undefined
                    });
                    const { tableInjectedProps: { issueFieldLockControls: issueFieldLockControls } } = this.props;
                    issueFieldLockControls.onFieldUnlock();
                }
                this.isSelection = false;
                this.setState({
                    inEditState: false
                });
            };
            this.onEditSelection = ()=>{
                this.isSelection = true;
            };
            this.onSubmit = (fieldValue)=>{
                this.childWrapperRef && this.childWrapperRef.focus();
                this.setState({
                    overlay: {
                        value: fieldValue
                    },
                    inEditState: false
                });
            };
            this.onChildWrapperRefUpdate = (el)=>{
                this.childWrapperRef = el;
            };
            this.getAccountIds = (fieldValue, value)=>({
                    oldId: value && value.accountId ? value.accountId : null,
                    newId: fieldValue && fieldValue.accountId ? fieldValue.accountId : null
                });
            this.state = {
                key: props.dataSelectorProps.key,
                inEditState: false
            };
        }
        componentDidUpdate(prevProps, prevState) {
            if (this.state.key !== prevState.key && this.overlayTimeoutId) window.clearTimeout(this.overlayTimeoutId);
        }
        componentWillUnmount() {
            if (this.overlayTimeoutId) window.clearTimeout(this.overlayTimeoutId);
        }
        getValue() {
            const { overlay: overlay } = this.state;
            if (overlay) return overlay.value;
            const { dataSelectorProps: { value: value } } = this.props;
            return value;
        }
        timeoutOverlay() {
            const { dataSelectorProps: { fieldType: fieldType } } = this.props;
            this.overlayTimeoutId = window.setTimeout(()=>{
                this.setState({
                    overlay: undefined
                });
                delete this.overlayTimeoutId;
                (0, $gUUjF.default).safeWarnWithoutCustomerData($00ba80989caf5281$var$LOCATION, `Overlay timeout reached for ${fieldType} field`);
            }, $00ba80989caf5281$var$OVERLAY_TIMEOUT);
        }
        renderChildComponent(isSaving) {
            const { dataSelectorProps: { fieldType: fieldType, key: key, isEditable: isEditable, overrideDisabledAppearance: overrideDisabledAppearance }, tableInjectedProps: { width: width, issueKey: issueKey, fieldId: fieldId, rowListRef: rowListRef, onSetEditingFieldPosition: onSetEditingFieldPosition, isFieldLocked: isFieldLocked, isUserPickerDisabled: isUserPickerDisabled, isLastColumn: isLastColumn } } = this.props;
            const props = {
                value: this.getValue(),
                fieldType: fieldType,
                fieldId: fieldId,
                width: width,
                isEditable: isEditable,
                issueKey: issueKey,
                rowListRef: rowListRef,
                onSetEditingFieldPosition: onSetEditingFieldPosition,
                isFieldLocked: isFieldLocked,
                isUserPickerDisabled: isUserPickerDisabled,
                isLastColumn: isLastColumn,
                overrideDisabledAppearance: overrideDisabledAppearance
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChildComponent, {
                ...props,
                key: key,
                onSubmit: this.onSubmit,
                onEditStart: this.onEditStart,
                onEditCancel: this.onEditCancel,
                // @ts-expect-error - TS2322 - Type '(fieldValue: FieldValue<T>, event: UIAnalyticsEventInterface) => void' is not assignable to type '(arg1: FieldValue<T>) => void'.
                onEditSuccess: this.onSuccess,
                onEditFailure: this.onFailure,
                isFieldLocked: isFieldLocked,
                isSaving: isSaving,
                onEditSelection: this.onEditSelection
            });
        }
        renderWithFocusWrapper(children) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7hM0m.default), {
                inEditState: this.state.inEditState
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                style: {
                    outline: 'none'
                },
                ref: this.onChildWrapperRefUpdate
            }, children));
        }
        render() {
            const { tableInjectedProps: { isLastColumn: isLastColumn } } = this.props;
            const { overlay: overlay } = this.state;
            return overlay ? this.renderWithFocusWrapper(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                paddingInlineEnd: isLastColumn ? 'space.0' : 'space.200'
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5oqGi.default), null, this.renderChildComponent(true)))) : this.renderWithFocusWrapper(this.renderChildComponent(false));
        }
    };
}

});
parcelRegister("5oqGi", function(module, exports) {

$parcel$export(module.exports, "default", () => $33d7187de9305cdc$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
function $33d7187de9305cdc$export$2e2bcd8739ae039(props) {
    const { border: border, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$BlanketContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$BackgroundContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$Background, {
        border: border
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$ComponentContainer, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$SpinnerContainer, {
        role: "status",
        "aria-label": "Loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null)));
}
$33d7187de9305cdc$export$2e2bcd8739ae039.defaultProps = {
    border: true
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $33d7187de9305cdc$var$BlanketContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c116y _2lx2vrvc _4t3i1wug",
            __cmplp.className
        ])
    });
});
const $33d7187de9305cdc$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1ltvidpf _4t3i1osq _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _u5f3u2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $33d7187de9305cdc$var$BackgroundContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _4t3i1osq _1bsb1osq _vchhusvi _1yt483op _1reo1wug _18m91wug",
            __cmplp.className
        ])
    });
});
const $33d7187de9305cdc$var$Background = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { border: border, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4t3i1osq _1bsb1osq _vchhusvi _bfhk14n2 _2rko1l7b",
            __cmplp.border ? "_19it1qih" : "_19itglyw",
            __cmplp.className
        ])
    });
});
const $33d7187de9305cdc$var$ComponentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_tzy4sxj9 _16jlkb7n _1o9zkb7n _i0dl1wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("c6dcs", function(module, exports) {

$parcel$export(module.exports, "updateFieldValue$", () => $45914c5ca5f791ff$export$62b1d44da2518e20);
$parcel$export(module.exports, "trackUpdatedField", () => $45914c5ca5f791ff$export$a57c24e3bce9af0e);

var $3JafE = parcelRequire("3JafE");
parcelRequire("bI4RP");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");

var $6vrw7 = parcelRequire("6vrw7");

var $bfutc = parcelRequire("bfutc");
const $45914c5ca5f791ff$var$toAccountIdOrNull = (accountId)=>accountId ? (0, $6vrw7.toAccountId)(accountId) : null;
const $45914c5ca5f791ff$var$putUserFieldValue = (// TODO: SHIELD-3213 - Not actually UserProps being passed - also includes fieldType
value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
fieldId, issueKey)=>{
    const newUserFieldValue = value ? {
        id: $45914c5ca5f791ff$var$toAccountIdOrNull(value.accountId)
    } : null;
    const newFieldValues = {
        [fieldId]: newUserFieldValue
    };
    return (0, $bfutc.putFieldValue$)((0, $6vrw7.toIssueKey)(issueKey), newFieldValues);
};
const $45914c5ca5f791ff$export$62b1d44da2518e20 = (issueKey, fieldId, newValue)=>{
    switch(newValue.fieldType){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
            // @ts-expect-error - TS2345 - Argument of type 'DataSelectorFieldValue<T>' is not assignable to parameter of type 'UserProps'.
            return $45914c5ca5f791ff$var$putUserFieldValue(newValue, fieldId, issueKey);
        default:
            return (0, $3JafE.Observable).throw(new Error(`fieldType ${newValue.fieldType} not supported`));
    }
};
const $45914c5ca5f791ff$export$a57c24e3bce9af0e = (event, field, fieldData)=>{
    const { oldId: oldId, oldCategory: oldCategory, newId: newId, newCategory: newCategory } = fieldData;
    (0, $jMP2a.fireTrackAnalytics)(event, 'issueFields updated', {
        updatedField: field,
        updatedFieldOldID: oldId,
        updatedFieldNewID: newId,
        statusCategoryOld: oldCategory,
        statusCategoryNew: newCategory
    });
};

});
parcelRegister("lO4Or", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $4eac1b8021be0c88$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $4eac1b8021be0c88$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $4eac1b8021be0c88$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $4eac1b8021be0c88$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $4eac1b8021be0c88$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $4eac1b8021be0c88$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $4eac1b8021be0c88$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $4eac1b8021be0c88$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $4eac1b8021be0c88$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $4eac1b8021be0c88$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $4eac1b8021be0c88$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $4eac1b8021be0c88$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $4eac1b8021be0c88$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $4eac1b8021be0c88$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $4eac1b8021be0c88$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $4eac1b8021be0c88$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $4eac1b8021be0c88$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $4eac1b8021be0c88$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $4eac1b8021be0c88$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $4eac1b8021be0c88$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $4eac1b8021be0c88$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $4eac1b8021be0c88$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $4eac1b8021be0c88$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $4eac1b8021be0c88$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $4eac1b8021be0c88$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $4eac1b8021be0c88$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $4eac1b8021be0c88$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $4eac1b8021be0c88$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $4eac1b8021be0c88$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $4eac1b8021be0c88$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $4eac1b8021be0c88$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $4eac1b8021be0c88$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $4eac1b8021be0c88$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $4eac1b8021be0c88$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $4eac1b8021be0c88$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $4eac1b8021be0c88$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $4eac1b8021be0c88$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $4eac1b8021be0c88$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $4eac1b8021be0c88$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $4eac1b8021be0c88$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $4eac1b8021be0c88$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $4eac1b8021be0c88$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $4eac1b8021be0c88$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $4eac1b8021be0c88$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $4eac1b8021be0c88$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $4eac1b8021be0c88$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $4eac1b8021be0c88$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $4eac1b8021be0c88$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $4eac1b8021be0c88$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $4eac1b8021be0c88$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $4eac1b8021be0c88$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $4eac1b8021be0c88$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $4eac1b8021be0c88$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $4eac1b8021be0c88$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $4eac1b8021be0c88$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $4eac1b8021be0c88$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $4eac1b8021be0c88$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $4eac1b8021be0c88$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $4eac1b8021be0c88$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $4eac1b8021be0c88$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $4eac1b8021be0c88$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $4eac1b8021be0c88$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $4eac1b8021be0c88$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $4eac1b8021be0c88$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $4eac1b8021be0c88$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $4eac1b8021be0c88$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $4eac1b8021be0c88$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $4eac1b8021be0c88$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $4eac1b8021be0c88$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $4eac1b8021be0c88$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $4eac1b8021be0c88$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $4eac1b8021be0c88$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $4eac1b8021be0c88$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $4eac1b8021be0c88$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $4eac1b8021be0c88$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $4eac1b8021be0c88$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $4eac1b8021be0c88$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $4eac1b8021be0c88$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $4eac1b8021be0c88$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $4eac1b8021be0c88$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $4eac1b8021be0c88$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $4eac1b8021be0c88$export$798d2f5814884447);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $4eac1b8021be0c88$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $4eac1b8021be0c88$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $4eac1b8021be0c88$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $4eac1b8021be0c88$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $4eac1b8021be0c88$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $4eac1b8021be0c88$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $4eac1b8021be0c88$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $4eac1b8021be0c88$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $4eac1b8021be0c88$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $4eac1b8021be0c88$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $4eac1b8021be0c88$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $4eac1b8021be0c88$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $4eac1b8021be0c88$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $4eac1b8021be0c88$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $4eac1b8021be0c88$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $4eac1b8021be0c88$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $4eac1b8021be0c88$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $4eac1b8021be0c88$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $4eac1b8021be0c88$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $4eac1b8021be0c88$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $4eac1b8021be0c88$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $4eac1b8021be0c88$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $4eac1b8021be0c88$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $4eac1b8021be0c88$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $4eac1b8021be0c88$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $4eac1b8021be0c88$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $4eac1b8021be0c88$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $4eac1b8021be0c88$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $4eac1b8021be0c88$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $4eac1b8021be0c88$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $4eac1b8021be0c88$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $4eac1b8021be0c88$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $4eac1b8021be0c88$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $4eac1b8021be0c88$export$34317c2d84a93553);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $4eac1b8021be0c88$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $4eac1b8021be0c88$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $4eac1b8021be0c88$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $4eac1b8021be0c88$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $4eac1b8021be0c88$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $4eac1b8021be0c88$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $4eac1b8021be0c88$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $4eac1b8021be0c88$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $4eac1b8021be0c88$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $4eac1b8021be0c88$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $4eac1b8021be0c88$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $4eac1b8021be0c88$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $4eac1b8021be0c88$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $4eac1b8021be0c88$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $4eac1b8021be0c88$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $4eac1b8021be0c88$export$2d75b47d12efc812);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $4eac1b8021be0c88$export$7b79405842547ccb);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $4eac1b8021be0c88$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $4eac1b8021be0c88$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $4eac1b8021be0c88$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $4eac1b8021be0c88$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $4eac1b8021be0c88$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $4eac1b8021be0c88$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $4eac1b8021be0c88$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $4eac1b8021be0c88$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $4eac1b8021be0c88$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $4eac1b8021be0c88$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $4eac1b8021be0c88$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $4eac1b8021be0c88$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $4eac1b8021be0c88$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $4eac1b8021be0c88$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $4eac1b8021be0c88$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $4eac1b8021be0c88$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $4eac1b8021be0c88$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $4eac1b8021be0c88$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $4eac1b8021be0c88$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $4eac1b8021be0c88$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $4eac1b8021be0c88$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $4eac1b8021be0c88$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $4eac1b8021be0c88$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $4eac1b8021be0c88$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $4eac1b8021be0c88$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $4eac1b8021be0c88$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $4eac1b8021be0c88$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $4eac1b8021be0c88$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $4eac1b8021be0c88$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $4eac1b8021be0c88$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $4eac1b8021be0c88$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $4eac1b8021be0c88$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $4eac1b8021be0c88$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $4eac1b8021be0c88$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $4eac1b8021be0c88$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $4eac1b8021be0c88$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $4eac1b8021be0c88$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $4eac1b8021be0c88$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $4eac1b8021be0c88$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $4eac1b8021be0c88$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $4eac1b8021be0c88$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $4eac1b8021be0c88$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $4eac1b8021be0c88$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $4eac1b8021be0c88$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $4eac1b8021be0c88$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $4eac1b8021be0c88$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $4eac1b8021be0c88$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $4eac1b8021be0c88$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $4eac1b8021be0c88$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $4eac1b8021be0c88$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "CONFERENCE_CALL_TYPE", () => $4eac1b8021be0c88$export$f7dcde9e9e88aff2);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $4eac1b8021be0c88$export$b5358afda8ff335e);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $4eac1b8021be0c88$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $4eac1b8021be0c88$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $4eac1b8021be0c88$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $4eac1b8021be0c88$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $4eac1b8021be0c88$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $4eac1b8021be0c88$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $4eac1b8021be0c88$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $4eac1b8021be0c88$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $4eac1b8021be0c88$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $4eac1b8021be0c88$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $4eac1b8021be0c88$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $4eac1b8021be0c88$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $4eac1b8021be0c88$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $4eac1b8021be0c88$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $4eac1b8021be0c88$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $4eac1b8021be0c88$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $4eac1b8021be0c88$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $4eac1b8021be0c88$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $4eac1b8021be0c88$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $4eac1b8021be0c88$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $4eac1b8021be0c88$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $4eac1b8021be0c88$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $4eac1b8021be0c88$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $4eac1b8021be0c88$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $4eac1b8021be0c88$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $4eac1b8021be0c88$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $4eac1b8021be0c88$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $4eac1b8021be0c88$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $4eac1b8021be0c88$export$3c3e26aadbfa2c32);

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");
const $4eac1b8021be0c88$export$b144116dae474c88 = 'issue-link-search';
const $4eac1b8021be0c88$export$bc917bc699b25f75 = 'number';
const $4eac1b8021be0c88$export$5f26ca419fdffbe7 = 'string';
const $4eac1b8021be0c88$export$ce9bfd823c7e1a6d = 'datetime';
const $4eac1b8021be0c88$export$346b72b1f7cd6d5a = 'date';
const $4eac1b8021be0c88$export$b20fbcacd7942c2a = 'option2';
const $4eac1b8021be0c88$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $4eac1b8021be0c88$export$a2e8554bffc61ece = 'any';
const $4eac1b8021be0c88$export$f25cd4907cbb25b9 = 'array';
const $4eac1b8021be0c88$export$5600354b43577e17 = 'user';
const $4eac1b8021be0c88$export$5dbc9917f72d0d2a = 'group';
const $4eac1b8021be0c88$export$253649f07fb55948 = 'object';
const $4eac1b8021be0c88$export$eb39592ba5247ee7 = 'group-list';
const $4eac1b8021be0c88$export$f48a9be226105736 = 'array-string';
const $4eac1b8021be0c88$export$42e2e93fc721df5d = 'version';
const $4eac1b8021be0c88$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $4eac1b8021be0c88$export$7773375e72c953ed = 'approval-panel';
const $4eac1b8021be0c88$export$80ad0037098f3919 = 'project';
const $4eac1b8021be0c88$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $4eac1b8021be0c88$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $4eac1b8021be0c88$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $4eac1b8021be0c88$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $4eac1b8021be0c88$export$c979d9c548c05133 = 'JiraBooleanField';
const $4eac1b8021be0c88$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $4eac1b8021be0c88$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $4eac1b8021be0c88$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $4eac1b8021be0c88$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $4eac1b8021be0c88$export$b0deb225eed90fbd = 'JiraCMDBField';
const $4eac1b8021be0c88$export$add3775cfea8fde3 = 'JiraColorField';
const $4eac1b8021be0c88$export$9631d4098abab3eb = 'JiraComponentsField';
const $4eac1b8021be0c88$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $4eac1b8021be0c88$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $4eac1b8021be0c88$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $4eac1b8021be0c88$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $4eac1b8021be0c88$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $4eac1b8021be0c88$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $4eac1b8021be0c88$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $4eac1b8021be0c88$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $4eac1b8021be0c88$export$6d8da4497234455 = 'JiraEpicLinkField';
const $4eac1b8021be0c88$export$9bcfac568e4fa59c = 'JiraFlagField';
const $4eac1b8021be0c88$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $4eac1b8021be0c88$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $4eac1b8021be0c88$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $4eac1b8021be0c88$export$810709f0c5c2e9db = 'JiraLabelsField';
const $4eac1b8021be0c88$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $4eac1b8021be0c88$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $4eac1b8021be0c88$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $4eac1b8021be0c88$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $4eac1b8021be0c88$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $4eac1b8021be0c88$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $4eac1b8021be0c88$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $4eac1b8021be0c88$export$31aea7548807c6b5 = 'JiraPeopleField';
const $4eac1b8021be0c88$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $4eac1b8021be0c88$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $4eac1b8021be0c88$export$12f54499c6252188 = 'JiraProjectField';
const $4eac1b8021be0c88$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $4eac1b8021be0c88$export$c69486dd643dfb69 = 'JiraReporterField';
const $4eac1b8021be0c88$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $4eac1b8021be0c88$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $4eac1b8021be0c88$export$37f4daaa7b409554 = 'JiraRichTextField';
const $4eac1b8021be0c88$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $4eac1b8021be0c88$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $4eac1b8021be0c88$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $4eac1b8021be0c88$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $4eac1b8021be0c88$export$e40f819979b3881d = 'JiraStatusField';
const $4eac1b8021be0c88$export$6c243704a22baffe = 'JiraTeamField';
const $4eac1b8021be0c88$export$6c32429bac235203 = 'JiraTeamViewField';
const $4eac1b8021be0c88$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $4eac1b8021be0c88$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $4eac1b8021be0c88$export$37ccd11f08a93ccb = 'JiraUrlField';
const $4eac1b8021be0c88$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $4eac1b8021be0c88$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $4eac1b8021be0c88$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $4eac1b8021be0c88$export$aa815aaa741ae18 = 'JiraWatchesField';
const $4eac1b8021be0c88$export$e805f89b15d2abf4 = 'JiraAssetField';
const $4eac1b8021be0c88$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $4eac1b8021be0c88$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $4eac1b8021be0c88$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $4eac1b8021be0c88$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $4eac1b8021be0c88$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $4eac1b8021be0c88$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $4eac1b8021be0c88$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $4eac1b8021be0c88$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $4eac1b8021be0c88$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $4eac1b8021be0c88$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $4eac1b8021be0c88$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $4eac1b8021be0c88$export$c48132adab502d6b = 'JiraForgeUsersField';
const $4eac1b8021be0c88$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $4eac1b8021be0c88$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $4eac1b8021be0c88$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $4eac1b8021be0c88$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $4eac1b8021be0c88$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $4eac1b8021be0c88$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $4eac1b8021be0c88$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $4eac1b8021be0c88$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $4eac1b8021be0c88$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $4eac1b8021be0c88$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $4eac1b8021be0c88$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $4eac1b8021be0c88$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $4eac1b8021be0c88$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $4eac1b8021be0c88$export$bfcb1a91094f113a = 'JiraGoalsField';
const $4eac1b8021be0c88$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $4eac1b8021be0c88$export$798d2f5814884447 = 'forgeCustomField';
const $4eac1b8021be0c88$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $4eac1b8021be0c88$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $4eac1b8021be0c88$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $4eac1b8021be0c88$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $4eac1b8021be0c88$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $4eac1b8021be0c88$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $4eac1b8021be0c88$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $4eac1b8021be0c88$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $4eac1b8021be0c88$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $4eac1b8021be0c88$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $4eac1b8021be0c88$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $4eac1b8021be0c88$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $4eac1b8021be0c88$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $4eac1b8021be0c88$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $4eac1b8021be0c88$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $4eac1b8021be0c88$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $4eac1b8021be0c88$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $4eac1b8021be0c88$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $4eac1b8021be0c88$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $4eac1b8021be0c88$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $4eac1b8021be0c88$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $4eac1b8021be0c88$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $4eac1b8021be0c88$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $4eac1b8021be0c88$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $4eac1b8021be0c88$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $4eac1b8021be0c88$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $4eac1b8021be0c88$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $4eac1b8021be0c88$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $4eac1b8021be0c88$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $4eac1b8021be0c88$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $4eac1b8021be0c88$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $4eac1b8021be0c88$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $4eac1b8021be0c88$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $4eac1b8021be0c88$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $4eac1b8021be0c88$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $4eac1b8021be0c88$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $4eac1b8021be0c88$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $4eac1b8021be0c88$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $4eac1b8021be0c88$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $4eac1b8021be0c88$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $4eac1b8021be0c88$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $4eac1b8021be0c88$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $4eac1b8021be0c88$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $4eac1b8021be0c88$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $4eac1b8021be0c88$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $4eac1b8021be0c88$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $4eac1b8021be0c88$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $4eac1b8021be0c88$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $4eac1b8021be0c88$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $4eac1b8021be0c88$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $4eac1b8021be0c88$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $4eac1b8021be0c88$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $4eac1b8021be0c88$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $4eac1b8021be0c88$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $4eac1b8021be0c88$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $4eac1b8021be0c88$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $4eac1b8021be0c88$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $4eac1b8021be0c88$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $4eac1b8021be0c88$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $4eac1b8021be0c88$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $4eac1b8021be0c88$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $4eac1b8021be0c88$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $4eac1b8021be0c88$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $4eac1b8021be0c88$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $4eac1b8021be0c88$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $4eac1b8021be0c88$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $4eac1b8021be0c88$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $4eac1b8021be0c88$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $4eac1b8021be0c88$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $4eac1b8021be0c88$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $4eac1b8021be0c88$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $4eac1b8021be0c88$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $4eac1b8021be0c88$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $4eac1b8021be0c88$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $4eac1b8021be0c88$export$fba8634fd401ba8b = 'assignee';
const $4eac1b8021be0c88$export$a91aea2438afcce8 = 'reporter';
const $4eac1b8021be0c88$export$b159f8b8f27aae4c = 'duedate';
const $4eac1b8021be0c88$export$34740f8d07d23ac0 = 'priority';
const $4eac1b8021be0c88$export$43b6e33ec70f2272 = 'labels';
const $4eac1b8021be0c88$export$ff39ebd4bb12b718 = 'created';
const $4eac1b8021be0c88$export$cd8e68094cb5c3cb = 'updated';
const $4eac1b8021be0c88$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $4eac1b8021be0c88$export$37abf56f13f61ec5 = 'components';
const $4eac1b8021be0c88$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $4eac1b8021be0c88$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $4eac1b8021be0c88$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $4eac1b8021be0c88$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $4eac1b8021be0c88$export$791007408faf42f4 = 'servicedesk-incident-management';
const $4eac1b8021be0c88$export$827a1c600bac12a3 = 'devSummary';
const $4eac1b8021be0c88$export$e9ba671d077969f8 = 'releases';
const $4eac1b8021be0c88$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $4eac1b8021be0c88$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $4eac1b8021be0c88$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $4eac1b8021be0c88$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $4eac1b8021be0c88$export$a5c9f63aadcb220 = 'fixVersions';
const $4eac1b8021be0c88$export$94009605902e4fe5 = 'versions';
const $4eac1b8021be0c88$export$5e7324042f1d6b31 = 'description';
const $4eac1b8021be0c88$export$113281d03e6830ef = 'environment';
const $4eac1b8021be0c88$export$5ff798870a3dffbf = 'watches';
const $4eac1b8021be0c88$export$907219511d14ba3d = 'summary';
const $4eac1b8021be0c88$export$d09aa6a4f3538063 = 'proforma-forms';
const $4eac1b8021be0c88$export$3aca8c91b58a42e2 = 'resolution';
const $4eac1b8021be0c88$export$ccb5ffefbf8b987c = 'timetracking';
const $4eac1b8021be0c88$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $4eac1b8021be0c88$export$358267065be1e = 'status';
const $4eac1b8021be0c88$export$dcaa788c7ada56de = 'statusCategory';
const $4eac1b8021be0c88$export$ebb48b08205007c5 = 'issuetype';
const $4eac1b8021be0c88$export$5e91047fe9955d0e = 'issuekey';
const $4eac1b8021be0c88$export$3b3d0889022c85b3 = 'children-issues';
const $4eac1b8021be0c88$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $4eac1b8021be0c88$export$8fe3d5be8cb17459 = 'epic-issues';
const $4eac1b8021be0c88$export$335851d83a79891 = 'hierarchy-level-below';
const $4eac1b8021be0c88$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $4eac1b8021be0c88$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $4eac1b8021be0c88$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $4eac1b8021be0c88$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $4eac1b8021be0c88$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $4eac1b8021be0c88$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $4eac1b8021be0c88$export$7b3d247435a784fa = 'SLA_PANEL';
const $4eac1b8021be0c88$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $4eac1b8021be0c88$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $4eac1b8021be0c88$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $4eac1b8021be0c88$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $4eac1b8021be0c88$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $4eac1b8021be0c88$export$f7dcde9e9e88aff2 = 'CONFERENCE_CALL';
const $4eac1b8021be0c88$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $4eac1b8021be0c88$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $4eac1b8021be0c88$export$22f61ccc2730431f = 'similar-issues';
const $4eac1b8021be0c88$export$8bbb446f57294715 = 'subtasks';
const $4eac1b8021be0c88$export$34fcd7cb291a1e4d = 'votes';
const $4eac1b8021be0c88$export$5e93f2a57cc4ca3a = 'parent';
const $4eac1b8021be0c88$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $4eac1b8021be0c88$export$91a9dba2d38d9a6f = 'project';
const $4eac1b8021be0c88$export$df36fc05622c402 = 'worklog';
const $4eac1b8021be0c88$export$ede0a4c20124ec85 = 'timespent';
const $4eac1b8021be0c88$export$3eeb79d48fb5f667 = 'dataclassification';
const $4eac1b8021be0c88$export$45e72c9a63ab61ab = 'SENTIMENT';
const $4eac1b8021be0c88$export$99ad62164189f781 = 'ecosystemGlance';
const $4eac1b8021be0c88$export$7719ef6e9283671 = 'forgeGlance';
const $4eac1b8021be0c88$export$bfebea5ce2e1887a = 'ecosystemContext';
const $4eac1b8021be0c88$export$be8e68fb1aed253e = 'forgeContext';
const $4eac1b8021be0c88$export$84e5674890d55030 = 'issuerestriction';
const $4eac1b8021be0c88$export$326a5522a485e43d = 'security';
const $4eac1b8021be0c88$export$c9f3f01e2c535302 = 'securitylevel';
const $4eac1b8021be0c88$export$35e5652f764785bd = 'creator';
const $4eac1b8021be0c88$export$66519f3bbff1796a = 'team';
const $4eac1b8021be0c88$export$a4ee0bca77cc8463 = 'estimate';
const $4eac1b8021be0c88$export$fed53408e89e0497 = 'dueDate';
const $4eac1b8021be0c88$export$d53c26f9ce31f56b = 'targetStart';
const $4eac1b8021be0c88$export$48f82d653f85e459 = 'targetEnd';
const $4eac1b8021be0c88$export$ea5a888f39f722c7 = 'startDate';
const $4eac1b8021be0c88$export$f245bbec12cc0e40 = 'color';
const $4eac1b8021be0c88$export$aed630b4b7114a59 = 'attachment';
const $4eac1b8021be0c88$export$b50c1a8fef07104 = 'issuelinks';
const $4eac1b8021be0c88$export$ea3d72f4bb7738ba = 'timeestimate';
const $4eac1b8021be0c88$export$a4cab0124760d860 = 'comment';
const $4eac1b8021be0c88$export$734929aef118d7e2 = 'worklog';
const $4eac1b8021be0c88$export$ffbacacb07c1d46d = 'parent';
const $4eac1b8021be0c88$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $4eac1b8021be0c88$export$278c072e2f9176ab = 'aggregatetimespent';
const $4eac1b8021be0c88$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $4eac1b8021be0c88$export$fbc5ebe2e580bf8b = 'progress';
const $4eac1b8021be0c88$export$aa3b37e271efd578 = 'aggregateprogress';
const $4eac1b8021be0c88$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $4eac1b8021be0c88$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $4eac1b8021be0c88$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $4eac1b8021be0c88$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $4eac1b8021be0c88$export$34740f8d07d23ac0,
        REPORTER_TYPE: $4eac1b8021be0c88$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $4eac1b8021be0c88$export$5e7324042f1d6b31,
        LABELS_TYPE: $4eac1b8021be0c88$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $4eac1b8021be0c88$export$37abf56f13f61ec5,
        SPRINT_TYPE: $4eac1b8021be0c88$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $4eac1b8021be0c88$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $4eac1b8021be0c88$export$269d70c1b1c9fb80,
        EPIC_TYPE: $4eac1b8021be0c88$export$9f2fedcd916d2a79,
        FIX_VERSIONS_TYPE: $4eac1b8021be0c88$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $4eac1b8021be0c88$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $4eac1b8021be0c88$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $4eac1b8021be0c88$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $4eac1b8021be0c88$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $4eac1b8021be0c88$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $4eac1b8021be0c88$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $4eac1b8021be0c88$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $4eac1b8021be0c88$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $4eac1b8021be0c88$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $4eac1b8021be0c88$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $4eac1b8021be0c88$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $4eac1b8021be0c88$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $4eac1b8021be0c88$export$c7ae0622b0bd5d56,
        CONFERENCE_CALL_TYPE: $4eac1b8021be0c88$export$f7dcde9e9e88aff2,
        ASSETS_CF_TYPE: $4eac1b8021be0c88$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $4eac1b8021be0c88$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $4eac1b8021be0c88$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $4eac1b8021be0c88$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $4eac1b8021be0c88$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $4eac1b8021be0c88$export$e9ba671d077969f8,
        PARENT_CF_TYPE: $4eac1b8021be0c88$export$3e71e11f80203acb,
        BASELINE_START_CF_TYPE: $4eac1b8021be0c88$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $4eac1b8021be0c88$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $4eac1b8021be0c88$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $4eac1b8021be0c88$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $4eac1b8021be0c88$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $4eac1b8021be0c88$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $4eac1b8021be0c88$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $4eac1b8021be0c88$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $4eac1b8021be0c88$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $4eac1b8021be0c88$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $4eac1b8021be0c88$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $4eac1b8021be0c88$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $4eac1b8021be0c88$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $4eac1b8021be0c88$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $4eac1b8021be0c88$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $4eac1b8021be0c88$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $4eac1b8021be0c88$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $4eac1b8021be0c88$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $4eac1b8021be0c88$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $4eac1b8021be0c88$export$39866626496bbfc8,
        VERSION_CF_TYPE: $4eac1b8021be0c88$export$24382b4e8c58336b,
        DATE_CF_TYPE: $4eac1b8021be0c88$export$ff745f432984005d,
        GROUP_CF_TYPE: $4eac1b8021be0c88$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $4eac1b8021be0c88$export$b600addfa3355c57,
        USER_CF_TYPE: $4eac1b8021be0c88$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $4eac1b8021be0c88$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $4eac1b8021be0c88$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $4eac1b8021be0c88$export$65524be5675e57e6,
        TEAM_CF_TYPE: $4eac1b8021be0c88$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $4eac1b8021be0c88$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $4eac1b8021be0c88$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $4eac1b8021be0c88$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $4eac1b8021be0c88$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $4eac1b8021be0c88$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $4eac1b8021be0c88$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $4eac1b8021be0c88$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $4eac1b8021be0c88$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $4eac1b8021be0c88$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $4eac1b8021be0c88$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $4eac1b8021be0c88$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $4eac1b8021be0c88$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $4eac1b8021be0c88$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $4eac1b8021be0c88$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $4eac1b8021be0c88$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $4eac1b8021be0c88$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $4eac1b8021be0c88$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $4eac1b8021be0c88$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $4eac1b8021be0c88$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $4eac1b8021be0c88$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $4eac1b8021be0c88$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $4eac1b8021be0c88$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $4eac1b8021be0c88$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $4eac1b8021be0c88$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $4eac1b8021be0c88$export$2bbb7f69c97ea279
    };
    Object.assign(types, {
        FORGE_CONTEXT_TYPE: $4eac1b8021be0c88$export$be8e68fb1aed253e
    });
    if ((0, $1ybV0.ff)('parent-field-in-issue-view_x4zn4')) Object.assign(types, {
        PARENT_TYPE: $4eac1b8021be0c88$export$5e93f2a57cc4ca3a
    });
    if ((0, $eI5EY.fg)('jsm-sentiment-analysis')) Object.assign(types, {
        SENTIMENT_TYPE: $4eac1b8021be0c88$export$45e72c9a63ab61ab
    });
    if ((0, $1ybV0.ff)('sentiment-custom-field')) Object.assign(types, {
        SENTIMENT_CF_TYPE: $4eac1b8021be0c88$export$c23cfbdf83daa90d
    });
    return types;
};
const $4eac1b8021be0c88$export$3c3e26aadbfa2c32 = (0, $5iWql.default)($4eac1b8021be0c88$var$getLayoutFieldTypesNonMemoized);

});

parcelRegister("bfutc", function(module, exports) {

$parcel$export(module.exports, "putFieldValue$", () => $326b0ad1b536efb9$export$1e79252a3a0c4801);

var $aiRd8 = parcelRequire("aiRd8");
const $326b0ad1b536efb9$var$getUpdateFieldValueUrl = (issueKey)=>`/rest/api/2/issue/${issueKey}`;
const $326b0ad1b536efb9$export$1e79252a3a0c4801 = (issueKey, newFieldValues)=>(0, $aiRd8.default)($326b0ad1b536efb9$var$getUpdateFieldValueUrl(issueKey), {
        method: 'PUT',
        body: JSON.stringify({
            fields: newFieldValues
        })
    });

});


parcelRegister("7hM0m", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3951e612821c61c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a3951e612821c61c$var$preventKeyDownProp = (inEditState)=>(e)=>{
        if (inEditState || e.key === 'Enter') e.stopPropagation();
    };
const $a3951e612821c61c$var$PreventKeyboardPropWrapper = ({ children: children, inEditState: inEditState })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        onKeyDown: $a3951e612821c61c$var$preventKeyDownProp(inEditState),
        role: "presentation"
    }, children);
var $a3951e612821c61c$export$2e2bcd8739ae039 = $a3951e612821c61c$var$PreventKeyboardPropWrapper;

});

parcelRegister("5KGFD", function(module, exports) {

$parcel$export(module.exports, "getCurrentAssignee", () => $aca3c0385eef2628$export$7ff716f0bdf4c335);

var $2OdyW = parcelRequire("2OdyW");
const $aca3c0385eef2628$var$getCurrentAssigneeUrl = (issueKey)=>`/rest/api/3/issue/${issueKey}?fields=assignee`;
const $aca3c0385eef2628$export$7ff716f0bdf4c335 = (issueKey)=>(0, $2OdyW.default)($aca3c0385eef2628$var$getCurrentAssigneeUrl(issueKey), {
        method: 'GET'
    });

});


parcelRegister("8z6xl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dafbcfe1f1c520f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $g8JvH = parcelRequire("g8JvH");

var $2NwGr = parcelRequire("2NwGr");

var $lB25E = parcelRequire("lB25E");

var $7HSCV = parcelRequire("7HSCV");

var $egLZi = parcelRequire("egLZi");

var $5xHW3 = parcelRequire("5xHW3");
const $3dafbcfe1f1c520f$var$SingleUserSelectWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('issueField', {
    onEditSuccess: 'updated'
})((0, $5xHW3.default));
const $3dafbcfe1f1c520f$var$SingleUserSelect = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.RouterActions), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3dafbcfe1f1c520f$var$SingleUserSelectWithAnalytics, {
            UserSelect: (0, $egLZi.default),
            ProfileCard: (0, $2NwGr.AsyncProfileCardNext),
            AssigneeButton: (0, $7HSCV.default),
            onPushAction: push,
            ...props
        }));
var $3dafbcfe1f1c520f$export$2e2bcd8739ae039 = $3dafbcfe1f1c520f$var$SingleUserSelect;

});
parcelRegister("2NwGr", function(module, exports) {

$parcel$export(module.exports, "AsyncProfileCardNext", () => $d91bacdeb64d663f$export$a3c0845f856d4292);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $1lXFP = parcelRequire("1lXFP");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d91bacdeb64d663f$var$LazyComponent = (0, $7rh0R.lazy)(()=>(parcelRequire("aWDkE")).then((module)=>module.ProfileCard), {
    moduleId: "./src/packages/profilecard-next/src/main.tsx"
});
const $d91bacdeb64d663f$export$a3c0845f856d4292 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "AsyncProfileCardNext",
        packageName: "jiraProfilecardNext",
        render: ()=>// props.children in this context is the code being wrapped
            // in a <ProfileCardTrigger> (I.e. it is the thing a user hovers over to
            // display a profile card).
            // In the event of an unexpected error within @atlaskit/profilecard,
            // just render the unwrapped children (I.e. they will render but nothing
            // happens on hover)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada",
        attributes: (0, $1lXFP.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-profile-card-next-view",
        fallback: props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d91bacdeb64d663f$var$LazyComponent, props)));
var $d91bacdeb64d663f$export$2e2bcd8739ae039 = $d91bacdeb64d663f$export$a3c0845f856d4292;

});
parcelRegister("1lXFP", function(module, exports) {

$parcel$export(module.exports, "isLoaderErrorAttributes", () => $1c31f74fac112a78$export$c7209ce2e0d060ea);

var $7rh0R = parcelRequire("7rh0R");
const $1c31f74fac112a78$export$c7209ce2e0d060ea = (error)=>({
        isLoaderError: (0, $7rh0R.isLoaderError)(error)
    });

});

parcelRegister("aWDkE", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("keVAk")
]).then(()=>parcelRequire('12NzK'));

});


parcelRegister("7HSCV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bfc9834c58e6f71$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $bJgd9 = parcelRequire("bJgd9");
var $5bfc9834c58e6f71$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $bJgd9.default));

});
parcelRegister("bJgd9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a6c0f909a751a37$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $jG2Eu = parcelRequire("jG2Eu");

var $iJlfe = parcelRequire("iJlfe");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $gd0Sp = parcelRequire("gd0Sp");

var $hMRqg = parcelRequire("hMRqg");
const $6a6c0f909a751a37$var$AssigneeButton = ({ isLastColumn: isLastColumn, assignee: assignee, intl: intl, overrideDisabledAppearance: overrideDisabledAppearance, accountId: accountId, ProfileCard: ProfileCard, ...rest })=>{
    const [isHover, setIsHover] = (0, $eUqFw.useState)(false);
    const setIsHoverToTrue = ()=>setIsHover(true);
    const setIsHoverToFalse = ()=>setIsHover(false);
    const assigneeName = assignee ? assignee.displayName || assignee.emailAddress : intl.formatMessage((0, $hMRqg.default).unassigned);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6a6c0f909a751a37$var$wrapperBaseStyles,
        paddingInlineEnd: isLastColumn ? 'space.100' : 'space.0',
        onMouseEnter: setIsHoverToTrue,
        onMouseLeave: setIsHoverToFalse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6a6c0f909a751a37$export$2d5d2ba3c7c8c40b, {
        ...rest,
        isHovered: isHover,
        "aria-label": `${assigneeName} - edit Assignee`
    }, accountId && ProfileCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProfileCard, {
        accountId: accountId,
        TenantContextSubscriber: (0, $gd0Sp.TenantContextSubscriber),
        actions: [
            (0, $2f37035f7aaf1787$export$23cedd3261bd8015),
            (0, $2f37035f7aaf1787$export$6bef782d14a92db8)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        src: assignee && assignee.avatarUrl,
        size: "small",
        borderColor: "transparent",
        isDisabled: !overrideDisabledAppearance && rest.isButtonDisabled
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        src: assignee && assignee.avatarUrl,
        size: "small",
        borderColor: "transparent",
        isDisabled: !overrideDisabledAppearance && rest.isButtonDisabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6a6c0f909a751a37$var$Text, null, assigneeName)));
};
$6a6c0f909a751a37$var$AssigneeButton.defaultProps = {
    isLastColumn: false,
    isButtonDisabled: false,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    overrideDisabledAppearance: false
};
var $6a6c0f909a751a37$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $6a6c0f909a751a37$var$AssigneeButton;
const $6a6c0f909a751a37$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isButtonDisabled: isButtonDisabled, isHovered: isHovered, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ei78nn": (0, $9t7rW.default)({
                cursor: 'default'
            })
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _19itidpf _2rko1l7b _1yt4otz2 _1bsb1osq _4t3ixy5q _1reo15vq _syaz1kw7 _1wyb1oud _12ji1r31 _1qu2glyw _12y31o36",
            !__cmplp.isButtonDisabled && __cmplp.isHovered ? "_bfhkyucn" : "_bfhk18uv",
            __cmplp.isButtonDisabled ? "_80ommkww" : "_80omtlke",
            __cmplp.className
        ])
    });
});
const $6a6c0f909a751a37$var$wrapperBaseStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.050',
    paddingRight: 'space.0',
    paddingBottom: 'space.050',
    paddingLeft: 'space.0',
    display: 'flex',
    textAlign: 'left'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a6c0f909a751a37$var$Text = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _vwz419ii _19bvu2gc _1reo15vq _1bto1l2s _o5721q9c _y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
// values which are passed into the tracking callback by atlaskit
const $2f37035f7aaf1787$export$febebefae5a09065 = 'profile-card.loaded';
const $2f37035f7aaf1787$export$3ca1936ee743bd18 = 'profile-card.view';
const $2f37035f7aaf1787$export$25bd35f2cd9ae0ea = 'profile-card.reload';
const $2f37035f7aaf1787$export$86aa8b9c379ebbbd = 'profile-card.error';
const $2f37035f7aaf1787$export$4442e31da6ba4127 = 'profile-card.click';
const $2f37035f7aaf1787$export$7ecd9c56ca354ac0 = 'profileCardNext';
const $2f37035f7aaf1787$export$81319ffa9c0d18d7 = 'profileCardNext';
const $2f37035f7aaf1787$export$3145fc6c544ad7bf = 'profileCardNextLegacy';
const $2f37035f7aaf1787$export$50632e21ea714398 = 'profileCardNextLegacy';
const $2f37035f7aaf1787$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $2f37035f7aaf1787$export$2549357601611c61 = 'loadError';
const $2f37035f7aaf1787$export$23cedd3261bd8015 = 'viewProfile';
const $2f37035f7aaf1787$export$6bef782d14a92db8 = 'assignedIssues';
const $2f37035f7aaf1787$export$6b36f20db7a18a86 = 'reportedIssues';
const $2f37035f7aaf1787$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("hMRqg", function(module, exports) {

$parcel$export(module.exports, "default", () => $69b123db669c6f08$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $69b123db669c6f08$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    assignToMe: {
        "id": "issue-table.common.fields.assignee.single-user-select.user-select.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    unassigned: {
        "id": "issue-table.common.fields.assignee.single-user-select.user-select.unassigned",
        "defaultMessage": "Unassigned"
    },
    automatic: {
        "id": "issue-table.common.fields.assignee.single-user-select.user-select.automatic",
        "defaultMessage": "Automatic"
    },
    invitePeopleOption: {
        "id": "issue-table.common.fields.assignee.single-user-select.user-select.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-table.common.fields.assignee.single-user-select.user-select.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});



parcelRegister("egLZi", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e72bf114f6925d$export$2e2bcd8739ae039);

var $e91YZ = parcelRequire("e91YZ");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $gjOW8 = parcelRequire("gjOW8");

var $b5o6E = parcelRequire("b5o6E");

var $6Bf44 = parcelRequire("6Bf44");

var $8FR9B = parcelRequire("8FR9B");

var $1Rt1q = parcelRequire("1Rt1q");

var $wom1o = parcelRequire("wom1o");

var $d6RYS = parcelRequire("d6RYS");

var $j0UlN = parcelRequire("j0UlN");
const $a5e72bf114f6925d$var$mapStateToProps = (state)=>({
        avatarUrl: (0, $6Bf44.getAvatarUrl)(state),
        atlassianAccountId: (0, $8FR9B.getAtlassianAccountId)(state),
        displayName: (0, $6Bf44.getDisplayName)(state),
        emailAddress: (0, $6Bf44.getEmailAddress)(state),
        AsyncUserPicker: $d6RYS.default,
        onSearchUser: $wom1o.default,
        isAdmin: (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)().isAdmin
    });
var // @ts-expect-error - Parameter 'ownProps' implicitly has an 'any' type.
$a5e72bf114f6925d$export$2e2bcd8739ae039 = (0, $1Rt1q.connect)($a5e72bf114f6925d$var$mapStateToProps, (dispatch, ownProps)=>({
        // @ts-expect-error - TS7006 - Parameter 'issueKey' implicitly has an 'any' type. | TS7006 - Parameter 'fieldId' implicitly has an 'any' type. | TS7006 - Parameter 'fieldValue' implicitly has an 'any' type.
        onChange: (issueKey, fieldId, fieldValue)=>{
            ownProps.onSubmit(fieldValue);
            return dispatch((0, $gjOW8.submitFieldUpdateAction)(issueKey, fieldId, fieldValue, ownProps.onEditSuccess, ownProps.onEditFailure));
        },
        onComponentLoadFailure: ()=>{
            ownProps.onComponentLoadFailure && ownProps.onComponentLoadFailure();
            dispatch((0, $b5o6E.disableUserPickerAction)());
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-table.view.fields.common.single-user-select.user-select', '[FD-4424] Async user select failed to load');
            (0, $guiFP.default)({
                meta: {
                    id: 'asyncUserSelectLoadFailure',
                    packageName: 'jiraIssueTable',
                    teamName: 'jsd-shield'
                }
            });
        }
    }))((0, $j0UlN.default));

});
parcelRegister("6Bf44", function(module, exports) {

$parcel$export(module.exports, "getAvatarUrl", () => $25439d8149469178$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "getDisplayName", () => $25439d8149469178$export$be63e0664592e141);
$parcel$export(module.exports, "getEmailAddress", () => $25439d8149469178$export$ec5591214e33605f);

var $9jIiv = parcelRequire("9jIiv");
const $25439d8149469178$var$getAssigneeInitialization = (state)=>(0, $9jIiv.getFieldInitialization)(state).assignee;
const $25439d8149469178$export$b4f8f1f54acec99b = (state)=>{
    const assignee = $25439d8149469178$var$getAssigneeInitialization(state);
    return assignee ? assignee.avatarUrl : undefined;
};
const $25439d8149469178$export$be63e0664592e141 = (state)=>{
    const assignee = $25439d8149469178$var$getAssigneeInitialization(state);
    return assignee ? assignee.displayName : undefined;
};
const $25439d8149469178$export$ec5591214e33605f = (state)=>{
    const assignee = $25439d8149469178$var$getAssigneeInitialization(state);
    return assignee ? assignee.emailAddress : undefined;
};

});

parcelRegister("8FR9B", function(module, exports) {

$parcel$export(module.exports, "getAtlassianAccountId", () => $4c4396b3f9a0e9b1$export$f5baf4f0aaa47428);

var $9jIiv = parcelRequire("9jIiv");
const $4c4396b3f9a0e9b1$export$f5baf4f0aaa47428 = (state)=>(0, $9jIiv.getInitialAppProps)(state).atlassianAccountId;
const $4c4396b3f9a0e9b1$export$fdd2c0ba94025c3c = (state)=>(0, $9jIiv.getInitialAppProps)(state).cloudId;
const $4c4396b3f9a0e9b1$export$505ebc60b5fc3b2e = (state)=>(0, $9jIiv.getInitialAppProps)(state).fabricPfDirUrl;

});

parcelRegister("wom1o", function(module, exports) {

$parcel$export(module.exports, "default", () => $76e0beb11686ee48$export$2e2bcd8739ae039);


var $gUZKm = parcelRequire("gUZKm");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$76e0beb11686ee48$export$2e2bcd8739ae039 = (issueKey, query, fieldContext)=>{
    if (fieldContext === (0, $460498cb425cec7f$export$17e03e15c8be5abe)) return (0, $gUZKm.default)(issueKey, query ?? '');
    throw new Error('Not implemented');
};

});
const $460498cb425cec7f$export$17e03e15c8be5abe = 'ASSIGNEE';
const $460498cb425cec7f$export$9c542858adf7dcd0 = 'DEFAULT';

parcelRegister("gUZKm", function(module, exports) {

$parcel$export(module.exports, "default", () => $5012169dc8ae67d0$export$2e2bcd8739ae039);

var $fZlY1 = parcelRequire("fZlY1");
const $5012169dc8ae67d0$var$transformResponse = (response)=>response.map((userResponse)=>({
            id: userResponse.accountId,
            avatarUrl: userResponse.avatarUrls['48x48'],
            name: userResponse.displayName,
            byline: userResponse.emailAddress,
            value: {
                accountId: userResponse.accountId,
                avatarUrl: userResponse.avatarUrls['48x48'],
                displayName: userResponse.displayName,
                emailAddress: userResponse.emailAddress
            }
        }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5012169dc8ae67d0$export$2e2bcd8739ae039 = (issueKey, query)=>(0, $fZlY1.default)(issueKey, query).then((response)=>new Promise((resolve)=>{
            resolve($5012169dc8ae67d0$var$transformResponse(response));
        }));

});
parcelRegister("fZlY1", function(module, exports) {

$parcel$export(module.exports, "default", () => $738a267fbfb17c4c$export$2e2bcd8739ae039);

var $2OdyW = parcelRequire("2OdyW");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$738a267fbfb17c4c$export$2e2bcd8739ae039 = (issueKey, query)=>(0, $2OdyW.default)(`/rest/api/latest/user/assignable/search?issueKey=${issueKey}&query=${query}`, {
        method: 'GET'
    });

});



parcelRegister("d6RYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $184e661757f1c57d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $4Bees = parcelRequire("4Bees");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $184e661757f1c57d$var$LazyUserPicker = (0, $7rh0R.lazy)(()=>(parcelRequire("gOxhT")), {
    moduleId: "../platform/packages/elements/user-picker/src/index.ts"
});
const $184e661757f1c57d$export$2e2bcd8739ae039 = (props)=>{
    const { onError: onError, ...userPickerProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-issue-table-user-picker",
        packageName: "jiraIssueTable",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "user-picker",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($184e661757f1c57d$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "small"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($184e661757f1c57d$var$UserPickerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($184e661757f1c57d$var$LazyUserPicker, userPickerProps))));
};
const $184e661757f1c57d$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _kqswh2mm _154i12x7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $184e661757f1c57d$var$UserPickerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1q5411p5 _16vph2mm _14od1wug _1etn1wug _1ospglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gOxhT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("ioBKv")
]).then(()=>parcelRequire('9OIPy'));

});


parcelRegister("j0UlN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6d385f22809a4b1$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/react-arrow-function-property-naming */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2jDha = parcelRequire("2jDha");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $giAhk = parcelRequire("giAhk");

var $hiBi9 = parcelRequire("hiBi9");

var $jMP2a = parcelRequire("jMP2a");


var $4B6vS = parcelRequire("4B6vS");


var $hMRqg = parcelRequire("hMRqg");
const $c6d385f22809a4b1$var$getInviteFromAssignCohort = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('invite.from.assign', 'not-enrolled', [
        'control',
        'not-enrolled',
        'variation'
    ]);
const $c6d385f22809a4b1$var$isInviteFromAssignEnabled = ()=>$c6d385f22809a4b1$var$getInviteFromAssignCohort() === 'variation';
const $c6d385f22809a4b1$var$toUserForEditing = (value)=>{
    if (!value) return undefined;
    return {
        id: value.accountId,
        name: value.displayName || value.emailAddress || '',
        avatarUrl: value.avatarUrl,
        value: value
    };
};
const $c6d385f22809a4b1$var$fireInviteFromAssignExposureEvent = (createAnalyticsEvent, fieldId, suggestionsCount, isAdmin)=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'exposed';
    const actionSubject = 'feature';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const attrs = {
        fieldId: fieldId,
        flagKey: 'invite.from.assign',
        value: $c6d385f22809a4b1$var$getInviteFromAssignCohort(),
        userRole: isAdmin ? 'admin' : 'basic',
        suggestionsCount: suggestionsCount,
        source: 'assigneeField'
    };
    (0, $jMP2a.fireOperationalAnalytics)(event, `${actionSubject} ${action}`, attrs);
};
const $c6d385f22809a4b1$var$fireInviteItemRendererEvent = (createAnalyticsEvent, fieldId, suggestionsCount, isAdmin)=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'rendered';
    const actionSubject = 'inviteItem';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const attrs = {
        fieldId: fieldId,
        userRole: isAdmin ? 'admin' : 'basic',
        suggestionsCount: suggestionsCount,
        source: 'assigneeField'
    };
    (0, $jMP2a.fireUIAnalytics)(event, `${actionSubject} ${action}`, attrs);
}; // eslint-disable-next-line jira/react/no-class-components
class $c6d385f22809a4b1$export$fc39e35a5100d3e8 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isAdmin: false,
            enablePeopleInvite: true
        };
    }
    loadAssignToMeUser() {
        const { value: value, avatarUrl: avatarUrl, atlassianAccountId: atlassianAccountId, emailAddress: emailAddress, displayName: displayName, intl: intl } = this.props;
        if (value && value.accountId === atlassianAccountId) return undefined;
        if (!emailAddress && !avatarUrl && !displayName) {
            (0, $gUUjF.default).safeWarnWithoutCustomerData('issue-table.view.fields.common.single-user-select.user-select', 'Assign-to-me not initialized in time', {});
            return undefined;
        }
        const assignToMeUser = {
            id: (0, $d9944846fce8542d$export$34c10ac17efea7b3),
            name: intl.formatMessage((0, $hMRqg.default).assignToMe),
            avatarUrl: avatarUrl,
            value: {
                emailAddress: emailAddress,
                accountId: atlassianAccountId,
                avatarUrl: avatarUrl,
                displayName: displayName
            }
        };
        return assignToMeUser;
    }
    loadUnassignedUser() {
        const { value: value, intl: intl } = this.props; // While the 'Unassigned' option is defined as value being undefined, the value can briefly have a displayName
        // of "Unassigned" when selected from the user-picker, before the issue-table polls again. To avoid this, added
        // a check of accountId as the 'Unassigned' option does not have an accountId.
        if (!value || !value.accountId) return undefined;
        const unassignedUser = {
            id: (0, $d9944846fce8542d$export$bdab9bfb39981463),
            name: intl.formatMessage((0, $hMRqg.default).unassigned)
        };
        return unassignedUser;
    }
    loadAutomaticUser() {
        const { value: value, intl: intl } = this.props;
        if (value && value.accountId === (0, $d9944846fce8542d$export$f42e6736d1a95712)) return undefined;
        const automaticUser = {
            id: (0, $d9944846fce8542d$export$f5d5f6bb902f1027),
            name: intl.formatMessage((0, $hMRqg.default).automatic),
            value: {
                accountId: (0, $d9944846fce8542d$export$f42e6736d1a95712),
                displayName: intl.formatMessage((0, $hMRqg.default).automatic),
                avatarUrl: '',
                emailAddress: ''
            }
        };
        return automaticUser;
    }
    getInvitePeopleOption() {
        const { intl: intl, isAdmin: isAdmin } = this.props;
        return {
            id: (0, $d9944846fce8542d$export$d875316cb0cd94f7),
            avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($4B6vS))),
            name: intl.formatMessage(isAdmin ? (0, $hMRqg.default).invitePeopleOptionAdmin : (0, $hMRqg.default).invitePeopleOption)
        };
    }
    render() {
        const { width: width, value: value, AsyncUserPicker: AsyncUserPicker, onComponentLoadFailure: onComponentLoadFailure, rowListRef: rowListRef, fieldId: fieldId, isSaving: isSaving, onSetEditingRef: onSetEditingRef } = this.props;
        const isOpen = this.state.isOpen && !isSaving; // onSetEditingRef is used to set ref of current container such that
        // UserPicker options list can render with the correct X/Y offset.
        // This is required in react-redux v8 upgrade because ref is not set properly.
        // https://hello.atlassian.net/wiki/spaces/JFP/pages/3593342635/Rollout+Strategy+For+React-Redux+V8#JSM-assignee-bug
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c6d385f22809a4b1$var$Container // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        , {
            "data-testid": "issue-table.view.fields.common.single-user-select.user-select",
            ref: onSetEditingRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AsyncUserPicker, {
            open: isOpen,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            loadOptions: this.loadUsers,
            width: width,
            value: $c6d385f22809a4b1$var$toUserForEditing(value),
            onChange: this.onChange,
            onError: onComponentLoadFailure,
            isClearable: false,
            menuMinWidth: (0, $d9944846fce8542d$export$eef3ca04e2ec81e0),
            menuPortalTarget: rowListRef,
            onSelection: this.onSelection,
            fieldId: fieldId
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: true
        };
        this.invitePeopleExposedEventFired = false;
        this.onChange = (item)=>{
            const { onChange: onChange, issueKey: issueKey, fieldId: fieldId, fieldType: fieldType, intl: intl, enablePeopleInvite: enablePeopleInvite } = this.props;
            if (!$c6d385f22809a4b1$var$isInviteFromAssignEnabled() || enablePeopleInvite !== true || item.id !== (0, $d9944846fce8542d$export$d875316cb0cd94f7)) {
                if (item.value) onChange(issueKey, fieldId, {
                    ...item.value,
                    fieldType: fieldType
                });
                else onChange(issueKey, fieldId, {
                    displayName: intl.formatMessage((0, $hMRqg.default).unassigned),
                    fieldType: fieldType
                });
            }
        };
        this.onBlur = ()=>{
            this.setState({
                isOpen: false
            });
            this.props.onEditCancel();
        };
        this.onFocus = ()=>{
            this.setState({
                isOpen: true
            });
        };
        this.onSelection = (item)=>{
            const { onEditSelection: onEditSelection, createAnalyticsEvent: createAnalyticsEvent, enablePeopleInvite: enablePeopleInvite } = this.props;
            if ($c6d385f22809a4b1$var$isInviteFromAssignEnabled() && enablePeopleInvite === true && item.id === (0, $d9944846fce8542d$export$d875316cb0cd94f7)) (0, $hiBi9.triggerOpenDrawer)(createAnalyticsEvent ?? null, {
                inviteFlow: 'assignee'
            });
            else onEditSelection();
        };
        this.loadUsers = (query)=>{
            const { issueKey: issueKey, onSearchUser: onSearchUser, enablePeopleInvite: enablePeopleInvite, createAnalyticsEvent: createAnalyticsEvent, isAdmin: isAdmin, fieldId: fieldId } = this.props;
            const searchPromise = onSearchUser(issueKey, query, (0, $460498cb425cec7f$export$17e03e15c8be5abe)).then((users)=>{
                if (enablePeopleInvite === true && query !== undefined && query !== '' && users.length < 3) {
                    if (!this.invitePeopleExposedEventFired) {
                        this.invitePeopleExposedEventFired = true;
                        $c6d385f22809a4b1$var$fireInviteFromAssignExposureEvent(createAnalyticsEvent, fieldId, users.length, isAdmin);
                    }
                    if ($c6d385f22809a4b1$var$isInviteFromAssignEnabled()) {
                        $c6d385f22809a4b1$var$fireInviteItemRendererEvent(createAnalyticsEvent, fieldId, users.length, isAdmin);
                        return [
                            ...users,
                            this.getInvitePeopleOption()
                        ];
                    }
                }
                return users;
            });
            const options = [];
            const assignToMeUser = this.loadAssignToMeUser();
            if (assignToMeUser) options.push(assignToMeUser);
            const unassignedUser = this.loadUnassignedUser();
            if (unassignedUser) options.push(unassignedUser);
            const automaticUser = this.loadAutomaticUser();
            if (automaticUser) options.push(automaticUser);
            options.push(searchPromise);
            return options;
        };
    }
}
var $c6d385f22809a4b1$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $2jDha.default)()((0, $giAhk.injectIntlV2)($c6d385f22809a4b1$export$fc39e35a5100d3e8));
const $c6d385f22809a4b1$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1ltvr5cr",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hiBi9", function(module, exports) {

$parcel$export(module.exports, "shouldDisplayModal", () => $df085b8c8c8c9e63$export$32eec1126fb86cc9);
$parcel$export(module.exports, "useInvitePeopleDrawer", () => $df085b8c8c8c9e63$export$48fb2d80745c5e67);
$parcel$export(module.exports, "triggerOpenDrawer", () => $df085b8c8c8c9e63$export$b7dab610045052db);

var $1Iui1 = parcelRequire("1Iui1");

var $WBLbN = parcelRequire("WBLbN");

var $cQrkf = parcelRequire("cQrkf");
const $df085b8c8c8c9e63$var$CONTROLLER_NAME = 'invite-people-drawer';
const $df085b8c8c8c9e63$var$initialState = {
    isOpen: false,
    inviteFlow: 'unknown',
    continueUrl: undefined
};
const $df085b8c8c8c9e63$export$1dbc37ce23aead84 = ({ inviteFromAssignModalCohort: inviteFromAssignModalCohort })=>{
    let resolvedCohort = {
        cohort: '',
        ineligibilityReasons: [
            ''
        ]
    };
    if (inviteFromAssignModalCohort === (0, $1Iui1.NOT_ENROLLED)) resolvedCohort = {
        cohort: (0, $1Iui1.NOT_ENROLLED),
        ineligibilityReasons: []
    };
    if (inviteFromAssignModalCohort === (0, $1Iui1.CONTROL)) resolvedCohort = {
        cohort: (0, $1Iui1.CONTROL),
        ineligibilityReasons: []
    };
    if (inviteFromAssignModalCohort === (0, $1Iui1.VARIATION)) resolvedCohort = {
        cohort: (0, $1Iui1.VARIATION),
        ineligibilityReasons: []
    };
    return resolvedCohort;
};
const $df085b8c8c8c9e63$export$32eec1126fb86cc9 = (inviteAssignModelContext)=>{
    if ($df085b8c8c8c9e63$export$1dbc37ce23aead84(inviteAssignModelContext).cohort === (0, $1Iui1.VARIATION)) return true;
    return false;
};
const $df085b8c8c8c9e63$var$Store = (0, $WBLbN.createStore)({
    name: $df085b8c8c8c9e63$var$CONTROLLER_NAME,
    initialState: $df085b8c8c8c9e63$var$initialState,
    actions: {
        openDrawer: (createAnalyticsEvent, { inviteFlow: inviteFlow, analyticsSource: analyticsSource, continueUrl: continueUrl }, inviteAssignModelContext, invitePromptOnLinkInsertContext)=>({ setState: setState })=>{
                const displayModal = inviteAssignModelContext && $df085b8c8c8c9e63$export$32eec1126fb86cc9(inviteAssignModelContext);
                let processedInviteAssignModalContext;
                if (inviteAssignModelContext) {
                    processedInviteAssignModalContext = {
                        ...inviteAssignModelContext
                    };
                    const { cohort: resultCohort, ineligibilityReasons: ineligibilityReasons } = $df085b8c8c8c9e63$export$1dbc37ce23aead84(inviteAssignModelContext);
                    (0, $cQrkf.fireAddTeammatetoJiraAnalytics)(createAnalyticsEvent, resultCohort, analyticsSource);
                    (0, $cQrkf.fireInviteFromAssignModalExposedAnalytics)(createAnalyticsEvent, inviteAssignModelContext.inviteFromAssignModalCohort, resultCohort, ineligibilityReasons, analyticsSource);
                    processedInviteAssignModalContext.inviteFromAssignModalCohort = resultCohort;
                }
                if (displayModal) (0, $cQrkf.fireModalTriggeredAnalytics)(createAnalyticsEvent, inviteFlow, inviteAssignModelContext, analyticsSource);
                else (0, $cQrkf.fireDrawerTriggeredAnalytics)(createAnalyticsEvent, inviteFlow, analyticsSource);
                setState({
                    isOpen: true,
                    inviteFlow: inviteFlow,
                    continueUrl: continueUrl,
                    inviteAssignModelContext: processedInviteAssignModalContext,
                    invitePromptOnLinkInsertContext: invitePromptOnLinkInsertContext
                });
            },
        closeDrawer: ()=>({ setState: setState })=>setState($df085b8c8c8c9e63$var$initialState)
    }
});
const $df085b8c8c8c9e63$export$48fb2d80745c5e67 = (0, $WBLbN.createHook)($df085b8c8c8c9e63$var$Store);
const $df085b8c8c8c9e63$export$ac7fed664b4735b5 = (0, $WBLbN.createContainer)($df085b8c8c8c9e63$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen })=>{
            setState({
                isOpen: isOpen
            });
        }
});
const $df085b8c8c8c9e63$export$4358742cbaf4a6d4 = (0, $WBLbN.createSubscriber)($df085b8c8c8c9e63$var$Store, {
    displayName: 'InvitePeopleDrawerSubscriber',
    selector: (state)=>state.isOpen
});
const $df085b8c8c8c9e63$export$b7dab610045052db = (createAnalyticsEvent, contextConfig, inviteAssignModelContext)=>{
    (0, $WBLbN.defaultRegistry).getStore($df085b8c8c8c9e63$var$Store)?.actions.openDrawer(createAnalyticsEvent, contextConfig, inviteAssignModelContext);
};

});
parcelRegister("1Iui1", function(module, exports) {

$parcel$export(module.exports, "COHORT", () => $1524157debf2fd00$export$3d370c33621572df);
$parcel$export(module.exports, "NOT_ENROLLED", () => $1524157debf2fd00$export$5b7423264d48ab04);
$parcel$export(module.exports, "CONTROL", () => $1524157debf2fd00$export$43f367b3e957f219);
$parcel$export(module.exports, "EXPERIMENT", () => $1524157debf2fd00$export$9ba2bc3b1bdc1519);
$parcel$export(module.exports, "VARIATION", () => $1524157debf2fd00$export$fa04ad826acc90da);

var $1ybV0 = parcelRequire("1ybV0");
const $1524157debf2fd00$export$3d370c33621572df = 'cohort';
const $1524157debf2fd00$export$5b7423264d48ab04 = 'not-enrolled';
const $1524157debf2fd00$export$43f367b3e957f219 = 'control';
const $1524157debf2fd00$export$9ba2bc3b1bdc1519 = 'experiment';
const $1524157debf2fd00$export$fa04ad826acc90da = 'variation';
const $1524157debf2fd00$export$6486974e39493fa6 = 'variation-1';
const $1524157debf2fd00$export$7d994996134ad562 = 'variation-2';
const $1524157debf2fd00$export$795e7d69b248dcd0 = 'variation-3';
const $1524157debf2fd00$export$c9c947c57470b787 = 'variation-4';
const $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $1524157debf2fd00$export$5b7423264d48ab04,
    $1524157debf2fd00$export$43f367b3e957f219,
    $1524157debf2fd00$export$9ba2bc3b1bdc1519,
    $1524157debf2fd00$export$fa04ad826acc90da,
    $1524157debf2fd00$export$6486974e39493fa6,
    $1524157debf2fd00$export$7d994996134ad562,
    $1524157debf2fd00$export$795e7d69b248dcd0,
    $1524157debf2fd00$export$c9c947c57470b787
];
var // Use optionalValidExperimentGroups to further restrict the list of cohorts
// eslint-disable-next-line jira/import/no-anonymous-default-export
$1524157debf2fd00$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $1ybV0.getMultivariateFeatureFlag)(experimentFeatureFlag, $1524157debf2fd00$export$5b7423264d48ab04, validExperimentGroups);

});

parcelRegister("cQrkf", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProvider", () => $de9a0e3d07ee4b39$export$1b581a2ec13e37f1);
$parcel$export(module.exports, "fireDrawerTriggeredAnalytics", () => $de9a0e3d07ee4b39$export$2e49c23c45194e1a);
$parcel$export(module.exports, "fireModalTriggeredAnalytics", () => $de9a0e3d07ee4b39$export$6815765da918b983);
$parcel$export(module.exports, "fireInviteFromAssignModalExposedAnalytics", () => $de9a0e3d07ee4b39$export$9a32ecb3d5c4df6b);
$parcel$export(module.exports, "fireAddTeammatetoJiraAnalytics", () => $de9a0e3d07ee4b39$export$21b810258e82d438);

var $eUqFw = parcelRequire("eUqFw");

var $jYVKV = parcelRequire("jYVKV");

var $1Iui1 = parcelRequire("1Iui1");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $iKlrz = parcelRequire("iKlrz");

var $3FyZ4 = parcelRequire("3FyZ4");

var $9QFxq = parcelRequire("9QFxq");
const $de9a0e3d07ee4b39$var$getInviteFromAssignCohort = ()=>(0, $1ybV0.getFeatureFlagValue)('invite.from.assign', (0, $1Iui1.NOT_ENROLLED));
const $de9a0e3d07ee4b39$var$useAnalyticsClient = ()=>{
    const analyticsWebClientRef = (0, $eUqFw.useRef)((0, $3FyZ4.getAnalyticsWebClientPromise)());
    return {
        sendEvent: (analyticsEvent)=>{
            analyticsWebClientRef.current.then((webClient)=>webClient.sendEvent((0, $iKlrz.getEvent)(analyticsEvent)));
        }
    };
};
const $de9a0e3d07ee4b39$export$1b581a2ec13e37f1 = ({ children: children })=>{
    const { sendEvent: sendEvent } = $de9a0e3d07ee4b39$var$useAnalyticsClient();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
        channel: "peopleAndTeams",
        onEvent: sendEvent
    }, children);
};
const $de9a0e3d07ee4b39$var$sendAnalyticsClientUIEvent = async (createAnalyticsEvent, analyticsPayload)=>{
    if (createAnalyticsEvent) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), // @ts-expect-error Argument of type '[string, string, Attributes | undefined]' is not assignable to parameter of type 'RestArguments'.
    `${analyticsPayload.actionSubject} ${analyticsPayload.action}`, analyticsPayload?.actionSubjectId || '', analyticsPayload.attributes);
    else {
        const webAnalyticsClient = await (0, $3FyZ4.getAnalyticsWebClientPromise)();
        const analyticsClient = webAnalyticsClient.getInstance();
        // SSR doesn't have an analytics client
        if (analyticsClient) analyticsClient.sendUIEvent(analyticsPayload);
    }
};
const $de9a0e3d07ee4b39$export$2e49c23c45194e1a = async (createAnalyticsEvent, inviteFlow, source)=>{
    const analyticsPayload = {
        action: 'triggered',
        actionSubject: 'drawer',
        actionSubjectId: 'invitePeopleDrawer',
        attributes: {
            source: (0, $9QFxq.getSourceByInviteFlow)(inviteFlow),
            inviteFromAssignCohort: $de9a0e3d07ee4b39$var$getInviteFromAssignCohort()
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    $de9a0e3d07ee4b39$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};
const $de9a0e3d07ee4b39$export$6815765da918b983 = async (createAnalyticsEvent, inviteFlow, inviteAssignModelContext, source)=>{
    const analyticsPayload = {
        action: 'triggered',
        actionSubject: 'modal',
        actionSubjectId: 'invitePeopleModal',
        attributes: {
            source: (0, $9QFxq.getSourceByInviteFlow)(inviteFlow),
            inviteFromAssignCohort: $de9a0e3d07ee4b39$var$getInviteFromAssignCohort(),
            inviteFromAssignModalCohort: inviteAssignModelContext.inviteFromAssignModalCohort
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    $de9a0e3d07ee4b39$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};
const $de9a0e3d07ee4b39$export$9a32ecb3d5c4df6b = async (createAnalyticsEvent, inviteFromAssignModalCohort, resultCohort, ineligibilityReasons, source)=>{
    const analyticsPayload = {
        action: 'exposed',
        actionSubject: 'feature',
        product: 'jira',
        attributes: {
            flagKey: 'invite.from.assign.modal',
            value: inviteFromAssignModalCohort,
            cohort: resultCohort,
            growthInitiative: 'virality',
            ineligibilityReasons: ineligibilityReasons
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    if (createAnalyticsEvent) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${analyticsPayload.actionSubject} ${analyticsPayload.action}`, analyticsPayload.attributes);
    else {
        const webAnalyticsClient = await (0, $3FyZ4.getAnalyticsWebClientPromise)();
        const analyticsClient = webAnalyticsClient.getInstance();
        // SSR doesn't have an analytics client
        if (analyticsClient) analyticsClient.sendTrackEvent(analyticsPayload);
    }
};
const $de9a0e3d07ee4b39$export$21b810258e82d438 = async (createAnalyticsEvent, resultCohort, source)=>{
    const analyticsPayload = {
        action: 'clicked',
        actionSubject: 'addTeammatetoJira',
        product: 'jira',
        attributes: {
            inviteFromAssignModalCohort: resultCohort
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    $de9a0e3d07ee4b39$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};

});
parcelRegister("9QFxq", function(module, exports) {

$parcel$export(module.exports, "getSourceByInviteFlow", () => $2b0bde6b83f84248$export$c35cd18e9d0123e3);
const $2b0bde6b83f84248$export$c35cd18e9d0123e3 = (inviteFlow)=>{
    let source = inviteFlow;
    if (inviteFlow === 'mention') source = 'mentionInEditor';
    else if (inviteFlow === 'assignee') source = 'assigneeField';
    return source;
};

});



parcelRegister("4B6vS", function(module, exports) {
module.exports = new URL("add.6dea82c4.png", import.meta.url).toString();

});

const $d9944846fce8542d$export$eef3ca04e2ec81e0 = 300;
const $d9944846fce8542d$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $d9944846fce8542d$export$bdab9bfb39981463 = 'unassigned';
const $d9944846fce8542d$export$34c10ac17efea7b3 = 'assignToMe';
const $d9944846fce8542d$export$f5d5f6bb902f1027 = 'automatic';
const $d9944846fce8542d$export$f42e6736d1a95712 = '-1';



parcelRegister("5xHW3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c89b69dabef70081$export$2e2bcd8739ae039);
/* eslint-disable react/no-find-dom-node */ 
var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $7u4fN = parcelRequire("7u4fN");

var $giAhk = parcelRequire("giAhk");


var $gd0Sp = parcelRequire("gd0Sp");

var $jU4ta = parcelRequire("jU4ta");
// eslint-disable-next-line jira/react/no-class-components
class $c89b69dabef70081$var$SingleUserSelect extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isEditable: true
        };
    }
    constructor(props){
        super(props);
        this.onEditStart = ()=>{
            const { onEditStart: onEditStart } = this.props;
            onEditStart && onEditStart();
        };
        this.onEditCancel = ()=>{
            const { onEditCancel: onEditCancel } = this.props;
            onEditCancel && onEditCancel();
        };
        this.onSubmit = (fieldValue)=>{
            const { onSubmit: onSubmit, value: value } = this.props;
            const isValueUnchanged = value == null && fieldValue == null || value && fieldValue && value.accountId === fieldValue.accountId;
            if (isValueUnchanged) return;
            onSubmit && onSubmit(fieldValue);
        };
        this.onSuccess = (fieldValue)=>{
            const { onEditSuccess: onEditSuccess } = this.props;
            onEditSuccess && onEditSuccess(fieldValue);
        };
        this.onFailure = ()=>{
            const { onEditFailure: onEditFailure } = this.props;
            onEditFailure && onEditFailure();
        };
        this.onMouseEnter = ()=>{
            if (this.node) {
                if (this.state.fieldVerticalOffset !== this.node.offsetTop || this.state.fieldHorizontalOffset !== this.node.offsetLeft) this.setState({
                    fieldVerticalOffset: this.node.offsetTop,
                    fieldHorizontalOffset: this.node.offsetLeft
                });
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onSetRef = (ref)=>{
            if (ref && ref instanceof HTMLElement) {
                this.node = ref;
                if ((this.state.fieldVerticalOffset !== ref.offsetTop || this.state.fieldHorizontalOffset !== ref.offsetLeft) && ref.offsetParent instanceof HTMLElement) this.setState({
                    fieldVerticalOffset: ref.offsetTop,
                    fieldHorizontalOffset: ref.offsetLeft
                });
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onSetEditingRef = (ref)=>{
            // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'ReactInstance | null | undefined'.
            const node = (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).findDOMNode(ref);
            if (ref && node instanceof HTMLElement) {
                this.editingNode = node;
                const { onSetEditingFieldPosition: onSetEditingFieldPosition } = this.props;
                const { fieldHorizontalOffset: fieldHorizontalOffset, fieldVerticalOffset: fieldVerticalOffset } = this.state;
                this.setState({
                    fieldHorizontalOffset: fieldHorizontalOffset,
                    fieldVerticalOffset: fieldVerticalOffset
                });
                if (node.offsetParent instanceof HTMLElement) onSetEditingFieldPosition(fieldHorizontalOffset, fieldVerticalOffset, node.offsetWidth, node.offsetParent.offsetWidth, node.offsetParent.offsetHeight);
            }
        };
        this.renderAssigneeButton = ()=>{
            const { value: value, AssigneeButton: AssigneeButton, isUserPickerDisabled: isUserPickerDisabled, isLastColumn: isLastColumn, isEditable: isEditable, overrideDisabledAppearance: overrideDisabledAppearance } = this.props;
            const isButtonDisabled = !isEditable || isUserPickerDisabled;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AssigneeButton, {
                assignee: value,
                isButtonDisabled: isButtonDisabled,
                overrideDisabledAppearance: overrideDisabledAppearance,
                onClick: !isButtonDisabled ? this.onEditStart : undefined,
                onMouseEnter: this.onMouseEnter,
                isLastColumn: isLastColumn
            });
        };
        this.state = {
            fieldVerticalOffset: 0,
            fieldHorizontalOffset: 0
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.width !== this.props.width && this.props.isFieldLocked && this.editingNode && this.editingNode.offsetParent instanceof HTMLElement) this.props.onSetEditingFieldPosition(this.editingNode.offsetLeft, this.editingNode.offsetTop, this.editingNode.offsetWidth, this.editingNode.offsetParent.offsetWidth, this.editingNode.offsetParent.offsetHeight);
    }
    componentWillUnmount() {
        this.node = null;
    }
    renderFullLengthAvatar() {
        const { isEditable: isEditable, issueKey: issueKey, width: width, isLastColumn: isLastColumn, value: value } = this.props;
        let assigneeButtonKey;
        if (value && value.accountId) assigneeButtonKey = `${issueKey}-${isEditable.toString()}-${value.accountId}`;
        else assigneeButtonKey = `${issueKey}-${isEditable.toString()}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jU4ta.SelectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                width: width || 'auto'
            },
            ref: this.onSetRef,
            "data-testid": `issue-table.view.fields.common.single-user-select.${issueKey}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            key: assigneeButtonKey,
            component: this.renderAssigneeButton
        })));
    }
    renderWithProfileCard(element) {
        if (!this.props.value) return null;
        const { ProfileCard: ProfileCard } = this.props;
        const { accountId: accountId } = this.props.value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProfileCard, {
            accountId: accountId,
            TenantContextSubscriber: (0, $gd0Sp.TenantContextSubscriber),
            actions: [
                (0, $2f37035f7aaf1787$export$23cedd3261bd8015),
                (0, $2f37035f7aaf1787$export$6bef782d14a92db8)
            ]
        }, element);
    }
    renderUserSelect() {
        const { value: value, width: width, fieldType: fieldType, fieldId: fieldId, issueKey: issueKey, UserSelect: UserSelect, rowListRef: rowListRef, onSetEditingFieldPosition: onSetEditingFieldPosition, onEditSelection: onEditSelection, isSaving: isSaving } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UserSelect, {
            issueKey: issueKey,
            fieldType: fieldType,
            fieldId: fieldId,
            width: width,
            value: value,
            onSubmit: this.onSubmit,
            onEditCancel: this.onEditCancel,
            onEditSuccess: this.onSuccess,
            onEditFailure: this.onFailure,
            onEditSelection: onEditSelection,
            onComponentLoadFailure: this.onEditCancel,
            rowListRef: rowListRef,
            onSetDropdownLocation: onSetEditingFieldPosition,
            ref: this.onSetEditingRef,
            isSaving: isSaving,
            onSetEditingRef: this.onSetEditingRef
        });
    }
    render() {
        const { isFieldLocked: isFieldLocked } = this.props;
        if (isFieldLocked) return this.renderUserSelect();
        const avatarElement = this.renderFullLengthAvatar();
        if (!this.props.value || !this.props.value.accountId) return avatarElement;
        return this.renderWithProfileCard(avatarElement);
    }
}
var // @ts-expect-error - Argument of type 'typeof SingleUserSelect' is not assignable to parameter of type 'ComponentType<WithIntlProvided<{ isSaving: boolean; } & FieldComponentProps<UserFieldType> & { UserSelect: ComponentType<any>; ProfileCard: ComponentType<any>; AssigneeButton: ComponentType<...>; onEditSelection: () => void; }>> & typeof SingleUserSelect'.
$c89b69dabef70081$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($c89b69dabef70081$var$SingleUserSelect);

});
parcelRegister("jU4ta", function(module, exports) {

$parcel$export(module.exports, "COLUMN_GUTTER", () => $428fa98d769293d3$export$515be1884a10d89);
$parcel$export(module.exports, "UnselectableChildGutterPaddingContainer", () => $428fa98d769293d3$export$bc94b44cfbfbe38d);
$parcel$export(module.exports, "SelectableChildGutterPaddingContainer", () => $428fa98d769293d3$export$4845bba6014b7a3e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line import/order

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");
const $428fa98d769293d3$export$515be1884a10d89 = {
    left: (0, $c9TLT.gridSize),
    right: (0, $c9TLT.gridSize) * 3,
    rightLastColumn: (0, $c9TLT.gridSize)
};
const $428fa98d769293d3$var$breakWordStyle = {
    minWidth: '0px',
    overflowWrap: 'break-word'
};
const $428fa98d769293d3$export$bc94b44cfbfbe38d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLastColumn: isLastColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1gg4a5j": (0, $9t7rW.default)(`0px ${__cmplp.isLastColumn ? "var(--ds-space-100, 8px)" : "var(--ds-space-300, 24px)"} 0px ${"var(--ds-space-100, 8px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt44105 _1ul9idpf _1i4q1hna",
            __cmplp.className
        ])
    });
});
const $428fa98d769293d3$export$4845bba6014b7a3e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLastColumn: isLastColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9idpf _1i4q1hna",
            __cmplp.isLastColumn ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : (0, $1ybV0.ff)('jsm-queue-sidebar-bug-fixes-second-round_xuenh') ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_1yt41w1b",
            __cmplp.className
        ])
    });
});

});




parcelRegister("d8iCB", function(module, exports) {

$parcel$export(module.exports, "CmdbObjects", () => $df608ff1d1fe50fd$export$1db90f8a9b594ea2);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $hoasw = parcelRequire("hoasw");

var $lAZNF = parcelRequire("lAZNF");

var $ipKLH = parcelRequire("ipKLH");
const $df608ff1d1fe50fd$export$1db90f8a9b594ea2 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isExpanded, setIsExpanded] = (0, $eUqFw.useState)(false);
    const enrichedObjects = (0, $ipKLH.filterEnrichedObjects)(props.dataSelectorProps.value);
    const [firstObject, ...remainingObjects] = (0, $ipKLH.sortCmdbObjects)(enrichedObjects);
    const handleShowMoreClick = (event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'insightObjectQueuesToggleShowMore', {
            action: isExpanded ? 'hiding' : 'showing'
        });
        setIsExpanded(!isExpanded);
    };
    const renderObject = (object)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df608ff1d1fe50fd$var$SingleObject, {
            key: object.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hoasw.MemoizedInsightIcon), {
            mediaClientConfig: object.avatar.mediaClientConfig,
            size: "xsmall",
            iconUrl: object.avatar.url16,
            label: object.label
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df608ff1d1fe50fd$var$ObjectLabel, null, object.label));
    const hasMoreObjects = remainingObjects.length > 0;
    const showAllObjects = isExpanded && hasMoreObjects;
    if (!firstObject) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df608ff1d1fe50fd$var$EmptyObject, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df608ff1d1fe50fd$var$MessageWrapper, null, formatMessage((0, $lAZNF.default).none)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df608ff1d1fe50fd$var$Wrapper, null, renderObject(firstObject), showAllObjects && remainingObjects.map(renderObject), hasMoreObjects && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: handleShowMoreClick
    }, isExpanded ? formatMessage((0, $lAZNF.default).showLess) : formatMessage((0, $lAZNF.default).showMore, {
        numberOfObjects: remainingObjects.length
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df608ff1d1fe50fd$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80 _1yt41b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df608ff1d1fe50fd$var$SingleObject = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _18s8swc3 _1yt41xzv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df608ff1d1fe50fd$var$ObjectLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66 _11c8qk37",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df608ff1d1fe50fd$var$MessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt412v8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df608ff1d1fe50fd$var$EmptyObject = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _18s8swc3 _1yt41xzv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hoasw", function(module, exports) {

$parcel$export(module.exports, "InsightIcon", () => $92badab1baa94ec2$export$4f72cced31fa9b94);
$parcel$export(module.exports, "MemoizedInsightIcon", () => $92badab1baa94ec2$export$55641517b59933d7);
$parcel$export(module.exports, "UnstyledInsightIcon", () => $92badab1baa94ec2$export$30c7947f25987be2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eri7S = parcelRequire("eri7S");
var $iJlfe = parcelRequire("iJlfe");
var $aWAMO = parcelRequire("aWAMO");

var $b8FLL = parcelRequire("b8FLL");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");
const $92badab1baa94ec2$export$cc575ace31787a4e = (mediaClientConfig)=>Boolean(mediaClientConfig.mediaBaseUrl) && Boolean(mediaClientConfig.mediaJwtToken) && Boolean(mediaClientConfig.issuer) && Boolean(mediaClientConfig.fileId);
const $92badab1baa94ec2$export$d80733771196ad02 = (mediaClientConfig)=>Boolean(mediaClientConfig.mediaBaseUrl) && Boolean(mediaClientConfig.mediaJwtToken) && Boolean(mediaClientConfig.clientId) && Boolean(mediaClientConfig.fileId);
const $92badab1baa94ec2$var$DefaultIcon = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "square",
        size: size,
        name: label
    });
const $92badab1baa94ec2$export$a39db5532f57c7c2 = (clientAuth)=>Promise.resolve({
        clientId: clientAuth.clientId,
        token: clientAuth.mediaJwtToken,
        baseUrl: clientAuth.mediaBaseUrl
    });
const $92badab1baa94ec2$export$a5f760203816608a = (asapAuth)=>Promise.resolve({
        asapIssuer: asapAuth.issuer,
        token: asapAuth.mediaJwtToken,
        baseUrl: asapAuth.mediaBaseUrl
    });
const $92badab1baa94ec2$export$4f72cced31fa9b94 = (props)=>{
    const { iconUrl: iconUrl, size: size, label: label, mediaClientConfig: mediaClientConfig } = props;
    if ((0, $eI5EY.fg)('assets_rearch_media_client_auth')) {
        if (!mediaClientConfig || $92badab1baa94ec2$export$d80733771196ad02(mediaClientConfig) === false) {
            if (iconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                src: iconUrl,
                appearance: "square",
                size: size,
                name: label
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92badab1baa94ec2$var$DefaultIcon, {
                size: size,
                label: label
            });
        }
    } else if (!mediaClientConfig || $92badab1baa94ec2$export$cc575ace31787a4e(mediaClientConfig) === false) {
        if (iconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            src: iconUrl,
            appearance: "square",
            size: size,
            name: label
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92badab1baa94ec2$var$DefaultIcon, {
            size: size,
            label: label
        });
    }
    const fileIdentifier = {
        id: mediaClientConfig.fileId,
        mediaItemType: 'file'
    };
    const imageSize = {
        width: (0, $eri7S.AVATAR_SIZES)[size],
        height: (0, $eri7S.AVATAR_SIZES)[size]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b8FLL.MediaImageWithErrorBoundary), {
        identifier: fileIdentifier,
        mediaClientConfig: {
            authProvider: ()=>(0, $eI5EY.fg)('assets_rearch_media_client_auth') ? $92badab1baa94ec2$export$a39db5532f57c7c2(mediaClientConfig) : $92badab1baa94ec2$export$a5f760203816608a(mediaClientConfig)
        },
        apiConfig: imageSize
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aWAMO.default), {
            appearance: "square",
            size: size
        });
        if (error) {
            (0, $guiFP.default)({
                error: // @ts-expect-error - TS2322 - Type 'true' is not assignable to type 'Error | undefined'.
                error,
                meta: {
                    id: 'insightIcon',
                    packageName: 'jiraServicedeskInsightIcon',
                    teamName: 'falcons'
                }
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92badab1baa94ec2$var$DefaultIcon, {
                size: size,
                label: label
            });
        }
        if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92badab1baa94ec2$var$DefaultIcon, {
            size: size,
            label: label
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            src: data.src,
            appearance: "square",
            size: size,
            name: label
        });
    });
};
const $92badab1baa94ec2$export$55641517b59933d7 = /*#__PURE__*/ (0, $eUqFw.memo)($92badab1baa94ec2$export$4f72cced31fa9b94);
const $92badab1baa94ec2$export$30c7947f25987be2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92badab1baa94ec2$var$UnstyledInsightIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92badab1baa94ec2$export$55641517b59933d7, props));
/**
 * The reason for calling !important on display block is to ovveride the inherited
 * CSS from Avatar atlaskit component in order to centre the icon within the reference
 * object container.
 */ // Double check the shadow !
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $92badab1baa94ec2$var$UnstyledInsightIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81i6y _p7r1tcjq _1ugpglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aWAMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $77d4bbf842392835$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");
function $77d4bbf842392835$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $77d4bbf842392835$var$skeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $eri7S.CSS_VAR_AVATAR_BGCOLOR)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    border: `${(0, $eri7S.BORDER_WIDTH)}px solid transparent`
});
const $77d4bbf842392835$var$sizeStyles = Object.entries((0, $eri7S.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $byn9U.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`
        })
    };
}, {});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $77d4bbf842392835$var$radiusStyles = Object.entries((0, $eri7S.AVATAR_RADIUS)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $byn9U.css)({
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderRadius: `${size}px`
        })
    };
}, {});
const $77d4bbf842392835$var$defaultRadiusStyles = {
    name: "1by8p7f",
    styles: "border-radius:var(--ds-border-radius-circle, 50%)"
};
const $77d4bbf842392835$var$strongOpacityStyles = {
    name: "19sqbed",
    styles: "opacity:0.3"
};
const $77d4bbf842392835$var$defaultOpacityStyles = {
    name: "1rz7oiv",
    styles: "opacity:0.15"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $77d4bbf842392835$var$Skeleton = ({ size: size, appearance: appearance, color: color, weight: weight })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $77d4bbf842392835$var$skeletonStyles,
            $77d4bbf842392835$var$sizeStyles[size ?? 'medium'],
            appearance === 'square' ? $77d4bbf842392835$var$radiusStyles[size ?? 'medium'] : $77d4bbf842392835$var$defaultRadiusStyles,
            weight === 'strong' ? $77d4bbf842392835$var$strongOpacityStyles : $77d4bbf842392835$var$defaultOpacityStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $eri7S.CSS_VAR_AVATAR_BGCOLOR)]: color ?? 'currentColor'
        }
    });
var $77d4bbf842392835$export$2e2bcd8739ae039 = $77d4bbf842392835$var$Skeleton;

});

parcelRegister("b8FLL", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithErrorBoundary", () => $57e59fb61c90cfb2$export$758a2fef95a29ad0);

var $eUqFw = parcelRequire("eUqFw");

var $jb3WS = parcelRequire("jb3WS");

var $3qKWD = parcelRequire("3qKWD");
const $57e59fb61c90cfb2$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jb3WS.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children({
            loading: false,
            error: true
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3qKWD.MediaImageWithMediaClient), props));

});
parcelRegister("jb3WS", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("eUqFw")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("3qKWD", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithMediaClient", () => $bb0b784caf1f45fa$export$8acd7eecc88dfeb5);

var $eUqFw = parcelRequire("eUqFw");

var $mtjJr = parcelRequire("mtjJr");

var $1xvoH = parcelRequire("1xvoH");
const $bb0b784caf1f45fa$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, getSsrScriptProps: getSsrScriptProps } = (0, $1xvoH.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children({
        loading: status === 'loading',
        error: status === 'error',
        data: status === 'succeeded' ? {
            status: status,
            src: preview?.dataURI
        } : undefined
    }), getSsrScriptProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("script", getSsrScriptProps()));
};
const $bb0b784caf1f45fa$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $eUqFw.useMemo)(()=>(0, $mtjJr.withMediaClient)($bb0b784caf1f45fa$var$MediaImageBase), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MediaImageComponent, props);
};

});
parcelRegister("mtjJr", function(module, exports) {

$parcel$export(module.exports, "withMediaClient", () => $9c77d1cdc83d45af$export$9f7977d4a2561bee);

var $eUqFw = parcelRequire("eUqFw");

var $kJ7yF = parcelRequire("kJ7yF");
const $9c77d1cdc83d45af$export$9f7977d4a2561bee = (Component)=>({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJ7yF.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                ...otherProps,
                mediaClient: value
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJ7yF.MediaClientProvider), {
                clientConfig: mediaClientConfig
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJ7yF.MediaClientContext).Consumer, null, (client)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                    ...otherProps,
                    mediaClient: client
                }))));

});
parcelRegister("kJ7yF", function(module, exports) {

$parcel$export(module.exports, "MediaClientContext", () => $2a63c6834b952386$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "getMediaClient", () => $2a63c6834b952386$export$c9ecbc1b719fd417);
$parcel$export(module.exports, "MediaClientProvider", () => $2a63c6834b952386$export$5bff351c86f56d97);
$parcel$export(module.exports, "useMediaClient", () => $2a63c6834b952386$export$8b3e87ea56c3a345);

var $eUqFw = parcelRequire("eUqFw");

var $go0co = parcelRequire("go0co");
const $2a63c6834b952386$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(undefined);
const $2a63c6834b952386$export$f92e83e86b03c398 = new Map();
const $2a63c6834b952386$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $go0co.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $2a63c6834b952386$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $go0co.MediaClient)(mediaClientConfig);
        $2a63c6834b952386$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};
const $2a63c6834b952386$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $eUqFw.useMemo)(()=>$2a63c6834b952386$export$c9ecbc1b719fd417(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a63c6834b952386$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient
    }, children);
};
const $2a63c6834b952386$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($2a63c6834b952386$export$ba5d7212f2b4619f);
    if (!mediaClient) throw new Error('No MediaClient set, use MediaClientProvider to set one');
    return mediaClient;
};

});
parcelRegister("go0co", function(module, exports) {

$parcel$export(module.exports, "MediaClient", () => $53af8e7882f0f992$export$fba8b4ca6d386aec);

var $4FH8r = parcelRequire("4FH8r");
parcelRequire("2q7Xj");
var $fmEc3 = parcelRequire("fmEc3");

var $EEZOU = parcelRequire("EEZOU");

var $3ixzU = parcelRequire("3ixzU");

var $eJAUz = parcelRequire("eJAUz");
parcelRequire("gHZqD");
var $exlxT = parcelRequire("exlxT");

class $53af8e7882f0f992$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $exlxT.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $EEZOU.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: mediaClientConfig.useSha256ForUploads ? (0, $fmEc3.ChunkHashAlgorithm).Sha256 : (0, $fmEc3.ChunkHashAlgorithm).Sha1
        });
        this.config = mediaClientConfig;
        this.file = new (0, $3ixzU.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $4FH8r.EventEmitter2)();
        this.stargate = new (0, $eJAUz.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
	 * @internal
	 */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("6o5wg"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("4FH8r", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $2fFJv !== 'undefined' && $2fFJv.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $2fFJv.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("2q7Xj", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => (parcelRequire("iE8r2")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("jrFS0")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("jrFS0")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("fmEc3")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $iE8r2 = parcelRequire("iE8r2");

var $jrFS0 = parcelRequire("jrFS0");

var $fmEc3 = parcelRequire("fmEc3");

});
parcelRegister("iE8r2", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => $4cdeb32efb36e469$export$8cef61637918b288);

var $4FH8r = parcelRequire("4FH8r");

var $6roQF = parcelRequire("6roQF");
const $4cdeb32efb36e469$export$8cef61637918b288 = {
    streams: new (0, $6roQF.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $4FH8r.EventEmitter2)()
};

});
parcelRegister("6roQF", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("jrFS0", function(module, exports) {

$parcel$export(module.exports, "isClientBasedAuth", () => $a5c9edcfc78df537$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $a5c9edcfc78df537$export$17f6055767a8d96a);
function $a5c9edcfc78df537$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $a5c9edcfc78df537$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $a5c9edcfc78df537$export$17f6055767a8d96a = (auth)=>{
    if ($a5c9edcfc78df537$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("fmEc3", function(module, exports) {

$parcel$export(module.exports, "ChunkHashAlgorithm", () => $2714010903136296$export$d3e73a50cc549c2e);
var $2714010903136296$export$d3e73a50cc549c2e;
(function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha1"] = "sha1";
    ChunkHashAlgorithm["Sha256"] = "sha256";
})($2714010903136296$export$d3e73a50cc549c2e || ($2714010903136296$export$d3e73a50cc549c2e = {}));

});


parcelRegister("EEZOU", function(module, exports) {

$parcel$export(module.exports, "MediaStore", () => $1e7feef2970a1c0d$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $1e7feef2970a1c0d$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $1e7feef2970a1c0d$export$20f9315304dd6726);
parcelRequire("2q7Xj");
var $fmEc3 = parcelRequire("fmEc3");
var $jrFS0 = parcelRequire("jrFS0");

var $5Cq8b = parcelRequire("5Cq8b");

var $aFsdc = parcelRequire("aFsdc");

var $4M5UY = parcelRequire("4M5UY");

var $5AvHR = parcelRequire("5AvHR");

var $2WGjX = parcelRequire("2WGjX");

var $gNTpJ = parcelRequire("gNTpJ");

var $bvZYv = parcelRequire("bvZYv");

var $XHGTv = parcelRequire("XHGTv");

var $6daei = parcelRequire("6daei");
const $1e7feef2970a1c0d$var$MEDIA_API_REGION = 'media-api-region';
const $1e7feef2970a1c0d$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $1e7feef2970a1c0d$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': params?.['max-age'] ?? (0, $aFsdc.FILE_CACHE_MAX_AGE),
        allowAnimated: params?.allowAnimated ?? true,
        mode: params?.mode ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $aFsdc.MAX_RESOLUTION),
            height: (0, $aFsdc.MAX_RESOLUTION)
        } : {}
    };
};
const $1e7feef2970a1c0d$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
class $1e7feef2970a1c0d$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.resolveAuth = (authContext)=>(0, $bvZYv.resolveAuth)(this.config.authProvider, authContext);
        this.resolveInitialAuth = ()=>(0, $bvZYv.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $fmEc3.ChunkHashAlgorithm).Sha1;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const options = {
            params: $1e7feef2970a1c0d$var$extendImageParams(params),
            auth: auth
        };
        const imageEndpoint = !(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery') ? 'image/cdn' : 'image';
        return (0, $gNTpJ.mapToMediaCdnUrl)((0, $2WGjX.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
    }
    async getFileBinary(id, collectionName, maxAge = (0, $aFsdc.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = !(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery') ? 'binary/cdn' : 'binary';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, undefined, true).then((0, $2WGjX.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $aFsdc.FILE_CACHE_MAX_AGE)) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const binaryEndpoint = !(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery') ? 'binary/cdn' : 'binary';
        return (0, $gNTpJ.mapToMediaCdnUrl)((0, $2WGjX.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
    }
    async getArtifactURL(artifacts, artifactName, collectionName) {
        const artifactUrl = (0, $4M5UY.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': (0, $aFsdc.FILE_CACHE_MAX_AGE)
            },
            auth: auth
        };
        return (0, $2WGjX.createUrl)((0, $gNTpJ.mapToMediaCdnUrl)(artifactUrl, auth.token), options);
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = !(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery') ? 'image/cdn' : 'image';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: $1e7feef2970a1c0d$var$extendImageParams(params, fetchMaxRes),
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: (0, $XHGTv.fg)('platform.media-card-performance-observer_a803k') && true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $2WGjX.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, options);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam } = options;
        const auth = await this.resolveAuth(authContext);
        const clientId = (0, $jrFS0.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = traceContext ? {
            ...traceContext,
            spanId: traceContext?.spanId || (0, $5Cq8b.getRandomHex)(8)
        } : undefined;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $gNTpJ.mapToMediaCdnUrl)(url, auth.token);
        const response = await (0, $5AvHR.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: addMediaClientParam ? {
                ...params,
                clientId: clientId
            } : params,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $1e7feef2970a1c0d$var$setKeyValueInSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $1e7feef2970a1c0d$var$setKeyValueInSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $1e7feef2970a1c0d$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $1e7feef2970a1c0d$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $1e7feef2970a1c0d$export$c8b741e18397852a = ()=>{
    return $1e7feef2970a1c0d$var$getValueFromSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_ENVIRONMENT);
};
const $1e7feef2970a1c0d$export$20f9315304dd6726 = ()=>{
    return $1e7feef2970a1c0d$var$getValueFromSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_REGION);
};

});
parcelRegister("5Cq8b", function(module, exports) {

$parcel$export(module.exports, "isUndefined", () => $b1f5fb9992743b46$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $b1f5fb9992743b46$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $b1f5fb9992743b46$export$456b25e3a9b4a843);
const $b1f5fb9992743b46$export$fce6876652108ab = (value)=>value === undefined;
const $b1f5fb9992743b46$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $b1f5fb9992743b46$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $b1f5fb9992743b46$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $b1f5fb9992743b46$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $b1f5fb9992743b46$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $b1f5fb9992743b46$export$456b25e3a9b4a843(byte) {
    let randomHex;
    if (window?.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $b1f5fb9992743b46$var$getRandomHexValues(byte);
    }
    else randomHex = $b1f5fb9992743b46$var$getRandomHexValues(byte);
    return randomHex;
}

});

parcelRegister("aFsdc", function(module, exports) {

$parcel$export(module.exports, "RECENTS_COLLECTION", () => $8452033603633a1a$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $8452033603633a1a$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $8452033603633a1a$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $8452033603633a1a$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $8452033603633a1a$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $8452033603633a1a$export$f14f521f3d306044);

var $bYwuj = parcelRequire("bYwuj");
const $8452033603633a1a$export$860a16125e30000b = 'recents';
const $8452033603633a1a$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $8452033603633a1a$export$6e70f30e392bc53f = 4096;
const $8452033603633a1a$export$c1abb8bab1e615cd = 5 * (0, $bYwuj.DATA_UNIT).MB;
const $8452033603633a1a$export$3d5157f0def70e54 = 1000;
const $8452033603633a1a$export$f14f521f3d306044 = 2 * (0, $bYwuj.DATA_UNIT).TB;

});
parcelRegister("bYwuj", function(module, exports) {

$parcel$export(module.exports, "DATA_UNIT", () => $e9c15b08e9162a33$export$76cfea4c354af843);
const $e9c15b08e9162a33$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
var $e9c15b08e9162a33$export$76cfea4c354af843;
(function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
})($e9c15b08e9162a33$export$76cfea4c354af843 || ($e9c15b08e9162a33$export$76cfea4c354af843 = {}));

});


parcelRegister("4M5UY", function(module, exports) {

$parcel$export(module.exports, "getArtifactUrl", () => $d9f7ddb4d1f162b2$export$1cc24defa44e7f84);

var $XHGTv = parcelRequire("XHGTv");

var $6daei = parcelRequire("6daei");
const $d9f7ddb4d1f162b2$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    if (!(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery')) return `${artifacts[prop]?.url}/cdn`;
    return artifacts[prop]?.url;
};

});
parcelRegister("6daei", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $954ab823235da1ff$export$64d6499adf9b2e51);
const $954ab823235da1ff$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $954ab823235da1ff$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $954ab823235da1ff$var$FEDRAMP_MODERATE;
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});


parcelRegister("5AvHR", function(module, exports) {

$parcel$export(module.exports, "request", () => $4a84a560f69f3535$export$b5fe3f66a567bec0);

var $7aQon = parcelRequire("7aQon");

var $2WGjX = parcelRequire("2WGjX");
async function $4a84a560f69f3535$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $2WGjX.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $2WGjX.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $2WGjX.createProcessFetchResponse)(metadata));
    return (0, $2WGjX.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("7aQon", function(module, exports) {

$parcel$export(module.exports, "RequestError", () => $9c115d8974651e85$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $9c115d8974651e85$export$3717b1ffef4428ea);

var $6bBrC = parcelRequire("6bBrC");
class $9c115d8974651e85$export$43ee7d0e4f429743 extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason);
        this.reason = reason;
        this.metadata = metadata;
        this.innerError = innerError;
    }
    get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            innerError: innerError
        };
    }
}
function $9c115d8974651e85$export$3717b1ffef4428ea(err) {
    return err instanceof $9c115d8974651e85$export$43ee7d0e4f429743;
}

});
parcelRegister("6bBrC", function(module, exports) {

$parcel$export(module.exports, "BaseMediaClientError", () => $acff2c6dc8396dfc$export$2b0aca14d61c3190);

var $eKK8L = parcelRequire("eKK8L");
class $acff2c6dc8396dfc$export$2b0aca14d61c3190 extends Error {
    constructor(message){
        super(message);
        this.message = message;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}

});
parcelRegister("eKK8L", function(module, exports) {

$parcel$export(module.exports, "isMediaClientError", () => $11f35e187e1f2fdf$export$2491e0bbdb59256e);
$parcel$export(module.exports, "getMediaClientErrorReason", () => $11f35e187e1f2fdf$export$c15d72765ee2baa4);
function $11f35e187e1f2fdf$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $11f35e187e1f2fdf$export$c15d72765ee2baa4(err) {
    return $11f35e187e1f2fdf$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});



parcelRegister("2WGjX", function(module, exports) {

$parcel$export(module.exports, "isRateLimitedError", () => $6c6863351bba029c$export$bc96a6a479480590);
$parcel$export(module.exports, "createUrl", () => $6c6863351bba029c$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $6c6863351bba029c$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $6c6863351bba029c$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $6c6863351bba029c$export$5cc7b0795397da86);
$parcel$export(module.exports, "fetchRetry", () => $6c6863351bba029c$export$782df2acbe10b22c);
$parcel$export(module.exports, "createRequestErrorReason", () => $6c6863351bba029c$export$6397609af718d008);
$parcel$export(module.exports, "createProcessFetchResponse", () => $6c6863351bba029c$export$6e2e477edb7d6032);
parcelRequire("2q7Xj");
var $jrFS0 = parcelRequire("jrFS0");

var $hFyZ6 = parcelRequire("hFyZ6");

var $7aQon = parcelRequire("7aQon");
function $6c6863351bba029c$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $6c6863351bba029c$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $6c6863351bba029c$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $6c6863351bba029c$export$bc96a6a479480590(error) {
    return !!error && (0, $7aQon.isRequestError)(error) && error.attributes.statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $6c6863351bba029c$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $6c6863351bba029c$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$6c6863351bba029c$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$6c6863351bba029c$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $6c6863351bba029c$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $jrFS0.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $6c6863351bba029c$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth?.baseUrl);
    const authParams = auth && (0, $hFyZ6.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.append(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $6c6863351bba029c$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$6c6863351bba029c$export$eaf4479116d2f925(auth),
        ...$6c6863351bba029c$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $6c6863351bba029c$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $7aQon.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$6c6863351bba029c$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $6c6863351bba029c$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $7aQon.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$6c6863351bba029c$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $6c6863351bba029c$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    maxAttempts: 5,
    factor: 2
};
function $6c6863351bba029c$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $7aQon.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $6c6863351bba029c$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$6c6863351bba029c$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $6c6863351bba029c$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($6c6863351bba029c$export$de0b576cf7ce4a53(err)) throw new (0, $7aQon.RequestError)('clientAbortedRequest', metadata, err);
        if (!$6c6863351bba029c$export$ad8c5cf7dd4c3caf(err) && !(0, $7aQon.isRequestError)(err) || (0, $7aQon.isRequestError)(err) && (!err.metadata || !err.metadata.statusCode || err.metadata.statusCode < 500)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $7aQon.isRequestError)(lastError)) throw $6c6863351bba029c$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $7aQon.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $6c6863351bba029c$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $6c6863351bba029c$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $6c6863351bba029c$export$6397609af718d008(statusCode);
    return new (0, $7aQon.RequestError)(reason, {
        ...metadata,
        ...$6c6863351bba029c$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $6c6863351bba029c$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $6c6863351bba029c$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $6c6863351bba029c$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("hFyZ6", function(module, exports) {

$parcel$export(module.exports, "mapAuthToQueryParameters", () => $032b1e5883aca6a7$export$6833b130611df767);
parcelRequire("2q7Xj");
var $jrFS0 = parcelRequire("jrFS0");
function $032b1e5883aca6a7$export$6833b130611df767(auth) {
    if ((0, $jrFS0.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});



parcelRegister("gNTpJ", function(module, exports) {

$parcel$export(module.exports, "mapToMediaCdnUrl", () => $5aace4118a232dd4$export$fb88a576cf28364d);

var $XHGTv = parcelRequire("XHGTv");

var $6daei = parcelRequire("6daei");
const $5aace4118a232dd4$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
// Cloudfront has a hard limit of 8,192 bytes
// https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/cloudfront-limits.html
// Assuming other parts of the URL make up a max of ~1000 (in reality it's lower), the token can be ~7000
const $5aace4118a232dd4$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
function $5aace4118a232dd4$export$fb88a576cf28364d(url, token) {
    const tokenLength = token?.length ?? 0;
    if ((0, $6daei.isFedRamp)() || tokenLength > $5aace4118a232dd4$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $XHGTv.fg)('platform.media-cdn-delivery') && (0, $XHGTv.fg)('platform.media-cdn-single-host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = $5aace4118a232dd4$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});

parcelRegister("bvZYv", function(module, exports) {

$parcel$export(module.exports, "resolveAuth", () => $9dc00fbb50183c87$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $9dc00fbb50183c87$export$5211e1371264aec3);

var $89khs = parcelRequire("89khs");

var $aSVFn = parcelRequire("aSVFn");
const $9dc00fbb50183c87$export$560085fe411c0660 = 10000;
const $9dc00fbb50183c87$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $9dc00fbb50183c87$export$560085fe411c0660)=>{
    let auth;
    try {
        auth = await Promise.race([
            authProvider(authContext),
            (0, $aSVFn.rejectTimeout)(authProviderTimeout, new (0, $89khs.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        if (err instanceof (0, $89khs.MediaStoreError)) throw err;
        throw new (0, $89khs.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $89khs.MediaStoreError)('emptyAuth');
    /*
    We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
    Token expiration check in the frontend is a bad idea. Don't do it!
    More info:
    https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
    https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
  */ return auth;
};
const $9dc00fbb50183c87$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $89khs.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("89khs", function(module, exports) {

$parcel$export(module.exports, "MediaStoreError", () => $1f9b2d64052a14af$export$b78480bd311630bc);
$parcel$export(module.exports, "isMediaStoreError", () => $1f9b2d64052a14af$export$8d2a9b675b2ce37a);

var $6bBrC = parcelRequire("6bBrC");
class $1f9b2d64052a14af$export$b78480bd311630bc extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason);
        this.reason = reason;
        this.innerError = innerError;
    }
    get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $1f9b2d64052a14af$export$8d2a9b675b2ce37a(err) {
    return err instanceof $1f9b2d64052a14af$export$b78480bd311630bc;
}

});

parcelRegister("aSVFn", function(module, exports) {

$parcel$export(module.exports, "rejectTimeout", () => $e63044c0dd9a5237$export$cf2d2a1124beacb2);
const $e63044c0dd9a5237$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $e63044c0dd9a5237$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});



parcelRegister("3ixzU", function(module, exports) {

$parcel$export(module.exports, "FileFetcherImpl", () => $f9763f928076fcdc$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("fIVY8")).FileFetcherError);

var $hIoOm = parcelRequire("hIoOm");

var $aynDk = parcelRequire("aynDk");

var $dFBS3 = parcelRequire("dFBS3");
parcelRequire("2q7Xj");
var $jrFS0 = parcelRequire("jrFS0");

var $8w4F1 = parcelRequire("8w4F1");

var $EEZOU = parcelRequire("EEZOU");

var $9x67R = parcelRequire("9x67R");

var $fIVY8 = parcelRequire("fIVY8");

var $eSb3E = parcelRequire("eSb3E");

var $1l4qL = parcelRequire("1l4qL");

var $59gZB = parcelRequire("59gZB");

var $aFsdc = parcelRequire("aFsdc");

var $bxYYu = parcelRequire("bxYYu");

var $bVMx4 = parcelRequire("bVMx4");

var $04AOJ = parcelRequire("04AOJ");

var $9sBfG = parcelRequire("9sBfG");

var $dpRAQ = parcelRequire("dpRAQ");

var $eqcfa = parcelRequire("eqcfa");
var $9BeXg = parcelRequire("9BeXg");

var $cfjUA = parcelRequire("cfjUA");

var $rMufQ = parcelRequire("rMufQ");

var $3izHV = parcelRequire("3izHV");

var $cILCr = parcelRequire("cILCr");

var $eqlnz = parcelRequire("eqlnz");

var $6wdWp = parcelRequire("6wdWp");
parcelRequire("gHZqD");
var $exlxT = parcelRequire("exlxT");
class $f9763f928076fcdc$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $exlxT.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>typeof error === 'string' ? {
                status: 'error',
                id: id,
                reason: error,
                occurrenceKey: occurrenceKey,
                message: error
            } : {
                status: 'error',
                id: id,
                reason: error?.reason,
                details: error?.attributes,
                occurrenceKey: occurrenceKey,
                message: error?.message
            };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        this.createDownloadFileStream = (id, collectionName, occurrenceKey)=>{
            const subject = (0, $rMufQ.createMediaSubject)();
            const poll = new (0, $eqlnz.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName
                });
                if (!response) throw new (0, $fIVY8.FileFetcherError)('emptyItems', id, {
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                });
                if ((0, $6wdWp.isEmptyFile)(response)) throw new (0, $fIVY8.FileFetcherError)('zeroVersionFile', id, {
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                });
                const fileState = (0, $9x67R.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $dpRAQ.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $04AOJ.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.dataloader = (0, $bVMx4.createFileDataloader)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey } = options;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxYYu)))(id)) {
            const subject = (0, $rMufQ.createMediaSubject)();
            const err = new (0, $fIVY8.FileFetcherError)('invalidFileId', id, {
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = {
                status: 'error',
                id: id,
                reason: err?.reason,
                message: err?.message,
                occurrenceKey: occurrenceKey,
                details: err?.attributes
            };
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $eqcfa.fromObservable)(subject);
        }
        return (0, $eqcfa.fromObservable)((0, $1l4qL.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $9BeXg.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
    touchFiles(descriptors, collection, traceContext) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext) {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $rMufQ.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $1l4qL.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $3izHV.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $cfjUA.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $rMufQ.createMediaSubject)();
        (0, $1l4qL.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $hIoOm.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $aynDk.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $9sBfG.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $eSb3E.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller?.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $eqcfa.fromObservable)(subject);
    }
    async downloadBinary(id, name = 'download', collectionName) {
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
        (0, $8w4F1.downloadUrl)(url, {
            name: name
        });
        (0, $59gZB.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $aFsdc.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const mediaStore = destination.mediaStore || new (0, $EEZOU.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $jrFS0.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const cache = (0, $1l4qL.getFileStreamsCache)();
        let processingSubscription;
        try {
            const { data: copiedFile } = await mediaStore.copyFileWithToken(body, params, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $3izHV.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $9x67R.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $rMufQ.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $9x67R.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $9x67R.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $cILCr.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $9sBfG.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $9sBfG.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $9x67R.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $9x67R.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $9x67R.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $1l4qL.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $rMufQ.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("8w4F1", function(module, exports) {

$parcel$export(module.exports, "downloadUrl", () => $b20aaa7fa9049904$export$8a96edb1c96563f4);
const $b20aaa7fa9049904$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("9x67R", function(module, exports) {

$parcel$export(module.exports, "isUploadingFileState", () => $4ada6060c1d21d91$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $4ada6060c1d21d91$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $4ada6060c1d21d91$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $4ada6060c1d21d91$export$f863e1e09c8a926);
$parcel$export(module.exports, "isPreviewableFileState", () => $4ada6060c1d21d91$export$92dd692b31e42e64);
$parcel$export(module.exports, "isFinalFileState", () => $4ada6060c1d21d91$export$270b3fc27120edd0);
$parcel$export(module.exports, "isImageRepresentationReady", () => $4ada6060c1d21d91$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $4ada6060c1d21d91$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $4ada6060c1d21d91$export$ea3730792e8bebfb);
const $4ada6060c1d21d91$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $4ada6060c1d21d91$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $4ada6060c1d21d91$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $4ada6060c1d21d91$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $4ada6060c1d21d91$export$92dd692b31e42e64 = (fileState)=>!$4ada6060c1d21d91$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $4ada6060c1d21d91$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $4ada6060c1d21d91$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $4ada6060c1d21d91$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        metadataTraceContext: metadataTraceContext
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing'
            };
    }
};
const $4ada6060c1d21d91$export$ea3730792e8bebfb = (id, item)=>{
    return $4ada6060c1d21d91$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("fIVY8", function(module, exports) {

$parcel$export(module.exports, "FileFetcherError", () => $0af7ec264212be2b$export$e3e60f0dab8641de);

var $6bBrC = parcelRequire("6bBrC");
class $0af7ec264212be2b$export$e3e60f0dab8641de extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, id, metadata){
        super(reason);
        this.reason = reason;
        this.id = id;
        this.metadata = metadata;
    }
    get attributes() {
        const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey } = {} } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $0af7ec264212be2b$export$5c3435f75ce0ce70(err) {
    return err instanceof $0af7ec264212be2b$export$e3e60f0dab8641de;
}

});

parcelRegister("eSb3E", function(module, exports) {

$parcel$export(module.exports, "uploadFile", () => $46ff4c8ed9468aee$export$a5575dbeeffdad98);

var $2gF4Y = parcelRequire("2gF4Y");

var $jpkPA = parcelRequire("jpkPA");

var $eGPtZ = parcelRequire("eGPtZ");

var $fLD6W = parcelRequire("fLD6W");

var $1jayH = parcelRequire("1jayH");

var $aFsdc = parcelRequire("aFsdc");

var $eLiN6 = parcelRequire("eLiN6");
const $46ff4c8ed9468aee$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $fLD6W.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $46ff4c8ed9468aee$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $46ff4c8ed9468aee$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $46ff4c8ed9468aee$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext);
        offset += chunks.length;
    };
};
const $46ff4c8ed9468aee$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext);
};
const $46ff4c8ed9468aee$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $aFsdc.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $eLiN6.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $eLiN6.fileSizeError)) callbacks?.onUploadFinish(new (0, $1jayH.UploaderError)(err.message, id, {
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks?.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $2gF4Y.chunkinator)(content, {
        hashingFunction: (blob)=>$46ff4c8ed9468aee$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $46ff4c8ed9468aee$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $aFsdc.PROCESSING_BATCH_SIZE),
        processingFunction: $46ff4c8ed9468aee$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $jpkPA.from)(deferredUploadId).pipe((0, $eGPtZ.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $eGPtZ.concatMap)(()=>(0, $jpkPA.from)($46ff4c8ed9468aee$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $46ff4c8ed9468aee$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("2gF4Y", function(module, exports) {

$parcel$export(module.exports, "chunkinator", () => $926a40091d882f6c$export$9ab6bef3838698f8);

var $dBQte = parcelRequire("dBQte");

var $eGPtZ = parcelRequire("eGPtZ");

var $4ZLqF = parcelRequire("4ZLqF");

var $8riMk = parcelRequire("8riMk");

var $fZ5s6 = parcelRequire("fZ5s6");

var $66iic = parcelRequire("66iic");

var $f28UZ = parcelRequire("f28UZ");

var $iYmB8 = parcelRequire("iYmB8");

var $7zy4k = parcelRequire("7zy4k");

var $jpkPA = parcelRequire("jpkPA");
const $926a40091d882f6c$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $8riMk.fromPromise)((0, $7zy4k.fetchBlob)(file)).pipe((0, $eGPtZ.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $fZ5s6.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $66iic.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $f28UZ.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $dBQte.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $iYmB8.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $eGPtZ.concatMap)((batchedChunks)=>{
            return (0, $jpkPA.from)(batchedChunks);
        }), (0, $4ZLqF.bufferCount)(totalChunks));
    }));
const $926a40091d882f6c$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $926a40091d882f6c$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("fZ5s6", function(module, exports) {

$parcel$export(module.exports, "slicenator", () => $b09d6a25440d952b$export$5b92d769f2f57509);

var $3fnK6 = parcelRequire("3fnK6");

var $aynDk = parcelRequire("aynDk");
const $b09d6a25440d952b$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $3fnK6.range)(0, totalChunks).pipe((0, $aynDk.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});

parcelRegister("66iic", function(module, exports) {

$parcel$export(module.exports, "hashinator", () => $bba7ef0a5244bc3b$export$d5f5a550a38ec367);

var $7zy4k = parcelRequire("7zy4k");
const $bba7ef0a5244bc3b$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $bba7ef0a5244bc3b$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $7zy4k.asyncMap)($bba7ef0a5244bc3b$export$28a452a485721473(hasher), concurrency)(blobs$);

});
parcelRegister("7zy4k", function(module, exports) {

$parcel$export(module.exports, "fetchBlob", () => $434114a42104e3d7$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $434114a42104e3d7$export$707ee4c4c95d39e3);

var $3JafE = parcelRequire("3JafE");

var $b1qLQ = parcelRequire("b1qLQ");
async function $434114a42104e3d7$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $434114a42104e3d7$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $434114a42104e3d7$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $3JafE.Observable)((sub)=>{
            notifiers.push($434114a42104e3d7$var$notify(project(value), sub, onReady));
        });
};
const $434114a42104e3d7$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $b1qLQ.mergeMap)($434114a42104e3d7$var$mapper(project), concurrent);

});


parcelRegister("f28UZ", function(module, exports) {

$parcel$export(module.exports, "uploadinator", () => $6a83285a61ef7586$export$94ce0f3fcf999415);

var $7zy4k = parcelRequire("7zy4k");
const $6a83285a61ef7586$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $7zy4k.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("iYmB8", function(module, exports) {

$parcel$export(module.exports, "processinator", () => $38ace8e9a7e10729$export$2f21790600302ed);

var $4ZLqF = parcelRequire("4ZLqF");

var $eGPtZ = parcelRequire("eGPtZ");
const $38ace8e9a7e10729$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $4ZLqF.bufferCount)(options.batchSize)).pipe((0, $eGPtZ.concatMap)(process));
};

});


parcelRegister("fLD6W", function(module, exports) {

$parcel$export(module.exports, "createHasher", () => $80d9fc5820b1f0fe$export$14b114effbc08b6b);
parcelRequire("2q7Xj");
var $fmEc3 = parcelRequire("fmEc3");
let $80d9fc5820b1f0fe$var$hasher = null;
let $80d9fc5820b1f0fe$var$sha256Hasher = null;
const $80d9fc5820b1f0fe$export$b7d263e6bc26b29a = ()=>$80d9fc5820b1f0fe$var$hasher = null;



const $80d9fc5820b1f0fe$export$14b114effbc08b6b = async (algorithm)=>{
    const numWorkers = 3;
    if (algorithm === (0, $fmEc3.ChunkHashAlgorithm).Sha256) {
        if (!$80d9fc5820b1f0fe$var$sha256Hasher) {
            // TODO this needs to support worker sha256 hasher as well
            const { SimpleHasher: SimpleHasher } = await (parcelRequire("a1LbI"));
            $80d9fc5820b1f0fe$var$sha256Hasher = new SimpleHasher();
        }
        return $80d9fc5820b1f0fe$var$sha256Hasher;
    } else if (!$80d9fc5820b1f0fe$var$hasher) try {
        const { WorkerHasher: WorkerHasher } = await (parcelRequire("37sun"));
        $80d9fc5820b1f0fe$var$hasher = new WorkerHasher(numWorkers);
    } catch (error) {
        const { SimpleHasher: SimpleHasher } = await (parcelRequire("jYrgF"));
        $80d9fc5820b1f0fe$var$hasher = new SimpleHasher();
    }
    return $80d9fc5820b1f0fe$var$hasher;
};

});
parcelRegister("a1LbI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iw25e").then(()=>parcelRequire('4HVlI'));

});

parcelRegister("37sun", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("izugL")
]).then(()=>parcelRequire('kAV1m'));

});

parcelRegister("jYrgF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("lOaWi")
]).then(()=>parcelRequire('7ykMh'));

});


parcelRegister("1jayH", function(module, exports) {

$parcel$export(module.exports, "UploaderError", () => $93268a427390d3ba$export$515240c3f059c807);

var $6bBrC = parcelRequire("6bBrC");
class $93268a427390d3ba$export$515240c3f059c807 extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, id, metadata){
        super(reason);
        this.reason = reason;
        this.id = id;
        this.metadata = metadata;
    }
    get attributes() {
        const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey } = {} } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $93268a427390d3ba$export$80ee180172bc336(err) {
    return err instanceof $93268a427390d3ba$export$515240c3f059c807;
}

});

parcelRegister("eLiN6", function(module, exports) {

$parcel$export(module.exports, "fileSizeError", () => $1d73b7e36a95c49b$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $1d73b7e36a95c49b$export$71f452e02035c1e2);

var $bYwuj = parcelRequire("bYwuj");

var $aFsdc = parcelRequire("aFsdc");
const $1d73b7e36a95c49b$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $1d73b7e36a95c49b$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $aFsdc.MAX_UPLOAD_FILE_SIZE)) throw new Error($1d73b7e36a95c49b$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $bYwuj.DATA_UNIT).GB) return 5 * (0, $bYwuj.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $bYwuj.DATA_UNIT).GB && fileSize <= 50 * (0, $bYwuj.DATA_UNIT).GB) return 50 * (0, $bYwuj.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $bYwuj.DATA_UNIT).GB && fileSize <= 0.95 * (0, $bYwuj.DATA_UNIT).TB) return 100 * (0, $bYwuj.DATA_UNIT).MB;
    return 210 * (0, $bYwuj.DATA_UNIT).MB;
};

});


parcelRegister("1l4qL", function(module, exports) {

$parcel$export(module.exports, "getFileStreamsCache", () => $5b31f9f9111d0f01$export$f2f061938c1e6810);
class $5b31f9f9111d0f01$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}
let $5b31f9f9111d0f01$var$streamCache;

const $5b31f9f9111d0f01$export$f2f061938c1e6810 = ()=>{
    if (!$5b31f9f9111d0f01$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("iE8r2")).mediaState;
        $5b31f9f9111d0f01$var$streamCache = new $5b31f9f9111d0f01$export$4293896e79732236(mediaState.streams);
    }
    return $5b31f9f9111d0f01$var$streamCache;
};

});

parcelRegister("59gZB", function(module, exports) {

$parcel$export(module.exports, "globalMediaEventEmitter", () => $b6e693db8a3ca69e$export$68d003d3105952ad);
parcelRequire("2q7Xj");
var $iE8r2 = parcelRequire("iE8r2");
const $b6e693db8a3ca69e$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $iE8r2.mediaState).eventEmitter) (0, $iE8r2.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $iE8r2.mediaState).eventEmitter) (0, $iE8r2.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $iE8r2.mediaState).eventEmitter) return (0, $iE8r2.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("bxYYu", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $aul3P = parcelRequire("aul3P");
var $8682131465584b62$require$Buffer = $aul3P.Buffer;
var $8682131465584b62$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $8682131465584b62$var$_byteToHex = [];
for(var $8682131465584b62$var$i = 0; $8682131465584b62$var$i < 256; $8682131465584b62$var$i++)$8682131465584b62$var$_byteToHex[$8682131465584b62$var$i] = ($8682131465584b62$var$i + 0x100).toString(16).substr(1);
function $8682131465584b62$var$unparse(buf, offset) {
    var i = offset || 0, bth = $8682131465584b62$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($8682131465584b62$require$Buffer.isBuffer(uuid)) parsedUuid = $8682131465584b62$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$8682131465584b62$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $8682131465584b62$var$extractVersion(parsedUuid);
    else if ($8682131465584b62$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $8682131465584b62$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("bVMx4", function(module, exports) {

$parcel$export(module.exports, "createFileDataloader", () => $d49dc51366e1ddfa$export$ae188fee39529b82);

var $1l2Nv = parcelRequire("1l2Nv");

var $5Cq8b = parcelRequire("5Cq8b");
const $d49dc51366e1ddfa$export$b79d95ee17a87a = 100;
const $d49dc51366e1ddfa$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $d49dc51366e1ddfa$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $d49dc51366e1ddfa$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $d49dc51366e1ddfa$var$makeCacheKey(id, collection);
        prev[key] = $d49dc51366e1ddfa$var$isBatchLoadingErrorResult(fileItem) ? fileItem.error : {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $d49dc51366e1ddfa$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || null;
    });
};
function $d49dc51366e1ddfa$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $5Cq8b.getRandomHex)(8),
                spanId: (0, $5Cq8b.getRandomHex)(8)
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $d49dc51366e1ddfa$export$71cd2e8f8162d47b(keys, items);
    };
}
function $d49dc51366e1ddfa$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($1l2Nv)))($d49dc51366e1ddfa$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $d49dc51366e1ddfa$export$b79d95ee17a87a
    });
}

});
parcelRegister("1l2Nv", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $0f99ec2102c35890$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $0f99ec2102c35890$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $0f99ec2102c35890$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $0f99ec2102c35890$var$getValidCacheKeyFn(options);
        this._cacheMap = $0f99ec2102c35890$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $0f99ec2102c35890$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $0f99ec2102c35890$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$0f99ec2102c35890$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $0f99ec2102c35890$var$enqueuePostPromiseJob = typeof $2fFJv === 'object' && typeof $2fFJv.nextTick === 'function' ? function(fn) {
    if (!$0f99ec2102c35890$var$resolvedPromise) $0f99ec2102c35890$var$resolvedPromise = Promise.resolve();
    $0f99ec2102c35890$var$resolvedPromise.then(function() {
        $2fFJv.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $0f99ec2102c35890$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $0f99ec2102c35890$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $0f99ec2102c35890$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $0f99ec2102c35890$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $0f99ec2102c35890$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $0f99ec2102c35890$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $0f99ec2102c35890$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$0f99ec2102c35890$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $0f99ec2102c35890$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $0f99ec2102c35890$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $0f99ec2102c35890$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $0f99ec2102c35890$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $0f99ec2102c35890$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $0f99ec2102c35890$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $0f99ec2102c35890$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $0f99ec2102c35890$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $0f99ec2102c35890$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $0f99ec2102c35890$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $0f99ec2102c35890$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $0f99ec2102c35890$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $0f99ec2102c35890$var$DataLoader;

});


parcelRegister("04AOJ", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $2d99bdcc193fb729$export$ac3214931ffd82af);

var $3izHV = parcelRequire("3izHV");
const $2d99bdcc193fb729$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $3izHV.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("3izHV", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $271e34cd6fe1cabd$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("br8gy")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("br8gy")).isVideoMimeTypeSupportedByBrowser);

var $hZoAg = parcelRequire("hZoAg");

var $br8gy = parcelRequire("br8gy");

var $5BRco = parcelRequire("5BRco");
const $271e34cd6fe1cabd$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $hZoAg.isArchive)(mimeType)) return 'archive';
    if ((0, $br8gy.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $br8gy.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $br8gy.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $br8gy.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("hZoAg", function(module, exports) {

$parcel$export(module.exports, "isArchive", () => $4c79e3ce7fc2a8d0$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $4c79e3ce7fc2a8d0$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("br8gy", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $7e5c6394ef188971$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $7e5c6394ef188971$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $7e5c6394ef188971$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $7e5c6394ef188971$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $7e5c6394ef188971$export$55ca6cdaf6093034 = (mimeType)=>$7e5c6394ef188971$export$74325e3c843a9555(mimeType) || $7e5c6394ef188971$export$c021f2623a75015f(mimeType) || $7e5c6394ef188971$export$ff36075ea755a717(mimeType) || $7e5c6394ef188971$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("5BRco", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $85f5842a210424b1$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $85f5842a210424b1$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $85f5842a210424b1$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $85f5842a210424b1$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $85f5842a210424b1$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $85f5842a210424b1$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$548d9148a80556a3 = (mimeType)=>$85f5842a210424b1$export$e9a065a80f76311e(mimeType) || $85f5842a210424b1$export$86baad7a89d908e9(mimeType) || $85f5842a210424b1$export$8cba23825d020bbb(mimeType) || $85f5842a210424b1$export$9c2b4de5fdca2ce3(mimeType) || $85f5842a210424b1$export$94e1479e01d2af53(mimeType);

});



parcelRegister("9sBfG", function(module, exports) {

$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $4579abe2682788f5$export$89097c0ec1e0dee1);

var $9x67R = parcelRequire("9x67R");
const $4579abe2682788f5$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $9x67R.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("dpRAQ", function(module, exports) {

$parcel$export(module.exports, "convertBase64ToBlob", () => $241808151c7df3d7$export$ed17558b11b88056);
const $241808151c7df3d7$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("eqcfa", function(module, exports) {

$parcel$export(module.exports, "fromObservable", () => $5370b0715ba587e9$export$4b2432e2d8723823);

var $rMufQ = parcelRequire("rMufQ");
function $5370b0715ba587e9$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $5370b0715ba587e9$export$8659d1f07d151381(item) {
    return $5370b0715ba587e9$export$4b2432e2d8723823((0, $rMufQ.createMediaSubject)(item));
}

});
parcelRegister("rMufQ", function(module, exports) {

$parcel$export(module.exports, "createMediaSubject", () => $b1945b205bb99a41$export$bc76d51553fa5e35);

var $lXGL9 = parcelRequire("lXGL9");
function $b1945b205bb99a41$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $lXGL9.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});


parcelRegister("9BeXg", function(module, exports) {

$parcel$export(module.exports, "toPromise", () => $41ac1ff94334ef1d$export$4dbaaf6c79705e6c);

var $hIoOm = parcelRequire("hIoOm");
const $41ac1ff94334ef1d$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $hIoOm.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("cfjUA", function(module, exports) {

$parcel$export(module.exports, "getDimensionsFromBlob", () => $e97c761e4a22f2e8$export$71797c284d89a3e1);

var $leGRQ = parcelRequire("leGRQ");

var $USL4H = parcelRequire("USL4H");
const $e97c761e4a22f2e8$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $leGRQ.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $USL4H.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("leGRQ", function(module, exports) {

$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $dc02c409650d12cb$export$a1c3205f28a20414);
const $dc02c409650d12cb$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("USL4H", function(module, exports) {

$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $8e2e403157239a69$export$62aabd5ff85d0451);
const $8e2e403157239a69$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("cILCr", function(module, exports) {

$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $5cccb92ec7f36e1d$export$2ccdd6f9a9eba6a);

var $br8gy = parcelRequire("br8gy");
var $5BRco = parcelRequire("5BRco");

var $USL4H = parcelRequire("USL4H");
async function $5cccb92ec7f36e1d$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $br8gy.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $5BRco.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $USL4H.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("eqlnz", function(module, exports) {

$parcel$export(module.exports, "PollingFunction", () => $f01979f4321e41b7$export$4c54d536f8e37dc2);

var $foadk = parcelRequire("foadk");
const $f01979f4321e41b7$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $f01979f4321e41b7$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$f01979f4321e41b7$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $foadk.PollingError)('pollingMaxAttemptsExceeded', this.attempt));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $foadk.PollingError)('pollingMaxAttemptsExceeded', this.attempt));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("foadk", function(module, exports) {

$parcel$export(module.exports, "PollingError", () => $830cdba99e9f23c2$export$c3748c310e92340a);
$parcel$export(module.exports, "isPollingError", () => $830cdba99e9f23c2$export$541e3e52eea6fece);

var $6bBrC = parcelRequire("6bBrC");
class $830cdba99e9f23c2$export$c3748c310e92340a extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, attempts){
        super(reason);
        this.reason = reason;
        this.attempts = attempts;
    }
    get attributes() {
        const { reason: reason, attempts: attempts } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}
function $830cdba99e9f23c2$export$541e3e52eea6fece(err) {
    return err instanceof $830cdba99e9f23c2$export$c3748c310e92340a;
}

});


parcelRegister("6wdWp", function(module, exports) {

$parcel$export(module.exports, "isEmptyFile", () => $8d001a32183537d3$export$728192ce8dd94659);
const $8d001a32183537d3$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $8d001a32183537d3$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $8d001a32183537d3$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("gHZqD", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => (parcelRequire("exlxT")).mediaStore);

var $exlxT = parcelRequire("exlxT");

});
parcelRegister("exlxT", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => $107a0f046eaf76d8$export$5785580dea19518d);

var $7dY5U = parcelRequire("7dY5U");

var $2Qvr5 = parcelRequire("2Qvr5");

var $gQVOz = parcelRequire("gQVOz");
const $107a0f046eaf76d8$var$mediaStoreWithoutDevtools = (0, $gQVOz.createStore)()((0, $7dY5U.subscribeWithSelector)((0, $2Qvr5.immer)(()=>({
        files: {}
    }))));
const $107a0f046eaf76d8$var$mediaStoreWithDevtools = (0, $gQVOz.createStore)()((0, $7dY5U.devtools)((0, $7dY5U.subscribeWithSelector)((0, $2Qvr5.immer)(()=>({
        files: {}
    })))));
const $107a0f046eaf76d8$export$5785580dea19518d = $107a0f046eaf76d8$var$mediaStoreWithoutDevtools;
const $107a0f046eaf76d8$export$503459913a0dc356 = (initialStore)=>{
    return (0, $gQVOz.createStore)()((0, $7dY5U.subscribeWithSelector)((0, $2Qvr5.immer)(()=>({
            files: {},
            ...initialStore
        }))));
};

});
parcelRegister("7dY5U", function(module, exports) {

$parcel$export(module.exports, "devtools", () => $45f0a2b2efc9d9f9$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $45f0a2b2efc9d9f9$export$5c593627aef9f076);
var $45f0a2b2efc9d9f9$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $45f0a2b2efc9d9f9$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $45f0a2b2efc9d9f9$export$4feba8a1bc8e9afd = $45f0a2b2efc9d9f9$var$reduxImpl;
const $45f0a2b2efc9d9f9$var$trackedConnections = /* @__PURE__ */ new Map();
const $45f0a2b2efc9d9f9$var$getTrackedConnectionState = (name)=>{
    const api = $45f0a2b2efc9d9f9$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $45f0a2b2efc9d9f9$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $45f0a2b2efc9d9f9$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $45f0a2b2efc9d9f9$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $45f0a2b2efc9d9f9$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) {
            if (($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $45f0a2b2efc9d9f9$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $45f0a2b2efc9d9f9$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $45f0a2b2efc9d9f9$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $45f0a2b2efc9d9f9$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $45f0a2b2efc9d9f9$export$6922d3b3a607469e = $45f0a2b2efc9d9f9$var$devtoolsImpl;
const $45f0a2b2efc9d9f9$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $45f0a2b2efc9d9f9$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $45f0a2b2efc9d9f9$export$5c593627aef9f076 = $45f0a2b2efc9d9f9$var$subscribeWithSelectorImpl;
const $45f0a2b2efc9d9f9$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $45f0a2b2efc9d9f9$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $45f0a2b2efc9d9f9$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $45f0a2b2efc9d9f9$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $45f0a2b2efc9d9f9$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $45f0a2b2efc9d9f9$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $45f0a2b2efc9d9f9$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $45f0a2b2efc9d9f9$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $45f0a2b2efc9d9f9$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $45f0a2b2efc9d9f9$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $45f0a2b2efc9d9f9$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $45f0a2b2efc9d9f9$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $45f0a2b2efc9d9f9$var$oldImpl(config, baseOptions);
    }
    return $45f0a2b2efc9d9f9$var$newImpl(config, baseOptions);
};
const $45f0a2b2efc9d9f9$export$9a6132153fba2e0 = $45f0a2b2efc9d9f9$var$persistImpl;

});

parcelRegister("2Qvr5", function(module, exports) {

$parcel$export(module.exports, "immer", () => $a3e9bebcfca14386$export$428de7ec69ac95c);

var $lbd4c = parcelRequire("lbd4c");
const $a3e9bebcfca14386$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $lbd4c.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $a3e9bebcfca14386$export$428de7ec69ac95c = $a3e9bebcfca14386$var$immerImpl;

});
parcelRegister("lbd4c", function(module, exports) {

$parcel$export(module.exports, "produce", () => fn);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $221c0e7836ac0785$export$2e2bcd8739ae039 = fn;

});


parcelRegister("gQVOz", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $14d460da377d9036$export$f51a9068ac82ea43);
var $14d460da377d9036$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $14d460da377d9036$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($14d460da377d9036$import_meta.env ? $14d460da377d9036$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $14d460da377d9036$export$f51a9068ac82ea43 = (createState)=>createState ? $14d460da377d9036$var$createStoreImpl(createState) : $14d460da377d9036$var$createStoreImpl;
var $14d460da377d9036$export$2e2bcd8739ae039 = (createState)=>{
    if (($14d460da377d9036$import_meta.env ? $14d460da377d9036$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $14d460da377d9036$export$f51a9068ac82ea43(createState);
};

});




parcelRegister("eJAUz", function(module, exports) {

$parcel$export(module.exports, "StargateClient", () => $aebd1b09d3f1d2ab$export$c66ca190f89caaac);
class $aebd1b09d3f1d2ab$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("6o5wg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kRysi").then(()=>parcelRequire('8gBya'));

});




parcelRegister("1xvoH", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $86ba7cfc6df4e172$export$4eaebdef02112fe4);

var $eUqFw = parcelRequire("eUqFw");

var $9x67R = parcelRequire("9x67R");

var $RBcRl = parcelRequire("RBcRl");
var $kJ7yF = parcelRequire("kJ7yF");

var $br8gy = parcelRequire("br8gy");

var $XHGTv = parcelRequire("XHGTv");

var $iP4HA = parcelRequire("iP4HA");

var $kj8oZ = parcelRequire("kj8oZ");

var $jvF4x = parcelRequire("jvF4x");
var $1eI0l = parcelRequire("1eI0l");
var $jyk7o = parcelRequire("jyk7o");

var $862c0 = parcelRequire("862c0");
var $6tTCR = parcelRequire("6tTCR");

var $2GnF5 = parcelRequire("2GnF5");
const $86ba7cfc6df4e172$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $kJ7yF.useMediaClient)();
    const [status, setStatus] = (0, $eUqFw.useState)('loading');
    const [error, setError] = (0, $eUqFw.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $eUqFw.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $eUqFw.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $eUqFw.useState)('not-resolved');
    const ssrReliabilityRef = (0, $eUqFw.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const requestDimensions = (0, $eUqFw.useMemo)(()=>dimensions ? (0, $2GnF5.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $2GnF5.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    if ((0, $XHGTv.fg)('platform.media-card-performance-observer_a803k')) imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $jyk7o.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $6tTCR.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $jvF4x.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $iP4HA.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $eUqFw.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $RBcRl.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const fileStatus = fileState?.status;
    const isBackendPreviewReady = !!fileState && (0, $9x67R.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $eUqFw.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileStatus === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileStatus === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $kj8oZ.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileStatus === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $kj8oZ.MediaFilePreviewError)('metadata-fetch', new Error(fileStateErrorMessage)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileStatus,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $2GnF5.useCurrentValueRef)(()=>{
        return (0, $jvF4x.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $eUqFw.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $2GnF5.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $2GnF5.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $eUqFw.useEffect)(()=>{
        const cachedPreview = (0, $jyk7o.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $2GnF5.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $1eI0l.isSupportedLocalPreview)(mediaType) && (0, $br8gy.isMimeTypeSupportedByBrowser)(mimeType || '')) // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
        // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
        // Then, local Preview NOT available
        (0, $jvF4x.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
            setIsBannedLocalPreview(true);
            // CXP-2723 TODO: We might have to wrap this error in MediaCardError
            setNonCriticalError(e);
        });
        else if (!error && !nonCriticalError && (!preview || (0, $2GnF5.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $jvF4x.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
            const wrappedError = (0, $kj8oZ.ensureMediaFilePreviewError)('preview-fetch', e);
            if (!preview) {
                setStatus('error');
                setError(wrappedError);
            } else // If there is already a preview, we consider it a non-critical error
            setNonCriticalError(wrappedError);
        });
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $eUqFw.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $jvF4x.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $iP4HA.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $jvF4x.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $iP4HA.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $iP4HA.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $jvF4x.isLocalPreview)(failedPreview);
        const isRemote = (0, $jvF4x.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $kj8oZ.ImageLoadError)(failedPreview?.source);
            (0, $jyk7o.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $eUqFw.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $jvF4x.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $jvF4x.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $862c0.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps
    };
};

});
parcelRegister("RBcRl", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $d6b826f28e3bf18f$export$90ff537b0999afb);

var $eUqFw = parcelRequire("eUqFw");

var $kJ7yF = parcelRequire("kJ7yF");

var $eC7jK = parcelRequire("eC7jK");
function $d6b826f28e3bf18f$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false } = options;
    const mediaClient = (0, $kJ7yF.useMediaClient)();
    const fileState = (0, $eC7jK.useMediaStore)((state)=>state.files[id]);
    (0, $eUqFw.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("eC7jK", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $7ebccbb6e4a1c8db$export$8a9cc8c330400af8);

var $k4N4B = parcelRequire("k4N4B");

var $kJ7yF = parcelRequire("kJ7yF");
const $7ebccbb6e4a1c8db$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $k4N4B.useStore)(store, selector, equals);
function $7ebccbb6e4a1c8db$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $kJ7yF.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $7ebccbb6e4a1c8db$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("k4N4B", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $0605707b4ba00383$export$6ccbb43953eebf8);

var $gQVOz = parcelRequire("gQVOz");

var $eUqFw = parcelRequire("eUqFw");

var $d5G6h = parcelRequire("d5G6h");
var $0605707b4ba00383$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $0605707b4ba00383$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw)));
const { useSyncExternalStoreWithSelector: $0605707b4ba00383$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($d5G6h)));
let $0605707b4ba00383$var$didWarnAboutEqualityFn = false;
const $0605707b4ba00383$var$identity = (arg)=>arg;
function $0605707b4ba00383$export$6ccbb43953eebf8(api, selector = $0605707b4ba00383$var$identity, equalityFn) {
    if (($0605707b4ba00383$import_meta.env ? $0605707b4ba00383$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$0605707b4ba00383$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $0605707b4ba00383$var$didWarnAboutEqualityFn = true;
    }
    const slice = $0605707b4ba00383$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $0605707b4ba00383$var$useDebugValue(slice);
    return slice;
}
const $0605707b4ba00383$var$createImpl = (createState)=>{
    if (($0605707b4ba00383$import_meta.env ? $0605707b4ba00383$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $gQVOz.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$0605707b4ba00383$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $0605707b4ba00383$export$185802fd694ee1f5 = (createState)=>createState ? $0605707b4ba00383$var$createImpl(createState) : $0605707b4ba00383$var$createImpl;
var $0605707b4ba00383$export$2e2bcd8739ae039 = (createState)=>{
    if (($0605707b4ba00383$import_meta.env ? $0605707b4ba00383$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $0605707b4ba00383$export$185802fd694ee1f5(createState);
};

});
parcelRegister("d5G6h", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1ZzZb"));

});
parcelRegister("1ZzZb", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $173766f8d19e6ee9$export$bf730a2d8bf68b42, (v) => $173766f8d19e6ee9$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $173766f8d19e6ee9$export$bf730a2d8bf68b42;
'use strict';

var $eUqFw = parcelRequire("eUqFw");

var $7rCff = parcelRequire("7rCff");
function $173766f8d19e6ee9$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $173766f8d19e6ee9$var$q = "function" === typeof Object.is ? Object.is : $173766f8d19e6ee9$var$p, $173766f8d19e6ee9$var$r = $7rCff.useSyncExternalStore, $173766f8d19e6ee9$var$t = $eUqFw.useRef, $173766f8d19e6ee9$var$u = $eUqFw.useEffect, $173766f8d19e6ee9$var$v = $eUqFw.useMemo, $173766f8d19e6ee9$var$w = $eUqFw.useDebugValue;
$173766f8d19e6ee9$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $173766f8d19e6ee9$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $173766f8d19e6ee9$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($173766f8d19e6ee9$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $173766f8d19e6ee9$var$r(a, c[0], c[1]);
    $173766f8d19e6ee9$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $173766f8d19e6ee9$var$w(d);
    return d;
};

});
parcelRegister("7rCff", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ekNRM"));

});
parcelRegister("ekNRM", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $a6f99d656c9e333c$export$306c0aa65ff9ec16, (v) => $a6f99d656c9e333c$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a6f99d656c9e333c$export$306c0aa65ff9ec16;
'use strict';

var $eUqFw = parcelRequire("eUqFw");
function $a6f99d656c9e333c$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a6f99d656c9e333c$var$k = "function" === typeof Object.is ? Object.is : $a6f99d656c9e333c$var$h, $a6f99d656c9e333c$var$l = $eUqFw.useState, $a6f99d656c9e333c$var$m = $eUqFw.useEffect, $a6f99d656c9e333c$var$n = $eUqFw.useLayoutEffect, $a6f99d656c9e333c$var$p = $eUqFw.useDebugValue;
function $a6f99d656c9e333c$var$q(a, b) {
    var d = b(), f = $a6f99d656c9e333c$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $a6f99d656c9e333c$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $a6f99d656c9e333c$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $a6f99d656c9e333c$var$m(function() {
        $a6f99d656c9e333c$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $a6f99d656c9e333c$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $a6f99d656c9e333c$var$p(d);
    return d;
}
function $a6f99d656c9e333c$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$a6f99d656c9e333c$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $a6f99d656c9e333c$var$t(a, b) {
    return b();
}
var $a6f99d656c9e333c$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $a6f99d656c9e333c$var$t : $a6f99d656c9e333c$var$q;
$a6f99d656c9e333c$export$306c0aa65ff9ec16 = void 0 !== $eUqFw.useSyncExternalStore ? $eUqFw.useSyncExternalStore : $a6f99d656c9e333c$var$u;

});







parcelRegister("iP4HA", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $9e13c15b19442f5f$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $9e13c15b19442f5f$export$768c370ed0dbaeb3);

var $eKK8L = parcelRequire("eKK8L");
var $7aQon = parcelRequire("7aQon");

var $kj8oZ = parcelRequire("kj8oZ");
const $9e13c15b19442f5f$export$29aa614726672b2e = (error)=>{
    if ((0, $kj8oZ.isMediaFilePreviewError)(error) && !!error.secondaryError) {
        if ((0, $7aQon.isRequestError)(error.secondaryError)) return error.secondaryError.metadata?.traceContext;
        else if ((0, $kj8oZ.isMediaFileStateError)(error.secondaryError)) return error.secondaryError.details?.metadata?.traceContext;
    }
};
const $9e13c15b19442f5f$export$4af9d71992e89714 = (error)=>{
    if ((0, $kj8oZ.isMediaFilePreviewError)(error)) return error.primaryReason;
    else return 'nativeError';
};
const $9e13c15b19442f5f$export$88c61dcad53762da = (error)=>{
    if ((0, $kj8oZ.isMediaFilePreviewError)(error) && error.secondaryError) {
        const mediaClientReason = (0, $kj8oZ.isMediaFileStateError)(error.secondaryError) ? (0, $kj8oZ.getFileStateErrorReason)(error.secondaryError) : (0, $eKK8L.getMediaClientErrorReason)(error.secondaryError);
        if (mediaClientReason !== 'unknown') return mediaClientReason;
    }
    return 'nativeError';
};
const $9e13c15b19442f5f$export$9ccc5365d056da4b = (error)=>{
    if ((0, $kj8oZ.isMediaFilePreviewError)(error) && error.secondaryError) return error.secondaryError.message;
    else return error.message;
};
const $9e13c15b19442f5f$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $9e13c15b19442f5f$export$4af9d71992e89714(error),
        error: $9e13c15b19442f5f$export$88c61dcad53762da(error),
        errorDetail: $9e13c15b19442f5f$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $9e13c15b19442f5f$export$29aa614726672b2e(error)
    };
};
const $9e13c15b19442f5f$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$9e13c15b19442f5f$export$74aaf4784c2edb2c(new (0, $kj8oZ.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("kj8oZ", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $ee0c6ebccdf3d6b2$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $ee0c6ebccdf3d6b2$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $ee0c6ebccdf3d6b2$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $ee0c6ebccdf3d6b2$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $ee0c6ebccdf3d6b2$export$d0a45ab59b4606b);
$parcel$export(module.exports, "isMediaFilePreviewError", () => $ee0c6ebccdf3d6b2$export$553696a6e769784c);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $ee0c6ebccdf3d6b2$export$7156ce7b78b49bd7);
$parcel$export(module.exports, "isMediaFileStateError", () => $ee0c6ebccdf3d6b2$export$166a250c03366459);
$parcel$export(module.exports, "getFileStateErrorReason", () => $ee0c6ebccdf3d6b2$export$2e87e6d20b09376d);

var $gqduQ = parcelRequire("gqduQ");
class $ee0c6ebccdf3d6b2$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $ee0c6ebccdf3d6b2$export$2c035820a31723e extends $ee0c6ebccdf3d6b2$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
    }
}
class $ee0c6ebccdf3d6b2$export$10ab445310d30114 extends $ee0c6ebccdf3d6b2$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
    }
}
class $ee0c6ebccdf3d6b2$export$18e89b7e50818288 extends $ee0c6ebccdf3d6b2$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
    }
}
const $ee0c6ebccdf3d6b2$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $ee0c6ebccdf3d6b2$export$d0a45ab59b4606b extends $ee0c6ebccdf3d6b2$export$96e559194c287cf4 {
    constructor(source){
        super($ee0c6ebccdf3d6b2$var$getImageLoadPrimaryReason(source));
    }
}
function $ee0c6ebccdf3d6b2$export$553696a6e769784c(err) {
    return err instanceof $ee0c6ebccdf3d6b2$export$96e559194c287cf4;
}
const $ee0c6ebccdf3d6b2$export$b380593ba3516c6f = (err)=>err instanceof $ee0c6ebccdf3d6b2$export$2c035820a31723e;
const $ee0c6ebccdf3d6b2$export$e1d87830b3784f94 = (err)=>err instanceof $ee0c6ebccdf3d6b2$export$10ab445310d30114;
const $ee0c6ebccdf3d6b2$export$443aeb298d35d79d = (err)=>$ee0c6ebccdf3d6b2$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $ee0c6ebccdf3d6b2$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($ee0c6ebccdf3d6b2$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $ee0c6ebccdf3d6b2$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $ee0c6ebccdf3d6b2$export$96e559194c287cf4(primaryReason, error);
};
function $ee0c6ebccdf3d6b2$export$166a250c03366459(err) {
    return err instanceof (0, $gqduQ.MediaFileStateError);
}
function $ee0c6ebccdf3d6b2$export$2e87e6d20b09376d(err) {
    return err.details?.reason ?? 'unknown';
}

});
parcelRegister("gqduQ", function(module, exports) {

$parcel$export(module.exports, "MediaFileStateError", () => $bbb89c3abac14beb$export$38242da09b559a);
class $bbb89c3abac14beb$export$38242da09b559a extends Error {
    constructor(id, reason, message = '', details){
        super(reason);
        this.id = id;
        this.reason = reason;
        this.message = message;
        this.details = details;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}

});



parcelRegister("jvF4x", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $50ac7c582533743d$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $50ac7c582533743d$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $50ac7c582533743d$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $50ac7c582533743d$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $50ac7c582533743d$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $50ac7c582533743d$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $50ac7c582533743d$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $50ac7c582533743d$export$98e935d981c884d);

var $1p7md = parcelRequire("1p7md");

var $kj8oZ = parcelRequire("kj8oZ");

var $jyk7o = parcelRequire("jyk7o");

var $1eI0l = parcelRequire("1eI0l");
const $50ac7c582533743d$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $1p7md.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $jyk7o.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $50ac7c582533743d$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $1p7md.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $kj8oZ.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $50ac7c582533743d$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $50ac7c582533743d$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $50ac7c582533743d$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $50ac7c582533743d$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $50ac7c582533743d$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $50ac7c582533743d$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $1eI0l.getRemotePreview)(mediaClient, id, params, traceContext);
    return $50ac7c582533743d$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $50ac7c582533743d$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $1eI0l.getLocalPreview)(filePreview);
    return $50ac7c582533743d$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("1p7md", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $8948517ceba57403$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $8948517ceba57403$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $8948517ceba57403$export$e51a8146182600b8);
const $8948517ceba57403$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $8948517ceba57403$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$8948517ceba57403$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $8948517ceba57403$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $8948517ceba57403$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $8948517ceba57403$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $8948517ceba57403$var$getStringFromParams(params, 'collection'),
        alt: $8948517ceba57403$var$getStringFromParams(params, 'alt'),
        height: $8948517ceba57403$var$getNumberFromParams(params, 'height'),
        width: $8948517ceba57403$var$getNumberFromParams(params, 'width'),
        size: $8948517ceba57403$var$getNumberFromParams(params, 'size'),
        name: $8948517ceba57403$var$getStringFromParams(params, 'name'),
        mimeType: $8948517ceba57403$var$getStringFromParams(params, 'mimeType')
    };
};
const $8948517ceba57403$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $8948517ceba57403$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$8948517ceba57403$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $8948517ceba57403$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("jyk7o", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $a222999f2a3917ca$export$b7e8ee3f7a41459);

var $fxEZn = parcelRequire("fxEZn");
const $a222999f2a3917ca$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $a222999f2a3917ca$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $a222999f2a3917ca$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $a222999f2a3917ca$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $a222999f2a3917ca$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $a222999f2a3917ca$export$b7e8ee3f7a41459 = new $a222999f2a3917ca$export$7b50526c091bb915((0, $fxEZn.createObjectURLCache)());

});
parcelRegister("fxEZn", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $3fcfa7c3b88343f6$export$ba71be67d5c32535);

var $4FH8r = parcelRequire("4FH8r");

var $6roQF = parcelRequire("6roQF");
const $3fcfa7c3b88343f6$export$36d0f9859761643d = 50;
class $3fcfa7c3b88343f6$var$ExtendedLRUCache extends (0, $6roQF.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $4FH8r.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $3fcfa7c3b88343f6$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $3fcfa7c3b88343f6$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $3fcfa7c3b88343f6$export$ba71be67d5c32535 = ()=>new $3fcfa7c3b88343f6$export$75d1c8c9ba1d0773($3fcfa7c3b88343f6$export$36d0f9859761643d);

});


parcelRegister("1eI0l", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $3baf1546cf72426c$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3baf1546cf72426c$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3baf1546cf72426c$export$bfe20bd01db02b3);

var $3izHV = parcelRequire("3izHV");

var $dZWOK = parcelRequire("dZWOK");

var $kj8oZ = parcelRequire("kj8oZ");

var $3J2hq = parcelRequire("3J2hq");
const $3baf1546cf72426c$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3baf1546cf72426c$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $dZWOK.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $kj8oZ.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3baf1546cf72426c$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $3J2hq.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $kj8oZ.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3baf1546cf72426c$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $kj8oZ.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $3izHV.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3baf1546cf72426c$var$getImageLocalPreview(value);
            case 'video':
                return $3baf1546cf72426c$var$getVideoLocalPreview(value);
            default:
                throw new (0, $kj8oZ.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $kj8oZ.LocalPreviewError)('local-preview-unsupported');
};
const $3baf1546cf72426c$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $kj8oZ.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("dZWOK", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $20d9cb8065ed9c55$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $20d9cb8065ed9c55$export$67689507e8404821);

var $7Ks1a = parcelRequire("7Ks1a");

var $dcjbt = parcelRequire("dcjbt");

var $7R2PQ = parcelRequire("7R2PQ");

var $hTKdV = parcelRequire("hTKdV");
const { Orientation: $20d9cb8065ed9c55$var$Orientation, XResolution: $20d9cb8065ed9c55$var$XResolution } = (0, $7Ks1a.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $20d9cb8065ed9c55$var$DPI_WEB_BASELINE = 72;
async function $20d9cb8065ed9c55$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $20d9cb8065ed9c55$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $20d9cb8065ed9c55$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $20d9cb8065ed9c55$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $20d9cb8065ed9c55$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $20d9cb8065ed9c55$var$DPI_WEB_BASELINE;
        else return $20d9cb8065ed9c55$export$268f92356524130b(tags, $20d9cb8065ed9c55$var$XResolution, $20d9cb8065ed9c55$var$DPI_WEB_BASELINE) / $20d9cb8065ed9c55$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $20d9cb8065ed9c55$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$20d9cb8065ed9c55$var$Orientation]) {
        const tagValue = tags[$20d9cb8065ed9c55$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $7Ks1a.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $20d9cb8065ed9c55$export$67689507e8404821(file) {
    const tags = await (0, $dcjbt.readImageMetaTags)(file);
    return $20d9cb8065ed9c55$var$getOrientationFromTags(tags);
}
function $20d9cb8065ed9c55$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $20d9cb8065ed9c55$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $20d9cb8065ed9c55$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $dcjbt.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $20d9cb8065ed9c55$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $20d9cb8065ed9c55$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $7R2PQ.loadImage)(src);
        const { width: width, height: height } = (0, $7R2PQ.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("7Ks1a", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $3451dd865f26bcbe$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $3451dd865f26bcbe$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $3451dd865f26bcbe$export$f6ea0c89fd7d156);
var $3451dd865f26bcbe$export$48c85e6e32ef0825;
(function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
})($3451dd865f26bcbe$export$48c85e6e32ef0825 || ($3451dd865f26bcbe$export$48c85e6e32ef0825 = {}));
var $3451dd865f26bcbe$export$e369bb48cf33e564;
(function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
})($3451dd865f26bcbe$export$e369bb48cf33e564 || ($3451dd865f26bcbe$export$e369bb48cf33e564 = {}));
const $3451dd865f26bcbe$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("dcjbt", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $3968a72b4e3e5571$export$41982b5c7acb23c4);

var $7Ks1a = parcelRequire("7Ks1a");

var $90lR8 = parcelRequire("90lR8");

var $932a4 = parcelRequire("932a4");

var $g4zYY = parcelRequire("g4zYY");
async function $3968a72b4e3e5571$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $7Ks1a.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $932a4.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $g4zYY.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $7Ks1a.ImageType).JPEG) return await (0, $90lR8.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("90lR8", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $3cfacf7fa7775806$export$556b2ccec62d7f2a);

var $7Ks1a = parcelRequire("7Ks1a");
const { XResolution: $3cfacf7fa7775806$var$XResolution, YResolution: $3cfacf7fa7775806$var$YResolution } = (0, $7Ks1a.SupportedImageMetaTag);
let $3cfacf7fa7775806$var$loadImage;

function $3cfacf7fa7775806$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$3cfacf7fa7775806$var$loadImage) {
            const module = await (parcelRequire("al79X"));
            $3cfacf7fa7775806$var$loadImage = module.default || module;
        }
        $3cfacf7fa7775806$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $3cfacf7fa7775806$var$XResolution || key === $3cfacf7fa7775806$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("al79X", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4EQ6s").then(()=>parcelRequire('hB5r9'));

});


parcelRegister("932a4", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $d107ad611f184457$export$5fb37736440fca6f);

var $7R2PQ = parcelRequire("7R2PQ");
let $d107ad611f184457$var$pngChunksExtract;

async function $d107ad611f184457$export$5fb37736440fca6f(file) {
    if (!$d107ad611f184457$var$pngChunksExtract) {
        const module = await (parcelRequire("iz6F4"));
        $d107ad611f184457$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $7R2PQ.fileToArrayBuffer)(file);
    const chunks = $d107ad611f184457$var$pngChunksExtract(buffer);
    return await $d107ad611f184457$export$9185743fdd58ce45(chunks);
}
async function $d107ad611f184457$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("7R2PQ", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $762b6f6dab9d1b7f$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $762b6f6dab9d1b7f$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $762b6f6dab9d1b7f$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $762b6f6dab9d1b7f$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $762b6f6dab9d1b7f$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $762b6f6dab9d1b7f$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $762b6f6dab9d1b7f$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $762b6f6dab9d1b7f$export$61a1de0822e2820);

var $hdGyo = parcelRequire("hdGyo");

var $8LNkR = parcelRequire("8LNkR");

var $eCjZE = parcelRequire("eCjZE");

var $9x8bE = parcelRequire("9x8bE");

var $eKyyR = parcelRequire("eKyyR");

var $3WWqq = parcelRequire("3WWqq");

var $hq1pc = parcelRequire("hq1pc");

var $2qasA = parcelRequire("2qasA");

var $dMHxL = parcelRequire("dMHxL");

var $bMNrG = parcelRequire("bMNrG");

var $h7CpT = parcelRequire("h7CpT");

var $6Wxq8 = parcelRequire("6Wxq8");

var $h5uIF = parcelRequire("h5uIF");

var $3FCIk = parcelRequire("3FCIk");

var $3NApm = parcelRequire("3NApm");

var $1OdUR = parcelRequire("1OdUR");
function $762b6f6dab9d1b7f$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $762b6f6dab9d1b7f$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $762b6f6dab9d1b7f$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $762b6f6dab9d1b7f$export$849633012686f7ee(file)
    };
}
async function $762b6f6dab9d1b7f$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $762b6f6dab9d1b7f$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $762b6f6dab9d1b7f$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $762b6f6dab9d1b7f$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $762b6f6dab9d1b7f$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $762b6f6dab9d1b7f$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $762b6f6dab9d1b7f$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hdGyo)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dMHxL)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($h7CpT)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dMHxL)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bMNrG)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qasA)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9x8bE)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3FCIk)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eCjZE)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8LNkR)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($h5uIF)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6Wxq8)))
    }
];
function $762b6f6dab9d1b7f$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $762b6f6dab9d1b7f$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $1OdUR.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3NApm)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eKyyR)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3WWqq)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hq1pc)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("hdGyo", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c894a8df21fa5c84$var$_react = $c894a8df21fa5c84$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c894a8df21fa5c84$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c894a8df21fa5c84$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $c894a8df21fa5c84$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869v1.546zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665v3.715zM4.462 15.99h-1.08A.384.384 0 013 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 01-.383.384zm7.45 0h-2.24a.384.384 0 01-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506zm5.776 0h-1.08a.384.384 0 01-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 01-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 01-.383.384z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c894a8df21fa5c84$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $c894a8df21fa5c84$var$_default = $c894a8df21fa5c84$var$PdfDocument24Icon;
module.exports.default = $c894a8df21fa5c84$var$_default;

});

parcelRegister("8LNkR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6628fb7cf0e02b12$var$_react = $6628fb7cf0e02b12$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6628fb7cf0e02b12$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6628fb7cf0e02b12$var$Gif24Icon = (props)=>/*#__PURE__*/ $6628fb7cf0e02b12$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FFAB00" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm10.564 16.636h-1.93a.243.243 0 01-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 01-.243.243m3.79 0h-1.931a.243.243 0 01-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 01-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.241.241 0 01-.242.258H8.195a.243.243 0 01-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 01-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$6628fb7cf0e02b12$var$Gif24Icon.displayName = 'Gif24Icon';
var $6628fb7cf0e02b12$var$_default = $6628fb7cf0e02b12$var$Gif24Icon;
module.exports.default = $6628fb7cf0e02b12$var$_default;

});

parcelRegister("eCjZE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $aa441f8cde622841$var$_react = $aa441f8cde622841$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $aa441f8cde622841$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $aa441f8cde622841$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $aa441f8cde622841$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#CA5010" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1.376 6.013A.437.437 0 004 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 00.497-.434V4.868a.437.437 0 00-.499-.434L4.376 6.014zM17 7v10h2.5a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5H17zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.421-2.514 2.421H9.329V15.5H7.854V8.454zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231H9.33z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$aa441f8cde622841$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $aa441f8cde622841$var$_default = $aa441f8cde622841$var$PowerpointPresentation24Icon;
module.exports.default = $aa441f8cde622841$var$_default;

});

parcelRegister("9x8bE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6f0d8bdcc8cbb422$var$_react = $6f0d8bdcc8cbb422$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6f0d8bdcc8cbb422$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6f0d8bdcc8cbb422$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $6f0d8bdcc8cbb422$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1D7AFC" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1.376 6.013A.437.437 0 004 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 00.497-.434V4.868a.437.437 0 00-.499-.434L4.376 6.014zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663h-.078zM17 7v10h2.5a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5H17z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$6f0d8bdcc8cbb422$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $6f0d8bdcc8cbb422$var$_default = $6f0d8bdcc8cbb422$var$WordDocument24Icon;
module.exports.default = $6f0d8bdcc8cbb422$var$_default;

});

parcelRegister("eKyyR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $abd02bb672a51ffd$var$_react = $abd02bb672a51ffd$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $abd02bb672a51ffd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $abd02bb672a51ffd$var$Sketch24Icon = (props)=>/*#__PURE__*/ $abd02bb672a51ffd$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FF8B00" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm9.03 20h.001c.29-.001.562-.126.752-.343l6.971-8a1 1 0 00.095-1.185l-2.485-4a1.003 1.003 0 00-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 00.081 1.216l7.03 8c.188.216.462.34.75.34z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$abd02bb672a51ffd$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $abd02bb672a51ffd$var$_default = $abd02bb672a51ffd$var$Sketch24Icon;
module.exports.default = $abd02bb672a51ffd$var$_default;

});

parcelRegister("3WWqq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2e041bec93092120$var$_react = $2e041bec93092120$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2e041bec93092120$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2e041bec93092120$var$Figma24Icon = (props)=>/*#__PURE__*/ $2e041bec93092120$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.248 0A3.248 3.248 0 000 3.248v17.504A3.248 3.248 0 003.248 24h17.504A3.248 3.248 0 0024 20.752V3.248A3.248 3.248 0 0020.752 0H3.248zm8.755 17.012a2.506 2.506 0 01-2.505 2.507 2.506 2.506 0 010-5.013 2.506 2.506 0 010-5.012 2.506 2.506 0 010-5.013h5.009a2.506 2.506 0 010 5.013h-2.505v2.5a2.506 2.506 0 012.505-2.5 2.506 2.506 0 010 5.012 2.506 2.506 0 01-2.505-2.5v5.006z" fill="#8270DB"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2e041bec93092120$var$Figma24Icon.displayName = 'Figma24Icon';
var $2e041bec93092120$var$_default = $2e041bec93092120$var$Figma24Icon;
module.exports.default = $2e041bec93092120$var$_default;

});

parcelRegister("hq1pc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $cae5f47c2a571309$var$_react = $cae5f47c2a571309$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $cae5f47c2a571309$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $cae5f47c2a571309$var$Executable24Icon = (props)=>/*#__PURE__*/ $cae5f47c2a571309$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm2 13v5a1 1 0 001 1h12a1 1 0 001-1v-5H5zm1.883-8a1 1 0 00-.992.876L5 13h14l-.89-7.124A1 1 0 0017.116 5H6.883zM8 15h8a1 1 0 010 2H8a1 1 0 010-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$cae5f47c2a571309$var$Executable24Icon.displayName = 'Executable24Icon';
var $cae5f47c2a571309$var$_default = $cae5f47c2a571309$var$Executable24Icon;
module.exports.default = $cae5f47c2a571309$var$_default;

});

parcelRegister("2qasA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1c361fa263fe065a$var$_react = $1c361fa263fe065a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $1c361fa263fe065a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1c361fa263fe065a$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $1c361fa263fe065a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196F3" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm12.049 5l-5.422.055 4.677 8.15 5.422-.055L15.049 5zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697L4 14.108zm6.646.141L7.982 19h9.354L20 14.249h-9.354z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1c361fa263fe065a$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $1c361fa263fe065a$var$_default = $1c361fa263fe065a$var$GoogleDoc24Icon;
module.exports.default = $1c361fa263fe065a$var$_default;

});

parcelRegister("dMHxL", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a09188e84ea7ab45$var$_react = $a09188e84ea7ab45$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a09188e84ea7ab45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a09188e84ea7ab45$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $a09188e84ea7ab45$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270DB" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm12.049 5l-5.422.055 4.677 8.15 5.422-.055L15.049 5zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697L4 14.108zm6.646.141L7.982 19h9.354L20 14.249h-9.354z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$a09188e84ea7ab45$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $a09188e84ea7ab45$var$_default = $a09188e84ea7ab45$var$GoogleForm24Icon;
module.exports.default = $a09188e84ea7ab45$var$_default;

});

parcelRegister("bMNrG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $894a8844a9a1528d$var$_react = $894a8844a9a1528d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $894a8844a9a1528d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $894a8844a9a1528d$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $894a8844a9a1528d$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0A9D58" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm12.049 5l-5.422.055 4.677 8.15 5.422-.055L15.049 5zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697L4 14.108zm6.646.141L7.982 19h9.354L20 14.249h-9.354z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$894a8844a9a1528d$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $894a8844a9a1528d$var$_default = $894a8844a9a1528d$var$GoogleSheet24Icon;
module.exports.default = $894a8844a9a1528d$var$_default;

});

parcelRegister("h7CpT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c770e3deabcd313a$var$_react = $c770e3deabcd313a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c770e3deabcd313a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c770e3deabcd313a$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $c770e3deabcd313a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FFC107" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm12.049 5l-5.422.055 4.677 8.15 5.422-.055L15.049 5zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697L4 14.108zm6.646.141L7.982 19h9.354L20 14.249h-9.354z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c770e3deabcd313a$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $c770e3deabcd313a$var$_default = $c770e3deabcd313a$var$GoogleSlide24Icon;
module.exports.default = $c770e3deabcd313a$var$_default;

});

parcelRegister("6Wxq8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $50e215742d0d2558$var$_react = $50e215742d0d2558$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $50e215742d0d2558$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $50e215742d0d2558$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $50e215742d0d2558$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22A06B" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1.376 6.013A.437.437 0 004 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 00.497-.434V4.868a.437.437 0 00-.499-.434L4.376 6.014zM17 7v10h2.5a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5H17zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5H6.93z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$50e215742d0d2558$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $50e215742d0d2558$var$_default = $50e215742d0d2558$var$ExcelSpreadsheet24Icon;
module.exports.default = $50e215742d0d2558$var$_default;

});

parcelRegister("h5uIF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c70abb8afd54d479$var$_react = $c70abb8afd54d479$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c70abb8afd54d479$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c70abb8afd54d479$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $c70abb8afd54d479$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36B37E" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm2 5a1 1 0 100 2h3a1 1 0 100-2H5zm0 4a1 1 0 100 2h3a1 1 0 000-2H5zm0 4a1 1 0 000 2h3a1 1 0 000-2H5zm0 4a1 1 0 000 2h3a1 1 0 000-2H5zm7-12a1 1 0 000 2h7a1 1 0 000-2h-7zm0 4a1 1 0 000 2h7a1 1 0 000-2h-7zm0 4a1 1 0 000 2h7a1 1 0 000-2h-7zm0 4a1 1 0 000 2h7a1 1 0 000-2h-7z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c70abb8afd54d479$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $c70abb8afd54d479$var$_default = $c70abb8afd54d479$var$Spreadsheet24Icon;
module.exports.default = $c70abb8afd54d479$var$_default;

});

parcelRegister("3FCIk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2ac33b3cb49c77eb$var$_react = $2ac33b3cb49c77eb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2ac33b3cb49c77eb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2ac33b3cb49c77eb$var$Presentation24Icon = (props)=>/*#__PURE__*/ $2ac33b3cb49c77eb$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270DB" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm3 14a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1zm8-6a1 1 0 00-1 1v9a1 1 0 002 0V9a1 1 0 00-1-1zm-4 4a1 1 0 00-1 1v5a1 1 0 002 0v-5a1 1 0 00-1-1zm8-7a1 1 0 00-1 1v12a1 1 0 002 0V6a1 1 0 00-1-1z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2ac33b3cb49c77eb$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $2ac33b3cb49c77eb$var$_default = $2ac33b3cb49c77eb$var$Presentation24Icon;
module.exports.default = $2ac33b3cb49c77eb$var$_default;

});

parcelRegister("3NApm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2c42309754fc4881$var$_react = $2c42309754fc4881$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2c42309754fc4881$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2c42309754fc4881$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $2c42309754fc4881$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00B8D9" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm5.017 12.265l-2.58-2.501L8.236 7.05a.999.999 0 10-1.392-1.436l-3.54 3.432a1 1 0 000 1.436l3.32 3.219a1 1 0 101.393-1.436zm6.638-8.21a1 1 0 00-1.271.62l-4.83 14.046a1 1 0 001.892.65l4.829-14.045a1 1 0 00-.62-1.271zm6.081 9.776l-3.32-3.219a.999.999 0 10-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 101.392 1.436l3.54-3.432a1 1 0 000-1.436z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2c42309754fc4881$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $2c42309754fc4881$var$_default = $2c42309754fc4881$var$SourceCode24Icon;
module.exports.default = $2c42309754fc4881$var$_default;

});

parcelRegister("1OdUR", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $d49392d0af6b4c2e$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $d49392d0af6b4c2e$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $d49392d0af6b4c2e$export$ba4368c844580f9e);
function $d49392d0af6b4c2e$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $d49392d0af6b4c2e$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $d49392d0af6b4c2e$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $d49392d0af6b4c2e$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $d49392d0af6b4c2e$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $d49392d0af6b4c2e$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $d49392d0af6b4c2e$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("iz6F4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("f26P8").then(()=>parcelRequire('3TpCy'));

});


parcelRegister("g4zYY", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $75e912d905a332c2$export$55c3bc9841b19de2);
function $75e912d905a332c2$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("hTKdV", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $5ac62904b0493085$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $5ac62904b0493085$export$43142f95b8de7a91);
const $5ac62904b0493085$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $5ac62904b0493085$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $5ac62904b0493085$export$43142f95b8de7a91 = (orientation)=>{
    return $5ac62904b0493085$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("3J2hq", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $34418b456963f386$export$4269d30173168e5c);
const $34418b456963f386$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("862c0", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $635d7cc412152f53$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $635d7cc412152f53$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $635d7cc412152f53$export$de7c49925e44d75d);

var $7UQrl = parcelRequire("7UQrl");
const $635d7cc412152f53$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $635d7cc412152f53$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $635d7cc412152f53$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $635d7cc412152f53$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $635d7cc412152f53$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $635d7cc412152f53$var$dashed = (param)=>param ? `-${param}` : '';
const $635d7cc412152f53$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$635d7cc412152f53$var$dashed(collectionName)}${$635d7cc412152f53$var$dashed(occurrenceKey)}`;
const $635d7cc412152f53$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $635d7cc412152f53$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $635d7cc412152f53$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $7UQrl.printFunctionCall)($635d7cc412152f53$export$4310981e0aa4ce67, $635d7cc412152f53$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $7UQrl.printScript)([
        $635d7cc412152f53$export$ede93d4564eaa8da.toString(),
        $635d7cc412152f53$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $635d7cc412152f53$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $635d7cc412152f53$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("7UQrl", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $9e4757ccfa33a587$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $9e4757ccfa33a587$export$8b902fb69a2f17c1);
const $9e4757ccfa33a587$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $9e4757ccfa33a587$var$printParams = (args)=>args.map((arg)=>$9e4757ccfa33a587$var$printParam(arg)).join(',');
const $9e4757ccfa33a587$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$9e4757ccfa33a587$var$printParams(args)});`;
const $9e4757ccfa33a587$export$8b902fb69a2f17c1 = (statements)=>`(function(){
  ${statements.join(';')}
})();
`;

});


parcelRegister("6tTCR", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $88c51d281a1c15e7$export$d3a890b0f7844b6f);

var $862c0 = parcelRequire("862c0");
const $88c51d281a1c15e7$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $862c0.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $862c0.getKey)(identifier)];
};

});

parcelRegister("2GnF5", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $0956df2291cfa61d$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $0956df2291cfa61d$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $0956df2291cfa61d$export$b3e10e1f0fbb71db);

var $eUqFw = parcelRequire("eUqFw");
const $0956df2291cfa61d$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $0956df2291cfa61d$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $0956df2291cfa61d$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $0956df2291cfa61d$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $0956df2291cfa61d$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $eUqFw.useRef)(value);
    ref.current = value;
    return ref;
}

});





parcelRegister("lAZNF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9da50f85288601cf$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9da50f85288601cf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showLess: {
        "id": "issue-table.common.fields.cmdb-object.show-less",
        "defaultMessage": "\u2026 Show less"
    },
    showMore: {
        "id": "issue-table.common.fields.cmdb-object.show-more",
        "defaultMessage": "\u2026 ({numberOfObjects, plural, one {# more} other {# more}})"
    },
    none: {
        "id": "issue-table.common.fields.cmdb-object.none",
        "defaultMessage": "None"
    }
});

});

parcelRegister("ipKLH", function(module, exports) {

$parcel$export(module.exports, "filterEnrichedObjects", () => $aa3841e0178e4d1f$export$91f05c2342ca3f05);
$parcel$export(module.exports, "sortCmdbObjects", () => $aa3841e0178e4d1f$export$51618eba19894675);
const $aa3841e0178e4d1f$var$baseKeys = [
    'id',
    'workspaceId',
    'objectId',
    'objectKey',
    'label',
    'avatar',
    'objectType',
    'links',
    'attributes'
];
const $aa3841e0178e4d1f$export$91f05c2342ca3f05 = (values)=>{
    const isEnrichedObject = (value)=>{
        const keys = Object.keys(value);
        return $aa3841e0178e4d1f$var$baseKeys.every((key)=>keys.includes(key));
    };
    return values.filter(isEnrichedObject);
};
const $aa3841e0178e4d1f$export$51618eba19894675 = (unsortedObjects)=>unsortedObjects.sort((objectOne, objectTwo)=>{
        if (objectOne.label.toLowerCase() < objectTwo.label.toLowerCase()) return -1;
        if (objectOne.label.toLowerCase() > objectTwo.label.toLowerCase()) return 1;
        return 0;
    });

});


parcelRegister("6Gt0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d7703307a47c88e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $5d7703307a47c88e$export$2e2bcd8739ae039(props) {
    const { dataSelectorProps: { value: { displayName: displayName } } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, displayName);
}

});

parcelRegister("7YT7G", function(module, exports) {

$parcel$export(module.exports, "default", () => $8974b8ee4ec2e389$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $90IgZ = parcelRequire("90IgZ");
function $8974b8ee4ec2e389$export$2e2bcd8739ae039(props) {
    const { dataSelectorProps: { value: value } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8974b8ee4ec2e389$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90IgZ.FormattedDate), {
        value: value,
        year: "numeric",
        month: "short",
        day: "numeric"
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8974b8ee4ec2e389$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4wue8 _1i4q1hna",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6QN02", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cbeac74692a4074$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $h89xE = parcelRequire("h89xE");

var $9jf8F = parcelRequire("9jf8F");

var $jU4ta = parcelRequire("jU4ta");
const $8cbeac74692a4074$var$Entitlement = ({ dataSelectorProps: { value: value }, tableInjectedProps: { isLastColumn: isLastColumn } })=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jU4ta.UnselectableChildGutterPaddingContainer), {
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h89xE.ReadView), {
        name: (0, $9jf8F.getNameFromFieldData)(value)
    })) : null;
var $8cbeac74692a4074$export$2e2bcd8739ae039 = $8cbeac74692a4074$var$Entitlement;

});
parcelRegister("h89xE", function(module, exports) {

$parcel$export(module.exports, "ReadView", () => $9575d576fafe3fed$export$a4b5824ec1e018e1);

var $eUqFw = parcelRequire("eUqFw");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hSXNT = parcelRequire("hSXNT");

var $8CtY9 = parcelRequire("8CtY9");
const $9575d576fafe3fed$export$a4b5824ec1e018e1 = ({ name: name })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: [
            $9575d576fafe3fed$var$containerStyles,
            !name && $9575d576fafe3fed$var$placeholderStyles,
            $9575d576fafe3fed$var$overflowStyles,
            $9575d576fafe3fed$var$alignmentFixStyles
        ],
        testId: "servicedesk-customer-service-entitlements-field.common.ui.read-view.inline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hSXNT.LabelIcon), {
        size: "xsmall",
        type: "PRODUCT"
    }), name || formatMessage((0, $8CtY9.default).entitlementFieldPlaceholder));
};
const $9575d576fafe3fed$var$containerStyles = (0, $1ZAYh.xcss)({
    margin: 'space.050'
});
const $9575d576fafe3fed$var$placeholderStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtlest'
});
const $9575d576fafe3fed$var$overflowStyles = (0, $1ZAYh.xcss)({
    overflowWrap: 'anywhere'
});
const $9575d576fafe3fed$var$alignmentFixStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.100'
});

});
parcelRegister("hSXNT", function(module, exports) {

$parcel$export(module.exports, "LabelIcon", () => $88a66dca9a0a6eb8$export$6722f2abd5aa752a);

var $eUqFw = parcelRequire("eUqFw");

var $cI2j2 = parcelRequire("cI2j2");

var $6XYP2 = parcelRequire("6XYP2");

var $k0AQe = parcelRequire("k0AQe");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $8rQuz = parcelRequire("8rQuz");
const $88a66dca9a0a6eb8$export$6722f2abd5aa752a = ({ size: size, type: type, label: label = '', testId: testId, ...etc })=>{
    const Icon = type === 'ORGANIZATION' ? (0, (/*@__PURE__*/$parcel$interopDefault($6XYP2))) : (0, (/*@__PURE__*/$parcel$interopDefault($k0AQe)));
    const iconSize = size === 'large' ? 'large' : 'small';
    const isLarge = size === 'large';
    if ((0, $8rQuz.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $88a66dca9a0a6eb8$var$containerStyles,
            size === 'small' && $88a66dca9a0a6eb8$var$smallStyles,
            size === 'xsmall' && $88a66dca9a0a6eb8$var$xsmallStyles
        ],
        testId: testId
    }, isLarge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cI2j2.default), {
        icon: Icon,
        appearance: "gray",
        shape: "square",
        size: "40",
        label: label
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        color: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        label: label,
        ...etc
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $88a66dca9a0a6eb8$var$containerStyles,
            size === 'large' && $88a66dca9a0a6eb8$var$largeStyles,
            size === 'small' && $88a66dca9a0a6eb8$var$smallStyles,
            size === 'xsmall' && $88a66dca9a0a6eb8$var$xsmallStyles
        ],
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        LEGACY_primaryColor: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        LEGACY_size: iconSize,
        label: label,
        ...etc
    }));
};
const $88a66dca9a0a6eb8$var$containerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    backgroundColor: 'color.background.neutral'
});
const $88a66dca9a0a6eb8$var$largeStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    padding: 'space.050'
});
const $88a66dca9a0a6eb8$var$smallStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.050',
    padding: 'space.050'
});
const $88a66dca9a0a6eb8$var$xsmallStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.050',
    padding: 'space.025'
});

});
parcelRegister("cI2j2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fb8d50dcfc24c9b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");
function $1fb8d50dcfc24c9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1fb8d50dcfc24c9b$var$sizeMap = {
    '16': {
        name: "157xhr7",
        styles: "width:16px;height:16px"
    },
    '24': {
        name: "rrel8y",
        styles: "width:24px;height:24px"
    },
    '32': {
        name: "68x97p",
        styles: "width:32px;height:32px"
    },
    '40': {
        name: "1mfsro6",
        styles: "width:40px;height:40px"
    },
    '48': {
        name: "18jhpep",
        styles: "width:48px;height:48px"
    }
};
const $1fb8d50dcfc24c9b$var$appearanceMap = {
    grayBold: {
        name: "algye9",
        styles: "background-color:var(--ds-background-accent-gray-bolder, #626F86);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    limeBold: {
        name: "a86nvv",
        styles: "background-color:var(--ds-background-accent-lime-bolder, #5B7F24);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    greenBold: {
        name: "13e2qqr",
        styles: "background-color:var(--ds-background-accent-green-bolder, #1F845A);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    blueBold: {
        name: "jpsdma",
        styles: "background-color:var(--ds-background-accent-blue-bolder, #0C66E4);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    redBold: {
        name: "1bg8y7a",
        styles: "background-color:var(--ds-background-accent-red-bolder, #C9372C);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    purpleBold: {
        name: "19bo3lb",
        styles: "background-color:var(--ds-background-accent-purple-bolder, #6E5DC6);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    magentaBold: {
        name: "1l16rgo",
        styles: "background-color:var(--ds-background-accent-magenta-bolder, #AE4787);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    tealBold: {
        name: "7kw5zl",
        styles: "background-color:var(--ds-background-accent-teal-bolder, #227D9B);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    orangeBold: {
        name: "h77eay",
        styles: "background-color:var(--ds-background-accent-orange-bolder, #C25100);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    yellowBold: {
        name: "sbe4w3",
        styles: "background-color:var(--ds-background-accent-yellow-bolder, #946F00);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    gray: {
        name: "yxgei8",
        styles: "background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);color:var(--ds-icon-accent-gray, #758195)"
    },
    lime: {
        name: "o9c6oh",
        styles: "background-color:var(--ds-background-accent-lime-subtler, #D3F1A7);color:var(--ds-icon-accent-lime, #6A9A23)"
    },
    orange: {
        name: "szqzk5",
        styles: "background-color:var(--ds-background-accent-orange-subtler, #FEDEC8);color:var(--ds-icon-accent-orange, #E56910)"
    },
    magenta: {
        name: "o6ptuw",
        styles: "background-color:var(--ds-background-accent-magenta-subtler, #FDD0EC);color:var(--ds-icon-accent-magenta, #CD519D)"
    },
    green: {
        name: "157dg7e",
        styles: "background-color:var(--ds-background-accent-green-subtler, #BAF3DB);color:var(--ds-icon-accent-green, #22A06B)"
    },
    blue: {
        name: "x3nujl",
        styles: "background-color:var(--ds-background-accent-blue-subtler, #CCE0FF);color:var(--ds-icon-accent-blue, #1D7AFC)"
    },
    red: {
        name: "zqoyws",
        styles: "background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-icon-accent-red, #C9372C)"
    },
    purple: {
        name: "fitjkd",
        styles: "background-color:var(--ds-background-accent-purple-subtler, #DFD8FD);color:var(--ds-icon-accent-purple, #8270DB)"
    },
    teal: {
        name: "b3m1ww",
        styles: "background-color:var(--ds-background-accent-teal-subtler, #C6EDFB);color:var(--ds-icon-accent-teal, #2898BD)"
    },
    yellow: {
        name: "1j18jub",
        styles: "background-color:var(--ds-background-accent-yellow-subtler, #F8E6A0);color:var(--ds-icon-accent-yellow, #B38600)"
    }
};
const $1fb8d50dcfc24c9b$var$shapeMap = {
    square: {
        name: "vwdoqr",
        styles: "border-radius:var(--ds-border-radius-100, 4px)"
    },
    circle: {
        name: "i2ucdk",
        styles: "border-radius:var(--ds-border-radius-circle, 32032px)"
    }
};
const $1fb8d50dcfc24c9b$var$iconTileStyles = {
    name: "ykimcl",
    styles: "display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center"
};
function $1fb8d50dcfc24c9b$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent } = props;
    const ExpandedIcon = Icon;
    if (LEGACY_fallbackComponent && !(0, $XHGTv.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $1fb8d50dcfc24c9b$var$iconTileStyles,
            $1fb8d50dcfc24c9b$var$appearanceMap[appearance],
            $1fb8d50dcfc24c9b$var$sizeMap[size],
            $1fb8d50dcfc24c9b$var$shapeMap[shape]
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)(ExpandedIcon, {
        color: "currentColor",
        label: label,
        spacing: "spacious",
        shouldScale: true
    }));
}

});

parcelRegister("6XYP2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::256a7838c06b0fb117b2e3d975619c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $51276ec517a23412$var$_react = $51276ec517a23412$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $51276ec517a23412$var$_officeBuilding = $51276ec517a23412$var$_interopRequireDefault((parcelRequire("jaf6K")));

var $51276ec517a23412$var$_officeBuildingFilled = $51276ec517a23412$var$_interopRequireDefault((parcelRequire("bKtyL")));
function $51276ec517a23412$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for OfficeBuildingIcon.
 * This component is OfficeBuildingIcon, with `UNSAFE_fallbackIcon` set to "OfficeBuildingFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $51276ec517a23412$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $51276ec517a23412$var$_react.default.createElement($51276ec517a23412$var$_officeBuilding.default, Object.assign({
        LEGACY_fallbackIcon: $51276ec517a23412$var$_officeBuildingFilled.default
    }, props));
$51276ec517a23412$var$OfficeBuildingIcon.Name = 'OfficeBuildingIconMigration';
var $51276ec517a23412$var$_default = module.exports.default = $51276ec517a23412$var$OfficeBuildingIcon;

});
parcelRegister("jaf6K", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b55a6def56fbc22d2b935e40630a784e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df3aab978cc1c9fb$var$_react = $df3aab978cc1c9fb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $df3aab978cc1c9fb$var$_UNSAFE_baseNew = $df3aab978cc1c9fb$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $df3aab978cc1c9fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $df3aab978cc1c9fb$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $df3aab978cc1c9fb$var$_react.default.createElement($df3aab978cc1c9fb$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15.25V2c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v13.25m10.5 0h-3.5m3.5 0H15m-12.25 0h3.5m-3.5 0H1m4-11.5h2m2 0h2m0 3H9m-2 0H5m1.25 8.5v-4.5h3.5v4.5m-3.5 0h3.5"/>`
    }, props));
$df3aab978cc1c9fb$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $df3aab978cc1c9fb$var$_default = module.exports.default = $df3aab978cc1c9fb$var$OfficeBuildingIcon;

});

parcelRegister("bKtyL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88daeb8328df15a4$var$_react = $88daeb8328df15a4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $88daeb8328df15a4$var$_officeBuilding = $88daeb8328df15a4$var$_interopRequireDefault((parcelRequire("jaf6K")));
function $88daeb8328df15a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $88daeb8328df15a4$var$OfficeBuildingFilledIcon = (props)=>/*#__PURE__*/ $88daeb8328df15a4$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8z"/><path fill="inherit" d="M6 10h2v2H6zm0 3h2v2H6z"/><path fill="currentcolor" d="M9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/><path fill="inherit" d="M12 7h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/></g></svg>`
    }, props, {
        newIcon: $88daeb8328df15a4$var$_officeBuilding.default
    }));
$88daeb8328df15a4$var$OfficeBuildingFilledIcon.displayName = 'OfficeBuildingFilledIcon';
var $88daeb8328df15a4$var$_default = module.exports.default = $88daeb8328df15a4$var$OfficeBuildingFilledIcon;

});


parcelRegister("k0AQe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc3e2ac12fe298d80752bca3205608ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e91062b4221ea369$var$_react = $e91062b4221ea369$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $e91062b4221ea369$var$_tag = $e91062b4221ea369$var$_interopRequireDefault((parcelRequire("kBeAb")));

var $e91062b4221ea369$var$_label = $e91062b4221ea369$var$_interopRequireDefault((parcelRequire("2OpmI")));
function $e91062b4221ea369$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for TagIcon.
 * This component is TagIcon, with `UNSAFE_fallbackIcon` set to "LabelIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e91062b4221ea369$var$TagIcon = (props)=>/*#__PURE__*/ $e91062b4221ea369$var$_react.default.createElement($e91062b4221ea369$var$_tag.default, Object.assign({
        LEGACY_fallbackIcon: $e91062b4221ea369$var$_label.default
    }, props));
$e91062b4221ea369$var$TagIcon.Name = 'TagIconMigration';
var $e91062b4221ea369$var$_default = module.exports.default = $e91062b4221ea369$var$TagIcon;

});
parcelRegister("kBeAb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45c2d4e51182b362766f8bfa1893feb7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eff293281ade4b06$var$_react = $eff293281ade4b06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $eff293281ade4b06$var$_UNSAFE_baseNew = $eff293281ade4b06$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $eff293281ade4b06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eff293281ade4b06$var$TagIcon = (props)=>/*#__PURE__*/ $eff293281ade4b06$var$_react.default.createElement($eff293281ade4b06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8.768 1.75H13c.69 0 1.25.56 1.25 1.25v4.232c0 .332-.132.65-.366.884l-5.75 5.75a1.25 1.25 0 0 1-1.768 0L2.134 9.634a1.25 1.25 0 0 1 0-1.768l5.75-5.75a1.25 1.25 0 0 1 .884-.366Z"/><rect width="2" height="2" x="10" y="4" fill="currentcolor" rx="1"/>`
    }, props));
$eff293281ade4b06$var$TagIcon.displayName = 'TagIcon';
var $eff293281ade4b06$var$_default = module.exports.default = $eff293281ade4b06$var$TagIcon;

});

parcelRegister("2OpmI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20c3ed57b318b9b4$var$_react = $20c3ed57b318b9b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $20c3ed57b318b9b4$var$_tag = $20c3ed57b318b9b4$var$_interopRequireDefault((parcelRequire("kBeAb")));
function $20c3ed57b318b9b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $20c3ed57b318b9b4$var$LabelIcon = (props)=>/*#__PURE__*/ $20c3ed57b318b9b4$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.433 5.428-4.207.6A2 2 0 0 0 5.53 7.727l-.6 4.207a1 1 0 0 0 .281.849l6.895 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283m-.647 5.858A1.666 1.666 0 1 1 8.43 8.929a1.666 1.666 0 0 1 2.357 2.357"/></svg>`
    }, props, {
        newIcon: $20c3ed57b318b9b4$var$_tag.default
    }));
$20c3ed57b318b9b4$var$LabelIcon.displayName = 'LabelIcon';
var $20c3ed57b318b9b4$var$_default = module.exports.default = $20c3ed57b318b9b4$var$LabelIcon;

});



parcelRegister("8CtY9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b04ec42d5f3bae95$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b04ec42d5f3bae95$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    entitlementFieldPlaceholder: {
        "id": "servicedesk-customer-service-entitlements-field.common.read-view.entitlement-field-placeholder",
        "defaultMessage": "None"
    }
});

});


parcelRegister("9jf8F", function(module, exports) {

$parcel$export(module.exports, "getNameFromFieldData", () => $537c6710bb84b62b$export$88049b8e8e0c8291);
const $537c6710bb84b62b$export$88049b8e8e0c8291 = (value)=>value?.product?.name;

});


parcelRegister("1f6RV", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ce9e3ee90c3a69$export$2e2bcd8739ae039);

var $7f2nY = parcelRequire("7f2nY");

var $1Rt1q = parcelRequire("1Rt1q");

var $brrbP = parcelRequire("brrbP");
const $87ce9e3ee90c3a69$var$mapStateToProps = (state)=>({
        useJSMQueueDurationEvent: (0, $7f2nY.getUseJSMQueueDurationEvent)(state)
    });
const $87ce9e3ee90c3a69$var$mergeProps = (stateProps, dispatchProps, ownProps)=>({
        ...ownProps,
        ...stateProps
    });
var $87ce9e3ee90c3a69$export$2e2bcd8739ae039 = (0, $1Rt1q.connect)($87ce9e3ee90c3a69$var$mapStateToProps, {}, $87ce9e3ee90c3a69$var$mergeProps)((0, $brrbP.default));

});
parcelRegister("brrbP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebc3795d5e8816ac$export$2e2bcd8739ae039);
/* eslint-disable jira/react/no-style-attribute */ 
var $eUqFw = parcelRequire("eUqFw");


var $2eG9N = parcelRequire("2eG9N");

var $dnbhd = parcelRequire("dnbhd");

var $jMP2a = parcelRequire("jMP2a");

var $jU4ta = parcelRequire("jU4ta");
const $ebc3795d5e8816ac$var$TruncateFirstSpan = ({ children: children, innerRef: innerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ref: innerRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textOverflow: 'ellipsis',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexGrow: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexShrink: 10000,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: '12px'
        }
    }, children);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ebc3795d5e8816ac$var$TruncateSecondSpan = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textOverflow: 'ellipsis',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexGrow: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexShrink: 1,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexBasis: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: '12px'
        }
    }, children);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ebc3795d5e8816ac$var$StandaloneTruncateDiv = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textOverflow: 'ellipsis',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            whiteSpace: 'nowrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, children);
const $ebc3795d5e8816ac$var$SPAN_PARENT_FLEX_TRUNCATE_STYLE = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    display: 'flex',
    flexGrow: 1
};
const $ebc3795d5e8816ac$var$SECONDARY_LINK_STYLE = {
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$exports).N90})`
};
const $ebc3795d5e8816ac$var$getSecondaryLinkStyle = ()=>$ebc3795d5e8816ac$var$SECONDARY_LINK_STYLE;
const $ebc3795d5e8816ac$var$PADDING_STYLE = {
    padding: `10px ${"var(--ds-space-075, 6px)"} 10px ${"var(--ds-space-075, 6px)"}`,
    width: 'auto'
};
const $ebc3795d5e8816ac$var$getFocusStyle = (isFocused)=>({
        borderColor: isFocused ? `${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$exports).B200})`}` : 'transparent',
        borderRadius: '3px',
        borderWidth: '2px',
        borderStyle: 'solid',
        boxShadow: 'none',
        outline: 'none'
    });
const $ebc3795d5e8816ac$var$getFocusableTruncatingParentLinkStyle = (isFocused)=>({
        ...$ebc3795d5e8816ac$var$SPAN_PARENT_FLEX_TRUNCATE_STYLE,
        ...$ebc3795d5e8816ac$var$getSecondaryLinkStyle(),
        ...$ebc3795d5e8816ac$var$PADDING_STYLE,
        ...$ebc3795d5e8816ac$var$getFocusStyle(isFocused)
    });
const $ebc3795d5e8816ac$var$disabledStyle = {
    ...$ebc3795d5e8816ac$var$SPAN_PARENT_FLEX_TRUNCATE_STYLE,
    ...$ebc3795d5e8816ac$var$getSecondaryLinkStyle(),
    padding: `${"var(--ds-space-150, 12px)"} 0px`
};
const $ebc3795d5e8816ac$export$fd902cb3210d888f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            flexGrow: 10
        }
    });
const $ebc3795d5e8816ac$var$renderNonInteractiveIssueKey = (isLastColumn, issueKey)=>// Monolith still relies on 'issuekey' class selector for it's webdriver tests
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jU4ta.UnselectableChildGutterPaddingContainer), {
        className: "issuekey",
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebc3795d5e8816ac$var$StandaloneTruncateDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: $ebc3795d5e8816ac$var$disabledStyle
    }, issueKey)));
class $ebc3795d5e8816ac$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            linkStyle: {}
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataSelectorProps.value !== nextProps.dataSelectorProps.value || this.props.tableInjectedProps.isTableDisabled !== nextProps.tableInjectedProps.isTableDisabled || this.state.isFocused !== nextState.isFocused || this.state.tooltipText !== nextState.tooltipText;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderIssueKeyLink(issueKey, projectKey, issueNumber) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...$ebc3795d5e8816ac$var$getFocusableTruncatingParentLinkStyle(this.state.isFocused),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...this.props.linkStyle
            },
            onMouseOver: this.onMouseOver,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            href: `/browse/${issueKey}`,
            onClick: this.onClick,
            onAuxClick: this.onAuxClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "issue-link",
            'data-issue-key': issueKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebc3795d5e8816ac$var$TruncateFirstSpan, {
            innerRef: this.onSetProjectKeyRef
        }, projectKey), "-", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebc3795d5e8816ac$var$TruncateSecondSpan, null, issueNumber)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebc3795d5e8816ac$export$fd902cb3210d888f, null));
    }
    renderNonInteractiveIssueKeyFF(isLastColumn, issueKey, projectKey, issueNumber) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jU4ta.UnselectableChildGutterPaddingContainer), {
            // Monolith still relies on 'issuekey' class selector for it's webdriver tests
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "issuekey",
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: $ebc3795d5e8816ac$var$disabledStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebc3795d5e8816ac$var$TruncateFirstSpan, {
            innerRef: this.onSetProjectKeyRef
        }, projectKey), "-", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebc3795d5e8816ac$var$TruncateSecondSpan, null, issueNumber)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebc3795d5e8816ac$export$fd902cb3210d888f, null));
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderWithTooltipIfRequired(content) {
        const { tooltipText: tooltipText } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jU4ta.SelectableChildGutterPaddingContainer), {
            // Monolith still relies on 'issuekey' class selector for it's webdriver tests
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "issuekey",
            isLastColumn: this.props.tableInjectedProps.isLastColumn
        }, tooltipText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            delay: 0,
            content: tooltipText
        }, content) : content);
    }
    render() {
        const { dataSelectorProps: { value: issueKey }, tableInjectedProps: { isLastColumn: isLastColumn, isTableDisabled: isTableDisabled } } = this.props;
        const splitIssueKey = issueKey.split('-');
        if (splitIssueKey && splitIssueKey.length === 2) {
            if (!isTableDisabled) return this.renderWithTooltipIfRequired(this.renderIssueKeyLink(issueKey, splitIssueKey[0], splitIssueKey[1]));
            return this.renderNonInteractiveIssueKeyFF(isLastColumn, issueKey, splitIssueKey[0], splitIssueKey[1]);
        }
        return $ebc3795d5e8816ac$var$renderNonInteractiveIssueKey(isLastColumn, issueKey);
    }
    constructor(...args){
        super(...args);
        this.state = {
            isFocused: false,
            tooltipText: ''
        };
        this.onSetProjectKeyRef = (ref)=>{
            // @ts-expect-error - TS2322 - Type 'HTMLElement | null | undefined' is not assignable to type 'null'.
            this.projectKeyRef = ref;
        };
        this.onFocus = ()=>{
            this.setState({
                isFocused: true
            });
        };
        this.onBlur = ()=>{
            this.setState({
                isFocused: false
            });
        };
        this.onMouseOver = ()=>{
            if (this.projectKeyRef) {
                let tooltipText = '';
                // Check if the element has overflown. If yes, set the innerText in state for tooltip to display
                // @ts-expect-error - TS2339 - Property 'scrollWidth' does not exist on type 'never'. | TS2339 - Property 'offsetWidth' does not exist on type 'never'.
                if (this.projectKeyRef.scrollWidth > this.projectKeyRef.offsetWidth) tooltipText = this.props.dataSelectorProps.value;
                if (this.state.tooltipText !== tooltipText) this.setState(()=>({
                        tooltipText: tooltipText
                    }));
            }
        };
        this.onClick = (event, analyticsEvent)=>{
            const { onIssueViewTransition: onIssueViewTransition } = this.props.tableInjectedProps;
            const { useJSMQueueDurationEvent: useJSMQueueDurationEvent } = this.props;
            useJSMQueueDurationEvent && useJSMQueueDurationEvent();
            onIssueViewTransition?.(event);
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'tableIssueLink');
        };
        this.onAuxClick = ()=>{
            const { useJSMQueueDurationEvent: useJSMQueueDurationEvent } = this.props;
            useJSMQueueDurationEvent && useJSMQueueDurationEvent();
        };
        this.projectKeyRef = null;
    }
}

});
parcelRegister("dnbhd", function(module, exports) {

$parcel$export(module.exports, "default", () => $92444a2f8aee76e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eGI9v = parcelRequire("eGI9v");

var $lB25E = parcelRequire("lB25E");
function $92444a2f8aee76e7$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), rest, children);
}
var $92444a2f8aee76e7$export$2e2bcd8739ae039 = (0, $eGI9v.default)('link', {
    onClick: 'clicked'
})($92444a2f8aee76e7$var$Link);

});



parcelRegister("2UzBs", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f17a50ada7840aa$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $AAlgn = parcelRequire("AAlgn");

var $8puAb = parcelRequire("8puAb");
// TODO: Show meatball only onHover and onFocus
const $4f17a50ada7840aa$var$IssueOperations = ({ tableInjectedProps: { issueKey: issueKey }, dataSelectorProps: { issueId: issueId, useRefetch: useRefetch } })=>{
    const { onRefetch: onRefetch } = useRefetch();
    const [flags, setFlags] = (0, $eUqFw.useState)([]);
    const onAddFlag = (styleClass, isSuccessful)=>setFlags([
            {
                id: flags.length + 1,
                styleClass: styleClass,
                isSuccessful: isSuccessful
            },
            ...flags
        ]);
    const onDismissFlag = ()=>setFlags(flags.slice(1));
    const onIssueRefetch = ()=>onRefetch(issueKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f17a50ada7840aa$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $AAlgn.default), {
        issueId: issueId,
        issueKey: issueKey,
        onAddFlag: onAddFlag,
        onIssueRefetch: onIssueRefetch
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8puAb.default), {
        flags: flags,
        onDismiss: onDismissFlag,
        issueKey: issueKey
    }));
};
var $4f17a50ada7840aa$export$2e2bcd8739ae039 = $4f17a50ada7840aa$var$IssueOperations;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f17a50ada7840aa$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80 _1yt41b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("AAlgn", function(module, exports) {

$parcel$export(module.exports, "default", () => $94de4624ba87fbc5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $jG1wZ = parcelRequire("jG1wZ");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $94de4624ba87fbc5$var$MeatballMenu = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("k8CPr")), {
    ssr: false,
    moduleId: "./src/packages/issue-table/src/common/fields/issue-operations/meatball-menu/index.tsx"
});
const $94de4624ba87fbc5$var$AsyncMeatballMenu = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-meatball-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                label: "",
                size: "medium"
            }),
            isDisabled: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94de4624ba87fbc5$var$MeatballMenu, props));
var $94de4624ba87fbc5$export$2e2bcd8739ae039 = $94de4624ba87fbc5$var$AsyncMeatballMenu;

});
parcelRegister("k8CPr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hUmO2").then(()=>parcelRequire('fxD0t'));

});


parcelRegister("8puAb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e7e72ea65a34e22$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");


var $eBkd9 = parcelRequire("eBkd9");

var $c8KxL = parcelRequire("c8KxL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lSoca = parcelRequire("lSoca");

var $j18mp = parcelRequire("j18mp");
const $8e7e72ea65a34e22$var$NotificationFlagGroup = ({ flags: flags, onDismiss: onDismiss, issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c8KxL.default), {
        onDismissed: onDismiss
    }, flags.map(({ id: id, styleClass: styleClass, isSuccessful: isSuccessful })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eBkd9.default), {
            id: id,
            icon: isSuccessful ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
                label: "Success",
                size: "medium",
                primaryColor: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                label: "Error",
                size: "medium",
                primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`
            }),
            key: id,
            title: isSuccessful ? formatMessage((0, $lSoca.default).successTitle) : formatMessage((0, $lSoca.default).errorTitle),
            description: isSuccessful ? formatMessage((0, $lSoca.default)[(0, $j18mp.getMessageId)(styleClass)], {
                issueKey: issueKey
            }) : formatMessage((0, $lSoca.default).errorDesc, {
                issueKey: issueKey
            })
        })));
};
var $8e7e72ea65a34e22$export$2e2bcd8739ae039 = $8e7e72ea65a34e22$var$NotificationFlagGroup;

});
parcelRegister("eBkd9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2abc675c3cd85b60$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5L0Jp = parcelRequire("5L0Jp");

var $kQ0RL = parcelRequire("kQ0RL");
const $2abc675c3cd85b60$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.CommonFlag), {
        isAutoDismiss: true,
        ...props,
        flagType: "info"
    }));
var $2abc675c3cd85b60$export$2e2bcd8739ae039 = $2abc675c3cd85b60$var$AkAutoDismissFlag;

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("5eqyk")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("5eqyk")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("5eqyk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cCYJs")
]).then(()=>parcelRequire('kbpOk'));

});

parcelRegister("eWPgg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hkLGi").then(()=>parcelRequire('jkRT2'));

});



parcelRegister("c8KxL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9f08ed55ceefb4$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$4b9f08ed55ceefb4$export$2e2bcd8739ae039 = (0, $kQ0RL.FlagGroup);

});

parcelRegister("lSoca", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e872da9c297af44$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1e872da9c297af44$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    thanksIssueUpdated: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-updated",
        "defaultMessage": "{issueKey} has been updated."
    },
    thanksIssueAssigned: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-assigned",
        "defaultMessage": "{issueKey} has been assigned."
    },
    thanksIssueCommented: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-commented",
        "defaultMessage": "{issueKey} has been updated with your comment."
    },
    thanksIssueWorklogged: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-worklogged",
        "defaultMessage": "Work has been logged on {issueKey}."
    },
    thanksIssueVoted: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-voted",
        "defaultMessage": "Your vote on {issueKey} has been updated."
    },
    thanksIssueWatched: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-watched",
        "defaultMessage": "Your watcher status on {issueKey} has been updated."
    },
    thanksIssueMoved: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-moved",
        "defaultMessage": "{issueKey} has been moved."
    },
    thanksIssueLinked: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-linked",
        "defaultMessage": "The links on {issueKey} have been updated."
    },
    thanksIssueCloned: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-cloned",
        "defaultMessage": "{issueKey} has been cloned."
    },
    thanksIssueLabelled: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-labelled",
        "defaultMessage": "The labels on {issueKey} have been updated."
    },
    thanksIssueDeleted: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-deleted",
        "defaultMessage": "{issueKey} has been deleted."
    },
    thanksIssueAttached: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-attached",
        "defaultMessage": "The file(s) have been attached to {issueKey}."
    },
    successTitle: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.success-title",
        "defaultMessage": "Issue updated"
    },
    errorTitle: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.error-title",
        "defaultMessage": "Error"
    },
    errorDesc: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.error-desc",
        "defaultMessage": "Your operation on {issueKey} could not be performed."
    }
});

});

parcelRegister("j18mp", function(module, exports) {

$parcel$export(module.exports, "getMessageId", () => $78779418f0daa359$export$7a6ec380c1221521);

var $jfchT = parcelRequire("jfchT");
const $78779418f0daa359$export$7a6ec380c1221521 = (styleClass)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "issueaction-assign-issue": { readonly id: "assign-dialog"; readonly issueMsg: "thanksIssueAssigned"; }; readonly "issueaction-assign-to-me hide-from-opsbar": { readonly id: "assign-dialog"; readonly issueMsg: "thanksIssueAssigned"; }; ... 5 more ...; readonly "issueaction-edit-labels": { ...; }; }'.
    (0, $jfchT.DIALOG_DATA)[styleClass]?.issueMsg ?? 'thanksIssueUpdated';

});
parcelRegister("jfchT", function(module, exports) {

$parcel$export(module.exports, "RANK_TO_TOP", () => $e9d729ee52237469$export$a1d82a1fb322eabf);
$parcel$export(module.exports, "RANK_TO_BOTTOM", () => $e9d729ee52237469$export$264804825e75ec82);
$parcel$export(module.exports, "OPERATION_IDS", () => $e9d729ee52237469$export$498178c427a35252);
$parcel$export(module.exports, "LINK_IDS", () => $e9d729ee52237469$export$1fff534c17344ccf);
$parcel$export(module.exports, "DIALOG_FIELDS", () => $e9d729ee52237469$export$5ae74c325a8e870e);
$parcel$export(module.exports, "SKIP_FIELDS", () => $e9d729ee52237469$export$cb2989a570fe66ad);
$parcel$export(module.exports, "URL_OVERRIDE_FIELDS", () => $e9d729ee52237469$export$b86499b7cf24c281);
$parcel$export(module.exports, "DIALOG_DATA", () => $e9d729ee52237469$export$f57e70208d0fb8b9);
const $e9d729ee52237469$export$52f11126cce982f0 = 'issueaction-edit-issue';
const $e9d729ee52237469$export$11ee87f991dd6574 = 'issueaction-assign-issue';
const $e9d729ee52237469$export$ae8a4274289f40bb = 'issueaction-assign-to-me hide-from-opsbar';
const $e9d729ee52237469$export$c9767814627656fa = 'issueaction-comment-issue add-issue-comment';
const $e9d729ee52237469$export$9934728f04ded7bc = 'issueaction-log-work';
const $e9d729ee52237469$export$b550abc3cf5b5518 = 'issueaction-greenhopper-rapidboard-operation js-rapidboard-operation-issue';
const $e9d729ee52237469$export$a1d82a1fb322eabf = 'issueaction-greenhopper-rank-top-operation';
const $e9d729ee52237469$export$264804825e75ec82 = 'issueaction-greenhopper-rank-bottom-operation';
const $e9d729ee52237469$export$5cae3e39deafae4f = 'unified-attach-file';
const $e9d729ee52237469$export$c09f2ff565f29b80 = 'issueaction-attach-screenshot-html5';
const $e9d729ee52237469$export$a876e536f49fe640 = 'issueaction-vote-issue';
const $e9d729ee52237469$export$1115d06861734773 = 'issueaction-unvote-issue';
const $e9d729ee52237469$export$c6ca243f8c6e0ac = 'issueaction-view-voters';
const $e9d729ee52237469$export$8590ac458b1ca5cd = 'issueaction-watch-issue';
const $e9d729ee52237469$export$b40485ac21b9ee1c = 'issueaction-unwatch-issue';
const $e9d729ee52237469$export$f0ff74d1b108a4b2 = 'issueaction-manage-watchers';
const $e9d729ee52237469$export$50aa55e768c08714 = 'issueaction-create-subtask';
const $e9d729ee52237469$export$fa8a3a104fe88777 = 'issueaction-subtask-to-issue';
const $e9d729ee52237469$export$ac6fd3afd550810f = 'issueaction-issue-to-subtask';
const $e9d729ee52237469$export$852d908b6524fa54 = 'devstatus-cta-link';
const $e9d729ee52237469$export$19d060cbaff808b8 = 'issueaction-create-linked-issue';
const $e9d729ee52237469$export$346f08c1f0d0fe41 = 'issueaction-move-issue';
const $e9d729ee52237469$export$b395009ca7f092c7 = 'issueaction-link-issue';
const $e9d729ee52237469$export$c07b68c109124fe2 = 'issueaction-clone-issue';
const $e9d729ee52237469$export$79b91d4669dcadcb = 'issueaction-edit-labels';
const $e9d729ee52237469$export$4bd2facc4a3e6aa1 = 'issueaction-delete-issue';
const $e9d729ee52237469$export$97de66002300ed70 = 'issueaction-fields-add';
const $e9d729ee52237469$export$743e517487373c63 = 'permissionhelper-trigger';
const $e9d729ee52237469$export$2792beb653acc784 = 'notificationhelper-trigger';
const $e9d729ee52237469$export$f6220122141a5652 = 'add-jira-issue-link-link';
const $e9d729ee52237469$export$2bdea7332f260f02 = 'add-confluence-page-link-link';
const $e9d729ee52237469$export$85cff93a8d7829c9 = 'add-web-link-link';
const $e9d729ee52237469$export$498178c427a35252 = {
    EDIT_ISSUE: $e9d729ee52237469$export$52f11126cce982f0,
    ASSIGN: $e9d729ee52237469$export$11ee87f991dd6574,
    ASSIGN_TO_ME: $e9d729ee52237469$export$ae8a4274289f40bb,
    COMMENT_ISSUE: $e9d729ee52237469$export$c9767814627656fa,
    LOG_WORK: $e9d729ee52237469$export$9934728f04ded7bc,
    AGILE_BOARD: $e9d729ee52237469$export$b550abc3cf5b5518,
    RANK_TO_TOP: $e9d729ee52237469$export$a1d82a1fb322eabf,
    RANK_TO_BOTTOM: $e9d729ee52237469$export$264804825e75ec82,
    ATTACH_FILE: $e9d729ee52237469$export$5cae3e39deafae4f,
    ATTACH_SCREENSHOT: $e9d729ee52237469$export$c09f2ff565f29b80,
    ADD_VOTE: $e9d729ee52237469$export$a876e536f49fe640,
    REMOVE_VOTE: $e9d729ee52237469$export$1115d06861734773,
    VIEW_VOTERS: $e9d729ee52237469$export$c6ca243f8c6e0ac,
    WATCH_ISSUE: $e9d729ee52237469$export$8590ac458b1ca5cd,
    UNWATCH_ISSUE: $e9d729ee52237469$export$b40485ac21b9ee1c,
    WATCHERS: $e9d729ee52237469$export$f0ff74d1b108a4b2,
    CREATE_SUBTASK: $e9d729ee52237469$export$50aa55e768c08714,
    CONVERT_TO_ISSUE: $e9d729ee52237469$export$fa8a3a104fe88777,
    CONVERT_TO_SUBTASK: $e9d729ee52237469$export$ac6fd3afd550810f,
    CREATE_BRANCH: $e9d729ee52237469$export$852d908b6524fa54,
    CREATE_LINKED_ISSUE: $e9d729ee52237469$export$19d060cbaff808b8,
    MOVE: $e9d729ee52237469$export$346f08c1f0d0fe41,
    LINK: $e9d729ee52237469$export$b395009ca7f092c7,
    CLONE: $e9d729ee52237469$export$c07b68c109124fe2,
    LABELS: $e9d729ee52237469$export$79b91d4669dcadcb,
    DELETE: $e9d729ee52237469$export$4bd2facc4a3e6aa1,
    ADD_FIELD: $e9d729ee52237469$export$97de66002300ed70,
    PERMISSION_HELPER: $e9d729ee52237469$export$743e517487373c63,
    NOTIFICATION_HELPER: $e9d729ee52237469$export$2792beb653acc784
};
const $e9d729ee52237469$export$1fff534c17344ccf = {
    LINK_ISSUE: $e9d729ee52237469$export$f6220122141a5652,
    LINK_CONFLUENCE_PAGE: $e9d729ee52237469$export$2bdea7332f260f02,
    ADD_WEB_LINK: $e9d729ee52237469$export$85cff93a8d7829c9
};
const $e9d729ee52237469$export$5ae74c325a8e870e = [
    $e9d729ee52237469$export$52f11126cce982f0,
    $e9d729ee52237469$export$c9767814627656fa,
    $e9d729ee52237469$export$9934728f04ded7bc,
    $e9d729ee52237469$export$a1d82a1fb322eabf,
    $e9d729ee52237469$export$264804825e75ec82,
    $e9d729ee52237469$export$5cae3e39deafae4f,
    $e9d729ee52237469$export$a876e536f49fe640,
    $e9d729ee52237469$export$1115d06861734773,
    $e9d729ee52237469$export$8590ac458b1ca5cd,
    $e9d729ee52237469$export$b40485ac21b9ee1c,
    $e9d729ee52237469$export$b395009ca7f092c7,
    $e9d729ee52237469$export$c07b68c109124fe2,
    $e9d729ee52237469$export$79b91d4669dcadcb,
    $e9d729ee52237469$export$4bd2facc4a3e6aa1,
    $e9d729ee52237469$export$97de66002300ed70,
    $e9d729ee52237469$export$743e517487373c63,
    $e9d729ee52237469$export$2792beb653acc784,
    $e9d729ee52237469$export$11ee87f991dd6574,
    $e9d729ee52237469$export$ae8a4274289f40bb,
    $e9d729ee52237469$export$c09f2ff565f29b80,
    $e9d729ee52237469$export$19d060cbaff808b8,
    $e9d729ee52237469$export$50aa55e768c08714
];
const $e9d729ee52237469$export$cb2989a570fe66ad = [
    $e9d729ee52237469$export$52f11126cce982f0,
    $e9d729ee52237469$export$11ee87f991dd6574,
    $e9d729ee52237469$export$ae8a4274289f40bb,
    $e9d729ee52237469$export$c09f2ff565f29b80,
    $e9d729ee52237469$export$19d060cbaff808b8,
    $e9d729ee52237469$export$852d908b6524fa54,
    $e9d729ee52237469$export$b395009ca7f092c7
];
const $e9d729ee52237469$export$b86499b7cf24c281 = {
    [$e9d729ee52237469$export$743e517487373c63]: '/secure/admin/PermissionHelperAdmin.jspa',
    [$e9d729ee52237469$export$2792beb653acc784]: '/secure/admin/NotificationHelperAdmin.jspa'
};
const $e9d729ee52237469$export$f57e70208d0fb8b9 = {
    [$e9d729ee52237469$export$11ee87f991dd6574]: {
        id: 'assign-dialog',
        issueMsg: 'thanksIssueAssigned'
    },
    [$e9d729ee52237469$export$ae8a4274289f40bb]: {
        id: 'assign-dialog',
        issueMsg: 'thanksIssueAssigned'
    },
    [$e9d729ee52237469$export$c9767814627656fa]: {
        id: 'comment-add-dialog',
        issueMsg: 'thanksIssueCommented'
    },
    [$e9d729ee52237469$export$5cae3e39deafae4f]: {
        id: 'attach-file-dialog',
        issueMsg: 'thanksIssueAttached'
    },
    [$e9d729ee52237469$export$4bd2facc4a3e6aa1]: {
        id: 'delete-issue-dialog',
        issueMsg: 'thanksIssueDeleted'
    },
    [$e9d729ee52237469$export$c07b68c109124fe2]: {
        id: 'clone-issue-dialog',
        issueMsg: 'thanksIssueCloned'
    },
    [$e9d729ee52237469$export$9934728f04ded7bc]: {
        id: 'edit-log-work-dialog',
        issueMsg: 'thanksIssueWorklogged'
    },
    [$e9d729ee52237469$export$79b91d4669dcadcb]: {
        id: 'edit-labels-dialog',
        issueMsg: 'thanksIssueLabelled'
    }
};

});




parcelRegister("dFiWK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ef0d8c01963b394$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jU4ta = parcelRequire("jU4ta");
function $1ef0d8c01963b394$export$2e2bcd8739ae039(props) {
    const { dataSelectorProps: { value: { iconUrl: iconUrl, description: description, name: name } }, tableInjectedProps: { isLastColumn: isLastColumn } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jU4ta.UnselectableChildGutterPaddingContainer), {
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ef0d8c01963b394$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        height: "16",
        width: "16",
        src: iconUrl,
        alt: description,
        title: name
    })));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ef0d8c01963b394$var$StyledWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itidpf _1yt4hx70",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8fFF2", function(module, exports) {

$parcel$export(module.exports, "default", () => $73cd456692781bae$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bGEPY = parcelRequire("bGEPY");
const $73cd456692781bae$var$Labels = ({ tableInjectedProps: { isLastColumn: isLastColumn }, dataSelectorProps: { value: value } })=>// @ts-expect-error - TS2322 - Type 'LabelsProps' is not assignable to type 'TagData[]'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bGEPY.default), {
        tags: value,
        isLastColumn: isLastColumn
    });
var $73cd456692781bae$export$2e2bcd8739ae039 = $73cd456692781bae$var$Labels;

});
parcelRegister("bGEPY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f05acd8bb1c56f13$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lXabx = parcelRequire("lXabx");

var $cAKIH = parcelRequire("cAKIH");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jU4ta = parcelRequire("jU4ta");

var $iWjkF = parcelRequire("iWjkF");
const $f05acd8bb1c56f13$var$Tags = ({ tags: tags, isLastColumn: isLastColumn })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (tags.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jU4ta.UnselectableChildGutterPaddingContainer), {
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f05acd8bb1c56f13$var$MessageWrapper, null, formatMessage((0, $iWjkF.default).none)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jU4ta.UnselectableChildGutterPaddingContainer), {
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f05acd8bb1c56f13$var$TagWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cAKIH.default), null, tags.map((tag, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXabx.default), {
            key: index,
            appearance: "default",
            text: tag.name,
            href: tag.href,
            isRemovable: false
        })))));
};
var $f05acd8bb1c56f13$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f05acd8bb1c56f13$var$Tags;
const $f05acd8bb1c56f13$var$TagWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s87c40",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f05acd8bb1c56f13$var$MessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41bpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lXabx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3ff7c9e14de284a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $co43T = parcelRequire("co43T");

var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $lSV8Z = parcelRequire("lSV8Z");
var $5Dp4O = parcelRequire("5Dp4O");

var $XHGTv = parcelRequire("XHGTv");

var $jFsza = parcelRequire("jFsza");

var $i6wnX = parcelRequire("i6wnX");

var $d9W8K = parcelRequire("d9W8K");

var $6aZHE = parcelRequire("6aZHE");

var $gz2Bi = parcelRequire("gz2Bi");

var $keeN7 = parcelRequire("keeN7");
var $c3ff7c9e14de284a$var$TagStatus;
(function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
})($c3ff7c9e14de284a$var$TagStatus || ($c3ff7c9e14de284a$var$TagStatus = {}));
const $c3ff7c9e14de284a$var$packageName = "platform-pkg";
const $c3ff7c9e14de284a$var$packageVersion = "0.0.0-use.local";
const $c3ff7c9e14de284a$var$defaultBeforeRemoveAction = ()=>true;
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ const $c3ff7c9e14de284a$var$removingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        boxShadow: `0 0 0 2px transparent`,
        outline: 'none'
    }
});
const $c3ff7c9e14de284a$var$RemovableTagComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $c3ff7c9e14de284a$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $5Q9wj.default), linkComponent: linkComponent }, ref)=>{
    const [status, setStatus] = (0, $eUqFw.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $eUqFw.useState)(false);
    const onAfterRemoveActionWithAnalytics = (0, $co43T.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $c3ff7c9e14de284a$var$packageName,
            packageVersion: $c3ff7c9e14de284a$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $eUqFw.useCallback)(()=>{
        onAfterRemoveActionWithAnalytics(text);
        setStatus("removed");
    }, [
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    const handleRemoveRequest = (0, $eUqFw.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $eUqFw.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $eUqFw.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $eUqFw.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $eUqFw.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $eUqFw.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $keeN7.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${text}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined;
    const content = /*#__PURE__*/ (0, $byn9U.jsx)((0, $gz2Bi.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        backgroundColor: (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle, #00000000)" : undefined,
        // Tag background color on hover
        [(0, $jFsza.cssVar).color.background.hover]: (0, $XHGTv.fg)('platform-component-visual-refresh') ? undefined : $i6wnX.removalHoverBackgroundColors,
        // Tag background color on press
        [(0, $jFsza.cssVar).color.background.active]: (0, $XHGTv.fg)('platform-component-visual-refresh') ? undefined : $i6wnX.removalActiveBackgroundColors,
        // The tag text on hover of remove button
        [(0, $jFsza.cssVar).color.text.default]: (0, $XHGTv.fg)('platform-component-visual-refresh') ? undefined : $i6wnX.removalTextColors,
        // 'elemBefore' text on press of remove button
        [(0, $jFsza.cssVar).color.text.active]: (0, $XHGTv.fg)('platform-component-visual-refresh') ? undefined : $i6wnX.removalTextColors,
        // The tag link text on hover of remove button
        [(0, $jFsza.cssVar).color.text.link]: (0, $XHGTv.fg)('platform-component-visual-refresh') ? undefined : $i6wnX.removalTextColors
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $lSV8Z.default), null, !(status === "removed") && /*#__PURE__*/ (0, $byn9U.jsx)((0, $5Dp4O.default), null, (motion)=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $d9W8K.default), {
            ref: (0, $1lQG9.default)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            css: [
                status === "removing" && $c3ff7c9e14de284a$var$removingStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === "removing",
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ (0, $byn9U.jsx)((0, $6aZHE.default), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $c3ff7c9e14de284a$var$RemovableTag = /*#__PURE__*/ (0, $eUqFw.memo)($c3ff7c9e14de284a$var$RemovableTagComponent);
var $c3ff7c9e14de284a$export$2e2bcd8739ae039 = $c3ff7c9e14de284a$var$RemovableTag;

});
parcelRegister("5Dp4O", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fb4b88a82b6f14c$export$2e2bcd8739ae039);


var $5LHuc = parcelRequire("5LHuc");

var $5bTtn = parcelRequire("5bTtn");

var $hcijx = parcelRequire("hcijx");

var $3WV8S = parcelRequire("3WV8S");

var $lSV8Z = parcelRequire("lSV8Z");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $8fb4b88a82b6f14c$var$ShrinkOut = ({ children: children, duration: duration = (0, $5LHuc.smallDurationMs), onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $hcijx.useElementRef)();
    const exiting = (0, $lSV8Z.useExitingPersistence)();
    const requestAnimationFrame = (0, $5bTtn.useRequestAnimationFrame)();
    const setTimeout = (0, $5bTtn.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $3WV8S.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: (0, $d58b680a02f4d6a4$export$929e5a82286172a6),
                        transitionDuration: `${duration}ms`,
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, duration);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $8fb4b88a82b6f14c$export$2e2bcd8739ae039 = $8fb4b88a82b6f14c$var$ShrinkOut;

});
const $d58b680a02f4d6a4$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $d58b680a02f4d6a4$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $d58b680a02f4d6a4$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

parcelRegister("hcijx", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $81c15b5f9718dda0$export$ff879f35a69d56b7);

var $eUqFw = parcelRequire("eUqFw");
const $81c15b5f9718dda0$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $eUqFw.useRef)(null);
    const setRef = (0, $eUqFw.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});


parcelRegister("jFsza", function(module, exports) {

$parcel$export(module.exports, "tagHeight", () => $2e837ad2e72491cc$export$5b2b1030a679f37);
$parcel$export(module.exports, "buttonWidthUnitless", () => $2e837ad2e72491cc$export$c6f3ea2b4cffd0ca);
$parcel$export(module.exports, "maxTextWidthUnitless", () => $2e837ad2e72491cc$export$2e3bcb01bf928995);
$parcel$export(module.exports, "maxTextWidth", () => $2e837ad2e72491cc$export$982d4a1a6de11130);
$parcel$export(module.exports, "defaultBorderRadius", () => $2e837ad2e72491cc$export$35d5d1e251b985cf);
$parcel$export(module.exports, "defaultRoundedBorderRadius", () => $2e837ad2e72491cc$export$c49771100fee18c8);
$parcel$export(module.exports, "defaultMargin", () => $2e837ad2e72491cc$export$6728fea658cfb92e);
$parcel$export(module.exports, "defaultTextPadding", () => $2e837ad2e72491cc$export$c2d03c4c68282362);
$parcel$export(module.exports, "textPaddingRight", () => $2e837ad2e72491cc$export$b5686dedf408caa0);
$parcel$export(module.exports, "textMarginLeft", () => $2e837ad2e72491cc$export$b824cac86306f7a2);
$parcel$export(module.exports, "cssVar", () => $2e837ad2e72491cc$export$8b4981022bd80a4e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $lcnyw = parcelRequire("lcnyw");
const $2e837ad2e72491cc$var$gridSizeValue = (0, $lcnyw.gridSize)();
const $2e837ad2e72491cc$var$borderRadiusValue = (0, $lcnyw.borderRadius)();
const $2e837ad2e72491cc$export$b4d89c3994664204 = 2.5 * $2e837ad2e72491cc$var$gridSizeValue;
const $2e837ad2e72491cc$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$2e837ad2e72491cc$export$b4d89c3994664204}px`})`;
const $2e837ad2e72491cc$export$c6f3ea2b4cffd0ca = $2e837ad2e72491cc$export$b4d89c3994664204; // button should be square
const $2e837ad2e72491cc$export$aba002ef70684916 = $2e837ad2e72491cc$export$5b2b1030a679f37; // button should be square
const $2e837ad2e72491cc$export$d5949a2c2ea9dcea = 25 * $2e837ad2e72491cc$var$gridSizeValue;
const $2e837ad2e72491cc$export$488fda99655ff65a = `${$2e837ad2e72491cc$export$d5949a2c2ea9dcea}px`;
const $2e837ad2e72491cc$export$2e3bcb01bf928995 = $2e837ad2e72491cc$export$d5949a2c2ea9dcea - $2e837ad2e72491cc$export$b4d89c3994664204;
const $2e837ad2e72491cc$export$982d4a1a6de11130 = `${$2e837ad2e72491cc$export$2e3bcb01bf928995}px`;
const $2e837ad2e72491cc$export$35d5d1e251b985cf = `${$2e837ad2e72491cc$var$borderRadiusValue}px`;
const $2e837ad2e72491cc$export$c49771100fee18c8 = `${$2e837ad2e72491cc$export$c6f3ea2b4cffd0ca / 2}px`;
const $2e837ad2e72491cc$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$2e837ad2e72491cc$var$gridSizeValue / 2}px`})`;
const $2e837ad2e72491cc$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$2e837ad2e72491cc$var$gridSizeValue / 2}px`})`;
const $2e837ad2e72491cc$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $2e837ad2e72491cc$var$gridSizeValue}px`})`;
const $2e837ad2e72491cc$export$b824cac86306f7a2 = $2e837ad2e72491cc$export$5b2b1030a679f37;
const $2e837ad2e72491cc$export$8b4981022bd80a4e = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        borderColor: '--ds-bc',
        focusRing: '--ds-cfr',
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        },
        removeButton: {
            default: '--ds-rb',
            hover: '--ds-rbh'
        }
    },
    borderRadius: '--ds-br'
};

});

parcelRegister("i6wnX", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $fc0da2a7c84ba49c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $fc0da2a7c84ba49c$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $fc0da2a7c84ba49c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $fc0da2a7c84ba49c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $fc0da2a7c84ba49c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $fc0da2a7c84ba49c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $fc0da2a7c84ba49c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $fc0da2a7c84ba49c$export$2a31dbe82788f940);
$parcel$export(module.exports, "borderRadius", () => $fc0da2a7c84ba49c$export$7a57f79000377ca2);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $fc0da2a7c84ba49c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $fc0da2a7c84ba49c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $fc0da2a7c84ba49c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $fc0da2a7c84ba49c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $fc0da2a7c84ba49c$export$b03fbc2a369c563e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 

var $jFsza = parcelRequire("jFsza");
const $fc0da2a7c84ba49c$export$daa0ace263cb20d2 = {
    standard: `var(--ds-text, ${$73a5c9d720aa66e1$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-link, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$73a5c9d720aa66e1$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
};
const $fc0da2a7c84ba49c$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $fc0da2a7c84ba49c$export$7c7104a5f052cab7 = {
    standard: `var(--ds-link, ${$73a5c9d720aa66e1$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$73a5c9d720aa66e1$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
};
const $fc0da2a7c84ba49c$export$382469baad253eb7 = {
    standard: `var(--ds-link-pressed, ${$73a5c9d720aa66e1$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: `var(--ds-text-accent-gray, ${$73a5c9d720aa66e1$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue-bolder, ${$73a5c9d720aa66e1$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green-bolder, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple-bolder, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: `var(--ds-text-accent-gray-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
};
const $fc0da2a7c84ba49c$export$b9d7c59a579c23c6 = {
    standard: `var(--ds-background-neutral, ${$73a5c9d720aa66e1$export$9fdfb749e33cdf97})`,
    blue: `var(--ds-background-accent-blue-subtle, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`,
    red: `var(--ds-background-accent-red-subtle, ${$73a5c9d720aa66e1$export$be802dd0d8b57f35})`,
    yellow: `var(--ds-background-accent-yellow-subtle, ${$73a5c9d720aa66e1$export$5aae31392d72caaa})`,
    green: `var(--ds-background-accent-green-subtle, ${$73a5c9d720aa66e1$export$747d86715d4175de})`,
    teal: `var(--ds-background-accent-teal-subtle, ${$73a5c9d720aa66e1$export$69cb3ca10c1e330e})`,
    purple: `var(--ds-background-accent-purple-subtle, ${$73a5c9d720aa66e1$export$6011520a64d9a187})`,
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: `var(--ds-background-accent-gray-subtle, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-background-accent-blue-subtler, ${$73a5c9d720aa66e1$export$8c13c2ee36917869})`,
    redLight: `var(--ds-background-accent-red-subtler, ${$73a5c9d720aa66e1$export$b34b069eff244586})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler, ${$73a5c9d720aa66e1$export$1cc05bbbf340e559})`,
    greenLight: `var(--ds-background-accent-green-subtler, ${$73a5c9d720aa66e1$export$afbce1382ec95f73})`,
    tealLight: `var(--ds-background-accent-teal-subtler, ${$73a5c9d720aa66e1$export$776c9c497ef08533})`,
    purpleLight: `var(--ds-background-accent-purple-subtler, ${$73a5c9d720aa66e1$export$4b0a4417ed59760f})`,
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: `var(--ds-background-accent-gray-subtler, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`
};
const $fc0da2a7c84ba49c$export$4410079763249c74 = {
    standard: `var(--ds-background-neutral-hovered, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-hovered, ${$73a5c9d720aa66e1$export$8c13c2ee36917869})`,
    red: `var(--ds-background-accent-red-subtle-hovered, ${$73a5c9d720aa66e1$export$b34b069eff244586})`,
    yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$73a5c9d720aa66e1$export$1cc05bbbf340e559})`,
    green: `var(--ds-background-accent-green-subtle-hovered, ${$73a5c9d720aa66e1$export$afbce1382ec95f73})`,
    teal: `var(--ds-background-accent-teal-subtle-hovered, ${$73a5c9d720aa66e1$export$776c9c497ef08533})`,
    purple: `var(--ds-background-accent-purple-subtle-hovered, ${$73a5c9d720aa66e1$export$4b0a4417ed59760f})`,
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: `var(--ds-background-accent-gray-subtle-hovered, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
    blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$73a5c9d720aa66e1$export$226de0355ed012f8})`,
    redLight: `var(--ds-background-accent-red-subtler-hovered, ${$73a5c9d720aa66e1$export$4b84fd0e2c617bd})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$73a5c9d720aa66e1$export$41060a744ab0b7ae})`,
    greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$73a5c9d720aa66e1$export$69a3bf21b9686c2b})`,
    tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$73a5c9d720aa66e1$export$7a8f4d33f6f9772c})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$73a5c9d720aa66e1$export$363e4475840015bb})`,
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$73a5c9d720aa66e1$export$1ce2d1575d444ceb})`
};
const $fc0da2a7c84ba49c$export$76be99c5e13e3566 = {
    standard: `var(--ds-background-neutral-pressed, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-pressed, ${$73a5c9d720aa66e1$export$226de0355ed012f8})`,
    red: `var(--ds-background-accent-red-subtle-pressed, ${$73a5c9d720aa66e1$export$4b84fd0e2c617bd})`,
    yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$73a5c9d720aa66e1$export$41060a744ab0b7ae})`,
    green: `var(--ds-background-accent-green-subtle-pressed, ${$73a5c9d720aa66e1$export$69a3bf21b9686c2b})`,
    teal: `var(--ds-background-accent-teal-subtle-pressed, ${$73a5c9d720aa66e1$export$7a8f4d33f6f9772c})`,
    purple: `var(--ds-background-accent-purple-subtle-pressed, ${$73a5c9d720aa66e1$export$363e4475840015bb})`,
    grey: `var(--ds-background-accent-gray-subtle-pressed, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`,
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`,
    redLight: `var(--ds-background-accent-red-subtler-pressed, ${$73a5c9d720aa66e1$export$be802dd0d8b57f35})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$73a5c9d720aa66e1$export$5aae31392d72caaa})`,
    greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$73a5c9d720aa66e1$export$747d86715d4175de})`,
    tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$73a5c9d720aa66e1$export$69cb3ca10c1e330e})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$73a5c9d720aa66e1$export$6011520a64d9a187})`,
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$73a5c9d720aa66e1$export$8754fc7e6d8b3000})`
};
const $fc0da2a7c84ba49c$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`;
const $fc0da2a7c84ba49c$export$7a57f79000377ca2 = {
    default: (0, $jFsza.defaultBorderRadius),
    rounded: (0, $jFsza.defaultRoundedBorderRadius)
};
const $fc0da2a7c84ba49c$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$73a5c9d720aa66e1$export$4b84fd0e2c617bd})`;
const $fc0da2a7c84ba49c$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$73a5c9d720aa66e1$export$4b84fd0e2c617bd})`;
const $fc0da2a7c84ba49c$export$17d206ccea111bbb = `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$2837b5a1a71d5c02})`;
const $fc0da2a7c84ba49c$export$f64c7641cbc22da7 = {
    standard: `var(--ds-text, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    red: `var(--ds-text-accent-red-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    green: `var(--ds-text-accent-green-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    lime: `var(--ds-text-accent-lime-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    magenta: `var(--ds-text-accent-magenta-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    orange: `var(--ds-text-accent-orange-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    grey: `var(--ds-text-accent-gray-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    redLight: `var(--ds-text-accent-red, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    tealLight: `var(--ds-text-accent-teal, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    limeLight: `var(--ds-text-accent-lime, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    magentaLight: `var(--ds-text-accent-magenta, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    orangeLight: `var(--ds-text-accent-orange, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    greyLight: `var(--ds-text-accent-gray, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
};
const $fc0da2a7c84ba49c$export$b03fbc2a369c563e = {
    standard: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    red: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    green: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    lime: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    magenta: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    orange: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    grey: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    limeLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    magentaLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    orangeLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    greyLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
};

});

parcelRegister("d9W8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $98c5a9f7a5ded4f8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $jFsza = parcelRequire("jFsza");

var $i6wnX = parcelRequire("i6wnX");
function $98c5a9f7a5ded4f8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $98c5a9f7a5ded4f8$var$baseStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $jFsza.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $jFsza.defaultMargin),
    padding: "var(--ds-space-0, 0px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $jFsza.cssVar).color.background.default})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.text.default})`,
    cursor: 'default'
});
const $98c5a9f7a5ded4f8$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $jFsza.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $jFsza.defaultMargin),
    position: 'relative',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
    border: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderColor: `var(${(0, $jFsza.cssVar).color.borderColor})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    borderWidth: "var(--ds-border-width, 1px)",
    color: "var(--ds-text, #172B4D)",
    cursor: 'default',
    paddingInline: "var(--ds-space-050, 4px)"
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $98c5a9f7a5ded4f8$var$interactiveStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $jFsza.cssVar).color.background.hover})`
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $jFsza.cssVar).color.background.active})`
    }
});
const $98c5a9f7a5ded4f8$var$interactiveStyles = {
    name: "jcdcgl",
    styles: "&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #091E420F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #091E4224);}"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $98c5a9f7a5ded4f8$var$focusRingStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 2px var(${(0, $jFsza.cssVar).color.focusRing})`,
        outline: 'none'
    }
});
const $98c5a9f7a5ded4f8$var$focusRingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        outline: `2px solid ${$i6wnX.focusRingColors}`,
        outlineOffset: '2px '
    }
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $98c5a9f7a5ded4f8$var$nonStandardLinkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.active})`
    }
});
const $98c5a9f7a5ded4f8$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? $i6wnX.textColors['standardLink'] : $i6wnX.textColors[color];
    const backgroundHoverColors = isRemovable && !isLink ? $i6wnX.backgroundColors[color] : $i6wnX.linkHoverBackgroundColors[color];
    const backgroundActiveColors = isRemovable && !isLink ? $i6wnX.backgroundColors[color] : $i6wnX.linkActiveBackgroundColors[color];
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...other,
        ref: ref,
        css: [
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $98c5a9f7a5ded4f8$var$baseStyles : $98c5a9f7a5ded4f8$var$baseStylesOld,
            isInteractive && ((0, $XHGTv.fg)('platform-component-visual-refresh') ? $98c5a9f7a5ded4f8$var$focusRingStyles : $98c5a9f7a5ded4f8$var$focusRingStylesOld),
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? isLink && $98c5a9f7a5ded4f8$var$interactiveStyles : undefined,
            !(0, $XHGTv.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && $98c5a9f7a5ded4f8$var$nonStandardLinkStyles,
            !(0, $XHGTv.fg)('platform-component-visual-refresh') && isInteractive && $98c5a9f7a5ded4f8$var$interactiveStylesOld
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.borderColor]: $i6wnX.borderColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.default]: $i6wnX.textColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.hover]: $i6wnX.textHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.active]: $i6wnX.textActiveColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.link]: textLinkColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.default]: $i6wnX.backgroundColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.hover]: backgroundHoverColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.active]: backgroundActiveColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.focusRing]: $i6wnX.focusRingColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.removeButton.default]: $i6wnX.removeButtonColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.removeButton.hover]: $i6wnX.removeButtonHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).borderRadius]: $i6wnX.borderRadius[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$98c5a9f7a5ded4f8$export$2e2bcd8739ae039 = $98c5a9f7a5ded4f8$var$BaseTag;

});

parcelRegister("6aZHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $70eddb948b5989f5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $jFsza = parcelRequire("jFsza");
function $70eddb948b5989f5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $70eddb948b5989f5$var$beforeElementStyles = {
    name: "cfjv6",
    styles: "display:flex;height:16px;align-items:center;justify-content:center;inset-block-start:var(--ds-space-0, 0px)"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $70eddb948b5989f5$var$beforeElementStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    insetBlockStart: "var(--ds-space-0, 0px)"
});
const $70eddb948b5989f5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $XHGTv.fg)('platform-component-visual-refresh') ? $70eddb948b5989f5$var$beforeElementStyles : $70eddb948b5989f5$var$beforeElementStylesOld
    }, elemBefore) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$70eddb948b5989f5$export$2e2bcd8739ae039 = $70eddb948b5989f5$var$Before;

});

parcelRegister("gz2Bi", function(module, exports) {

$parcel$export(module.exports, "default", () => $154b7edc63fec879$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $jFsza = parcelRequire("jFsza");
function $154b7edc63fec879$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $154b7edc63fec879$var$baseStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $jFsza.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $jFsza.defaultTextPadding),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineStart: (0, $jFsza.defaultTextPadding),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $154b7edc63fec879$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $jFsza.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $154b7edc63fec879$var$linkStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.text.link})`,
    pointerEvents: 'auto',
    textDecoration: 'none',
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.hover})`,
        textDecoration: 'underline'
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.active})`,
        textDecoration: 'underline'
    },
    '&:focus': {
        outline: 'none'
    }
});
const $154b7edc63fec879$var$linkStyles = {
    name: "1e5oc06",
    styles: "color:var(--ds-text, #172B4D);pointer-events:auto;text-decoration:none;&:hover{color:var(--ds-text, #172B4D);text-decoration:underline;}&:active{color:var(--ds-text, #172B4D);text-decoration:underline;}&:focus{outline:none;}"
};
const $154b7edc63fec879$var$hasAfterStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $jFsza.maxTextWidthUnitless) - (0, $jFsza.buttonWidthUnitless)}px`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $jFsza.textPaddingRight)
});
const $154b7edc63fec879$var$hasAfterStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $jFsza.maxTextWidthUnitless) - (0, $jFsza.buttonWidthUnitless)}px`
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $154b7edc63fec879$var$hasBeforeStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: (0, $jFsza.textMarginLeft)
});
const $154b7edc63fec879$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $byn9U.jsx)(Link, {
        href: href,
        "data-color": color,
        css: [
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$baseStyles : $154b7edc63fec879$var$baseStylesOld,
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$linkStyles : $154b7edc63fec879$var$linkStylesOld,
            !(0, $XHGTv.fg)('platform-component-visual-refresh') && elemBefore && $154b7edc63fec879$var$hasBeforeStyles,
            isRemovable && (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$hasAfterStyles : undefined,
            isRemovable && !(0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$hasAfterStylesOld : undefined
        ]
    }, text);
    else return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$baseStyles : $154b7edc63fec879$var$baseStylesOld,
            !(0, $XHGTv.fg)('platform-component-visual-refresh') && elemBefore && $154b7edc63fec879$var$hasBeforeStyles,
            isRemovable && (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$hasAfterStyles : undefined,
            isRemovable && !(0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$hasAfterStylesOld : undefined
        ]
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$154b7edc63fec879$export$2e2bcd8739ae039 = $154b7edc63fec879$var$Content;

});

parcelRegister("keeN7", function(module, exports) {

$parcel$export(module.exports, "default", () => $4292d770fb9954c5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fbOgz = parcelRequire("fbOgz");

var $XHGTv = parcelRequire("XHGTv");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $jFsza = parcelRequire("jFsza");
const $4292d770fb9954c5$var$removeButtonStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    height: '16px',
    width: '16px',
    margin: 'space.0',
    padding: 'space.0',
    insetInlineEnd: 'space.0',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    appearance: 'none',
    backgroundColor: 'color.background.neutral.subtle',
    border: 'none',
    borderRadius: 'border.radius.050',
    color: 'color.text',
    cursor: 'pointer',
    pointerEvents: 'auto',
    marginInlineStart: 'space.negative.025',
    marginInlineEnd: 'space.negative.025',
    ':focus-visible': {
        outlineOffset: 'space.negative.025'
    },
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $4292d770fb9954c5$var$removeButtonStylesOld = (0, $1ZAYh.xcss)({
    display: 'flex',
    height: '16px',
    margin: 'space.0',
    padding: 'space.0',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    appearance: 'none',
    backgroundColor: 'color.background.neutral.subtle',
    border: 'none',
    // Once legacy theming is dropped, this can be changed to 'border.radius'
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    // Once legacy theming is dropped, this can be changed to 'inherit'
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.removeButton.default})`,
    cursor: 'pointer',
    pointerEvents: 'auto',
    ':focus-visible': {
        outlineOffset: 'space.0'
    },
    ':hover': {
        // Once legacy theming is dropped, this can be changed to 'cssVar.color.text.default'
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.removeButton.hover})`
    }
});
const $4292d770fb9954c5$var$removeButtonStylesOldIcon = (0, $1ZAYh.xcss)({
    insetInlineEnd: 'space.0'
});
const $4292d770fb9954c5$var$removeButtonStylesNewIcon = (0, $1ZAYh.xcss)({
    insetInlineEnd: 'space.025'
});
const $4292d770fb9954c5$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        xcss: [
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $4292d770fb9954c5$var$removeButtonStyles : $4292d770fb9954c5$var$removeButtonStylesOld,
            (0, $XHGTv.fg)('platform-visual-refresh-icons') ? $4292d770fb9954c5$var$removeButtonStylesNewIcon : $4292d770fb9954c5$var$removeButtonStylesOldIcon
        ],
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fbOgz))), {
        color: "currentColor",
        label: "",
        LEGACY_size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4292d770fb9954c5$export$2e2bcd8739ae039 = $4292d770fb9954c5$var$RemoveButton;

});
parcelRegister("fbOgz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77b0cdbbee1b52bd7575a4eda010b0e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0eedfeb10f4bac1$var$_react = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b0eedfeb10f4bac1$var$_cross = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("adUQx")));

var $b0eedfeb10f4bac1$var$_close = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("je5kZ")));
function $b0eedfeb10f4bac1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0eedfeb10f4bac1$var$CrossIcon = (props)=>/*#__PURE__*/ $b0eedfeb10f4bac1$var$_react.default.createElement($b0eedfeb10f4bac1$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $b0eedfeb10f4bac1$var$_close.default
    }, props));
$b0eedfeb10f4bac1$var$CrossIcon.Name = 'CrossIconMigration';
var $b0eedfeb10f4bac1$var$_default = module.exports.default = $b0eedfeb10f4bac1$var$CrossIcon;

});
parcelRegister("adUQx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $771736c5909ba4b4$var$_react = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $771736c5909ba4b4$var$_UNSAFE_baseNew = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $771736c5909ba4b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $771736c5909ba4b4$var$CrossIcon = (props)=>/*#__PURE__*/ $771736c5909ba4b4$var$_react.default.createElement($771736c5909ba4b4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$771736c5909ba4b4$var$CrossIcon.displayName = 'CrossIcon';
var $771736c5909ba4b4$var$_default = module.exports.default = $771736c5909ba4b4$var$CrossIcon;

});

parcelRegister("je5kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff3771012ed2785$var$_react = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $dff3771012ed2785$var$_close = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("02Sz7")));
function $dff3771012ed2785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dff3771012ed2785$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $dff3771012ed2785$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $dff3771012ed2785$var$_close.default
    }));
$dff3771012ed2785$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $dff3771012ed2785$var$_default = module.exports.default = $dff3771012ed2785$var$EditorCloseIcon;

});




parcelRegister("cAKIH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b674095defbc4ab$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $8b674095defbc4ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8b674095defbc4ab$var$baseStyles = {
    name: "1pwt1s8",
    styles: "display:flex;width:100%;flex-wrap:wrap"
};
const $8b674095defbc4ab$var$justifyStartStyles = {
    name: "11g6mpt",
    styles: "justify-content:flex-start"
};
const $8b674095defbc4ab$var$justifyEndStyles = {
    name: "1f60if8",
    styles: "justify-content:flex-end"
};
/**
 * __Tag group__
 *
 * A tag group controls the layout and alignment for a collection of tags.
 *
 * - [Examples](https://atlassian.design/components/tag-group/examples)
 * - [Code](https://atlassian.design/components/tag-group/code)
 * - [Usage](https://atlassian.design/components/tag-group/usage)
 */ const $8b674095defbc4ab$var$TagGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ alignment: alignment = 'start', titleId: titleId, label: label, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "group",
        ref: ref,
        "aria-label": label,
        "aria-labelledby": titleId,
        css: [
            $8b674095defbc4ab$var$baseStyles,
            alignment === 'start' && $8b674095defbc4ab$var$justifyStartStyles,
            alignment === 'end' && $8b674095defbc4ab$var$justifyEndStyles
        ]
    }, children);
});
var $8b674095defbc4ab$export$2e2bcd8739ae039 = $8b674095defbc4ab$var$TagGroup;

});

parcelRegister("iWjkF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a738d99c48fe1eb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6a738d99c48fe1eb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    none: {
        "id": "issue-table.common.fields.common.tags.none",
        "defaultMessage": "None"
    }
});

});



parcelRegister("8JJio", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bf25bddb1e49158$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ak5WI = parcelRequire("ak5WI");

var $jDnEe = parcelRequire("jDnEe");
const $5bf25bddb1e49158$var$MajorIncident = ({ dataSelectorProps: { value: value } })=>value === (0, $ak5WI.MAJOR_INCIDENT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jDnEe.MajorIncidentLozenge), null) : null;
var $5bf25bddb1e49158$export$2e2bcd8739ae039 = $5bf25bddb1e49158$var$MajorIncident;

});
parcelRegister("ak5WI", function(module, exports) {

$parcel$export(module.exports, "MAJOR_INCIDENT", () => $b33156ee50c454aa$export$f5d2c3c7bebeaa98);
$parcel$export(module.exports, "SPOTLIGHT_ID", () => $b33156ee50c454aa$export$1222b4ae9a94b9ec);

var $eMxRI = parcelRequire("eMxRI");
const $b33156ee50c454aa$export$f5d2c3c7bebeaa98 = 'MAJOR_INCIDENT';
const $b33156ee50c454aa$var$MAJOR_INCIDENT_FIELD_KEY = 'major-incident-field';
const $b33156ee50c454aa$export$1222b4ae9a94b9ec = `${(0, $eMxRI.ISSUE_FIELD_SPOTLIGHT_PREFIX)}${$b33156ee50c454aa$var$MAJOR_INCIDENT_FIELD_KEY}`;

});
parcelRegister("eMxRI", function(module, exports) {

$parcel$export(module.exports, "BOARD_SIDEBAR", () => $5a120aeb28a0304e$export$d84e7970e2d564af);
$parcel$export(module.exports, "EDIT_FIELD", () => $5a120aeb28a0304e$export$256eddbefbf4b2ce);
$parcel$export(module.exports, "GIVE_FEEDBACK", () => $5a120aeb28a0304e$export$3c1bb52064935485);
$parcel$export(module.exports, "STATUS_AND_APPROVAL_SPOTLIGHT", () => $5a120aeb28a0304e$export$988f0f6f6457039a);
$parcel$export(module.exports, "STATUS_SPOTLIGHT", () => $5a120aeb28a0304e$export$b11eec52127ca1f1);
$parcel$export(module.exports, "ISSUE_FIELD_SPOTLIGHT_PREFIX", () => $5a120aeb28a0304e$export$2028cf1423b28cf8);
const $5a120aeb28a0304e$export$d84e7970e2d564af = 'BOARD_SIDEBAR';
const $5a120aeb28a0304e$export$256eddbefbf4b2ce = 'EDIT_FIELD';
const $5a120aeb28a0304e$export$3c1bb52064935485 = 'GIVE_FEEDBACK';
const $5a120aeb28a0304e$export$95f98990d7202b31 = 'SHOW_MORE';
const $5a120aeb28a0304e$export$988f0f6f6457039a = 'status-and-approval-spotlight';
const $5a120aeb28a0304e$export$b11eec52127ca1f1 = 'status-spotlight';
const $5a120aeb28a0304e$export$e5820f3349d3bcf0 = 'reporter-spotlight';
const $5a120aeb28a0304e$export$2028cf1423b28cf8 = 'global-spotlight-target-';
const $5a120aeb28a0304e$export$43c3daf5ccfeb2da = {
    ASSIGNEE: {
        TIME_TO_RENDER_INITIAL_SUGGESTIONS: 'jira.fe.issue.fields.assignee.time-to.render-initial-suggestions',
        TIME_TO_REFLECT_INPUT_RESULT: 'jira.fe.issue.fields.assignee.time-to.reflect-input-results',
        TIME_TO_REFLECT_SELECTED: 'jira.fe.issue.fields.assignee.time-to.reflect-selected',
        TIME_TO_ASSIGN_TO_ME_VIA_SHORTCUT: 'jira.fe.issue.fields.assignee.time-to.assign-to-me-via-shortcut'
    },
    SUMMARY: {
        TIME_TO_RENDER_EDIT_VIEW: 'jira.fe.issue.field.summary.time-to.render-edit-view',
        TIME_TO_RENDER_READ_VIEW_ON_CONFIRM: 'jira.fe.issue.field.summary.time-to.render-read-view-on-confirm',
        TIME_TO_RENDER_READ_VIEW_ON_CANCEL: 'jira.fe.issue.field.summary.time-to.render-read-view-on-cancel'
    },
    LABELS: {
        TIME_TO_RENDER_INITIAL_SUGGESTIONS: 'jira.fe.issue.fields.labels.time-to.render-initial-suggestions',
        TIME_TO_REFLECT_INPUT_RESULT: 'jira.fe.issue.fields.labels.time-to.reflect-input-results',
        TIME_TO_RENDER_READ_VIEW_ON_CONFIRM: 'jira.fe.issue.field.labels.time-to.render-read-view-on-confirm',
        TIME_TO_RENDER_READ_VIEW_ON_CANCEL: 'jira.fe.issue.field.labels.time-to.render-read-view-on-cancel',
        TIME_TO_REFLECT_SELECTED_EXISTING: 'jira.fe.issue.fields.labels.time-to.reflect-selected-existing',
        TIME_TO_REFLECT_SELECTED_NEW: 'jira.fe.issue.fields.labels.time-to.reflect-selected-new',
        TIME_TO_REFLECT_REMOVED_EXISTING: 'jira.fe.issue.fields.labels.time-to.reflect-removed-existing'
    },
    STORY_POINTS: {
        TIME_TO_RENDER_EDIT_VIEW: 'jira.fe.issue.field.story-points.time-to.render-edit-view',
        TIME_TO_RENDER_READ_VIEW_ON_CONFIRM: 'jira.fe.issue.field.story-points.time-to.render-read-view-on-confirm',
        TIME_TO_RENDER_READ_VIEW_ON_CANCEL: 'jira.fe.issue.field.story-points.time-to.render-read-view-on-cancel'
    },
    ISSUE_LINKS: {
        TIME_TO_REFLECT_SELECTED_ISSUE: 'jira.fe.issue.fields.issue-links.time-to.reflect-selected-issue',
        TIME_TO_REFLECT_REMOVED_ISSUE: 'jira.fe.issue.fields.issue-links.time-to.reflect-removed-issue',
        TIME_TO_REFLECT_INPUT_RESULT: 'jira.fe.issue.fields.issue-links.time-to.reflect-input-results',
        TIME_TO_RENDER_LINKED_ISSUE: 'jira.fe.issue.fields.issue-links.time-to.render-linked-issue',
        TIME_TO_RENDER_NEW_LINKED_ISSUE_INPUT: 'jira.fe.issue.fields.issue-links.time-to.render-new-linked-issue-input'
    },
    SPRINT: {
        TIME_TO_REFLECT_SELECTED_SPRINT: 'jira.fe.issue.fields.sprint.time-to.reflect-selected-sprint',
        TIME_TO_REFLECT_REMOVED_SPRINT: 'jira.fe.issue.fields.sprint.time-to.reflect-removed-sprint',
        TIME_TO_REFLECT_INPUT_RESULT: 'jira.fe.issue.fields.sprint.time-to.reflect-input-results',
        TIME_TO_RENDER_READ_VIEW: 'jira.fe.issue.fields.sprint.time-to.render-read-view',
        TIME_TO_RENDER_INITIAL_SUGGESTIONS: 'jira.fe.issue.fields.sprint.time-to.render-initial-suggestions'
    },
    PRIORITY: {
        TIME_TO_RENDER_READ_VIEW: 'jira.fe.issue.fields.priority.time-to.render-read-view',
        TIME_TO_RENDER_SUGGESTIONS: 'jira.fe.issue.fields.priority.time-to.render-suggestions',
        TIME_TO_REFLECT_PRIORITY_UPDATE: 'jira.fe.issue.fields.priority.time-to.reflect-priority-update'
    },
    COMMENTS: {
        TIME_TO_RENDER_NEW_COMMENT_EDITOR: 'jira.fe.issue.fields.comments.time-to.render-new-comment-editor',
        TIME_TO_RENDER_SAVED_COMMENT: 'jira.fe.issue.fields.comments.time-to.render-saved-comment'
    },
    DESCRIPTION: {
        TIME_TO_RENDER_EDIT_VIEW: 'jira.fe.issue.field.description.time-to.render-edit-view',
        TIME_TO_SAVE_UPDATED_DESCRIPTION: 'jira.fe.issue.field.description.time-to.save-updated-description',
        TIME_TO_SAVE_UNCHANGED_DESCRIPTION: 'jira.fe.issue.field.description.time-to.save-unchanged-description'
    },
    EPIC_LINKS: {
        TIME_TO_FETCH_INPUT_RESULTS_EPIC_PICKER_ENABLED: 'jira.fe.issue.fields.epic-link.time-to.fetch-input-results.epic-picker-enabled',
        TIME_TO_FETCH_INPUT_RESULTS_EPIC_PICKER_DISABLED: 'jira.fe.issue.fields.epic-link.time-to.fetch-input-results.epic-picker-disabled'
    }
};

});


parcelRegister("jDnEe", function(module, exports) {

$parcel$export(module.exports, "MajorIncidentLozenge", () => $f204ab5477af9292$export$d005b05e81381a5a);
$parcel$export(module.exports, "MajorIncidentLozengeWithTooltip", () => $f204ab5477af9292$export$1f7421f79cdd882a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ffiyv = parcelRequire("ffiyv");

var $2eG9N = parcelRequire("2eG9N");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $2wCUM = parcelRequire("2wCUM");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $itJNi = parcelRequire("itJNi");

var $dWLk9 = parcelRequire("dWLk9");

var $ak5WI = parcelRequire("ak5WI");

var $bxn6g = parcelRequire("bxn6g");

var $byave = parcelRequire("byave");
const $f204ab5477af9292$export$d005b05e81381a5a = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "removed"
    }, formatMessage((0, $byave.default).lozengeLabel));
};
const $f204ab5477af9292$export$1f7421f79cdd882a = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { isEntitled: isMIMEntitled } = (0, $itJNi.useJsmMimEntitlementResource)((0, $dWLk9.useCloudId)());
    const issueKey = (0, $hJ992.useIssueKey)();
    const [{ value: value }] = (0, $bxn6g.useMajorIncidentField)({
        issueKey: issueKey
    });
    const isIssueOfIncidentsPractice = (0, $2wCUM.useIsIssueOfIncidentsPractice)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const shouldRenderLozenge = (0, $1ybV0.ff)('im_feature_enablement_gating') ? isMIMEntitled && isIssueOfIncidentsPractice && value === (0, $ak5WI.MAJOR_INCIDENT) : isIssueOfIncidentsPractice && value === (0, $ak5WI.MAJOR_INCIDENT);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldRenderLozenge) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'majorIncidentLozenge viewed', {
            action: 'viewed',
            actionSubjectId: 'majorIncidentLozenge',
            teamName: 'jsm-getting-started'
        });
    }, [
        createAnalyticsEvent,
        shouldRenderLozenge
    ]);
    return shouldRenderLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f204ab5477af9292$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $byave.default).tootltipContent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f204ab5477af9292$export$d005b05e81381a5a, null))) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f204ab5477af9292$var$LozengeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hJ992", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimit", () => $7e3614f655e5103c$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $7e3614f655e5103c$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $7e3614f655e5103c$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $7e3614f655e5103c$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $7e3614f655e5103c$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $7e3614f655e5103c$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $7e3614f655e5103c$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $7e3614f655e5103c$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $7e3614f655e5103c$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $7e3614f655e5103c$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $7e3614f655e5103c$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $7e3614f655e5103c$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $7e3614f655e5103c$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "useBackButtonUrl", () => $7e3614f655e5103c$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $7e3614f655e5103c$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $7e3614f655e5103c$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $7e3614f655e5103c$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $7e3614f655e5103c$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $7e3614f655e5103c$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $7e3614f655e5103c$export$4596c26005fbb859);
$parcel$export(module.exports, "useIsAiOptInEnabled", () => $7e3614f655e5103c$export$b131d9f6da853161);
$parcel$export(module.exports, "useIsJiraIssue", () => $7e3614f655e5103c$export$cf5fc815f761fb4b);

var $eUqFw = parcelRequire("eUqFw");


var $7ZZxN = parcelRequire("7ZZxN");

var $e91YZ = parcelRequire("e91YZ");

var $guDlK = parcelRequire("guDlK");

var $6vrw7 = parcelRequire("6vrw7");

var $7HKaW = parcelRequire("7HKaW");

var $jBTMs = parcelRequire("jBTMs");

var $j3FUN = parcelRequire("j3FUN");

var $hWdjG = parcelRequire("hWdjG");
const $7e3614f655e5103c$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $hWdjG.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $7e3614f655e5103c$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $hWdjG.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $7e3614f655e5103c$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $7e3614f655e5103c$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $7e3614f655e5103c$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $hWdjG.useIssueContextStoreIsModal)();
    return isModal;
};
const $7e3614f655e5103c$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $7e3614f655e5103c$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $hWdjG.useIssueContextStoreIssueId)();
    return issueId;
};
const $7e3614f655e5103c$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $hWdjG.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $7e3614f655e5103c$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $hWdjG.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $7e3614f655e5103c$export$f87be37f8e8be65 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return (0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);
};
const $7e3614f655e5103c$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $hWdjG.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $7e3614f655e5103c$export$d6ec1293313f49ac = ()=>{
    const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, $hWdjG.useIssueContextStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            resetDetailView: resetDetailView
        }), [
        setIssueContext,
        mergeIssueContext,
        getChildIssuesLimit,
        getMaxTokenLength,
        getIsLoadedWithPage,
        getBackButtonUrl,
        getIsSpaEnabled,
        getIssueKey,
        setDetailViewAsModal,
        setDetailViewAsSidebar,
        resetDetailView
    ]);
    return [
        undefined,
        actions
    ];
};
const $7e3614f655e5103c$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $hWdjG.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $7e3614f655e5103c$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $hWdjG.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $7e3614f655e5103c$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $hWdjG.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $7e3614f655e5103c$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $hWdjG.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $7e3614f655e5103c$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $hWdjG.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $7e3614f655e5103c$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $hWdjG.useIssueContextStoreViewMode)();
    return viewMode;
};
const $7e3614f655e5103c$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $hWdjG.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $7e3614f655e5103c$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $hWdjG.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $7e3614f655e5103c$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $hWdjG.useIssueContextStoreBoardId)();
    return boardId;
};
const $7e3614f655e5103c$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $hWdjG.useIssueContextStoreBoardType)();
    return boardType;
};
const $7e3614f655e5103c$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $hWdjG.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $7e3614f655e5103c$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $hWdjG.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $7e3614f655e5103c$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $hWdjG.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $7e3614f655e5103c$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $hWdjG.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $7e3614f655e5103c$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $hWdjG.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const licenseStates = (0, $jBTMs.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $7HKaW.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $7e3614f655e5103c$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$b19f949fb9713614);
};
const $7e3614f655e5103c$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$a5132300c5214280);
};
const $7e3614f655e5103c$export$b131d9f6da853161 = ()=>{
    const [isAiOptInEnabled] = (0, $hWdjG.useIssueContextIsAiOptInEnabled)();
    return isAiOptInEnabled;
};
const $7e3614f655e5103c$export$cf5fc815f761fb4b = ()=>{
    const issueKey = $7e3614f655e5103c$export$22108eca27445997();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    return [
        (0, $7ZZxN.SOFTWARE_PROJECT),
        (0, $7ZZxN.CORE_PROJECT)
    ].some((type)=>type === projectType);
};

});
const $0100842672acae20$export$53d41ff2666118e1 = 'agility-backlog';
const $0100842672acae20$export$7552fe2669628499 = 'bitbucket-issue';
const $0100842672acae20$export$41a718da0a8636f4 = 'connect-issue';
const $0100842672acae20$export$cebf0bc8b2ccaf57 = 'core-issue';
const $0100842672acae20$export$5e91e17726e54450 = 'jiraCalendar';
const $0100842672acae20$export$82540942fb014b0a = 'business-calendar';
const $0100842672acae20$export$7ca28938a07e0c33 = 'business-list';
const $0100842672acae20$export$f6cf06aaaeb58a54 = 'business-timeline';
const $0100842672acae20$export$b2c0462ff17aa26e = 'business-board';
const $0100842672acae20$export$a607850ebccd28ac = 'business-approvals';
const $0100842672acae20$export$1da6cede3561048f = 'business-files';
const $0100842672acae20$export$b19f949fb9713614 = 'full-issue';
const $0100842672acae20$export$a5132300c5214280 = 'embed-issue';
const $0100842672acae20$export$710114090a811b37 = 'global-issue-navigator-issue';
const $0100842672acae20$export$ce88447986394f2d = 'mobile-issue';
const $0100842672acae20$export$6a90d9196d330040 = 'project-issue-navigator';
const $0100842672acae20$export$2247c9059c171db1 = 'roadmap-issue';
const $0100842672acae20$export$cd16d39c55c569d0 = 'simple-software-board';
const $0100842672acae20$export$f72626bf0d75dfad = 'software-backlog-issue';
const $0100842672acae20$export$778b4609e784cb27 = 'software-deployments-issue';
const $0100842672acae20$export$5b73d694a6048002 = 'version-detail-issue';
const $0100842672acae20$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $0100842672acae20$export$21b5b7189add7861 = 'software-incidents-issue';
const $0100842672acae20$export$9c5d81b901471b27 = 'software-issue';
const $0100842672acae20$export$1735f6ad917dc411 = 'change-calendar';
const $0100842672acae20$export$7063ee6d0035a982 = 'queues-issue-view';
const $0100842672acae20$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $0100842672acae20$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $0100842672acae20$export$14a8072f422804fd = 'issue-navigator-next';

parcelRegister("guDlK", function(module, exports) {

$parcel$export(module.exports, "useProjectKey", () => $598d4d607d97d3ec$export$f87be37f8e8be65);
$parcel$export(module.exports, "useProjectContextActions", () => $598d4d607d97d3ec$export$bd73624ca941f105);
$parcel$export(module.exports, "useProjectType", () => $598d4d607d97d3ec$export$6de29d851c914935);
$parcel$export(module.exports, "useProjectContext", () => $598d4d607d97d3ec$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useApplication", () => $598d4d607d97d3ec$export$aaf75bb403fe1fb5);
$parcel$export(module.exports, "useEdition", () => $598d4d607d97d3ec$export$d56c02945cf5a9e5);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $598d4d607d97d3ec$export$524ef4f6102ed540);
$parcel$export(module.exports, "useIsClassicProject", () => $598d4d607d97d3ec$export$e2cf96f40a8867ce);
$parcel$export(module.exports, "useProjectId", () => $598d4d607d97d3ec$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProjectStatus", () => $598d4d607d97d3ec$export$30f16f2782a4113b);
$parcel$export(module.exports, "useProjectConfiguration", () => $598d4d607d97d3ec$export$af19ad68b52fa1a6);
$parcel$export(module.exports, "useProjectIssueTypes", () => $598d4d607d97d3ec$export$80bef597b440cf71);

var $eUqFw = parcelRequire("eUqFw");

var $eIp1n = parcelRequire("eIp1n");

var $6WXNs = parcelRequire("6WXNs");

var $6vrw7 = parcelRequire("6vrw7");

var $gd0Sp = parcelRequire("gd0Sp");

var $lbuGg = parcelRequire("lbuGg");

var $9ZB9O = parcelRequire("9ZB9O");
const $598d4d607d97d3ec$export$f87be37f8e8be65 = (issueKey)=>(0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);
const $598d4d607d97d3ec$export$bd73624ca941f105 = ()=>{
    const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, $lbuGg.useProjectContextActionStore)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setProjectContext: setProjectContext,
            mergeProjectProperty: mergeProjectProperty
        }), [
        setProjectContext,
        mergeProjectProperty
    ]);
    return [
        null,
        actions
    ];
};
const $598d4d607d97d3ec$export$6de29d851c914935 = (projectKey)=>{
    const [projectType] = (0, $lbuGg.useProjectContextProjectTypeStore)({
        projectKey: projectKey
    });
    return projectType;
};
const $598d4d607d97d3ec$export$8f31c2503e1efa93 = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext;
};
const $598d4d607d97d3ec$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
    const projectType = $598d4d607d97d3ec$export$6de29d851c914935(projectKey);
    if (projectType === undefined) {
        if (failSafely) return undefined;
        throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
    }
    return (0, $eIp1n.getApplicationForProject)(projectType);
};
const $598d4d607d97d3ec$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
    const { appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    const application = $598d4d607d97d3ec$export$aaf75bb403fe1fb5(projectKey, failSafely);
    if (!application) return undefined;
    return (0, $6WXNs.getEdition)(application, appEditions);
};
const $598d4d607d97d3ec$export$524ef4f6102ed540 = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.isSimplified || false;
};
const $598d4d607d97d3ec$export$e2cf96f40a8867ce = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return !projectContext?.isSimplified;
};
const $598d4d607d97d3ec$export$16d1475ed6c26568 = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectId;
};
const $598d4d607d97d3ec$export$30f16f2782a4113b = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectStatus;
};
const $598d4d607d97d3ec$export$af19ad68b52fa1a6 = (projectKey)=>{
    const projectType = $598d4d607d97d3ec$export$6de29d851c914935(projectKey);
    const isSimplified = $598d4d607d97d3ec$export$524ef4f6102ed540(projectKey);
    return (0, $9ZB9O.getIssueConfiguration)({
        isSimplified: isSimplified,
        projectType: projectType
    });
};
const $598d4d607d97d3ec$export$654dd2c557853fbe = (projectKey)=>{
    const [projectName] = (0, $lbuGg.useProjectContextProjectNameStore)({
        projectKey: projectKey
    });
    return projectName;
};
const $598d4d607d97d3ec$export$80bef597b440cf71 = (projectKey)=>{
    const [issueTypes] = (0, $lbuGg.useProjectContextIssueTypesStore)({
        projectKey: projectKey
    });
    return issueTypes;
};

});
parcelRegister("lbuGg", function(module, exports) {

$parcel$export(module.exports, "useProjectContextActionStore", () => $4715ac6bc4ce2fb7$export$9afb89c1fe103bbe);
$parcel$export(module.exports, "useProjectContextStore", () => $4715ac6bc4ce2fb7$export$8b09478b33186ec);
$parcel$export(module.exports, "useProjectContextProjectTypeStore", () => $4715ac6bc4ce2fb7$export$f2e1ed3b2b4707cb);
$parcel$export(module.exports, "useProjectContextProjectNameStore", () => $4715ac6bc4ce2fb7$export$9469fde70658518);
$parcel$export(module.exports, "useProjectContextIssueTypesStore", () => $4715ac6bc4ce2fb7$export$f73e9904779f6be5);

var $WBLbN = parcelRequire("WBLbN");

var $bAXOf = parcelRequire("bAXOf");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4715ac6bc4ce2fb7$var$initialState = {};
const $4715ac6bc4ce2fb7$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    name: 'project-context',
    initialState: $4715ac6bc4ce2fb7$var$initialState,
    actions: $bAXOf
});
const $4715ac6bc4ce2fb7$export$9afb89c1fe103bbe = (0, $WBLbN.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: null
});
const $4715ac6bc4ce2fb7$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
const $4715ac6bc4ce2fb7$export$8b09478b33186ec = (0, $WBLbN.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getProjectContext
});
const $4715ac6bc4ce2fb7$var$getProjectType = (state, { projectKey: projectKey })=>{
    const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectType;
};
const $4715ac6bc4ce2fb7$export$f2e1ed3b2b4707cb = (0, $WBLbN.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getProjectType
});
const $4715ac6bc4ce2fb7$var$getProjectName = (state, { projectKey: projectKey })=>{
    const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectName;
};
const $4715ac6bc4ce2fb7$export$9469fde70658518 = (0, $WBLbN.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getProjectName
});
const $4715ac6bc4ce2fb7$var$getIssueTypes = (state, { projectKey: projectKey })=>{
    const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.issueTypes;
};
const $4715ac6bc4ce2fb7$export$f73e9904779f6be5 = (0, $WBLbN.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getIssueTypes
});

});
parcelRegister("bAXOf", function(module, exports) {

$parcel$export(module.exports, "setProjectContext", () => $f8fc64b164fe014a$export$d64151aab9ae5f09);
$parcel$export(module.exports, "mergeProjectProperty", () => $f8fc64b164fe014a$export$78f1c6052937615f);
const $f8fc64b164fe014a$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: projectContext
        });
    };
const $f8fc64b164fe014a$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentProjectContext = currentState[key];
        const newProjectContext = {
            ...currentProjectContext,
            ...projectContext
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: newProjectContext
        });
    };

});


parcelRegister("9ZB9O", function(module, exports) {

$parcel$export(module.exports, "getIssueConfiguration", () => $78bf57e6f575c3aa$export$902f6c5cc939598a);

var $2wUFy = parcelRequire("2wUFy");

var $7ZZxN = parcelRequire("7ZZxN");
const $78bf57e6f575c3aa$export$cdbd1eb3b05729e0 = 'flagActions';
const $78bf57e6f575c3aa$export$c161a774ec2e7e56 = 'cardCoverActions';
const $78bf57e6f575c3aa$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $78bf57e6f575c3aa$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $2wUFy.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $2wUFy.default).SOFTWARE_ISSUE,
        issueActions: [
            $78bf57e6f575c3aa$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $2wUFy.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $78bf57e6f575c3aa$export$cdbd1eb3b05729e0,
            $78bf57e6f575c3aa$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $2wUFy.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $78bf57e6f575c3aa$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $2wUFy.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $78bf57e6f575c3aa$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $2wUFy.default).MOBILE_ISSUE,
        issueActions: []
    });
const $78bf57e6f575c3aa$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $2wUFy.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if (config.isSimplified) return $78bf57e6f575c3aa$export$aebf676dfa727a1c();
            return $78bf57e6f575c3aa$export$27e0678365e5dcff();
        case 0, $7ZZxN.CORE_PROJECT:
            return $78bf57e6f575c3aa$export$381ce08838c53afa();
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return $78bf57e6f575c3aa$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $78bf57e6f575c3aa$export$27e0678365e5dcff();
    }
    return $78bf57e6f575c3aa$export$27e0678365e5dcff();
};

});
parcelRegister("2wUFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $78d48529cb7f139c$export$2e2bcd8739ae039);
const $78d48529cb7f139c$var$keys = {
    CONNECT_ISSUE: 'connect-issue',
    BITBUCKET_ISSUE: 'bitbucket-issue',
    CORE_ISSUE: 'core-issue',
    MOBILE_ISSUE: 'mobile-issue',
    SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
    SOFTWARE_ISSUE: 'software-issue',
    STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
    SERVICE_DESK: 'service-desk',
    EMPTY_APPLICATION_KEY: ''
};
var $78d48529cb7f139c$export$2e2bcd8739ae039 = $78d48529cb7f139c$var$keys;

});



parcelRegister("jBTMs", function(module, exports) {

$parcel$export(module.exports, "useLicenseStates", () => $0a5df676eadd90b5$export$268651a63abe408a);

var $gd0Sp = parcelRequire("gd0Sp");
const $0a5df676eadd90b5$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("j3FUN", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $02df0e5ac33ae573$export$54d534cc91e54850);

var $gd0Sp = parcelRequire("gd0Sp");
const $02df0e5ac33ae573$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("hWdjG", function(module, exports) {

$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $c495211a89197754$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $c495211a89197754$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $c495211a89197754$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $c495211a89197754$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $c495211a89197754$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $c495211a89197754$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $c495211a89197754$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $c495211a89197754$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $c495211a89197754$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $c495211a89197754$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $c495211a89197754$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $c495211a89197754$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $c495211a89197754$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $c495211a89197754$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $c495211a89197754$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $c495211a89197754$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $c495211a89197754$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $c495211a89197754$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $c495211a89197754$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $c495211a89197754$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $c495211a89197754$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $c495211a89197754$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $c495211a89197754$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiOptInEnabled", () => $c495211a89197754$export$7e70ee570119a0a7);
$parcel$export(module.exports, "IssueContextContainer", () => $c495211a89197754$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $c495211a89197754$export$965360ae27fcae98);

var $6vrw7 = parcelRequire("6vrw7");

var $WBLbN = parcelRequire("WBLbN");

var $8d785 = parcelRequire("8d785");

var $hHM8F = parcelRequire("hHM8F");

var $fhgeS = parcelRequire("fhgeS");
const $c495211a89197754$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: (0, $6vrw7.toIssueKey)(''),
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $fhgeS.getViewModeFromLocalStorage)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false
};
const $c495211a89197754$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    name: 'issue-context',
    initialState: $c495211a89197754$export$d4c72bab9d6cc13a,
    actions: $8d785.actions
});
const $c495211a89197754$var$getIssueContext = (state)=>state;
const $c495211a89197754$var$getIsModal = (state)=>state.isModal;
const $c495211a89197754$var$getIssueKey = (state)=>state.issueKey;
const $c495211a89197754$var$getIsArchived = (state)=>state.isArchived;
const $c495211a89197754$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $c495211a89197754$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $c495211a89197754$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $c495211a89197754$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $c495211a89197754$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $c495211a89197754$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $c495211a89197754$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $c495211a89197754$var$getIsLoading = (state)=>state.isLoading;
const $c495211a89197754$var$getViewMode = (state)=>state.viewMode;
const $c495211a89197754$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $c495211a89197754$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $c495211a89197754$var$getBoardId = (state)=>state.boardId;
const $c495211a89197754$var$getBoardType = (state)=>state.boardType;
const $c495211a89197754$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $c495211a89197754$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $c495211a89197754$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $c495211a89197754$var$getRapidViewId = (state)=>state.rapidViewId;
const $c495211a89197754$var$getViewScreenId = (state)=>state.viewScreenId;
const $c495211a89197754$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $c495211a89197754$export$f6e0a3ee03299fbc = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueContext
});
const $c495211a89197754$export$abdbea56d86b4aac = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesLimit)
});
const $c495211a89197754$export$326ff2b963d51c5c = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesIssueLimitUrls)
});
const $c495211a89197754$export$44bcaaabb74e402b = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueKey
});
const $c495211a89197754$export$332dcee0cf9f4e45 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueId
});
const $c495211a89197754$export$c940355b1fc6e1c4 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsArchived
});
const $c495211a89197754$export$b9eebaa1da421997 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsClassifyEditEnabled
});
const $c495211a89197754$export$daa47fd600e43a32 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsModal
});
const $c495211a89197754$export$ba2e9546ab5ba6f = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewScreenId
});
const $c495211a89197754$export$74d38d6c437efc1b = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getAnalyticsSource
});
const $c495211a89197754$export$2092528ee170d9e7 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewMap
});
const $c495211a89197754$export$57898374e6239a5a = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getMaxTokenLength
});
const $c495211a89197754$export$ff0264ec4c015dc1 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoadedWithPage
});
const $c495211a89197754$export$6c8b81f6dca8c23d = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getEstimationStatistic
});
const $c495211a89197754$export$fe7085456138f0fc = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoading
});
const $c495211a89197754$export$c339e36468c12443 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewMode
});
const $c495211a89197754$export$ef3bfa2642bb98cd = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBackButtonUrl
});
const $c495211a89197754$export$8accd063c74cd455 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueNavigatorData
});
const $c495211a89197754$export$e7edffc2a20027e7 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardId
});
const $c495211a89197754$export$48aaa3a6bc2085d7 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardType
});
const $c495211a89197754$export$4a4b96bcf5166327 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsSpaEnabled
});
const $c495211a89197754$export$bbd8ba0180545556 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getLoginRedirectUrl
});
const $c495211a89197754$export$aaa89627762c7d00 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getOnIssueKeyChange
});
const $c495211a89197754$export$796589b0ec52848a = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewId
});
const $c495211a89197754$export$7e70ee570119a0a7 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsAiOptInEnabled
});
const $c495211a89197754$export$93db6a8f3342dddf = (0, $WBLbN.createContainer)($c495211a89197754$export$6f57813fe9f31bf9);
const $c495211a89197754$export$965360ae27fcae98 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("8d785", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0a3f8ba487c482e8$export$e324594224ef24da);

var $7LyiF = parcelRequire("7LyiF");

var $hHM8F = parcelRequire("hHM8F");

var $fhgeS = parcelRequire("fhgeS");
const $0a3f8ba487c482e8$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || getState().viewMode
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || getState().viewMode
        });
    };
const $0a3f8ba487c482e8$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $0a3f8ba487c482e8$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, $hHM8F.getChildIssuesLimit)(getState());
const $0a3f8ba487c482e8$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
const $0a3f8ba487c482e8$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $0a3f8ba487c482e8$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
const $0a3f8ba487c482e8$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $0a3f8ba487c482e8$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
const $0a3f8ba487c482e8$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
const $0a3f8ba487c482e8$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), 'MODAL');
        setState({
            viewMode: 'MODAL'
        });
    };
const $0a3f8ba487c482e8$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), 'SIDEBAR');
        setState({
            viewMode: 'SIDEBAR'
        });
    };
const $0a3f8ba487c482e8$export$75007d125f198b78 = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $fhgeS.getViewModeFromLocalStorage)()
        });
    };
const $0a3f8ba487c482e8$export$e324594224ef24da = {
    setIssueContext: $0a3f8ba487c482e8$export$784a03c4b74da53e,
    mergeIssueContext: $0a3f8ba487c482e8$export$666ee48e0eaf4f13,
    getChildIssuesLimit: $0a3f8ba487c482e8$export$89b6937a83edcaa6,
    getMaxTokenLength: $0a3f8ba487c482e8$export$e40f2acaf1a50b00,
    getIsLoadedWithPage: $0a3f8ba487c482e8$export$2fe981b90be13483,
    getBackButtonUrl: $0a3f8ba487c482e8$export$afce556782490aae,
    getIsSpaEnabled: $0a3f8ba487c482e8$export$711dfa096bf81f2d,
    getIssueKey: $0a3f8ba487c482e8$export$4a030f6192bebe03,
    getIsArchived: $0a3f8ba487c482e8$export$b41341ac6c74ca6,
    setDetailViewAsModal: $0a3f8ba487c482e8$export$77ec0de2f63f10c4,
    setDetailViewAsSidebar: $0a3f8ba487c482e8$export$b303af51de56a0e,
    resetDetailView: $0a3f8ba487c482e8$export$75007d125f198b78
};

});
parcelRegister("7LyiF", function(module, exports) {

$parcel$export(module.exports, "LOG_LOCATION", () => $7643f341d271ccc9$export$25a759e49d5049db);
$parcel$export(module.exports, "localStorage", () => $7643f341d271ccc9$export$c2ed3351cac403d1);
$parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", () => $7643f341d271ccc9$export$a13f7f627010bccd);

var $aZaPn = parcelRequire("aZaPn");
const $7643f341d271ccc9$export$25a759e49d5049db = 'issue.issue-context-service';
const $7643f341d271ccc9$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_issue_view');
const $7643f341d271ccc9$export$a13f7f627010bccd = 'view-mode';

});

parcelRegister("hHM8F", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $a9a8c93b5bcca8ab$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $a9a8c93b5bcca8ab$export$8f43520910e8128c);

var $gUUjF = parcelRequire("gUUjF");

var $7LyiF = parcelRequire("7LyiF");
// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData(`${(0, $7LyiF.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $a9a8c93b5bcca8ab$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $a9a8c93b5bcca8ab$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});

parcelRegister("fhgeS", function(module, exports) {

$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $49ad189ccd6ad8c9$export$cae7c4c591dcc261);

var $7LyiF = parcelRequire("7LyiF");
const $49ad189ccd6ad8c9$export$cae7c4c591dcc261 = ()=>(0, $7LyiF.localStorage).get((0, $7LyiF.VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';

});




parcelRegister("2wCUM", function(module, exports) {

$parcel$export(module.exports, "usePracticesFieldValue", () => $7ae062e66f35ed18$export$edecf7b484763b0d);
$parcel$export(module.exports, "useIsAgentOrProjectAdmin", () => $7ae062e66f35ed18$export$e1f1a212ffd431eb);
$parcel$export(module.exports, "useIsIssueOfIncidentsPractice", () => $7ae062e66f35ed18$export$3d5b53ead0d10d84);
$parcel$export(module.exports, "useIsIssueOfPostIncidentReviewPractice", () => $7ae062e66f35ed18$export$2a245b8b8b1276b1);
$parcel$export(module.exports, "useIsIssueOfDeveloperEscalationPractice", () => $7ae062e66f35ed18$export$4f9a7f08c8bc7afb);

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $lO4Or = parcelRequire("lO4Or");

var $9V785 = parcelRequire("9V785");

var $jyTef = parcelRequire("jyTef");

var $f1lMr = parcelRequire("f1lMr");
const $7ae062e66f35ed18$export$edecf7b484763b0d = ({ issueKey: issueKey })=>(0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.SERVICEDESK_PRACTICES_TYPE)
    });
const $7ae062e66f35ed18$export$e1f1a212ffd431eb = ()=>{
    const [{ data: data, error: error }] = (0, $jyTef.useServiceDeskContext)();
    if (error) return false;
    return data?.userRole === (0, $9V785.USER_JSM_PROJECT_ROLE).AGENT_ROLE || data?.userRole === (0, $9V785.USER_JSM_PROJECT_ROLE).AGENT_PROJECT_ADMIN_ROLE;
};
const $7ae062e66f35ed18$export$3d5b53ead0d10d84 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [practices] = $7ae062e66f35ed18$export$edecf7b484763b0d({
        issueKey: issueKey
    });
    return Array.isArray(practices) && practices?.includes((0, $f1lMr.INCIDENTS));
};
const $7ae062e66f35ed18$export$2a245b8b8b1276b1 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [practices] = $7ae062e66f35ed18$export$edecf7b484763b0d({
        issueKey: issueKey
    });
    return Array.isArray(practices) && practices?.includes((0, $f1lMr.POST_INCIDENT_REVIEWS));
};
const $7ae062e66f35ed18$export$4f9a7f08c8bc7afb = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const [practices] = $7ae062e66f35ed18$export$edecf7b484763b0d({
        issueKey: issueKey
    });
    return Array.isArray(practices) && practices?.includes((0, $f1lMr.DEVELOPER_ESCALATION));
};

});
parcelRegister("kmr29", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $da19d1ee706d4a81$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $da19d1ee706d4a81$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useFieldValuesForIssues", () => $da19d1ee706d4a81$export$ac289b84121829df);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $da19d1ee706d4a81$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $da19d1ee706d4a81$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $da19d1ee706d4a81$export$612d9bcb0c9d8976);

var $eUqFw = parcelRequire("eUqFw");

var $2vzCR = parcelRequire("2vzCR");

var $WBLbN = parcelRequire("WBLbN");
const $da19d1ee706d4a81$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $da19d1ee706d4a81$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $da19d1ee706d4a81$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $da19d1ee706d4a81$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $da19d1ee706d4a81$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState()[issueKey], fields)
        });
    };
const $da19d1ee706d4a81$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState(), newIssues));
    };
const $da19d1ee706d4a81$var$actions = {
    setFieldValue: $da19d1ee706d4a81$var$setFieldValue,
    getFieldValue: $da19d1ee706d4a81$var$getFieldValue,
    setIssue: $da19d1ee706d4a81$var$setIssue,
    mergeIssue: $da19d1ee706d4a81$var$mergeIssue,
    setIssues: $da19d1ee706d4a81$var$setIssues,
    mergeIssues: $da19d1ee706d4a81$export$11aa02e14fdf7753
};
// this is a global store
const $da19d1ee706d4a81$var$store = (0, $WBLbN.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $da19d1ee706d4a81$var$actions
});
const $da19d1ee706d4a81$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $da19d1ee706d4a81$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$da19d1ee706d4a81$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $da19d1ee706d4a81$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $da19d1ee706d4a81$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $da19d1ee706d4a81$var$getAllFields = (state, issueKey)=>state[issueKey];
const $da19d1ee706d4a81$export$b79fae7fbe3ac392 = (0, $WBLbN.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValueSelector
});
const $da19d1ee706d4a81$export$25b73e671fe7a8fa = (0, $WBLbN.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getAllFields
});
const $da19d1ee706d4a81$export$ac289b84121829df = (0, $WBLbN.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValuesForIssuesSelector
});
const $da19d1ee706d4a81$export$915cdeec521b54f7 = (0, $WBLbN.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getMultiFieldValuesForIssuesSelector
});
const $da19d1ee706d4a81$export$4e5f1f4ed08d155e = (0, $WBLbN.createSubscriber)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValueSelector
});
const $da19d1ee706d4a81$var$useFieldValueStoreActions = (0, $WBLbN.createHook)($da19d1ee706d4a81$var$store, {
    selector: null
});
const $da19d1ee706d4a81$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $da19d1ee706d4a81$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $eUqFw.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

parcelRegister("9V785", function(module, exports) {

$parcel$export(module.exports, "USER_JSM_PROJECT_ROLE", () => $3cdacd90d2ecef12$export$a9054e41660c4d00);
// use USER_JSM_PROJECT_ROLE instead
const $3cdacd90d2ecef12$var$AGENT_ROLE = 'agent';
const $3cdacd90d2ecef12$var$AGENT_PROJECT_ADMIN_ROLE = 'agent-project-admin';
const $3cdacd90d2ecef12$var$JIRA_ROLE = 'jira-user';
const $3cdacd90d2ecef12$export$a9054e41660c4d00 = {
    AGENT_ROLE: $3cdacd90d2ecef12$var$AGENT_ROLE,
    AGENT_PROJECT_ADMIN_ROLE: $3cdacd90d2ecef12$var$AGENT_PROJECT_ADMIN_ROLE,
    JIRA_ROLE: $3cdacd90d2ecef12$var$JIRA_ROLE
};

});


parcelRegister("itJNi", function(module, exports) {

$parcel$export(module.exports, "useJsmMimEntitlementResource", () => $fd35fd5cc08acd79$export$db2d9c66103c357c);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $lB25E = parcelRequire("lB25E");

const $fd35fd5cc08acd79$var$getDataLoader = ()=>(parcelRequire("g7cDs"));
const $fd35fd5cc08acd79$export$972b28729379ca5f = (0, $lB25E.createResource)({
    type: 'JSM_MIM_ENTITLEMENT',
    getKey: ()=>'JSM_MIM_ENTITLEMENT',
    getDataLoader: $fd35fd5cc08acd79$var$getDataLoader,
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});
const $fd35fd5cc08acd79$export$db2d9c66103c357c = (cloudId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $lB25E.useResource)($fd35fd5cc08acd79$export$972b28729379ca5f);
    (0, $eUqFw.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $eUqFw.useMemo)(()=>{
        if (!(0, $1ybV0.ff)('im_feature_enablement_gating')) return {
            isEntitled: true
        };
        if (error || loading || !data || !cloudId) return {
            isEntitled: false
        };
        const { isEntitled: isEntitled } = data;
        return {
            isEntitled: isEntitled
        };
    }, [
        data,
        loading,
        error,
        cloudId
    ]);
};

});
parcelRegister("g7cDs", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jxMIW").then(()=>parcelRequire('gtZxG'));

});


parcelRegister("bxn6g", function(module, exports) {

$parcel$export(module.exports, "useMajorIncidentField", () => $e9167a92871f7f8c$export$91517ada3bce1236);

var $gGiWF = parcelRequire("gGiWF");

var $36pXK = parcelRequire("36pXK");
const $e9167a92871f7f8c$export$91517ada3bce1236 = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure, onSubmit: onSubmit })=>{
    const { majorIncidentFieldIdKey: fieldKey, fieldType: fieldType } = (0, $36pXK.useMajorIncidentConfig)(issueKey);
    const [{ value: value, loading: loading, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        issueKey: issueKey,
        fieldKey: fieldKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onSubmit: onSubmit
    });
    return [
        {
            value: value,
            loading: loading,
            error: error
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("gGiWF", function(module, exports) {

$parcel$export(module.exports, "useEditField", () => $04407df9ae6d3d74$export$343e962d356c0af1);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5oStv = parcelRequire("5oStv");

var $5oStv = parcelRequire("5oStv");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");

var $JRB5w = parcelRequire("JRB5w");

var $hJ992 = parcelRequire("hJ992");

var $8wbQu = parcelRequire("8wbQu");

var $7eDnP = parcelRequire("7eDnP");

var $8p8vy = parcelRequire("8p8vy");

var $3koWU = parcelRequire("3koWU");

var $jMP2a = parcelRequire("jMP2a");

var $kmr29 = parcelRequire("kmr29");

var $fecbI = parcelRequire("fecbI");
/**
 * Some responses contain `fields` property without `fieldKey`.
 * We must avoid changing the state of this fields by checking `fieldKey` property in the `fields`.
 * @param response
 * @param fieldKey
 */ const $04407df9ae6d3d74$var$getFieldValue = (response, fieldKey)=>{
    if (!response) return null;
    if (response.fields) {
        if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
        return null;
    }
    return response;
};
const $04407df9ae6d3d74$var$shouldCallSetFieldValue = (response, fieldKey)=>{
    if (!response) return false;
    if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
    return true;
};
const $04407df9ae6d3d74$export$3796d3fdbc2e6b54 = (fieldOptions)=>{
    // di-ignore - Please fix parent-switcher examples
    const baseUrl = '';
    const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $04407df9ae6d3d74$var$getFieldValue, saveField: saveField = (0, $fecbI.defaultSaveField), saveFieldById: saveFieldById = (0, $fecbI.defaultSaveFieldById), addValuesToField: addValuesToField = (0, $fecbI.defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, $fecbI.defaultRemoveValuesFromField), onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) } = fieldOptions;
    // We need to track the mounted state as it is possible that a component
    // using this hook can be unmounted before the async edit operation is completed.
    // Causing a react warning about setting state on an unmounted component.
    const isMounted = (0, $3koWU.useIsMounted)();
    const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const resetError = (0, $eUqFw.useCallback)(()=>{
        if (isMounted.current) setError(null);
    }, [
        setError,
        isMounted
    ]);
    const editFieldValue = (0, $eUqFw.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
        isOptimistic: true
    })=>{
        let result;
        const analyticsData = {
            editOperationType: editOperationType,
            issueId: issueId,
            fieldKey: analyticsFieldKeyAlias ?? fieldKey,
            fieldType: analyticsFieldTypeAlias ?? fieldType
        };
        if (isMounted.current) {
            setLoading(true);
            setError(null);
        }
        try {
            onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
            if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
            result = await editOperation(issueKey, fieldKey, valuesForOperation, baseUrl, meta);
            const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
            $04407df9ae6d3d74$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
            if ((0, $1ybV0.ff)('ui-modifications-issue-view-status-custom-field-support_hwx15')) onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent, meta);
            else onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent);
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            result = Promise.reject(ex);
            onFailure(ex, valuesForOperation);
            setFieldValue(issueKey, fieldKey, fieldValue);
            if (isMounted.current) setError(ex);
            const isValidationError = ex instanceof (0, $7byHA.ValidationError);
            if (!isValidationError) (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
            if (fieldKey === 'timetracking' && (0, $1ybV0.ff)('jiv-18751-investigate-time-tracking-update-errors_ng38s')) (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'timetracking updateFailed', {
                fieldKey: fieldKey,
                fieldType: fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $JRB5w.isClientFetchError)(ex),
                exceptionName: ex.name,
                exceptionMessage: ex.message,
                exceptionStack: ex.stack
            });
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                fieldKey: fieldKey,
                fieldType: analyticsFieldTypeAlias ?? fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $JRB5w.isClientFetchError)(ex)
            });
        }
        if (isMounted.current) setLoading(false);
        return result;
    }, [
        issueId,
        analyticsFieldKeyAlias,
        fieldKey,
        analyticsFieldTypeAlias,
        fieldType,
        isMounted,
        onSubmit,
        fieldValue,
        setFieldValue,
        issueKey,
        onSuccess,
        onFailure,
        mapNonOptimisticResponse
    ]);
    const saveValue = (0, $eUqFw.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
        editFieldValue,
        saveField
    ]);
    const saveById = (0, $eUqFw.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
            isOptimistic: false
        }), [
        editFieldValue,
        saveFieldById
    ]);
    const addValues = (0, $eUqFw.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
        editFieldValue,
        addValuesToField
    ]);
    const removeValues = (0, $eUqFw.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
        editFieldValue,
        removeValuesFromField
    ]);
    return [
        {
            value: fieldValue,
            loading: loading,
            error: error
        },
        {
            saveById: saveById,
            saveValue: saveValue,
            addValues: addValues,
            removeValues: removeValues,
            resetError: resetError
        }
    ];
};
const $04407df9ae6d3d74$export$76d937477b5f784a = (issueKey)=>{
    const contextualIssueId = (0, $hJ992.useIssueId)();
    const contextualIssueKey = (0, $hJ992.useIssueKey)();
    return contextualIssueKey === issueKey ? contextualIssueId : null;
};
const $04407df9ae6d3d74$export$343e962d356c0af1 = (fieldOptions)=>{
    const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), shouldPreventIssueViewSoftRefresh: shouldPreventIssueViewSoftRefresh = false } = fieldOptions;
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $8p8vy.useIssueViewFieldUpdateEvents)();
    const contextualIssueId = $04407df9ae6d3d74$export$76d937477b5f784a(issueKey);
    const issueId = issueIdFromFieldOptions ?? contextualIssueId;
    const isEditFromIssueView = (0, $8wbQu.useIsEditFromIssueView);
    const onSubmitFn = (0, $eUqFw.useCallback)((oldValue, newValue, meta, event)=>{
        onSubmit(oldValue, newValue, meta, event);
        issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
    }, [
        fieldChangeRequested,
        fieldKey,
        issueId,
        onSubmit
    ]);
    const onSuccessFn = (0, $eUqFw.useCallback)(// Remove optional from meta with `ui-modifications-issue-view-status-custom-field-support_hwx15` FF clean up
    async (fieldValue, event, meta)=>{
        onSuccess(fieldValue);
        if ((0, $1ybV0.ff)('ui-modifications-issue-view-status-custom-field-support_hwx15')) issueId && fieldChanged(issueId, fieldKey, fieldValue, undefined, meta);
        else issueId && fieldChanged(issueId, fieldKey, fieldValue);
        if (!shouldPreventIssueViewSoftRefresh && !isEditFromIssueView(event)) try {
            const reason = (0, $7eDnP.Reason).SoftRefresh;
            (0, $1ybV0.ff)('relay-migration-issue-fields-soft-refresh-ld') ? await (0, $5oStv.default).refreshIssuePageThrowable(issueKey, reason) : await (0, $5oStv.default).refreshIssuePageThrowable(issueKey, reason);
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
        }
    }, [
        fieldChanged,
        fieldKey,
        shouldPreventIssueViewSoftRefresh,
        isEditFromIssueView,
        issueId,
        issueKey,
        onSuccess
    ]);
    const onFailureFn = (0, $eUqFw.useCallback)((error, failedValue)=>{
        onFailure(error, failedValue);
        issueId && fieldChangeFailed(issueId, fieldKey);
    }, [
        fieldChangeFailed,
        fieldKey,
        issueId,
        onFailure
    ]);
    return $04407df9ae6d3d74$export$3796d3fdbc2e6b54({
        ...fieldOptions,
        onSubmit: onSubmitFn,
        onSuccess: onSuccessFn,
        onFailure: onFailureFn
    });
};

});
parcelRegister("5oStv", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdea36b35279d86d$export$2e2bcd8739ae039);

var $7eDnP = parcelRequire("7eDnP");
const $bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
const $bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addEventListener = (event, callback)=>{
    document.addEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeEventListener = (event, callback)=>{
    document.removeEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addRefreshIssueListener = (callback)=>$bdea36b35279d86d$var$addEventListener($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeRefreshIssueListener = (callback)=>$bdea36b35279d86d$var$removeEventListener($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addUpdateIssueGlanceListener = (callback)=>$bdea36b35279d86d$var$addEventListener($bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeUpdateIssueGlanceListener = (callback)=>$bdea36b35279d86d$var$removeEventListener($bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
const $bdea36b35279d86d$var$refreshIssuePageThrowable = (issueKey, reason = (0, $7eDnP.Reason).OnDemand)=>{
    try {
        document.dispatchEvent(new CustomEvent($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, {
            detail: [
                issueKey,
                {
                    mergeIntoCurrent: false,
                    reason: reason
                }
            ]
        }));
        return Promise.resolve();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Promise.reject(e);
    }
};
const $bdea36b35279d86d$var$refreshIssuePage = (issueKey)=>// Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $bdea36b35279d86d$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bdea36b35279d86d$export$2e2bcd8739ae039 = {
    addRefreshIssueListener: $bdea36b35279d86d$var$addRefreshIssueListener,
    removeRefreshIssueListener: $bdea36b35279d86d$var$removeRefreshIssueListener,
    addUpdateIssueGlanceListener: $bdea36b35279d86d$var$addUpdateIssueGlanceListener,
    removeUpdateIssueGlanceListener: $bdea36b35279d86d$var$removeUpdateIssueGlanceListener,
    refreshIssuePageThrowable: $bdea36b35279d86d$var$refreshIssuePageThrowable,
    refreshIssuePage: $bdea36b35279d86d$var$refreshIssuePage
};

});
parcelRegister("7eDnP", function(module, exports) {

$parcel$export(module.exports, "Reason", () => $501d104507444a18$export$fe867595c4640fb1);
const $501d104507444a18$export$fe867595c4640fb1 = {
    /**
	 * Aka hard refresh, used by Ecosystem apps to refresh issue view on demand
	 * 1) Full issue view refresh
	 * 2) Hard Ecosystem apps refresh (causes remounting of the apps)
	 */ OnDemand: 'ON_DEMAND',
    /**
	 * Used by Jira internally to update issue view on demand without forcing Ecosystem apps to rerender
	 * 1) Full issue view refresh only
	 * 2) Ecosystem app aren't hard refreshed, however, if field's value has changed, Forge custom field will rerender
	 */ SoftRefresh: 'SOFT_REFRESH',
    /**
	 * Issue view refresh caused by Realtime service (Jirt)
	 */ Realtime: 'REALTIME'
};

});


parcelRegister("8wbQu", function(module, exports) {

$parcel$export(module.exports, "useIsEditFromIssueView", () => $e05e50438955dd5a$export$870b996a6c1c7896);

var $eI5EY = parcelRequire("eI5EY");

var $hRcYT = parcelRequire("hRcYT");

var $iKlrz = parcelRequire("iKlrz");
const $e05e50438955dd5a$export$870b996a6c1c7896 = (event)=>{
    const ISSUE_VIEW_SOURCES = [
        'fullIssueScreen',
        'boardIssueViewScreen',
        ...!(0, $eI5EY.fg)('fix_issue_hook_from_backlog') ? [
            'backlogScreen'
        ] : [],
        'agility-backlogScreen',
        'issueNavigatorEmbeddedIssueViewScreen',
        'globalIssueNavigatorIssueScreen',
        'mobileIssueScreen',
        'classicRoadmapScreen',
        'roadmapScreen',
        'versionDetailsIssueScreen',
        'bitbucketIssueScreen',
        'jsmQueueAgentViewSidebarScreen',
        'viewQueueIssueScreen',
        'jswModalIssueAppScreen',
        'jwmModalIssueAppScreen',
        'jswSidebarIssueAppScreen',
        'jwmSidebarIssueAppScreen'
    ];
    const { payload: { source: source } } = (0, $iKlrz.getEvent)(event);
    if (!source) return false;
    if (ISSUE_VIEW_SOURCES.includes(source)) // event originated from issue view location
    return true;
    if (source.startsWith((0, $hRcYT.PACKAGE_NAME_GASV3))) // event originated from forge app, which can only be mounted in issue view for field editing
    return true;
    return false;
};

});

parcelRegister("8p8vy", function(module, exports) {

$parcel$export(module.exports, "useIssueViewFieldUpdateEvents", () => $0829b81e40dd527a$export$444af741f6d8f512);
$parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", () => $0829b81e40dd527a$export$f9eb49cc2f0e28ce);

var $1ybV0 = parcelRequire("1ybV0");

var $WBLbN = parcelRequire("WBLbN");

var $focHG = parcelRequire("focHG");

var $k3tie = parcelRequire("k3tie");
const $0829b81e40dd527a$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
        if (typeof eventHandler !== 'function') // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const { eventHandlers: eventHandlers } = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
        const typeEventHandlers = eventHandlers[type];
        setState({
            eventHandlers: {
                ...eventHandlers,
                [type]: typeEventHandlers.concat([
                    eventHandler
                ])
            }
        });
        return ()=>{
            const { eventHandlers: eventHandlersForUnregister } = getState();
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
            const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
            const newTypeEventHandlers = typeEventHandlersForUnregister.filter(// @ts-expect-error - TS7006 - Parameter 'handler' implicitly has an 'any' type.
            (handler)=>handler !== eventHandler);
            setState({
                eventHandlers: {
                    ...eventHandlersForUnregister,
                    [type]: newTypeEventHandlers
                }
            });
        };
    };
const $0829b81e40dd527a$var$fieldChanged = (issueId, fieldId, fieldValue, aggFieldChangeProps, additionalProperties)=>({ getState: getState })=>{
        let value = fieldValue;
        if ((0, $1ybV0.ff)('relay-migration-issue-fields-events-transformer-ld')) {
            if (aggFieldChangeProps) value = (0, $focHG.transformAggToLegacy)({
                fieldValue: fieldValue,
                aggFieldChangeProps: aggFieldChangeProps
            });
        }
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                fieldId: // field id is required to be compatible with v1 onChange API
                fieldId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    ...(0, $1ybV0.ff)('ui-modifications-issue-view-status-custom-field-support_hwx15') ? {
                        additionalProperties: additionalProperties
                    } : {}
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGED
            });
        });
    };
const $0829b81e40dd527a$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_FAILED
            });
        });
    };
const $0829b81e40dd527a$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties, aggFieldChangeProps)=>({ getState: getState })=>{
        let value = fieldValue;
        if ((0, $1ybV0.ff)('relay-migration-issue-fields-events-transformer-ld')) {
            if (aggFieldChangeProps) value = (0, $focHG.transformAggToLegacy)({
                fieldValue: fieldValue,
                aggFieldChangeProps: aggFieldChangeProps
            });
        }
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_REQUESTED
            });
        });
    };
const $0829b81e40dd527a$var$actions = {
    fieldChanged: $0829b81e40dd527a$var$fieldChanged,
    fieldChangeFailed: $0829b81e40dd527a$var$fieldChangeFailed,
    fieldChangeRequested: $0829b81e40dd527a$var$fieldChangeRequested,
    registerEventHandler: $0829b81e40dd527a$var$registerEventHandler
};
// this is a global state
const $0829b81e40dd527a$var$store = (0, $WBLbN.createStore)({
    name: 'issue-view-field-update-events',
    initialState: {
        eventHandlers: {
            onChange: []
        }
    },
    actions: $0829b81e40dd527a$var$actions
});
const $0829b81e40dd527a$export$444af741f6d8f512 = (0, $WBLbN.createHook)($0829b81e40dd527a$var$store, {
    selector: null
});
const $0829b81e40dd527a$export$f9eb49cc2f0e28ce = (0, $WBLbN.createContainer)($0829b81e40dd527a$var$store);

});
parcelRegister("focHG", function(module, exports) {

$parcel$export(module.exports, "transformAggToLegacy", () => $ecb153413af3f22f$export$d951e3c38e10736d);

var $9ax61 = parcelRequire("9ax61");

var $lO4Or = parcelRequire("lO4Or");

var $9r5wz = parcelRequire("9r5wz");
const $ecb153413af3f22f$export$d951e3c38e10736d = ({ fieldValue: fieldValue, aggFieldChangeProps: aggFieldChangeProps })=>{
    if (!aggFieldChangeProps?.__typename) throw new Error('node did not have __typename');
    switch(aggFieldChangeProps.__typename){
        // These fields require context for their transform in transformAggFieldToLegacyField so need to be manually implemented
        // This is not an exhaustive list, I did a quick check is all, so best to check the transform works as expected as you migrate fields to relay
        // These are commented out because they are not implemented and due to types can't just be added here until implemented
        // case JSM_PEOPLE_GQL_FIELD:
        // case ISSUE_RESTRICTION_GQL_FIELD:
        // case MULTI_USER_PICKER_GQL_FIELD:
        // otherwise we can default to the existing package
        case 0, $lO4Or.PEOPLE_GQL_FIELD:
        case 0, $lO4Or.SECURITY_GQL_FIELD:
        case 0, $lO4Or.NUMBER_GQL_FIELD:
        case 0, $lO4Or.TEXT_GQL_FIELD:
        case 0, $lO4Or.USER_PICKER_GQL_FIELD:
        case 0, $lO4Or.PRIORITY_GQL_FIELD:
        case 0, $lO4Or.URL_GQL_FIELD:
        case 0, $lO4Or.DATE_PICKER_GQL_FIELD:
        case 0, $lO4Or.PROJECT_GQL_FIELD:
        case 0, $lO4Or.DATE_TIME_GQL_FIELD:
        case 0, $lO4Or.COLOR_GQL_FIELD:
        case 0, $lO4Or.TIME_TRACKING_GQL_FIELD:
        case 0, $lO4Or.ORIGINAL_ESTIMATE_GQL_FIELD:
        case 0, $lO4Or.ISSUE_TYPE_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $9ax61.transformAggFieldToLegacyField)({
                [$ecb153413af3f22f$var$getValueKey(aggFieldChangeProps.__typename)]: fieldValue,
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type
            })?.value;
        case 0, $lO4Or.PARENT_GQL_FIELD:
            return (0, $9r5wz.transformAggParentFieldValueToLegacyFieldValue)(fieldValue);
        case 0, $lO4Or.SPRINT_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $9ax61.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                ...fieldValue
            })?.value;
        case 0, $lO4Or.CHECKBOX_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $9ax61.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                selectedOptions: fieldValue.selectedOptions,
                checkboxesFieldOptions: fieldValue.fieldOptions
            })?.value;
        case 0, $lO4Or.COMPONENTS_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $9ax61.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                components: fieldValue.components,
                selectedComponentsConnection: fieldValue.selectedComponentsConnection
            })?.value;
        default:
            throw new Error('__typename not implemented');
    }
};
const $ecb153413af3f22f$var$getValueKey = (__typename)=>{
    const VALUE_KEYS = {
        [(0, $lO4Or.TEXT_GQL_FIELD)]: 'text',
        [(0, $lO4Or.NUMBER_GQL_FIELD)]: 'number',
        [(0, $lO4Or.PRIORITY_GQL_FIELD)]: 'priority',
        [(0, $lO4Or.USER_PICKER_GQL_FIELD)]: 'user',
        [(0, $lO4Or.DATE_PICKER_GQL_FIELD)]: 'date',
        [(0, $lO4Or.PROJECT_GQL_FIELD)]: 'project',
        [(0, $lO4Or.DATE_TIME_GQL_FIELD)]: 'dateTime',
        [(0, $lO4Or.ORIGINAL_ESTIMATE_GQL_FIELD)]: 'originalEstimate',
        [(0, $lO4Or.TIME_TRACKING_GQL_FIELD)]: 'originalEstimate',
        [(0, $lO4Or.URL_GQL_FIELD)]: 'uri',
        [(0, $lO4Or.SECURITY_GQL_FIELD)]: 'securityLevel',
        [(0, $lO4Or.PEOPLE_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $lO4Or.COLOR_GQL_FIELD)]: 'color',
        [(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)]: 'issueType'
    };
    const value = VALUE_KEYS[__typename];
    if (value) return value;
    throw new Error(`Did you forget to implement getValueKey for your field type? Couldn't find a value in the map for ${__typename}`);
};

});
parcelRegister("9ax61", function(module, exports) {

$parcel$export(module.exports, "transformAggFieldToLegacyField", () => $85127a55c87acb28$export$586ba15cbf3d3031);
$parcel$export(module.exports, "transformAggFieldsToLegacyFields", () => $85127a55c87acb28$export$ba106ff8c087e6b1);

var $5iWql = parcelRequire("5iWql");

var $lO4Or = parcelRequire("lO4Or");

var $kBgu2 = parcelRequire("kBgu2");

var $blEoo = parcelRequire("blEoo");

var $6Ux91 = parcelRequire("6Ux91");

var $5sNJN = parcelRequire("5sNJN");

var $2wvLE = parcelRequire("2wvLE");

var $8d1m1 = parcelRequire("8d1m1");

var $5CYGa = parcelRequire("5CYGa");

var $9wKha = parcelRequire("9wKha");

var $6PKzm = parcelRequire("6PKzm");

var $jyP56 = parcelRequire("jyP56");

var $epJqO = parcelRequire("epJqO");

var $Pxexr = parcelRequire("Pxexr");

var $beuR4 = parcelRequire("beuR4");

var $d9IUw = parcelRequire("d9IUw");

var $xnQ91 = parcelRequire("xnQ91");

var $jsTfy = parcelRequire("jsTfy");

var $55kng = parcelRequire("55kng");

var $7BRej = parcelRequire("7BRej");

var $04Gbh = parcelRequire("04Gbh");

var $3ZJZc = parcelRequire("3ZJZc");

var $bw8ws = parcelRequire("bw8ws");

var $9vCKL = parcelRequire("9vCKL");

var $i5dch = parcelRequire("i5dch");

var $iJcxE = parcelRequire("iJcxE");

var $djkJh = parcelRequire("djkJh");

var $kbDa2 = parcelRequire("kbDa2");

var $4gy8O = parcelRequire("4gy8O");

var $9w928 = parcelRequire("9w928");

var $3khS7 = parcelRequire("3khS7");

var $c52Z6 = parcelRequire("c52Z6");

var $6IjGS = parcelRequire("6IjGS");

var $eOsdu = parcelRequire("eOsdu");

var $6MxWX = parcelRequire("6MxWX");

var $9myMG = parcelRequire("9myMG");

var $gM34d = parcelRequire("gM34d");

var $16kx8 = parcelRequire("16kx8");

var $4IQ8F = parcelRequire("4IQ8F");

var $lcInz = parcelRequire("lcInz");

var $4PFnn = parcelRequire("4PFnn");

var $alpM1 = parcelRequire("alpM1");

var $l6kyU = parcelRequire("l6kyU");

var $gHd8e = parcelRequire("gHd8e");

var $dUrU1 = parcelRequire("dUrU1");

var $hQM7C = parcelRequire("hQM7C");

var $QjWSM = parcelRequire("QjWSM");

var $4CGp4 = parcelRequire("4CGp4");

var $lWE99 = parcelRequire("lWE99");

var $4eNqf = parcelRequire("4eNqf");

var $fkHM1 = parcelRequire("fkHM1");

var $fkaQR = parcelRequire("fkaQR");

var $ijtj3 = parcelRequire("ijtj3");

var $gyvos = parcelRequire("gyvos");

var $3w75b = parcelRequire("3w75b");

var $lQr58 = parcelRequire("lQr58");

var $8oO4q = parcelRequire("8oO4q");

var $5Ne6t = parcelRequire("5Ne6t");

var $2ETkN = parcelRequire("2ETkN");

var $fz8Wc = parcelRequire("fz8Wc");

var $jBiXV = parcelRequire("jBiXV");

var $1XUHd = parcelRequire("1XUHd");

var $c6LKM = parcelRequire("c6LKM");

var $8zTcQ = parcelRequire("8zTcQ");

var $5W75j = parcelRequire("5W75j");

var $7iFVU = parcelRequire("7iFVU");

var $kyZt3 = parcelRequire("kyZt3");

var $dX2ot = parcelRequire("dX2ot");

var $jhiYN = parcelRequire("jhiYN");

var $1BsAz = parcelRequire("1BsAz");
// We're memoising this just in case we FF another field
const $85127a55c87acb28$var$getTransformersNonMemoised = ()=>({
        [(0, $lO4Or.AFFECTED_SERVICES_GQL_FIELD)]: (0, $kBgu2.transformAggAffectedServicesToLegacyField),
        [(0, $lO4Or.BOOLEAN_GQL_FIELD)]: (0, $6Ux91.transformAggBooleanToLegacyField),
        [(0, $lO4Or.CASCADING_SELECT_GQL_FIELD)]: (0, $5sNJN.transformAggCascadingSelectToLegacyField),
        [(0, $lO4Or.CHECKBOX_GQL_FIELD)]: (0, $2wvLE.transformAggCheckboxToLegacyField),
        [(0, $lO4Or.CMDB_GQL_FIELD)]: (0, $8d1m1.transformAggCMDBToLegacyField),
        [(0, $lO4Or.MULTI_SELECT_GQL_FIELD)]: (0, $hQM7C.transformAggMultipleSelectToLegacyField),
        [(0, $lO4Or.COMPONENTS_GQL_FIELD)]: (0, $9wKha.transformAggComponentsToLegacyField),
        [(0, $lO4Or.CONNECT_DATE_TIME_GQL_FIELD)]: (0, $6PKzm.transformAggConnectDateTimeToLegacyField),
        [(0, $lO4Or.CONNECT_MULTI_SELECT_GQL_FIELD)]: (0, $jyP56.transformAggConnectMultipleSelectToLegacyField),
        [(0, $lO4Or.CONNECT_NUMBER_GQL_FIELD)]: (0, $epJqO.transformAggConnectNumberToLegacyField),
        [(0, $lO4Or.CONNECT_RICH_TEXT_GQL_FIELD)]: (0, $Pxexr.transformAggConnectRichTextToLegacyField),
        [(0, $lO4Or.CONNECT_SINGLE_SELECT_GQL_FIELD)]: (0, $beuR4.transformAggConnectSingleSelectToLegacyField),
        [(0, $lO4Or.CONNECT_TEXT_GQL_FIELD)]: (0, $d9IUw.transformAggConnectTextToLegacyField),
        [(0, $lO4Or.COLOR_GQL_FIELD)]: (0, $5CYGa.transformAggColorToLegacyField),
        [(0, $lO4Or.DATE_PICKER_GQL_FIELD)]: (0, $jsTfy.transformAggDatePickerToLegacyField),
        [(0, $lO4Or.DATE_TIME_GQL_FIELD)]: (0, $55kng.transformAggDateTimePickerToLegacyField),
        [(0, $lO4Or.EPIC_LINK_GQL_FIELD)]: (0, $7BRej.transformAggEpicLinkToLegacyField),
        [(0, $lO4Or.FLAG_GQL_FIELD)]: (0, $04Gbh.transformAggFlagToLegacyField),
        [(0, $lO4Or.FORGE_DATETIME_GQL_FIELD)]: (0, $bw8ws.transformAggForgeDateTimeToLegacyField),
        [(0, $lO4Or.FORGE_DATE_GQL_FIELD)]: (0, $3ZJZc.transformAggForgeDateToLegacyField),
        [(0, $lO4Or.FORGE_GROUP_GQL_FIELD)]: (0, $9vCKL.transformAggForgeGroupToLegacyField),
        [(0, $lO4Or.FORGE_GROUPS_GQL_FIELD)]: (0, $i5dch.transformAggForgeGroupsToLegacyField),
        [(0, $lO4Or.FORGE_NUMBER_GQL_FIELD)]: (0, $iJcxE.transformAggForgeNumberToLegacyField),
        [(0, $lO4Or.FORGE_OBJECT_GQL_FIELD)]: (0, $djkJh.transformAggForgeObjectToLegacyField),
        [(0, $lO4Or.FORGE_STRING_GQL_FIELD)]: (0, $kbDa2.transformAggForgeStringToLegacyField),
        [(0, $lO4Or.FORGE_STRINGS_GQL_FIELD)]: (0, $4gy8O.transformAggForgeStringsToLegacyField),
        [(0, $lO4Or.FORGE_USER_GQL_FIELD)]: (0, $9w928.transformAggForgeUserToLegacyField),
        [(0, $lO4Or.FORGE_USERS_GQL_FIELD)]: (0, $3khS7.transformAggForgeUsersToLegacyField),
        [(0, $lO4Or.ISSUE_RESTRICTION_GQL_FIELD)]: (0, $6IjGS.transformAggIssueRestrictionToLegacyField),
        [(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)]: (0, $eOsdu.transformAggIssueTypeToLegacyField),
        [(0, $lO4Or.JSM_APPROVAL_GQL_FIELD)]: (0, $6MxWX.transformAggJSMApprovalsToLegacyField),
        [(0, $lO4Or.JSM_ASSETS_GQL_FIELD)]: (0, $blEoo.transformAggAssetToLegacyField),
        [(0, $lO4Or.JSM_MAJOR_INCIDENT_FIELD)]: (0, $gM34d.transformAggJSMMajorIncidentToLegacyField),
        [(0, $lO4Or.JSM_ORGANIZATION_GQL_FIELD)]: (0, $16kx8.transformAggJSMOrganizationToLegacyField),
        [(0, $lO4Or.JSM_ENTITLEMENTS_GQL_FIELD)]: (0, $9myMG.transformAggJSMEntitlementsToLegacyField),
        [(0, $lO4Or.JSM_SENTIMENT_GQL_FIELD)]: (0, $l6kyU.transformAggJSMSentimentToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $lO4Or.JSM_PEOPLE_GQL_FIELD)]: (0, $QjWSM.transformAggMultipleUserPickerToLegacyField),
        [(0, $lO4Or.JSM_REQUEST_FEEDBACK_GQL_FIELD)]: (0, $4IQ8F.transformAggJSMRequestFeedbackToLegacyField),
        [(0, $lO4Or.JSM_REQUEST_LANGUAGE_GQL_FIELD)]: (0, $lcInz.transformAggJSMRequestLanguageToLegacyField),
        [(0, $lO4Or.JSM_REQUEST_TYPE_GQL_FIELD)]: (0, $4PFnn.transformAggJSMRequestTypeToLegacyField),
        [(0, $lO4Or.JSM_RESPONDERS_GQL_FIELD)]: (0, $alpM1.transformAggJSMRespondersToLegacyField),
        [(0, $lO4Or.LABEL_GQL_FIELD)]: (0, $gHd8e.transformAggLabelsNodeToLegacyField),
        [(0, $lO4Or.PRIORITY_GQL_FIELD)]: (0, $fkHM1.transformAggPriorityToLegacyField),
        [(0, $lO4Or.MULTI_GROUP_PICKER_GQL_FIELD)]: (0, $dUrU1.transformAggMultiGroupPickerToLegacyField),
        [(0, $lO4Or.MULTI_USER_PICKER_GQL_FIELD)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $QjWSM.transformAggMultipleUserPickerToLegacyField),
        [(0, $lO4Or.NUMBER_GQL_FIELD)]: (0, $lWE99.transformAggNumberToLegacyField),
        [(0, $lO4Or.ORIGINAL_ESTIMATE_GQL_FIELD)]: (0, $4eNqf.transformAggOriginalEstimateToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $lO4Or.PEOPLE_GQL_FIELD)]: (0, $QjWSM.transformAggMultipleUserPickerToLegacyField),
        [(0, $lO4Or.PROFORMA_FORMS_GQL_FIELD)]: (0, $fkaQR.transformAggProformaFormsToLegacyField),
        [(0, $lO4Or.PROJECT_GQL_FIELD)]: (0, $ijtj3.transformAggProjectToLegacyField),
        [(0, $lO4Or.MULTI_VERSION_GQL_FIELD)]: (0, $4CGp4.transformAggMultipleVersionPickerToLegacyField),
        [(0, $lO4Or.RADIO_GQL_FIELD)]: (0, $gyvos.transformAggRadioSelectToLegacyField),
        [(0, $lO4Or.RICH_TEXT_GQL_FIELD)]: (0, $lQr58.transformAggRichTextToLegacyField),
        [(0, $lO4Or.RESOLUTION_GQL_FIELD)]: (0, $3w75b.transformAggResolutionToLegacyField),
        [(0, $lO4Or.SECURITY_GQL_FIELD)]: (0, $8oO4q.transformAggSecurityLevelToLegacyField),
        [(0, $lO4Or.SPRINT_GQL_FIELD)]: (0, $c6LKM.transformAggSprintToLegacyField),
        [(0, $lO4Or.STATUS_GQL_FIELD)]: (0, $8zTcQ.transformAggStatusToLegacyField),
        [(0, $lO4Or.SINGLE_GROUP_PICKER_GQL_FIELD)]: (0, $5Ne6t.transformAggSingleGroupPickerToLegacyField),
        [(0, $lO4Or.SINGLE_SELECT_GQL_FIELD)]: (0, $fz8Wc.transformAggSingleSelectToLegacyField),
        [(0, $lO4Or.TEAM_GQL_FIELD)]: (0, $5W75j.transformAggTeamToLegacyField),
        [(0, $lO4Or.TEAM_VIEW_GQL_FIELD)]: (0, $7iFVU.transformAggTeamViewToLegacyField),
        [(0, $lO4Or.TEXT_GQL_FIELD)]: (0, $2ETkN.transformAggSingleLineTextToLegacyField),
        [(0, $lO4Or.TIME_TRACKING_GQL_FIELD)]: (0, $kyZt3.transformAggTimeTrackingToLegacyField),
        [(0, $lO4Or.USER_PICKER_GQL_FIELD)]: (0, $jBiXV.transformAggSingleSelectUserPickerToLegacyField),
        [(0, $lO4Or.URL_GQL_FIELD)]: (0, $dX2ot.transformAggUrlToLegacyField),
        [(0, $lO4Or.VERSION_GQL_FIELD)]: (0, $1XUHd.transformAggSingleVersionPickerToLegacyField),
        [(0, $lO4Or.VOTES_GQL_FIELD)]: (0, $jhiYN.transformAggVotesToLegacyField),
        [(0, $lO4Or.WATCHES_GQL_FIELD)]: (0, $1BsAz.transformAggWatchesToLegacyField),
        [(0, $lO4Or.DATA_CLASSIFICATION_FIELD)]: (0, $xnQ91.transformAggDataClassificationToLegacyField),
        [(0, $lO4Or.GOALS_GQL_FIELD)]: (0, $c52Z6.transformAggGoalsToLegacyField)
    });
const $85127a55c87acb28$var$getTransformers = (0, $5iWql.default)($85127a55c87acb28$var$getTransformersNonMemoised);
const $85127a55c87acb28$export$586ba15cbf3d3031 = (node, context)=>{
    const typename = node.__typename;
    const transformer = $85127a55c87acb28$var$getTransformers()[typename];
    return transformer ? transformer(node, context) : undefined;
};
const $85127a55c87acb28$export$ba106ff8c087e6b1 = (fields)=>{
    if (fields == null) return {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields.reduce((fieldsState, fieldEdge)=>{
        if (fieldEdge?.node != null) {
            const transformedField = $85127a55c87acb28$export$586ba15cbf3d3031(fieldEdge.node, fields);
            if (transformedField != null) {
                const fieldData = 'key' in transformedField ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    [transformedField.key]: transformedField
                } : transformedField;
                Object.assign(fieldsState, fieldData);
            }
        }
        return fieldsState;
    }, {});
};

});
parcelRegister("kBgu2", function(module, exports) {

$parcel$export(module.exports, "transformAggAffectedServicesToLegacyField", () => $347ea3dcad361eb5$export$231e0419515441d4);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $347ea3dcad361eb5$var$transformJiraServicesToLegacyServices = ({ serviceId: serviceId, name: name })=>({
        id: serviceId,
        name: name ?? undefined
    });
const $347ea3dcad361eb5$export$231e0419515441d4 = (node)=>{
    if (node.type !== (0, $lO4Or.SERVICE_ENTITY_CF_TYPE)) return undefined;
    const hasValue = Boolean(node.selectedAffectedServicesConnection?.edges?.length);
    const value = hasValue ? (0, $f4e7j.transformAggConnection)(node.selectedAffectedServicesConnection, $347ea3dcad361eb5$var$transformJiraServicesToLegacyServices) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: value,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.SERVICE_ENTITY_CF_TYPE),
            items: 'service-entity-field',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});
const $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $c7e7b1d3600a0c0f$export$a4a240cb4053b29f = 'jira-text-renderer';
const $c7e7b1d3600a0c0f$export$840ed33fa94f7693 = 'frother-control-renderer';

parcelRegister("f4e7j", function(module, exports) {

$parcel$export(module.exports, "transformAggNodeToLegacyField", () => $e263c15d21d94d7e$export$e7ea61856a169c36);
$parcel$export(module.exports, "transformAggConnection", () => $e263c15d21d94d7e$export$daf92cda81d86cdc);
$parcel$export(module.exports, "toLegacyConnectOption", () => $e263c15d21d94d7e$export$b5de5f3d2de73afc);
const $e263c15d21d94d7e$export$e7ea61856a169c36 = (node)=>({
        ari: 'id' in node ? node.id : undefined,
        key: 'fieldId' in node && !!node.fieldId ? node.fieldId : '',
        title: 'name' in node ? node.name : '',
        editable: Boolean('isEditableInIssueView' in node ? node.isEditableInIssueView : 'fieldConfig' in node && node.fieldConfig != null && 'isEditable' in node.fieldConfig && node.fieldConfig.isEditable),
        required: Boolean('fieldConfig' in node && node.fieldConfig != null && 'isRequired' in node.fieldConfig && node.fieldConfig.isRequired),
        autoCompleteUrl: 'searchUrl' in node ? node.searchUrl : null,
        allowedValues: [],
        value: null,
        schema: {
            type: 'type' in node ? node.type : '',
            custom: null,
            system: null
        },
        description: 'description' in node && node.description ? node.description : undefined
    });
const $e263c15d21d94d7e$export$daf92cda81d86cdc = (connection, transformCallback)=>{
    const edges = connection?.edges ?? [];
    if (transformCallback) return edges.map((edge)=>edge?.node != null ? transformCallback(edge.node) : null).filter(Boolean);
    return edges.map((edge)=>edge?.node).filter(Boolean);
};
const $e263c15d21d94d7e$export$b5de5f3d2de73afc = (node)=>{
    if (!node) return null;
    return {
        value: node.value ?? null,
        id: parseInt(node.optionId, 10)
    };
};

});


parcelRegister("blEoo", function(module, exports) {

$parcel$export(module.exports, "transformAggAssetToLegacyField", () => $894bbc4a3f1bdf98$export$2136dcd78a2ef18f);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $894bbc4a3f1bdf98$export$2136dcd78a2ef18f = (node)=>{
    switch(node.type){
        case 0, $lO4Or.ASSETS_CF_TYPE:
            {
                const hasValue = Boolean(node.selectedAssetsConnection?.edges?.length);
                const assetValue = hasValue ? (0, $f4e7j.transformAggConnection)(node.selectedAssetsConnection, ({ appKey: appKey, originId: originId, serializedOrigin: serializedOrigin, value: value })=>({
                        appKey: appKey,
                        originId: originId,
                        serializedOrigin: serializedOrigin,
                        value: value
                    })) : null;
                return {
                    ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                    autoCompleteUrl: node.searchUrl,
                    value: assetValue,
                    schema: {
                        custom: node.type,
                        system: null,
                        items: 'sd-asset',
                        type: 'array',
                        renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("6Ux91", function(module, exports) {

$parcel$export(module.exports, "transformAggBooleanToLegacyField", () => $0e4e588f42a69494$export$4bd89b95f0d10de9);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $0e4e588f42a69494$export$4bd89b95f0d10de9 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: {
                    alertLinking: {
                        enabled: node.value
                    }
                },
                schema: {
                    configuration: null,
                    items: null,
                    renderer: null,
                    custom: null,
                    system: (0, $lO4Or.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE),
                    type: (0, $lO4Or.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("5sNJN", function(module, exports) {

$parcel$export(module.exports, "transformAggCascadingSelectToLegacyField", () => $8a9ad29dba216e4b$export$a8778af5ceb1017c);

var $1ybV0 = parcelRequire("1ybV0");


var $f4e7j = parcelRequire("f4e7j");
const $8a9ad29dba216e4b$export$a8778af5ceb1017c = (node)=>{
    let value = null;
    if (node.cascadingOption) {
        const { childOptionValue: childOptionValue, parentOptionValue: parentOptionValue } = node.cascadingOption;
        const child = childOptionValue ? {
            child: {
                id: childOptionValue.optionId,
                value: childOptionValue.value
            }
        } : {};
        value = {
            // assigned in the statement above
            id: parentOptionValue?.optionId,
            value: parentOptionValue?.value,
            ...child
        };
    }
    const allowedValues = (0, $1ybV0.ff)('issue.details.relay-cascading-select-field-issue-view-layout-integration') ? [] : (0, $f4e7j.transformAggConnection)(node.cascadingOptions, (cascadingOption)=>{
        if (!cascadingOption.parentOptionValue) return null;
        const { parentOptionValue: parentOptionValue, childOptionValues: childOptionValues } = cascadingOption;
        const childrenObj = childOptionValues?.length ? {
            children: childOptionValues.filter(Boolean).map((option)=>({
                    id: option.optionId,
                    value: option.value ?? null,
                    ari: option.id
                }))
        } : {};
        return {
            value: parentOptionValue.value,
            id: parentOptionValue.optionId,
            ...childrenObj
        };
    });
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: 'option-with-child',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2wvLE", function(module, exports) {

$parcel$export(module.exports, "transformAggCheckboxToLegacyField", () => $de1faea4cf000ccb$export$baa5afdbd8fd12d3);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $de1faea4cf000ccb$export$baa5afdbd8fd12d3 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
            {
                // We're inlining the transformers per field here so it'll be easy to remove them once we make the allowedValues async
                const value = (0, $f4e7j.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                const allowedValues = (0, $f4e7j.transformAggConnection)(node.checkboxesFieldOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: allowedValues,
                    schema: {
                        type: 'array',
                        renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("8d1m1", function(module, exports) {

$parcel$export(module.exports, "transformAggCMDBToLegacyField", () => $65b0c941ec21e177$export$93506453d9bb56ae);

var $1ybV0 = parcelRequire("1ybV0");


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $65b0c941ec21e177$var$transformObjectTypeToLegacy = (attribute, workspaceId)=>({
        workspaceId: workspaceId,
        id: `${workspaceId}:${attribute.objectTypeId}`,
        name: attribute.name,
        objectSchemaId: attribute.objectSchemaId,
        objectTypeId: attribute.objectTypeId,
        // `icon` is unused
        icon: {
            id: attribute.icon.id,
            name: attribute.icon.name,
            url16: attribute.icon.url16,
            url48: attribute.icon.url48
        }
    });
const $65b0c941ec21e177$var$transformCMDBConfigurationToLegacyConfiguration = (node)=>{
    if (!node.cmdbFieldConfig) return node.isInsightAvailable === false ? {
        isInsightAvailable: node.isInsightAvailable
    } : {};
    return {
        cmdbFieldConfig: {
            multiple: node.cmdbFieldConfig.multiple,
            objectSchemaId: node.cmdbFieldConfig.objectSchemaId.split('/')[2],
            attributesDisplayedOnIssue: (0, $f4e7j.transformAggConnection)(node.cmdbFieldConfig?.attributesDisplayedOnIssue),
            attributesIncludedInAutoCompleteSearch: (0, $f4e7j.transformAggConnection)(node.cmdbFieldConfig?.attributesIncludedInAutoCompleteSearch)
        },
        isInsightAvailable: node.isInsightAvailable,
        wasInsightRequestSuccessful: node.wasInsightRequestSuccessful
    };
};
const $65b0c941ec21e177$var$transformObjectTypeAttributeToLegacy = (type)=>{
    switch(type){
        case 'REFERENCED_OBJECT':
            return 1;
        case 'USER':
            return 2;
        case 'GROUP':
            return 4;
        case 'PROJECT':
            return 6;
        case 'STATUS':
            return 7;
        case 'BITBUCKET_REPO':
            return 8;
        case 'OPSGENIE_TEAM':
            return 9;
        case 'DEFAULT':
            return 0;
        default:
            // eslint-disable-next-line no-console
            console.error(new Error(`Unknown attribute type found in transformObjectTypeAttributeToLegacy: ${type}. Mapping type to '-1'`));
            return -1;
    }
};
const $65b0c941ec21e177$var$transformReferencedObject = (node)=>({
        id: node.objectGlobalId,
        workspaceId: node.workspaceId,
        objectKey: node.objectKey,
        label: node.label,
        avatar: node.avatar,
        objectId: node.objectId
    });
const $65b0c941ec21e177$var$transformCmdbUser = (node)=>({
        avatarUrl: node.picture,
        displayName: node.name,
        name: node.name,
        key: node.accountId
    });
const $65b0c941ec21e177$var$transformCmdbGroup = (node)=>({
        name: node.name
    });
const $65b0c941ec21e177$var$transformCmdbProject = (node)=>({
        avatarUrl: node.avatar?.large,
        id: Number(node.id),
        key: node.key,
        name: node.name
    });
const $65b0c941ec21e177$var$transformCmdbBitbucketRepo = (node)=>({
        uuid: node.uuid,
        name: node.name,
        url: node.url,
        avatarUrl: node.avatarUrl
    });
const $65b0c941ec21e177$var$transformCmdbOpsgenieTeam = (node)=>({
        id: node.id,
        name: node.name,
        url: node.url
    });
const $65b0c941ec21e177$var$transformCmdbStatus = (node)=>({
        id: node.id,
        name: node.name,
        category: node.category
    });
const $65b0c941ec21e177$var$transformObjectAttributeValuesToLegacy = (node)=>{
    if (!node) return null;
    const defaultObjectValue = {
        displayValue: node.displayValue,
        searchValue: node.searchValue,
        ...node.value != null ? {
            value: node.value
        } : {}
    };
    if (node.referencedObject) return {
        ...defaultObjectValue,
        referencedObject: $65b0c941ec21e177$var$transformReferencedObject(node.referencedObject)
    };
    if (node.user) return {
        ...defaultObjectValue,
        user: $65b0c941ec21e177$var$transformCmdbUser(node.user)
    };
    if (node.group) return {
        ...defaultObjectValue,
        group: $65b0c941ec21e177$var$transformCmdbGroup(node.group)
    };
    if (node.project) return {
        ...defaultObjectValue,
        project: $65b0c941ec21e177$var$transformCmdbProject(node.project)
    };
    if (node.bitbucketRepo) return {
        ...defaultObjectValue,
        bitbucketRepo: $65b0c941ec21e177$var$transformCmdbBitbucketRepo(node.bitbucketRepo)
    };
    if (node.opsgenieTeam) return {
        ...defaultObjectValue,
        opsgenieTeam: $65b0c941ec21e177$var$transformCmdbOpsgenieTeam(node.opsgenieTeam)
    };
    if (node.status) return {
        ...defaultObjectValue,
        status: $65b0c941ec21e177$var$transformCmdbStatus(node.status)
    };
    return defaultObjectValue;
};
const $65b0c941ec21e177$var$transformObjectAttributesToLegacyObjectAttributes = (node, workspaceId)=>{
    if (!node) return null;
    const { objectTypeAttributeId: objectTypeAttributeId, objectTypeAttribute: objectTypeAttribute } = node;
    return {
        objectTypeAttributeId: objectTypeAttributeId,
        ...!(0, $1ybV0.ff)('assets-rearch-deprecate-attribute-value-id_ykukg') && {
            id: node.attributeId
        },
        workspaceId: workspaceId,
        objectAttributeValues: (0, $f4e7j.transformAggConnection)(node.objectAttributeValues, $65b0c941ec21e177$var$transformObjectAttributeValuesToLegacy),
        objectTypeAttribute: {
            id: objectTypeAttributeId,
            label: objectTypeAttribute.label,
            name: objectTypeAttribute.name,
            workspaceId: workspaceId,
            type: $65b0c941ec21e177$var$transformObjectTypeAttributeToLegacy(objectTypeAttribute.type),
            ...objectTypeAttribute.defaultType ? {
                defaultType: {
                    id: objectTypeAttribute.defaultType.id,
                    name: objectTypeAttribute.defaultType.name
                }
            } : {}
        }
    };
};
const $65b0c941ec21e177$var$transformJiraCMDBToLegacyCMDB = (node)=>{
    if (!node) return null;
    const { label: label, objectGlobalId: objectGlobalId, objectId: objectId, objectKey: objectKey, workspaceId: workspaceId, webUrl: webUrl, avatar: avatar } = node;
    return {
        attributes: (0, $f4e7j.transformAggConnection)(node.attributes, (nodeAttribute)=>$65b0c941ec21e177$var$transformObjectAttributesToLegacyObjectAttributes(nodeAttribute, workspaceId)),
        avatar: avatar,
        label: label,
        id: objectGlobalId,
        objectId: objectId,
        objectKey: objectKey,
        workspaceId: workspaceId,
        links: {
            self: webUrl
        },
        objectType: $65b0c941ec21e177$var$transformObjectTypeToLegacy(node.objectType, workspaceId)
    };
};
const $65b0c941ec21e177$export$93506453d9bb56ae = (node)=>{
    if (node.type !== (0, $lO4Or.CMDB_OBJECT_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?` : null,
        configuration: $65b0c941ec21e177$var$transformCMDBConfigurationToLegacyConfiguration(node),
        value: (0, $f4e7j.transformAggConnection)(node.selectedCmdbObjectsConnection, $65b0c941ec21e177$var$transformJiraCMDBToLegacyCMDB),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.CMDB_OBJECT_CF_TYPE),
            items: 'cmdb-object-field',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("5CYGa", function(module, exports) {

$parcel$export(module.exports, "transformAggColorToLegacyField", () => $9050c04462f98fea$export$587c178f1b45e5e9);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $9050c04462f98fea$export$587c178f1b45e5e9 = (node)=>{
    const value = node.color?.colorKey ?? null;
    switch(node.type){
        case 0, $lO4Or.EPIC_COLOR_TYPE:
        case 0, $lO4Or.COLOR_CF_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: value,
                schema: {
                    configuration: null,
                    type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    custom: node.type,
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("9wKha", function(module, exports) {

$parcel$export(module.exports, "transformAggComponentsToLegacyField", () => $786c86fdf4d26692$export$97a9275777684b77);

var $1ybV0 = parcelRequire("1ybV0");


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
// @DoNotExport Flow is deriving component's type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $786c86fdf4d26692$var$transformJiraComponentToLegacyComponent = (component)=>{
    if (component == null) return null;
    return {
        id: component.componentId,
        name: component.name,
        ...(0, $1ybV0.ff)('compass-components-in-jira-components_xw42u', false) ? {
            ari: component.ari,
            metadata: component.metadata
        } : {}
    };
};
const $786c86fdf4d26692$export$97a9275777684b77 = (node)=>{
    if (node.type !== (0, $lO4Or.COMPONENTS_TYPE)) return undefined;
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.components, $786c86fdf4d26692$var$transformJiraComponentToLegacyComponent);
    const value = (0, $f4e7j.transformAggConnection)(node.selectedComponentsConnection, $786c86fdf4d26692$var$transformJiraComponentToLegacyComponent);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: 'component',
            renderer: (0, $c7e7b1d3600a0c0f$export$840ed33fa94f7693),
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            custom: null,
            system: (0, $lO4Or.COMPONENTS_TYPE)
        }
    };
};

});

parcelRegister("6PKzm", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectDateTimeToLegacyField", () => $37a64e51f4c4445c$export$e6d015aa746cbdaf);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $37a64e51f4c4445c$export$e6d015aa746cbdaf = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.dateTime ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    });

});

parcelRegister("jyP56", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectMultipleSelectToLegacyField", () => $060cb99a84a6f8a5$export$edf5c98d20696686);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $060cb99a84a6f8a5$export$edf5c98d20696686 = (node)=>{
    const value = (0, $f4e7j.transformAggConnection)(node.selectedOptions, (0, $f4e7j.toLegacyConnectOption));
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.connectMultiSelectFieldOptions, (0, $f4e7j.toLegacyConnectOption));
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value.length ? value : null,
        allowedValues: allowedValues,
        schema: {
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: (0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
            configuration: null
        }
    };
};

});

parcelRegister("epJqO", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectNumberToLegacyField", () => $c342681984a0fce1$export$4638a5dd3285d8f2);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $c342681984a0fce1$export$4638a5dd3285d8f2 = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.number ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    });

});

parcelRegister("Pxexr", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectRichTextToLegacyField", () => $6d21cc1975a64a13$export$11063e1f9210f191);

var $esUXI = parcelRequire("esUXI");


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $6d21cc1975a64a13$var$emptyAdfObject = (0, $esUXI.getEmptyADF)();
const $6d21cc1975a64a13$var$getPlainTextValue = (node)=>{
    if (!node.richText) return null;
    if (node.richText.plainText == null) return '';
    return node.richText.plainText;
};
const $6d21cc1975a64a13$export$11063e1f9210f191 = (node)=>{
    const { renderer: renderer } = node;
    if ((0, $2qVcp.default)(node)) return undefined;
    const isPlainTextRenderer = renderer === (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f);
    const values = isPlainTextRenderer ? {
        value: $6d21cc1975a64a13$var$getPlainTextValue(node)
    } : {
        adfValue: node.richText?.adfValue?.json || $6d21cc1975a64a13$var$emptyAdfObject
    };
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        ...values,
        schema: {
            custom: (0, $lO4Or.TEXT_AREA_CF_TYPE),
            renderer: renderer,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            configuration: null,
            items: null
        }
    };
};

});
parcelRegister("esUXI", function(module, exports) {

$parcel$export(module.exports, "getEmptyADF", () => $e4fec1f97a138b24$export$d109ab46c9575565);

var $3o7y4 = parcelRequire("3o7y4");
const $e4fec1f97a138b24$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});
parcelRegister("3o7y4", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $e439d27de8d77afc$export$dd1bc94b04021eeb);
const $e439d27de8d77afc$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;

});


parcelRegister("2qVcp", function(module, exports) {

$parcel$export(module.exports, "default", () => $08fb6c9e1b8a0092$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");
const $08fb6c9e1b8a0092$export$c63f561360bafed1 = 'issue.agg-field-transformers.missing-renderer';
// If the renderer is missing, log an error and return true.
// This was added as part of https://jplat.atlassian.net/browse/JIV-14881 to help identify why
// fields are sometimes missing the renderer.
const $08fb6c9e1b8a0092$var$isFieldMissingRenderer = (field)=>{
    try {
        // Narrow the type of field to fields with a renderer
        if (!('renderer' in field)) return false;
        if (field?.renderer) return false;
        (0, $gUUjF.default).safeErrorWithoutCustomerData($08fb6c9e1b8a0092$export$c63f561360bafed1, `Field ${field.fieldId} of type ${field.__typename} has missing renderer: ${field.renderer}`);
        return true;
    } catch  {
        return false;
    }
};
var $08fb6c9e1b8a0092$export$2e2bcd8739ae039 = $08fb6c9e1b8a0092$var$isFieldMissingRenderer;

});


parcelRegister("beuR4", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectSingleSelectToLegacyField", () => $b2ab3564d5e0e945$export$e44db7cf61369a28);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $b2ab3564d5e0e945$export$e44db7cf61369a28 = (node)=>{
    let value = null;
    if (node.fieldOption != null) value = {
        id: parseInt(node.fieldOption?.optionId, 10),
        value: node.fieldOption?.value
    };
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: (0, $f4e7j.transformAggConnection)(node.connectSingleSelectFieldOptions, (0, $f4e7j.toLegacyConnectOption)),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("d9IUw", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectTextToLegacyField", () => $a23506d3b78ec681$export$dd05277f5aa90657);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $a23506d3b78ec681$export$dd05277f5aa90657 = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("xnQ91", function(module, exports) {

$parcel$export(module.exports, "transformAggDataClassificationToLegacyField", () => $104546bf95896cb2$export$b5edfdc89a7a2932);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $104546bf95896cb2$export$b5edfdc89a7a2932 = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        key: (0, $lO4Or.DATA_CLASSIFICATION_TYPE),
        value: node,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            custom: null,
            system: null,
            type: (0, $lO4Or.DATA_CLASSIFICATION_TYPE)
        }
    });

});

parcelRegister("jsTfy", function(module, exports) {

$parcel$export(module.exports, "transformAggDatePickerToLegacyField", () => $cbf69a6b68f1ac34$export$3d6e51d37c0454a9);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $cbf69a6b68f1ac34$export$3d6e51d37c0454a9 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.DUE_DATE_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $lO4Or.ISSUE_FIELD_DATE_CF_TYPE),
                    configuration: null,
                    system: node.type,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    custom: null,
                    items: null
                }
            };
        case 0, $lO4Or.DATE_CF_TYPE:
        case 0, $lO4Or.BASELINE_START_CF_TYPE:
        case 0, $lO4Or.BASELINE_END_CF_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $lO4Or.ISSUE_FIELD_DATE_CF_TYPE),
                    custom: node.type,
                    configuration: null,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("55kng", function(module, exports) {

$parcel$export(module.exports, "transformAggDateTimePickerToLegacyField", () => $d108194053a9b0cf$export$3de22f1277f0c239);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $d108194053a9b0cf$var$defaultSchema = {
    type: (0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE),
    custom: null,
    system: null,
    configuration: null,
    items: null,
    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)
};
const $d108194053a9b0cf$export$3de22f1277f0c239 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.CREATED:
        case 0, $lO4Or.UPDATED:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: node.dateTime || '',
                schema: {
                    ...$d108194053a9b0cf$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $lO4Or.RESOLUTION_DATE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$d108194053a9b0cf$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $lO4Or.DATETIME_CF_TYPE:
        case 0, $lO4Or.FIRST_RESPONSE_DATE_CF_TYPE:
        case 0, $lO4Or.REQUEST_FEEDBACK_DATE_CF_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$d108194053a9b0cf$var$defaultSchema,
                    custom: node.type
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("7BRej", function(module, exports) {

$parcel$export(module.exports, "transformAggEpicLinkToLegacyField", () => $3731013de9f5c7b2$export$1311f30c94840aa2);

var $opsFH = parcelRequire("opsFH");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $3731013de9f5c7b2$var$transformJiraEpicToLegacyEpicLink = (epic)=>{
    if (epic == null) return null;
    return {
        id: Number(epic.issueId),
        key: epic.key || '',
        done: !!epic.done,
        name: epic.name || '',
        summary: epic.summary || '',
        color: {
            key: epic.color ?? (0, $opsFH.AgileColors).AGILE_COLOR_1
        },
        // This can only be set from cache handlers
        fromCache: false
    };
};
const $3731013de9f5c7b2$export$1311f30c94840aa2 = (node)=>{
    if (node.type !== (0, $lO4Or.EPIC_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: $3731013de9f5c7b2$var$transformJiraEpicToLegacyEpicLink(node.epic),
        schema: {
            configuration: null,
            items: null,
            renderer: 'jira-text-renderer',
            type: 'any',
            custom: (0, $lO4Or.EPIC_TYPE),
            system: null
        }
    };
};

});
parcelRegister("opsFH", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $e6c2c5f41d0c328b$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $e6c2c5f41d0c328b$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $e6c2c5f41d0c328b$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $e6c2c5f41d0c328b$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $e6c2c5f41d0c328b$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $e6c2c5f41d0c328b$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $e6c2c5f41d0c328b$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $e6c2c5f41d0c328b$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $e6c2c5f41d0c328b$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $e6c2c5f41d0c328b$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $e6c2c5f41d0c328b$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $e6c2c5f41d0c328b$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $e6c2c5f41d0c328b$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $e6c2c5f41d0c328b$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $e6c2c5f41d0c328b$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $e6c2c5f41d0c328b$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $e6c2c5f41d0c328b$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $e6c2c5f41d0c328b$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $e6c2c5f41d0c328b$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $e6c2c5f41d0c328b$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $e6c2c5f41d0c328b$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $e6c2c5f41d0c328b$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $e6c2c5f41d0c328b$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $e6c2c5f41d0c328b$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $e6c2c5f41d0c328b$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $e6c2c5f41d0c328b$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $e6c2c5f41d0c328b$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $e6c2c5f41d0c328b$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $e6c2c5f41d0c328b$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $e6c2c5f41d0c328b$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $e6c2c5f41d0c328b$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $e6c2c5f41d0c328b$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $e6c2c5f41d0c328b$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $e6c2c5f41d0c328b$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $e6c2c5f41d0c328b$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $e6c2c5f41d0c328b$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $e6c2c5f41d0c328b$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $e6c2c5f41d0c328b$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $e6c2c5f41d0c328b$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $e6c2c5f41d0c328b$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $e6c2c5f41d0c328b$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $e6c2c5f41d0c328b$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $e6c2c5f41d0c328b$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $e6c2c5f41d0c328b$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $e6c2c5f41d0c328b$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $e6c2c5f41d0c328b$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $e6c2c5f41d0c328b$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $e6c2c5f41d0c328b$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $e6c2c5f41d0c328b$export$4b7407b8700035bd);
/**
 * Color constants
 */ const $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2 = 'PURPLE';
const $e6c2c5f41d0c328b$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $e6c2c5f41d0c328b$export$738c3b9a44c87ecc = 'BLUE';
const $e6c2c5f41d0c328b$export$1225f83626261b80 = 'DARK_BLUE';
const $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b = 'GREEN';
const $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $e6c2c5f41d0c328b$export$d0446fe88325854e = 'TEAL';
const $e6c2c5f41d0c328b$export$bb848c92687e69dc = 'DARK_TEAL';
const $e6c2c5f41d0c328b$export$aab610c505c06a8f = 'YELLOW';
const $e6c2c5f41d0c328b$export$466af87757d343a2 = 'DARK_YELLOW';
const $e6c2c5f41d0c328b$export$3de5e29ed1757f9b = 'ORANGE';
const $e6c2c5f41d0c328b$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $e6c2c5f41d0c328b$export$7d278ca694634874 = 'GREY';
const $e6c2c5f41d0c328b$export$26453300bfc61cb8 = 'DARK_GREY';
const $e6c2c5f41d0c328b$export$56d196d2844d1ca1 = [
    $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    $e6c2c5f41d0c328b$export$1225f83626261b80,
    $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    $e6c2c5f41d0c328b$export$d0446fe88325854e,
    $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    $e6c2c5f41d0c328b$export$466af87757d343a2,
    $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    $e6c2c5f41d0c328b$export$7d278ca694634874,
    $e6c2c5f41d0c328b$export$26453300bfc61cb8
];
const $e6c2c5f41d0c328b$export$792af22a0198af8d = 'purple';
const $e6c2c5f41d0c328b$export$588af712afdcb006 = 'dark_purple';
const $e6c2c5f41d0c328b$export$84c4918645391802 = 'blue';
const $e6c2c5f41d0c328b$export$b8f1f5838352a33a = 'dark_blue';
const $e6c2c5f41d0c328b$export$9384b7e350ee6542 = 'green';
const $e6c2c5f41d0c328b$export$87d3fb8d8656d38b = 'dark_green';
const $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae = 'teal';
const $e6c2c5f41d0c328b$export$a89b77a449bd223e = 'dark_teal';
const $e6c2c5f41d0c328b$export$9a33b5e3cde94885 = 'yellow';
const $e6c2c5f41d0c328b$export$33253d7862bceb8a = 'dark_yellow';
const $e6c2c5f41d0c328b$export$6609c2b23fc42f39 = 'orange';
const $e6c2c5f41d0c328b$export$cd994662b5911917 = 'dark_orange';
const $e6c2c5f41d0c328b$export$1793d43e13e078c5 = 'grey';
const $e6c2c5f41d0c328b$export$487a6e9145526564 = 'dark_grey';
const $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $e6c2c5f41d0c328b$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $e6c2c5f41d0c328b$export$94ac87c81ed074a7 = 'ghx-label-3';
const $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $e6c2c5f41d0c328b$export$610a2c132b6fcf96 = 'ghx-label-5';
const $e6c2c5f41d0c328b$export$8e4997dba71f1c40 = 'ghx-label-6';
const $e6c2c5f41d0c328b$export$18a545b4e69b27b4 = 'ghx-label-7';
const $e6c2c5f41d0c328b$export$27fff1a0d295292a = 'ghx-label-8';
const $e6c2c5f41d0c328b$export$e57aa662a56724e1 = 'ghx-label-9';
const $e6c2c5f41d0c328b$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $e6c2c5f41d0c328b$export$457ecb9560f2bf83 = 'ghx-label-11';
const $e6c2c5f41d0c328b$export$a866db37165a696c = 'ghx-label-12';
const $e6c2c5f41d0c328b$export$9b18447c1168a1b6 = 'ghx-label-13';
const $e6c2c5f41d0c328b$export$93b9ad4020e271b7 = 'ghx-label-14';
const $e6c2c5f41d0c328b$export$5cd2af17b34de3e3 = 'color_1';
const $e6c2c5f41d0c328b$export$987671fa69482a7b = 'color_2';
const $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446 = 'color_3';
const $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36 = 'color_4';
const $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256 = 'color_5';
const $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78 = 'color_6';
const $e6c2c5f41d0c328b$export$9dc62d5d151cb355 = 'color_7';
const $e6c2c5f41d0c328b$export$1ed15b30f5663f92 = 'color_8';
const $e6c2c5f41d0c328b$export$5d23a84d55ac1644 = 'color_9';
const $e6c2c5f41d0c328b$export$bf08c9a6ed42e349 = 'color_10';
const $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c = 'color_11';
const $e6c2c5f41d0c328b$export$da30755a37c3a597 = 'color_12';
const $e6c2c5f41d0c328b$export$721cf84faff6bf19 = 'color_13';
const $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd = 'color_14';
const $e6c2c5f41d0c328b$export$c537fa0d021d010b = {
    PURPLE: $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    BLUE: $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    DARK_BLUE: $e6c2c5f41d0c328b$export$1225f83626261b80,
    GREEN: $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    TEAL: $e6c2c5f41d0c328b$export$d0446fe88325854e,
    DARK_TEAL: $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    YELLOW: $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    DARK_YELLOW: $e6c2c5f41d0c328b$export$466af87757d343a2,
    ORANGE: $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    DARK_ORANGE: $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    GREY: $e6c2c5f41d0c328b$export$7d278ca694634874,
    DARK_GREY: $e6c2c5f41d0c328b$export$26453300bfc61cb8
};
const $e6c2c5f41d0c328b$export$d33d39828a18210a = {
    SERVER_PURPLE: $e6c2c5f41d0c328b$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $e6c2c5f41d0c328b$export$588af712afdcb006,
    SERVER_BLUE: $e6c2c5f41d0c328b$export$84c4918645391802,
    SERVER_DARK_BLUE: $e6c2c5f41d0c328b$export$b8f1f5838352a33a,
    SERVER_GREEN: $e6c2c5f41d0c328b$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $e6c2c5f41d0c328b$export$87d3fb8d8656d38b,
    SERVER_TEAL: $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $e6c2c5f41d0c328b$export$a89b77a449bd223e,
    SERVER_YELLOW: $e6c2c5f41d0c328b$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $e6c2c5f41d0c328b$export$33253d7862bceb8a,
    SERVER_ORANGE: $e6c2c5f41d0c328b$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $e6c2c5f41d0c328b$export$cd994662b5911917,
    SERVER_GREY: $e6c2c5f41d0c328b$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $e6c2c5f41d0c328b$export$487a6e9145526564
};
const $e6c2c5f41d0c328b$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $e6c2c5f41d0c328b$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $e6c2c5f41d0c328b$export$94ac87c81ed074a7,
    GHX_LABEL_4: $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $e6c2c5f41d0c328b$export$610a2c132b6fcf96,
    GHX_LABEL_6: $e6c2c5f41d0c328b$export$8e4997dba71f1c40,
    GHX_LABEL_7: $e6c2c5f41d0c328b$export$18a545b4e69b27b4,
    GHX_LABEL_8: $e6c2c5f41d0c328b$export$27fff1a0d295292a,
    GHX_LABEL_9: $e6c2c5f41d0c328b$export$e57aa662a56724e1,
    GHX_LABEL_10: $e6c2c5f41d0c328b$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $e6c2c5f41d0c328b$export$457ecb9560f2bf83,
    GHX_LABEL_12: $e6c2c5f41d0c328b$export$a866db37165a696c,
    GHX_LABEL_13: $e6c2c5f41d0c328b$export$9b18447c1168a1b6,
    GHX_LABEL_14: $e6c2c5f41d0c328b$export$93b9ad4020e271b7
};
const $e6c2c5f41d0c328b$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $e6c2c5f41d0c328b$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $e6c2c5f41d0c328b$export$987671fa69482a7b,
    AGILE_COLOR_3: $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $e6c2c5f41d0c328b$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $e6c2c5f41d0c328b$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $e6c2c5f41d0c328b$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $e6c2c5f41d0c328b$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $e6c2c5f41d0c328b$export$da30755a37c3a597,
    AGILE_COLOR_13: $e6c2c5f41d0c328b$export$721cf84faff6bf19,
    AGILE_COLOR_14: $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd
};

});


parcelRegister("04Gbh", function(module, exports) {

$parcel$export(module.exports, "transformAggFlagToLegacyField", () => $c8b2d8c7cabddb24$export$31555b6ea19f4c2);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $c8b2d8c7cabddb24$var$transformJiraFlagToLegacyFlag = (flag)=>{
    if (flag == null || flag.isFlagged == null) return null;
    return [
        {
            value: flag.isFlagged
        }
    ];
};
const $c8b2d8c7cabddb24$export$31555b6ea19f4c2 = (node)=>{
    // Agg flag field comes back as multichecbox CF type instead of current graphql flagged CF type
    if (node.type !== (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $c8b2d8c7cabddb24$var$transformJiraFlagToLegacyFlag(node.flag),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.FLAGGED_CF_TYPE),
            items: 'option',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("3ZJZc", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateToLegacyField", () => $c763da6a17e08623$export$30fccfce22948120);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $c763da6a17e08623$export$30fccfce22948120 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.date,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_DATE_CF_TYPE)
        }
    };
};

});

parcelRegister("bw8ws", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateTimeToLegacyField", () => $4c0a1710d24fba77$export$61b1f0cbd04c7b9c);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $4c0a1710d24fba77$export$61b1f0cbd04c7b9c = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.dateTime,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    };
};

});

parcelRegister("9vCKL", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupToLegacyField", () => $c9b907ff4adf2ba8$export$60b03d63015cbb9f);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $c9b907ff4adf2ba8$export$60b03d63015cbb9f = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.selectedGroup ? {
            name: node.selectedGroup.name
        } : null,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE)
        }
    };
};

});

parcelRegister("i5dch", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupsToLegacyField", () => $a11ed3e141cd8632$export$2dfa4944fba5d1f5);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $a11ed3e141cd8632$export$2dfa4944fba5d1f5 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    const value = node.selectedGroupsConnection?.edges?.length ? (0, $f4e7j.transformAggConnection)(node.selectedGroupsConnection, ({ name: name })=>({
            name: name
        })) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $lO4Or.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("iJcxE", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeNumberToLegacyField", () => $0d8b7166bd07a2e4$export$5dab8986dc45db07);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $0d8b7166bd07a2e4$export$5dab8986dc45db07 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.number,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    };
};

});

parcelRegister("djkJh", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeObjectToLegacyField", () => $d8b2a1a28c816219$export$fbdabdbae2a203b9);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $d8b2a1a28c816219$export$fbdabdbae2a203b9 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    const value = (()=>{
        if (node.object == null) return null;
        try {
            return JSON.parse(node.object);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            throw new Error('Failed to transform forge object field: node.object was invalid JSON object');
        }
    })();
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_OBJECT_CF_TYPE)
        }
    };
};

});

parcelRegister("kbDa2", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringToLegacyField", () => $c3ecb4f8814d5007$export$3a581fb4b3e578bd);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $c3ecb4f8814d5007$export$3a581fb4b3e578bd = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("4gy8O", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringsToLegacyField", () => $e5fb5863b3ffc3de$export$418a06cb5dc6aba5);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $e5fb5863b3ffc3de$export$418a06cb5dc6aba5 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    const hasValue = Boolean(node.selectedLabelsConnection?.edges?.length);
    const value = hasValue ? (0, $f4e7j.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("9w928", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUserToLegacyField", () => $bdc773687305de8f$export$bc73c7a747f907e5);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");

var $g5TY0 = parcelRequire("g5TY0");
const $bdc773687305de8f$export$bc73c7a747f907e5 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $g5TY0.transformJiraUserToLegacyServerUser)(node.user) : null,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE)
        }
    };
};

});
parcelRegister("g5TY0", function(module, exports) {

$parcel$export(module.exports, "transformJiraUserToLegacyServerUser", () => $c92150b2c9939d9c$export$d7b231260a016eaf);

const $c92150b2c9939d9c$var$getAccountType = (objectType)=>{
    switch(objectType){
        case 'AtlassianAccountUser':
            return 0, $0f8390fc7463ac8c$export$981400c14dd99bc0;
        case 'CustomerUser':
            return 0, $0f8390fc7463ac8c$export$2823897fb92cd040;
        case 'AppUser':
            return 0, $0f8390fc7463ac8c$export$1973ca62b6c5abfe;
        default:
            return 0, $0f8390fc7463ac8c$export$d1f5101c0939e3fe;
    }
};
const $c92150b2c9939d9c$var$generateAvatarUrls = (url)=>({
        '16x16': url,
        '24x24': url,
        '32x32': url,
        '48x48': url
    });
const $c92150b2c9939d9c$export$d7b231260a016eaf = (user)=>{
    if (!user) return null;
    const userOptionalKeysMap = {
        emailAddress: 'email',
        locale: 'locale',
        timeZone: 'zoneinfo'
    };
    const optionalValues = {};
    Object.entries(userOptionalKeysMap).forEach(([key, aggKey])=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const aggValue = user[aggKey];
        if (aggValue !== undefined && aggValue !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        optionalValues[key] = aggValue;
    });
    const avatars = user.picture != null ? {
        avatarUrl: user.picture,
        avatarUrls: $c92150b2c9939d9c$var$generateAvatarUrls(user.picture)
    } : {};
    return {
        ...avatars,
        ...optionalValues,
        accountId: user.accountId,
        accountType: $c92150b2c9939d9c$var$getAccountType(user.__typename),
        active: user.accountStatus === 'active',
        displayName: user.name
    };
};

});
const $0f8390fc7463ac8c$export$981400c14dd99bc0 = 'atlassian';
const $0f8390fc7463ac8c$export$2823897fb92cd040 = 'customer';
const $0f8390fc7463ac8c$export$1973ca62b6c5abfe = 'app';
const $0f8390fc7463ac8c$export$d1f5101c0939e3fe = 'unknown';



parcelRegister("3khS7", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUsersToLegacyField", () => $04695e9464f736dc$export$bbfea2e2f2c853b8);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");

var $g5TY0 = parcelRequire("g5TY0");
const $04695e9464f736dc$export$bbfea2e2f2c853b8 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    const value = node.selectedUsersConnection?.edges?.length ? (0, $f4e7j.transformAggConnection)(node.selectedUsersConnection, (0, $g5TY0.transformJiraUserToLegacyServerUser)) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("c52Z6", function(module, exports) {

$parcel$export(module.exports, "transformAggGoalsToLegacyField", () => $967e7c1cc9b41f1e$export$158301a02ae4cbe7);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $967e7c1cc9b41f1e$export$158301a02ae4cbe7 = (node)=>{
    if (node.type !== (0, $lO4Or.GOALS_CF_TYPE)) return undefined;
    const value = node.selectedGoals ? {
        goals: node.selectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>({
                id: edge?.node?.id || '',
                name: edge?.node?.name || '',
                status: edge?.node?.status || null
            })) || [],
        totalCount: node.selectedGoals?.totalCount || 0
    } : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.GOALS_CF_TYPE),
            items: null,
            renderer: null,
            system: null,
            type: (0, $lO4Or.GOALS_CF_TYPE)
        }
    };
};

});

parcelRegister("6IjGS", function(module, exports) {

$parcel$export(module.exports, "transformAggIssueRestrictionToLegacyField", () => $656ee40cfd5a4289$export$62db794d5816e28e);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $ijtj3 = parcelRequire("ijtj3");
const $656ee40cfd5a4289$var$transformJiraRoleToRestriction = (role)=>{
    if (role == null) return null;
    return {
        restrictionValue: role.roleId
    };
};
const $656ee40cfd5a4289$export$62db794d5816e28e = (node, context)=>{
    if (node.type !== (0, $lO4Or.ISSUE_RESTRICTION_TYPE)) return undefined;
    const roles = (0, $f4e7j.transformAggConnection)(node.selectedRolesConnection, $656ee40cfd5a4289$var$transformJiraRoleToRestriction);
    const restrictions = roles.length > 0 ? {
        projectrole: roles
    } : {};
    const project = (0, $ijtj3.getSystemAggJiraProject)(context);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: {
            shouldDisplay: project.canSetIssueRestriction === true,
            issuerestrictions: restrictions
        },
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            type: (0, $lO4Or.ISSUE_RESTRICTION_TYPE),
            custom: null,
            system: node.type
        }
    };
};

});
parcelRegister("ijtj3", function(module, exports) {

$parcel$export(module.exports, "getProjectType", () => $b7b19c470c7e1e1a$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getSystemAggJiraProject", () => $b7b19c470c7e1e1a$export$d100105d56da4a0a);
$parcel$export(module.exports, "transformAggProjectToProjectContext", () => $b7b19c470c7e1e1a$export$275f121d4e6f5165);
$parcel$export(module.exports, "transformAggProjectToLegacyField", () => $b7b19c470c7e1e1a$export$30c14b802399f417);

var $7ZZxN = parcelRequire("7ZZxN");



var $lO4Or = parcelRequire("lO4Or");

var $6vrw7 = parcelRequire("6vrw7");

var $laBqX = parcelRequire("laBqX");

var $f4e7j = parcelRequire("f4e7j");
const $b7b19c470c7e1e1a$var$getProjectStatus = (status)=>{
    switch(status){
        case 'ACTIVE':
            return 0, $5bd9e96e4d7e8aee$export$62113557945f790a;
        case 'ARCHIVED':
            return 0, $5bd9e96e4d7e8aee$export$4ccc35479ba9ad1;
        case 'DELETED':
            return 0, $5bd9e96e4d7e8aee$export$a95d71e582b8bc0;
        default:
            // Based on `getProjectStatus` from src/packages/issue/issue-view/src/common/service/issue/issue-transformer.js
            return 0, $5bd9e96e4d7e8aee$export$62113557945f790a;
    }
};
const $b7b19c470c7e1e1a$export$3dd0da95519c1a33 = (projectType)=>{
    switch(projectType){
        case 'SERVICE_DESK':
            return 0, $7ZZxN.SERVICE_DESK_PROJECT;
        case 'BUSINESS':
            return 0, $7ZZxN.CORE_PROJECT;
        case 'SOFTWARE':
            return 0, $7ZZxN.SOFTWARE_PROJECT;
        case 'PRODUCT_DISCOVERY':
            return 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $b7b19c470c7e1e1a$export$d100105d56da4a0a = (fields)=>{
    /**
	 * We only want the system `PROJECT_TYPE` field.
	 * For custom fields, e.g., project picker, see `transformAggProjectToLegacyField`
	 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const projectField = fields?.find((edge)=>edge?.node?.__typename === (0, $lO4Or.PROJECT_GQL_FIELD) && edge?.node?.type != null && edge.node.type === (0, $lO4Or.PROJECT_TYPE))?.node;
    // Needs the `PROJECT_GQL_FIELD` refinement so we can return as `AggJiraProject`
    if (projectField == null || projectField.__typename !== (0, $lO4Or.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $lO4Or.PROJECT_GQL_FIELD)} with ${(0, $lO4Or.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $lO4Or.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    return projectField.project;
};
const $b7b19c470c7e1e1a$export$f7d5cb97957d02e3 = (project)=>project.projectStyle === 'TEAM_MANAGED_PROJECT';
const $b7b19c470c7e1e1a$var$transformAggProjectToServerProjectOption = (project)=>{
    if (project == null) return null;
    const { projectId: projectId, key: key, name: name, avatar: avatar } = project;
    return {
        name: name,
        id: projectId ?? undefined,
        key: (0, $6vrw7.toProjectKey)(key),
        avatarUrls: {
            '48x48': avatar.large
        }
    };
};
const $b7b19c470c7e1e1a$export$275f121d4e6f5165 = (fields)=>{
    const project = $b7b19c470c7e1e1a$export$d100105d56da4a0a(fields);
    const { projectId: projectId, name: name, key: key, avatar: avatar, status: status, projectType: type, navigationMetadata: navigationMetadata } = project;
    const projectType = $b7b19c470c7e1e1a$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform system project: projectType ${String(type)} was invalid`);
    return {
        projectId: projectId,
        projectType: projectType,
        projectName: name,
        projectKey: key,
        projectStatus: $b7b19c470c7e1e1a$var$getProjectStatus(status),
        avatarUrl: avatar.medium,
        isSimplified: $b7b19c470c7e1e1a$export$f7d5cb97957d02e3(project),
        boardId: navigationMetadata?.boardId
    };
};
const $b7b19c470c7e1e1a$var$transformAggProjectToLegacyProjectPickerField = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: $b7b19c470c7e1e1a$var$transformAggProjectToServerProjectOption(node.project),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            type: (0, $lO4Or.PROJECT_TYPE),
            custom: (0, $lO4Or.PROJECT_PICKER_CF_TYPE),
            system: null
        }
    });
const $b7b19c470c7e1e1a$var$transformAggProjectToLegacySimilarIssuesField = (node)=>{
    // Similar issues field only exist in JSM projects
    if ($b7b19c470c7e1e1a$export$3dd0da95519c1a33(node.project?.projectType) !== (0, $7ZZxN.SERVICE_DESK_PROJECT)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        key: (0, $lO4Or.SIMILAR_ISSUES_TYPE),
        title: (0, $lO4Or.SIMILAR_ISSUES_TYPE),
        value: node.project?.similarIssues?.featureEnabled === true,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $lO4Or.SIMILAR_ISSUES_TYPE),
            custom: null,
            system: (0, $lO4Or.SIMILAR_ISSUES_TYPE)
        }
    };
};
const $b7b19c470c7e1e1a$var$transformAggProjectToLegacyProjectField = (node)=>{
    if (node?.__typename !== (0, $lO4Or.PROJECT_GQL_FIELD) || node?.type === null || node?.type !== (0, $lO4Or.PROJECT_TYPE)) throw new Error(`Failed to get system project data: ${(0, $lO4Or.PROJECT_GQL_FIELD)} with ${(0, $lO4Or.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node)}]`);
    const projectField = node;
    if (projectField == null || projectField.__typename !== (0, $lO4Or.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $lO4Or.PROJECT_GQL_FIELD)} with ${(0, $lO4Or.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $lO4Or.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    const project = projectField.project;
    const { projectType: type } = project;
    const projectType = $b7b19c470c7e1e1a$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform project: projectType ${String(project?.projectType)} was invalid`);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: {
            projectType: projectType
        }
    };
};
const $b7b19c470c7e1e1a$var$transformAggProjectToLegacyFieldByType = (node)=>{
    const projectType = $b7b19c470c7e1e1a$export$3dd0da95519c1a33(node.project?.projectType);
    if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) // Similar issues field only exist in JSM projects
    return $b7b19c470c7e1e1a$var$transformAggProjectToLegacySimilarIssuesField(node);
    if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return $b7b19c470c7e1e1a$var$transformAggProjectToLegacyProjectField(node);
    return undefined;
};
const $b7b19c470c7e1e1a$export$30c14b802399f417 = (node)=>{
    if ((0, $laBqX.isJPDDeliveryLinkTypeFilteringEnabled)()) switch(node.type){
        case 0, $lO4Or.PROJECT_PICKER_CF_TYPE:
            return $b7b19c470c7e1e1a$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $lO4Or.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $b7b19c470c7e1e1a$var$transformAggProjectToLegacyFieldByType(node);
        default:
            return undefined;
    }
    else switch(node.type){
        case 0, $lO4Or.PROJECT_PICKER_CF_TYPE:
            return $b7b19c470c7e1e1a$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $lO4Or.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $b7b19c470c7e1e1a$var$transformAggProjectToLegacySimilarIssuesField(node);
        default:
            return undefined;
    }
};

});
const $5bd9e96e4d7e8aee$export$62113557945f790a = 'PROJECT_ACTIVE';
const $5bd9e96e4d7e8aee$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $5bd9e96e4d7e8aee$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';

parcelRegister("laBqX", function(module, exports) {

$parcel$export(module.exports, "isParentInIssueViewEnabled", () => $99e1f9f9d21b8f5c$export$9c7fa56ed1fa2e15);
$parcel$export(module.exports, "isJPDDeliveryLinkTypeFilteringEnabled", () => $99e1f9f9d21b8f5c$export$8fac1563227555f2);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $1ybV0 = parcelRequire("1ybV0");
const $99e1f9f9d21b8f5c$export$9c7fa56ed1fa2e15 = ()=>(0, $1ybV0.ff)('parent-field-in-issue-view_x4zn4', false);
const $99e1f9f9d21b8f5c$export$8fac1563227555f2 = ()=>(0, $1ybV0.ff)('polaris.jpd-panel-filter-by-delivery-link-type', false);

});



parcelRegister("eOsdu", function(module, exports) {

$parcel$export(module.exports, "getSystemAggJiraIssueType", () => $fddff707046980f2$export$b4644a0cc2f2935e);
$parcel$export(module.exports, "transformJiraIssueTypeToLegacyIssueType", () => $fddff707046980f2$export$2356062173546155);
$parcel$export(module.exports, "transformAggIssueTypeToLegacyField", () => $fddff707046980f2$export$de2eb3b47c7c887b);


var $edkGa = parcelRequire("edkGa");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $fddff707046980f2$export$d95e76b2d065f98d = {
    avatarId: 0,
    self: ''
};
const $fddff707046980f2$export$b4644a0cc2f2935e = (fields)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueTypeField = fields?.find((edge)=>edge?.node != null && edge.node.__typename === (0, $lO4Or.ISSUE_TYPE_GQL_FIELD) && edge.node.type === (0, $lO4Or.ISSUE_TYPE))?.node;
    if (issueTypeField == null || issueTypeField.__typename !== (0, $lO4Or.ISSUE_TYPE_GQL_FIELD) || issueTypeField.type !== (0, $lO4Or.ISSUE_TYPE)) throw new Error(`Failed to get system issue type: ${(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)} with ${(0, $lO4Or.ISSUE_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (issueTypeField.issueType == null) throw new Error(`Failed to get system issue type: ${(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)}.issueType is missing [${JSON.stringify(issueTypeField)}]`);
    return issueTypeField.issueType;
};
const $fddff707046980f2$export$2356062173546155 = (issueType)=>({
        ...$fddff707046980f2$export$d95e76b2d065f98d,
        id: issueType.issueTypeId,
        iconUrl: issueType.avatar?.medium ?? '',
        name: issueType.name,
        description: 'description' in issueType && issueType.description != null ? issueType.description : '',
        hierarchyLevel: issueType.hierarchy.level,
        subtask: issueType.hierarchy.level === (0, $edkGa.ISSUE_TYPE_HIERARCHY_LEVEL).SUBTASK_LEVEL
    });
const $fddff707046980f2$export$de2eb3b47c7c887b = (node)=>{
    if (node.type !== (0, $lO4Or.ISSUE_TYPE) || node.issueType == null) throw new Error(`Failed to transform ${(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)}: type is not ${(0, $lO4Or.ISSUE_TYPE)} or 'issueType' is empty [${JSON.stringify(node)}]`);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $fddff707046980f2$export$2356062173546155(node.issueType),
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: (0, $lO4Or.ISSUE_TYPE),
            type: (0, $lO4Or.ISSUE_TYPE)
        }
    };
};

});
parcelRegister("edkGa", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE_HIERARCHY_LEVEL", () => $b500da57c36bb99b$export$2fe6880f0073407c);

var $3l6tm = parcelRequire("3l6tm");
const $b500da57c36bb99b$export$2fe6880f0073407c = {
    SUBTASK_LEVEL: (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_SUBTASK),
    BASE_LEVEL: (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_BASE),
    LEVEL_ONE: (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_EPIC),
    LEVEL_TWO: 2
};

});
parcelRegister("3l6tm", function(module, exports) {

$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", () => $493876d3567385f4$export$2294cfc7730248df);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", () => $493876d3567385f4$export$961a1d6da881600c);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", () => $493876d3567385f4$export$e11dea67b88ee556);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", () => $493876d3567385f4$export$9ad20e435294162a);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", () => $493876d3567385f4$export$a454b3474c5ee5f5);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", () => $493876d3567385f4$export$b69c1b48ce8f83de);
$parcel$export(module.exports, "BASE_HIERARCHY_TYPE", () => $493876d3567385f4$export$ba7c785763a2a58f);
$parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", () => $493876d3567385f4$export$e09d07f2dcff2603);
$parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", () => $493876d3567385f4$export$1165245f61159842);
$parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", () => $493876d3567385f4$export$8a96a83b3f957e58);
$parcel$export(module.exports, "toHierarchyLevel", () => $493876d3567385f4$export$c0c893ca5ccae9dd);
$parcel$export(module.exports, "isBaseHierarchyLevel", () => $493876d3567385f4$export$bcf91a9d8c5b0f58);
$parcel$export(module.exports, "isEpicHierarchyLevel", () => $493876d3567385f4$export$e415cf60723c7aae);
$parcel$export(module.exports, "isSubtaskHierarchyLevel", () => $493876d3567385f4$export$41f00a40e2ebd6e8);
$parcel$export(module.exports, "getHierarchyLevelType", () => $493876d3567385f4$export$556b686fea6fb229);
$parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", () => $493876d3567385f4$export$638ac52227e67c8);
const $493876d3567385f4$export$2294cfc7730248df = 4;
const $493876d3567385f4$export$961a1d6da881600c = 3;
const $493876d3567385f4$export$e11dea67b88ee556 = 2;
const $493876d3567385f4$export$9ad20e435294162a = 1;
const $493876d3567385f4$export$a454b3474c5ee5f5 = 0;
const $493876d3567385f4$export$b69c1b48ce8f83de = -1;
const $493876d3567385f4$export$ba7c785763a2a58f = 'BASE';
const $493876d3567385f4$export$e09d07f2dcff2603 = 'CHILD';
const $493876d3567385f4$export$1165245f61159842 = 'PARENT';
const $493876d3567385f4$export$8a96a83b3f957e58 = 'EPIC';
const $493876d3567385f4$export$c0c893ca5ccae9dd = (level)=>level;
const $493876d3567385f4$export$bcf91a9d8c5b0f58 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return true;
    return numericLevel === $493876d3567385f4$export$a454b3474c5ee5f5;
};
const $493876d3567385f4$export$e415cf60723c7aae = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $493876d3567385f4$export$9ad20e435294162a;
};
const $493876d3567385f4$export$41f00a40e2ebd6e8 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $493876d3567385f4$export$b69c1b48ce8f83de;
};
const $493876d3567385f4$export$556b686fea6fb229 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) > 0) return $493876d3567385f4$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $493876d3567385f4$export$e09d07f2dcff2603;
    return $493876d3567385f4$export$ba7c785763a2a58f;
};
const $493876d3567385f4$export$638ac52227e67c8 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) === 1) return $493876d3567385f4$export$8a96a83b3f957e58;
    if (Number(hierarchyLevel) > 1) return $493876d3567385f4$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $493876d3567385f4$export$e09d07f2dcff2603;
    return $493876d3567385f4$export$ba7c785763a2a58f;
};

});



parcelRegister("6MxWX", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMApprovalsToLegacyField", () => $3d843a7647f78c65$export$b14d30f2a9e4c343);

var $23qRX = parcelRequire("23qRX");

var $lO4Or = parcelRequire("lO4Or");

var $6vrw7 = parcelRequire("6vrw7");

var $f4e7j = parcelRequire("f4e7j");

var $g5TY0 = parcelRequire("g5TY0");
const $3d843a7647f78c65$var$transformApproverPrincipalsToLegacy = (approverPrincipal)=>{
    if (!approverPrincipal) return undefined;
    switch(approverPrincipal.__typename){
        case 0, $lO4Or.JSM_USER_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $6vrw7.toAccountId)(approverPrincipal.user.accountId),
                name: approverPrincipal.user.name,
                meta: {
                    jiraRest: approverPrincipal.jiraRest
                },
                type: 'user',
                avatarUrl: approverPrincipal.user.picture
            };
        case 0, $lO4Or.JSM_GROUP_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $23qRX.toGroupId)(approverPrincipal.groupId),
                meta: {
                    memberCount: approverPrincipal.memberCount,
                    approvedCount: approverPrincipal.approvedCount
                },
                name: approverPrincipal.name,
                type: 'group'
            };
        default:
            return undefined;
    }
};
const $3d843a7647f78c65$var$getApproverDecision = (decision)=>{
    switch(decision){
        case 0, $23qRX.APPROVER_APPROVED:
            return 0, $23qRX.APPROVER_APPROVED;
        case 0, $23qRX.APPROVER_DECLINED:
            return 0, $23qRX.APPROVER_DECLINED;
        case 0, $23qRX.APPROVER_PENDING:
        default:
            return 0, $23qRX.APPROVER_PENDING;
    }
};
const $3d843a7647f78c65$var$transformApproverToLegacy = (approvalNode)=>{
    if (!approvalNode) return undefined;
    const approver = (0, $g5TY0.transformJiraUserToLegacyServerUser)(approvalNode.approver);
    if (!approver) return undefined;
    return {
        approverDecision: $3d843a7647f78c65$var$getApproverDecision(approvalNode.approverDecision),
        approver: approver
    };
};
const $3d843a7647f78c65$var$transformConfigurationToLegacy = (configurations)=>{
    // This function contains a lot of null checks and default empty values to satisfy flow because
    // the AGG type coming back is in the shape of [JiraServiceManagementApprovalConfiguration]
    // Which means technically it can be an empty array. Even though we will always only ever
    // get 1 object back.
    const { approversConfigurations: approversConfigurations = [], condition: condition } = configurations?.[0] || {};
    const approverConfiguration = approversConfigurations[0];
    return {
        approvers: {
            type: approverConfiguration?.type ?? '',
            customFieldName: approverConfiguration?.fieldName ?? '',
            customFieldId: approverConfiguration?.fieldId ?? ''
        },
        condition: {
            type: condition?.type ?? '',
            value: condition?.value ?? ''
        }
    };
};
const $3d843a7647f78c65$var$transformDateToLegacy = (date)=>({
        epochMillis: new Date(date).valueOf()
    });
const $3d843a7647f78c65$var$transformStatusToLegacy = (status)=>({
        name: status.name || '',
        category: Number(status.categoryId)
    });
const $3d843a7647f78c65$var$transformActiveApprovalToLegacy = (activeApproval)=>{
    const { id: id, configurations: configurations, status: status, createdDate: createdDate, canAnswerApproval: canAnswerApproval, pendingApprovalCount: pendingApprovalCount, name: name, finalDecision: finalDecision, approvalState: approvalState, approvedStatus: approvedStatus } = activeApproval;
    return {
        id: id,
        approvalState: approvalState,
        approvedStatus: approvedStatus,
        finalDecision: $3d843a7647f78c65$var$getApproverDecision(finalDecision),
        name: name,
        pendingApprovalCount: pendingApprovalCount,
        canAnswerApproval: canAnswerApproval,
        approverPrincipals: (0, $f4e7j.transformAggConnection)(activeApproval.approverPrincipals, $3d843a7647f78c65$var$transformApproverPrincipalsToLegacy),
        approvers: (0, $f4e7j.transformAggConnection)(activeApproval.approvers, $3d843a7647f78c65$var$transformApproverToLegacy),
        configuration: $3d843a7647f78c65$var$transformConfigurationToLegacy(configurations),
        createdDate: $3d843a7647f78c65$var$transformDateToLegacy(createdDate ?? ''),
        decisions: (0, $f4e7j.transformAggConnection)(activeApproval.decisions, $3d843a7647f78c65$var$transformApproverToLegacy),
        excludedApprovers: (0, $f4e7j.transformAggConnection)(activeApproval.excludedApprovers, (0, $g5TY0.transformJiraUserToLegacyServerUser)),
        status: status ? $3d843a7647f78c65$var$transformStatusToLegacy(status) : null
    };
};
const $3d843a7647f78c65$var$transformCompletedApprovalToLegacy = (completedApproval)=>{
    if (!completedApproval) return undefined;
    const { id: id, name: name, finalDecision: finalDecision, createdDate: createdDate, completedDate: completedDate, status: status } = completedApproval;
    return {
        id: id,
        name: name,
        finalDecision: $3d843a7647f78c65$var$getApproverDecision(finalDecision),
        createdDate: $3d843a7647f78c65$var$transformDateToLegacy(createdDate ?? ''),
        completedDate: $3d843a7647f78c65$var$transformDateToLegacy(completedDate),
        status: status ? $3d843a7647f78c65$var$transformStatusToLegacy(status) : null,
        approvers: (0, $f4e7j.transformAggConnection)(completedApproval.approvers, $3d843a7647f78c65$var$transformApproverToLegacy)
    };
};
const $3d843a7647f78c65$export$b14d30f2a9e4c343 = (node)=>{
    if (node.type !== (0, $lO4Or.SERVICEDESK_APPROVAL_TYPE)) return undefined;
    const activeApproval = node.activeApproval ? {
        activeApproval: $3d843a7647f78c65$var$transformActiveApprovalToLegacy(node.activeApproval)
    } : {};
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: {
            ...activeApproval,
            completedApprovals: (0, $f4e7j.transformAggConnection)(node.completedApprovalsConnection, $3d843a7647f78c65$var$transformCompletedApprovalToLegacy)
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $lO4Or.SERVICEDESK_APPROVAL_TYPE),
            type: (0, $lO4Or.SERVICEDESK_APPROVAL_TYPE)
        }
    };
};

});
parcelRegister("23qRX", function(module, exports) {

$parcel$export(module.exports, "toGroupId", () => $f236b06d6aabb595$export$779c261480444a4d);
$parcel$export(module.exports, "APPROVER_PENDING", () => $f236b06d6aabb595$export$3b59c4db06f5829b);
$parcel$export(module.exports, "APPROVER_APPROVED", () => $f236b06d6aabb595$export$e17ae8ca1010e2a4);
$parcel$export(module.exports, "APPROVER_DECLINED", () => $f236b06d6aabb595$export$b5a0d270c9cd7435);
$parcel$export(module.exports, "APPROVAL_OK", () => $f236b06d6aabb595$export$2e6187b6a4348938);
const $f236b06d6aabb595$export$779c261480444a4d = (x)=>x;
const $f236b06d6aabb595$export$3b59c4db06f5829b = 'pending';
const $f236b06d6aabb595$export$e17ae8ca1010e2a4 = 'approved';
const $f236b06d6aabb595$export$b5a0d270c9cd7435 = 'declined';
const $f236b06d6aabb595$export$2e6187b6a4348938 = 'OK';
const $f236b06d6aabb595$export$b5d660d719b8009 = 'INSUFFICIENT_APPROVERS';

});


parcelRegister("9myMG", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMEntitlementsToLegacyField", () => $d0d645fec4d38846$export$850fadda8a5e6f27);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $d0d645fec4d38846$export$850fadda8a5e6f27 = (node)=>{
    if (node.type !== (0, $lO4Or.ENTITLEMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.selectedEntitlement,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.ENTITLEMENT_CF_TYPE),
            items: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("gM34d", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMMajorIncidentToLegacyField", () => $07db702730ef03b7$export$d4e0b2288fb31144);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $07db702730ef03b7$export$d4e0b2288fb31144 = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.majorIncident,
        renderedValue: null,
        configuration: {},
        schema: {
            configuration: null,
            custom: (0, $lO4Or.MAJOR_INCIDENT_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("16kx8", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMOrganizationToLegacyField", () => $cedd80ccbf21d473$export$7bd14951253a7c5f);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $cedd80ccbf21d473$export$7bd14951253a7c5f = (node)=>{
    if (node.type !== (0, $lO4Or.ORGANIZATIONS_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: (0, $f4e7j.transformAggConnection)(node.selectedOrganizationsConnection, (selectedNode)=>({
                id: selectedNode.organizationId,
                name: selectedNode.organizationName
            })),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.ORGANIZATIONS_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("4IQ8F", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestFeedbackToLegacyField", () => $2d53157bbab9736d$export$c52c6988b335096);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $2d53157bbab9736d$export$c52c6988b335096 = (node)=>{
    if (node.type !== (0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.feedback,
        schema: {
            type: 'sd-feedback',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: (0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("lcInz", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestLanguageToLegacyField", () => $32361ac554652aa8$export$6a53240e225f742);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $32361ac554652aa8$export$6a53240e225f742 = (node)=>{
    if (node.type !== (0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.language,
        allowedValues: [
            ...node.languages ?? []
        ],
        schema: {
            type: 'sd-request-lang',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: (0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("4PFnn", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestTypeToLegacyField", () => $97b247bfb6fb2bf8$export$5ffaab1383177efa);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $97b247bfb6fb2bf8$var$transformRequestTypeToLegacy = (requestType)=>{
    if (!requestType) return null;
    return {
        requestType: {
            id: parseInt(requestType.requestTypeId, 10),
            issueTypeId: requestType.issueType?.issueTypeId || '',
            name: requestType.name || '',
            icon: {
                _links: {
                    iconUrls: {
                        '48x48': requestType.avatar?.large || ''
                    }
                }
            }
        }
    };
};
const $97b247bfb6fb2bf8$export$5ffaab1383177efa = (node)=>{
    if (node.type !== (0, $lO4Or.REQUEST_TYPE_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...' is not assignable to parameter of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...'.
        value: $97b247bfb6fb2bf8$var$transformRequestTypeToLegacy(node.requestType),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.REQUEST_TYPE_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'sd-customerrequesttype'
        }
    };
};

});

parcelRegister("alpM1", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRespondersToLegacyField", () => $e4d9f726b0420c01$export$5171c4d1ae5bcde5);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $e4d9f726b0420c01$var$transformJiraResponderToLegacyResponder = (responder)=>{
    if (responder == null) return undefined;
    switch(responder.__typename){
        case 0, $lO4Or.JSM_USER_RESPONDER_GQL_FIELD:
            if (responder.user === null) return undefined;
            return {
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                ari: responder.user.canonicalAccountId,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                avatarUrl: responder.user.picture,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                name: responder.user.name,
                type: 'user'
            };
        case 0, $lO4Or.JSM_TEAM_RESPONDER_FIELD:
            return {
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                ari: responder.teamId,
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                name: responder.teamName,
                type: 'team'
            };
        default:
            return undefined;
    }
};
const $e4d9f726b0420c01$export$5171c4d1ae5bcde5 = (node)=>{
    if (node.type !== (0, $lO4Or.RESPONDERS_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: (0, $f4e7j.transformAggConnection)(node.respondersConnection, $e4d9f726b0420c01$var$transformJiraResponderToLegacyResponder),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.RESPONDERS_CF_TYPE),
            items: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("l6kyU", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMSentimentToLegacyField", () => $760020295c96925b$export$702d3754a4c7d90a);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $760020295c96925b$export$702d3754a4c7d90a = (node)=>{
    if (node.type !== (0, $lO4Or.SENTIMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.sentiment,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.SENTIMENT_CF_TYPE),
            items: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("gHd8e", function(module, exports) {

$parcel$export(module.exports, "transformAggLabelsNodeToLegacyField", () => $e9d06b1cdd22d77f$export$98e4f56e2e6c44fe);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $e9d06b1cdd22d77f$var$defaultSchema = {
    configuration: null,
    items: 'string',
    type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)
};
const $e9d06b1cdd22d77f$export$98e4f56e2e6c44fe = (node)=>{
    const selectedLabels = (0, $f4e7j.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name);
    switch(node.type){
        case 0, $lO4Or.LABELS_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: selectedLabels,
                schema: {
                    ...$e9d06b1cdd22d77f$var$defaultSchema,
                    custom: null,
                    system: node.type
                }
            };
        case 0, $lO4Or.LABELS_CF_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                // empty value for custom labels field is null while system labels field is `[]`
                value: selectedLabels.length === 0 ? null : selectedLabels,
                schema: {
                    ...$e9d06b1cdd22d77f$var$defaultSchema,
                    custom: node.type,
                    system: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("dUrU1", function(module, exports) {

$parcel$export(module.exports, "transformAggMultiGroupPickerToLegacyField", () => $bf00e02f796ca76f$export$f968da580693597d);


var $f4e7j = parcelRequire("f4e7j");
const $bf00e02f796ca76f$export$f968da580693597d = (node)=>{
    const value = (0, $f4e7j.transformAggConnection)(node.selectedGroupsConnection, (groupNode)=>({
            groupId: groupNode.groupId,
            name: groupNode.name
        }));
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            type: 'array',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: 'group',
            configuration: null
        }
    };
};

});

parcelRegister("hQM7C", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleSelectToLegacyField", () => $b77f8634d7271da6$export$869fb8fbcb97e0ee);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $b77f8634d7271da6$export$869fb8fbcb97e0ee = (node)=>{
    switch(node.type){
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
            {
                const value = (0, $f4e7j.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: [],
                    schema: {
                        type: 'array',
                        renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("QjWSM", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleUserPickerToLegacyField", () => $c7caa94b89e539e2$export$cdd9991119eb040e);

var $7ZZxN = parcelRequire("7ZZxN");


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $ijtj3 = parcelRequire("ijtj3");

var $g5TY0 = parcelRequire("g5TY0");
const $c7caa94b89e539e2$export$cdd9991119eb040e = (node, context)=>{
    const value = (0, $f4e7j.transformAggConnection)(node.selectedUsersConnection, (0, $g5TY0.transformJiraUserToLegacyServerUser));
    const legacyFieldValues = {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            configuration: null,
            custom: node.type,
            items: 'user',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
    switch(node.type){
        case 0, $lO4Or.REQUEST_PARTICIPANTS_CF_TYPE:
            {
                const project = (0, $ijtj3.getSystemAggJiraProject)(context);
                if ((0, $ijtj3.getProjectType)(project.projectType) !== (0, $7ZZxN.SERVICE_DESK_PROJECT)) return undefined;
                // Empty array is the expected value when there are no request
                // participants.
                return {
                    ...legacyFieldValues,
                    value: value
                };
            }
        case 0, $lO4Or.PARTICIPANTS_CF_TYPE:
        case 0, $lO4Or.MULTI_USER_CF_TYPE:
            return legacyFieldValues;
        case 0, $lO4Or.APPROVERS_LIST_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            {
                const schemaConfig = 'isMulti' in node && node.isMulti != null ? [
                    {
                        key: 'isMulti',
                        value: String(node.isMulti)
                    }
                ] : null;
                return {
                    ...legacyFieldValues,
                    autoCompleteUrl: node.searchUrl,
                    schema: {
                        ...legacyFieldValues.schema,
                        configuration: schemaConfig
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("4CGp4", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleVersionPickerToLegacyField", () => $3d2f68ea759270b4$export$6207ea60703068d8);

var $1ybV0 = parcelRequire("1ybV0");


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $hd35n = parcelRequire("hd35n");
const $3d2f68ea759270b4$var$defaultSchema = {
    configuration: null,
    custom: null,
    items: 'version',
    renderer: (0, $c7e7b1d3600a0c0f$export$840ed33fa94f7693),
    system: null,
    type: 'array'
};
const $3d2f68ea759270b4$export$6207ea60703068d8 = (node)=>{
    if (node.type !== (0, $lO4Or.MULTI_VERSION_CF_TYPE) && node.type !== (0, $lO4Or.AFFECTS_VERSIONS_TYPE) && node.type !== (0, $lO4Or.FIX_VERSIONS_TYPE)) return undefined;
    const legacyFieldValues = {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        allowedValues: (0, $f4e7j.transformAggConnection)(node.multiPickerVersions, (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $hd35n.transformAggVersionToLegacyVersion) : (0, $hd35n.transformAggVersionToLegacyVersionOld)),
        value: (0, $f4e7j.transformAggConnection)(node.selectedVersionsConnection, (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $hd35n.transformAggVersionToLegacyVersion) : (0, $hd35n.transformAggVersionToLegacyVersionOld))
    };
    switch(node.type){
        case 0, $lO4Or.MULTI_VERSION_CF_TYPE:
            return {
                ...legacyFieldValues,
                value: legacyFieldValues.value.length === 0 ? null : legacyFieldValues.value,
                schema: {
                    ...$3d2f68ea759270b4$var$defaultSchema,
                    custom: (0, $lO4Or.MULTI_VERSION_CF_TYPE)
                }
            };
        case 0, $lO4Or.AFFECTS_VERSIONS_TYPE:
        case 0, $lO4Or.FIX_VERSIONS_TYPE:
            return {
                ...legacyFieldValues,
                allowedValues: legacyFieldValues.allowedValues.filter((v)=>!v.archived),
                schema: {
                    ...$3d2f68ea759270b4$var$defaultSchema,
                    system: node.type
                }
            };
        default:
            return undefined;
    }
};

});
parcelRegister("hd35n", function(module, exports) {

$parcel$export(module.exports, "transformAggVersionToLegacyVersionOld", () => $41957f3e8e88f6a1$export$5427f5949bb0492d);
$parcel$export(module.exports, "transformAggVersionToLegacyVersion", () => $41957f3e8e88f6a1$export$becef8d087e8b62b);

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");

var $exWH1 = parcelRequire("exWH1");
const $41957f3e8e88f6a1$export$5427f5949bb0492d = (version)=>({
        id: version.versionId ?? '',
        name: version.name ?? '',
        description: version.description ?? '',
        archived: version.status === (0, $exWH1.VersionStatus).ARCHIVED,
        released: version.status === (0, $exWH1.VersionStatus).RELEASED
    });
const $41957f3e8e88f6a1$export$becef8d087e8b62b = (version)=>({
        id: version.versionId ?? '',
        name: version.name ?? '',
        description: version.description ?? '',
        archived: version.status === (0, $exWH1.VersionStatus).ARCHIVED,
        released: version.status === (0, $exWH1.VersionStatus).RELEASED,
        ari: version.id
    });
const $41957f3e8e88f6a1$export$5753f8f86af3608d = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration'), $41957f3e8e88f6a1$export$becef8d087e8b62b, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
$41957f3e8e88f6a1$export$5427f5949bb0492d);

});
parcelRegister("exWH1", function(module, exports) {

$parcel$export(module.exports, "VersionStatus", () => $4c4bb928a168d525$export$8c6e0f93bfb5c6a4);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports




var $edkGa = parcelRequire("edkGa");


const $4c4bb928a168d525$export$8c6e0f93bfb5c6a4 = {
    ARCHIVED: 'ARCHIVED',
    RELEASED: 'RELEASED',
    UNRELEASED: 'UNRELEASED'
};

});



parcelRegister("lWE99", function(module, exports) {

$parcel$export(module.exports, "transformAggNumberToLegacyField", () => $1ea236981671650b$export$d754a24ed0096d2f);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $1ea236981671650b$export$d754a24ed0096d2f = (node)=>{
    const fieldType = node.isStoryPointField === true ? (0, $lO4Or.STORY_POINTS_TYPE) : node.type;
    switch(fieldType){
        case 0, $lO4Or.NUMBER_CF_TYPE:
        case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $lO4Or.STORY_POINTS_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: node.number ?? null,
                schema: {
                    configuration: null,
                    items: null,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    custom: fieldType,
                    system: null,
                    type: (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("4eNqf", function(module, exports) {

$parcel$export(module.exports, "transformAggOriginalEstimateToLegacyField", () => $50d87f174d910a4b$export$f08d02fdc74f920e);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $50d87f174d910a4b$export$f08d02fdc74f920e = (node)=>{
    if (node.type !== (0, $lO4Or.TIME_ESTIMATE_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.originalEstimate?.timeInSeconds ?? null,
        schema: {
            configuration: null,
            custom: null,
            system: node.type,
            items: null,
            type: (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE),
            renderer: null
        }
    };
};

});

parcelRegister("fkHM1", function(module, exports) {

$parcel$export(module.exports, "transformAggPriorityToLegacyField", () => $ccf6d66eff5dbc1f$export$9e966ce605f800d2);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $ccf6d66eff5dbc1f$var$transformJiraPriorityToLegacyPriority = (priority)=>{
    if (priority == null) return null;
    return {
        id: priority.priorityId,
        iconUrl: String(priority.iconUrl || ''),
        name: priority.name || '',
        sequence: priority.sequence || undefined
    };
};
const $ccf6d66eff5dbc1f$export$9e966ce605f800d2 = (node)=>{
    if (node.type !== (0, $lO4Or.PRIORITY_TYPE)) return undefined;
    const allowedValues = (0, $f4e7j.transformAggConnection)('priorities' in node ? node.priorities : null, $ccf6d66eff5dbc1f$var$transformJiraPriorityToLegacyPriority);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        // @ts-expect-error - Argument of type '{ readonly color: string | null | undefined; readonly iconUrl: string | null | undefined; readonly name: string | null | undefined; readonly priorityId: string; } | { readonly iconUrl: string | ... 1 more ... | undefined; readonly name: string | ... 1 more ... | undefined; readonly priorityId: string; } | { ...; } |...' is not assignable to parameter of type 'AggJiraPriority | null'.
        value: $ccf6d66eff5dbc1f$var$transformJiraPriorityToLegacyPriority(node.priority),
        schema: {
            type: (0, $lO4Or.PRIORITY_TYPE),
            custom: null,
            system: (0, $lO4Or.PRIORITY_TYPE),
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)
        }
    };
};

});

parcelRegister("fkaQR", function(module, exports) {

$parcel$export(module.exports, "transformAggProformaFormsToLegacyField", () => $b1792cecaa8dedc0$export$fdcdbf17b0d4e36f);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $b1792cecaa8dedc0$export$fdcdbf17b0d4e36f = (node)=>{
    if (node.type !== (0, $lO4Or.PROFORMA_FORMS)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.proformaForms,
        schema: {
            configuration: null,
            items: null,
            system: (0, $lO4Or.PROFORMA_FORMS),
            custom: null,
            renderer: null,
            type: (0, $lO4Or.PROFORMA_FORMS)
        }
    };
};

});

parcelRegister("gyvos", function(module, exports) {

$parcel$export(module.exports, "transformAggRadioSelectToLegacyField", () => $f7afb2486834699b$export$f147f1eb3a15ccfc);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $f7afb2486834699b$export$f147f1eb3a15ccfc = (node)=>{
    if (node.type !== (0, $lO4Or.RADIO_BUTTONS_CF_TYPE)) return undefined;
    const value = node.selectedOption ? {
        id: node.selectedOption?.optionId,
        value: node.selectedOption?.value,
        isDisabled: node.selectedOption?.isDisabled
    } : null;
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.radioSelectFieldOptions, (option)=>({
            id: option.optionId,
            value: option.value ?? null,
            ari: option.id
        }));
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: 'option',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("3w75b", function(module, exports) {

$parcel$export(module.exports, "transformAggResolutionToLegacyField", () => $5302369645b034cd$export$179f600c7e1d0230);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $5302369645b034cd$var$resolutionTransformer = (resolution)=>{
    if (resolution == null) return null;
    return {
        id: resolution.resolutionId,
        name: resolution.name || ''
    };
};
const $5302369645b034cd$export$179f600c7e1d0230 = (node)=>{
    if (node.type !== (0, $lO4Or.RESOLUTION_TYPE)) return undefined;
    const value = $5302369645b034cd$var$resolutionTransformer(node.resolution);
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.resolutions, $5302369645b034cd$var$resolutionTransformer);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: (0, $lO4Or.RESOLUTION_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $lO4Or.RESOLUTION_TYPE),
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("lQr58", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextToLegacyField", () => $63df895e1ecc6044$export$e65ff2ce94be106e);

var $esUXI = parcelRequire("esUXI");


var $lO4Or = parcelRequire("lO4Or");

var $7Vbpp = parcelRequire("7Vbpp");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $63df895e1ecc6044$var$emptyAdfObject = (0, $esUXI.getEmptyADF)();
const $63df895e1ecc6044$var$getSchema = (aggType, renderer)=>{
    switch(aggType){
        case 0, $lO4Or.TEXT_AREA_CF_TYPE:
            return {
                custom: aggType,
                renderer: renderer,
                type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                configuration: null,
                items: null
            };
        case 0, $lO4Or.DESCRIPTION_TYPE:
        case 0, $lO4Or.ENVIRONMENT_TYPE:
        default:
            return {
                system: aggType,
                renderer: renderer,
                type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
                custom: null,
                configuration: null,
                items: null
            };
    }
};
// Exactly match the legacy /graphql value, handling the case where the field is empty and has never been edited
// There's no functional difference between `null` or empty string when rendering the field in the issue view.
const $63df895e1ecc6044$var$getPlainTextValue = (node)=>{
    // When the field is empty and a value has never been set
    if (!node.richText) return null;
    // When the field has been set to a value, and then set back to empty
    if (node.richText?.plainText == null) return '';
    return node.richText?.plainText;
};
const $63df895e1ecc6044$export$e65ff2ce94be106e = (node)=>{
    // Description field always renders with ADF
    const { renderer: renderer } = node;
    if ((0, $2qVcp.default)(node)) return undefined;
    const isPlainTextRenderer = node.type !== (0, $lO4Or.DESCRIPTION_TYPE) && renderer === (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f);
    if (isPlainTextRenderer) return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $63df895e1ecc6044$var$getPlainTextValue(node),
        schema: $63df895e1ecc6044$var$getSchema(node.type, renderer)
    };
    const adfValueJson = node.richText?.adfValue?.json ?? null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        // The usages of the collection is deprecated.
        adfValue: adfValueJson ? (0, $7Vbpp.removeCollectionFromAdf)(adfValueJson) : $63df895e1ecc6044$var$emptyAdfObject,
        value: null,
        schema: $63df895e1ecc6044$var$getSchema(node.type, renderer)
    };
};

});
parcelRegister("7Vbpp", function(module, exports) {

$parcel$export(module.exports, "emptyAdfObject", () => $e11eab7652408d68$export$202742e99f678c60);
$parcel$export(module.exports, "removeCollectionFromAdf", () => $e11eab7652408d68$export$9e9311e676291037);
$parcel$export(module.exports, "convertAdfStringToObject", () => $e11eab7652408d68$export$ee70d4eb14697455);
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $e11eab7652408d68$export$cf4bde415465976c);
$parcel$export(module.exports, "removeNewLineCharactersFromAdf", () => $e11eab7652408d68$export$d6ce0667c33b94ff);
$parcel$export(module.exports, "removeTrailingNewLineCharacters", () => $e11eab7652408d68$export$3688e35a300432d6);
$parcel$export(module.exports, "simplifyAdf", () => $e11eab7652408d68$export$def86d25f0c7f0bc);
$parcel$export(module.exports, "hasMediaFileNodes", () => $e11eab7652408d68$export$9a632b58fb9b287c);
$parcel$export(module.exports, "hasMediaFileNodesUpdated", () => $e11eab7652408d68$export$80a6e90c7b29d88c);

var $6qhKX = parcelRequire("6qhKX");
var $hYZXM = parcelRequire("hYZXM");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");
const $e11eab7652408d68$export$202742e99f678c60 = {
    type: 'doc',
    version: 1,
    content: []
};
const $e11eab7652408d68$export$9e9311e676291037 = (adf)=>{
    if (adf === null || adf === undefined) return null;
    if (adf.type === 'media' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if ((0, $1ybV0.ff)('issue.details.media-inline') && adf.type === 'mediaInline' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.content) return {
        ...adf,
        content: adf.content.map($e11eab7652408d68$export$9e9311e676291037)
    };
    return adf;
};
const $e11eab7652408d68$export$ee70d4eb14697455 = (adf)=>{
    if (typeof adf === 'string') try {
        return $e11eab7652408d68$export$9e9311e676291037(JSON.parse(adf));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
        return null;
    }
    return $e11eab7652408d68$export$9e9311e676291037(adf);
};
const $e11eab7652408d68$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
        if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
        return false;
    }) : false;
const $e11eab7652408d68$export$d6ce0667c33b94ff = (adf)=>{
    if (!adf || !adf.content) return $e11eab7652408d68$export$202742e99f678c60;
    let len;
    for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
        // if the last item of the node is of type mediaGroup, we don't want to strip newline character as
        // it practically makes it unclickable. Leave a new line character so there is still some space for ppl to click
        if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
    }
    return {
        ...adf,
        content: adf.content.slice(0, len + 1)
    };
};
const $e11eab7652408d68$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
const $e11eab7652408d68$export$def86d25f0c7f0bc = (adf)=>$e11eab7652408d68$export$cf4bde415465976c(adf) ? $e11eab7652408d68$export$202742e99f678c60 : adf;
const $e11eab7652408d68$export$9a632b58fb9b287c = (doc)=>{
    if ((0, $1ybV0.ff)('issue.details.media-inline')) {
        const mediaNodes = new Map();
        (0, $hYZXM.traverse)(doc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                mediaNodes.set(mediaNode.attrs.id, node);
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                mediaNodes.set(mediaInlineNode.attrs.id, node);
            }
        });
        return mediaNodes.size > 0;
    }
    const mediaNodes = new Map();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $hYZXM.traverse)(doc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            mediaNodes.set(node.attrs.id, node);
        }
    });
    return mediaNodes.size > 0;
};
const $e11eab7652408d68$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
    if ((0, $1ybV0.ff)('issue.details.media-inline')) {
        const currentMediaNodes = new Set();
        const newMediaNodes = new Set();
        const updatedMediaNodes = new Set();
        if (newDoc) (0, $hYZXM.traverse)(newDoc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                newMediaNodes.add(mediaNode.attrs.id);
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                newMediaNodes.add(mediaInlineNode.attrs.id);
            }
        });
        if (currentDoc) (0, $hYZXM.traverse)(currentDoc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                currentMediaNodes.add(mediaNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
                }
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                currentMediaNodes.add(mediaInlineNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
                }
            }
        });
        return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
    }
    const currentMediaNodes = new Set();
    const newMediaNodes = new Set();
    const updatedMediaNodes = new Set();
    if (newDoc) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $hYZXM.traverse)(newDoc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            newMediaNodes.add(node.attrs.id);
        }
    });
    if (currentDoc) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $hYZXM.traverse)(currentDoc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            currentMediaNodes.add(node.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(node.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(node.attrs.id);
            }
        }
    });
    return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
};
const $e11eab7652408d68$export$ddf077301434502d = (doc)=>{
    if (doc === null || doc === undefined) return false;
    const nonSimpleTextNodes = (0, $6qhKX.filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
    return nonSimpleTextNodes.length === 0;
};



const $e11eab7652408d68$export$2277e89f0b6d4ed = async (node)=>{
    // the imports here were kept async so as not to blow the bundle sizes for everyone
    const { defaultSchema: defaultSchema } = await (parcelRequire("gAEPB"));
    const { WikiMarkupTransformer: WikiMarkupTransformer } = await (parcelRequire("87zwO"));
    const { JSONTransformer: JSONTransformer } = await (parcelRequire("hhZ0p"));
    const jsonTransformer = new JSONTransformer();
    const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
    if (node === null || node === undefined) return '';
    const pmNode = jsonTransformer.parse(node);
    return wikiMarkupTransformer.encode(pmNode);
};

});
parcelRegister("6qhKX", function(module, exports) {

$parcel$export(module.exports, "filter", () => $d1e7bd2dc2348b7c$export$3dea766d36a8935f);

var $hYZXM = parcelRequire("hYZXM");
function $d1e7bd2dc2348b7c$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $hYZXM.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});
parcelRegister("hYZXM", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $ed8bc6cb8f4f14d7$export$df3f009e3d155b20);
function $ed8bc6cb8f4f14d7$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $ed8bc6cb8f4f14d7$export$df3f009e3d155b20(adf, visitors) {
    if (!$ed8bc6cb8f4f14d7$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $ed8bc6cb8f4f14d7$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $ed8bc6cb8f4f14d7$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $ed8bc6cb8f4f14d7$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});


parcelRegister("gAEPB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("deyW2").then(()=>parcelRequire('9wcjJ'));

});

parcelRegister("87zwO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("apXnN").then(()=>parcelRequire('fjUC0'));

});

parcelRegister("hhZ0p", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kYJkV").then(()=>parcelRequire('3M3qX'));

});



parcelRegister("8oO4q", function(module, exports) {

$parcel$export(module.exports, "transformAggSecurityLevelToLegacyField", () => $28a96bf619a924f9$export$45e25e2a6750ea5a);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $28a96bf619a924f9$var$transformJiraSecurityLevel = (securityLevel)=>{
    if (securityLevel == null) return null;
    return {
        id: securityLevel.securityId,
        description: securityLevel.description || '',
        name: securityLevel.name || ''
    };
};
const $28a96bf619a924f9$export$45e25e2a6750ea5a = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $28a96bf619a924f9$var$transformJiraSecurityLevel(node.securityLevel),
        allowedValues: (0, $f4e7j.transformAggConnection)(node.securityLevels, $28a96bf619a924f9$var$transformJiraSecurityLevel),
        schema: {
            configuration: null,
            type: (0, $lO4Or.SECURITY_LEVEL_TYPE_OVERRIDE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $lO4Or.SECURITY_LEVEL_TYPE),
            items: null
        }
    });

});

parcelRegister("5Ne6t", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleGroupPickerToLegacyField", () => $1b8c5a144aba3441$export$e6697ec5bdac9ec0);


var $f4e7j = parcelRequire("f4e7j");
const $1b8c5a144aba3441$export$e6697ec5bdac9ec0 = (node)=>{
    const value = node.selectedGroup != null ? {
        groupId: node.selectedGroup.groupId,
        name: node.selectedGroup.name
    } : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'group',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2ETkN", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleLineTextToLegacyField", () => $84dcb0c130bea779$export$31f32b3fd9e5ab6);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $84dcb0c130bea779$var$defaultSchema = {
    configuration: null,
    items: null,
    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)
};
const $84dcb0c130bea779$export$31f32b3fd9e5ab6 = (node)=>{
    const defaultTransformedField = {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.text
    };
    switch(node.type){
        case 0, $lO4Or.EPIC_NAME_TYPE:
        case 0, $lO4Or.MESSAGE_EDIT_CF_TYPE:
        case 0, $lO4Or.MESSAGE_VIEW_CF_TYPE:
        case 0, $lO4Or.READ_ONLY_CF_TYPE:
        case 0, $lO4Or.TEXT_CF_TYPE:
        case 0, $lO4Or.USER_PROPERTY_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$84dcb0c130bea779$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
                }
            };
        case 0, $lO4Or.RANK_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$84dcb0c130bea779$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $lO4Or.ISSUE_FIELD_ANY_CF_TYPE)
                }
            };
        case 0, $lO4Or.SUMMARY_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$84dcb0c130bea779$var$defaultSchema,
                    type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
                    custom: null,
                    system: node.type
                }
            };
        case 0, $lO4Or.SERVICEDESK_PRACTICES_TYPE:
            // Transform field only if the practice has a value
            return node.text != null ? {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: [
                    node.text
                ],
                schema: {
                    ...$84dcb0c130bea779$var$defaultSchema,
                    renderer: null,
                    custom: null,
                    system: node.type,
                    type: (0, $lO4Or.SERVICEDESK_PRACTICES_TYPE)
                }
            } : undefined;
        default:
            return undefined;
    }
};

});

parcelRegister("fz8Wc", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectToLegacyField", () => $6eb6c9de60f230bb$export$4e113f935e09d226);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $6eb6c9de60f230bb$var$getField = (node, customType)=>{
    const value = node.fieldOption != null ? {
        ari: node.fieldOption.id,
        id: node.fieldOption.optionId,
        value: node.fieldOption.value
    } : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'option',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: customType || node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};
const $6eb6c9de60f230bb$export$4e113f935e09d226 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.EPIC_STATUS_TYPE:
        case 0, $lO4Or.SELECT_CF_TYPE:
            return $6eb6c9de60f230bb$var$getField(node);
        case 0, $lO4Or.CATEGORY_TYPE:
            return $6eb6c9de60f230bb$var$getField(node, (0, $lO4Or.SELECT_CF_TYPE));
        default:
            return undefined;
    }
};

});

parcelRegister("jBiXV", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectUserPickerToLegacyField", () => $13d89b5e83359a47$export$7bf73fc06c6d71be);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $g5TY0 = parcelRequire("g5TY0");
const $13d89b5e83359a47$export$7bf73fc06c6d71be = (node)=>{
    const legacyField = {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $g5TY0.transformJiraUserToLegacyServerUser)(node.user) : null
    };
    switch(node.type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE),
                    custom: null,
                    system: node.type,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.LAST_UPDATER_OR_COMMENTER_CF_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE),
                    custom: node.type,
                    system: null,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("1XUHd", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleVersionPickerToLegacyField", () => $c650b563dc539b29$export$d03f622577260442);

var $1ybV0 = parcelRequire("1ybV0");


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $hd35n = parcelRequire("hd35n");
const $c650b563dc539b29$export$d03f622577260442 = (node)=>{
    if (node.type !== (0, $lO4Or.VERSION_CF_TYPE)) return undefined;
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.singlePickerVersions, (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $hd35n.transformAggVersionToLegacyVersion) : (0, $hd35n.transformAggVersionToLegacyVersionOld));
    const transformVersion = (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $hd35n.transformAggVersionToLegacyVersion) : (0, $hd35n.transformAggVersionToLegacyVersionOld);
    const value = node.version ? transformVersion(node.version) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            type: (0, $lO4Or.ISSUE_FIELD_VERSION_CF_TYPE),
            custom: (0, $lO4Or.VERSION_CF_TYPE),
            system: null
        }
    };
};

});

parcelRegister("c6LKM", function(module, exports) {

$parcel$export(module.exports, "transformAggSprintToLegacyField", () => $c11b803b5a137e84$export$9b5bb05d50970021);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $c11b803b5a137e84$var$SprintOptionalKeyMap = {
    goal: 'goal',
    completeDate: 'completionDate',
    startDate: 'startDate',
    endDate: 'endDate'
};
const $c11b803b5a137e84$var$transformAggSprintToLegacySprint = (sprint)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const optionalValues = {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys($c11b803b5a137e84$var$SprintOptionalKeyMap).forEach((key)=>{
        const aggKey = $c11b803b5a137e84$var$SprintOptionalKeyMap[key];
        const aggValue = sprint[aggKey];
        if (aggValue !== undefined && aggValue !== null) optionalValues[key] = aggValue;
    });
    return {
        id: Number(sprint.sprintId),
        name: sprint.name,
        state: sprint.state?.toLowerCase(),
        boardId: Number(sprint.boardName) || 0,
        ...optionalValues
    };
};
const $c11b803b5a137e84$export$9b5bb05d50970021 = (node)=>{
    if (node.type !== (0, $lO4Or.SPRINT_TYPE)) return undefined;
    const sprints = (0, $f4e7j.transformAggConnection)(node.selectedSprintsConnection, $c11b803b5a137e84$var$transformAggSprintToLegacySprint);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: sprints,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.SPRINT_TYPE),
            items: 'json',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("8zTcQ", function(module, exports) {

$parcel$export(module.exports, "getStatusesDeprecatedValue", () => $23ba42f503d38228$export$b80ec59d806c2f94);
$parcel$export(module.exports, "transformAggStatusToLegacyField", () => $23ba42f503d38228$export$c80e5acb1c882c48);

var $8Qd0L = parcelRequire("8Qd0L");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $23ba42f503d38228$export$b80ec59d806c2f94 = (fields)=>{
    const { status: status } = fields;
    if (!status || status.value == null) return {};
    const { value: value } = status;
    return {
        [value.id]: {
            id: value.id,
            name: value.name,
            statusCategory: (0, $8Qd0L.statusCategoryForId)(value.statusCategory?.id)
        }
    };
};
const $23ba42f503d38228$var$transformJiraStatusToLegacyStatus = (status)=>{
    if (status == null) return null;
    const { statusCategory: statusCategory } = status;
    return {
        id: status.statusId,
        name: status.name || '',
        statusCategory: {
            id: Number(statusCategory.statusCategoryId)
        }
    };
};
const $23ba42f503d38228$export$c80e5acb1c882c48 = (node)=>{
    if (node.type !== (0, $lO4Or.STATUS_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $23ba42f503d38228$var$transformJiraStatusToLegacyStatus(node.status),
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $lO4Or.STATUS_TYPE),
            custom: null,
            system: (0, $lO4Or.STATUS_TYPE)
        }
    };
};

});

parcelRegister("5W75j", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamToLegacyField", () => $97428b249585cac2$export$fb1b80497e96456f);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $97428b249585cac2$export$fb1b80497e96456f = (node)=>{
    if (node.type !== (0, $lO4Or.TEAM_CF_TYPE)) return undefined;
    const value = node.selectedTeam ? {
        id: node.selectedTeam.teamId,
        title: node.selectedTeam.name,
        isShared: node.selectedTeam.isShared,
        avatarUrl: node.selectedTeam.avatar?.medium
    } : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.TEAM_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: (0, $lO4Or.ISSUE_FIELD_ANY_CF_TYPE)
        }
    };
};

});

parcelRegister("7iFVU", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamViewToLegacyField", () => $bb4542beb2315e32$export$6f6aaafb49bd4769);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $bb4542beb2315e32$var$transformAggTeamViewToLegacyTeam = (team)=>{
    if (team == null) return null;
    return {
        id: team.jiraSuppliedTeamId,
        name: team.jiraSuppliedName || '',
        isVisible: team.jiraSuppliedVisibility || false,
        avatarUrl: team.jiraSuppliedAvatar?.xsmall || ''
    };
};
const $bb4542beb2315e32$export$6f6aaafb49bd4769 = (node)=>{
    if (node.type !== (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...' is not assignable to parameter of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...'.
        value: $bb4542beb2315e32$var$transformAggTeamViewToLegacyTeam(node.selectedTeam),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'team'
        }
    };
};

});

parcelRegister("kyZt3", function(module, exports) {

$parcel$export(module.exports, "transformAggTimeTrackingToLegacyField", () => $3404d836fe97323f$export$874d9bd14269ec6f);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $3404d836fe97323f$var$getEstimateValues = (estimate, key)=>{
    if (estimate) return {
        [key]: estimate.timeInSeconds || 0
    };
    return {};
};
const $3404d836fe97323f$export$874d9bd14269ec6f = (node)=>{
    if (node.type !== (0, $lO4Or.TIME_TRACKING_TYPE)) return undefined;
    const originalEstimate = $3404d836fe97323f$var$getEstimateValues(node.originalEstimate || null, 'originalEstimateSeconds');
    const remainingEstimate = $3404d836fe97323f$var$getEstimateValues(node.remainingEstimate || null, 'remainingEstimateSeconds');
    const timeSpent = $3404d836fe97323f$var$getEstimateValues(node.timeSpent || null, 'timeSpentSeconds');
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: {
            ...originalEstimate,
            ...remainingEstimate,
            ...timeSpent
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: (0, $lO4Or.TIME_TRACKING_TYPE),
            type: (0, $lO4Or.TIME_TRACKING_TYPE)
        }
    };
};

});

parcelRegister("dX2ot", function(module, exports) {

$parcel$export(module.exports, "transformAggUrlToLegacyField", () => $65722746bbedc61a$export$6e950e0ec9801f6c);


var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $65722746bbedc61a$export$6e950e0ec9801f6c = (node)=>{
    if (node.type !== (0, $lO4Or.URL_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.uri ?? null,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.URL_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("jhiYN", function(module, exports) {

$parcel$export(module.exports, "transformAggVotesToLegacyField", () => $471f4de3dfdc045c$export$8966614b8594736);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $471f4de3dfdc045c$var$transformAggVoteToLegacyVote = (vote)=>({
        votes: vote.count != null ? Number(vote.count) : 0,
        hasVoted: vote.hasVoted ?? false
    });
const $471f4de3dfdc045c$export$8966614b8594736 = (node)=>{
    if (node.type !== (0, $lO4Or.VOTES_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.vote ? $471f4de3dfdc045c$var$transformAggVoteToLegacyVote(node.vote) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $lO4Or.VOTES_TYPE),
            type: (0, $lO4Or.VOTES_TYPE)
        }
    };
};

});

parcelRegister("1BsAz", function(module, exports) {

$parcel$export(module.exports, "transformAggWatchesToLegacyField", () => $47cca6eb8a2344d9$export$6730cb17d10d6156);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $47cca6eb8a2344d9$var$transformAggWatchesToLegacyWatches = (watch)=>({
        watchCount: watch.count != null ? Number(watch.count) : 0,
        isWatching: watch.isWatching ?? false
    });
const $47cca6eb8a2344d9$export$6730cb17d10d6156 = (node)=>{
    if (node.type !== (0, $lO4Or.WATCHES_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.watch ? $47cca6eb8a2344d9$var$transformAggWatchesToLegacyWatches(node.watch) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $lO4Or.WATCHES_TYPE),
            type: (0, $lO4Or.WATCHES_TYPE)
        }
    };
};

});


parcelRegister("9r5wz", function(module, exports) {

$parcel$export(module.exports, "transformAggParentFieldValueToLegacyFieldValue", () => $8fcd0c4405f180f5$export$d8a5feb2bb0425b4);
const $8fcd0c4405f180f5$export$d8a5feb2bb0425b4 = (parentIssue)=>{
    if (!parentIssue) return null;
    return {
        id: parentIssue.issueId,
        ari: parentIssue.id,
        key: parentIssue.key,
        self: parentIssue.webUrl,
        color: parentIssue.issueColorField?.color?.colorKey,
        fields: {
            summary: parentIssue.summaryField?.text,
            issuetype: {
                name: parentIssue.issueTypeField?.issueType?.name,
                iconUrl: parentIssue.issueTypeField?.issueType?.avatar?.xsmall,
                // We do not have this data
                id: '',
                self: '',
                description: '',
                subtask: false,
                avatarId: 0,
                hierarchyLevel: 0
            }
        }
    };
};

});


parcelRegister("k3tie", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $8f27d9da737621d3$export$8db21fc94823e1cc);
// Copied over from `src/packages/issue/issue-view/src/model/change-type.js`
const $8f27d9da737621d3$export$8b9b8ed7fbac313c = 'FIELD_CHANGE_REQUESTED';
const $8f27d9da737621d3$export$f567ac9d3526e5ce = 'FIELD_CHANGED';
const $8f27d9da737621d3$export$7c15aaba9a26f469 = 'FIELD_CHANGE_FAILED';
const $8f27d9da737621d3$export$8db21fc94823e1cc = {
    [$8f27d9da737621d3$export$8b9b8ed7fbac313c]: $8f27d9da737621d3$export$8b9b8ed7fbac313c,
    [$8f27d9da737621d3$export$7c15aaba9a26f469]: $8f27d9da737621d3$export$7c15aaba9a26f469,
    [$8f27d9da737621d3$export$f567ac9d3526e5ce]: $8f27d9da737621d3$export$f567ac9d3526e5ce
};

});


parcelRegister("3koWU", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $c314bd343c8e5174$export$80c2a3957bcb42ea);

var $eUqFw = parcelRequire("eUqFw");
const $c314bd343c8e5174$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});

parcelRegister("fecbI", function(module, exports) {

$parcel$export(module.exports, "defaultSaveField", () => $4eca3d717c3df3ee$export$b74e6b7f831f1cb2);
$parcel$export(module.exports, "defaultSaveFieldById", () => $4eca3d717c3df3ee$export$b2c49aae5d84cced);
$parcel$export(module.exports, "defaultAddValuesToField", () => $4eca3d717c3df3ee$export$c46c7284cd9c5d3);
$parcel$export(module.exports, "defaultRemoveValuesFromField", () => $4eca3d717c3df3ee$export$33b78476f5d734b3);

var $lRmyA = parcelRequire("lRmyA");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4eca3d717c3df3ee$var$getFieldUpdate = (fieldKey, value)=>({
        fields: {
            [fieldKey]: value
        }
    });
const $4eca3d717c3df3ee$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, $lRmyA.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($4eca3d717c3df3ee$var$getFieldUpdate(fieldKey, newValue))
    });
const $4eca3d717c3df3ee$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, $lRmyA.performPutRequest)(`/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
        body: JSON.stringify($4eca3d717c3df3ee$var$getFieldUpdate(fieldKey, newValue))
    });
const $4eca3d717c3df3ee$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, _baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'add',
                    value: valuesToAdd
                }
            ]
        }
    };
    return (0, $lRmyA.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};
const $4eca3d717c3df3ee$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, _baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'remove',
                    value: valuesToRemove
                }
            ]
        }
    };
    return (0, $lRmyA.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};

});


parcelRegister("36pXK", function(module, exports) {

$parcel$export(module.exports, "useMajorIncidentConfig", () => $928b6c6acf57b198$export$4fa770b3011492c);

var $eUqFw = parcelRequire("eUqFw");

var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $928b6c6acf57b198$export$4fa770b3011492c = (issueKey)=>{
    const [{ value: fieldConfig }] = (0, $8411R.useIssueFieldConfig)(issueKey);
    const [majorIncidentFieldIdKey, searchUrl, fieldType] = (0, $eUqFw.useMemo)(()=>{
        if (fieldConfig != null) {
            const fieldId = Object.keys(fieldConfig).find((fieldKey)=>fieldConfig[fieldKey].schema.custom === (0, $lO4Or.MAJOR_INCIDENT_CF_TYPE));
            if (fieldId != null) {
                const majorIncidentConfig = fieldConfig[fieldId];
                const { autoCompleteUrl: autoCompleteUrl, schema: { type: type } } = majorIncidentConfig;
                return [
                    fieldId,
                    autoCompleteUrl || '',
                    type
                ];
            }
        }
        return [
            '',
            '',
            'string'
        ];
    }, [
        fieldConfig
    ]);
    return {
        majorIncidentFieldIdKey: majorIncidentFieldIdKey,
        searchUrl: searchUrl,
        fieldType: fieldType
    };
};

});
parcelRegister("8411R", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfig", () => $7e02dfdf3441382d$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $7e02dfdf3441382d$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $7e02dfdf3441382d$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $7e02dfdf3441382d$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $7e02dfdf3441382d$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $7e02dfdf3441382d$export$28a22fd0dedf31b7);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $8LJqN = parcelRequire("8LJqN");

var $eI5EY = parcelRequire("eI5EY");

var $7byHA = parcelRequire("7byHA");

var $lRmyA = parcelRequire("lRmyA");

var $dwyR8 = parcelRequire("dwyR8");

var $kPvBW = parcelRequire("kPvBW");

var $4ceCM = parcelRequire("4ceCM");

var $3koWU = parcelRequire("3koWU");

var $6rkLV = parcelRequire("6rkLV");
const $7e02dfdf3441382d$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $7e02dfdf3441382d$var$fetchDataOld = async (issueKey)=>{
    const response = await (0, $lRmyA.performPostRequest)((0, $dwyR8.getGraphQlUrl)('', (0, $kPvBW.IssueViewFetchOperations).FIELD_CONFIGURATION), {
        body: JSON.stringify({
            query: $7e02dfdf3441382d$export$9715ac6597e498fd(),
            variables: {
                issueKey: issueKey
            }
        })
    });
    if (response && response.data && response.data.issue && response.data.issue.fields) return response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
    (result, field)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [field.key]: {
                autoCompleteUrl: field.autoCompleteUrl,
                allowedValues: field.allowedValues,
                isEditable: field.editable,
                isRequired: field.required,
                schema: field.schema,
                title: field.title,
                ...field.description ? {
                    description: field.description
                } : {}
            }
        }), {});
    return null;
};
const $7e02dfdf3441382d$var$fieldConfigurationQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: (0, $kPvBW.IssueViewFetchOperations).FIELD_CONFIGURATION,
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: 'Issue View Field Configuration Query',
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $7e02dfdf3441382d$var$fieldConfigurationQueryExperienceTracking = ({ wasExperienceSuccessful: wasExperienceSuccessful, error: error })=>{
    (0, $4ceCM.sendExperienceAnalytics)($7e02dfdf3441382d$var$fieldConfigurationQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error?.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $7byHA.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {}
    }));
};
const $7e02dfdf3441382d$var$fetchDataWithExperienceTracking = async (issueKey)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)((0, $dwyR8.getGraphQlUrl)('', (0, $kPvBW.IssueViewFetchOperations).FIELD_CONFIGURATION), {
            body: JSON.stringify({
                query: $7e02dfdf3441382d$export$9715ac6597e498fd(),
                variables: {
                    issueKey: issueKey
                }
            })
        });
        if (response?.data?.issue?.fields) {
            const fieldConfigData = response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
            (result, field)=>({
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...result,
                    [field.key]: {
                        autoCompleteUrl: field.autoCompleteUrl,
                        allowedValues: field.allowedValues,
                        isEditable: field.editable,
                        isRequired: field.required,
                        schema: field.schema,
                        title: field.title,
                        ...field.description ? {
                            description: field.description
                        } : {}
                    }
                }), {});
            $7e02dfdf3441382d$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: true
            });
            return fieldConfigData;
        }
        $7e02dfdf3441382d$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: new Error('Unexpected field configuration response')
        });
        return null;
    } catch (error) {
        $7e02dfdf3441382d$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: error instanceof (0, $7byHA.default) ? error : undefined
        });
        return null;
    }
};
const $7e02dfdf3441382d$var$fetchData = (0, $8LJqN.functionWithCondition)(()=>(0, $eI5EY.fg)('jiv-18890-field-configuration-query-exp-tracking'), $7e02dfdf3441382d$var$fetchDataWithExperienceTracking, $7e02dfdf3441382d$var$fetchDataOld);
const $7e02dfdf3441382d$var$requestSet = new Set();
const $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $7e02dfdf3441382d$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $3koWU.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $6rkLV.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $eUqFw.useState)(()=>!skipRefresh && value === undefined && !$7e02dfdf3441382d$var$requestSet.has(issueKey));
    const getData = (0, $eUqFw.useCallback)(async ()=>{
        setLoading(true);
        $7e02dfdf3441382d$var$requestSet.add(issueKey);
        const result = await $7e02dfdf3441382d$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $7e02dfdf3441382d$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const shouldGetData = !skipRefresh && !$7e02dfdf3441382d$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return [
        {
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $6rkLV.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $6rkLV.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $eUqFw.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $6rkLV.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $6rkLV.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $7e02dfdf3441382d$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return [
        {
            value: value
        }
    ];
};
const $7e02dfdf3441382d$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $6rkLV.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return [
        {
            value: value
        }
    ];
};
const $7e02dfdf3441382d$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $6rkLV.useFieldConfigStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("dwyR8", function(module, exports) {

$parcel$export(module.exports, "getGraphQlUrl", () => $82ad8876acbb4446$export$5647e6bbf2b3526f);
$parcel$export(module.exports, "getFieldDataOptions", () => $82ad8876acbb4446$export$f2fec0cacdfabaaf);

var $k0k8C = parcelRequire("k0k8C");

var $aAj2A = parcelRequire("aAj2A");
const $82ad8876acbb4446$export$5647e6bbf2b3526f = (baseUrl, operation)=>`${baseUrl}/rest/graphql/1/${(0, $k0k8C.appendOperationQuery)(operation)}`;
const $82ad8876acbb4446$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
        method: 'POST',
        body: JSON.stringify({
            query: (0, $aAj2A.default)(issueKey, projectKey)
        })
    });

});
parcelRegister("aAj2A", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f04a44c8c5fa855$export$2e2bcd8739ae039);
const $2f04a44c8c5fa855$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};
const $2f04a44c8c5fa855$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
const $2f04a44c8c5fa855$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
const $2f04a44c8c5fa855$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
const $2f04a44c8c5fa855$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
const $2f04a44c8c5fa855$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
var // Disable this eslint rule temporarily so we can query for configuration
// eslint-disable-next-line jira/import/no-anonymous-default-export
$2f04a44c8c5fa855$export$2e2bcd8739ae039 = (issueKey, projectKey)=>$2f04a44c8c5fa855$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$2f04a44c8c5fa855$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$2f04a44c8c5fa855$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$2f04a44c8c5fa855$var$getIsHybridAgilityProjectQuery()}
            ${$2f04a44c8c5fa855$var$getAgileQuery()}
        }
        ${$2f04a44c8c5fa855$var$getProjectQuery(projectKey)}
    }`;

});


parcelRegister("kPvBW", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $b682c7d6e9f17978$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $b682c7d6e9f17978$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $b682c7d6e9f17978$export$b38f30d67f730bc4);
const $b682c7d6e9f17978$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $b682c7d6e9f17978$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $b682c7d6e9f17978$export$757f91ad408a28d4 = 'jira.user.issue.filter.hide-done-subtasks';
const $b682c7d6e9f17978$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("6rkLV", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfigStore", () => $2581b610ec8db8fc$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $2581b610ec8db8fc$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $2581b610ec8db8fc$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $2581b610ec8db8fc$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $2581b610ec8db8fc$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $2581b610ec8db8fc$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $2581b610ec8db8fc$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $2581b610ec8db8fc$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $2581b610ec8db8fc$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $df4Sl = parcelRequire("df4Sl");

var $2vzCR = parcelRequire("2vzCR");

var $WBLbN = parcelRequire("WBLbN");
const $2581b610ec8db8fc$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $2581b610ec8db8fc$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $2581b610ec8db8fc$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $2581b610ec8db8fc$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState(), newIssues));
    };
const $2581b610ec8db8fc$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $2581b610ec8db8fc$var$actions = {
    setIssueConfig: $2581b610ec8db8fc$var$setIssueConfig,
    setIssuesConfig: $2581b610ec8db8fc$var$setIssuesConfig,
    mergeIssueConfig: $2581b610ec8db8fc$var$mergeIssueConfig,
    mergeIssuesConfig: $2581b610ec8db8fc$var$mergeIssuesConfig,
    setFieldConfigValue: $2581b610ec8db8fc$var$setFieldConfigValue
};
// this is a global state
const $2581b610ec8db8fc$var$store = (0, $WBLbN.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $2581b610ec8db8fc$var$actions
});
const $2581b610ec8db8fc$var$getIssueFieldConfig = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $2581b610ec8db8fc$export$52f51db4e2b3da57 = (0, $WBLbN.createHook)($2581b610ec8db8fc$var$store, {
    selector: $2581b610ec8db8fc$var$getIssueFieldConfig
});
const $2581b610ec8db8fc$var$getFieldConfig = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $2581b610ec8db8fc$var$getFieldConfigWithLabel = (0, $df4Sl.createSelector)($2581b610ec8db8fc$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $2581b610ec8db8fc$var$getFieldOptionsOverrides = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $2581b610ec8db8fc$export$f9beb98c7488fd61 = (0, $WBLbN.createHook)($2581b610ec8db8fc$var$store, {
    selector: $2581b610ec8db8fc$var$getFieldConfig
});
const $2581b610ec8db8fc$export$314199caf05d245 = (0, $WBLbN.createHook)($2581b610ec8db8fc$var$store, {
    selector: null
});
const $2581b610ec8db8fc$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $2581b610ec8db8fc$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $2581b610ec8db8fc$var$overridesActions = {
    setFieldConfigOverridesValue: $2581b610ec8db8fc$var$setOverrides,
    resetOverridesStore: $2581b610ec8db8fc$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $2581b610ec8db8fc$var$overridesStore = (0, $WBLbN.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $2581b610ec8db8fc$var$overridesActions
});
const $2581b610ec8db8fc$export$ff357cf5a96ec0c6 = (0, $WBLbN.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getIssueFieldConfig
});
const $2581b610ec8db8fc$export$6e41e9c34587d557 = (0, $WBLbN.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldConfig
});
const $2581b610ec8db8fc$export$e704d739927bd1d6 = (0, $WBLbN.createStateHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldConfigWithLabel
});
const $2581b610ec8db8fc$export$d94ae842140da412 = (0, $WBLbN.createActionsHook)($2581b610ec8db8fc$var$overridesStore);
const $2581b610ec8db8fc$export$bfea9bb9bad7bc8f = (0, $WBLbN.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldOptionsOverrides
});
const $2581b610ec8db8fc$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $2581b610ec8db8fc$export$982ff1008c2e2780 = (0, $WBLbN.createStateHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getIsFieldBusySelector
});

});




parcelRegister("byave", function(module, exports) {

$parcel$export(module.exports, "default", () => $652c7d4225abee61$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $652c7d4225abee61$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tootltipContent: {
        "id": "major-incident.major-incident-lozenge.tootltip-content",
        "defaultMessage": "This incident is marked as a major incident to increase visibility."
    },
    lozengeLabel: {
        "id": "major-incident.major-incident-lozenge.lozenge-label",
        "defaultMessage": "MAJOR INCIDENT"
    }
});

});



parcelRegister("7vcYl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d90757a516ecf1f4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4XQdE = parcelRequire("4XQdE");

var $ReiIP = parcelRequire("ReiIP");
const $d90757a516ecf1f4$var$MultiUserField = (props)=>{
    const { dataSelectorProps: { value: items } } = props;
    const userData = (0, $eUqFw.useMemo)(()=>items.map((user)=>({
                email: user.email,
                key: user.email,
                name: user.name,
                src: user.avatarUrl
            })), [
        items
    ]);
    if (!items || items.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ReiIP.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ReiIP.Content), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XQdE.default), {
        size: "small",
        maxCount: 5,
        appearance: "stack",
        data: userData
    })));
};
var $d90757a516ecf1f4$export$2e2bcd8739ae039 = $d90757a516ecf1f4$var$MultiUserField;

});
parcelRegister("4XQdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6346b768779c72$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $iJlfe = parcelRequire("iJlfe");


var $5Q9wj = parcelRequire("5Q9wj");

var $7PTrT = parcelRequire("7PTrT");

var $8BKky = parcelRequire("8BKky");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $2eG9N = parcelRequire("2eG9N");

var $hCcWD = parcelRequire("hCcWD");

var $3Czko = parcelRequire("3Czko");

var $6cUPN = parcelRequire("6cUPN");

var $h5NqH = parcelRequire("h5NqH");

var $5TioN = parcelRequire("5TioN");

var $33ZPs = parcelRequire("33ZPs");

var $bLnyK = parcelRequire("bLnyK");
const $3b6346b768779c72$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $3b6346b768779c72$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $3b6346b768779c72$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $iJlfe.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eUqFw.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $5Q9wj.default;
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5TioN.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: (0, $lcnyw.layers).modal(),
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6cUPN.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $h5NqH.default), {
                    onClick: (e)=>e.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8BKky.default), null, data.slice(max).map((avatar, index)=>$3b6346b768779c72$var$getOverrides(overrides).AvatarGroupItem.render((0, $hCcWD.default), {
                        avatar: avatar,
                        onAvatarClick: onAvatarClick,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $3b6346b768779c72$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $33ZPs.default) : (0, $3Czko.default);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData, idx)=>{
        const callback = avatarData.onClick || onAvatarClick;
        const finalAvatar = $3b6346b768779c72$var$getOverrides(overrides).Avatar.render(avatar, {
            ...avatarData,
            size: size,
            borderColor: borderColor || avatarData.borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event, analyticsEvent)=>{
                callback(event, analyticsEvent, idx);
            } : undefined,
            stackIndex: max - idx
        }, idx);
        return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $2eG9N.default), {
            key: (0, $bLnyK.composeUniqueKey)(avatarData, idx),
            content: avatarData.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total));
};
var $3b6346b768779c72$export$2e2bcd8739ae039 = $3b6346b768779c72$var$AvatarGroup;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("hCcWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ec5414b121adc7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");
var $e7PSD = parcelRequire("e7PSD");
var $bo4OB = parcelRequire("bo4OB");

var $jXJS5 = parcelRequire("jXJS5");
const $19ec5414b121adc7$var$AvatarGroupItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { avatar: avatar, onAvatarClick: onAvatarClick, testId: testId, index: index } = props;
    const { href: href, onClick: onClick, ...rest } = avatar;
    const itemRef = (0, $jXJS5.default)();
    const CustomComponent = ({ children: children, ...props })=>{
        return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            type: "button",
            ...props
        }, children));
    };
    const AvatarIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        ...rest,
        testId: testId && `${testId}--avatar`,
        borderColor: "transparent",
        size: "small",
        name: ""
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: avatar.target,
        rel: avatar.target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, avatar.name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId
    }, avatar.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, avatar.name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$19ec5414b121adc7$export$2e2bcd8739ae039 = $19ec5414b121adc7$var$AvatarGroupItem;

});
parcelRegister("jXJS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a822a3bf76dc75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6cUPN = parcelRequire("6cUPN");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $47a822a3bf76dc75$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $47a822a3bf76dc75$export$2e2bcd8739ae039 = $47a822a3bf76dc75$var$useRegisterItemWithFocusManager;

});
parcelRegister("6cUPN", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $c9e49b704731182e$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $c9e49b704731182e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $HPlWp = parcelRequire("HPlWp");
const $c9e49b704731182e$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic
 */ const $c9e49b704731182e$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eUqFw.useEffect)(()=>{
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $HPlWp.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: (0, $HPlWp.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9e49b704731182e$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $c9e49b704731182e$export$2e2bcd8739ae039 = $c9e49b704731182e$var$FocusManager;

});
parcelRegister("HPlWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2eeb0b24006473e$export$2e2bcd8739ae039);

const $b2eeb0b24006473e$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $b2eeb0b24006473e$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $b2eeb0b24006473e$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement && nextFocusableElement.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement && prevFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, -1);
                nextFocusableElement && nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement && prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("3Czko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f319fa8ea8cddd21$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $f319fa8ea8cddd21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f319fa8ea8cddd21$var$gutter = "var(--ds-space-negative-050, -4px)";
const $f319fa8ea8cddd21$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    isolation: 'isolate',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    listStyleType: 'none !important',
    marginInlineEnd: $f319fa8ea8cddd21$var$gutter,
    marginInlineStart: $f319fa8ea8cddd21$var$gutter
});
const $f319fa8ea8cddd21$var$listItemStyles = {
    name: "3unxte",
    styles: "margin:var(--ds-space-0, 0px);margin-block-end:var(--ds-space-100, 8px);padding-inline-end:var(--ds-space-050, 4px);padding-inline-start:var(--ds-space-050, 4px)"
};
const $f319fa8ea8cddd21$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $f319fa8ea8cddd21$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $f319fa8ea8cddd21$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f319fa8ea8cddd21$export$2e2bcd8739ae039 = $f319fa8ea8cddd21$var$Grid;

});

parcelRegister("h5NqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ffca550571fe4d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $6cUPN = parcelRequire("6cUPN");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $4ffca550571fe4d8$var$PopupAvatarGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, setInitialFocusRef: setInitialFocusRef, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    (0, $eUqFw.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    }));
};
var $4ffca550571fe4d8$export$2e2bcd8739ae039 = $4ffca550571fe4d8$var$PopupAvatarGroup;

});

parcelRegister("5TioN", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bc7348cf05a7b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");
var $iJlfe = parcelRequire("iJlfe");

var $XHGTv = parcelRequire("XHGTv");

const $80bc7348cf05a7b7$var$buttonSizes = {
    xsmall: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xxlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $80bc7348cf05a7b7$var$buttonActiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 ${(0, $eri7S.BORDER_WIDTH)}px ${`var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`}`,
        color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: `scale(${(0, $eri7S.ACTIVE_SCALE_FACTOR)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
            color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
        }
    }
});
const $80bc7348cf05a7b7$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
            color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::after': {
            display: 'none'
        }
    }
});
const $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT = 99;
const $80bc7348cf05a7b7$var$MoreIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : `var(--ds-border-inverse, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`, size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iJlfe.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        ref: ref,
        onClick: onClickHander
    }, ({ testId: _, className: className, ref: ref, ...props })=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $byn9U.jsx)("button", {
            type: "submit",
            ...buttonProps,
            ...props,
            ref: ref,
            "data-testid": testId,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                font: $80bc7348cf05a7b7$var$buttonSizes[size]
            },
            css: [
                $80bc7348cf05a7b7$var$buttonStyles,
                isActive && $80bc7348cf05a7b7$var$buttonActiveStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className
        }, "+", count > $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT ? $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT : count));
});
$80bc7348cf05a7b7$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$80bc7348cf05a7b7$export$2e2bcd8739ae039 = $80bc7348cf05a7b7$var$MoreIndicator;

});

parcelRegister("33ZPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e31b31f1a588aba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $lcnyw = parcelRequire("lcnyw");
const $9e31b31f1a588aba$var$gutter = (0, $eri7S.BORDER_WIDTH) * 2 + (0, $lcnyw.gridSize)() / 2;
const $9e31b31f1a588aba$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    isolation: 'isolate',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    listStyleType: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: $9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$listItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: -$9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $9e31b31f1a588aba$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $9e31b31f1a588aba$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9e31b31f1a588aba$export$2e2bcd8739ae039 = $9e31b31f1a588aba$var$Stack;

});

parcelRegister("bLnyK", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $009108df95df64ca$export$b067756944994c79);
const $009108df95df64ca$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});


parcelRegister("ReiIP", function(module, exports) {

$parcel$export(module.exports, "Container", () => $8cf2388d3c6e9174$export$42a852a2b6b56249);
$parcel$export(module.exports, "Content", () => $8cf2388d3c6e9174$export$7c6e2c02157bb7d2);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $8cf2388d3c6e9174$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo1wug _18m91wug _80omtlke",
            __cmplp.className
        ])
    });
});
const $8cf2388d3c6e9174$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41rr7 _1i4q1hna",
            __cmplp.className
        ])
    });
});

});


parcelRegister("3cZ4e", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd905e1d5c0ea335$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $3MV1G = parcelRequire("3MV1G");

var $9jNAz = parcelRequire("9jNAz");

var $cAKIH = parcelRequire("cAKIH");

var $83aOZ = parcelRequire("83aOZ");
const $cd905e1d5c0ea335$var$MultiValueField = (props)=>{
    const { dataSelectorProps: { value: items }, tableInjectedProps: { fieldName: fieldName, fieldId: fieldId } } = props;
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const expandedView = (0, $eUqFw.useMemo)(()=>items.map(({ value: value }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
                key: `multi-value-${fieldId}-${index}`,
                text: value
            })), [
        items,
        fieldId
    ]);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const onToggle = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        setIsOpen,
        isOpen
    ]);
    const getContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $83aOZ.PopUpContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cAKIH.default), null, expandedView));
    const getTrigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...triggerProps,
            appearance: "link",
            isSelected: isOpen,
            onClick: onToggle
        }, `${items.length} ${fieldName}`);
    if (!items || items.length === 0) return null;
    if (items.length <= 3) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $83aOZ.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $83aOZ.Content), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cAKIH.default), null, expandedView)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $83aOZ.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $83aOZ.Content), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        content: getContent,
        trigger: getTrigger
    })));
};
var $cd905e1d5c0ea335$export$2e2bcd8739ae039 = $cd905e1d5c0ea335$var$MultiValueField;

});
parcelRegister("9jNAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $02a667cb3800fd5a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $d9W8K = parcelRequire("d9W8K");

var $6aZHE = parcelRequire("6aZHE");

var $gz2Bi = parcelRequire("gz2Bi");
const $02a667cb3800fd5a$var$SimpleTagComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $byn9U.jsx)((0, $gz2Bi.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $d9W8K.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $byn9U.jsx)((0, $6aZHE.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $02a667cb3800fd5a$var$SimpleTag = /*#__PURE__*/ (0, $eUqFw.memo)($02a667cb3800fd5a$var$SimpleTagComponent);
var $02a667cb3800fd5a$export$2e2bcd8739ae039 = $02a667cb3800fd5a$var$SimpleTag;

});

parcelRegister("83aOZ", function(module, exports) {

$parcel$export(module.exports, "Container", () => $b914cc7205b9ba1b$export$42a852a2b6b56249);
$parcel$export(module.exports, "Content", () => $b914cc7205b9ba1b$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "PopUpContent", () => $b914cc7205b9ba1b$export$c5f1e7ec38c8ebe2);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line import/order

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $b914cc7205b9ba1b$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo1wug _18m91wug _80omtlke",
            __cmplp.className
        ])
    });
});
const $b914cc7205b9ba1b$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41rr7 _1i4q1hna",
            __cmplp.className
        ])
    });
});
const $b914cc7205b9ba1b$export$c5f1e7ec38c8ebe2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12fnklw _1yt4u2gc",
            __cmplp.className
        ])
    });
});

});


parcelRegister("7C4bN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d81748c61eae371$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7khX6 = parcelRequire("7khX6");
function $4d81748c61eae371$export$2e2bcd8739ae039(props) {
    if (props.dataSelectorProps.value === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7khX6.default), null);
    const { dataSelectorProps: { value: { iconUrl: iconUrl, name: name } } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4d81748c61eae371$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        height: "16",
        width: "16",
        src: iconUrl,
        alt: name,
        title: name
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4d81748c61eae371$var$StyledWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itidpf _1yt414ck",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7khX6", function(module, exports) {

$parcel$export(module.exports, "default", () => $adaee8eae8929259$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gw74N = parcelRequire("gw74N");


var $5JgJ2 = parcelRequire("5JgJ2");

var $6km2A = parcelRequire("6km2A");

var $4dmrv = parcelRequire("4dmrv");
function $adaee8eae8929259$var$Error(props) {
    const { isLastColumn: isLastColumn, message: message } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const tooltipMessage = typeof message === 'string' ? message : formatMessage(message);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6km2A.default), {
        isLastColumn: isLastColumn,
        tooltipMessage: tooltipMessage,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gw74N))),
        color: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R400})`,
        backgroundColor: "var(--ds-background-danger, rgb(239, 239, 239))"
    });
}
$adaee8eae8929259$var$Error.defaultProps = {
    isLastColumn: false,
    message: (0, $4dmrv.default).errorMessage
};
var $adaee8eae8929259$export$2e2bcd8739ae039 = $adaee8eae8929259$var$Error;

});
parcelRegister("6km2A", function(module, exports) {

$parcel$export(module.exports, "default", () => $02cc040828de1930$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $29yDk = parcelRequire("29yDk");

var $c9TLT = parcelRequire("c9TLT");

var $jU4ta = parcelRequire("jU4ta");
const $02cc040828de1930$var$DIALOG_MAX_WIDTH = (0, $c9TLT.gridSize) * 36;
const $02cc040828de1930$var$TABLE_LEFT_MARGIN = (0, $c9TLT.gridSize) * 5;
class $02cc040828de1930$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isLastColumn: false,
            tooltipTitle: undefined
        };
    }
    calculateDialogPosition() {
        if (this.alertRef.current) {
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            const { left: left } = this.alertRef.current.getBoundingClientRect();
            if (this.alertRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            this.alertRef.current.offsetParent && left > // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            this.alertRef.current.offsetParent.getBoundingClientRect().left + $02cc040828de1930$var$DIALOG_MAX_WIDTH + $02cc040828de1930$var$TABLE_LEFT_MARGIN) return 'bottom-end';
        }
        return 'bottom-start';
    }
    renderDialogContent() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02cc040828de1930$var$DialogContainer, null, this.props.tooltipTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, this.props.tooltipTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, this.props.tooltipMessage));
    }
    render() {
        const { isLastColumn: isLastColumn, Icon: Icon, color: color, backgroundColor: backgroundColor } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jU4ta.UnselectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
            placement: this.calculateDialogPosition(),
            content: this.renderDialogContent(),
            isOpen: this.state.dialogOpen,
            onClose: this.onClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02cc040828de1930$var$Container, {
            onClick: this.onClick,
            color: color,
            backgroundColor: backgroundColor,
            /* @ts-expect-error - TS2322 - Type 'RefObject<unknown>' is not assignable to type '{ current: HTMLDivElement | null; }'. */ ref: this.alertRef,
            tabIndex: 0,
            onMouseEnter: this.onMouseEnterContainer,
            onMouseLeave: this.onMouseLeaveContainer,
            isHovered: this.state.isHovered
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02cc040828de1930$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            color: color
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02cc040828de1930$var$Container, {
            onClick: this.onClick,
            color: color,
            backgroundColor: backgroundColor,
            /* @ts-expect-error - TS2322 - Type 'RefObject<unknown>' is not assignable to type '{ current: HTMLDivElement | null; }'. */ ref: this.alertRef,
            tabIndex: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02cc040828de1930$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            color: "currentColor"
        })))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            dialogOpen: false,
            isHovered: false
        };
        this.onClick = ()=>this.setState({
                dialogOpen: !this.state.dialogOpen
            });
        this.onMouseEnterContainer = ()=>this.setState({
                ...this.state,
                isHovered: true
            });
        this.onMouseLeaveContainer = ()=>this.setState({
                ...this.state,
                isHovered: false
            });
        this.alertRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02cc040828de1930$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, isHovered: isHovered, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1aegsjq": (0, $9t7rW.default)(`2px solid ${__cmplp.color}`),
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color),
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19it1pqh _syaz1cj8 _bfhk3qkl _2rkoi2wt _1bsb1osq _4t3i1ylp _y3gn1h6o",
            __cmplp.isHovered ? "_80omtlke" : "_80om1wug",
            __cmplp.className
        ])
    });
});
const $02cc040828de1930$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkv77o",
            __cmplp.className
        ])
    });
});
const $02cc040828de1930$var$DialogContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12fo812",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4dmrv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b85144d707cb86be$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b85144d707cb86be$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "issue-table.common.fields.error.error-message",
        "defaultMessage": "There was a problem showing this field."
    }
});

});



parcelRegister("85LCN", function(module, exports) {

$parcel$export(module.exports, "default", () => $653dd851eda37a77$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2eG9N = parcelRequire("2eG9N");

var $giAhk = parcelRequire("giAhk");

var $jU4ta = parcelRequire("jU4ta");

var $1yGbG = parcelRequire("1yGbG");
const $653dd851eda37a77$var$ANONYMOUS_STYLE = 'anonymous';
const $653dd851eda37a77$var$TOOLTIP_STYLE = 'tooltip';
const $653dd851eda37a77$var$SIMPLE_STYLE = 'simple';
const $653dd851eda37a77$var$getTooltipMessage = (style)=>{
    if (style.type === $653dd851eda37a77$var$TOOLTIP_STYLE) return `${style.displayName} - ${style.emailAddress}`;
    return null;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $653dd851eda37a77$var$renderWithTooltipIfRequired = (content, tooltipText)=>{
    if (tooltipText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: tooltipText
    }, content);
    return content;
};
// eslint-disable-next-line jira/react/no-class-components
class $653dd851eda37a77$var$Reporter extends (0, $eUqFw.Component) {
    getDisplayMessage(style) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        switch(style.type){
            case $653dd851eda37a77$var$TOOLTIP_STYLE:
                return this.formatForDisplay(style.displayName);
            case $653dd851eda37a77$var$SIMPLE_STYLE:
                return this.formatForDisplay(style.value);
            case $653dd851eda37a77$var$ANONYMOUS_STYLE:
                return formatMessage((0, $1yGbG.default).anonymous);
            default:
                // prettier-ignore
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                style;
                return '';
        }
    }
    getStyle() {
        const { dataSelectorProps: { value: value } } = this.props;
        if (!value || !value.emailAddress && !value.displayName) return {
            type: $653dd851eda37a77$var$ANONYMOUS_STYLE
        };
        const { emailAddress: emailAddress, displayName: displayName } = value;
        if (!emailAddress || !displayName || emailAddress === displayName) return {
            type: $653dd851eda37a77$var$SIMPLE_STYLE,
            value: emailAddress || displayName || ''
        };
        return {
            type: $653dd851eda37a77$var$TOOLTIP_STYLE,
            emailAddress: emailAddress,
            displayName: displayName
        };
    }
    formatForDisplay(name) {
        const { dataSelectorProps: { value: value }, intl: { formatMessage: formatMessage } } = this.props;
        const active = !value || value.active;
        if (active) return name;
        return formatMessage((0, $1yGbG.default).inactive, {
            name: name
        });
    }
    render() {
        const { tableInjectedProps: { isLastColumn: isLastColumn } } = this.props;
        const style = this.getStyle();
        const tooltip = $653dd851eda37a77$var$getTooltipMessage(style);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jU4ta.UnselectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, $653dd851eda37a77$var$renderWithTooltipIfRequired(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($653dd851eda37a77$var$ReporterWrapper, null, this.getDisplayMessage(style)), tooltip));
    }
}
var $653dd851eda37a77$export$2e2bcd8739ae039 // gridSize + 2 to account for summary field {padding: gridSize} + 2px from transparent border
 = (0, $giAhk.injectIntlV2)($653dd851eda37a77$var$Reporter);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $653dd851eda37a77$var$ReporterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41w01 _1i4q1hna",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1yGbG", function(module, exports) {

$parcel$export(module.exports, "default", () => $42a2e7b3d8ab5ae5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $42a2e7b3d8ab5ae5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    anonymous: {
        "id": "issue-table.common.fields.reporter.anonymous",
        "defaultMessage": "Anonymous"
    },
    inactive: {
        "id": "issue-table.common.fields.reporter.inactive",
        "defaultMessage": "{name} (Inactive)"
    }
});

});


parcelRegister("60SBI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b390bb3897d9cff9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $difW2 = parcelRequire("difW2");
const $b390bb3897d9cff9$var$Responders = ({ dataSelectorProps: { value: value } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $difW2.RespondersInlineView), {
        values: value
    });
var $b390bb3897d9cff9$export$2e2bcd8739ae039 = $b390bb3897d9cff9$var$Responders;

});
parcelRegister("difW2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "RespondersInlineView", () => $0a2f03d8d286232e$export$c1d034b633262480);
$parcel$export(module.exports, "default", () => $0a2f03d8d286232e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9jNAz = parcelRequire("9jNAz");

var $cAKIH = parcelRequire("cAKIH");

var $2NwGr = parcelRequire("2NwGr");

const $0a2f03d8d286232e$export$c1d034b633262480 = ({ values: values })=>{
    const respondersRender = values.map((it)=>{
        const accountId = it.ari.startsWith((0, $55f10c18f7cea5ca$export$470b0d72e4fdc43a)) ? it.ari.substring((0, $55f10c18f7cea5ca$export$470b0d72e4fdc43a).length) : null;
        const renderTagWithProfileCardWrapper = (accountIdValue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2NwGr.AsyncProfileCardNext), {
                key: it.ari,
                accountId: accountIdValue
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
                testId: "responders.ui.inline.async-tag",
                key: it.ari,
                text: it.name
            }));
        return accountId !== null ? renderTagWithProfileCardWrapper(accountId) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
            testId: "responders.ui.inline.tag",
            key: it.ari,
            text: it.name
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cAKIH.default), null, respondersRender);
};
var $0a2f03d8d286232e$export$2e2bcd8739ae039 = $0a2f03d8d286232e$export$c1d034b633262480;

});
const $55f10c18f7cea5ca$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';



parcelRegister("neNmT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f76119841e2e338$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jU4ta = parcelRequire("jU4ta");

var $2a0M2 = parcelRequire("2a0M2");
const $3f76119841e2e338$var$Sentiment = ({ dataSelectorProps: { value: value }, tableInjectedProps: { isLastColumn: isLastColumn } })=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jU4ta.UnselectableChildGutterPaddingContainer), {
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2a0M2.ReadView), {
        id: value.id,
        name: value.name
    })) : null;
var $3f76119841e2e338$export$2e2bcd8739ae039 = $3f76119841e2e338$var$Sentiment;

});
parcelRegister("2a0M2", function(module, exports) {

$parcel$export(module.exports, "ReadView", () => $64d899892107385c$export$a4b5824ec1e018e1);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dzivv = parcelRequire("dzivv");
const $64d899892107385c$export$a4b5824ec1e018e1 = ({ id: id, name: name })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), null, (0, $dzivv.EmojiIconForSentimentCustomField)(id, formatMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $64d899892107385c$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, name)));
};
const $64d899892107385c$var$contentStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.025',
    marginLeft: 'space.150',
    whiteSpace: 'nowrap'
});

});
parcelRegister("dzivv", function(module, exports) {

$parcel$export(module.exports, "EmojiIconForSentimentCustomField", () => $6282e7ba7a951c3e$export$48a4724ca11bcd06);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $kD1hr = parcelRequire("kD1hr");


var $fr48n = parcelRequire("fr48n");
const $6282e7ba7a951c3e$var$NegativeSentimentGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "96",
        height: "96",
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M61.7766 14.7403C57.4089 12.9312 52.7276 12 48 12C38.4522 12 29.2955 15.7928 22.5442 22.5442C15.7928 29.2955 12 38.4522 12 48C12 57.5478 15.7928 66.7045 22.5442 73.4558C29.2955 80.2072 38.4522 84 48 84C52.7276 84 57.4089 83.0688 61.7766 81.2597C66.1443 79.4505 70.1129 76.7988 73.4558 73.4558C76.7988 70.1129 79.4505 66.1443 81.2597 61.7766C83.0688 57.4089 84 52.7276 84 48C84 43.2724 83.0688 38.5911 81.2597 34.2234C79.4505 29.8557 76.7988 25.8871 73.4558 22.5442C70.1129 19.2012 66.1443 16.5495 61.7766 14.7403ZM76.284 48C76.284 63.6 63.6 76.284 48 76.284C32.4 76.284 19.716 63.6 19.716 48C19.7245 40.5012 22.7071 33.312 28.0095 28.0095C33.312 22.7071 40.5012 19.7245 48 19.716C63.6 19.716 76.284 32.4 76.284 48ZM38.3156 45.0357C38.9396 45.2944 39.6085 45.4277 40.284 45.428C41.6483 45.428 42.9607 44.886 43.9254 43.9214C44.89 42.9567 45.432 41.6483 45.432 40.284C45.432 38.9197 44.89 37.6113 43.9254 36.6466C42.9607 35.682 41.6523 35.14 40.288 35.14C39.6125 35.1397 38.9435 35.2725 38.3193 35.5308C37.6951 35.7891 37.1279 36.1678 36.6501 36.6452C36.1722 37.1227 35.7931 37.6896 35.5343 38.3136C35.2756 38.9376 35.1423 39.6065 35.142 40.282C35.1417 40.9575 35.2745 41.6265 35.5328 42.2507C35.7911 42.8749 36.1698 43.4421 36.6472 43.9199C37.1247 44.3978 37.6916 44.7769 38.3156 45.0357ZM52.0786 43.9214C53.0433 44.886 54.3517 45.428 55.716 45.428C57.0803 45.428 58.3887 44.886 59.3534 43.9214C60.318 42.9567 60.86 41.6483 60.86 40.284C60.86 38.9197 60.318 37.6113 59.3534 36.6466C58.3887 35.682 57.0803 35.14 55.716 35.14C54.3517 35.14 53.0433 35.682 52.0786 36.6466C51.114 37.6113 50.572 38.9197 50.572 40.284C50.572 41.6483 51.114 42.9567 52.0786 43.9214ZM38.8717 63.0827C38.2912 63.6733 37.5055 64.0176 36.6777 64.0439C35.85 64.0702 35.0439 63.7766 34.427 63.2241C33.8101 62.6716 33.4298 61.9026 33.3651 61.077C33.3005 60.2513 33.5564 59.4325 34.0798 58.7907C35.8298 56.8374 37.9718 55.2747 40.366 54.2044C42.7603 53.1341 45.3531 52.5802 47.9757 52.5787C50.5936 52.5799 53.1818 53.1319 55.5724 54.1987C57.963 55.2654 60.1024 56.8232 61.8517 58.7707C62.3954 59.4089 62.6683 60.2342 62.6123 61.0707C62.5564 61.9071 62.176 62.6887 61.5522 63.2489C60.9285 63.809 60.1106 64.1034 59.273 64.0694C58.4353 64.0354 57.644 63.6756 57.0677 63.0667C52.4357 57.9067 43.4958 57.9067 38.8717 63.0827Z",
        fill: "currentColor"
    }));
const $6282e7ba7a951c3e$var$NeutralSentimentGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "96",
        height: "96",
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M61.7766 14.7403C57.4089 12.9312 52.7276 12 48 12C38.4522 12 29.2955 15.7928 22.5442 22.5442C15.7928 29.2955 12 38.4522 12 48C12 57.5478 15.7928 66.7045 22.5442 73.4558C29.2955 80.2072 38.4522 84 48 84C52.7276 84 57.4089 83.0688 61.7766 81.2597C66.1443 79.4505 70.1129 76.7988 73.4558 73.4558C76.7988 70.1129 79.4505 66.1443 81.2597 61.7766C83.0688 57.4089 84 52.7276 84 48C84 43.2724 83.0688 38.5911 81.2597 34.2234C79.4505 29.8557 76.7988 25.8871 73.4558 22.5442C70.1129 19.2012 66.1443 16.5495 61.7766 14.7403ZM76.284 48C76.284 63.6 63.6 76.284 48 76.284C32.4 76.284 19.716 63.6 19.716 48C19.7245 40.5012 22.7071 33.312 28.0095 28.0095C33.312 22.7071 40.5012 19.7245 48 19.716C63.6 19.716 76.284 32.4 76.284 48ZM38.3156 45.0357C38.9396 45.2944 39.6085 45.4277 40.284 45.428C41.6483 45.428 42.9607 44.886 43.9254 43.9214C44.89 42.9567 45.432 41.6483 45.432 40.284C45.432 38.9197 44.89 37.6113 43.9254 36.6466C42.9607 35.682 41.6523 35.14 40.288 35.14C39.6125 35.1397 38.9435 35.2725 38.3193 35.5308C37.6951 35.7891 37.1279 36.1678 36.6501 36.6452C36.1722 37.1227 35.7931 37.6896 35.5343 38.3136C35.2756 38.9376 35.1423 39.6065 35.142 40.282C35.1417 40.9575 35.2745 41.6265 35.5328 42.2507C35.7911 42.8749 36.1698 43.4421 36.6472 43.9199C37.1247 44.3978 37.6916 44.7769 38.3156 45.0357ZM52.0786 43.9214C53.0433 44.886 54.3517 45.428 55.716 45.428C57.0803 45.428 58.3887 44.886 59.3534 43.9214C60.318 42.9567 60.86 41.6483 60.86 40.284C60.86 38.9197 60.318 37.6113 59.3534 36.6466C58.3887 35.682 57.0803 35.14 55.716 35.14C54.3517 35.14 53.0433 35.682 52.0786 36.6466C51.114 37.6113 50.572 38.9197 50.572 40.284C50.572 41.6483 51.114 42.9567 52.0786 43.9214ZM37 54.625C35.136 54.625 33.625 56.136 33.625 58C33.625 59.864 35.136 61.375 37 61.375L59 61.375C60.864 61.375 62.375 59.864 62.375 58C62.375 56.136 60.864 54.625 59 54.625L37 54.625Z",
        fill: "currentColor"
    }));
const $6282e7ba7a951c3e$export$48a4724ca11bcd06 = (sentimentId, formatMessage)=>{
    switch(sentimentId){
        case '1000':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
                glyph: $6282e7ba7a951c3e$var$NegativeSentimentGlyph,
                label: formatMessage((0, $fr48n.default).negativeSentimentIconLabel),
                primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`,
                size: "medium"
            });
        case '2000':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
                glyph: $6282e7ba7a951c3e$var$NeutralSentimentGlyph,
                label: formatMessage((0, $fr48n.default).neutralSentimentIconLabel),
                primaryColor: "var(--ds-icon-subtle, #44546F)",
                size: "medium"
            });
        case '3000':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kD1hr))), {
                primaryColor: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`,
                size: "medium",
                label: formatMessage((0, $fr48n.default).positiveSentimentIconLabel)
            });
        default:
            return null;
    }
};

});
parcelRegister("kD1hr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f048716d3eb719f1$var$_react = $f048716d3eb719f1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $f048716d3eb719f1$var$_emoji = $f048716d3eb719f1$var$_interopRequireDefault((parcelRequire("enL2F")));
function $f048716d3eb719f1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f048716d3eb719f1$var$EmojiIcon = (props)=>/*#__PURE__*/ $f048716d3eb719f1$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18m0 16.071c3.9 0 7.071-3.171 7.071-7.071S15.9 4.929 12 4.929A7.08 7.08 0 0 0 4.929 12c0 3.9 3.171 7.071 7.071 7.071m-1.929-7.714a1.286 1.286 0 1 1 .001-2.572 1.286 1.286 0 0 1 0 2.572m3.858 0a1.286 1.286 0 1 1 0-2.572 1.286 1.286 0 0 1 0 2.572m.347 2.035a.805.805 0 0 1 1.198 1.073A4.67 4.67 0 0 1 12 16.018a4.67 4.67 0 0 1-3.469-1.548.804.804 0 0 1 1.196-1.074c1.158 1.29 3.393 1.29 4.549-.004"/></svg>`
    }, props, {
        newIcon: $f048716d3eb719f1$var$_emoji.default
    }));
$f048716d3eb719f1$var$EmojiIcon.displayName = 'EmojiIcon';
var $f048716d3eb719f1$var$_default = module.exports.default = $f048716d3eb719f1$var$EmojiIcon;

});
parcelRegister("enL2F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ca1bbf4403656d4b5e9e7546fbc0463e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a787b43bc3843a09$var$_react = $a787b43bc3843a09$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a787b43bc3843a09$var$_UNSAFE_baseNew = $a787b43bc3843a09$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a787b43bc3843a09$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a787b43bc3843a09$var$EmojiIcon = (props)=>/*#__PURE__*/ $a787b43bc3843a09$var$_react.default.createElement($a787b43bc3843a09$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.25 6.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M11.25 9.75S10 11.5 8 11.5 4.75 9.75 4.75 9.75M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Zm-9-1.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
    }, props));
$a787b43bc3843a09$var$EmojiIcon.displayName = 'EmojiIcon';
var $a787b43bc3843a09$var$_default = module.exports.default = $a787b43bc3843a09$var$EmojiIcon;

});


parcelRegister("fr48n", function(module, exports) {

$parcel$export(module.exports, "default", () => $272a01d4e4505a41$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $272a01d4e4505a41$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    negativeSentimentIconLabel: {
        "id": "issue-table.common.fields.sentiment.negative-sentiment-icon-label",
        "defaultMessage": "Negative sentiment icon"
    },
    positiveSentimentIconLabel: {
        "id": "issue-table.common.fields.sentiment.positive-sentiment-icon-label",
        "defaultMessage": "Positive sentiment icon"
    },
    neutralSentimentIconLabel: {
        "id": "issue-table.common.fields.sentiment.neutral-sentiment-icon-label",
        "defaultMessage": "Neutral sentiment icon"
    }
});

});




parcelRegister("02WRG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d0bd49073046d8e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");


var $d3rF7 = parcelRequire("d3rF7");


var $GKUdY = parcelRequire("GKUdY");
const $3d0bd49073046d8e$export$a7502422f07570ed = 'metric not found';
const $3d0bd49073046d8e$var$Sla = (props)=>{
    const { dataSelectorProps: { value: value }, tableInjectedProps: { isLastColumn: isLastColumn } } = props;
    const onError = (location, error, attributes)=>{
        // This check is added to supress the false burn events the client errors are creating in SLA Queue View Reliability SLOs
        // These errors are safe to be ignored
        // Platform team added a check to filter them from SFX & Splunk but still JSM Bumblebee team is seeing SLO Burn events
        // Ref: https://product-fabric.atlassian.net/browse/P2X-1109
        if ((0, $GKUdY.isClientFetchError)(error)) return;
        const errorPayload = {
            error: error,
            meta: {
                id: 'slaQueueView',
                packageName: 'jiraIssueTable'
            },
            attributes: {
                ...attributes,
                location: location,
                fieldType: (0, $eb1896b876bf2c2c$export$f790c24298ed441b)
            },
            sendToPrivacyUnsafeSplunk: true
        };
        return (0, $guiFP.default)(errorPayload);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d3rF7.AsyncLazySla), {
        isLastColumn: isLastColumn,
        value: value,
        onError: onError,
        viewMode: (0, $bb8ad3e299c0efc0$export$2e5e3c3156fc4c3c)
    });
};
var $3d0bd49073046d8e$export$2e2bcd8739ae039 = $3d0bd49073046d8e$var$Sla;

});
const $bb8ad3e299c0efc0$export$a63db8d18dae0c68 = 'card';
const $bb8ad3e299c0efc0$export$2e5e3c3156fc4c3c = 'queue';

parcelRegister("d3rF7", function(module, exports) {

$parcel$export(module.exports, "AsyncLazySla", () => $3ecf0c1d7a7b264e$export$e4c697b53a973eb5);

var $eUqFw = parcelRequire("eUqFw");

var $jh2R9 = parcelRequire("jh2R9");

var $7rh0R = parcelRequire("7rh0R");

var $5GxEP = parcelRequire("5GxEP");

const $3ecf0c1d7a7b264e$var$AsyncSla = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("bh9d9")), {
    moduleId: "./src/packages/jira-issue-sla/src/ui/sla/main.tsx"
});
const $3ecf0c1d7a7b264e$export$e4c697b53a973eb5 = (props)=>{
    const { viewMode: viewMode, onError: onError } = props;
    const boundary = (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(`sla ${viewMode} View`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: boundary,
        packageName: "jira-issue-sla",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ecf0c1d7a7b264e$var$AsyncSla, props)));
};

});
parcelRegister("bh9d9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kAMpR")
]).then(()=>parcelRequire('fvoOI'));

});


parcelRegister("GKUdY", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $8eb18d2945c2d7a8$export$2e7adc44463c3f4f);
const $8eb18d2945c2d7a8$var$KNOWN_NETWORK_ERRORS = [
    'Failed to fetch dynamically imported module',
    'error loading dynamically imported module',
    'Importing a module script failed'
];
const $8eb18d2945c2d7a8$var$isClientFetchErrorMessage = (message)=>Boolean(message) && !!$8eb18d2945c2d7a8$var$KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $8eb18d2945c2d7a8$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($8eb18d2945c2d7a8$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && $8eb18d2945c2d7a8$var$isClientFetchErrorMessage(error.cause.message));

});


parcelRegister("4zvpq", function(module, exports) {

$parcel$export(module.exports, "default", () => $152ce3d80695eb2e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6vrw7 = parcelRequire("6vrw7");

var $jU4ta = parcelRequire("jU4ta");

var $bkl01 = parcelRequire("bkl01");

var $lbWsn = parcelRequire("lbWsn");
class $152ce3d80695eb2e$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static getDerivedStateFromProps(props, { canRenderEditExperience: canRenderEditExperience }) {
        const { dataSelectorProps: { isEditable: isEditable }, tableInjectedProps: { shouldHydrateFully: shouldHydrateFully } } = props;
        if (shouldHydrateFully && isEditable === true && !canRenderEditExperience) return {
            canRenderEditExperience: true
        };
        return null;
    }
    enableEditExperienceIfAvailable() {
        if (this.props.dataSelectorProps.isEditable === true && !this.state.canRenderEditExperience) this.setState({
            canRenderEditExperience: true
        });
    }
    render() {
        const { dataSelectorProps: { value: { id: id, name: name, description: description, statusCategory: { id: statusCategoryId } }, isEditable: isEditable, onChange: onChange }, tableInjectedProps: { isLastColumn: isLastColumn, issueKey: issueKey, issueFieldLockControls: issueFieldLockControls } } = this.props;
        const { canRenderEditExperience: canRenderEditExperience } = this.state;
        const transformedProps = {
            value: {
                id: id.toString(),
                name: name,
                description: description,
                statusCategory: {
                    id: statusCategoryId
                }
            },
            isLastColumn: isLastColumn,
            appearance: 'lozenge',
            issueKey: (0, $6vrw7.toIssueKey)(issueKey),
            onChange: onChange,
            issueFieldLockControls: issueFieldLockControls
        };
        if (isEditable === true && canRenderEditExperience) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jU4ta.SelectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bkl01.default), transformedProps));
        // SelectableChildGutterPaddingContainer, because it always renders within (possibly disabled) button.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jU4ta.SelectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn,
            onMouseOver: this.onMouseOver,
            onFocus: this.onFocus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbWsn.default), transformedProps));
    }
    constructor(...args){
        super(...args);
        this.state = {
            canRenderEditExperience: false
        };
        this.onMouseOver = ()=>{
            this.enableEditExperienceIfAvailable();
        };
        this.onFocus = ()=>{
            this.enableEditExperienceIfAvailable();
        };
    }
}

});
parcelRegister("bkl01", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d267a4038ae5345$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $6nWxr = parcelRequire("6nWxr");

var $d16Lt = parcelRequire("d16Lt");

var $c6dcs = parcelRequire("c6dcs");

var $7hM0m = parcelRequire("7hM0m");
const $6d267a4038ae5345$var$FIELD_TYPE = 'status';

// TODO reevaluate phase - forPaint is simply for initial parity
const $6d267a4038ae5345$var$IssueStatusField = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("c3b9g")), {
    moduleId: "./src/packages/issue/fields/status/src/index.tsx"
});
class $6d267a4038ae5345$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(props){
        super(props);
        this.onSuccess = (fieldValue, viaDialog, event)=>{
            const { onChange: onChange, issueKey: issueKey, issueFieldLockControls: issueFieldLockControls } = this.props;
            (0, $c6dcs.trackUpdatedField)(event, $6d267a4038ae5345$var$FIELD_TYPE, this.getDataForAnalytics(fieldValue));
            // issue-field/status type does not have a description but JSD status type expects one
            const status = {
                ...fieldValue,
                description: ''
            };
            onChange && onChange(issueKey, status);
            issueFieldLockControls.onFieldUnlock();
        };
        this.onSubmit = ()=>{
            this.setState({
                inEditState: false
            });
        };
        this.onEditStart = ()=>{
            this.props.issueFieldLockControls.onFieldLock();
            this.setState({
                inEditState: true
            });
        };
        this.onEditCancel = ()=>{
            this.props.issueFieldLockControls.onFieldUnlock();
            this.setState({
                inEditState: false
            });
        };
        this.state = {
            inEditState: false
        };
    }
    getDataForAnalytics(fieldValue) {
        const { value: value } = this.props;
        return {
            ...value ? {
                oldId: value.id,
                oldCategory: value.statusCategory.id
            } : {},
            ...fieldValue ? {
                newId: fieldValue.id,
                newCategory: fieldValue.statusCategory.id
            } : {}
        };
    }
    render() {
        const { value: value, appearance: appearance, issueKey: issueKey, issueFieldLockControls: { onFieldUnlock: onFieldUnlock } } = this.props;
        const status = {
            id: value.id,
            name: value.name,
            statusCategory: value.statusCategory
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7hM0m.default), {
            inEditState: this.state.inEditState
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6nWxr.IssueStatusFieldBoundary), {
            packageName: "issue-table",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d16Lt.StatusLozenge), {
                value: status
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6d267a4038ae5345$var$IssueStatusField, {
            value: status,
            appearance: appearance,
            issueKey: issueKey,
            isOptimistic: false,
            onSubmit: this.onSubmit,
            onSuccess: this.onSuccess,
            onFailure: onFieldUnlock,
            onEditStart: this.onEditStart,
            onEditCancel: this.onEditCancel
        })));
    }
}

});
parcelRegister("6nWxr", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueStatusField", () => $525e34d5896b7f0a$export$ddd324b06f34200);
$parcel$export(module.exports, "IssueStatusFieldBoundary", () => $525e34d5896b7f0a$export$dba9e9c892560f60);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

var $d16Lt = parcelRequire("d16Lt");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $525e34d5896b7f0a$var$AsyncLazyIssueStatusField = (0, $7rh0R.lazy)(()=>(parcelRequire("gaVJL")), {
    moduleId: "./src/packages/issue/fields/status/src/ui/main.tsx"
});
const $525e34d5896b7f0a$export$ddd324b06f34200 = (props)=>{
    const { initialValue: initialValue, value: value } = props;
    const errorProps = {
        initialValue: initialValue,
        value: value
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "issue-field-status",
        packageName: "jira-issue-field-status",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d16Lt.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-status-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d16Lt.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($525e34d5896b7f0a$var$AsyncLazyIssueStatusField, props)));
};
const $525e34d5896b7f0a$export$dba9e9c892560f60 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "issue-status-field",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-status-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("d16Lt", function(module, exports) {

$parcel$export(module.exports, "StatusLozenge", () => $ff16a2437ea95212$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "StatusLozengeWithDropdownIndicator", () => $ff16a2437ea95212$export$9f5070a985b0679b);

var $eUqFw = parcelRequire("eUqFw");

var $2GJ4g = parcelRequire("2GJ4g");
const $ff16a2437ea95212$export$f72db4ad1e9b3e6d = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false
    });
};
const $ff16a2437ea95212$export$9f5070a985b0679b = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        shouldShowDropdownIndication: true
    });
};

});
parcelRegister("2GJ4g", function(module, exports) {

$parcel$export(module.exports, "TEST_ID_PREFIX", () => $0211a3ed28924b4c$export$9cbc201c09a37b3f);
$parcel$export(module.exports, "StatusLozenge", () => $0211a3ed28924b4c$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "WrappedStatusLozenge", () => $0211a3ed28924b4c$export$69ea4907eefa8e7b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $bbaTG = parcelRequire("bbaTG");

var $2ziLQ = parcelRequire("2ziLQ");

var $b5IAe = parcelRequire("b5IAe");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");


var $bR5MV = parcelRequire("bR5MV");

var $9zysr = parcelRequire("9zysr");

var $eI5EY = parcelRequire("eI5EY");

var $8rQuz = parcelRequire("8rQuz");

var $iccsh = parcelRequire("iccsh");

var $aO9ya = parcelRequire("aO9ya");

var $a8LdG = parcelRequire("a8LdG");
const $0211a3ed28924b4c$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
const $0211a3ed28924b4c$var$CustomChevronDownGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: 12,
        height: 12,
        viewBox: "5 5 13 13"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $0211a3ed28924b4c$var$StatusLozengeNew = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StatusContentWrapper, {
        "data-testid": `${$0211a3ed28924b4c$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aO9ya.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StyledLozengeContentWrapper, null, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $0211a3ed28924b4c$var$CustomChevronDownGlyph,
        label: ""
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aO9ya.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, name)), hasHoverState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0211a3ed28924b4c$var$hoverOverlayStyles
    }));
const $0211a3ed28924b4c$var$WrappedStatusLozengeNew = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, ...others } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        xcss: $0211a3ed28924b4c$var$pressableStyles,
        ref: targetRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        ...(0, $eI5EY.fg)('issue-jiv-18579-status-field-interaction-name') ? {
            // When cleaning up we will need to disable the `jira/ufo/valid-labels` lint rule
            // because for this particular interaction we only want to track
            // opening the status popup.
            interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StatusLozengeNew, {
        ...others,
        isEditable: isEditable
    }));
};
const $0211a3ed28924b4c$var$EditableLozenge = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8LdG.LozengeOld), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StyledLozengeContentWrapper, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $0211a3ed28924b4c$var$CustomChevronDownGlyph,
        label: ""
    })));
const $0211a3ed28924b4c$var$StatusLozengeOld = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, targetRef: targetRef, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StyledLozenge, {
        hasHoverState: hasHoverState,
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StatusContentWrapper, {
        ref: targetRef,
        "data-testid": `${$0211a3ed28924b4c$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$EditableLozenge, null, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8LdG.LozengeOld), null, name)));
const $0211a3ed28924b4c$var$WrappedStatusLozengeOld = (props)=>{
    const { ariaLabel: ariaLabel, error: error, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, ...other } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        ref: targetRef,
        appearance: "subtle",
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: 'transparent',
                    margin: 0,
                    width: 'auto',
                    height: 'auto',
                    padding: 0,
                    border: `2px solid ${error ? `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$exports).R300})` : 'transparent'}`,
                    borderRadius: '5px',
                    ...isEditable === true ? undefined : {
                        cursor: 'auto'
                    },
                    outline: 0,
                    boxShadow: `0 0 0 2px ${isOpen === true ? `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$exports).B200})` : 'transparent'}`,
                    '& > span': {
                        margin: 0
                    },
                    '&:focus, &:focus-within': {
                        boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$exports).B200})`}`
                    }
                },
                spinnerStyles: spinnerStyles
            };
        },
        ...(0, $eI5EY.fg)('issue-jiv-18579-status-field-interaction-name') ? {
            // When cleaning up we will need to disable the `jira/ufo/valid-labels` lint rule
            // because for this particular interaction we only want to track
            // opening the status popup.
            interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined
        } : {
            interactionName: 'auto-generated.jira-issue-field-status.common.ui.status-lozenge.button'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StatusLozengeOld, {
        ...other,
        isEditable: isEditable
    }));
};
const $0211a3ed28924b4c$export$f72db4ad1e9b3e6d = (0, $9zysr.componentWithCondition)((0, $8rQuz.isVisualRefreshEnabled), $0211a3ed28924b4c$var$StatusLozengeNew, $0211a3ed28924b4c$var$StatusLozengeOld);
const $0211a3ed28924b4c$export$69ea4907eefa8e7b = (0, $9zysr.componentWithCondition)((0, $8rQuz.isVisualRefreshEnabled), $0211a3ed28924b4c$var$WrappedStatusLozengeNew, $0211a3ed28924b4c$var$WrappedStatusLozengeOld); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0211a3ed28924b4c$var$StyledLozenge = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "wv585u-0"
})`display:flex;align-items:center;> div{display:flex;line-height:initial;outline:0;> span{padding:${"var(--ds-space-025, 2px)"} 0;vertical-align:text-bottom;color:${(props)=>props.isDisabled ? (0, $bR5MV.disabledColor).text : (0, $bR5MV.textColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};background-color:${(props)=>props.isDisabled ? (0, $bR5MV.disabledColor).bg : (0, $bR5MV.bgColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};${(props)=>props.hasHoverState ? `&:hover {
                        color: ${props.isDisabled ? (0, $bR5MV.disabledColor).text : (0, $bR5MV.textHoverColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};
                        background-color: ${props.isDisabled ? (0, $bR5MV.disabledColor).bg : (0, $bR5MV.bgHoverColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};
                    }` : ''};${(props)=>props.isDisabled && (0, $kwce8.css)({
        pointerEvents: 'none'
    })}}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0211a3ed28924b4c$var$StyledLozengeContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o",
            (0, $iccsh.isTabularGridFieldsEnabled)() ? "_1e0c1bgi" : "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0211a3ed28924b4c$var$StatusContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            (0, $iccsh.isTabularGridFieldsEnabled)() ? "_1bsb1osq" : "_1bsb1wug",
            __cmplp.className
        ])
    });
});
const $0211a3ed28924b4c$var$pressableStyles = (0, $1ZAYh.xcss)({
    border: 'none',
    padding: 'space.0',
    borderRadius: '3px',
    background: 'transparent',
    position: 'relative'
});
const $0211a3ed28924b4c$var$hoverOverlayStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    inset: '0',
    borderRadius: '3px',
    ':hover': {
        opacity: 0.3,
        backgroundColor: 'color.background.inverse.subtle'
    }
});

});
parcelRegister("bR5MV", function(module, exports) {

$parcel$export(module.exports, "statusCategoryToThemeMap", () => $0bd810462bafa4a2$export$d9e35f42afe1e488);
$parcel$export(module.exports, "bgColor", () => $0bd810462bafa4a2$export$7dcbec377a25efc6);
$parcel$export(module.exports, "textColor", () => $0bd810462bafa4a2$export$32f78bffcd82ff28);
$parcel$export(module.exports, "bgHoverColor", () => $0bd810462bafa4a2$export$69fdf3ba928b4c77);
$parcel$export(module.exports, "textHoverColor", () => $0bd810462bafa4a2$export$99ec0cf2cf1b2082);
$parcel$export(module.exports, "disabledColor", () => $0bd810462bafa4a2$export$b70f10fc4a6ba453);

const $0bd810462bafa4a2$export$61137dce61763ec3 = 'default';
const $0bd810462bafa4a2$export$132676d06d92ad48 = 'success';
const $0bd810462bafa4a2$export$5c1f3b72419aa125 = 'inprogress';
const $0bd810462bafa4a2$export$d9e35f42afe1e488 = {
    '1': $0bd810462bafa4a2$export$61137dce61763ec3,
    '2': $0bd810462bafa4a2$export$61137dce61763ec3,
    '3': $0bd810462bafa4a2$export$132676d06d92ad48,
    '4': $0bd810462bafa4a2$export$5c1f3b72419aa125
};
const $0bd810462bafa4a2$export$7dcbec377a25efc6 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-background-success, ${(0, $73a5c9d720aa66e1$export$8a6341c32b6a3ee6)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-background-information, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`
};
const $0bd810462bafa4a2$export$32f78bffcd82ff28 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $73a5c9d720aa66e1$export$6fa04827ac68a4fb)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $73a5c9d720aa66e1$export$a6ee3d71bc067634)})`
};
const $0bd810462bafa4a2$export$69fdf3ba928b4c77 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-background-success-hovered, ${(0, $73a5c9d720aa66e1$export$a49394138f7b8e85)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-background-information-hovered, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
};
const $0bd810462bafa4a2$export$99ec0cf2cf1b2082 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`
};
const $0bd810462bafa4a2$export$b70f10fc4a6ba453 = {
    bg: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`,
    text: `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`
};

});

parcelRegister("iccsh", function(module, exports) {

$parcel$export(module.exports, "isTabularGridFieldsEnabled", () => $96fedf0b1762860e$export$9605b1d5fe0c238b);

var $1ybV0 = parcelRequire("1ybV0");
const $96fedf0b1762860e$export$455240e4be839479 = 'jsw.uif.tmp.card.tabular.grid';
const $96fedf0b1762860e$export$9605b1d5fe0c238b = ()=>(0, $1ybV0.ff)($96fedf0b1762860e$export$455240e4be839479, false); // </rkarki>
 // <bento>
 // </bento>

});

parcelRegister("aO9ya", function(module, exports) {

$parcel$export(module.exports, "Lozenge", () => $131033d2f04f07b4$export$a31cbe1bf5463979);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $bR5MV = parcelRequire("bR5MV");

const $131033d2f04f07b4$export$a31cbe1bf5463979 = ({ children: children, statusCategoryId: statusCategoryId, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        appearance: (0, $bR5MV.statusCategoryToThemeMap)[statusCategoryId],
        isBold: true,
        ...isDisabled ? {
            style: {
                color: (0, $bR5MV.disabledColor).text,
                backgroundColor: (0, $bR5MV.disabledColor).bg
            }
        } : {}
    }, children);

});

parcelRegister("a8LdG", function(module, exports) {

$parcel$export(module.exports, "LozengeOld", () => $c24adb58350b577e$export$26089816624d22fc);
// TODO - delete this file when cleaning up visual-refresh

var $eUqFw = parcelRequire("eUqFw");
const $c24adb58350b577e$var$containerStyles = {
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'inline-block',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    maxWidth: '100%',
    padding: 0,
    textTransform: 'uppercase',
    verticalAlign: 'top'
};
const $c24adb58350b577e$var$contentStyles = {
    boxSizing: 'border-box',
    display: 'inline-block',
    maxWidth: 200,
    overflow: 'hidden',
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    width: '100%'
};
const $c24adb58350b577e$export$26089816624d22fc = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $c24adb58350b577e$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $c24adb58350b577e$var$contentStyles
    }, children));
$c24adb58350b577e$export$26089816624d22fc.displayName = 'Lozenge';

});



parcelRegister("gaVJL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("k03Ss")
]).then(()=>parcelRequire('lpHr5'));

});


parcelRegister("c3b9g", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("aAnTw")
]).then(()=>parcelRequire('g2Yce'));

});


parcelRegister("lbWsn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a60f5cb5cfe8fd6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $d16Lt = parcelRequire("d16Lt");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a60f5cb5cfe8fd6b$export$2e2bcd8739ae039 = ({ value: value })=>{
    const status = {
        id: value.id,
        name: value.name,
        statusCategory: value.statusCategory
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d16Lt.StatusLozenge), {
        value: status
    });
};

});


parcelRegister("3hRMA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b3f1e2fdc912645$export$2e2bcd8739ae039);

var $7f2nY = parcelRequire("7f2nY");

var $1Rt1q = parcelRequire("1Rt1q");

var $jdSNR = parcelRequire("jdSNR");
const $5b3f1e2fdc912645$var$mapStateToProps = (state)=>({
        useJSMQueueDurationEvent: (0, $7f2nY.getUseJSMQueueDurationEvent)(state)
    });
const $5b3f1e2fdc912645$var$mergeProps = (stateProps, dispatchProps, ownProps)=>({
        ...ownProps,
        ...stateProps
    });
var $5b3f1e2fdc912645$export$2e2bcd8739ae039 = (0, $1Rt1q.connect)($5b3f1e2fdc912645$var$mapStateToProps, {}, $5b3f1e2fdc912645$var$mergeProps)((0, $jdSNR.default));

});
parcelRegister("jdSNR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5357fc9e7b0daffc$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");

var $dnbhd = parcelRequire("dnbhd");

var $jMP2a = parcelRequire("jMP2a");

var $jU4ta = parcelRequire("jU4ta");
const $5357fc9e7b0daffc$var$linkStyle = ()=>({
        boxShadow: 'none',
        outline: 'none'
    });
class $5357fc9e7b0daffc$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    renderDisabled() {
        const { dataSelectorProps: { value: value }, tableInjectedProps: { isLastColumn: isLastColumn } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jU4ta.UnselectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            paddingBlock: "space.100",
            paddingInline: "space.0"
        }, value));
    }
    render() {
        const { dataSelectorProps: { value: value }, tableInjectedProps: { isLastColumn: isLastColumn, issueKey: issueKey, isTableDisabled: isTableDisabled } } = this.props;
        if (isTableDisabled) return this.renderDisabled();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jU4ta.SelectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5357fc9e7b0daffc$var$Container, {
            isFocused: this.state.isFocused
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $5357fc9e7b0daffc$var$linkStyle(),
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            href: `/browse/${issueKey}`,
            onClick: this.onClick,
            onAuxClick: this.onAuxClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "issue-link",
            'data-issue-key': issueKey
        }, value)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isFocused: false
        };
        this.onFocus = ()=>{
            this.setState({
                isFocused: true
            });
        };
        this.onBlur = ()=>{
            this.setState({
                isFocused: false
            });
        };
        this.onClick = (event, analyticsEvent)=>{
            const { onIssueViewTransition: onIssueViewTransition } = this.props.tableInjectedProps;
            const { useJSMQueueDurationEvent: useJSMQueueDurationEvent } = this.props;
            onIssueViewTransition?.(event);
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'tableIssueLink');
            useJSMQueueDurationEvent && useJSMQueueDurationEvent();
        };
        this.onAuxClick = ()=>{
            const { useJSMQueueDurationEvent: useJSMQueueDurationEvent } = this.props;
            useJSMQueueDurationEvent && useJSMQueueDurationEvent();
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5357fc9e7b0daffc$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt458a2 _1bsb1wug _2rko1l7b _189eyh40 _1dqonqa1 _16qsglyw _12ji1r31 _1qu2glyw _12y31o36",
            __cmplp.isFocused ? "_1h6d194a" : "_1h6d3acm",
            __cmplp.className
        ])
    });
});

});


parcelRegister("k2XWr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3afc108ca818316$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $c3afc108ca818316$var$WorkCategory = (props)=>{
    const { dataSelectorProps: { value: value } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, value);
};
var $c3afc108ca818316$export$2e2bcd8739ae039 = $c3afc108ca818316$var$WorkCategory;

});


parcelRegister("bQN0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cfd3c77778c5122$export$2e2bcd8739ae039);

var $8QWSq = parcelRequire("8QWSq");

var $1Rt1q = parcelRequire("1Rt1q");

var $2RAxi = parcelRequire("2RAxi");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3cfd3c77778c5122$var$mapDispatchToProps = (dispatch, { rowId: rowId })=>({
        // @ts-expect-error - TS7031 - Binding element 'isShiftKeyDown' implicitly has an 'any' type. | TS7031 - Binding element 'selection' implicitly has an 'any' type.
        onChange: ({ isShiftKeyDown: isShiftKeyDown, isSelected: selection }, analyticsEvent)=>dispatch((0, $8QWSq.selectRowAction)({
                rowId: rowId,
                isShiftKeyDown: isShiftKeyDown,
                selection: selection
            }, analyticsEvent))
    });
var $3cfd3c77778c5122$export$2e2bcd8739ae039 = (0, $1Rt1q.connect)(null, $3cfd3c77778c5122$var$mapDispatchToProps)((0, $2RAxi.default));

});
parcelRegister("2RAxi", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5ac92c95df07af8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $3OXzs = parcelRequire("3OXzs");

var $bT7k5 = parcelRequire("bT7k5");

var $2eG9N = parcelRequire("2eG9N");

var $c9TLT = parcelRequire("c9TLT");

var $giAhk = parcelRequire("giAhk");


var $fBSce = parcelRequire("fBSce");

var $jMP2a = parcelRequire("jMP2a");

var $6vrw7 = parcelRequire("6vrw7");

var $b1zB6 = parcelRequire("b1zB6");
const $f5ac92c95df07af8$var$checkboxCellPaddingLeft = `${1.5 * (0, $c9TLT.gridSize)}px`;
// eslint-disable-next-line jira/react/no-class-components
class $f5ac92c95df07af8$var$CheckboxWrapperWithoutIntl extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            Checkbox: (0, $bT7k5.default),
            SelectedIssuesSubscriber: (0, $fBSce.SelectedIssuesSubscriber)
        };
    }
    createOnChange({ selectedIssueKeys: selectedIssueKeys }) {
        return (event, analyticsEvent)=>{
            const { onChange: onChange, rowId: rowId } = this.props; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            const isShiftKeyDown = event.nativeEvent.shiftKey;
            onChange({
                isSelected: !(0, (/*@__PURE__*/$parcel$interopDefault($3OXzs)))(selectedIssueKeys, (0, $6vrw7.toIssueKey)(rowId)),
                isShiftKeyDown: isShiftKeyDown
            }, analyticsEvent);
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueTableBulkActionCheckbox');
        };
    }
    render() {
        const { SelectedIssuesSubscriber: SelectedIssuesSubscriber, rowId: rowId, Checkbox: Checkbox, intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectedIssuesSubscriber, null, ({ issueKeys: issueKeys, limit: limit, isLocked: isLocked })=>{
            const issueKey = (0, $6vrw7.toIssueKey)(rowId);
            const isChecked = (0, (/*@__PURE__*/$parcel$interopDefault($3OXzs)))(issueKeys, issueKey);
            if (isLocked) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5ac92c95df07af8$var$StyledWrapper, {
                isDisabled: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Checkbox, {
                isDisabled: true,
                isChecked: isChecked
            }));
            const isDisabled = !isChecked && issueKeys.length >= limit;
            return isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5ac92c95df07af8$var$StyledWrapper, {
                isDisabled: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Checkbox, {
                isDisabled: true,
                isChecked: isChecked
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
                content: intl.formatMessage((0, $b1zB6.default).maximumReached, {
                    limit: (0, $aaf3e14612d6f36e$export$81a88ed305997a6d)
                }),
                delay: 0,
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5ac92c95df07af8$var$TooltipHolder, null))) : // @ts-expect-error - TS2741 - Property 'isDisabled' is missing in type '{ children: Element; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { isDisabled: boolean; }, any>>'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5ac92c95df07af8$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Checkbox, {
                "aria-label": intl.formatMessage((0, $b1zB6.default).selectThisCheckboxLabel, {
                    issueKey: issueKey
                }),
                isChecked: isChecked,
                onChange: this.createOnChange({
                    selectedIssueKeys: issueKeys
                })
            }));
        });
    }
}
const $f5ac92c95df07af8$export$eef12940a6696c78 = (0, $giAhk.injectIntlV2)($f5ac92c95df07af8$var$CheckboxWrapperWithoutIntl);
var $f5ac92c95df07af8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f5ac92c95df07af8$export$eef12940a6696c78;
const $f5ac92c95df07af8$var$StyledWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1sdlsvv": (0, $9t7rW.default)($f5ac92c95df07af8$var$checkboxCellPaddingLeft),
            "--_jmuphv": (0, $9t7rW.default)(__cmplp.isDisabled ? 'not-allowed' : 'pointer')
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_uiztglyw _kqswh2mm _vchhusvi _1bsb1osq _1yt41ah3 _12ul13s5",
            __cmplp.className
        ])
    });
});
const $f5ac92c95df07af8$var$TooltipHolder = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80om13gf _kqswstnw _154iu2gc _1ltvu2gc _1xi2u2gc _94n5u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bT7k5", function(module, exports) {

$parcel$export(module.exports, "default", () => $562b222d8d94ede5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");


var $eYWZs = parcelRequire("eYWZs");
var $kzlpH = parcelRequire("kzlpH");
var $kbQR9 = parcelRequire("kbQR9");
var $1BPvG = parcelRequire("1BPvG");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $562b222d8d94ede5$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $562b222d8d94ede5$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $1lQG9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eUqFw.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kzlpH.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $562b222d8d94ede5$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eYWZs.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbQR9.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1BPvG.default), null)));
}));
$562b222d8d94ede5$var$Checkbox.displayName = 'Checkbox';
var $562b222d8d94ede5$export$2e2bcd8739ae039 = $562b222d8d94ede5$var$Checkbox;

});
parcelRegister("eYWZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da93fd40e0e88a3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");
function $3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $3da93fd40e0e88a3$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $3da93fd40e0e88a3$export$2e2bcd8739ae039 = $3da93fd40e0e88a3$var$CheckboxIcon;

});

parcelRegister("kzlpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f9422953e9457b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $f4f9422953e9457b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $f4f9422953e9457b$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $f4f9422953e9457b$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $f4f9422953e9457b$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $f4f9422953e9457b$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $f4f9422953e9457b$var$baseStyles,
            label && $f4f9422953e9457b$var$textLabelLayoutStyles,
            isDisabled && $f4f9422953e9457b$var$disabledStyles,
            $f4f9422953e9457b$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("kbQR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $582b6523b23912df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $582b6523b23912df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $582b6523b23912df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $582b6523b23912df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $582b6523b23912df$var$labelTextStyles
    }, children);
}

});

parcelRegister("1BPvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac167f9dd7ee34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $87ac167f9dd7ee34$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $87ac167f9dd7ee34$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $87ac167f9dd7ee34$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("b1zB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $880da7626475c02d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $880da7626475c02d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    maximumReached: {
        "id": "issue-table.common.fields.checkbox.maximum-reached",
        "defaultMessage": "Limit reached ({limit})"
    },
    selectThisCheckboxLabel: {
        "id": "issue-table.common.fields.checkbox.select-this-checkbox-label",
        "defaultMessage": "Select issue ({issueKey})"
    }
});

});



parcelRegister("pbZdv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d449d7d3789bd57$export$2e2bcd8739ae039);

var $df4Sl = parcelRequire("df4Sl");

var $bT7k5 = parcelRequire("bT7k5");

var $fBSce = parcelRequire("fBSce");

var $h0Rgs = parcelRequire("h0Rgs");

var $1Rt1q = parcelRequire("1Rt1q");

var $hE3ZY = parcelRequire("hE3ZY");
const $0d449d7d3789bd57$var$getAllKnownIssueKeysFactory = ()=>(0, $df4Sl.createSelector)((0, $h0Rgs.getAllKnownIssueKeys), (res)=>res);
const $0d449d7d3789bd57$var$mapStateToPropsFactory = ()=>{
    const getAllKnownIssueKeysInstance = $0d449d7d3789bd57$var$getAllKnownIssueKeysFactory();
    return (state)=>({
            allIssueKeys: getAllKnownIssueKeysInstance(state),
            SelectedIssuesSubscriber: $fBSce.SelectedIssuesSubscriber,
            Checkbox: $bT7k5.default
        });
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 1. | TS2345 - Argument of type 'typeof CheckboxWrapper' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$0d449d7d3789bd57$export$2e2bcd8739ae039 = (0, $1Rt1q.connect)($0d449d7d3789bd57$var$mapStateToPropsFactory)((0, $hE3ZY.default));

});
parcelRegister("hE3ZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $763e21231846ae83$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $8blac = parcelRequire("8blac");

var $giAhk = parcelRequire("giAhk");

var $jMP2a = parcelRequire("jMP2a");

var $ddvsY = parcelRequire("ddvsY");
// eslint-disable-next-line jira/react/no-class-components
class $763e21231846ae83$var$CheckboxWrapperWithoutIntl extends (0, $eUqFw.Component) {
    static isSelected(state) {
        const { issueKeys: issueKeys } = state;
        // for isIndeterminate to work, we must always also set isSelected. Thus, this condition becomes very simple.
        return !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(issueKeys);
    }
    isIndeterminate(state) {
        const { issueKeys: issueKeys } = state;
        const { allIssueKeys: allIssueKeys } = this.props;
        return issueKeys.length !== allIssueKeys.length && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(issueKeys);
    }
    createOnChange(state, actions) {
        return (e, analyticsEvent)=>{
            const { issueKeys: issueKeys } = state;
            const { allIssueKeys: allIssueKeys } = this.props;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(issueKeys)) {
                actions.selectIssues(allIssueKeys, analyticsEvent);
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueTableHeaderBulkActionCheckbox', {
                    usage: 'selectAll'
                });
            } else {
                // allIssueKeys not guaranteed to contain all issueKeys
                actions.deselectAllIssues(analyticsEvent);
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueTableHeaderBulkActionCheckbox', {
                    usage: 'deselectAll'
                });
            }
        };
    }
    render() {
        const { SelectedIssuesSubscriber: SelectedIssuesSubscriber, Checkbox: Checkbox, intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectedIssuesSubscriber, null, (state, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($763e21231846ae83$var$StyledWrapper, {
                isDisabled: state.isLocked
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Checkbox, {
                "aria-label": intl.formatMessage((0, $ddvsY.default).selectAllCheckboxLabel),
                isDisabled: state.isLocked,
                isChecked: $763e21231846ae83$var$CheckboxWrapperWithoutIntl.isSelected(state),
                isIndeterminate: this.isIndeterminate(state),
                // @ts-expect-error - TS2345 - Argument of type 'BoundActions<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/issue-table-selection/src/services/actions/index")>' is not assignable to parameter of type 'typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/issue-table-selection/src/services/actions/index")'.
                onChange: this.createOnChange(state, actions)
            })));
    }
}
const $763e21231846ae83$export$eef12940a6696c78 = (0, $giAhk.injectIntlV2)($763e21231846ae83$var$CheckboxWrapperWithoutIntl);
var $763e21231846ae83$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $763e21231846ae83$export$eef12940a6696c78;
const $763e21231846ae83$var$StyledWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_jmuphv": (0, $9t7rW.default)(__cmplp.isDisabled ? 'not-allowed' : 'pointer')
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_uiztglyw _vchhusvi _1bsb1osq _1yt4hx2x _12ul13s5",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ddvsY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7df90e395233e8dd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7df90e395233e8dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    selectAllCheckboxLabel: {
        "id": "issue-table.common.fields.checkbox.header.select-all-checkbox-label",
        "defaultMessage": "Select all issues"
    }
});

});



parcelRegister("2GeIJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5d8376e7b071926$export$2e2bcd8739ae039);

var $c8Guq = parcelRequire("c8Guq");

var $8un0w = parcelRequire("8un0w");

var $47a3k = parcelRequire("47a3k");

var $1Rt1q = parcelRequire("1Rt1q");

var $cqGKA = parcelRequire("cqGKA");

var $6YP9W = parcelRequire("6YP9W");
const $f5d8376e7b071926$var$mapStateToProps = (state, ownProps)=>{
    const { columnId: columnId } = ownProps;
    const onSortOrderChange = (0, $47a3k.getOnSortOrderChanged)(state, columnId);
    const sortOrder = (0, $47a3k.getCurrentSorting)(state, columnId);
    let isSortable = false;
    if (onSortOrderChange) isSortable = true;
    return {
        columnName: (0, $47a3k.maybeColumnTitle)(state, columnId).orSome(''),
        fieldType: (0, $47a3k.getFieldType)(state, columnId),
        sortOrder: sortOrder,
        isDisabled: (0, $47a3k.isDisabled)(state, columnId) && sortOrder,
        onSortOrderChange: onSortOrderChange,
        isSortable: isSortable
    };
};
var $f5d8376e7b071926$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $8un0w.default)({
    onSortOrderChange: (fieldId, sortOrder)=>({
            name: 'sortOrderChange',
            fieldId: fieldId,
            sortOrder: sortOrder
        })
}), (0, $cqGKA.ReduxAnalyticsData)((state, ownProps)=>({
        attributes: {
            fieldId: (0, $47a3k.getFieldType)(state, ownProps.columnId)
        }
    })), // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 1.
(0, $1Rt1q.connect)($f5d8376e7b071926$var$mapStateToProps))((0, $6YP9W.default));

});
parcelRegister("47a3k", function(module, exports) {

$parcel$export(module.exports, "getColumns", () => $e45952126629b320$export$978e30a0fb8610d8);
$parcel$export(module.exports, "maybeColumnTitle", () => $e45952126629b320$export$7929a97abf07197e);
$parcel$export(module.exports, "getColumnTitle", () => $e45952126629b320$export$7fd4bf39bc1fa7d6);
$parcel$export(module.exports, "getCurrentSorting", () => $e45952126629b320$export$d31773bdd38d8c2c);
$parcel$export(module.exports, "isDisabled", () => $e45952126629b320$export$30e0dc115df457ed);
$parcel$export(module.exports, "getFieldType", () => $e45952126629b320$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "getOnSortOrderChanged", () => $e45952126629b320$export$7d6c76fc2d097cc2);
$parcel$export(module.exports, "isLastColumn", () => $e45952126629b320$export$e509b4c22370e953);
$parcel$export(module.exports, "isColumnKnown", () => $e45952126629b320$export$265a5752f4c87727);

var $df4Sl = parcelRequire("df4Sl");

var $8i1R8 = parcelRequire("8i1R8");

var $7Oh8q = parcelRequire("7Oh8q");

var $9jIiv = parcelRequire("9jIiv");
const $e45952126629b320$export$978e30a0fb8610d8 = (state)=>(0, $9jIiv.getPersisted)(state).columns;
const $e45952126629b320$export$46d040b9076e32ab = (state, columnId)=>(0, $7Oh8q.Maybe).fromNull((0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))($e45952126629b320$export$978e30a0fb8610d8(state), {
        id: columnId
    }));
const $e45952126629b320$export$7929a97abf07197e = (state, columnId)=>// @ts-expect-error - TS7006 - Parameter 'column' implicitly has an 'any' type.
    $e45952126629b320$export$46d040b9076e32ab(state, columnId).map((column)=>column.title);
const $e45952126629b320$export$7fd4bf39bc1fa7d6 = (state, columnId)=>$e45952126629b320$export$7929a97abf07197e(state, columnId).orSome('');
const $e45952126629b320$export$d31773bdd38d8c2c = (state, columnId)=>$e45952126629b320$export$46d040b9076e32ab(state, columnId)// @ts-expect-error - TS7006 - Parameter 'column' implicitly has an 'any' type.
    .flatMap((column)=>(0, $7Oh8q.Maybe).fromNull(column.currentSorting)).cata(()=>undefined, // @ts-expect-error - TS7006 - Parameter 'order' implicitly has an 'any' type.
    (order)=>order);
const $e45952126629b320$export$30e0dc115df457ed = (state, columnId)=>$e45952126629b320$export$46d040b9076e32ab(state, columnId)// @ts-expect-error - TS7006 - Parameter 'column' implicitly has an 'any' type.
    .flatMap((column)=>(0, $7Oh8q.Maybe).fromNull(column.isDisabled)).cata(()=>false, // @ts-expect-error - TS7006 - Parameter 'disabled' implicitly has an 'any' type.
    (disabled)=>disabled);
const $e45952126629b320$export$b9089a6e41ed43aa = (state, columnId)=>$e45952126629b320$export$46d040b9076e32ab(state, columnId)// @ts-expect-error - TS7006 - Parameter 'column' implicitly has an 'any' type.
    .map((column)=>column.fieldType).orSome('');
const $e45952126629b320$export$932a39ca74873b9d = (state, columnId)=>// @ts-expect-error - TS7006 - Parameter 'column' implicitly has an 'any' type.
    $e45952126629b320$export$46d040b9076e32ab(state, columnId).flatMap((column)=>(0, $7Oh8q.Maybe).fromNull(column.onSortOrderChanged));
const $e45952126629b320$export$7d6c76fc2d097cc2 = (state, columnId)=>$e45952126629b320$export$932a39ca74873b9d(state, columnId).cata(()=>undefined, // @ts-expect-error - TS7006 - Parameter 'callback' implicitly has an 'any' type.
    (callback)=>callback);
const $e45952126629b320$export$e509b4c22370e953 = (state, columnId)=>{
    const columns = $e45952126629b320$export$978e30a0fb8610d8(state);
    return columns.length > 0 && columns[columns.length - 1].id === columnId;
};
const $e45952126629b320$var$indexColumnIds = (0, $df4Sl.createSelector)($e45952126629b320$export$978e30a0fb8610d8, (columns)=>new Set(columns.map((column)=>column.id)));
const $e45952126629b320$export$265a5752f4c87727 = (state, columnId)=>$e45952126629b320$var$indexColumnIds(state).has(columnId);

});

parcelRegister("cqGKA", function(module, exports) {

$parcel$export(module.exports, "ReduxAnalyticsData", () => $45a4789cb44e106f$export$eb16d2484452fbaa);

var $6rCaY = parcelRequire("6rCaY");

var $1Rt1q = parcelRequire("1Rt1q");
const $45a4789cb44e106f$export$eb16d2484452fbaa = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToAnalytics, { storeKey: storeKey, ...restConnectOptions } = {})=>(0, $6rCaY.default)(mapStateToAnalytics, {
        ...restConnectOptions,
        context: (0, $1Rt1q.IssueTableContext)
    });

});

parcelRegister("6YP9W", function(module, exports) {

$parcel$export(module.exports, "default", () => $b97128e80506ec31$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7u4fN = parcelRequire("7u4fN");

var $2ziLQ = parcelRequire("2ziLQ");


var $c9TLT = parcelRequire("c9TLT");

var $giAhk = parcelRequire("giAhk");

var $kOaxk = parcelRequire("kOaxk");


var $l21t5 = parcelRequire("l21t5");

var $bgD5e = parcelRequire("bgD5e");
const $b97128e80506ec31$var$ascendingGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 25"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M10.7 16.7v-5.6l-1.3 1.3c-.4.4-1 .4-1.4 0-.2-.2-.3-.5-.3-.7 0-.3.1-.5.3-.7l3-3c.2-.2.5-.3.7-.3.3 0 .5.1.7.3l3 3c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-1.3-1.3v5.6c0 .6-.5 1-1 1s-1-.5-1-1z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
    }));
const $b97128e80506ec31$var$descendingGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 25"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.7 8.7v5.6L14 13c.4-.4 1-.4 1.4 0 .2.2.3.5.3.7 0 .3-.1.5-.3.7l-3 3c-.2.2-.5.3-.7.3-.3 0-.5-.1-.7-.3l-3-3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l1.3 1.3V8.7c0-.6.4-1 1-1s1 .4 1 1z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
    }));
class $b97128e80506ec31$export$99f5cf69b7ccb3ed extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isDefaultSortOrder: false,
            allowClearingSort: false,
            sortOrder: (0, $e6571ec563c0baf9$export$c53d0f541b41b88e),
            width: undefined,
            onSortOrderChange: undefined
        };
    }
    onKeyDownCapture(event) {
        if (event.key === 'Enter') event.stopPropagation();
    }
    getTooltipText(columnName) {
        if (typeof columnName === 'string') return `${columnName} \u{2022} ${this.getSortOrderTooltipText()}`;
        return this.getSortOrderTooltipText();
    }
    getSortOrderTooltipText() {
        switch(this.props.sortOrder){
            case 0, $e6571ec563c0baf9$export$c53d0f541b41b88e:
                return this.getNoOrderTooltipText();
            case 0, $e6571ec563c0baf9$export$1dee026a19752d6b:
                return this.getAscOrderTooltipText();
            case 0, $e6571ec563c0baf9$export$b6abcf7fa1d94f65:
                return this.getDescOrderTooltipText();
            default:
                return 'Invalid state';
        }
    }
    getNoOrderTooltipText() {
        const { fieldType: fieldType, intl: { formatMessage: format } } = this.props;
        const fieldConfigs = (0, $kOaxk.default)[fieldType];
        if (fieldConfigs && fieldConfigs.ascText) return format((0, $l21t5.default).sortOrder, {
            sortOrder: format(fieldConfigs.ascText)
        });
        return format((0, $l21t5.default).defaultSortOrder, {
            isAscending: true
        });
    }
    getAscOrderTooltipText() {
        const { fieldType: fieldType, isDefaultSortOrder: isDefaultSortOrder, intl: { formatMessage: format } } = this.props;
        const fieldConfigs = (0, $kOaxk.default)[fieldType];
        if (fieldConfigs && fieldConfigs.ascText) return format((0, $l21t5.default).sortedOrder, {
            sortOrder: format(fieldConfigs.ascText),
            isDefault: isDefaultSortOrder
        });
        return format((0, $l21t5.default).defaultSortedOrder, {
            isAscending: true,
            isDefault: isDefaultSortOrder
        });
    }
    getDescOrderTooltipText() {
        const { fieldType: fieldType, isDefaultSortOrder: isDefaultSortOrder, intl: { formatMessage: format } } = this.props;
        const fieldConfigs = (0, $kOaxk.default)[fieldType];
        if (fieldConfigs && fieldConfigs.descText) return format((0, $l21t5.default).sortedOrder, {
            sortOrder: format(fieldConfigs.descText),
            isDefault: isDefaultSortOrder
        });
        return format((0, $l21t5.default).defaultSortedOrder, {
            isAscending: false,
            isDefault: isDefaultSortOrder
        });
    }
    getNextSortOrder(currentSortOrder) {
        switch(currentSortOrder){
            case 0, $e6571ec563c0baf9$export$c53d0f541b41b88e:
                return 0, $e6571ec563c0baf9$export$1dee026a19752d6b;
            case 0, $e6571ec563c0baf9$export$1dee026a19752d6b:
                return 0, $e6571ec563c0baf9$export$b6abcf7fa1d94f65;
            case 0, $e6571ec563c0baf9$export$b6abcf7fa1d94f65:
            default:
                return this.props.allowClearingSort ? (0, $e6571ec563c0baf9$export$c53d0f541b41b88e) : (0, $e6571ec563c0baf9$export$1dee026a19752d6b);
        }
    }
    getHeaderIcon() {
        switch(this.props.sortOrder){
            case 0, $e6571ec563c0baf9$export$1dee026a19752d6b:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
                    glyph: $b97128e80506ec31$var$ascendingGlyph,
                    label: "Ascending icon",
                    size: "medium"
                });
            case 0, $e6571ec563c0baf9$export$b6abcf7fa1d94f65:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
                    glyph: $b97128e80506ec31$var$descendingGlyph,
                    label: "Descending icon",
                    size: "medium"
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
                    glyph: $b97128e80506ec31$var$ascendingGlyph,
                    label: "Sort-by icon",
                    size: "medium",
                    primaryColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N60})`
                });
        }
    }
    getButtonWithTooltip() {
        const { columnName: columnName, sortOrder: sortOrder, width: width, isDisabled: isDisabled } = this.props;
        const buttonAppearance = sortOrder === (0, $e6571ec563c0baf9$export$c53d0f541b41b88e) ? 'subtle' : 'default';
        const isHeaderSelected = sortOrder !== (0, $e6571ec563c0baf9$export$c53d0f541b41b88e);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bgD5e.default), {
            isSortOrderChanged: this.state.sortOrderChanged,
            tooltipText: this.getTooltipText(columnName),
            onShow: this.onSortOrderTooltipShow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: buttonAppearance,
            onClick: this.onSortOrderChange,
            spacing: "none",
            isDisabled: isDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b97128e80506ec31$var$HeaderContent, {
            hasIcon: isHeaderSelected,
            hasFixedWidth: !!width
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b97128e80506ec31$var$HeaderText, {
            hasIcon: isHeaderSelected,
            maxWidth: width
        }, columnName), /* The icon must be part of the tooltip target, so we can't use the
                               `iconAfter` prop of the atlaskit button */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b97128e80506ec31$var$IconWrapper, {
            isVisible: isHeaderSelected
        }, this.getHeaderIcon()))));
    }
    render() {
        const { isSortable: isSortable, columnName: columnName, width: width, isDisabled: isDisabled } = this.props;
        if (isSortable || isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b97128e80506ec31$var$HeaderWrapperExperiment, {
            onKeyDownCapture: this.onKeyDownCapture,
            "data-component-selector": "header-wrapper-experiment-component-selector"
        }, this.getButtonWithTooltip());
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b97128e80506ec31$var$PlainHeader, {
            maxWidth: width
        }, columnName);
    }
    constructor(...args){
        super(...args);
        this.state = {
            sortOrderChanged: false
        };
        this.onSortOrderChange = (e, analyticsEvent)=>{
            const { onSortOrderChange: onSortOrderChange, sortOrder: sortOrder, columnId: columnId } = this.props;
            const nextSortOrder = this.getNextSortOrder(sortOrder);
            onSortOrderChange && onSortOrderChange(columnId, nextSortOrder, analyticsEvent);
            this.setState({
                sortOrderChanged: true
            });
        };
        this.onSortOrderTooltipShow = ()=>{
            this.setState({
                sortOrderChanged: false
            });
        };
    }
}
var $b97128e80506ec31$export$2e2bcd8739ae039 /* Icon also appears under these pseudo-classes */  = (0, $giAhk.injectIntlV2)($b97128e80506ec31$export$99f5cf69b7ccb3ed);
const $b97128e80506ec31$var$addWhenInteracted = 'button:focus &, [data-component-selector="header-wrapper-experiment-component-selector"]:hover &'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b97128e80506ec31$var$HeaderWrapperExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _z29h2jkb _1m1b1r31 _lt2an7od _1twe1o36 _1s3gn7od",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b97128e80506ec31$var$HeaderContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasFixedWidth: hasFixedWidth, hasIcon: hasIcon, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_t94dt9": (0, $9t7rW.default)(`${"var(--ds-space-0, 0px)"} ${__cmplp.hasFixedWidth || __cmplp.hasIcon ? "var(--ds-space-0, 0px)" : "var(--ds-space-300, 24px)"} ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-100, 8px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _1e0c1txw _1yt41d6p _y3gn1e5h _1v7oze3t _3myyze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b97128e80506ec31$var$HeaderText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxWidth: maxWidth, hasIcon: hasIcon, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_e2mome": (0, $9t7rW.default)(__cmplp.maxWidth - (0, $c9TLT.gridSize) * (__cmplp.hasIcon ? 5 : 2), "px"),
            "--_uyt2xi": (0, $9t7rW.default)(__cmplp.maxWidth - (0, $c9TLT.gridSize) * 5, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _vwz41tcg _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.maxWidth && "_p12f1388",
            __cmplp.maxWidth && "_1i461gch _123n1gch",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b97128e80506ec31$var$PlainHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxWidth: maxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $9t7rW.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1a45 _vwz41tcg _1yt4h8dc _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.maxWidth && "_p12f1ayu",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b97128e80506ec31$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16q71kw7 _1dhe1kw7",
            __cmplp.isVisible ? "_1e0c1kw7" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kOaxk", function(module, exports) {

$parcel$export(module.exports, "default", () => $61821f262752e684$export$2e2bcd8739ae039);

var $fAGPG = parcelRequire("fAGPG");
// Map system field ids and custom field types to their configurations: max width, min width, asc text, desc text, etc.
const $61821f262752e684$var$fieldConfigurationsMap = {
    assignee: {
        ascText: (0, $fAGPG.default).aToZOrder,
        descText: (0, $fAGPG.default).zToAOrder
    },
    reporterWithIcon: {
        ascText: (0, $fAGPG.default).aToZOrder,
        descText: (0, $fAGPG.default).zToAOrder
    },
    'com.atlassian.servicedesk:sd-sla-field': {
        ascText: (0, $fAGPG.default).shortestToLongestOrder,
        descText: (0, $fAGPG.default).longestToShortestOrder
    },
    components: {
        ascText: (0, $fAGPG.default).aToZOrder,
        descText: (0, $fAGPG.default).zToAOrder
    },
    created: {
        ascText: (0, $fAGPG.default).oldestToNewestOrder,
        descText: (0, $fAGPG.default).newestToOldestOrder
    },
    issuekey: {
        ascText: (0, $fAGPG.default).aToZOrder,
        descText: (0, $fAGPG.default).zToAOrder
    },
    issuetype: {
        ascText: (0, $fAGPG.default).aToZOrder,
        descText: (0, $fAGPG.default).zToAOrder
    },
    reporter: {
        ascText: (0, $fAGPG.default).aToZOrder,
        descText: (0, $fAGPG.default).zToAOrder
    },
    summary: {
        ascText: (0, $fAGPG.default).aToZOrder,
        descText: (0, $fAGPG.default).zToAOrder
    },
    updated: {
        ascText: (0, $fAGPG.default).oldestToNewestOrder,
        descText: (0, $fAGPG.default).newestToOldestOrder
    },
    date: {
        ascText: (0, $fAGPG.default).oldestToNewestOrder,
        descText: (0, $fAGPG.default).newestToOldestOrder
    }
};
var $61821f262752e684$export$2e2bcd8739ae039 = $61821f262752e684$var$fieldConfigurationsMap;

});
parcelRegister("fAGPG", function(module, exports) {

$parcel$export(module.exports, "default", () => $488305cd31d34f19$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $488305cd31d34f19$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    aToZOrder: {
        "id": "issue-table.model.fields.field-configurations-map.a-to-z-order",
        "defaultMessage": "A \u2192 Z"
    },
    zToAOrder: {
        "id": "issue-table.model.fields.field-configurations-map.z-to-a-order",
        "defaultMessage": "Z \u2192 A"
    },
    oldestToNewestOrder: {
        "id": "issue-table.model.fields.field-configurations-map.oldest-to-newest-order",
        "defaultMessage": "oldest \u2192 newest"
    },
    newestToOldestOrder: {
        "id": "issue-table.model.fields.field-configurations-map.newest-to-oldest-order",
        "defaultMessage": "newest \u2192 oldest"
    },
    shortestToLongestOrder: {
        "id": "issue-table.model.fields.field-configurations-map.shortest-to-longest-order",
        "defaultMessage": "shortest \u2192 longest"
    },
    longestToShortestOrder: {
        "id": "issue-table.model.fields.field-configurations-map.longest-to-shortest-order",
        "defaultMessage": "longest \u2192 shortest"
    },
    lowestToHighestOrder: {
        "id": "issue-table.model.fields.field-configurations-map.lowest-to-highest-order",
        "defaultMessage": "lowest \u2192 highest"
    },
    highestToLowestOrder: {
        "id": "issue-table.model.fields.field-configurations-map.highest-to-lowest-order",
        "defaultMessage": "highest \u2192 lowest"
    }
});

});


parcelRegister("l21t5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7231945e45c842d7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7231945e45c842d7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sortedOrder: {
        "id": "issue-table.common.sort-column-header.sorted-order",
        "defaultMessage": "Sorted {sortOrder} {isDefault, select, \n                true {(Default)}\n                other {}\n            }"
    },
    sortOrder: {
        "id": "issue-table.common.sort-column-header.sort-order",
        "defaultMessage": "Sort {sortOrder}"
    },
    defaultSortedOrder: {
        "id": "issue-table.common.sort-column-header.default-sorted-order",
        "defaultMessage": "Sorted in {isAscending, select, \n                true {ascending} \n                other {descending}\n            } order {isDefault, select, \n                true {(Default)}\n                other {}\n            }"
    },
    defaultSortOrder: {
        "id": "issue-table.common.sort-column-header.default-sort-order",
        "defaultMessage": "Sort in {isAscending, select, \n                true {ascending} \n                other {descending}\n            } order"
    }
});

});

parcelRegister("bgD5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e2a5260d62583d7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2eG9N = parcelRequire("2eG9N");
const $5e2a5260d62583d7$var$SORT_ORDER_CHANGED_TOOLTIP_DELAY = 0;
const $5e2a5260d62583d7$var$TOOLTIP_DELAY = 1000;
const $5e2a5260d62583d7$var$TOOLTIP_POSITION = 'top';
class $5e2a5260d62583d7$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static getDerivedStateFromProps(nextProps, state) {
        if (nextProps.isSortOrderChanged) return {
            // force re-rendering the tooltip component to let the new delay value take into effect
            tooltipComponentKey: state.tooltipComponentKey + 1
        };
        return null;
    }
    render() {
        const { isSortOrderChanged: isSortOrderChanged, tooltipText: tooltipText, children: children } = this.props;
        const delay = isSortOrderChanged ? $5e2a5260d62583d7$var$SORT_ORDER_CHANGED_TOOLTIP_DELAY : $5e2a5260d62583d7$var$TOOLTIP_DELAY;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            delay: delay,
            position: $5e2a5260d62583d7$var$TOOLTIP_POSITION,
            content: tooltipText,
            onShow: this.onShow,
            key: this.state.tooltipComponentKey
        }, children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            tooltipComponentKey: 0
        };
        this.onShow = ()=>{
            this.props.onShow && this.props.onShow();
        };
    }
}

});






parcelRegister("ckmCH", function(module, exports) {

$parcel$export(module.exports, "default", () => $50e37f08f8d5a1bb$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $1JOCh = parcelRequire("1JOCh");

var $fqTVa = parcelRequire("fqTVa");
var // @ts-expect-error - No overload matches this call
$50e37f08f8d5a1bb$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $fqTVa.default), (0, $1JOCh.default));

});
parcelRegister("1JOCh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f35052fa55639b69$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $4W3Gm = parcelRequire("4W3Gm");
var $f35052fa55639b69$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $4W3Gm.default));

});
parcelRegister("4W3Gm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3395e241f1b82172$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("iects");
parcelRequire("1Lcr1");
parcelRequire("8OtG5");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $hs2qb = parcelRequire("hs2qb");

var $88MUq = parcelRequire("88MUq");

var $d7xzx = parcelRequire("d7xzx");

var $7f2nY = parcelRequire("7f2nY");
let $3395e241f1b82172$var$cachedAssigneeInitializationResponse;
const $3395e241f1b82172$export$6e5dca841bdf93e3 = ()=>{
    $3395e241f1b82172$var$cachedAssigneeInitializationResponse = undefined;
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$3395e241f1b82172$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $88MUq.INITIALIZE_COLUMN)).filter((action)=>action.payload.column.fieldType === 'assignee').switchMap(()=>{
        if ((0, $7f2nY.isTableDisabled)(store.getState())) return (0, $3JafE.Observable).empty();
        if ($3395e241f1b82172$var$cachedAssigneeInitializationResponse) return (0, $3JafE.Observable).of((0, $d7xzx.setAssigneeInitializationStateAction)($3395e241f1b82172$var$cachedAssigneeInitializationResponse));
        return (0, $hs2qb.default)().mergeMap((response)=>{
            $3395e241f1b82172$var$cachedAssigneeInitializationResponse = response;
            return (0, $3JafE.Observable).of((0, $d7xzx.setAssigneeInitializationStateAction)(response));
        }).catch((error)=>{
            (0, $gUUjF.default).safeWarnWithoutCustomerData('issue-table.ops.field.initialize.assignee', `Failed to initialize assignee. Received status code ${error.statusCode}`);
            return (0, $3JafE.Observable).empty();
        });
    });

});
parcelRegister("hs2qb", function(module, exports) {

$parcel$export(module.exports, "default", () => $adc612e3e66c1931$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");

var $4d2CX = parcelRequire("4d2CX");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$adc612e3e66c1931$export$2e2bcd8739ae039 = ()=>(0, $4d2CX.getCurrentUser$)().mergeMap((response)=>(0, $3JafE.Observable).of({
            avatarUrl: response.avatarUrls['48x48'],
            displayName: response.displayName,
            emailAddress: response.emailAddress
        }));

});
parcelRegister("4d2CX", function(module, exports) {

$parcel$export(module.exports, "getCurrentUser$", () => $5fcb838e68e80e59$export$87b9ee5a2e330d07);

var $aiRd8 = parcelRequire("aiRd8");
const $5fcb838e68e80e59$export$87b9ee5a2e330d07 = ()=>(0, $aiRd8.default)('/rest/api/3/myself', {
        method: 'GET'
    });

});




parcelRegister("fqTVa", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cf0fc5316b93f90$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $gMqUU = parcelRequire("gMqUU");

var $5V0mM = parcelRequire("5V0mM");
var $7cf0fc5316b93f90$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $5V0mM.default), (0, $gMqUU.default));

});
parcelRegister("gMqUU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8eeb9c94d284ec60$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("3wBUP");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $gjOW8 = parcelRequire("gjOW8");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$8eeb9c94d284ec60$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $gjOW8.FIELD_UPDATE_FAILURE)).switchMap((action)=>{
        const { fieldType: fieldType, failureReason: failureReason } = action.payload;
        if (failureReason.type === (0, $gjOW8.ERROR_RESPONSE)) {
            const { statusCode: statusCode } = failureReason;
            (0, $guiFP.default)({
                meta: {
                    id: 'opsFieldUpdate',
                    packageName: 'jiraIssueTable',
                    teamName: 'jsd-shield'
                },
                attributes: {
                    message: 'Error response from server attempting to update field value',
                    statusCode: statusCode,
                    fieldType: fieldType
                }
            });
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-table.ops.field.update', `[FD-3358] Error response from server attempting to update field value. statusCode: [${statusCode}], fieldType: [${fieldType}]`);
        } else {
            (0, $guiFP.default)({
                meta: {
                    id: 'opsFieldUpdate',
                    packageName: 'jiraIssueTable',
                    teamName: 'jsd-shield'
                },
                attributes: {
                    message: 'Unknown error attempting to update field value.',
                    fieldType: fieldType
                }
            });
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-table.ops.field.update', `[FD-3358] Unknown error attempting to update field value. fieldType: [${fieldType}]`);
        }
        return (0, $3JafE.Observable).empty();
    });

});

parcelRegister("5V0mM", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dcaca9d2aaf59dd$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $c6dcs = parcelRequire("c6dcs");

var $gjOW8 = parcelRequire("gjOW8");

var $47a3k = parcelRequire("47a3k");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$2dcaca9d2aaf59dd$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $gjOW8.FIELD_UPDATE_SUBMIT)).switchMap((action)=>{
        const state = store.getState();
        const { issueKey: issueKey, fieldId: fieldId, fieldValue: fieldValue, onSuccess: onSuccess, onFailure: onFailure } = action.payload;
        return (0, $c6dcs.updateFieldValue$)(issueKey, fieldId, fieldValue).mergeMap(()=>{
            onSuccess(fieldValue);
            return (0, $3JafE.Observable).of((0, $gjOW8.updateFieldSuccessAction)(issueKey, fieldId));
        }).catch((error)=>{
            onFailure();
            return (0, $3JafE.Observable).of((0, $gjOW8.updateFieldFailureErrorResponseAction)(issueKey, fieldId, fieldValue.fieldType, (0, $47a3k.getColumnTitle)(state, fieldId), error));
        });
    });

});



parcelRegister("iTXqj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7272daff8bc58b8e$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $le0XB = parcelRequire("le0XB");
var $7272daff8bc58b8e$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $le0XB.default));

});
parcelRegister("le0XB", function(module, exports) {

$parcel$export(module.exports, "default", () => $33c25805c5fe6fca$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $jMP2a = parcelRequire("jMP2a");

var $8MLGs = parcelRequire("8MLGs");

var $fMHj9 = parcelRequire("fMHj9");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$33c25805c5fe6fca$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $8MLGs.ISSUE_EDIT_STARTED)).switchMap((action)=>{
        const { fieldType: fieldType, issueKey: issueKey } = action.payload;
        const { analyticsEvent: analyticsEvent } = action.meta;
        const state = store.getState();
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'tableRow locked', {
            fieldType: fieldType,
            lockedIssuesCount: (0, $fMHj9.getLockedIssueCountAssumingIssueKeyWillBeLocked)(state, issueKey)
        });
        return (0, $3JafE.Observable).empty();
    });

});


parcelRegister("e9G4b", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee6c59a6ba5e1d88$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $7988s = parcelRequire("7988s");
var $ee6c59a6ba5e1d88$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $7988s.default));

});
parcelRegister("7988s", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d3424c9102baeeb$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");


var $jyIFK = parcelRequire("jyIFK");

var $b5o6E = parcelRequire("b5o6E");

var $7f2nY = parcelRequire("7f2nY");
const $2d3424c9102baeeb$export$3869e16e736a9111 = (prevShowPagination, offsetFromBottom, totalPages)=>{
    if (totalPages > 1) return(// If pagination is already shown but the table has not been scrolled back up enough
    prevShowPagination && offsetFromBottom < (0, $6e1a998ae5fb6552$export$ad4eb70d85e8e21f) || // Or, if no pagination is shown and table has been scrolled to the bottom
    !prevShowPagination && offsetFromBottom === 0);
    return false;
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$2d3424c9102baeeb$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $jyIFK.UPDATE_VERTICAL_OFFSET)).switchMap((action)=>{
        const { totalPages: totalPages, verticalPosition: verticalPosition, onVerticalScrollOffsetChanged: onVerticalScrollOffsetChanged } = action.payload;
        const showPagination = (0, $7f2nY.shouldShowPagination)(store.getState());
        const { offsetFromTop: offsetFromTop, offsetFromBottom: offsetFromBottom } = verticalPosition;
        const nextShowPagination = $2d3424c9102baeeb$export$3869e16e736a9111(showPagination, offsetFromBottom, totalPages);
        onVerticalScrollOffsetChanged && onVerticalScrollOffsetChanged(verticalPosition);
        // @ts-expect-error - TS2304 - Cannot find name 'SetVerticalOffsetAction'. | TS2304 - Cannot find name 'SetPaginationVisibilityAction'.
        const actions = [];
        if (nextShowPagination !== showPagination) actions.push((0, $b5o6E.setPaginationVisibility)(nextShowPagination));
        actions.push((0, $jyIFK.setVerticalOffsetAction)(offsetFromTop));
        return (0, $3JafE.Observable).of(...actions);
    });

});



parcelRegister("fECcE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7297aaa9db4e2d3a$export$2e2bcd8739ae039);

var $jyIFK = parcelRequire("jyIFK");

var $47a3k = parcelRequire("47a3k");

var $h0Rgs = parcelRequire("h0Rgs");

var $7ZrT1 = parcelRequire("7ZrT1");

var $7f2nY = parcelRequire("7f2nY");

var $1Rt1q = parcelRequire("1Rt1q");

var $93N85 = parcelRequire("93N85");

var $lbUvA = parcelRequire("lbUvA");

var $j4t2m = parcelRequire("j4t2m");
const $7297aaa9db4e2d3a$var$mapStateToProps = (state)=>({
        Table: $lbUvA.default,
        columns: (0, $47a3k.getColumns)(state),
        Pagination: $93N85.default,
        showPagination: (0, $7f2nY.shouldShowPagination)(state),
        editingFieldHorizontalOffset: (0, $7f2nY.getEditingFieldHorizontalOffset)(state),
        editingFieldVerticalOffset: (0, $7f2nY.getEditingFieldVerticalOffset)(state),
        editingFieldWidth: (0, $7f2nY.getEditingFieldWidth)(state),
        horizontalScrollOffset: (0, $7ZrT1.getHorizontalScrollOffset)(state),
        verticalScrollOffset: (0, $7ZrT1.getVerticalScrollOffset)(state),
        tableWidth: (0, $7f2nY.getTableWidth)(state),
        tableHeight: (0, $7f2nY.getTableHeight)(state),
        loadedIssueKeys: (0, $h0Rgs.mergeIssueKeysWithLockedIssues)(state)
    });
const $7297aaa9db4e2d3a$var$mapDispatchToProps = {
    onUpdateHorizontalScrollOffset: (offset)=>(0, $jyIFK.setHorizontalOffsetAction)(offset.offsetFromLeft),
    onUpdateVerticalScrollOffset: (0, $jyIFK.updateVerticalOffsetAction)
};
// @ts-expect-error - TS2322 - Type 'ComponentClass<Omit<DispatchProp<any>, "dispatch">> & { WrappedComponent: Component<DispatchProp<any>>; }' is not assignable to type 'ComponentType<PropsWithDefaults>'. | TS2554 - Expected 3-4 arguments, but got 2.
const $7297aaa9db4e2d3a$var$ConnectedIssueTable = (0, $1Rt1q.connect)($7297aaa9db4e2d3a$var$mapStateToProps, $7297aaa9db4e2d3a$var$mapDispatchToProps)((0, $j4t2m.default));
var $7297aaa9db4e2d3a$export$2e2bcd8739ae039 = $7297aaa9db4e2d3a$var$ConnectedIssueTable;

});
parcelRegister("7ZrT1", function(module, exports) {

$parcel$export(module.exports, "getHorizontalScrollOffset", () => $93c5365acbf27bf1$export$624a30c8322e672b);
$parcel$export(module.exports, "getVerticalScrollOffset", () => $93c5365acbf27bf1$export$76e51b2d87e066ab);

var $9jIiv = parcelRequire("9jIiv");
const $93c5365acbf27bf1$export$6db1911eee044119 = (state)=>(0, $9jIiv.getPersisted)(state).offsets;
const $93c5365acbf27bf1$export$624a30c8322e672b = (state)=>$93c5365acbf27bf1$export$6db1911eee044119(state).horizontalScrollOffset;
const $93c5365acbf27bf1$export$76e51b2d87e066ab = (state)=>$93c5365acbf27bf1$export$6db1911eee044119(state).verticalScrollOffset;

});

parcelRegister("93N85", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa1fff5d513c6c84$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $2Gntj = parcelRequire("2Gntj");

var $9HJs6 = parcelRequire("9HJs6");
var $fa1fff5d513c6c84$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(()=>({
        Pagination: (0, $2Gntj.default)
    }), {})((0, $9HJs6.default));

});
parcelRegister("2Gntj", function(module, exports) {

$parcel$export(module.exports, "default", () => $91da03b10e7b2fcb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $91da03b10e7b2fcb$var$LazyPagination = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("eQXjS")), {
    moduleId: "../platform/packages/design-system/pagination/src/index.tsx"
});
const $91da03b10e7b2fcb$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-issue-table-pagination",
        packageName: "issueTable",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-issue-table-pagination",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($91da03b10e7b2fcb$var$LoadingComponent, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($91da03b10e7b2fcb$var$LazyPagination, props)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91da03b10e7b2fcb$var$LoadingComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3izwfg _1bsb19bv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eQXjS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("lE49Z")
]).then(()=>parcelRequire('hSPq1'));

});


parcelRegister("9HJs6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7f9e03198ea7a15$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iqjbc = parcelRequire("iqjbc");

var $giAhk = parcelRequire("giAhk");

var $fCkrP = parcelRequire("fCkrP");
function $d7f9e03198ea7a15$var$PaginationComponent(props) {
    const { currentPage: currentPage, totalPages: totalPages, Pagination: Pagination, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7f9e03198ea7a15$export$b14e02386c6038ac, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7f9e03198ea7a15$export$8c3f8ac08a926abc, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Pagination, {
        selectedIndex: currentPage - 1,
        onChange: props.onPageChange,
        i18n: {
            prev: formatMessage((0, $fCkrP.default).previousButton),
            next: formatMessage((0, $fCkrP.default).nextButton)
        },
        pages: (0, (/*@__PURE__*/$parcel$interopDefault($iqjbc)))(1, totalPages + 1)
    })));
}
var $d7f9e03198ea7a15$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = (0, $giAhk.injectIntlV2)($d7f9e03198ea7a15$var$PaginationComponent);
const $d7f9e03198ea7a15$export$b14e02386c6038ac = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3 _2hwx1ejb",
            __cmplp.className
        ])
    });
});
const $d7f9e03198ea7a15$export$8c3f8ac08a926abc = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _n3tdu2gc _ca0qu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iqjbc", function(module, exports) {

var $doiuZ = parcelRequire("doiuZ");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $d699885de2b5454c$var$range = $doiuZ();
module.exports = $d699885de2b5454c$var$range;

});
parcelRegister("doiuZ", function(module, exports) {

var $iVCWR = parcelRequire("iVCWR");

var $3P7i5 = parcelRequire("3P7i5");

var $d0d5X = parcelRequire("d0d5X");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $9bfbddb9d5847b3e$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $3P7i5(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $d0d5X(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $d0d5X(end);
        step = step === undefined ? start < end ? 1 : -1 : $d0d5X(step);
        return $iVCWR(start, end, step, fromRight);
    };
}
module.exports = $9bfbddb9d5847b3e$var$createRange;

});
parcelRegister("iVCWR", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $dc7bc3319622b4d0$var$nativeCeil = Math.ceil, $dc7bc3319622b4d0$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $dc7bc3319622b4d0$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $dc7bc3319622b4d0$var$nativeMax($dc7bc3319622b4d0$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $dc7bc3319622b4d0$var$baseRange;

});



parcelRegister("fCkrP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea530935bf042b1b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ea530935bf042b1b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    previousButton: {
        "id": "issue-table.pagination.previous-button",
        "defaultMessage": "Prev"
    },
    nextButton: {
        "id": "issue-table.pagination.next-button",
        "defaultMessage": "Next"
    }
});

});



parcelRegister("lbUvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4170e69fc8c3eac$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");

var $h0Rgs = parcelRequire("h0Rgs");

var $k99Fq = parcelRequire("k99Fq");

var $7f2nY = parcelRequire("7f2nY");

var $1Rt1q = parcelRequire("1Rt1q");

var $4cF2j = parcelRequire("4cF2j");
const $a4170e69fc8c3eac$var$mapStateToProps = (state)=>({
        issueKeys: (0, $h0Rgs.mergeIssueKeysWithLockedIssues)(state),
        transformProps: $k99Fq.transformProps,
        renderSidebarIcon: (0, $7f2nY.getRenderSidebarIcon)(state),
        refreshSidebar: (0, $1ybV0.ff)('jsm-queue-sidebar-bulk-edit-bug-fix_jx9ff', false) ? (0, $7f2nY.getRefreshSidebar)(state) : undefined
    });
// @ts-expect-error - TS2322 - Type 'ComponentClass<Omit<DispatchProp<any>, "dispatch">> & { WrappedComponent: Component<DispatchProp<any>>; }' is not assignable to type 'ComponentType<Props>'. | TS2554 - Expected 3-4 arguments, but got 1. | TS2345 - Argument of type 'typeof Table' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
const $a4170e69fc8c3eac$var$ConnectedIssueTable = (0, $1Rt1q.connect)($a4170e69fc8c3eac$var$mapStateToProps)((0, $4cF2j.default));
var $a4170e69fc8c3eac$export$2e2bcd8739ae039 = $a4170e69fc8c3eac$var$ConnectedIssueTable;

});
parcelRegister("k99Fq", function(module, exports) {

$parcel$export(module.exports, "transformProps", () => $fbb02c1155f88141$export$7b42a0094fb00b6e);



var $fljl6 = parcelRequire("fljl6");

var $dEWzf = parcelRequire("dEWzf");

var $9nkxi = parcelRequire("9nkxi");
const $fbb02c1155f88141$var$transformScrollCallback = (0, $9nkxi.default)();
const $fbb02c1155f88141$export$7b42a0094fb00b6e = (props, createCell)=>{
    const { issueKeys: issueKeys, columns: columns, isContentStale: isContentStale, shouldSkipVirtualization: shouldSkipVirtualization, shouldHideLoadingIndicator: shouldHideLoadingIndicator, shouldRerenderRowOnHover: shouldRerenderRowOnHover, totalPages: totalPages, FieldDataSelector: FieldDataSelector, onActiveItemChanged: onActiveItemChanged, onActiveRowIdChanged: onActiveRowIdChanged, onDisplayedRowsChanged: onDisplayedRowsChanged, onTableFocusFunctionChanged: onTableFocusFunctionChanged, onTableRefChanged: onTableRefChanged, onUpdateHorizontalScrollOffset: onUpdateHorizontalScrollOffset, selectedIssueKeys: selectedIssueKeys = [], contentKey: contentKey, ssrTableSize: ssrTableSize, disableRowHighlight: disableRowHighlight = false, renderSidebarIcon: renderSidebarIcon, appProps: appProps } = props;
    const { rowIds: rowIds, rowsConfiguration: rowsConfiguration } = (0, $dEWzf.default)(issueKeys, selectedIssueKeys);
    return {
        isContentStale: isContentStale,
        shouldSkipVirtualization: shouldSkipVirtualization,
        shouldHideLoadingIndicator: shouldHideLoadingIndicator,
        shouldRerenderRowOnHover: shouldRerenderRowOnHover,
        rowIds: rowIds,
        rowsConfiguration: rowsConfiguration,
        columns: (0, $fljl6.default)(FieldDataSelector, columns, createCell),
        navigationMode: (0, $a37593d97c1ae333$export$a01cd8e028b3d34f),
        expandedColumnIds: [],
        columnWidths: {},
        hiddenColumnIds: [],
        defaultRowHeight: (0, $6e1a998ae5fb6552$export$258441c8a79bb589),
        autoRowHeight: (0, $6e1a998ae5fb6552$export$80fc56c6cdbfffed),
        draggableRows: (0, $6e1a998ae5fb6552$export$6fd8e343a23be522),
        showDecalAtBottom: totalPages > 1,
        NonTemporaryCellWrapper: undefined,
        onActiveItemChanged: onActiveItemChanged,
        onActiveRowIdChanged: onActiveRowIdChanged,
        onDisplayedRowsChanged: onDisplayedRowsChanged,
        onVerticalScrollOffsetChanged: $fbb02c1155f88141$var$transformScrollCallback(props),
        onHorizontalScrollOffsetChanged: onUpdateHorizontalScrollOffset,
        onRowListFocusFunctionChanged: onTableFocusFunctionChanged,
        onReactPortalContainerRefChanged: onTableRefChanged,
        contentKey: contentKey,
        ssrTableSize: ssrTableSize,
        disableRowHighlight: disableRowHighlight,
        renderSidebarIcon: renderSidebarIcon,
        premiumSLAColumnIds: appProps.premiumSLAColumns
    };
};

});
const $a37593d97c1ae333$export$9e9986b7abe95577 = 'cellNavigation';
const $a37593d97c1ae333$export$a01cd8e028b3d34f = 'rowNavigation';
const $a37593d97c1ae333$export$8ea4ff4da61b68e4 = 'noNavigation';
const $a37593d97c1ae333$export$8a257aa81ef4a9e0 = 'activeRow';
const $a37593d97c1ae333$export$4b3489234fd17200 = 'activeCell';

parcelRegister("dEWzf", function(module, exports) {

$parcel$export(module.exports, "default", () => $9333a6abbfbeaf47$export$2e2bcd8739ae039);

var $3OXzs = parcelRequire("3OXzs");

var $5iWql = parcelRequire("5iWql");
const $9333a6abbfbeaf47$var$LOADING_ROW_CONFIGURATION = {
    isLoading: true
};
var $9333a6abbfbeaf47$export$2e2bcd8739ae039 = (0, $5iWql.default)((issueKeys, selectedIssueKeys)=>{
    const rowIds = [];
    const rowsConfiguration = {};
    for(let i = 0; i < issueKeys.length; i += 1){
        const issueKey = issueKeys[i];
        if (issueKey == null) {
            rowIds[i] = i.toString();
            rowsConfiguration[i.toString()] = $9333a6abbfbeaf47$var$LOADING_ROW_CONFIGURATION;
        } else {
            rowIds[i] = issueKey;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($3OXzs)))(selectedIssueKeys, issueKey)) rowsConfiguration[issueKey] = {
                isSelected: true
            };
        }
    }
    return {
        rowIds: rowIds,
        rowsConfiguration: rowsConfiguration
    };
});

});

parcelRegister("9nkxi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b02a179b58073eaf$export$2e2bcd8739ae039);

const $b02a179b58073eaf$var$DIRECTION_UP = 'UP';
const $b02a179b58073eaf$var$DIRECTION_DOWN = 'DOWN';
// The number of issue keys that would be fetched on scroll
const $b02a179b58073eaf$var$FETCH_BATCH_SIZE = 100;
// The number of issue keys that would be fetched on scroll
const $b02a179b58073eaf$var$OVERFETCH_SIZE = 3;
// Fetch issues only if the index changed (after scrolling) by 25% of buffer in store
const $b02a179b58073eaf$var$ISSUE_FETCH_SCROLL_THRESHOLD = 0.25;
// load more issues in the direction of scroll
const $b02a179b58073eaf$var$FETCH_BATCH_DIRECTIONAL_BIAS = 0.8;
// min rows scrolled before a fetch is requested
const $b02a179b58073eaf$var$MIN_SCROLL_BOUNDARY_DELTA = 3;
// validation functions
const $b02a179b58073eaf$var$isFirstBatch = (prevPageIssueCount, startIndex)=>startIndex === prevPageIssueCount;
const $b02a179b58073eaf$var$isLastBatch = (issueKeyCount, startIndex)=>startIndex === issueKeyCount - $b02a179b58073eaf$var$FETCH_BATCH_SIZE + $b02a179b58073eaf$var$OVERFETCH_SIZE;
const $b02a179b58073eaf$var$hasScrolledPastThreshold = (issueCountForThresholdCheck, scrollDelta)=>Math.abs(scrollDelta) > issueCountForThresholdCheck * $b02a179b58073eaf$var$ISSUE_FETCH_SCROLL_THRESHOLD;
const $b02a179b58073eaf$export$acc3c238efb0cb80 = (issueKeyCount, prevPageIssueCount, isLastPage, displayStart, displayEnd, isScrollingUp)=>{
    // Find out how many issues are rendered and how many more are needed for a batch of 100 issues.
    const extraIssuesToBeFetched = $b02a179b58073eaf$var$FETCH_BATCH_SIZE - (displayEnd - displayStart);
    // count of issues in either direction based on scroll direction
    const extraIssuesInScrollDirection = Math.floor(extraIssuesToBeFetched * $b02a179b58073eaf$var$FETCH_BATCH_DIRECTIONAL_BIAS);
    const extraIssuesOppositeScrollDirection = extraIssuesToBeFetched - extraIssuesInScrollDirection;
    const extraIssuesAtTopOfTable = isScrollingUp ? extraIssuesInScrollDirection : extraIssuesOppositeScrollDirection;
    return {
        startIndex: Math.min(Math.max(displayStart + prevPageIssueCount - extraIssuesAtTopOfTable, prevPageIssueCount), prevPageIssueCount + issueKeyCount - $b02a179b58073eaf$var$FETCH_BATCH_SIZE + (isLastPage ? $b02a179b58073eaf$var$OVERFETCH_SIZE : 0)),
        extraIssuesInScrollDirection: extraIssuesInScrollDirection,
        extraIssuesOppositeScrollDirection: extraIssuesOppositeScrollDirection
    };
};
const $b02a179b58073eaf$export$2ad5771a0a9b303a = (issueKeyCount, issueCountForThresholdCheck, prevPageIssueCount, startIndex, prevStartIndex, scrollDelta)=>{
    // fetch only if the index changes by 25% of the buffer in store in the direction of scroll
    // or if it's the first or the last batch for that page
    if (scrollDelta && startIndex !== prevStartIndex && ($b02a179b58073eaf$var$hasScrolledPastThreshold(issueCountForThresholdCheck, scrollDelta) || $b02a179b58073eaf$var$isLastBatch(issueKeyCount, startIndex) || $b02a179b58073eaf$var$isFirstBatch(prevPageIssueCount, startIndex))) return true;
    return false;
};
var // We are executing multiple IssueTable callbacks which are all tied to vertical scroll offset changes in VirtualTable
// eslint-disable-next-line jira/import/no-anonymous-default-export
$b02a179b58073eaf$export$2e2bcd8739ae039 = ()=>{
    // to keep a track of dispay boundary, used in identifying the scroll direction and offset
    let prevVisibleStart = 0;
    // to keep a track of prev indices, to not do anything if index didn't change
    let prevStartIndex;
    // to keep a track of any changes in scroll direction
    let prevScrollDirection = $b02a179b58073eaf$var$DIRECTION_DOWN;
    return (props)=>(verticalPosition)=>{
            const { onUpdateVerticalScrollOffset: onUpdateVerticalScrollOffset, onVerticalScrollOffsetChanged: onVerticalScrollOffsetChanged, onIssueDataRequested: onIssueDataRequested, issueKeys: issueKeys, currentPage: currentPage, totalPages: totalPages } = props;
            const { displayStart: displayStart, displayEnd: displayEnd, visibleStart: visibleStart, offsetFromTop: offsetFromTop, offsetFromBottom: offsetFromBottom } = verticalPosition;
            const issueKeyCount = issueKeys.length;
            const topAndBottomOffset = {
                offsetFromTop: offsetFromTop,
                offsetFromBottom: offsetFromBottom
            };
            onUpdateVerticalScrollOffset(totalPages, topAndBottomOffset, onVerticalScrollOffsetChanged);
            const scrollDelta = visibleStart - prevVisibleStart;
            // if all issues are already rendered, or no change in display boundaries, no need to fetch any more
            if (issueKeyCount < $b02a179b58073eaf$var$FETCH_BATCH_SIZE || Math.abs(scrollDelta) < $b02a179b58073eaf$var$MIN_SCROLL_BOUNDARY_DELTA) return;
            const scrollDirection = visibleStart > prevVisibleStart ? $b02a179b58073eaf$var$DIRECTION_DOWN : $b02a179b58073eaf$var$DIRECTION_UP;
            // take pagination into account
            const prevPageIssueCount = (currentPage - 1) * (0, $6e1a998ae5fb6552$export$f88f58d1a4b2078b);
            const isLastPage = currentPage === totalPages;
            const { startIndex: startIndex, extraIssuesInScrollDirection: extraIssuesInScrollDirection, extraIssuesOppositeScrollDirection: extraIssuesOppositeScrollDirection } = $b02a179b58073eaf$export$acc3c238efb0cb80(issueKeyCount, prevPageIssueCount, isLastPage, displayStart, displayEnd, scrollDirection === $b02a179b58073eaf$var$DIRECTION_UP);
            // if the scroll direction was changed, the threshold must be smaller because there are less issues loaded in that direction
            const issueCountForThresholdCheck = scrollDirection === prevScrollDirection ? extraIssuesInScrollDirection : extraIssuesOppositeScrollDirection;
            // @ts-expect-error - TS2322 - Type '"UP" | "DOWN"' is not assignable to type '"DOWN"'.
            prevScrollDirection = scrollDirection;
            const shouldFetchData = $b02a179b58073eaf$export$2ad5771a0a9b303a(issueKeyCount, issueCountForThresholdCheck, prevPageIssueCount, startIndex, prevStartIndex, scrollDelta);
            onIssueDataRequested && shouldFetchData && onIssueDataRequested(startIndex);
            // unless the scroll is not enough to enforce a new fetch, do not update the previous values
            if (shouldFetchData) {
                prevStartIndex = startIndex;
                prevVisibleStart = visibleStart;
            }
        };
};

});


parcelRegister("4cF2j", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9441e5ee7ec24d1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $jcd1O = parcelRequire("jcd1O");

var $3yErT = parcelRequire("3yErT");

class $b9441e5ee7ec24d1$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(props){
        super(props);
        this.createCell = (0, $3yErT.createCellsCache)();
    }
    render() {
        const { issueKeys: issueKeys } = this.props;
        const { transformProps: transformProps, tableRef: tableRef, ...otherProps } = this.props;
        if (issueKeys && issueKeys.length > (0, $6e1a998ae5fb6552$export$f88f58d1a4b2078b)) (0, $gUUjF.default).safeWarnWithoutCustomerData('issue-table', `[FD-4474] Maximum number of issues allowed by IssueTable on a page is ${(0, $6e1a998ae5fb6552$export$f88f58d1a4b2078b)}`);
        const tableProps = transformProps(otherProps, this.createCell);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jcd1O.default), {
            ...tableProps,
            ref: tableRef
        });
    }
}

});
parcelRegister("jcd1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $c65beb486ec349a7$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $jG2Eu = parcelRequire("jG2Eu");

var $7vbEf = parcelRequire("7vbEf");


var $2jJQb = parcelRequire("2jJQb");

var $8qUHb = parcelRequire("8qUHb");

var $5yvx1 = parcelRequire("5yvx1");

var $cMIaK = parcelRequire("cMIaK");

var $5lWf9 = parcelRequire("5lWf9");

var $9DmQz = parcelRequire("9DmQz");

var $km8yJ = parcelRequire("km8yJ");

var $6pOL1 = parcelRequire("6pOL1");

var $bEVdW = parcelRequire("bEVdW");

var $7ippN = parcelRequire("7ippN");

var $g2M4i = parcelRequire("g2M4i");
class $c65beb486ec349a7$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            NonTemporaryCellWrapper: undefined,
            navigationMode: (0, $a37593d97c1ae333$export$9e9986b7abe95577),
            rowIds: [],
            rowsConfiguration: {},
            defaultRowHeight: Math.max((0, $bEVdW.default).row.height, (0, $bEVdW.default).row.minHeight),
            autoRowHeight: false,
            draggableRows: false,
            columns: [],
            expandedColumnIds: [],
            columnWidths: {},
            hiddenColumnIds: [],
            onActiveItemChanged: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onRowListFocusFunctionChanged: undefined,
            contentKey: undefined
        };
    }
    static getInitialStoreState(props) {
        return false && props.ssrTableSize ? {
            internal: {
                ...(0, $9DmQz.initialState),
                tableSize: props.ssrTableSize
            }
        } : undefined;
    }
    constructor(props){
        super(props);
        const initialStoreState = $c65beb486ec349a7$export$2e2bcd8739ae039.getInitialStoreState(props);
        this.store = (0, $7ippN.default)(initialStoreState);
        const consumerState = (0, $g2M4i.default)(props);
        this.store.dispatch((0, $2jJQb.setStateFromProps)(consumerState, (0, $bEVdW.default)));
        if (props.renderSidebarIcon) this.store.dispatch((0, $5lWf9.setRenderSidebarIcon)(props.renderSidebarIcon));
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(this.props, nextProps)) {
            const consumerState = (0, $g2M4i.default)(nextProps);
            this.store.dispatch((0, $8qUHb.updateStateFromProps)(consumerState));
            if (nextProps.renderSidebarIcon) this.store.dispatch((0, $5lWf9.setRenderSidebarIcon)(nextProps.renderSidebarIcon));
        }
    }
    scrollToRow(rowId) {
        this.store.dispatch((0, $cMIaK.scrollToRow)(rowId));
    }
    resetVerticalScrollOffset() {
        this.store.dispatch((0, $5yvx1.setVertical)(0));
    }
    render() {
        const { defaultRowHeight: defaultRowHeight, autoRowHeight: autoRowHeight, customScrollBarOffset: customScrollBarOffset } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vbEf.Provider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6pOL1.ThemeProvider), {
            defaultRowHeight: defaultRowHeight,
            autoRowHeight: autoRowHeight,
            customScrollBarOffset: customScrollBarOffset
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $km8yJ.default), null)));
    }
}

});
parcelRegister("7vbEf", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $37c43a3133a2391b$export$2881499e37b75b9a);
$parcel$export(module.exports, "connect", () => $37c43a3133a2391b$export$64605811ab45167f);

var $eUqFw = parcelRequire("eUqFw");

var $lNNXV = parcelRequire("lNNXV");
const $37c43a3133a2391b$var$STORE_KEY = 'tableStore';
const $37c43a3133a2391b$export$93e4b0b2cc49b648 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $37c43a3133a2391b$export$2881499e37b75b9a = (0, $lNNXV.createProvider)($37c43a3133a2391b$export$93e4b0b2cc49b648);
const $37c43a3133a2391b$export$64605811ab45167f = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mapDispatchToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mergeProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
options = {})=>(0, $lNNXV.connect)(mapStateToProps, mapDispatchToProps, mergeProps, {
        ...options,
        context: $37c43a3133a2391b$export$93e4b0b2cc49b648,
        storeKey: $37c43a3133a2391b$var$STORE_KEY
    });

});

parcelRegister("2jJQb", function(module, exports) {

$parcel$export(module.exports, "SET_STATE_FROM_PROPS", () => $b019fb44886e3414$export$fa83d46c9d6439df);
$parcel$export(module.exports, "setStateFromProps", () => $b019fb44886e3414$export$ecd61896fb1d9dfc);
const $b019fb44886e3414$export$fa83d46c9d6439df = 'ops.hydrate.set.SET_STATE_FROM_PROPS';
const $b019fb44886e3414$export$ecd61896fb1d9dfc = (apiState, theme)=>({
        type: $b019fb44886e3414$export$fa83d46c9d6439df,
        payload: {
            apiState: apiState,
            theme: theme
        }
    });

});

parcelRegister("8qUHb", function(module, exports) {

$parcel$export(module.exports, "UPDATE_STATE_FROM_PROPS", () => $cd65d82db252e4fb$export$9915f5b7a701b9dc);
$parcel$export(module.exports, "updateStateFromProps", () => $cd65d82db252e4fb$export$129cd88740c3c561);
const $cd65d82db252e4fb$export$9915f5b7a701b9dc = 'ops.hydrate.update.UPDATE_STATE_FROM_PROPS';
const $cd65d82db252e4fb$export$129cd88740c3c561 = (payload)=>({
        type: $cd65d82db252e4fb$export$9915f5b7a701b9dc,
        payload: payload
    });

});

parcelRegister("5yvx1", function(module, exports) {

$parcel$export(module.exports, "SET_SCROLL_OFFSET", () => $b934b8042a9e5221$export$b62cd193236337c8);
$parcel$export(module.exports, "setVertical", () => $b934b8042a9e5221$export$f34530221b3f1c79);
$parcel$export(module.exports, "setHorizontal", () => $b934b8042a9e5221$export$dd2992a7040a040);
const $b934b8042a9e5221$export$226d1a200557982a = 'VERTICAL';
const $b934b8042a9e5221$export$608a8b0c7bb8a183 = 'HORIZONTAL';
const $b934b8042a9e5221$export$b62cd193236337c8 = 'ops.scrolling.offset.SET_SCROLL_OFFSET';
const $b934b8042a9e5221$export$adaa4cf7ef1b65be = (payload)=>({
        type: $b934b8042a9e5221$export$b62cd193236337c8,
        payload: payload
    });
const $b934b8042a9e5221$export$f34530221b3f1c79 = (offset)=>({
        type: $b934b8042a9e5221$export$b62cd193236337c8,
        payload: {
            offset: offset,
            direction: $b934b8042a9e5221$export$226d1a200557982a
        }
    });
const $b934b8042a9e5221$export$dd2992a7040a040 = (offset)=>({
        type: $b934b8042a9e5221$export$b62cd193236337c8,
        payload: {
            offset: offset,
            direction: $b934b8042a9e5221$export$608a8b0c7bb8a183
        }
    });

});

parcelRegister("cMIaK", function(module, exports) {

$parcel$export(module.exports, "SCROLL_TO_ROW", () => $7dccc275167ebe9a$export$ac622773190ce65e);
$parcel$export(module.exports, "scrollToRow", () => $7dccc275167ebe9a$export$71590875881b540);
const $7dccc275167ebe9a$export$ac622773190ce65e = 'ops.scrolling.to-row.SCROLL_TO_ROW';
const $7dccc275167ebe9a$export$71590875881b540 = (payload)=>({
        type: $7dccc275167ebe9a$export$ac622773190ce65e,
        payload: payload
    });

});

parcelRegister("5lWf9", function(module, exports) {

$parcel$export(module.exports, "SET_VERTICAL_SCROLL_OFFSET", () => $c08d273bf792c01d$export$80ba52f206861eb4);
$parcel$export(module.exports, "setVerticalScrollOffset", () => $c08d273bf792c01d$export$326ff279ca4dfb77);
$parcel$export(module.exports, "SET_VERTICAL_SCROLL_DELTA", () => $c08d273bf792c01d$export$653d24855aaede15);
$parcel$export(module.exports, "setVerticalScrollDelta", () => $c08d273bf792c01d$export$1331c3f83dd180bd);
$parcel$export(module.exports, "SET_HORIZONTAL_SCROLL_OFFSET", () => $c08d273bf792c01d$export$e1dd7001449ed5e8);
$parcel$export(module.exports, "setHorizontalScrollOffset", () => $c08d273bf792c01d$export$22fd5ac5ac6862d2);
$parcel$export(module.exports, "SET_TABLE_SIZE", () => $c08d273bf792c01d$export$7988e33354cc36c5);
$parcel$export(module.exports, "setTableSize", () => $c08d273bf792c01d$export$ef8b504c11e86ef2);
$parcel$export(module.exports, "SET_ACTIVE_ITEM", () => $c08d273bf792c01d$export$ff7b028545454800);
$parcel$export(module.exports, "setActiveItem", () => $c08d273bf792c01d$export$375743a38c44f220);
$parcel$export(module.exports, "CLEAR_ACTIVE_ITEM", () => $c08d273bf792c01d$export$d63ae865b2dc3e7f);
$parcel$export(module.exports, "clearActiveItem", () => $c08d273bf792c01d$export$f8e43f3f64585431);
$parcel$export(module.exports, "SET_RESIZING_COLUMN", () => $c08d273bf792c01d$export$9b07079645db68ce);
$parcel$export(module.exports, "setResizingColumn", () => $c08d273bf792c01d$export$ecabdd68bb804ada);
$parcel$export(module.exports, "SET_COLUMN_SORT_ORDER", () => $c08d273bf792c01d$export$d353d2412612deea);
$parcel$export(module.exports, "setColumnSortOrder", () => $c08d273bf792c01d$export$53f60a18200636);
$parcel$export(module.exports, "SET_SORT_ORDER_WITH_OVERRIDE", () => $c08d273bf792c01d$export$bd2944db1d7878d7);
$parcel$export(module.exports, "setSortOrderWithOverride", () => $c08d273bf792c01d$export$21099b8525c19e6b);
$parcel$export(module.exports, "SET_MULTI_ADD_ANCHOR", () => $c08d273bf792c01d$export$45d5c36be62dcf8e);
$parcel$export(module.exports, "setMultiAddAnchor", () => $c08d273bf792c01d$export$ccc97b11ed34fa9c);
$parcel$export(module.exports, "CLEAR_MULTI_ADD_ANCHOR", () => $c08d273bf792c01d$export$28f3def567195a3c);
$parcel$export(module.exports, "clearMultiAddAnchor", () => $c08d273bf792c01d$export$fba9cdc0d3369b8b);
$parcel$export(module.exports, "SET_SORTED_ROW_IDS_HASH", () => $c08d273bf792c01d$export$a5a55dd3afd00236);
$parcel$export(module.exports, "setSortedRowIdsHash", () => $c08d273bf792c01d$export$7b78b0b46aa05c76);
$parcel$export(module.exports, "SET_ROW_BORDER_WIDTH", () => $c08d273bf792c01d$export$a347b798ae4b070c);
$parcel$export(module.exports, "setRowBorderWidth", () => $c08d273bf792c01d$export$a1c22b3a0006689b);
$parcel$export(module.exports, "SET_ROW_HEIGHT_MAPPING", () => $c08d273bf792c01d$export$3c2f00efa2858459);
$parcel$export(module.exports, "clearRowHeightMapping", () => $c08d273bf792c01d$export$ee45b95e009bf919);
$parcel$export(module.exports, "BATCH_UPDATE_ROW_HEIGHT_MAPPING", () => $c08d273bf792c01d$export$1e2cc4b1d7e85685);
$parcel$export(module.exports, "batchUpdateRowHeightMapping", () => $c08d273bf792c01d$export$6ad1445af83aec72);
$parcel$export(module.exports, "SET_SCROLLBAR_SIZE", () => $c08d273bf792c01d$export$1343829730561bf3);
$parcel$export(module.exports, "setScrollbarSize", () => $c08d273bf792c01d$export$dc80aaf47c2ba019);
$parcel$export(module.exports, "SET_HEADER_HEIGHT", () => $c08d273bf792c01d$export$e52e6a4be99a8322);
$parcel$export(module.exports, "setHeaderHeight", () => $c08d273bf792c01d$export$5f442def93f9b3e5);
$parcel$export(module.exports, "SET_RENDER_SIDE_BAR_ICON", () => $c08d273bf792c01d$export$9699e624bf23e2bb);
$parcel$export(module.exports, "setRenderSidebarIcon", () => $c08d273bf792c01d$export$28433d58f8f5bf2);
const $c08d273bf792c01d$export$80ba52f206861eb4 = 'state.internal.SET_VERTICAL_SCROLL_OFFSET';
const $c08d273bf792c01d$export$326ff279ca4dfb77 = (offset)=>({
        type: $c08d273bf792c01d$export$80ba52f206861eb4,
        payload: offset
    });
const $c08d273bf792c01d$export$653d24855aaede15 = 'state.internal.SET_VERTICAL_SCROLL_DELTA';
const $c08d273bf792c01d$export$1331c3f83dd180bd = (delta)=>({
        type: $c08d273bf792c01d$export$653d24855aaede15,
        payload: delta
    });
const $c08d273bf792c01d$export$e1dd7001449ed5e8 = 'state.internal.SET_HORIZONTAL_SCROLL_OFFSET';
const $c08d273bf792c01d$export$22fd5ac5ac6862d2 = (offset)=>({
        type: $c08d273bf792c01d$export$e1dd7001449ed5e8,
        payload: offset
    });
const $c08d273bf792c01d$export$7988e33354cc36c5 = 'state.internal.SET_TABLE_SIZE';
const $c08d273bf792c01d$export$ef8b504c11e86ef2 = (tableSize)=>({
        type: $c08d273bf792c01d$export$7988e33354cc36c5,
        payload: tableSize
    });
const $c08d273bf792c01d$export$ff7b028545454800 = 'state.internal.SET_ACTIVE_ITEM';
const $c08d273bf792c01d$export$375743a38c44f220 = (payload)=>({
        type: $c08d273bf792c01d$export$ff7b028545454800,
        payload: payload
    });
const $c08d273bf792c01d$export$d63ae865b2dc3e7f = 'state.internal.CLEAR_ACTIVE_ITEM';
const $c08d273bf792c01d$export$f8e43f3f64585431 = ()=>({
        type: $c08d273bf792c01d$export$d63ae865b2dc3e7f
    });
const $c08d273bf792c01d$export$9b07079645db68ce = 'state.internal.SET_RESIZING_COLUMN';
const $c08d273bf792c01d$export$ecabdd68bb804ada = (payload)=>({
        type: $c08d273bf792c01d$export$9b07079645db68ce,
        payload: payload
    });
const $c08d273bf792c01d$export$d353d2412612deea = 'state.internal.SET_COLUMN_SORT_ORDER';
const $c08d273bf792c01d$export$53f60a18200636 = (payload)=>({
        type: $c08d273bf792c01d$export$d353d2412612deea,
        payload: payload
    });
const $c08d273bf792c01d$export$bd2944db1d7878d7 = 'state.internal.SET_SORT_ORDER_WITH_OVERRIDE';
const $c08d273bf792c01d$export$21099b8525c19e6b = (payload)=>({
        type: $c08d273bf792c01d$export$bd2944db1d7878d7,
        payload: payload
    });
const $c08d273bf792c01d$export$45d5c36be62dcf8e = 'state.internal.SET_MULTI_ADD_ANCHOR';
const $c08d273bf792c01d$export$ccc97b11ed34fa9c = (payload)=>({
        type: $c08d273bf792c01d$export$45d5c36be62dcf8e,
        payload: payload
    });
const $c08d273bf792c01d$export$28f3def567195a3c = 'state.internal.CLEAR_MULTI_ADD_ANCHOR';
const $c08d273bf792c01d$export$fba9cdc0d3369b8b = ()=>({
        type: $c08d273bf792c01d$export$28f3def567195a3c
    });
const $c08d273bf792c01d$export$a5a55dd3afd00236 = 'state.internal.SET_SORTED_ROW_IDS_HASH';
const $c08d273bf792c01d$export$7b78b0b46aa05c76 = (payload)=>({
        type: $c08d273bf792c01d$export$a5a55dd3afd00236,
        payload: payload
    });
const $c08d273bf792c01d$export$a347b798ae4b070c = 'state.internal.SET_ROW_BORDER_WIDTH';
const $c08d273bf792c01d$export$a1c22b3a0006689b = (payload)=>({
        type: $c08d273bf792c01d$export$a347b798ae4b070c,
        payload: payload
    });
const $c08d273bf792c01d$export$3c2f00efa2858459 = 'state.internal.SET_ROW_HEIGHT_MAPPING';
const $c08d273bf792c01d$export$a0d036f26f10d9d2 = (payload)=>({
        type: $c08d273bf792c01d$export$3c2f00efa2858459,
        payload: payload
    });
const $c08d273bf792c01d$export$ee45b95e009bf919 = ()=>$c08d273bf792c01d$export$a0d036f26f10d9d2({});
const $c08d273bf792c01d$export$1e2cc4b1d7e85685 = 'state.internal.BATCH_UPDATE_ROW_HEIGHT_MAPPING';
const $c08d273bf792c01d$export$6ad1445af83aec72 = (rowIds, rowHeightMapping)=>({
        type: $c08d273bf792c01d$export$1e2cc4b1d7e85685,
        payload: {
            rowIds: rowIds,
            rowHeightMapping: rowHeightMapping
        }
    });
const $c08d273bf792c01d$export$1343829730561bf3 = 'state.internal.SET_SCROLLBAR_SIZE';
const $c08d273bf792c01d$export$dc80aaf47c2ba019 = (payload)=>({
        type: $c08d273bf792c01d$export$1343829730561bf3,
        payload: payload
    });
const $c08d273bf792c01d$export$e52e6a4be99a8322 = 'state.internal.SET_HEADER_HEIGHT';
const $c08d273bf792c01d$export$5f442def93f9b3e5 = (height)=>({
        type: $c08d273bf792c01d$export$e52e6a4be99a8322,
        payload: height
    });
const $c08d273bf792c01d$export$9699e624bf23e2bb = 'state.consumer.SET_RENDER_SIDE_BAR_ICON';
const $c08d273bf792c01d$export$28433d58f8f5bf2 = (payload)=>({
        type: $c08d273bf792c01d$export$9699e624bf23e2bb,
        payload: payload
    });

});

parcelRegister("9DmQz", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $ad43c09e37e33bbb$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $ad43c09e37e33bbb$export$2e2bcd8739ae039);

var $8dloj = parcelRequire("8dloj");

var $5lWf9 = parcelRequire("5lWf9");
const $ad43c09e37e33bbb$export$d4c72bab9d6cc13a = {
    verticalScrollOffset: 0,
    verticalScrollDelta: 0,
    horizontalScrollOffset: 0,
    // FSN-4037 Remove draggingRowId related logic during FF cleanup
    draggingRowId: undefined,
    multiAddAnchorId: undefined,
    resizingColumnId: undefined,
    draggingColumnId: undefined,
    isSortOverrideEnabled: false,
    activeSortedColumnConfiguration: undefined,
    activeItem: undefined,
    tableSize: {
        width: 0,
        height: 0,
        widthWithoutScrollbarOffset: 0,
        rowMargin: 0
    },
    rowBorderWidth: 0,
    rowHeightMapping: {},
    scrollbarSize: 0,
    sortedRowIdsHash: {},
    headerHeight: 0,
    renderSidebarIcon: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad43c09e37e33bbb$export$2e2bcd8739ae039 = (state = $ad43c09e37e33bbb$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $5lWf9.SET_VERTICAL_SCROLL_OFFSET:
            return {
                ...state,
                verticalScrollOffset: action.payload
            };
        case 0, $5lWf9.SET_VERTICAL_SCROLL_DELTA:
            return {
                ...state,
                verticalScrollDelta: action.payload
            };
        case 0, $5lWf9.SET_HORIZONTAL_SCROLL_OFFSET:
            return {
                ...state,
                horizontalScrollOffset: action.payload
            };
        case 0, $5lWf9.SET_MULTI_ADD_ANCHOR:
            return {
                ...state,
                multiAddAnchorId: action.payload
            };
        case 0, $5lWf9.CLEAR_MULTI_ADD_ANCHOR:
            return {
                ...state,
                multiAddAnchorId: undefined
            };
        case 0, $5lWf9.SET_TABLE_SIZE:
            return {
                ...state,
                tableSize: action.payload
            };
        case 0, $5lWf9.SET_RESIZING_COLUMN:
            return {
                ...state,
                resizingColumnId: action.payload
            };
        case 0, $5lWf9.SET_COLUMN_SORT_ORDER:
            return {
                ...state,
                activeSortedColumnConfiguration: action.payload,
                isSortOverrideEnabled: false
            };
        case 0, $5lWf9.SET_ACTIVE_ITEM:
            return {
                ...state,
                activeItem: action.payload
            };
        case 0, $5lWf9.CLEAR_ACTIVE_ITEM:
            return {
                ...state,
                activeItem: undefined
            };
        case 0, $5lWf9.SET_SORT_ORDER_WITH_OVERRIDE:
            return {
                ...state,
                isSortOverrideEnabled: action.payload.isSortOverrideEnabled
            };
        case 0, $5lWf9.SET_SORTED_ROW_IDS_HASH:
            return {
                ...state,
                sortedRowIdsHash: action.payload
            };
        case 0, $5lWf9.SET_ROW_BORDER_WIDTH:
            return {
                ...state,
                rowBorderWidth: action.payload
            };
        case 0, $5lWf9.SET_ROW_HEIGHT_MAPPING:
            return {
                ...state,
                rowHeightMapping: action.payload
            };
        case 0, $5lWf9.BATCH_UPDATE_ROW_HEIGHT_MAPPING:
            {
                const { rowHeightMapping: rowHeightMapping, rowIds: rowIds } = action.payload;
                const validatedRowHeights = (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(state.rowHeightMapping, rowIds);
                return {
                    ...state,
                    rowHeightMapping: {
                        ...validatedRowHeights,
                        ...rowHeightMapping
                    }
                };
            }
        case 0, $5lWf9.SET_SCROLLBAR_SIZE:
            return {
                ...state,
                scrollbarSize: action.payload
            };
        case 0, $5lWf9.SET_HEADER_HEIGHT:
            return {
                ...state,
                headerHeight: action.payload
            };
        case 0, $5lWf9.SET_RENDER_SIDE_BAR_ICON:
            return {
                ...state,
                renderSidebarIcon: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("km8yJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $97e2854beea17823$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $hmJUb = parcelRequire("hmJUb");

var $01OF3 = parcelRequire("01OF3");

var $4aSHd = parcelRequire("4aSHd");

var $5jaaH = parcelRequire("5jaaH");

var $a7y6r = parcelRequire("a7y6r");

var $k5Bve = parcelRequire("k5Bve");

var $9RI6V = parcelRequire("9RI6V");
var $97e2854beea17823$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state)=>({
        isAutoHeight: (0, $01OF3.isAutoHeight)(state),
        width: (0, $4aSHd.getTableWidth)(state),
        height: (0, $5jaaH.getTableHeight)(state),
        TableMain: $9RI6V.default,
        DetailsPanel: $a7y6r.default
    }), {
    setTableSize: $hmJUb.set
})((0, $k5Bve.default));

});
parcelRegister("hmJUb", function(module, exports) {

$parcel$export(module.exports, "SET_TABLE_SIZE", () => $72ab9e8435a636aa$export$7988e33354cc36c5);
$parcel$export(module.exports, "set", () => $72ab9e8435a636aa$export$adaa4cf7ef1b65be);
// set table size
const $72ab9e8435a636aa$export$7988e33354cc36c5 = 'ops.table-size.SET_TABLE_SIZE';
const $72ab9e8435a636aa$export$adaa4cf7ef1b65be = (tableSize)=>({
        type: $72ab9e8435a636aa$export$7988e33354cc36c5,
        payload: tableSize
    });

});

parcelRegister("01OF3", function(module, exports) {

$parcel$export(module.exports, "getConsumerState", () => $4d1746e33c806db9$export$341d8012284373b1);
$parcel$export(module.exports, "isAutoHeight", () => $4d1746e33c806db9$export$db0e511b14aa0a6e);
$parcel$export(module.exports, "isContentStale", () => $4d1746e33c806db9$export$9039d26c291af11d);
$parcel$export(module.exports, "shouldHideLoadingIndicator", () => $4d1746e33c806db9$export$fffff0ed501bd482);
$parcel$export(module.exports, "shouldRerenderRowOnHover", () => $4d1746e33c806db9$export$21a66ad733a5f373);
$parcel$export(module.exports, "showBottomDecal", () => $4d1746e33c806db9$export$6587735983eaa612);
$parcel$export(module.exports, "getNavigationMode", () => $4d1746e33c806db9$export$d8d84b9edb2f3121);
$parcel$export(module.exports, "isInCellNavigationMode", () => $4d1746e33c806db9$export$164b1d002ce21ad4);
$parcel$export(module.exports, "isInRowNavigationMode", () => $4d1746e33c806db9$export$a7cdf0911782f4e9);
$parcel$export(module.exports, "getShouldSkipVirtualization", () => $4d1746e33c806db9$export$76b0eed37faf2db7);
$parcel$export(module.exports, "disableRowHighlight", () => $4d1746e33c806db9$export$94e08c39526945ff);
$parcel$export(module.exports, "getRowExpansionCallback", () => $4d1746e33c806db9$export$bd84bd77b16747b0);
$parcel$export(module.exports, "getRowAddCallback", () => $4d1746e33c806db9$export$6b23e7f48fb98382);
$parcel$export(module.exports, "getClearAddedRowsCallback", () => $4d1746e33c806db9$export$b1c02c566f8f8e21);
$parcel$export(module.exports, "getPersistAddedRowCallback", () => $4d1746e33c806db9$export$8f6f1d89690007b6);
$parcel$export(module.exports, "getCancelAddedRowCallback", () => $4d1746e33c806db9$export$549fbf34b02d3f9f);
$parcel$export(module.exports, "getColumnExpandCallback", () => $4d1746e33c806db9$export$d1881e0c1d23cb54);
$parcel$export(module.exports, "getChangeHiddenColumnsCallback", () => $4d1746e33c806db9$export$c5513fe56d491d3c);
$parcel$export(module.exports, "getActiveItemChangedCallback", () => $4d1746e33c806db9$export$940cf9a84f2cd566);
$parcel$export(module.exports, "getActiveRowIdChangedCallback", () => $4d1746e33c806db9$export$e4a9acb7b8a41ad4);
$parcel$export(module.exports, "getSortedColumnChangedCallback", () => $4d1746e33c806db9$export$54ab8d2edb67b6c5);
$parcel$export(module.exports, "getVerticalScrollOffsetChangedCallback", () => $4d1746e33c806db9$export$208a9f508202aaea);
$parcel$export(module.exports, "getHorizontalScrollOffsetChangedCallback", () => $4d1746e33c806db9$export$9bc70187ed1fe3de);
$parcel$export(module.exports, "getOnRowListFocusFunctionChangedCallback", () => $4d1746e33c806db9$export$f3043684c353f104);
$parcel$export(module.exports, "getOnReactPortalContainerRefChangedCallback", () => $4d1746e33c806db9$export$4b1da0361b069d9);
$parcel$export(module.exports, "getDetailsPanelComponent", () => $4d1746e33c806db9$export$eb8f069328f0ef13);
$parcel$export(module.exports, "getNonTemporaryCellWrapper", () => $4d1746e33c806db9$export$9d360b10d6c49c27);
$parcel$export(module.exports, "isDetailsPanelOpen", () => $4d1746e33c806db9$export$8eff1175be4b2e5d);
$parcel$export(module.exports, "isColumnConfigurationVisible", () => $4d1746e33c806db9$export$af0e6e54e108dbdf);
$parcel$export(module.exports, "getVisibleAdditionalColumnIds", () => $4d1746e33c806db9$export$95e03d3af742e020);
$parcel$export(module.exports, "getVisibleColumnIds", () => $4d1746e33c806db9$export$9158bf17317ec5a3);
$parcel$export(module.exports, "getVisibleColumnCount", () => $4d1746e33c806db9$export$a494b4888339717d);
$parcel$export(module.exports, "getDefaultAddColumnId", () => $4d1746e33c806db9$export$d2c4eee6843b68dc);
$parcel$export(module.exports, "getTotalDynamicColumnMaxWidth", () => $4d1746e33c806db9$export$b87f4bf1dea22966);
$parcel$export(module.exports, "getTotalDynamicColumnMinWidth", () => $4d1746e33c806db9$export$2143bc4b2542ea5d);
$parcel$export(module.exports, "getLoadingRowComponent", () => $4d1746e33c806db9$export$65784ca6b29dc2a3);
$parcel$export(module.exports, "getFacade", () => $4d1746e33c806db9$export$379c1b3c8c56422e);
$parcel$export(module.exports, "isTableFacade", () => $4d1746e33c806db9$export$f4b00b57da9022eb);
$parcel$export(module.exports, "isTreeTableFacade", () => $4d1746e33c806db9$export$428877d41520e34c);
$parcel$export(module.exports, "shouldDelayRowRenderingOnScroll", () => $4d1746e33c806db9$export$47cf89187102921d);
$parcel$export(module.exports, "getPremiumSLAColumns", () => $4d1746e33c806db9$export$bd19afa7f02ff55d);

var $df4Sl = parcelRequire("df4Sl");

var $1ybV0 = parcelRequire("1ybV0");




var $4Bkxm = parcelRequire("4Bkxm");

var $el8hi = parcelRequire("el8hi");
const $4d1746e33c806db9$export$341d8012284373b1 = (state)=>state.consumer;
const $4d1746e33c806db9$export$db0e511b14aa0a6e = (state)=>state.consumer.autoHeight;
const $4d1746e33c806db9$export$9039d26c291af11d = (state)=>state.consumer.isContentStale;
const $4d1746e33c806db9$export$fffff0ed501bd482 = (state)=>state.consumer.shouldHideLoadingIndicator;
const $4d1746e33c806db9$export$21a66ad733a5f373 = (state)=>state.consumer.shouldRerenderRowOnHover;
const $4d1746e33c806db9$export$6587735983eaa612 = (state)=>state.consumer.showDecalAtBottom;
const $4d1746e33c806db9$export$d8d84b9edb2f3121 = (state)=>state.consumer.navigationMode;
const $4d1746e33c806db9$export$164b1d002ce21ad4 = (state)=>$4d1746e33c806db9$export$d8d84b9edb2f3121(state) === (0, $a37593d97c1ae333$export$9e9986b7abe95577);
const $4d1746e33c806db9$export$a7cdf0911782f4e9 = (state)=>$4d1746e33c806db9$export$d8d84b9edb2f3121(state) === (0, $a37593d97c1ae333$export$a01cd8e028b3d34f);
const $4d1746e33c806db9$export$76b0eed37faf2db7 = (state)=>state.consumer.shouldSkipVirtualization;
const $4d1746e33c806db9$export$94e08c39526945ff = (state)=>state.consumer.disableRowHighlight;
// CALLBACKS
const $4d1746e33c806db9$var$getConsumerCallbacks = (state)=>state.consumer.callbacks;
const $4d1746e33c806db9$export$bd84bd77b16747b0 = (state)=>$4d1746e33c806db9$var$getConsumerCallbacks(state).onRowExpansionChangeRequested;
const $4d1746e33c806db9$export$6b23e7f48fb98382 = (state)=>$4d1746e33c806db9$var$getConsumerCallbacks(state).onRowAddRequested;
const $4d1746e33c806db9$export$b1c02c566f8f8e21 = (state)=>$4d1746e33c806db9$var$getConsumerCallbacks(state).onClearAddedRowsRequested;
const $4d1746e33c806db9$export$8f6f1d89690007b6 = (state)=>$4d1746e33c806db9$var$getConsumerCallbacks(state).onPersistAddedRowRequested;
const $4d1746e33c806db9$export$549fbf34b02d3f9f = (state)=>$4d1746e33c806db9$var$getConsumerCallbacks(state).onCancelAddedRowRequested;
const $4d1746e33c806db9$export$d1881e0c1d23cb54 = (state)=>$4d1746e33c806db9$var$getConsumerCallbacks(state).onColumnExpansionChangeRequested;
const $4d1746e33c806db9$export$9bc4a4d8de396706 = (state)=>$4d1746e33c806db9$var$getConsumerCallbacks(state).onColumnMoveRequested;
const $4d1746e33c806db9$export$c5513fe56d491d3c = (state)=>$4d1746e33c806db9$var$getConsumerCallbacks(state).onChangeHiddenColumnsRequested;
const $4d1746e33c806db9$export$940cf9a84f2cd566 = (state)=>$4d1746e33c806db9$var$getConsumerCallbacks(state).onActiveItemChanged;
const $4d1746e33c806db9$export$e4a9acb7b8a41ad4 = (state)=>$4d1746e33c806db9$var$getConsumerCallbacks(state).onActiveRowIdChanged;
const $4d1746e33c806db9$export$54ab8d2edb67b6c5 = (state)=>$4d1746e33c806db9$var$getConsumerCallbacks(state).onSortedColumnChanged;
const $4d1746e33c806db9$export$15d0406154f187f9 = (state)=>$4d1746e33c806db9$var$getConsumerCallbacks(state).onSortedRowIdsChanged;
const $4d1746e33c806db9$export$80456d589232e453 = (state)=>$4d1746e33c806db9$var$getConsumerCallbacks(state).onDisplayedRowsChanged;
const $4d1746e33c806db9$export$208a9f508202aaea = (state)=>$4d1746e33c806db9$var$getConsumerCallbacks(state).onVerticalScrollOffsetChanged;
const $4d1746e33c806db9$export$9bc70187ed1fe3de = (state)=>$4d1746e33c806db9$var$getConsumerCallbacks(state).onHorizontalScrollOffsetChanged;
const $4d1746e33c806db9$export$f3043684c353f104 = (state)=>state.consumer.callbacks.onRowListFocusFunctionChanged;
const $4d1746e33c806db9$export$4b1da0361b069d9 = (state)=>state.consumer.callbacks.onReactPortalContainerRefChanged;
const $4d1746e33c806db9$export$eb8f069328f0ef13 = (state)=>state.consumer.DetailsPanelComponent;
const $4d1746e33c806db9$export$9d360b10d6c49c27 = (state)=>state.consumer.NonTemporaryCellWrapper;
const $4d1746e33c806db9$export$8eff1175be4b2e5d = (state)=>!!$4d1746e33c806db9$export$eb8f069328f0ef13(state);
const $4d1746e33c806db9$export$af0e6e54e108dbdf = (0, $df4Sl.createSelector)($4d1746e33c806db9$export$c5513fe56d491d3c, $4d1746e33c806db9$export$8eff1175be4b2e5d, (hiddenColumnsCallback, detailsPanelOpen)=>hiddenColumnsCallback !== undefined && !detailsPanelOpen);
const $4d1746e33c806db9$export$95e03d3af742e020 = (0, $df4Sl.createSelector)((0, $4Bkxm.getColumnTree), (0, $4Bkxm.getExpandedColumnIdsHash), (0, $4Bkxm.getHiddenColumnsLookupHash), (0, $4Bkxm.getSortedColumnIds), $4d1746e33c806db9$export$8eff1175be4b2e5d, (columnTree, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds, isDetailsOpen)=>isDetailsOpen ? [] : (0, $el8hi.default)(columnTree, columnTree.rootAdditionalIds, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds));
const $4d1746e33c806db9$export$9158bf17317ec5a3 = (0, $df4Sl.createSelector)((0, $4Bkxm.getVisibleCoreColumnIds), $4d1746e33c806db9$export$95e03d3af742e020, (coreColumnIds, additionalColumnIds)=>coreColumnIds.concat(additionalColumnIds));
const $4d1746e33c806db9$export$a494b4888339717d = (0, $df4Sl.createSelector)($4d1746e33c806db9$export$9158bf17317ec5a3, (visibleColumnIds)=>visibleColumnIds.length);
const $4d1746e33c806db9$export$d2c4eee6843b68dc = (0, $df4Sl.createSelector)((0, $4Bkxm.getColumnTree), $4d1746e33c806db9$export$9158bf17317ec5a3, (columnTree, visibleColumnIds)=>visibleColumnIds.find((columnId)=>columnTree.columns[columnId].isDefaultAdd) || visibleColumnIds[0]);
const $4d1746e33c806db9$var$makeSummedDynamicColumnProperty = (accessor)=>(0, $df4Sl.createSelector)($4d1746e33c806db9$export$9158bf17317ec5a3, (0, $4Bkxm.getColumnTree), (visibleColumnIds, columnTree)=>visibleColumnIds// FSN-4987 Remove resize strategy related logic during cleanup
        .filter((columnId)=>(0, $1ybV0.ff)('remove-react-dnd-from-virtual-table-cleanup_5ho59') || columnTree.columns[columnId].resizeStrategy === (0, $c947ad34bf4dc375$export$4670af9f718b9e66)).map((columnId)=>accessor(columnTree.columns[columnId])).reduce((a, b)=>a + b, 0));
const $4d1746e33c806db9$export$b87f4bf1dea22966 = $4d1746e33c806db9$var$makeSummedDynamicColumnProperty((column)=>column.maxWidth);
const $4d1746e33c806db9$export$2143bc4b2542ea5d = $4d1746e33c806db9$var$makeSummedDynamicColumnProperty((column)=>column.minWidth);
const $4d1746e33c806db9$export$65784ca6b29dc2a3 = (state)=>$4d1746e33c806db9$export$341d8012284373b1(state).LoadingRowComponent;
const $4d1746e33c806db9$export$379c1b3c8c56422e = (state)=>$4d1746e33c806db9$export$341d8012284373b1(state).facade;
const $4d1746e33c806db9$export$f4b00b57da9022eb = (state)=>$4d1746e33c806db9$export$379c1b3c8c56422e(state) === (0, $1ae691fea746d497$export$88a597d0c7ae97b);
const $4d1746e33c806db9$export$428877d41520e34c = (state)=>$4d1746e33c806db9$export$379c1b3c8c56422e(state) === (0, $1ae691fea746d497$export$1d9e930504ed3ddf);
const $4d1746e33c806db9$export$47cf89187102921d = (state)=>$4d1746e33c806db9$export$f4b00b57da9022eb(state);
const $4d1746e33c806db9$export$bd19afa7f02ff55d = (state)=>(0, $1ybV0.ff)('platform.queue-page-error-boundaries_ro9zq') ? $4d1746e33c806db9$export$341d8012284373b1(state).premiumSLAColumnIds : undefined;

});
const $c947ad34bf4dc375$export$4670af9f718b9e66 = 'DYNAMIC_RESIZE';
const $c947ad34bf4dc375$export$3920b9c14da1301c = 'DRAGGABLE_RESIZE';
const $c947ad34bf4dc375$export$913055729e1380b2 = 'summary';
const $c947ad34bf4dc375$export$6e386ac144cffab5 = 'ASCENDING';
const $c947ad34bf4dc375$export$f634ff5a7f1c8f3 = 'DESCENDING';

const $1ae691fea746d497$export$88a597d0c7ae97b = 'TABLE';
const $1ae691fea746d497$export$1d9e930504ed3ddf = 'TREE_TABLE';

parcelRegister("4Bkxm", function(module, exports) {

$parcel$export(module.exports, "getColumnTree", () => $380f8fa1c1fd4e11$export$626e2d661dbdbb1e);
$parcel$export(module.exports, "getColumnWidths", () => $380f8fa1c1fd4e11$export$e54c9225ca52acc);
$parcel$export(module.exports, "getDefaultComparator", () => $380f8fa1c1fd4e11$export$db92824abfb21a2e);
$parcel$export(module.exports, "getSortedColumnIds", () => $380f8fa1c1fd4e11$export$9286093f6e1ecac);
$parcel$export(module.exports, "getCellComponent", () => $380f8fa1c1fd4e11$export$cc7ae951af4ebc4e);
$parcel$export(module.exports, "getExpandedColumnIdsHash", () => $380f8fa1c1fd4e11$export$973bd9cbde2d338d);
$parcel$export(module.exports, "getHiddenColumnsLookupHash", () => $380f8fa1c1fd4e11$export$a6f67a8a23dbf9a1);
$parcel$export(module.exports, "getVisibleCoreColumnIds", () => $380f8fa1c1fd4e11$export$489e7298b8651c2e);
$parcel$export(module.exports, "getVisibleCoreColumnsWidth", () => $380f8fa1c1fd4e11$export$987e0cd3ec211c8);
$parcel$export(module.exports, "getColumnConfiguration", () => $380f8fa1c1fd4e11$export$3d6f7f2469223338);
$parcel$export(module.exports, "getColumnTitle", () => $380f8fa1c1fd4e11$export$7fd4bf39bc1fa7d6);
$parcel$export(module.exports, "getColumnHeaderComponent", () => $380f8fa1c1fd4e11$export$b4e69e5204b2a3b0);
$parcel$export(module.exports, "getColumnTooltip", () => $380f8fa1c1fd4e11$export$b165f1ee654a6c88);
$parcel$export(module.exports, "getColumnMinWidth", () => $380f8fa1c1fd4e11$export$76d9570454343133);
$parcel$export(module.exports, "getColumnColor", () => $380f8fa1c1fd4e11$export$cf34af5efc32c51);
$parcel$export(module.exports, "getColumnHasChildren", () => $380f8fa1c1fd4e11$export$55dbcdc822375b7c);
$parcel$export(module.exports, "getColumnParentId", () => $380f8fa1c1fd4e11$export$a63e62bf5f23be09);
$parcel$export(module.exports, "isColumnExpanded", () => $380f8fa1c1fd4e11$export$fd339f76e0ca945c);
$parcel$export(module.exports, "isColumnSortable", () => $380f8fa1c1fd4e11$export$19a1e000b0c7f615);
$parcel$export(module.exports, "isParentColumn", () => $380f8fa1c1fd4e11$export$d5f9813bca43da33);
$parcel$export(module.exports, "isChildColumn", () => $380f8fa1c1fd4e11$export$3289971ebd775b18);
$parcel$export(module.exports, "getParentId", () => $380f8fa1c1fd4e11$export$e6e327a97512715e);
$parcel$export(module.exports, "isFirstColumn", () => $380f8fa1c1fd4e11$export$d3671a4f3687bed);
$parcel$export(module.exports, "isVisibleCoreColumn", () => $380f8fa1c1fd4e11$export$3180485c5d58c720);
$parcel$export(module.exports, "canCellBeMultiLine", () => $380f8fa1c1fd4e11$export$f36235907d788d9d);
$parcel$export(module.exports, "hasAnyMultiLineColumn", () => $380f8fa1c1fd4e11$export$893dde5c71a334bb);
$parcel$export(module.exports, "getAllColumnIds", () => $380f8fa1c1fd4e11$export$373740f91e6ef0b9);

var $df4Sl = parcelRequire("df4Sl");

var $9BtCH = parcelRequire("9BtCH");

var $dIFkw = parcelRequire("dIFkw");

var $lEdvV = parcelRequire("lEdvV");

var $el8hi = parcelRequire("el8hi");

var $d5Oyp = parcelRequire("d5Oyp");
const $380f8fa1c1fd4e11$export$626e2d661dbdbb1e = (state)=>state.consumer.columnTree;
const $380f8fa1c1fd4e11$export$d6f73af294120ea1 = (state)=>state.consumer.expandedColumnIds;
const $380f8fa1c1fd4e11$export$701fee8fc287bd90 = (state)=>state.consumer.hiddenColumnIds;
const $380f8fa1c1fd4e11$export$e54c9225ca52acc = (state)=>state.consumer.columnWidths;
const $380f8fa1c1fd4e11$export$7a380d7d28b470cc = (state)=>state.consumer.columnComparators;
const $380f8fa1c1fd4e11$export$db92824abfb21a2e = (state)=>state.consumer.defaultComparator;
const $380f8fa1c1fd4e11$export$6dd907dd5b1dc40e = (state)=>state.consumer.minAdditionalColumnsWidth;
const $380f8fa1c1fd4e11$export$9286093f6e1ecac = (state)=>state.consumer.sortedColumnIds;
const $380f8fa1c1fd4e11$export$cc7ae951af4ebc4e = (state, columnId)=>$380f8fa1c1fd4e11$export$626e2d661dbdbb1e(state).columns[columnId].CellComponent;
const $380f8fa1c1fd4e11$export$78d02608cba67d5b = (0, $df4Sl.createSelector)($380f8fa1c1fd4e11$export$db92824abfb21a2e, $380f8fa1c1fd4e11$export$7a380d7d28b470cc, (defaultComparator, columnComparators)=>(0, $dIFkw.default)(defaultComparator, columnComparators));
const $380f8fa1c1fd4e11$export$973bd9cbde2d338d = (0, $df4Sl.createSelector)($380f8fa1c1fd4e11$export$d6f73af294120ea1, (expandedColumnIds)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    expandedColumnIds.reduce((acc, next)=>{
        // for effeciency sake we are mutating the accumulator to build up our hash
        acc[next] = true;
        return acc;
    }, {}));
const $380f8fa1c1fd4e11$export$a6f67a8a23dbf9a1 = (0, $df4Sl.createSelector)($380f8fa1c1fd4e11$export$701fee8fc287bd90, (hiddenColumnIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($9BtCH)))(hiddenColumnIds, (hash, id)=>({
            ...hash,
            [id]: true
        }), {}));
const $380f8fa1c1fd4e11$export$489e7298b8651c2e = (0, $df4Sl.createSelector)($380f8fa1c1fd4e11$export$626e2d661dbdbb1e, $380f8fa1c1fd4e11$export$973bd9cbde2d338d, $380f8fa1c1fd4e11$export$a6f67a8a23dbf9a1, $380f8fa1c1fd4e11$export$9286093f6e1ecac, (columnTree, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds)=>(0, $el8hi.default)(columnTree, columnTree.rootCoreIds, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds));
const $380f8fa1c1fd4e11$export$987e0cd3ec211c8 = (0, $df4Sl.createSelector)($380f8fa1c1fd4e11$export$489e7298b8651c2e, $380f8fa1c1fd4e11$export$626e2d661dbdbb1e, $380f8fa1c1fd4e11$export$e54c9225ca52acc, (coreColumns, columnTree, columnWidths)=>coreColumns.length === 0 ? 0 : coreColumns.reduce((acc, columnId)=>{
        const columnWidth = columnWidths[columnId] || columnTree.columns[columnId].defaultWidth;
        return acc + columnWidth;
    }, 54));
const $380f8fa1c1fd4e11$export$3d6f7f2469223338 = (0, $df4Sl.createSelector)($380f8fa1c1fd4e11$export$626e2d661dbdbb1e, $380f8fa1c1fd4e11$export$a6f67a8a23dbf9a1, $380f8fa1c1fd4e11$export$9286093f6e1ecac, (columnTree, hiddenColumnIdsHash, sortedColumnIds)=>(0, $d5Oyp.default)(columnTree, columnTree.rootCoreIds.concat(columnTree.rootAdditionalIds), hiddenColumnIdsHash, sortedColumnIds));
const $380f8fa1c1fd4e11$export$d12de2db7af15c1f = (0, $df4Sl.createSelector)($380f8fa1c1fd4e11$export$489e7298b8651c2e, (visibleCoreColumnIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($9BtCH)))(visibleCoreColumnIds, (hash, id)=>({
            ...hash,
            [id]: true
        }), {}));
const $380f8fa1c1fd4e11$export$7fd4bf39bc1fa7d6 = (state, columnId)=>$380f8fa1c1fd4e11$export$626e2d661dbdbb1e(state).columns[columnId].title;
const $380f8fa1c1fd4e11$export$b4e69e5204b2a3b0 = (state, columnId)=>$380f8fa1c1fd4e11$export$626e2d661dbdbb1e(state).columns[columnId].HeaderComponent;
const $380f8fa1c1fd4e11$export$b165f1ee654a6c88 = (state, columnId)=>$380f8fa1c1fd4e11$export$626e2d661dbdbb1e(state).columns[columnId].tooltip;
const $380f8fa1c1fd4e11$export$76d9570454343133 = (state, columnId)=>{
    const columnTree = $380f8fa1c1fd4e11$export$626e2d661dbdbb1e(state);
    return columnTree.columns[columnId].minWidth;
};
const $380f8fa1c1fd4e11$export$134c72f8153b1472 = (state, columnId)=>{
    const columnTree = $380f8fa1c1fd4e11$export$626e2d661dbdbb1e(state);
    return columnTree.columns[columnId].maxWidth;
};
const $380f8fa1c1fd4e11$export$cf34af5efc32c51 = (state, columnId)=>$380f8fa1c1fd4e11$export$626e2d661dbdbb1e(state).columns[columnId].color || '#333';
const $380f8fa1c1fd4e11$export$55dbcdc822375b7c = (state, columnId)=>{
    const columnTree = $380f8fa1c1fd4e11$export$626e2d661dbdbb1e(state);
    return !!columnTree.columns[columnId].childrenIds && // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
    columnTree.columns[columnId].childrenIds.length > 0;
};
const $380f8fa1c1fd4e11$export$a63e62bf5f23be09 = (state, columnId)=>{
    const columnTree = $380f8fa1c1fd4e11$export$626e2d661dbdbb1e(state);
    return columnTree.columns[columnId].parentId;
};
const $380f8fa1c1fd4e11$export$588980822120b07b = (state, columnId)=>$380f8fa1c1fd4e11$export$626e2d661dbdbb1e(state).columns[columnId].resizeStrategy;
const $380f8fa1c1fd4e11$export$fd339f76e0ca945c = (state, columnId)=>{
    const expandedColumnIdsHash = $380f8fa1c1fd4e11$export$973bd9cbde2d338d(state);
    return !!expandedColumnIdsHash[columnId];
};
const $380f8fa1c1fd4e11$export$19a1e000b0c7f615 = (state, columnId)=>{
    const columnComparators = $380f8fa1c1fd4e11$export$7a380d7d28b470cc(state);
    return !!columnComparators[columnId];
};
const $380f8fa1c1fd4e11$export$d5f9813bca43da33 = (state, columnId)=>!!$380f8fa1c1fd4e11$export$626e2d661dbdbb1e(state).columns[columnId].childrenIds;
const $380f8fa1c1fd4e11$export$3289971ebd775b18 = (state, columnId)=>!!$380f8fa1c1fd4e11$export$626e2d661dbdbb1e(state).columns[columnId].parentId;
const $380f8fa1c1fd4e11$export$e6e327a97512715e = (state, columnId)=>$380f8fa1c1fd4e11$export$626e2d661dbdbb1e(state).columns[columnId].parentId;
const $380f8fa1c1fd4e11$export$d3671a4f3687bed = (state, columnId)=>$380f8fa1c1fd4e11$export$489e7298b8651c2e(state)[0] === columnId;
const $380f8fa1c1fd4e11$export$3180485c5d58c720 = (state, columnId)=>{
    const visibleColumnsLookupHash = $380f8fa1c1fd4e11$export$d12de2db7af15c1f(state);
    return !!visibleColumnsLookupHash[columnId];
};
const $380f8fa1c1fd4e11$export$f36235907d788d9d = (state, columnId)=>$380f8fa1c1fd4e11$export$626e2d661dbdbb1e(state).columns[columnId].canBeMultiLine || false;
const $380f8fa1c1fd4e11$export$893dde5c71a334bb = (0, $df4Sl.createSelector)($380f8fa1c1fd4e11$export$626e2d661dbdbb1e, (columnTree)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const columns = Object.values(columnTree.columns);
    return columns.filter((column)=>column.canBeMultiLine).length > 0;
});
const $380f8fa1c1fd4e11$export$1e5039fcef278b0d = (0, $df4Sl.createSelector)($380f8fa1c1fd4e11$export$626e2d661dbdbb1e, (columnTree)=>[
        ...columnTree.rootCoreIds,
        ...columnTree.rootAdditionalIds
    ]);
const $380f8fa1c1fd4e11$export$373740f91e6ef0b9 = (0, $df4Sl.createSelector)($380f8fa1c1fd4e11$export$9286093f6e1ecac, $380f8fa1c1fd4e11$export$626e2d661dbdbb1e, $380f8fa1c1fd4e11$export$1e5039fcef278b0d, (sortedColumnIds, columnTree, rootColumnIds)=>(0, $lEdvV.default)(columnTree, rootColumnIds, sortedColumnIds));

});
parcelRegister("9BtCH", function(module, exports) {

var $flmMe = parcelRequire("flmMe");

var $awetI = parcelRequire("awetI");

var $7qARj = parcelRequire("7qARj");

var $jhbYY = parcelRequire("jhbYY");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $6fde8c506e131c3e$var$reduce(collection, iteratee, accumulator) {
    var func = $1c8hB(collection) ? $flmMe : $jhbYY, initAccum = arguments.length < 3;
    return func(collection, $7qARj(iteratee, 4), accumulator, initAccum, $awetI);
}
module.exports = $6fde8c506e131c3e$var$reduce;

});
parcelRegister("jhbYY", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $e088e655a3a9a31d$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $e088e655a3a9a31d$var$baseReduce;

});


parcelRegister("dIFkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $823664b9bde4446f$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$823664b9bde4446f$export$2e2bcd8739ae039 = (defaultComparator, columnComparators)=>{
    if (!defaultComparator) return undefined;
    return typeof defaultComparator === 'function' ? defaultComparator : columnComparators[defaultComparator];
};

});

parcelRegister("lEdvV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e17efeb5334ddb9a$export$2e2bcd8739ae039);

var $1ileA = parcelRequire("1ileA");
const $e17efeb5334ddb9a$var$traverseColumns = (columnTree, columnIds, sortedColumnIds, result)=>{
    (0, $1ileA.default)(sortedColumnIds, columnIds).forEach((columnId)=>{
        const childrenIds = columnTree.columns[columnId].childrenIds || [];
        result.push(columnId);
        $e17efeb5334ddb9a$var$traverseColumns(columnTree, childrenIds, sortedColumnIds, result);
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e17efeb5334ddb9a$export$2e2bcd8739ae039 = (columnTree, rootColumnIds, sortedColumnIds)=>{
    const result = [];
    $e17efeb5334ddb9a$var$traverseColumns(columnTree, rootColumnIds, sortedColumnIds, result);
    return result;
};

});
parcelRegister("1ileA", function(module, exports) {

$parcel$export(module.exports, "default", () => $25a2384858d8d90d$export$2e2bcd8739ae039);

var $jq5QE = parcelRequire("jq5QE");

var $iVIEg = parcelRequire("iVIEg");

var $kG4jb = parcelRequire("kG4jb");
const $25a2384858d8d90d$var$getLevelIds = (sortedColumnIds, columnIds)=>{
    if (sortedColumnIds === undefined) return columnIds;
    const levelIdsNotInSortedArray = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(columnIds, sortedColumnIds);
    const sortedIdsInLevel = (0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(sortedColumnIds, columnIds);
    /*  to cope with inconsistent data provided by the consumer - in case of overridden column sort order,
        we append ids that exist in the current level array but not in the sorted array (override), at the end.
     */ return (0, (/*@__PURE__*/$parcel$interopDefault($jq5QE)))(sortedIdsInLevel, levelIdsNotInSortedArray);
};
var $25a2384858d8d90d$export$2e2bcd8739ae039 = $25a2384858d8d90d$var$getLevelIds;

});
parcelRegister("jq5QE", function(module, exports) {

var $3wMve = parcelRequire("3wMve");

var $hKE3p = parcelRequire("hKE3p");

var $b69Sx = parcelRequire("b69Sx");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */ function $e234fb627856802d$var$concat() {
    var length = arguments.length;
    if (!length) return [];
    var args = Array(length - 1), array = arguments[0], index = length;
    while(index--)args[index - 1] = arguments[index];
    return $3wMve($1c8hB(array) ? $b69Sx(array) : [
        array
    ], $hKE3p(args, 1));
}
module.exports = $e234fb627856802d$var$concat;

});



parcelRegister("el8hi", function(module, exports) {

$parcel$export(module.exports, "default", () => $310c70d0aec9c8ba$export$2e2bcd8739ae039);

var $1ileA = parcelRequire("1ileA");
const $310c70d0aec9c8ba$var$traverseColumns = (columnTree, columnIds, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds, result)=>{
    (0, $1ileA.default)(sortedColumnIds, columnIds).forEach((columnId)=>{
        const childrenIds = (expandedColumnIdsHash[columnId] ? columnTree.columns[columnId].childrenIds : []) || [];
        if (!hiddenColumnIdsHash[columnId]) {
            result.push(columnId);
            $310c70d0aec9c8ba$var$traverseColumns(columnTree, childrenIds, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds, result);
        }
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$310c70d0aec9c8ba$export$2e2bcd8739ae039 = (columnTree, rootColumnIds, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds)=>{
    const result = [];
    $310c70d0aec9c8ba$var$traverseColumns(columnTree, rootColumnIds, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds, result);
    return result;
};

});

parcelRegister("d5Oyp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4440e71a20cfaa6c$export$2e2bcd8739ae039);

var $1LCin = parcelRequire("1LCin");

var $1ileA = parcelRequire("1ileA");
const $4440e71a20cfaa6c$var$traverseColumns = (columnTree, columnIds, hiddenColumnIdsHash, sortedColumnIds, result)=>{
    (0, $1ileA.default)(sortedColumnIds, columnIds).forEach((columnId)=>{
        const column = columnTree.columns[columnId];
        const { parentId: parentId } = column;
        const isParentHidden = parentId ? !!hiddenColumnIdsHash[parentId] : false;
        const columnConfiguration = {
            id: column.id,
            title: column.title,
            // FSN-4987 Remove resize strategy related logic during cleanup
            resizeStrategy: column.resizeStrategy,
            isHidden: !!hiddenColumnIdsHash[columnId],
            isDisabled: column.isHideable === false,
            parentId: parentId,
            isParentHidden: isParentHidden,
            depth: (0, $1LCin.default)(columnTree.columns, columnId)
        };
        if (!column.isMarkup) result.push(columnConfiguration);
        const childrenIds = column.childrenIds || [];
        $4440e71a20cfaa6c$var$traverseColumns(columnTree, childrenIds, hiddenColumnIdsHash, sortedColumnIds, result);
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4440e71a20cfaa6c$export$2e2bcd8739ae039 = (columnTree, rootColumnIds, hiddenColumnIdsHash, sortedColumnIds)=>{
    const result = [];
    $4440e71a20cfaa6c$var$traverseColumns(columnTree, rootColumnIds, hiddenColumnIdsHash, sortedColumnIds, result);
    return result;
};

});
parcelRegister("1LCin", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb8fb9c8093cf5b0$export$2e2bcd8739ae039);

var $ffUxt = parcelRequire("ffUxt");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb8fb9c8093cf5b0$export$2e2bcd8739ae039 = (tree, id)=>(0, $ffUxt.default)(tree, id).length - 1;

});
parcelRegister("ffUxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $f68f3bce4508cb53$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f68f3bce4508cb53$export$2e2bcd8739ae039 = (tree, id)=>{
    const path = [
        id
    ];
    let currentId = id;
    while(tree[currentId].parentId){
        const { parentId: parentId } = tree[currentId];
        // @ts-expect-error - TS2345 - Argument of type 'Optional<string>' is not assignable to parameter of type 'string'.
        path.unshift(parentId);
        // @ts-expect-error - TS2322 - Type 'Optional<string>' is not assignable to type 'string'.
        currentId = parentId;
    }
    return path;
};

});





parcelRegister("4aSHd", function(module, exports) {

$parcel$export(module.exports, "getActiveItem", () => $c22cf78ff9d3f703$export$f0f14253205ef68f);
$parcel$export(module.exports, "getActiveRow", () => $c22cf78ff9d3f703$export$be515f6e1df61362);
$parcel$export(module.exports, "getActiveCell", () => $c22cf78ff9d3f703$export$70059ae5084357cb);
$parcel$export(module.exports, "getResizingColumnId", () => $c22cf78ff9d3f703$export$db5a621909f822c0);
$parcel$export(module.exports, "getVerticalScrollOffset", () => $c22cf78ff9d3f703$export$76e51b2d87e066ab);
$parcel$export(module.exports, "hasVerticallyScrolled", () => $c22cf78ff9d3f703$export$e7c447ae7e47068f);
$parcel$export(module.exports, "getHorizontalScrollOffset", () => $c22cf78ff9d3f703$export$624a30c8322e672b);
$parcel$export(module.exports, "getIsSortOverrideEnabled", () => $c22cf78ff9d3f703$export$97b55762fc1eba7f);
$parcel$export(module.exports, "getTableHeight", () => $c22cf78ff9d3f703$export$81ff4c821ba5ba90);
$parcel$export(module.exports, "getTableWidth", () => $c22cf78ff9d3f703$export$4910020ffe58186f);
$parcel$export(module.exports, "getTableWidthWithoutScrollbarOffset", () => $c22cf78ff9d3f703$export$cbeeb8058672c78a);
$parcel$export(module.exports, "getTableRowMargin", () => $c22cf78ff9d3f703$export$a388e245e4b1a116);
$parcel$export(module.exports, "getDraggingRowId", () => $c22cf78ff9d3f703$export$fdc0e8ca65eb11e);
$parcel$export(module.exports, "getActiveSortedColumnConfiguration", () => $c22cf78ff9d3f703$export$eaa5c021c57b0ffd);
$parcel$export(module.exports, "getSortedRowIdsHash", () => $c22cf78ff9d3f703$export$204c73f66abde0fb);
$parcel$export(module.exports, "getHeaderHeight", () => $c22cf78ff9d3f703$export$98ba287114e9d0c3);
$parcel$export(module.exports, "getRenderSidebarIcon", () => $c22cf78ff9d3f703$export$a0841f9badd7cdca);

const $c22cf78ff9d3f703$export$f0f14253205ef68f = (state)=>state.internal.activeItem;
const $c22cf78ff9d3f703$export$be515f6e1df61362 = (state)=>{
    const activeItem = $c22cf78ff9d3f703$export$f0f14253205ef68f(state);
    return activeItem && activeItem.type === (0, $a37593d97c1ae333$export$8a257aa81ef4a9e0) ? activeItem : undefined;
};
const $c22cf78ff9d3f703$export$70059ae5084357cb = (state)=>{
    const activeItem = $c22cf78ff9d3f703$export$f0f14253205ef68f(state);
    return activeItem && activeItem.type === (0, $a37593d97c1ae333$export$4b3489234fd17200) ? activeItem : undefined;
};
const $c22cf78ff9d3f703$export$db5a621909f822c0 = (state)=>state.internal.resizingColumnId;
const $c22cf78ff9d3f703$export$76e51b2d87e066ab = (state)=>state.internal.verticalScrollOffset;
const $c22cf78ff9d3f703$export$e7c447ae7e47068f = (state)=>state.internal.verticalScrollOffset > 0;
const $c22cf78ff9d3f703$export$becdfc8521c14ad2 = (state)=>state.internal.verticalScrollDelta;
const $c22cf78ff9d3f703$export$624a30c8322e672b = (state)=>state.internal.horizontalScrollOffset;
const $c22cf78ff9d3f703$export$97b55762fc1eba7f = (state)=>state.internal.isSortOverrideEnabled;
const $c22cf78ff9d3f703$export$af7a4f73692b1459 = (state)=>state.internal.tableSize;
const $c22cf78ff9d3f703$export$81ff4c821ba5ba90 = (state)=>$c22cf78ff9d3f703$export$af7a4f73692b1459(state).height;
const $c22cf78ff9d3f703$export$4910020ffe58186f = (state)=>$c22cf78ff9d3f703$export$af7a4f73692b1459(state).width;
const $c22cf78ff9d3f703$export$cbeeb8058672c78a = (state)=>$c22cf78ff9d3f703$export$af7a4f73692b1459(state).widthWithoutScrollbarOffset;
const $c22cf78ff9d3f703$export$a388e245e4b1a116 = (state)=>$c22cf78ff9d3f703$export$af7a4f73692b1459(state).rowMargin;
const $c22cf78ff9d3f703$export$fdc0e8ca65eb11e = (state)=>state.internal.draggingRowId;
const $c22cf78ff9d3f703$export$f0d8a9d6630b9103 = (state)=>state.internal.multiAddAnchorId;
const $c22cf78ff9d3f703$export$eaa5c021c57b0ffd = (state)=>state.internal.activeSortedColumnConfiguration;
const $c22cf78ff9d3f703$export$204c73f66abde0fb = (state)=>state.internal.sortedRowIdsHash;
const $c22cf78ff9d3f703$export$728dbf35b325565b = (state)=>state.internal.scrollbarSize;
const $c22cf78ff9d3f703$export$98ba287114e9d0c3 = (state)=>state.internal.headerHeight;
const $c22cf78ff9d3f703$export$a0841f9badd7cdca = (state)=>state.internal.renderSidebarIcon;

});

parcelRegister("5jaaH", function(module, exports) {

$parcel$export(module.exports, "getRowDepth", () => $31faaa78a5ea4063$export$d9790c6d67ace138);
$parcel$export(module.exports, "getVisibleLoadingRowIds", () => $31faaa78a5ea4063$export$79bc68636023e019);
$parcel$export(module.exports, "isAddLinkShown", () => $31faaa78a5ea4063$export$f1f55f40e2397801);
$parcel$export(module.exports, "isGlobalAddEnabled", () => $31faaa78a5ea4063$export$53bdd4654b396c67);
$parcel$export(module.exports, "canLastRowAddSiblingOrChildren", () => $31faaa78a5ea4063$export$7c458dc02abd8dc7);
$parcel$export(module.exports, "getTableHeight", () => $31faaa78a5ea4063$export$81ff4c821ba5ba90);
$parcel$export(module.exports, "getTableContentWidth", () => $31faaa78a5ea4063$export$bf1a6d4805ae1aa3);
$parcel$export(module.exports, "getTableContentHeight", () => $31faaa78a5ea4063$export$6d30ea7d886d20a8);
$parcel$export(module.exports, "getTableRowsHeight", () => $31faaa78a5ea4063$export$508de1ea1f8be016);
$parcel$export(module.exports, "getHorizontalScrollWidth", () => $31faaa78a5ea4063$export$59e4df7bc874f4dc);
$parcel$export(module.exports, "getColumnWidth", () => $31faaa78a5ea4063$export$dfa11a34ceba822);
$parcel$export(module.exports, "getScrollOffsetForRowIndex", () => $31faaa78a5ea4063$export$7f5dc96b25afd50);
$parcel$export(module.exports, "hasHorizontalScrollbar", () => $31faaa78a5ea4063$export$35f00941c70ac98c);
$parcel$export(module.exports, "hasVerticalScrollbar", () => $31faaa78a5ea4063$export$5ce15b832a232abf);
$parcel$export(module.exports, "isHorizontalScrollLeftShadowVisible", () => $31faaa78a5ea4063$export$482d647122d9850d);
$parcel$export(module.exports, "getMaxHorizontalScrollOffset", () => $31faaa78a5ea4063$export$9854f9aebd7abc1c);
$parcel$export(module.exports, "isHorizontalScrollRightShadowVisible", () => $31faaa78a5ea4063$export$a5fd1dde37333151);
$parcel$export(module.exports, "getVisibleAdditionalColumnsWidth", () => $31faaa78a5ea4063$export$c17b791581a1b518);
$parcel$export(module.exports, "getOffsetFromBottom", () => $31faaa78a5ea4063$export$8d5a56e5651cf107);
$parcel$export(module.exports, "getOffsetFromTop", () => $31faaa78a5ea4063$export$302e8799c65ec80);
$parcel$export(module.exports, "getOffsetFromLeft", () => $31faaa78a5ea4063$export$be46d880d5c67a2f);
$parcel$export(module.exports, "getOffsetFromRight", () => $31faaa78a5ea4063$export$cdbbb229c03c4259);
$parcel$export(module.exports, "getColumnSortOrder", () => $31faaa78a5ea4063$export$28e014ec3d91f1b2);
$parcel$export(module.exports, "getShouldVirtualize", () => $31faaa78a5ea4063$export$75cdbb73a780df34);
$parcel$export(module.exports, "getVirtualBoundaries", () => $31faaa78a5ea4063$export$3ddd5b9a27496e14);
$parcel$export(module.exports, "getNumberOfLoadingRowsInDisplayBoundary", () => $31faaa78a5ea4063$export$15a684dfff6d5394);
$parcel$export(module.exports, "getActiveRowIndex", () => $31faaa78a5ea4063$export$b455bac95fd02aad);
$parcel$export(module.exports, "getNextActiveRowIndex", () => $31faaa78a5ea4063$export$7b06ecd71d436a71);
$parcel$export(module.exports, "getPrevActiveRowIndex", () => $31faaa78a5ea4063$export$c98fb65aaf1fa4f7);
$parcel$export(module.exports, "rowIndexToRowId", () => $31faaa78a5ea4063$export$7bf5553e96d8acb1);
$parcel$export(module.exports, "getActiveRowId", () => $31faaa78a5ea4063$export$f5e04ce1033f6b64);
$parcel$export(module.exports, "isActiveRowId", () => $31faaa78a5ea4063$export$4fad04245eebe683);
$parcel$export(module.exports, "isActiveRowItem", () => $31faaa78a5ea4063$export$9b16a7f2e1834f77);
$parcel$export(module.exports, "getSetFocusOnRow", () => $31faaa78a5ea4063$export$cff73bbfaa0526d1);
$parcel$export(module.exports, "isCellActive", () => $31faaa78a5ea4063$export$c14f48cad4f0ee46);
$parcel$export(module.exports, "shouldRowHydrateFully", () => $31faaa78a5ea4063$export$9b148117f6b512ea);

var $df4Sl = parcelRequire("df4Sl");

var $4oraa = parcelRequire("4oraa");

var $1ybV0 = parcelRequire("1ybV0");

var $ajzlS = parcelRequire("ajzlS");



var $01OF3 = parcelRequire("01OF3");

var $4Bkxm = parcelRequire("4Bkxm");

var $f5bbs = parcelRequire("f5bbs");

var $4aSHd = parcelRequire("4aSHd");

var $fZ2Nd = parcelRequire("fZ2Nd");
const $31faaa78a5ea4063$export$d9790c6d67ace138 = (state, rowId)=>{
    const rowDepthAndPath = (0, $f5bbs.getStaticRowPathAndDepth)(state);
    if ((0, $f5bbs.isRowBeingAdded)(state, rowId)) {
        // @ts-expect-error - TS2339 - Property 'anchorId' does not exist on type 'Optional<TemporaryAddedRow>'. | TS2339 - Property 'position' does not exist on type 'Optional<TemporaryAddedRow>'.
        const { anchorId: anchorId, position: position } = (0, $f5bbs.getTemporaryAddedRow)(state);
        if (anchorId) return position === 'INSIDE' ? rowDepthAndPath[anchorId].depth + 1 : rowDepthAndPath[anchorId].depth;
        /* FIRST or LAST rows will be designated to the highest level */ return 0;
    }
    if (rowDepthAndPath[rowId] === undefined) return 0;
    return rowDepthAndPath[rowId].depth;
};
const $31faaa78a5ea4063$export$79bc68636023e019 = (0, $df4Sl.createSelector)((0, $fZ2Nd.getFlattenedWithAddedRowIds), (0, $f5bbs.getRowsConfiguration), (visibleRowIds, rowsConfiguration)=>visibleRowIds.filter((rowId)=>{
        const rowConfiguration = rowsConfiguration[rowId];
        if (!rowConfiguration) return false;
        return rowConfiguration.isLoading;
    }));
const $31faaa78a5ea4063$export$f1f55f40e2397801 = (state)=>(0, $01OF3.getRowAddCallback)(state) !== undefined && (0, $f5bbs.getAddLinkCaption)(state) !== undefined && !(0, $f5bbs.isAnyRowBeingAdded)(state);
const $31faaa78a5ea4063$export$53bdd4654b396c67 = (0, $df4Sl.createSelector)((0, $01OF3.getRowAddCallback), (0, $f5bbs.isAnyRowBeingAdded), (0, $4aSHd.getDraggingRowId), (rowAddCallback, rowBeingAdded, draggingRowId)=>rowAddCallback !== undefined && !rowBeingAdded && !draggingRowId);
const $31faaa78a5ea4063$export$ffaca24172efb7ca = (0, $df4Sl.createSelector)((0, $4aSHd.getActiveSortedColumnConfiguration), (0, $4Bkxm.getDefaultComparator), (0, $f5bbs.isAnyRowBeingAdded), (activeSortedColumnConfiguration, defaultComparator, anyRowBeingAdded)=>{
    if (anyRowBeingAdded) return false;
    // If we are sorted by something, it's still ok IF it would match the default sort order
    return !activeSortedColumnConfiguration || typeof defaultComparator === 'string' && activeSortedColumnConfiguration.columnId === defaultComparator && activeSortedColumnConfiguration.sortOrder === (0, $c947ad34bf4dc375$export$6e386ac144cffab5);
});
const $31faaa78a5ea4063$export$4835fe21099e222d = (state)=>state.consumer.draggableRows;
const $31faaa78a5ea4063$var$isDraggablePerRow = (0, $df4Sl.createSelector)((0, $f5bbs.getRowTree), (0, $f5bbs.getRowsConfiguration), (rowTree, rowsConfiguration)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isDraggableHash = {};
    Object.keys(rowTree.rows).forEach((rowId)=>{
        const rowConfiguration = rowsConfiguration[rowId];
        if (rowConfiguration) // if it is configured on a per-row basis
        isDraggableHash[rowId] = rowConfiguration.isDraggable !== undefined ? rowConfiguration.isDraggable : true;
        else // if the callback is implemented, and it has not been
        // configured, default to allow dragging
        isDraggableHash[rowId] = true;
    });
    return isDraggableHash;
});
const $31faaa78a5ea4063$export$f04970757ee58393 = (state, rowId)=>$31faaa78a5ea4063$export$4835fe21099e222d(state) && $31faaa78a5ea4063$var$isDraggablePerRow(state)[rowId];
const $31faaa78a5ea4063$export$7c458dc02abd8dc7 = (state)=>{
    const rowIds = (0, $fZ2Nd.getFlattenedWithAddedRowIds)(state);
    const lastRowId = rowIds[rowIds.length - 1];
    const lastRowConfig = (0, $f5bbs.getRowsConfiguration)(state)[lastRowId];
    if (lastRowConfig) return (0, $f5bbs.getRowCanAddSibling)(state, lastRowId) || (0, $f5bbs.getRowCanAddChildren)(state, lastRowId);
    return false;
};
const $31faaa78a5ea4063$export$81ff4c821ba5ba90 = (0, $df4Sl.createSelector)((0, $4aSHd.getTableHeight), (0, $fZ2Nd.getVisibleRowsCount), (0, $01OF3.isAutoHeight), $31faaa78a5ea4063$export$f1f55f40e2397801, (0, $f5bbs.getAbsoluteRowHeight), $31faaa78a5ea4063$export$7c458dc02abd8dc7, (0, $f5bbs.getAddBarOverflow), (0, $4aSHd.getHeaderHeight), (tableHeightInternal, visibleRowsCount, autoHeight, addLinkShown, absoluteRowHeight, hasAddBar, addBarOverflow, headerHeight)=>{
    if (autoHeight) {
        const rowMultiplier = visibleRowsCount + (addLinkShown ? 1 : 0);
        return rowMultiplier * absoluteRowHeight + (hasAddBar || addLinkShown ? addBarOverflow : 0) + headerHeight;
    }
    return tableHeightInternal;
});
const $31faaa78a5ea4063$export$bf1a6d4805ae1aa3 = (0, $df4Sl.createSelector)((0, $01OF3.isDetailsPanelOpen), (0, $4Bkxm.getVisibleCoreColumnsWidth), (0, $4aSHd.getTableWidth), (isDetailsOpen, visibleCoreColumnWidth, tableWidth)=>isDetailsOpen ? visibleCoreColumnWidth : tableWidth);
const $31faaa78a5ea4063$export$6d30ea7d886d20a8 = (state)=>Math.max(0, $31faaa78a5ea4063$export$81ff4c821ba5ba90(state) - (0, $4aSHd.getHeaderHeight)(state));
const $31faaa78a5ea4063$export$508de1ea1f8be016 = (0, $df4Sl.createSelector)((0, $fZ2Nd.getVisibleRowsCount), (0, $f5bbs.getAbsoluteRowHeight), $31faaa78a5ea4063$export$7c458dc02abd8dc7, $31faaa78a5ea4063$export$f1f55f40e2397801, (0, $f5bbs.getAddBarOverflow), (visibleRowsCount, absoluteRowHeight, hasAddBar, addLinkShown, addBarOverflow)=>visibleRowsCount * absoluteRowHeight + (hasAddBar || addLinkShown ? addBarOverflow : 0));
const $31faaa78a5ea4063$export$59e4df7bc874f4dc = (state)=>(0, $4aSHd.getTableWidth)(state) - (0, $4Bkxm.getVisibleCoreColumnsWidth)(state);
const $31faaa78a5ea4063$export$99ecae6d98dc3df3 = (0, $df4Sl.createSelector)((0, $01OF3.getTotalDynamicColumnMinWidth), (0, $01OF3.getTotalDynamicColumnMaxWidth), (0, $4Bkxm.getColumnTree), (0, $4aSHd.getTableWidthWithoutScrollbarOffset), (0, $4aSHd.getTableRowMargin), (0, $01OF3.getVisibleColumnIds), (0, $4Bkxm.getColumnWidths), (totalDynamicMinWidth, totalDynamicMaxWidth, columnTree, tableWidth, rowMargin, visibleColumnIds, columnWidths)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    let totalStaticColumnWidth = 0;
    visibleColumnIds.forEach((columnId)=>{
        if ((0, $1ybV0.ff)('remove-react-dnd-from-virtual-table-cleanup_5ho59') || columnTree.columns[columnId] === undefined) return;
        // FSN-4987 Remove resize strategy related logic during cleanup
        if (columnTree.columns[columnId].resizeStrategy === (0, $c947ad34bf4dc375$export$3920b9c14da1301c)) {
            const width = columnWidths[columnId] || columnTree.columns[columnId].defaultWidth;
            result[columnId] = width;
            totalStaticColumnWidth += width;
        }
    });
    const distributableWidth = tableWidth - totalStaticColumnWidth;
    visibleColumnIds.forEach((columnId)=>{
        if (columnTree.columns[columnId] === undefined) return;
        if ((0, $1ybV0.ff)('remove-react-dnd-from-virtual-table-cleanup_5ho59') || columnTree.columns[columnId].resizeStrategy === (0, $c947ad34bf4dc375$export$4670af9f718b9e66)) {
            if (totalDynamicMaxWidth <= distributableWidth) // Plenty of space; consume as much as possible
            result[columnId] = columnTree.columns[columnId].maxWidth;
            else if (totalDynamicMinWidth >= distributableWidth) // Less space than required; consume as little as possible
            result[columnId] = columnTree.columns[columnId].minWidth;
            else {
                // Between min & max; distribute remaining space based on relative min widths.
                const { minWidth: minWidth } = columnTree.columns[columnId];
                const { maxWidth: maxWidth } = columnTree.columns[columnId];
                const scalingFactor = (maxWidth - minWidth) / (totalDynamicMaxWidth - totalDynamicMinWidth);
                result[columnId] = Math.min(maxWidth, minWidth + scalingFactor * (distributableWidth - totalDynamicMinWidth));
            }
        }
    });
    return result;
});
const $31faaa78a5ea4063$export$dfa11a34ceba822 = (state, columnId)=>$31faaa78a5ea4063$export$99ecae6d98dc3df3(state)[columnId];
const $31faaa78a5ea4063$export$96b57a8283901306 = (state)=>Math.round(Object.values($31faaa78a5ea4063$export$99ecae6d98dc3df3(state)).reduce((sum, width)=>sum + width, 0));
const $31faaa78a5ea4063$export$354f0f01a9ec3ab0 = (0, $df4Sl.createSelector)((0, $fZ2Nd.getFlattenedWithAddedRowIds), (0, $f5bbs.getRowHeightMapping), (0, $f5bbs.getAbsoluteRowHeight), (visibleRowIds, rowHeightMapping, approximateRowHeight)=>{
    if (visibleRowIds.length === 0) return [];
    // We map heights to _start_ positions of the rows, hence starting
    // with "[0]" and deleting the last. We deliberately exclude the last
    // row.
    const rowPositions = [
        0
    ];
    for(let i = 0; i < visibleRowIds.length - 1; i += 1){
        const lastHeight = rowPositions[rowPositions.length - 1];
        const nextHeight = lastHeight + (rowHeightMapping[visibleRowIds[i]] || approximateRowHeight);
        rowPositions.push(nextHeight);
    }
    return rowPositions;
});
const $31faaa78a5ea4063$export$7f5dc96b25afd50 = (0, $df4Sl.createSelector)($31faaa78a5ea4063$export$354f0f01a9ec3ab0, // @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7006 - Parameter 'rowIndex' implicitly has an 'any' type.
(_, rowIndex)=>rowIndex, (rowPositionArray, rowIndex)=>{
    if (rowIndex < 0) return 0;
    if (rowIndex >= rowPositionArray.length) return rowPositionArray[rowPositionArray.length - 1];
    return rowPositionArray[rowIndex];
});
const $31faaa78a5ea4063$export$e04c926b10911ac2 = (0, $df4Sl.createSelector)($31faaa78a5ea4063$export$354f0f01a9ec3ab0, $31faaa78a5ea4063$export$6d30ea7d886d20a8, (0, $f5bbs.getRowHeightMapping), (0, $fZ2Nd.getFlattenedWithAddedRowIds), (rowPositionArray, tableHeight, rowHeightMapping, visibleRowIds)=>{
    const lastRowStartPosition = rowPositionArray[rowPositionArray.length - 1];
    const lastRowHeight = rowHeightMapping[visibleRowIds[visibleRowIds.length - 1]];
    return lastRowStartPosition + lastRowHeight - tableHeight;
});
const $31faaa78a5ea4063$export$35f00941c70ac98c = (0, $df4Sl.createSelector)($31faaa78a5ea4063$export$96b57a8283901306, (0, $4aSHd.getTableWidthWithoutScrollbarOffset), (allColumnWidth, tableWidth)=>allColumnWidth > tableWidth);
const $31faaa78a5ea4063$export$5ce15b832a232abf = (state)=>$31faaa78a5ea4063$export$e04c926b10911ac2(state) > 0;
const $31faaa78a5ea4063$export$482d647122d9850d = (0, $df4Sl.createSelector)((0, $01OF3.isDetailsPanelOpen), (0, $4aSHd.getHorizontalScrollOffset), (isDetailsOpen, horizontalScrollOffset)=>!isDetailsOpen && horizontalScrollOffset > 0);
const $31faaa78a5ea4063$export$9854f9aebd7abc1c = (0, $df4Sl.createSelector)($31faaa78a5ea4063$export$96b57a8283901306, (0, $4aSHd.getTableWidthWithoutScrollbarOffset), (allColumnWidth, tableWidth)=>allColumnWidth - tableWidth);
const $31faaa78a5ea4063$export$a5fd1dde37333151 = (0, $df4Sl.createSelector)((0, $01OF3.isDetailsPanelOpen), (0, $4aSHd.getHorizontalScrollOffset), $31faaa78a5ea4063$export$9854f9aebd7abc1c, (isDetailsOpen, horizontalScrollOffset, maxHorizontalScrollOffset)=>!isDetailsOpen && horizontalScrollOffset < maxHorizontalScrollOffset);
const $31faaa78a5ea4063$export$c17b791581a1b518 = (0, $df4Sl.createSelector)((0, $01OF3.getVisibleAdditionalColumnIds), $31faaa78a5ea4063$export$99ecae6d98dc3df3, (additionalColumns, columnWidthHash)=>additionalColumns.reduce((acc, columnId)=>acc + columnWidthHash[columnId], 0));
const $31faaa78a5ea4063$export$a4a1496398ad37a = (distance)=>Math.max(0, Math.floor(distance));
const $31faaa78a5ea4063$export$8d5a56e5651cf107 = (state)=>$31faaa78a5ea4063$export$a4a1496398ad37a($31faaa78a5ea4063$export$e04c926b10911ac2(state) - (0, $4aSHd.getVerticalScrollOffset)(state));
const $31faaa78a5ea4063$export$302e8799c65ec80 = (state)=>$31faaa78a5ea4063$export$a4a1496398ad37a((0, $4aSHd.getVerticalScrollOffset)(state));
const $31faaa78a5ea4063$export$be46d880d5c67a2f = (state)=>$31faaa78a5ea4063$export$a4a1496398ad37a((0, $4aSHd.getHorizontalScrollOffset)(state));
const $31faaa78a5ea4063$export$cdbbb229c03c4259 = (state)=>$31faaa78a5ea4063$export$a4a1496398ad37a($31faaa78a5ea4063$export$9854f9aebd7abc1c(state) - (0, $4aSHd.getHorizontalScrollOffset)(state));
const $31faaa78a5ea4063$var$getSortOrderForColumns = (0, $df4Sl.createSelector)((0, $4Bkxm.getColumnTree), (0, $4Bkxm.getDefaultComparator), (0, $4aSHd.getActiveSortedColumnConfiguration), (columnTree, defaultComparator, activeSortedColumnConfiguration)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const columnSortOrderHash = {};
    if (activeSortedColumnConfiguration === undefined) {
        /* When the default comparator is specified as a column id,
			 * rather than the function, we have to be explicit since
			 * sorting behaviour differs. In this case, if not actively
			 * sorting by anything, we are actively sorting by the default
			 * column (compared to passively).
			 */ if (typeof defaultComparator === 'string') columnSortOrderHash[defaultComparator] = (0, $c947ad34bf4dc375$export$6e386ac144cffab5);
        return columnSortOrderHash;
    }
    Object.keys(columnTree.columns).forEach((columnId)=>{
        // need to check truthy-ness again since flow disregards check outside a function call
        if (activeSortedColumnConfiguration !== undefined && columnId === activeSortedColumnConfiguration.columnId) columnSortOrderHash[columnId] = activeSortedColumnConfiguration.sortOrder;
    });
    return columnSortOrderHash;
});
const $31faaa78a5ea4063$export$28e014ec3d91f1b2 = (state, columnId)=>$31faaa78a5ea4063$var$getSortOrderForColumns(state)[columnId];
const $31faaa78a5ea4063$var$DEFAULT_BOUNDARIES = {
    visibleStart: 0,
    visibleEnd: 0,
    displayStart: 0,
    displayEnd: 0
};
const $31faaa78a5ea4063$var$DEFAULT_BUFFER_SIZE = 5;
const $31faaa78a5ea4063$var$getVisibleRowIndexAtOffset = (rowPositions, offsetPosition)=>{
    if (rowPositions.length === 0) return 0;
    // sortedIndex for log(n) performance.
    const idx = (0, (/*@__PURE__*/$parcel$interopDefault($4oraa)))(rowPositions, offsetPosition);
    // sortedIndex always returns the position after the equality. To make
    // this easier to reason about, we'll check whether the index prior starts
    // at exactly the offsetPosition, and return that instead if it does.
    if (rowPositions[idx] === offsetPosition) return idx;
    return idx - 1;
};
const $31faaa78a5ea4063$var$calculateVirtualBoundaries = (rowIds, scrollTop, contentHeight, rowPositionArray, shouldVirtualize, virtualBufferSize)=>{
    if (contentHeight === 0 || rowIds.length === 0) return $31faaa78a5ea4063$var$DEFAULT_BOUNDARIES;
    const numberOfTotalRows = rowIds.length - 1;
    const visibleStart = Math.max($31faaa78a5ea4063$var$getVisibleRowIndexAtOffset(rowPositionArray, scrollTop), 0);
    const visibleEnd = Math.min($31faaa78a5ea4063$var$getVisibleRowIndexAtOffset(rowPositionArray, scrollTop + contentHeight), numberOfTotalRows);
    const bufferSize = shouldVirtualize ? virtualBufferSize : numberOfTotalRows;
    // if the total number of rows is rather small (up to the provided threshold) then we render all, always.
    const displayStart = Math.max(0, visibleStart - bufferSize);
    const displayEnd = Math.min(visibleEnd + bufferSize, numberOfTotalRows);
    return {
        visibleStart: visibleStart,
        visibleEnd: visibleEnd,
        displayStart: displayStart,
        displayEnd: displayEnd
    };
};
const $31faaa78a5ea4063$export$75cdbb73a780df34 = (0, $df4Sl.createSelector)((0, $01OF3.isTableFacade), (0, $fZ2Nd.getFlattenedWithAddedRowIds), (0, $01OF3.getShouldSkipVirtualization), (tableFacade, rowIds, shouldSkipVirtualization)=>{
    if (shouldSkipVirtualization ?? false) return false;
    return tableFacade || rowIds.length > (0, $ajzlS.minRowsForTreeTableVirtualisation);
});
const $31faaa78a5ea4063$export$3ddd5b9a27496e14 = (0, $df4Sl.createSelector)((0, $fZ2Nd.getFlattenedWithAddedRowIds), (0, $4aSHd.getVerticalScrollOffset), $31faaa78a5ea4063$export$6d30ea7d886d20a8, $31faaa78a5ea4063$export$354f0f01a9ec3ab0, $31faaa78a5ea4063$export$75cdbb73a780df34, (rowIds, scrollTop, contentHeight, rowPositionArray, shouldVirtualize)=>// render all rows when there are not more than minRowsForVirtualisation
    $31faaa78a5ea4063$var$calculateVirtualBoundaries(rowIds, scrollTop, contentHeight, rowPositionArray, shouldVirtualize, $31faaa78a5ea4063$var$DEFAULT_BUFFER_SIZE));
const $31faaa78a5ea4063$export$1e9cf27313ff3cdf = (0, $df4Sl.createSelector)((0, $fZ2Nd.getFlattenedWithAddedRowIds), (0, $f5bbs.getRowsConfiguration), $31faaa78a5ea4063$export$3ddd5b9a27496e14, (visibleRowIds, rowsConfiguration, virtualBoundaries)=>{
    const { displayStart: displayStart, displayEnd: displayEnd } = virtualBoundaries;
    return visibleRowIds.slice(displayStart, displayEnd).filter((rowId)=>{
        const rowConfiguration = rowsConfiguration[rowId];
        if (!rowConfiguration) return false;
        return rowConfiguration.isLoading;
    });
});
const $31faaa78a5ea4063$export$15a684dfff6d5394 = (state)=>$31faaa78a5ea4063$export$1e9cf27313ff3cdf(state).length;
const $31faaa78a5ea4063$export$b455bac95fd02aad = (state)=>{
    const activeItem = (0, $4aSHd.getActiveItem)(state);
    if (activeItem && activeItem.type === (0, $a37593d97c1ae333$export$8a257aa81ef4a9e0)) return activeItem.rowIndex;
    if (activeItem && activeItem.type === (0, $a37593d97c1ae333$export$4b3489234fd17200)) return (0, $fZ2Nd.getVisibleIndexForRowId)(state, activeItem.rowId);
    return undefined;
};
const $31faaa78a5ea4063$export$7b06ecd71d436a71 = (state)=>{
    const currRow = $31faaa78a5ea4063$export$b455bac95fd02aad(state);
    if (currRow === undefined) return 0;
    const lastVisibleRow = (0, $fZ2Nd.getVisibleRowsCount)(state) - 1;
    return Math.min(currRow + 1, lastVisibleRow);
};
const $31faaa78a5ea4063$export$c98fb65aaf1fa4f7 = (state)=>{
    const currRow = $31faaa78a5ea4063$export$b455bac95fd02aad(state);
    if (currRow === undefined) return 0;
    return Math.max(currRow - 1, 0);
};
const $31faaa78a5ea4063$export$7bf5553e96d8acb1 = (state, rowIndex)=>{
    const visibleRowIds = (0, $fZ2Nd.getFlattenedWithAddedRowIds)(state);
    return rowIndex == null ? undefined : visibleRowIds[rowIndex];
};
const $31faaa78a5ea4063$export$f5e04ce1033f6b64 = (state)=>{
    const activeItem = (0, $4aSHd.getActiveItem)(state);
    if (!activeItem) return undefined;
    switch(activeItem.type){
        case 0, $a37593d97c1ae333$export$4b3489234fd17200:
            return activeItem.rowId;
        case 0, $a37593d97c1ae333$export$8a257aa81ef4a9e0:
            {
                const { rowIndex: rowIndex } = activeItem;
                return $31faaa78a5ea4063$export$7bf5553e96d8acb1(state, rowIndex);
            }
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            activeItem;
            return undefined;
    }
};
const $31faaa78a5ea4063$export$4fad04245eebe683 = (state, rowId)=>$31faaa78a5ea4063$export$f5e04ce1033f6b64(state) === rowId;
const $31faaa78a5ea4063$export$9b16a7f2e1834f77 = (state, rowId)=>(0, $01OF3.isInRowNavigationMode)(state) && $31faaa78a5ea4063$export$4fad04245eebe683(state, rowId);
const $31faaa78a5ea4063$export$cff73bbfaa0526d1 = (state, rowId)=>{
    const activeRow = (0, $4aSHd.getActiveRow)(state);
    return !!activeRow && $31faaa78a5ea4063$export$4fad04245eebe683(state, rowId) && !!activeRow.setFocusOnRow;
};
const $31faaa78a5ea4063$export$c14f48cad4f0ee46 = (state, rowId, columnId)=>{
    const activeItem = (0, $4aSHd.getActiveCell)(state);
    return !!activeItem && activeItem.rowId === rowId && activeItem.columnId === columnId;
};
const $31faaa78a5ea4063$export$eca20d464f1d2890 = (0, $df4Sl.createSelector)((0, $fZ2Nd.getFlattenedWithAddedRowIds), $31faaa78a5ea4063$export$b455bac95fd02aad, (visibleRowIds, activeRowIndex)=>{
    if (activeRowIndex === undefined || activeRowIndex >= visibleRowIds.length) return [];
    return [
        ...Array(3).keys()
    ].map((adjacencyIndex)=>activeRowIndex + adjacencyIndex - 1).filter((rowIndex)=>rowIndex >= 0 && rowIndex < visibleRowIds.length).map((idx)=>visibleRowIds[idx]);
});
const $31faaa78a5ea4063$export$e333218078e16c44 = (state, rowId)=>(0, $fZ2Nd.getFlattenedWithAddedRowIds)(state)[0] === rowId;
const $31faaa78a5ea4063$export$9b148117f6b512ea = (0, $df4Sl.createSelector)($31faaa78a5ea4063$export$eca20d464f1d2890, $31faaa78a5ea4063$export$e333218078e16c44, (_, rowId)=>rowId, (activeAndAdjacentRowIds, firstRow, rowId)=>activeAndAdjacentRowIds.length === 0 && firstRow || activeAndAdjacentRowIds.some((activeOrAdjacentRowId)=>activeOrAdjacentRowId === rowId));

});
parcelRegister("4oraa", function(module, exports) {

var $gEXyd = parcelRequire("gEXyd");
/**
 * Uses a binary search to determine the lowest index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * _.sortedIndex([30, 50], 40);
 * // => 1
 */ function $332e794c78dde7ad$var$sortedIndex(array, value) {
    return $gEXyd(array, value);
}
module.exports = $332e794c78dde7ad$var$sortedIndex;

});
parcelRegister("gEXyd", function(module, exports) {

var $b8gGo = parcelRequire("b8gGo");

var $3QMTK = parcelRequire("3QMTK");

var $8aco7 = parcelRequire("8aco7");
/** Used as references for the maximum length and index of an array. */ var $c20e935a7014e00a$var$MAX_ARRAY_LENGTH = 4294967295, $c20e935a7014e00a$var$HALF_MAX_ARRAY_LENGTH = $c20e935a7014e00a$var$MAX_ARRAY_LENGTH >>> 1;
/**
 * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
 * performs a binary search of `array` to determine the index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */ function $c20e935a7014e00a$var$baseSortedIndex(array, value, retHighest) {
    var low = 0, high = array == null ? low : array.length;
    if (typeof value == 'number' && value === value && high <= $c20e935a7014e00a$var$HALF_MAX_ARRAY_LENGTH) {
        while(low < high){
            var mid = low + high >>> 1, computed = array[mid];
            if (computed !== null && !$8aco7(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
            else high = mid;
        }
        return high;
    }
    return $b8gGo(array, value, $3QMTK, retHighest);
}
module.exports = $c20e935a7014e00a$var$baseSortedIndex;

});
parcelRegister("b8gGo", function(module, exports) {

var $8aco7 = parcelRequire("8aco7");
/** Used as references for the maximum length and index of an array. */ var $81ad61ea4a25a0a5$var$MAX_ARRAY_LENGTH = 4294967295, $81ad61ea4a25a0a5$var$MAX_ARRAY_INDEX = $81ad61ea4a25a0a5$var$MAX_ARRAY_LENGTH - 1;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $81ad61ea4a25a0a5$var$nativeFloor = Math.floor, $81ad61ea4a25a0a5$var$nativeMin = Math.min;
/**
 * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
 * which invokes `iteratee` for `value` and each element of `array` to compute
 * their sort ranking. The iteratee is invoked with one argument; (value).
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} iteratee The iteratee invoked per element.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */ function $81ad61ea4a25a0a5$var$baseSortedIndexBy(array, value, iteratee, retHighest) {
    var low = 0, high = array == null ? 0 : array.length;
    if (high === 0) return 0;
    value = iteratee(value);
    var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = $8aco7(value), valIsUndefined = value === undefined;
    while(low < high){
        var mid = $81ad61ea4a25a0a5$var$nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = $8aco7(computed);
        if (valIsNaN) var setLow = retHighest || othIsReflexive;
        else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
        else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        else if (othIsNull || othIsSymbol) setLow = false;
        else setLow = retHighest ? computed <= value : computed < value;
        if (setLow) low = mid + 1;
        else high = mid;
    }
    return $81ad61ea4a25a0a5$var$nativeMin(high, $81ad61ea4a25a0a5$var$MAX_ARRAY_INDEX);
}
module.exports = $81ad61ea4a25a0a5$var$baseSortedIndexBy;

});



parcelRegister("ajzlS", function(module, exports) {

$parcel$export(module.exports, "minRowsForTreeTableVirtualisation", () => $411de1a56bb542ea$export$3c21ff0ba5a7aae2);
$parcel$export(module.exports, "childrenOperationIndicatorWidth", () => $411de1a56bb542ea$export$3f2e7d270d9c828e);
$parcel$export(module.exports, "levelIndentBaseline", () => $411de1a56bb542ea$export$8831b0de9d6cd1e0);
$parcel$export(module.exports, "addBarCircleSize", () => $411de1a56bb542ea$export$3d6f348975bc66c6);
$parcel$export(module.exports, "akButtonHeight", () => $411de1a56bb542ea$export$21cb66b1f2cfe05b);
$parcel$export(module.exports, "scrollbarWidth", () => $411de1a56bb542ea$export$14c8a45ff6da16d);
// ROW BODY
const $411de1a56bb542ea$export$3c21ff0ba5a7aae2 = 100;
const $411de1a56bb542ea$export$3f2e7d270d9c828e = 24;
const $411de1a56bb542ea$export$66910203ed6bdbb = 8;
const $411de1a56bb542ea$export$a659c25736116809 = 3;
const $411de1a56bb542ea$export$8831b0de9d6cd1e0 = $411de1a56bb542ea$export$a659c25736116809 + $411de1a56bb542ea$export$3f2e7d270d9c828e;
const $411de1a56bb542ea$export$75e30597b152d012 = $411de1a56bb542ea$export$a659c25736116809 + $411de1a56bb542ea$export$66910203ed6bdbb;
const $411de1a56bb542ea$export$1380a626586d9aba = 12;
const $411de1a56bb542ea$export$9aeb22ae511a8bf4 = 5;
const $411de1a56bb542ea$export$3d6f348975bc66c6 = 24;
const $411de1a56bb542ea$export$21cb66b1f2cfe05b = 32;
const $411de1a56bb542ea$export$15a53da47f8d8b84 = 8;
const $411de1a56bb542ea$export$14c8a45ff6da16d = 5;

});

parcelRegister("f5bbs", function(module, exports) {

$parcel$export(module.exports, "getRowTree", () => $90e2691298e815b9$export$51f19bc561029712);
$parcel$export(module.exports, "getRowsConfiguration", () => $90e2691298e815b9$export$7afbda1c447dab73);
$parcel$export(module.exports, "getAddedRows", () => $90e2691298e815b9$export$b65d941a4f06833c);
$parcel$export(module.exports, "getMaxDepth", () => $90e2691298e815b9$export$dc00159d5f925dca);
$parcel$export(module.exports, "getAddLinkCaption", () => $90e2691298e815b9$export$b08f0f9a8b4bbfe8);
$parcel$export(module.exports, "getExpandedRowIdsHash", () => $90e2691298e815b9$export$5874281f3f9f8f1f);
$parcel$export(module.exports, "isRowExpanded", () => $90e2691298e815b9$export$22559e97b2ec8b6);
$parcel$export(module.exports, "getTemporaryAddedRow", () => $90e2691298e815b9$export$692ae8ed13990af6);
$parcel$export(module.exports, "isAnyRowBeingAdded", () => $90e2691298e815b9$export$53a366bd49d883e9);
$parcel$export(module.exports, "isRowBeingAdded", () => $90e2691298e815b9$export$a59b29339b2950b1);
$parcel$export(module.exports, "getRowAddingStatus", () => $90e2691298e815b9$export$4be3de2f99f7bcb7);
$parcel$export(module.exports, "getRowHasChildren", () => $90e2691298e815b9$export$bac1675af7abd620);
$parcel$export(module.exports, "getRow", () => $90e2691298e815b9$export$42035f545ecd5428);
$parcel$export(module.exports, "getDefaultRowHeight", () => $90e2691298e815b9$export$d44a80f12163dfc8);
$parcel$export(module.exports, "getRowHeightMapping", () => $90e2691298e815b9$export$86d23b7fefef4879);
$parcel$export(module.exports, "getAbsoluteRowHeight", () => $90e2691298e815b9$export$d58c78cd12373bd6);
$parcel$export(module.exports, "getRowHeight", () => $90e2691298e815b9$export$69b171017bdea2b4);
$parcel$export(module.exports, "isAutoRowHeight", () => $90e2691298e815b9$export$736c13cc18282c63);
$parcel$export(module.exports, "getStaticRowPathAndDepth", () => $90e2691298e815b9$export$d3cd1bd0d2f257ec);
$parcel$export(module.exports, "getRowAddPosition", () => $90e2691298e815b9$export$d1680008a2c9c92a);
$parcel$export(module.exports, "getAddBarOverflow", () => $90e2691298e815b9$export$89d1c0cf2787df2d);
$parcel$export(module.exports, "isRowLoading", () => $90e2691298e815b9$export$a15c7e972e303897);
$parcel$export(module.exports, "getRowCanAddChildren", () => $90e2691298e815b9$export$da03f1b8699c006f);
$parcel$export(module.exports, "getRowCanAddSibling", () => $90e2691298e815b9$export$622bee8dc98ce142);
$parcel$export(module.exports, "isRowSelected", () => $90e2691298e815b9$export$710e11cf672b86c);

var $df4Sl = parcelRequire("df4Sl");

var $eoER9 = parcelRequire("eoER9");

var $ajzlS = parcelRequire("ajzlS");

var $1LCin = parcelRequire("1LCin");

var $ffUxt = parcelRequire("ffUxt");
const $90e2691298e815b9$export$51f19bc561029712 = (state)=>state.consumer.rowTree;
const $90e2691298e815b9$export$7afbda1c447dab73 = (state)=>state.consumer.rowsConfiguration;
const $90e2691298e815b9$export$b65d941a4f06833c = (state)=>state.consumer.addedRows;
const $90e2691298e815b9$export$dc00159d5f925dca = (state)=>state.consumer.maxDepth;
const $90e2691298e815b9$export$b08f0f9a8b4bbfe8 = (state)=>state.consumer.addLinkCaption;
const $90e2691298e815b9$export$f7d97a6a8ca8eb30 = (state)=>state.consumer.expandedRowIds;
const $90e2691298e815b9$export$5874281f3f9f8f1f = (0, $df4Sl.createSelector)($90e2691298e815b9$export$f7d97a6a8ca8eb30, (expandedRowIds)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    expandedRowIds.reduce((acc, next)=>{
        // for effeciency sake we are mutating the accumulator to build up our hash
        acc[next] = true;
        return acc;
    }, {}));
const $90e2691298e815b9$export$22559e97b2ec8b6 = (state, rowId)=>!!$90e2691298e815b9$export$5874281f3f9f8f1f(state)[rowId];
const $90e2691298e815b9$export$692ae8ed13990af6 = (state)=>state.consumer.addedRows !== undefined ? state.consumer.addedRows.temporary : undefined;
const $90e2691298e815b9$export$16d7466356aaf65d = (state)=>state.consumer.addedRows !== undefined ? state.consumer.addedRows.persisted : undefined;
const $90e2691298e815b9$export$53a366bd49d883e9 = (state)=>$90e2691298e815b9$export$692ae8ed13990af6(state) !== undefined;
const $90e2691298e815b9$export$a59b29339b2950b1 = (state, rowId)=>{
    const temporaryAddedRow = $90e2691298e815b9$export$692ae8ed13990af6(state);
    return temporaryAddedRow !== undefined && temporaryAddedRow.temporaryId === rowId;
};
const $90e2691298e815b9$export$4be3de2f99f7bcb7 = (state, rowId)=>{
    const addedRows = $90e2691298e815b9$export$b65d941a4f06833c(state);
    if (addedRows !== undefined) {
        if (!!addedRows.temporary && addedRows.temporary.temporaryId === rowId) return addedRows.temporary.isPersisting ? 'PERSISTING' : 'NEW';
        if (!!addedRows.persisted && addedRows.persisted[rowId]) return 'PERSISTED';
    }
    return undefined;
};
const $90e2691298e815b9$export$ab5d39c3fc4e75a3 = (state, rowId)=>$90e2691298e815b9$export$51f19bc561029712(state).rows[rowId].parentId;
const $90e2691298e815b9$export$bac1675af7abd620 = (state, rowId)=>{
    // a temp child will not be included in the row tree children - need to check both.
    const temporaryAddedRow = $90e2691298e815b9$export$692ae8ed13990af6(state);
    const row = $90e2691298e815b9$export$51f19bc561029712(state).rows[rowId];
    return row && row.childrenIds.length > 0 || temporaryAddedRow !== undefined && temporaryAddedRow.anchorId === rowId && temporaryAddedRow.position === 'INSIDE';
};
const $90e2691298e815b9$export$42035f545ecd5428 = (state, rowId)=>$90e2691298e815b9$export$51f19bc561029712(state).rows[rowId];
const $90e2691298e815b9$export$d44a80f12163dfc8 = (state)=>state.consumer.rowHeight;
const $90e2691298e815b9$var$getRowBorderWidth = (state)=>state.internal.rowBorderWidth;
const $90e2691298e815b9$export$86d23b7fefef4879 = (state)=>state.internal.rowHeightMapping;
const $90e2691298e815b9$export$e61f0a8029f642f4 = (0, $df4Sl.createSelector)($90e2691298e815b9$export$86d23b7fefef4879, $90e2691298e815b9$export$d44a80f12163dfc8, (rowHeightMapping, defaultRowHeight)=>{
    const vals = Object.values(rowHeightMapping).sort();
    const medianIdx = Math.floor(vals.length / 2);
    return vals[medianIdx] || defaultRowHeight;
});
const $90e2691298e815b9$export$d58c78cd12373bd6 = (state)=>Math.max(0, ($90e2691298e815b9$export$e61f0a8029f642f4(state) || $90e2691298e815b9$export$d44a80f12163dfc8(state)) - $90e2691298e815b9$var$getRowBorderWidth(state));
const $90e2691298e815b9$export$69b171017bdea2b4 = (state, rowId)=>{
    const knownRowHeight = $90e2691298e815b9$export$86d23b7fefef4879(state)[rowId];
    if (knownRowHeight) return Math.max(0, knownRowHeight);
    return $90e2691298e815b9$export$d58c78cd12373bd6(state);
};
const $90e2691298e815b9$export$736c13cc18282c63 = (state)=>state.consumer.autoRowHeight;
const $90e2691298e815b9$export$d3cd1bd0d2f257ec = (0, $df4Sl.createSelector)($90e2691298e815b9$export$51f19bc561029712, (rowTree)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rowPathAndDepthHash = {};
    Object.keys(rowTree.rows).forEach((rowId)=>{
        const depth = (0, $1LCin.default)(rowTree.rows, rowId);
        const path = (0, $ffUxt.default)(rowTree.rows, rowId);
        rowPathAndDepthHash[rowId] = {
            depth: depth,
            path: path
        };
    });
    return rowPathAndDepthHash;
});
const $90e2691298e815b9$export$829a6e4495ba9529 = (0, $df4Sl.createSelector)($90e2691298e815b9$export$51f19bc561029712, (rowTree)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rowDepthHash = {};
    Object.keys(rowTree.rows).forEach((rowId)=>{
        const depth = (0, $1LCin.default)(rowTree.rows, rowId);
        rowDepthHash[rowId] = {
            depth: depth
        };
    });
    return rowDepthHash;
});
const $90e2691298e815b9$export$ecd30898c6a65cf4 = (0, $df4Sl.createSelector)($90e2691298e815b9$export$51f19bc561029712, (rowTree)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rowPathHash = {};
    Object.keys(rowTree.rows).forEach((rowId)=>{
        const path = (0, $ffUxt.default)(rowTree.rows, rowId);
        rowPathHash[rowId] = {
            path: path
        };
    });
    return rowPathHash;
});
const $90e2691298e815b9$export$e57b56ebfdae922b = (0, $df4Sl.createSelector)($90e2691298e815b9$export$dc00159d5f925dca, $90e2691298e815b9$export$f7d97a6a8ca8eb30, (maxDepth, expandedRowIds)=>({
        maxDepth: maxDepth,
        expandedRowIds: expandedRowIds
    }));
const $90e2691298e815b9$export$d1680008a2c9c92a = (0, $eoER9.createWeakMapSelector)($90e2691298e815b9$export$42035f545ecd5428, $90e2691298e815b9$export$829a6e4495ba9529, $90e2691298e815b9$export$e57b56ebfdae922b, // @ts-expect-error - TS7006 - Parameter 'row' implicitly has an 'any' type. | TS7006 - Parameter 'rowDepth' implicitly has an 'any' type. | TS7031 - Binding element 'maxDepth' implicitly has an 'any' type. | TS7031 - Binding element 'expandedRowIds' implicitly has an 'any' type.
(row, rowDepth, { maxDepth: maxDepth, expandedRowIds: expandedRowIds })=>{
    if (row === undefined) throw new Error('row must not be undefined');
    const rowId = row.id;
    const currentRowDepth = rowDepth[rowId].depth;
    // if a row can have children and is expanded, add a child
    // if a row can have children but is collapsed, add a sibling
    if (currentRowDepth < maxDepth) {
        if (expandedRowIds.indexOf(rowId) !== -1) return 'INSIDE';
        return 'AFTER';
    }
    // otherwise it is a child row, add a sibling
    return 'AFTER';
});
const $90e2691298e815b9$export$89d1c0cf2787df2d = (state)=>((0, $ajzlS.addBarCircleSize) - $90e2691298e815b9$var$getRowBorderWidth(state)) / 2;
const $90e2691298e815b9$export$f9af5c27d326c0d1 = (state, rowId)=>{
    const rowConfiguration = $90e2691298e815b9$export$7afbda1c447dab73(state)[rowId];
    return rowConfiguration ? rowConfiguration.dragIndicatorColor : undefined;
};
const $90e2691298e815b9$export$a15c7e972e303897 = (state, rowId)=>{
    const rowConfiguration = $90e2691298e815b9$export$7afbda1c447dab73(state)[rowId];
    if (rowConfiguration) return rowConfiguration.isLoading || false;
    return false;
};
const $90e2691298e815b9$export$da03f1b8699c006f = (state, rowId)=>{
    const rowConfiguration = $90e2691298e815b9$export$7afbda1c447dab73(state)[rowId];
    if (rowConfiguration) return rowConfiguration.canAddChildren !== undefined ? rowConfiguration.canAddChildren : true;
    return true;
};
const $90e2691298e815b9$export$622bee8dc98ce142 = (state, rowId)=>{
    const rowConfiguration = $90e2691298e815b9$export$7afbda1c447dab73(state)[rowId];
    if (rowConfiguration) return rowConfiguration.canAddSibling !== undefined ? rowConfiguration.canAddSibling : true;
    return true;
};
const $90e2691298e815b9$export$710e11cf672b86c = (state, rowId)=>{
    const rowConfiguration = $90e2691298e815b9$export$7afbda1c447dab73(state)[rowId];
    if (rowConfiguration) return rowConfiguration.isSelected || false;
    return false;
};

});
parcelRegister("eoER9", function(module, exports) {

$parcel$export(module.exports, "createWeakMapSelector", () => $83d259675c776220$export$3a90d1d234e724b5);
$parcel$export(module.exports, "createSelector", () => $83d259675c776220$export$595d22ed68ca2841);
// @ts-expect-error - TS2305 - Module '"reselect"' has no exported member 'SelectorCreator'.

var $df4Sl = parcelRequire("df4Sl");

var $3X7pb = parcelRequire("3X7pb");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $83d259675c776220$var$weakMapMemoize = (func)=>{
    const memorizer = (0, $3X7pb.createMemorizer)();
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    return (...args)=>{
        const cached = memorizer.read(args);
        if (cached !== undefined) return (0, $3X7pb.toReturnValue)(cached);
        const result = func.apply(func, args);
        memorizer.store(args, result);
        return result;
    };
};
const $83d259675c776220$export$3a90d1d234e724b5 = (0, $df4Sl.createSelectorCreator)($83d259675c776220$var$weakMapMemoize);
const $83d259675c776220$export$595d22ed68ca2841 = (0, $df4Sl.createSelectorCreator)((0, $df4Sl.defaultMemoize));

});
parcelRegister("3X7pb", function(module, exports) {

$parcel$export(module.exports, "toReturnValue", () => $24f64c7d1be5459a$export$9f3707bed4fc53c8);
$parcel$export(module.exports, "createMemorizer", () => $24f64c7d1be5459a$export$9db09f4ba21f9d2a);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $24f64c7d1be5459a$var$UNDEFINED = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $24f64c7d1be5459a$var$NULL = {};
const $24f64c7d1be5459a$export$7abc386bcfed62e1 = (key)=>{
    if (key === undefined) return $24f64c7d1be5459a$var$UNDEFINED;
    if (key === null) return $24f64c7d1be5459a$var$NULL;
    return key;
};
const $24f64c7d1be5459a$export$9f3707bed4fc53c8 = (x)=>{
    if (x === $24f64c7d1be5459a$var$UNDEFINED) return undefined;
    if (x === $24f64c7d1be5459a$var$NULL) return null;
    return x;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $24f64c7d1be5459a$var$getFromWeakMapChain = (args, index, map)=>{
    const element = map.get($24f64c7d1be5459a$export$7abc386bcfed62e1(args[index]));
    if (index < args.length - 1) {
        if (element) return $24f64c7d1be5459a$var$getFromWeakMapChain(args, index + 1, element);
        return undefined;
    }
    return element;
};
const $24f64c7d1be5459a$var$storeToEmptyWeakMapChain = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
args, index, // eslint-disable-next-line @typescript-eslint/no-explicit-any
map, // eslint-disable-next-line @typescript-eslint/no-explicit-any
result)=>{
    if (index < args.length - 1) {
        const subMap = new WeakMap();
        map.set($24f64c7d1be5459a$export$7abc386bcfed62e1(args[index]), subMap);
        $24f64c7d1be5459a$var$storeToEmptyWeakMapChain(args, index + 1, subMap, result);
    } else map.set($24f64c7d1be5459a$export$7abc386bcfed62e1(args[index]), result);
};
const $24f64c7d1be5459a$var$storeToWeakMapChain = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
args, index, // eslint-disable-next-line @typescript-eslint/no-explicit-any
map, // eslint-disable-next-line @typescript-eslint/no-explicit-any
result)=>{
    if (index < args.length - 1) {
        const element = map.get($24f64c7d1be5459a$export$7abc386bcfed62e1(args[index]));
        if (element) $24f64c7d1be5459a$var$storeToWeakMapChain(args, index + 1, element, result);
        else {
            const subMap = new WeakMap();
            map.set($24f64c7d1be5459a$export$7abc386bcfed62e1(args[index]), subMap);
            // we know that from now on, all chain elements need to be new maps,
            // so we move to a slightly more performent recursion
            $24f64c7d1be5459a$var$storeToEmptyWeakMapChain(args, index + 1, subMap, result);
        }
    } else map.set($24f64c7d1be5459a$export$7abc386bcfed62e1(args[index]), result);
};
const $24f64c7d1be5459a$export$9db09f4ba21f9d2a = ()=>{
    const weakMap = new WeakMap();
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        store: (args, result)=>result !== undefined ? $24f64c7d1be5459a$var$storeToWeakMapChain(args, 0, weakMap, result) : $24f64c7d1be5459a$var$storeToWeakMapChain(args, 0, weakMap, $24f64c7d1be5459a$var$UNDEFINED),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        read: (args)=>$24f64c7d1be5459a$var$getFromWeakMapChain(args, 0, weakMap)
    };
};

});



parcelRegister("fZ2Nd", function(module, exports) {

$parcel$export(module.exports, "getFlattenedWithAddedRowIds", () => $6364f5af34d97c96$export$6e21a717b784ff6c);
$parcel$export(module.exports, "getVisibleRowsCount", () => $6364f5af34d97c96$export$b4a9f7539f5aceeb);
$parcel$export(module.exports, "getVisibleIndexForRowId", () => $6364f5af34d97c96$export$79cf3e6172c1e206);

var $df4Sl = parcelRequire("df4Sl");

var $f5bbs = parcelRequire("f5bbs");

var $4aSHd = parcelRequire("4aSHd");

var $eV4MF = parcelRequire("eV4MF");

var $crJ1B = parcelRequire("crJ1B");
const $6364f5af34d97c96$export$53ea5f0c9428e57 = (0, $df4Sl.createSelector)((0, $4aSHd.getSortedRowIdsHash), // FSN-4037 Remove draggingRowId related logic during FF cleanup
(0, $4aSHd.getDraggingRowId), (0, $f5bbs.getExpandedRowIdsHash), (sortedRowIdsHash, draggingRowId, expandedRowIdsHash)=>(0, $eV4MF.default)(sortedRowIdsHash, draggingRowId, expandedRowIdsHash));
// memoize and transform to expected type for insertAnchoredRowIds utility
const $6364f5af34d97c96$var$getTemporaryAddedRowHash = (0, $df4Sl.createSelector)((0, $f5bbs.getTemporaryAddedRow), (temporaryAddedRow)=>temporaryAddedRow !== undefined ? {
        [temporaryAddedRow.temporaryId]: temporaryAddedRow
    } : undefined);
const $6364f5af34d97c96$export$6e21a717b784ff6c = (0, $df4Sl.createSelector)($6364f5af34d97c96$export$53ea5f0c9428e57, (0, $f5bbs.getRowTree), (0, $f5bbs.getExpandedRowIdsHash), $6364f5af34d97c96$var$getTemporaryAddedRowHash, (flattenedRowIds, rowTree, expandedRowIdsHash, temporaryAddedRows)=>(0, $crJ1B.default)(flattenedRowIds, rowTree, expandedRowIdsHash, temporaryAddedRows));
const $6364f5af34d97c96$export$b4a9f7539f5aceeb = (state)=>$6364f5af34d97c96$export$6e21a717b784ff6c(state).length;
const $6364f5af34d97c96$export$883d77261e4c3cdd = (0, $df4Sl.createSelector)($6364f5af34d97c96$export$6e21a717b784ff6c, (flattenedRowIds)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    flattenedRowIds.reduce((acc, rowId, idx)=>{
        acc[rowId] = idx;
        return acc;
    }, {}));
const $6364f5af34d97c96$export$79cf3e6172c1e206 = (state, rowId)=>$6364f5af34d97c96$export$883d77261e4c3cdd(state)[rowId];

});
parcelRegister("eV4MF", function(module, exports) {

$parcel$export(module.exports, "default", () => $31f0159c21cbbf78$export$2e2bcd8739ae039);

const $31f0159c21cbbf78$var$traverseRows = (rowIds, sortedRowIdsHash, // FSN-4037 Remove draggingRowId related logic during FF cleanup
draggingRowId, result, expandedRowIdsHash)=>{
    if (rowIds === undefined || rowIds.length === 0) return;
    rowIds.forEach((rowId)=>{
        // if an item is being dragged, its' children should be hidden
        // otherwise check if it is the list of consumer expanded rows
        const childrenIds = draggingRowId === rowId ? [] : expandedRowIdsHash[rowId] && sortedRowIdsHash[rowId] || [];
        result.push(rowId);
        $31f0159c21cbbf78$var$traverseRows(childrenIds, sortedRowIdsHash, draggingRowId, result, expandedRowIdsHash);
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$31f0159c21cbbf78$export$2e2bcd8739ae039 = (sortedRowIdsHash, draggingRowId, expandedRowIdsHash)=>{
    const result = [];
    $31f0159c21cbbf78$var$traverseRows(sortedRowIdsHash[0, $7872bfc970cd976d$export$59c500c4e33fdb0], sortedRowIdsHash, draggingRowId, result, expandedRowIdsHash);
    return result;
};

});
const $7872bfc970cd976d$export$d12b3737880ade32 = 'FIRST';
const $7872bfc970cd976d$export$c7329282a8166cba = 'LAST';
const $7872bfc970cd976d$export$45ce4e6476e88525 = 'BEFORE';
const $7872bfc970cd976d$export$6a633207bebc1e0e = 'AFTER';
const $7872bfc970cd976d$export$667b331f8de09773 = 'INSIDE';
const $7872bfc970cd976d$export$a63dec0667c2f97a = 'IS_LOADING';
const $7872bfc970cd976d$export$456b4a90eb507580 = 'DELAYED_RENDER';
const $7872bfc970cd976d$export$59c500c4e33fdb0 = 'ROOT';


parcelRegister("crJ1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d27799e2487a0fa$export$2e2bcd8739ae039);

var $fUTZC = parcelRequire("fUTZC");

var $03i9R = parcelRequire("03i9R");

var $gJ7r4 = parcelRequire("gJ7r4");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5d27799e2487a0fa$export$2e2bcd8739ae039 = (baseRowIds, rowTree, expandedRowIdsHash, anchoredRows)=>{
    if (!anchoredRows) return baseRowIds;
    // remove added rows from their sorted order, to be positioned by anchor instead
    const result = (0, (/*@__PURE__*/$parcel$interopDefault($03i9R)))(baseRowIds, (baseRowId)=>anchoredRows !== undefined && anchoredRows[baseRowId] !== undefined);
    // for each added row, insert based on the anchor
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anchoredRows, (anchorRow, anchoredRowId)=>{
        const { anchorId: anchorId, position: position } = anchorRow;
        if (position === 'FIRST') result.unshift(anchoredRowId);
        else if (position === 'LAST') result.push(anchoredRowId);
        else if (anchorId) {
            const anchorRowLocation = result.indexOf(anchorId);
            // the anchor row may not be in the set of currently visible things
            if (anchorRowLocation !== -1) {
                if (position === 'BEFORE') result.splice(anchorRowLocation, 0, anchoredRowId);
                else if (position === 'AFTER') {
                    const spliceOffset = 1 + (0, $gJ7r4.default)(anchorId, rowTree, expandedRowIdsHash);
                    result.splice(anchorRowLocation + spliceOffset, 0, anchoredRowId);
                } else if (position === 'INSIDE' && expandedRowIdsHash[anchorId]) result.splice(anchorRowLocation + 1, 0, anchoredRowId);
            }
        }
    });
    return result;
};

});
parcelRegister("03i9R", function(module, exports) {

var $904yO = parcelRequire("904yO");

var $9vvKC = parcelRequire("9vvKC");

var $7qARj = parcelRequire("7qARj");

var $1c8hB = parcelRequire("1c8hB");

var $bRX4x = parcelRequire("bRX4x");
/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */ function $009e5dc1ea78ed8e$var$reject(collection, predicate) {
    var func = $1c8hB(collection) ? $904yO : $9vvKC;
    return func(collection, $bRX4x($7qARj(predicate, 3)));
}
module.exports = $009e5dc1ea78ed8e$var$reject;

});
parcelRegister("9vvKC", function(module, exports) {

var $awetI = parcelRequire("awetI");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6ebfa35ee06f887f$var$baseFilter(collection, predicate) {
    var result = [];
    $awetI(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $6ebfa35ee06f887f$var$baseFilter;

});


parcelRegister("gJ7r4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a1689fa466246e0$export$2e2bcd8739ae039);

var $fUTZC = parcelRequire("fUTZC");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0a1689fa466246e0$export$2e2bcd8739ae039 = (rowId, rowTree, expandedRowIdsHash)=>{
    let childLength = 0;
    // @ts-expect-error - TS2304 - Cannot find name 'Identifier'.
    const traverseChildren = (parentId)=>{
        const childrenIds = expandedRowIdsHash[parentId] ? rowTree.rows[parentId].childrenIds : [];
        childLength += childrenIds.length;
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(childrenIds, (childId)=>{
            traverseChildren(childId);
        });
    };
    traverseChildren(rowId);
    return childLength;
};

});




parcelRegister("a7y6r", function(module, exports) {

$parcel$export(module.exports, "default", () => $39158ddef4a19f84$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $01OF3 = parcelRequire("01OF3");

var $5jaaH = parcelRequire("5jaaH");

var $h2Z16 = parcelRequire("h2Z16");
var $39158ddef4a19f84$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state)=>({
        activeRowId: (0, $5jaaH.getActiveRowId)(state),
        DetailsContent: (0, $01OF3.getDetailsPanelComponent)(state)
    }), {})((0, $h2Z16.default));

});
parcelRegister("h2Z16", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b972130c040f602$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $6pOL1 = parcelRequire("6pOL1");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2b972130c040f602$var$Panel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1x5895j": (0, $9t7rW.default)(`1px solid ${__cmplp.theme.header.borderColor}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1kl7135k _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $2b972130c040f602$var$DetailsPanel extends (0, $eUqFw.PureComponent) {
    componentDidMount() {
        const { DetailsContent: DetailsContent } = this.props;
        // only try focus the panel if it would be open (some DetailsContent is supplied)
        DetailsContent && this.panelRef && this.panelRef.focus();
    }
    render() {
        const { activeRowId: activeRowId, DetailsContent: DetailsContent, theme: theme } = this.props;
        if (DetailsContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2b972130c040f602$var$Panel, {
            tabIndex: 0,
            ref: (div)=>{
                this.panelRef = div;
            },
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DetailsContent, {
            activeRowId: activeRowId
        }));
        return null;
    }
}
var $2b972130c040f602$export$2e2bcd8739ae039 = (0, $6pOL1.withTheme)($2b972130c040f602$var$DetailsPanel);

});
parcelRegister("6pOL1", function(module, exports) {

$parcel$export(module.exports, "withTheme", () => $7620bf3376ed9def$export$e8748c6a27b910dc);
$parcel$export(module.exports, "ThemeProvider", () => $7620bf3376ed9def$export$d8964aec282183a3);

var $eUqFw = parcelRequire("eUqFw");

var $1XWVa = parcelRequire("1XWVa");

var $bEVdW = parcelRequire("bEVdW");
/*
 * This is to replace the styledComponent theme provider as part of the compiled
 * css migration at https://hello.jira.atlassian.cloud/browse/ENGHEALTH-4743.
 * Before the migration, styled-components/ThemeProvider was used at
 * jira/src/packages/servicedesk/virtual-table/src/app/table/index.tsx
 * to inject StyledTheme context for the styledComponents to consume and after
 * the migration below theme context is used instead.
 *
 * */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $7620bf3376ed9def$var$ThemeContext = /*#__PURE__*/ (0, $eUqFw.createContext)({});
const $7620bf3376ed9def$export$93d4e7f90805808f = ()=>(0, $eUqFw.useContext)($7620bf3376ed9def$var$ThemeContext);
function $7620bf3376ed9def$export$e8748c6a27b910dc(Component) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7620bf3376ed9def$var$ThemeContext.Consumer, null, (defaultTheme)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                ...props,
                theme: defaultTheme
            }));
}
const $7620bf3376ed9def$export$d8964aec282183a3 = ({ children: children, defaultRowHeight: defaultRowHeight, autoRowHeight: autoRowHeight, customScrollBarOffset: customScrollBarOffset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7620bf3376ed9def$var$ThemeContext.Provider, {
        value: (0, $1XWVa.compiledThemeWithProps)((0, $bEVdW.default), defaultRowHeight, autoRowHeight, customScrollBarOffset)
    }, children);

});
parcelRegister("1XWVa", function(module, exports) {

$parcel$export(module.exports, "createTheme", () => $74e0909fa8cb27b1$export$25d302a5b900a763);
$parcel$export(module.exports, "compiledThemeWithProps", () => $74e0909fa8cb27b1$export$5a55b0960b1e154b);

var $2vzCR = parcelRequire("2vzCR");

var $5iWql = parcelRequire("5iWql");

var $jLYXE = parcelRequire("jLYXE");
const $74e0909fa8cb27b1$export$919aa3481b25eaec = (aTheme, anotherTheme)=>(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, aTheme, anotherTheme);
const $74e0909fa8cb27b1$var$createRowCompiledTheme = ({ height: height, minHeight: minHeight, borderRadius: borderRadius, ...others }, autoHeight)=>({
        defaultHeight: Math.max(height, minHeight),
        height: height && !autoHeight ? `${height}px` : 'auto',
        minHeight: `${Math.max(height, minHeight)}px`,
        borderRadius: `${borderRadius}px`,
        ...others
    });
const $74e0909fa8cb27b1$var$createHeaderCompiledTheme = ({ height: height, paddingBottom: paddingBottom, paddingTop: paddingTop, ...others })=>({
        height: height ? `${height}px` : 'auto',
        paddingBottom: `${paddingBottom}px`,
        paddingTop: `${paddingTop}px`,
        ...others
    });
const $74e0909fa8cb27b1$var$createListCompiledTheme = ({ paddingTop: paddingTop })=>({
        paddingTop: `${paddingTop}px`
    });
const $74e0909fa8cb27b1$var$createCompiledTheme = (theme, autoHeight, customScrollBarOffset)=>{
    const { decal: decal, header: header, list: list, row: row, scrollbar: scrollbar, shadow: shadow } = theme;
    const scrollBarTheme = customScrollBarOffset !== undefined ? {
        ...scrollbar,
        offset: customScrollBarOffset
    } : scrollbar;
    return {
        decal: decal,
        header: $74e0909fa8cb27b1$var$createHeaderCompiledTheme(header),
        list: $74e0909fa8cb27b1$var$createListCompiledTheme(list),
        row: $74e0909fa8cb27b1$var$createRowCompiledTheme(row, autoHeight),
        scrollbar: scrollBarTheme,
        shadow: shadow
    };
};
const $74e0909fa8cb27b1$export$25d302a5b900a763 = (theme)=>$74e0909fa8cb27b1$export$919aa3481b25eaec((0, $jLYXE.default), theme);
const $74e0909fa8cb27b1$export$5a55b0960b1e154b = (0, $5iWql.default)((theme, height, autoHeight, customScrollBarOffset)=>$74e0909fa8cb27b1$var$createCompiledTheme((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, theme, {
        row: {
            defaultHeight: height,
            height: height
        }
    }), autoHeight, customScrollBarOffset));

});
parcelRegister("jLYXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6911a165c3fafe72$export$2e2bcd8739ae039);

var /**
 * Default theme
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$6911a165c3fafe72$export$2e2bcd8739ae039 = {
    list: {
        paddingTop: 0
    },
    row: {
        height: 40,
        minHeight: 40,
        borderColor: (0, $73a5c9d720aa66e1$exports).N40,
        borderRadius: 0,
        borderWidth: 1,
        maxDepthChildrenOperationIndicatorWidth: 8,
        activeColor: (0, $73a5c9d720aa66e1$exports).T50,
        hoveredColor: (0, $73a5c9d720aa66e1$exports).N20
    },
    header: {
        height: 35,
        borderWidth: 1,
        borderColor: (0, $73a5c9d720aa66e1$exports).N60,
        paddingBottom: 0,
        paddingTop: 0,
        sideMargin: 0,
        hasShadow: false
    },
    scrollbar: {
        offset: 0,
        marginTop: 0,
        marginBottom: 0,
        paddingTop: 0,
        paddingBottom: 0,
        computeHeight: false
    },
    shadow: {
        softenShadow: false,
        right: {
            display: 'none'
        },
        left: {
            borderWidth: 1,
            computeHeight: false
        },
        bottom: {
            display: 'none'
        }
    },
    decal: {
        borderWidth: 0,
        borderColor: (0, $73a5c9d720aa66e1$exports).N50
    }
};

});


parcelRegister("bEVdW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7affa3e492818f80$export$2e2bcd8739ae039);
// eslint-disable-next-line import/order


var $c9TLT = parcelRequire("c9TLT");

var $1XWVa = parcelRequire("1XWVa");
var $7affa3e492818f80$export$2e2bcd8739ae039 = (0, $1XWVa.createTheme)({
    list: {
        paddingTop: (0, $c9TLT.gridSize) / 2
    },
    row: {
        height: 0,
        minHeight: (0, $c9TLT.gridSize) * 5,
        borderColor: 'transparent',
        borderRadius: (0, $c9TLT.gridSize) / 2,
        borderWidth: 0,
        maxDepthChildrenOperationIndicatorWidth: 0,
        activeColor: (0, $73a5c9d720aa66e1$exports).N20,
        hoveredColor: (0, $73a5c9d720aa66e1$exports).N20,
        useCssHover: true
    },
    header: {
        height: 0,
        borderColor: (0, $73a5c9d720aa66e1$exports).N50,
        borderWidth: 2,
        paddingBottom: (0, $c9TLT.gridSize) / 2,
        paddingTop: (0, $c9TLT.gridSize),
        sideMargin: (0, $c9TLT.gridSize),
        hasShadow: true
    },
    scrollbar: {
        offset: (0, $c9TLT.gridSize) * 4,
        marginTop: (0, $c9TLT.gridSize) + (0, $c9TLT.gridSize) / 2,
        marginBottom: (0, $c9TLT.gridSize),
        paddingTop: (0, $c9TLT.gridSize),
        paddingBottom: (0, $c9TLT.gridSize) / 2,
        computeHeight: true
    },
    shadow: {
        softenShadow: true,
        right: {
            display: 'block'
        },
        left: {
            borderWidth: 0,
            computeHeight: true
        },
        bottom: {
            display: 'block'
        }
    },
    decal: {
        borderColor: (0, $73a5c9d720aa66e1$exports).N50,
        borderWidth: 2
    }
});

});




parcelRegister("k5Bve", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef68d95806491f6$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $1FoRq = parcelRequire("1FoRq");

var $6pOL1 = parcelRequire("6pOL1");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bef68d95806491f6$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isAutoHeight: isAutoHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isAutoHeight ? "_4t3i1wug" : "_4t3i1osq",
            !__cmplp.isAutoHeight && "_16jlkb7n _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
const $bef68d95806491f6$var$FullHeightAutoSizer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $1FoRq.AutoSizer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3iaq80",
            __cmplp.className
        ])
    });
});
const $bef68d95806491f6$var$AutoSizedContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`),
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1hdq _4t3i2nrh",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $bef68d95806491f6$var$Table extends (0, $eUqFw.PureComponent) {
    render() {
        const { width: width, height: height, isAutoHeight: isAutoHeight, TableMain: TableMain, DetailsPanel: DetailsPanel } = this.props;
        const autoSizerStyle = isAutoHeight ? {
            height: 'auto'
        } : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bef68d95806491f6$var$Wrapper, {
            isAutoHeight: isAutoHeight,
            "data-component-selector": "virtual-table.view.table-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bef68d95806491f6$var$FullHeightAutoSizer, {
            onResize: this.onResize,
            style: {
                ...autoSizerStyle
            }
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bef68d95806491f6$var$AutoSizedContentWrapper, {
                width: width,
                height: height
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TableMain, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DetailsPanel, null))));
    }
    constructor(...args){
        super(...args);
        this.onResize = (size)=>{
            const { setTableSize: setTableSize, theme: theme } = this.props;
            // AutoSizer uses offsetWidth/offsetHeight for dimensions which rounds and can cause scrollbars.
            // i.e. height of 700.5 will be rounded to 701
            // We need to remove a single pixel to prevent this
            // https://github.com/bvaughn/react-virtualized/issues/1287
            const width = size.width - 1;
            const height = size.height - 1;
            setTableSize({
                height: height,
                width: width,
                widthWithoutScrollbarOffset: width - theme.scrollbar.offset,
                rowMargin: theme.header.sideMargin * 2
            });
        };
    }
}
var $bef68d95806491f6$export$2e2bcd8739ae039 = (0, $6pOL1.withTheme)($bef68d95806491f6$var$Table);

});
parcelRegister("1FoRq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2DPbm = parcelRequire("2DPbm");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $136ce7930e2abfc3$var$_interopRequireDefault($2DPbm).default;
    }
});
Object.defineProperty(module.exports, 'AutoSizer', {
    enumerable: true,
    get: function get() {
        return $136ce7930e2abfc3$var$_interopRequireDefault($2DPbm).default;
    }
});
function $136ce7930e2abfc3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("2DPbm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2gFMx = parcelRequire("2gFMx");
var $1ec6ed07ef4e0151$var$_extends3 = $1ec6ed07ef4e0151$var$_interopRequireDefault($2gFMx);

var $cLNRv = parcelRequire("cLNRv");
var $1ec6ed07ef4e0151$var$_getPrototypeOf2 = $1ec6ed07ef4e0151$var$_interopRequireDefault($cLNRv);

var $jO9Ex = parcelRequire("jO9Ex");
var $1ec6ed07ef4e0151$var$_classCallCheck3 = $1ec6ed07ef4e0151$var$_interopRequireDefault($jO9Ex);

var $i2meQ = parcelRequire("i2meQ");
var $1ec6ed07ef4e0151$var$_createClass3 = $1ec6ed07ef4e0151$var$_interopRequireDefault($i2meQ);

var $aMQVq = parcelRequire("aMQVq");
var $1ec6ed07ef4e0151$var$_possibleConstructorReturn3 = $1ec6ed07ef4e0151$var$_interopRequireDefault($aMQVq);

var $5taqD = parcelRequire("5taqD");
var $1ec6ed07ef4e0151$var$_inherits3 = $1ec6ed07ef4e0151$var$_interopRequireDefault($5taqD);

var $eUqFw = parcelRequire("eUqFw");
var $1ec6ed07ef4e0151$var$React = $1ec6ed07ef4e0151$var$_interopRequireWildcard($eUqFw);

var $jq35C = parcelRequire("jq35C");
var $1ec6ed07ef4e0151$var$_detectElementResize2 = $1ec6ed07ef4e0151$var$_interopRequireDefault($jq35C);

var $1Qivz = parcelRequire("1Qivz");
var $1ec6ed07ef4e0151$var$_propTypes2 = $1ec6ed07ef4e0151$var$_interopRequireDefault($1Qivz);
function $1ec6ed07ef4e0151$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $1ec6ed07ef4e0151$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1ec6ed07ef4e0151$var$AutoSizer = function(_React$PureComponent) {
    (0, $1ec6ed07ef4e0151$var$_inherits3.default)(AutoSizer, _React$PureComponent);
    function AutoSizer() {
        var _ref;
        var _temp, _this, _ret;
        (0, $1ec6ed07ef4e0151$var$_classCallCheck3.default)(this, AutoSizer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $1ec6ed07ef4e0151$var$_possibleConstructorReturn3.default)(this, (_ref = AutoSizer.__proto__ || (0, $1ec6ed07ef4e0151$var$_getPrototypeOf2.default)(AutoSizer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            height: _this.props.defaultHeight || 0,
            width: _this.props.defaultWidth || 0
        }, _this._onResize = function() {
            var _this$props = _this.props, disableHeight = _this$props.disableHeight, disableWidth = _this$props.disableWidth, onResize = _this$props.onResize;
            if (_this._parentNode) {
                // Guard against AutoSizer component being removed from the DOM immediately after being added.
                // This can result in invalid style values which can result in NaN values if we don't handle them.
                // See issue #150 for more context.
                var _height = _this._parentNode.offsetHeight || 0;
                var _width = _this._parentNode.offsetWidth || 0;
                var win = _this._window || window;
                var _style = win.getComputedStyle(_this._parentNode) || {};
                var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
                var paddingRight = parseInt(_style.paddingRight, 10) || 0;
                var paddingTop = parseInt(_style.paddingTop, 10) || 0;
                var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;
                var newHeight = _height - paddingTop - paddingBottom;
                var newWidth = _width - paddingLeft - paddingRight;
                if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
                    _this.setState({
                        height: _height - paddingTop - paddingBottom,
                        width: _width - paddingLeft - paddingRight
                    });
                    onResize({
                        height: _height,
                        width: _width
                    });
                }
            }
        }, _this._setRef = function(autoSizer) {
            _this._autoSizer = autoSizer;
        }, _temp), (0, $1ec6ed07ef4e0151$var$_possibleConstructorReturn3.default)(_this, _ret);
    } // uses any instead of Window because Flow doesn't have window type
    (0, $1ec6ed07ef4e0151$var$_createClass3.default)(AutoSizer, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var nonce = this.props.nonce;
                if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
                    // Delay access of parentNode until mount.
                    // This handles edge-cases where the component has already been unmounted before its ref has been set,
                    // As well as libraries like react-lite which have a slightly different lifecycle.
                    this._parentNode = this._autoSizer.parentNode;
                    this._window = this._autoSizer.parentNode.ownerDocument.defaultView;
                    // Defer requiring resize handler in order to support server-side rendering.
                    // See issue #41
                    this._detectElementResize = (0, $1ec6ed07ef4e0151$var$_detectElementResize2.default)(nonce, this._window);
                    this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
                    this._onResize();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this._detectElementResize && this._parentNode) this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, className = _props.className, disableHeight = _props.disableHeight, disableWidth = _props.disableWidth, style = _props.style;
                var _state = this.state, height = _state.height, width = _state.width;
                // Outer div should not force width/height since that may prevent containers from shrinking.
                // Inner component should overflow and use calculated width/height.
                // See issue #68 for more information.
                var outerStyle = {
                    overflow: 'visible'
                };
                var childParams = {};
                if (!disableHeight) {
                    outerStyle.height = 0;
                    childParams.height = height;
                }
                if (!disableWidth) {
                    outerStyle.width = 0;
                    childParams.width = width;
                }
                /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */ return $1ec6ed07ef4e0151$var$React.createElement('div', {
                    className: className,
                    ref: this._setRef,
                    style: (0, $1ec6ed07ef4e0151$var$_extends3.default)({}, outerStyle, style)
                }, children(childParams));
            }
        }
    ]);
    return AutoSizer;
}($1ec6ed07ef4e0151$var$React.PureComponent);
$1ec6ed07ef4e0151$var$AutoSizer.defaultProps = {
    onResize: function onResize() {},
    disableHeight: false,
    disableWidth: false,
    style: {}
};
$1ec6ed07ef4e0151$var$AutoSizer.propTypes = null;
module.exports.default = $1ec6ed07ef4e0151$var$AutoSizer;

});
parcelRegister("2gFMx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $1a6d7c6c067b8cc3$export$1e511d4a378977f5, (v) => $1a6d7c6c067b8cc3$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $1a6d7c6c067b8cc3$export$2e2bcd8739ae039, (v) => $1a6d7c6c067b8cc3$export$2e2bcd8739ae039 = v);
var $1a6d7c6c067b8cc3$export$1e511d4a378977f5;
var $1a6d7c6c067b8cc3$export$2e2bcd8739ae039;
"use strict";
$1a6d7c6c067b8cc3$export$1e511d4a378977f5 = true;

var $b43x1 = parcelRequire("b43x1");
var $1a6d7c6c067b8cc3$var$_assign2 = $1a6d7c6c067b8cc3$var$_interopRequireDefault($b43x1);
function $1a6d7c6c067b8cc3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$1a6d7c6c067b8cc3$export$2e2bcd8739ae039 = $1a6d7c6c067b8cc3$var$_assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

});
parcelRegister("b43x1", function(module, exports) {

module.exports = {
    "default": (parcelRequire("dyfRa")),
    __esModule: true
};

});
parcelRegister("dyfRa", function(module, exports) {
parcelRequire("kX90m");

module.exports = (parcelRequire("aMwpa")).Object.assign;

});
parcelRegister("kX90m", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $e03XD = parcelRequire("e03XD");

$e03XD($e03XD.S + $e03XD.F, 'Object', {
    assign: (parcelRequire("3ksdV"))
});

});
parcelRegister("e03XD", function(module, exports) {

var $Tiymd = parcelRequire("Tiymd");

var $aMwpa = parcelRequire("aMwpa");

var $bgjSK = parcelRequire("bgjSK");

var $9dqdv = parcelRequire("9dqdv");

var $6Yw7l = parcelRequire("6Yw7l");
var $a314234ee4b1b532$var$PROTOTYPE = 'prototype';
var $a314234ee4b1b532$var$$export = function(type, name, source) {
    var IS_FORCED = type & $a314234ee4b1b532$var$$export.F;
    var IS_GLOBAL = type & $a314234ee4b1b532$var$$export.G;
    var IS_STATIC = type & $a314234ee4b1b532$var$$export.S;
    var IS_PROTO = type & $a314234ee4b1b532$var$$export.P;
    var IS_BIND = type & $a314234ee4b1b532$var$$export.B;
    var IS_WRAP = type & $a314234ee4b1b532$var$$export.W;
    var exports = IS_GLOBAL ? $aMwpa : $aMwpa[name] || ($aMwpa[name] = {});
    var expProto = exports[$a314234ee4b1b532$var$PROTOTYPE];
    var target = IS_GLOBAL ? $Tiymd : IS_STATIC ? $Tiymd[name] : ($Tiymd[name] || {})[$a314234ee4b1b532$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $6Yw7l(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $bgjSK(out, $Tiymd) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$a314234ee4b1b532$var$PROTOTYPE] = C[$a314234ee4b1b532$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $bgjSK(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $a314234ee4b1b532$var$$export.R && expProto && !expProto[key]) $9dqdv(expProto, key, out);
        }
    }
};
// type bitmap
$a314234ee4b1b532$var$$export.F = 1; // forced
$a314234ee4b1b532$var$$export.G = 2; // global
$a314234ee4b1b532$var$$export.S = 4; // static
$a314234ee4b1b532$var$$export.P = 8; // proto
$a314234ee4b1b532$var$$export.B = 16; // bind
$a314234ee4b1b532$var$$export.W = 32; // wrap
$a314234ee4b1b532$var$$export.U = 64; // safe
$a314234ee4b1b532$var$$export.R = 128; // real proto method for `library`
module.exports = $a314234ee4b1b532$var$$export;

});
parcelRegister("Tiymd", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $0a6387701af29dff$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $0a6387701af29dff$var$global; // eslint-disable-line no-undef

});

parcelRegister("aMwpa", function(module, exports) {
var $020692ad8d3771b6$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $020692ad8d3771b6$var$core; // eslint-disable-line no-undef

});

parcelRegister("bgjSK", function(module, exports) {
// optional / simple context binding

var $4PBcz = parcelRequire("4PBcz");
module.exports = function(fn, that, length) {
    $4PBcz(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("4PBcz", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("9dqdv", function(module, exports) {

var $hIB01 = parcelRequire("hIB01");

var $aZwDw = parcelRequire("aZwDw");

module.exports = (parcelRequire("6thbX")) ? function(object, key, value) {
    return $hIB01.f(object, key, $aZwDw(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("hIB01", function(module, exports) {

$parcel$export(module.exports, "f", () => $ce633f0d6980c4c2$export$2d1720544b23b823, (v) => $ce633f0d6980c4c2$export$2d1720544b23b823 = v);
var $ce633f0d6980c4c2$export$2d1720544b23b823;

var $jdpF7 = parcelRequire("jdpF7");

var $8MNgS = parcelRequire("8MNgS");

var $5s3nY = parcelRequire("5s3nY");
var $ce633f0d6980c4c2$var$dP = Object.defineProperty;

$ce633f0d6980c4c2$export$2d1720544b23b823 = (parcelRequire("6thbX")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $jdpF7(O);
    P = $5s3nY(P, true);
    $jdpF7(Attributes);
    if ($8MNgS) try {
        return $ce633f0d6980c4c2$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("jdpF7", function(module, exports) {

var $1zFdr = parcelRequire("1zFdr");
module.exports = function(it) {
    if (!$1zFdr(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("1zFdr", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("8MNgS", function(module, exports) {



module.exports = !(parcelRequire("6thbX")) && !(parcelRequire("iNaFM"))(function() {
    return Object.defineProperty((parcelRequire("4Py1Y"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("6thbX", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("iNaFM"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("iNaFM", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("4Py1Y", function(module, exports) {

var $1zFdr = parcelRequire("1zFdr");

var $Tiymd = parcelRequire("Tiymd");
var $384652aa420d7c34$require$document = $Tiymd.document;
// typeof document.createElement is 'object' in old IE
var $384652aa420d7c34$var$is = $1zFdr($384652aa420d7c34$require$document) && $1zFdr($384652aa420d7c34$require$document.createElement);
module.exports = function(it) {
    return $384652aa420d7c34$var$is ? $384652aa420d7c34$require$document.createElement(it) : {};
};

});


parcelRegister("5s3nY", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $1zFdr = parcelRequire("1zFdr");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$1zFdr(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$1zFdr(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$1zFdr(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$1zFdr(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("aZwDw", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("6Yw7l", function(module, exports) {
var $5141428ca4d1c535$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $5141428ca4d1c535$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("3ksdV", function(module, exports) {
'use strict';

var $6thbX = parcelRequire("6thbX");

var $3Qq35 = parcelRequire("3Qq35");

var $gz5yj = parcelRequire("gz5yj");

var $lEu8b = parcelRequire("lEu8b");

var $7kYU6 = parcelRequire("7kYU6");

var $2RBhn = parcelRequire("2RBhn");
var $26c921fb558de49c$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$26c921fb558de49c$var$$assign || (parcelRequire("iNaFM"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $26c921fb558de49c$var$$assign({}, A)[S] != 7 || Object.keys($26c921fb558de49c$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $7kYU6(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $gz5yj.f;
    var isEnum = $lEu8b.f;
    while(aLen > index){
        var S = $2RBhn(arguments[index++]);
        var keys = getSymbols ? $3Qq35(S).concat(getSymbols(S)) : $3Qq35(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$6thbX || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $26c921fb558de49c$var$$assign;

});
parcelRegister("3Qq35", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $6QCVe = parcelRequire("6QCVe");

var $c5IyZ = parcelRequire("c5IyZ");
module.exports = Object.keys || function keys(O) {
    return $6QCVe(O, $c5IyZ);
};

});
parcelRegister("6QCVe", function(module, exports) {

var $6Yw7l = parcelRequire("6Yw7l");

var $uZdCX = parcelRequire("uZdCX");

var $4fc5ca8c2d339bcd$var$arrayIndexOf = (parcelRequire("3oulG"))(false);

var $4fc5ca8c2d339bcd$var$IE_PROTO = (parcelRequire("2xdmx"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $uZdCX(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $4fc5ca8c2d339bcd$var$IE_PROTO) $6Yw7l(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($6Yw7l(O, key = names[i++])) ~$4fc5ca8c2d339bcd$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("uZdCX", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $2RBhn = parcelRequire("2RBhn");

var $9NV8H = parcelRequire("9NV8H");
module.exports = function(it) {
    return $2RBhn($9NV8H(it));
};

});
parcelRegister("2RBhn", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $7A4P0 = parcelRequire("7A4P0");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $7A4P0(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("7A4P0", function(module, exports) {
var $584fa2a9599a1920$var$toString = {}.toString;
module.exports = function(it) {
    return $584fa2a9599a1920$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("9NV8H", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("3oulG", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $uZdCX = parcelRequire("uZdCX");

var $fTg1r = parcelRequire("fTg1r");

var $eF7Pk = parcelRequire("eF7Pk");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $uZdCX($this);
        var length = $fTg1r(O.length);
        var index = $eF7Pk(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("fTg1r", function(module, exports) {
// 7.1.15 ToLength

var $3xWSq = parcelRequire("3xWSq");
var $b9186bc652284f3b$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $b9186bc652284f3b$var$min($3xWSq(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("3xWSq", function(module, exports) {
// 7.1.4 ToInteger
var $29521fe616939884$var$ceil = Math.ceil;
var $29521fe616939884$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $29521fe616939884$var$floor : $29521fe616939884$var$ceil)(it);
};

});


parcelRegister("eF7Pk", function(module, exports) {

var $3xWSq = parcelRequire("3xWSq");
var $aacaf747231c5347$var$max = Math.max;
var $aacaf747231c5347$var$min = Math.min;
module.exports = function(index, length) {
    index = $3xWSq(index);
    return index < 0 ? $aacaf747231c5347$var$max(index + length, 0) : $aacaf747231c5347$var$min(index, length);
};

});


parcelRegister("2xdmx", function(module, exports) {

var $1d89075ef1733bd9$var$shared = (parcelRequire("kCZia"))('keys');

var $b1OOh = parcelRequire("b1OOh");
module.exports = function(key) {
    return $1d89075ef1733bd9$var$shared[key] || ($1d89075ef1733bd9$var$shared[key] = $b1OOh(key));
};

});
parcelRegister("kCZia", function(module, exports) {

var $aMwpa = parcelRequire("aMwpa");

var $Tiymd = parcelRequire("Tiymd");
var $f046e68e3b8c4e69$var$SHARED = '__core-js_shared__';
var $f046e68e3b8c4e69$var$store = $Tiymd[$f046e68e3b8c4e69$var$SHARED] || ($Tiymd[$f046e68e3b8c4e69$var$SHARED] = {});

(module.exports = function(key, value) {
    return $f046e68e3b8c4e69$var$store[key] || ($f046e68e3b8c4e69$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $aMwpa.version,
    mode: (parcelRequire("2isa8")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("2isa8", function(module, exports) {
module.exports = true;

});


parcelRegister("b1OOh", function(module, exports) {
var $8077337b366c5b6b$var$id = 0;
var $8077337b366c5b6b$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$8077337b366c5b6b$var$id + $8077337b366c5b6b$var$px).toString(36));
};

});



parcelRegister("c5IyZ", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});


parcelRegister("gz5yj", function(module, exports) {

$parcel$export(module.exports, "f", () => $c0f438d0690feeb2$export$2d1720544b23b823, (v) => $c0f438d0690feeb2$export$2d1720544b23b823 = v);
var $c0f438d0690feeb2$export$2d1720544b23b823;
$c0f438d0690feeb2$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("lEu8b", function(module, exports) {

$parcel$export(module.exports, "f", () => $fc34b4c94ea102c2$export$2d1720544b23b823, (v) => $fc34b4c94ea102c2$export$2d1720544b23b823 = v);
var $fc34b4c94ea102c2$export$2d1720544b23b823;
$fc34b4c94ea102c2$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});

parcelRegister("7kYU6", function(module, exports) {
// 7.1.13 ToObject(argument)

var $9NV8H = parcelRequire("9NV8H");
module.exports = function(it) {
    return Object($9NV8H(it));
};

});






parcelRegister("cLNRv", function(module, exports) {

module.exports = {
    "default": (parcelRequire("5NbMn")),
    __esModule: true
};

});
parcelRegister("5NbMn", function(module, exports) {
parcelRequire("hGEQI");

module.exports = (parcelRequire("aMwpa")).Object.getPrototypeOf;

});
parcelRegister("hGEQI", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $7kYU6 = parcelRequire("7kYU6");

var $3prgy = parcelRequire("3prgy");

(parcelRequire("2EilE"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $3prgy($7kYU6(it));
    };
});

});
parcelRegister("3prgy", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $6Yw7l = parcelRequire("6Yw7l");

var $7kYU6 = parcelRequire("7kYU6");

var $27b8db5922169ed5$var$IE_PROTO = (parcelRequire("2xdmx"))('IE_PROTO');
var $27b8db5922169ed5$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $7kYU6(O);
    if ($6Yw7l(O, $27b8db5922169ed5$var$IE_PROTO)) return O[$27b8db5922169ed5$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $27b8db5922169ed5$var$ObjectProto : null;
};

});

parcelRegister("2EilE", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $e03XD = parcelRequire("e03XD");

var $aMwpa = parcelRequire("aMwpa");

var $iNaFM = parcelRequire("iNaFM");
module.exports = function(KEY, exec) {
    var fn = ($aMwpa.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $e03XD($e03XD.S + $e03XD.F * $iNaFM(function() {
        fn(1);
    }), 'Object', exp);
};

});




parcelRegister("jO9Ex", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $e6ba2caaec6e7c87$export$1e511d4a378977f5, (v) => $e6ba2caaec6e7c87$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $e6ba2caaec6e7c87$export$2e2bcd8739ae039, (v) => $e6ba2caaec6e7c87$export$2e2bcd8739ae039 = v);
var $e6ba2caaec6e7c87$export$1e511d4a378977f5;
var $e6ba2caaec6e7c87$export$2e2bcd8739ae039;
"use strict";
$e6ba2caaec6e7c87$export$1e511d4a378977f5 = true;
$e6ba2caaec6e7c87$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};

});

parcelRegister("i2meQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $d219a9fc8d9b72f7$export$1e511d4a378977f5, (v) => $d219a9fc8d9b72f7$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $d219a9fc8d9b72f7$export$2e2bcd8739ae039, (v) => $d219a9fc8d9b72f7$export$2e2bcd8739ae039 = v);
var $d219a9fc8d9b72f7$export$1e511d4a378977f5;
var $d219a9fc8d9b72f7$export$2e2bcd8739ae039;
"use strict";
$d219a9fc8d9b72f7$export$1e511d4a378977f5 = true;

var $7uigX = parcelRequire("7uigX");
var $d219a9fc8d9b72f7$var$_defineProperty2 = $d219a9fc8d9b72f7$var$_interopRequireDefault($7uigX);
function $d219a9fc8d9b72f7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$d219a9fc8d9b72f7$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $d219a9fc8d9b72f7$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

});
parcelRegister("7uigX", function(module, exports) {

module.exports = {
    "default": (parcelRequire("8QmVP")),
    __esModule: true
};

});
parcelRegister("8QmVP", function(module, exports) {
parcelRequire("29H1v");

var $aMwpa = parcelRequire("aMwpa");
var $6704f7d038ceceea$require$$Object = $aMwpa.Object;
module.exports = function defineProperty(it, key, desc) {
    return $6704f7d038ceceea$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("29H1v", function(module, exports) {

var $e03XD = parcelRequire("e03XD");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$e03XD($e03XD.S + $e03XD.F * !(parcelRequire("6thbX")), 'Object', {
    defineProperty: (parcelRequire("hIB01")).f
});

});




parcelRegister("aMQVq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $7da770f13281a945$export$1e511d4a378977f5, (v) => $7da770f13281a945$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $7da770f13281a945$export$2e2bcd8739ae039, (v) => $7da770f13281a945$export$2e2bcd8739ae039 = v);
var $7da770f13281a945$export$1e511d4a378977f5;
var $7da770f13281a945$export$2e2bcd8739ae039;
"use strict";
$7da770f13281a945$export$1e511d4a378977f5 = true;

var $iKXrS = parcelRequire("iKXrS");
var $7da770f13281a945$var$_typeof3 = $7da770f13281a945$var$_interopRequireDefault($iKXrS);
function $7da770f13281a945$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$7da770f13281a945$export$2e2bcd8739ae039 = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $7da770f13281a945$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

});
parcelRegister("iKXrS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $da7aa32252e16ce7$export$1e511d4a378977f5, (v) => $da7aa32252e16ce7$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $da7aa32252e16ce7$export$2e2bcd8739ae039, (v) => $da7aa32252e16ce7$export$2e2bcd8739ae039 = v);
var $da7aa32252e16ce7$export$1e511d4a378977f5;
var $da7aa32252e16ce7$export$2e2bcd8739ae039;
"use strict";
$da7aa32252e16ce7$export$1e511d4a378977f5 = true;

var $9XWro = parcelRequire("9XWro");
var $da7aa32252e16ce7$var$_iterator2 = $da7aa32252e16ce7$var$_interopRequireDefault($9XWro);

var $2580X = parcelRequire("2580X");
var $da7aa32252e16ce7$var$_symbol2 = $da7aa32252e16ce7$var$_interopRequireDefault($2580X);
var $da7aa32252e16ce7$var$_typeof = typeof $da7aa32252e16ce7$var$_symbol2.default === "function" && typeof $da7aa32252e16ce7$var$_iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof $da7aa32252e16ce7$var$_symbol2.default === "function" && obj.constructor === $da7aa32252e16ce7$var$_symbol2.default && obj !== $da7aa32252e16ce7$var$_symbol2.default.prototype ? "symbol" : typeof obj;
};
function $da7aa32252e16ce7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$da7aa32252e16ce7$export$2e2bcd8739ae039 = typeof $da7aa32252e16ce7$var$_symbol2.default === "function" && $da7aa32252e16ce7$var$_typeof($da7aa32252e16ce7$var$_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : $da7aa32252e16ce7$var$_typeof(obj);
} : function(obj) {
    return obj && typeof $da7aa32252e16ce7$var$_symbol2.default === "function" && obj.constructor === $da7aa32252e16ce7$var$_symbol2.default && obj !== $da7aa32252e16ce7$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $da7aa32252e16ce7$var$_typeof(obj);
};

});
parcelRegister("9XWro", function(module, exports) {

module.exports = {
    "default": (parcelRequire("2HsZd")),
    __esModule: true
};

});
parcelRegister("2HsZd", function(module, exports) {
parcelRequire("hk0a3");
parcelRequire("5rlu9");

module.exports = (parcelRequire("lBMLV")).f('iterator');

});
parcelRegister("hk0a3", function(module, exports) {
'use strict';

var $c9c46de7c8e907ca$var$$at = (parcelRequire("8KGAK"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("hvCN6"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $c9c46de7c8e907ca$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("8KGAK", function(module, exports) {

var $3xWSq = parcelRequire("3xWSq");

var $9NV8H = parcelRequire("9NV8H");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($9NV8H(that));
        var i = $3xWSq(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});

parcelRegister("hvCN6", function(module, exports) {
'use strict';

var $2isa8 = parcelRequire("2isa8");

var $e03XD = parcelRequire("e03XD");

var $5DcrY = parcelRequire("5DcrY");

var $9dqdv = parcelRequire("9dqdv");

var $4CSvb = parcelRequire("4CSvb");

var $dyqaq = parcelRequire("dyqaq");

var $a5wrg = parcelRequire("a5wrg");

var $3prgy = parcelRequire("3prgy");

var $cbf36bfa64a1f0ac$var$ITERATOR = (parcelRequire("3DTJ3"))('iterator');
var $cbf36bfa64a1f0ac$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $cbf36bfa64a1f0ac$var$FF_ITERATOR = '@@iterator';
var $cbf36bfa64a1f0ac$var$KEYS = 'keys';
var $cbf36bfa64a1f0ac$var$VALUES = 'values';
var $cbf36bfa64a1f0ac$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $dyqaq(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$cbf36bfa64a1f0ac$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $cbf36bfa64a1f0ac$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $cbf36bfa64a1f0ac$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $cbf36bfa64a1f0ac$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$cbf36bfa64a1f0ac$var$ITERATOR] || proto[$cbf36bfa64a1f0ac$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $3prgy($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $a5wrg(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$2isa8 && typeof IteratorPrototype[$cbf36bfa64a1f0ac$var$ITERATOR] != 'function') $9dqdv(IteratorPrototype, $cbf36bfa64a1f0ac$var$ITERATOR, $cbf36bfa64a1f0ac$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $cbf36bfa64a1f0ac$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$2isa8 || FORCED) && ($cbf36bfa64a1f0ac$var$BUGGY || VALUES_BUG || !proto[$cbf36bfa64a1f0ac$var$ITERATOR])) $9dqdv(proto, $cbf36bfa64a1f0ac$var$ITERATOR, $default);
    // Plug for library
    $4CSvb[NAME] = $default;
    $4CSvb[TAG] = $cbf36bfa64a1f0ac$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($cbf36bfa64a1f0ac$var$VALUES),
            keys: IS_SET ? $default : getMethod($cbf36bfa64a1f0ac$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $5DcrY(proto, key, methods[key]);
        } else $e03XD($e03XD.P + $e03XD.F * ($cbf36bfa64a1f0ac$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("5DcrY", function(module, exports) {

module.exports = (parcelRequire("9dqdv"));

});

parcelRegister("4CSvb", function(module, exports) {
module.exports = {};

});

parcelRegister("dyqaq", function(module, exports) {
'use strict';

var $3FikI = parcelRequire("3FikI");

var $aZwDw = parcelRequire("aZwDw");

var $a5wrg = parcelRequire("a5wrg");
var $9de2bf9b22f167c8$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("9dqdv"))($9de2bf9b22f167c8$var$IteratorPrototype, (parcelRequire("3DTJ3"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $3FikI($9de2bf9b22f167c8$var$IteratorPrototype, {
        next: $aZwDw(1, next)
    });
    $a5wrg(Constructor, NAME + ' Iterator');
};

});
parcelRegister("3FikI", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $jdpF7 = parcelRequire("jdpF7");

var $kbx7w = parcelRequire("kbx7w");

var $c5IyZ = parcelRequire("c5IyZ");

var $2ab36c008f37c78f$var$IE_PROTO = (parcelRequire("2xdmx"))('IE_PROTO');
var $2ab36c008f37c78f$var$Empty = function() {};
var $2ab36c008f37c78f$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $2ab36c008f37c78f$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("4Py1Y"))('iframe');
    var i = $c5IyZ.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("eCthJ")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $2ab36c008f37c78f$var$createDict = iframeDocument.F;
    while(i--)delete $2ab36c008f37c78f$var$createDict[$2ab36c008f37c78f$var$PROTOTYPE][$c5IyZ[i]];
    return $2ab36c008f37c78f$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $2ab36c008f37c78f$var$Empty[$2ab36c008f37c78f$var$PROTOTYPE] = $jdpF7(O);
        result = new $2ab36c008f37c78f$var$Empty();
        $2ab36c008f37c78f$var$Empty[$2ab36c008f37c78f$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$2ab36c008f37c78f$var$IE_PROTO] = O;
    } else result = $2ab36c008f37c78f$var$createDict();
    return Properties === undefined ? result : $kbx7w(result, Properties);
};

});
parcelRegister("kbx7w", function(module, exports) {

var $hIB01 = parcelRequire("hIB01");

var $jdpF7 = parcelRequire("jdpF7");

var $3Qq35 = parcelRequire("3Qq35");

module.exports = (parcelRequire("6thbX")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $jdpF7(O);
    var keys = $3Qq35(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$hIB01.f(O, P = keys[i++], Properties[P]);
    return O;
};

});

parcelRegister("eCthJ", function(module, exports) {

var $Tiymd = parcelRequire("Tiymd");
var $aa4b54b56aabc8f8$require$document = $Tiymd.document;
module.exports = $aa4b54b56aabc8f8$require$document && $aa4b54b56aabc8f8$require$document.documentElement;

});


parcelRegister("a5wrg", function(module, exports) {

var $hIB01 = parcelRequire("hIB01");
var $758388ae4ea0e5d2$require$def = $hIB01.f;

var $6Yw7l = parcelRequire("6Yw7l");

var $758388ae4ea0e5d2$var$TAG = (parcelRequire("3DTJ3"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$6Yw7l(it = stat ? it : it.prototype, $758388ae4ea0e5d2$var$TAG)) $758388ae4ea0e5d2$require$def(it, $758388ae4ea0e5d2$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("3DTJ3", function(module, exports) {

var $2a703d8d80c0db95$var$store = (parcelRequire("kCZia"))('wks');

var $b1OOh = parcelRequire("b1OOh");

var $Tiymd = parcelRequire("Tiymd");
var $2a703d8d80c0db95$require$Symbol = $Tiymd.Symbol;
var $2a703d8d80c0db95$var$USE_SYMBOL = typeof $2a703d8d80c0db95$require$Symbol == 'function';
var $2a703d8d80c0db95$var$$exports = module.exports = function(name) {
    return $2a703d8d80c0db95$var$store[name] || ($2a703d8d80c0db95$var$store[name] = $2a703d8d80c0db95$var$USE_SYMBOL && $2a703d8d80c0db95$require$Symbol[name] || ($2a703d8d80c0db95$var$USE_SYMBOL ? $2a703d8d80c0db95$require$Symbol : $b1OOh)('Symbol.' + name));
};
$2a703d8d80c0db95$var$$exports.store = $2a703d8d80c0db95$var$store;

});





parcelRegister("5rlu9", function(module, exports) {
parcelRequire("apb0F");

var $Tiymd = parcelRequire("Tiymd");

var $9dqdv = parcelRequire("9dqdv");

var $4CSvb = parcelRequire("4CSvb");

var $3f6023eca5f868be$var$TO_STRING_TAG = (parcelRequire("3DTJ3"))('toStringTag');
var $3f6023eca5f868be$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var $3f6023eca5f868be$var$i = 0; $3f6023eca5f868be$var$i < $3f6023eca5f868be$var$DOMIterables.length; $3f6023eca5f868be$var$i++){
    var $3f6023eca5f868be$var$NAME = $3f6023eca5f868be$var$DOMIterables[$3f6023eca5f868be$var$i];
    var $3f6023eca5f868be$var$Collection = $Tiymd[$3f6023eca5f868be$var$NAME];
    var $3f6023eca5f868be$var$proto = $3f6023eca5f868be$var$Collection && $3f6023eca5f868be$var$Collection.prototype;
    if ($3f6023eca5f868be$var$proto && !$3f6023eca5f868be$var$proto[$3f6023eca5f868be$var$TO_STRING_TAG]) $9dqdv($3f6023eca5f868be$var$proto, $3f6023eca5f868be$var$TO_STRING_TAG, $3f6023eca5f868be$var$NAME);
    $4CSvb[$3f6023eca5f868be$var$NAME] = $4CSvb.Array;
}

});
parcelRegister("apb0F", function(module, exports) {
'use strict';

var $fxxRc = parcelRequire("fxxRc");

var $jL8LP = parcelRequire("jL8LP");

var $4CSvb = parcelRequire("4CSvb");

var $uZdCX = parcelRequire("uZdCX");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("hvCN6"))(Array, 'Array', function(iterated, kind) {
    this._t = $uZdCX(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $jL8LP(1);
    }
    if (kind == 'keys') return $jL8LP(0, index);
    if (kind == 'values') return $jL8LP(0, O[index]);
    return $jL8LP(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$4CSvb.Arguments = $4CSvb.Array;
$fxxRc('keys');
$fxxRc('values');
$fxxRc('entries');

});
parcelRegister("fxxRc", function(module, exports) {
module.exports = function() {};

});

parcelRegister("jL8LP", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});



parcelRegister("lBMLV", function(module, exports) {

$parcel$export(module.exports, "f", () => $fbb2e2c9b90a0797$export$2d1720544b23b823, (v) => $fbb2e2c9b90a0797$export$2d1720544b23b823 = v);
var $fbb2e2c9b90a0797$export$2d1720544b23b823;

$fbb2e2c9b90a0797$export$2d1720544b23b823 = (parcelRequire("3DTJ3"));

});



parcelRegister("2580X", function(module, exports) {

module.exports = {
    "default": (parcelRequire("9nPi6")),
    __esModule: true
};

});
parcelRegister("9nPi6", function(module, exports) {
parcelRequire("4TBu4");
parcelRequire("aVDCP");
parcelRequire("cJaq8");
parcelRequire("hkNGV");

module.exports = (parcelRequire("aMwpa")).Symbol;

});
parcelRegister("4TBu4", function(module, exports) {
'use strict';

var $Tiymd = parcelRequire("Tiymd");

var $6Yw7l = parcelRequire("6Yw7l");

var $6thbX = parcelRequire("6thbX");

var $e03XD = parcelRequire("e03XD");

var $5DcrY = parcelRequire("5DcrY");

var $bmXMY = parcelRequire("bmXMY");
var $39096007c19b2cf3$require$META = $bmXMY.KEY;

var $iNaFM = parcelRequire("iNaFM");

var $kCZia = parcelRequire("kCZia");

var $a5wrg = parcelRequire("a5wrg");

var $b1OOh = parcelRequire("b1OOh");

var $3DTJ3 = parcelRequire("3DTJ3");

var $lBMLV = parcelRequire("lBMLV");

var $5JZxk = parcelRequire("5JZxk");

var $7oGik = parcelRequire("7oGik");

var $2txWS = parcelRequire("2txWS");

var $jdpF7 = parcelRequire("jdpF7");

var $1zFdr = parcelRequire("1zFdr");

var $7kYU6 = parcelRequire("7kYU6");

var $uZdCX = parcelRequire("uZdCX");

var $5s3nY = parcelRequire("5s3nY");

var $aZwDw = parcelRequire("aZwDw");

var $3FikI = parcelRequire("3FikI");

var $hbWGp = parcelRequire("hbWGp");

var $42GOE = parcelRequire("42GOE");

var $gz5yj = parcelRequire("gz5yj");

var $hIB01 = parcelRequire("hIB01");

var $3Qq35 = parcelRequire("3Qq35");
var $39096007c19b2cf3$var$gOPD = $42GOE.f;
var $39096007c19b2cf3$var$dP = $hIB01.f;
var $39096007c19b2cf3$var$gOPN = $hbWGp.f;
var $39096007c19b2cf3$var$$Symbol = $Tiymd.Symbol;
var $39096007c19b2cf3$var$$JSON = $Tiymd.JSON;
var $39096007c19b2cf3$var$_stringify = $39096007c19b2cf3$var$$JSON && $39096007c19b2cf3$var$$JSON.stringify;
var $39096007c19b2cf3$var$PROTOTYPE = 'prototype';
var $39096007c19b2cf3$var$HIDDEN = $3DTJ3('_hidden');
var $39096007c19b2cf3$var$TO_PRIMITIVE = $3DTJ3('toPrimitive');
var $39096007c19b2cf3$var$isEnum = {}.propertyIsEnumerable;
var $39096007c19b2cf3$var$SymbolRegistry = $kCZia('symbol-registry');
var $39096007c19b2cf3$var$AllSymbols = $kCZia('symbols');
var $39096007c19b2cf3$var$OPSymbols = $kCZia('op-symbols');
var $39096007c19b2cf3$var$ObjectProto = Object[$39096007c19b2cf3$var$PROTOTYPE];
var $39096007c19b2cf3$var$USE_NATIVE = typeof $39096007c19b2cf3$var$$Symbol == 'function' && !!$gz5yj.f;
var $39096007c19b2cf3$var$QObject = $Tiymd.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $39096007c19b2cf3$var$setter = !$39096007c19b2cf3$var$QObject || !$39096007c19b2cf3$var$QObject[$39096007c19b2cf3$var$PROTOTYPE] || !$39096007c19b2cf3$var$QObject[$39096007c19b2cf3$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $39096007c19b2cf3$var$setSymbolDesc = $6thbX && $iNaFM(function() {
    return $3FikI($39096007c19b2cf3$var$dP({}, 'a', {
        get: function() {
            return $39096007c19b2cf3$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $39096007c19b2cf3$var$gOPD($39096007c19b2cf3$var$ObjectProto, key);
    if (protoDesc) delete $39096007c19b2cf3$var$ObjectProto[key];
    $39096007c19b2cf3$var$dP(it, key, D);
    if (protoDesc && it !== $39096007c19b2cf3$var$ObjectProto) $39096007c19b2cf3$var$dP($39096007c19b2cf3$var$ObjectProto, key, protoDesc);
} : $39096007c19b2cf3$var$dP;
var $39096007c19b2cf3$var$wrap = function(tag) {
    var sym = $39096007c19b2cf3$var$AllSymbols[tag] = $3FikI($39096007c19b2cf3$var$$Symbol[$39096007c19b2cf3$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $39096007c19b2cf3$var$isSymbol = $39096007c19b2cf3$var$USE_NATIVE && typeof $39096007c19b2cf3$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $39096007c19b2cf3$var$$Symbol;
};
var $39096007c19b2cf3$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $39096007c19b2cf3$var$ObjectProto) $39096007c19b2cf3$var$$defineProperty($39096007c19b2cf3$var$OPSymbols, key, D);
    $jdpF7(it);
    key = $5s3nY(key, true);
    $jdpF7(D);
    if ($6Yw7l($39096007c19b2cf3$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$6Yw7l(it, $39096007c19b2cf3$var$HIDDEN)) $39096007c19b2cf3$var$dP(it, $39096007c19b2cf3$var$HIDDEN, $aZwDw(1, {}));
            it[$39096007c19b2cf3$var$HIDDEN][key] = true;
        } else {
            if ($6Yw7l(it, $39096007c19b2cf3$var$HIDDEN) && it[$39096007c19b2cf3$var$HIDDEN][key]) it[$39096007c19b2cf3$var$HIDDEN][key] = false;
            D = $3FikI(D, {
                enumerable: $aZwDw(0, false)
            });
        }
        return $39096007c19b2cf3$var$setSymbolDesc(it, key, D);
    }
    return $39096007c19b2cf3$var$dP(it, key, D);
};
var $39096007c19b2cf3$var$$defineProperties = function defineProperties(it, P) {
    $jdpF7(it);
    var keys = $7oGik(P = $uZdCX(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$39096007c19b2cf3$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $39096007c19b2cf3$var$$create = function create(it, P) {
    return P === undefined ? $3FikI(it) : $39096007c19b2cf3$var$$defineProperties($3FikI(it), P);
};
var $39096007c19b2cf3$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $39096007c19b2cf3$var$isEnum.call(this, key = $5s3nY(key, true));
    if (this === $39096007c19b2cf3$var$ObjectProto && $6Yw7l($39096007c19b2cf3$var$AllSymbols, key) && !$6Yw7l($39096007c19b2cf3$var$OPSymbols, key)) return false;
    return E || !$6Yw7l(this, key) || !$6Yw7l($39096007c19b2cf3$var$AllSymbols, key) || $6Yw7l(this, $39096007c19b2cf3$var$HIDDEN) && this[$39096007c19b2cf3$var$HIDDEN][key] ? E : true;
};
var $39096007c19b2cf3$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $uZdCX(it);
    key = $5s3nY(key, true);
    if (it === $39096007c19b2cf3$var$ObjectProto && $6Yw7l($39096007c19b2cf3$var$AllSymbols, key) && !$6Yw7l($39096007c19b2cf3$var$OPSymbols, key)) return;
    var D = $39096007c19b2cf3$var$gOPD(it, key);
    if (D && $6Yw7l($39096007c19b2cf3$var$AllSymbols, key) && !($6Yw7l(it, $39096007c19b2cf3$var$HIDDEN) && it[$39096007c19b2cf3$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $39096007c19b2cf3$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $39096007c19b2cf3$var$gOPN($uZdCX(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$6Yw7l($39096007c19b2cf3$var$AllSymbols, key = names[i++]) && key != $39096007c19b2cf3$var$HIDDEN && key != $39096007c19b2cf3$require$META) result.push(key);
    return result;
};
var $39096007c19b2cf3$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $39096007c19b2cf3$var$ObjectProto;
    var names = $39096007c19b2cf3$var$gOPN(IS_OP ? $39096007c19b2cf3$var$OPSymbols : $uZdCX(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($6Yw7l($39096007c19b2cf3$var$AllSymbols, key = names[i++]) && (IS_OP ? $6Yw7l($39096007c19b2cf3$var$ObjectProto, key) : true)) result.push($39096007c19b2cf3$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$39096007c19b2cf3$var$USE_NATIVE) {
    $39096007c19b2cf3$var$$Symbol = function Symbol() {
        if (this instanceof $39096007c19b2cf3$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $b1OOh(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $39096007c19b2cf3$var$ObjectProto) $set.call($39096007c19b2cf3$var$OPSymbols, value);
            if ($6Yw7l(this, $39096007c19b2cf3$var$HIDDEN) && $6Yw7l(this[$39096007c19b2cf3$var$HIDDEN], tag)) this[$39096007c19b2cf3$var$HIDDEN][tag] = false;
            $39096007c19b2cf3$var$setSymbolDesc(this, tag, $aZwDw(1, value));
        };
        if ($6thbX && $39096007c19b2cf3$var$setter) $39096007c19b2cf3$var$setSymbolDesc($39096007c19b2cf3$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $39096007c19b2cf3$var$wrap(tag);
    };
    $5DcrY($39096007c19b2cf3$var$$Symbol[$39096007c19b2cf3$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $42GOE.f = $39096007c19b2cf3$var$$getOwnPropertyDescriptor;
    $hIB01.f = $39096007c19b2cf3$var$$defineProperty;
    (parcelRequire("52EsI")).f = $hbWGp.f = $39096007c19b2cf3$var$$getOwnPropertyNames;
    (parcelRequire("lEu8b")).f = $39096007c19b2cf3$var$$propertyIsEnumerable;
    $gz5yj.f = $39096007c19b2cf3$var$$getOwnPropertySymbols;
    if ($6thbX && !(parcelRequire("2isa8"))) $5DcrY($39096007c19b2cf3$var$ObjectProto, 'propertyIsEnumerable', $39096007c19b2cf3$var$$propertyIsEnumerable, true);
    $lBMLV.f = function(name) {
        return $39096007c19b2cf3$var$wrap($3DTJ3(name));
    };
}
$e03XD($e03XD.G + $e03XD.W + $e03XD.F * !$39096007c19b2cf3$var$USE_NATIVE, {
    Symbol: $39096007c19b2cf3$var$$Symbol
});
for(var $39096007c19b2cf3$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $39096007c19b2cf3$var$j = 0; $39096007c19b2cf3$var$es6Symbols.length > $39096007c19b2cf3$var$j;)$3DTJ3($39096007c19b2cf3$var$es6Symbols[$39096007c19b2cf3$var$j++]);
for(var $39096007c19b2cf3$var$wellKnownSymbols = $3Qq35($3DTJ3.store), $39096007c19b2cf3$var$k = 0; $39096007c19b2cf3$var$wellKnownSymbols.length > $39096007c19b2cf3$var$k;)$5JZxk($39096007c19b2cf3$var$wellKnownSymbols[$39096007c19b2cf3$var$k++]);
$e03XD($e03XD.S + $e03XD.F * !$39096007c19b2cf3$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $6Yw7l($39096007c19b2cf3$var$SymbolRegistry, key += '') ? $39096007c19b2cf3$var$SymbolRegistry[key] : $39096007c19b2cf3$var$SymbolRegistry[key] = $39096007c19b2cf3$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$39096007c19b2cf3$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $39096007c19b2cf3$var$SymbolRegistry)if ($39096007c19b2cf3$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $39096007c19b2cf3$var$setter = true;
    },
    useSimple: function() {
        $39096007c19b2cf3$var$setter = false;
    }
});
$e03XD($e03XD.S + $e03XD.F * !$39096007c19b2cf3$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $39096007c19b2cf3$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $39096007c19b2cf3$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $39096007c19b2cf3$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $39096007c19b2cf3$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $39096007c19b2cf3$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $39096007c19b2cf3$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $39096007c19b2cf3$var$FAILS_ON_PRIMITIVES = $iNaFM(function() {
    $gz5yj.f(1);
});
$e03XD($e03XD.S + $e03XD.F * $39096007c19b2cf3$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $gz5yj.f($7kYU6(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$39096007c19b2cf3$var$$JSON && $e03XD($e03XD.S + $e03XD.F * (!$39096007c19b2cf3$var$USE_NATIVE || $iNaFM(function() {
    var S = $39096007c19b2cf3$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $39096007c19b2cf3$var$_stringify([
        S
    ]) != '[null]' || $39096007c19b2cf3$var$_stringify({
        a: S
    }) != '{}' || $39096007c19b2cf3$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$1zFdr(replacer) && it === undefined || $39096007c19b2cf3$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$2txWS(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$39096007c19b2cf3$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $39096007c19b2cf3$var$_stringify.apply($39096007c19b2cf3$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$39096007c19b2cf3$var$$Symbol[$39096007c19b2cf3$var$PROTOTYPE][$39096007c19b2cf3$var$TO_PRIMITIVE] || (parcelRequire("9dqdv"))($39096007c19b2cf3$var$$Symbol[$39096007c19b2cf3$var$PROTOTYPE], $39096007c19b2cf3$var$TO_PRIMITIVE, $39096007c19b2cf3$var$$Symbol[$39096007c19b2cf3$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$a5wrg($39096007c19b2cf3$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$a5wrg(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$a5wrg($Tiymd.JSON, 'JSON', true);

});
parcelRegister("bmXMY", function(module, exports) {

var $8470209bd5646a6f$var$META = (parcelRequire("b1OOh"))('meta');

var $1zFdr = parcelRequire("1zFdr");

var $6Yw7l = parcelRequire("6Yw7l");

var $hIB01 = parcelRequire("hIB01");
var $8470209bd5646a6f$require$setDesc = $hIB01.f;
var $8470209bd5646a6f$var$id = 0;
var $8470209bd5646a6f$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $8470209bd5646a6f$var$FREEZE = !(parcelRequire("iNaFM"))(function() {
    return $8470209bd5646a6f$var$isExtensible(Object.preventExtensions({}));
});
var $8470209bd5646a6f$var$setMeta = function(it) {
    $8470209bd5646a6f$require$setDesc(it, $8470209bd5646a6f$var$META, {
        value: {
            i: 'O' + ++$8470209bd5646a6f$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $8470209bd5646a6f$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$1zFdr(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$6Yw7l(it, $8470209bd5646a6f$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$8470209bd5646a6f$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $8470209bd5646a6f$var$setMeta(it);
    // return object ID
    }
    return it[$8470209bd5646a6f$var$META].i;
};
var $8470209bd5646a6f$var$getWeak = function(it, create) {
    if (!$6Yw7l(it, $8470209bd5646a6f$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$8470209bd5646a6f$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $8470209bd5646a6f$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$8470209bd5646a6f$var$META].w;
};
// add metadata on freeze-family methods calling
var $8470209bd5646a6f$var$onFreeze = function(it) {
    if ($8470209bd5646a6f$var$FREEZE && $8470209bd5646a6f$var$meta.NEED && $8470209bd5646a6f$var$isExtensible(it) && !$6Yw7l(it, $8470209bd5646a6f$var$META)) $8470209bd5646a6f$var$setMeta(it);
    return it;
};
var $8470209bd5646a6f$var$meta = module.exports = {
    KEY: $8470209bd5646a6f$var$META,
    NEED: false,
    fastKey: $8470209bd5646a6f$var$fastKey,
    getWeak: $8470209bd5646a6f$var$getWeak,
    onFreeze: $8470209bd5646a6f$var$onFreeze
};

});

parcelRegister("5JZxk", function(module, exports) {

var $Tiymd = parcelRequire("Tiymd");

var $aMwpa = parcelRequire("aMwpa");

var $2isa8 = parcelRequire("2isa8");

var $lBMLV = parcelRequire("lBMLV");

var $hIB01 = parcelRequire("hIB01");
var $42e0e392b78d557f$require$defineProperty = $hIB01.f;
module.exports = function(name) {
    var $Symbol = $aMwpa.Symbol || ($aMwpa.Symbol = $2isa8 ? {} : $Tiymd.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $42e0e392b78d557f$require$defineProperty($Symbol, name, {
        value: $lBMLV.f(name)
    });
};

});

parcelRegister("7oGik", function(module, exports) {
// all enumerable object keys, includes symbols

var $3Qq35 = parcelRequire("3Qq35");

var $gz5yj = parcelRequire("gz5yj");

var $lEu8b = parcelRequire("lEu8b");
module.exports = function(it) {
    var result = $3Qq35(it);
    var getSymbols = $gz5yj.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $lEu8b.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});

parcelRegister("2txWS", function(module, exports) {
// 7.2.2 IsArray(argument)

var $7A4P0 = parcelRequire("7A4P0");
module.exports = Array.isArray || function isArray(arg) {
    return $7A4P0(arg) == 'Array';
};

});

parcelRegister("hbWGp", function(module, exports) {

$parcel$export(module.exports, "f", () => $c840fbf7ee23ffb8$export$2d1720544b23b823, (v) => $c840fbf7ee23ffb8$export$2d1720544b23b823 = v);
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $c840fbf7ee23ffb8$export$2d1720544b23b823;

var $uZdCX = parcelRequire("uZdCX");

var $52EsI = parcelRequire("52EsI");
var $c840fbf7ee23ffb8$require$gOPN = $52EsI.f;
var $c840fbf7ee23ffb8$var$toString = {}.toString;
var $c840fbf7ee23ffb8$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $c840fbf7ee23ffb8$var$getWindowNames = function(it) {
    try {
        return $c840fbf7ee23ffb8$require$gOPN(it);
    } catch (e) {
        return $c840fbf7ee23ffb8$var$windowNames.slice();
    }
};
$c840fbf7ee23ffb8$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $c840fbf7ee23ffb8$var$windowNames && $c840fbf7ee23ffb8$var$toString.call(it) == '[object Window]' ? $c840fbf7ee23ffb8$var$getWindowNames(it) : $c840fbf7ee23ffb8$require$gOPN($uZdCX(it));
};

});
parcelRegister("52EsI", function(module, exports) {

$parcel$export(module.exports, "f", () => $3abc8693f4d46e8c$export$2d1720544b23b823, (v) => $3abc8693f4d46e8c$export$2d1720544b23b823 = v);
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $3abc8693f4d46e8c$export$2d1720544b23b823;

var $6QCVe = parcelRequire("6QCVe");

var $3abc8693f4d46e8c$var$hiddenKeys = (parcelRequire("c5IyZ")).concat('length', 'prototype');
$3abc8693f4d46e8c$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $6QCVe(O, $3abc8693f4d46e8c$var$hiddenKeys);
};

});


parcelRegister("42GOE", function(module, exports) {

$parcel$export(module.exports, "f", () => $2f188fb35aa5638e$export$2d1720544b23b823, (v) => $2f188fb35aa5638e$export$2d1720544b23b823 = v);
var $2f188fb35aa5638e$export$2d1720544b23b823;

var $lEu8b = parcelRequire("lEu8b");

var $aZwDw = parcelRequire("aZwDw");

var $uZdCX = parcelRequire("uZdCX");

var $5s3nY = parcelRequire("5s3nY");

var $6Yw7l = parcelRequire("6Yw7l");

var $8MNgS = parcelRequire("8MNgS");
var $2f188fb35aa5638e$var$gOPD = Object.getOwnPropertyDescriptor;

$2f188fb35aa5638e$export$2d1720544b23b823 = (parcelRequire("6thbX")) ? $2f188fb35aa5638e$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $uZdCX(O);
    P = $5s3nY(P, true);
    if ($8MNgS) try {
        return $2f188fb35aa5638e$var$gOPD(O, P);
    } catch (e) {}
    if ($6Yw7l(O, P)) return $aZwDw(!$lEu8b.f.call(O, P), O[P]);
};

});


parcelRegister("aVDCP", function(module, exports) {

});

parcelRegister("cJaq8", function(module, exports) {

(parcelRequire("5JZxk"))('asyncIterator');

});

parcelRegister("hkNGV", function(module, exports) {

(parcelRequire("5JZxk"))('observable');

});





parcelRegister("5taqD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $3fb7c0111f5c0ef4$export$1e511d4a378977f5, (v) => $3fb7c0111f5c0ef4$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $3fb7c0111f5c0ef4$export$2e2bcd8739ae039, (v) => $3fb7c0111f5c0ef4$export$2e2bcd8739ae039 = v);
var $3fb7c0111f5c0ef4$export$1e511d4a378977f5;
var $3fb7c0111f5c0ef4$export$2e2bcd8739ae039;
"use strict";
$3fb7c0111f5c0ef4$export$1e511d4a378977f5 = true;

var $ephCu = parcelRequire("ephCu");
var $3fb7c0111f5c0ef4$var$_setPrototypeOf2 = $3fb7c0111f5c0ef4$var$_interopRequireDefault($ephCu);

var $9nmSg = parcelRequire("9nmSg");
var $3fb7c0111f5c0ef4$var$_create2 = $3fb7c0111f5c0ef4$var$_interopRequireDefault($9nmSg);

var $iKXrS = parcelRequire("iKXrS");
var $3fb7c0111f5c0ef4$var$_typeof3 = $3fb7c0111f5c0ef4$var$_interopRequireDefault($iKXrS);
function $3fb7c0111f5c0ef4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$3fb7c0111f5c0ef4$export$2e2bcd8739ae039 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $3fb7c0111f5c0ef4$var$_typeof3.default)(superClass)));
    subClass.prototype = (0, $3fb7c0111f5c0ef4$var$_create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3fb7c0111f5c0ef4$var$_setPrototypeOf2.default ? (0, $3fb7c0111f5c0ef4$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

});
parcelRegister("ephCu", function(module, exports) {

module.exports = {
    "default": (parcelRequire("jbw8H")),
    __esModule: true
};

});
parcelRegister("jbw8H", function(module, exports) {
parcelRequire("8YZNe");

module.exports = (parcelRequire("aMwpa")).Object.setPrototypeOf;

});
parcelRegister("8YZNe", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $e03XD = parcelRequire("e03XD");

$e03XD($e03XD.S, 'Object', {
    setPrototypeOf: (parcelRequire("cAIQR")).set
});

});
parcelRegister("cAIQR", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $1zFdr = parcelRequire("1zFdr");

var $jdpF7 = parcelRequire("jdpF7");
var $92aba36f6b06a026$var$check = function(O, proto) {
    $jdpF7(O);
    if (!$1zFdr(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("bgjSK"))(Function.call, (parcelRequire("42GOE")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $92aba36f6b06a026$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $92aba36f6b06a026$var$check
};

});




parcelRegister("9nmSg", function(module, exports) {

module.exports = {
    "default": (parcelRequire("bFuWU")),
    __esModule: true
};

});
parcelRegister("bFuWU", function(module, exports) {
parcelRequire("1zGUv");

var $aMwpa = parcelRequire("aMwpa");
var $87eb87e70ca19670$require$$Object = $aMwpa.Object;
module.exports = function create(P, D) {
    return $87eb87e70ca19670$require$$Object.create(P, D);
};

});
parcelRegister("1zGUv", function(module, exports) {

var $e03XD = parcelRequire("e03XD");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$e03XD($e03XD.S, 'Object', {
    create: (parcelRequire("3FikI"))
});

});




parcelRegister("jq35C", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e232d790bb1068b6$var$createDetectElementResize;
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Added support for injecting custom window object
 **/ function $e232d790bb1068b6$var$createDetectElementResize(nonce, hostWindow) {
    // Check `document` and `window` in case of server-side rendering
    var _window;
    if (typeof hostWindow !== 'undefined') _window = hostWindow;
    else if (typeof window !== 'undefined') _window = window;
    else if (typeof self !== 'undefined') _window = self;
    else _window = $parcel$global;
    var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;
    if (!attachEvent) {
        var requestFrame = function() {
            var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function(fn) {
                return _window.setTimeout(fn, 20);
            };
            return function(fn) {
                return raf(fn);
            };
        }();
        var cancelFrame = function() {
            var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
            return function(id) {
                return cancel(id);
            };
        }();
        var resetTriggers = function resetTriggers(element) {
            var triggers = element.__resizeTriggers__, expand = triggers.firstElementChild, contract = triggers.lastElementChild, expandChild = expand.firstElementChild;
            contract.scrollLeft = contract.scrollWidth;
            contract.scrollTop = contract.scrollHeight;
            expandChild.style.width = expand.offsetWidth + 1 + 'px';
            expandChild.style.height = expand.offsetHeight + 1 + 'px';
            expand.scrollLeft = expand.scrollWidth;
            expand.scrollTop = expand.scrollHeight;
        };
        var checkTriggers = function checkTriggers(element) {
            return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
        };
        var scrollListener = function scrollListener(e) {
            // Don't measure (which forces) reflow for scrolls that happen inside of children!
            if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) return;
            var element = this;
            resetTriggers(this);
            if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
            this.__resizeRAF__ = requestFrame(function() {
                if (checkTriggers(element)) {
                    element.__resizeLast__.width = element.offsetWidth;
                    element.__resizeLast__.height = element.offsetHeight;
                    element.__resizeListeners__.forEach(function(fn) {
                        fn.call(element, e);
                    });
                }
            });
        };
        /* Detect CSS Animations support to detect element display/re-attach */ var animation = false, keyframeprefix = '', animationstartevent = 'animationstart', domPrefixes = 'Webkit Moz O ms'.split(' '), startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '), pfx = '';
        var elm = _window.document.createElement('fakeelement');
        if (elm.style.animationName !== undefined) animation = true;
        if (animation === false) {
            for(var i = 0; i < domPrefixes.length; i++)if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
                pfx = domPrefixes[i];
                keyframeprefix = '-' + pfx.toLowerCase() + '-';
                animationstartevent = startEvents[i];
                animation = true;
                break;
            }
        }
        var animationName = 'resizeanim';
        var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
        var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
    }
    var createStyles = function createStyles(doc) {
        if (!doc.getElementById('detectElementResize')) {
            //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
            var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', head = doc.head || doc.getElementsByTagName('head')[0], style = doc.createElement('style');
            style.id = 'detectElementResize';
            style.type = 'text/css';
            if (nonce != null) style.setAttribute('nonce', nonce);
            if (style.styleSheet) style.styleSheet.cssText = css;
            else style.appendChild(doc.createTextNode(css));
            head.appendChild(style);
        }
    };
    var addResizeListener = function addResizeListener(element, fn) {
        if (attachEvent) element.attachEvent('onresize', fn);
        else {
            if (!element.__resizeTriggers__) {
                var doc = element.ownerDocument;
                var elementStyle = _window.getComputedStyle(element);
                if (elementStyle && elementStyle.position == 'static') element.style.position = 'relative';
                createStyles(doc);
                element.__resizeLast__ = {};
                element.__resizeListeners__ = [];
                (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
                element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>';
                element.appendChild(element.__resizeTriggers__);
                resetTriggers(element);
                element.addEventListener('scroll', scrollListener, true);
                // Store reference to original instantiated scrollListener so it can be unbound later
                element.__scrollListener__ = scrollListener;
                /* Listen for a css animation to detect element display/re-attach */ if (animationstartevent) {
                    element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
                        if (e.animationName == animationName) resetTriggers(element);
                    };
                    element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                }
            }
            element.__resizeListeners__.push(fn);
        }
    };
    var removeResizeListener = function removeResizeListener(element, fn) {
        if (attachEvent) element.detachEvent('onresize', fn);
        else {
            element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
            if (!element.__resizeListeners__.length) {
                if (element.__scrollListener__) element.removeEventListener('scroll', element.__scrollListener__, true);
                if (element.__resizeTriggers__.__animationListener__) {
                    element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                    element.__resizeTriggers__.__animationListener__ = null;
                }
                try {
                    element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
                } catch (e) {
                // Preact compat; see developit/preact-compat/issues/228
                }
            }
        }
    };
    return {
        addResizeListener: addResizeListener,
        removeResizeListener: removeResizeListener
    };
}

});




parcelRegister("9RI6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $ace580855a7733ca$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $2Enn0 = parcelRequire("2Enn0");

var $7vbEf = parcelRequire("7vbEf");

var $f5bbs = parcelRequire("f5bbs");

var $4aSHd = parcelRequire("4aSHd");

var $5jaaH = parcelRequire("5jaaH");

var $fZ2Nd = parcelRequire("fZ2Nd");

var $6lH3A = parcelRequire("6lH3A");

var $aAprJ = parcelRequire("aAprJ");

var $j6oZ7 = parcelRequire("j6oZ7");

var $4oUOk = parcelRequire("4oUOk");

var $1y3rU = parcelRequire("1y3rU");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ace580855a7733ca$var$mapStateToPropsFactory = ()=>{
    const onTableChangeFactory = (0, $5iWql.default)((containerWidth, tableHasHorizontalScrollbar, tableHasVerticalScrollbar)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (analyticsEvent)=>{
            (0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
                containerType: 'virtualTable',
                attributes: {
                    hasHorizontalScrollbar: tableHasHorizontalScrollbar,
                    hasVerticalScrollbar: tableHasVerticalScrollbar,
                    containerWidth: containerWidth
                }
            });
        });
    return (state)=>{
        const rowIds = (0, $fZ2Nd.getFlattenedWithAddedRowIds)(state);
        const firstRowId = rowIds[0];
        const containerWidth = (0, $4aSHd.getTableWidthWithoutScrollbarOffset)(state);
        const tableHasHorizontalScrollbar = (0, $5jaaH.hasHorizontalScrollbar)(state);
        const tableHasVerticalScrollbar = (0, $5jaaH.hasVerticalScrollbar)(state);
        return {
            rowIds: rowIds,
            width: (0, $5jaaH.getTableContentWidth)(state),
            containerWidth: containerWidth,
            hasHorizontalScrollbar: tableHasHorizontalScrollbar,
            hasVerticalScrollbar: tableHasVerticalScrollbar,
            hasLoadingRows: (0, $f5bbs.isRowLoading)(state, firstRowId),
            Header: $aAprJ.default,
            Content: $6lH3A.default,
            ResizeColumnOverlay: $1y3rU.default,
            HorizontalScrollOverlay: $4oUOk.default,
            onTableChange: onTableChangeFactory(containerWidth, tableHasHorizontalScrollbar, tableHasVerticalScrollbar)
        };
    };
};
var $ace580855a7733ca$export$2e2bcd8739ae039 = (0, $7vbEf.connect)($ace580855a7733ca$var$mapStateToPropsFactory, {})((0, $j6oZ7.default));

});
parcelRegister("6lH3A", function(module, exports) {

$parcel$export(module.exports, "default", () => $a72969f44fa6ebfd$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $01OF3 = parcelRequire("01OF3");

var $5jaaH = parcelRequire("5jaaH");

var $97owY = parcelRequire("97owY");
var $a72969f44fa6ebfd$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state)=>({
        isHorizontalScrollVisible: (0, $5jaaH.hasHorizontalScrollbar)(state),
        isContentStale: (0, $01OF3.isContentStale)(state),
        shouldHideLoadingIndicator: (0, $01OF3.shouldHideLoadingIndicator)(state)
    }), {})((0, $97owY.default));

});
parcelRegister("97owY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cde7c3791953334$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");


var $6pOL1 = parcelRequire("6pOL1");

var $jz2Rt = parcelRequire("jz2Rt");

var $ihIs1 = parcelRequire("ihIs1");

var $kIjoA = parcelRequire("kIjoA");

var $8VdSY = parcelRequire("8VdSY");

var $3iPgc = parcelRequire("3iPgc");
function $5cde7c3791953334$var$Content(props) {
    const { isHorizontalScrollVisible: isHorizontalScrollVisible, isContentStale: isContentStale, shouldHideLoadingIndicator: shouldHideLoadingIndicator, theme: theme } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5cde7c3791953334$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8VdSY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5cde7c3791953334$export$f185744748c379a7, {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ihIs1.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iPgc.default), null)), isContentStale && // @ts-expect-error - TS2322 - Type '{ shouldHideLoadingIndicator: boolean; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<Omit<DispatchProp<any>, "dispatch">, any, any>> & Readonly<...> & Readonly<...>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jz2Rt.default), {
        shouldHideLoadingIndicator: shouldHideLoadingIndicator
    })), isHorizontalScrollVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5cde7c3791953334$var$HorizontalScrollBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIjoA.default), null)));
}
$5cde7c3791953334$var$Content.defaultProps = {
    isContentStale: false,
    shouldHideLoadingIndicator: false
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5cde7c3791953334$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.className
        ])
    });
});
const $5cde7c3791953334$export$f185744748c379a7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1wbkrwb": (0, $9t7rW.default)(__cmplp.theme.row.useCssHover ? `var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$exports).N20})` : 'inherit')
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f3xy5q _tjnf16s5",
            __cmplp.className
        ])
    });
});
const $5cde7c3791953334$var$HorizontalScrollBarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyru2gc _19pkutpp _n3td1b66 _kqswh2mm",
            __cmplp.className
        ])
    });
});
var $5cde7c3791953334$export$2e2bcd8739ae039 = (0, $6pOL1.withTheme)($5cde7c3791953334$var$Content);

});
parcelRegister("jz2Rt", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a263d8ff5881176$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $4aSHd = parcelRequire("4aSHd");

var $6FkMh = parcelRequire("6FkMh");
var // @ts-expect-error - Expected 2-4 arguments, but got 1.
$9a263d8ff5881176$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state)=>({
        scrollOffset: (0, $4aSHd.getVerticalScrollOffset)(state),
        width: (0, $4aSHd.getTableWidthWithoutScrollbarOffset)(state)
    }))((0, $6FkMh.default));

});
parcelRegister("6FkMh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dbc315d8ad103bd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $infUR = parcelRequire("infUR");
const $0dbc315d8ad103bd$var$SPINNER_DELAY = 500;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0dbc315d8ad103bd$export$2e2bcd8739ae039 = ({ shouldHideLoadingIndicator: shouldHideLoadingIndicator, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $infUR.Blanket), props, shouldHideLoadingIndicator ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        delay: $0dbc315d8ad103bd$var$SPINNER_DELAY,
        size: "large"
    }));

});
parcelRegister("infUR", function(module, exports) {

$parcel$export(module.exports, "Blanket", () => $472e1a9779ab393f$export$5b927fc1ef8c468b);
/* styles.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");
const $472e1a9779ab393f$var$baseStyle = null;
const $472e1a9779ab393f$export$5b927fc1ef8c468b = ({ scrollOffset: scrollOffset, width: width, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            top: `${scrollOffset}px`,
            bottom: `${-scrollOffset}px`,
            width: `${width}px !important`
        },
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _tzy4txnc _bfhkvuon _kqswstnw _1pbyouyt"
        ])
    }, children);

});



parcelRegister("ihIs1", function(module, exports) {

$parcel$export(module.exports, "default", () => $113c70f0e8587128$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $kWPYY = parcelRequire("kWPYY");

var $5yvx1 = parcelRequire("5yvx1");

var $3rJ4C = parcelRequire("3rJ4C");

var $01OF3 = parcelRequire("01OF3");

var $5lWf9 = parcelRequire("5lWf9");

var $4aSHd = parcelRequire("4aSHd");

var $5jaaH = parcelRequire("5jaaH");

var $7EWSq = parcelRequire("7EWSq");

var $d5Q75 = parcelRequire("d5Q75");

var $kC7so = parcelRequire("kC7so");
var $113c70f0e8587128$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state)=>({
        isAutoHeight: (0, $01OF3.isAutoHeight)(state),
        maxHorizontalScrollOffset: (0, $5jaaH.getMaxHorizontalScrollOffset)(state),
        onRowListFocusFunctionChanged: (0, $01OF3.getOnRowListFocusFunctionChangedCallback)(state),
        onReactPortalContainerRefChanged: (0, $01OF3.getOnReactPortalContainerRefChangedCallback)(state),
        horizontalScrollOffset: (0, $4aSHd.getHorizontalScrollOffset)(state),
        navigationMode: (0, $01OF3.getNavigationMode)(state),
        AutoHeightList: $7EWSq.default,
        VirtualList: $kC7so.default
    }), {
    setHorizontalScrollOffset: $5yvx1.setHorizontal,
    setScrollbarSize: $3rJ4C.set,
    navigateToRow: $kWPYY.navigateToRow,
    clearActiveItem: $5lWf9.clearActiveItem
})((0, $d5Q75.default));

});
parcelRegister("kWPYY", function(module, exports) {

$parcel$export(module.exports, "NAVIGATE_TO_ROW", () => $95ecb73a56922d19$export$4b025a6245795408);
$parcel$export(module.exports, "navigateToRow", () => $95ecb73a56922d19$export$2b9abf839c94a6c4);
const $95ecb73a56922d19$export$4b025a6245795408 = 'ops.rows.navigate.NAVIGATE_TO_ROW';
const $95ecb73a56922d19$export$2b9abf839c94a6c4 = (payload)=>({
        type: $95ecb73a56922d19$export$4b025a6245795408,
        payload: payload
    });

});

parcelRegister("3rJ4C", function(module, exports) {

$parcel$export(module.exports, "SET_SCROLLBAR_SIZE", () => $bdfefbd39004baed$export$1343829730561bf3);
$parcel$export(module.exports, "set", () => $bdfefbd39004baed$export$adaa4cf7ef1b65be);
const $bdfefbd39004baed$export$1343829730561bf3 = 'ops.scrolling.size.SET_SCROLLBAR_SIZE';
const $bdfefbd39004baed$export$adaa4cf7ef1b65be = (payload)=>({
        type: $bdfefbd39004baed$export$1343829730561bf3,
        payload: payload
    });

});

parcelRegister("7EWSq", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f8a46fda879b1e5$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $fZ2Nd = parcelRequire("fZ2Nd");

var $95nd0 = parcelRequire("95nd0");

var $vzVDg = parcelRequire("vzVDg");
var $0f8a46fda879b1e5$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state)=>({
        rowIds: (0, $fZ2Nd.getFlattenedWithAddedRowIds)(state),
        List: $95nd0.default
    }), {})((0, $vzVDg.default));

});
parcelRegister("95nd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bd0cc57492e9fcf$export$2e2bcd8739ae039);

var $df4Sl = parcelRequire("df4Sl");

var $hTLlD = parcelRequire("hTLlD");

var $jG2Eu = parcelRequire("jG2Eu");

var $biByU = parcelRequire("biByU");

var $2Enn0 = parcelRequire("2Enn0");

var $7vbEf = parcelRequire("7vbEf");

var $4Bkxm = parcelRequire("4Bkxm");

var $01OF3 = parcelRequire("01OF3");

var $f5bbs = parcelRequire("f5bbs");

var $5jaaH = parcelRequire("5jaaH");

var $azYFi = parcelRequire("azYFi");

var $1rFeJ = parcelRequire("1rFeJ");
const $3bd0cc57492e9fcf$var$ASSIGNEE_COLUMN = 'assignee';
const $3bd0cc57492e9fcf$export$8c7854b27b9ed844 = (analyticsDataByColumns)=>{
    const groupedData = {
        minDisplayStart: Number.MAX_SAFE_INTEGER,
        maxDisplayEnd: 0,
        groups: {}
    };
    analyticsDataByColumns.forEach((analyticsData)=>{
        const { mountBeginTime: mountBeginTime, mountEndTime: mountEndTime, displayStart: displayStart, displayEnd: displayEnd } = analyticsData;
        const batchSize = analyticsDataByColumns.filter((v)=>v.displayStart === displayStart).length;
        groupedData.minDisplayStart = Math.min(displayStart, groupedData.minDisplayStart);
        groupedData.maxDisplayEnd = Math.max(displayEnd, groupedData.maxDisplayEnd);
        // group each data by the display boundary and calculate the avg time for each group
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
        if (!groupedData.groups[displayStart]) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
        groupedData.groups[displayStart] = {
            startTime: mountBeginTime,
            endTime: mountEndTime,
            meanMountTime: (mountEndTime - mountBeginTime) / batchSize
        };
        else {
            // Always take the earliest begin and end times
            const newStartTime = Math.min(mountBeginTime, // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
            groupedData.groups[displayStart].startTime);
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
            const newEndTime = Math.min(mountEndTime, groupedData.groups[displayStart].endTime);
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
            groupedData.groups[displayStart].startTime = newStartTime;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
            groupedData.groups[displayStart].endTime = newEndTime;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
            groupedData.groups[displayStart].meanMountTime = (newEndTime - newStartTime) / batchSize;
        }
    });
    return groupedData;
};
const $3bd0cc57492e9fcf$export$432f698644f45d1 = (groupedData)=>{
    const sortedMountTimes = Object.values(groupedData.groups).map((v)=>v.meanMountTime).sort((a, b)=>a - b);
    const dataLength = sortedMountTimes.length;
    return {
        median: Math.round(sortedMountTimes[Math.floor(dataLength / 2)]),
        perc90: Math.round(sortedMountTimes[Math.floor(dataLength * 0.9)]),
        perc95: Math.round(sortedMountTimes[Math.floor(dataLength * 0.95)]),
        max: Math.round(sortedMountTimes[dataLength - 1])
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3bd0cc57492e9fcf$var$fireRowMountAnalytics = (accumulatedRowAnalyticsData)=>{
    // if the user added/removed columns or switched to a different list that has different number of columns
    // fire the analytics separately for each of them
    const uniqueColumns = (0, (/*@__PURE__*/$parcel$interopDefault($biByU)))(// @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type.
    accumulatedRowAnalyticsData.map((v)=>v.columns), (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));
    // Get the metrics for each batch grouped by no. of columns
    uniqueColumns.forEach((columnArray)=>{
        // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type.
        const analyticsDataByColumns = accumulatedRowAnalyticsData.filter((v)=>(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(v.columns, columnArray));
        const { columns: columns, numberOfColumns: numberOfColumns, numberOfRows: numberOfRows, analyticsEvent: analyticsEvent } = analyticsDataByColumns[0];
        const hasNewAssigneeField = columns.includes($3bd0cc57492e9fcf$var$ASSIGNEE_COLUMN);
        const groupedData = $3bd0cc57492e9fcf$export$8c7854b27b9ed844(analyticsDataByColumns);
        const { median: median, perc90: perc90, perc95: perc95, max: max } = $3bd0cc57492e9fcf$export$432f698644f45d1(groupedData);
        (0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
            containerType: 'virtualTable',
            attributes: {
                totalNoOfRowsInTable: numberOfRows,
                columns: columns,
                numberOfColumns: numberOfColumns,
                numberOfRowsInEvent: analyticsDataByColumns.length,
                medianTimeTakenToMount: median,
                perc90TimeTakenToMount: perc90,
                perc95TimeTakenToMount: perc95,
                maxTimeTakenToMount: max,
                minDisplayStart: groupedData.minDisplayStart,
                maxDisplayEnd: groupedData.maxDisplayEnd,
                hasNewAssigneeField: hasNewAssigneeField
            }
        });
    });
};
const $3bd0cc57492e9fcf$var$getVisibleCoreColumnIdsMemoized = ()=>(0, $df4Sl.createSelector)((state)=>[].concat(// @ts-expect-error - TS2769 - No overload matches this call.
        (0, $4Bkxm.getVisibleCoreColumnIds)(state), (0, $01OF3.getVisibleAdditionalColumnIds)(state)), (res)=>res);
const $3bd0cc57492e9fcf$var$mapStateToPropsFactory = ()=>{
    const getVisibleCoreColumnIdsInstance = $3bd0cc57492e9fcf$var$getVisibleCoreColumnIdsMemoized();
    return (state)=>{
        const hasAutoHeight = (0, $01OF3.isAutoHeight)(state);
        const onRowContentMount = // only when table is virtualised
        !hasAutoHeight && (0, $5jaaH.getShouldVirtualize)(state) ? $3bd0cc57492e9fcf$var$fireRowMountAnalytics : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        return {
            rowTree: (0, $f5bbs.getRowTree)(state),
            expandedRowIdsHash: (0, $f5bbs.getExpandedRowIdsHash)(state),
            addBarOverflow: (0, $f5bbs.getAddBarOverflow)(state),
            temporaryAddedRow: (0, $f5bbs.getTemporaryAddedRow)(state),
            rowHeightMapping: (0, $f5bbs.getRowHeightMapping)(state),
            absoluteRowHeight: (0, $f5bbs.getAbsoluteRowHeight)(state),
            lastRowHasAddBar: (0, $5jaaH.canLastRowAddSiblingOrChildren)(state),
            addLinkShown: (0, $5jaaH.isAddLinkShown)(state),
            visibleColumns: getVisibleCoreColumnIdsInstance(state),
            onRowContentMount: onRowContentMount,
            RowItem: $1rFeJ.default
        };
    };
};
var $3bd0cc57492e9fcf$export$2e2bcd8739ae039 = (0, $7vbEf.connect)($3bd0cc57492e9fcf$var$mapStateToPropsFactory, {})((0, $azYFi.default));

});
parcelRegister("biByU", function(module, exports) {

var $42tFs = parcelRequire("42tFs");
/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */ function $839e83316547a995$var$uniqWith(array, comparator) {
    comparator = typeof comparator == 'function' ? comparator : undefined;
    return array && array.length ? $42tFs(array, undefined, comparator) : [];
}
module.exports = $839e83316547a995$var$uniqWith;

});

parcelRegister("azYFi", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ab46fb1617fe58e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $6iz4v = parcelRequire("6iz4v");

var $6pOL1 = parcelRequire("6pOL1");

var $iFd3W = parcelRequire("iFd3W");
const $1ab46fb1617fe58e$var$ANALYTICS_DEBOUNCE_TIME = 5000;
// eslint-disable-next-line jira/react/no-class-components
class $1ab46fb1617fe58e$var$RowList extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.fireRowMountAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            this.props.onRowContentMount(this.accumulatedRowAnalyticsData);
            this.accumulatedRowAnalyticsData = [];
        }, $1ab46fb1617fe58e$var$ANALYTICS_DEBOUNCE_TIME);
        this.gatherRowMountAnalyticsData = (mountBeginTime, mountEndTime, columns, numberOfColumns, analyticsEvent)=>{
            const { displayStart: displayStart, displayEnd: displayEnd } = this.props;
            if (!displayStart) return;
            this.accumulatedRowAnalyticsData.push({
                displayStart: displayStart,
                displayEnd: displayEnd,
                mountBeginTime: mountBeginTime,
                mountEndTime: mountEndTime,
                columns: columns.slice(0).sort(),
                numberOfColumns: numberOfColumns,
                numberOfRows: this.state.rowIds.length,
                analyticsEvent: analyticsEvent
            });
            this.fireRowMountAnalytics();
        };
        const { rowIds: rowIds, displayStart: displayStart, displayEnd: displayEnd, visibleColumns: visibleColumns } = props;
        this.state = {
            rowIds: rowIds
        };
        this.accumulatedRowAnalyticsData = [];
        // TODO: Remove this once we have sufficient numbers for performance profiling
        const rowsRendered = displayEnd - displayStart + 1;
        const columnsRendered = visibleColumns.length;
        (0, $6iz4v.setMark)(`virtualtable.rowlist.render.${rowsRendered * columnsRendered}.(${rowsRendered}x${columnsRendered}).cells.start`);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { rowIds: rowIds, displayStart: displayStart, displayEnd: displayEnd } = this.props;
        // if the incoming rows are different
        if (rowIds !== nextProps.rowIds || displayStart !== nextProps.displayStart || displayEnd !== nextProps.displayEnd) this.resetState(nextProps.rowIds);
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { displayStart: displayStart, displayEnd: displayEnd } = this.props;
        return displayStart !== nextProps.displayStart || displayEnd !== nextProps.displayEnd || this.state.rowIds !== nextState.rowIds;
    }
    resetState(rowIds) {
        this.setState({
            rowIds: rowIds
        });
    }
    render() {
        const { displayStart: displayStart, displayEnd: displayEnd, temporaryAddedRow: temporaryAddedRow, addBarOverflow: addBarOverflow, RowItem: RowItem, absoluteRowHeight: absoluteRowHeight, rowHeightMapping: rowHeightMapping, onRowContentUpdate: onRowContentUpdate, lastRowHasAddBar: lastRowHasAddBar, addLinkShown: addLinkShown, onLoadingRowUnmount: onLoadingRowUnmount, theme: theme } = this.props;
        const { rowIds: rowIds } = this.state;
        const rows = [];
        const numberOfRows = rowIds.length - 1;
        const alwaysVisibleRows = {
            [rowIds[0]]: true,
            [rowIds[numberOfRows]]: true,
            ...temporaryAddedRow && {
                [temporaryAddedRow.temporaryId]: true
            }
        };
        let spacerHeight = 0;
        let spacerStartRow = null;
        for(let index = 0; index <= numberOfRows; index += 1){
            const isAlwaysVisible = alwaysVisibleRows[rowIds[index]];
            const isDisplay = index >= displayStart && index <= displayEnd;
            if (isAlwaysVisible || isDisplay) {
                if (spacerHeight > 0 && spacerStartRow) {
                    // by using a key which is virtual row range it represents,
                    // it can still be usefully reconciled (during dragging for example)
                    const spacerKey = `${spacerStartRow}${rowIds[index - 1]}`;
                    rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFd3W.Spacer), {
                        key: spacerKey,
                        height: spacerHeight
                    }));
                    spacerHeight = 0;
                    spacerStartRow = null;
                }
                rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(RowItem, {
                    key: rowIds[index],
                    id: rowIds[index],
                    rowIndex: index,
                    onRowContentMount: this.gatherRowMountAnalyticsData,
                    onRowContentUpdate: onRowContentUpdate,
                    onLoadingRowUnmount: onLoadingRowUnmount
                }));
            } else {
                spacerHeight += rowHeightMapping[rowIds[index]] || absoluteRowHeight;
                spacerStartRow = rowIds[index];
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFd3W.Wrapper), {
            addPadding: lastRowHasAddBar || addLinkShown,
            addBarOverflow: addBarOverflow,
            theme: theme
        }, rows);
    }
}
var $1ab46fb1617fe58e$export$2e2bcd8739ae039 = (0, $6pOL1.withTheme)($1ab46fb1617fe58e$var$RowList);

});
parcelRegister("iFd3W", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $ead4624e00fb4c91$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "Spacer", () => $ead4624e00fb4c91$export$d7a54cba636a8cd6);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $ead4624e00fb4c91$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { addPadding: addPadding, addBarOverflow: addBarOverflow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_g2wqu5": (0, $9t7rW.default)(__cmplp.addBarOverflow, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0q1b66",
            __cmplp.addPadding ? "_n3tdhkvd" : "_n3tdze3t",
            __cmplp.className
        ])
    });
});
const $ead4624e00fb4c91$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i2nrh",
            __cmplp.className
        ])
    });
});
const $ead4624e00fb4c91$export$f185744748c379a7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});

});


parcelRegister("1rFeJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb9ab074cb42564d$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $lMerx = parcelRequire("lMerx");

var $01OF3 = parcelRequire("01OF3");

var $f5bbs = parcelRequire("f5bbs");

var $5jaaH = parcelRequire("5jaaH");

var $85i6k = parcelRequire("85i6k");

var $aJitp = parcelRequire("aJitp");

var $lidr9 = parcelRequire("lidr9");
const $fb9ab074cb42564d$var$mapStateToProps = (state, { id: id })=>{
    const { displayStart: displayStart } = (0, $5jaaH.getVirtualBoundaries)(state);
    return {
        delayRowRenderOnScroll: (0, $01OF3.shouldDelayRowRenderingOnScroll)(state) && displayStart > 0,
        isInCreation: (0, $f5bbs.isRowBeingAdded)(state, id),
        isLoading: (0, $f5bbs.isRowLoading)(state, id),
        LoadingRow: (0, $01OF3.getLoadingRowComponent)(state),
        isInRowNavigationMode: (0, $01OF3.isInRowNavigationMode)(state),
        NewRow: $lidr9.default,
        DefaultRow: $85i6k.default
    };
};
var $fb9ab074cb42564d$export$2e2bcd8739ae039 = (0, $7vbEf.connect)($fb9ab074cb42564d$var$mapStateToProps, {
    // @ts-expect-error - TS7006 - Parameter 'newActiveRow' implicitly has an 'any' type.
    onSetActiveRow: (newActiveRow)=>(0, $lMerx.setActiveRow)(newActiveRow)
})((0, $aJitp.default));

});
parcelRegister("lMerx", function(module, exports) {

$parcel$export(module.exports, "SET_ACTIVE_CELL", () => $b301a44ccde6b93c$export$53294753640e6bdd);
$parcel$export(module.exports, "SET_ACTIVE_ROW", () => $b301a44ccde6b93c$export$551e11108d45fd88);
$parcel$export(module.exports, "setActiveCell", () => $b301a44ccde6b93c$export$c1df6941ca12827f);
$parcel$export(module.exports, "setActiveRow", () => $b301a44ccde6b93c$export$94bb5fd7cd44d4b3);

const $b301a44ccde6b93c$export$53294753640e6bdd = 'ops.items.active.set.SET_ACTIVE_CELL';
const $b301a44ccde6b93c$export$551e11108d45fd88 = 'ops.items.active.set.SET_ACTIVE_ROW';
const $b301a44ccde6b93c$export$c1df6941ca12827f = (payload)=>({
        type: $b301a44ccde6b93c$export$53294753640e6bdd,
        payload: {
            type: (0, $a37593d97c1ae333$export$4b3489234fd17200),
            ...payload
        }
    });
const $b301a44ccde6b93c$export$94bb5fd7cd44d4b3 = (payload)=>({
        type: $b301a44ccde6b93c$export$551e11108d45fd88,
        payload: {
            type: (0, $a37593d97c1ae333$export$8a257aa81ef4a9e0),
            setFocusOnRow: false,
            ...payload
        }
    });

});

parcelRegister("85i6k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0a4d789e21e1225$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $01OF3 = parcelRequire("01OF3");

var $f5bbs = parcelRequire("f5bbs");

var $5jaaH = parcelRequire("5jaaH");

var $g6c63 = parcelRequire("g6c63");

var $h1dCZ = parcelRequire("h1dCZ");

var $bYyCW = parcelRequire("bYyCW");
var $e0a4d789e21e1225$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state, { id: id })=>{
    const isActiveItem = (0, $5jaaH.isActiveRowItem)(state, id);
    const isRowHighlighted = isActiveItem && !(0, $01OF3.isTreeTableFacade)(state) && !(0, $01OF3.isContentStale)(state) && !(0, $01OF3.disableRowHighlight)(state);
    const isRowLeftEdgeVisible = (0, $5jaaH.getOffsetFromLeft)(state) === 0;
    const isRowRightEdgeVisible = (0, $5jaaH.getOffsetFromRight)(state) === 0;
    return {
        isActiveItem: isActiveItem,
        isRowHighlighted: isRowHighlighted,
        isRowLeftEdgeVisible: isRowLeftEdgeVisible,
        isRowRightEdgeVisible: isRowRightEdgeVisible,
        isGlobalAddEnabled: (0, $5jaaH.isGlobalAddEnabled)(state),
        setFocusOnRow: (0, $5jaaH.getSetFocusOnRow)(state, id),
        isSelected: (0, $f5bbs.isRowSelected)(state, id),
        AddBar: $g6c63.default,
        Content: $h1dCZ.default
    };
}, {})((0, $bYyCW.default));

});
parcelRegister("g6c63", function(module, exports) {

$parcel$export(module.exports, "default", () => $98526ac9628430e6$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $01OF3 = parcelRequire("01OF3");

var $f5bbs = parcelRequire("f5bbs");

var $4dOZP = parcelRequire("4dOZP");
var $98526ac9628430e6$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state, { rowId: rowId })=>({
        addPosition: (0, $f5bbs.getRowAddPosition)(state, rowId),
        isRowExpanded: (0, $f5bbs.isRowExpanded)(state, rowId),
        canAddSibling: (0, $f5bbs.getRowCanAddSibling)(state, rowId),
        canAddChildren: (0, $f5bbs.getRowCanAddChildren)(state, rowId),
        onRowAddRequested: (0, $01OF3.getRowAddCallback)(state)
    }), {})((0, $4dOZP.default));

});
parcelRegister("4dOZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $c34b9e332e7b4be6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $buw7x = parcelRequire("buw7x");


var $90IgZ = parcelRequire("90IgZ");

var $giAhk = parcelRequire("giAhk");

var $kFtWi = parcelRequire("kFtWi");
const $c34b9e332e7b4be6$var$messages = (0, $90IgZ.defineMessages)({
    addIcon: {
        "id": "virtual-table.table.content.rows.common.default-row.add-bar.add-icon",
        "defaultMessage": "Click to add row"
    }
});
class $c34b9e332e7b4be6$export$3213cbaa523231e6 extends (0, $eUqFw.Component) {
    shouldComponentUpdate(nextProps) {
        const { rowId: rowId, isRowExpanded: isRowExpanded, canAddChildren: canAddChildren, canAddSibling: canAddSibling } = this.props;
        return rowId !== nextProps.rowId || canAddChildren !== nextProps.canAddChildren || canAddSibling !== nextProps.canAddSibling || isRowExpanded !== nextProps.isRowExpanded;
    }
    renderAddBar() {
        const { intl: { formatMessage: formatMessage }, isRowExpanded: isRowExpanded, rowId: rowId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kFtWi.Wrapper), {
            isIndented: isRowExpanded,
            onClick: this.onRowAddRequested,
            // eslint-disable-next-line jira/integration/enforce-data-testid-usage
            "data-test-id": `common.components.virtual-table.table.content.rows.common.default-row.add-bar.wrapper-${rowId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kFtWi.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($buw7x))), {
            color: `var(--ds-icon-accent-green, ${(0, $73a5c9d720aa66e1$exports).G200})`,
            label: formatMessage($c34b9e332e7b4be6$var$messages.addIcon)
        })));
    }
    render() {
        const { canAddChildren: canAddChildren, canAddSibling: canAddSibling, addPosition: addPosition } = this.props;
        const canAddAtPosition = addPosition === 'INSIDE' && canAddChildren || addPosition === 'AFTER' && canAddSibling;
        return canAddAtPosition ? this.renderAddBar() : null;
    }
    constructor(...args){
        super(...args);
        this.onRowAddRequested = ()=>{
            const { rowId: rowId, addPosition: addPosition, onRowAddRequested: onRowAddRequested } = this.props;
            onRowAddRequested && onRowAddRequested({
                anchorId: rowId,
                position: addPosition
            });
        };
    }
}
var $c34b9e332e7b4be6$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($c34b9e332e7b4be6$export$3213cbaa523231e6);

});
parcelRegister("buw7x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::274a3d745c0c6824dba97f9232f7df06>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85db698715a74588$var$_react = $85db698715a74588$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $85db698715a74588$var$_add = $85db698715a74588$var$_interopRequireDefault((parcelRequire("cS2gQ")));

var $85db698715a74588$var$_addCircle = $85db698715a74588$var$_interopRequireDefault((parcelRequire("joqqM")));
function $85db698715a74588$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85db698715a74588$var$AddIcon = (props)=>/*#__PURE__*/ $85db698715a74588$var$_react.default.createElement($85db698715a74588$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $85db698715a74588$var$_addCircle.default
    }, props));
$85db698715a74588$var$AddIcon.Name = 'AddIconMigration';
var $85db698715a74588$var$_default = module.exports.default = $85db698715a74588$var$AddIcon;

});
parcelRegister("joqqM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e1e4c2d5db89ba60$var$_react = $e1e4c2d5db89ba60$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $e1e4c2d5db89ba60$var$_add = $e1e4c2d5db89ba60$var$_interopRequireDefault((parcelRequire("cS2gQ")));
function $e1e4c2d5db89ba60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e1e4c2d5db89ba60$var$AddCircleIcon = (props)=>/*#__PURE__*/ $e1e4c2d5db89ba60$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M11.046 7.958v3.088H7.958a.954.954 0 1 0 0 1.908h3.088v3.088a.954.954 0 1 0 1.908 0v-3.088h3.088a.954.954 0 1 0 0-1.908h-3.088V7.958a.954.954 0 1 0-1.908 0"/></g></svg>`
    }, props, {
        newIcon: $e1e4c2d5db89ba60$var$_add.default
    }));
$e1e4c2d5db89ba60$var$AddCircleIcon.displayName = 'AddCircleIcon';
var $e1e4c2d5db89ba60$var$_default = module.exports.default = $e1e4c2d5db89ba60$var$AddCircleIcon;

});


parcelRegister("kFtWi", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $45f7aff9d9cf61c1$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "IconWrapper", () => $45f7aff9d9cf61c1$export$be58b4326e23250f);
/* styles.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $45f7aff9d9cf61c1$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIndented: isIndented, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _4t3i12x7 _bfhkgbbm _x3dov4vr _n7zlv4vr _tzy4idpf _80omtlke _kqswh2mm _154iv77o _19pkr5cr _16l4kb7n _o7ks134x",
            __cmplp.isIndented ? "_2hwxmgjw" : "_2hwxxmi2",
            __cmplp.className
        ])
    });
});
const $45f7aff9d9cf61c1$export$be58b4326e23250f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1ejb _1bsb1ejb _19pkxmi2 _18u01i6y",
            __cmplp.className
        ])
    });
});

});



parcelRegister("h1dCZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d30e5b5fc5027378$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $01OF3 = parcelRequire("01OF3");

var $4Bkxm = parcelRequire("4Bkxm");

var $5jaaH = parcelRequire("5jaaH");

var $dHcAn = parcelRequire("dHcAn");

var $M9G4y = parcelRequire("M9G4y");

var $bCfUf = parcelRequire("bCfUf");

var $bnrbB = parcelRequire("bnrbB");

var $euRxp = parcelRequire("euRxp");
var $d30e5b5fc5027378$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state, { id: id })=>({
        isActive: (0, $5jaaH.isActiveRowId)(state, id),
        coreColumnIds: (0, $4Bkxm.getVisibleCoreColumnIds)(state),
        additionalColumnIds: (0, $01OF3.getVisibleAdditionalColumnIds)(state),
        shouldRerenderRowOnHover: (0, $01OF3.shouldRerenderRowOnHover)(state),
        premiumSLAColumnIds: (0, $01OF3.getPremiumSLAColumns)(state),
        AdditionalColumnsContainer: $dHcAn.default,
        CellWrapper: $M9G4y.default,
        RowChildOperationIndicator: $bnrbB.default,
        ConditionalErrorBoundary: $bCfUf.default
    }), {})((0, $euRxp.default));

});
parcelRegister("dHcAn", function(module, exports) {

$parcel$export(module.exports, "default", () => $965df7cf24aec577$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $5yvx1 = parcelRequire("5yvx1");

var $4aSHd = parcelRequire("4aSHd");

var $5jaaH = parcelRequire("5jaaH");

var $fZ2Nd = parcelRequire("fZ2Nd");

var $gNW35 = parcelRequire("gNW35");
var $965df7cf24aec577$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state)=>({
        scrollLeft: (0, $4aSHd.getHorizontalScrollOffset)(state),
        /* This prop is not used by the component other than to force an update when the rows change.
		 * It has been done to fix the behaviour of row scroll being reset during table actions that
		 * would have previously only reconciled the elements, rather than reconstructing them.
		 * This behaviour is inherent to React and the browser, where React re-inserting nodes cause
		 * the browser to reset specific transient properties (such as scrolling or video play).
		 * Here we are forcing the re-rendering so the scroll position can be correctly
		 * inferred directly from the store.
		 * For more info see https://github.com/facebook/react/issues/13042 and the associated links.
		 */ rowIds: (0, $fZ2Nd.getFlattenedWithAddedRowIds)(state),
        additionalColumnsWidth: (0, $5jaaH.getVisibleAdditionalColumnsWidth)(state)
    }), {
    setHorizontalScrollOffset: $5yvx1.setHorizontal
})((0, $gNW35.default));

});
parcelRegister("gNW35", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2d211a7414644ed$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $zcJ0y = parcelRequire("zcJ0y");
const $f2d211a7414644ed$var$isWebkit = ()=>(0, $zcJ0y.isChrome)() || (0, $zcJ0y.isSafari)() || (0, $zcJ0y.isEdge)();
const $f2d211a7414644ed$var$wrapperStyles = {
    overflow: 'hidden',
    flex: '1 1 auto',
    marginBottom: 0
};
const $f2d211a7414644ed$var$noBarContainerStyles = {
    display: 'flex',
    overflowX: 'scroll',
    paddingBottom: 0
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2d211a7414644ed$var$ScrollableDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1fjgglyw _4pckglyw",
            $f2d211a7414644ed$var$isWebkit() && "_1cicglyw",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $f2d211a7414644ed$var$AdditionalColumnsContainer extends (0, $eUqFw.PureComponent) {
    componentDidMount() {
        const { scrollLeft: scrollLeft } = this.props;
        this.updateScrollLeft(scrollLeft);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.updateScrollLeft(nextProps.scrollLeft);
    }
    updateScrollLeft(scrollLeft) {
        const { scrollRef: scrollRef } = this;
        if (scrollRef && scrollRef.scrollLeft !== scrollLeft) {
            this.ignoreScrollEvent = true;
            scrollRef.scrollLeft = scrollLeft;
        }
    }
    render() {
        const { children: children } = this.props;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: $f2d211a7414644ed$var$wrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f2d211a7414644ed$var$ScrollableDiv, {
            ref: (div)=>{
                this.setScrollRef(div);
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $f2d211a7414644ed$var$noBarContainerStyles,
            onScroll: this.onScroll
        }, children)));
    }
    constructor(...args){
        super(...args);
        this.onScroll = (event)=>{
            const { setHorizontalScrollOffset: setHorizontalScrollOffset } = this.props;
            const { scrollRef: scrollRef, ignoreScrollEvent: ignoreScrollEvent } = this;
            if (event.currentTarget === scrollRef && !ignoreScrollEvent) setHorizontalScrollOffset(event.currentTarget.scrollLeft);
            this.ignoreScrollEvent = false;
        };
        this.setScrollRef = (ref)=>{
            this.scrollRef = ref;
        };
    }
}
var $f2d211a7414644ed$export$2e2bcd8739ae039 = $f2d211a7414644ed$var$AdditionalColumnsContainer;

});


parcelRegister("M9G4y", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1b6fd773a8a0573$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $4Gq9K = parcelRequire("4Gq9K");

var $qMUlQ = parcelRequire("qMUlQ");

var $lMerx = parcelRequire("lMerx");

var $4Bkxm = parcelRequire("4Bkxm");

var $01OF3 = parcelRequire("01OF3");

var $f5bbs = parcelRequire("f5bbs");

var $4aSHd = parcelRequire("4aSHd");

var $5jaaH = parcelRequire("5jaaH");

var $aA0YT = parcelRequire("aA0YT");
var $a1b6fd773a8a0573$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state, { rowId: rowId, columnId: columnId, isRowHovered: isRowHovered, isRowKeyboardActive: isRowKeyboardActive })=>{
    const activeItem = (0, $4aSHd.getActiveCell)(state);
    const isActive = (0, $5jaaH.isCellActive)(state, rowId, columnId);
    const activatedFrom = isActive && activeItem ? activeItem.activatedFrom : undefined;
    return {
        isInCellNavigationMode: (0, $01OF3.isInCellNavigationMode)(state),
        shouldHydrateFully: (0, $5jaaH.shouldRowHydrateFully)(state, rowId),
        width: (0, $5jaaH.getColumnWidth)(state, columnId),
        depth: (0, $5jaaH.getRowDepth)(state, rowId),
        maxDepth: (0, $f5bbs.getMaxDepth)(state),
        isActive: isActive,
        activatedFrom: activatedFrom,
        isRowHovered: isRowHovered || false,
        isRowKeyboardActive: isRowKeyboardActive || false,
        activeItemChanged: (0, $01OF3.getActiveItemChangedCallback)(state),
        CellComponent: (0, $4Bkxm.getCellComponent)(state, columnId),
        NonTemporaryCellWrapper: (0, $01OF3.getNonTemporaryCellWrapper)(state),
        canBeMultiLine: (0, $4Bkxm.canCellBeMultiLine)(state, columnId),
        parentId: (0, $4Bkxm.getColumnParentId)(state, columnId),
        renderSidebarIcon: (0, $4aSHd.getRenderSidebarIcon)(state)
    };
}, {
    setActiveCell: $lMerx.setActiveCell,
    clearActiveItem: $qMUlQ.clear,
    navigateToCell: $4Gq9K.navigateToCell
})((0, $aA0YT.default));

});
parcelRegister("4Gq9K", function(module, exports) {

$parcel$export(module.exports, "NAVIGATE_TO_CELL", () => $a4bcfee053187bc7$export$d4980933cbdb75cc);
$parcel$export(module.exports, "navigateToCell", () => $a4bcfee053187bc7$export$4dc17e9d5bc2fa90);
const $a4bcfee053187bc7$export$d4980933cbdb75cc = 'ops.cells.navigate.NAVIGATE_TO_CELL';
const $a4bcfee053187bc7$export$4dc17e9d5bc2fa90 = (payload)=>({
        type: $a4bcfee053187bc7$export$d4980933cbdb75cc,
        payload: payload
    });

});

parcelRegister("qMUlQ", function(module, exports) {

$parcel$export(module.exports, "CLEAR_ACTIVE_ITEM", () => $9b6195172311c542$export$d63ae865b2dc3e7f);
$parcel$export(module.exports, "clear", () => $9b6195172311c542$export$42ffd38884aecdac);
const $9b6195172311c542$export$d63ae865b2dc3e7f = 'ops.items.active.clear.CLEAR_ACTIVE_ITEM';
const $9b6195172311c542$export$42ffd38884aecdac = ()=>({
        type: $9b6195172311c542$export$d63ae865b2dc3e7f,
        payload: undefined
    });

});

parcelRegister("aA0YT", function(module, exports) {

$parcel$export(module.exports, "default", () => $07b9b3b9d06b33b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $gtzuR = parcelRequire("gtzuR");

var $1ybV0 = parcelRequire("1ybV0");




var $dLC7J = parcelRequire("dLC7J");
const $07b9b3b9d06b33b7$var$getWrapperStyles = (width)=>({
        flex: '0 0 auto',
        width: `${width}px`
    });
const $07b9b3b9d06b33b7$var$NAVIGATION_KEYS = {
    [(0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('up')]: (0, $d090cdd78de8086e$export$b29f845fa4b57508),
    [(0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('right')]: (0, $d090cdd78de8086e$export$1cac5500365a4eb4),
    [(0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('down')]: (0, $d090cdd78de8086e$export$c7c029a231f98d34),
    [(0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('left')]: (0, $d090cdd78de8086e$export$f981f70d61d1405a)
};
// eslint-disable-next-line jira/react/no-class-components
class $07b9b3b9d06b33b7$var$CellWrapper extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isRowTemporary: false,
            isRowHovered: false,
            isRowKeyboardActive: false,
            confirmToNavigate: true
        };
    }
    // remove on clean up of jsm-queue-sidebar-bulk-edit-bug-fix_jx9ff
    constructor(props){
        super(props);
        this.onFocus = ()=>{
            const { rowId: rowId, columnId: columnId, setActiveCell: setActiveCell, isInCellNavigationMode: isInCellNavigationMode } = this.props;
            if (isInCellNavigationMode) setActiveCell({
                type: (0, $a37593d97c1ae333$export$4b3489234fd17200),
                rowId: rowId,
                columnId: columnId
            });
        };
        this.onBlur = ()=>{
            const { clearActiveItem: clearActiveItem, isInCellNavigationMode: isInCellNavigationMode, onCellBlur: onCellBlur } = this.props;
            if (isInCellNavigationMode) clearActiveItem();
            if (this.state.shouldFireOnRowBlur) {
                if (!(0, $1ybV0.ff)('jsm-queue-sidebar-bulk-edit-bug-fix_jx9ff', false)) onCellBlur();
            }
        };
        this.onKeyDown = (event)=>{
            const { confirmToNavigate: confirmToNavigate, isInCellNavigationMode: isInCellNavigationMode, columnId: columnId } = this.props;
            let direction;
            if (!(0, $1ybV0.ff)('jsm-queue-sidebar-bulk-edit-bug-fix_jx9ff', false) && columnId === (0, $c947ad34bf4dc375$export$913055729e1380b2) && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('tab')) {
                this.setState({
                    shouldFireOnRowBlur: false
                });
                setTimeout(()=>this.setState({
                        shouldFireOnRowBlur: true
                    }), 100);
            }
            if (!isInCellNavigationMode) return;
            /* Special handling for enter since it can be ignored */ if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter') && confirmToNavigate) direction = (0, $d090cdd78de8086e$export$c7c029a231f98d34);
            else direction = $07b9b3b9d06b33b7$var$NAVIGATION_KEYS[event.keyCode];
            if (direction) {
                event.preventDefault();
                event.stopPropagation();
                const { rowId: rowId, navigateToCell: navigateToCell } = this.props;
                navigateToCell({
                    rowId: rowId,
                    columnId: columnId,
                    direction: direction
                });
            }
        };
        this.getTargetRef = (div)=>{
            this.targetRef = div;
        };
        this.state = {
            shouldFireOnRowBlur: true
        };
    }
    shouldComponentUpdate(nextProps) {
        return this.props.rowId !== nextProps.rowId || this.props.columnId !== nextProps.columnId || this.props.width !== nextProps.width || this.props.depth !== nextProps.depth || this.props.maxDepth !== nextProps.maxDepth || this.props.activatedFrom !== nextProps.activatedFrom || this.props.isActive !== nextProps.isActive || this.props.shouldHydrateFully !== nextProps.shouldHydrateFully || this.props.isRowHovered !== nextProps.isRowHovered || this.props.isRowKeyboardActive !== nextProps.isRowKeyboardActive || this.props.confirmToNavigate !== nextProps.confirmToNavigate || this.props.activeItemChanged !== nextProps.activeItemChanged || this.props.renderSidebarIcon !== nextProps.renderSidebarIcon;
    }
    componentDidUpdate(prevProps) {
        const { rowId: rowId, columnId: columnId, isActive: isActive, activeItemChanged: activeItemChanged } = this.props;
        if (!prevProps.isActive && isActive) activeItemChanged({
            rowId: rowId,
            columnId: columnId
        });
    }
    render() {
        const { rowId: rowId, width: width, columnId: columnId, activatedFrom: activatedFrom, isActive: isActive, isRowTemporary: isRowTemporary, isRowHovered: isRowHovered, isRowKeyboardActive: isRowKeyboardActive, CellComponent: CellComponent, NonTemporaryCellWrapper: NonTemporaryCellWrapper, onCellMount: onCellMount, canBeMultiLine: canBeMultiLine, shouldHydrateFully: shouldHydrateFully, renderSidebarIcon: renderSidebarIcon } = this.props;
        const onMultiLineCellUpdated = canBeMultiLine ? onCellMount : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        const commonProps = {
            rowId: rowId,
            width: width,
            columnId: columnId,
            activatedFrom: activatedFrom,
            isActive: isActive,
            isRowTemporary: isRowTemporary,
            isRowHovered: isRowHovered,
            isRowKeyboardActive: isRowKeyboardActive,
            onMount: onMultiLineCellUpdated,
            onUpdate: onMultiLineCellUpdated,
            canBeMultiLine: canBeMultiLine,
            shouldHydrateFully: shouldHydrateFully
        };
        /* We just use the wrapping element for bubbling */ if (renderSidebarIcon) {
            const colWidth = width;
            const renderCell = ()=>{
                if (columnId === (0, $c947ad34bf4dc375$export$913055729e1380b2)) {
                    // Leave 60px space for icon summary cells
                    const colAdjust = 60;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dLC7J.CellWithIconIconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dLC7J.RestrictedWidthCell), {
                        width: colWidth - colAdjust
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CellComponent, commonProps)), (isRowHovered || isRowKeyboardActive) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dLC7J.SidebarIcon), null, renderSidebarIcon(rowId)));
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CellComponent, commonProps);
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: this.getTargetRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: $07b9b3b9d06b33b7$var$getWrapperStyles(width),
                onFocus: this.onFocus,
                onBlur: this.onBlur,
                onKeyDown: this.onKeyDown,
                "data-testid": `common.components.virtual-table.table.content.rows.common.cell-wrapper-row${rowId}-${columnId}`,
                role: "presentation"
            }, isRowTemporary || NonTemporaryCellWrapper === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderCell()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NonTemporaryCellWrapper, {
                Cell: CellComponent,
                ...commonProps
            }));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this.getTargetRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $07b9b3b9d06b33b7$var$getWrapperStyles(width),
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            onKeyDown: this.onKeyDown,
            // eslint-disable-next-line jira/integration/enforce-data-testid-usage
            "data-test-id": `common.components.virtual-table.table.content.rows.common.cell-wrapper-row${rowId}-${columnId}`,
            role: "presentation"
        }, isRowTemporary || NonTemporaryCellWrapper === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CellComponent, commonProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NonTemporaryCellWrapper, {
            Cell: CellComponent,
            ...commonProps
        }));
    }
}
var $07b9b3b9d06b33b7$export$2e2bcd8739ae039 = $07b9b3b9d06b33b7$var$CellWrapper;

});
parcelRegister("gtzuR", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});

const $d090cdd78de8086e$export$b29f845fa4b57508 = 'UP';
const $d090cdd78de8086e$export$c7c029a231f98d34 = 'DOWN';
const $d090cdd78de8086e$export$f981f70d61d1405a = 'LEFT';
const $d090cdd78de8086e$export$1cac5500365a4eb4 = 'RIGHT';

parcelRegister("dLC7J", function(module, exports) {

$parcel$export(module.exports, "CellWithIconIconWrapper", () => $08f548fe3b22f124$export$5512dcd0dcc8c03b);
$parcel$export(module.exports, "RestrictedWidthCell", () => $08f548fe3b22f124$export$d401bcca6458918c);
$parcel$export(module.exports, "SidebarIcon", () => $08f548fe3b22f124$export$bbd31c05825b0e6c);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $bAQOb = parcelRequire("bAQOb");
const $08f548fe3b22f124$export$5512dcd0dcc8c03b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $08f548fe3b22f124$export$d401bcca6458918c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1hdq",
            __cmplp.className
        ])
    });
});
const $08f548fe3b22f124$var$SidebarIconOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _2hwxpxbi _19pku2gc",
            __cmplp.className
        ])
    });
});
const $08f548fe3b22f124$var$SidebarIconNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $08f548fe3b22f124$export$bbd31c05825b0e6c = (0, $bAQOb.componentWithFF)('jsm-queue-sidebar-bug-fixes-second-round_xuenh', $08f548fe3b22f124$var$SidebarIconNew, $08f548fe3b22f124$var$SidebarIconOld);

});



parcelRegister("bCfUf", function(module, exports) {

$parcel$export(module.exports, "default", () => $448009683b5b1329$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $01OF3 = parcelRequire("01OF3");

var $8gueX = parcelRequire("8gueX");

var $jOPvQ = parcelRequire("jOPvQ");
var $448009683b5b1329$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state)=>({
        columnsToIgnore: (0, $01OF3.getPremiumSLAColumns)(state),
        ErrorInlineMessage: $8gueX.default
    }), {})((0, $jOPvQ.ConditionalErrorBoundary));

});
parcelRegister("8gueX", function(module, exports) {

$parcel$export(module.exports, "default", () => $aadd3eebf12fe7f3$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $4Bkxm = parcelRequire("4Bkxm");

var $dJeLK = parcelRequire("dJeLK");
var $aadd3eebf12fe7f3$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state, { columnId: columnId })=>({
        columnWidth: (0, $4Bkxm.getColumnMinWidth)(state, columnId)
    }), {})((0, $dJeLK.ErrorInlineMessage));

});
parcelRegister("dJeLK", function(module, exports) {

$parcel$export(module.exports, "ErrorInlineMessage", () => $2ee69f3391c077d5$export$ffbab3d811b5160b);

var $eUqFw = parcelRequire("eUqFw");

var $6zOB7 = parcelRequire("6zOB7");

var $jOdsB = parcelRequire("jOdsB");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $iwyd2 = parcelRequire("iwyd2");
const $2ee69f3391c077d5$export$ffbab3d811b5160b = ({ columnWidth: columnWidth })=>{
    const onClick = (0, $eUqFw.useCallback)(()=>window.location.reload(), []);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: "space.100",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $1ZAYh.xcss)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${columnWidth}px`
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jOdsB.default), {
        appearance: "error",
        iconLabel: formatMessage((0, $iwyd2.default).errorFlagText)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingInlineStart: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iwyd2.default).errorFlagText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "subtle",
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $1ZAYh.xcss)({
            color: 'color.text.accent.blue'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iwyd2.default).errorFlagLinkText))))));
};

});
parcelRegister("jOdsB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ceaa73c399a515a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7u4fN = parcelRequire("7u4fN");

var $29yDk = parcelRequire("29yDk");

var $9Amv1 = parcelRequire("9Amv1");
var $1Yimi = parcelRequire("1Yimi");


var $kDL8j = parcelRequire("kDL8j");
function $2ceaa73c399a515a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2ceaa73c399a515a$var$rootStyles = {
    name: "ssyr0c",
    styles: "display:inline-block;max-width:100%;&:focus{outline:1px solid;}&:hover{[data-ds--inline-message--icon]{color:var(--icon-accent-color);}[data-ds--inline-message--button]{text-decoration:underline;}}"
};
const $2ceaa73c399a515a$var$iconColor = (appearance)=>{
    switch(appearance){
        case 'connectivity':
            return `var(--ds-icon-brand, ${0, $73a5c9d720aa66e1$export$e62e8919cca44969})`;
        case 'confirmation':
            return `var(--ds-icon-success, ${0, $73a5c9d720aa66e1$export$747d86715d4175de})`;
        case 'info':
            return `var(--ds-icon-discovery, ${0, $73a5c9d720aa66e1$export$a7175d4e9206bc80})`;
        case 'warning':
            return `var(--ds-icon-warning, ${0, $73a5c9d720aa66e1$export$5aae31392d72caaa})`;
        case 'error':
            return `var(--ds-icon-danger, ${0, $73a5c9d720aa66e1$export$4a7404f376229999})`;
    }
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ const $2ceaa73c399a515a$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', type: type = 'connectivity', appearance: appearance, children: children, testId: testId, iconLabel: iconLabel })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const toggleDialog = (0, $eUqFw.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $eUqFw.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    if (!appearance) appearance = type;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $2ceaa73c399a515a$var$rootStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            '--icon-accent-color': $2ceaa73c399a515a$var$iconColor(appearance)
        },
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $29yDk.default), {
        onClose: onCloseDialog,
        content: children,
        isOpen: isOpen,
        placement: placement,
        testId: testId && `${testId}--inline-dialog`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        "data-ds--inline-message--button": true,
        appearance: "subtle-link",
        onClick: toggleDialog,
        spacing: "none",
        testId: testId && `${testId}--button`,
        "aria-expanded": isOpen
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kDL8j.default), {
        isOpen: isOpen,
        appearance: appearance,
        label: iconLabel
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.100"
    }, title && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        weight: "medium",
        testId: testId && `${testId}--title`
    }, title), secondaryText && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        weight: "medium",
        color: "color.text.subtlest",
        maxLines: 1,
        testId: testId && `${testId}--text`
    }, secondaryText))))));
};
var $2ceaa73c399a515a$export$2e2bcd8739ae039 = $2ceaa73c399a515a$var$InlineMessage;

});
parcelRegister("kDL8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b39338dc4e2b071$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");


var $kAPh5 = parcelRequire("kAPh5");
function $2b39338dc4e2b071$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2b39338dc4e2b071$var$iconColor = (appearance)=>{
    switch(appearance){
        case 'connectivity':
            return `var(--ds-icon-brand, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
        case 'confirmation':
            return `var(--ds-icon-success, ${0, $73a5c9d720aa66e1$export$940e1f69e873f202})`;
        case 'info':
            return `var(--ds-icon-discovery, ${0, $73a5c9d720aa66e1$export$b48405b95304b5a1})`;
        case 'warning':
            return `var(--ds-icon-warning, ${0, $73a5c9d720aa66e1$export$c6930421db9fa514})`;
        case 'error':
            return `var(--ds-icon-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
    }
};
const $2b39338dc4e2b071$var$iconWrapperStyles = {
    name: "kw6wgo",
    styles: "display:flex;align-items:center;flex:0 0 auto;color:var(--icon-color)"
};
const $2b39338dc4e2b071$var$iconColorStyles = {
    name: "1iy94md",
    styles: "color:var(--icon-accent-color)"
};
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ const $2b39338dc4e2b071$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $kAPh5.typesMapping);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-ds--inline-message--icon": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            '--icon-color': $2b39338dc4e2b071$var$iconColor(appearance)
        },
        css: [
            $2b39338dc4e2b071$var$iconWrapperStyles,
            isOpen && $2b39338dc4e2b071$var$iconColorStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
        testId: "inline-message-icon",
        label: label || defaultLabel,
        size: "medium"
    }));
};
var $2b39338dc4e2b071$export$2e2bcd8739ae039 = $2b39338dc4e2b071$var$SelectedIcon;

});
parcelRegister("kAPh5", function(module, exports) {

$parcel$export(module.exports, "typesMapping", () => $6da7ad19346443c2$export$4d111645c0b39d5d);

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");

var $2bv8J = parcelRequire("2bv8J");

var $5YsMl = parcelRequire("5YsMl");
const $6da7ad19346443c2$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($96IgR))),
        defaultLabel: 'error inline message'
    }
};

});



parcelRegister("iwyd2", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc0a6e250860b704$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cc0a6e250860b704$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorFlagText: {
        "id": "virtual-table.table.content.rows.common.conditional-error-boundary.error-inline-message.error-flag-text",
        "defaultMessage": "We're having trouble loading this data. Try again later or contact Atlassian support."
    },
    errorFlagLinkText: {
        "id": "virtual-table.table.content.rows.common.conditional-error-boundary.error-inline-message.error-flag-link-text",
        "defaultMessage": "Reload"
    }
});

});



parcelRegister("jOPvQ", function(module, exports) {

$parcel$export(module.exports, "ConditionalErrorBoundary", () => $6d195dbac191410f$export$6465e24fd5df7a56);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");
const $6d195dbac191410f$export$6465e24fd5df7a56 = ({ children: children, columnId: columnId, columnsToIgnore: columnsToIgnore, ErrorInlineMessage: ErrorInlineMessage })=>!columnsToIgnore?.includes(columnId) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "virtual-table-row-additional-column",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ErrorInlineMessage, {
                columnId: columnId
            })
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);

});


parcelRegister("bnrbB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3a28aea3024a2e8$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $01OF3 = parcelRequire("01OF3");

var $f5bbs = parcelRequire("f5bbs");

var $5jaaH = parcelRequire("5jaaH");

var $cWmBu = parcelRequire("cWmBu");
var $b3a28aea3024a2e8$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state, { rowId: rowId })=>({
        maxDepth: (0, $f5bbs.getMaxDepth)(state),
        rowDepth: (0, $5jaaH.getRowDepth)(state, rowId),
        isRowExpanded: (0, $f5bbs.isRowExpanded)(state, rowId),
        rowHasChildren: (0, $f5bbs.getRowHasChildren)(state, rowId),
        isAddEnabled: (0, $5jaaH.isGlobalAddEnabled)(state) && (0, $f5bbs.getRowCanAddChildren)(state, rowId),
        onRowExpansionChangeRequested: (0, $01OF3.getRowExpansionCallback)(state),
        onRowAddRequested: (0, $01OF3.getRowAddCallback)(state)
    }), {})((0, $cWmBu.default));

});
parcelRegister("cWmBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $3acab12d0575ddf3$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ 
var $eUqFw = parcelRequire("eUqFw");

var $gO9Xw = parcelRequire("gO9Xw");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");


var $90IgZ = parcelRequire("90IgZ");

var $giAhk = parcelRequire("giAhk");

var $6pOL1 = parcelRequire("6pOL1");

var $ajzlS = parcelRequire("ajzlS");
const $3acab12d0575ddf3$var$messages = (0, $90IgZ.defineMessages)({
    collapseIcon: {
        "id": "virtual-table.table.content.rows.common.default-row.content.child-operation-indicator.collapse-icon",
        "defaultMessage": "Click to collapse row"
    },
    expandIcon: {
        "id": "virtual-table.table.content.rows.common.default-row.content.child-operation-indicator.expand-icon",
        "defaultMessage": "Click to expand row"
    },
    addIcon: {
        "id": "virtual-table.table.content.rows.common.default-row.content.child-operation-indicator.add-icon",
        "defaultMessage": "Click to add row"
    }
});
const $3acab12d0575ddf3$var$baseIndicatorStyles = {
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'center',
    alignItems: 'center',
    color: (0, $73a5c9d720aa66e1$exports).N70
};
const $3acab12d0575ddf3$var$interactiveIndicatorStyles = {
    ...$3acab12d0575ddf3$var$baseIndicatorStyles,
    width: `${(0, $ajzlS.childrenOperationIndicatorWidth)}px`,
    cursor: 'pointer'
};
const $3acab12d0575ddf3$var$getDefaultIndicatorStyles = (isMaxDepth, theme)=>({
        ...$3acab12d0575ddf3$var$baseIndicatorStyles,
        width: `${isMaxDepth ? theme.row.maxDepthChildrenOperationIndicatorWidth : (0, $ajzlS.childrenOperationIndicatorWidth)}px`
    });
const $3acab12d0575ddf3$var$getAddIndicatorWrapperStyles = (isRowHovered)=>({
        height: '16px',
        width: '16px',
        visibility: isRowHovered ? 'visible' : 'hidden'
    });
class $3acab12d0575ddf3$export$20869452acc58b2a extends (0, $eUqFw.Component) {
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { rowHasChildren: rowHasChildren, isRowExpanded: isRowExpanded } = this.props;
        /* A row that had children but now has none SHOULD NOT be expanded.
     * The general use case for this is cancelling an add operation, where the
     * temporary row was the only child. As cancelling can occur from internal or
     * external to the table, this is the only way to ensure this behaviour.
     */ if (rowHasChildren && !nextProps.rowHasChildren && isRowExpanded) this.onCollapse();
    }
    shouldComponentUpdate(nextProps) {
        const { rowId: rowId, rowDepth: rowDepth, maxDepth: maxDepth, isRowExpanded: isRowExpanded, isRowHovered: isRowHovered, isRowKeyboardActive: isRowKeyboardActive, rowHasChildren: rowHasChildren, isAddEnabled: isAddEnabled } = this.props;
        return rowId !== nextProps.rowId || rowDepth !== nextProps.rowDepth || maxDepth !== nextProps.maxDepth || isRowExpanded !== nextProps.isRowExpanded || isRowHovered !== nextProps.isRowHovered || isRowKeyboardActive !== nextProps.isRowKeyboardActive || rowHasChildren !== nextProps.rowHasChildren || isAddEnabled !== nextProps.isAddEnabled;
    }
    renderCollapseIndicator() {
        const { intl: { formatMessage: formatMessage }, rowId: rowId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: $3acab12d0575ddf3$var$interactiveIndicatorStyles,
            onClick: this.onCollapse,
            // eslint-disable-next-line jira/integration/enforce-data-testid-usage
            "data-test-id": `common.components.virtual-table.table.content.rows.common.default-row.content.child-operation-indicator.collapse-${rowId}`,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && this.onCollapse,
            role: "button",
            tabIndex: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            size: "small",
            label: formatMessage($3acab12d0575ddf3$var$messages.collapseIcon)
        }));
    }
    renderExpandIndicator() {
        const { intl: { formatMessage: formatMessage }, rowId: rowId } = this.props;
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: $3acab12d0575ddf3$var$interactiveIndicatorStyles,
            onClick: this.onExpand,
            // eslint-disable-next-line jira/integration/enforce-data-testid-usage
            "data-test-id": `common.components.virtual-table.table.content.rows.common.default-row.content.child-operation-indicator.expand-${rowId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
            size: "small",
            label: formatMessage($3acab12d0575ddf3$var$messages.expandIcon)
        })));
    }
    renderAddIndicator() {
        const { intl: { formatMessage: formatMessage }, isRowHovered: isRowHovered, rowId: rowId } = this.props;
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: $3acab12d0575ddf3$var$interactiveIndicatorStyles,
            onClick: this.onRowAddRequested,
            // eslint-disable-next-line jira/integration/enforce-data-testid-usage
            "data-test-id": `common.components.virtual-table.table.content.rows.common.default-row.content.child-operation-indicator.add-${rowId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: $3acab12d0575ddf3$var$getAddIndicatorWrapperStyles(isRowHovered)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
            size: "small",
            label: formatMessage($3acab12d0575ddf3$var$messages.addIcon)
        }))));
    }
    render() {
        const { maxDepth: maxDepth, rowDepth: rowDepth, rowHasChildren: rowHasChildren, isRowExpanded: isRowExpanded, isAddEnabled: isAddEnabled, theme: theme } = this.props;
        const isMaxDepth = rowDepth === maxDepth;
        if (!isMaxDepth) {
            if (rowHasChildren) {
                if (isRowExpanded) return this.renderCollapseIndicator();
                return this.renderExpandIndicator();
            }
            if (isAddEnabled) return this.renderAddIndicator();
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: $3acab12d0575ddf3$var$getDefaultIndicatorStyles(isMaxDepth, theme)
        });
    }
    constructor(...args){
        super(...args);
        this.onExpand = ()=>{
            const { rowId: rowId, onRowExpansionChangeRequested: onRowExpansionChangeRequested } = this.props;
            onRowExpansionChangeRequested({
                rowId: rowId,
                shouldExpand: true
            });
        };
        this.onCollapse = ()=>{
            const { rowId: rowId, onRowExpansionChangeRequested: onRowExpansionChangeRequested } = this.props;
            onRowExpansionChangeRequested({
                rowId: rowId,
                shouldExpand: false
            });
        };
        this.onRowAddRequested = ()=>{
            const { rowId: rowId, onRowAddRequested: onRowAddRequested } = this.props;
            onRowAddRequested && onRowAddRequested({
                anchorId: rowId,
                position: 'INSIDE'
            });
        };
    }
}
var $3acab12d0575ddf3$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $6pOL1.withTheme)($3acab12d0575ddf3$export$20869452acc58b2a));

});


parcelRegister("euRxp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e412b41ca475755$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $eGI9v = parcelRequire("eGI9v");

var $1ybV0 = parcelRequire("1ybV0");

var $6pOL1 = parcelRequire("6pOL1");
const $5e412b41ca475755$var$getWrapperStyles = (backgroundColor, theme)=>{
    const style = {
        display: 'flex',
        boxSizing: 'border-box',
        borderTop: `${theme.row.borderWidth}px solid ${theme.row.borderColor}`,
        borderBottom: `${theme.row.borderWidth}px solid ${theme.row.borderColor}`,
        height: theme.row.height,
        minHeight: theme.row.minHeight,
        marginLeft: '0px',
        boxShadow: 'none'
    };
    if (theme.row.useCssHover) return style;
    return {
        ...style,
        backgroundColor: backgroundColor
    };
};
// eslint-disable-next-line jira/react/no-class-components
class $5e412b41ca475755$var$RowContent extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.onMouseEnter = ()=>{
            if (!this.props.theme.row.useCssHover || (this.props.shouldRerenderRowOnHover ?? false)) this.setState({
                isHovered: true
            });
        };
        this.onMouseLeave = ()=>{
            if (!this.props.theme.row.useCssHover || (this.props.shouldRerenderRowOnHover ?? false)) this.setState({
                isHovered: false
            });
        };
        // remove on clean up of jsm-queue-sidebar-bulk-edit-bug-fix_jx9ff
        this.onFocus = ()=>{
            this.setState({
                isKeyboardActive: true
            });
        };
        // remove on clean up of jsm-queue-sidebar-bulk-edit-bug-fix_jx9ff
        this.setKeyboardInactive = ()=>{
            this.setState({
                isKeyboardActive: false
            });
        };
        this.setRef = (el)=>{
            this.ref = el;
        };
        this.recalculateHeight = ()=>{
            const { id: id, onRowContentUpdate: onRowContentUpdate } = this.props;
            if (this.ref && onRowContentUpdate) onRowContentUpdate(id, this.ref.getBoundingClientRect().height);
        };
        this.state = {
            isHovered: false,
            isKeyboardActive: false,
            render: !props.coreColumnIds.length
        };
        this.beginTime = Date.now();
    }
    componentDidMount() {
        const { onRowContentMount: onRowContentMount, coreColumnIds: coreColumnIds, additionalColumnIds: additionalColumnIds } = this.props;
        if (!this.state.render) this.timeoutId = setTimeout(()=>this.setState({
                render: true
            }), 16);
        this.recalculateHeight();
        // @ts-expect-error - TS2769 - No overload matches this call.
        const allColumns = [].concat(coreColumnIds, additionalColumnIds);
        onRowContentMount && onRowContentMount(this.beginTime, Date.now(), allColumns, allColumns.length);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.state.render !== nextState.render || this.state.isHovered !== nextState.isHovered || this.state.isKeyboardActive !== nextState.isKeyboardActive || this.props.id !== nextProps.id || this.props.isActive !== nextProps.isActive || this.props.coreColumnIds !== nextProps.coreColumnIds || this.props.additionalColumnIds !== nextProps.additionalColumnIds;
    }
    componentWillUnmount() {
        clearTimeout(this.timeoutId);
    }
    determineRowColor(isActive, isHovered) {
        if (isHovered) return this.props.theme.row.hoveredColor;
        if (isActive) return this.props.theme.row.activeColor;
        return (0, $73a5c9d720aa66e1$exports).N0;
    }
    renderChildOperationIndicator() {
        const { id: id, RowChildOperationIndicator: RowChildOperationIndicator, isActive: isActive, ConditionalErrorBoundary: ConditionalErrorBoundary } = this.props;
        const { isHovered: isHovered, isKeyboardActive: isKeyboardActive } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ConditionalErrorBoundary, {
            columnId: "child-operation-indicator"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(RowChildOperationIndicator, {
            rowId: id,
            isRowHovered: isHovered,
            isRowKeyboardActive: (0, $1ybV0.ff)('jsm-queue-sidebar-bulk-edit-bug-fix_jx9ff', false) ? isActive : isKeyboardActive
        }));
    }
    renderCoreColumns() {
        const { id: id, coreColumnIds: coreColumnIds, CellWrapper: CellWrapper, isActive: isActive, ConditionalErrorBoundary: ConditionalErrorBoundary } = this.props;
        const { isHovered: isHovered, isKeyboardActive: isKeyboardActive } = this.state;
        return coreColumnIds.map((columnId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ConditionalErrorBoundary, {
                key: `${columnId}-${id}`,
                columnId: columnId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CellWrapper, {
                key: columnId,
                rowId: id,
                columnId: columnId,
                isRowHovered: isHovered,
                isRowKeyboardActive: (0, $1ybV0.ff)('jsm-queue-sidebar-bulk-edit-bug-fix_jx9ff', false) ? isActive : isKeyboardActive,
                onCellBlur: this.setKeyboardInactive,
                onCellMount: this.recalculateHeight
            })));
    }
    renderAdditionalColumns() {
        const { id: id, additionalColumnIds: additionalColumnIds, AdditionalColumnsContainer: AdditionalColumnsContainer, CellWrapper: CellWrapper, isActive: isActive, ConditionalErrorBoundary: ConditionalErrorBoundary } = this.props;
        const { isHovered: isHovered, isKeyboardActive: isKeyboardActive } = this.state;
        return additionalColumnIds.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AdditionalColumnsContainer, null, additionalColumnIds.map((columnId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ConditionalErrorBoundary, {
                key: `${columnId}-${id}`,
                columnId: columnId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CellWrapper, {
                key: columnId,
                rowId: id,
                columnId: columnId,
                isRowHovered: isHovered,
                isRowKeyboardActive: (0, $1ybV0.ff)('jsm-queue-sidebar-bulk-edit-bug-fix_jx9ff', false) ? isActive : isKeyboardActive,
                onCellBlur: this.setKeyboardInactive,
                onCellMount: this.recalculateHeight
            })))) : null;
    }
    render() {
        const { isActive: isActive, theme: theme } = this.props;
        const { isHovered: isHovered } = this.state;
        const color = this.determineRowColor(isActive, isHovered);
        return this.state.render ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "virtual-table-row",
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave,
            onFocus: (0, $1ybV0.ff)('jsm-queue-sidebar-bulk-edit-bug-fix_jx9ff', false) ? undefined : this.onFocus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this.setRef,
            // @ts-expect-error - TS2322 - Type '{ display: string; boxSizing: string; borderTop: string; borderBottom: string; height: string; minHeight: string; marginLeft: string; boxShadow: string; } | { backgroundColor: string; display: string; ... 6 more ...; boxShadow: string; }' is not assignable to type 'CSSProperties | undefined'.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $5e412b41ca475755$var$getWrapperStyles(color, theme)
        }, this.renderChildOperationIndicator(), this.renderCoreColumns(), this.renderAdditionalColumns())) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "virtual-table-row",
            // @ts-expect-error - TS2322 - Type '{ display: string; boxSizing: string; borderTop: string; borderBottom: string; height: string; minHeight: string; marginLeft: string; boxShadow: string; } | { backgroundColor: string; display: string; ... 6 more ...; boxShadow: string; }' is not assignable to type 'CSSProperties | undefined'.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $5e412b41ca475755$var$getWrapperStyles(color, theme)
        }, this.renderChildOperationIndicator(), this.renderCoreColumns());
    }
}
var $5e412b41ca475755$export$2e2bcd8739ae039 = (0, $eGI9v.default)('virtualTableRows', {
    onRowContentMount: 'mounted'
})((0, $6pOL1.withTheme)($5e412b41ca475755$var$RowContent));

});


parcelRegister("bYyCW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a150beb2d1879929$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $eGI9v = parcelRequire("eGI9v");

var $6pOL1 = parcelRequire("6pOL1");

var $IxOJr = parcelRequire("IxOJr");
// regarding height & overflow:
// we set the height here to reduce positioning complexity.
// otherwise we need to consider the add bar and its' visibility
// while offsetting margins on the row
const $a150beb2d1879929$var$getOuterWrapperStyles = (isSelected)=>({
        ...isSelected ? {
            backgroundColor: `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$exports).B50})`
        } : {},
        marginLeft: "var(--ds-space-0, 0)",
        outline: 'none'
    });
const $a150beb2d1879929$var$getContentWrapperStyles = ()=>({
        height: 'auto',
        minHeight: "var(--ds-space-500, 40px)",
        overflow: 'hidden',
        marginTop: "var(--ds-space-0, 0)",
        borderRadius: "var(--ds-space-050, 4px)",
        flexGrow: 1
    });
// The following styles create a faux absolute element with the height and width of its flex(direction row) parent.
// We cannot use position relative on OuterWrapper as elements in virtual-table-row-list-portal
// depend on a relative parent at the table level.
const $a150beb2d1879929$var$rowHighlightWrapperStyles = {
    position: 'relative',
    flexShrink: 0,
    width: '100%',
    marginLeft: '-100%',
    transform: 'translateX(100%)',
    pointerEvents: 'none'
};
// eslint-disable-next-line jira/react/no-class-components
class $a150beb2d1879929$var$DefaultRow extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.myRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.state = {
            render: false
        };
    }
    componentDidMount() {
        this.timeoutId = setTimeout(()=>this.setState({
                render: true
            }), 250); // we render the AddBar quite delayed as it will only be visible when hovered
        if (this.props.isActiveItem && this.myRef.current) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.focus();
        this.myRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.addEventListener('focusin', this.props.onFocusCallback);
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { id: id, isActiveItem: isActiveItem, isRowHighlighted: isRowHighlighted, isRowLeftEdgeVisible: isRowLeftEdgeVisible, isRowRightEdgeVisible: isRowRightEdgeVisible, isSelected: isSelected } = this.props;
        return id !== nextProps.id || this.state.render !== nextState.render || isActiveItem !== nextProps.isActiveItem || isRowHighlighted !== nextProps.isRowHighlighted || isRowLeftEdgeVisible !== nextProps.isRowLeftEdgeVisible || isRowRightEdgeVisible !== nextProps.isRowRightEdgeVisible || isSelected !== nextProps.isSelected;
    }
    componentDidUpdate(prevProps) {
        if (this.props.isActiveItem && !prevProps.isActiveItem && this.myRef.current && this.props.setFocusOnRow) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.focus();
    }
    componentWillUnmount() {
        clearTimeout(this.timeoutId);
        this.myRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.removeEventListener('focusin', this.props.onFocusCallback);
    }
    render() {
        const { id: id, isRowHighlighted: isRowHighlighted, isRowLeftEdgeVisible: isRowLeftEdgeVisible, isRowRightEdgeVisible: isRowRightEdgeVisible, isGlobalAddEnabled: isGlobalAddEnabled, AddBar: AddBar, Content: Content, theme: theme, onClick: onClick, onRowContentMount: onRowContentMount, onRowContentUpdate: onRowContentUpdate, isSelected: isSelected } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // @ts-expect-error - TS2322 - Type 'RefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
            ref: this.myRef,
            onClick: onClick,
            role: "presentation",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $a150beb2d1879929$var$getOuterWrapperStyles(isSelected),
            tabIndex: -1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                display: 'flex'
            }
        }, isRowHighlighted && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: $a150beb2d1879929$var$rowHighlightWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $IxOJr.RowHighlight), {
            theme: theme,
            isRowLeftEdgeVisible: isRowLeftEdgeVisible,
            isRowRightEdgeVisible: isRowRightEdgeVisible
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: $a150beb2d1879929$var$getContentWrapperStyles()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Content, {
            id: id,
            onRowContentMount: onRowContentMount,
            onRowContentUpdate: onRowContentUpdate
        }))), isGlobalAddEnabled && this.state.render && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AddBar, {
            rowId: id
        }));
    }
}
var $a150beb2d1879929$export$2e2bcd8739ae039 = (0, $eGI9v.default)('rowItem', {
    onClick: 'clicked'
})((0, $6pOL1.withTheme)($a150beb2d1879929$var$DefaultRow));

});
parcelRegister("IxOJr", function(module, exports) {

$parcel$export(module.exports, "getWidth", () => $641c3f874fb13510$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "RowHighlight", () => $641c3f874fb13510$export$c5433d3086f82ff8);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $ajzlS = parcelRequire("ajzlS");
const $641c3f874fb13510$export$85ae013617b39492 = ({ width: width, isFirstColumn: isFirstColumn })=>`
    width: ${isFirstColumn ? width + (0, $ajzlS.levelIndentBaseline) : width}px;
`;
const $641c3f874fb13510$export$3c49c185de0c2bfc = ({ width: width, isFirstColumn: isFirstColumn })=>`${isFirstColumn ? width + (0, $ajzlS.levelIndentBaseline) : width}px`;
const $641c3f874fb13510$export$c5433d3086f82ff8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isRowRightEdgeVisible: isRowRightEdgeVisible, theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_pbz34m": (0, $9t7rW.default)(__cmplp.isRowRightEdgeVisible ? 0 : "var(--ds-space-negative-100, -8px)"),
            "--_5kefb9": (0, $9t7rW.default)(__cmplp.theme.row.borderRadius)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154ix0bf _1xi2idpf _94n5x0bf _1ltvidpf _lcxvglyw _18postnw _15l2idpf _32rx14cd _1x88idpf _19doidpf _eq431l7n _14mj1rr2 _aetrb3bt _11fnglyw _1bqqkb7n _j9jr1w01",
            __cmplp.isRowRightEdgeVisible ? "_1reoewfl _18m9ewfl" : "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});



parcelRegister("aJitp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8d54c9f946a381a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $jMP2a = parcelRequire("jMP2a");

class $f8d54c9f946a381a$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.onFocusCallback = ()=>{
            const { isInRowNavigationMode: isInRowNavigationMode, onSetActiveRow: onSetActiveRow, rowIndex: rowIndex } = this.props;
            if (isInRowNavigationMode) onSetActiveRow({
                rowIndex: rowIndex
            });
        };
        this.onClick = (event, analyticsEvent)=>{
            this.props.onSetActiveRow({
                rowIndex: this.props.rowIndex
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'click', {
                rowIndex: this.props.rowIndex
            });
        };
        this.state = {
            delayRender: props.delayRowRenderOnScroll
        };
    }
    componentDidMount() {
        if (this.state.delayRender) setTimeout(()=>this.setState({
                delayRender: false
            }), 16);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.id !== nextProps.id || this.props.isInCreation !== nextProps.isInCreation || this.state.delayRender !== nextState.delayRender || this.props.rowIndex !== nextProps.rowIndex;
    }
    render() {
        const { id: id, isInCreation: isInCreation, isLoading: isLoading, rowIndex: rowIndex, onLoadingRowUnmount: onLoadingRowUnmount, NewRow: NewRow, LoadingRow: LoadingRow, onRowContentMount: onRowContentMount, onRowContentUpdate: onRowContentUpdate, DefaultRow: DefaultRow } = this.props;
        if (isInCreation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NewRow, {
            id: id
        });
        if (LoadingRow && (isLoading || this.state.delayRender)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadingRow, {
            id: id,
            onClick: this.onClick,
            onUnmount: isLoading || this.state.delayRender ? onLoadingRowUnmount : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            reasonType: isLoading ? (0, $7872bfc970cd976d$export$a63dec0667c2f97a) : (0, $7872bfc970cd976d$export$456b4a90eb507580),
            rowIndex: rowIndex,
            onRowContentUpdate: onRowContentUpdate,
            onFocusCallback: this.onFocusCallback
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DefaultRow, {
            id: id,
            onClick: this.onClick,
            onRowContentMount: onRowContentMount,
            onRowContentUpdate: onRowContentUpdate,
            onFocusCallback: this.onFocusCallback
        });
    }
}

});

parcelRegister("lidr9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3885834e46308b1$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");


var $qMUlQ = parcelRequire("qMUlQ");

var $lMerx = parcelRequire("lMerx");

var $fCOY6 = parcelRequire("fCOY6");

var $01OF3 = parcelRequire("01OF3");

var $4Bkxm = parcelRequire("4Bkxm");

var $f5bbs = parcelRequire("f5bbs");

var $5jaaH = parcelRequire("5jaaH");

var $dHcAn = parcelRequire("dHcAn");

var $M9G4y = parcelRequire("M9G4y");

var $1MB23 = parcelRequire("1MB23");
var $f3885834e46308b1$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state, { id: id })=>({
        depth: (0, $5jaaH.getRowDepth)(state, id),
        maxDepth: (0, $f5bbs.getMaxDepth)(state),
        status: (0, $f5bbs.getRowAddingStatus)(state, id),
        coreColumnIds: (0, $4Bkxm.getVisibleCoreColumnIds)(state),
        additionalColumnIds: (0, $01OF3.getVisibleAdditionalColumnIds)(state),
        defaultAddColumnId: (0, $01OF3.getDefaultAddColumnId)(state),
        isActive: (0, $5jaaH.isActiveRowId)(state, id),
        onPersistAddedRowRequested: (0, $01OF3.getPersistAddedRowCallback)(state),
        onCancelAddedRowRequested: (0, $01OF3.getCancelAddedRowCallback)(state),
        navigationMode: (0, $01OF3.getNavigationMode)(state),
        AdditionalColumnsContainer: $dHcAn.default,
        CellWrapper: $M9G4y.default
    }), {
    setActiveCell: $lMerx.setActiveCell,
    clearActiveItem: $qMUlQ.clear,
    setMultiAddAnchor: $fCOY6.set
}, // @ts-expect-error - TS7031 - Binding element 'defaultAddColumnId' implicitly has an 'any' type.
({ defaultAddColumnId: defaultAddColumnId, ...stateProps }, dispatchProps, ownProps)=>({
        ...ownProps,
        ...stateProps,
        setMultiAddAnchor: dispatchProps.setMultiAddAnchor,
        setActiveItem: ()=>{
            if (0, $a37593d97c1ae333$export$9e9986b7abe95577) dispatchProps.setActiveCell({
                type: (0, $a37593d97c1ae333$export$4b3489234fd17200),
                rowId: ownProps.id,
                columnId: defaultAddColumnId
            });
            else if (0, $a37593d97c1ae333$export$a01cd8e028b3d34f) dispatchProps.setActiveRow({
                type: (0, $a37593d97c1ae333$export$8a257aa81ef4a9e0),
                rowIndex: ownProps.rowIndex
            });
        },
        clearActiveItem: dispatchProps.clearActiveItem
    }))((0, $1MB23.default));

});
parcelRegister("fCOY6", function(module, exports) {

$parcel$export(module.exports, "SET_MULTI_ADD_ANCHOR", () => $074e99656d2587e8$export$45d5c36be62dcf8e);
$parcel$export(module.exports, "set", () => $074e99656d2587e8$export$adaa4cf7ef1b65be);
const $074e99656d2587e8$export$45d5c36be62dcf8e = 'ops.rows.add-anchor.set.SET_MULTI_ADD_ANCHOR';
const $074e99656d2587e8$export$adaa4cf7ef1b65be = (rowId)=>({
        type: $074e99656d2587e8$export$45d5c36be62dcf8e,
        payload: rowId
    });

});

parcelRegister("1MB23", function(module, exports) {

$parcel$export(module.exports, "default", () => $052ecbea1c183703$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gtzuR = parcelRequire("gtzuR");


var $6pOL1 = parcelRequire("6pOL1");

var $ajzlS = parcelRequire("ajzlS");
// eslint-disable-next-line jira/react/no-class-components
class $052ecbea1c183703$var$NewRow extends (0, $eUqFw.PureComponent) {
    componentDidMount() {
        const { status: status, setActiveItem: setActiveItem } = this.props;
        if (status === 'NEW') setActiveItem();
    }
    componentDidUpdate(prevProps) {
        const { id: id, status: status, isActive: isActive, onPersistAddedRowRequested: onPersistAddedRowRequested } = this.props;
        if (prevProps.isActive && !isActive && status === 'NEW') onPersistAddedRowRequested(id);
    }
    componentWillUnmount() {
        /* If we are navigating by Cell.
     * All cells in a new row will be unmounted with it, stopping the clear callback from occurring.
     * This means anyone subscribing to the currently active cell may still refer to the temporary cells id,
     * even when that temporary value has been resolved into a "real" one.
     * We would not want to do this in the cell wrapper, as the problem does not exist for other rows, and could
     * cause side-effects.
     */ this.props.clearActiveItem();
    }
    renderCoreColumns() {
        const { id: id, coreColumnIds: coreColumnIds, CellWrapper: CellWrapper } = this.props;
        return coreColumnIds.map((columnId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CellWrapper, {
                key: columnId,
                rowId: id,
                columnId: columnId,
                isRowTemporary: true,
                confirmToNavigate: false
            }));
    }
    renderAdditionalColumns() {
        const { id: id, additionalColumnIds: additionalColumnIds, AdditionalColumnsContainer: AdditionalColumnsContainer, CellWrapper: CellWrapper } = this.props;
        return additionalColumnIds.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AdditionalColumnsContainer, null, additionalColumnIds.map((columnId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CellWrapper, {
                key: columnId,
                rowId: id,
                columnId: columnId,
                isRowTemporary: true,
                confirmToNavigate: false
            }))) : null;
    }
    render() {
        const { depth: depth, maxDepth: maxDepth, status: status, theme: theme } = this.props;
        const indent = (0, $ajzlS.levelIndentBaseline) + depth * (0, $ajzlS.levelIndentBaseline);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                background: status === 'PERSISTING' ? $052ecbea1c183703$var$persistingGradient : (0, $73a5c9d720aa66e1$exports).G50,
                marginLeft: `${indent}px`
            },
            onKeyDown: this.onCellKeyDown,
            className: (0, $7JEyt.default)([
                "_1e0c1txw _vchhusvi _x3dooyrj _n7zloyrj _4t3i1jfw _19pkze3t"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($052ecbea1c183703$var$FakeChildOperationIndicator, {
            isMaxDepth: depth === maxDepth,
            theme: theme
        }), this.renderCoreColumns(), this.renderAdditionalColumns());
    }
    constructor(...args){
        super(...args);
        this.onCellKeyDown = (event)=>{
            const { id: id, status: status, setMultiAddAnchor: setMultiAddAnchor, onPersistAddedRowRequested: onPersistAddedRowRequested, onCancelAddedRowRequested: onCancelAddedRowRequested } = this.props;
            if (status === 'NEW') switch(event.keyCode){
                case (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter'):
                    event.stopPropagation();
                    setMultiAddAnchor(id);
                    onPersistAddedRowRequested(id);
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('escape'):
                    event.stopPropagation();
                    onCancelAddedRowRequested(id);
                    break;
                default:
                    break;
            }
        };
    }
}
var $052ecbea1c183703$export$2e2bcd8739ae039 = (0, $6pOL1.withTheme)($052ecbea1c183703$var$NewRow);
const $052ecbea1c183703$var$persistingGradient = `
    repeating-linear-gradient(
        315deg,
        rgba(0,0,0,0.1), rgba(0,0,0,0.1) 1px,
        ${(0, $73a5c9d720aa66e1$exports).N0} 0, ${(0, $73a5c9d720aa66e1$exports).N0} 5px
    )
`;
const $052ecbea1c183703$var$rowWrapperStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $052ecbea1c183703$var$FakeChildOperationIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMaxDepth: isMaxDepth, theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_eobblv": (0, $9t7rW.default)(__cmplp.theme.row.maxDepthChildrenOperationIndicatorWidth, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _vchhusvi",
            __cmplp.isMaxDepth ? "_1bsb1fz4" : "_1bsbg21h",
            __cmplp.className
        ])
    });
});

});




parcelRegister("vzVDg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c491c762b001b51$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $5c491c762b001b51$export$2e2bcd8739ae039(props) {
    const { rowIds: rowIds, List: List } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(List, {
        rowIds: rowIds,
        displayStart: 0,
        displayEnd: rowIds.length
    });
}

});


parcelRegister("d5Q75", function(module, exports) {

$parcel$export(module.exports, "default", () => $45acec1f7d313147$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9Ufhw = parcelRequire("9Ufhw");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $45acec1f7d313147$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12ji1r31 _1qu2glyw _12y31o36",
            __cmplp.className
        ])
    });
});
class $45acec1f7d313147$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        const { isAutoHeight: isAutoHeight, AutoHeightList: AutoHeightList, VirtualList: VirtualList } = this.props;
        const Content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($45acec1f7d313147$var$Wrapper, {
            tabIndex: -1,
            ref: this.onRefChanged
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this.onDivRefChanged,
            className: "virtual-table-row-list-portal"
        }), isAutoHeight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AutoHeightList, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(VirtualList, null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Ufhw.default), null), Content);
    }
    constructor(...args){
        super(...args);
        this.onRefChanged = (el)=>{
            const { onRowListFocusFunctionChanged: onRowListFocusFunctionChanged } = this.props;
            if (!onRowListFocusFunctionChanged) return;
            if (el != null) onRowListFocusFunctionChanged(()=>{
                el && el.focus();
            });
            else onRowListFocusFunctionChanged(null);
        };
        this.onDivRefChanged = (el)=>{
            const { onReactPortalContainerRefChanged: onReactPortalContainerRefChanged } = this.props;
            if (!onReactPortalContainerRefChanged) return;
            if (el != null) onReactPortalContainerRefChanged(el);
        };
    }
}

});
parcelRegister("9Ufhw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dc10fe01294ea06$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $kWPYY = parcelRequire("kWPYY");

var $5yvx1 = parcelRequire("5yvx1");

var $01OF3 = parcelRequire("01OF3");

var $5lWf9 = parcelRequire("5lWf9");

var $4aSHd = parcelRequire("4aSHd");

var $5jaaH = parcelRequire("5jaaH");

var $gT5K3 = parcelRequire("gT5K3");
const $5dc10fe01294ea06$var$mapDispatchToProps = {
    navigateToRow: $kWPYY.navigateToRow,
    clearActiveItem: $5lWf9.clearActiveItem,
    setHorizontalScrollOffset: $5yvx1.setHorizontal
};
var $5dc10fe01294ea06$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state)=>({
        maxHorizontalScrollOffset: (0, $5jaaH.getMaxHorizontalScrollOffset)(state),
        horizontalScrollOffset: (0, $4aSHd.getHorizontalScrollOffset)(state),
        navigationMode: (0, $01OF3.getNavigationMode)(state),
        activeRowIndex: (0, $5jaaH.getActiveRowIndex)(state),
        isContentStale: (0, $01OF3.isContentStale)(state)
    }), $5dc10fe01294ea06$var$mapDispatchToProps)((0, $gT5K3.default));

});
parcelRegister("gT5K3", function(module, exports) {

$parcel$export(module.exports, "default", () => $94a89a4854fc0a97$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9LXG4 = parcelRequire("9LXG4");

var $9aFSa = parcelRequire("9aFSa");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


const $94a89a4854fc0a97$var$KeyboardShortcuts = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const HORIZONTAL_SCROLL_DISTANCE = 40;
    const SHIFT_TAB = 'shiftTab';
    const analyticsEvent = createAnalyticsEvent({
        action: 'pressed',
        actionSubject: 'rowItem'
    });
    const handleTabKey = (tabKey)=>{
        if (props.isContentStale || props.navigationMode !== (0, $a37593d97c1ae333$export$a01cd8e028b3d34f)) return;
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, tabKey === SHIFT_TAB ? 'tabFieldLeft' : 'tabFieldRight', {
            rowIndex: props.activeRowIndex,
            keyPressed: tabKey
        });
    };
    const handleKeyUpOrDown = (direction, key, index)=>{
        if (props.isContentStale || props.navigationMode !== (0, $a37593d97c1ae333$export$a01cd8e028b3d34f)) return;
        props.navigateToRow({
            direction: direction
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, `navigateRow${(0, (/*@__PURE__*/$parcel$interopDefault($9LXG4)))(direction)}`, {
            keyPressed: key,
            rowIndex: index
        });
    };
    const handleKeyLeft = ()=>{
        if (props.isContentStale || props.navigationMode !== (0, $a37593d97c1ae333$export$a01cd8e028b3d34f)) return;
        const newOffset = Math.max(0, props.horizontalScrollOffset - HORIZONTAL_SCROLL_DISTANCE);
        if (props.horizontalScrollOffset !== newOffset) props.setHorizontalScrollOffset(newOffset);
    };
    const handleKeyRight = ()=>{
        if (props.isContentStale || props.navigationMode !== (0, $a37593d97c1ae333$export$a01cd8e028b3d34f)) return;
        const newOffset = Math.min(props.maxHorizontalScrollOffset, props.horizontalScrollOffset + HORIZONTAL_SCROLL_DISTANCE);
        if (props.horizontalScrollOffset !== newOffset) props.setHorizontalScrollOffset(newOffset);
    };
    const mapping = {
        tab: {
            callback: ()=>handleTabKey('tab')
        },
        'shift+tab': {
            callback: ()=>handleTabKey(SHIFT_TAB)
        },
        j: {
            callback: ()=>handleKeyUpOrDown((0, $d090cdd78de8086e$export$c7c029a231f98d34), 'j', props.activeRowIndex)
        },
        arrowdown: {
            callback: ()=>handleKeyUpOrDown((0, $d090cdd78de8086e$export$c7c029a231f98d34), 'arrowdown', props.activeRowIndex)
        },
        k: {
            callback: ()=>handleKeyUpOrDown((0, $d090cdd78de8086e$export$b29f845fa4b57508), 'k', props.activeRowIndex)
        },
        arrowup: {
            callback: ()=>handleKeyUpOrDown((0, $d090cdd78de8086e$export$b29f845fa4b57508), 'arrowup', props.activeRowIndex)
        },
        arrowleft: {
            callback: ()=>handleKeyLeft()
        },
        arrowright: {
            callback: ()=>handleKeyRight()
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: mapping
    });
};
$94a89a4854fc0a97$var$KeyboardShortcuts.defaultProps = {
    isContentStale: false
};
var $94a89a4854fc0a97$export$2e2bcd8739ae039 = $94a89a4854fc0a97$var$KeyboardShortcuts;

});
parcelRegister("9aFSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $80173688b586a9b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7Q1yP = parcelRequire("7Q1yP");

var $cIhGE = parcelRequire("cIhGE");

var $haeC1 = parcelRequire("haeC1");

var $fVFUy = parcelRequire("fVFUy");

var $kGQen = parcelRequire("kGQen");

var $h80SI = parcelRequire("h80SI");
let $80173688b586a9b5$var$shortcutsCount = 0;
let $80173688b586a9b5$var$subscription = null;
const $80173688b586a9b5$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eUqFw.useContext)((0, $kGQen.ShortcutRegistryContext)) || (0, $fVFUy.rootRegistry);
    const addKeyMap = (0, $eUqFw.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $h80SI.bindKeyMapWithErrorHandling)(keyMap, location),
                label: label
            })), [
        label,
        parentRegistry,
        keyMap,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $80173688b586a9b5$var$shortcutsCount -= 1;
            if ($80173688b586a9b5$var$subscription && $80173688b586a9b5$var$shortcutsCount === 0) {
                $80173688b586a9b5$var$subscription.unsubscribe();
                $80173688b586a9b5$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$subscription = $80173688b586a9b5$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $cIhGE.default)().subscribe((0, $haeC1.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80173688b586a9b5$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $7Q1yP.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80173688b586a9b5$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("7Q1yP", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $e8e091cfd61e9197$export$a33a81f1fc5458ad);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");

var $WBLbN = parcelRequire("WBLbN");
const $e8e091cfd61e9197$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $e8e091cfd61e9197$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$e8e091cfd61e9197$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $lRmyA.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $e8e091cfd61e9197$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $6rW04.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $e8e091cfd61e9197$export$b62f67be35e65859
    }
});
const $e8e091cfd61e9197$export$a33a81f1fc5458ad = (0, $WBLbN.createHook)($e8e091cfd61e9197$var$Store);

});

parcelRegister("cIhGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e80b5974f2eb64$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $61e80b5974f2eb64$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");
parcelRequire("fRdoC");
parcelRequire("5dKXv");
parcelRequire("8OtG5");
parcelRequire("fWv6o");
parcelRequire("flmol");
parcelRequire("7Rus6");
parcelRequire("azOPD");
parcelRequire("1d9Hc");

var $1YqdI = parcelRequire("1YqdI");
const $61e80b5974f2eb64$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $61e80b5974f2eb64$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$61e80b5974f2eb64$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$61e80b5974f2eb64$var$isEditable(e.target) && !$61e80b5974f2eb64$var$ignoredKeys[e.key]);
const $61e80b5974f2eb64$export$25d1b8252b4c49b7 = ()=>{
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $61e80b5974f2eb64$var$key$;
const $61e80b5974f2eb64$var$flush$ = new (0, $70s4u.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61e80b5974f2eb64$export$2e2bcd8739ae039 = ()=>{
    if (!$61e80b5974f2eb64$var$key$) {
        $61e80b5974f2eb64$var$key$ = false ? new (0, $70s4u.Subject)() : (0, $3JafE.Observable).fromEvent(document, 'keydown').filter($61e80b5974f2eb64$var$isRelevantKeyEvent).filter($61e80b5974f2eb64$export$25d1b8252b4c49b7).map((0, $1YqdI.toKeyWithModifiers));
        const sequence$ = $61e80b5974f2eb64$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $61e80b5974f2eb64$var$key$ = $61e80b5974f2eb64$var$key$.debounceTime(1000).startWith(null).merge($61e80b5974f2eb64$var$flush$).switchMapTo(sequence$);
    }
    return $61e80b5974f2eb64$var$key$;
};
const $61e80b5974f2eb64$export$4909b86c8034bf73 = ()=>{
    $61e80b5974f2eb64$var$flush$.next();
};

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});


parcelRegister("haeC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bf9c8ab51bd76c$export$2e2bcd8739ae039);

var $cIhGE = parcelRequire("cIhGE");

var $fVFUy = parcelRequire("fVFUy");
const $44bf9c8ab51bd76c$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$44bf9c8ab51bd76c$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $fVFUy.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $cIhGE.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($44bf9c8ab51bd76c$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $cIhGE.flush)();
    }
};

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});


parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});

parcelRegister("h80SI", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $2297a6a3d8ab933d$export$77477772a9b904da);

var $gUUjF = parcelRequire("gUUjF");
const $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
        try {
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $2297a6a3d8ab933d$export$77477772a9b904da = (keyMap, location)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
            }
        }), {});

});





parcelRegister("kC7so", function(module, exports) {

$parcel$export(module.exports, "default", () => $6afce64adc96d237$export$2e2bcd8739ae039);

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");

var $7vbEf = parcelRequire("7vbEf");

var $kZUuT = parcelRequire("kZUuT");

var $11Kxz = parcelRequire("11Kxz");

var $01OF3 = parcelRequire("01OF3");

var $f5bbs = parcelRequire("f5bbs");

var $5jaaH = parcelRequire("5jaaH");

var $fZ2Nd = parcelRequire("fZ2Nd");

var $95nd0 = parcelRequire("95nd0");

var $7Jlbb = parcelRequire("7Jlbb");
const $6afce64adc96d237$var$mapStateToProps = (state)=>({
        rowIds: (0, $fZ2Nd.getFlattenedWithAddedRowIds)(state),
        contentHeight: (0, $5jaaH.getTableContentHeight)(state),
        isAutoRowHeight: (0, $f5bbs.isAutoRowHeight)(state),
        defaultRowHeight: (0, $f5bbs.getDefaultRowHeight)(state),
        virtualBoundaries: (0, $5jaaH.getVirtualBoundaries)(state),
        numberOfLoadingRows: (0, $5jaaH.getNumberOfLoadingRowsInDisplayBoundary)(state),
        isTableFacade: (0, $01OF3.isTableFacade)(state),
        List: $95nd0.default
    });
const $6afce64adc96d237$var$mapDispatchToProps = (dispatch)=>({
        batchUpdateRowHeightMapping: (rowIds, rowHeightMapping)=>dispatch((0, $11Kxz.batchUpdateRowHeightMapping)(rowIds, rowHeightMapping)),
        onDeferredBuffering: (rowsRendered, rowsDeferred, analyticsEvent)=>{
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'virtualList deferredBuffering', {
                rowsRendered: rowsRendered,
                rowsDeferred: rowsDeferred
            });
        },
        onLoadingRowUnmount: (numberOfLoadingRows, displayStart, rowId, timeVisibleFor, reasonType, analyticsEvent)=>displayStart === 0 ? undefined : dispatch((0, $kZUuT.fireLoadingRowAnalytics)({
                rowId: rowId,
                timeVisibleFor: timeVisibleFor,
                numberOfLoadingRows: numberOfLoadingRows,
                reasonType: reasonType,
                analyticsEvent: analyticsEvent
            }))
    });
var $6afce64adc96d237$export$2e2bcd8739ae039 = (0, $7vbEf.connect)($6afce64adc96d237$var$mapStateToProps, $6afce64adc96d237$var$mapDispatchToProps)((0, $g8JvH.AnalyticsEventToProps)('virtualList', {
    onDeferredBuffering: 'deferredBuffering'
})((0, $7Jlbb.default)));

});
parcelRegister("kZUuT", function(module, exports) {

$parcel$export(module.exports, "FIRE_LOADING_ROW_ANALYTICS", () => $5112562dbaec588b$export$73369b76089b13a6);
$parcel$export(module.exports, "fireLoadingRowAnalytics", () => $5112562dbaec588b$export$d043bad71b13e219);
const $5112562dbaec588b$export$73369b76089b13a6 = 'ops.rows.analytics.FIRE_LOADING_ROW_ANALYTICS';
const $5112562dbaec588b$export$d043bad71b13e219 = (payload)=>({
        type: $5112562dbaec588b$export$73369b76089b13a6,
        payload: payload
    });

});

parcelRegister("11Kxz", function(module, exports) {

$parcel$export(module.exports, "BATCH_UPDATE_ROW_HEIGHT_MAPPING", () => $d5c7191749ab5b88$export$1e2cc4b1d7e85685);
$parcel$export(module.exports, "batchUpdateRowHeightMapping", () => $d5c7191749ab5b88$export$6ad1445af83aec72);
const $d5c7191749ab5b88$export$1e2cc4b1d7e85685 = 'ops.rows.row-height.BATCH_UPDATE_ROW_HEIGHT_MAPPING';
const $d5c7191749ab5b88$export$6ad1445af83aec72 = (rowIds, rowHeightMapping)=>({
        type: $d5c7191749ab5b88$export$1e2cc4b1d7e85685,
        payload: {
            rowIds: rowIds,
            rowHeightMapping: rowHeightMapping
        }
    });

});

parcelRegister("7Jlbb", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc6e8a3623dd783d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $elFZ3 = parcelRequire("elFZ3");
const $fc6e8a3623dd783d$var$stateToRenderState = (state)=>{
    const { visibleStart: visibleStart, visibleEnd: visibleEnd, displayStart: displayStart, displayEnd: displayEnd, rowIds: rowIds } = state;
    return {
        virtualBoundaries: {
            visibleStart: visibleStart,
            visibleEnd: visibleEnd,
            displayStart: displayStart,
            displayEnd: displayEnd
        },
        rowIds: rowIds
    };
};
class $fc6e8a3623dd783d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.updateStateRowHeight = (rowId, rowHeight)=>{
            this.rowHeightUpdateBatch[rowId] = rowHeight;
        };
        this.state = {
            displayStart: 0,
            displayEnd: 0,
            visibleStart: 0,
            visibleEnd: 0,
            rowHeights: {},
            rowIds: props.rowIds
        };
        const { rowIds: rowIds } = props;
        this.rowIds = rowIds;
        this.rowHeightUpdateBatch = {};
        this.shouldUpdate = false;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { isTableFacade: isTableFacade, isAutoRowHeight: isAutoRowHeight, virtualBoundaries: virtualBoundaries, rowIds: rowIds } = nextProps;
        const { visibleStart: visibleStart, visibleEnd: visibleEnd } = virtualBoundaries;
        // 1) In case of TreeTable, update the list only when we scroll and
        // pass beyond the buffer rows, rather than for every scroll update
        //      1.1) make an inclusive equality comparison. we always want at least 1
        //      item beyond the viewport so we can keyboard navigate to it
        // 2) In case of Table, the list is updated when it's scrolled past even one row.
        // This is to address the weird experience where, when scrolling the table upwards,
        // with deferred row rendering, the rows render one-by-one downwards in batches of 5 (SHIELD-3990)
        if (isTableFacade && (visibleStart < this.state.visibleStart || visibleEnd > this.state.visibleEnd) || visibleStart <= this.state.displayStart || visibleEnd >= this.state.displayEnd) {
            this.shouldUpdate = true;
            if (isTableFacade && (0, $elFZ3.shouldDeferBuffering)($fc6e8a3623dd783d$var$stateToRenderState(this.state), nextProps)) {
                this.setState({
                    visibleEnd: visibleEnd,
                    visibleStart: visibleStart,
                    displayStart: visibleStart,
                    displayEnd: visibleEnd,
                    rowIds: rowIds
                });
                this.needsDisplayBufferRendered = true;
            } else {
                this.needsDisplayBufferRendered = false;
                this.cancelBuffering();
                this.setState({
                    ...virtualBoundaries,
                    rowIds: rowIds
                });
            }
        } else this.shouldUpdate = false;
        if (isAutoRowHeight) {
            const { batchUpdateRowHeightMapping: batchUpdateRowHeightMapping } = nextProps;
            if (this.batchUpdateTimeoutId == null) this.batchUpdateTimeoutId = window.setTimeout(()=>{
                this.batchUpdateTimeoutId = null;
                if (Object.keys(this.rowHeightUpdateBatch).length > 0) batchUpdateRowHeightMapping(rowIds, this.rowHeightUpdateBatch);
                this.rowHeightUpdateBatch = {};
            });
        }
    }
    shouldComponentUpdate(nextProps) {
        const { rowIds: rowIds, contentHeight: contentHeight } = this.props;
        // table has been resized or entirely new rows: we need to re-adjust - end of story.
        if (contentHeight !== nextProps.contentHeight || rowIds !== nextProps.rowIds) return true;
        // the buffer rows have been surpassed, render a new set of rows and buffers
        return this.shouldUpdate;
    }
    componentDidUpdate() {
        this.shouldUpdate = false;
        if (this.needsDisplayBufferRendered) {
            this.needsDisplayBufferRendered = false;
            const { displayStart: displayStart, displayEnd: displayEnd } = this.props.virtualBoundaries;
            this.scheduleBuffering(displayStart, displayEnd);
        }
    }
    componentWillUnmount() {
        this.cancelBuffering();
        this.batchUpdateTimeoutId && window.clearTimeout(this.batchUpdateTimeoutId);
    }
    afterAnimationFrame() {
        return new Promise((resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reject)=>{
            this.cancelNextAnimationFrameHandlers = ()=>{
                this.cancelNextAnimationFrameHandlers = null;
                reject(new Error('Cancelled'));
            };
            window.requestAnimationFrame(()=>{
                window.setTimeout(()=>{
                    this.cancelNextAnimationFrameHandlers = null;
                    // @ts-expect-error - TS2794 - Expected 1 arguments, but got 0. Did you forget to include 'void' in your type argument to 'Promise'?
                    resolve();
                });
            });
        });
    }
    cancelBuffering() {
        this.cancelNextAnimationFrameHandlers && this.cancelNextAnimationFrameHandlers();
    }
    scheduleBuffering(displayStart, displayEnd) {
        this.cancelBuffering();
        this.afterAnimationFrame().then(()=>{
            this.shouldUpdate = true;
            const rowsRendered = this.state.displayEnd - this.state.displayStart;
            const rowsDeferred = this.state.displayStart - displayStart + (displayEnd - this.state.displayEnd);
            this.props.onDeferredBuffering(rowsRendered, rowsDeferred);
            this.setState({
                displayStart: displayStart,
                displayEnd: displayEnd
            });
        }).catch(()=>{
        // presumably due to being cancelled
        });
    }
    getBoundaries() {
        if (false) return this.props.virtualBoundaries;
        return this.state;
    }
    render() {
        const { rowIds: rowIds, contentHeight: contentHeight, onLoadingRowUnmount: onLoadingRowUnmount, List: List } = this.props;
        const { displayStart: displayStart, displayEnd: displayEnd } = this.getBoundaries();
        // @ts-expect-error - TS2367 - This condition will always return 'false' since the types 'string[]' and 'number' have no overlap.
        if (contentHeight === 0 || rowIds === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(List, {
            rowIds: rowIds,
            displayStart: displayStart,
            displayEnd: displayEnd,
            onRowContentUpdate: this.updateStateRowHeight,
            onLoadingRowUnmount: onLoadingRowUnmount
        });
    }
}

});
parcelRegister("elFZ3", function(module, exports) {

$parcel$export(module.exports, "shouldDeferBuffering", () => $bb21c49c38cbb4ea$export$ae5c6ac06aadc69);
/**
 * Threshold for rows in the "buffered" region (i.e., difference of <display region> and <visible region>).
 *
 * Only the visible region will be rendered initially if more than `DEFERRED_BUFFERING_NEW_MOUNT_THRESHOLD`
 * of the "buffered" rows need to be mounted (because they were not previously rendered); rendering of the
 * buffer will be deferred.
 */ const $bb21c49c38cbb4ea$var$DEFERRED_BUFFERING_NEW_MOUNT_THRESHOLD = 0.3;
const $bb21c49c38cbb4ea$var$getRowsForBuffering = ({ virtualBoundaries: { displayStart: displayStart, visibleStart: visibleStart, visibleEnd: visibleEnd, displayEnd: displayEnd }, rowIds: rowIds })=>[
        ...rowIds.slice(displayStart, visibleStart),
        ...rowIds.slice(visibleEnd + 1, displayEnd + 1)
    ];
const $bb21c49c38cbb4ea$var$getPreviouslyRenderedRows = (prevRenderState)=>{
    const { rowIds: rowIds, virtualBoundaries: { displayStart: displayStart, displayEnd: displayEnd } } = prevRenderState;
    return rowIds.slice(displayStart, displayEnd + 1);
};
const $bb21c49c38cbb4ea$var$getBufferRowsNeedingMount = (nextRenderState, prevRenderState)=>{
    const previouslyRenderedRows = new Set($bb21c49c38cbb4ea$var$getPreviouslyRenderedRows(prevRenderState));
    return $bb21c49c38cbb4ea$var$getRowsForBuffering(nextRenderState).filter((row)=>!previouslyRenderedRows.has(row));
};
// Only allow deferred buffering when at the top of the row list for now.
const $bb21c49c38cbb4ea$var$canDeferBuffering = (nextRenderState)=>{
    const { virtualBoundaries: { visibleStart: visibleStart } } = nextRenderState;
    return visibleStart === 0;
};
const $bb21c49c38cbb4ea$export$ae5c6ac06aadc69 = (prevRenderState, nextRenderState)=>{
    if (!$bb21c49c38cbb4ea$var$canDeferBuffering(nextRenderState)) return false;
    const { visibleStart: visibleStart, displayStart: displayStart, visibleEnd: visibleEnd, displayEnd: displayEnd } = nextRenderState.virtualBoundaries;
    const requestedBufferSize = displayEnd - visibleEnd + (visibleStart - displayStart);
    if (requestedBufferSize === 0) return false;
    const rowsNeedingMount = $bb21c49c38cbb4ea$var$getBufferRowsNeedingMount(nextRenderState, prevRenderState).length;
    return rowsNeedingMount > requestedBufferSize * $bb21c49c38cbb4ea$var$DEFERRED_BUFFERING_NEW_MOUNT_THRESHOLD;
};

});




parcelRegister("kIjoA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bb245573d964860$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $5yvx1 = parcelRequire("5yvx1");

var $4Bkxm = parcelRequire("4Bkxm");

var $4aSHd = parcelRequire("4aSHd");

var $5jaaH = parcelRequire("5jaaH");

var $d8zvO = parcelRequire("d8zvO");
var $2bb245573d964860$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state)=>({
        left: (0, $4Bkxm.getVisibleCoreColumnsWidth)(state),
        viewportWidth: (0, $5jaaH.getHorizontalScrollWidth)(state),
        contentWidth: (0, $5jaaH.getVisibleAdditionalColumnsWidth)(state) + (0, $4aSHd.getTableRowMargin)(state),
        scrollLeft: (0, $4aSHd.getHorizontalScrollOffset)(state)
    }), {
    setHorizontalScrollOffset: $5yvx1.setHorizontal
})((0, $d8zvO.default));

});
parcelRegister("d8zvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $92d7346a079879d5$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $6pOL1 = parcelRequire("6pOL1");

var $97YHm = parcelRequire("97YHm");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $92d7346a079879d5$var$StyledScrollbar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $97YHm.StyledScrollbars), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_t50dub": (0, $9t7rW.default)(`${__cmplp.left}px`),
            "--_zfsphk": (0, $9t7rW.default)(`${__cmplp.width - __cmplp.theme.scrollbar.offset}px !important`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw7079 _1ltvdw55 _94n5idpf _1bsb8zc1 _4t3i2dgd _16mt19el",
            __cmplp.className
        ])
    });
});
const $92d7346a079879d5$var$FakeContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1hdq _4t3it94y",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $92d7346a079879d5$var$HorizontalScrollbar extends (0, $eUqFw.PureComponent) {
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { scrollRef: scrollRef } = this;
        if (scrollRef) scrollRef.scrollLeft(nextProps.scrollLeft);
    }
    render() {
        const { viewportWidth: viewportWidth, contentWidth: contentWidth, left: left, theme: theme } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92d7346a079879d5$var$StyledScrollbar, {
            ref: this.setScrollRef,
            width: viewportWidth,
            left: left,
            onScrollFrame: this.onHorizontalScroll,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92d7346a079879d5$var$FakeContent, {
            width: contentWidth
        }));
    }
    constructor(...args){
        super(...args);
        this.onHorizontalScroll = ({ scrollLeft: scrollLeft })=>{
            const { setHorizontalScrollOffset: setHorizontalScrollOffset } = this.props;
            setHorizontalScrollOffset(scrollLeft);
        };
        this.setScrollRef = (ref)=>{
            this.scrollRef = ref;
        };
    }
}
var $92d7346a079879d5$export$2e2bcd8739ae039 = (0, $6pOL1.withTheme)($92d7346a079879d5$var$HorizontalScrollbar);

});
parcelRegister("97YHm", function(module, exports) {

$parcel$export(module.exports, "StyledScrollbars", () => $d065224c5c012042$export$8c1e030d30c518f3);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dhXcG = parcelRequire("dhXcG");
const $d065224c5c012042$export$8c1e030d30c518f3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, (/*@__PURE__*/$parcel$interopDefault($dhXcG))), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_iwvize3t _1dcdu2gc _1ijuu2gc _bh271c1a _nhmktnze _d39w1qh3 _1o3o19el _ekl21fj3 _2bk9gxqn _1t7ztlke _145vtnze _4bumh2mm _e1uku2gc _bwqgze3t _i0vgu2gc _13411c1a _1a4htnze _1syn1m3d _tqfr19el _1dni1fj3 _1cld1hsp _8vvgtlke _qb98tnze",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dhXcG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Scrollbars = undefined;

var $hm1SX = parcelRequire("hm1SX");
var $9acac97bee8a61e5$var$_Scrollbars2 = $9acac97bee8a61e5$var$_interopRequireDefault($hm1SX);
function $9acac97bee8a61e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports["default"] = $9acac97bee8a61e5$var$_Scrollbars2["default"];
module.exports.Scrollbars = $9acac97bee8a61e5$var$_Scrollbars2["default"];

});
parcelRegister("hm1SX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ca25f4216b441bce$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ca25f4216b441bce$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $le4ma = parcelRequire("le4ma");
var $ca25f4216b441bce$var$_raf3 = $ca25f4216b441bce$var$_interopRequireDefault($le4ma);

var $ggKCU = parcelRequire("ggKCU");
var $ca25f4216b441bce$var$_domCss2 = $ca25f4216b441bce$var$_interopRequireDefault($ggKCU);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");
var $ca25f4216b441bce$var$_propTypes2 = $ca25f4216b441bce$var$_interopRequireDefault($1Qivz);

var $jK96v = parcelRequire("jK96v");
var $ca25f4216b441bce$var$_isString2 = $ca25f4216b441bce$var$_interopRequireDefault($jK96v);

var $6LwRl = parcelRequire("6LwRl");
var $ca25f4216b441bce$var$_getScrollbarWidth2 = $ca25f4216b441bce$var$_interopRequireDefault($6LwRl);

var $OTFeF = parcelRequire("OTFeF");
var $ca25f4216b441bce$var$_returnFalse2 = $ca25f4216b441bce$var$_interopRequireDefault($OTFeF);

var $eoguQ = parcelRequire("eoguQ");
var $ca25f4216b441bce$var$_getInnerWidth2 = $ca25f4216b441bce$var$_interopRequireDefault($eoguQ);

var $ddLvN = parcelRequire("ddLvN");
var $ca25f4216b441bce$var$_getInnerHeight2 = $ca25f4216b441bce$var$_interopRequireDefault($ddLvN);

var $evv3d = parcelRequire("evv3d");

var $i7qJ5 = parcelRequire("i7qJ5");
function $ca25f4216b441bce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $ca25f4216b441bce$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $ca25f4216b441bce$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ca25f4216b441bce$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ca25f4216b441bce$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $ca25f4216b441bce$var$Scrollbars = function(_Component) {
    $ca25f4216b441bce$var$_inherits(Scrollbars, _Component);
    function Scrollbars(props) {
        var _ref;
        $ca25f4216b441bce$var$_classCallCheck(this, Scrollbars);
        for(var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        var _this = $ca25f4216b441bce$var$_possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [
            this,
            props
        ].concat(rest)));
        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
        _this.getScrollTop = _this.getScrollTop.bind(_this);
        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
        _this.getClientWidth = _this.getClientWidth.bind(_this);
        _this.getClientHeight = _this.getClientHeight.bind(_this);
        _this.getValues = _this.getValues.bind(_this);
        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);
        _this.scrollLeft = _this.scrollLeft.bind(_this);
        _this.scrollTop = _this.scrollTop.bind(_this);
        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
        _this.scrollToTop = _this.scrollToTop.bind(_this);
        _this.scrollToRight = _this.scrollToRight.bind(_this);
        _this.scrollToBottom = _this.scrollToBottom.bind(_this);
        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleDragEnd = _this.handleDragEnd.bind(_this);
        _this.state = {
            didMountUniversal: false
        };
        return _this;
    }
    $ca25f4216b441bce$var$_createClass(Scrollbars, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.addListeners();
                this.update();
                this.componentDidMountUniversal();
            }
        },
        {
            key: 'componentDidMountUniversal',
            value: function componentDidMountUniversal() {
                // eslint-disable-line react/sort-comp
                var universal = this.props.universal;
                if (!universal) return;
                this.setState({
                    didMountUniversal: true
                });
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                this.update();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.removeListeners();
                (0, $le4ma.cancel)(this.requestFrame);
                clearTimeout(this.hideTracksTimeout);
                clearInterval(this.detectScrollingInterval);
            }
        },
        {
            key: 'getScrollLeft',
            value: function getScrollLeft() {
                if (!this.view) return 0;
                return this.view.scrollLeft;
            }
        },
        {
            key: 'getScrollTop',
            value: function getScrollTop() {
                if (!this.view) return 0;
                return this.view.scrollTop;
            }
        },
        {
            key: 'getScrollWidth',
            value: function getScrollWidth() {
                if (!this.view) return 0;
                return this.view.scrollWidth;
            }
        },
        {
            key: 'getScrollHeight',
            value: function getScrollHeight() {
                if (!this.view) return 0;
                return this.view.scrollHeight;
            }
        },
        {
            key: 'getClientWidth',
            value: function getClientWidth() {
                if (!this.view) return 0;
                return this.view.clientWidth;
            }
        },
        {
            key: 'getClientHeight',
            value: function getClientHeight() {
                if (!this.view) return 0;
                return this.view.clientHeight;
            }
        },
        {
            key: 'getValues',
            value: function getValues() {
                var _ref2 = this.view || {}, _ref2$scrollLeft = _ref2.scrollLeft, scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2.scrollTop, scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop, _ref2$scrollWidth = _ref2.scrollWidth, scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth, _ref2$scrollHeight = _ref2.scrollHeight, scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight, _ref2$clientWidth = _ref2.clientWidth, clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth, _ref2$clientHeight = _ref2.clientHeight, clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;
                return {
                    left: scrollLeft / (scrollWidth - clientWidth) || 0,
                    top: scrollTop / (scrollHeight - clientHeight) || 0,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollWidth: scrollWidth,
                    scrollHeight: scrollHeight,
                    clientWidth: clientWidth,
                    clientHeight: clientHeight
                };
            }
        },
        {
            key: 'getThumbHorizontalWidth',
            value: function getThumbHorizontalWidth() {
                var _props = this.props, thumbSize = _props.thumbSize, thumbMinSize = _props.thumbMinSize;
                var _view = this.view, scrollWidth = _view.scrollWidth, clientWidth = _view.clientWidth;
                var trackWidth = (0, $ca25f4216b441bce$var$_getInnerWidth2["default"])(this.trackHorizontal);
                var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
                if (trackWidth === width) return 0;
                if (thumbSize) return thumbSize;
                return Math.max(width, thumbMinSize);
            }
        },
        {
            key: 'getThumbVerticalHeight',
            value: function getThumbVerticalHeight() {
                var _props2 = this.props, thumbSize = _props2.thumbSize, thumbMinSize = _props2.thumbMinSize;
                var _view2 = this.view, scrollHeight = _view2.scrollHeight, clientHeight = _view2.clientHeight;
                var trackHeight = (0, $ca25f4216b441bce$var$_getInnerHeight2["default"])(this.trackVertical);
                var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
                if (trackHeight === height) return 0;
                if (thumbSize) return thumbSize;
                return Math.max(height, thumbMinSize);
            }
        },
        {
            key: 'getScrollLeftForOffset',
            value: function getScrollLeftForOffset(offset) {
                var _view3 = this.view, scrollWidth = _view3.scrollWidth, clientWidth = _view3.clientWidth;
                var trackWidth = (0, $ca25f4216b441bce$var$_getInnerWidth2["default"])(this.trackHorizontal);
                var thumbWidth = this.getThumbHorizontalWidth();
                return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
            }
        },
        {
            key: 'getScrollTopForOffset',
            value: function getScrollTopForOffset(offset) {
                var _view4 = this.view, scrollHeight = _view4.scrollHeight, clientHeight = _view4.clientHeight;
                var trackHeight = (0, $ca25f4216b441bce$var$_getInnerHeight2["default"])(this.trackVertical);
                var thumbHeight = this.getThumbVerticalHeight();
                return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
            }
        },
        {
            key: 'scrollLeft',
            value: function scrollLeft() {
                var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (!this.view) return;
                this.view.scrollLeft = left;
            }
        },
        {
            key: 'scrollTop',
            value: function scrollTop() {
                var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (!this.view) return;
                this.view.scrollTop = top;
            }
        },
        {
            key: 'scrollToLeft',
            value: function scrollToLeft() {
                if (!this.view) return;
                this.view.scrollLeft = 0;
            }
        },
        {
            key: 'scrollToTop',
            value: function scrollToTop() {
                if (!this.view) return;
                this.view.scrollTop = 0;
            }
        },
        {
            key: 'scrollToRight',
            value: function scrollToRight() {
                if (!this.view) return;
                this.view.scrollLeft = this.view.scrollWidth;
            }
        },
        {
            key: 'scrollToBottom',
            value: function scrollToBottom() {
                if (!this.view) return;
                this.view.scrollTop = this.view.scrollHeight;
            }
        },
        {
            key: 'addListeners',
            value: function addListeners() {
                /* istanbul ignore if */ if (typeof document === 'undefined' || !this.view) return;
                var view = this.view, trackHorizontal = this.trackHorizontal, trackVertical = this.trackVertical, thumbHorizontal = this.thumbHorizontal, thumbVertical = this.thumbVertical;
                view.addEventListener('scroll', this.handleScroll);
                if (!(0, $ca25f4216b441bce$var$_getScrollbarWidth2["default"])()) return;
                trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
                trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
                trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
                trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
                trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
                trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
                thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
                thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
                window.addEventListener('resize', this.handleWindowResize);
            }
        },
        {
            key: 'removeListeners',
            value: function removeListeners() {
                /* istanbul ignore if */ if (typeof document === 'undefined' || !this.view) return;
                var view = this.view, trackHorizontal = this.trackHorizontal, trackVertical = this.trackVertical, thumbHorizontal = this.thumbHorizontal, thumbVertical = this.thumbVertical;
                view.removeEventListener('scroll', this.handleScroll);
                if (!(0, $ca25f4216b441bce$var$_getScrollbarWidth2["default"])()) return;
                trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
                trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
                trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
                trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
                trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
                trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
                thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
                thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
                window.removeEventListener('resize', this.handleWindowResize);
                // Possibly setup by `handleDragStart`
                this.teardownDragging();
            }
        },
        {
            key: 'handleScroll',
            value: function handleScroll(event) {
                var _this2 = this;
                var _props3 = this.props, onScroll = _props3.onScroll, onScrollFrame = _props3.onScrollFrame;
                if (onScroll) onScroll(event);
                this.update(function(values) {
                    var scrollLeft = values.scrollLeft, scrollTop = values.scrollTop;
                    _this2.viewScrollLeft = scrollLeft;
                    _this2.viewScrollTop = scrollTop;
                    if (onScrollFrame) onScrollFrame(values);
                });
                this.detectScrolling();
            }
        },
        {
            key: 'handleScrollStart',
            value: function handleScrollStart() {
                var onScrollStart = this.props.onScrollStart;
                if (onScrollStart) onScrollStart();
                this.handleScrollStartAutoHide();
            }
        },
        {
            key: 'handleScrollStartAutoHide',
            value: function handleScrollStartAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.showTracks();
            }
        },
        {
            key: 'handleScrollStop',
            value: function handleScrollStop() {
                var onScrollStop = this.props.onScrollStop;
                if (onScrollStop) onScrollStop();
                this.handleScrollStopAutoHide();
            }
        },
        {
            key: 'handleScrollStopAutoHide',
            value: function handleScrollStopAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: 'handleWindowResize',
            value: function handleWindowResize() {
                this.update();
            }
        },
        {
            key: 'handleHorizontalTrackMouseDown',
            value: function handleHorizontalTrackMouseDown(event) {
                event.preventDefault();
                var target = event.target, clientX = event.clientX;
                var _target$getBoundingCl = target.getBoundingClientRect(), targetLeft = _target$getBoundingCl.left;
                var thumbWidth = this.getThumbHorizontalWidth();
                var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
            }
        },
        {
            key: 'handleVerticalTrackMouseDown',
            value: function handleVerticalTrackMouseDown(event) {
                event.preventDefault();
                var target = event.target, clientY = event.clientY;
                var _target$getBoundingCl2 = target.getBoundingClientRect(), targetTop = _target$getBoundingCl2.top;
                var thumbHeight = this.getThumbVerticalHeight();
                var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
                this.view.scrollTop = this.getScrollTopForOffset(offset);
            }
        },
        {
            key: 'handleHorizontalThumbMouseDown',
            value: function handleHorizontalThumbMouseDown(event) {
                event.preventDefault();
                this.handleDragStart(event);
                var target = event.target, clientX = event.clientX;
                var offsetWidth = target.offsetWidth;
                var _target$getBoundingCl3 = target.getBoundingClientRect(), left = _target$getBoundingCl3.left;
                this.prevPageX = offsetWidth - (clientX - left);
            }
        },
        {
            key: 'handleVerticalThumbMouseDown',
            value: function handleVerticalThumbMouseDown(event) {
                event.preventDefault();
                this.handleDragStart(event);
                var target = event.target, clientY = event.clientY;
                var offsetHeight = target.offsetHeight;
                var _target$getBoundingCl4 = target.getBoundingClientRect(), top = _target$getBoundingCl4.top;
                this.prevPageY = offsetHeight - (clientY - top);
            }
        },
        {
            key: 'setupDragging',
            value: function setupDragging() {
                (0, $ca25f4216b441bce$var$_domCss2["default"])(document.body, $evv3d.disableSelectStyle);
                document.addEventListener('mousemove', this.handleDrag);
                document.addEventListener('mouseup', this.handleDragEnd);
                document.onselectstart = $ca25f4216b441bce$var$_returnFalse2["default"];
            }
        },
        {
            key: 'teardownDragging',
            value: function teardownDragging() {
                (0, $ca25f4216b441bce$var$_domCss2["default"])(document.body, $evv3d.disableSelectStyleReset);
                document.removeEventListener('mousemove', this.handleDrag);
                document.removeEventListener('mouseup', this.handleDragEnd);
                document.onselectstart = undefined;
            }
        },
        {
            key: 'handleDragStart',
            value: function handleDragStart(event) {
                this.dragging = true;
                event.stopImmediatePropagation();
                this.setupDragging();
            }
        },
        {
            key: 'handleDrag',
            value: function handleDrag(event) {
                if (this.prevPageX) {
                    var clientX = event.clientX;
                    var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(), trackLeft = _trackHorizontal$getB.left;
                    var thumbWidth = this.getThumbHorizontalWidth();
                    var clickPosition = thumbWidth - this.prevPageX;
                    var offset = -trackLeft + clientX - clickPosition;
                    this.view.scrollLeft = this.getScrollLeftForOffset(offset);
                }
                if (this.prevPageY) {
                    var clientY = event.clientY;
                    var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(), trackTop = _trackVertical$getBou.top;
                    var thumbHeight = this.getThumbVerticalHeight();
                    var _clickPosition = thumbHeight - this.prevPageY;
                    var _offset = -trackTop + clientY - _clickPosition;
                    this.view.scrollTop = this.getScrollTopForOffset(_offset);
                }
                return false;
            }
        },
        {
            key: 'handleDragEnd',
            value: function handleDragEnd() {
                this.dragging = false;
                this.prevPageX = this.prevPageY = 0;
                this.teardownDragging();
                this.handleDragEndAutoHide();
            }
        },
        {
            key: 'handleDragEndAutoHide',
            value: function handleDragEndAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: 'handleTrackMouseEnter',
            value: function handleTrackMouseEnter() {
                this.trackMouseOver = true;
                this.handleTrackMouseEnterAutoHide();
            }
        },
        {
            key: 'handleTrackMouseEnterAutoHide',
            value: function handleTrackMouseEnterAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.showTracks();
            }
        },
        {
            key: 'handleTrackMouseLeave',
            value: function handleTrackMouseLeave() {
                this.trackMouseOver = false;
                this.handleTrackMouseLeaveAutoHide();
            }
        },
        {
            key: 'handleTrackMouseLeaveAutoHide',
            value: function handleTrackMouseLeaveAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: 'showTracks',
            value: function showTracks() {
                clearTimeout(this.hideTracksTimeout);
                (0, $ca25f4216b441bce$var$_domCss2["default"])(this.trackHorizontal, {
                    opacity: 1
                });
                (0, $ca25f4216b441bce$var$_domCss2["default"])(this.trackVertical, {
                    opacity: 1
                });
            }
        },
        {
            key: 'hideTracks',
            value: function hideTracks() {
                var _this3 = this;
                if (this.dragging) return;
                if (this.scrolling) return;
                if (this.trackMouseOver) return;
                var autoHideTimeout = this.props.autoHideTimeout;
                clearTimeout(this.hideTracksTimeout);
                this.hideTracksTimeout = setTimeout(function() {
                    (0, $ca25f4216b441bce$var$_domCss2["default"])(_this3.trackHorizontal, {
                        opacity: 0
                    });
                    (0, $ca25f4216b441bce$var$_domCss2["default"])(_this3.trackVertical, {
                        opacity: 0
                    });
                }, autoHideTimeout);
            }
        },
        {
            key: 'detectScrolling',
            value: function detectScrolling() {
                var _this4 = this;
                if (this.scrolling) return;
                this.scrolling = true;
                this.handleScrollStart();
                this.detectScrollingInterval = setInterval(function() {
                    if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                        clearInterval(_this4.detectScrollingInterval);
                        _this4.scrolling = false;
                        _this4.handleScrollStop();
                    }
                    _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                    _this4.lastViewScrollTop = _this4.viewScrollTop;
                }, 100);
            }
        },
        {
            key: 'raf',
            value: function raf(callback) {
                var _this5 = this;
                if (this.requestFrame) $ca25f4216b441bce$var$_raf3["default"].cancel(this.requestFrame);
                this.requestFrame = (0, $ca25f4216b441bce$var$_raf3["default"])(function() {
                    _this5.requestFrame = undefined;
                    callback();
                });
            }
        },
        {
            key: 'update',
            value: function update(callback) {
                var _this6 = this;
                this.raf(function() {
                    return _this6._update(callback);
                });
            }
        },
        {
            key: '_update',
            value: function _update(callback) {
                var _props4 = this.props, onUpdate = _props4.onUpdate, hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;
                var values = this.getValues();
                if ((0, $ca25f4216b441bce$var$_getScrollbarWidth2["default"])()) {
                    var scrollLeft = values.scrollLeft, clientWidth = values.clientWidth, scrollWidth = values.scrollWidth;
                    var trackHorizontalWidth = (0, $ca25f4216b441bce$var$_getInnerWidth2["default"])(this.trackHorizontal);
                    var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                    var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                    var thumbHorizontalStyle = {
                        width: thumbHorizontalWidth,
                        transform: 'translateX(' + thumbHorizontalX + 'px)'
                    };
                    var scrollTop = values.scrollTop, clientHeight = values.clientHeight, scrollHeight = values.scrollHeight;
                    var trackVerticalHeight = (0, $ca25f4216b441bce$var$_getInnerHeight2["default"])(this.trackVertical);
                    var thumbVerticalHeight = this.getThumbVerticalHeight();
                    var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                    var thumbVerticalStyle = {
                        height: thumbVerticalHeight,
                        transform: 'translateY(' + thumbVerticalY + 'px)'
                    };
                    if (hideTracksWhenNotNeeded) {
                        var trackHorizontalStyle = {
                            visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
                        };
                        var trackVerticalStyle = {
                            visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
                        };
                        (0, $ca25f4216b441bce$var$_domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                        (0, $ca25f4216b441bce$var$_domCss2["default"])(this.trackVertical, trackVerticalStyle);
                    }
                    (0, $ca25f4216b441bce$var$_domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                    (0, $ca25f4216b441bce$var$_domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
                }
                if (onUpdate) onUpdate(values);
                if (typeof callback !== 'function') return;
                callback(values);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this7 = this;
                var scrollbarWidth = (0, $ca25f4216b441bce$var$_getScrollbarWidth2["default"])();
                /* eslint-disable no-unused-vars */ var _props5 = this.props, onScroll = _props5.onScroll, onScrollFrame = _props5.onScrollFrame, onScrollStart = _props5.onScrollStart, onScrollStop = _props5.onScrollStop, onUpdate = _props5.onUpdate, renderView = _props5.renderView, renderTrackHorizontal = _props5.renderTrackHorizontal, renderTrackVertical = _props5.renderTrackVertical, renderThumbHorizontal = _props5.renderThumbHorizontal, renderThumbVertical = _props5.renderThumbVertical, tagName = _props5.tagName, hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded, autoHide = _props5.autoHide, autoHideTimeout = _props5.autoHideTimeout, autoHideDuration = _props5.autoHideDuration, thumbSize = _props5.thumbSize, thumbMinSize = _props5.thumbMinSize, universal = _props5.universal, autoHeight = _props5.autoHeight, autoHeightMin = _props5.autoHeightMin, autoHeightMax = _props5.autoHeightMax, style = _props5.style, children = _props5.children, props = $ca25f4216b441bce$var$_objectWithoutProperties(_props5, [
                    'onScroll',
                    'onScrollFrame',
                    'onScrollStart',
                    'onScrollStop',
                    'onUpdate',
                    'renderView',
                    'renderTrackHorizontal',
                    'renderTrackVertical',
                    'renderThumbHorizontal',
                    'renderThumbVertical',
                    'tagName',
                    'hideTracksWhenNotNeeded',
                    'autoHide',
                    'autoHideTimeout',
                    'autoHideDuration',
                    'thumbSize',
                    'thumbMinSize',
                    'universal',
                    'autoHeight',
                    'autoHeightMin',
                    'autoHeightMax',
                    'style',
                    'children'
                ]);
                /* eslint-enable no-unused-vars */ var didMountUniversal = this.state.didMountUniversal;
                var containerStyle = $ca25f4216b441bce$var$_extends({}, $evv3d.containerStyleDefault, autoHeight && $ca25f4216b441bce$var$_extends({}, $evv3d.containerStyleAutoHeight, {
                    minHeight: autoHeightMin,
                    maxHeight: autoHeightMax
                }), style);
                var viewStyle = $ca25f4216b441bce$var$_extends({}, $evv3d.viewStyleDefault, {
                    // Hide scrollbars by setting a negative margin
                    marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                    marginBottom: scrollbarWidth ? -scrollbarWidth : 0
                }, autoHeight && $ca25f4216b441bce$var$_extends({}, $evv3d.viewStyleAutoHeight, {
                    // Add scrollbarWidth to autoHeight in order to compensate negative margins
                    minHeight: (0, $ca25f4216b441bce$var$_isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
                    maxHeight: (0, $ca25f4216b441bce$var$_isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
                }), autoHeight && universal && !didMountUniversal && {
                    minHeight: autoHeightMin,
                    maxHeight: autoHeightMax
                }, universal && !didMountUniversal && $evv3d.viewStyleUniversalInitial);
                var trackAutoHeightStyle = {
                    transition: 'opacity ' + autoHideDuration + 'ms',
                    opacity: 0
                };
                var trackHorizontalStyle = $ca25f4216b441bce$var$_extends({}, $evv3d.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                    display: 'none'
                });
                var trackVerticalStyle = $ca25f4216b441bce$var$_extends({}, $evv3d.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                    display: 'none'
                });
                return (0, $eUqFw.createElement)(tagName, $ca25f4216b441bce$var$_extends({}, props, {
                    style: containerStyle,
                    ref: function ref(_ref3) {
                        _this7.container = _ref3;
                    }
                }), [
                    (0, $eUqFw.cloneElement)(renderView({
                        style: viewStyle
                    }), {
                        key: 'view',
                        ref: function ref(_ref4) {
                            _this7.view = _ref4;
                        }
                    }, children),
                    (0, $eUqFw.cloneElement)(renderTrackHorizontal({
                        style: trackHorizontalStyle
                    }), {
                        key: 'trackHorizontal',
                        ref: function ref(_ref5) {
                            _this7.trackHorizontal = _ref5;
                        }
                    }, (0, $eUqFw.cloneElement)(renderThumbHorizontal({
                        style: $evv3d.thumbHorizontalStyleDefault
                    }), {
                        ref: function ref(_ref6) {
                            _this7.thumbHorizontal = _ref6;
                        }
                    })),
                    (0, $eUqFw.cloneElement)(renderTrackVertical({
                        style: trackVerticalStyle
                    }), {
                        key: 'trackVertical',
                        ref: function ref(_ref7) {
                            _this7.trackVertical = _ref7;
                        }
                    }, (0, $eUqFw.cloneElement)(renderThumbVertical({
                        style: $evv3d.thumbVerticalStyleDefault
                    }), {
                        ref: function ref(_ref8) {
                            _this7.thumbVertical = _ref8;
                        }
                    }))
                ]);
            }
        }
    ]);
    return Scrollbars;
}($eUqFw.Component);
module.exports["default"] = $ca25f4216b441bce$var$Scrollbars;
$ca25f4216b441bce$var$Scrollbars.propTypes = {
    onScroll: $ca25f4216b441bce$var$_propTypes2["default"].func,
    onScrollFrame: $ca25f4216b441bce$var$_propTypes2["default"].func,
    onScrollStart: $ca25f4216b441bce$var$_propTypes2["default"].func,
    onScrollStop: $ca25f4216b441bce$var$_propTypes2["default"].func,
    onUpdate: $ca25f4216b441bce$var$_propTypes2["default"].func,
    renderView: $ca25f4216b441bce$var$_propTypes2["default"].func,
    renderTrackHorizontal: $ca25f4216b441bce$var$_propTypes2["default"].func,
    renderTrackVertical: $ca25f4216b441bce$var$_propTypes2["default"].func,
    renderThumbHorizontal: $ca25f4216b441bce$var$_propTypes2["default"].func,
    renderThumbVertical: $ca25f4216b441bce$var$_propTypes2["default"].func,
    tagName: $ca25f4216b441bce$var$_propTypes2["default"].string,
    thumbSize: $ca25f4216b441bce$var$_propTypes2["default"].number,
    thumbMinSize: $ca25f4216b441bce$var$_propTypes2["default"].number,
    hideTracksWhenNotNeeded: $ca25f4216b441bce$var$_propTypes2["default"].bool,
    autoHide: $ca25f4216b441bce$var$_propTypes2["default"].bool,
    autoHideTimeout: $ca25f4216b441bce$var$_propTypes2["default"].number,
    autoHideDuration: $ca25f4216b441bce$var$_propTypes2["default"].number,
    autoHeight: $ca25f4216b441bce$var$_propTypes2["default"].bool,
    autoHeightMin: $ca25f4216b441bce$var$_propTypes2["default"].oneOfType([
        $ca25f4216b441bce$var$_propTypes2["default"].number,
        $ca25f4216b441bce$var$_propTypes2["default"].string
    ]),
    autoHeightMax: $ca25f4216b441bce$var$_propTypes2["default"].oneOfType([
        $ca25f4216b441bce$var$_propTypes2["default"].number,
        $ca25f4216b441bce$var$_propTypes2["default"].string
    ]),
    universal: $ca25f4216b441bce$var$_propTypes2["default"].bool,
    style: $ca25f4216b441bce$var$_propTypes2["default"].object,
    children: $ca25f4216b441bce$var$_propTypes2["default"].node
};
$ca25f4216b441bce$var$Scrollbars.defaultProps = {
    renderView: $i7qJ5.renderViewDefault,
    renderTrackHorizontal: $i7qJ5.renderTrackHorizontalDefault,
    renderTrackVertical: $i7qJ5.renderTrackVerticalDefault,
    renderThumbHorizontal: $i7qJ5.renderThumbHorizontalDefault,
    renderThumbVertical: $i7qJ5.renderThumbVerticalDefault,
    tagName: 'div',
    thumbMinSize: 30,
    hideTracksWhenNotNeeded: false,
    autoHide: false,
    autoHideTimeout: 1000,
    autoHideDuration: 200,
    autoHeight: false,
    autoHeightMin: 0,
    autoHeightMax: 200,
    universal: false
};

});
parcelRegister("le4ma", function(module, exports) {

var $fKI31 = parcelRequire("fKI31");
var $f73e48e49de1bdfb$var$root = typeof window === 'undefined' ? $parcel$global : window, $f73e48e49de1bdfb$var$vendors = [
    'moz',
    'webkit'
], $f73e48e49de1bdfb$var$suffix = 'AnimationFrame', $f73e48e49de1bdfb$var$raf = $f73e48e49de1bdfb$var$root['request' + $f73e48e49de1bdfb$var$suffix], $f73e48e49de1bdfb$var$caf = $f73e48e49de1bdfb$var$root['cancel' + $f73e48e49de1bdfb$var$suffix] || $f73e48e49de1bdfb$var$root['cancelRequest' + $f73e48e49de1bdfb$var$suffix];
for(var $f73e48e49de1bdfb$var$i = 0; !$f73e48e49de1bdfb$var$raf && $f73e48e49de1bdfb$var$i < $f73e48e49de1bdfb$var$vendors.length; $f73e48e49de1bdfb$var$i++){
    $f73e48e49de1bdfb$var$raf = $f73e48e49de1bdfb$var$root[$f73e48e49de1bdfb$var$vendors[$f73e48e49de1bdfb$var$i] + 'Request' + $f73e48e49de1bdfb$var$suffix];
    $f73e48e49de1bdfb$var$caf = $f73e48e49de1bdfb$var$root[$f73e48e49de1bdfb$var$vendors[$f73e48e49de1bdfb$var$i] + 'Cancel' + $f73e48e49de1bdfb$var$suffix] || $f73e48e49de1bdfb$var$root[$f73e48e49de1bdfb$var$vendors[$f73e48e49de1bdfb$var$i] + 'CancelRequest' + $f73e48e49de1bdfb$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$f73e48e49de1bdfb$var$raf || !$f73e48e49de1bdfb$var$caf) {
    var $f73e48e49de1bdfb$var$last = 0, $f73e48e49de1bdfb$var$id = 0, $f73e48e49de1bdfb$var$queue = [], $f73e48e49de1bdfb$var$frameDuration = 1000 / 60;
    $f73e48e49de1bdfb$var$raf = function(callback) {
        if ($f73e48e49de1bdfb$var$queue.length === 0) {
            var _now = $fKI31(), next = Math.max(0, $f73e48e49de1bdfb$var$frameDuration - (_now - $f73e48e49de1bdfb$var$last));
            $f73e48e49de1bdfb$var$last = next + _now;
            setTimeout(function() {
                var cp = $f73e48e49de1bdfb$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $f73e48e49de1bdfb$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($f73e48e49de1bdfb$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $f73e48e49de1bdfb$var$queue.push({
            handle: ++$f73e48e49de1bdfb$var$id,
            callback: callback,
            cancelled: false
        });
        return $f73e48e49de1bdfb$var$id;
    };
    $f73e48e49de1bdfb$var$caf = function(handle) {
        for(var i = 0; i < $f73e48e49de1bdfb$var$queue.length; i++)if ($f73e48e49de1bdfb$var$queue[i].handle === handle) $f73e48e49de1bdfb$var$queue[i].cancelled = true;
    };
}
module.exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $f73e48e49de1bdfb$var$raf.call($f73e48e49de1bdfb$var$root, fn);
};
module.exports.cancel = function() {
    $f73e48e49de1bdfb$var$caf.apply($f73e48e49de1bdfb$var$root, arguments);
};
module.exports.polyfill = function(object) {
    if (!object) object = $f73e48e49de1bdfb$var$root;
    object.requestAnimationFrame = $f73e48e49de1bdfb$var$raf;
    object.cancelAnimationFrame = $f73e48e49de1bdfb$var$caf;
};

});
parcelRegister("fKI31", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) module.exports = function() {
        return performance.now();
    };
    else if (typeof $2fFJv !== "undefined" && $2fFJv !== null && $2fFJv.hrtime) {
        module.exports = function() {
            return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };
        hrtime = $2fFJv.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        moduleLoadTime = getNanoSeconds();
        upTime = $2fFJv.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
    } else if (Date.now) {
        module.exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        module.exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call(module.exports);

});


parcelRegister("ggKCU", function(module, exports) {

var $4rg7t = parcelRequire("4rg7t");

var $700mw = parcelRequire("700mw");
var $bd824f08fddf0280$var$cache = {
    'float': 'cssFloat'
};

var $broEu = parcelRequire("broEu");
function $bd824f08fddf0280$var$style(element, property, value) {
    var camel = $bd824f08fddf0280$var$cache[property];
    if (typeof camel === 'undefined') camel = $bd824f08fddf0280$var$detect(property);
    // may be false if CSS prop is unsupported
    if (camel) {
        if (value === undefined) return element.style[camel];
        element.style[camel] = $broEu(camel, value);
    }
}
function $bd824f08fddf0280$var$each(element, properties) {
    for(var k in properties)if (properties.hasOwnProperty(k)) $bd824f08fddf0280$var$style(element, k, properties[k]);
}
function $bd824f08fddf0280$var$detect(cssProp) {
    var camel = $700mw(cssProp);
    var result = $4rg7t(camel);
    $bd824f08fddf0280$var$cache[camel] = $bd824f08fddf0280$var$cache[cssProp] = $bd824f08fddf0280$var$cache[result] = result;
    return result;
}
function $bd824f08fddf0280$var$set() {
    if (arguments.length === 2) {
        if (typeof arguments[1] === 'string') arguments[0].style.cssText = arguments[1];
        else $bd824f08fddf0280$var$each(arguments[0], arguments[1]);
    } else $bd824f08fddf0280$var$style(arguments[0], arguments[1], arguments[2]);
}
module.exports = $bd824f08fddf0280$var$set;
module.exports.set = $bd824f08fddf0280$var$set;
module.exports.get = function(element, properties) {
    if (Array.isArray(properties)) return properties.reduce(function(obj, prop) {
        obj[prop] = $bd824f08fddf0280$var$style(element, prop || '');
        return obj;
    }, {});
    else return $bd824f08fddf0280$var$style(element, properties || '');
};

});
parcelRegister("4rg7t", function(module, exports) {
var $33b6300d40a94b89$var$div = null;
var $33b6300d40a94b89$var$prefixes = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
module.exports = function prefixStyle(prop) {
    // re-use a dummy div
    if (!$33b6300d40a94b89$var$div) $33b6300d40a94b89$var$div = document.createElement('div');
    var style = $33b6300d40a94b89$var$div.style;
    // prop exists without prefix
    if (prop in style) return prop;
    // borderRadius -> BorderRadius
    var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1);
    // find the vendor-prefixed prop
    for(var i = $33b6300d40a94b89$var$prefixes.length; i >= 0; i--){
        var name = $33b6300d40a94b89$var$prefixes[i] + titleCase;
        // e.g. WebkitBorderRadius or webkitBorderRadius
        if (name in style) return name;
    }
    return false;
};

});

parcelRegister("700mw", function(module, exports) {

var $lenmq = parcelRequire("lenmq");
/**
 * Export.
 */ module.exports = $5188d06fbca336aa$var$toCamelCase;
/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */ function $5188d06fbca336aa$var$toCamelCase(string) {
    return $lenmq(string).replace(/\s(\w)/g, function(matches, letter) {
        return letter.toUpperCase();
    });
}

});
parcelRegister("lenmq", function(module, exports) {

var $dJO7v = parcelRequire("dJO7v");
/**
 * Export.
 */ module.exports = $f74d06b7617f5e3e$var$toSpaceCase;
/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */ function $f74d06b7617f5e3e$var$toSpaceCase(string) {
    return $dJO7v(string).replace(/[\W_]+(.|$)/g, function(matches, match) {
        return match ? ' ' + match : '';
    }).trim();
}

});
parcelRegister("dJO7v", function(module, exports) {
/**
 * Export.
 */ module.exports = $a0065b1cf00e2392$var$toNoCase;
/**
 * Test whether a string is camel-case.
 */ var $a0065b1cf00e2392$var$hasSpace = /\s/;
var $a0065b1cf00e2392$var$hasSeparator = /(_|-|\.|:)/;
var $a0065b1cf00e2392$var$hasCamel = /([a-z][A-Z]|[A-Z][a-z])/;
/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */ function $a0065b1cf00e2392$var$toNoCase(string) {
    if ($a0065b1cf00e2392$var$hasSpace.test(string)) return string.toLowerCase();
    if ($a0065b1cf00e2392$var$hasSeparator.test(string)) return ($a0065b1cf00e2392$var$unseparate(string) || string).toLowerCase();
    if ($a0065b1cf00e2392$var$hasCamel.test(string)) return $a0065b1cf00e2392$var$uncamelize(string).toLowerCase();
    return string.toLowerCase();
}
/**
 * Separator splitter.
 */ var $a0065b1cf00e2392$var$separatorSplitter = /[\W_]+(.|$)/g;
/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */ function $a0065b1cf00e2392$var$unseparate(string) {
    return string.replace($a0065b1cf00e2392$var$separatorSplitter, function(m, next) {
        return next ? ' ' + next : '';
    });
}
/**
 * Camelcase splitter.
 */ var $a0065b1cf00e2392$var$camelSplitter = /(.)([A-Z]+)/g;
/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */ function $a0065b1cf00e2392$var$uncamelize(string) {
    return string.replace($a0065b1cf00e2392$var$camelSplitter, function(m, previous, uppers) {
        return previous + ' ' + uppers.toLowerCase().split('').join(' ');
    });
}

});



parcelRegister("broEu", function(module, exports) {
/* The following list is defined in React's core */ var $854556b6004d12cd$var$IS_UNITLESS = {
    animationIterationCount: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridColumn: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    stopOpacity: true,
    strokeDashoffset: true,
    strokeOpacity: true,
    strokeWidth: true
};
module.exports = function(name, value) {
    if (typeof value === 'number' && !$854556b6004d12cd$var$IS_UNITLESS[name]) return value + 'px';
    else return value;
};

});


parcelRegister("jK96v", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $e5f9600a935931f7$var$isString;
function $e5f9600a935931f7$var$isString(maybe) {
    return typeof maybe === 'string';
}

});

parcelRegister("6LwRl", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $4ed09f13b7ea6c3d$var$getScrollbarWidth;

var $ggKCU = parcelRequire("ggKCU");
var $4ed09f13b7ea6c3d$var$_domCss2 = $4ed09f13b7ea6c3d$var$_interopRequireDefault($ggKCU);
function $4ed09f13b7ea6c3d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $4ed09f13b7ea6c3d$var$scrollbarWidth = false;
function $4ed09f13b7ea6c3d$var$getScrollbarWidth() {
    if ($4ed09f13b7ea6c3d$var$scrollbarWidth !== false) return $4ed09f13b7ea6c3d$var$scrollbarWidth;
    /* istanbul ignore else */ if (typeof document !== 'undefined') {
        var div = document.createElement('div');
        (0, $4ed09f13b7ea6c3d$var$_domCss2["default"])(div, {
            width: 100,
            height: 100,
            position: 'absolute',
            top: -9999,
            overflow: 'scroll',
            MsOverflowStyle: 'scrollbar'
        });
        document.body.appendChild(div);
        $4ed09f13b7ea6c3d$var$scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    } else $4ed09f13b7ea6c3d$var$scrollbarWidth = 0;
    return $4ed09f13b7ea6c3d$var$scrollbarWidth || 0;
}

});

parcelRegister("OTFeF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $098fd95ae479f4dc$var$returnFalse;
function $098fd95ae479f4dc$var$returnFalse() {
    return false;
}

});

parcelRegister("eoguQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $a7a01a6cef131059$var$getInnerWidth;
function $a7a01a6cef131059$var$getInnerWidth(el) {
    var clientWidth = el.clientWidth;
    var _getComputedStyle = getComputedStyle(el), paddingLeft = _getComputedStyle.paddingLeft, paddingRight = _getComputedStyle.paddingRight;
    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}

});

parcelRegister("ddLvN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $9a01581de272dbcf$var$getInnerHeight;
function $9a01581de272dbcf$var$getInnerHeight(el) {
    var clientHeight = el.clientHeight;
    var _getComputedStyle = getComputedStyle(el), paddingTop = _getComputedStyle.paddingTop, paddingBottom = _getComputedStyle.paddingBottom;
    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}

});

parcelRegister("evv3d", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a8fc0c0153193882$var$containerStyleDefault = module.exports.containerStyleDefault = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%'
};
// Overrides containerStyleDefault properties
var $a8fc0c0153193882$var$containerStyleAutoHeight = module.exports.containerStyleAutoHeight = {
    height: 'auto'
};
var $a8fc0c0153193882$var$viewStyleDefault = module.exports.viewStyleDefault = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch'
};
// Overrides viewStyleDefault properties
var $a8fc0c0153193882$var$viewStyleAutoHeight = module.exports.viewStyleAutoHeight = {
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined
};
var $a8fc0c0153193882$var$viewStyleUniversalInitial = module.exports.viewStyleUniversalInitial = {
    overflow: 'hidden',
    marginRight: 0,
    marginBottom: 0
};
var $a8fc0c0153193882$var$trackHorizontalStyleDefault = module.exports.trackHorizontalStyleDefault = {
    position: 'absolute',
    height: 6
};
var $a8fc0c0153193882$var$trackVerticalStyleDefault = module.exports.trackVerticalStyleDefault = {
    position: 'absolute',
    width: 6
};
var $a8fc0c0153193882$var$thumbHorizontalStyleDefault = module.exports.thumbHorizontalStyleDefault = {
    position: 'relative',
    display: 'block',
    height: '100%'
};
var $a8fc0c0153193882$var$thumbVerticalStyleDefault = module.exports.thumbVerticalStyleDefault = {
    position: 'relative',
    display: 'block',
    width: '100%'
};
var $a8fc0c0153193882$var$disableSelectStyle = module.exports.disableSelectStyle = {
    userSelect: 'none'
};
var $a8fc0c0153193882$var$disableSelectStyleReset = module.exports.disableSelectStyleReset = {
    userSelect: ''
};

});

parcelRegister("i7qJ5", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d30d9cb59132aa18$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
module.exports.renderViewDefault = $d30d9cb59132aa18$var$renderViewDefault;
module.exports.renderTrackHorizontalDefault = $d30d9cb59132aa18$var$renderTrackHorizontalDefault;
module.exports.renderTrackVerticalDefault = $d30d9cb59132aa18$var$renderTrackVerticalDefault;
module.exports.renderThumbHorizontalDefault = $d30d9cb59132aa18$var$renderThumbHorizontalDefault;
module.exports.renderThumbVerticalDefault = $d30d9cb59132aa18$var$renderThumbVerticalDefault;

var $eUqFw = parcelRequire("eUqFw");
var $d30d9cb59132aa18$var$_react2 = $d30d9cb59132aa18$var$_interopRequireDefault($eUqFw);
function $d30d9cb59132aa18$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d30d9cb59132aa18$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
/* eslint-disable react/prop-types */ function $d30d9cb59132aa18$var$renderViewDefault(props) {
    return $d30d9cb59132aa18$var$_react2["default"].createElement('div', props);
}
function $d30d9cb59132aa18$var$renderTrackHorizontalDefault(_ref) {
    var style = _ref.style, props = $d30d9cb59132aa18$var$_objectWithoutProperties(_ref, [
        'style'
    ]);
    var finalStyle = $d30d9cb59132aa18$var$_extends({}, style, {
        right: 2,
        bottom: 2,
        left: 2,
        borderRadius: 3
    });
    return $d30d9cb59132aa18$var$_react2["default"].createElement('div', $d30d9cb59132aa18$var$_extends({
        style: finalStyle
    }, props));
}
function $d30d9cb59132aa18$var$renderTrackVerticalDefault(_ref2) {
    var style = _ref2.style, props = $d30d9cb59132aa18$var$_objectWithoutProperties(_ref2, [
        'style'
    ]);
    var finalStyle = $d30d9cb59132aa18$var$_extends({}, style, {
        right: 2,
        bottom: 2,
        top: 2,
        borderRadius: 3
    });
    return $d30d9cb59132aa18$var$_react2["default"].createElement('div', $d30d9cb59132aa18$var$_extends({
        style: finalStyle
    }, props));
}
function $d30d9cb59132aa18$var$renderThumbHorizontalDefault(_ref3) {
    var style = _ref3.style, props = $d30d9cb59132aa18$var$_objectWithoutProperties(_ref3, [
        'style'
    ]);
    var finalStyle = $d30d9cb59132aa18$var$_extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return $d30d9cb59132aa18$var$_react2["default"].createElement('div', $d30d9cb59132aa18$var$_extends({
        style: finalStyle
    }, props));
}
function $d30d9cb59132aa18$var$renderThumbVerticalDefault(_ref4) {
    var style = _ref4.style, props = $d30d9cb59132aa18$var$_objectWithoutProperties(_ref4, [
        'style'
    ]);
    var finalStyle = $d30d9cb59132aa18$var$_extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return $d30d9cb59132aa18$var$_react2["default"].createElement('div', $d30d9cb59132aa18$var$_extends({
        style: finalStyle
    }, props));
}

});






parcelRegister("8VdSY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f7ec15d7d2c5131$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $5yvx1 = parcelRequire("5yvx1");

var $01OF3 = parcelRequire("01OF3");

var $f5bbs = parcelRequire("f5bbs");

var $4aSHd = parcelRequire("4aSHd");

var $5jaaH = parcelRequire("5jaaH");

var $aDSn9 = parcelRequire("aDSn9");
var $4f7ec15d7d2c5131$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state)=>({
        visibleColumnCount: (0, $01OF3.getVisibleColumnCount)(state),
        facade: (0, $01OF3.getFacade)(state),
        isVirtualised: (0, $5jaaH.getShouldVirtualize)(state),
        virtualBoundaries: (0, $5jaaH.getVirtualBoundaries)(state),
        viewportHeight: (0, $5jaaH.getTableContentHeight)(state),
        scrollTop: (0, $4aSHd.getVerticalScrollOffset)(state),
        defaultRowHeight: (0, $f5bbs.getDefaultRowHeight)(state),
        isHorizontalScrollVisible: (0, $5jaaH.hasHorizontalScrollbar)(state)
    }), {
    setVerticalScrollOffset: $5yvx1.setVertical
})((0, $aDSn9.default));

});
parcelRegister("aDSn9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0937da0f7c30da7e$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $511uv = parcelRequire("511uv");

var $5lVgU = parcelRequire("5lVgU");

var $6pOL1 = parcelRequire("6pOL1");

var $ajzlS = parcelRequire("ajzlS");

var $bCGks = parcelRequire("bCGks");
// eslint-disable-next-line jira/react/no-class-components
class $0937da0f7c30da7e$var$VerticalScrollbar extends (0, $eUqFw.PureComponent) {
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { scrollRef: scrollRef } = this;
        // Changing scrollTop will prevent continuation of the scrolling
        // animation in some browsers, so make sure we're not already in a
        // scroll event before setting it.
        if (scrollRef && !this.isScrolling) scrollRef.scrollTop(nextProps.scrollTop);
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "virtual-table.table.content.scrollbars.vertical.virtual-table-scrollbar-wrapper",
            ref: this.setTargetRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bCGks.default), {
            onScrollbarsRef: this.setScrollRef,
            height: this.calculateHeight(),
            onScrollStart: this.onScrollStart,
            onScrollStop: this.onScrollStop,
            onScrollFrame: this.onVerticalScroll
        }, children));
    }
    constructor(...args){
        super(...args);
        this.onVerticalScroll = ({ scrollTop: scrollTop })=>{
            const { setVerticalScrollOffset: setVerticalScrollOffset } = this.props;
            setVerticalScrollOffset(scrollTop);
        };
        this.onScrollStart = ()=>{
            const { isVirtualised: isVirtualised, facade: facade, visibleColumnCount: visibleColumnCount, virtualBoundaries: { displayStart: displayStart, displayEnd: displayEnd } } = this.props;
            (0, $511uv.getLongTasksMetrics)('scroll').start('virtual-table', undefined, {
                isVirtualised: isVirtualised,
                visibleColumnCount: visibleColumnCount,
                facade: facade,
                displayedRows: displayEnd - displayStart
            });
            this.isScrolling = true;
        };
        this.onScrollStop = ()=>{
            this.isScrolling = false;
            (0, $511uv.getLongTasksMetrics)('scroll').stop((0, $5lVgU.virtualTableScrollReporter));
        };
        this.setScrollRef = (ref)=>{
            this.scrollRef = ref;
        };
        this.setTargetRef = (ref)=>{
            this.targetRef = ref;
        };
        this.calculateHeight = ()=>{
            const { isHorizontalScrollVisible: isHorizontalScrollVisible, theme: theme, viewportHeight: viewportHeight } = this.props;
            if (theme.scrollbar.computeHeight && isHorizontalScrollVisible) {
                const spaceTakenByHorizontalScrollbar = (0, $ajzlS.scrollbarWidth) + theme.scrollbar.marginTop + theme.scrollbar.marginBottom;
                return viewportHeight - spaceTakenByHorizontalScrollbar;
            }
            return viewportHeight;
        };
    }
}
var $0937da0f7c30da7e$export$2e2bcd8739ae039 = (0, $6pOL1.withTheme)($0937da0f7c30da7e$var$VerticalScrollbar);

});
parcelRegister("511uv", function(module, exports) {

$parcel$export(module.exports, "getLongTasksMetrics", () => $6e4a680496b7cbbf$export$b092a8653a66aa5e);

var $jqvCZ = parcelRequire("jqvCZ");

var $6iz4v = parcelRequire("6iz4v");

var $hgcvd = parcelRequire("hgcvd");

var $7tZw9 = parcelRequire("7tZw9");
let $6e4a680496b7cbbf$var$observer = null;
const $6e4a680496b7cbbf$var$stopObserver = ()=>{
    if ($6e4a680496b7cbbf$var$observer) {
        $6e4a680496b7cbbf$var$observer.disconnect();
        $6e4a680496b7cbbf$var$observer = null;
    }
};
const $6e4a680496b7cbbf$export$b092a8653a66aa5e = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((type)=>{
    const clearData = {
        type: type
    };
    let isStarted = false;
    let observationData = {
        ...clearData
    };
    const isDnd = /dnd$/.test(type.toLowerCase());
    return {
        start: (appName, startPerformanceMark, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            if (window.PerformanceObserver && !isStarted) try {
                const startTimestamp = (0, $hgcvd.default).now();
                observationData = {
                    type: observationData.type,
                    startTimestamp: startTimestamp,
                    dragStartEndTimestamp: startTimestamp,
                    eventStartPerformanceMark: startPerformanceMark,
                    events: [],
                    appName: appName,
                    extra: extra
                };
                isStarted = true;
                $6e4a680496b7cbbf$var$stopObserver();
                $6e4a680496b7cbbf$var$observer = new window.PerformanceObserver((list)=>{
                    list.getEntries().forEach((entry)=>{
                        if (entry.entryType === 'longtask') {
                            if (!(0, $7tZw9.isExpandedObservationData)(observationData) || observationData.events.find((item)=>item.timestamp === entry.startTime && item.duration === entry.duration)) return;
                            observationData.events.push({
                                timestamp: entry.startTime,
                                duration: entry.duration
                            });
                        } else if (entry.entryType === 'event' && entry.name === 'dragstart') /**
								 * Use the observed event to compute the "end" timestamp of the dragstart event,
								 * which will be used for splitting the long tasks for dragstart and dragmove.
								 */ observationData.dragStartEndTimestamp = entry.startTime + entry.duration;
                    });
                });
                $6e4a680496b7cbbf$var$observer.observe({
                    type: 'longtask'
                });
                if (isDnd) /**
						 * Observe events with >48ms duration.
						 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceObserver/observe
						 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                $6e4a680496b7cbbf$var$observer.observe({
                    type: 'event',
                    durationThreshold: 48
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
            } catch (e) {}
        },
        stop: (callback, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            if ((0, $hgcvd.default).now && isStarted) {
                const stopTimestamp = (0, $hgcvd.default).now();
                setTimeout(()=>{
                    $6e4a680496b7cbbf$var$stopObserver();
                    callback({
                        ...observationData
                    }, extra, stopTimestamp);
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                });
            }
        },
        stopIfNoMark: (performanceMark)=>{
            if ($6e4a680496b7cbbf$var$observer && performanceMark) {
                const perfMark = (0, $6iz4v.getMark)(performanceMark);
                if (!perfMark) {
                    $6e4a680496b7cbbf$var$stopObserver();
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                }
            }
        }
    };
});

});
parcelRegister("7tZw9", function(module, exports) {

$parcel$export(module.exports, "isExpandedObservationData", () => $e45a8242e5c0159d$export$3d38a87309e205a4);
const $e45a8242e5c0159d$export$3d38a87309e205a4 = (observationData)=>observationData !== undefined && 'events' in observationData && observationData.events !== undefined;

});


parcelRegister("5lVgU", function(module, exports) {

$parcel$export(module.exports, "virtualTableScrollReporter", () => $c36cd1d02f210f48$export$4378f1933287fdc8);

var $x71UL = parcelRequire("x71UL");

var $7tZw9 = parcelRequire("7tZw9");

var $fPUXl = parcelRequire("fPUXl");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c36cd1d02f210f48$var$aggregatedDataTimeout = {};
const $c36cd1d02f210f48$export$4378f1933287fdc8 = (observationData)=>{
    if (!(0, $7tZw9.isExpandedObservationData)(observationData)) return;
    const startTime = observationData.events.map((event)=>event.timestamp);
    const analyticsData = {
        ...(0, $fPUXl.generateLongTaskAnalyticsContinuousActionSummary)('virtualTableScroll', observationData.events),
        measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime)
    };
    const { appName: appName } = observationData;
    if ($c36cd1d02f210f48$var$aggregatedDataTimeout[`common.${appName}.virtualTableScroll`]) $c36cd1d02f210f48$var$aggregatedDataTimeout[`common.${appName}.virtualTableScroll`].data.push(analyticsData);
    else $c36cd1d02f210f48$var$aggregatedDataTimeout[`common.${appName}.virtualTableScroll`] = {
        data: [
            analyticsData
        ],
        extra: observationData.extra,
        timeout: setTimeout(()=>{
            const { data: data, extra: extraData } = $c36cd1d02f210f48$var$aggregatedDataTimeout[`common.${appName}.virtualTableScroll`];
            const triggerAppAnalytics = (0, $fPUXl.triggerAnalytics)(`common.${appName}`);
            triggerAppAnalytics('long-tasks-virtual-table-scroll', {
                ...(0, $fPUXl.getAverageResultsFromContinuousActions)('virtualTableScroll', data),
                ...extraData,
                avgScrollTimespan: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, 'measureTimespan')
            });
            delete $c36cd1d02f210f48$var$aggregatedDataTimeout[`common.${appName}.virtualTableScroll`];
        }, 7000)
    };
};

});
parcelRegister("x71UL", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $6P7TZ = parcelRequire("6P7TZ");
/**
 * This method is like `_.mean` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be averaged.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the mean.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.meanBy(objects, function(o) { return o.n; });
 * // => 5
 *
 * // The `_.property` iteratee shorthand.
 * _.meanBy(objects, 'n');
 * // => 5
 */ function $0638892b8ae22890$var$meanBy(array, iteratee) {
    return $6P7TZ(array, $7qARj(iteratee, 2));
}
module.exports = $0638892b8ae22890$var$meanBy;

});
parcelRegister("6P7TZ", function(module, exports) {

var $835ZM = parcelRequire("835ZM");
/** Used as references for various `Number` constants. */ var $4f7da2b12e23c1f3$var$NAN = 0 / 0;
/**
 * The base implementation of `_.mean` and `_.meanBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the mean.
 */ function $4f7da2b12e23c1f3$var$baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? $835ZM(array, iteratee) / length : $4f7da2b12e23c1f3$var$NAN;
}
module.exports = $4f7da2b12e23c1f3$var$baseMean;

});
parcelRegister("835ZM", function(module, exports) {
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $5dc3411db180ba2c$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
module.exports = $5dc3411db180ba2c$var$baseSum;

});



parcelRegister("fPUXl", function(module, exports) {

$parcel$export(module.exports, "triggerAnalytics", () => $9e8129e894f8b784$export$2c57de8a70f64057);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummary", () => $9e8129e894f8b784$export$2be2635781d23aab);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummaryWithSlo", () => $9e8129e894f8b784$export$c674a20081e82c6a);
$parcel$export(module.exports, "getAverageResultsFromContinuousActions", () => $9e8129e894f8b784$export$c36fdc326d0c207c);
$parcel$export(module.exports, "generateLongTaskAnalyticsContinuousActionSummary", () => $9e8129e894f8b784$export$7e5f2df95eca342a);

var $x71UL = parcelRequire("x71UL");

var $4YjDD = parcelRequire("4YjDD");

var $9HwDQ = parcelRequire("9HwDQ");
const $9e8129e894f8b784$export$2c57de8a70f64057 = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $9e8129e894f8b784$export$2be2635781d23aab = (prefix, longTasks)=>{
    const durations = longTasks.map((task)=>task.duration);
    return {
        [`${prefix}LongTaskCount`]: longTasks.length,
        [`${prefix}LongTaskAvg`]: longTasks.length > 0 ? durations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0,
        [`${prefix}LongTaskMax`]: longTasks.length > 0 ? Math.max(...durations) : 0
    };
};
const $9e8129e894f8b784$export$c674a20081e82c6a = (prefix, longTasks, sloSettings)=>{
    const summary = $9e8129e894f8b784$export$2be2635781d23aab(prefix, longTasks);
    if (!sloSettings) return summary;
    const framerate = summary[`${prefix}LongTaskCount`] === 0 ? 20 : 1000 / summary[`${prefix}LongTaskAvg`];
    const blocktime = summary[`${prefix}LongTaskCount`] === 0 ? 0 : summary[`${prefix}LongTaskCount`] * summary[`${prefix}LongTaskAvg`];
    const isSuccess = framerate >= sloSettings.framerateThreshold && blocktime < sloSettings.blocktimeThreshold;
    return {
        [`${prefix}LongTaskSloIsSuccess`]: isSuccess,
        ...summary
    };
};
const $9e8129e894f8b784$export$c36fdc326d0c207c = (prefix, data)=>({
        [`${prefix}ClusterCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($9HwDQ)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterCountAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterAvg`) || 0,
        [`${prefix}ClusterDistanceAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterDistanceAvg`) || 0,
        [`${prefix}ClusterAvgLongTaskCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterAvgLongTaskCount`) || 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: data.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($4YjDD)))(data.map((entry)=>entry[`${prefix}ClusterAvgLongTaskCount`] * entry[`${prefix}ClusterAvgLongTaskAvg`])) / (0, (/*@__PURE__*/$parcel$interopDefault($9HwDQ)))(data, `${prefix}ClusterAvgLongTaskCount`) : 0,
        [`${prefix}Count`]: data.length
    });
const $9e8129e894f8b784$export$7e5f2df95eca342a = (prefix, longTasks)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clusters = longTasks.reduce((foundClusters, task)=>{
        if (foundClusters.length === 0) foundClusters.push({
            tasks: [],
            start: 0,
            stop: 0
        });
        const prevCluster = foundClusters[foundClusters.length - 1];
        const taskEnd = task.timestamp + task.duration;
        if (prevCluster.tasks.length === 0) {
            prevCluster.tasks.push(task);
            prevCluster.start = task.timestamp;
            prevCluster.stop = taskEnd;
        } else if (task.timestamp - prevCluster.stop < 100) {
            prevCluster.tasks.push(task);
            prevCluster.stop = taskEnd;
        } else foundClusters.push({
            tasks: [
                task
            ],
            start: task.timestamp,
            stop: taskEnd
        });
        return foundClusters;
    }, []);
    const clusterDurations = clusters.map((cluster)=>cluster.stop - cluster.start);
    const tasksDurations = longTasks.map((task)=>task.duration);
    const gapsBetweenClusters = clusters.length > 1 ? clusters // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((gaps, cluster, i)=>{
        if (gaps.length === 0) {
            gaps.push({
                start: cluster.stop,
                stop: null
            });
            return gaps;
        }
        // eslint-disable-next-line no-param-reassign
        gaps[gaps.length - 1].stop = cluster.start;
        if (i !== clusters.length - 1) gaps.push({
            start: cluster.stop,
            stop: null
        });
        return gaps;
    }, []).map((gap)=>gap.stop - gap.start) : [];
    return {
        [`${prefix}ClusterCount`]: clusters.length,
        [`${prefix}ClusterAvg`]: clusters.length > 0 ? clusterDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / clusters.length : 0,
        [`${prefix}ClusterDistanceAvg`]: gapsBetweenClusters.length > 0 ? gapsBetweenClusters.reduce((sumAcc, duration)=>sumAcc + duration, 0) / gapsBetweenClusters.length : 0,
        [`${prefix}ClusterAvgLongTaskCount`]: clusters.length > 0 ? clusters.map((cluster)=>cluster.tasks.length).reduce((sumAcc, count)=>sumAcc + count, 0) / clusters.length : 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: longTasks.length > 0 ? tasksDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0
    };
};

});
parcelRegister("4YjDD", function(module, exports) {

var $835ZM = parcelRequire("835ZM");

var $3QMTK = parcelRequire("3QMTK");
/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function $39ebffc448745d7b$var$sum(array) {
    return array && array.length ? $835ZM(array, $3QMTK) : 0;
}
module.exports = $39ebffc448745d7b$var$sum;

});

parcelRegister("9HwDQ", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $835ZM = parcelRequire("835ZM");
/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */ function $7101732f00f14013$var$sumBy(array, iteratee) {
    return array && array.length ? $835ZM(array, $7qARj(iteratee, 2)) : 0;
}
module.exports = $7101732f00f14013$var$sumBy;

});



parcelRegister("bCGks", function(module, exports) {

$parcel$export(module.exports, "default", () => $8740e269afeb68b2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $97YHm = parcelRequire("97YHm");
class $8740e269afeb68b2$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            className: '',
            onScrollbarsRef: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onScrollFrame: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onScrollStart: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onScrollStop: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    render() {
        const { className: className, onScrollbarsRef: onScrollbarsRef, onScrollFrame: onScrollFrame, onScrollStart: onScrollStart, onScrollStop: onScrollStop, children: children, height: height } = this.props;
        /* className is passed down to enable styled component composition */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $97YHm.StyledScrollbars), {
            style: {
                height: `${height}px`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: onScrollbarsRef,
            onScrollFrame: onScrollFrame,
            onScrollStart: onScrollStart,
            onScrollStop: onScrollStop,
            renderTrackVertical: this.renderVerticalTrack,
            renderThumbVertical: this.renderVerticalThumb,
            renderTrackHorizontal: this.renderHorizontalTrack,
            renderThumbHorizontal: this.renderHorizontalThumb,
            hideTracksWhenNotNeeded: true
        }, children);
    }
    constructor(...args){
        super(...args);
        this.renderVerticalTrack = (props)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: props.ref,
                style: props.style,
                className: "track-vertical"
            });
        this.renderVerticalThumb = (props)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: props.ref,
                style: props.style,
                className: "thumb-vertical"
            });
        this.renderHorizontalTrack = (props)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: props.ref,
                style: props.style,
                className: "track-horizontal"
            });
        this.renderHorizontalThumb = (props)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: props.ref,
                style: props.style,
                className: "thumb-horizontal"
            });
    }
}

});



parcelRegister("3iPgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f50f0b893fd8c57$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $4Bkxm = parcelRequire("4Bkxm");

var $kQgJP = parcelRequire("kQgJP");

var $UsjWM = parcelRequire("UsjWM");

var $76Cwi = parcelRequire("76Cwi");
var $7f50f0b893fd8c57$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state)=>({
        coreColumnsWidth: (0, $4Bkxm.getVisibleCoreColumnsWidth)(state),
        AddLink: $kQgJP.default,
        ScrollArea: $76Cwi.default
    }), {})((0, $UsjWM.default));

});
parcelRegister("kQgJP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9c5b9ac4b87b90f$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");


var $01OF3 = parcelRequire("01OF3");

var $f5bbs = parcelRequire("f5bbs");

var $4aSHd = parcelRequire("4aSHd");

var $5jaaH = parcelRequire("5jaaH");

var $20duf = parcelRequire("20duf");
var $a9c5b9ac4b87b90f$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state)=>{
    const sortedRowIds = (0, $4aSHd.getSortedRowIdsHash)(state)[0, $7872bfc970cd976d$export$59c500c4e33fdb0];
    return {
        addLinkCaption: (0, $f5bbs.getAddLinkCaption)(state),
        lastRowId: sortedRowIds && sortedRowIds[sortedRowIds.length - 1],
        isVisible: (0, $5jaaH.isAddLinkShown)(state),
        onRowAddRequested: (0, $01OF3.getRowAddCallback)(state),
        addBarOverflow: (0, $f5bbs.getAddBarOverflow)(state)
    };
}, {})((0, $20duf.default));

});
parcelRegister("20duf", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b6546052f6d9af1$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $6pOL1 = parcelRequire("6pOL1");

var $ajzlS = parcelRequire("ajzlS");
const $0b6546052f6d9af1$var$wrapperBaseStyle = null;
const $0b6546052f6d9af1$var$Wrapper = ({ addBarOverflow: addBarOverflow, theme: theme, padding: padding, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            paddingRight: `${padding}px`,
            paddingTop: `${padding}px`,
            paddingBottom: `${padding}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingLeft: `${(0, $ajzlS.levelIndentBaseline)}px`,
            marginTop: `-${addBarOverflow + theme.row.borderWidth}px`
        },
        className: (0, $7JEyt.default)([
            "_otyru2gc"
        ])
    }, children);
// eslint-disable-next-line jira/react/no-class-components
class $0b6546052f6d9af1$var$AddLink extends (0, $eUqFw.PureComponent) {
    renderAddLink() {
        const { addLinkCaption: addLinkCaption, addBarOverflow: addBarOverflow, theme: theme } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b6546052f6d9af1$var$Wrapper, {
            addBarOverflow: addBarOverflow,
            theme: theme,
            padding: (theme.row.defaultHeight - (0, $ajzlS.akButtonHeight)) / 2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: this.onRowAddRequested,
            appearance: "subtle-link",
            testId: "virtual-table.table.content.utility-row.add-link.button"
        }, addLinkCaption));
    }
    render() {
        const { isVisible: isVisible } = this.props;
        return isVisible ? this.renderAddLink() : null;
    }
    constructor(...args){
        super(...args);
        this.onRowAddRequested = ()=>{
            const { lastRowId: lastRowId, onRowAddRequested: onRowAddRequested } = this.props;
            onRowAddRequested && onRowAddRequested({
                anchorId: lastRowId,
                position: lastRowId ? 'AFTER' : 'LAST'
            });
        };
    }
}
var $0b6546052f6d9af1$export$2e2bcd8739ae039 = (0, $6pOL1.withTheme)($0b6546052f6d9af1$var$AddLink);

});


parcelRegister("UsjWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $226dee0ece5bd654$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
function $226dee0ece5bd654$export$2e2bcd8739ae039(props) {
    const { coreColumnsWidth: coreColumnsWidth, AddLink: AddLink, ScrollArea: ScrollArea } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($226dee0ece5bd654$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($226dee0ece5bd654$var$CoreWidthPlaceholder, {
        width: coreColumnsWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AddLink, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ScrollArea, null));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $226dee0ece5bd654$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $226dee0ece5bd654$var$CoreWidthPlaceholder = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1bsb1hdq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("76Cwi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3aeea009e39a885$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $f5bbs = parcelRequire("f5bbs");

var $5jaaH = parcelRequire("5jaaH");

var $dHcAn = parcelRequire("dHcAn");

var $knCEK = parcelRequire("knCEK");
var $c3aeea009e39a885$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state)=>({
        rowsHeight: (0, $5jaaH.getTableRowsHeight)(state),
        contentHeight: (0, $5jaaH.getTableContentHeight)(state),
        contentWidth: (0, $5jaaH.getVisibleAdditionalColumnsWidth)(state),
        isAddLinkShown: (0, $5jaaH.isAddLinkShown)(state),
        addBarOverflow: (0, $f5bbs.getAddBarOverflow)(state),
        AdditionalColumnsContainer: $dHcAn.default
    }), {})((0, $knCEK.default));

});
parcelRegister("knCEK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b50ae5ed4b1e9a79$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $6pOL1 = parcelRequire("6pOL1");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b50ae5ed4b1e9a79$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { addBarOverflow: addBarOverflow, theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`),
            "--_j34cc7": (0, $9t7rW.default)(`-${__cmplp.addBarOverflow + __cmplp.theme.row.borderWidth}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _4t3i2nrh _19pk1w53 _otyru2gc",
            __cmplp.className
        ])
    });
});
const $b50ae5ed4b1e9a79$var$FakeContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`),
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1bsb1hdq _4t3i2nrh",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $b50ae5ed4b1e9a79$var$ScrollArea extends (0, $eUqFw.PureComponent) {
    getAreaHeight() {
        const { rowsHeight: rowsHeight, contentHeight: contentHeight, isAddLinkShown: isAddLinkShown, theme: theme } = this.props;
        // we are reducing Scrollbar height in src/common/components/virtual-table/view/table/content/scrollbars/vertical
        // /index-dumb.js to accommodate stuff below table within the viewport.
        // Utility Row takes whatever height is left below rowList on the viewport hence need to reduce it here as well
        // else it is introducing vertical scroll even if we do not have enough rows to scroll.
        const spareContentSpace = contentHeight - rowsHeight - (theme.scrollbar.offset - theme.scrollbar.paddingTop);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { defaultHeight: defaultHeight } = theme.row;
        const addLinkSpace = isAddLinkShown ? defaultHeight : 0;
        return spareContentSpace > 0 ? spareContentSpace : addLinkSpace;
    }
    render() {
        const { contentWidth: contentWidth, AdditionalColumnsContainer: AdditionalColumnsContainer, addBarOverflow: addBarOverflow, theme: theme } = this.props;
        const areaHeight = this.getAreaHeight();
        // there is either
        // 1) no space required to be filled, or the add link is not visible
        // 2) no visible additional rows/details panel is open (as derived by no content width)
        if (areaHeight === 0 || contentWidth === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b50ae5ed4b1e9a79$var$Wrapper, {
            height: areaHeight,
            addBarOverflow: addBarOverflow,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AdditionalColumnsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b50ae5ed4b1e9a79$var$FakeContent, {
            width: contentWidth,
            height: areaHeight
        })));
    }
}
var $b50ae5ed4b1e9a79$export$2e2bcd8739ae039 = (0, $6pOL1.withTheme)($b50ae5ed4b1e9a79$var$ScrollArea);

});





parcelRegister("aAprJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $eddd51a13ee54e44$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $eRWTs = parcelRequire("eRWTs");

var $4Bkxm = parcelRequire("4Bkxm");

var $01OF3 = parcelRequire("01OF3");

var $f5bbs = parcelRequire("f5bbs");

var $4aSHd = parcelRequire("4aSHd");

var $5jaaH = parcelRequire("5jaaH");

var $dHcAn = parcelRequire("dHcAn");

var $jFubm = parcelRequire("jFubm");

var $jsVgu = parcelRequire("jsVgu");

var $jSyf0 = parcelRequire("jSyf0");
var $eddd51a13ee54e44$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state)=>({
        coreColumnIds: (0, $4Bkxm.getVisibleCoreColumnIds)(state),
        additionalColumnIds: (0, $01OF3.getVisibleAdditionalColumnIds)(state),
        isColumnConfigurationVisible: (0, $01OF3.isColumnConfigurationVisible)(state),
        hasVerticallyScrolled: (0, $4aSHd.hasVerticallyScrolled)(state),
        tableHasLeftShadow: (0, $5jaaH.isHorizontalScrollLeftShadowVisible)(state),
        tableHasRightShadow: (0, $5jaaH.isHorizontalScrollRightShadowVisible)(state),
        bottomShadowWidth: (0, $4aSHd.getTableWidthWithoutScrollbarOffset)(state),
        isAutoRowHeight: (0, $f5bbs.isAutoRowHeight)(state),
        AdditionalColumnsContainer: $dHcAn.default,
        Column: $jFubm.default,
        ColumnConfiguration: $jsVgu.default
    }), {
    setHeaderHeight: $eRWTs.set
})((0, $jSyf0.default));

});
parcelRegister("eRWTs", function(module, exports) {

$parcel$export(module.exports, "SET_HEADER_HEIGHT", () => $922b92c6dbaea3e9$export$e52e6a4be99a8322);
$parcel$export(module.exports, "set", () => $922b92c6dbaea3e9$export$adaa4cf7ef1b65be);
const $922b92c6dbaea3e9$export$e52e6a4be99a8322 = 'ops.header.size.SET_HEADER_HEIGHT';
const $922b92c6dbaea3e9$export$adaa4cf7ef1b65be = (height)=>({
        type: $922b92c6dbaea3e9$export$e52e6a4be99a8322,
        payload: height
    });

});

parcelRegister("jFubm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a2036c1b35ba30e$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $54PsC = parcelRequire("54PsC");

var $2VHY1 = parcelRequire("2VHY1");
var $7a2036c1b35ba30e$export$2e2bcd8739ae039 = (0, $7vbEf.connect)(()=>({
        DynamicColumnComponent: $54PsC.default
    }), {})((0, $2VHY1.default));

});
parcelRegister("54PsC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b47810209c3271ec$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6BLrc = parcelRequire("6BLrc");
function $b47810209c3271ec$export$2e2bcd8739ae039(props) {
    const { id: id } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6BLrc.default), {
        id: id
    });
}

});
parcelRegister("6BLrc", function(module, exports) {

$parcel$export(module.exports, "default", () => $fab1200888e5ab89$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $4Bkxm = parcelRequire("4Bkxm");

var $5jaaH = parcelRequire("5jaaH");

var $lXyux = parcelRequire("lXyux");

var $h3cJd = parcelRequire("h3cJd");
var $fab1200888e5ab89$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state, { id: id })=>({
        width: (0, $5jaaH.getColumnWidth)(state, id),
        isFirstColumn: (0, $4Bkxm.isFirstColumn)(state, id),
        DefaultColumn: $lXyux.default
    }), {})((0, $h3cJd.default));

});
parcelRegister("lXyux", function(module, exports) {

$parcel$export(module.exports, "default", () => $42e4517cef9090e0$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $4Bkxm = parcelRequire("4Bkxm");

var $6KHdw = parcelRequire("6KHdw");

var $aU2If = parcelRequire("aU2If");
var $42e4517cef9090e0$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state, { id: id })=>({
        title: (0, $4Bkxm.getColumnTitle)(state, id),
        HeaderComponent: (0, $4Bkxm.getColumnHeaderComponent)(state, id),
        tooltip: (0, $4Bkxm.getColumnTooltip)(state, id),
        isChild: (0, $4Bkxm.isChildColumn)(state, id),
        isParent: (0, $4Bkxm.isParentColumn)(state, id),
        parentId: (0, $4Bkxm.getParentId)(state, id),
        Column: $6KHdw.default
    }), {})((0, $aU2If.default));

});
parcelRegister("6KHdw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a693819d2d3193c$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $4Bkxm = parcelRequire("4Bkxm");

var $1zkGk = parcelRequire("1zkGk");

var $aQNw9 = parcelRequire("aQNw9");

var $jXyzM = parcelRequire("jXyzM");

var $kBUsF = parcelRequire("kBUsF");
var $3a693819d2d3193c$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state, props)=>({
        ChildBar: $1zkGk.default,
        ColumnChildOperationIndicator: $aQNw9.default,
        ColumnSortOperationIndicator: $jXyzM.default,
        isCoreColumn: (0, $4Bkxm.isVisibleCoreColumn)(state, props.id)
    }), {})((0, $kBUsF.default));

});
parcelRegister("1zkGk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4c305eda2733318$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $4Bkxm = parcelRequire("4Bkxm");

var $fR8fo = parcelRequire("fR8fo");
var $a4c305eda2733318$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state, { columnId: columnId })=>({
        backgroundColor: (0, $4Bkxm.getColumnColor)(state, columnId)
    }), {})((0, $fR8fo.default));

});
parcelRegister("fR8fo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c91903394b400676$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
function $c91903394b400676$export$2e2bcd8739ae039(props) {
    const { backgroundColor: backgroundColor } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c91903394b400676$var$BarBackground, {
        backgroundColor: backgroundColor
    });
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c91903394b400676$var$BarBackground = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1xi2idpf _1ltvidpf _4t3iyh40 _bfhk3qkl _tzy41v3n",
            __cmplp.className
        ])
    });
});

});


parcelRegister("aQNw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d6e33be8db3169d$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $4Bkxm = parcelRequire("4Bkxm");

var $01OF3 = parcelRequire("01OF3");

var $OwuIN = parcelRequire("OwuIN");
var $0d6e33be8db3169d$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state, { columnId: columnId })=>({
        isParentColumn: (0, $4Bkxm.isParentColumn)(state, columnId),
        isColumnExpanded: (0, $4Bkxm.isColumnExpanded)(state, columnId),
        columnHasChildren: (0, $4Bkxm.getColumnHasChildren)(state, columnId),
        color: (0, $4Bkxm.getColumnColor)(state, columnId),
        onColumnExpansionChangeRequested: (0, $01OF3.getColumnExpandCallback)(state)
    }), {})((0, $OwuIN.default));

});
parcelRegister("OwuIN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9710cf9085b2abe$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $9mdqb = parcelRequire("9mdqb");

var $413Az = parcelRequire("413Az");

var $aqbuV = parcelRequire("aqbuV");
const $e9710cf9085b2abe$export$fd2a14967cd13576 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1bsbutpp _2hwx12x7 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $e9710cf9085b2abe$export$ff0bdaf3b6126558 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { columnHasChildren: columnHasChildren, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbutpp _4t3iutpp _kqswh2mm _tzy41v3n _16l4kb7n",
            __cmplp.columnHasChildren ? "_80omtlke" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $e9710cf9085b2abe$export$53c3957bbb0bab2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf _bfhk1cj8",
            __cmplp.className
        ])
    });
});
const $e9710cf9085b2abe$export$b6be64795e38ec8c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.className
        ])
    });
});
const $e9710cf9085b2abe$export$bebc7a423c9a9514 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $e9710cf9085b2abe$export$b6be64795e38ec8c, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_euc18": (0, $9t7rW.default)((0, (/*@__PURE__*/$parcel$interopDefault($413Az))), ")", "url(")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1itknvb0",
            __cmplp.className
        ])
    });
});
const $e9710cf9085b2abe$export$169f51fb2902d283 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $e9710cf9085b2abe$export$b6be64795e38ec8c, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1oumqk1": (0, $9t7rW.default)((0, (/*@__PURE__*/$parcel$interopDefault($aqbuV))), ")", "url(")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1itk1oyw",
            __cmplp.className
        ])
    });
});
const $e9710cf9085b2abe$export$6cdf59eef5a3aef5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $e9710cf9085b2abe$export$b6be64795e38ec8c, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1fpc7jq": (0, $9t7rW.default)((0, (/*@__PURE__*/$parcel$interopDefault($9mdqb))), ")", "url(")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1itkplyw",
            __cmplp.className
        ])
    });
});
class $e9710cf9085b2abe$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            columnHasChildren: undefined
        };
    }
    renderExpansionIndicator() {
        const { columnHasChildren: columnHasChildren, isColumnExpanded: isColumnExpanded } = this.props;
        if (columnHasChildren === true) {
            if (isColumnExpanded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9710cf9085b2abe$export$6cdf59eef5a3aef5, null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9710cf9085b2abe$export$169f51fb2902d283, null);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9710cf9085b2abe$export$bebc7a423c9a9514, null);
    }
    renderExpansionIndicatorContainer() {
        const { color: color, columnHasChildren: columnHasChildren } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9710cf9085b2abe$export$ff0bdaf3b6126558, {
            onClick: this.onColumnExpanded,
            columnHasChildren: columnHasChildren,
            role: "button",
            tabIndex: 0,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && this.onColumnExpanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9710cf9085b2abe$export$53c3957bbb0bab2, {
            color: color
        }), this.renderExpansionIndicator());
    }
    render() {
        return this.props.isParentColumn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9710cf9085b2abe$export$fd2a14967cd13576, null, this.renderExpansionIndicatorContainer());
    }
    constructor(...args){
        super(...args);
        this.onColumnExpanded = ()=>{
            const { columnId: columnId, isColumnExpanded: isColumnExpanded, columnHasChildren: columnHasChildren, onColumnExpansionChangeRequested: onColumnExpansionChangeRequested } = this.props;
            // neutral indicators should not be actionable
            if (columnHasChildren === true) onColumnExpansionChangeRequested({
                columnId: columnId,
                shouldExpand: !isColumnExpanded
            });
        };
    }
}

});
parcelRegister("9mdqb", function(module, exports) {
module.exports = new URL("minus-mask.a30c8bf5.svg", import.meta.url).toString();

});

parcelRegister("413Az", function(module, exports) {
module.exports = new URL("neutral-mask.7cced194.svg", import.meta.url).toString();

});

parcelRegister("aqbuV", function(module, exports) {
module.exports = new URL("plus-mask.26076cf9.svg", import.meta.url).toString();

});



parcelRegister("jXyzM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5661279aff7763e4$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $fkLMy = parcelRequire("fkLMy");

var $af0lw = parcelRequire("af0lw");

var $4Bkxm = parcelRequire("4Bkxm");

var $01OF3 = parcelRequire("01OF3");

var $f5bbs = parcelRequire("f5bbs");

var $5jaaH = parcelRequire("5jaaH");

var $47dcL = parcelRequire("47dcL");
var $5661279aff7763e4$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state, { columnId: columnId })=>({
        sortOrder: (0, $5jaaH.getColumnSortOrder)(state, columnId),
        isColumnSortable: (0, $4Bkxm.isColumnSortable)(state, columnId),
        isSortEnabled: !(0, $f5bbs.isAnyRowBeingAdded)(state),
        isDefaultSortColumn: (0, $4Bkxm.getDefaultComparator)(state) === columnId,
        onClearAddedRowsRequested: (0, $01OF3.getClearAddedRowsCallback)(state),
        onSortedColumnChanged: (0, $01OF3.getSortedColumnChangedCallback)(state)
    }), {
    setColumnSortOrder: (0, $af0lw.set),
    clearColumnSortOrder: (0, $fkLMy.clear)
})((0, $47dcL.default));

});
parcelRegister("fkLMy", function(module, exports) {

$parcel$export(module.exports, "CLEAR_COLUMN_SORT_ORDER", () => $b288796472232947$export$875ad0918a4254f7);
$parcel$export(module.exports, "clear", () => $b288796472232947$export$42ffd38884aecdac);
const $b288796472232947$export$875ad0918a4254f7 = 'ops.columns.sorting.clear.CLEAR_COLUMN_SORT_ORDER';
const $b288796472232947$export$42ffd38884aecdac = ()=>({
        type: $b288796472232947$export$875ad0918a4254f7,
        payload: undefined
    });

});

parcelRegister("af0lw", function(module, exports) {

$parcel$export(module.exports, "SET_COLUMN_SORT_ORDER", () => $43faac4cf0225594$export$d353d2412612deea);
$parcel$export(module.exports, "set", () => $43faac4cf0225594$export$adaa4cf7ef1b65be);
const $43faac4cf0225594$export$d353d2412612deea = 'ops.columns.sorting.set.SET_COLUMN_SORT_ORDER';
const $43faac4cf0225594$export$adaa4cf7ef1b65be = (payload)=>({
        type: $43faac4cf0225594$export$d353d2412612deea,
        payload: payload
    });

});

parcelRegister("47dcL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c89caa74cc64e87c$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gg6kf = parcelRequire("gg6kf");
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c89caa74cc64e87c$var$SortIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { image: image, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_y0q4cp": (0, $9t7rW.default)(__cmplp.image, ")", "url(")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1bsbftgi _4t3i1osq _11q71izh _1itk1lpx _18u012x7 _80omtlke",
            __cmplp.className
        ])
    });
});
class $c89caa74cc64e87c$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            sortOrder: undefined
        };
    }
    setSortOrder(nextSortOrder) {
        return ()=>{
            const { columnId: columnId, setColumnSortOrder: setColumnSortOrder, onSortedColumnChanged: onSortedColumnChanged } = this.props;
            const payload = {
                columnId: columnId,
                sortOrder: nextSortOrder
            };
            setColumnSortOrder(payload);
            onSortedColumnChanged(payload);
        };
    }
    clearSortOrder() {
        return ()=>{
            const { clearColumnSortOrder: clearColumnSortOrder, onSortedColumnChanged: onSortedColumnChanged } = this.props;
            clearColumnSortOrder();
            onSortedColumnChanged(undefined);
        };
    }
    /* Along with sorting, any rows that were added since the last sort
   * and thus positioned "absolutely" should be discarded to allow for
   * explicit sorting once again.
   */ createClickAction(sortSpecificCallbacks) {
        return ()=>{
            const { onClearAddedRowsRequested: onClearAddedRowsRequested } = this.props;
            sortSpecificCallbacks();
            onClearAddedRowsRequested();
        };
    }
    renderSortOperationIndicator() {
        const { sortOrder: sortOrder, isDefaultSortColumn: isDefaultSortColumn } = this.props;
        const { nextSortOrder: nextSortOrder, image: image } = isDefaultSortColumn ? (0, $gg6kf.DEFAULT_SORT_INDICATOR_METADATA)[sortOrder || 'DEFAULT'] : (0, $gg6kf.INDICATOR_METADATA)[sortOrder || 'DEFAULT'];
        const clickAction = nextSortOrder === 'DEFAULT' ? this.createClickAction(this.clearSortOrder()) : this.createClickAction(this.setSortOrder(nextSortOrder));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c89caa74cc64e87c$var$SortIndicator, {
            onClick: clickAction,
            image: image,
            role: "button",
            tabIndex: 0,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && clickAction
        });
    }
    render() {
        const { isColumnSortable: isColumnSortable, isSortEnabled: isSortEnabled } = this.props;
        return isColumnSortable && isSortEnabled ? this.renderSortOperationIndicator() : null;
    }
}

});
parcelRegister("gg6kf", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_SORT_INDICATOR_METADATA", () => $b3e74669f94d7202$export$cc67c62619d38570);
$parcel$export(module.exports, "INDICATOR_METADATA", () => $b3e74669f94d7202$export$319f25ddc8a4a7f2);


var $gb7VO = parcelRequire("gb7VO");

var $93L3J = parcelRequire("93L3J");

var $jFbmJ = parcelRequire("jFbmJ");
const $b3e74669f94d7202$export$cc67c62619d38570 = {
    DESCENDING: {
        nextSortOrder: (0, $c947ad34bf4dc375$export$6e386ac144cffab5),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($jFbmJ)))
    },
    ASCENDING: {
        nextSortOrder: (0, $c947ad34bf4dc375$export$f634ff5a7f1c8f3),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($93L3J)))
    },
    DEFAULT: {
        nextSortOrder: (0, $c947ad34bf4dc375$export$6e386ac144cffab5),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($gb7VO)))
    }
};
const $b3e74669f94d7202$export$319f25ddc8a4a7f2 = {
    DESCENDING: {
        nextSortOrder: 'DEFAULT',
        image: (0, (/*@__PURE__*/$parcel$interopDefault($jFbmJ)))
    },
    ASCENDING: {
        nextSortOrder: (0, $c947ad34bf4dc375$export$f634ff5a7f1c8f3),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($93L3J)))
    },
    DEFAULT: {
        nextSortOrder: (0, $c947ad34bf4dc375$export$6e386ac144cffab5),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($gb7VO)))
    }
};

});
parcelRegister("gb7VO", function(module, exports) {
module.exports = new URL("sortable-indicator.e7b63888.svg", import.meta.url).toString();

});

parcelRegister("93L3J", function(module, exports) {
module.exports = new URL("sorted-indicator-asc.99c81f7a.svg", import.meta.url).toString();

});

parcelRegister("jFbmJ", function(module, exports) {
module.exports = new URL("sorted-indicator-desc.ee65fbfe.svg", import.meta.url).toString();

});




parcelRegister("kBUsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e28d2f1e839adef1$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eoCgY = parcelRequire("eoCgY");

var $IxOJr = parcelRequire("IxOJr");
// we only show the coloured top border for child columns that themselves are no parents
// @ts-expect-error - TS7006 - Parameter 'isChild' implicitly has an 'any' type. | TS7006 - Parameter 'isParent' implicitly has an 'any' type.
const $e28d2f1e839adef1$var$hasChildColumnAppearance = (isChild, isParent)=>isChild && !isParent;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e28d2f1e839adef1$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstColumn: isFirstColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_14tplr7": (0, $9t7rW.default)((0, $IxOJr.getWidth)({
                width: __cmplp.width,
                isFirstColumn: __cmplp.isFirstColumn
            }))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbssom _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _kqswh2mm _vchhusvi _1yt4h8dc _irr34m1f",
            __cmplp.className
        ])
    });
});
const $e28d2f1e839adef1$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isChild: isChild, isParent: isParent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zkb7n _i0dl1wug _k48p8n31 _vwz41u1b _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            $e28d2f1e839adef1$var$hasChildColumnAppearance(__cmplp.isChild, __cmplp.isParent) ? "_1wyb1crf" : "_1wybdlk8",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $e28d2f1e839adef1$var$DumbColumn extends (0, $eUqFw.PureComponent) {
    renderChildOperationIndicator() {
        const { id: id, ColumnChildOperationIndicator: ColumnChildOperationIndicator } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ColumnChildOperationIndicator, {
            columnId: id
        });
    }
    renderSortingOperationIndicator() {
        const { id: id, ColumnSortOperationIndicator: ColumnSortOperationIndicator } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ColumnSortOperationIndicator, {
            columnId: id
        });
    }
    renderChildBar() {
        const { isChild: isChild, isParent: isParent, ChildBar: ChildBar, id: id } = this.props;
        if ($e28d2f1e839adef1$var$hasChildColumnAppearance(isChild, isParent)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChildBar, {
            columnId: id
        });
        return null;
    }
    renderTitle() {
        const { title: title } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eoCgY)))(title)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return title;
        const InnerTitle = title;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InnerTitle, null);
    }
    render() {
        const { id: id, title: title, width: width, tooltip: tooltip, isChild: isChild, isParent: isParent, HeaderComponent: HeaderComponent, isFirstColumn: isFirstColumn } = this.props;
        return HeaderComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeaderComponent, {
            columnId: id,
            title: title,
            width: width
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e28d2f1e839adef1$var$Wrapper, {
            // @ts-expect-error - TS2322 - Type 'Optional<string | Element>' is not assignable to type 'string | undefined'.
            title: tooltip,
            width: width,
            isFirstColumn: isFirstColumn
        }, this.renderChildOperationIndicator(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e28d2f1e839adef1$var$Title, {
            isChild: isChild,
            isParent: isParent
        }, this.renderTitle()), this.renderSortingOperationIndicator(), this.renderChildBar());
    }
}
var $e28d2f1e839adef1$export$2e2bcd8739ae039 = $e28d2f1e839adef1$var$DumbColumn;

});


parcelRegister("aU2If", function(module, exports) {

$parcel$export(module.exports, "default", () => $62d95e3040775900$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $62d95e3040775900$export$2e2bcd8739ae039({ Column: Column, id: id, title: title, HeaderComponent: HeaderComponent, tooltip: tooltip, width: width, isChild: isChild, isParent: isParent, parentId: parentId, isFirstColumn: isFirstColumn }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Column, {
        id: id,
        title: title,
        HeaderComponent: HeaderComponent,
        tooltip: tooltip,
        width: width,
        isChild: isChild,
        isParent: isParent,
        parentId: parentId,
        isFirstColumn: isFirstColumn
    });
}

});


parcelRegister("h3cJd", function(module, exports) {

$parcel$export(module.exports, "default", () => $d56326636734dc17$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $IxOJr = parcelRequire("IxOJr");
class $d56326636734dc17$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {};
    }
    render() {
        const { id: id, width: width, isFirstColumn: isFirstColumn, DefaultColumn: DefaultColumn } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d56326636734dc17$var$Wrapper, {
            width: width,
            isFirstColumn: isFirstColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DefaultColumn, {
            id: id,
            width: width,
            isFirstColumn: isFirstColumn
        }));
    }
}
const $d56326636734dc17$var$wrapperStyles = null;
const $d56326636734dc17$var$wrapperMarginLeftStylesMap = {
    firstColumn: "_18u01ejb",
    otherColumn: "_18u0ze3t"
};
const $d56326636734dc17$var$Wrapper = ({ isFirstColumn: isFirstColumn, width: width, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            width: (0, $IxOJr.getWidth)({
                width: width,
                isFirstColumn: isFirstColumn
            })
        },
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _kqswh2mm",
            $d56326636734dc17$var$wrapperMarginLeftStylesMap[isFirstColumn ? 'firstColumn' : 'otherColumn']
        ])
    }, children);

});



parcelRegister("2VHY1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dc741ae85c1b159$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $5dc741ae85c1b159$export$2e2bcd8739ae039(props) {
    const { id: id, DynamicColumnComponent: DynamicColumnComponent } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DynamicColumnComponent, {
        id: id
    });
}

});


parcelRegister("jsVgu", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf67c08d7af9de7c$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $4Bkxm = parcelRequire("4Bkxm");

var $01OF3 = parcelRequire("01OF3");

var $4aSHd = parcelRequire("4aSHd");

var $2TlSx = parcelRequire("2TlSx");
var $bf67c08d7af9de7c$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state)=>({
        columnConfiguration: (0, $4Bkxm.getColumnConfiguration)(state),
        headerHeight: (0, $4aSHd.getHeaderHeight)(state),
        onChangeHiddenColumnsRequested: (0, $01OF3.getChangeHiddenColumnsCallback)(state)
    }), {})((0, $2TlSx.default));

});
parcelRegister("2TlSx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c51d31614a80777$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");

var $iw0Y6 = parcelRequire("iw0Y6");

var $90IgZ = parcelRequire("90IgZ");

var $giAhk = parcelRequire("giAhk");

var $4Twkh = parcelRequire("4Twkh");
const $3c51d31614a80777$var$messages = (0, $90IgZ.defineMessages)({
    configureIcon: {
        "id": "virtual-table.table.header.column-configuration.configure-icon",
        "defaultMessage": "Click to expand column configuration"
    }
});
function $3c51d31614a80777$export$7b06a271790152c(props) {
    const { intl: { formatMessage: formatMessage }, columnConfiguration: columnConfiguration, headerHeight: headerHeight, onChangeHiddenColumnsRequested: onChangeHiddenColumnsRequested } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c51d31614a80777$var$ConfigWrapper, {
        headerHeight: headerHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, ...propsTrigger })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...propsTrigger,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))), {
                    label: formatMessage($3c51d31614a80777$var$messages.configureIcon)
                }),
                appearance: "subtle",
                ref: triggerRef
            }),
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Twkh.default), {
        columnConfiguration: columnConfiguration,
        onChangeHiddenColumnsRequested: onChangeHiddenColumnsRequested
    })));
}
var $3c51d31614a80777$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($3c51d31614a80777$export$7b06a271790152c);
const $3c51d31614a80777$var$ConfigWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { headerHeight: headerHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_3ioxf9": (0, $9t7rW.default)(`${__cmplp.headerHeight}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1xi2idpf _4t3i5h89 _bfhku67f",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $epS3S = parcelRequire("epS3S");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $eUqFw.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event, currentLevel)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(()=>{
            triggerRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $epS3S.DropdownMenuProvider), {
        value: {
            returnFocusRef: triggerRef
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    })));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);


var $XHGTv = parcelRequire("XHGTv");

var $8gwL5 = parcelRequire("8gwL5");
const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if ((0, $XHGTv.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $8gwL5.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});



parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("epS3S", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuProvider", () => $ee1dc8dd27dd916a$export$9357e33608f1035a);

var $eUqFw = parcelRequire("eUqFw");
const $ee1dc8dd27dd916a$var$DropdownMenuContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $ee1dc8dd27dd916a$export$9357e33608f1035a = $ee1dc8dd27dd916a$var$DropdownMenuContext.Provider;

});

parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});


parcelRegister("4Twkh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f7879a389ed632b$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $9BtCH = parcelRequire("9BtCH");

var $1urNG = parcelRequire("1urNG");

var $7GXrf = parcelRequire("7GXrf");

var $kZ8fn = parcelRequire("kZ8fn");

var $dvnRd = parcelRequire("dvnRd");

var $gYn83 = parcelRequire("gYn83");
class $8f7879a389ed632b$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    onSelect() {
        const { columnConfiguration: columnConfiguration, onChangeHiddenColumnsRequested: onChangeHiddenColumnsRequested } = this.props;
        if (onChangeHiddenColumnsRequested === undefined) return 0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu));
        const allHiddenColumns = (0, $gYn83.getAllHiddenColumns)(columnConfiguration);
        const columnsMap = (0, (/*@__PURE__*/$parcel$interopDefault($9BtCH)))(columnConfiguration, (hash, item)=>({
                ...hash,
                [item.id]: {
                    isHidden: item.isHidden,
                    hiddenParentColumns: (0, $gYn83.getHiddenParentColumns)(item, columnConfiguration)
                }
            }), {});
        return (item)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
            const column = columnsMap[item.id];
            if (column.isHidden) {
                // show
                const columnsToShow = (0, (/*@__PURE__*/$parcel$interopDefault($1urNG)))([
                    item.id
                ], column.hiddenParentColumns);
                onChangeHiddenColumnsRequested((0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))(allHiddenColumns, ...columnsToShow));
            } else // hide
            onChangeHiddenColumnsRequested((0, (/*@__PURE__*/$parcel$interopDefault($1urNG)))(allHiddenColumns, [
                item.id
            ]));
        };
    }
    transformColumnsToItems() {
        const { columnConfiguration: columnConfiguration } = this.props;
        const items = columnConfiguration.map((column)=>{
            const hiddenParentColumns = (0, $gYn83.getHiddenParentColumns)(column, columnConfiguration);
            return {
                id: column.id,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dvnRd.default), {
                    key: column.id,
                    depth: column.depth,
                    title: column.title,
                    color: (0, $gYn83.determineItemColor)(column, hiddenParentColumns),
                    isDisabled: column.isDisabled,
                    isChecked: !column.isHidden
                }),
                isDisabled: column.isDisabled
            };
        });
        return [
            {
                items: items
            }
        ];
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kZ8fn.default), {
            items: this.transformColumnsToItems(),
            onSelect: this.onSelect()
        });
    }
}

});
parcelRegister("1urNG", function(module, exports) {

var $hKE3p = parcelRequire("hKE3p");

var $9eFtX = parcelRequire("9eFtX");

var $42tFs = parcelRequire("42tFs");

var $cRpul = parcelRequire("cRpul");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $115e28588d963fcd$var$union = $9eFtX(function(arrays) {
    return $42tFs($hKE3p(arrays, 1, $cRpul, true));
});
module.exports = $115e28588d963fcd$var$union;

});

parcelRegister("kZ8fn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3c546f2a5a834aa$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $6HC1D = parcelRequire("6HC1D");

var $dxIU5 = parcelRequire("dxIU5");

var $45oFJ = parcelRequire("45oFJ");

var $k61d1 = parcelRequire("k61d1");

var $gJXdx = parcelRequire("gJXdx");

var $jG2Eu = parcelRequire("jG2Eu");

var $gtzuR = parcelRequire("gtzuR");

var $hompL = parcelRequire("hompL");

var $1zsCC = parcelRequire("1zsCC");

var $hK3eJ = parcelRequire("hK3eJ");

var $jelHH = parcelRequire("jelHH");
const $c3c546f2a5a834aa$var$canSelect = ({ type: type })=>type !== (0, $hK3eJ.itemTypes).HEADING;
// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c3c546f2a5a834aa$var$getItemKey = (keyMap, item)=>{
    if (keyMap.has(item)) return keyMap.get(item);
    const newKey = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
    keyMap.set(item, newKey);
    return newKey;
};
// eslint-disable-next-line jira/react/no-class-components
class $c3c546f2a5a834aa$var$MultiSelectList extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            items: [],
            type: (0, $hK3eJ.itemTypes).DEFAULT,
            explanation: undefined,
            maxHeight: undefined,
            canSelectBySpaceKey: true,
            onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            autoFocus: true
        };
    }
    constructor(props){
        super(props);
        this.onKeydown = (event)=>{
            switch(event.keyCode){
                case (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('down'):
                    this.navigateFocus({
                        isPrev: false
                    });
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('up'):
                    this.navigateFocus({
                        isPrev: true
                    });
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter'):
                    this.triggerOnSelect();
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('space'):
                    /* Searchable lists need the space key for typing in the input */ if (!this.props.canSelectBySpaceKey) return;
                    this.triggerOnSelect();
                    break;
                default:
                    return;
            }
            event.stopPropagation();
            event.preventDefault();
        };
        this.navigateFocus = ({ isPrev: isPrev })=>{
            const { lastFocusedIndex: lastFocusedIndex, state: { items: items } } = this;
            let nextFocusIndex;
            if (lastFocusedIndex === undefined || lastFocusedIndex >= items.length) nextFocusIndex = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(items, $c3c546f2a5a834aa$var$canSelect);
            else if (isPrev) nextFocusIndex = (0, (/*@__PURE__*/$parcel$interopDefault($gJXdx)))(items, $c3c546f2a5a834aa$var$canSelect, Math.max(lastFocusedIndex - 1, 0));
            else nextFocusIndex = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(items, $c3c546f2a5a834aa$var$canSelect, lastFocusedIndex + 1);
            if (nextFocusIndex !== -1) {
                this.updateFocus(nextFocusIndex);
                // disable mouse move handler when use keyboard navigation
                this.shouldBypassMouseMove();
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.navigateFocusTo = (nextFocusIndex, child)=>{
            if (!this.bypassMouseMove && $c3c546f2a5a834aa$var$canSelect(child)) this.updateFocus(nextFocusIndex);
        };
        // should not enable mouse move focus if user keeping navigate by keyboard
        this.shouldNotByPassMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            this.bypassMouseMove = false;
        }, 300);
        /*
        when select changes potentially cause re-render,
        re-render will cause click event pass through the list and flyout close.
    */ this.triggerOnSelect = (0, (/*@__PURE__*/$parcel$interopDefault($45oFJ))).bind(this, ()=>{
            if (this.lastFocusedIndex !== undefined) this.props.onSelect(this.state.items[this.lastFocusedIndex].origin);
        });
        this.state = {
            items: []
        };
        this.keyMap = new WeakMap();
    }
    UNSAFE_componentWillMount() {
        this.transformItems(this.props);
    }
    componentDidMount() {
        const { autoFocus: autoFocus } = this.props;
        autoFocus && this.focus();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.items !== this.props.items || nextProps.type !== this.props.type) this.transformItems(nextProps);
    }
    focus() {
        this.menu && this.menu.focus();
    }
    transformItems(props) {
        const { items: items, type: type } = props;
        const { navigateFocusTo: navigateFocusTo, triggerOnSelect: triggerOnSelect } = this;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const transformedItems = items.reduce((retVal, item)=>{
            const heading = item.heading && {
                ...item.heading,
                type: (0, $hK3eJ.itemTypes).HEADING,
                origin: item.heading
            };
            // @ts-expect-error - TS2365 - Operator '+' cannot be applied to types 'number' and 'boolean'.
            const index = retVal.length + !!heading;
            const children = item.items.map((child, i)=>({
                    ...child,
                    isFocused: false,
                    onHover: navigateFocusTo.bind(this, i + index, child),
                    onSelect: triggerOnSelect,
                    type: type,
                    origin: child
                }));
            if (heading) // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            return [
                ...retVal,
                heading,
                ...children
            ];
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            return [
                ...retVal,
                ...children
            ];
        }, []);
        this.setState({
            items: transformedItems
        }, ()=>{
            const { lastFocusedIndex: lastFocusedIndex } = this;
            if (lastFocusedIndex !== undefined && transformedItems[lastFocusedIndex] && $c3c546f2a5a834aa$var$canSelect(transformedItems[lastFocusedIndex])) // refocus
            this.updateFocus(lastFocusedIndex);
            else {
                // focus first selectable item
                this.lastFocusedIndex = undefined;
                this.navigateFocus({
                    isPrev: false
                });
            }
        });
    }
    shouldBypassMouseMove() {
        this.bypassMouseMove = true;
        this.shouldNotByPassMouseMove();
    }
    updateFocus(nextFocusIndex) {
        const { state: { items: items } } = this;
        if (!items[nextFocusIndex].isFocused) {
            this.lastFocusedIndex = nextFocusIndex;
            this.setState({
                items: items.map((item, index)=>(0, $6HC1D.set)(item, 'isFocused', index === nextFocusIndex))
            }, ()=>{
                if (this.list) {
                    const focusedItem = this.list.children[nextFocusIndex];
                    const { offsetHeight: offsetHeight, scrollTop: scrollTop, offsetTop: offsetTop } = this.list;
                    const maxVisibleHeight = offsetHeight + scrollTop;
                    // @ts-expect-error - TS2339 - Property 'offsetTop' does not exist on type 'Element'.
                    const itemTop = focusedItem.offsetTop - offsetTop;
                    // @ts-expect-error - TS2339 - Property 'offsetHeight' does not exist on type 'Element'.
                    const itemBottom = focusedItem.offsetHeight + itemTop;
                    if (itemTop < scrollTop) // item is hide in the top
                    this.list.scrollTop = itemTop;
                    else if (maxVisibleHeight < itemBottom) // item is hide in the bottom
                    this.list.scrollTop = itemBottom - offsetHeight;
                }
            });
        }
    }
    renderContent() {
        const { explanation: explanation } = this.props;
        const { keyMap: keyMap, state: { items: items } } = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jelHH.ListWrapper), {
            // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'string | number'.
            maxHeight: this.props.maxHeight,
            ref: (el)=>{
                this.list = el;
            }
        }, items.map(({ origin: origin, ...itemProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zsCC.default), {
                key: $c3c546f2a5a834aa$var$getItemKey(keyMap, origin),
                ...itemProps
            }))), explanation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jelHH.Explanation), null, explanation));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jelHH.Menu), {
            ref: (el)=>{
                this.menu = el;
            },
            tabIndex: -1,
            onKeyDown: this.onKeydown,
            role: "menu",
            // eslint-disable-next-line jira/integration/enforce-data-testid-usage
            "data-test-id": "virtual-table.table.header.column-configuration.list.flyout.multi-select-list.list.menu"
        }, this.renderContent());
    }
}
var $c3c546f2a5a834aa$export$2e2bcd8739ae039 = $c3c546f2a5a834aa$var$MultiSelectList;

});
parcelRegister("45oFJ", function(module, exports) {

var $d446o = parcelRequire("d446o");

var $9eFtX = parcelRequire("9eFtX");
/**
 * Defers invoking the `func` until the current call stack has cleared. Any
 * additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to defer.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.defer(function(text) {
 *   console.log(text);
 * }, 'deferred');
 * // => Logs 'deferred' after one millisecond.
 */ var $2f9ac46fdd991ea9$var$defer = $9eFtX(function(func, args) {
    return $d446o(func, 1, args);
});
module.exports = $2f9ac46fdd991ea9$var$defer;

});
parcelRegister("d446o", function(module, exports) {
/** Error message constants. */ var $982ed4a8bf365535$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */ function $982ed4a8bf365535$var$baseDelay(func, wait, args) {
    if (typeof func != 'function') throw new TypeError($982ed4a8bf365535$var$FUNC_ERROR_TEXT);
    return setTimeout(function() {
        func.apply(undefined, args);
    }, wait);
}
module.exports = $982ed4a8bf365535$var$baseDelay;

});


parcelRegister("gJXdx", function(module, exports) {

var $9mB9u = parcelRequire("9mB9u");

var $7qARj = parcelRequire("7qARj");

var $hNahz = parcelRequire("hNahz");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c2fec8a2b4cc30dc$var$nativeMax = Math.max, $c2fec8a2b4cc30dc$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $c2fec8a2b4cc30dc$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $hNahz(fromIndex);
        index = fromIndex < 0 ? $c2fec8a2b4cc30dc$var$nativeMax(length + index, 0) : $c2fec8a2b4cc30dc$var$nativeMin(index, length - 1);
    }
    return $9mB9u(array, $7qARj(predicate, 3), index, true);
}
module.exports = $c2fec8a2b4cc30dc$var$findLastIndex;

});

parcelRegister("1zsCC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac8772493b51e077$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $9nt1B = parcelRequire("9nt1B");

var $gGyns = parcelRequire("gGyns");

var $90IgZ = parcelRequire("90IgZ");

var $giAhk = parcelRequire("giAhk");

var $hK3eJ = parcelRequire("hK3eJ");

var $COSfE = parcelRequire("COSfE");
// @ts-expect-error - TS2304 - Cannot find name 'ItemType'.
const $ac8772493b51e077$var$shouldShowSelect = (type)=>[
        (0, $hK3eJ.itemTypes).CHECKBOX,
        (0, $hK3eJ.itemTypes).RADIO
    ].indexOf(type) !== -1;
const $ac8772493b51e077$var$messages = (0, $90IgZ.defineMessages)({
    selected: {
        "id": "virtual-table.table.header.column-configuration.list.flyout.multi-select-list.list.item.selected",
        "defaultMessage": "Item selected"
    }
});
class $ac8772493b51e077$export$1c8ae823384d605f extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            type: (0, $hK3eJ.itemTypes).DEFAULT,
            description: undefined,
            lozenge: undefined,
            avatarUrl: undefined,
            appearance: {},
            isFocused: false,
            isSelected: false,
            isDefaultSelected: false,
            isDisabled: false,
            hasDivider: false,
            onHover: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    renderContent() {
        const { avatarUrl: avatarUrl, content: content, lozenge: lozenge, type: type } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $COSfE.Content), null, $ac8772493b51e077$var$shouldShowSelect(type) && this.renderSelect(), avatarUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $COSfE.Avatar), {
            src: avatarUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $COSfE.Title), null, content), lozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $COSfE.LozengeWrapper), null, lozenge));
    }
    renderSelect() {
        const { type: type, isSelected: isSelected, isDefaultSelected: isDefaultSelected, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $COSfE.CheckIconWrapper), {
            isDefaultSelected: isDefaultSelected
        }, (isSelected || isDefaultSelected) && (type === (0, $hK3eJ.itemTypes).CHECKBOX ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))), {
            size: "small",
            label: formatMessage($ac8772493b51e077$var$messages.selected)
        }) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gGyns))), {
            size: "small",
            label: formatMessage($ac8772493b51e077$var$messages.selected)
        })));
    }
    renderDescription() {
        const { avatarUrl: avatarUrl, description: description, type: type } = this.props;
        // @ts-expect-error - TS2365 - Operator '+' cannot be applied to types 'boolean' and 'boolean'.
        const shouldIndent = $ac8772493b51e077$var$shouldShowSelect(type) + !!avatarUrl;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $COSfE.Description), {
            shouldIndent: shouldIndent
        }, description);
    }
    render() {
        const { appearance: appearance, description: description, hasDivider: hasDivider, onHover: onHover, isFocused: isFocused, isDisabled: isDisabled, type: type, id: id } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $COSfE.Wrapper), {
            type: type,
            onClick: this.onClick,
            isFocused: isFocused,
            isDisabled: isDisabled,
            onMouseMove: onHover,
            hasDivider: hasDivider,
            appearance: appearance,
            "data-testid": `common.components.virtual-table.table.header.column-configuration.list.flyout.multi-select-list.list.item.wrapper-${id}`
        }, this.renderContent(), description && this.renderDescription());
    }
    constructor(...args){
        super(...args);
        this.onClick = ()=>{
            const { isDisabled: isDisabled, onSelect: onSelect } = this.props;
            if (!isDisabled) onSelect();
        };
    }
}
var $ac8772493b51e077$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($ac8772493b51e077$export$1c8ae823384d605f);

});
parcelRegister("9nt1B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d3cc6c41555bcf7$var$_react = $6d3cc6c41555bcf7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $6d3cc6c41555bcf7$var$_checkMark = $6d3cc6c41555bcf7$var$_interopRequireDefault((parcelRequire("j52dF")));
function $6d3cc6c41555bcf7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6d3cc6c41555bcf7$var$CheckIcon = (props)=>/*#__PURE__*/ $6d3cc6c41555bcf7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $6d3cc6c41555bcf7$var$_checkMark.default
    }));
$6d3cc6c41555bcf7$var$CheckIcon.displayName = 'CheckIcon';
var $6d3cc6c41555bcf7$var$_default = module.exports.default = $6d3cc6c41555bcf7$var$CheckIcon;

});
parcelRegister("j52dF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de4034a95f8a9e06$var$_react = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $de4034a95f8a9e06$var$_UNSAFE_baseNew = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $de4034a95f8a9e06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de4034a95f8a9e06$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $de4034a95f8a9e06$var$_react.default.createElement($de4034a95f8a9e06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$de4034a95f8a9e06$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $de4034a95f8a9e06$var$_default = module.exports.default = $de4034a95f8a9e06$var$CheckMarkIcon;

});


parcelRegister("gGyns", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c25b3c367a26ef0b$var$_react = $c25b3c367a26ef0b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $c25b3c367a26ef0b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c25b3c367a26ef0b$var$PresenceActiveIcon = (props)=>/*#__PURE__*/ $c25b3c367a26ef0b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="6" fill="currentcolor" fill-rule="evenodd"/></svg>`
    }, props));
$c25b3c367a26ef0b$var$PresenceActiveIcon.displayName = 'PresenceActiveIcon';
var $c25b3c367a26ef0b$var$_default = module.exports.default = $c25b3c367a26ef0b$var$PresenceActiveIcon;

});

parcelRegister("hK3eJ", function(module, exports) {

$parcel$export(module.exports, "itemTypes", () => $9782b4387bc47fae$export$d02ea220375e4aff);
const $9782b4387bc47fae$export$d02ea220375e4aff = {
    HEADING: 'HEADING',
    RADIO: 'RADIO',
    CHECKBOX: 'CHECKBOX',
    DEFAULT: 'DEFAULT'
};

});

parcelRegister("COSfE", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $352ae9d7f9be51b3$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "CheckIconWrapper", () => $352ae9d7f9be51b3$export$4db74a067a8aeeff);
$parcel$export(module.exports, "Avatar", () => $352ae9d7f9be51b3$export$e2255cf6045e8d47);
$parcel$export(module.exports, "Content", () => $352ae9d7f9be51b3$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "Title", () => $352ae9d7f9be51b3$export$f99233281efd08a0);
$parcel$export(module.exports, "LozengeWrapper", () => $352ae9d7f9be51b3$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "Description", () => $352ae9d7f9be51b3$export$393edc798c47379d);
/* styles.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");


var $c9TLT = parcelRequire("c9TLT");

var $hK3eJ = parcelRequire("hK3eJ");
const $352ae9d7f9be51b3$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasDivider: hasDivider, appearance: appearance, isDisabled: isDisabled, isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rwr3ip": (0, $9t7rW.default)((()=>{
                if (__cmplp.appearance.color) return __cmplp.appearance.color;
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                if (__cmplp.type === (0, $hK3eJ.itemTypes).HEADING) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                return `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$exports).N300})`;
                return undefined;
            })())
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_uiztglyw _1yt41ano _syazj3uf _80om13gf",
            __cmplp.hasDivider && "_n7zl1l7n",
            __cmplp.type === (0, $hK3eJ.itemTypes).HEADING && "_11c8qk37",
            __cmplp.isFocused && "_bfhk1hxd",
            __cmplp.className
        ])
    });
});
const $352ae9d7f9be51b3$export$4db74a067a8aeeff = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDefaultSelected: isDefaultSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf _4t3i7vkz _1bsb1tcg",
            __cmplp.isDefaultSelected ? "_tzy4105o" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $352ae9d7f9be51b3$var$avatarSize = `${(0, $c9TLT.gridSize) * 2}px`;
const $352ae9d7f9be51b3$export$e2255cf6045e8d47 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1gqeyu4": (0, $9t7rW.default)($352ae9d7f9be51b3$var$avatarSize)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf _1bsbq5n1 _4t3iq5n1 _2rko1l7b _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $352ae9d7f9be51b3$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $352ae9d7f9be51b3$export$f99233281efd08a0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $352ae9d7f9be51b3$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _4t3i7vkz _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $352ae9d7f9be51b3$export$393edc798c47379d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldIndent: shouldIndent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _vchh1rc1 _11c8qk37",
            __cmplp.shouldIndent ? "_19bv1tcg" : "_19bvidpf",
            __cmplp.className
        ])
    });
});

});


parcelRegister("jelHH", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $4022d589ede410af$export$d9b273488cd8ce6f);
$parcel$export(module.exports, "ListWrapper", () => $4022d589ede410af$export$a1d70406c7c51a07);
$parcel$export(module.exports, "Explanation", () => $4022d589ede410af$export$1c704a1d6baa66ad);
/* styles.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $4022d589ede410af$export$d9b273488cd8ce6f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbko4j _12ji1r31 _1qu2glyw _12y31o36",
            __cmplp.className
        ])
    });
});
const $4022d589ede410af$export$a1d70406c7c51a07 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxHeight: maxHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1upm8ip": (0, $9t7rW.default)(__cmplp.maxHeight, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18m91wug",
            __cmplp.maxHeight && "_c71l1w9o",
            __cmplp.className
        ])
    });
});
const $4022d589ede410af$export$1c704a1d6baa66ad = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaznsd6 _11c8qk37 _1yt4c05c",
            __cmplp.className
        ])
    });
});

});


parcelRegister("dvnRd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0f3f828b2449742$export$2e2bcd8739ae039);
/* item.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eoCgY = parcelRequire("eoCgY");

var $9nt1B = parcelRequire("9nt1B");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f0f3f828b2449742$var$ItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { depth: depth, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color),
            "--_13d8cnv": (0, $9t7rW.default)(`${__cmplp.depth * 20}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _syaz1cj8 _18u01cdh _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.isDisabled && "_80om13gf",
            __cmplp.className
        ])
    });
});
const $f0f3f828b2449742$var$WidthPlaceholder = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbpxbi _2hwxu2gc",
            __cmplp.className
        ])
    });
});
class $f0f3f828b2449742$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    renderCheckOrPlaceholder() {
        const { isChecked: isChecked } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0f3f828b2449742$var$WidthPlaceholder, null, isChecked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))), {
            size: "small",
            label: ""
        }));
    }
    renderTitle() {
        const { title: title } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eoCgY)))(title)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return title;
        const Title = title;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Title, null);
    }
    render() {
        const { depth: depth, color: color, isDisabled: isDisabled } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0f3f828b2449742$var$ItemWrapper, {
            depth: depth,
            color: color,
            isDisabled: isDisabled
        }, this.renderCheckOrPlaceholder(), this.renderTitle());
    }
}

});

parcelRegister("gYn83", function(module, exports) {

$parcel$export(module.exports, "getHiddenParentColumns", () => $c6549f7eef11825b$export$1eb020b7a0c2885a);
$parcel$export(module.exports, "getAllHiddenColumns", () => $c6549f7eef11825b$export$be8e94436c3182a9);
$parcel$export(module.exports, "determineItemColor", () => $c6549f7eef11825b$export$d24b05f5766e3698);

var $8i1R8 = parcelRequire("8i1R8");

var $8blac = parcelRequire("8blac");

var $9BtCH = parcelRequire("9BtCH");

var $1urNG = parcelRequire("1urNG");

const $c6549f7eef11825b$export$1eb020b7a0c2885a = (column, columnConfiguration)=>{
    if (!column.parentId) return [];
    // @ts-expect-error - TS2322 - Type 'ColumnConfiguration | undefined' is not assignable to type 'ColumnConfiguration'.
    const columnParent = (0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(columnConfiguration, (configItem)=>configItem.id === column.parentId);
    const addToList = columnParent.isHidden ? [
        columnParent.id
    ] : [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($1urNG)))(addToList, $c6549f7eef11825b$export$1eb020b7a0c2885a(columnParent, columnConfiguration));
};
const $c6549f7eef11825b$export$be8e94436c3182a9 = (columnConfigurations)=>(0, (/*@__PURE__*/$parcel$interopDefault($9BtCH)))(columnConfigurations, // @ts-expect-error - TS2769 - No overload matches this call.
    (list, columnConfig)=>{
        if (columnConfig.isHidden) return [
            ...list,
            columnConfig.id
        ];
        return list;
    }, []);
const $c6549f7eef11825b$export$d24b05f5766e3698 = (column, hiddenParentColumns)=>{
    const { depth: depth, isHidden: isHidden, isDisabled: isDisabled } = column;
    const isActiveChild = depth > 0 && !isHidden;
    const hasInactiveParent = !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(hiddenParentColumns);
    return isActiveChild && hasInactiveParent || isDisabled ? (0, $73a5c9d720aa66e1$exports).N80 : 'inherit';
};

});




parcelRegister("jSyf0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f086c6ba712d02d$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $6pOL1 = parcelRequire("6pOL1");

var $fRQT9 = parcelRequire("fRQT9");
// eslint-disable-next-line jira/react/no-class-components
class $6f086c6ba712d02d$var$ColumnHeaders extends (0, $eUqFw.PureComponent) {
    componentDidMount() {
        if (this.props.isAutoRowHeight && this.ref) this.props.setHeaderHeight(Math.ceil(this.ref.getBoundingClientRect().height));
    }
    componentDidUpdate() {
        if (this.props.isAutoRowHeight && this.ref) this.props.setHeaderHeight(Math.ceil(this.ref.getBoundingClientRect().height));
    }
    renderCoreColumns() {
        const { coreColumnIds: coreColumnIds, Column: Column } = this.props;
        return coreColumnIds.map((columnId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Column, {
                key: columnId,
                id: columnId
            }));
    }
    renderAdditionalColumns() {
        const { additionalColumnIds: additionalColumnIds, AdditionalColumnsContainer: AdditionalColumnsContainer, Column: Column } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AdditionalColumnsContainer, null, additionalColumnIds.map((columnId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Column, {
                key: columnId,
                id: columnId
            })));
    }
    render() {
        const { additionalColumnIds: additionalColumnIds, bottomShadowWidth: bottomShadowWidth, isColumnConfigurationVisible: isColumnConfigurationVisible, hasVerticallyScrolled: hasVerticallyScrolled, tableHasLeftShadow: tableHasLeftShadow, tableHasRightShadow: tableHasRightShadow, ColumnConfiguration: ColumnConfiguration, theme: theme } = this.props;
        const styledCompProps = {
            hasScrolled: hasVerticallyScrolled,
            leftShadowVisible: tableHasLeftShadow,
            rightShadowVisible: tableHasRightShadow,
            width: bottomShadowWidth
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fRQT9.Wrapper), {
            ref: this.setRef,
            ...styledCompProps,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fRQT9.InnerWrapper), {
            ...styledCompProps,
            theme: theme
        }, this.renderCoreColumns(), additionalColumnIds.length > 0 && this.renderAdditionalColumns(), isColumnConfigurationVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ColumnConfiguration, null), theme.header.hasShadow && hasVerticallyScrolled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fRQT9.ShadowWrapper), {
            ...styledCompProps,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fRQT9.HeaderShadow), {
            ...styledCompProps,
            theme: theme
        }))));
    }
    constructor(...args){
        super(...args);
        this.setRef = (el)=>{
            this.ref = el;
        };
    }
}
var $6f086c6ba712d02d$export$2e2bcd8739ae039 = (0, $6pOL1.withTheme)($6f086c6ba712d02d$var$ColumnHeaders);

});
parcelRegister("fRQT9", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $bf0f83e8944005b7$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "InnerWrapper", () => $bf0f83e8944005b7$export$f185744748c379a7);
$parcel$export(module.exports, "ShadowWrapper", () => $bf0f83e8944005b7$export$4ebb490b3ccfc72f);
$parcel$export(module.exports, "HeaderShadow", () => $bf0f83e8944005b7$export$3f791d6f3d371905);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $bf0f83e8944005b7$var$marginMultiplier = (hasScrolled, isShadowVisible)=>{
    if (isShadowVisible) return 0;
    if (hasScrolled) return -1;
    return 1;
};
const $bf0f83e8944005b7$var$getShadowWidth = ({ width: width, leftShadowVisible: leftShadowVisible, rightShadowVisible: rightShadowVisible })=>width + (leftShadowVisible ? 0 : 8) + (rightShadowVisible ? 0 : 8);
const $bf0f83e8944005b7$var$getMargin = (hasScrolled, isShadowVisible)=>8 * $bf0f83e8944005b7$var$marginMultiplier(hasScrolled, isShadowVisible);
const $bf0f83e8944005b7$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasScrolled: hasScrolled, leftShadowVisible: leftShadowVisible, rightShadowVisible: rightShadowVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_150w5uv": (0, $9t7rW.default)(`${$bf0f83e8944005b7$var$getMargin(__cmplp.hasScrolled, __cmplp.leftShadowVisible)}px`),
            "--_oytggz": (0, $9t7rW.default)(`${$bf0f83e8944005b7$var$getMargin(__cmplp.hasScrolled, __cmplp.rightShadowVisible)}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1wug _n7zlqpdy _18u0t6e2 _2hwx1meq _n3td1b66 _ca0qu2gc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $bf0f83e8944005b7$export$f185744748c379a7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasScrolled: hasScrolled, leftShadowVisible: leftShadowVisible, rightShadowVisible: rightShadowVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1koxo07": (0, $9t7rW.default)(`${$bf0f83e8944005b7$var$getMargin(__cmplp.hasScrolled, __cmplp.leftShadowVisible) * -1}px`),
            "--_1hyq4n0": (0, $9t7rW.default)(`${$bf0f83e8944005b7$var$getMargin(__cmplp.hasScrolled, __cmplp.rightShadowVisible) * -1}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1wug _1e0c1txw _18u0wdq9 _2hwxek4m _18m915vq",
            __cmplp.className
        ])
    });
});
const $bf0f83e8944005b7$export$4ebb490b3ccfc72f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ht14a7": (0, $9t7rW.default)(`${$bf0f83e8944005b7$var$getShadowWidth(__cmplp)}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1xi2ze3t _94n5xmi2 _1ltvze3t _1reo15vq _18m915vq _4t3iutpp _1bsbcyjv _1pbykb7n _lcxvglyw",
            __cmplp.className
        ])
    });
});
const $bf0f83e8944005b7$export$3f791d6f3d371905 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ht14a7": (0, $9t7rW.default)(`${$bf0f83e8944005b7$var$getShadowWidth(__cmplp)}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154ix0bf _1xi2ze3t _94n5x0bf _1ltvze3t _4t3iutpp _1bsbcyjv",
            __cmplp.className
        ])
    });
});

});



parcelRegister("j6oZ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f62e19db4f37cca$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dxIU5 = parcelRequire("dxIU5");

var $eGI9v = parcelRequire("eGI9v");

var $6pOL1 = parcelRequire("6pOL1");
const $2f62e19db4f37cca$var$ANALYTICS_DEBOUNCE_MILLIS = 1000;
// eslint-disable-next-line jira/react/no-class-components
class $2f62e19db4f37cca$var$TableMain extends (0, $eUqFw.PureComponent) {
    constructor(props){
        super(props);
        this.analyticsDebouncer = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(props.onTableChange, $2f62e19db4f37cca$var$ANALYTICS_DEBOUNCE_MILLIS);
    }
    componentDidMount() {
        const { containerWidth: containerWidth, hasLoadingRows: hasLoadingRows, onTableChange: onTableChange } = this.props;
        if (containerWidth && !hasLoadingRows) onTableChange();
    }
    // @ts-expect-error - TS7006 - Parameter 'prevProps' implicitly has an 'any' type.
    componentDidUpdate(prevProps) {
        const { rowIds: rowIds, containerWidth: containerWidth, hasLoadingRows: hasLoadingRows, hasHorizontalScrollbar: hasHorizontalScrollbar, hasVerticalScrollbar: hasVerticalScrollbar } = this.props;
        if (!hasLoadingRows && (rowIds !== prevProps.rowIds || containerWidth !== prevProps.containerWidth || hasHorizontalScrollbar !== prevProps.hasHorizontalScrollbar || hasVerticalScrollbar !== prevProps.hasVerticalScrollbar)) /*
       * send analytics event if -
       * - the window was resized
       * - the scrollbar state changed (new rows added, rows expanded, columns added)
       * - table content updated (new table/queue, pagination, sorting, asyn updates)
       *    - but not 'loading' rows
       *
       * Do this over a 1 sec timer to avoid multiple events getting fired during window resize
       * since AutoSizer keeps updating this component during every resize
       */ this.analyticsDebouncer();
    }
    render() {
        const { width: width, Header: Header, Content: Content, ResizeColumnOverlay: ResizeColumnOverlay, HorizontalScrollOverlay: HorizontalScrollOverlay } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                width: `${width}px`
            },
            className: (0, $7JEyt.default)([
                "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _2lx21bp4"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f62e19db4f37cca$var$HeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f62e19db4f37cca$var$ContentWrapper, {
            className: "virtual-table-content-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Content, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ResizeColumnOverlay, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HorizontalScrollOverlay, null));
    }
}
var $2f62e19db4f37cca$export$2e2bcd8739ae039 = (0, $eGI9v.default)('virtualTable', {
    onTableChange: 'updated'
})((0, $6pOL1.withTheme)($2f62e19db4f37cca$var$TableMain));
const $2f62e19db4f37cca$var$wrapperStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2f62e19db4f37cca$var$HeaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _u5f3xy5q",
            __cmplp.className
        ])
    });
});
const $2f62e19db4f37cca$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _kqswh2mm _bfhkvuon",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4oUOk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7c45d860ef37469$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $01OF3 = parcelRequire("01OF3");

var $4Bkxm = parcelRequire("4Bkxm");

var $4aSHd = parcelRequire("4aSHd");

var $5jaaH = parcelRequire("5jaaH");

var $juamq = parcelRequire("juamq");
var $d7c45d860ef37469$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state)=>({
        getOffsetFromBottom: (0, $5jaaH.getOffsetFromBottom)(state),
        isHorizontalScrollVisible: (0, $5jaaH.hasHorizontalScrollbar)(state),
        offset: (0, $4Bkxm.getVisibleCoreColumnsWidth)(state),
        showBottomDecal: (0, $01OF3.showBottomDecal)(state),
        showLeftShadow: (0, $5jaaH.isHorizontalScrollLeftShadowVisible)(state),
        showRightShadow: (0, $5jaaH.isHorizontalScrollRightShadowVisible)(state),
        tableHeight: (0, $5jaaH.getTableHeight)(state),
        tableWidth: (0, $4aSHd.getTableWidthWithoutScrollbarOffset)(state)
    }), {})((0, $juamq.default));

});
parcelRegister("juamq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ce60b7d257937d1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $6pOL1 = parcelRequire("6pOL1");

var $ajzlS = parcelRequire("ajzlS");

var $hUhfz = parcelRequire("hUhfz");
const $6ce60b7d257937d1$export$1b2ba256944351ec = 20;
// eslint-disable-next-line jira/react/no-class-components
class $6ce60b7d257937d1$var$HorizontalScrollOverlay extends (0, $eUqFw.PureComponent) {
    render() {
        const { offset: offset, showLeftShadow: showLeftShadow, showRightShadow: showRightShadow, tableHeight: tableHeight, tableWidth: tableWidth, isHorizontalScrollVisible: isHorizontalScrollVisible, showBottomDecal: showBottomDecal, getOffsetFromBottom: getOffsetFromBottom, theme: theme } = this.props;
        const showBottomShadow = (isHorizontalScrollVisible || showBottomDecal) && getOffsetFromBottom > 0;
        const spaceTakenByHorizontalScrollbar = (0, $ajzlS.scrollbarWidth) + theme.scrollbar.marginTop + theme.scrollbar.marginBottom;
        const verticalShadowHeight = tableHeight - spaceTakenByHorizontalScrollbar;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, showLeftShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUhfz.LeftWrapper), {
            offset: offset,
            height: verticalShadowHeight,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUhfz.LeftShadow), {
            theme: theme
        })), showRightShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUhfz.RightWrapper), {
            height: verticalShadowHeight,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUhfz.RightShadow), null)), showBottomShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUhfz.BottomWrapper), {
            height: $6ce60b7d257937d1$export$1b2ba256944351ec,
            tableWidth: tableWidth,
            topPositionForBottomShadow: this.calculateTopPositionForBottomShadow(spaceTakenByHorizontalScrollbar),
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUhfz.BottomShadow), null)));
    }
    constructor(...args){
        super(...args);
        this.calculateTopPositionForBottomShadow = (spaceTakenByHorizontalScrollbar)=>{
            const { isHorizontalScrollVisible: isHorizontalScrollVisible, tableHeight: tableHeight } = this.props;
            if (isHorizontalScrollVisible) return tableHeight - spaceTakenByHorizontalScrollbar - $6ce60b7d257937d1$export$1b2ba256944351ec;
            return tableHeight - $6ce60b7d257937d1$export$1b2ba256944351ec;
        };
    }
}
var $6ce60b7d257937d1$export$2e2bcd8739ae039 = (0, $6pOL1.withTheme)($6ce60b7d257937d1$var$HorizontalScrollOverlay);

});
parcelRegister("hUhfz", function(module, exports) {

$parcel$export(module.exports, "LeftWrapper", () => $b20ddb7f47646d9c$export$c3d2343a748f64d3);
$parcel$export(module.exports, "LeftShadow", () => $b20ddb7f47646d9c$export$1074439aaaee272);
$parcel$export(module.exports, "RightWrapper", () => $b20ddb7f47646d9c$export$8e62e599821d99ec);
$parcel$export(module.exports, "RightShadow", () => $b20ddb7f47646d9c$export$337d65b8c34718ef);
$parcel$export(module.exports, "BottomWrapper", () => $b20ddb7f47646d9c$export$193005078f73716a);
$parcel$export(module.exports, "BottomShadow", () => $b20ddb7f47646d9c$export$7fe1c90591195108);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $b20ddb7f47646d9c$var$softShadow = {
    '@media screen and (-webkit-min-device-pixel-ratio: 0)': {
        boxShadow: "var(--ds-shadow-overflow, 0 0 12px 0 rgba(0, 0, 0, 0.1))"
    },
    '@media screen and (-webkit-transition)': {
        boxShadow: "var(--ds-shadow-overflow, 0 0 6px 0 rgba(0, 0, 0, 0.1))"
    },
    '@-moz-document url-prefix()': {
        boxShadow: "var(--ds-shadow-overflow, 0 0 6px 0 rgba(0, 0, 0, 0.1))"
    }
};
const $b20ddb7f47646d9c$export$c3d2343a748f64d3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1l2g1c7": (0, $9t7rW.default)(`${__cmplp.theme.shadow.left.borderWidth}px solid ${__cmplp.theme.header.borderColor}`),
            "--_10ib6lf": (0, $9t7rW.default)(__cmplp.height, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154ize3t _94n5ze3t _1ltvze3t _1reo15vq _18m915vq _1bsbv47k _1kl71s3n",
            __cmplp.theme.shadow.left.computeHeight ? "_4t3it1jn" : "_4t3i1kw7",
            __cmplp.className
        ])
    });
});
const $b20ddb7f47646d9c$export$1074439aaaee272 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154ix0bf _94n5x0bf _1ltvx0bf _1bsb19bv _wxnd2jpx _16pl190o _5hft2jpx",
            __cmplp.className
        ])
    });
});
const $b20ddb7f47646d9c$export$8e62e599821d99ec = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1bke5hq": (0, $9t7rW.default)(__cmplp.theme.shadow.right.display),
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154ize3t _1xi2xy5q _94n5ze3t _1reo15vq _18m915vq _1bsbv47k _1e0c13s1 _4t3i2nrh",
            __cmplp.className
        ])
    });
});
const $b20ddb7f47646d9c$export$337d65b8c34718ef = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154ix0bf _94n5x0bf _1ltvv47k _1bsb19bv _wxnd2jpx _16pl190o _5hft2jpx",
            __cmplp.className
        ])
    });
});
const $b20ddb7f47646d9c$export$193005078f73716a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { topPositionForBottomShadow: topPositionForBottomShadow, tableWidth: tableWidth, theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_iucfl6": (0, $9t7rW.default)(`${__cmplp.topPositionForBottomShadow}px`),
            "--_1lfl5vu": (0, $9t7rW.default)(`width: ${__cmplp.tableWidth}px`),
            "--_1lfsua2": (0, $9t7rW.default)(__cmplp.theme.shadow.bottom.display),
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154i1lgz _1ltvze3t _1bsb1p8o _1e0ch4j2 _4t3i2nrh _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $b20ddb7f47646d9c$export$7fe1c90591195108 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ltvze3t _1bsb1osq _4t3i19bv _wxnd2jpx _16pl190o _5hft2jpx",
            __cmplp.className
        ])
    });
});

});



parcelRegister("1y3rU", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdc35d426e026098$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $4aSHd = parcelRequire("4aSHd");

var $5jaaH = parcelRequire("5jaaH");

var $gs9dI = parcelRequire("gs9dI");
var $bdc35d426e026098$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state)=>({
        width: (0, $5jaaH.getTableContentWidth)(state),
        isVisible: !!(0, $4aSHd.getResizingColumnId)(state)
    }), {})((0, $gs9dI.default));

});
parcelRegister("gs9dI", function(module, exports) {

$parcel$export(module.exports, "default", () => $97719a78152c06c0$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
function $97719a78152c06c0$export$2e2bcd8739ae039(props) {
    const { width: width, isVisible: isVisible } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($97719a78152c06c0$var$Overlay, {
        width: width,
        isVisible: isVisible
    });
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97719a78152c06c0$var$Overlay = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_lcxvglyw _kqswstnw _154iidpf _94n5idpf _1ltvidpf _1bsb1hdq _bfhkexu1",
            __cmplp.isVisible ? "_tzy4105o" : "_tzy4idpf",
            __cmplp.isVisible ? "_v564mmrx" : "_v564b45n",
            __cmplp.className
        ])
    });
});

});




parcelRegister("7ippN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e71161703680993$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $MYW4e = parcelRequire("MYW4e");

var $bd1K7 = parcelRequire("bd1K7");

var $czGdf = parcelRequire("czGdf");

var $j09wR = parcelRequire("j09wR");

var $lMEZh = parcelRequire("lMEZh");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$5e71161703680993$export$2e2bcd8739ae039 = (initialState)=>(0, $huRi7.createStore)((0, $MYW4e.enableBatching)((0, $lMEZh.default)), initialState, (0, $czGdf.default)({
        name: 'Table'
    })((0, $huRi7.applyMiddleware)((0, $bd1K7.createEpicMiddleware)((0, $j09wR.default)))));

});
parcelRegister("j09wR", function(module, exports) {

$parcel$export(module.exports, "default", () => $76b2f0e2ff6dd8c4$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $jXEvw = parcelRequire("jXEvw");

var $8zHI3 = parcelRequire("8zHI3");

var $8ww9Q = parcelRequire("8ww9Q");

var $cBMsJ = parcelRequire("cBMsJ");

var $8rOcs = parcelRequire("8rOcs");

var $71Rf2 = parcelRequire("71Rf2");

var $8FZuY = parcelRequire("8FZuY");

var $5FJhe = parcelRequire("5FJhe");
var $76b2f0e2ff6dd8c4$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $jXEvw.default), (0, $cBMsJ.default), (0, $5FJhe.default), (0, $8zHI3.default), (0, $8rOcs.default), (0, $71Rf2.default), (0, $8FZuY.default), (0, $8ww9Q.default));

});
parcelRegister("jXEvw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3781ca87541dd3dc$export$2e2bcd8739ae039);


var $01OF3 = parcelRequire("01OF3");

var $5jaaH = parcelRequire("5jaaH");

var $fZ2Nd = parcelRequire("fZ2Nd");

var $iM5Fk = parcelRequire("iM5Fk");

var $lMerx = parcelRequire("lMerx");

var $4Gq9K = parcelRequire("4Gq9K");

var $itHbK = parcelRequire("itHbK");
var $3781ca87541dd3dc$export$2e2bcd8739ae039 = (0, $iM5Fk.defineTransaction)((0, $4Gq9K.NAVIGATE_TO_CELL), (action, state)=>{
    const { direction: direction, columnId: columnId, rowId: rowId } = action.payload;
    const visibleColumnIds = (0, $01OF3.getVisibleColumnIds)(state);
    const loadingRowIdsSet = new Set((0, $5jaaH.getVisibleLoadingRowIds)(state));
    const visibleRowIds = (0, $fZ2Nd.getFlattenedWithAddedRowIds)(state);
    /* activatedFrom is the opposite of direction, as it is the
	 * relative orientation of the cell that navigated to it, and not
	 * the user interaction that caused the navigation.
	 */ switch(direction){
        case 0, $d090cdd78de8086e$export$b29f845fa4b57508:
            return (0, $lMerx.setActiveCell)({
                columnId: columnId,
                rowId: (0, $itHbK.navigateUp)(visibleRowIds, rowId, loadingRowIdsSet),
                activatedFrom: (0, $d090cdd78de8086e$export$c7c029a231f98d34)
            });
        case 0, $d090cdd78de8086e$export$c7c029a231f98d34:
            return (0, $lMerx.setActiveCell)({
                columnId: columnId,
                rowId: (0, $itHbK.navigateDown)(visibleRowIds, rowId, loadingRowIdsSet),
                activatedFrom: (0, $d090cdd78de8086e$export$b29f845fa4b57508)
            });
        case 0, $d090cdd78de8086e$export$f981f70d61d1405a:
            return (0, $lMerx.setActiveCell)({
                columnId: (0, $itHbK.navigateUp)(visibleColumnIds, columnId, new Set()),
                rowId: rowId,
                activatedFrom: (0, $d090cdd78de8086e$export$1cac5500365a4eb4)
            });
        case 0, $d090cdd78de8086e$export$1cac5500365a4eb4:
            return (0, $lMerx.setActiveCell)({
                columnId: (0, $itHbK.navigateDown)(visibleColumnIds, columnId, new Set()),
                rowId: rowId,
                activatedFrom: (0, $d090cdd78de8086e$export$f981f70d61d1405a)
            });
        default:
            throw new Error('illegal value of the direction property.');
    }
});

});
parcelRegister("iM5Fk", function(module, exports) {

$parcel$export(module.exports, "defineTransaction", () => $7f24c71c81006c69$export$c19bdc7dbe69198d);

var $MYW4e = parcelRequire("MYW4e");
parcelRequire("jAXdN");
parcelRequire("jyKN9");
parcelRequire("fiQ2m");
parcelRequire("flmol");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $bd1K7 = parcelRequire("bd1K7");

var $9DhEq = parcelRequire("9DhEq");

var $gKA5o = parcelRequire("gKA5o");

var $3JafE = parcelRequire("3JafE");

var $ajwhX = parcelRequire("ajwhX");
const $7f24c71c81006c69$var$errorHandler = (0, $ajwhX.errorHandlerFactory)();
const $7f24c71c81006c69$export$c19bdc7dbe69198d = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(type, callback)=>(action$, store)=>action$.ofType(type)// @ts-expect-error - TS7006 - Parameter 'payload' implicitly has an 'any' type.
        .flatMap((payload)=>{
            const callbackResult = callback ? callback(payload, store.getState()) : [];
            const flatTree = Array.isArray(callbackResult) ? (0, (/*@__PURE__*/$parcel$interopDefault($9DhEq)))(callbackResult) : [
                callbackResult
            ];
            const observables = [];
            flatTree.forEach((leaf)=>{
                if (leaf instanceof (0, $3JafE.Observable)) observables.push(leaf);
                else observables.push((0, $3JafE.Observable).of(leaf));
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($gKA5o)))(observables) === 1) return observables[0];
            return (0, $3JafE.Observable).zip(...observables, (...resolvedActions)=>// @ts-expect-error - TS2345 - Argument of type 'unknown[]' is not assignable to parameter of type 'Action[]'.
                (0, $MYW4e.batchActions)((0, (/*@__PURE__*/$parcel$interopDefault($9DhEq)))(resolvedActions)));
        }).catch($7f24c71c81006c69$var$errorHandler);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7f24c71c81006c69$var$defaultGeneratePayload = (action)=>action.payload;
const $7f24c71c81006c69$export$aec11e7f84966a38 = (type, method, callback, generatePayload)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (action$, store)=>action$.ofType(type)// @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type.
        .flatMap((action)=>{
            const observable = method(generatePayload === undefined ? $7f24c71c81006c69$var$defaultGeneratePayload(action) : generatePayload(action, store.getState()));
            if (typeof callback !== 'undefined') return observable.map((response)=>{
                const actions = callback ? callback(response, store.getState()) : [];
                if (Array.isArray(actions)) return (0, $MYW4e.batchActions)(actions);
                return actions;
            });
            return observable.ignoreElements();
        }).catch($7f24c71c81006c69$var$errorHandler);
const $7f24c71c81006c69$export$cc1acdd68c249d8b = (type, before, method, after, generatePayload)=>{
    const optimisticTransaction = $7f24c71c81006c69$export$c19bdc7dbe69198d(type, before);
    const apiTransaction = $7f24c71c81006c69$export$aec11e7f84966a38(type, method, after, generatePayload);
    return (0, $bd1K7.combineEpics)(optimisticTransaction, apiTransaction);
};

});
parcelRegister("9DhEq", function(module, exports) {

var $hKE3p = parcelRequire("hKE3p");
/** Used as references for various `Number` constants. */ var $703572b8b756f789$var$INFINITY = 1 / 0;
/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */ function $703572b8b756f789$var$flattenDeep(array) {
    var length = array == null ? 0 : array.length;
    return length ? $hKE3p(array, $703572b8b756f789$var$INFINITY) : [];
}
module.exports = $703572b8b756f789$var$flattenDeep;

});

parcelRegister("gKA5o", function(module, exports) {

var $fCpZe = parcelRequire("fCpZe");

var $fjnSB = parcelRequire("fjnSB");

var $jxg5X = parcelRequire("jxg5X");

var $4ZYEI = parcelRequire("4ZYEI");

var $eQiJU = parcelRequire("eQiJU");
/** `Object#toString` result references. */ var $c31cef206f882b8b$var$mapTag = '[object Map]', $c31cef206f882b8b$var$setTag = '[object Set]';
/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */ function $c31cef206f882b8b$var$size(collection) {
    if (collection == null) return 0;
    if ($jxg5X(collection)) return $4ZYEI(collection) ? $eQiJU(collection) : collection.length;
    var tag = $fjnSB(collection);
    if (tag == $c31cef206f882b8b$var$mapTag || tag == $c31cef206f882b8b$var$setTag) return collection.size;
    return $fCpZe(collection).length;
}
module.exports = $c31cef206f882b8b$var$size;

});
parcelRegister("4ZYEI", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $1c8hB = parcelRequire("1c8hB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $3a3be8dd1917bddc$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $3a3be8dd1917bddc$var$isString(value) {
    return typeof value == 'string' || !$1c8hB(value) && $hYEMs(value) && $2OY5s(value) == $3a3be8dd1917bddc$var$stringTag;
}
module.exports = $3a3be8dd1917bddc$var$isString;

});

parcelRegister("eQiJU", function(module, exports) {

var $3K42x = parcelRequire("3K42x");

var $fFFC0 = parcelRequire("fFFC0");

var $CYLq5 = parcelRequire("CYLq5");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $ace4754dece6a484$var$stringSize(string) {
    return $fFFC0(string) ? $CYLq5(string) : $3K42x(string);
}
module.exports = $ace4754dece6a484$var$stringSize;

});
parcelRegister("3K42x", function(module, exports) {

var $pRnxj = parcelRequire("pRnxj");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $2b98cd398295eed4$var$asciiSize = $pRnxj('length');
module.exports = $2b98cd398295eed4$var$asciiSize;

});

parcelRegister("CYLq5", function(module, exports) {
/** Used to compose unicode character classes. */ var $0752af280e68c649$var$rsAstralRange = '\\ud800-\\udfff', $0752af280e68c649$var$rsComboMarksRange = '\\u0300-\\u036f', $0752af280e68c649$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $0752af280e68c649$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $0752af280e68c649$var$rsComboRange = $0752af280e68c649$var$rsComboMarksRange + $0752af280e68c649$var$reComboHalfMarksRange + $0752af280e68c649$var$rsComboSymbolsRange, $0752af280e68c649$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $0752af280e68c649$var$rsAstral = '[' + $0752af280e68c649$var$rsAstralRange + ']', $0752af280e68c649$var$rsCombo = '[' + $0752af280e68c649$var$rsComboRange + ']', $0752af280e68c649$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $0752af280e68c649$var$rsModifier = '(?:' + $0752af280e68c649$var$rsCombo + '|' + $0752af280e68c649$var$rsFitz + ')', $0752af280e68c649$var$rsNonAstral = '[^' + $0752af280e68c649$var$rsAstralRange + ']', $0752af280e68c649$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $0752af280e68c649$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $0752af280e68c649$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $0752af280e68c649$var$reOptMod = $0752af280e68c649$var$rsModifier + '?', $0752af280e68c649$var$rsOptVar = '[' + $0752af280e68c649$var$rsVarRange + ']?', $0752af280e68c649$var$rsOptJoin = '(?:' + $0752af280e68c649$var$rsZWJ + '(?:' + [
    $0752af280e68c649$var$rsNonAstral,
    $0752af280e68c649$var$rsRegional,
    $0752af280e68c649$var$rsSurrPair
].join('|') + ')' + $0752af280e68c649$var$rsOptVar + $0752af280e68c649$var$reOptMod + ')*', $0752af280e68c649$var$rsSeq = $0752af280e68c649$var$rsOptVar + $0752af280e68c649$var$reOptMod + $0752af280e68c649$var$rsOptJoin, $0752af280e68c649$var$rsSymbol = '(?:' + [
    $0752af280e68c649$var$rsNonAstral + $0752af280e68c649$var$rsCombo + '?',
    $0752af280e68c649$var$rsCombo,
    $0752af280e68c649$var$rsRegional,
    $0752af280e68c649$var$rsSurrPair,
    $0752af280e68c649$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $0752af280e68c649$var$reUnicode = RegExp($0752af280e68c649$var$rsFitz + '(?=' + $0752af280e68c649$var$rsFitz + ')|' + $0752af280e68c649$var$rsSymbol + $0752af280e68c649$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $0752af280e68c649$var$unicodeSize(string) {
    var result = $0752af280e68c649$var$reUnicode.lastIndex = 0;
    while($0752af280e68c649$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $0752af280e68c649$var$unicodeSize;

});



parcelRegister("ajwhX", function(module, exports) {

$parcel$export(module.exports, "errorHandlerFactory", () => $7f62cef295140ba3$export$6a6f72199c8b8578);

var $3JafE = parcelRequire("3JafE");
parcelRequire("dM0Xt");
parcelRequire("jyKN9");

var $gUUjF = parcelRequire("gUUjF");

var $8xmdY = parcelRequire("8xmdY");

var $5egKh = parcelRequire("5egKh");

const $7f62cef295140ba3$var$LOCATION = 'common.components.virtual-table.ops.common.errors';
const $7f62cef295140ba3$var$translateJsError = (jsError)=>(0, $3JafE.Observable).of(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $5egKh.error)({
        type: (0, $8200ab5c6ac5754a$export$78244dbb77cfa6b6),
        message: jsError.message,
        stack: jsError.stack
    }));
const $7f62cef295140ba3$var$generateErrorAction = (thrownError)=>$7f62cef295140ba3$var$translateJsError(thrownError);
const $7f62cef295140ba3$export$6a6f72199c8b8578 = (additionalFailAction)=>(thrownError)=>{
        (0, $8xmdY.captureException)($7f62cef295140ba3$var$LOCATION, thrownError);
        (0, $gUUjF.default).safeErrorWithoutCustomerData($7f62cef295140ba3$var$LOCATION, thrownError.message || 'Operations error', thrownError);
        const errorAction = $7f62cef295140ba3$var$generateErrorAction(thrownError);
        if (additionalFailAction) return (0, $3JafE.Observable).concat(errorAction, (0, $3JafE.Observable).of(additionalFailAction()));
        return errorAction;
    };

});
parcelRegister("5egKh", function(module, exports) {

$parcel$export(module.exports, "error", () => $c1d1c167cdd94033$export$a3bc9b8ed74fc);
const $c1d1c167cdd94033$export$103bedf43ba882db = 'ops.common.errors.ERROR';
const $c1d1c167cdd94033$export$a3bc9b8ed74fc = (payload)=>({
        type: $c1d1c167cdd94033$export$103bedf43ba882db,
        payload: payload
    });

});

const $8200ab5c6ac5754a$export$ee9d07cf1658f1a7 = 'HTTP';
const $8200ab5c6ac5754a$export$78244dbb77cfa6b6 = 'UNKNOWN';
const $8200ab5c6ac5754a$export$a545733500b6abfc = 'REDUX';



parcelRegister("itHbK", function(module, exports) {

$parcel$export(module.exports, "navigateUp", () => $901432bcf04cc95c$export$565581085a0f36e2);
$parcel$export(module.exports, "navigateDown", () => $901432bcf04cc95c$export$876f6f483a97d3b5);

var $k61d1 = parcelRequire("k61d1");

var $gJXdx = parcelRequire("gJXdx");
const $901432bcf04cc95c$var$navigateWithStrategy = (items, currentItemId, searchStrategy)=>{
    const selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(items, (item)=>item === currentItemId);
    // Selected item is not found; go to top
    if (selectedIndex === -1) return items[0];
    const nextIndex = searchStrategy(selectedIndex);
    if (nextIndex === -1) return items[0];
    return items[nextIndex];
};
const $901432bcf04cc95c$var$buildSearchStrategy = (searchFn, fallbackFn)=>(selectedIndex)=>{
        const searchResult = searchFn(selectedIndex);
        if (searchResult === -1) return fallbackFn(selectedIndex);
        return searchResult;
    };
const $901432bcf04cc95c$export$565581085a0f36e2 = (items, currentItemId, ineligibleItemsSet)=>$901432bcf04cc95c$var$navigateWithStrategy(items, currentItemId, $901432bcf04cc95c$var$buildSearchStrategy((selectedIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJXdx)))(items, (item)=>!ineligibleItemsSet.has(item), selectedIndex - 1), ()=>(0, (/*@__PURE__*/$parcel$interopDefault($gJXdx)))(items, (item)=>!ineligibleItemsSet.has(item), items.length - 1)));
const $901432bcf04cc95c$export$876f6f483a97d3b5 = (items, currentItemId, ineligibleItemsSet)=>$901432bcf04cc95c$var$navigateWithStrategy(items, currentItemId, $901432bcf04cc95c$var$buildSearchStrategy((selectedIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(items, (item)=>!ineligibleItemsSet.has(item), selectedIndex + 1), ()=>(0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(items, (item)=>!ineligibleItemsSet.has(item), 0)));

});


parcelRegister("8zHI3", function(module, exports) {

$parcel$export(module.exports, "default", () => $81d3455677993f2e$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $iZw0k = parcelRequire("iZw0k");

var $5EnTs = parcelRequire("5EnTs");
var $81d3455677993f2e$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $iZw0k.default), (0, $5EnTs.default));

});
parcelRegister("iZw0k", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ea6f3d395abd291$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $8gu2p = parcelRequire("8gu2p");

var $hJTVv = parcelRequire("hJTVv");
var $6ea6f3d395abd291$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $8gu2p.default), (0, $hJTVv.default));

});
parcelRegister("8gu2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $c362064ea72e76f1$export$2e2bcd8739ae039);

var $5lWf9 = parcelRequire("5lWf9");

var $iM5Fk = parcelRequire("iM5Fk");

var $6RfFc = parcelRequire("6RfFc");
var $c362064ea72e76f1$export$2e2bcd8739ae039 = (0, $iM5Fk.defineTransaction)((0, $6RfFc.CLEAR_RESIZING_COLUMN), ()=>(0, $5lWf9.setResizingColumn)(undefined));

});
parcelRegister("6RfFc", function(module, exports) {

$parcel$export(module.exports, "CLEAR_RESIZING_COLUMN", () => $f1629175332671f2$export$9939dee145f3882b);
const $f1629175332671f2$export$9939dee145f3882b = 'ops.columns.resizing.clear.CLEAR_RESIZING_COLUMN';
const $f1629175332671f2$export$42ffd38884aecdac = ()=>({
        type: $f1629175332671f2$export$9939dee145f3882b,
        payload: undefined
    });

});


parcelRegister("hJTVv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c024208687596fa$export$2e2bcd8739ae039);

var $5lWf9 = parcelRequire("5lWf9");

var $iM5Fk = parcelRequire("iM5Fk");

var $aKk9u = parcelRequire("aKk9u");
var $8c024208687596fa$export$2e2bcd8739ae039 = (0, $iM5Fk.defineTransaction)((0, $aKk9u.SET_RESIZING_COLUMN), (action)=>(0, $5lWf9.setResizingColumn)(action.payload));

});
parcelRegister("aKk9u", function(module, exports) {

$parcel$export(module.exports, "SET_RESIZING_COLUMN", () => $80f3e9773e11ee7e$export$9b07079645db68ce);
const $80f3e9773e11ee7e$export$9b07079645db68ce = 'ops.columns.resizing.set.SET_RESIZING_COLUMN';
const $80f3e9773e11ee7e$export$adaa4cf7ef1b65be = (payload)=>({
        type: $80f3e9773e11ee7e$export$9b07079645db68ce,
        payload: payload
    });

});



parcelRegister("5EnTs", function(module, exports) {

$parcel$export(module.exports, "default", () => $01bcd37313be6369$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $8uWYC = parcelRequire("8uWYC");

var $lD2AQ = parcelRequire("lD2AQ");

var $hTf4o = parcelRequire("hTf4o");
var $01bcd37313be6369$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $8uWYC.default), (0, $hTf4o.default), (0, $lD2AQ.default));

});
parcelRegister("8uWYC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bfd191c99b95e2c$export$2e2bcd8739ae039);

var $01OF3 = parcelRequire("01OF3");

var $f5bbs = parcelRequire("f5bbs");

var $5lWf9 = parcelRequire("5lWf9");

var $4aSHd = parcelRequire("4aSHd");

var $kCVlz = parcelRequire("kCVlz");

var $iM5Fk = parcelRequire("iM5Fk");

var $fkLMy = parcelRequire("fkLMy");
var $4bfd191c99b95e2c$export$2e2bcd8739ae039 = (0, $iM5Fk.defineTransaction)((0, $fkLMy.CLEAR_COLUMN_SORT_ORDER), (action, state)=>{
    const consumerState = (0, $01OF3.getConsumerState)(state);
    const sortedRowIdsHash = (0, $kCVlz.default)((0, $f5bbs.getAddedRows)(state), (0, $f5bbs.getRowTree)(state), (0, $4aSHd.getActiveSortedColumnConfiguration)(state), false, undefined, (0, $4aSHd.getSortedRowIdsHash)(state), consumerState.addedRows, consumerState.rowTree, consumerState.columnComparators, consumerState.defaultComparator);
    consumerState.callbacks.onSortedRowIdsChanged && consumerState.callbacks.onSortedRowIdsChanged(sortedRowIdsHash);
    return [
        (0, $5lWf9.setColumnSortOrder)(undefined),
        (0, $5lWf9.setSortedRowIdsHash)(sortedRowIdsHash)
    ];
});

});
parcelRegister("kCVlz", function(module, exports) {

$parcel$export(module.exports, "default", () => $98528185eb202556$export$2e2bcd8739ae039);

var $8blac = parcelRequire("8blac");

var $5iWql = parcelRequire("5iWql");

var $dIFkw = parcelRequire("dIFkw");

var $8DHCV = parcelRequire("8DHCV");

var $51eUM = parcelRequire("51eUM");
var $98528185eb202556$export$2e2bcd8739ae039 = (0, $5iWql.default)((lastAddedRows, lastRowTree, lastSortedColumnConfiguration, sortOverrideEnabled, activeSortedColumnConfiguration, lastSortedRowIdsHash, addedRows, rowTree, columnComparators, defaultComparator)=>{
    const newAddedRows = (0, $8DHCV.default)(lastAddedRows, addedRows);
    // bypass sorting if possible (no new added rows, rowTree didn't change, sortConfiguration didn't change)
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(newAddedRows) && lastRowTree === rowTree && lastSortedColumnConfiguration === activeSortedColumnConfiguration) return lastSortedRowIdsHash;
    return (0, $51eUM.default)({
        rowTree: rowTree,
        columnComparators: columnComparators,
        defaultComparator: (0, $dIFkw.default)(defaultComparator, columnComparators),
        persistedAddedRows: newAddedRows,
        isSortOverrideEnabled: sortOverrideEnabled,
        activeSortedColumnConfiguration: activeSortedColumnConfiguration,
        sortedRowIdsHash: lastSortedRowIdsHash
    });
});

});
parcelRegister("8DHCV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b02d7a747b137e63$export$2e2bcd8739ae039);

var $fUTZC = parcelRequire("fUTZC");

var $5iWql = parcelRequire("5iWql");
var $b02d7a747b137e63$export$2e2bcd8739ae039 = (0, $5iWql.default)((addedRows, nextAddedRows)=>{
    if (nextAddedRows && nextAddedRows.persisted) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(nextAddedRows.persisted, (persistedRow, rowId)=>{
            if (addedRows === undefined || addedRows.persisted === undefined || addedRows.persisted[rowId] === undefined) result[rowId] = persistedRow;
        });
        return result;
    }
    return undefined;
});

});

parcelRegister("51eUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $73670eacc6877218$export$2e2bcd8739ae039);

var $ezsJz = parcelRequire("ezsJz");

var $fUTZC = parcelRequire("fUTZC");

var $aXGkF = parcelRequire("aXGkF");

var $03i9R = parcelRequire("03i9R");



var $kPVGQ = parcelRequire("kPVGQ");
const $73670eacc6877218$var$sort = (rowIds, sortOrder, comparator)=>[
        ...rowIds
    ].sort(comparator);
const $73670eacc6877218$var$sortRowIds = (rowIds, sortConfiguration, lastSortedRowIds)=>{
    if (rowIds.length === 0) return rowIds;
    const { consumerComparator: consumerComparator, sortOrder: sortOrder, isSortOverrideEnabled: isSortOverrideEnabled } = sortConfiguration;
    const sortAwareConsumerComparator = consumerComparator(sortOrder);
    // either this is the first time sorting, or the user has explicitly sorted the table
    // sort as expressed by the consumer
    if (!lastSortedRowIds || !isSortOverrideEnabled) return $73670eacc6877218$var$sort(rowIds, sortOrder, sortAwareConsumerComparator);
    // 2...Nth time sorting
    // any update that isn't an explicit sort we want to maintain order based on the previous
    const lastRowIdsHash = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))(lastSortedRowIds);
    const internalComparator = (rowId1, rowId2)=>{
        // both ids were already present, sort in their old older
        if (lastRowIdsHash[rowId1] !== undefined && lastRowIdsHash[rowId2] !== undefined) return Number(lastRowIdsHash[rowId1]) < Number(lastRowIdsHash[rowId2]) ? -1 : 1;
        // one of the ids is new, sort as expected by the consumer (including order)
        return sortAwareConsumerComparator(rowId1, rowId2);
    };
    return [
        ...rowIds
    ].sort(internalComparator);
};
const $73670eacc6877218$var$toLookupHash = (array)=>{
    if (!array) return {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const hash = {};
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))((0, (/*@__PURE__*/$parcel$interopDefault($ezsJz)))(array, (element)=>!!element), // eslint-disable-next-line no-return-assign
    (element)=>hash[element] = true);
    return hash;
};
const $73670eacc6877218$var$getRowIdsWithoutAddedRows = (rowIds, sortConfiguration, persistedAddedRows, lastSortedRowIds)=>{
    if (sortConfiguration.isSortOverrideEnabled) {
        const lastSortedRowIdsHash = $73670eacc6877218$var$toLookupHash(lastSortedRowIds);
        return (0, (/*@__PURE__*/$parcel$interopDefault($03i9R)))(rowIds, (rowId)=>persistedAddedRows !== undefined && persistedAddedRows[rowId] !== undefined && lastSortedRowIdsHash[rowId] === undefined);
    }
    return rowIds;
};
const $73670eacc6877218$var$traverseRows = (rowTree, parentRowId, rowIds, sortConfiguration, result, persistedAddedRows, sortedRowIdsHash)=>{
    if (rowIds === undefined || rowIds.length === 0) return;
    // filter out added-rows, as they shouldn't be sorted but just inserted afterwards according to their position/anchor
    const sortableRowIds = $73670eacc6877218$var$getRowIdsWithoutAddedRows(rowIds, sortConfiguration, persistedAddedRows, sortedRowIdsHash[parentRowId] || []);
    const sortedRowIds = $73670eacc6877218$var$sortRowIds(sortableRowIds, sortConfiguration, sortedRowIdsHash[parentRowId] || []);
    const reSortedRowIds = (0, $kPVGQ.default)(parentRowId, sortedRowIds, rowTree, persistedAddedRows);
    // eslint-disable-next-line no-param-reassign
    result[parentRowId] = reSortedRowIds;
    reSortedRowIds.forEach((rowId)=>{
        const { childrenIds: childrenIds } = rowTree.rows[rowId];
        $73670eacc6877218$var$traverseRows(rowTree, rowId, childrenIds, sortConfiguration, result, persistedAddedRows, sortedRowIdsHash);
    });
};
const $73670eacc6877218$export$3da49b8141c52d70 = (rowTree, sortConfiguration, persistedAddedRows, sortedRowIdsHash)=>{
    const result = {};
    $73670eacc6877218$var$traverseRows(rowTree, (0, $7872bfc970cd976d$export$59c500c4e33fdb0), rowTree.rootIds, sortConfiguration, result, persistedAddedRows, sortedRowIdsHash);
    return result;
};
const $73670eacc6877218$var$DEFAULT_SORT_ORDER_FOR_COMPARATORS = (0, $c947ad34bf4dc375$export$6e386ac144cffab5);
const $73670eacc6877218$var$getSortConfiguration = (columnComparators, // @ts-expect-error - TS7006 - Parameter 'activeSortedColumnConfiguration' implicitly has an 'any' type.
activeSortedColumnConfiguration, defaultComparator, isSortOverrideEnabled)=>{
    // are we sorting by a particular comparator
    const activeSortedColumnComparator = activeSortedColumnConfiguration && columnComparators ? columnComparators[activeSortedColumnConfiguration.columnId] : undefined;
    // if we are not, use the default comparator
    const consumerComparator = activeSortedColumnComparator || defaultComparator;
    // which of the sort tri-state are we in
    // this is where the tri-state ASC/DESC/UNDEF is reduced to ASC/DESC to
    // keep the tri-state hidden from actual comparator implementations
    const sortOrder = activeSortedColumnConfiguration ? activeSortedColumnConfiguration.sortOrder : $73670eacc6877218$var$DEFAULT_SORT_ORDER_FOR_COMPARATORS;
    return {
        consumerComparator: consumerComparator,
        sortOrder: sortOrder,
        isSortOverrideEnabled: isSortOverrideEnabled
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$73670eacc6877218$export$2e2bcd8739ae039 = ({ rowTree: rowTree, persistedAddedRows: persistedAddedRows, columnComparators: columnComparators, activeSortedColumnConfiguration: activeSortedColumnConfiguration, isSortOverrideEnabled: isSortOverrideEnabled, defaultComparator: defaultComparator, sortedRowIdsHash: sortedRowIdsHash })=>{
    if (!defaultComparator) return {
        [(0, $7872bfc970cd976d$export$59c500c4e33fdb0)]: rowTree.rootIds
    };
    const sortConfiguration = $73670eacc6877218$var$getSortConfiguration(columnComparators, activeSortedColumnConfiguration, defaultComparator, isSortOverrideEnabled);
    return $73670eacc6877218$export$3da49b8141c52d70(rowTree, sortConfiguration, persistedAddedRows, sortedRowIdsHash);
};

});
parcelRegister("ezsJz", function(module, exports) {

var $904yO = parcelRequire("904yO");

var $9vvKC = parcelRequire("9vvKC");

var $7qARj = parcelRequire("7qARj");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $a9ba9f860705508e$var$filter(collection, predicate) {
    var func = $1c8hB(collection) ? $904yO : $9vvKC;
    return func(collection, $7qARj(predicate, 3));
}
module.exports = $a9ba9f860705508e$var$filter;

});

parcelRegister("kPVGQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0b84c3180c72028$export$2e2bcd8739ae039);

var $fUTZC = parcelRequire("fUTZC");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b0b84c3180c72028$export$2e2bcd8739ae039 = (parentRowId, baseRowIds, rowTree, anchoredRows)=>{
    if (!anchoredRows) return baseRowIds;
    const result = [
        ...baseRowIds
    ];
    // for each added row, insert based on the anchor
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anchoredRows, (anchorRow, anchoredRowId)=>{
        const { anchorId: anchorId, position: position } = anchorRow;
        if (position === 'FIRST') result.unshift(anchoredRowId);
        else if (position === 'LAST') result.push(anchoredRowId);
        else if (anchorId) {
            const anchorRowLocation = result.indexOf(anchorId);
            // the anchor row may not be in the set of currently visible things
            if (anchorRowLocation !== -1) {
                if (position === 'BEFORE') result.splice(anchorRowLocation, 0, anchoredRowId);
                else if (position === 'AFTER') {
                    const spliceOffset = 1;
                    result.splice(anchorRowLocation + spliceOffset, 0, anchoredRowId);
                }
            }
            if (position === 'INSIDE' && anchorId === parentRowId) result.splice(anchorRowLocation + 1, 0, anchoredRowId);
        }
    });
    return result;
};

});




parcelRegister("lD2AQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d57c4371c34f814$export$2e2bcd8739ae039);

var $01OF3 = parcelRequire("01OF3");

var $f5bbs = parcelRequire("f5bbs");

var $5lWf9 = parcelRequire("5lWf9");

var $4aSHd = parcelRequire("4aSHd");

var $kCVlz = parcelRequire("kCVlz");

var $iM5Fk = parcelRequire("iM5Fk");

var $6akGV = parcelRequire("6akGV");
var $8d57c4371c34f814$export$2e2bcd8739ae039 = (0, $iM5Fk.defineTransaction)((0, $6akGV.RE_SORT), (action, state)=>{
    const consumerState = (0, $01OF3.getConsumerState)(state);
    const sortedRowIdsHash = (0, $kCVlz.default)((0, $f5bbs.getAddedRows)(state), (0, $f5bbs.getRowTree)(state), undefined, false, (0, $4aSHd.getActiveSortedColumnConfiguration)(state), (0, $4aSHd.getSortedRowIdsHash)(state), consumerState.addedRows, consumerState.rowTree, consumerState.columnComparators, consumerState.defaultComparator);
    consumerState.callbacks.onSortedRowIdsChanged && consumerState.callbacks.onSortedRowIdsChanged(sortedRowIdsHash);
    return [
        (0, $5lWf9.setSortedRowIdsHash)(sortedRowIdsHash)
    ];
});

});
parcelRegister("6akGV", function(module, exports) {

$parcel$export(module.exports, "RE_SORT", () => $d681d03310a7969c$export$e43c6499ab033999);
const $d681d03310a7969c$export$e43c6499ab033999 = 'ops.columns.sorting.re-sort.RE_SORT';
const $d681d03310a7969c$export$8f208e436e07f92 = ()=>({
        type: $d681d03310a7969c$export$e43c6499ab033999
    });

});


parcelRegister("hTf4o", function(module, exports) {

$parcel$export(module.exports, "default", () => $524e3cecb6903c5d$export$2e2bcd8739ae039);

var $01OF3 = parcelRequire("01OF3");

var $f5bbs = parcelRequire("f5bbs");

var $5lWf9 = parcelRequire("5lWf9");

var $4aSHd = parcelRequire("4aSHd");

var $kCVlz = parcelRequire("kCVlz");

var $iM5Fk = parcelRequire("iM5Fk");

var $af0lw = parcelRequire("af0lw");
var $524e3cecb6903c5d$export$2e2bcd8739ae039 = (0, $iM5Fk.defineTransaction)((0, $af0lw.SET_COLUMN_SORT_ORDER), (action, state)=>{
    const consumerState = (0, $01OF3.getConsumerState)(state);
    const sortedRowIdsHash = (0, $kCVlz.default)((0, $f5bbs.getAddedRows)(state), (0, $f5bbs.getRowTree)(state), (0, $4aSHd.getActiveSortedColumnConfiguration)(state), false, action.payload, (0, $4aSHd.getSortedRowIdsHash)(state), consumerState.addedRows, consumerState.rowTree, consumerState.columnComparators, consumerState.defaultComparator);
    consumerState.callbacks.onSortedRowIdsChanged && consumerState.callbacks.onSortedRowIdsChanged(sortedRowIdsHash);
    return [
        (0, $5lWf9.setColumnSortOrder)(action.payload),
        (0, $5lWf9.setSortedRowIdsHash)(sortedRowIdsHash)
    ];
});

});



parcelRegister("8ww9Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $abe5275df3f62db5$export$2e2bcd8739ae039);
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $5lWf9 = parcelRequire("5lWf9");

var $6H2ME = parcelRequire("6H2ME");

var $ajwhX = parcelRequire("ajwhX");

var $eRWTs = parcelRequire("eRWTs");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$abe5275df3f62db5$export$2e2bcd8739ae039 = (action$)=>{
    const errorHandler = (0, $ajwhX.errorHandlerFactory)();
    return (0, $6H2ME.withUnpackedBatchActions)(action$)// @ts-expect-error - TS2339 - Property 'ofType' does not exist on type 'Observable<any>'.
    .ofType((0, $eRWTs.SET_HEADER_HEIGHT))// @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type.
    .map((action)=>(0, $5lWf9.setHeaderHeight)(action.payload)).catch(errorHandler);
};

});
parcelRegister("6H2ME", function(module, exports) {

$parcel$export(module.exports, "withUnpackedBatchActions", () => $2c1d023945648f1d$export$25f000f90e13af6b);

var $MYW4e = parcelRequire("MYW4e");
parcelRequire("jyKN9");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");
const $2c1d023945648f1d$export$25f000f90e13af6b = (action$)=>action$.mergeMap((action)=>{
        if (action.type === (0, $MYW4e.BATCH)) return (0, $3JafE.Observable).of(...action.payload);
        return (0, $3JafE.Observable).of(action);
    });

});


parcelRegister("cBMsJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b36096f29857158f$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $cGCIk = parcelRequire("cGCIk");

var $aiD9Y = parcelRequire("aiD9Y");
var $b36096f29857158f$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $cGCIk.default), (0, $aiD9Y.default));

});
parcelRegister("cGCIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c0eed7f8276ce92$export$2e2bcd8739ae039);

var $jOtWU = parcelRequire("jOtWU");

var $f5bbs = parcelRequire("f5bbs");

var $5lWf9 = parcelRequire("5lWf9");

var $4aSHd = parcelRequire("4aSHd");

var $kCVlz = parcelRequire("kCVlz");

var $iM5Fk = parcelRequire("iM5Fk");

var $eRWTs = parcelRequire("eRWTs");

var $e6ysM = parcelRequire("e6ysM");

var $2jJQb = parcelRequire("2jJQb");
const $6c0eed7f8276ce92$var$getScrollbarSize = ()=>{
    if (document.body) {
        const { body: body } = document;
        const scrollbarContainer = document.createElement('div');
        scrollbarContainer.setAttribute('style', `position: absolute;
             width: 100px;
             height: 100px;
             overflow: scroll;
             top: -9999px;`);
        body.appendChild(scrollbarContainer);
        // Pick arbitrary axis, both should have the same bar size
        const scrollbarSize = scrollbarContainer.offsetWidth - scrollbarContainer.clientWidth;
        body.removeChild(scrollbarContainer);
        return scrollbarSize;
    }
    return 0;
};
var $6c0eed7f8276ce92$export$2e2bcd8739ae039 = (0, $iM5Fk.defineTransaction)((0, $2jJQb.SET_STATE_FROM_PROPS), (action, state)=>{
    const { apiState: apiState, theme: theme } = action.payload;
    const { defaultSortedColumn: defaultSortedColumn, ...consumerState } = apiState;
    const sortedRowIdsHash = (0, $kCVlz.default)((0, $f5bbs.getAddedRows)(state), (0, $f5bbs.getRowTree)(state), (0, $4aSHd.getActiveSortedColumnConfiguration)(state), (0, $4aSHd.getIsSortOverrideEnabled)(state), defaultSortedColumn, (0, $4aSHd.getSortedRowIdsHash)(state), consumerState.addedRows, consumerState.rowTree, consumerState.columnComparators, consumerState.defaultComparator);
    const setActions = [
        (0, $jOtWU.setConsumerState)(consumerState),
        (0, $5lWf9.setSortedRowIdsHash)(sortedRowIdsHash),
        (0, $eRWTs.set)(theme.header.height),
        (0, $e6ysM.set)(theme.row.borderWidth)
    ];
    if (consumerState.autoRowHeight) // @ts-expect-error - TS2345 - Argument of type 'SetScrollbarSizeAction' is not assignable to parameter of type 'SetSortedRowIdsHashAction | SetHeaderHeightAction | SetConsumerStateAction | SetRowBorderWidthAction'.
    setActions.push((0, $5lWf9.setScrollbarSize)($6c0eed7f8276ce92$var$getScrollbarSize()));
    if (defaultSortedColumn) // @ts-expect-error - TS2345 - Argument of type 'SetColumnSortOrderAction' is not assignable to parameter of type 'SetSortedRowIdsHashAction | SetHeaderHeightAction | SetConsumerStateAction | SetRowBorderWidthAction'.
    setActions.push((0, $5lWf9.setColumnSortOrder)(defaultSortedColumn));
    consumerState.callbacks.onSortedRowIdsChanged && consumerState.callbacks.onSortedRowIdsChanged(sortedRowIdsHash);
    return setActions;
});

});
parcelRegister("jOtWU", function(module, exports) {

$parcel$export(module.exports, "SET_CONSUMER_STATE", () => $6c685a427c97dda9$export$56c40290cf7dd948);
$parcel$export(module.exports, "setConsumerState", () => $6c685a427c97dda9$export$9444caca88c67753);
const $6c685a427c97dda9$export$56c40290cf7dd948 = 'state.consumer.SET_CONSUMER_STATE';
const $6c685a427c97dda9$export$9444caca88c67753 = (payload)=>({
        type: $6c685a427c97dda9$export$56c40290cf7dd948,
        payload: payload
    });

});

parcelRegister("e6ysM", function(module, exports) {

$parcel$export(module.exports, "SET_ROW_BORDER_WIDTH", () => $24290871f89012cf$export$a347b798ae4b070c);
$parcel$export(module.exports, "set", () => $24290871f89012cf$export$adaa4cf7ef1b65be);
const $24290871f89012cf$export$a347b798ae4b070c = 'ops.rows.row-border.SET_ROW_BORDER_WIDTH';
const $24290871f89012cf$export$adaa4cf7ef1b65be = (width)=>({
        type: $24290871f89012cf$export$a347b798ae4b070c,
        payload: width
    });

});


parcelRegister("aiD9Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1150a9b47da15c4$export$2e2bcd8739ae039);

var $hTLlD = parcelRequire("hTLlD");

var $jOtWU = parcelRequire("jOtWU");

var $01OF3 = parcelRequire("01OF3");

var $4Bkxm = parcelRequire("4Bkxm");

var $f5bbs = parcelRequire("f5bbs");

var $5lWf9 = parcelRequire("5lWf9");

var $4aSHd = parcelRequire("4aSHd");

var $5jaaH = parcelRequire("5jaaH");

var $kCVlz = parcelRequire("kCVlz");

var $iM5Fk = parcelRequire("iM5Fk");

var $lMerx = parcelRequire("lMerx");

var $8qUHb = parcelRequire("8qUHb");
const $b1150a9b47da15c4$var$getActiveRowSync = (state, consumerState)=>{
    if ((0, $01OF3.isInRowNavigationMode)(state)) {
        const activeRowIndex = (0, $5jaaH.getActiveRowIndex)(state);
        const { rootIds: rootIds } = consumerState.rowTree;
        if (consumerState.contentKey !== state.consumer.contentKey) return [
            (0, $5lWf9.clearActiveItem)()
        ];
        if (activeRowIndex !== undefined) {
            if (!rootIds.length) return [
                (0, $5lWf9.clearActiveItem)()
            ];
            if (rootIds[activeRowIndex] === undefined) return [
                (0, $lMerx.setActiveRow)({
                    rowIndex: rootIds.length - 1
                })
            ];
            // Causes the row to refocus in the case that it is rerendered
            return [
                (0, $lMerx.setActiveRow)({
                    rowIndex: activeRowIndex,
                    setFocusOnRow: true
                })
            ];
        }
    }
    return [];
};
const $b1150a9b47da15c4$var$isSameColumnSet = (state, nextColumns)=>{
    const prevColumnIds = (0, $4Bkxm.getAllColumnIds)(state);
    const nextColumnIds = nextColumns.map((column)=>column.id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(new Set([
        prevColumnIds
    ]), new Set([
        nextColumnIds
    ]));
};
// Strictly speaking the property we care about is the that the width of
// multiline columns is unchanged, as this may in turn influence cell height
// if any multi-line column is present.
//
// Invalidating this isn't essential, but may save briefly underbuffering w/
// virtualisation.  Hence we use the same set of columns as a proxy for change
// to multiline column width.
const $b1150a9b47da15c4$var$isRowHeightMapStale = (state, nextColumns)=>!$b1150a9b47da15c4$var$isSameColumnSet(state, nextColumns) && (0, $4Bkxm.hasAnyMultiLineColumn)(state);
const $b1150a9b47da15c4$var$getRowHeightMappingInvalidation = (state, consumerState)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const nextColumns = Object.values(consumerState.columnTree.columns);
    if ($b1150a9b47da15c4$var$isRowHeightMapStale(state, nextColumns)) return [
        (0, $5lWf9.clearRowHeightMapping)()
    ];
    return [];
};
const $b1150a9b47da15c4$var$getConditionalActions = (state, consumerState)=>[
        ...$b1150a9b47da15c4$var$getActiveRowSync(state, consumerState),
        ...$b1150a9b47da15c4$var$getRowHeightMappingInvalidation(state, consumerState)
    ];
var $b1150a9b47da15c4$export$2e2bcd8739ae039 = (0, $iM5Fk.defineTransaction)((0, $8qUHb.UPDATE_STATE_FROM_PROPS), (action, state)=>{
    const { defaultSortedColumn: defaultSortedColumn, ...consumerState } = action.payload;
    const sortedRowIdsHash = (0, $kCVlz.default)((0, $f5bbs.getAddedRows)(state), (0, $f5bbs.getRowTree)(state), (0, $4aSHd.getActiveSortedColumnConfiguration)(state), true, (0, $4aSHd.getActiveSortedColumnConfiguration)(state), (0, $4aSHd.getSortedRowIdsHash)(state), consumerState.addedRows, consumerState.rowTree, consumerState.columnComparators, consumerState.defaultComparator);
    consumerState.callbacks.onSortedRowIdsChanged && consumerState.callbacks.onSortedRowIdsChanged(sortedRowIdsHash);
    return [
        (0, $jOtWU.setConsumerState)(consumerState),
        ...$b1150a9b47da15c4$var$getConditionalActions(state, action.payload),
        (0, $5lWf9.setSortOrderWithOverride)({
            isSortOverrideEnabled: true
        }),
        (0, $5lWf9.setSortedRowIdsHash)(sortedRowIdsHash)
    ];
});

});


parcelRegister("8rOcs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec4059a2c7a06c7d$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $6MYoA = parcelRequire("6MYoA");
var $ec4059a2c7a06c7d$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $6MYoA.default));

});
parcelRegister("6MYoA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7253efd7157236c5$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $jzFyM = parcelRequire("jzFyM");

var $k8u3f = parcelRequire("k8u3f");
var $7253efd7157236c5$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $jzFyM.default), (0, $k8u3f.default));

});
parcelRegister("jzFyM", function(module, exports) {

$parcel$export(module.exports, "default", () => $37c2ee4e46622ea3$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("1NUMQ");
parcelRequire("flmol");
parcelRequire("5hZYM");
parcelRequire("3wBUP");

var $01OF3 = parcelRequire("01OF3");

var $5lWf9 = parcelRequire("5lWf9");

var $lMerx = parcelRequire("lMerx");

var $qMUlQ = parcelRequire("qMUlQ");
var /* We don't want a cell to blur if we are only doing so to focus another cell. */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$37c2ee4e46622ea3$export$2e2bcd8739ae039 = (action, // eslint-disable-next-line @typescript-eslint/no-explicit-any
store)=>action.ofType((0, $qMUlQ.CLEAR_ACTIVE_ITEM)).switchMap(()=>(0, $3JafE.Observable).timer(50).map(()=>{
            (0, $01OF3.getActiveItemChangedCallback)(store.getState())(undefined);
            const getActiveRowIdChanged = (0, $01OF3.getActiveRowIdChangedCallback)(store.getState());
            if (getActiveRowIdChanged != null) getActiveRowIdChanged(undefined);
            return (0, $5lWf9.clearActiveItem)();
        }).takeUntil(action.ofType((0, $lMerx.SET_ACTIVE_CELL), (0, $lMerx.SET_ACTIVE_ROW))));

});

parcelRegister("k8u3f", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe43630fd91549dd$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");

var $01OF3 = parcelRequire("01OF3");

var $5lWf9 = parcelRequire("5lWf9");

var $5jaaH = parcelRequire("5jaaH");

var $6H2ME = parcelRequire("6H2ME");

var $ajwhX = parcelRequire("ajwhX");

var $iM5Fk = parcelRequire("iM5Fk");

var $lMerx = parcelRequire("lMerx");
const $fe43630fd91549dd$export$4237cfdec709360b = (0, $iM5Fk.defineTransaction)((0, $lMerx.SET_ACTIVE_CELL), (action)=>(0, $5lWf9.setActiveItem)(action.payload));
const $fe43630fd91549dd$export$436fa03bfc3ce94c = (action$, store)=>{
    const errorHandler = (0, $ajwhX.errorHandlerFactory)();
    return (0, $6H2ME.withUnpackedBatchActions)(action$)// @ts-expect-error - TS2339 - Property 'ofType' does not exist on type 'Observable<any>'.
    .ofType((0, $lMerx.SET_ACTIVE_ROW))// @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type.
    .mergeMap((action)=>{
        const state = store.getState();
        const activeRowIdChanged = (0, $01OF3.getActiveRowIdChangedCallback)(state);
        if (activeRowIdChanged != null) {
            const activeRowId = (0, $5jaaH.rowIndexToRowId)(state, action.payload.rowIndex);
            activeRowIdChanged(activeRowId);
        }
        return (0, $3JafE.Observable).of((0, $5lWf9.setActiveItem)(action.payload));
    }).catch(errorHandler);
};
var $fe43630fd91549dd$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)($fe43630fd91549dd$export$4237cfdec709360b, $fe43630fd91549dd$export$436fa03bfc3ce94c);

});



parcelRegister("71Rf2", function(module, exports) {

$parcel$export(module.exports, "default", () => $349ac0221feae454$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $9gu4a = parcelRequire("9gu4a");

var $gS08n = parcelRequire("gS08n");

var $6cm0j = parcelRequire("6cm0j");

var $le2bN = parcelRequire("le2bN");

var $5HNRp = parcelRequire("5HNRp");
var $349ac0221feae454$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $9gu4a.default), (0, $6cm0j.default), (0, $5HNRp.default), (0, $le2bN.default), (0, $gS08n.default));

});
parcelRegister("9gu4a", function(module, exports) {

$parcel$export(module.exports, "default", () => $665ecf428b527217$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $kMsRD = parcelRequire("kMsRD");

var $jBFED = parcelRequire("jBFED");
var $665ecf428b527217$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $jBFED.default), (0, $kMsRD.default));

});
parcelRegister("kMsRD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5adb51b8c3904ba$export$2e2bcd8739ae039);

var $5lWf9 = parcelRequire("5lWf9");

var $iM5Fk = parcelRequire("iM5Fk");

var $giG1g = parcelRequire("giG1g");
var $a5adb51b8c3904ba$export$2e2bcd8739ae039 = (0, $iM5Fk.defineTransaction)((0, $giG1g.CLEAR_MULTI_ADD_ANCHOR), ()=>(0, $5lWf9.clearMultiAddAnchor)());

});
parcelRegister("giG1g", function(module, exports) {

$parcel$export(module.exports, "CLEAR_MULTI_ADD_ANCHOR", () => $bdb266ac55c2cfd4$export$28f3def567195a3c);
const $bdb266ac55c2cfd4$export$28f3def567195a3c = 'ops.rows.add-anchor.clear.CLEAR_MULTI_ADD_ANCHOR';
const $bdb266ac55c2cfd4$export$42ffd38884aecdac = ()=>({
        type: $bdb266ac55c2cfd4$export$28f3def567195a3c
    });

});


parcelRegister("jBFED", function(module, exports) {

$parcel$export(module.exports, "default", () => $1497ac908a4438f5$export$2e2bcd8739ae039);

var $5lWf9 = parcelRequire("5lWf9");

var $iM5Fk = parcelRequire("iM5Fk");

var $fCOY6 = parcelRequire("fCOY6");
var $1497ac908a4438f5$export$2e2bcd8739ae039 = (0, $iM5Fk.defineTransaction)((0, $fCOY6.SET_MULTI_ADD_ANCHOR), (action)=>(0, $5lWf9.setMultiAddAnchor)(action.payload));

});


parcelRegister("gS08n", function(module, exports) {

$parcel$export(module.exports, "default", () => $df10d70013c8fd0e$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("eDJGt");
parcelRequire("l5lul");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $2Enn0 = parcelRequire("2Enn0");

var $f5bbs = parcelRequire("f5bbs");

var $5jaaH = parcelRequire("5jaaH");

var $kZUuT = parcelRequire("kZUuT");
// Buffer all loading row analytics events for 15s and fire as one event
const $df10d70013c8fd0e$var$BUFFER_TIME = 15000;
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$df10d70013c8fd0e$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $kZUuT.FIRE_LOADING_ROW_ANALYTICS)).bufferTime($df10d70013c8fd0e$var$BUFFER_TIME).do((actions)=>{
        const eventAttributes = [];
        let lastAnalyticsEvent;
        actions.forEach((action)=>{
            const { rowId: rowId, timeVisibleFor: timeVisibleFor, numberOfLoadingRows: numberOfLoadingRows, reasonType: reasonType, analyticsEvent: analyticsEvent } = action.payload;
            const state = store.getState();
            const { displayStart: displayStart, displayEnd: displayEnd } = (0, $5jaaH.getVirtualBoundaries)(state);
            // check if the rowId was removed from the tree due to row data update
            const rowStillExists = !!(0, $f5bbs.getRow)(state, rowId);
            // check if the row, if exists, is still in 'loading' state
            const isStillLoading = rowStillExists && (0, $f5bbs.isRowLoading)(state, rowId);
            // check if the row is in the display boundary
            const intRowId = parseInt(rowId, 10);
            const isInDisplayBoundary = intRowId >= 0 && intRowId >= displayStart && intRowId <= displayEnd;
            // gather all event attributes into one for all the events fired within BUFFER_TIME
            eventAttributes.push({
                displayStart: displayStart,
                displayEnd: displayEnd,
                numberOfLoadingRows: numberOfLoadingRows,
                reasonType: reasonType,
                timeVisibleFor: timeVisibleFor,
                rowIdStillExists: !!rowStillExists,
                isInDisplayBoundary: isInDisplayBoundary,
                gotFulfilled: !isStillLoading
            });
            lastAnalyticsEvent = analyticsEvent;
        });
        // fire the event
        lastAnalyticsEvent && (0, $2Enn0.fireOperationalAnalytics)(lastAnalyticsEvent, {
            containerType: 'loadingRow',
            attributes: {
                eventAttributes: eventAttributes
            }
        });
    }).switchMap(()=>(0, $3JafE.Observable).empty());

});

parcelRegister("6cm0j", function(module, exports) {

$parcel$export(module.exports, "default", () => $329c61150068203a$export$2e2bcd8739ae039);


var $5jaaH = parcelRequire("5jaaH");

var $iM5Fk = parcelRequire("iM5Fk");

var $lMerx = parcelRequire("lMerx");

var $kWPYY = parcelRequire("kWPYY");
const $329c61150068203a$var$getNextRowIndex = (state, direction)=>{
    switch(direction){
        case 0, $d090cdd78de8086e$export$b29f845fa4b57508:
            return (0, $5jaaH.getPrevActiveRowIndex)(state);
        case 0, $d090cdd78de8086e$export$c7c029a231f98d34:
            return (0, $5jaaH.getNextActiveRowIndex)(state);
        default:
            throw new Error('illegal value of the direction property.');
    }
};
var $329c61150068203a$export$2e2bcd8739ae039 = (0, $iM5Fk.defineTransaction)((0, $kWPYY.NAVIGATE_TO_ROW), (action, state)=>(0, $lMerx.setActiveRow)({
        rowIndex: $329c61150068203a$var$getNextRowIndex(state, action.payload.direction),
        setFocusOnRow: true
    }));

});

parcelRegister("le2bN", function(module, exports) {

$parcel$export(module.exports, "default", () => $52bc38e107423335$export$2e2bcd8739ae039);
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $5lWf9 = parcelRequire("5lWf9");

var $6H2ME = parcelRequire("6H2ME");

var $ajwhX = parcelRequire("ajwhX");

var $e6ysM = parcelRequire("e6ysM");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$52bc38e107423335$export$2e2bcd8739ae039 = (action$)=>{
    const errorHandler = (0, $ajwhX.errorHandlerFactory)();
    return (0, $6H2ME.withUnpackedBatchActions)(action$)// @ts-expect-error - TS2339 - Property 'ofType' does not exist on type 'Observable<any>'.
    .ofType((0, $e6ysM.SET_ROW_BORDER_WIDTH))// @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type.
    .map((action)=>(0, $5lWf9.setRowBorderWidth)(action.payload)).catch(errorHandler);
};

});

parcelRegister("5HNRp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7471146605a96214$export$2e2bcd8739ae039);

var $5lWf9 = parcelRequire("5lWf9");

var $iM5Fk = parcelRequire("iM5Fk");

var $11Kxz = parcelRequire("11Kxz");
const $7471146605a96214$var$batchUpdateRowHeightMappingEpic = (0, $iM5Fk.defineTransaction)((0, $11Kxz.BATCH_UPDATE_ROW_HEIGHT_MAPPING), (action)=>(0, $5lWf9.batchUpdateRowHeightMapping)(action.payload.rowIds, action.payload.rowHeightMapping));
var $7471146605a96214$export$2e2bcd8739ae039 = $7471146605a96214$var$batchUpdateRowHeightMappingEpic;

});


parcelRegister("8FZuY", function(module, exports) {

$parcel$export(module.exports, "default", () => $440f4d6e95841c00$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $cLfPp = parcelRequire("cLfPp");

var $jM59v = parcelRequire("jM59v");

var $iR1jH = parcelRequire("iR1jH");

var $f7L23 = parcelRequire("f7L23");

var $177wT = parcelRequire("177wT");
var $440f4d6e95841c00$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $jM59v.default), (0, $177wT.default), (0, $cLfPp.default), (0, $f7L23.default), (0, $iR1jH.default));

});
parcelRegister("cLfPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d496a1326e01f9$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("5dKXv");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");

var $jOtWU = parcelRequire("jOtWU");

var $01OF3 = parcelRequire("01OF3");

var $5lWf9 = parcelRequire("5lWf9");

var $5jaaH = parcelRequire("5jaaH");

var $6H2ME = parcelRequire("6H2ME");

var $ajwhX = parcelRequire("ajwhX");
const $95d496a1326e01f9$var$DEBOUNCE_MILLIS = 100;
const $95d496a1326e01f9$var$handleOffsetChange = (store)=>{
    const state = store.getState();
    const onHorizontalScrollOffsetChanged = (0, $01OF3.getHorizontalScrollOffsetChangedCallback)(state);
    if (onHorizontalScrollOffsetChanged) {
        const offsetFromLeft = (0, $5jaaH.getOffsetFromLeft)(state);
        const offsetFromRight = (0, $5jaaH.getOffsetFromRight)(state);
        onHorizontalScrollOffsetChanged({
            offsetFromLeft: offsetFromLeft,
            offsetFromRight: offsetFromRight
        });
    }
    return (0, $3JafE.Observable).empty();
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $95d496a1326e01f9$var$debouncedEpic = (action$, store)=>{
    const errorHandler = (0, $ajwhX.errorHandlerFactory)();
    return (0, $6H2ME.withUnpackedBatchActions)(action$)// @ts-expect-error - TS2339 - Property 'ofType' does not exist on type 'Observable<any>'.
    .ofType((0, $5lWf9.SET_HORIZONTAL_SCROLL_OFFSET), (0, $5lWf9.SET_TABLE_SIZE)).debounceTime($95d496a1326e01f9$var$DEBOUNCE_MILLIS).mergeMap(()=>$95d496a1326e01f9$var$handleOffsetChange(store)).catch(errorHandler);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $95d496a1326e01f9$var$consumerStateEpic = (action$, store)=>{
    const errorHandler = (0, $ajwhX.errorHandlerFactory)();
    return (0, $6H2ME.withUnpackedBatchActions)(action$)// @ts-expect-error - TS2339 - Property 'ofType' does not exist on type 'Observable<any>'.
    .ofType((0, $jOtWU.SET_CONSUMER_STATE)).mergeMap(()=>$95d496a1326e01f9$var$handleOffsetChange(store)).catch(errorHandler);
};
var $95d496a1326e01f9$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)($95d496a1326e01f9$var$debouncedEpic, $95d496a1326e01f9$var$consumerStateEpic);

});

parcelRegister("jM59v", function(module, exports) {

$parcel$export(module.exports, "default", () => $67ec086ce5868ead$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("dM0Xt");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $5lWf9 = parcelRequire("5lWf9");

var $4aSHd = parcelRequire("4aSHd");

var $ajwhX = parcelRequire("ajwhX");

var $5yvx1 = parcelRequire("5yvx1");
const $67ec086ce5868ead$var$errorHandler = (0, $ajwhX.errorHandlerFactory)();
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$67ec086ce5868ead$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $5yvx1.SET_SCROLL_OFFSET))// @ts-expect-error - TS2345 - Argument of type '(action: SetScrollOffsetAction) => Observable<SetVerticalScrollOffsetAction | SetVerticalScrollDeltaAction> | Observable<...>' is not assignable to parameter of type '(value: SetScrollOffsetAction, index: number) => ObservableInput<SetVerticalScrollOffsetAction | SetVerticalScrollDeltaAction>'.
    .mergeMap((action)=>{
        if (action.payload.direction === 'VERTICAL') {
            const lastPos = (0, $4aSHd.getVerticalScrollOffset)(store.getState());
            const delta = lastPos - action.payload.offset;
            return (0, $3JafE.Observable).concat((0, $3JafE.Observable).of((0, $5lWf9.setVerticalScrollOffset)(action.payload.offset)), (0, $3JafE.Observable).of((0, $5lWf9.setVerticalScrollDelta)(delta)));
        }
        if (action.payload.direction === 'HORIZONTAL') return (0, $3JafE.Observable).of((0, $5lWf9.setHorizontalScrollOffset)(action.payload.offset));
        throw new Error(`The direction property ${action.payload.direction} value is illegal.`);
    }).catch($67ec086ce5868ead$var$errorHandler);

});

parcelRegister("iR1jH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e5be8fd4747757c$export$2e2bcd8739ae039);

var $5lWf9 = parcelRequire("5lWf9");

var $iM5Fk = parcelRequire("iM5Fk");

var $3rJ4C = parcelRequire("3rJ4C");
var $7e5be8fd4747757c$export$2e2bcd8739ae039 = (0, $iM5Fk.defineTransaction)((0, $3rJ4C.SET_SCROLLBAR_SIZE), (action)=>(0, $5lWf9.setScrollbarSize)(action.payload));

});

parcelRegister("f7L23", function(module, exports) {

$parcel$export(module.exports, "default", () => $72398880c9963b5e$export$2e2bcd8739ae039);


var $4Bkxm = parcelRequire("4Bkxm");

var $5lWf9 = parcelRequire("5lWf9");

var $5jaaH = parcelRequire("5jaaH");

var $fZ2Nd = parcelRequire("fZ2Nd");

var $iM5Fk = parcelRequire("iM5Fk");

var $cMIaK = parcelRequire("cMIaK");
var $72398880c9963b5e$export$2e2bcd8739ae039 = (0, $iM5Fk.defineTransaction)((0, $cMIaK.SCROLL_TO_ROW), (action, state)=>{
    const rowIds = (0, $fZ2Nd.getFlattenedWithAddedRowIds)(state);
    const rowIndex = rowIds.indexOf(action.payload);
    // if row is invalid/not visible then clear the active item
    if (rowIndex === -1) return (0, $5lWf9.clearActiveItem)();
    // A row is 36px high, including the 1px border. These borders
    // overlap leading to an offset height for scrolling as 36px - 1px
    return [
        (0, $5lWf9.setActiveItem)({
            type: (0, $a37593d97c1ae333$export$4b3489234fd17200),
            rowId: action.payload,
            columnId: (0, $4Bkxm.getVisibleCoreColumnIds)(state)[0]
        }),
        (0, $5lWf9.setVerticalScrollOffset)((0, $5jaaH.getScrollOffsetForRowIndex)(state, rowIndex))
    ];
});

});

parcelRegister("177wT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba8de7ca6143dda7$export$2e2bcd8739ae039);
parcelRequire("8jBvP");
parcelRequire("5dKXv");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");

var $jOtWU = parcelRequire("jOtWU");

var $01OF3 = parcelRequire("01OF3");

var $5lWf9 = parcelRequire("5lWf9");

var $5jaaH = parcelRequire("5jaaH");

var $6H2ME = parcelRequire("6H2ME");

var $ajwhX = parcelRequire("ajwhX");
const $ba8de7ca6143dda7$var$DEBOUNCE_MILLIS = 16;
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$ba8de7ca6143dda7$export$2e2bcd8739ae039 = (action$, store)=>{
    const errorHandler = (0, $ajwhX.errorHandlerFactory)();
    return (0, $6H2ME.withUnpackedBatchActions)(action$)// @ts-expect-error - TS2339 - Property 'ofType' does not exist on type 'Observable<any>'.
    .ofType((0, $5lWf9.SET_VERTICAL_SCROLL_OFFSET), (0, $5lWf9.SET_TABLE_SIZE), (0, $jOtWU.SET_CONSUMER_STATE)).debounceTime($ba8de7ca6143dda7$var$DEBOUNCE_MILLIS).mergeMap(()=>{
        const state = store.getState();
        const onVerticalScrollOffsetChanged = (0, $01OF3.getVerticalScrollOffsetChangedCallback)(state);
        if (onVerticalScrollOffsetChanged) {
            const virtualBoundaries = (0, $5jaaH.getVirtualBoundaries)(state);
            onVerticalScrollOffsetChanged({
                ...virtualBoundaries,
                offsetFromTop: (0, $5jaaH.getOffsetFromTop)(state),
                offsetFromBottom: (0, $5jaaH.getOffsetFromBottom)(state)
            });
        }
        return (0, $3JafE.Observable).empty();
    }).catch(errorHandler);
};

});


parcelRegister("5FJhe", function(module, exports) {

$parcel$export(module.exports, "default", () => $5981fe7c9f2ad5b1$export$2e2bcd8739ae039);

var $5lWf9 = parcelRequire("5lWf9");

var $iM5Fk = parcelRequire("iM5Fk");

var $hmJUb = parcelRequire("hmJUb");
var $5981fe7c9f2ad5b1$export$2e2bcd8739ae039 = (0, $iM5Fk.defineTransaction)((0, $hmJUb.SET_TABLE_SIZE), (action)=>(0, $5lWf9.setTableSize)(action.payload));

});


parcelRegister("lMEZh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a4f0dcf1e3ed300$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $1sd4W = parcelRequire("1sd4W");

var $9DmQz = parcelRequire("9DmQz");
var $8a4f0dcf1e3ed300$export$2e2bcd8739ae039 = (0, $huRi7.combineReducers)({
    consumer: $1sd4W.default,
    internal: $9DmQz.default
});

});
parcelRegister("1sd4W", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f2ad34863ef77c0$export$2e2bcd8739ae039);


var $jOtWU = parcelRequire("jOtWU");
const $4f2ad34863ef77c0$var$initialState = {
    maxDepth: 0,
    addLinkCaption: undefined,
    DetailsPanelComponent: undefined,
    NonTemporaryCellWrapper: undefined,
    autoHeight: true,
    showShadowAtBottom: false,
    navigationMode: (0, $a37593d97c1ae333$export$8ea4ff4da61b68e4),
    rowTree: {
        rows: {},
        rootIds: []
    },
    rowsConfiguration: {},
    addedRows: undefined,
    expandedRowIds: [],
    columnTree: {
        columns: {},
        rootCoreIds: [],
        rootAdditionalIds: []
    },
    expandedColumnIds: [],
    columnWidths: {},
    sortedColumnIds: undefined,
    draggableColumns: false,
    LoadingRowComponent: undefined,
    callbacks: {}
};
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$4f2ad34863ef77c0$export$2e2bcd8739ae039 = (state = $4f2ad34863ef77c0$var$initialState, action)=>{
    switch(action.type){
        case 0, $jOtWU.SET_CONSUMER_STATE:
            return action.payload;
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});



parcelRegister("g2M4i", function(module, exports) {

$parcel$export(module.exports, "default", () => $b86f84f6a70d245d$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $5iWql = parcelRequire("5iWql");



var $bqD33 = parcelRequire("bqD33");
const $b86f84f6a70d245d$var$getValueOrFallback = (value, fallback)=>value === undefined ? fallback : value;
const $b86f84f6a70d245d$var$traverseColumns = (columns, columnMap, parentChildrenIds)=>{
    columns.forEach((column)=>{
        let childrenIds;
        // eslint-disable-next-line no-param-reassign
        columnMap[column.id] = {
            id: column.id,
            title: column.title,
            HeaderComponent: column.HeaderComponent,
            tooltip: column.tooltip,
            defaultWidth: column.minWidth,
            minWidth: column.minWidth,
            maxWidth: column.maxWidth,
            // FSN-4987 Remove resize strategy related logic during cleanup
            resizeStrategy: (0, $c947ad34bf4dc375$export$4670af9f718b9e66),
            isHideable: false,
            isDraggable: false,
            isMarkup: false,
            isDefaultAdd: false,
            color: undefined,
            childrenIds: childrenIds,
            parentId: undefined,
            canBeMultiLine: $b86f84f6a70d245d$var$getValueOrFallback(column.canBeMultiLine, false),
            CellComponent: column.CellComponent
        };
        parentChildrenIds.push(column.id);
    });
};
const $b86f84f6a70d245d$var$transformColumns = (0, $5iWql.default)((columns)=>{
    const columnTree = {
        columns: {},
        rootCoreIds: [],
        rootAdditionalIds: []
    };
    $b86f84f6a70d245d$var$traverseColumns(columns, columnTree.columns, columnTree.rootAdditionalIds);
    return columnTree;
});
const $b86f84f6a70d245d$var$transformRows = (0, $5iWql.default)((rowIds)=>{
    const rowTree = {
        rootIds: [],
        rows: {}
    };
    rowIds.forEach((id)=>{
        if (!rowTree.rows[id]) rowTree.rows[id] = {
            id: id,
            parentId: undefined,
            childrenIds: []
        };
        // we've reached the root, add ourselves to rootIds
        rowTree.rootIds.push(id);
    });
    return rowTree;
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b86f84f6a70d245d$export$2e2bcd8739ae039 = (props)=>({
        // Table general
        facade: (0, $1ae691fea746d497$export$88a597d0c7ae97b),
        maxDepth: 0,
        DetailsPanelComponent: undefined,
        NonTemporaryCellWrapper: props.NonTemporaryCellWrapper,
        autoHeight: false,
        showDecalAtBottom: props.showDecalAtBottom,
        navigationMode: props.navigationMode,
        addLinkCaption: undefined,
        addedRows: undefined,
        isContentStale: props.isContentStale,
        shouldSkipVirtualization: props.shouldSkipVirtualization,
        shouldHideLoadingIndicator: props.shouldHideLoadingIndicator,
        shouldRerenderRowOnHover: props.shouldRerenderRowOnHover,
        contentKey: props.contentKey,
        // Rows
        rowTree: $b86f84f6a70d245d$var$transformRows(props.rowIds),
        rowsConfiguration: props.rowsConfiguration,
        rowHeight: props.defaultRowHeight,
        autoRowHeight: props.autoRowHeight,
        draggableRows: props.draggableRows,
        defaultComparator: undefined,
        expandedRowIds: [],
        // @ts-expect-error - TS2322 - Type 'ComponentClass<Omit<DispatchProp<any>, "dispatch">> & { WrappedComponent: Component<DispatchProp<any>>; }' is not assignable to type 'Optional<LoadingRowComponent>'.
        LoadingRowComponent: (0, $bqD33.default),
        disableRowHighlight: props.disableRowHighlight,
        // Columns
        columnTree: $b86f84f6a70d245d$var$transformColumns(props.columns),
        expandedColumnIds: props.expandedColumnIds,
        columnWidths: props.columnWidths,
        hiddenColumnIds: [],
        minAdditionalColumnsWidth: 0,
        defaultSortedColumn: undefined,
        columnComparators: {},
        sortedColumnIds: undefined,
        draggableColumns: false,
        premiumSLAColumnIds: props.premiumSLAColumnIds,
        callbacks: {
            onActiveRowIdChanged: props.onActiveRowIdChanged,
            onActiveItemChanged: props.onActiveItemChanged,
            onDisplayedRowsChanged: props.onDisplayedRowsChanged,
            onVerticalScrollOffsetChanged: props.onVerticalScrollOffsetChanged,
            onHorizontalScrollOffsetChanged: props.onHorizontalScrollOffsetChanged,
            onRowListFocusFunctionChanged: props.onRowListFocusFunctionChanged,
            onReactPortalContainerRefChanged: props.onReactPortalContainerRefChanged,
            onRowExpansionChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onColumnExpansionChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onColumnMoveRequested: undefined,
            onChangeHiddenColumnsRequested: undefined,
            onRowAddRequested: undefined,
            onClearAddedRowsRequested: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onPersistAddedRowRequested: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onCancelAddedRowRequested: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onSortedColumnChanged: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onSortedRowIdsChanged: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        }
    });

});
parcelRegister("bqD33", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1c8e8128684e0fd$export$2e2bcd8739ae039);

var $7vbEf = parcelRequire("7vbEf");

var $f5bbs = parcelRequire("f5bbs");

var $4aSHd = parcelRequire("4aSHd");

var $5jaaH = parcelRequire("5jaaH");

var $bhHgb = parcelRequire("bhHgb");
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 1.
$d1c8e8128684e0fd$export$2e2bcd8739ae039 = (0, $7vbEf.connect)((state, ownProps)=>({
        virtualBoundaries: (0, $5jaaH.getVirtualBoundaries)(state),
        numberOfLoadingRows: (0, $5jaaH.getNumberOfLoadingRowsInDisplayBoundary)(state),
        rowHeight: (0, $f5bbs.getRowHeight)(state, ownProps.id),
        tableWidth: (0, $4aSHd.getTableWidth)(state),
        tableHasRightShadow: (0, $5jaaH.isHorizontalScrollRightShadowVisible)(state),
        isActiveItem: (0, $5jaaH.isActiveRowItem)(state, ownProps.id),
        isRowLeftEdgeVisible: (0, $5jaaH.getOffsetFromLeft)(state) === 0,
        isRowRightEdgeVisible: (0, $5jaaH.getOffsetFromRight)(state) === 0,
        renderSidebarIcon: ownProps.renderSidebarIcon
    }))((0, $bhHgb.default));

});
parcelRegister("bhHgb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb17351b210c4bf1$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $giAhk = parcelRequire("giAhk");

var $IxOJr = parcelRequire("IxOJr");

var $6pOL1 = parcelRequire("6pOL1");

var $5GhkP = parcelRequire("5GhkP");
const $cb17351b210c4bf1$var$WIDE_SKELETON_WIDTH_PX = 616;
const $cb17351b210c4bf1$var$SHORT_SKELETON_WIDTH_PX = 408;
const $cb17351b210c4bf1$var$MIN_TABLE_WIDTH_FOR_FULL_SKELETONS = $cb17351b210c4bf1$var$WIDE_SKELETON_WIDTH_PX + 200;
const $cb17351b210c4bf1$var$SKELETON_HEIGHT = 20; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb17351b210c4bf1$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { rowHeight: rowHeight, noRightMargin: noRightMargin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1px358m": (0, $9t7rW.default)(`${__cmplp.rowHeight}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1qdi _2hwxze3t _kqswh2mm _1e0c1txw _4cvr1h6o _12ji1r31 _1qu2glyw _12y31o36",
            __cmplp.className
        ])
    });
});
const $cb17351b210c4bf1$var$shimmer = null; // Replace with once Loader component ready.
const $cb17351b210c4bf1$export$8f31e4c4a37b8e9c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`),
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhk1u4r _1itk1n44 _12vemgnk _16jlkb7n _1o9zkb7n _i0dl1wug _2rko1y44 _4t3i2nrh _p12f1hdq",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $cb17351b210c4bf1$var$LoadingRow extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { id: id, rowHeight: rowHeight, reasonType: reasonType, onRowContentUpdate: onRowContentUpdate } = this.props;
        onRowContentUpdate && onRowContentUpdate(id, rowHeight);
        this.timestampMounted = Date.now();
        this.initialReasonType = reasonType;
        if (this.props.isActiveItem && this.myRef.current) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.focus();
        this.myRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.addEventListener('focusin', this.props.onFocusCallback);
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isActiveItem && this.props.isActiveItem && this.myRef.current) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.focus();
    }
    componentWillUnmount() {
        const { id: id, onUnmount: onUnmount, numberOfLoadingRows: numberOfLoadingRows, virtualBoundaries: { displayStart: displayStart } } = this.props;
        const timeVisibleFor = Date.now() - this.timestampMounted;
        onUnmount && onUnmount(numberOfLoadingRows, displayStart, id, timeVisibleFor, // @ts-expect-error Argument of type 'string' is not assignable to parameter of type 'UIAnalyticsEvent'.
        this.initialReasonType);
        this.myRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.removeEventListener('focusin', this.props.onFocusCallback);
    }
    baseSkeletonWidth() {
        const { rowIndex: rowIndex } = this.props;
        return rowIndex % 2 ? $cb17351b210c4bf1$var$SHORT_SKELETON_WIDTH_PX : $cb17351b210c4bf1$var$WIDE_SKELETON_WIDTH_PX;
    }
    skeletonWidth() {
        const { tableWidth: tableWidth } = this.props;
        const baseWidth = this.baseSkeletonWidth();
        if (tableWidth < $cb17351b210c4bf1$var$MIN_TABLE_WIDTH_FOR_FULL_SKELETONS) {
            const scalingFactor = tableWidth / $cb17351b210c4bf1$var$MIN_TABLE_WIDTH_FOR_FULL_SKELETONS;
            return Math.ceil(baseWidth * scalingFactor);
        }
        return baseWidth;
    }
    render() {
        const { rowHeight: rowHeight, tableHasRightShadow: tableHasRightShadow, isActiveItem: isActiveItem, isRowLeftEdgeVisible: isRowLeftEdgeVisible, isRowRightEdgeVisible: isRowRightEdgeVisible, onClick: onClick, intl: { formatMessage: formatMessage }, theme: theme } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb17351b210c4bf1$var$Wrapper // @ts-expect-error - TS2322 - The expected type comes from property onClick which is declared here on type IntrinsicAttributes & { rowHeight: number; noRightMargin: boolean; } & ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
        , {
            onClick: onClick,
            rowHeight: rowHeight,
            noRightMargin: tableHasRightShadow,
            isActiveItem: isActiveItem,
            ref: this.myRef,
            tabIndex: 0,
            "aria-label": formatMessage((0, $5GhkP.default).loadingRow),
            role: "button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb17351b210c4bf1$export$8f31e4c4a37b8e9c, {
            width: this.skeletonWidth(),
            height: $cb17351b210c4bf1$var$SKELETON_HEIGHT
        }), isActiveItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $IxOJr.RowHighlight), {
            theme: theme,
            isRowLeftEdgeVisible: isRowLeftEdgeVisible,
            isRowRightEdgeVisible: isRowRightEdgeVisible
        }));
    }
    constructor(...args){
        super(...args);
        this.myRef = /*#__PURE__*/ (0, $eUqFw.createRef)() // @ts-expect-error - TS2564 - Property 'timestampMounted' has no initializer and is not definitely assigned in the constructor.
        ;
    }
}
var $cb17351b210c4bf1$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $6pOL1.withTheme)($cb17351b210c4bf1$var$LoadingRow));

});
parcelRegister("5GhkP", function(module, exports) {

$parcel$export(module.exports, "default", () => $930be385a5af31c2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $930be385a5af31c2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    loadingRow: {
        "id": "virtual-table.app.table.loading-row.loading-row",
        "defaultMessage": "Loading row contents"
    }
});

});





parcelRegister("3yErT", function(module, exports) {

$parcel$export(module.exports, "createCellsCache", () => $4ca96d5c070b1506$export$b8f5d4dcd5b8c653);

var $eUqFw = parcelRequire("eUqFw");

var $jqvCZ = parcelRequire("jqvCZ");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $7khX6 = parcelRequire("7khX6");

var $6s3Dt = parcelRequire("6s3Dt");

var $hkeMT = parcelRequire("hkeMT");
const $4ca96d5c070b1506$var$LOCATION = 'issue-table.view.create-cell.view';
const $4ca96d5c070b1506$export$4983e1eef8c41de4 = (arg)=>{
    const argSplitByHyphen = arg.split('-');
    return {
        containsHyphen: argSplitByHyphen.length > 1,
        numericalValue: parseInt(argSplitByHyphen[argSplitByHyphen.length - 1], 10),
        length: arg.length
    };
};
const $4ca96d5c070b1506$var$cacheResolver = (jsonComponentArgs, mergedColumnProps)=>mergedColumnProps.fieldId;
const $4ca96d5c070b1506$export$24c442202b6913f7 = (jsonComponentArgs, mergedColumnProps, FieldDataSelector)=>class Cell extends (0, $eUqFw.Component) {
        componentDidCatch(error) {
            const { fieldType: fieldType, fieldId: fieldId } = mergedColumnProps;
            const event = {
                fieldDescriptor: JSON.stringify({
                    fieldId: fieldId,
                    fieldType: fieldType
                }),
                privacySafeRowId: JSON.stringify($4ca96d5c070b1506$export$4983e1eef8c41de4(this.props.rowId))
            };
            (0, $gUUjF.default).safeErrorWithoutCustomerData($4ca96d5c070b1506$var$LOCATION, `create cell component failed to render: ${String(error)}`, event);
            (0, $guiFP.default)({
                meta: {
                    id: 'createCell',
                    packageName: 'jiraIssueTable',
                    teamName: 'jsd-shield'
                },
                attributes: {
                    fieldDescriptor: JSON.stringify({
                        fieldId: fieldId,
                        fieldType: fieldType
                    }),
                    privacySafeRowId: JSON.stringify($4ca96d5c070b1506$export$4983e1eef8c41de4(this.props.rowId))
                },
                // @ts-expect-error - TS2345 - Argument of type 'Error' is not assignable to parameter of type 'string'.
                error: new Error(error)
            });
            if (fieldType === 'com.atlassian.servicedesk:sd-sla-field') (0, $guiFP.default)({
                meta: {
                    id: 'slaViewCell',
                    packageName: 'jiraIssueTable'
                },
                // @ts-expect-error - TS2345 - Argument of type 'Error' is not assignable to parameter of type 'string'.
                error: new Error(error)
            });
            this.setState({
                hasError: true
            });
        }
        render() {
            if (this.state.hasError === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hkeMT.CellWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7khX6.default), null));
            const { rowId: rowId, columnId: columnId, isActive: isActive, width: width, onMount: onMount, onUpdate: onUpdate, canBeMultiLine: canBeMultiLine, shouldHydrateFully: shouldHydrateFully } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6s3Dt.default), {
                rowId: rowId,
                columnId: columnId,
                isActive: isActive,
                shouldHydrateFully: !!shouldHydrateFully,
                width: width,
                onMount: onMount,
                onUpdate: onUpdate,
                canBeMultiLine: canBeMultiLine,
                jsonComponentArgs: jsonComponentArgs,
                mergedColumnProps: mergedColumnProps,
                FieldDataSelector: FieldDataSelector
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                hasError: false
            };
        }
    };
const $4ca96d5c070b1506$export$b8f5d4dcd5b8c653 = ()=>// @ts-expect-error - TS2345: Type '[jsonComponentArgs: JsonComponentArgs<T>, mergedColumnProps: MergedColumnProps<T>, FieldDataSelector: ComponentType<FieldDataSelectorProps>]' is not assignable to type '[jsonComponentArgs: JsonComponentArgs<keyof DataSelectorPropsMap>, mergedColumnProps: MergedColumnProps<keyof DataSelectorPropsMap>]'.
    (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))($4ca96d5c070b1506$export$24c442202b6913f7, $4ca96d5c070b1506$var$cacheResolver);

});
parcelRegister("6s3Dt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4b719d151cbd226$export$2e2bcd8739ae039);

var $c8Guq = parcelRequire("c8Guq");

var $8un0w = parcelRequire("8un0w");

var $aFvYX = parcelRequire("aFvYX");

var $8MLGs = parcelRequire("8MLGs");

var $kVxqo = parcelRequire("kVxqo");

var $h0Rgs = parcelRequire("h0Rgs");

var $itrEZ = parcelRequire("itrEZ");

var $7f2nY = parcelRequire("7f2nY");

var $1Rt1q = parcelRequire("1Rt1q");

var $cqGKA = parcelRequire("cqGKA");

var $6jG3p = parcelRequire("6jG3p");

var $7ustk = parcelRequire("7ustk");

var $3qjL7 = parcelRequire("3qjL7");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a4b719d151cbd226$var$mapStateToProps = (state, ownProps)=>({
        TableStateConnector: $7ustk.default,
        isCellValid: (0, $kVxqo.isCellValid)(state, ownProps.columnId, ownProps.rowId),
        rowListRef: (0, $itrEZ.getRowListRef)(state),
        JsonCell: $6jG3p.default,
        isUserPickerDisabled: (0, $7f2nY.isUserPickerDisabled)(state)
    });
const $a4b719d151cbd226$var$mapDispatchToProps = {
    onEditStart: (0, $8MLGs.issueEditStartedAction)
};
var $a4b719d151cbd226$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $8un0w.default)({
    onClick: (fieldType)=>({
            name: fieldType
        })
}), (0, $1Rt1q.connect)($a4b719d151cbd226$var$mapStateToProps, $a4b719d151cbd226$var$mapDispatchToProps, null, {
    // @ts-expect-error - TS7006 - Parameter 'nextProps' implicitly has an 'any' type. | TS7006 - Parameter 'prevProps' implicitly has an 'any' type.
    areStatePropsEqual: (nextProps, prevProps)=>{
        // Stop rendering immediately if the cell isn't valid. This
        // should always be due to the virtual-table rendering the old
        // locations in the first reconciliation, before a second
        // reconciliation kicks in with the new row and column IDs.
        if (!nextProps.isCellValid) return true;
        return (0, $aFvYX.default)(nextProps, prevProps);
    }
}), (0, $cqGKA.ReduxAnalyticsData)((state, ownProps)=>({
        attributes: {
            fieldType: ownProps.mergedColumnProps.fieldType,
            tableRowNumber: (0, $h0Rgs.getIssueKeyPositionIndex)(state, ownProps.rowId) + 1
        }
    })))((0, $3qjL7.default));

});
parcelRegister("aFvYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f24f9d4e9538bf7e$export$2e2bcd8739ae039);

var $5NVi6 = parcelRequire("5NVi6");
var /**
 * Shallow equal using '===' comparison and one-level array checks.
 *
 * WARNING: This is not a true shallow equal, use @atlassian/jira-platform-shallow-equal.
 *
 * @see {@link http://go.atlassian.com/shallow-equal}
 *
 * @param {*} obj1
 * @param {*} obj2
 * @returns {boolean}
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f24f9d4e9538bf7e$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    if (!(0, $5NVi6.default)(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const value = obj1[key];
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        return Array.isArray(nextValue) && Array.isArray(value) && (0, $5NVi6.default)(value, nextValue);
    });
    return areValuesEqual;
};

});
parcelRegister("5NVi6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e4109ba822744d4$export$2e2bcd8739ae039);
/**
 * Returns true if the two given arrays are equal one level deep
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $8e4109ba822744d4$export$2e2bcd8739ae039 = (array1 = [], array2 = [])=>{
    // @ts-expect-error - This comparison appears to be unintentional because the types 'readonly T[]' and 'readonly U[]' have no overlap.
    if (array1 === array2) return true;
    // check one level deep
    // @ts-expect-error - This comparison appears to be unintentional because the types 'T' and 'U' have no overlap.
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};

});


parcelRegister("kVxqo", function(module, exports) {

$parcel$export(module.exports, "isCellValid", () => $85ce3a444c5be94c$export$197f9971d7c5eea6);

var $47a3k = parcelRequire("47a3k");

var $h0Rgs = parcelRequire("h0Rgs");
const $85ce3a444c5be94c$export$197f9971d7c5eea6 = (state, columnId, rowId)=>(0, $h0Rgs.isIssueKnown)(state, rowId) && (0, $47a3k.isColumnKnown)(state, columnId);

});

parcelRegister("itrEZ", function(module, exports) {

$parcel$export(module.exports, "getRowListRef", () => $23f7fcb3fb4e199d$export$3fa6769a2044ea5a);

var $9jIiv = parcelRequire("9jIiv");
const $23f7fcb3fb4e199d$export$3fa6769a2044ea5a = (state)=>(0, $9jIiv.getPersisted)(state).rowListRef;

});

parcelRegister("6jG3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fb5a700574c4a74$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
class $7fb5a700574c4a74$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static getDerivedStateFromProps(props) {
        if (props.tableInjectedProps.isTableDisabled) return {
            isEditable: false
        };
        return null;
    }
    componentDidUpdate(prevProps) {
        if (prevProps.tableInjectedProps.isTableDisabled === true && this.props.tableInjectedProps.isTableDisabled === false) this.setState({
            // @ts-expect-error - TS2339 - Property 'isEditable' does not exist on type 'SlaDataSelectorProps | ServiceEntityDataSelectorProps | CmdbObjectDataSelectorProps | ... 13 more ... | MeatballMenuDataSelectorProps'.
            isEditable: this.props.fieldData.isEditable || false
        });
    }
    render() {
        const { FieldComponent: FieldComponent, fieldData: fieldData, tableInjectedProps: tableInjectedProps } = this.props;
        const { isEditable: isEditable } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldComponent, {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            dataSelectorProps: {
                ...fieldData,
                isEditable: isEditable
            },
            tableInjectedProps: tableInjectedProps
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            // @ts-expect-error - TS2339 - Property 'isEditable' does not exist on type 'SlaDataSelectorProps | ServiceEntityDataSelectorProps | CmdbObjectDataSelectorProps | ... 13 more ... | MeatballMenuDataSelectorProps'.
            isEditable: this.props.fieldData.isEditable || false
        };
    }
}

});

parcelRegister("7ustk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9e90c5f023b1b52$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $aFvYX = parcelRequire("aFvYX");

var $9aFsj = parcelRequire("9aFsj");

var $b5o6E = parcelRequire("b5o6E");

var $kVxqo = parcelRequire("kVxqo");

var $47a3k = parcelRequire("47a3k");

var $fMHj9 = parcelRequire("fMHj9");

var $h0Rgs = parcelRequire("h0Rgs");

var $7f2nY = parcelRequire("7f2nY");

var $1Rt1q = parcelRequire("1Rt1q");

var $eW5Vf = parcelRequire("eW5Vf");
const $d9e90c5f023b1b52$var$mapStateToPropsFactory = ()=>{
    const onIssueViewTransitionFactory = (0, $5iWql.default)((state, issueKey)=>(0, $7f2nY.getOnIssueViewTransitionCallback)(state, issueKey));
    return (state, props)=>({
            isCellValid: (0, $kVxqo.isCellValid)(state, props.fieldDescriptor.fieldId, props.issueKey),
            isFieldLocked: (0, $fMHj9.getIsFieldLocked)(state, props),
            isLastColumn: (0, $47a3k.isLastColumn)(state, props.fieldDescriptor.fieldId),
            positionIndex: (0, $h0Rgs.getIssueKeyPositionIndex)(state, props.issueKey),
            fieldName: (0, $47a3k.getColumnTitle)(state, props.fieldDescriptor.fieldId),
            isTableDisabled: (0, $7f2nY.isTableDisabled)(state),
            onIssueViewTransition: onIssueViewTransitionFactory(state, props.issueKey)
        });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d9e90c5f023b1b52$var$mapDispatchToProps = (dispatch, props)=>({
        onFieldLock: (positionIndex)=>dispatch((0, $9aFsj.lockFieldAction)(props.issueKey, props.fieldDescriptor.fieldId, positionIndex)),
        onFieldUnlock: ()=>dispatch((0, $9aFsj.unlockFieldAction)(props.issueKey, props.fieldDescriptor.fieldId)),
        onSetEditingFieldPosition: (horizontalOffset, verticalOffset, fieldWidth, tableWidth, tableHeight)=>dispatch((0, $b5o6E.setEditingFieldPositionAction)(horizontalOffset, verticalOffset, fieldWidth, tableWidth, tableHeight))
    });
const $d9e90c5f023b1b52$var$issueFieldLockControlsFactory = (0, $5iWql.default)((positionIndex, onFieldLock, onFieldUnlock)=>({
        onFieldUnlock: onFieldUnlock,
        onFieldLock: ()=>onFieldLock(positionIndex)
    }));
const $d9e90c5f023b1b52$var$mergeProps = (stateProps, dispatchProps, ownProps)=>{
    const { positionIndex: positionIndex, isCellValid: _, ...componentStateProps } = stateProps;
    return {
        ...ownProps,
        ...componentStateProps,
        issueFieldLockControls: $d9e90c5f023b1b52$var$issueFieldLockControlsFactory(stateProps.positionIndex, dispatchProps.onFieldLock, dispatchProps.onFieldUnlock),
        onSetEditingFieldPosition: dispatchProps.onSetEditingFieldPosition
    };
};
const $d9e90c5f023b1b52$var$ConnectedTableStateConnector = (0, $1Rt1q.connect)($d9e90c5f023b1b52$var$mapStateToPropsFactory, $d9e90c5f023b1b52$var$mapDispatchToProps, $d9e90c5f023b1b52$var$mergeProps, {
    // @ts-expect-error - TS7006 - Parameter 'nextProps' implicitly has an 'any' type. | TS7006 - Parameter 'prevProps' implicitly has an 'any' type.
    areStatePropsEqual: (nextProps, prevProps)=>{
        // Stop rendering immediately if the cell isn't valid.
        if (!nextProps.isCellValid) return true;
        return (0, $aFvYX.default)(nextProps, prevProps);
    }
})((0, $eW5Vf.default));
var $d9e90c5f023b1b52$export$2e2bcd8739ae039 = $d9e90c5f023b1b52$var$ConnectedTableStateConnector;

});
parcelRegister("eW5Vf", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc5368447f4bf3ba$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
class $bc5368447f4bf3ba$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static getDerivedStateFromProps(props, prevState) {
        const { isFieldLocked: isFieldLocked, fieldData: fieldData } = props;
        if (!isFieldLocked && fieldData && prevState.cachedFieldData !== fieldData) return {
            cachedFieldData: fieldData
        };
        return null;
    }
    componentWillUnmount() {
        const { isFieldLocked: isFieldLocked, issueFieldLockControls: { onFieldUnlock: onFieldUnlock } } = this.props;
        // unlock, if locked, when unmounting
        isFieldLocked && onFieldUnlock && onFieldUnlock();
    }
    render() {
        const { children: children, issueFieldLockControls: issueFieldLockControls, isFieldLocked: isFieldLocked, fieldData: givenFieldData, isLastColumn: isLastColumn, fieldName: fieldName, onSetEditingFieldPosition: onSetEditingFieldPosition, isTableDisabled: isTableDisabled, onIssueViewTransition: onIssueViewTransition } = this.props;
        const { cachedFieldData: cachedFieldData } = this.state;
        const fieldData = !isFieldLocked && givenFieldData ? givenFieldData : cachedFieldData;
        return children({
            issueFieldLockControls: issueFieldLockControls,
            fieldData: fieldData,
            isLastColumn: isLastColumn,
            fieldName: fieldName,
            onSetEditingFieldPosition: onSetEditingFieldPosition,
            isFieldLocked: isFieldLocked,
            isTableDisabled: isTableDisabled,
            onIssueViewTransition: onIssueViewTransition
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            cachedFieldData: null
        };
    }
}

});


parcelRegister("3qjL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e189ea30932d4d1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eGI9v = parcelRequire("eGI9v");

var $gUUjF = parcelRequire("gUUjF");

var $kEgAJ = parcelRequire("kEgAJ");

var $hkeMT = parcelRequire("hkeMT");
const $6e189ea30932d4d1$var$LOCATION = 'issue-table.view.create-cell.view';
const $6e189ea30932d4d1$export$4983e1eef8c41de4 = (arg)=>{
    const argSplitByHyphen = arg.split('-');
    return {
        containsHyphen: argSplitByHyphen.length > 1,
        numericalValue: parseInt(argSplitByHyphen[argSplitByHyphen.length - 1], 10),
        length: arg.length
    };
};
// eslint-disable-next-line jira/react/no-class-components
class $6e189ea30932d4d1$var$Cell extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentDidUpdate() {
        const { onUpdate: onUpdate } = this.props;
        if (onUpdate) onUpdate();
    }
    getFieldDescriptor() {
        const { fieldId: fieldId, fieldType: fieldType } = this.props.mergedColumnProps;
        return {
            fieldId: fieldId,
            fieldType: fieldType
        };
    }
    render() {
        const { rowId: rowId, FieldDataSelector: FieldDataSelector } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hkeMT.CellWrapper), {
            onClick: this.onClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldDataSelector, {
            issueKey: rowId,
            fieldDescriptor: this.getFieldDescriptor()
        }, this.renderField));
    }
    constructor(...args){
        super(...args);
        this.onClick = ()=>{
            this.props.onClick(this.props.mergedColumnProps.fieldType);
        };
        this.renderLockableField = ({ fieldData: fieldData, issueFieldLockControls: issueFieldLockControls, isLastColumn: isLastColumn, fieldName: fieldName, onSetEditingFieldPosition: onSetEditingFieldPosition, isFieldLocked: isFieldLocked, isTableDisabled: isTableDisabled, onIssueViewTransition: onIssueViewTransition })=>{
            const { jsonComponentArgs: jsonComponentArgs, mergedColumnProps: mergedColumnProps, isActive: isActive, shouldHydrateFully: shouldHydrateFully, width: width, rowId: rowId, rowListRef: rowListRef, onEditStart: onEditStart, isUserPickerDisabled: isUserPickerDisabled, JsonCell: JsonCell } = this.props;
            if (fieldData) {
                // @ts-expect-error - TS2339 - Property 'fieldRenderedValue' does not exist on type 'AnyDataSelectorJsonProps | DataSelectorHtmlProps'. | TS2339 - Property 'fieldCssClass' does not exist on type 'AnyDataSelectorJsonProps | DataSelectorHtmlProps'.
                if (fieldData.fieldRenderedValue != null || fieldData.fieldCssClass != null) {
                    const { canBeMultiLine: canBeMultiLine } = this.props;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kEgAJ.default), {
                        canBeMultiLine: !!canBeMultiLine,
                        isLastColumn: isLastColumn,
                        doNotRenderTooltip: !!mergedColumnProps.doNotRenderTooltip,
                        ...fieldData
                    });
                }
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const fieldDataType = fieldData.fieldType;
                if (jsonComponentArgs && jsonComponentArgs.fieldType === fieldDataType) {
                    const { FieldComponent: FieldComponent } = jsonComponentArgs;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(JsonCell, {
                        FieldComponent: FieldComponent,
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fieldData: fieldData,
                        tableInjectedProps: {
                            fieldId: mergedColumnProps.fieldId,
                            isActive: isActive,
                            issueFieldLockControls: issueFieldLockControls,
                            onEditStart: onEditStart,
                            width: width,
                            shouldHydrateFully: shouldHydrateFully,
                            isLastColumn: isLastColumn,
                            issueKey: rowId,
                            fieldName: fieldName,
                            rowListRef: rowListRef,
                            onSetEditingFieldPosition: onSetEditingFieldPosition,
                            isFieldLocked: isFieldLocked,
                            isUserPickerDisabled: isUserPickerDisabled,
                            isTableDisabled: isTableDisabled,
                            onIssueViewTransition: onIssueViewTransition
                        }
                    });
                }
            } else {
                (0, $gUUjF.default).safeWarnWithoutCustomerData($6e189ea30932d4d1$var$LOCATION, `[FD-3358] Rendered an empty cell because a FieldDataSelector returned null without backup data. row-id details: "${JSON.stringify($6e189ea30932d4d1$export$4983e1eef8c41de4(rowId))}", column-type: "${mergedColumnProps.fieldType}"`);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null);
            }
            throw new Error(`[FD-3358] Cannot render cell without either: prerendered html from the data selector OR field json data of the correct type for the current column. row-id details: "${JSON.stringify($6e189ea30932d4d1$export$4983e1eef8c41de4(rowId))}", column-type: "${mergedColumnProps.fieldType}", data-field-type: "${// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            fieldData && fieldData.fieldType}", data-css-class: "${fieldData && fieldData.fieldCssClass}"`);
        };
        this.renderField = (selectorFieldData)=>{
            const { TableStateConnector: TableStateConnector, rowId: rowId } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TableStateConnector, {
                issueKey: rowId,
                fieldDescriptor: this.getFieldDescriptor(),
                fieldData: selectorFieldData
            }, this.renderLockableField);
        };
    }
}
var $6e189ea30932d4d1$export$2e2bcd8739ae039 = (0, $eGI9v.default)('field', {
    onClick: 'clicked',
    onEditStart: 'locked'
})($6e189ea30932d4d1$var$Cell);

});
parcelRegister("kEgAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $40decc87c2a4d4e3$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/react/no-style-attribute */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2eG9N = parcelRequire("2eG9N");
// TODO: FREE-2849 : Revisit the list and add more as required
const $40decc87c2a4d4e3$var$BLOCK_ELEMENTS = 'div, p, h2';
class $40decc87c2a4d4e3$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.onSetRef = (div)=>{
            this.ref = div;
        };
        this.onMouseOver = ()=>{
            if (this.props.doNotRenderTooltip) return;
            if (this.ref) {
                /*
       * If there is a 'block' child node, the width of the child is to be taken for the correct calculations.
       * Since we are rendering HTML blob, we need to find out if there are any 'block' child nodes
       */ const targetElement = this.ref.querySelector($40decc87c2a4d4e3$var$BLOCK_ELEMENTS) || this.ref;
                let tooltipText = '';
                // Check if the element has overflown. If yes, set the innerText in state for tooltip to display
                // @ts-expect-error - TS2339 - Property 'offsetWidth' does not exist on type 'Element'.
                if (targetElement && targetElement.scrollWidth > targetElement.offsetWidth) // @ts-expect-error - TS2339 - Property 'innerText' does not exist on type 'Element'.
                tooltipText = targetElement.innerText;
                if (this.state.tooltipText !== tooltipText) this.setState(()=>({
                        tooltipText: tooltipText
                    }));
            }
        };
        this.rawText = '';
        this.hasEllipsis = false;
        this.state = {
            tooltipText: ''
        };
    }
    getContent() {
        const { fieldRenderedValue: fieldRenderedValue, fieldCssClass: fieldCssClass, canBeMultiLine: canBeMultiLine, isLastColumn: isLastColumn } = this.props;
        const innerHtml = {
            __html: fieldRenderedValue
        };
        if (canBeMultiLine) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // @ts-expect-error - TS2322 - Type '{ padding: string; overflowWrap: string; }' is not assignable to type 'Properties<string | number, string & {}>'.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isLastColumn ? $40decc87c2a4d4e3$var$LastColumnMultilineStyle : $40decc87c2a4d4e3$var$NonLastColumnMultilineStyle,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: fieldCssClass,
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: innerHtml
        });
        return isLastColumn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($40decc87c2a4d4e3$var$StyledWrapperLastColumn, {
            ref: this.onSetRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: fieldCssClass,
            dangerouslySetInnerHTML: innerHtml,
            onMouseOver: this.onMouseOver,
            onFocus: this.onMouseOver,
            role: "textbox",
            tabIndex: 0
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($40decc87c2a4d4e3$var$BaseStyledWrapper, {
            ref: this.onSetRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: fieldCssClass,
            dangerouslySetInnerHTML: innerHtml,
            onMouseOver: this.onMouseOver,
            onFocus: this.onMouseOver,
            role: "textbox",
            tabIndex: 0
        });
    }
    render() {
        const { tooltipText: tooltipText } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($40decc87c2a4d4e3$var$FieldRenderedValueContainer, null, tooltipText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            delay: 0,
            content: tooltipText
        }, this.getContent()) : this.getContent());
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $40decc87c2a4d4e3$var$FieldRenderedValueContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9idpf",
            __cmplp.className
        ])
    });
});
const $40decc87c2a4d4e3$var$BaseStyledWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41rr7 _1reo15vq _18m915vq _1bto1l2s _o5721q9c _1bsb1osq _vchhusvi _bhp515vq _wrxl15vq _5i651l2s _pg4a1q9c",
            __cmplp.className
        ])
    });
});
const $40decc87c2a4d4e3$var$StyledWrapperLastColumn = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $40decc87c2a4d4e3$var$BaseStyledWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4u2gc",
            __cmplp.className
        ])
    });
});
const $40decc87c2a4d4e3$var$LastColumnMultilineStyle = {
    padding: `${"var(--ds-space-100, 8px)"}`,
    overflowWrap: 'break-word'
};
const $40decc87c2a4d4e3$var$NonLastColumnMultilineStyle = {
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
    overflowWrap: 'break-word'
};

});

parcelRegister("hkeMT", function(module, exports) {

$parcel$export(module.exports, "CellWrapper", () => $9cee56a7f79d923e$export$4812fadef83edffe);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $9cee56a7f79d923e$export$4812fadef83edffe = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1tke1ylp _vchhusvi _1bsb1osq",
            __cmplp.className
        ])
    });
});

});






parcelRegister("j4t2m", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f6617c09d124c5d$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $5iWql = parcelRequire("5iWql");

var $l5PRC = parcelRequire("l5PRC");

var $c9TLT = parcelRequire("c9TLT");

var $jRTJE = parcelRequire("jRTJE");

var $92fnI = parcelRequire("92fnI");
const $3f6617c09d124c5d$var$ANIMATION_TIMEOUT = 200;
const $3f6617c09d124c5d$var$ASSIGNEE_HEIGHT = 40;
const $3f6617c09d124c5d$var$ASSIGNEE_DROPDOWN_WIDTH_HEIGHT = 300;
const $3f6617c09d124c5d$var$OFFSET_PADDING = 4;
const $3f6617c09d124c5d$var$BOTTOM_LEFT = 'BOTTOM_LEFT';
const $3f6617c09d124c5d$var$BOTTOM_RIGHT = 'BOTTOM_RIGHT';
const $3f6617c09d124c5d$var$TOP_LEFT = 'TOP_LEFT';
const $3f6617c09d124c5d$var$TOP_RIGHT = 'TOP_RIGHT';
const $3f6617c09d124c5d$var$DROPDOWN_WIDTH_MARGIN = 7 * (0, $c9TLT.gridSize);
const $3f6617c09d124c5d$var$DROPDOWN_HEIGHT_MARGIN = 9 * (0, $c9TLT.gridSize);
const $3f6617c09d124c5d$var$spaceAvailableRightOfField = (tableWidth, horizontalScrollOffset, horizontalOffset)=>tableWidth + horizontalScrollOffset - horizontalOffset > $3f6617c09d124c5d$var$ASSIGNEE_DROPDOWN_WIDTH_HEIGHT + $3f6617c09d124c5d$var$DROPDOWN_WIDTH_MARGIN;
const $3f6617c09d124c5d$var$spaceAvailableUnderField = (tableHeight, verticalScrollOffset, verticalOffset)=>tableHeight + verticalScrollOffset - verticalOffset > $3f6617c09d124c5d$var$ASSIGNEE_DROPDOWN_WIDTH_HEIGHT + $3f6617c09d124c5d$var$DROPDOWN_HEIGHT_MARGIN;
const $3f6617c09d124c5d$var$getPositionType = (horizontalOffset, horizontalScrollOffset, verticalOffset, verticalScrollOffset, tableWidth, tableHeight)=>{
    if ($3f6617c09d124c5d$var$spaceAvailableUnderField(tableHeight, verticalScrollOffset, verticalOffset)) {
        if ($3f6617c09d124c5d$var$spaceAvailableRightOfField(tableWidth, horizontalScrollOffset, horizontalOffset)) return $3f6617c09d124c5d$var$BOTTOM_LEFT;
        return $3f6617c09d124c5d$var$BOTTOM_RIGHT;
    }
    if ($3f6617c09d124c5d$var$spaceAvailableRightOfField(tableWidth, horizontalScrollOffset, horizontalOffset)) return $3f6617c09d124c5d$var$TOP_LEFT;
    return $3f6617c09d124c5d$var$TOP_RIGHT;
};
const $3f6617c09d124c5d$export$193f85369df210ff = (horizontalOffset, horizontalScrollOffset, verticalOffset, verticalScrollOffset, fieldWidth, tableWidth, tableHeight)=>{
    switch($3f6617c09d124c5d$var$getPositionType(horizontalOffset, horizontalScrollOffset, verticalOffset, verticalScrollOffset, tableWidth, tableHeight)){
        case $3f6617c09d124c5d$var$BOTTOM_LEFT:
            return {
                left: `${horizontalOffset - horizontalScrollOffset - $3f6617c09d124c5d$var$OFFSET_PADDING}px`,
                top: `${verticalOffset + $3f6617c09d124c5d$var$ASSIGNEE_HEIGHT}px`,
                bottom: undefined
            };
        case $3f6617c09d124c5d$var$BOTTOM_RIGHT:
            return {
                left: `${horizontalOffset - horizontalScrollOffset + fieldWidth - $3f6617c09d124c5d$var$OFFSET_PADDING - $3f6617c09d124c5d$var$ASSIGNEE_DROPDOWN_WIDTH_HEIGHT}px`,
                top: `${verticalOffset + $3f6617c09d124c5d$var$ASSIGNEE_HEIGHT}px`,
                bottom: undefined
            };
        case $3f6617c09d124c5d$var$TOP_LEFT:
            return {
                left: `${horizontalOffset - horizontalScrollOffset - $3f6617c09d124c5d$var$OFFSET_PADDING}px`,
                top: 'auto',
                bottom: `${-verticalOffset - $3f6617c09d124c5d$var$OFFSET_PADDING}px`
            };
        default:
            return {
                left: `${horizontalOffset - horizontalScrollOffset + fieldWidth - $3f6617c09d124c5d$var$OFFSET_PADDING - $3f6617c09d124c5d$var$ASSIGNEE_DROPDOWN_WIDTH_HEIGHT}px`,
                top: 'auto',
                bottom: `${-verticalOffset - $3f6617c09d124c5d$var$OFFSET_PADDING}px`
            };
    }
};
class $3f6617c09d124c5d$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = (0, $92fnI.defaultProps);
    }
    render() {
        const { currentPage: currentPage, totalPages: totalPages, onPageChange: onPageChange } = this.props;
        const { Table: Table, showPagination: showPagination, Pagination: Pagination, editingFieldHorizontalOffset: editingFieldHorizontalOffset, editingFieldVerticalOffset: editingFieldVerticalOffset, editingFieldWidth: editingFieldWidth, horizontalScrollOffset: horizontalScrollOffset, verticalScrollOffset: verticalScrollOffset, tableWidth: tableWidth, tableHeight: tableHeight, onUpdateHorizontalScrollOffset: onUpdateHorizontalScrollOffset, onActiveRowIdChanged: onActiveRowIdChanged, ...otherProps } = this.props;
        const portalPosition = $3f6617c09d124c5d$export$193f85369df210ff(editingFieldHorizontalOffset, horizontalScrollOffset, editingFieldVerticalOffset, verticalScrollOffset, editingFieldWidth, tableWidth, tableHeight);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f6617c09d124c5d$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f6617c09d124c5d$var$TableContainer, {
            animationTimeout: $3f6617c09d124c5d$var$ANIMATION_TIMEOUT,
            hasPagination: showPagination,
            left: portalPosition.left,
            top: portalPosition.top,
            bottom: portalPosition.bottom
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRTJE.IssueContextSubscriber), null, (__, { setIssueKeyContext: setIssueKeyContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Table, {
                ...otherProps,
                onActiveRowIdChanged: this.onSetIssueKeyContextCallback(setIssueKeyContext),
                onUpdateHorizontalScrollOffset: this.onUpdateHorizontalScrollOffset
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l5PRC.default), {
            in: showPagination,
            classNames: "fade",
            timeout: $3f6617c09d124c5d$var$ANIMATION_TIMEOUT,
            unmountOnExit: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f6617c09d124c5d$var$Animate, {
            timeout: $3f6617c09d124c5d$var$ANIMATION_TIMEOUT
        }, showPagination && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Pagination, {
            currentPage: currentPage,
            totalPages: totalPages,
            onPageChange: onPageChange
        }))));
    }
    constructor(...args){
        super(...args);
        this.onUpdateHorizontalScrollOffset = (horizontalPositioning)=>{
            const { onHorizontalScrollOffsetChanged: onHorizontalScrollOffsetChanged, onUpdateHorizontalScrollOffset: onUpdateHorizontalScrollOffset } = this.props;
            onUpdateHorizontalScrollOffset(horizontalPositioning);
            onHorizontalScrollOffsetChanged && onHorizontalScrollOffsetChanged(horizontalPositioning);
        };
        this.onSetIssueKeyContextCallback = (0, $5iWql.default)((setIssueKeyContext)=>(rowId)=>{
                const isIssueDataLoaded = this.props.loadedIssueKeys.includes(rowId);
                if (isIssueDataLoaded) setIssueKeyContext(rowId);
                else setIssueKeyContext(undefined);
                this.props.onActiveRowIdChanged && this.props.onActiveRowIdChanged(rowId);
            });
    }
}
const $3f6617c09d124c5d$var$APPROX_PAGINATION_HEIGHT = 48;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3f6617c09d124c5d$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $3f6617c09d124c5d$var$TableContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { animationTimeout: animationTimeout, hasPagination: hasPagination, left: left, top: top, bottom: bottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1pg9jf5": (0, $9t7rW.default)(`all ${__cmplp.animationTimeout}ms ease-in`),
            "--_lr32lc": (0, $9t7rW.default)(__cmplp.left),
            "--_1vj9tq": (0, $9t7rW.default)(__cmplp.top),
            "--_14iunx0": (0, $9t7rW.default)(__cmplp.bottom)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _16jl1406 _1o9zkb7n _i0dlf1ug _v5641gtb _15po1rza _1b1u1wug _jzhkstnw _rg151ter _3c8c1tn0",
            __cmplp.hasPagination && "_n3tdckbl",
            __cmplp.className
        ])
    });
});
const $3f6617c09d124c5d$var$Animate = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { timeout: timeout, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_g2896q": (0, $9t7rW.default)(`all ${__cmplp.timeout}ms ease-in`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1n9t _94n5idpf _1xi2idpf _fgdaidpf _9xe0idpf _la5rkb7n _a9jfckbl _15og6od0 _160ykb7n _prrmckbl _1urkidpf _w97pidpf _11h16od0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("92fnI", function(module, exports) {

$parcel$export(module.exports, "defaultProps", () => $3c10d8998d80e246$export$9c21a3269931e1e6);

var $jG2Eu = parcelRequire("jG2Eu");
const $3c10d8998d80e246$export$9c21a3269931e1e6 = {
    currentPage: 1,
    totalPages: 1,
    onPageChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};

});




parcelRegister("c9rDh", function(module, exports) {

$parcel$export(module.exports, "AsyncBulkActionToolbar", () => $ef19d6bab60724c6$export$d53c287f3c6193b2);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef19d6bab60724c6$var$AsyncBulkActionToolbarLazy = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("N5QM9")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/bulk-actions-toolbar/src/index.tsx"
});
const $ef19d6bab60724c6$export$d53c287f3c6193b2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.jira-servicedesk.bulk-actions.toolbar",
        packageName: "atlassian/jira-servicedesk-bulk-actions-toolbar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "servicedesk-bulk-actions-toolbar",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef19d6bab60724c6$var$AsyncBulkActionToolbarLazy, props)));

});
parcelRegister("N5QM9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hkEcx")
]).then(()=>parcelRequire('9tYZ4'));

});


parcelRegister("5Aqh1", function(module, exports) {

$parcel$export(module.exports, "getExperienceTrackingInitialFetchStatus", () => $1303aba920c455d3$export$ec3d1bbe6bde55e);
$parcel$export(module.exports, "getHasLoadedIssueDataFromCache", () => $1303aba920c455d3$export$c50657eec51e9e);
$parcel$export(module.exports, "getInitialFetchErrorEventAttributes", () => $1303aba920c455d3$export$711bef1cfb497c56);

var $df4Sl = parcelRequire("df4Sl");

var $eI5EY = parcelRequire("eI5EY");


var $3i6VQ = parcelRequire("3i6VQ");
const $1303aba920c455d3$export$3c50a15364b58a95 = (state)=>(0, $3i6VQ.getPersisted)(state).experienceTracking;
const $1303aba920c455d3$export$ec3d1bbe6bde55e = (state)=>$1303aba920c455d3$export$3c50a15364b58a95(state).initialDataLoadStatus;
const $1303aba920c455d3$export$c50657eec51e9e = (state)=>$1303aba920c455d3$export$3c50a15364b58a95(state).hasLoadedIssueDataFromCache;
const $1303aba920c455d3$var$getErrorStatusCode = (state)=>$1303aba920c455d3$export$3c50a15364b58a95(state).errorStatusCode;
const $1303aba920c455d3$var$getErrorMessage = (state)=>$1303aba920c455d3$export$3c50a15364b58a95(state).errorMessages;
const $1303aba920c455d3$var$getErrorKey = (state)=>$1303aba920c455d3$export$3c50a15364b58a95(state).errorKey;
const $1303aba920c455d3$var$getTraceId = (state)=>$1303aba920c455d3$export$3c50a15364b58a95(state).traceId;
const $1303aba920c455d3$var$constructErrorMessage = (statusCode, errorMessage, errorKey)=>`Initial fetch failed status code: ${statusCode}, error: ${JSON.stringify(errorMessage)}, errorKey: ${errorKey}`;
const $1303aba920c455d3$export$711bef1cfb497c56 = (0, $df4Sl.createSelector)($1303aba920c455d3$export$ec3d1bbe6bde55e, $1303aba920c455d3$export$c50657eec51e9e, $1303aba920c455d3$var$getErrorStatusCode, $1303aba920c455d3$var$getErrorMessage, $1303aba920c455d3$var$getErrorKey, $1303aba920c455d3$var$getTraceId, (initialDataLoadStatus, hasLoadedIssueDataFromCache, errorStatusCode, errorMessage, errorKey, traceId)=>{
    if (initialDataLoadStatus === (0, $749205be6d2f0e96$export$70ef9aa03c29b42b)) {
        if ((0, $eI5EY.fg)('adding-more-data-for-viewqueue-and-viewnav-event')) return {
            didFallbackOnIssueCache: hasLoadedIssueDataFromCache,
            errorMessage: $1303aba920c455d3$var$constructErrorMessage(errorStatusCode, errorMessage, errorKey),
            traceId: traceId || 'no-trace-id'
        };
        return {
            didFallbackOnIssueCache: hasLoadedIssueDataFromCache,
            errorMessage: errorStatusCode !== undefined ? `Initial fetch failed with status code ${errorStatusCode}` : 'Initial fetch failed'
        };
    }
    return undefined;
});

});

parcelRegister("ihzrq", function(module, exports) {

$parcel$export(module.exports, "getIssueTableAppProps", () => $0d7ad6754cebb1a5$export$b7be6dcc4ea236d0);

var $df4Sl = parcelRequire("df4Sl");

var $3nTcJ = parcelRequire("3nTcJ");
const $0d7ad6754cebb1a5$export$b7be6dcc4ea236d0 = (0, $df4Sl.createSelector)((0, $3nTcJ.getCloudId), (0, $3nTcJ.getFabricPfDirUrl), (0, $3nTcJ.getAtlassianAccountId), (cloudId, fabricPfDirUrl, atlassianAccountId)=>({
        cloudId: cloudId,
        fabricPfDirUrl: fabricPfDirUrl,
        atlassianAccountId: atlassianAccountId
    }));

});

parcelRegister("1sob9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e10615daf8d56d83$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $4gs2G = parcelRequire("4gs2G");

var $gaYiJ = parcelRequire("gaYiJ");

var $8GAE5 = parcelRequire("8GAE5");

var $3KNsL = parcelRequire("3KNsL");

var $1RqtY = parcelRequire("1RqtY");

var $8vWKU = parcelRequire("8vWKU");
const $e10615daf8d56d83$var$mapStateToProps = (state, ownProps)=>{
    const { issueKey: issueKey, fieldDescriptor: { fieldId: fieldId } } = ownProps;
    const isCellFirstFieldInTable = (0, $8GAE5.isFirstFieldInTable)(state, issueKey, fieldId);
    const queueVisible = (0, $1RqtY.isQueueVisible)(state);
    return {
        queueId: (0, $3KNsL.getQueueId)(state),
        onFieldDataSelection: (0, $8GAE5.getFieldPropsSelector)(state),
        isFirstFieldInTable: isCellFirstFieldInTable,
        isFieldToExperienceTrack: (0, $8GAE5.isFieldToExperienceTrack)(state, issueKey, fieldId),
        isQueueVisible: queueVisible,
        ReadyForUser: $gaYiJ.ReadyForUser
    };
};
const $e10615daf8d56d83$var$FieldDataSelector = (0, $lNNXV.connect)($e10615daf8d56d83$var$mapStateToProps, {
    onFieldChange: (0, $4gs2G.changeIssueFieldValueAction)
})((0, $8vWKU.default));
var $e10615daf8d56d83$export$2e2bcd8739ae039 = $e10615daf8d56d83$var$FieldDataSelector;

});
parcelRegister("8vWKU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6950e7312a21be7d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwMhr = parcelRequire("kwMhr");

var $6iz4v = parcelRequire("6iz4v");

var $iJHZm = parcelRequire("iJHZm");

var $91xes = parcelRequire("91xes");
const $6950e7312a21be7d$var$renderWithExperienceTracker = (node, { isFieldToExperienceTrack: isFieldToExperienceTrack, fieldDescriptor: { fieldType: fieldType } })=>isFieldToExperienceTrack ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
        location: `queue-cell-${fieldType}`
    }, node) : node;
const $6950e7312a21be7d$var$renderWithReadyForUser = (node, { queueId: queueId, isQueueVisible: isQueueVisible, isFirstFieldInTable: isFirstFieldInTable })=>isQueueVisible && isFirstFieldInTable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $91xes.AgentTableApdexSubmitter), null), node, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReadyOnUpdate), {
        comparer: [
            queueId
        ]
    })) : node;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6950e7312a21be7d$export$2e2bcd8739ae039 = (props)=>{
    const { onFieldChange: onFieldChange, onFieldDataSelection: onFieldDataSelection, fieldDescriptor: fieldDescriptor, issueKey: issueKey, children: children, isQueueVisible: isQueueVisible, isFirstFieldInTable: isFirstFieldInTable } = props;
    const dataSelectorCoordinates = {
        fieldDescriptor: fieldDescriptor,
        issueKey: issueKey
    };
    if (isQueueVisible && isFirstFieldInTable) (0, $6iz4v.setMark)('jsd.performance.profile.queues.firstfield.render');
    const childrenNode = children(onFieldDataSelection(dataSelectorCoordinates, onFieldChange));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $6950e7312a21be7d$var$renderWithReadyForUser($6950e7312a21be7d$var$renderWithExperienceTracker(childrenNode, props), props));
};

});
parcelRegister("91xes", function(module, exports) {

$parcel$export(module.exports, "AgentTableApdexProvider", () => $2386e7476ed9474a$export$28049b03af6e1521);
$parcel$export(module.exports, "AgentTableApdexSubmitter", () => $2386e7476ed9474a$export$d36b2dc23ff59e3d);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $be3PE = parcelRequire("be3PE");

var $7QneT = parcelRequire("7QneT");

var $aNBkj = parcelRequire("aNBkj");
const $2386e7476ed9474a$var$context = /*#__PURE__*/ (0, $eUqFw.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))));
const $2386e7476ed9474a$export$28049b03af6e1521 = ({ children: children, queueId: queueId, isLoading: isLoading, isVisible: isVisible, metricKey: metricKey, metric: metric, category: category, hasLoadedIssueDataFromCache: hasLoadedIssueDataFromCache })=>{
    const [finishedQueueId, setFinishedQueueId] = (0, $eUqFw.useState)(null);
    const updateFinishedQueueId = (0, $eUqFw.useCallback)(()=>{
        if (!isLoading) setFinishedQueueId(queueId);
    }, [
        queueId,
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2386e7476ed9474a$var$context.Provider, {
        value: updateFinishedQueueId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children, // Do not mount initially (when queueId is null) or when switching queueIds (queueId in state mismatches props) or when table is hidden
    finishedQueueId && finishedQueueId === queueId && isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $be3PE.JsmPageInteractiveEvent), {
        key: queueId ? (0, $aNBkj.fromQueueIdString)(queueId) : undefined,
        metricKey: metricKey,
        withMarks: (0, $7QneT.getAgentViewMarks)(),
        metric: metric,
        extra: {
            category: category || 'no-category',
            empty: false,
            hasLoadedIssueDataFromCache: hasLoadedIssueDataFromCache
        }
    })) : null));
};
const $2386e7476ed9474a$export$d36b2dc23ff59e3d = ()=>{
    const updateFinishedQueueId = (0, $eUqFw.useContext)($2386e7476ed9474a$var$context);
    (0, $eUqFw.useEffect)(updateFinishedQueueId);
    return null;
};

});



parcelRegister("2RpFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $993f93ddbce6f365$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $3ztB9 = parcelRequire("3ztB9");

var $1RqtY = parcelRequire("1RqtY");

var $ghMne = parcelRequire("ghMne");
const $993f93ddbce6f365$var$mapDispatchToProps = {
    onOpenIssue: (0, $3ztB9.openIssueAction)
};
var $993f93ddbce6f365$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
        activeIssueKey: (0, $1RqtY.getIssueKeyContext)(state)
    }), $993f93ddbce6f365$var$mapDispatchToProps)((0, $ghMne.default));

});
parcelRegister("ghMne", function(module, exports) {

$parcel$export(module.exports, "default", () => $971d510216e3d960$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");
const $971d510216e3d960$var$AnalyticsWrapper = (0, $g8JvH.AnalyticsEventToProps)('issue', {
    onKeyDown: 'pressed'
})(({ children: children, onKeyDown: onKeyDown })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($971d510216e3d960$var$Wrapper, {
        role: "presentation",
        onKeyDown: onKeyDown
    }, children));
const $971d510216e3d960$export$4983e1eef8c41de4 = (arg)=>{
    const argSplitByHyphen = arg.split('-');
    return {
        containsHyphen: argSplitByHyphen.length > 1,
        numericalValue: parseInt(argSplitByHyphen[argSplitByHyphen.length - 1], 10),
        length: arg.length
    };
};
class $971d510216e3d960$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isDisabled: false
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($971d510216e3d960$var$AnalyticsWrapper, {
            onKeyDown: this.onKeyDown,
            role: "presentation"
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.onKeyDown = (event, analyticsEvent)=>{
            const { onOpenIssue: onOpenIssue, activeIssueKey: activeIssueKey, isDisabled: isDisabled } = this.props;
            if (!isDisabled && activeIssueKey != null) switch(event.key){
                case 'o':
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'openIssue', {
                        keyPressed: 'o',
                        issueKey: $971d510216e3d960$export$4983e1eef8c41de4(activeIssueKey)
                    });
                    onOpenIssue();
                    event.preventDefault();
                    break;
                case 'Enter':
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'openIssue', {
                        keyPressed: 'enter',
                        issueKey: $971d510216e3d960$export$4983e1eef8c41de4(activeIssueKey)
                    });
                    onOpenIssue();
                    event.preventDefault();
                    break;
                default:
                    break;
            }
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $971d510216e3d960$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kNLgh", function(module, exports) {

$parcel$export(module.exports, "getColumnsForIssueTable", () => $a1e5bd371deaa5a9$export$7fd0c43240a64f42);

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");


var $8Obc6 = parcelRequire("8Obc6");
const $a1e5bd371deaa5a9$var$getStylingOverrides = (fieldType)=>{
    if (fieldType === 'assignee' && !(0, $8Obc6.getFieldTypesEligibleForJsonDataAsSet)().has(fieldType)) return {
        minWidth: 100,
        maxWidth: 200,
        canBeMultiLine: true
    };
    if ((0, $1ybV0.ff)('jsm-queue-sidebar-bug-fixes-second-round_xuenh') && fieldType === 'summary') return {
        minWidth: 262,
        maxWidth: 632,
        canBeMultiLine: true
    };
    return {};
};
const $a1e5bd371deaa5a9$export$7fd0c43240a64f42 = (0, $5iWql.default)((columns, onSortOrderChanged)=>// @ts-expect-error - TS7006 - Parameter 'column' implicitly has an 'any' type.
    columns.map((column)=>{
        const { id: id, title: title, fieldType: fieldType, currentSorting: currentSorting = (0, $e6571ec563c0baf9$export$c53d0f541b41b88e), sortable: sortable } = column;
        return {
            id: id,
            title: title,
            fieldType: fieldType,
            currentSorting: currentSorting,
            onSortOrderChanged: sortable ? onSortOrderChanged : undefined,
            ...$a1e5bd371deaa5a9$var$getStylingOverrides(column.fieldType)
        };
    }));
const $a1e5bd371deaa5a9$export$cd4e5573fbe2b576 = ()=>document.activeElement;

});

parcelRegister("7TXwS", function(module, exports) {

$parcel$export(module.exports, "default", () => $55cae0aa511f3ea1$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $5iWql = parcelRequire("5iWql");

var $eGI9v = parcelRequire("eGI9v");

var $6iz4v = parcelRequire("6iz4v");

var $1ybV0 = parcelRequire("1ybV0");

var $bsdZ2 = parcelRequire("bsdZ2");

var $db2ik = parcelRequire("db2ik");

var $2bMHt = parcelRequire("2bMHt");

var $aNBkj = parcelRequire("aNBkj");

var $f5prk = parcelRequire("f5prk");

var $6vrw7 = parcelRequire("6vrw7");

var $g039U = parcelRequire("g039U");


var $lbc5S = parcelRequire("lbc5S");

var $91xes = parcelRequire("91xes");
const $55cae0aa511f3ea1$var$isEcClientEnabled = ()=>{
    const experiences = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $1ybV0.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-inline');
};
// min scroll offset before the offset changed callback is called
const $55cae0aa511f3ea1$var$MIN_SCROLL_OFFSET_DELTA = 80;
const $55cae0aa511f3ea1$var$hasQueueBecomeVisible = (prevProps, nextProps)=>!prevProps.isQueueVisible && nextProps.isQueueVisible;
const $55cae0aa511f3ea1$var$hasQueueOrPageOrSortingChanged = (prevProps, nextProps)=>prevProps.queueId !== nextProps.queueId || prevProps.currentPage !== nextProps.currentPage || prevProps.isLoading !== nextProps.isLoading || prevProps.sortOrder !== nextProps.sortOrder || prevProps.sortedBy !== nextProps.sortedBy;
const $55cae0aa511f3ea1$var$onIssueViewTransitionOld = (0, $5iWql.default)((queueId, projectKey, queueCategory, isQueueTransient, queuesPush)=>{
    const push = (issueKey)=>{
        const path = isQueueTransient ? (0, $2bMHt.getIssueFragment)(issueKey) : `${(0, $2bMHt.getQueueFragment)((0, $aNBkj.fromQueueId)(queueId), queueCategory)}/${issueKey}`;
        queuesPush(path);
    };
    return (0, $db2ik.getIssueTransitionOverride)(push);
});
const $55cae0aa511f3ea1$var$onIssueViewTransition = (0, $5iWql.default)((queueId, projectKey, queueCategory, isQueueTransient, queuesPush, onSetIssueKey)=>{
    const push = (issueKey)=>{
        const path = isQueueTransient ? (0, $2bMHt.getIssueFragment)(issueKey) : `${(0, $2bMHt.getQueueFragment)((0, $aNBkj.fromQueueId)(queueId), queueCategory)}/${issueKey}`;
        queuesPush(path);
        onSetIssueKey(null);
    };
    return (0, $db2ik.getIssueTransitionOverride)(push);
});
// Init tenantContext for ECClient
const $55cae0aa511f3ea1$var$SaveInlineMutations = ()=>{
    (0, $bsdZ2.useEcClient)();
    return null;
};
class $55cae0aa511f3ea1$export$54ec01a60f47d33d extends (0, $eUqFw.PureComponent) {
    constructor(props){
        super(props);
        this.onIssueDataRequested = (startIndex)=>{
            const { onIssueDataRequested: onIssueDataRequested, isContentStale: isContentStale } = this.props;
            if (!this.isFirstUpdateAfterQueueChange && !isContentStale) onIssueDataRequested(startIndex);
            this.isFirstUpdateAfterQueueChange = false;
        };
        this.onPageChange = (event, newPage, analyticsEvent)=>{
            this.props.onPageChange(event, newPage, analyticsEvent);
        };
        this.onSetIssueTableRef = (ref)=>{
            this.issueTableRef = ref;
        };
        this.onVerticalScrollOffsetChanged = (verticalPosition)=>{
            const { offsetFromTop: offsetFromTop } = verticalPosition;
            const { onVerticalScrollChanged: onVerticalScrollChanged } = this.props;
            let direction = (0, $34edc5e681269c4f$export$57022ca1771ad970);
            if (Math.abs(offsetFromTop - this.prevOffsetFromTop) > $55cae0aa511f3ea1$var$MIN_SCROLL_OFFSET_DELTA) {
                // @ts-expect-error - TS2322 - Type '"UP" | "DOWN"' is not assignable to type '"UNCHANGED"'.
                direction = offsetFromTop > this.prevOffsetFromTop ? (0, $34edc5e681269c4f$export$28a694fb106a7f62) : (0, $34edc5e681269c4f$export$b5ad9376033e98b2);
                this.prevOffsetFromTop = offsetFromTop;
            }
            onVerticalScrollChanged && onVerticalScrollChanged({
                ...verticalPosition,
                direction: direction
            });
        };
        this.isFirstUpdateAfterQueueChange = false;
        (0, $6iz4v.setMark)('jsd.performance.profile.queues.issuetable.mount');
        this.initECClientEnabled = $55cae0aa511f3ea1$var$isEcClientEnabled();
    }
    componentDidMount() {
        if (this.props.canFocusTable) this.focusTable();
        this.props.onTableChange();
        this.prevOffsetFromTop = 0;
    }
    componentDidUpdate(prevProps) {
        if (this.props.canFocusTable && $55cae0aa511f3ea1$var$hasQueueBecomeVisible(prevProps, this.props)) this.focusTable();
        if ($55cae0aa511f3ea1$var$hasQueueOrPageOrSortingChanged(prevProps, this.props)) {
            this.isFirstUpdateAfterQueueChange = true;
            if (this.props.canFocusTable) this.focusTable();
            this.scrollToTop();
            this.props.onTableChange();
        }
    }
    scrollToTop() {
        const { issueTableRef: issueTableRef } = this;
        issueTableRef && issueTableRef.scrollToTop();
    }
    focusTable() {
        const { issueTableRef: issueTableRef } = this;
        issueTableRef && issueTableRef.focusContent();
    }
    render() {
        const { columns: columns, onActiveItemChanged: onActiveItemChanged, IssueTable: IssueTable, DemoDripFeed: DemoDripFeed, issueKeys: issueKeys, isContentStale: isContentStale, isLoading: isLoading, isQueueVisible: isQueueVisible, metricKey: metricKey, currentPage: currentPage, totalPages: totalPages, queueId: queueId, queueCategory: queueCategory, isQueueTransient: isQueueTransient, projectKey: projectKey, FieldDataSelector: FieldDataSelector, controlPolling: controlPolling, KeyboardShortcutListener: KeyboardShortcutListener, AsyncBulkActionToolbar: AsyncBulkActionToolbar, SelectedIssuesSubscriber: SelectedIssuesSubscriber, appProps: { cloudId: cloudId, fabricPfDirUrl: fabricPfDirUrl, atlassianAccountId: atlassianAccountId }, hasLoadedIssueDataFromCache: hasLoadedIssueDataFromCache, useJSMQueueDurationEvent: useJSMQueueDurationEvent, renderSidebarIcon: renderSidebarIcon, shouldRerenderRowOnHover: shouldRerenderRowOnHover, width: width, tableWidth: tableWidth, onSetSelectedIssueKeys: onSetSelectedIssueKeys, onRefreshSidebar: onRefreshSidebar, onSetIssueKey: onSetIssueKey, onNonPremiumSLAColumnError: onNonPremiumSLAColumnError } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55cae0aa511f3ea1$var$OuterContainer, {
            "data-testid": "servicedesk-queues-agent-view.layout.table.out",
            width: tableWidth
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55cae0aa511f3ea1$var$Container, {
            width: width,
            "data-testid": "servicedesk-queues-agent-view.layout.table.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $91xes.AgentTableApdexProvider), {
            queueId: queueId,
            isLoading: isLoading,
            isVisible: isQueueVisible,
            metricKey: metricKey,
            category: queueCategory,
            // @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
            metric: (0, $lbc5S.serviceViewPageLoad),
            hasLoadedIssueDataFromCache: hasLoadedIssueDataFromCache
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f5prk.default), {
            projectKey: projectKey
        }, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55cae0aa511f3ea1$var$IssueTableAnchor, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g039U.FFErrorBoundary), {
                onError: onNonPremiumSLAColumnError,
                id: "queue-sidebar-bulk-edit-bug-fix"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55cae0aa511f3ea1$var$ToolbarPositioning, null, (0, $1ybV0.ff)('jsm-queue-sidebar-bulk-edit-bug-fix_jx9ff', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AsyncBulkActionToolbar, {
                controlPolling: controlPolling,
                width: tableWidth
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AsyncBulkActionToolbar, {
                controlPolling: controlPolling
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectedIssuesSubscriber, null, ({ issueKeys: selectedIssueKeys })=>{
                onSetSelectedIssueKeys(selectedIssueKeys);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(KeyboardShortcutListener, {
                    isDisabled: isContentStale
                }, this.initECClientEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55cae0aa511f3ea1$var$SaveInlineMutations, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueTable, {
                    ref: this.onSetIssueTableRef,
                    isContentStale: isContentStale,
                    isDisabled: isContentStale,
                    columns: columns,
                    issueKeys: issueKeys,
                    selectedIssueKeys: selectedIssueKeys,
                    contentKey: String(queueId),
                    FieldDataSelector: FieldDataSelector,
                    onActiveItemChanged: onActiveItemChanged,
                    onIssueDataRequested: this.onIssueDataRequested,
                    onVerticalScrollOffsetChanged: this.onVerticalScrollOffsetChanged,
                    currentPage: currentPage,
                    onPageChange: this.onPageChange,
                    totalPages: totalPages,
                    appProps: {
                        cloudId: (0, $6vrw7.toCloudId)(cloudId),
                        fabricPfDirUrl: fabricPfDirUrl,
                        atlassianAccountId: atlassianAccountId,
                        premiumSLAColumns: [
                            'issuekey',
                            'summary',
                            'reporter'
                        ]
                    },
                    onIssueViewTransition: // eslint-disable-next-line no-nested-ternary
                    push ? (0, $1ybV0.ff)('jsm-queue-sidebar-bulk-edit-bug-fix_jx9ff') ? $55cae0aa511f3ea1$var$onIssueViewTransition(queueId, projectKey, queueCategory, isQueueTransient, push, onSetIssueKey) : $55cae0aa511f3ea1$var$onIssueViewTransitionOld(queueId, projectKey, queueCategory, isQueueTransient, push) : undefined,
                    useJSMQueueDurationEvent: useJSMQueueDurationEvent,
                    renderSidebarIcon: renderSidebarIcon,
                    refreshSidebar: onRefreshSidebar,
                    shouldRerenderRowOnHover: shouldRerenderRowOnHover
                }));
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DemoDripFeed, null)));
    }
}
var $55cae0aa511f3ea1$export$2e2bcd8739ae039 = (0, $eGI9v.default)('queue', {
    onTableChange: 'viewed'
})($55cae0aa511f3ea1$export$54ec01a60f47d33d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $55cae0aa511f3ea1$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $9t7rW.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.width !== undefined ? "_16jlkb7n _1bsb1efm" : "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $55cae0aa511f3ea1$var$OuterContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $9t7rW.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.width !== undefined ? "_bfhkvuon _1e0c1txw _16jlkb7n _1bsb1efm" : "_bfhkvuon _1e0c1txw _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $55cae0aa511f3ea1$var$ToolbarPositioning = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iu2gc _1ltvoahv _1pbyowjs",
            __cmplp.className
        ])
    });
});
const $55cae0aa511f3ea1$var$IssueTableAnchor = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4t3i1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bsdZ2", function(module, exports) {

$parcel$export(module.exports, "useEcClient", () => $b40c4387cd757cd5$export$9da409beb25e67da);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $gd0Sp = parcelRequire("gd0Sp");

var $65uQX = parcelRequire("65uQX");
const $b40c4387cd757cd5$export$9da409beb25e67da = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let tenantContext;
    try {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        tenantContext = (0, $gd0Sp.useTenantContext)();
    } catch (e) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', `tenant context : ${e?.toString() || ''}`);
    }
    (0, $eUqFw.useEffect)(()=>{
        (0, $65uQX.EcClient).setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    }, [
        tenantContext
    ]);
    const saveIssueMutationToCache = (0, $eUqFw.useCallback)((issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $65uQX.default).saveIssueMutationToCache(issueMutation, key, analyticsFailureEventObj), []);
    const saveIssueMutationsToCache = (0, $eUqFw.useCallback)((issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $65uQX.default).saveIssueMutationsToCache(issueMutations, key, analyticsFailureEventObj), []);
    const searchAndReconcile = (0, $eUqFw.useCallback)((matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability)=>(0, $65uQX.default).searchAndReconcile(matchApiUrl, jqlMatchingKey, search, parseIssueData, capability), []);
    const getIssueMutationFromCache = (key)=>(0, $65uQX.default).getIssueMutationFromCache(key);
    return {
        saveIssueMutationToCache: saveIssueMutationToCache,
        saveIssueMutationsToCache: saveIssueMutationsToCache,
        searchAndReconcile: searchAndReconcile,
        getIssueMutationFromCache: getIssueMutationFromCache
    };
};

});

parcelRegister("db2ik", function(module, exports) {

$parcel$export(module.exports, "overrideTransitionsInCurrentTab", () => $540c1c5cb9c4aa1e$export$d33e462dc45e1561);
$parcel$export(module.exports, "getIssueTransitionOverride", () => $540c1c5cb9c4aa1e$export$e3b6c227a74390b8);
const $540c1c5cb9c4aa1e$export$d33e462dc45e1561 = (push, event)=>{
    const { ctrlKey: ctrlKey, metaKey: metaKey } = event;
    // Let default browser behaviour occur when opening link in new tab/window
    // metaKey for macOS cmd. ctrKey for other OSes.
    if (ctrlKey || metaKey) return;
    event.preventDefault();
    push();
};
const $540c1c5cb9c4aa1e$export$e3b6c227a74390b8 = (push)=>(issueKey, event)=>$540c1c5cb9c4aa1e$export$d33e462dc45e1561(()=>push(issueKey), event);

});



parcelRegister("heWnU", function(module, exports) {

$parcel$export(module.exports, "default", () => $be583ba49f961ab8$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $6Mquv = parcelRequire("6Mquv");
const $be583ba49f961ab8$var$LOCATION = 'servicedesk.queues.agent-view.view.layout.usage-sampler';
const $be583ba49f961ab8$var$INTERVAL = 300000;
class $be583ba49f961ab8$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidMount() {
        this.intervalId = window.setInterval(()=>this.forceUpdate(), $be583ba49f961ab8$var$INTERVAL);
    }
    componentDidCatch(error) {
        this.setState({
            hasError: true
        });
        (0, $guiFP.default)({
            meta: {
                id: 'viewLayoutUsageSampling',
                packageName: 'jiraServicedeskQueuesAgentView',
                teamName: 'jsd-shield'
            },
            // @ts-expect-error - TS2345 - Argument of type 'Error' is not assignable to parameter of type 'string'.
            error: new Error(error)
        });
        (0, $gUUjF.default).safeErrorWithoutCustomerData($be583ba49f961ab8$var$LOCATION, `[FD-3358] Error while sampling usage: ${JSON.stringify(error && error.stack)}`);
    }
    componentWillUnmount() {
        this.intervalId && window.clearInterval(this.intervalId);
    }
    render() {
        if (this.state.hasError) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Mquv.default), null);
    }
}

});
parcelRegister("6Mquv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3f01bd67f1a8040$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $2Enn0 = parcelRequire("2Enn0");

var $lNNXV = parcelRequire("lNNXV");

var $aNBkj = parcelRequire("aNBkj");

var $3nTcJ = parcelRequire("3nTcJ");

var $8GAE5 = parcelRequire("8GAE5");

var $3KNsL = parcelRequire("3KNsL");

var $6ycyf = parcelRequire("6ycyf");

var $1RqtY = parcelRequire("1RqtY");

var $lJIpt = parcelRequire("lJIpt");

var $lbm9U = parcelRequire("lbm9U");
const $b3f01bd67f1a8040$var$mapStateToPropsFactory = ()=>{
    // @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    const onUpdateFactory = (0, $5iWql.default)((queueId, state)=>(analyticsEvent)=>{
            (0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
                containerType: 'queue',
                containerId: `${(0, $aNBkj.fromQueueId)(queueId)}`,
                attributes: {
                    isAdmin: (0, $3nTcJ.getIsAdmin)(state),
                    cachedIssueCount: (0, $8GAE5.getIssueCacheSize)(state),
                    availableIssueCount: (0, $8GAE5.getIssueCount)(state),
                    timeSinceIssueListInitialized: (0, $lJIpt.getTimeSinceIssueListInitialized)(state),
                    isQueueVisible: (0, $1RqtY.isQueueVisible)(state),
                    sortFieldType: (0, $6ycyf.getSortFieldType)(state),
                    sortOrder: (0, $6ycyf.getSortOrder)(state),
                    isDefaultSorting: !(0, $6ycyf.isManuallySorted)(state)
                }
            });
        });
    return (state)=>{
        const queueId = (0, $3KNsL.getQueueId)(state);
        return {
            onUpdate: onUpdateFactory(queueId, state),
            state: // this is used to force re-renders on every state update due to use of `pure` option in react-redux v5
            state
        };
    };
};
var // @ts-expect-error - TS2769 - Argument of type 'null' is not assignable to parameter of type 'MergeProps<{ onUpdate: (analyticsEvent: any) => void; state: State; }, {}, {}, {}>'.
$b3f01bd67f1a8040$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($b3f01bd67f1a8040$var$mapStateToPropsFactory, {}, null, {
    // TODO: this option is deprecated react-redux v8
    pure: false,
    shouldHandleStateChanges: false
})((0, $lbm9U.default));

});
parcelRegister("lJIpt", function(module, exports) {

$parcel$export(module.exports, "getTimeSinceIssueListInitialized", () => $17626f4350bbb657$export$4a764bf7fdeee8c4);

var $hgcvd = parcelRequire("hgcvd");

var $8GAE5 = parcelRequire("8GAE5");
const $17626f4350bbb657$export$4a764bf7fdeee8c4 = (state)=>Math.round((0, $hgcvd.default).now() - (0, $8GAE5.getTimeWhenLastInitialized)(state));

});

parcelRegister("lbm9U", function(module, exports) {

$parcel$export(module.exports, "default", () => $12a3db54bcedc486$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eGI9v = parcelRequire("eGI9v");
// eslint-disable-next-line jira/react/no-class-components
class $12a3db54bcedc486$var$AnalyticsWrapper extends (0, $eUqFw.Component) {
    componentDidUpdate() {
        this.props.onUpdate();
    }
    render() {
        return null;
    }
}
var $12a3db54bcedc486$export$2e2bcd8739ae039 = (0, $eGI9v.default)('UsageSampler', {
    onUpdate: 'sample'
})($12a3db54bcedc486$var$AnalyticsWrapper);

});



parcelRegister("kJKzX", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c7787b80f9c0932$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $hTLlD = parcelRequire("hTLlD");

var $a576Y = parcelRequire("a576Y");

var $gtzuR = parcelRequire("gtzuR");

var $7u4fN = parcelRequire("7u4fN");

var $kODOJ = parcelRequire("kODOJ");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $2eG9N = parcelRequire("2eG9N");

var $5qTKr = parcelRequire("5qTKr");


var $aYtGv = parcelRequire("aYtGv");

var $1ybV0 = parcelRequire("1ybV0");

var $dnJL9 = parcelRequire("dnJL9");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fBSce = parcelRequire("fBSce");

var $bsdZ2 = parcelRequire("bsdZ2");

var $bq4pN = parcelRequire("bq4pN");

var $6FP8W = parcelRequire("6FP8W");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");
var $bFzGY = parcelRequire("bFzGY");

var $7uxUn = parcelRequire("7uxUn");

var $hRZib = parcelRequire("hRZib");

var $6HEK3 = parcelRequire("6HEK3");

var $4yH5W = parcelRequire("4yH5W");

var $elcoO = parcelRequire("elcoO");

var $2htGg = parcelRequire("2htGg");

var $aNBkj = parcelRequire("aNBkj");

var $k3BCk = parcelRequire("k3BCk");

var $kHxr3 = parcelRequire("kHxr3");

var $f1lMr = parcelRequire("f1lMr");

var $g039U = parcelRequire("g039U");

var $p1pRy = parcelRequire("p1pRy");

var $9F9nP = parcelRequire("9F9nP");

var $l9RnQ = parcelRequire("l9RnQ");

var $l3I5p = parcelRequire("l3I5p");

var $frip8 = parcelRequire("frip8");

var $kQ4V1 = parcelRequire("kQ4V1");
const $3c7787b80f9c0932$var$isEcClientEnabled = ()=>{
    const experiences = (0, $1ybV0.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-issue-view');
};
const $3c7787b80f9c0932$var$JsmRepackagingBannerWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3c7787b80f9c0932$var$jsmRepackagingBannerStyles
    }, children);
const $3c7787b80f9c0932$var$SidebarIcon = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleOnKeyDown = (event)=>{
        if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter')) event.stopPropagation();
    };
    const onTooltipShow = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'queueSideBarIcon'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'sideBarIconShown');
    }; // TODO This should flip between sidebar/dialog message when that is implemented
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $l9RnQ.default).openIssueInSidebar),
        onShow: onTooltipShow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": formatMessage((0, $l9RnQ.default).openIssueInSidebar),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kODOJ))), {
            label: formatMessage((0, $l9RnQ.default).openIssueInSidebar)
        }),
        appearance: "subtle",
        spacing: "compact",
        onClick: props.onClickHandler,
        onKeyDown: handleOnKeyDown
    }));
};
const $3c7787b80f9c0932$var$WINDOW_ACTIVE_EVENT = 'visibilitychange'; // eslint-disable-next-line jira/react/no-class-components
class $3c7787b80f9c0932$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.state = {
            startTime: null
        };
    }
    componentDidMount() {
        const { queue: queue, issueCollection: issueCollection, issueCount: issueCount } = this.props;
        this.prevQueue = queue;
        this.addNavigationEventListeners();
        document.addEventListener($3c7787b80f9c0932$var$WINDOW_ACTIVE_EVENT, this.props.onWindowFocus);
        this.triggerIssuesChange(issueCollection);
        this.triggerIssuesCountChange(issueCount);
        this.setStartTime();
    }
    componentDidUpdate(prevProps) {
        const { onboardingResolved: onboardingResolved, onOnboardingResolved: onOnboardingResolved, issueCount: issueCount, onAtLeastOneIssueLoaded: onAtLeastOneIssueLoaded, onWindowFocus: onWindowFocus, isQueueVisible: isQueueVisible, onPageVisibilityChanged: onPageVisibilityChanged, queue: queue, issueCollection: issueCollection } = this.props; // onAtLeastOneIssueLoaded() lets the monolith know that a issue has loaded (for onboarding purposes)
        if (!onboardingResolved && issueCount > 0) {
            onAtLeastOneIssueLoaded();
            onOnboardingResolved(true);
        }
        if (prevProps.onWindowFocus !== onWindowFocus) {
            document.removeEventListener($3c7787b80f9c0932$var$WINDOW_ACTIVE_EVENT, prevProps.onWindowFocus);
            document.addEventListener($3c7787b80f9c0932$var$WINDOW_ACTIVE_EVENT, onWindowFocus);
        }
        if (prevProps.isQueueVisible !== isQueueVisible) onPageVisibilityChanged(isQueueVisible);
        prevProps.issueCollection !== issueCollection && this.triggerIssuesChange(issueCollection);
        prevProps.issueCount !== issueCount && this.triggerIssuesCountChange(issueCount);
        this.prevQueue = queue;
    }
    componentWillUnmount() {
        this.removeNavigationEventListeners();
        this.props.onUnmount();
        document.removeEventListener($3c7787b80f9c0932$var$WINDOW_ACTIVE_EVENT, this.props.onWindowFocus);
    }
    setStartTime() {
        const { startTime: startTime } = this.state;
        if (!startTime) this.setState({
            startTime: Date.now()
        });
    }
    getIsLoadingState() {
        const { isLoadingIssues: isLoadingIssues, queue: queue } = this.props;
        const { prevQueue: prevQueue } = this;
        if (prevQueue && prevQueue.id !== queue.id) return true;
        return isLoadingIssues;
    }
    isLoadingQueues() {
        const { queue: queue } = this.props;
        const { prevQueue: prevQueue } = this;
        return prevQueue && prevQueue.id !== queue.id;
    }
    addNavigationEventListeners() {
        const { onNavCollapseChange: onNavCollapseChange, sidebarApi: sidebarApi } = this.props;
        if (sidebarApi) {
            const { isCollapsed: isCollapsed, navActions: navActions } = sidebarApi;
            const { collapseStartAdd: collapseStartAdd, collapseStartClear: collapseStartClear, expandStartAdd: expandStartAdd, expandStartClear: expandStartClear } = navActions;
            onNavCollapseChange(isCollapsed);
            collapseStartAdd(()=>onNavCollapseChange(true));
            expandStartAdd(()=>onNavCollapseChange(false));
            this.removeNavListeners = ()=>{
                collapseStartClear();
                expandStartClear();
            };
        } else {
            const navigationApi = (0, $k3BCk.createNavigationApi)();
            navigationApi.then((sidebar)=>{
                onNavCollapseChange(sidebar.isCollapsed());
                const removeCollapseListener = sidebar.onCollapseStart(()=>onNavCollapseChange(true));
                const removeExpandListener = sidebar.onExpandStart(()=>onNavCollapseChange(false));
                this.removeNavListeners = ()=>{
                    removeCollapseListener();
                    removeExpandListener();
                };
            }) // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .catch(()=>{});
        }
    }
    removeNavigationEventListeners() {
        this.removeNavListeners && this.removeNavListeners();
    }
    triggerQueueChange() {
        const { queue: queue, onQueueChanged: onQueueChanged } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(this.prevQueue?.id, queue.id) || !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(this.prevQueue?.completeJql, queue.completeJql) || !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(this.prevQueue?.columns, queue.columns) || !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(this.prevQueue?.isFavorite, queue.isFavorite)) onQueueChanged(queue);
    }
    triggerIssuesChange(issueCollection) {
        const { onIssuesChanged: onIssuesChanged } = this.props;
        onIssuesChanged && onIssuesChanged(issueCollection.map((issue)=>issue?.key));
    }
    triggerIssuesCountChange(issuesCount) {
        const { onIssuesCountChanged: onIssuesCountChanged } = this.props;
        onIssuesCountChanged?.(issuesCount);
    }
    renderView() {
        const { Table: Table, EmptyQueue: EmptyQueue, EmptyFilteredQueue: EmptyFilteredQueue, isQueueEmpty: isQueueEmpty, isCurrentDataFiltered: isCurrentDataFiltered, shouldShowBadFilterQueryError: shouldShowBadFilterQueryError, onFilterClear: onFilterClear, onIssueChange: onIssueChange, onSetIssueKey: onSetIssueKey, onNonPremiumSLAColumnError: onNonPremiumSLAColumnError, columns: columns, sidebarIssueKey: sidebarIssueKey, sidebarReactKey: sidebarReactKey } = this.props;
        if (this.isLoadingQueues()) // errorBoundary not necessary since core functionality is not visible
        return null;
        if (isCurrentDataFiltered && !this.getIsLoadingState() && shouldShowBadFilterQueryError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c7787b80f9c0932$var$EmptyStateWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
            eventName: "jsmQueueFiltering failed"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c7787b80f9c0932$var$EmptyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9F9nP.FilterQueryFailed), {
            onFilterClear: onFilterClear
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Table, null));
        if (isCurrentDataFiltered && isQueueEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c7787b80f9c0932$var$EmptyStateWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c7787b80f9c0932$var$EmptyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(EmptyFilteredQueue, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Table, null));
        if (isQueueEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(EmptyQueue, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c7787b80f9c0932$var$TableWithIssueSidebar, {
            Table: Table,
            onIssueChange: onIssueChange,
            onSetIssueKey: onSetIssueKey,
            columns: columns,
            issueKey: sidebarIssueKey,
            reactKey: sidebarReactKey,
            onError: onNonPremiumSLAColumnError
        });
    }
    renderWithoutSelectedIssuesContainer() {
        const { isInitialized: isInitialized, ErrorState: ErrorState, UsageSampler: UsageSampler, Header: Header, queue: { id: queueId }, NavUpdater: NavUpdater, showIssueFailureError: showIssueFailureError, isQueueVisible: isQueueVisible, ViewTracker: ViewTracker, QueuesBreadcrumb: QueuesBreadcrumb, IssueContextListener: IssueContextListener, ItsmContextListener: ItsmContextListener, UpFlowPersistentUpgradeBanner: UpFlowPersistentUpgradeBanner, baseUrl: baseUrl, projectKey: projectKey, category: category, onNonPremiumSLAColumnError: onNonPremiumSLAColumnError } = this.props;
        const isLoading = this.getIsLoadingState(); // This is a state change during render, which is bad. See the comment
        // around ServiceDeskAnalyticsContext#forceRenderWhileLoading:
        // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/servicedesk/queues-agent-view/src/view/index.tsx#110
        this.triggerQueueChange();
        if (!isInitialized) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4yH5W.default), null);
        if (showIssueFailureError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $eI5EY.fg)('jsm-fission-decompose-queue-page-header') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2htGg.default), {
            baseUrl: baseUrl,
            projectKey: projectKey,
            category: category || (0, $f1lMr.NO_CATEGORY)
        }, (actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $6FP8W.getWillShowNav4)() && (0, $1ybV0.ff)('jsm-queues-nav4-refresh-m2-queues-pop-out-view_atq13') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frip8.default), {
                onDeleteComplete: actions.deleteItem
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kHxr3.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3I5p.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ErrorState, null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frip8.default), {
                onDeleteComplete: actions.deleteItem
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3I5p.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ErrorState, null)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2htGg.default), {
            baseUrl: baseUrl,
            projectKey: projectKey,
            category: category || (0, $f1lMr.NO_CATEGORY)
        }, (actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, {
                queueId: queueId,
                onDeleteComplete: actions.deleteItem
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ErrorState, null))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(QueuesBreadcrumb, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueContextListener, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ItsmContextListener, {
            projectKey: projectKey
        }), isQueueVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UpFlowPersistentUpgradeBanner, {
            isBannerEnabled: true,
            isFullWidth: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c7787b80f9c0932$var$LayoutContainer, {
            visible: isQueueVisible,
            "data-test-id": "servicedesk-queues-agent-view.layout.layout"
        }, isQueueVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewTracker, {
            key: (0, $aNBkj.fromQueueIdString)(queueId),
            queueId: queueId
        }), (category === (0, $f1lMr.INCIDENTS) || category === (0, $f1lMr.POST_INCIDENT_REVIEWS)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elcoO.AsyncPostIncidentReviewBenefitModal), {
            queueCategory: category
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2htGg.default), {
            baseUrl: baseUrl,
            projectKey: projectKey,
            category: category || (0, $f1lMr.NO_CATEGORY)
        }, (actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g039U.FFErrorBoundary), {
                onError: onNonPremiumSLAColumnError,
                id: "queue-nav-updater"
            }, !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NavUpdater, {
                queueId: queueId,
                onQueueIssueCountUpdated: actions.editItemIssueCount,
                onProjectStateHashUpdate: actions.refreshNavItems
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UsageSampler, null)), (0, $eI5EY.fg)('jsm-fission-decompose-queue-page-header') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frip8.default), {
                onDeleteComplete: actions.deleteItem
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, {
                queueId: queueId,
                onDeleteComplete: actions.deleteItem
            }))), (0, $eI5EY.fg)('jsm-fission-decompose-queue-page-header') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $1ybV0.ff)('enable_jsm_repackaging_changes_vtwk9') && (category === (0, $f1lMr.CHANGES) || category === (0, $f1lMr.PROBLEMS)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bq4pN.JsmRepackagingBanner), {
            workCategory: category,
            renderWrapper: $3c7787b80f9c0932$var$JsmRepackagingBannerWrapper
        }), (0, $1ybV0.ff)('im_feature_enablement_gating') && category === (0, $f1lMr.POST_INCIDENT_REVIEWS) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bq4pN.JsmRepackagingBanner), {
            workCategory: (0, $f1lMr.INCIDENTS),
            renderWrapper: $3c7787b80f9c0932$var$JsmRepackagingBannerWrapper
        }), (0, $6FP8W.getWillShowNav4)() && (0, $1ybV0.ff)('jsm-queues-nav4-refresh-m2-queues-pop-out-view_atq13') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kHxr3.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3I5p.default), null), this.renderView()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3I5p.default), null), this.renderView())) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $1ybV0.ff)('enable_jsm_repackaging_changes_vtwk9') && (category === (0, $f1lMr.CHANGES) || category === (0, $f1lMr.PROBLEMS)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bq4pN.JsmRepackagingBanner), {
            workCategory: category,
            renderWrapper: $3c7787b80f9c0932$var$JsmRepackagingBannerWrapper
        }), (0, $1ybV0.ff)('im_feature_enablement_gating') && category === (0, $f1lMr.POST_INCIDENT_REVIEWS) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bq4pN.JsmRepackagingBanner), {
            workCategory: (0, $f1lMr.INCIDENTS),
            renderWrapper: $3c7787b80f9c0932$var$JsmRepackagingBannerWrapper
        }), this.renderView())));
    }
    render() {
        const { queue: { id: queueId }, itsmPractices: itsmPractices, issueCollection: issueCollection, issueCount: issueCount, projectKey: projectKey, projectId: projectId, columns: columns, jql: jql } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            attributes: {
                itsmPractices: itsmPractices
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fBSce.SelectedIssuesContainer), {
            scope: `queue - ${(0, $aNBkj.fromQueueIdString)(queueId)}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hRZib.LoadedIssuesContainer), {
            scope: `queue - ${(0, $aNBkj.fromQueueIdString)(queueId)}`,
            queueId: (0, $aNBkj.fromQueueIdString)(queueId),
            projectKey: projectKey,
            projectId: projectId,
            issueCollection: issueCollection,
            totalIssueCount: issueCount,
            columns: columns,
            jql: jql
        }, this.renderWithoutSelectedIssuesContainer())));
    }
}
const { useResizeObserver: $3c7787b80f9c0932$var$useResizeObserver } = (0, $7uxUn.createResizeObserverHook)({
    debouncePeriod: 50 // optional debouncing of resize notifications
});
const $3c7787b80f9c0932$var$TableWithIssueSidebar = ({ Table: Table, onIssueChange: onIssueChange, onSetIssueKey: onSetIssueKey, onError: onError, columns: columns, issueKey: issueKey, reactKey: reactKey })=>{
    const [width, setWidth] = (0, $eUqFw.useState)(0);
    const [tableWidth, setTableWidth] = (0, $eUqFw.useState)(0);
    const [isResizing, setIsResizing] = (0, $eUqFw.useState)(false);
    const [startTime, setStartTime] = (0, $eUqFw.useState)(null);
    const throttledSetWidth = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(setWidth, 50), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)(); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let saveIssueMutationToCache;
    if ($3c7787b80f9c0932$var$isEcClientEnabled()) // eslint-disable-next-line react-hooks/rules-of-hooks
    saveIssueMutationToCache = (0, $bsdZ2.useEcClient)().saveIssueMutationToCache;
    (0, $eUqFw.useEffect)(()=>{
        if (columns && !!columns.find((col)=>col.id === 'summary')) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'queueSideBar enabled');
    }, [
        columns,
        createAnalyticsEvent
    ]);
    const ref = (0, $eUqFw.useRef)(null);
    $3c7787b80f9c0932$var$useResizeObserver({
        ref: ref,
        onResize () {
            setTableWidth(ref.current?.clientWidth ?? 0);
        }
    });
    const onChangeHandler = (event)=>{
        onIssueChange();
        (0, $6HEK3.saveIssueMutationAnalyticsToCache)(event, createAnalyticsEvent, saveIssueMutationToCache);
    };
    const renderSidebarIcon = (0, $eUqFw.useCallback)((selectedIssueKey)=>{
        const onClickHandler = ()=>{
            const sidebarIconClickEvent = createAnalyticsEvent({
                action: 'click',
                actionSubject: 'queueSideBarIcon'
            });
            (0, $jMP2a.fireTrackAnalytics)(sidebarIconClickEvent, 'sideBarIcon clicked');
            onSetIssueKey(selectedIssueKey);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c7787b80f9c0932$var$SidebarIcon, {
            onClickHandler: onClickHandler
        });
    }, [
        createAnalyticsEvent,
        onSetIssueKey
    ]);
    const onJSMQueueDurationEvent = (0, $eUqFw.useCallback)(()=>{
        if (startTime) {
            const duration = Date.now() - startTime;
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueIssue view', {
                duration: duration
            }); // Only fire after the first click
            setStartTime(null);
        }
    }, [
        createAnalyticsEvent,
        startTime
    ]);
    const onSidebarClose = (0, $eUqFw.useCallback)(()=>{
        onSetIssueKey(null);
    }, [
        onSetIssueKey
    ]);
    const onIssueDeleteSuccess = (0, $eUqFw.useCallback)(()=>{
        onSetIssueKey(null);
        onIssueChange();
    }, [
        onIssueChange,
        onSetIssueKey
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setStartTime(Date.now());
    }, [
        setStartTime
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c7787b80f9c0932$var$ViewWrapper, {
        "data-testid": "servicedesk-queues-agent-view.layout.tablecontainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3c7787b80f9c0932$var$TableAndSidebarWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5qTKr.WidthObserver), {
        setWidth: throttledSetWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c7787b80f9c0932$var$TableWrapper, {
        "data-testid": "servicedesk-queues-agent-view.layout.table",
        isResizing: isResizing,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Table, {
        renderSidebarIcon: renderSidebarIcon,
        shouldRerenderRowOnHover: true,
        useJSMQueueDurationEvent: onJSMQueueDurationEvent,
        width: width,
        tableWidth: tableWidth
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g039U.FFErrorBoundary), {
        onError: onError,
        id: "sidebar-issue-view"
    }, issueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ4V1.SidebarIssueView), {
        key: reactKey,
        issueKey: issueKey,
        parentWidth: width,
        onClose: onSidebarClose,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        analyticsSource: (0, $0100842672acae20$export$7063ee6d0035a982),
        setIsResizing: setIsResizing,
        onChange: onChangeHandler
    }))), (0, $eI5EY.fg)('jsm_boards_promo_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $p1pRy.BoardPromoSpotlight), null));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c7787b80f9c0932$var$LayoutContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visible: visible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1s93bfy": (0, $9t7rW.default)((0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2lx21bp4 _4t3i1l47 _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.visible ?? true ? "_1e0c1txw" : "_1e0cglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c7787b80f9c0932$var$EmptyStateWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1c0ioahv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c7787b80f9c0932$var$EmptyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _19pk9by0 _18u01ssb _t9ecg9dd",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c7787b80f9c0932$var$ViewWrapperLegacy = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c1txw _4t3i1osq _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c7787b80f9c0932$var$ViewWrapperNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c1txw _1bsb1osq _4t3i1osq _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $3c7787b80f9c0932$var$ViewWrapper = (0, $dnJL9.componentWithFG)('jsm-fission-decompose-queue-page-header', $3c7787b80f9c0932$var$ViewWrapperNew, $3c7787b80f9c0932$var$ViewWrapperLegacy); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c7787b80f9c0932$var$TableWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isResizing: isResizing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jl11wp _1reo1wug _p12f1osq",
            __cmplp.isResizing ? "_uiztglyw" : "_uizt1wug",
            __cmplp.className
        ])
    });
});
const $3c7787b80f9c0932$var$TableAndSidebarWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    width: '100%'
});
const $3c7787b80f9c0932$var$jsmRepackagingBannerStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.300'
});

});
parcelRegister("kODOJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2775d08fa787154$var$_react = $f2775d08fa787154$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $f2775d08fa787154$var$_sidebarRight = $f2775d08fa787154$var$_interopRequireDefault((parcelRequire("jzQ1O")));
function $f2775d08fa787154$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f2775d08fa787154$var$DetailViewIcon = (props)=>/*#__PURE__*/ $f2775d08fa787154$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14 17h6V7.01C20 7 14 7 14 7zM12 5h8c1.11 0 2 .9 2 2.01V17a2 2 0 0 1-2 2h-8zM2 7h8V5H3a1 1 0 0 0-1 1zm0 4h8V9H2zm0 7c0 .55.45 1 1 1h7v-2H2zm0-3h8v-2H2z"/></svg>`
    }, props, {
        newIcon: $f2775d08fa787154$var$_sidebarRight.default
    }));
$f2775d08fa787154$var$DetailViewIcon.displayName = 'DetailViewIcon';
var $f2775d08fa787154$var$_default = module.exports.default = $f2775d08fa787154$var$DetailViewIcon;

});
parcelRegister("jzQ1O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efcec0491b82465a6dab2a2bedd12deb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e409a4f36bea7306$var$_react = $e409a4f36bea7306$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $e409a4f36bea7306$var$_UNSAFE_baseNew = $e409a4f36bea7306$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $e409a4f36bea7306$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "SidebarRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a sidebar to the right of the viewport edge.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e409a4f36bea7306$var$SidebarRightIcon = (props)=>/*#__PURE__*/ $e409a4f36bea7306$var$_react.default.createElement($e409a4f36bea7306$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.75 2.75H14c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H7.75m0-10.5v10.5m0-10.5H2C1.31 2.75.75 3.31.75 4v8c0 .69.56 1.25 1.25 1.25h5.75M10 5.75h3m-3 3h3"/>`
    }, props));
$e409a4f36bea7306$var$SidebarRightIcon.displayName = 'SidebarRightIcon';
var $e409a4f36bea7306$var$_default = module.exports.default = $e409a4f36bea7306$var$SidebarRightIcon;

});


parcelRegister("bq4pN", function(module, exports) {

$parcel$export(module.exports, "JsmRepackagingBanner", () => $e638eb43cdbc6d49$export$35e7cf278e8fd184);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e638eb43cdbc6d49$var$AsyncJsmRepackagingBanner = (0, $7rh0R.lazy)(()=>(parcelRequire("gMHId")).then((module)=>module.JsmRepackagingBanner), {
    moduleId: "./src/packages/servicedesk/jsm-repackaging-banner/src/ui/index.tsx"
});
const $e638eb43cdbc6d49$export$35e7cf278e8fd184 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "jsmRepackagingBanner",
        packageName: "jiraJsmRepackagingBanner",
        fallback: "unmount",
        teamName: "jenga",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-repackaging-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e638eb43cdbc6d49$var$AsyncJsmRepackagingBanner, props)));

});
parcelRegister("gMHId", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fxQwV").then(()=>parcelRequire('l1QgQ'));

});


parcelRegister("7uxUn", function(module, exports) {

$parcel$export(module.exports, "createResizeObserverHook", () => $dc839ec384d19a4a$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $dc839ec384d19a4a$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $dc839ec384d19a4a$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $dc839ec384d19a4a$export$e58143dc89297272);

var $eUqFw = parcelRequire("eUqFw");

var $gDQs6 = parcelRequire("gDQs6");
function $dc839ec384d19a4a$export$87a9d3e287304ae4(params) {
    const group = new (0, $gDQs6.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $eUqFw.useRef)(onResize);
        (0, $eUqFw.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $eUqFw.useCallback)(()=>onResizeRef.current(), []);
        (0, $eUqFw.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $dc839ec384d19a4a$export$683480f191c0e3ea, flushResizeObservers: $dc839ec384d19a4a$export$a181ef2a6d0a1bb6 } = $dc839ec384d19a4a$export$87a9d3e287304ae4();
function $dc839ec384d19a4a$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $dc839ec384d19a4a$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $eUqFw.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("gDQs6", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverGroup", () => $91e461fbc4ab66c0$export$607798bbe2869c0);

var $lEfVV = parcelRequire("lEfVV");

var $dxIU5 = parcelRequire("dxIU5");
class $91e461fbc4ab66c0$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $lEfVV.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});


parcelRegister("hRZib", function(module, exports) {

$parcel$export(module.exports, "LoadedIssuesContainer", () => $49eea37f6465a0b8$export$53928552b3ea6ee2);
$parcel$export(module.exports, "useLoadedIssues", () => $49eea37f6465a0b8$export$982ad9cb800a4cbf);

var $8blac = parcelRequire("8blac");

var $cZHIn = parcelRequire("cZHIn");

var $WBLbN = parcelRequire("WBLbN");
const $49eea37f6465a0b8$var$getFieldIds = (columns)=>columns.map((col)=>col.id);
const $49eea37f6465a0b8$var$convertIssuesToKeyMap = (loadedIssues)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    loadedIssues.reduce((map, issue)=>{
        if (issue !== undefined && issue !== null) {
            const issueKeyToIdMap = map;
            issueKeyToIdMap[issue.key] = issue.id;
        }
        return map;
    }, {});
const $49eea37f6465a0b8$export$f23754098a438d57 = ()=>({ getState: getState, setState: setState }, { issueCollection: issueCollection, totalIssueCount: totalIssueCount, projectKey: projectKey, projectId: projectId, queueId: queueId, columns: columns, jql: jql })=>{
        const { issueKeyToIdMap: prevIssueKeyToIdMap, totalIssueCount: prevTotalIssueCount } = getState();
        if (!issueCollection || !totalIssueCount) return;
        const issueKeyToIdMap = $49eea37f6465a0b8$var$convertIssuesToKeyMap(issueCollection);
        if (totalIssueCount !== prevTotalIssueCount || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))((0, (/*@__PURE__*/$parcel$interopDefault($cZHIn)))(Object.keys(issueKeyToIdMap), Object.keys(prevIssueKeyToIdMap)))) {
            const fieldIds = $49eea37f6465a0b8$var$getFieldIds(columns);
            const noUndefinedIssueCollection = issueCollection.filter((item)=>item);
            setState({
                issueKeyToIdMap: issueKeyToIdMap,
                totalIssueCount: totalIssueCount,
                fieldIds: fieldIds,
                issueCollection: noUndefinedIssueCollection,
                projectKey: projectKey,
                projectId: projectId,
                queueId: queueId,
                columns: columns,
                jql: jql
            });
        }
    };
const $49eea37f6465a0b8$var$smartActions = {
    setLoadedIssues: $49eea37f6465a0b8$export$f23754098a438d57
};
const $49eea37f6465a0b8$export$d4c72bab9d6cc13a = {
    issueKeyToIdMap: {},
    totalIssueCount: 0,
    fieldIds: [],
    issueCollection: [],
    queueId: '',
    projectKey: '',
    projectId: 0,
    columns: [],
    jql: ''
};
const $49eea37f6465a0b8$var$Store = (0, $WBLbN.createStore)({
    name: 'loaded-queue',
    initialState: $49eea37f6465a0b8$export$d4c72bab9d6cc13a,
    actions: $49eea37f6465a0b8$var$smartActions
});
const $49eea37f6465a0b8$export$53928552b3ea6ee2 = (0, $WBLbN.createContainer)($49eea37f6465a0b8$var$Store, {
    onInit: $49eea37f6465a0b8$export$f23754098a438d57,
    onUpdate: $49eea37f6465a0b8$export$f23754098a438d57
});
const $49eea37f6465a0b8$export$b78ba1e2dbc48fb6 = (0, $WBLbN.createSubscriber)($49eea37f6465a0b8$var$Store, {
    displayName: 'LoadedIssuesSubscriber'
});
const $49eea37f6465a0b8$export$982ad9cb800a4cbf = (0, $WBLbN.createHook)($49eea37f6465a0b8$var$Store);
var $49eea37f6465a0b8$export$2e2bcd8739ae039 = $49eea37f6465a0b8$var$Store;

});
parcelRegister("cZHIn", function(module, exports) {

var $904yO = parcelRequire("904yO");

var $9eFtX = parcelRequire("9eFtX");

var $a5Cec = parcelRequire("a5Cec");

var $cRpul = parcelRequire("cRpul");
/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */ var $975d175e4660fff1$var$xor = $9eFtX(function(arrays) {
    return $a5Cec($904yO(arrays, $cRpul));
});
module.exports = $975d175e4660fff1$var$xor;

});
parcelRegister("a5Cec", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $hKE3p = parcelRequire("hKE3p");

var $42tFs = parcelRequire("42tFs");
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $7588064e955aa173$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $42tFs(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $fa0Ox(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $42tFs($hKE3p(result, 1), iteratee, comparator);
}
module.exports = $7588064e955aa173$var$baseXor;

});



parcelRegister("6HEK3", function(module, exports) {

$parcel$export(module.exports, "saveIssueMutationAnalyticsToCache", () => $b55abc31e99ca421$export$75fba429fd9a065f);

var $1ybV0 = parcelRequire("1ybV0");

var $fE3Ua = parcelRequire("fE3Ua");

var $48mPv = parcelRequire("48mPv");

var $d7Wfe = parcelRequire("d7Wfe");
const $b55abc31e99ca421$var$isEcClientEnabled = ()=>{
    const experiences = (0, $1ybV0.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-issue-view');
};
const $b55abc31e99ca421$export$75fba429fd9a065f = (event, createAnalyticsEvent, /* saveIssueMutationToCache from useEcClient() */ saveIssueMutationToCache)=>{
    if ($b55abc31e99ca421$var$isEcClientEnabled() && event?.type === (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGED) {
        const mutationFailedAnalyticsPayload = {
            errorMsg: 'FAILED_JSM_ISSUEVIEW',
            error: true
        };
        const analyticsEventObj = createAnalyticsEvent({});
        const analyticsDataKey = {
            analyticsEventObj: analyticsEventObj,
            analyticsMetadata: {
                scenario: 'jsm-issue-view',
                type: event.type
            }
        };
        saveIssueMutationToCache(new (0, $48mPv.default)(event?.issueId, (0, $d7Wfe.MutationSource).UPDATE), analyticsDataKey, mutationFailedAnalyticsPayload);
    }
};

});
parcelRegister("fE3Ua", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $407ab16d43881e85$export$8db21fc94823e1cc);
const $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $407ab16d43881e85$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $407ab16d43881e85$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $407ab16d43881e85$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $407ab16d43881e85$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $407ab16d43881e85$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $407ab16d43881e85$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $407ab16d43881e85$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$export$8db21fc94823e1cc = {
    [$407ab16d43881e85$var$FIELD_CHANGE_REQUESTED]: $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED,
    [$407ab16d43881e85$var$FIELD_CHANGE_FAILED]: $407ab16d43881e85$var$FIELD_CHANGE_FAILED,
    [$407ab16d43881e85$var$FIELD_CHANGED]: $407ab16d43881e85$var$FIELD_CHANGED,
    [$407ab16d43881e85$var$ISSUE_TYPE_CHANGED]: $407ab16d43881e85$var$ISSUE_TYPE_CHANGED,
    [$407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED]: $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED,
    [$407ab16d43881e85$var$ISSUE_LINKS_CREATED]: $407ab16d43881e85$var$ISSUE_LINKS_CREATED,
    [$407ab16d43881e85$var$ISSUE_LINK_DELETED]: $407ab16d43881e85$var$ISSUE_LINK_DELETED,
    [$407ab16d43881e85$var$CHILD_ISSUE_ADDED]: $407ab16d43881e85$var$CHILD_ISSUE_ADDED,
    [$407ab16d43881e85$var$SUBTASK_ADDED]: $407ab16d43881e85$var$SUBTASK_ADDED,
    [$407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED]: $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED]: $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED,
    [$407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});


parcelRegister("elcoO", function(module, exports) {

$parcel$export(module.exports, "AsyncPostIncidentReviewBenefitModal", () => $ee15e28d9bcfe1c0$export$1b5ddc821da26d04);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ee15e28d9bcfe1c0$var$LazyPostIncidentReviewBenefitModal = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("55xh1")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/post-incident-review-tour/src/ui/benefit-modal/index.tsx"
});
const $ee15e28d9bcfe1c0$export$1b5ddc821da26d04 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "postIncidentReviewBenefitModalComponent",
        packageName: "jiraServiceDeskPostIncidentReviewTour",
        teamName: "itsm-agni",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "post-incident-review-benefit-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ee15e28d9bcfe1c0$var$LazyPostIncidentReviewBenefitModal, props)));

});
parcelRegister("55xh1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("fpROI")
]).then(()=>parcelRequire('1323q'));

});


parcelRegister("k3BCk", function(module, exports) {

$parcel$export(module.exports, "createNavigationApi", () => $aff52659f81c308a$export$b440baa5a08af532);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
const $aff52659f81c308a$var$NAVIGATION_API_MODULE = 'servicedesk/jira/api';
// Try to require navigation api over 500ms, otherwise we'll fallback.
const $aff52659f81c308a$var$REQUIRE_TIMEOUT = 100;
const $aff52659f81c308a$var$REQUIRE_RETRIES = 5;
const $aff52659f81c308a$export$b440baa5a08af532 = ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $2BvS3.loadBridge)({
        name: $aff52659f81c308a$var$NAVIGATION_API_MODULE,
        timeout: $aff52659f81c308a$var$REQUIRE_TIMEOUT,
        tentatives: $aff52659f81c308a$var$REQUIRE_RETRIES,
        shouldLogError: false
    }).then((jiraApi)=>jiraApi.getNavigationApi());

});

parcelRegister("kHxr3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4a6e79cb4b646c9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aOINP = parcelRequire("aOINP");
var $ltfxy = parcelRequire("ltfxy");
var $7zpSo = parcelRequire("7zpSo");

var $b5IAe = parcelRequire("b5IAe");


var $5ge6s = parcelRequire("5ge6s");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fOCNu = parcelRequire("fOCNu");

var $jo4Ct = parcelRequire("jo4Ct");

var $cyl4r = parcelRequire("cyl4r");

var $fDE9L = parcelRequire("fDE9L");

var $ap7vt = parcelRequire("ap7vt");

var $lB25E = parcelRequire("lB25E");

var $7kuQk = parcelRequire("7kuQk");
const $c4a6e79cb4b646c9$var$SPOTLIGHT_TARGET_ID = 'jsm-nav4-queues-popout';
const $c4a6e79cb4b646c9$var$SPOTLIGHT_MESSAGE_ID = 'jsm-nav4-queues-popout-spotlight';
const $c4a6e79cb4b646c9$var$QueuesPopoutSpotlight = ({ stop: stop, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onClick = (0, $eUqFw.useCallback)(()=>{
        onDismiss?.();
        stop?.();
    }, [
        onDismiss,
        stop
    ]);
    const actions = (0, $eUqFw.useMemo)(()=>[
            {
                onClick: onClick,
                text: formatMessage((0, $7kuQk.default).spotlightDismissButtonLabel)
            }
        ], [
        onClick,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zpSo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ap7vt.JiraSpotlight), {
        actions: actions,
        dialogPlacement: "right top",
        heading: formatMessage((0, $7kuQk.default).spotlightHeading),
        key: $c4a6e79cb4b646c9$var$SPOTLIGHT_TARGET_ID,
        target: $c4a6e79cb4b646c9$var$SPOTLIGHT_TARGET_ID,
        targetRadius: 3,
        targetBgColor: `var(--ds-surface, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
        messageId: $c4a6e79cb4b646c9$var$SPOTLIGHT_MESSAGE_ID,
        messageType: "engagement"
    }, formatMessage((0, $7kuQk.default).spotlightMessage)));
};
const $c4a6e79cb4b646c9$var$QueuesPopoutPanelNav4 = ({ children: children })=>{
    const [projectKeyFromPath] = (0, $lB25E.usePathParam)('projectKey');
    const [practiceFromPath] = (0, $lB25E.usePathParam)('practiceType');
    const categoryFromPath = (0, $fDE9L.toItsmPractice)(practiceFromPath);
    const [isSpotlightDismissed, setIsSpotlightDismissed] = (0, $eUqFw.useState)(false);
    const categoryStateKey = (0, $jo4Ct.getCategoryStateKey)(projectKeyFromPath || '', categoryFromPath);
    const [isPoppedOut] = (0, $jo4Ct.usePoppedOutState)(categoryStateKey);
    const onSpotlightDismiss = (0, $eUqFw.useCallback)(()=>{
        setIsSpotlightDismissed(true);
    }, [
        setIsSpotlightDismissed
    ]);
    const practiceQueues = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: $c4a6e79cb4b646c9$var$SPOTLIGHT_TARGET_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyl4r.PracticeQueues), {
        key: categoryStateKey,
        projectKey: projectKeyFromPath || '',
        practice: categoryFromPath
    }))), isPoppedOut && !isSpotlightDismissed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ge6s.default), {
        messageId: $c4a6e79cb4b646c9$var$SPOTLIGHT_MESSAGE_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c4a6e79cb4b646c9$var$QueuesPopoutSpotlight, {
        onDismiss: onSpotlightDismiss
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fOCNu.default), {
        isPoppedOut: isPoppedOut,
        popoutComponent: practiceQueues
    }, children);
};
var $c4a6e79cb4b646c9$export$2e2bcd8739ae039 = $c4a6e79cb4b646c9$var$QueuesPopoutPanelNav4;

});
parcelRegister("5ge6s", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $67d1cec28351d2e7$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $67d1cec28351d2e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1C9jQ = parcelRequire("1C9jQ");

var $xMKqn = parcelRequire("xMKqn");
var $DEVKo = parcelRequire("DEVKo");

var $67SDP = parcelRequire("67SDP");

var $hS6Nu = parcelRequire("hS6Nu");

var $6uNFR = parcelRequire("6uNFR");

var $jGBLd = parcelRequire("jGBLd");

var $e91YZ = parcelRequire("e91YZ");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $jD3pk = parcelRequire("jD3pk");

var $38OPi = parcelRequire("38OPi");
const $67d1cec28351d2e7$var$isSyntheticTenant = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true';
class $67d1cec28351d2e7$export$580a2294c917898c extends (0, $DEVKo.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
        const environment = (0, $38OPi.toEnvironment)((0, $6rW04.default)('ajs-environment'));
        const getEnvironmentType = (env)=>{
            if (env === 'prod') return (0, $1C9jQ.envType).PROD;
            if (env === 'staging') return (0, $1C9jQ.envType).STAGING;
            return (0, $1C9jQ.envType).DEV;
        };
        // If a ancestor (e.g. CoordinationClient wraps CoordinationClient) is already choreographed,
        // we should not re-choreograph this CoordinationClient
        const enableChoreographer = (0, $jGBLd.shouldBeChoreographed)({
            messageType: messageType
        }) && !isAlreadyChoreographedAtAncestor;
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: getEnvironmentType(environment),
            additionalData: {
                sourceProductId: (0, $67SDP.ProductIds).JIRA
            }
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $67d1cec28351d2e7$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        this.enableChoreographer = enableChoreographer;
        this.onMessageDisposition = onMessageDisposition;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $1ybV0.ff)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, $67SDP.MessageDeliveryStatus).STARTED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) {
                const didStop = await super.stop(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $67SDP.MessageDeliveryStatus).STOPPED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            }
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId).then((didStart)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, $67SDP.MessageDeliveryStatus).STARTED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            return didStart;
        });
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId).then((didStop)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $67SDP.MessageDeliveryStatus).STOPPED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            return didStop;
        });
    }
}
function $67d1cec28351d2e7$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $6uNFR.useChoreographedStatusContext)();
    const client = new $67d1cec28351d2e7$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
    const { fallback: fallback, messageId: messageId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hS6Nu.ChoreographerContextProvider), {
        isChoreographed: client.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xMKqn.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children));
}

});
parcelRegister("hS6Nu", function(module, exports) {

$parcel$export(module.exports, "ChoreographerContextProvider", () => $ea4a43adc0d84a49$export$c3226151caaf2fbf);

var $eUqFw = parcelRequire("eUqFw");

var $6uNFR = parcelRequire("6uNFR");
const $ea4a43adc0d84a49$var$choreographedStatusContextValue = {
    isAlreadyChoreographedAtAncestor: true
};
const $ea4a43adc0d84a49$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $6uNFR.useChoreographedStatusContext)();
    const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
    return shouldUseChoreographerContextProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uNFR.ChoreographedStatusContext).Provider, {
        value: $ea4a43adc0d84a49$var$choreographedStatusContextValue
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};

});


parcelRegister("fOCNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $27ae39ee0be4ef36$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $27ae39ee0be4ef36$var$PopoutPanelNav4 = ({ isPoppedOut: isPoppedOut, popoutComponent: popoutComponent, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $27ae39ee0be4ef36$var$rootContainerStyles
    }, isPoppedOut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $27ae39ee0be4ef36$var$popoutPanelContainerStyles
    }, popoutComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $27ae39ee0be4ef36$var$mainContentContainerStyles
    }, children));
var $27ae39ee0be4ef36$export$2e2bcd8739ae039 = $27ae39ee0be4ef36$var$PopoutPanelNav4;
// Styles
const $27ae39ee0be4ef36$var$rootContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    height: '100%',
    width: '100%',
    overflow: 'hidden'
});
const $27ae39ee0be4ef36$var$popoutPanelContainerStyles = (0, $1ZAYh.xcss)({
    borderRightWidth: "var(--ds-border-width, 1px)",
    borderRightColor: 'color.border',
    borderRightStyle: 'solid',
    paddingRight: 'space.150',
    marginRight: 'space.150',
    minWidth: '280px',
    width: '280px',
    overflowY: 'auto'
});
const $27ae39ee0be4ef36$var$mainContentContainerStyles = (0, $1ZAYh.xcss)({
    flexDirection: 'column',
    display: 'flex',
    height: '100%',
    width: '100%',
    overflowX: 'hidden'
});

});

parcelRegister("jo4Ct", function(module, exports) {

$parcel$export(module.exports, "getCategoryStateKey", () => $d81d08658fb9a88c$export$6075a80438f902e4);
$parcel$export(module.exports, "CategoryStateContainer", () => $d81d08658fb9a88c$export$d25429b1c35bc216);
$parcel$export(module.exports, "usePoppedOutState", () => $d81d08658fb9a88c$export$abcb35f5af9dd85b);
$parcel$export(module.exports, "useLastVisitedQueueId", () => $d81d08658fb9a88c$export$c2c81ffd0b8349b);

var $WBLbN = parcelRequire("WBLbN");

var $iKZpp = parcelRequire("iKZpp");
const $d81d08658fb9a88c$export$f08a5758b7b88593 = 50;
const $d81d08658fb9a88c$export$939aa9619c650220 = 2419200000; // 28 days in milliseconds
const $d81d08658fb9a88c$var$createUpdateAction = (projectKey, practice, stateKey, value)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const categoryKey = $d81d08658fb9a88c$export$6075a80438f902e4(projectKey, practice);
        const newState = {
            ...currentState,
            [categoryKey]: {
                ...currentState[categoryKey] || {},
                [stateKey]: value,
                latestUpdateTimestamp: Date.now()
            }
        };
        setState(newState);
        // Save an evicted state to local storage to prevent unbounded growth.
        const evictedState = (0, $iKZpp.getEvictedState)(newState, $d81d08658fb9a88c$export$f08a5758b7b88593, $d81d08658fb9a88c$export$939aa9619c650220);
        (0, $iKZpp.setQueuesCategoryStateInLocalStorage)(evictedState);
    };
const $d81d08658fb9a88c$export$e324594224ef24da = {
    updatePoppedOutState: (projectKey, practice, isPoppedOut)=>$d81d08658fb9a88c$var$createUpdateAction(projectKey, practice, 'isPoppedOut', isPoppedOut),
    updateLastVisitedQueueId: (projectKey, practice, queueId)=>$d81d08658fb9a88c$var$createUpdateAction(projectKey, practice, 'lastVisitedQueueId', queueId),
    updateIsStarredExpanded: (projectKey, practice, isExpanded)=>$d81d08658fb9a88c$var$createUpdateAction(projectKey, practice, 'isStarredExpanded', isExpanded),
    updateExpandedGroups: (projectKey, practice, groups)=>$d81d08658fb9a88c$var$createUpdateAction(projectKey, practice, 'expandedGroups', groups),
    updateIsAllQueuesOpen: (projectKey, practice, isOpen)=>$d81d08658fb9a88c$var$createUpdateAction(projectKey, practice, 'isAllQueuesOpen', isOpen)
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $d81d08658fb9a88c$var$initialState = {};
const $d81d08658fb9a88c$var$Store = (0, $WBLbN.createStore)({
    name: 'jsm-queues-category-state-store',
    initialState: $d81d08658fb9a88c$var$initialState,
    actions: $d81d08658fb9a88c$export$e324594224ef24da
});
const $d81d08658fb9a88c$export$d25429b1c35bc216 = (0, $WBLbN.createContainer)($d81d08658fb9a88c$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            const stateFromStorage = (0, $iKZpp.getQueuesCategoryStateFromLocalStorage)();
            if (stateFromStorage) setState(stateFromStorage);
        }
});
const $d81d08658fb9a88c$export$abcb35f5af9dd85b = (0, $WBLbN.createHook)($d81d08658fb9a88c$var$Store, {
    selector: (state, categoryKey)=>state[categoryKey]?.isPoppedOut || false
});
const $d81d08658fb9a88c$export$c2c81ffd0b8349b = (0, $WBLbN.createHook)($d81d08658fb9a88c$var$Store, {
    selector: (state, categoryKey)=>state[categoryKey]?.lastVisitedQueueId || null
});
const $d81d08658fb9a88c$export$ef6285e9e3666377 = (0, $WBLbN.createHook)($d81d08658fb9a88c$var$Store, {
    selector: (state, categoryKey)=>state[categoryKey]?.isStarredExpanded || false
});
const $d81d08658fb9a88c$export$b68699ca40ca80b8 = (0, $WBLbN.createHook)($d81d08658fb9a88c$var$Store, {
    selector: (state, categoryKey)=>state[categoryKey]?.expandedGroups || []
});
const $d81d08658fb9a88c$export$6862a7823efdc851 = (0, $WBLbN.createHook)($d81d08658fb9a88c$var$Store, {
    selector: (state, categoryKey)=>state[categoryKey]?.isAllQueuesOpen || false
});
const $d81d08658fb9a88c$export$6075a80438f902e4 = (projectKey, practice)=>`${projectKey}-${practice}`;

});
parcelRegister("iKZpp", function(module, exports) {

$parcel$export(module.exports, "getQueueGroupsNavStateFromLocalStorage", () => $186850d8a48c4f0a$export$4fd3d85560a2aca5);
$parcel$export(module.exports, "setQueueGroupsNavStateInLocalStorage", () => $186850d8a48c4f0a$export$ea2ee3f5179c6fdf);
$parcel$export(module.exports, "getQueuesCategoryStateFromLocalStorage", () => $186850d8a48c4f0a$export$8832e9ccc1e52b0d);
$parcel$export(module.exports, "setQueuesCategoryStateInLocalStorage", () => $186850d8a48c4f0a$export$a5f3ae7965a4cde5);
$parcel$export(module.exports, "getEvictedState", () => $186850d8a48c4f0a$export$9aa04626df46f655);
const $186850d8a48c4f0a$export$3c59a089fdd2614a = 'queue-groups-nav-state';
const $186850d8a48c4f0a$export$9b99689db482a6bb = 'queues-category-state';
const $186850d8a48c4f0a$export$4fd3d85560a2aca5 = ()=>{
    try {
        const state = localStorage.getItem($186850d8a48c4f0a$export$3c59a089fdd2614a);
        if (state) return JSON.parse(state);
        return undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return undefined;
    }
};
const $186850d8a48c4f0a$export$ea2ee3f5179c6fdf = (value)=>{
    try {
        localStorage.setItem($186850d8a48c4f0a$export$3c59a089fdd2614a, JSON.stringify(value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /* empty */ }
};
const $186850d8a48c4f0a$export$8832e9ccc1e52b0d = ()=>{
    try {
        const state = localStorage.getItem($186850d8a48c4f0a$export$9b99689db482a6bb);
        if (state) return JSON.parse(state);
        return undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return undefined;
    }
};
const $186850d8a48c4f0a$export$a5f3ae7965a4cde5 = (value)=>{
    try {
        localStorage.setItem($186850d8a48c4f0a$export$9b99689db482a6bb, JSON.stringify(value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /* empty */ }
};
const $186850d8a48c4f0a$export$9aa04626df46f655 = (state, maxCacheLength, maxCacheTime)=>{
    const stateEntries = Object.entries(state);
    const stateLen = stateEntries.length;
    const sortedDescStateEntries = stateEntries.sort((a, b)=>b[1].latestUpdateTimestamp - a[1].latestUpdateTimestamp);
    const numStateValuesToKeep = Math.min(stateLen, maxCacheLength);
    const stateValuesToKeep = sortedDescStateEntries.slice(0, numStateValuesToKeep);
    const oldestAllowedTimestamp = Date.now() - maxCacheTime;
    const newState = {};
    stateValuesToKeep.forEach(([key, value])=>{
        if (value.latestUpdateTimestamp >= oldestAllowedTimestamp) newState[key] = state[key];
    });
    return newState;
};

});


parcelRegister("cyl4r", function(module, exports) {

$parcel$export(module.exports, "PracticeQueues", () => $dbd69e65e81b4079$export$9720502a768ac6d4);

var $eUqFw = parcelRequire("eUqFw");

var $1OuJn = parcelRequire("1OuJn");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");

var $gLn5u = parcelRequire("gLn5u");

var $guiFP = parcelRequire("guiFP");

var $bAQOb = parcelRequire("bAQOb");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7wRIc = parcelRequire("7wRIc");

var $bdiQj = parcelRequire("bdiQj");

var $k4Q7K = parcelRequire("k4Q7K");

var $c5iLA = parcelRequire("c5iLA");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hTOEt = parcelRequire("hTOEt");

var $5oIh2 = parcelRequire("5oIh2");

var $1L8BM = parcelRequire("1L8BM");

var $f1lMr = parcelRequire("f1lMr");

var $fDE9L = parcelRequire("fDE9L");

var $lB25E = parcelRequire("lB25E");

var $79zP6 = parcelRequire("79zP6");

var $8IUzF = parcelRequire("8IUzF");

var $5oGu5 = parcelRequire("5oGu5");

var $jo4Ct = parcelRequire("jo4Ct");

var $koTTC = parcelRequire("koTTC");

var $cfL67 = parcelRequire("cfL67");

var $6lOal = parcelRequire("6lOal");

var $4beXo = parcelRequire("4beXo");

var $xHJp2 = parcelRequire("xHJp2");

var $l2FFM = parcelRequire("l2FFM");

var $aeDO2 = parcelRequire("aeDO2");
const $dbd69e65e81b4079$var$gatherQueuesCounts = (queues = [])=>{
    let starredCount = 0;
    let teamPriorityCount = 0;
    queues.forEach((queue)=>{
        if (queue.starred) starredCount += 1;
        else if (queue.canBeHidden === false || queue.canBeHidden === undefined) teamPriorityCount += 1;
    });
    const otherQueuesCount = queues.length - starredCount - teamPriorityCount;
    return {
        starredCount: starredCount,
        teamPriorityCount: teamPriorityCount,
        otherQueuesCount: otherQueuesCount
    };
};
const $dbd69e65e81b4079$var$PracticeQueuesError = ({ onRefresh: onRefresh })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        padding: "space.100"
    }, formatMessage((0, $xHJp2.messages).fetchQueuesError, {
        button: (buttonLabel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                spacing: "none",
                appearance: "link",
                onClick: onRefresh
            }, buttonLabel)
    }));
};
const $dbd69e65e81b4079$var$PracticeQueuesLegacy = ({ practice: practice, isMatchingUrlForSelectedQueue: isMatchingUrlForSelectedQueue, projectKey: projectKey })=>{
    const currentCategory = practice || (0, $f1lMr.NO_CATEGORY);
    const queueCustomContext = (0, $hTOEt.useQueueCustomRouterContext)(projectKey);
    const { data: queueConnectItems } = (0, $bdiQj.useConnectAppNavigationData)(projectKey, (0, $7wRIc.staticJSMProjectConnectAddonsNavigationResource));
    const [queues, , queuesError, methods, refreshQueues] = (0, $1L8BM.useCategorizedNavItems)('', projectKey, currentCategory, queueCustomContext);
    const [metadata] = (0, $1L8BM.usePracticeMetadata)(practice, queueCustomContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const previousCategory = (0, $hzcvF.usePrevious)(currentCategory);
    (0, $79zP6.useOnFavoritesChanged)(projectKey, practice || (0, $f1lMr.NO_CATEGORY), queues, methods.editItemFavorite, methods.refreshIssueCountForItems);
    const isCountDataRequired = Boolean(metadata && !metadata.hasRequestedCount && isMatchingUrlForSelectedQueue);
    // perform the initial fetch of issue counts
    (0, $eUqFw.useEffect)(()=>{
        if (isCountDataRequired && methods.initialFetchNavItems) {
            const event = createAnalyticsEvent({
                action: 'mounted'
            });
            methods.initialFetchNavItems(event);
        }
    }, [
        createAnalyticsEvent,
        isCountDataRequired,
        methods
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (queues && previousCategory !== currentCategory && isCountDataRequired) {
            const attrs = {
                ...$dbd69e65e81b4079$var$gatherQueuesCounts(queues),
                flexQEnabled: true,
                queueCategory: currentCategory
            };
            const event = createAnalyticsEvent({});
            (0, $jMP2a.fireTrackAnalytics)(event, 'nav4PracticeQueueNavItems rendered', attrs);
        }
    }, [
        createAnalyticsEvent,
        currentCategory,
        isCountDataRequired,
        previousCategory,
        queues
    ]);
    if (queuesError && (0, $eI5EY.fg)('jsm_throw_error_on_resource_auth_pre-check_failed')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dbd69e65e81b4079$var$PracticeQueuesError, {
        onRefresh: refreshQueues
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aeDO2.StarredSection), {
        practice: practice,
        projectKey: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6lOal.AlwaysVisibleSection), {
        practice: practice,
        projectKey: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4beXo.HiddenSection), {
        practice: practice,
        projectKey: projectKey
    }), (!practice || practice === (0, $f1lMr.NO_CATEGORY)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4Q7K.ConnectMenu), {
        items: queueConnectItems,
        showIcons: true
    }), (!practice || practice === (0, $f1lMr.NO_CATEGORY)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c5iLA.ForgeServiceDeskQueueSection), {
        projectKey: projectKey
    }));
};
const $dbd69e65e81b4079$var$PracticeQueuesNew = ({ practice: practice, projectKey: projectKey })=>{
    const currentCategory = practice || (0, $f1lMr.NO_CATEGORY);
    const queueCustomContext = (0, $hTOEt.useQueueCustomRouterContext)(projectKey);
    const [, { updateLastVisitedQueueId: updateLastVisitedQueueId }] = (0, $jo4Ct.useLastVisitedQueueId)((0, $jo4Ct.getCategoryStateKey)(projectKey, currentCategory));
    const { data: queueConnectItems } = (0, $bdiQj.useConnectAppNavigationData)(projectKey, (0, $7wRIc.staticJSMProjectConnectAddonsNavigationResource));
    const [queues, queuesLoading, queuesError, methods, refreshQueues] = (0, $1L8BM.useCategorizedNavItems)('', projectKey, currentCategory, queueCustomContext);
    const [projectKeyFromPath] = (0, $lB25E.usePathParam)('projectKey');
    const [queueIdFromPath] = (0, $lB25E.usePathParam)('queueId');
    const [practiceFromPath] = (0, $lB25E.usePathParam)('practiceType');
    const categoryFromPath = (0, $fDE9L.toItsmPractice)(practiceFromPath);
    const queueFromPath = queues?.find((queue)=>queue.id === queueIdFromPath);
    const [selectedNavLocation, { updateSelectedNavLocation: updateSelectedNavLocation }] = (0, $5oGu5.useSelectedNavLocation)(queueIdFromPath || '');
    const [groups, groupsLoading, groupsFetchingError, refreshGroups] = (0, $5oIh2.usePriorityGroups)(currentCategory, queueCustomContext);
    const [issueCountEnabledQueues, { updateIssueCountEnabledQueues: updateIssueCountEnabledQueues }] = (0, $8IUzF.useIssueCountEnabledQueues)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $79zP6.useOnFavoritesChanged)(projectKey, practice || (0, $f1lMr.NO_CATEGORY), queues, methods.editItemFavorite, methods.refreshIssueCountForItems);
    const isInvalidNavLocation = (0, $eUqFw.useCallback)(()=>{
        if (queueIdFromPath) {
            if (!queueFromPath?.starred && selectedNavLocation.section === (0, $koTTC.QueueListSection).STARRED) return true;
        }
        return false;
    }, [
        queueIdFromPath,
        queueFromPath,
        selectedNavLocation
    ]);
    const selectDefaultNavLocation = (0, $eUqFw.useCallback)(()=>{
        if (queueIdFromPath === undefined) return;
        // Queue is in starred section
        if (queueFromPath?.starred) {
            updateSelectedNavLocation(queueIdFromPath, (0, $koTTC.QueueListSection).STARRED);
            return;
        }
        // Queue is in priority group
        const firstGroupWithQueue = groups.find((group)=>group.queues.includes(Number(queueIdFromPath)));
        if (firstGroupWithQueue) {
            updateSelectedNavLocation(queueIdFromPath, (0, $koTTC.QueueListSection).PRIORITY_GROUP, firstGroupWithQueue.id);
            return;
        }
        // Queue is in all queues section
        updateSelectedNavLocation(queueIdFromPath, (0, $koTTC.QueueListSection).ALL_QUEUES);
    }, [
        queueIdFromPath,
        queueFromPath,
        groups,
        updateSelectedNavLocation
    ]);
    const disableIssueCountRefreshForAllQueues = (0, $eUqFw.useCallback)(()=>{
        if (issueCountEnabledQueues.length > 0) {
            methods.enableIssueCountForSelectedQueues([]);
            updateIssueCountEnabledQueues([]);
        }
    }, [
        issueCountEnabledQueues,
        methods,
        updateIssueCountEnabledQueues
    ]);
    const enableIssueCountRefreshForSelectedQueues = (0, $eUqFw.useCallback)((newQueues)=>{
        if (!queues) return;
        // Enable issue-counts for starred queues as well
        const starredQueues = queues.filter((queue)=>queue.starred).map((queue)=>Number(queue.id));
        const queuesToRefresh = Array.from(new Set([
            ...newQueues,
            ...starredQueues
        ]));
        // If the queues to enable have not changed, do nothing
        if ((0, (/*@__PURE__*/$parcel$interopDefault($1OuJn)))(queuesToRefresh, issueCountEnabledQueues)) return;
        // Refresh issue count for the newly visible queues in the selected group
        const newlyVisibleQueuesInSelectedGroup = queuesToRefresh.filter((queueId)=>!issueCountEnabledQueues.includes(queueId)).map((queueId)=>String(queueId));
        methods.refreshIssueCountForItems(newlyVisibleQueuesInSelectedGroup);
        updateIssueCountEnabledQueues(queuesToRefresh);
        // Enable issue count for the selected queues - group queues only
        methods.enableIssueCountForSelectedQueues(newQueues);
    }, [
        queues,
        methods,
        issueCountEnabledQueues,
        updateIssueCountEnabledQueues
    ]);
    const oldDeps = [
        projectKey,
        projectKeyFromPath,
        queueIdFromPath,
        groups,
        groupsLoading,
        groupsFetchingError,
        selectedNavLocation,
        issueCountEnabledQueues,
        selectDefaultNavLocation,
        isInvalidNavLocation,
        disableIssueCountRefreshForAllQueues,
        enableIssueCountRefreshForSelectedQueues,
        currentCategory,
        categoryFromPath
    ];
    const deps = [
        ...oldDeps,
        queuesLoading,
        queuesError
    ];
    // Enable issue-counts refresh for the correct queues for the current nav location
    (0, $eUqFw.useEffect)(()=>{
        if (!queueIdFromPath) {
            disableIssueCountRefreshForAllQueues();
            return;
        }
        const inSelectedProject = projectKey === projectKeyFromPath;
        const inSelectedCategory = currentCategory === categoryFromPath;
        const shouldUpdateIssueCountsOld = !inSelectedProject || !inSelectedCategory || groupsLoading || groupsFetchingError;
        const shouldUpdateIssueCounts = shouldUpdateIssueCountsOld || queuesLoading || queuesError;
        if ((0, $eI5EY.fg)('jsm_throw_error_on_resource_auth_pre-check_failed') ? shouldUpdateIssueCounts : shouldUpdateIssueCountsOld) return;
        // If the queue does not have a valid section, set a default location
        if (selectedNavLocation.section === undefined || isInvalidNavLocation()) {
            selectDefaultNavLocation();
            return;
        }
        // update the last visited queue for this category in the local storage
        updateLastVisitedQueueId(projectKey, currentCategory, queueIdFromPath);
        // enable issue count refresh for the selected queues
        const selectedGroup = groups.find((group)=>group.id === selectedNavLocation.groupId);
        enableIssueCountRefreshForSelectedQueues(selectedGroup?.queues || []);
    // Replace with list during jsm_throw_error_on_resource_auth_pre-check_failed cleanup
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    // analytics
    (0, $eUqFw.useEffect)(()=>{
        if (!queues && !queuesLoading) return;
        if (queuesError) (0, $guiFP.default)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: queuesError,
            meta: {
                id: 'jsmQueuesListError',
                packageName: 'jiraServicedeskQueuesNav4',
                teamName: 'jsd-shield'
            }
        });
        else (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'nav4PracticeQueueNavItemsWithQueueGroups rendered', {
            projectKey: projectKey,
            category: currentCategory,
            packageName: 'jiraServicedeskQueuesNav4',
            teamName: 'jsd-shield'
        });
    }, [
        createAnalyticsEvent,
        currentCategory,
        queues,
        queuesError,
        projectKey,
        queuesLoading
    ]);
    if (queuesError && (0, $eI5EY.fg)('jsm_throw_error_on_resource_auth_pre-check_failed')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dbd69e65e81b4079$var$PracticeQueuesError, {
        onRefresh: refreshQueues
    });
    if ((!projectKey || queues == null) && !(0, $eI5EY.fg)('jsm_throw_error_on_resource_auth_pre-check_failed')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aeDO2.StarredSection), {
        practice: currentCategory,
        projectKey: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l2FFM.QueueGroupsSection), {
        projectKey: projectKey,
        currentCategory: currentCategory,
        onGroupDataRefresh: refreshGroups
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cfL67.AllQueuesSection), {
        practice: currentCategory,
        projectKey: projectKey
    }), (!practice || practice === (0, $f1lMr.NO_CATEGORY)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4Q7K.ConnectMenu), {
        items: queueConnectItems,
        showIcons: true
    }), (!practice || practice === (0, $f1lMr.NO_CATEGORY)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c5iLA.ForgeServiceDeskQueueSection), {
        projectKey: projectKey
    }));
};
const $dbd69e65e81b4079$export$9720502a768ac6d4 = (0, $bAQOb.componentWithFF)('jsm-queues-nav4-refresh-m2-dogfooding_rh43y', $dbd69e65e81b4079$var$PracticeQueuesNew, $dbd69e65e81b4079$var$PracticeQueuesLegacy);

});
parcelRegister("1OuJn", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $15224c7ccc9df08d$var$func = $jFIrw('isEqual', (parcelRequire("hTLlD")));

$15224c7ccc9df08d$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $15224c7ccc9df08d$var$func;

});
parcelRegister("jFIrw", function(module, exports) {

var $imppR = parcelRequire("imppR");

var $a02m0 = parcelRequire("a02m0");
/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $e524521dc9be9d0c$var$convert(name, func, options) {
    return $imppR($a02m0, name, func, options);
}
module.exports = $e524521dc9be9d0c$var$convert;

});
parcelRegister("imppR", function(module, exports) {

var $89eBv = parcelRequire("89eBv");

var $l6Yg9 = parcelRequire("l6Yg9");
/** Built-in value reference. */ var $d5ddff315914c7cb$var$push = Array.prototype.push;
/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$baseArity(func, n) {
    return n == 2 ? function(a, b) {
        return func.apply(undefined, arguments);
    } : function(a) {
        return func.apply(undefined, arguments);
    };
}
/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$baseAry(func, n) {
    return n == 2 ? function(a, b) {
        return func(a, b);
    } : function(a) {
        return func(a);
    };
}
/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */ function $d5ddff315914c7cb$var$cloneArray(array) {
    var length = array ? array.length : 0, result = Array(length);
    while(length--)result[length] = array[length];
    return result;
}
/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */ function $d5ddff315914c7cb$var$createCloner(func) {
    return function(object) {
        return func({}, object);
    };
}
/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$flatSpread(func, start) {
    return function() {
        var length = arguments.length, lastIndex = length - 1, args = Array(length);
        while(length--)args[length] = arguments[length];
        var array = args[start], otherArgs = args.slice(0, start);
        if (array) $d5ddff315914c7cb$var$push.apply(otherArgs, array);
        if (start != lastIndex) $d5ddff315914c7cb$var$push.apply(otherArgs, args.slice(start + 1));
        return func.apply(this, otherArgs);
    };
}
/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */ function $d5ddff315914c7cb$var$wrapImmutable(func, cloner) {
    return function() {
        var length = arguments.length;
        if (!length) return;
        var args = Array(length);
        while(length--)args[length] = arguments[length];
        var result = args[0] = cloner.apply(undefined, args);
        func.apply(undefined, args);
        return result;
    };
}
/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $d5ddff315914c7cb$var$baseConvert(util, name, func, options) {
    var isLib = typeof name == 'function', isObj = name === Object(name);
    if (isObj) {
        options = func;
        func = name;
        name = undefined;
    }
    if (func == null) throw new TypeError;
    options || (options = {});
    var config = {
        'cap': 'cap' in options ? options.cap : true,
        'curry': 'curry' in options ? options.curry : true,
        'fixed': 'fixed' in options ? options.fixed : true,
        'immutable': 'immutable' in options ? options.immutable : true,
        'rearg': 'rearg' in options ? options.rearg : true
    };
    var defaultHolder = isLib ? func : $l6Yg9, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
    var helpers = isLib ? func : {
        'ary': util.ary,
        'assign': util.assign,
        'clone': util.clone,
        'curry': util.curry,
        'forEach': util.forEach,
        'isArray': util.isArray,
        'isError': util.isError,
        'isFunction': util.isFunction,
        'isWeakMap': util.isWeakMap,
        'iteratee': util.iteratee,
        'keys': util.keys,
        'rearg': util.rearg,
        'toInteger': util.toInteger,
        'toPath': util.toPath
    };
    var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
    var aryMethodKeys = keys($89eBv.aryMethod);
    var wrappers = {
        'castArray': function(castArray) {
            return function() {
                var value = arguments[0];
                return isArray(value) ? castArray($d5ddff315914c7cb$var$cloneArray(value)) : castArray.apply(undefined, arguments);
            };
        },
        'iteratee': function(iteratee) {
            return function() {
                var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                if (config.cap && typeof arity == 'number') {
                    arity = arity > 2 ? arity - 2 : 1;
                    return length && length <= arity ? result : $d5ddff315914c7cb$var$baseAry(result, arity);
                }
                return result;
            };
        },
        'mixin': function(mixin) {
            return function(source) {
                var func = this;
                if (!isFunction(func)) return mixin(func, Object(source));
                var pairs = [];
                each(keys(source), function(key) {
                    if (isFunction(source[key])) pairs.push([
                        key,
                        func.prototype[key]
                    ]);
                });
                mixin(func, Object(source));
                each(pairs, function(pair) {
                    var value = pair[1];
                    if (isFunction(value)) func.prototype[pair[0]] = value;
                    else delete func.prototype[pair[0]];
                });
                return func;
            };
        },
        'nthArg': function(nthArg) {
            return function(n) {
                var arity = n < 0 ? 1 : toInteger(n) + 1;
                return curry(nthArg(n), arity);
            };
        },
        'rearg': function(rearg) {
            return function(func, indexes) {
                var arity = indexes ? indexes.length : 0;
                return curry(rearg(func, indexes), arity);
            };
        },
        'runInContext': function(runInContext) {
            return function(context) {
                return $d5ddff315914c7cb$var$baseConvert(util, runInContext(context), options);
            };
        }
    };
    /*--------------------------------------------------------------------------*/ /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */ function castCap(name, func) {
        if (config.cap) {
            var indexes = $89eBv.iterateeRearg[name];
            if (indexes) return iterateeRearg(func, indexes);
            var n = !isLib && $89eBv.iterateeAry[name];
            if (n) return iterateeAry(func, n);
        }
        return func;
    }
    /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castCurry(name, func, n) {
        return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
    }
    /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */ function castFixed(name, func, n) {
        if (config.fixed && (forceFixed || !$89eBv.skipFixed[name])) {
            var data = $89eBv.methodSpread[name], start = data && data.start;
            return start === undefined ? ary(func, n) : $d5ddff315914c7cb$var$flatSpread(func, start);
        }
        return func;
    }
    /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castRearg(name, func, n) {
        return config.rearg && n > 1 && (forceRearg || !$89eBv.skipRearg[name]) ? rearg(func, $89eBv.methodRearg[name] || $89eBv.aryRearg[n]) : func;
    }
    /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */ function cloneByPath(object, path) {
        path = toPath(path);
        var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
        while(nested != null && ++index < length){
            var key = path[index], value = nested[key];
            if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
            nested = nested[key];
        }
        return result;
    }
    /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */ function convertLib(options) {
        return _.runInContext.convert(options)(undefined);
    }
    /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */ function createConverter(name, func) {
        var realName = $89eBv.aliasToReal[name] || name, methodName = $89eBv.remap[realName] || realName, oldOptions = options;
        return function(options) {
            var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
            return $d5ddff315914c7cb$var$baseConvert(newUtil, realName, newFunc, newOptions);
        };
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */ function iterateeAry(func, n) {
        return overArg(func, function(func) {
            return typeof func == 'function' ? $d5ddff315914c7cb$var$baseAry(func, n) : func;
        });
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */ function iterateeRearg(func, indexes) {
        return overArg(func, function(func) {
            var n = indexes.length;
            return $d5ddff315914c7cb$var$baseArity(rearg($d5ddff315914c7cb$var$baseAry(func, n), indexes), n);
        });
    }
    /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function() {
            var length = arguments.length;
            if (!length) return func();
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var index = config.rearg ? 0 : length - 1;
            args[index] = transform(args[index]);
            return func.apply(undefined, args);
        };
    }
    /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */ function wrap(name, func, placeholder) {
        var result, realName = $89eBv.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
        if (wrapper) wrapped = wrapper(func);
        else if (config.immutable) {
            if ($89eBv.mutate.array[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, $d5ddff315914c7cb$var$cloneArray);
            else if ($89eBv.mutate.object[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, $d5ddff315914c7cb$var$createCloner(func));
            else if ($89eBv.mutate.set[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, cloneByPath);
        }
        each(aryMethodKeys, function(aryKey) {
            each($89eBv.aryMethod[aryKey], function(otherName) {
                if (realName == otherName) {
                    var data = $89eBv.methodSpread[realName], afterRearg = data && data.afterRearg;
                    result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                    result = castCap(realName, result);
                    result = castCurry(realName, result, aryKey);
                    return false;
                }
            });
            return !result;
        });
        result || (result = wrapped);
        if (result == func) result = forceCurry ? curry(result, 1) : function() {
            return func.apply(this, arguments);
        };
        result.convert = createConverter(realName, func);
        result.placeholder = func.placeholder = placeholder;
        return result;
    }
    /*--------------------------------------------------------------------------*/ if (!isObj) return wrap(name, func, defaultHolder);
    var _ = func;
    // Convert methods by ary cap.
    var pairs = [];
    each(aryMethodKeys, function(aryKey) {
        each($89eBv.aryMethod[aryKey], function(key) {
            var func = _[$89eBv.remap[key] || key];
            if (func) pairs.push([
                key,
                wrap(key, func, _)
            ]);
        });
    });
    // Convert remaining methods.
    each(keys(_), function(key) {
        var func = _[key];
        if (typeof func == 'function') {
            var length = pairs.length;
            while(length--){
                if (pairs[length][0] == key) return;
            }
            func.convert = createConverter(key, func);
            pairs.push([
                key,
                func
            ]);
        }
    });
    // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
    each(pairs, function(pair) {
        _[pair[0]] = pair[1];
    });
    _.convert = convertLib;
    _.placeholder = _;
    // Assign aliases.
    each(keys(_), function(key) {
        each($89eBv.realToAlias[key] || [], function(alias) {
            _[alias] = _[key];
        });
    });
    return _;
}
module.exports = $d5ddff315914c7cb$var$baseConvert;

});
parcelRegister("89eBv", function(module, exports) {

$parcel$export(module.exports, "aliasToReal", () => $5eea7e08a1db1590$export$bd0f5e6e44efa6b4, (v) => $5eea7e08a1db1590$export$bd0f5e6e44efa6b4 = v);
$parcel$export(module.exports, "aryMethod", () => $5eea7e08a1db1590$export$85c665b4d7da9cb4, (v) => $5eea7e08a1db1590$export$85c665b4d7da9cb4 = v);
$parcel$export(module.exports, "aryRearg", () => $5eea7e08a1db1590$export$42564e045b285e32, (v) => $5eea7e08a1db1590$export$42564e045b285e32 = v);
$parcel$export(module.exports, "iterateeAry", () => $5eea7e08a1db1590$export$81e17196e6a22b07, (v) => $5eea7e08a1db1590$export$81e17196e6a22b07 = v);
$parcel$export(module.exports, "iterateeRearg", () => $5eea7e08a1db1590$export$30975ceb42167ebd, (v) => $5eea7e08a1db1590$export$30975ceb42167ebd = v);
$parcel$export(module.exports, "methodRearg", () => $5eea7e08a1db1590$export$8ceb0ad7e94d3801, (v) => $5eea7e08a1db1590$export$8ceb0ad7e94d3801 = v);
$parcel$export(module.exports, "methodSpread", () => $5eea7e08a1db1590$export$fbaeb3f87df3cf26, (v) => $5eea7e08a1db1590$export$fbaeb3f87df3cf26 = v);
$parcel$export(module.exports, "mutate", () => $5eea7e08a1db1590$export$57e795267c26e600, (v) => $5eea7e08a1db1590$export$57e795267c26e600 = v);
$parcel$export(module.exports, "realToAlias", () => $5eea7e08a1db1590$export$1eb71a7e27943e71, (v) => $5eea7e08a1db1590$export$1eb71a7e27943e71 = v);
$parcel$export(module.exports, "remap", () => $5eea7e08a1db1590$export$aee1dbae5de2db9d, (v) => $5eea7e08a1db1590$export$aee1dbae5de2db9d = v);
$parcel$export(module.exports, "skipFixed", () => $5eea7e08a1db1590$export$87ffbe4821a5d5e0, (v) => $5eea7e08a1db1590$export$87ffbe4821a5d5e0 = v);
$parcel$export(module.exports, "skipRearg", () => $5eea7e08a1db1590$export$b4d07413ce528c90, (v) => $5eea7e08a1db1590$export$b4d07413ce528c90 = v);
/** Used to map aliases to their real names. */ var $5eea7e08a1db1590$export$bd0f5e6e44efa6b4;
/** Used to map ary to method names. */ var $5eea7e08a1db1590$export$85c665b4d7da9cb4;
/** Used to map ary to rearg configs. */ var $5eea7e08a1db1590$export$42564e045b285e32;
/** Used to map method names to their iteratee ary. */ var $5eea7e08a1db1590$export$81e17196e6a22b07;
/** Used to map method names to iteratee rearg configs. */ var $5eea7e08a1db1590$export$30975ceb42167ebd;
/** Used to map method names to rearg configs. */ var $5eea7e08a1db1590$export$8ceb0ad7e94d3801;
/** Used to map method names to spread configs. */ var $5eea7e08a1db1590$export$fbaeb3f87df3cf26;
/** Used to identify methods which mutate arrays or objects. */ var $5eea7e08a1db1590$export$57e795267c26e600;
/** Used to map real names to their aliases. */ var $5eea7e08a1db1590$export$1eb71a7e27943e71;
/** Used to map method names to other names. */ var $5eea7e08a1db1590$export$aee1dbae5de2db9d;
/** Used to track methods that skip fixing their arity. */ var $5eea7e08a1db1590$export$87ffbe4821a5d5e0;
/** Used to track methods that skip rearranging arguments. */ var $5eea7e08a1db1590$export$b4d07413ce528c90;
$5eea7e08a1db1590$export$bd0f5e6e44efa6b4 = {
    // Lodash aliases.
    'each': 'forEach',
    'eachRight': 'forEachRight',
    'entries': 'toPairs',
    'entriesIn': 'toPairsIn',
    'extend': 'assignIn',
    'extendAll': 'assignInAll',
    'extendAllWith': 'assignInAllWith',
    'extendWith': 'assignInWith',
    'first': 'head',
    // Methods that are curried variants of others.
    'conforms': 'conformsTo',
    'matches': 'isMatch',
    'property': 'get',
    // Ramda aliases.
    '__': 'placeholder',
    'F': 'stubFalse',
    'T': 'stubTrue',
    'all': 'every',
    'allPass': 'overEvery',
    'always': 'constant',
    'any': 'some',
    'anyPass': 'overSome',
    'apply': 'spread',
    'assoc': 'set',
    'assocPath': 'set',
    'complement': 'negate',
    'compose': 'flowRight',
    'contains': 'includes',
    'dissoc': 'unset',
    'dissocPath': 'unset',
    'dropLast': 'dropRight',
    'dropLastWhile': 'dropRightWhile',
    'equals': 'isEqual',
    'identical': 'eq',
    'indexBy': 'keyBy',
    'init': 'initial',
    'invertObj': 'invert',
    'juxt': 'over',
    'omitAll': 'omit',
    'nAry': 'ary',
    'path': 'get',
    'pathEq': 'matchesProperty',
    'pathOr': 'getOr',
    'paths': 'at',
    'pickAll': 'pick',
    'pipe': 'flow',
    'pluck': 'map',
    'prop': 'get',
    'propEq': 'matchesProperty',
    'propOr': 'getOr',
    'props': 'at',
    'symmetricDifference': 'xor',
    'symmetricDifferenceBy': 'xorBy',
    'symmetricDifferenceWith': 'xorWith',
    'takeLast': 'takeRight',
    'takeLastWhile': 'takeRightWhile',
    'unapply': 'rest',
    'unnest': 'flatten',
    'useWith': 'overArgs',
    'where': 'conformsTo',
    'whereEq': 'isMatch',
    'zipObj': 'zipObject'
};
$5eea7e08a1db1590$export$85c665b4d7da9cb4 = {
    '1': [
        'assignAll',
        'assignInAll',
        'attempt',
        'castArray',
        'ceil',
        'create',
        'curry',
        'curryRight',
        'defaultsAll',
        'defaultsDeepAll',
        'floor',
        'flow',
        'flowRight',
        'fromPairs',
        'invert',
        'iteratee',
        'memoize',
        'method',
        'mergeAll',
        'methodOf',
        'mixin',
        'nthArg',
        'over',
        'overEvery',
        'overSome',
        'rest',
        'reverse',
        'round',
        'runInContext',
        'spread',
        'template',
        'trim',
        'trimEnd',
        'trimStart',
        'uniqueId',
        'words',
        'zipAll'
    ],
    '2': [
        'add',
        'after',
        'ary',
        'assign',
        'assignAllWith',
        'assignIn',
        'assignInAllWith',
        'at',
        'before',
        'bind',
        'bindAll',
        'bindKey',
        'chunk',
        'cloneDeepWith',
        'cloneWith',
        'concat',
        'conformsTo',
        'countBy',
        'curryN',
        'curryRightN',
        'debounce',
        'defaults',
        'defaultsDeep',
        'defaultTo',
        'delay',
        'difference',
        'divide',
        'drop',
        'dropRight',
        'dropRightWhile',
        'dropWhile',
        'endsWith',
        'eq',
        'every',
        'filter',
        'find',
        'findIndex',
        'findKey',
        'findLast',
        'findLastIndex',
        'findLastKey',
        'flatMap',
        'flatMapDeep',
        'flattenDepth',
        'forEach',
        'forEachRight',
        'forIn',
        'forInRight',
        'forOwn',
        'forOwnRight',
        'get',
        'groupBy',
        'gt',
        'gte',
        'has',
        'hasIn',
        'includes',
        'indexOf',
        'intersection',
        'invertBy',
        'invoke',
        'invokeMap',
        'isEqual',
        'isMatch',
        'join',
        'keyBy',
        'lastIndexOf',
        'lt',
        'lte',
        'map',
        'mapKeys',
        'mapValues',
        'matchesProperty',
        'maxBy',
        'meanBy',
        'merge',
        'mergeAllWith',
        'minBy',
        'multiply',
        'nth',
        'omit',
        'omitBy',
        'overArgs',
        'pad',
        'padEnd',
        'padStart',
        'parseInt',
        'partial',
        'partialRight',
        'partition',
        'pick',
        'pickBy',
        'propertyOf',
        'pull',
        'pullAll',
        'pullAt',
        'random',
        'range',
        'rangeRight',
        'rearg',
        'reject',
        'remove',
        'repeat',
        'restFrom',
        'result',
        'sampleSize',
        'some',
        'sortBy',
        'sortedIndex',
        'sortedIndexOf',
        'sortedLastIndex',
        'sortedLastIndexOf',
        'sortedUniqBy',
        'split',
        'spreadFrom',
        'startsWith',
        'subtract',
        'sumBy',
        'take',
        'takeRight',
        'takeRightWhile',
        'takeWhile',
        'tap',
        'throttle',
        'thru',
        'times',
        'trimChars',
        'trimCharsEnd',
        'trimCharsStart',
        'truncate',
        'union',
        'uniqBy',
        'uniqWith',
        'unset',
        'unzipWith',
        'without',
        'wrap',
        'xor',
        'zip',
        'zipObject',
        'zipObjectDeep'
    ],
    '3': [
        'assignInWith',
        'assignWith',
        'clamp',
        'differenceBy',
        'differenceWith',
        'findFrom',
        'findIndexFrom',
        'findLastFrom',
        'findLastIndexFrom',
        'getOr',
        'includesFrom',
        'indexOfFrom',
        'inRange',
        'intersectionBy',
        'intersectionWith',
        'invokeArgs',
        'invokeArgsMap',
        'isEqualWith',
        'isMatchWith',
        'flatMapDepth',
        'lastIndexOfFrom',
        'mergeWith',
        'orderBy',
        'padChars',
        'padCharsEnd',
        'padCharsStart',
        'pullAllBy',
        'pullAllWith',
        'rangeStep',
        'rangeStepRight',
        'reduce',
        'reduceRight',
        'replace',
        'set',
        'slice',
        'sortedIndexBy',
        'sortedLastIndexBy',
        'transform',
        'unionBy',
        'unionWith',
        'update',
        'xorBy',
        'xorWith',
        'zipWith'
    ],
    '4': [
        'fill',
        'setWith',
        'updateWith'
    ]
};
$5eea7e08a1db1590$export$42564e045b285e32 = {
    '2': [
        1,
        0
    ],
    '3': [
        2,
        0,
        1
    ],
    '4': [
        3,
        2,
        0,
        1
    ]
};
$5eea7e08a1db1590$export$81e17196e6a22b07 = {
    'dropRightWhile': 1,
    'dropWhile': 1,
    'every': 1,
    'filter': 1,
    'find': 1,
    'findFrom': 1,
    'findIndex': 1,
    'findIndexFrom': 1,
    'findKey': 1,
    'findLast': 1,
    'findLastFrom': 1,
    'findLastIndex': 1,
    'findLastIndexFrom': 1,
    'findLastKey': 1,
    'flatMap': 1,
    'flatMapDeep': 1,
    'flatMapDepth': 1,
    'forEach': 1,
    'forEachRight': 1,
    'forIn': 1,
    'forInRight': 1,
    'forOwn': 1,
    'forOwnRight': 1,
    'map': 1,
    'mapKeys': 1,
    'mapValues': 1,
    'partition': 1,
    'reduce': 2,
    'reduceRight': 2,
    'reject': 1,
    'remove': 1,
    'some': 1,
    'takeRightWhile': 1,
    'takeWhile': 1,
    'times': 1,
    'transform': 2
};
$5eea7e08a1db1590$export$30975ceb42167ebd = {
    'mapKeys': [
        1
    ],
    'reduceRight': [
        1,
        0
    ]
};
$5eea7e08a1db1590$export$8ceb0ad7e94d3801 = {
    'assignInAllWith': [
        1,
        0
    ],
    'assignInWith': [
        1,
        2,
        0
    ],
    'assignAllWith': [
        1,
        0
    ],
    'assignWith': [
        1,
        2,
        0
    ],
    'differenceBy': [
        1,
        2,
        0
    ],
    'differenceWith': [
        1,
        2,
        0
    ],
    'getOr': [
        2,
        1,
        0
    ],
    'intersectionBy': [
        1,
        2,
        0
    ],
    'intersectionWith': [
        1,
        2,
        0
    ],
    'isEqualWith': [
        1,
        2,
        0
    ],
    'isMatchWith': [
        2,
        1,
        0
    ],
    'mergeAllWith': [
        1,
        0
    ],
    'mergeWith': [
        1,
        2,
        0
    ],
    'padChars': [
        2,
        1,
        0
    ],
    'padCharsEnd': [
        2,
        1,
        0
    ],
    'padCharsStart': [
        2,
        1,
        0
    ],
    'pullAllBy': [
        2,
        1,
        0
    ],
    'pullAllWith': [
        2,
        1,
        0
    ],
    'rangeStep': [
        1,
        2,
        0
    ],
    'rangeStepRight': [
        1,
        2,
        0
    ],
    'setWith': [
        3,
        1,
        2,
        0
    ],
    'sortedIndexBy': [
        2,
        1,
        0
    ],
    'sortedLastIndexBy': [
        2,
        1,
        0
    ],
    'unionBy': [
        1,
        2,
        0
    ],
    'unionWith': [
        1,
        2,
        0
    ],
    'updateWith': [
        3,
        1,
        2,
        0
    ],
    'xorBy': [
        1,
        2,
        0
    ],
    'xorWith': [
        1,
        2,
        0
    ],
    'zipWith': [
        1,
        2,
        0
    ]
};
$5eea7e08a1db1590$export$fbaeb3f87df3cf26 = {
    'assignAll': {
        'start': 0
    },
    'assignAllWith': {
        'start': 0
    },
    'assignInAll': {
        'start': 0
    },
    'assignInAllWith': {
        'start': 0
    },
    'defaultsAll': {
        'start': 0
    },
    'defaultsDeepAll': {
        'start': 0
    },
    'invokeArgs': {
        'start': 2
    },
    'invokeArgsMap': {
        'start': 2
    },
    'mergeAll': {
        'start': 0
    },
    'mergeAllWith': {
        'start': 0
    },
    'partial': {
        'start': 1
    },
    'partialRight': {
        'start': 1
    },
    'without': {
        'start': 1
    },
    'zipAll': {
        'start': 0
    }
};
$5eea7e08a1db1590$export$57e795267c26e600 = {
    'array': {
        'fill': true,
        'pull': true,
        'pullAll': true,
        'pullAllBy': true,
        'pullAllWith': true,
        'pullAt': true,
        'remove': true,
        'reverse': true
    },
    'object': {
        'assign': true,
        'assignAll': true,
        'assignAllWith': true,
        'assignIn': true,
        'assignInAll': true,
        'assignInAllWith': true,
        'assignInWith': true,
        'assignWith': true,
        'defaults': true,
        'defaultsAll': true,
        'defaultsDeep': true,
        'defaultsDeepAll': true,
        'merge': true,
        'mergeAll': true,
        'mergeAllWith': true,
        'mergeWith': true
    },
    'set': {
        'set': true,
        'setWith': true,
        'unset': true,
        'update': true,
        'updateWith': true
    }
};
$5eea7e08a1db1590$export$1eb71a7e27943e71 = function() {
    var hasOwnProperty = Object.prototype.hasOwnProperty, object = $5eea7e08a1db1590$export$bd0f5e6e44efa6b4, result = {};
    for(var key in object){
        var value = object[key];
        if (hasOwnProperty.call(result, value)) result[value].push(key);
        else result[value] = [
            key
        ];
    }
    return result;
}();
$5eea7e08a1db1590$export$aee1dbae5de2db9d = {
    'assignAll': 'assign',
    'assignAllWith': 'assignWith',
    'assignInAll': 'assignIn',
    'assignInAllWith': 'assignInWith',
    'curryN': 'curry',
    'curryRightN': 'curryRight',
    'defaultsAll': 'defaults',
    'defaultsDeepAll': 'defaultsDeep',
    'findFrom': 'find',
    'findIndexFrom': 'findIndex',
    'findLastFrom': 'findLast',
    'findLastIndexFrom': 'findLastIndex',
    'getOr': 'get',
    'includesFrom': 'includes',
    'indexOfFrom': 'indexOf',
    'invokeArgs': 'invoke',
    'invokeArgsMap': 'invokeMap',
    'lastIndexOfFrom': 'lastIndexOf',
    'mergeAll': 'merge',
    'mergeAllWith': 'mergeWith',
    'padChars': 'pad',
    'padCharsEnd': 'padEnd',
    'padCharsStart': 'padStart',
    'propertyOf': 'get',
    'rangeStep': 'range',
    'rangeStepRight': 'rangeRight',
    'restFrom': 'rest',
    'spreadFrom': 'spread',
    'trimChars': 'trim',
    'trimCharsEnd': 'trimEnd',
    'trimCharsStart': 'trimStart',
    'zipAll': 'zip'
};
$5eea7e08a1db1590$export$87ffbe4821a5d5e0 = {
    'castArray': true,
    'flow': true,
    'flowRight': true,
    'iteratee': true,
    'mixin': true,
    'rearg': true,
    'runInContext': true
};
$5eea7e08a1db1590$export$b4d07413ce528c90 = {
    'add': true,
    'assign': true,
    'assignIn': true,
    'bind': true,
    'bindKey': true,
    'concat': true,
    'difference': true,
    'divide': true,
    'eq': true,
    'gt': true,
    'gte': true,
    'isEqual': true,
    'lt': true,
    'lte': true,
    'matchesProperty': true,
    'merge': true,
    'multiply': true,
    'overArgs': true,
    'partial': true,
    'partialRight': true,
    'propertyOf': true,
    'random': true,
    'range': true,
    'rangeRight': true,
    'subtract': true,
    'zip': true,
    'zipObject': true,
    'zipObjectDeep': true
};

});

parcelRegister("l6Yg9", function(module, exports) {
/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */ module.exports = {};

});


parcelRegister("a02m0", function(module, exports) {














module.exports = {
    'ary': (parcelRequire("iX5mF")),
    'assign': (parcelRequire("k1JQY")),
    'clone': (parcelRequire("E0NNP")),
    'curry': (parcelRequire("cleLA")),
    'forEach': (parcelRequire("9Kzih")),
    'isArray': (parcelRequire("1c8hB")),
    'isError': (parcelRequire("dbogu")),
    'isFunction': (parcelRequire("eoCgY")),
    'isWeakMap': (parcelRequire("a1CHL")),
    'iteratee': (parcelRequire("akHxB")),
    'keys': (parcelRequire("fCpZe")),
    'rearg': (parcelRequire("k5dRT")),
    'toInteger': (parcelRequire("hNahz")),
    'toPath': (parcelRequire("d0KBl"))
};

});
parcelRegister("iX5mF", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");
/** Used to compose bitmasks for function metadata. */ var $dcc1e600da485164$var$WRAP_ARY_FLAG = 128;
/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */ function $dcc1e600da485164$var$ary(func, n, guard) {
    n = guard ? undefined : n;
    n = func && n == null ? func.length : n;
    return $xQ3hV(func, $dcc1e600da485164$var$WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}
module.exports = $dcc1e600da485164$var$ary;

});
parcelRegister("xQ3hV", function(module, exports) {

var $2n5KA = parcelRequire("2n5KA");

var $ajgvA = parcelRequire("ajgvA");

var $4sFI9 = parcelRequire("4sFI9");

var $dJxZV = parcelRequire("dJxZV");

var $3slGh = parcelRequire("3slGh");

var $6bTTb = parcelRequire("6bTTb");

var $fHM5F = parcelRequire("fHM5F");

var $bV9co = parcelRequire("bV9co");

var $3mXyn = parcelRequire("3mXyn");

var $hNahz = parcelRequire("hNahz");
/** Error message constants. */ var $065b75a1a2ef24b3$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $065b75a1a2ef24b3$var$WRAP_BIND_FLAG = 1, $065b75a1a2ef24b3$var$WRAP_BIND_KEY_FLAG = 2, $065b75a1a2ef24b3$var$WRAP_CURRY_FLAG = 8, $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG = 16, $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG = 32, $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $065b75a1a2ef24b3$var$nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $065b75a1a2ef24b3$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & $065b75a1a2ef24b3$var$WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError($065b75a1a2ef24b3$var$FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~($065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG | $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : $065b75a1a2ef24b3$var$nativeMax($hNahz(ary), 0);
    arity = arity === undefined ? arity : $hNahz(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : $6bTTb(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) $fHM5F(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $065b75a1a2ef24b3$var$nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & ($065b75a1a2ef24b3$var$WRAP_CURRY_FLAG | $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($065b75a1a2ef24b3$var$WRAP_CURRY_FLAG | $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == $065b75a1a2ef24b3$var$WRAP_BIND_FLAG) var result = $ajgvA(func, bitmask, thisArg);
    else if (bitmask == $065b75a1a2ef24b3$var$WRAP_CURRY_FLAG || bitmask == $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG) result = $4sFI9(func, bitmask, arity);
    else if ((bitmask == $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG || bitmask == ($065b75a1a2ef24b3$var$WRAP_BIND_FLAG | $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $3slGh(func, bitmask, thisArg, partials);
    else result = $dJxZV.apply(undefined, newData);
    var setter = data ? $2n5KA : $bV9co;
    return $3mXyn(setter(result, newData), func, bitmask);
}
module.exports = $065b75a1a2ef24b3$var$createWrap;

});
parcelRegister("2n5KA", function(module, exports) {

var $3QMTK = parcelRequire("3QMTK");

var $beYtW = parcelRequire("beYtW");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $1ba230a38b363991$var$baseSetData = !$beYtW ? $3QMTK : function(func, data) {
    $beYtW.set(func, data);
    return func;
};
module.exports = $1ba230a38b363991$var$baseSetData;

});

parcelRegister("ajgvA", function(module, exports) {

var $4ptXN = parcelRequire("4ptXN");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $78187bf3ce07aa33$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $78187bf3ce07aa33$var$createBind(func, bitmask, thisArg) {
    var isBind = bitmask & $78187bf3ce07aa33$var$WRAP_BIND_FLAG, Ctor = $4ptXN(func);
    function wrapper() {
        var fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = $78187bf3ce07aa33$var$createBind;

});
parcelRegister("4ptXN", function(module, exports) {

var $9F9XB = parcelRequire("9F9XB");

var $feGjZ = parcelRequire("feGjZ");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function $3360bd57e2c33b86$var$createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = $9F9XB(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return $feGjZ(result) ? result : thisBinding;
    };
}
module.exports = $3360bd57e2c33b86$var$createCtor;

});


parcelRegister("4sFI9", function(module, exports) {

var $5VdlS = parcelRequire("5VdlS");

var $4ptXN = parcelRequire("4ptXN");

var $dJxZV = parcelRequire("dJxZV");

var $lOKcz = parcelRequire("lOKcz");

var $9xQzO = parcelRequire("9xQzO");

var $kBgrU = parcelRequire("kBgrU");

var $c1MCs = parcelRequire("c1MCs");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $33fa21eee8bcca6f$var$createCurry(func, bitmask, arity) {
    var Ctor = $4ptXN(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = $9xQzO(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $kBgrU(args, placeholder);
        length -= holders.length;
        if (length < arity) return $lOKcz(func, bitmask, $dJxZV, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        return $5VdlS(fn, this, args);
    }
    return wrapper;
}
module.exports = $33fa21eee8bcca6f$var$createCurry;

});
parcelRegister("dJxZV", function(module, exports) {

var $98OfC = parcelRequire("98OfC");

var $aoNSM = parcelRequire("aoNSM");

var $24kQN = parcelRequire("24kQN");

var $4ptXN = parcelRequire("4ptXN");

var $lOKcz = parcelRequire("lOKcz");

var $9xQzO = parcelRequire("9xQzO");

var $jtjhF = parcelRequire("jtjhF");

var $kBgrU = parcelRequire("kBgrU");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $9ff9d999ee3e5b26$var$WRAP_BIND_FLAG = 1, $9ff9d999ee3e5b26$var$WRAP_BIND_KEY_FLAG = 2, $9ff9d999ee3e5b26$var$WRAP_CURRY_FLAG = 8, $9ff9d999ee3e5b26$var$WRAP_CURRY_RIGHT_FLAG = 16, $9ff9d999ee3e5b26$var$WRAP_ARY_FLAG = 128, $9ff9d999ee3e5b26$var$WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $9ff9d999ee3e5b26$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & $9ff9d999ee3e5b26$var$WRAP_ARY_FLAG, isBind = bitmask & $9ff9d999ee3e5b26$var$WRAP_BIND_FLAG, isBindKey = bitmask & $9ff9d999ee3e5b26$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($9ff9d999ee3e5b26$var$WRAP_CURRY_FLAG | $9ff9d999ee3e5b26$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $9ff9d999ee3e5b26$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $4ptXN(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = $9xQzO(wrapper), holdersCount = $24kQN(args, placeholder);
        if (partials) args = $98OfC(args, partials, holders, isCurried);
        if (partialsRight) args = $aoNSM(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = $kBgrU(args, placeholder);
            return $lOKcz(func, bitmask, $9ff9d999ee3e5b26$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = $jtjhF(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== $c1MCs && this instanceof wrapper) fn = Ctor || $4ptXN(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = $9ff9d999ee3e5b26$var$createHybrid;

});
parcelRegister("98OfC", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6a7bd72e71453dbc$var$nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $6a7bd72e71453dbc$var$composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $6a7bd72e71453dbc$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = $6a7bd72e71453dbc$var$composeArgs;

});

parcelRegister("aoNSM", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7922d6e81726c41f$var$nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $7922d6e81726c41f$var$composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $7922d6e81726c41f$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = $7922d6e81726c41f$var$composeArgsRight;

});

parcelRegister("24kQN", function(module, exports) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function $181c20ffe0a73f5e$var$countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = $181c20ffe0a73f5e$var$countHolders;

});

parcelRegister("lOKcz", function(module, exports) {

var $cp9gS = parcelRequire("cp9gS");

var $bV9co = parcelRequire("bV9co");

var $3mXyn = parcelRequire("3mXyn");
/** Used to compose bitmasks for function metadata. */ var $fe221b32db6745a2$var$WRAP_BIND_FLAG = 1, $fe221b32db6745a2$var$WRAP_BIND_KEY_FLAG = 2, $fe221b32db6745a2$var$WRAP_CURRY_BOUND_FLAG = 4, $fe221b32db6745a2$var$WRAP_CURRY_FLAG = 8, $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG = 32, $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $fe221b32db6745a2$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & $fe221b32db6745a2$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG : $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG : $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG);
    if (!(bitmask & $fe221b32db6745a2$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($fe221b32db6745a2$var$WRAP_BIND_FLAG | $fe221b32db6745a2$var$WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if ($cp9gS(func)) $bV9co(result, newData);
    result.placeholder = placeholder;
    return $3mXyn(result, func, bitmask);
}
module.exports = $fe221b32db6745a2$var$createRecurry;

});
parcelRegister("bV9co", function(module, exports) {

var $2n5KA = parcelRequire("2n5KA");

var $d1V3m = parcelRequire("d1V3m");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $8adc2746a2aa5eeb$var$setData = $d1V3m($2n5KA);
module.exports = $8adc2746a2aa5eeb$var$setData;

});

parcelRegister("3mXyn", function(module, exports) {

var $4pgZb = parcelRequire("4pgZb");

var $1k0ou = parcelRequire("1k0ou");

var $ly0Gc = parcelRequire("ly0Gc");

var $7YePn = parcelRequire("7YePn");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function $27419f3ed4dc5d4c$var$setWrapToString(wrapper, reference, bitmask) {
    var source = reference + '';
    return $ly0Gc(wrapper, $1k0ou(source, $7YePn($4pgZb(source), bitmask)));
}
module.exports = $27419f3ed4dc5d4c$var$setWrapToString;

});
parcelRegister("4pgZb", function(module, exports) {
/** Used to match wrap detail comments. */ var $3356ac43c54e635f$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $3356ac43c54e635f$var$reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function $3356ac43c54e635f$var$getWrapDetails(source) {
    var match = source.match($3356ac43c54e635f$var$reWrapDetails);
    return match ? match[1].split($3356ac43c54e635f$var$reSplitDetails) : [];
}
module.exports = $3356ac43c54e635f$var$getWrapDetails;

});

parcelRegister("1k0ou", function(module, exports) {
/** Used to match wrap detail comments. */ var $0f67f6f702bebdca$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function $0f67f6f702bebdca$var$insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
    details = details.join(length > 2 ? ', ' : ' ');
    return source.replace($0f67f6f702bebdca$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}
module.exports = $0f67f6f702bebdca$var$insertWrapDetails;

});

parcelRegister("7YePn", function(module, exports) {

var $9Kzih = parcelRequire("9Kzih");

var $lqZWH = parcelRequire("lqZWH");
/** Used to compose bitmasks for function metadata. */ var $5cd9a37742eb8774$var$WRAP_BIND_FLAG = 1, $5cd9a37742eb8774$var$WRAP_BIND_KEY_FLAG = 2, $5cd9a37742eb8774$var$WRAP_CURRY_FLAG = 8, $5cd9a37742eb8774$var$WRAP_CURRY_RIGHT_FLAG = 16, $5cd9a37742eb8774$var$WRAP_PARTIAL_FLAG = 32, $5cd9a37742eb8774$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $5cd9a37742eb8774$var$WRAP_ARY_FLAG = 128, $5cd9a37742eb8774$var$WRAP_REARG_FLAG = 256, $5cd9a37742eb8774$var$WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var $5cd9a37742eb8774$var$wrapFlags = [
    [
        'ary',
        $5cd9a37742eb8774$var$WRAP_ARY_FLAG
    ],
    [
        'bind',
        $5cd9a37742eb8774$var$WRAP_BIND_FLAG
    ],
    [
        'bindKey',
        $5cd9a37742eb8774$var$WRAP_BIND_KEY_FLAG
    ],
    [
        'curry',
        $5cd9a37742eb8774$var$WRAP_CURRY_FLAG
    ],
    [
        'curryRight',
        $5cd9a37742eb8774$var$WRAP_CURRY_RIGHT_FLAG
    ],
    [
        'flip',
        $5cd9a37742eb8774$var$WRAP_FLIP_FLAG
    ],
    [
        'partial',
        $5cd9a37742eb8774$var$WRAP_PARTIAL_FLAG
    ],
    [
        'partialRight',
        $5cd9a37742eb8774$var$WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        'rearg',
        $5cd9a37742eb8774$var$WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function $5cd9a37742eb8774$var$updateWrapDetails(details, bitmask) {
    $9Kzih($5cd9a37742eb8774$var$wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if (bitmask & pair[1] && !$lqZWH(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = $5cd9a37742eb8774$var$updateWrapDetails;

});



parcelRegister("9xQzO", function(module, exports) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function $6f2ffabf17208972$var$getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = $6f2ffabf17208972$var$getHolder;

});

parcelRegister("jtjhF", function(module, exports) {

var $b69Sx = parcelRequire("b69Sx");

var $3hFfZ = parcelRequire("3hFfZ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e2cfaf2379d6eef4$var$nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function $e2cfaf2379d6eef4$var$reorder(array, indexes) {
    var arrLength = array.length, length = $e2cfaf2379d6eef4$var$nativeMin(indexes.length, arrLength), oldArray = $b69Sx(array);
    while(length--){
        var index = indexes[length];
        array[length] = $3hFfZ(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = $e2cfaf2379d6eef4$var$reorder;

});

parcelRegister("kBgrU", function(module, exports) {
/** Used as the internal argument placeholder. */ var $eff405cccdf3a041$var$PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function $eff405cccdf3a041$var$replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === $eff405cccdf3a041$var$PLACEHOLDER) {
            array[index] = $eff405cccdf3a041$var$PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = $eff405cccdf3a041$var$replaceHolders;

});



parcelRegister("3slGh", function(module, exports) {

var $5VdlS = parcelRequire("5VdlS");

var $4ptXN = parcelRequire("4ptXN");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $2844ce06b6725f7d$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function $2844ce06b6725f7d$var$createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & $2844ce06b6725f7d$var$WRAP_BIND_FLAG, Ctor = $4ptXN(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return $5VdlS(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = $2844ce06b6725f7d$var$createPartial;

});

parcelRegister("fHM5F", function(module, exports) {

var $98OfC = parcelRequire("98OfC");

var $aoNSM = parcelRequire("aoNSM");

var $kBgrU = parcelRequire("kBgrU");
/** Used as the internal argument placeholder. */ var $b6f02cf0a655a19e$var$PLACEHOLDER = '__lodash_placeholder__';
/** Used to compose bitmasks for function metadata. */ var $b6f02cf0a655a19e$var$WRAP_BIND_FLAG = 1, $b6f02cf0a655a19e$var$WRAP_BIND_KEY_FLAG = 2, $b6f02cf0a655a19e$var$WRAP_CURRY_BOUND_FLAG = 4, $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG = 8, $b6f02cf0a655a19e$var$WRAP_ARY_FLAG = 128, $b6f02cf0a655a19e$var$WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b6f02cf0a655a19e$var$nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function $b6f02cf0a655a19e$var$mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($b6f02cf0a655a19e$var$WRAP_BIND_FLAG | $b6f02cf0a655a19e$var$WRAP_BIND_KEY_FLAG | $b6f02cf0a655a19e$var$WRAP_ARY_FLAG);
    var isCombo = srcBitmask == $b6f02cf0a655a19e$var$WRAP_ARY_FLAG && bitmask == $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG || srcBitmask == $b6f02cf0a655a19e$var$WRAP_ARY_FLAG && bitmask == $b6f02cf0a655a19e$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($b6f02cf0a655a19e$var$WRAP_ARY_FLAG | $b6f02cf0a655a19e$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & $b6f02cf0a655a19e$var$WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & $b6f02cf0a655a19e$var$WRAP_BIND_FLAG ? 0 : $b6f02cf0a655a19e$var$WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? $98OfC(partials, value, source[4]) : value;
        data[4] = partials ? $kBgrU(data[3], $b6f02cf0a655a19e$var$PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? $aoNSM(partials, value, source[6]) : value;
        data[6] = partials ? $kBgrU(data[5], $b6f02cf0a655a19e$var$PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & $b6f02cf0a655a19e$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $b6f02cf0a655a19e$var$nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = $b6f02cf0a655a19e$var$mergeData;

});



parcelRegister("E0NNP", function(module, exports) {

var $ee7Ev = parcelRequire("ee7Ev");
/** Used to compose bitmasks for cloning. */ var $07845bdb18fff27f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $07845bdb18fff27f$var$clone(value) {
    return $ee7Ev(value, $07845bdb18fff27f$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $07845bdb18fff27f$var$clone;

});

parcelRegister("cleLA", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");
/** Used to compose bitmasks for function metadata. */ var $8fc2e687045586ce$var$WRAP_CURRY_FLAG = 8;
/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */ function $8fc2e687045586ce$var$curry(func, arity, guard) {
    arity = guard ? undefined : arity;
    var result = $xQ3hV(func, $8fc2e687045586ce$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
    result.placeholder = $8fc2e687045586ce$var$curry.placeholder;
    return result;
}
// Assign default placeholders.
$8fc2e687045586ce$var$curry.placeholder = {};
module.exports = $8fc2e687045586ce$var$curry;

});

parcelRegister("dbogu", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $hYEMs = parcelRequire("hYEMs");

var $jtsd5 = parcelRequire("jtsd5");
/** `Object#toString` result references. */ var $998f1ff604abccc1$var$domExcTag = '[object DOMException]', $998f1ff604abccc1$var$errorTag = '[object Error]';
/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */ function $998f1ff604abccc1$var$isError(value) {
    if (!$hYEMs(value)) return false;
    var tag = $2OY5s(value);
    return tag == $998f1ff604abccc1$var$errorTag || tag == $998f1ff604abccc1$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$jtsd5(value);
}
module.exports = $998f1ff604abccc1$var$isError;

});

parcelRegister("a1CHL", function(module, exports) {

var $fjnSB = parcelRequire("fjnSB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $74c80559f18c75f2$var$weakMapTag = '[object WeakMap]';
/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */ function $74c80559f18c75f2$var$isWeakMap(value) {
    return $hYEMs(value) && $fjnSB(value) == $74c80559f18c75f2$var$weakMapTag;
}
module.exports = $74c80559f18c75f2$var$isWeakMap;

});

parcelRegister("akHxB", function(module, exports) {

var $ee7Ev = parcelRequire("ee7Ev");

var $7qARj = parcelRequire("7qARj");
/** Used to compose bitmasks for cloning. */ var $785d8bf9eb54b1a7$var$CLONE_DEEP_FLAG = 1;
/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */ function $785d8bf9eb54b1a7$var$iteratee(func) {
    return $7qARj(typeof func == 'function' ? func : $ee7Ev(func, $785d8bf9eb54b1a7$var$CLONE_DEEP_FLAG));
}
module.exports = $785d8bf9eb54b1a7$var$iteratee;

});

parcelRegister("k5dRT", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");

var $224h2 = parcelRequire("224h2");
/** Used to compose bitmasks for function metadata. */ var $e9ef0836fe6d24f1$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */ var $e9ef0836fe6d24f1$var$rearg = $224h2(function(func, indexes) {
    return $xQ3hV(func, $e9ef0836fe6d24f1$var$WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});
module.exports = $e9ef0836fe6d24f1$var$rearg;

});

parcelRegister("d0KBl", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $b69Sx = parcelRequire("b69Sx");

var $1c8hB = parcelRequire("1c8hB");

var $8aco7 = parcelRequire("8aco7");

var $1xzs7 = parcelRequire("1xzs7");

var $cNyDu = parcelRequire("cNyDu");

var $1uqnh = parcelRequire("1uqnh");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $978f6c7ba8ca5ebf$var$toPath(value) {
    if ($1c8hB(value)) return $kJvGp(value, $cNyDu);
    return $8aco7(value) ? [
        value
    ] : $b69Sx($1xzs7($1uqnh(value)));
}
module.exports = $978f6c7ba8ca5ebf$var$toPath;

});




parcelRegister("bdiQj", function(module, exports) {

$parcel$export(module.exports, "useConnectAppNavigationData", () => $fec72166bfc86ec6$export$4e0e21a37979b45e);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $hKtrD = parcelRequire("hKtrD");
const $fec72166bfc86ec6$export$4e0e21a37979b45e = (projectKey, resource)=>{
    const { data: data, ...rest } = (0, $iZJHG.useResourceWithCustomRouterContext)(resource, {
        matchParams: {
            projectKey: projectKey
        }
    });
    const connectDataItems = (0, $eUqFw.useMemo)(()=>data?.map((0, $hKtrD.transformLinkV4))?.filter(Boolean) || null, [
        data
    ]);
    return {
        data: connectDataItems,
        ...rest
    };
};

});

parcelRegister("k4Q7K", function(module, exports) {

$parcel$export(module.exports, "ConnectMenu", () => $a2873eb7a7dee994$export$19d0925d424b864a);

var $eUqFw = parcelRequire("eUqFw");

var $9ui8T = parcelRequire("9ui8T");

var $jZwDe = parcelRequire("jZwDe");
const $a2873eb7a7dee994$export$19d0925d424b864a = ({ items: items, showIcons: showIcons = false, shouldFilter: shouldFilter = true })=>{
    const filteredItems = (0, $9ui8T.useFilteredItems)(items || null, shouldFilter);
    if (filteredItems == null || !filteredItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, filteredItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jZwDe.ConnectItem), {
            key: item.id,
            item: item,
            showIcons: showIcons
        })));
};

});
parcelRegister("jZwDe", function(module, exports) {

$parcel$export(module.exports, "ConnectItem", () => $cc6710f71f26d090$export$8bb4bcea44a3c9ea);

var $eUqFw = parcelRequire("eUqFw");

var $k4nIh = parcelRequire("k4nIh");

var $422mK = parcelRequire("422mK");

var $bS2FN = parcelRequire("bS2FN");

var $bL3p1 = parcelRequire("bL3p1");

var $dplAH = parcelRequire("dplAH");
var $fUrao = parcelRequire("fUrao");
var $2sdKK = parcelRequire("2sdKK");
var $4cwcz = parcelRequire("4cwcz");
var $g6ngP = parcelRequire("g6ngP");

var $lB25E = parcelRequire("lB25E");
const $cc6710f71f26d090$export$8bb4bcea44a3c9ea = ({ item: item, showIcons: showIcons })=>{
    const { addNew: addNew } = (0, $422mK.useConnectItemClickHistory)();
    const icon = (0, $eUqFw.useMemo)(()=>{
        if (showIcons !== true || item.section) return undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bL3p1.ForgeIcon), {
            url: item.iconUrl
        });
    }, [
        showIcons,
        item.iconUrl,
        item.section
    ]);
    const [{ location: location, query: query }] = (0, $lB25E.useRouter)();
    const getIsCurrentLocationMatchItemUrl = (0, $eUqFw.useCallback)((itemUrl)=>{
        if (!itemUrl) return false;
        // match pathname and query params
        // code adapted from src/packages/navigation-apps/sidebar/common/src/common/ui/menu-item/main.tsx
        const currentLocation = {
            ...location,
            query: query
        };
        const urlMatcher = (0, $bS2FN.matchUrlExact)();
        const itemLocation = (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(itemUrl || '/', true);
        // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
        return urlMatcher(currentLocation, itemLocation);
    }, [
        location,
        query
    ]);
    const isItemSelected = (0, $eUqFw.useMemo)(()=>getIsCurrentLocationMatchItemUrl(item.url), [
        item.url,
        getIsCurrentLocationMatchItemUrl
    ]);
    const getIsChildSelected = (0, $eUqFw.useCallback)((parentItem)=>parentItem.items?.some((child)=>getIsCurrentLocationMatchItemUrl(child.url) || getIsChildSelected(child)) ?? false, [
        getIsCurrentLocationMatchItemUrl
    ]);
    const isChildSelected = (0, $eUqFw.useMemo)(()=>getIsChildSelected(item), [
        item,
        getIsChildSelected
    ]);
    const onItemClick = (0, $eUqFw.useCallback)(()=>{
        item.url != null && addNew(item.url);
    }, [
        addNew,
        item.url
    ]);
    const anchorElement = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        // inject style class names used by Connect app js to attach event listener to display modal dialog
        if (item.styleClass) {
            const classes = item.styleClass.split(' ').map((className)=>className.trim()).filter(Boolean).filter((className)=>anchorElement.current?.classList?.contains(className) === false);
            anchorElement.current?.classList?.add(...classes);
        }
    }, [
        item.styleClass
    ]);
    if (item.items && item.items.length > 0) {
        const childSections = item.items.filter((child)=>child.section);
        const isAllSectionsUnnamed = childSections.length > 0 && childSections.every((section)=>!section.name);
        const menuContent = item.items.map((child, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
                key: child.id
            }, isAllSectionsUnnamed && child.section && index > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dplAH.Divider), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc6710f71f26d090$export$8bb4bcea44a3c9ea, {
                item: child,
                showIcons: showIcons
            })));
        return item.name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fUrao.ExpandableMenuItem), {
            isDefaultExpanded: item.section || isChildSelected,
            isChildSelected: isChildSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cwcz.ExpandableMenuItemTrigger), {
            elemBefore: icon
        }, item.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2sdKK.ExpandableMenuItemContent), null, menuContent)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, menuContent);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6ngP.MenuLinkItem), {
        analytics: {
            itemId: item.id
        },
        elemBefore: icon,
        href: item.url ?? '',
        isSelected: isItemSelected,
        ref: anchorElement,
        onClick: onItemClick
    }, item.name);
};

});
parcelRegister("bL3p1", function(module, exports) {

$parcel$export(module.exports, "ForgeIcon", () => $da8becc13c967c27$export$fe0464db4dc93ab4);

var $eUqFw = parcelRequire("eUqFw");

var $l1LQr = parcelRequire("l1LQr");

var $aN9eE = parcelRequire("aN9eE");
const $da8becc13c967c27$export$fe0464db4dc93ab4 = ({ url: url })=>url != null && String(url).trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aN9eE.ContainerAvatar), {
        src: url,
        appearance: "subtle"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l1LQr))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    });

});
parcelRegister("aN9eE", function(module, exports) {

$parcel$export(module.exports, "ContainerAvatar", () => $c816f734440f51e0$export$f35a2d11bd6ae97);
/* container-avatar.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $c816f734440f51e0$var$styles = {
    root: "_vchhusvi _4t3igktf _1bsbgktf _2rkoiti9",
    withBorder: "_12y3e4h9 _12jimuej _1cwg1x9t _1qu2nqa1"
};
const $c816f734440f51e0$export$f35a2d11bd6ae97 = ({ src: src, appearance: appearance = 'default' })=>/*#__PURE__*/ $eUqFw.createElement("img", {
        src: src,
        alt: "",
        className: (0, $7JEyt.default)([
            $c816f734440f51e0$var$styles.root,
            appearance === 'default' && $c816f734440f51e0$var$styles.withBorder
        ])
    });

});


parcelRegister("dplAH", function(module, exports) {

$parcel$export(module.exports, "Divider", () => $e47b9a739fc44d3b$export$2e0a83ec2e27ecbb);
/* divider.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $e47b9a739fc44d3b$var$styles = null;
const $e47b9a739fc44d3b$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ $eUqFw.createElement("hr", {
        className: (0, $7JEyt.default)([
            "_1bsb1osq _179rglyw _mqm2zgxb _h7alglyw"
        ])
    });

});

parcelRegister("fUrao", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItem", () => $88c5bee065aee368$export$341dea48c30b36ff);

var $eUqFw = parcelRequire("eUqFw");

var $2WwAS = parcelRequire("2WwAS");

var $jzazL = parcelRequire("jzazL");

var $adHSl = parcelRequire("adHSl");
const $88c5bee065aee368$export$341dea48c30b36ff = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, isChildSelected: isChildSelected = false, onExpansionToggle: onExpansionToggle, children: children }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $2WwAS.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $adHSl.IsExpandedContext).Provider, {
        value: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $adHSl.SetIsExpandedContext).Provider, {
        value: setIsExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $adHSl.IsChildSelectedContext).Provider, {
        value: isChildSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $adHSl.OnExpansionToggleContext).Provider, {
        value: onExpansionToggle ?? null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jzazL.MenuListItem), {
        ref: forwardedRef
    }, children)))));
});

});
parcelRegister("jzazL", function(module, exports) {

$parcel$export(module.exports, "MenuListItem", () => $ab7d3abedc024d3e$export$6c2f3257abc4825b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $7MHzS = parcelRequire("7MHzS");
const $ab7d3abedc024d3e$export$6c2f3257abc4825b = (0, $7MHzS.ListItem);

});

parcelRegister("adHSl", function(module, exports) {

$parcel$export(module.exports, "IsExpandedContext", () => $2f3f334b842d252a$export$c856e5885cc34d81);
$parcel$export(module.exports, "SetIsExpandedContext", () => $2f3f334b842d252a$export$48cb11cb8691f597);
$parcel$export(module.exports, "IsChildSelectedContext", () => $2f3f334b842d252a$export$afd5e66c4a050b2b);
$parcel$export(module.exports, "OnExpansionToggleContext", () => $2f3f334b842d252a$export$572ce188c913ceba);
$parcel$export(module.exports, "LevelContext", () => $2f3f334b842d252a$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "useIsExpanded", () => $2f3f334b842d252a$export$37e565a09598825e);
$parcel$export(module.exports, "useSetIsExpanded", () => $2f3f334b842d252a$export$c9a171ea8de5861b);
$parcel$export(module.exports, "useIsChildSelected", () => $2f3f334b842d252a$export$5e0ac78afeceab3c);
$parcel$export(module.exports, "useOnExpansionToggle", () => $2f3f334b842d252a$export$56c8438498b72c7a);
$parcel$export(module.exports, "useLevel", () => $2f3f334b842d252a$export$fdfe9e5e8183d4f2);

var $eUqFw = parcelRequire("eUqFw");

var $8ynlC = parcelRequire("8ynlC");
const $2f3f334b842d252a$export$c856e5885cc34d81 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $2f3f334b842d252a$export$48cb11cb8691f597 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $2f3f334b842d252a$export$afd5e66c4a050b2b = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $2f3f334b842d252a$export$572ce188c913ceba = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $2f3f334b842d252a$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $eUqFw.createContext)(0);
const $2f3f334b842d252a$export$37e565a09598825e = ()=>{
    const context = (0, $eUqFw.useContext)($2f3f334b842d252a$export$c856e5885cc34d81);
    (0, $8ynlC.default)(context !== null, 'useIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $2f3f334b842d252a$export$c9a171ea8de5861b = ()=>{
    const context = (0, $eUqFw.useContext)($2f3f334b842d252a$export$48cb11cb8691f597);
    (0, $8ynlC.default)(context !== null, 'useSetIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $2f3f334b842d252a$export$5e0ac78afeceab3c = ()=>{
    const context = (0, $eUqFw.useContext)($2f3f334b842d252a$export$afd5e66c4a050b2b);
    (0, $8ynlC.default)(context !== null, 'useIsChildSelected must be used within an ExpandableMenuItem');
    return context;
};
const $2f3f334b842d252a$export$56c8438498b72c7a = ()=>(0, $eUqFw.useContext)($2f3f334b842d252a$export$572ce188c913ceba);
const $2f3f334b842d252a$export$fdfe9e5e8183d4f2 = ()=>(0, $eUqFw.useContext)($2f3f334b842d252a$export$650d12d3c2ddb8fc);

});


parcelRegister("2sdKK", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemContent", () => $4a4a07cbd89e64b0$export$bd680a81504a92e9);
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $2Eyt5 = parcelRequire("2Eyt5");

var $1XEld = parcelRequire("1XEld");

var $adHSl = parcelRequire("adHSl");
const $4a4a07cbd89e64b0$var$styles = {
    content: "_bozg1yac",
    collapsedContent: "_1e0cglyw"
};
const $4a4a07cbd89e64b0$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $adHSl.useIsExpanded)();
    const level = (0, $adHSl.useLevel)();
    const hasExpanded = (0, $eUqFw.useRef)(false);
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ $eUqFw.createElement((0, $adHSl.LevelContext).Provider, {
        value: level + 1
    }, /*#__PURE__*/ $eUqFw.createElement((0, $1XEld.List), {
        ref: forwardedRef,
        xcss: (0, $2Eyt5.cx)($4a4a07cbd89e64b0$var$styles.content, !isExpanded && $4a4a07cbd89e64b0$var$styles.collapsedContent)
    }, children));
});

});

parcelRegister("4cwcz", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemTrigger", () => $f5df8097bccf3569$export$fe6fe51056867f4d);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $c6CvK = parcelRequire("c6CvK");

var $fCmfi = parcelRequire("fCmfi");

var $b5IAe = parcelRequire("b5IAe");

var $bP7nx = parcelRequire("bP7nx");

var $adHSl = parcelRequire("adHSl");
const $f5df8097bccf3569$var$ExpandableMenuItemIcon = ({ iconProps: iconProps, isExpanded: isExpanded, isHovering: isHovering, isSelected: isSelected, defaultStateElem: defaultStateElem })=>{
    const isChildSelected = (0, $adHSl.useIsChildSelected)();
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($c6CvK))) : (0, (/*@__PURE__*/$parcel$interopDefault($fCmfi)));
    const chevronElem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected || isChildSelected ? "var(--ds-icon-selected, #0C66E4)" : undefined
    });
    return isHovering ? chevronElem : defaultStateElem ?? chevronElem;
};
const $f5df8097bccf3569$export$fe6fe51056867f4d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: elemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName }, forwardedRef)=>{
    const onExpansionToggle = (0, $adHSl.useOnExpansionToggle)();
    const isExpanded = (0, $adHSl.useIsExpanded)();
    const setIsExpanded = (0, $adHSl.useSetIsExpanded)();
    const [isHovering, setIsHovering] = (0, $eUqFw.useState)(false);
    const handleMouseEnter = (0, $eUqFw.useCallback)(()=>setIsHovering(true), []);
    const handleMouseLeave = (0, $eUqFw.useCallback)(()=>setIsHovering(false), []);
    const handleIconClick = (0, $eUqFw.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    const expandableElemBefore = isSelectable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5df8097bccf3569$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isHovering: isHovering,
                isExpanded: isExpanded,
                isSelected: isSelected,
                defaultStateElem: elemBefore
            }),
        "aria-expanded": isExpanded,
        label: isExpanded ? 'Collapse' : 'Expand',
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5df8097bccf3569$var$ExpandableMenuItemIcon, {
        isHovering: isHovering,
        isExpanded: isExpanded,
        isSelected: isSelected,
        defaultStateElem: elemBefore
    });
    return(// For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    // Wrapping in a `Box` so we can add the mouse event handlers, as `Flex` does not support those props
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bP7nx.MenuItemBase), {
        actions: actions,
        actionsOnHover: actionsOnHover,
        elemBefore: expandableElemBefore,
        ariaExpanded: isExpanded,
        elemAfter: elemAfter,
        href: href,
        isSelected: isSelected,
        onClick: handleMenuContentClick,
        ref: forwardedRef,
        testId: testId,
        interactionName: interactionName
    }, children)));
});

});
parcelRegister("bP7nx", function(module, exports) {

$parcel$export(module.exports, "MenuItemBase", () => $6d8de1d883387ba3$export$859b390bf71e044e);
/* menu-item.tsx generated by @compiled/babel-plugin v0.29.1 */ /**
 * @jsxFrag
 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $2Eyt5 = parcelRequire("2Eyt5");

var $6PZxV = parcelRequire("6PZxV");

var $4kMup = parcelRequire("4kMup");
var $4ZL0y = parcelRequire("4ZL0y");
var $1Yimi = parcelRequire("1Yimi");

var $iGOPs = parcelRequire("iGOPs");

var $adHSl = parcelRequire("adHSl");

var $74NH7 = parcelRequire("74NH7");

var $3R9tk = parcelRequire("3R9tk");
const $6d8de1d883387ba3$var$defaultAvatarValues = {
    size: 'small'
};
const $6d8de1d883387ba3$var$elemAfterDisplayVar = '--elem-after-display';
const $6d8de1d883387ba3$var$notchColorVar = '--notch-color';
/**
 * ## 🤹 `position:relative`
 *
 * We need `position:relative` on an element that takes
 * up the full size of the interactive element so we
 * can correctly use `position:absolute` to place:
 * 1. the notch for links
 * 2. a child of button / anchor to stretch it out to
 *    increase it's pressable area.
 *
 * ⛔️ We cannot add `position:relative` _only_ on the
 * button / anchor as that will cause sibling elements
 * to be rendered under the button / anchor when setting
 * a background color on the button / anchor.
 *
 * 📖 Note: `position:relative` elements are painted after
 * elements with `position:static` (the default)
 * https://drafts.csswg.org/css-position-4/#painting-order
 *
 * ⛔️ We cannot add `position:relative` to the container
 * element, as then the `:focus` ring styles on the
 * button / anchor can be cut off by the next sibling if it has
 * has a background color set (eg when selected)
 *
 * ✅ Add `position:relative` to all first level descendants
 * of the container element so that we don't impact DOM ordered
 * paint ordering within the item and the button / anchor focus
 * ring can still bleed over siblings
 *
 * 📖 We could use `> * { position: relative; }` on the container,
 * but that would violate our styling standard.
 */ const $6d8de1d883387ba3$var$topLevelSiblingStyles = {
    root: "_kqswh2mm"
};
/**
 * All slots on the menu item (eg `elemBefore`) are rendered as siblings
 * of our main button / anchor element and they are visually placed on
 * top of the main button / anchor.
 *
 * 📖 This is done so that we don't nest interactive elements in our markup.
 *
 * ✅ This is great when element in the slot is an interactive element
 * as we don't want the main menu item button / anchor to be triggered
 * when interacting with the element in the slot.
 *
 * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
 * prevent the main button / anchor (that is visually behind the element in
 * the slot) from being clicked. The element in the slot is a sibling of our
 * main button / anchor (not a child of it) so clicking on the element in the
 * slot will not bubble up to the button / anchor.
 *
 * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
 * element so that static content in a slot does not prevent clicking on the main
 * button / anchor.
 */ const $6d8de1d883387ba3$var$onTopOfButtonOrAnchorStyles = {
    root: "_18ukglyw"
};
const $6d8de1d883387ba3$var$containerStyles = {
    root: "_vchhusvi _1e0c11p5 _yv0eaa4y _4cvr1h6o _4t3izwfg _uiztglyw _2rkoglpi _syaz1gjq _1yyu3acm _rkdi1ji5 _19w515ej _19lc108i _u31n15ej",
    removeElemAfter: "_91juglyw",
    removeElemAfterOnHover: "_91ju1txw _1mfcglyw _1sjuglyw",
    selected: "_11q7fg4m _syazaqb7 _1yyu1fvw _30l3aqb7 _19lci1yw _u31n1fvw",
    pressed: "_11q71ji5 _1yyu15ej",
    hasDescription: "_4t3i1ady"
};
const $6d8de1d883387ba3$var$buttonOrAnchorStyles = {
    root: "_1e0c11p5 _yyhyjvu9 _1ii7kb7n _yv0enbh3 _4t3i1osq _1yt41b66 _11q7glyw _2rkoglpi _syaz1gjq _4cvr1h6o _y3gnv2br _j6xt1ji5",
    selected: "_syazaqb7 _j6xt19ru"
};
const $6d8de1d883387ba3$var$extendButtonOrAnchorStyles = {
    root: "_kqswstnw _1r04ze3t"
};
const $6d8de1d883387ba3$var$notchStyles = {
    root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
};
const $6d8de1d883387ba3$var$actionStyles = {
    root: "_1e0c1txw _4cvr1h6o _zulp1b66 _1ii7kb7n _yyhyqfx8 _y4ti1b66"
};
const $6d8de1d883387ba3$var$actionOnHoverStyles = {
    root: "_1e0c1txw _4cvr1h6o _zulp1b66 _y4ti1b66",
    gridPosition: "_1ii7kb7n _yyhy11wp"
};
const $6d8de1d883387ba3$var$textStyles = {
    root: "_yyhycs5v _y4ti1b66 _bozg1b66",
    noElemBeforeIndent: "_bozg12x7"
};
const $6d8de1d883387ba3$var$elemBeforeStyles = {
    root: "_yyhykb7n _1ii7kb7n _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66"
};
const $6d8de1d883387ba3$var$elemAfterStyles = {
    root: "_1e0cgmyj _yyhyegat _1ii7kb7n _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66"
};
const $6d8de1d883387ba3$export$859b390bf71e044e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName }, forwardedRef)=>{
    const level = (0, $adHSl.useLevel)();
    const setFlyoutMenuOpen = (0, $74NH7.useSetFlyoutMenuOpen)();
    const isFlyoutMenuOpen = (0, $74NH7.useFlyoutMenuOpen)();
    const isLink = typeof href !== 'undefined';
    const handleClick = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        // Toggle flyout menu open state when inside a flyout context provider
        setFlyoutMenuOpen(!isFlyoutMenuOpen);
    }, [
        onClick,
        setFlyoutMenuOpen,
        isFlyoutMenuOpen
    ]);
    const buttonAndAnchorSharedProps = {
        'aria-controls': ariaControls,
        'aria-haspopup': ariaHasPopup,
        onClick: handleClick
    };
    // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    const showElemBefore = elemBefore !== (0, $3R9tk.COLLAPSE_ELEM_BEFORE);
    const interactiveElemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // This extends the clickable area of nested menu items to the width
        // of the root level menu items, while being visually indented.
        style: {
            insetInlineStart: `-${level * 26}px`
        },
        "aria-hidden": "true",
        className: (0, $7JEyt.default)([
            $6d8de1d883387ba3$var$extendButtonOrAnchorStyles.root
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $6d8de1d883387ba3$var$textStyles.root,
            !showElemBefore && $6d8de1d883387ba3$var$textStyles.noElemBeforeIndent
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        weight: "medium",
        maxLines: 1,
        color: isSelected ? 'color.text.selected' : 'color.text.subtle'
    }, children), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtlest",
        size: "small",
        maxLines: 1
    }, description)));
    // If the menu item is expanded, show hover actions even when not hovered
    const showHoverActionsWhenNotHovered = Boolean(!ariaHasPopup && ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iGOPs.InteractionSurface), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6PZxV.AvatarContext).Provider, {
        value: $6d8de1d883387ba3$var$defaultAvatarValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        "data-selected": isSelected,
        className: (0, $7JEyt.default)([
            $6d8de1d883387ba3$var$containerStyles.root,
            isSelected && $6d8de1d883387ba3$var$containerStyles.selected,
            description && $6d8de1d883387ba3$var$containerStyles.hasDescription,
            ariaHasPopup && ariaExpanded && $6d8de1d883387ba3$var$containerStyles.pressed,
            actionsOnHover && elemAfter && $6d8de1d883387ba3$var$containerStyles.removeElemAfterOnHover,
            showHoverActionsWhenNotHovered && $6d8de1d883387ba3$var$containerStyles.removeElemAfter
        ])
    }, isLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        ...buttonAndAnchorSharedProps,
        xcss: (0, $2Eyt5.cx)($6d8de1d883387ba3$var$buttonOrAnchorStyles.root, $6d8de1d883387ba3$var$topLevelSiblingStyles.root, isSelected && $6d8de1d883387ba3$var$buttonOrAnchorStyles.selected),
        // Needed to override Anchor style due to a compiled/emotion conflict
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            textDecoration: 'none'
        },
        "aria-current": isSelected ? 'page' : undefined,
        href: href,
        target: target,
        ref: forwardedRef,
        testId: testId,
        interactionName: interactionName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "aria-hidden": "true",
        className: (0, $7JEyt.default)([
            $6d8de1d883387ba3$var$notchStyles.root
        ])
    }), interactiveElemContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        ...buttonAndAnchorSharedProps,
        xcss: (0, $2Eyt5.cx)($6d8de1d883387ba3$var$buttonOrAnchorStyles.root, $6d8de1d883387ba3$var$topLevelSiblingStyles.root, isSelected && $6d8de1d883387ba3$var$buttonOrAnchorStyles.selected),
        "aria-expanded": ariaExpanded,
        isDisabled: isDisabled,
        ref: forwardedRef,
        testId: testId,
        interactionName: interactionName
    }, interactiveElemContent), showElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $6d8de1d883387ba3$var$elemBeforeStyles.root,
            $6d8de1d883387ba3$var$topLevelSiblingStyles.root,
            $6d8de1d883387ba3$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemBefore), actionsOnHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iGOPs.InteractionConsumer), {
        xcss: $6d8de1d883387ba3$var$actionOnHoverStyles.gridPosition,
        // If the menu item is expanded, show hover actions even when not hovered
        behavior: showHoverActionsWhenNotHovered ? 'alwaysShown' : 'removeOnLeave'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $6d8de1d883387ba3$var$actionOnHoverStyles.root
        ])
    }, actionsOnHover)), elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $6d8de1d883387ba3$var$elemAfterStyles.root,
            $6d8de1d883387ba3$var$topLevelSiblingStyles.root,
            $6d8de1d883387ba3$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemAfter), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $6d8de1d883387ba3$var$actionStyles.root,
            $6d8de1d883387ba3$var$topLevelSiblingStyles.root,
            $6d8de1d883387ba3$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, actions))));
});

});
parcelRegister("74NH7", function(module, exports) {

$parcel$export(module.exports, "IsOpenContext", () => $cd45a4208976572b$export$efa4d9670e96ac31);
$parcel$export(module.exports, "SetIsOpenContext", () => $cd45a4208976572b$export$4c55b1c61a116b42);
$parcel$export(module.exports, "useFlyoutMenuOpen", () => $cd45a4208976572b$export$6927118f874a49aa);
$parcel$export(module.exports, "useSetFlyoutMenuOpen", () => $cd45a4208976572b$export$538ac1aa421adb94);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $cd45a4208976572b$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const $cd45a4208976572b$export$4c55b1c61a116b42 = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $5Q9wj.default));
const $cd45a4208976572b$export$6927118f874a49aa = ()=>(0, $eUqFw.useContext)($cd45a4208976572b$export$efa4d9670e96ac31);
const $cd45a4208976572b$export$538ac1aa421adb94 = ()=>(0, $eUqFw.useContext)($cd45a4208976572b$export$4c55b1c61a116b42);

});

parcelRegister("3R9tk", function(module, exports) {

$parcel$export(module.exports, "COLLAPSE_ELEM_BEFORE", () => $40f65e5ca7e914df$export$f4b8e24fae579c6f);
const $40f65e5ca7e914df$export$f4b8e24fae579c6f = Symbol('collapse-elem-before');

});



parcelRegister("g6ngP", function(module, exports) {

$parcel$export(module.exports, "MenuLinkItem", () => $70e50009f92936fd$export$68ef190193a37bc2);

var $eUqFw = parcelRequire("eUqFw");

var $bP7nx = parcelRequire("bP7nx");

var $jzazL = parcelRequire("jzazL");
const $70e50009f92936fd$var$MenuLinkItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName }, forwardedRef)=>{
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        // JSDOM does not support scrollIntoView, so ensuring it exists first (see https://github.com/jsdom/jsdom/issues/1695)
        if (isSelected && itemRef.current?.scrollIntoView) itemRef.current.scrollIntoView({
            block: 'nearest'
        });
    // This effect should only run on initial mount, otherwise the sidebar would scroll every time an item is selected
    //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jzazL.MenuListItem), {
        ref: itemRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bP7nx.MenuItemBase), {
        testId: testId,
        description: description,
        actions: actions,
        elemAfter: elemAfter,
        // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
        elemBefore: elemBefore,
        href: href,
        target: target,
        actionsOnHover: actionsOnHover,
        isSelected: isSelected,
        onClick: onClick,
        ref: forwardedRef,
        interactionName: interactionName
    }, children));
};
const $70e50009f92936fd$export$68ef190193a37bc2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)($70e50009f92936fd$var$MenuLinkItemNoRef);

});



parcelRegister("c5iLA", function(module, exports) {

$parcel$export(module.exports, "ForgeServiceDeskQueueSection", () => $2d3e00d9f54de65d$export$a133aa9cc8b5e080);

var $eUqFw = parcelRequire("eUqFw");

var $1boRu = parcelRequire("1boRu");

var $2UkVD = parcelRequire("2UkVD");

var $2Rqjr = parcelRequire("2Rqjr");

var $70ON1 = parcelRequire("70ON1");

var $jMYeN = parcelRequire("jMYeN");

var $9UOXn = parcelRequire("9UOXn");

var $bi9sX = parcelRequire("bi9sX");
const $2d3e00d9f54de65d$var$getItemHref = (extension, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
    return `/jira/servicedesk/projects/${projectKey}/queues/apps/${appId}/${envId}`;
};
const $2d3e00d9f54de65d$export$a133aa9cc8b5e080 = ({ projectKey: projectKey })=>{
    const { data: data } = (0, $9UOXn.useServiceDeskQueueForgeAppsNav4)(projectKey);
    if (!data?.length || !projectKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2UkVD.TriggerAnalyticsWrapper), null, data.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bi9sX.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $2d3e00d9f54de65d$var$getItemHref(extension, projectKey),
            name: extension.properties.title,
            sections: (0, $jMYeN.toSections)(extension),
            iconUrl: extension.properties.icon,
            showIcon: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $2Rqjr.SERVICEDESK_QUEUE_PAGE_MODULE)
        }
    }));
};

});
parcelRegister("2UkVD", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $722d0b8202526896$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $722d0b8202526896$export$e1a79e3d472c925a);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");
const $722d0b8202526896$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.SERVICEDESK_QUEUE_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $722d0b8202526896$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.SERVICEDESK_QUEUE_PAGE_MODULE),
        moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("9UOXn", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskQueueForgeApps", () => $afd8d247ad561286$export$8a2bb837db423089);
$parcel$export(module.exports, "useServiceDeskQueueForgeAppsNav4", () => $afd8d247ad561286$export$52b0be0dcb122e71);

var $eUqFw = parcelRequire("eUqFw");

var $8LJqN = parcelRequire("8LJqN");

var $eI5EY = parcelRequire("eI5EY");

var $fTsDx = parcelRequire("fTsDx");

var $enojT = parcelRequire("enojT");

var $l90Gp = parcelRequire("l90Gp");

var $iZJHG = parcelRequire("iZJHG");

var $6ibpp = parcelRequire("6ibpp");
const $afd8d247ad561286$export$6bad18feaf94ee66 = (routeName, parentStack, projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $l90Gp.forgeServiceDeskQueueModuleV1Resource), projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const serviceDeskQueueData = (0, $eUqFw.useMemo)(()=>data?.extensions || null, [
        data
    ]);
    const accessNarrowedData = (0, $eUqFw.useMemo)(()=>data?.accessNarrowedExtensions || null, [
        data
    ]);
    const stack = (0, $6ibpp.useForgeItemStack)(serviceDeskQueueData, routeName, parentStack);
    return (0, $eUqFw.useMemo)(()=>({
            data: serviceDeskQueueData ? serviceDeskQueueData.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, {})) : null,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error,
            stack: stack
        }), [
        serviceDeskQueueData,
        accessNarrowedData,
        loading,
        error,
        stack
    ]);
};
const $afd8d247ad561286$export$5c74a7dbe97049ac = (routeName, parentStack, projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $l90Gp.forgeServiceDeskQueueModuleV2Resource), projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const serviceDeskQueueData = (0, $eUqFw.useMemo)(()=>data?.filter((0, $enojT.isExtensionVisible)) || null, [
        data
    ]);
    const accessNarrowedData = (0, $eUqFw.useMemo)(()=>data?.filter((0, $enojT.isExtensionHiddenByAppAccessRules)) || null, [
        data
    ]);
    const stack = (0, $6ibpp.useForgeItemStack)(serviceDeskQueueData, routeName, parentStack);
    return (0, $eUqFw.useMemo)(()=>({
            data: serviceDeskQueueData,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error,
            stack: stack
        }), [
        serviceDeskQueueData,
        accessNarrowedData,
        loading,
        error,
        stack
    ]);
};
const $afd8d247ad561286$export$8a2bb837db423089 = (0, $8LJqN.functionWithCondition)(()=>(0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $afd8d247ad561286$export$5c74a7dbe97049ac, $afd8d247ad561286$export$6bad18feaf94ee66);
const $afd8d247ad561286$export$52b0be0dcb122e71 = (projectKey)=>$afd8d247ad561286$export$8a2bb837db423089(undefined, undefined, projectKey);

});
parcelRegister("fTsDx", function(module, exports) {

$parcel$export(module.exports, "useDoesExtensionMeetConditions", () => $f49523f1e6c1d89f$export$642911220fb6609f);
$parcel$export(module.exports, "doesExtensionMeetConditions", () => $f49523f1e6c1d89f$export$b1e4ed7044e85aa3);

var $eUqFw = parcelRequire("eUqFw");

var $iPaeE = parcelRequire("iPaeE");

var $e91YZ = parcelRequire("e91YZ");

var $fz8wa = parcelRequire("fz8wa");

var $gd0Sp = parcelRequire("gd0Sp");
const $f49523f1e6c1d89f$export$642911220fb6609f = ()=>{
    const { isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const { hasCoreAccess: hasCoreAccess, hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceManagementAccess } = (0, $fz8wa.useApplicationPermissions)();
    return (0, $eUqFw.useCallback)((extension, extraContext)=>{
        const { displayConditions: displayConditions } = extension.properties;
        if (displayConditions == null) return true;
        const context = {
            ...extraContext,
            isAdmin: // User info
            isAdmin,
            isLoggedIn: !isAnonymous,
            isSiteAdmin: isSiteAdmin,
            hasCoreAccess: // App permissions
            hasCoreAccess,
            hasServiceManagementAccess: hasServiceManagementAccess,
            hasSoftwareAccess: hasSoftwareAccess
        };
        return (0, $iPaeE.doesMeetConditions)(displayConditions, context);
    }, [
        hasCoreAccess,
        hasServiceManagementAccess,
        hasSoftwareAccess,
        isAdmin,
        isAnonymous,
        isSiteAdmin
    ]);
};
const $f49523f1e6c1d89f$export$b1e4ed7044e85aa3 = (extension, extraContext)=>{
    const { displayConditions: displayConditions } = extension.properties;
    const { appPermissions: { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess }, isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const context = {
        // Whatever extension needs
        ...extraContext,
        isAdmin: // User info
        isAdmin,
        isLoggedIn: !isAnonymous,
        isSiteAdmin: isSiteAdmin,
        hasSoftwareAccess: // App permissions
        hasSoftwareAccess,
        hasServiceManagementAccess: hasServiceDeskAccess,
        hasCoreAccess: hasCoreAccess
    };
    return displayConditions ? (0, $iPaeE.doesMeetConditions)(displayConditions, context) : true;
};

});


parcelRegister("bi9sX", function(module, exports) {

$parcel$export(module.exports, "ForgeItem", () => $28ceeddbbe1d32d0$export$26a5287439a1d287);

var $eUqFw = parcelRequire("eUqFw");

var $7eMp1 = parcelRequire("7eMp1");

var $fUrao = parcelRequire("fUrao");
var $2sdKK = parcelRequire("2sdKK");
var $4cwcz = parcelRequire("4cwcz");

var $lB25E = parcelRequire("lB25E");

var $bL3p1 = parcelRequire("bL3p1");

var $kPflg = parcelRequire("kPflg");

var $47Ijx = parcelRequire("47Ijx");
const $28ceeddbbe1d32d0$export$26a5287439a1d287 = (props)=>{
    const [{ location: location }] = (0, $lB25E.useRouter)();
    const { url: url, showIcon: showIcon, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, sections: sections, overrides: overrides } = props;
    const shouldExpandAsDefault = (0, $eUqFw.useMemo)(()=>location.pathname.includes(url), [
        url,
        location
    ]);
    const onNestedMenuItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event);
        return ()=>null;
    }, [
        overrides
    ]);
    if (!sections?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $47Ijx.ForgeItemSimple), props);
    if (overrides?.showSelectedAppMenuOnly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kPflg.ForgeItemExpandable), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fUrao.ExpandableMenuItem), {
        isDefaultExpanded: shouldExpandAsDefault
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cwcz.ExpandableMenuItemTrigger), {
        elemBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bL3p1.ForgeIcon), {
            url: iconUrl
        }) : undefined,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eMp1.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        onClick: onNestedMenuItemClick
    }, (0, $7eMp1.nameWithCustomEnvironment)(name, environmentType, environmentKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2sdKK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kPflg.ForgeItemExpandable), props)));
};

});
parcelRegister("kPflg", function(module, exports) {

$parcel$export(module.exports, "ForgeItemExpandable", () => $bb78f430dfac8c64$export$532bd53ddb8882b3);

var $eUqFw = parcelRequire("eUqFw");

var $d6g7g = parcelRequire("d6g7g");

var $2HjYU = parcelRequire("2HjYU");

var $dplAH = parcelRequire("dplAH");
var $fUrao = parcelRequire("fUrao");
var $2sdKK = parcelRequire("2sdKK");
var $4cwcz = parcelRequire("4cwcz");
var $g6ngP = parcelRequire("g6ngP");
var $4cPGW = parcelRequire("4cPGW");
var $jzazL = parcelRequire("jzazL");
var $9758r = parcelRequire("9758r");

var $bL3p1 = parcelRequire("bL3p1");
const $bb78f430dfac8c64$var$createPageUrl = (extensionBaseUrl, route)=>route ? `${extensionBaseUrl}/${String(route).trim().replace(/^\/+/, '')}` : extensionBaseUrl;
const $bb78f430dfac8c64$var$ForgeItemExpandableWithHeader = (props)=>{
    const { getLinkProps: getLinkProps } = (0, $2HjYU.useGetLinkProps)();
    const { showIcon: showIcon, id: itemId, url: url, section: section } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cPGW.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fUrao.ExpandableMenuItem), {
        isDefaultExpanded: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cwcz.ExpandableMenuItemTrigger), null, section.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2sdKK.ExpandableMenuItemContent), null, section.pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6ngP.MenuLinkItem), {
            key: page.route,
            elemBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bL3p1.ForgeIcon), {
                url: page.icon
            }) : undefined,
            ...getLinkProps($bb78f430dfac8c64$var$createPageUrl(url, page.route)),
            analytics: {
                itemId: itemId
            },
            onClick: ()=>{
                (0, $d6g7g.forgeModulesConcurrentLoadTime)(itemId).start({
                    startTime: performance.now()
                });
            }
        }, page.title)))));
};
const $bb78f430dfac8c64$var$ForgeItemExpandableWithoutHeader = (props)=>{
    const { getLinkProps: getLinkProps } = (0, $2HjYU.useGetLinkProps)();
    const { showIcon: showIcon, id: itemId, url: url, section: section } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cPGW.MenuList), null, section.pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6ngP.MenuLinkItem), {
            key: page.route,
            elemBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bL3p1.ForgeIcon), {
                url: page.icon
            }) : undefined,
            ...getLinkProps($bb78f430dfac8c64$var$createPageUrl(url, page.route)),
            analytics: {
                itemId: itemId
            },
            onClick: ()=>{
                (0, $d6g7g.forgeModulesConcurrentLoadTime)(itemId).start({
                    startTime: performance.now()
                });
            }
        }, page.title)));
};
const $bb78f430dfac8c64$export$532bd53ddb8882b3 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, sections: sections } = props;
    const hasSectionsWithHeader = sections?.some((section)=>!!section.header);
    return sections?.map((section, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jzazL.MenuListItem), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9758r.MenuSection), null, typeof section.header === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bb78f430dfac8c64$var$ForgeItemExpandableWithHeader, {
            id: itemId,
            section: section,
            url: url,
            showIcon: showIcon
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !hasSectionsWithHeader && index !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dplAH.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bb78f430dfac8c64$var$ForgeItemExpandableWithoutHeader, {
            id: itemId,
            section: section,
            url: url,
            showIcon: showIcon
        })))));
};

});
parcelRegister("2HjYU", function(module, exports) {

$parcel$export(module.exports, "useGetLinkProps", () => $618dc40ad0c4023a$export$a3307878c8496d13);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");
const $618dc40ad0c4023a$export$a3307878c8496d13 = ()=>{
    const [{ location: location }] = (0, $lB25E.useRouter)();
    const getLinkProps = (0, $eUqFw.useCallback)((menuItemPath, options)=>$618dc40ad0c4023a$var$getMenuLinkPropsFromUrlPath({
            currentPath: location.pathname,
            menuItemPath: menuItemPath,
            options: options
        }), [
        location.pathname
    ]);
    const getLinkPropsFromRoute = (0, $eUqFw.useCallback)((menuItemRoute, pathParamValues = {}, options)=>{
        const menuItemPath = (0, $lB25E.generatePath)(menuItemRoute.path, pathParamValues);
        return getLinkProps(menuItemPath, options);
    }, [
        getLinkProps
    ]);
    return {
        getLinkPropsFromRoute: getLinkPropsFromRoute,
        getLinkProps: /**
		 * Consider using getLinkPropsFromRoute instead, to be able to reuse the page route object, rather than copying its url path around.
		 */ getLinkProps
    };
};
const $618dc40ad0c4023a$var$defaultOptions = {
    shouldMatchExactPath: true
};
const $618dc40ad0c4023a$var$getMenuLinkPropsFromUrlPath = ({ currentPath: currentPath, menuItemPath: menuItemPath, options: options })=>{
    const { shouldMatchExactPath: shouldMatchExactPath } = {
        ...$618dc40ad0c4023a$var$defaultOptions,
        ...options
    };
    return {
        href: menuItemPath,
        isSelected: shouldMatchExactPath ? currentPath.replace(/\/$/, '') === menuItemPath.replace(/\/$/, '') : currentPath.includes(menuItemPath.replace(/\/$/, ''))
    };
};

});

parcelRegister("9758r", function(module, exports) {

$parcel$export(module.exports, "MenuSection", () => $ae162b8e77df07b1$export$4b1545b4f2016d26);

var $eUqFw = parcelRequire("eUqFw");

var $ki32l = parcelRequire("ki32l");

var $7bHjs = parcelRequire("7bHjs");
const $ae162b8e77df07b1$export$4b1545b4f2016d26 = ({ children: children })=>{
    const id = (0, $ki32l.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7bHjs.MenuSectionContext).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "group",
        "aria-labelledby": `${id}-heading`
    }, children));
};

});
parcelRegister("7bHjs", function(module, exports) {

$parcel$export(module.exports, "MenuSectionContext", () => $ce16ec005c385100$export$728ac99b9c7eea8a);
$parcel$export(module.exports, "useMenuSectionContext", () => $ce16ec005c385100$export$8100cda602411810);

var $eUqFw = parcelRequire("eUqFw");

var $8ynlC = parcelRequire("8ynlC");
const $ce16ec005c385100$export$728ac99b9c7eea8a = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $ce16ec005c385100$export$8100cda602411810 = ()=>{
    const context = (0, $eUqFw.useContext)($ce16ec005c385100$export$728ac99b9c7eea8a);
    (0, $8ynlC.default)(context, 'useMenuSectionContext must be used within a MenuSection');
    return context;
};

});



parcelRegister("47Ijx", function(module, exports) {

$parcel$export(module.exports, "ForgeItemSimple", () => $11687411f65e8a97$export$df3259e43d89ee7b);

var $eUqFw = parcelRequire("eUqFw");

var $d6g7g = parcelRequire("d6g7g");

var $7eMp1 = parcelRequire("7eMp1");

var $2HjYU = parcelRequire("2HjYU");

var $g6ngP = parcelRequire("g6ngP");

var $bL3p1 = parcelRequire("bL3p1");
const $11687411f65e8a97$export$df3259e43d89ee7b = (props)=>{
    const { getLinkProps: getLinkProps } = (0, $2HjYU.useGetLinkProps)();
    const { showIcon: showIcon, id: itemId, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, url: url, name: name, overrides: overrides } = props;
    if (overrides?.showSelectedAppMenuOnly) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6ngP.MenuLinkItem), {
        analytics: {
            itemId: itemId
        },
        elemBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bL3p1.ForgeIcon), {
            url: iconUrl
        }) : undefined,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eMp1.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        ...getLinkProps(url, {
            shouldMatchExactPath: false
        }),
        onClick: ()=>{
            (0, $d6g7g.forgeModulesConcurrentLoadTime)(itemId).start({
                startTime: performance.now()
            });
        }
    }, (0, $7eMp1.nameWithCustomEnvironment)(name, environmentType, environmentKey));
};

});



parcelRegister("hTOEt", function(module, exports) {

$parcel$export(module.exports, "useQueueCustomRouterContext", () => $e53f79cdccee0ff7$export$f7c5cd815dd083e4);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");
const $e53f79cdccee0ff7$export$f7c5cd815dd083e4 = (projectKey)=>{
    const [{ match: match }] = (0, $lB25E.useRouter)();
    return (0, $eUqFw.useMemo)(()=>projectKey ? {
            matchParams: {
                ...match.params,
                projectKey: projectKey
            }
        } : undefined, [
        match.params,
        projectKey
    ]);
};

});

parcelRegister("5oIh2", function(module, exports) {

$parcel$export(module.exports, "usePriorityGroupsActions", () => $96fb244e1d6d1f98$export$aceb895c0a1bdb9);
$parcel$export(module.exports, "usePriorityGroupData", () => $96fb244e1d6d1f98$export$e41417e5a9e40e44);
$parcel$export(module.exports, "usePriorityGroups", () => $96fb244e1d6d1f98$export$9ad7fd5c13dc6dbb);
$parcel$export(module.exports, "useCategorizedGroupsNavItems", () => $96fb244e1d6d1f98$export$7ddc2fd096cdc650);
$parcel$export(module.exports, "useNormalizedPriorityGroups", () => $96fb244e1d6d1f98$export$c2e9f9150500e785);

var $eUqFw = parcelRequire("eUqFw");

var $bNe1g = parcelRequire("bNe1g");

var $iZJHG = parcelRequire("iZJHG");

var $hRe6W = parcelRequire("hRe6W");

var $dWLk9 = parcelRequire("dWLk9");

var $lB25E = parcelRequire("lB25E");

var $5OEre = parcelRequire("5OEre");

var $1L8BM = parcelRequire("1L8BM");

var $a8x2b = parcelRequire("a8x2b");
const $96fb244e1d6d1f98$var$updateGroup = (updatedGroup, groups)=>groups.map((g)=>g.id === updatedGroup.id ? {
            ...g,
            name: updatedGroup.name,
            version: updatedGroup.version,
            queues: updatedGroup.queueIds
        } : g);
const $96fb244e1d6d1f98$var$deleteGroup = (id, groups)=>groups.filter((group)=>group.id !== id);
const $96fb244e1d6d1f98$var$updateQueueGroups = (updatedGroups, groups)=>groups.map((group)=>{
        const matchedGroup = updatedGroups?.find((updatedGroup)=>updatedGroup.group.id === group.id);
        if (matchedGroup === undefined) return group;
        return {
            ...group,
            id: matchedGroup.group.id,
            name: matchedGroup.group.name,
            queues: matchedGroup.group.queueIds,
            version: matchedGroup.group.version
        };
    });
const $96fb244e1d6d1f98$var$addQueueToGroupByGroupName = (queueId, updatedGroup, groups)=>groups.map((g)=>updatedGroup.includes(g.name) && !g.queues.includes(queueId) ? {
            ...g,
            queues: [
                ...g.queues,
                queueId
            ]
        } : g);
const $96fb244e1d6d1f98$var$removeQueueFromGroupsByGroupName = (queueId, updatedGroup, groups)=>groups.map((g)=>updatedGroup.includes(g.name) ? {
            ...g,
            queues: g.queues.filter((q)=>q !== queueId)
        } : g);
const $96fb244e1d6d1f98$var$createActions = (update, category, projectId, cloudId)=>({
        updateQueuesInGroup: (id, name, version, newQueues)=>(0, $a8x2b.updateGroup)({
                cloudId: cloudId,
                id: id,
                name: name,
                version: version,
                queueIds: newQueues
            }).then((updatedGroup)=>{
                update((data)=>({
                        ...data,
                        [category]: $96fb244e1d6d1f98$var$updateGroup(updatedGroup, data[category])
                    }));
            }),
        renameGroup: (id, newName, version, queues)=>(0, $a8x2b.updateGroup)({
                cloudId: cloudId,
                id: id,
                name: newName,
                version: version,
                queueIds: queues
            }).then((updatedGroup)=>{
                update((data)=>({
                        ...data,
                        [category]: $96fb244e1d6d1f98$var$updateGroup(updatedGroup, data[category])
                    }));
            }),
        createGroup: (name)=>(0, $a8x2b.createGroup)({
                name: name,
                category: category,
                projectId: projectId,
                cloudId: cloudId,
                queueIds: []
            }).then((createdGroup)=>{
                update((data)=>{
                    const groups = data[category] || [];
                    return {
                        ...data,
                        [category]: [
                            ...groups,
                            {
                                ...createdGroup,
                                queues: createdGroup.queueIds
                            }
                        ]
                    };
                });
            }),
        deleteGroup: (id)=>(0, $a8x2b.deleteGroup)({
                cloudId: cloudId,
                id: id
            }).then(()=>{
                update((data)=>({
                        ...data,
                        [category]: $96fb244e1d6d1f98$var$deleteGroup(id, data[category])
                    }));
            }),
        addQueueToGroupByGroupName: (queueId, toUpdateGroups)=>{
            if (toUpdateGroups.length === 0) return;
            update((data)=>({
                    ...data,
                    [category]: $96fb244e1d6d1f98$var$addQueueToGroupByGroupName(queueId, toUpdateGroups, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    data[category])
                }));
        },
        removeQueueFromGroupsByGroupName: (queueId, toUpdateGroups)=>{
            if (toUpdateGroups.length === 0) return;
            update((data)=>({
                    ...data,
                    [category]: $96fb244e1d6d1f98$var$removeQueueFromGroupsByGroupName(queueId, toUpdateGroups, data[category])
                }));
        },
        updateQueueGroupsByGroupId: (queueId, toUpdateGroups)=>(0, $a8x2b.updateQueueGroupsByGroupId)({
                cloudId: cloudId,
                projectId: projectId,
                category: category,
                queueId: queueId,
                groupIds: toUpdateGroups
            }).then((updatedGroups)=>{
                update((data)=>({
                        ...data,
                        [category]: $96fb244e1d6d1f98$var$updateQueueGroups(updatedGroups.results, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        data[category])
                    }));
            })
    });
const $96fb244e1d6d1f98$export$aceb895c0a1bdb9 = ()=>{
    const category = (0, $5OEre.useCurrentCategory)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const { update: update } = (0, $lB25E.useResource)((0, $hRe6W.priorityGroupResource));
    const projectId = projectContext?.projectId;
    return (0, $eUqFw.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>$96fb244e1d6d1f98$var$createActions(update, category, projectId?.toString(), cloudId), [
        category,
        cloudId,
        projectId,
        update
    ]);
};
const $96fb244e1d6d1f98$export$e41417e5a9e40e44 = (customContext)=>(0, $iZJHG.useResourceWithCustomRouterContext)((0, $hRe6W.priorityGroupResource), customContext);
const $96fb244e1d6d1f98$export$9ad7fd5c13dc6dbb = (category, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = $96fb244e1d6d1f98$export$e41417e5a9e40e44(customContext);
    const categorizedGroups = (0, $eUqFw.useMemo)(()=>(data && data[category]) ?? [], [
        category,
        data
    ]);
    return [
        categorizedGroups,
        loading,
        error,
        refresh
    ];
};
const $96fb244e1d6d1f98$export$7ddc2fd096cdc650 = (projectKey, category, customContext)=>{
    const [groups, groupLoading, groupError] = $96fb244e1d6d1f98$export$9ad7fd5c13dc6dbb(category, customContext);
    const [navItems, loading, queueError] = (0, $1L8BM.useCategorizedNavItems)('', projectKey, category, customContext);
    return (0, $eUqFw.useMemo)(()=>{
        const isLoading = loading || groupLoading;
        if (isLoading || queueError || groupError) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return [
            [],
            isLoading,
            groupError,
            queueError
        ];
        const normalizedGroups = groups.map((group)=>({
                group: group,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                queues: group.queues.map((queueId)=>navItems?.find((item)=>Number.parseInt(item.id, 10) === queueId)).filter((item)=>!!item)
            }));
        return [
            normalizedGroups,
            isLoading,
            groupError,
            queueError
        ];
    }, [
        groupError,
        groupLoading,
        groups,
        loading,
        navItems,
        queueError
    ]);
};
const $96fb244e1d6d1f98$export$c2e9f9150500e785 = ()=>{
    const projectKey = (0, $5OEre.useProjectKey)();
    const category = (0, $5OEre.useCurrentCategory)();
    const [groups, groupLoading] = $96fb244e1d6d1f98$export$9ad7fd5c13dc6dbb(category);
    const [navItems, loading, error] = (0, $1L8BM.useCategorizedQueues)('', projectKey, category);
    return (0, $eUqFw.useMemo)(()=>{
        const isLoading = loading || groupLoading;
        if (isLoading || error) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return [
            [],
            isLoading,
            error
        ];
        const normalizedGroups = groups.map((group)=>({
                group: group,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                queues: group.queues.map((queueId)=>navItems?.find((item)=>item.id === queueId)).filter((queue)=>!!queue)
            }));
        return [
            normalizedGroups,
            isLoading,
            error
        ];
    }, [
        error,
        groupLoading,
        groups,
        loading,
        navItems
    ]);
};

});
parcelRegister("a8x2b", function(module, exports) {

$parcel$export(module.exports, "createGroup", () => $e814674f2aac38fd$export$856f728536d122cb);
$parcel$export(module.exports, "updateGroup", () => $e814674f2aac38fd$export$7266cde9e95c4de8);
$parcel$export(module.exports, "deleteGroup", () => $e814674f2aac38fd$export$ae2679b329fc10b6);
$parcel$export(module.exports, "updateQueueGroupsByGroupId", () => $e814674f2aac38fd$export$bdf88b9d006a8a43);

var $lRmyA = parcelRequire("lRmyA");
const $e814674f2aac38fd$export$856f728536d122cb = ({ cloudId: cloudId, projectId: projectId, category: category, name: name, queueIds: queueIds })=>{
    const createGroupUrl = `/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/group`;
    const payload = {
        projectId: projectId,
        category: category,
        name: name,
        queueIds: queueIds
    };
    return (0, $lRmyA.performPostRequest)(createGroupUrl, {
        body: JSON.stringify(payload)
    });
};
const $e814674f2aac38fd$export$7266cde9e95c4de8 = ({ cloudId: cloudId, id: id, version: version, name: name, queueIds: queueIds })=>{
    const updateGroupUrl = `/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/group/${id}`;
    const payload = {
        version: version,
        name: name,
        queueIds: queueIds
    };
    return (0, $lRmyA.performPutRequest)(updateGroupUrl, {
        body: JSON.stringify(payload)
    });
};
const $e814674f2aac38fd$export$ae2679b329fc10b6 = ({ cloudId: cloudId, id: id })=>{
    const deleteGroupUrl = `/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/group/${id}`;
    return (0, $lRmyA.performDeleteRequest)(deleteGroupUrl);
};
const $e814674f2aac38fd$export$bdf88b9d006a8a43 = ({ cloudId: cloudId, projectId: projectId, category: category, queueId: queueId, groupIds: groupIds })=>{
    const batchUpdateQueueGroupsUrl = `/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/group/batch/update-queue-groups/${projectId}/${category}`;
    const payload = {
        projectId: projectId,
        category: category,
        queueId: queueId,
        groupIds: groupIds
    };
    return (0, $lRmyA.performPutRequest)(batchUpdateQueueGroupsUrl, {
        body: JSON.stringify(payload)
    });
};

});


parcelRegister("79zP6", function(module, exports) {

$parcel$export(module.exports, "useOnFavoritesChanged", () => $80c4ec2b38f388a4$export$ddf44c597e03063d);

var $eUqFw = parcelRequire("eUqFw");

var $8i1R8 = parcelRequire("8i1R8");

var $hvbu2 = parcelRequire("hvbu2");

var $jrdvV = parcelRequire("jrdvV");

var $dQZ5c = parcelRequire("dQZ5c");

var $1ybV0 = parcelRequire("1ybV0");
const $80c4ec2b38f388a4$var$updateQueueUsingCallback = (queues, queueItemChanges, editItemFavoriteCallback, refreshIssueCountForItemsCallback)=>{
    if (queues) {
        const itemsToRefresh = [];
        (0, (/*@__PURE__*/$parcel$interopDefault($hvbu2)))(queueItemChanges).forEach(({ id: id, value: value })=>{
            const queue = (0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(queues, {
                id: id
            });
            if (queue && queue.starred !== value) {
                const isHiddenQueueStarred = queue.canBeHidden === true && value === true;
                editItemFavoriteCallback(id, value);
                if (isHiddenQueueStarred) itemsToRefresh.push(id);
            }
        });
        if (!(0, $1ybV0.ff)('jsm-queues-nav4-refresh-m2-dogfooding_rh43y')) {
            if (itemsToRefresh && itemsToRefresh.length > 0) refreshIssueCountForItemsCallback(itemsToRefresh);
        }
    }
};
const $80c4ec2b38f388a4$export$ddf44c597e03063d = (projectKey, category, queues, editItemFavoriteCallback, refreshIssueCountForItemsCallback)=>{
    const { items: items } = (0, $eUqFw.useContext)((0, $dQZ5c.FavoriteChangeContext));
    const queueItemChanges = items[0, $jrdvV.QUEUES_ITEM_TYPE];
    const previousChangesRef = (0, $eUqFw.useRef)({
        projectKey: projectKey,
        category: category,
        changedItems: undefined
    });
    const { current: previousChanges } = previousChangesRef;
    const hasPotentialChanges = previousChanges.projectKey !== projectKey || previousChanges.category !== category || previousChanges.changedItems !== queueItemChanges;
    if (hasPotentialChanges) {
        previousChangesRef.current = {
            projectKey: projectKey,
            category: category,
            changedItems: queueItemChanges
        };
        $80c4ec2b38f388a4$var$updateQueueUsingCallback(queues, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        queueItemChanges, editItemFavoriteCallback, refreshIssueCountForItemsCallback);
    }
};

});

parcelRegister("8IUzF", function(module, exports) {

$parcel$export(module.exports, "useIssueCountEnabledQueues", () => $c8e1f26724a28473$export$99b90062d7e53784);

var $WBLbN = parcelRequire("WBLbN");
const $c8e1f26724a28473$export$e324594224ef24da = {
    updateIssueCountEnabledQueues: (queues)=>({ setState: setState })=>{
            setState({
                queues: queues
            });
        }
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $c8e1f26724a28473$var$initialState = {
    queues: []
};
const $c8e1f26724a28473$var$Store = (0, $WBLbN.createStore)({
    name: 'jsm-queue-groups-issue-count-enabled-queues-store',
    initialState: $c8e1f26724a28473$var$initialState,
    actions: $c8e1f26724a28473$export$e324594224ef24da
});
const $c8e1f26724a28473$export$99b90062d7e53784 = (0, $WBLbN.createHook)($c8e1f26724a28473$var$Store, {
    selector: (state)=>state?.queues
});

});

parcelRegister("5oGu5", function(module, exports) {

$parcel$export(module.exports, "NavigationDetailsContainer", () => $0a42425d1b8bc1cd$export$29eca0c9cd8a428b);
$parcel$export(module.exports, "useSelectedNavLocation", () => $0a42425d1b8bc1cd$export$d2f02560e6f207a);

var $WBLbN = parcelRequire("WBLbN");

var $iKZpp = parcelRequire("iKZpp");
const $0a42425d1b8bc1cd$export$dfef0225549f683d = 50;
const $0a42425d1b8bc1cd$export$a0bac38ed2b058db = 2419200000; // 28 days in milliseconds
const $0a42425d1b8bc1cd$export$e324594224ef24da = {
    updateSelectedNavLocation: (queueId, selectedSection, selectedGroupId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const currentStateForQueueId = currentState[queueId] || {};
            const newState = {
                ...currentState,
                [queueId]: {
                    ...currentStateForQueueId,
                    selectedSection: selectedSection,
                    selectedGroupId: selectedGroupId,
                    latestUpdateTimestamp: Date.now()
                }
            };
            // setState is a merge operation - passing in an evicted state won't remove data for old queueIds
            setState(newState);
            // Save a evicted state to local storage to prevent unboounded growth.
            const evictedState = (0, $iKZpp.getEvictedState)(newState, $0a42425d1b8bc1cd$export$dfef0225549f683d, $0a42425d1b8bc1cd$export$a0bac38ed2b058db);
            (0, $iKZpp.setQueueGroupsNavStateInLocalStorage)(evictedState);
        }
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $0a42425d1b8bc1cd$var$initialState = {};
const $0a42425d1b8bc1cd$var$Store = (0, $WBLbN.createStore)({
    name: 'jsm-queue-groups-nav-location-store',
    initialState: $0a42425d1b8bc1cd$var$initialState,
    actions: $0a42425d1b8bc1cd$export$e324594224ef24da
});
const $0a42425d1b8bc1cd$export$29eca0c9cd8a428b = (0, $WBLbN.createContainer)($0a42425d1b8bc1cd$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            const stateFromStorage = (0, $iKZpp.getQueueGroupsNavStateFromLocalStorage)();
            if (stateFromStorage) setState(stateFromStorage);
        }
});
const $0a42425d1b8bc1cd$export$d2f02560e6f207a = (0, $WBLbN.createHook)($0a42425d1b8bc1cd$var$Store, {
    selector: (state, queueId)=>({
            section: state[queueId]?.selectedSection,
            groupId: state[queueId]?.selectedGroupId
        })
});

});

parcelRegister("koTTC", function(module, exports) {

$parcel$export(module.exports, "QueueListSection", () => $7fdb39dffcc941ef$export$f9e39ac255344f7b);
var $7fdb39dffcc941ef$export$f9e39ac255344f7b;
(function(QueueListSection) {
    QueueListSection[QueueListSection["STARRED"] = 0] = "STARRED";
    QueueListSection[QueueListSection["PRIORITY_GROUP"] = 1] = "PRIORITY_GROUP";
    QueueListSection[QueueListSection["ALL_QUEUES"] = 2] = "ALL_QUEUES";
})($7fdb39dffcc941ef$export$f9e39ac255344f7b || ($7fdb39dffcc941ef$export$f9e39ac255344f7b = {}));

});

parcelRegister("cfL67", function(module, exports) {

$parcel$export(module.exports, "AllQueuesSection", () => $735fc62247597a3e$export$3db49d1e2b7c929f);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $fiu69 = parcelRequire("fiu69");

var $9IsWp = parcelRequire("9IsWp");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $cf2Y4 = parcelRequire("cf2Y4");

var $bAQOb = parcelRequire("bAQOb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hTOEt = parcelRequire("hTOEt");

var $9a7bp = parcelRequire("9a7bp");

var $1L8BM = parcelRequire("1L8BM");

var $dkB9x = parcelRequire("dkB9x");
var $2vG9C = parcelRequire("2vG9C");
var $gniqE = parcelRequire("gniqE");
var $9758r = parcelRequire("9758r");

var $lB25E = parcelRequire("lB25E");

var $jjGQs = parcelRequire("jjGQs");

var $btmoM = parcelRequire("btmoM");

var $jtrqc = parcelRequire("jtrqc");

var $kCavd = parcelRequire("kCavd");

var $ak8vS = parcelRequire("ak8vS");

var $cgR4D = parcelRequire("cgR4D");

var $1LOQS = parcelRequire("1LOQS");
const $735fc62247597a3e$var$AllQueuesSectionNew = ({ projectKey: projectKey, practice: practice })=>{
    const queueCustomContext = (0, $hTOEt.useQueueCustomRouterContext)(projectKey);
    const [queueIdFromPath] = (0, $lB25E.usePathParam)('queueId');
    const [allQueues] = (0, $1L8BM.useCategorizedNavItems)('', projectKey, practice, queueCustomContext);
    const popoutConfig = (0, $jjGQs.usePopoutConfig)(projectKey, practice);
    const selectedQueue = (0, $eUqFw.useMemo)(()=>allQueues?.find((queue)=>queue.id === queueIdFromPath), [
        allQueues,
        queueIdFromPath
    ]);
    const isQueueSelected = (0, $btmoM.useIsQueueSelected)(selectedQueue, (0, $9a7bp.QueueListSection).ALL_QUEUES);
    const hasSelectedQueue = isQueueSelected && selectedQueue !== undefined;
    if (!allQueues || allQueues.length === 0) return null;
    if (popoutConfig.isPoppedOut) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cgR4D.AllQueuesPopOut), {
        projectKey: projectKey,
        practice: practice
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, hasSelectedQueue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCavd.QueueItem), {
        queue: selectedQueue,
        section: (0, $9a7bp.QueueListSection).ALL_QUEUES
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ak8vS.AllQueuesFlyout), {
        projectKey: projectKey,
        practice: practice
    }));
};
const $735fc62247597a3e$var$AllQueuesSectionLegacy = ({ projectKey: projectKey, practice: practice })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const queueCustomContext = (0, $hTOEt.useQueueCustomRouterContext)(projectKey);
    const [queueIdFromPath] = (0, $lB25E.usePathParam)('queueId');
    const [allQueues] = (0, $1L8BM.useCategorizedNavItems)('', projectKey, practice, queueCustomContext);
    const [filter, setFilter] = (0, $eUqFw.useState)('');
    const searchResultQueues = (0, $eUqFw.useMemo)(()=>allQueues?.filter((queue)=>queue.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase())) ?? [], [
        allQueues,
        filter
    ]);
    const selectedQueue = (0, $eUqFw.useMemo)(()=>allQueues?.find((queue)=>queue.id === queueIdFromPath), [
        allQueues,
        queueIdFromPath
    ]);
    const isQueueSelected = (0, $btmoM.useIsQueueSelected)(selectedQueue, (0, $9a7bp.QueueListSection).ALL_QUEUES);
    const SearchIconMemo = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9IsWp))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }), []);
    const handleChange = (0, $eUqFw.useCallback)((event)=>setFilter(event.currentTarget.value), []);
    if (!allQueues || allQueues.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isQueueSelected && selectedQueue !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCavd.QueueItem), {
        queue: selectedQueue,
        section: (0, $9a7bp.QueueListSection).ALL_QUEUES
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkB9x.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gniqE.FlyoutMenuItemTrigger), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fiu69))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        })
    }, formatMessage((0, $1LOQS.messages).viewAllQueues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2vG9C.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9758r.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, formatMessage((0, $1LOQS.messages).allQueues))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.050",
        xcss: $735fc62247597a3e$var$scrollBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        isCompact: true,
        value: filter,
        onChange: handleChange,
        "aria-label": formatMessage((0, $1LOQS.messages).searchYourQueue),
        placeholder: formatMessage((0, $1LOQS.messages).searchYourQueue),
        elemBeforeInput: SearchIconMemo
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, searchResultQueues.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jtrqc.QueueList), {
        queues: searchResultQueues,
        section: (0, $9a7bp.QueueListSection).ALL_QUEUES,
        isQueueListInFlyOut: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlock: "space.100",
        xcss: $735fc62247597a3e$var$noSearchResultsFoundStyles
    }, formatMessage((0, $1LOQS.messages).noSearchResultsFound)))))))));
};
const $735fc62247597a3e$export$3db49d1e2b7c929f = (0, $bAQOb.componentWithFF)('jsm-queues-nav4-refresh-m2-queues-pop-out-view_atq13', $735fc62247597a3e$var$AllQueuesSectionNew, $735fc62247597a3e$var$AllQueuesSectionLegacy);
const $735fc62247597a3e$var$noSearchResultsFoundStyles = (0, $1ZAYh.xcss)({
    fontStyle: 'italic'
});
const $735fc62247597a3e$var$scrollBoxStyles = (0, $1ZAYh.xcss)({
    maxHeight: '500px',
    width: '250px',
    overflow: 'auto',
    scrollbarGutter: 'stable'
});

});
parcelRegister("fiu69", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b38d718ca9f4aa1019c5485273ebd51>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b22fe259af223f59$var$_react = $b22fe259af223f59$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b22fe259af223f59$var$_UNSAFE_baseNew = $b22fe259af223f59$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $b22fe259af223f59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AlignLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b22fe259af223f59$var$AlignLeftIcon = (props)=>/*#__PURE__*/ $b22fe259af223f59$var$_react.default.createElement($b22fe259af223f59$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 2.75h14M1 13.25h7M1 8h14"/>`
    }, props));
$b22fe259af223f59$var$AlignLeftIcon.displayName = 'AlignLeftIcon';
var $b22fe259af223f59$var$_default = module.exports.default = $b22fe259af223f59$var$AlignLeftIcon;

});

parcelRegister("9a7bp", function(module, exports) {

$parcel$export(module.exports, "QueueListSection", () => $4cdc7b0c2c3e2ed3$export$f9e39ac255344f7b);
$parcel$export(module.exports, "NavigationCategoryContainer", () => $4cdc7b0c2c3e2ed3$export$ea600ea09fe6bbd);
$parcel$export(module.exports, "useSelectedGroupIdByCategory", () => $4cdc7b0c2c3e2ed3$export$9a1583f58d01a77c);
$parcel$export(module.exports, "useSelectedQueueSectionByCategory", () => $4cdc7b0c2c3e2ed3$export$aca7e7401e11cffa);

var $WBLbN = parcelRequire("WBLbN");

var $hfazF = parcelRequire("hfazF");
var $4cdc7b0c2c3e2ed3$export$f9e39ac255344f7b;
(function(QueueListSection) {
    QueueListSection[QueueListSection["STARRED"] = 0] = "STARRED";
    QueueListSection[QueueListSection["PRIORITY_GROUP"] = 1] = "PRIORITY_GROUP";
    QueueListSection[QueueListSection["ALL_QUEUES"] = 2] = "ALL_QUEUES";
})($4cdc7b0c2c3e2ed3$export$f9e39ac255344f7b || ($4cdc7b0c2c3e2ed3$export$f9e39ac255344f7b = {}));
const $4cdc7b0c2c3e2ed3$export$e324594224ef24da = {
    updateCurrentCategorySelectedGroup: (projectKey, practice, selectedGroupId)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                ...getState()[practice] ? {
                    [practice]: {
                        ...getState()[practice],
                        selectedGroupId: selectedGroupId
                    }
                } : {
                    [practice]: {
                        selectedGroupId: selectedGroupId
                    }
                }
            });
            (0, $hfazF.setQueueGroupsStateInLocalStorage)(projectKey, getState());
        },
    updatePathCategorySelectedQueueSection: (projectKey, practice, selectedQueueSection)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                ...getState()[practice] ? {
                    [practice]: {
                        ...getState()[practice],
                        selectedQueueSection: selectedQueueSection
                    }
                } : {
                    [practice]: {
                        selectedQueueSection: selectedQueueSection
                    }
                }
            });
            (0, $hfazF.setQueueGroupsStateInLocalStorage)(projectKey, getState());
        }
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $4cdc7b0c2c3e2ed3$var$initialState = {};
const $4cdc7b0c2c3e2ed3$var$Store = (0, $WBLbN.createStore)({
    name: 'jsm-navigation-categories-store',
    initialState: $4cdc7b0c2c3e2ed3$var$initialState,
    actions: $4cdc7b0c2c3e2ed3$export$e324594224ef24da
});
const $4cdc7b0c2c3e2ed3$export$ea600ea09fe6bbd = (0, $WBLbN.createContainer)($4cdc7b0c2c3e2ed3$var$Store, {
    onInit: ()=>({ setState: setState }, { projectKey: projectKey })=>{
            const stateFromStorage = (0, $hfazF.getQueueGroupsStateFromLocalStorage)(projectKey);
            if (stateFromStorage) setState(stateFromStorage);
        }
});
const $4cdc7b0c2c3e2ed3$export$6676162114f1489a = (0, $WBLbN.createHook)($4cdc7b0c2c3e2ed3$var$Store);
const $4cdc7b0c2c3e2ed3$export$9a1583f58d01a77c = (0, $WBLbN.createHook)($4cdc7b0c2c3e2ed3$var$Store, {
    selector: (state, category)=>state[category]?.selectedGroupId
});
const $4cdc7b0c2c3e2ed3$export$aca7e7401e11cffa = (0, $WBLbN.createHook)($4cdc7b0c2c3e2ed3$var$Store, {
    selector: (state, category)=>state[category]?.selectedQueueSection
});

});
parcelRegister("hfazF", function(module, exports) {

$parcel$export(module.exports, "getQueueGroupsStateFromLocalStorage", () => $a910959bd672997b$export$69c85d62a3ce3c00);
$parcel$export(module.exports, "setQueueGroupsStateInLocalStorage", () => $a910959bd672997b$export$7475d3423fcf9a14);

var $aZaPn = parcelRequire("aZaPn");
const $a910959bd672997b$export$72f6692c81a0e6b3 = 'jsm-queue-groups-state';
const $a910959bd672997b$export$d8474cff104280f3 = 'selected-group-id';
const $a910959bd672997b$export$69c85d62a3ce3c00 = (projectKey)=>{
    const localStorageProvider = (0, $aZaPn.createLocalStorageProvider)($a910959bd672997b$export$72f6692c81a0e6b3);
    try {
        const state = localStorageProvider.get(`${$a910959bd672997b$export$d8474cff104280f3}-${projectKey}`);
        if (state) return JSON.parse(state);
        return undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return undefined;
    }
};
const $a910959bd672997b$export$7475d3423fcf9a14 = (projectKey, value)=>{
    const localStorageProvider = (0, $aZaPn.createLocalStorageProvider)($a910959bd672997b$export$72f6692c81a0e6b3);
    try {
        localStorageProvider.set(`${$a910959bd672997b$export$d8474cff104280f3}-${projectKey}`, JSON.stringify(value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /* empty */ }
};

});


parcelRegister("dkB9x", function(module, exports) {

$parcel$export(module.exports, "FlyoutMenuItem", () => $3865853ec55bdc2a$export$34e3b4eaa687835);

var $eUqFw = parcelRequire("eUqFw");

var $2WwAS = parcelRequire("2WwAS");

var $6zWut = parcelRequire("6zWut");

var $74NH7 = parcelRequire("74NH7");
const $3865853ec55bdc2a$export$34e3b4eaa687835 = ({ children: children, id: id, isOpen: isOpenControlled, isDefaultOpen: isDefaultOpen = false, onOpenChange: onOpenChange })=>{
    const [isOpen, setIsOpen] = (0, $2WwAS.default)(isOpenControlled, ()=>isDefaultOpen);
    (0, $eUqFw.useEffect)(()=>{
        onOpenChange?.(isOpen);
    }, [
        isOpen,
        onOpenChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $74NH7.IsOpenContext).Provider, {
        value: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $74NH7.SetIsOpenContext).Provider, {
        value: setIsOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zWut.Popup), {
        id: id,
        isOpen: isOpen
    }, children)));
};

});
parcelRegister("6zWut", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $19d697df082e5c8a$export$129a32eedafa97c5);
$parcel$export(module.exports, "PopupTrigger", () => $19d697df082e5c8a$export$95d4acdbab2fc6ef);
$parcel$export(module.exports, "PopupContent", () => $19d697df082e5c8a$export$2a2c7ba12d3231e3);

var $eUqFw = parcelRequire("eUqFw");

var $8ynlC = parcelRequire("8ynlC");

var $5Q9wj = parcelRequire("5Q9wj");

var $ki32l = parcelRequire("ki32l");

var $knRXm = parcelRequire("knRXm");

var $iGymL = parcelRequire("iGymL");

var $8nlzU = parcelRequire("8nlzU");
var $6frYP = parcelRequire("6frYP");

var $gmZvv = parcelRequire("gmZvv");

var $lcnyw = parcelRequire("lcnyw");

var $glmoE = parcelRequire("glmoE");

var $5xOmF = parcelRequire("5xOmF");

var $59zSl = parcelRequire("59zSl");
const $19d697df082e5c8a$var$IsOpenContext = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const $19d697df082e5c8a$var$IdContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $19d697df082e5c8a$var$TriggerRefContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $19d697df082e5c8a$var$SetTriggerRefContext = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $5Q9wj.default));
const $19d697df082e5c8a$var$EnsureIsInsidePopupContext = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
// Used to ensure popup sub-components are used within a Popup
// and provide a useful error message if not.
const $19d697df082e5c8a$var$useEnsureIsInsidePopup = ()=>{
    const context = (0, $eUqFw.useContext)($19d697df082e5c8a$var$EnsureIsInsidePopupContext);
    (0, $8ynlC.default)(context, 'PopupTrigger and PopupContent components must be used within a Popup');
};
const $19d697df082e5c8a$export$129a32eedafa97c5 = ({ children: children, id: providedId, isOpen: isOpen = false })=>{
    const [triggerRef, setTriggerRef] = (0, $eUqFw.useState)(null);
    const generatedId = (0, $ki32l.useId)();
    const id = providedId || generatedId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($19d697df082e5c8a$var$EnsureIsInsidePopupContext.Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($19d697df082e5c8a$var$IdContext.Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($19d697df082e5c8a$var$TriggerRefContext.Provider, {
        value: triggerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($19d697df082e5c8a$var$SetTriggerRefContext.Provider, {
        value: setTriggerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($19d697df082e5c8a$var$IsOpenContext.Provider, {
        value: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nlzU.Manager), null, children))))));
};
const $19d697df082e5c8a$export$95d4acdbab2fc6ef = ({ children: children })=>{
    $19d697df082e5c8a$var$useEnsureIsInsidePopup();
    const isOpen = (0, $eUqFw.useContext)($19d697df082e5c8a$var$IsOpenContext);
    const id = (0, $eUqFw.useContext)($19d697df082e5c8a$var$IdContext);
    const setTriggerRef = (0, $eUqFw.useContext)($19d697df082e5c8a$var$SetTriggerRefContext);
    const getMergedTriggerRef = (0, $59zSl.useGetMemoizedMergedTriggerRef)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6frYP.Reference), null, ({ ref: ref })=>children({
            ref: getMergedTriggerRef(ref, setTriggerRef, isOpen),
            'aria-controls': id,
            'aria-expanded': isOpen,
            'aria-haspopup': true
        }));
};
const $19d697df082e5c8a$var$defaultLayer = (0, $lcnyw.layers).layer();
const $19d697df082e5c8a$export$2a2c7ba12d3231e3 = ({ xcss: xcss, appearance: inAppearance = 'default', children: children, boundary: boundary, offset: offset, strategy: strategy, onClose: onClose, testId: testId, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: popupComponent, autoFocus: autoFocus = true, zIndex: zIndex = $19d697df082e5c8a$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport })=>{
    $19d697df082e5c8a$var$useEnsureIsInsidePopup();
    const isOpen = (0, $eUqFw.useContext)($19d697df082e5c8a$var$IsOpenContext);
    const id = (0, $eUqFw.useContext)($19d697df082e5c8a$var$IdContext);
    const triggerRef = (0, $eUqFw.useContext)($19d697df082e5c8a$var$TriggerRefContext);
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $5xOmF.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    (0, $iGymL.useNotifyOpenLayerObserver)({
        isOpen: isOpen
    });
    if (!isOpen) return null;
    const popperWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $knRXm.UNSAFE_LAYERING), {
        isDisabled: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $glmoE.default), {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss,
        appearance: appearance,
        content: children,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: popupComponent,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldFitContainer: shouldFitContainer,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent,
        shouldDisableFocusLock: shouldDisableFocusLock,
        triggerRef: triggerRef,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }));
    if (shouldRenderToParent) return popperWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gmZvv.default), {
        zIndex: zIndex
    }, popperWrapper);
};

});


parcelRegister("2vG9C", function(module, exports) {

$parcel$export(module.exports, "FlyoutMenuItemContent", () => $0ac1679c26d60999$export$2ca9a13c57a8839a);
/* flyout-menu-item-content.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $6zWut = parcelRequire("6zWut");

var $asbEV = parcelRequire("asbEV");

var $74NH7 = parcelRequire("74NH7");
const $0ac1679c26d60999$var$flyoutMenuItemContentStyles = {
    root: "_1yt4u2gc _14b51178"
};
/**
 * Additional wrapper element to lock the side nav flyout when the popup content is rendered.
 */ const $0ac1679c26d60999$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children }, forwardedRef)=>{
    (0, $asbEV.useSideNavFlyoutLock)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: forwardedRef
    }, children);
});
const $0ac1679c26d60999$export$2ca9a13c57a8839a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, containerTestId: containerTestId, onClose: onClose }, forwardedRef)=>{
    const setIsOpen = (0, $eUqFw.useContext)((0, $74NH7.SetIsOpenContext));
    const handleClose = (0, $eUqFw.useCallback)(()=>{
        onClose?.();
        setIsOpen(false);
    }, [
        setIsOpen,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zWut.PopupContent), {
        appearance: "UNSAFE_modal-below-sm",
        onClose: handleClose,
        placement: "right-start",
        shouldFitViewport: true,
        testId: containerTestId,
        xcss: $0ac1679c26d60999$var$flyoutMenuItemContentStyles.root
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0ac1679c26d60999$var$ContentWrapper, {
            ref: forwardedRef
        }, children));
});

});
parcelRegister("asbEV", function(module, exports) {

$parcel$export(module.exports, "useSideNavFlyoutLock", () => $53b6035c7f110c6b$export$27b43feeb6e0e516);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $fgdRB = parcelRequire("fgdRB");
const $53b6035c7f110c6b$export$27b43feeb6e0e516 = ()=>{
    const setFlyoutLock = (0, $eUqFw.useContext)((0, $fgdRB.SetFlyoutLockCount));
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $XHGTv.fg)('platform_design_system_team_layering_observer')) // This feature flag moves the flyout lock logic to Popup, so this hook should be a no-op.
        return;
        // This if statement is to prevent errors in test environments where window.matchMedia is not defined,
        // so consumers don't need to explicitly mock it in their tests.
        if (typeof window?.matchMedia !== 'function') return;
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setFlyoutLock((current)=>current + 1);
        return ()=>{
            if (matches) setFlyoutLock((current)=>current - 1);
        };
    }, [
        setFlyoutLock
    ]);
};

});


parcelRegister("gniqE", function(module, exports) {

$parcel$export(module.exports, "FlyoutMenuItemTrigger", () => $ade54ef30481f70b$export$9f59f399fe37b6ca);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $fCmfi = parcelRequire("fCmfi");

var $6zWut = parcelRequire("6zWut");

var $b5IAe = parcelRequire("b5IAe");

var $bP7nx = parcelRequire("bP7nx");

var $jzazL = parcelRequire("jzazL");
const $ade54ef30481f70b$export$9f59f399fe37b6ca = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, iconBefore: iconBefore, onClick: onClick, isDisabled: isDisabled, interactionName: interactionName }, forwardedRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jzazL.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zWut.PopupTrigger), null, ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bP7nx.MenuItemBase), {
            ref: (0, $1lQG9.default)([
                ref,
                forwardedRef
            ]),
            elemBefore: iconBefore,
            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                paddingInline: "space.075"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fCmfi))), {
                label: "",
                color: "var(--ds-icon, #44546F)"
            })),
            onClick: onClick,
            ariaControls: ariaControls,
            ariaExpanded: ariaExpanded,
            ariaHasPopup: ariaHasPopup,
            isDisabled: isDisabled,
            interactionName: interactionName
        }, children))));

});

parcelRegister("jjGQs", function(module, exports) {

$parcel$export(module.exports, "usePopoutConfig", () => $6ce4e8c9681daa99$export$2cbd7df9320f5286);

var $eUqFw = parcelRequire("eUqFw");

var $hTOEt = parcelRequire("hTOEt");

var $5oIh2 = parcelRequire("5oIh2");

var $1L8BM = parcelRequire("1L8BM");

var $lB25E = parcelRequire("lB25E");

var $jo4Ct = parcelRequire("jo4Ct");

var $koTTC = parcelRequire("koTTC");

var $jO9z1 = parcelRequire("jO9z1");
const $6ce4e8c9681daa99$var$getPopoutConfig = (isPoppedOut, queueSection)=>({
        isPoppedOut: isPoppedOut,
        highestAvailableSection: isPoppedOut ? queueSection : undefined
    });
const $6ce4e8c9681daa99$export$2cbd7df9320f5286 = (projectKey, practice)=>{
    const [{ location: location }] = (0, $lB25E.useRouter)();
    const pathname = location.pathname;
    const queueCustomContext = (0, $hTOEt.useQueueCustomRouterContext)(projectKey);
    const [allQueues] = (0, $1L8BM.useCategorizedNavItems)('', projectKey, practice, queueCustomContext);
    const [starredQueues] = (0, $1L8BM.useFavouriteNavItems)('', projectKey, practice, queueCustomContext);
    const [isPoppedOut] = (0, $jo4Ct.usePoppedOutState)((0, $jo4Ct.getCategoryStateKey)(projectKey, practice));
    const [queueIdFromPath] = (0, $lB25E.usePathParam)('queueId');
    const [groups] = (0, $5oIh2.useCategorizedGroupsNavItems)(projectKey, practice, queueCustomContext);
    const isCategorisedViewQueueUrl = (0, $jO9z1.isValidCategorisedViewQueueUrl)(projectKey, practice, queueIdFromPath, pathname);
    const queueFoundInPractice = allQueues?.some((queue)=>queue.id === queueIdFromPath);
    return (0, $eUqFw.useMemo)(()=>{
        // First, determine if the popout is active according to the criteria below
        //  - The popout must be in the popped out state (i.e. the user has clicked the popout button)
        //  - The current URL must be showing a valid view queue page
        //  - The current queue must be part of the practice
        if (!isPoppedOut || !isCategorisedViewQueueUrl || !queueFoundInPractice) return $6ce4e8c9681daa99$var$getPopoutConfig(false);
        // Next, if the popout is active, determine the highest available queue section available in this popout
        const hasNonEmptyPriorityGroups = groups?.some((group)=>group.queues.length > 0);
        const hasStarredQueues = starredQueues && starredQueues.length > 0;
        if (hasStarredQueues) return $6ce4e8c9681daa99$var$getPopoutConfig(true, (0, $koTTC.QueueListSection).STARRED);
        if (hasNonEmptyPriorityGroups) return $6ce4e8c9681daa99$var$getPopoutConfig(true, (0, $koTTC.QueueListSection).PRIORITY_GROUP);
        return $6ce4e8c9681daa99$var$getPopoutConfig(true, (0, $koTTC.QueueListSection).ALL_QUEUES);
    }, [
        isPoppedOut,
        isCategorisedViewQueueUrl,
        queueFoundInPractice,
        groups,
        starredQueues
    ]);
};

});
parcelRegister("jO9z1", function(module, exports) {

$parcel$export(module.exports, "isValidViewQueueUrl", () => $811659d34ae90bfe$export$b1a2a8e908746b71);
$parcel$export(module.exports, "getQueuesUrl", () => $811659d34ae90bfe$export$96cc9136710988d8);
$parcel$export(module.exports, "isValidQueuesUrl", () => $811659d34ae90bfe$export$a13ce3a24252ba88);
$parcel$export(module.exports, "isValidCategorisedViewQueueUrl", () => $811659d34ae90bfe$export$329289338cdb3da1);
$parcel$export(module.exports, "getCategorisedQueuesUrl", () => $811659d34ae90bfe$export$714ec44b3d657788);
$parcel$export(module.exports, "isValidCategorisedQueuesUrl", () => $811659d34ae90bfe$export$6d24a4cae21a7dbd);
$parcel$export(module.exports, "useHighestPriorityQueueUrl", () => $811659d34ae90bfe$export$e82fb154e65954b9);

var $2bMHt = parcelRequire("2bMHt");

var $hTOEt = parcelRequire("hTOEt");

var $1L8BM = parcelRequire("1L8BM");

var $fDE9L = parcelRequire("fDE9L");

var $jo4Ct = parcelRequire("jo4Ct");

var $btmoM = parcelRequire("btmoM");
const $811659d34ae90bfe$var$getStrippedPathname = (pathname)=>{
    // strip url params and trailing slashes if they exist
    const pathnameWithoutParams = pathname.split('?')[0];
    const pathnameWithoutTrailingSlash = pathnameWithoutParams.endsWith('/') ? pathnameWithoutParams.slice(0, -1) : pathnameWithoutParams;
    return pathnameWithoutTrailingSlash;
};
const $811659d34ae90bfe$export$b1a2a8e908746b71 = (projectKey, queueId, pathname)=>{
    if (!queueId) return false;
    const currentPath = $811659d34ae90bfe$var$getStrippedPathname(pathname);
    const constructedPath = `${$811659d34ae90bfe$export$96cc9136710988d8(projectKey)}/custom/${queueId}`;
    return currentPath.endsWith(constructedPath);
};
const $811659d34ae90bfe$export$a13ce3a24252ba88 = (projectKey, pathname)=>pathname.includes($811659d34ae90bfe$export$96cc9136710988d8(projectKey));
const $811659d34ae90bfe$export$329289338cdb3da1 = (projectKey, category, queueId, pathname)=>{
    if (!queueId) return false;
    if (!category) return $811659d34ae90bfe$export$b1a2a8e908746b71(projectKey, queueId, pathname);
    const currentPath = $811659d34ae90bfe$var$getStrippedPathname(pathname);
    const constructedPath = `${$811659d34ae90bfe$export$714ec44b3d657788(projectKey, category)}/custom/${queueId}`;
    return currentPath.endsWith(constructedPath);
};
const $811659d34ae90bfe$export$6d24a4cae21a7dbd = (projectKey, category, pathname)=>{
    if (!category) return $811659d34ae90bfe$export$a13ce3a24252ba88(projectKey, pathname);
    return pathname.includes($811659d34ae90bfe$export$714ec44b3d657788(projectKey, category));
};
const $811659d34ae90bfe$export$714ec44b3d657788 = (projectKey, category)=>{
    if (!category) return $811659d34ae90bfe$export$96cc9136710988d8(projectKey);
    return `${$811659d34ae90bfe$export$ebd25648349e3334(projectKey)}/${(0, $2bMHt.QUEUE_ROUTES)[category]}`;
};
const $811659d34ae90bfe$export$96cc9136710988d8 = (projectKey)=>`${$811659d34ae90bfe$export$ebd25648349e3334(projectKey)}/queues`;
const $811659d34ae90bfe$export$ebd25648349e3334 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}`;
const $811659d34ae90bfe$export$4f6fb26cc9e97438 = (projectKey, category)=>{
    // Need to get all data before returning to avoid hook errors
    const categoryStateKey = (0, $jo4Ct.getCategoryStateKey)(projectKey, category);
    const [lastVisitedQueueId] = (0, $jo4Ct.useLastVisitedQueueId)(categoryStateKey);
    const queueCustomContext = (0, $hTOEt.useQueueCustomRouterContext)(projectKey);
    const [starredQueues] = (0, $1L8BM.useFavouriteNavItems)('', projectKey, category, queueCustomContext);
    const [allQueues] = (0, $1L8BM.useCategorizedNavItems)('', projectKey, category, queueCustomContext);
    const [filteredGroups] = (0, $btmoM.useFilteredCategorizedQueueGroups)(projectKey, (0, $fDE9L.toItsmPractice)(category));
    // Always use the last visited queue if it exists
    if (lastVisitedQueueId) return lastVisitedQueueId;
    // Next best option is to return a starred queue
    if (starredQueues?.length) return starredQueues[0].id;
    // Next best option is to return the first queue in the first group
    if (filteredGroups?.length && filteredGroups[0].queues?.length) return filteredGroups[0].queues[0].id;
    // Final option is to return the first queue in the all queues list
    if (allQueues?.length) return allQueues[0].id;
    return undefined;
};
const $811659d34ae90bfe$export$e82fb154e65954b9 = (projectKey, category)=>{
    const queueId = $811659d34ae90bfe$export$4f6fb26cc9e97438(projectKey, category);
    if (!queueId) return '';
    return `${$811659d34ae90bfe$export$714ec44b3d657788(projectKey, category)}/custom/${queueId}`;
};

});
parcelRegister("btmoM", function(module, exports) {

$parcel$export(module.exports, "useIsQueueSelected", () => $b34a474f13bad50b$export$5405660a1c6b0f63);
$parcel$export(module.exports, "useFilteredCategorizedQueueGroups", () => $b34a474f13bad50b$export$7689b1dc3aabf437);

var $eUqFw = parcelRequire("eUqFw");

var $hTOEt = parcelRequire("hTOEt");

var $9a7bp = parcelRequire("9a7bp");

var $5oIh2 = parcelRequire("5oIh2");

var $f1lMr = parcelRequire("f1lMr");

var $lB25E = parcelRequire("lB25E");

var $5oGu5 = parcelRequire("5oGu5");
const $b34a474f13bad50b$export$b70190c48788c872 = (queue, priorityGroups, lastSelectedSection, currentSection, selectedGroupId)=>{
    if (currentSection === lastSelectedSection) return currentSection;
    const isStarred = queue.starred;
    const selectedPriorityGroup = priorityGroups.find((group)=>group.id === selectedGroupId);
    const isQueueInSelectedGroup = selectedPriorityGroup?.queues.some((queueInGroup)=>queueInGroup.toString(10) === queue.id);
    if (lastSelectedSection === (0, $9a7bp.QueueListSection).STARRED && !queue.starred) return isQueueInSelectedGroup ? (0, $9a7bp.QueueListSection).PRIORITY_GROUP : (0, $9a7bp.QueueListSection).ALL_QUEUES;
    if (lastSelectedSection === (0, $9a7bp.QueueListSection).PRIORITY_GROUP && !isQueueInSelectedGroup) return isStarred ? (0, $9a7bp.QueueListSection).STARRED : (0, $9a7bp.QueueListSection).ALL_QUEUES;
    if (lastSelectedSection === undefined) {
        if (isStarred) return (0, $9a7bp.QueueListSection).STARRED;
        if (isQueueInSelectedGroup) return (0, $9a7bp.QueueListSection).PRIORITY_GROUP;
        return (0, $9a7bp.QueueListSection).ALL_QUEUES;
    }
    return lastSelectedSection;
};
const $b34a474f13bad50b$export$9bdd97120118ee26 = (queue, priorityGroups, section, lastSelectedSection, lastSelectedGroupId, priorityGroupId)=>{
    const firstPriorityGroupWithQueue = priorityGroups.find((group)=>group.queues.includes(Number(queue.id)))?.id;
    const queueMissingValidHistory = lastSelectedSection === undefined || lastSelectedSection === (0, $9a7bp.QueueListSection).PRIORITY_GROUP && !lastSelectedGroupId;
    const isQueueSelectedBasedOnPriority = {
        [(0, $9a7bp.QueueListSection).STARRED]: queue.starred && !priorityGroupId,
        [(0, $9a7bp.QueueListSection).PRIORITY_GROUP]: !queue.starred && priorityGroupId === firstPriorityGroupWithQueue,
        [(0, $9a7bp.QueueListSection).ALL_QUEUES]: !queue.starred && !firstPriorityGroupWithQueue
    };
    const isQueueSelectedBasedOnHistory = {
        [(0, $9a7bp.QueueListSection).STARRED]: true,
        [(0, $9a7bp.QueueListSection).PRIORITY_GROUP]: lastSelectedGroupId === priorityGroupId,
        [(0, $9a7bp.QueueListSection).ALL_QUEUES]: true
    };
    if (queueMissingValidHistory) return isQueueSelectedBasedOnPriority[section];
    if (section === lastSelectedSection) return isQueueSelectedBasedOnHistory[lastSelectedSection];
    return false;
};
const $b34a474f13bad50b$export$5405660a1c6b0f63 = (queue, section, priorityGroupId)=>{
    const [queueIdFromPath] = (0, $lB25E.usePathParam)('queueId');
    const [selectedNavLocation] = (0, $5oGu5.useSelectedNavLocation)(queueIdFromPath || '');
    const [priorityGroups] = (0, $5oIh2.usePriorityGroups)(queue?.category || (0, $f1lMr.NO_CATEGORY));
    return (0, $eUqFw.useMemo)(()=>queue !== undefined ? $b34a474f13bad50b$export$9bdd97120118ee26(queue, priorityGroups, section, selectedNavLocation.section, selectedNavLocation.groupId, priorityGroupId) : false, [
        priorityGroupId,
        priorityGroups,
        queue,
        section,
        selectedNavLocation.groupId,
        selectedNavLocation.section
    ]);
};
const $b34a474f13bad50b$export$7689b1dc3aabf437 = (projectKey, category)=>{
    const queueCustomContext = (0, $hTOEt.useQueueCustomRouterContext)(projectKey);
    const [groups, isLoading, groupError, queueError] = (0, $5oIh2.useCategorizedGroupsNavItems)(projectKey, category, queueCustomContext);
    const filteredGroups = (0, $eUqFw.useMemo)(()=>groups.filter((group)=>group.queues.length > 0), [
        groups
    ]);
    return [
        filteredGroups,
        isLoading,
        groupError,
        queueError
    ];
};

});



parcelRegister("jtrqc", function(module, exports) {

$parcel$export(module.exports, "QueueList", () => $d87219f6deb673fa$export$6b278a59f65cf1eb);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $kCavd = parcelRequire("kCavd");
const $d87219f6deb673fa$export$6b278a59f65cf1eb = ({ QueueItem: QueueItem = (0, $kCavd.QueueItem), queues: queues, section: section, projectKey: projectKey, priorityGroupId: priorityGroupId, isQueueListInFlyOut: isQueueListInFlyOut = false })=>{
    if ((0, $1ybV0.ff)('jsm-queues-nav4-refresh-m2-dogfooding_rh43y')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, queues.map((queue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(QueueItem, {
            key: queue.id,
            queue: queue,
            section: section,
            projectKey: projectKey,
            priorityGroupId: priorityGroupId,
            isQueueInFlyOut: isQueueListInFlyOut
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, queues.map((queue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(QueueItem, {
            key: queue.id,
            queue: queue,
            section: section
        })));
};

});
parcelRegister("kCavd", function(module, exports) {

$parcel$export(module.exports, "QueueItem", () => $1360ae691bbbc1ca$export$1b63de307530e1bc);

var $eUqFw = parcelRequire("eUqFw");

var $lzTt0 = parcelRequire("lzTt0");

var $7kP6w = parcelRequire("7kP6w");

var $9nkwJ = parcelRequire("9nkwJ");

var $gaxd9 = parcelRequire("gaxd9");

var $2eG9N = parcelRequire("2eG9N");

var $bAQOb = parcelRequire("bAQOb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8K9kM = parcelRequire("8K9kM");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $9a7bp = parcelRequire("9a7bp");

var $f1lMr = parcelRequire("f1lMr");

var $fDE9L = parcelRequire("fDE9L");

var $4xHig = parcelRequire("4xHig");

var $g6ngP = parcelRequire("g6ngP");

var $lB25E = parcelRequire("lB25E");

var $jO9z1 = parcelRequire("jO9z1");

var $5oGu5 = parcelRequire("5oGu5");

var $jo4Ct = parcelRequire("jo4Ct");

var $btmoM = parcelRequire("btmoM");

var $ftE4T = parcelRequire("ftE4T");

var $l8dro = parcelRequire("l8dro");

var $9NT6W = parcelRequire("9NT6W");
const $1360ae691bbbc1ca$var$MAX_BADGE_COUNT = 999;
const $1360ae691bbbc1ca$export$d243ff4c233d53f3 = (pathCategorySelectedSection, currentQueueInSection)=>(currentLocation, itemLocation)=>{
        const pathNameMatches = currentLocation.pathname === itemLocation.pathname || currentLocation.pathname.substring(0, currentLocation.pathname.lastIndexOf('/')) === itemLocation.pathname;
        const isSectionMatched = pathCategorySelectedSection === currentQueueInSection;
        return pathNameMatches && isSectionMatched;
    };
const $1360ae691bbbc1ca$var$QueueItemLegacy = ({ Badge: Badge = (0, $9nkwJ.default), queue: queue, section: section, ...rest })=>{
    const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
    const [queueId] = (0, $lB25E.usePathParam)('queueId');
    const [practice] = (0, $lB25E.usePathParam)('practiceType');
    const pathCategory = (0, $fDE9L.toItsmPractice)(practice);
    const href = `/jira/servicedesk${queue.url}`;
    const isSelected = route != null && queueId === queue.id && location.pathname.startsWith(href);
    const queueCategory = queue.category || (0, $f1lMr.NO_CATEGORY);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const locale = (0, $4xHig.useLocale)();
    const getFormattedRelativeLastRefreshedTime = (0, $eUqFw.useCallback)(()=>{
        if (queue.badgeCount === undefined) return formatMessage((0, $l8dro.tooltipMessages).loadingIssueCountTooltip);
        const lastRefreshedTime = queue.lastRefreshedTime === 0 || queue.lastRefreshedTime === undefined ? Date.now() : queue.lastRefreshedTime;
        return formatMessage((0, $l8dro.tooltipMessages).showLastRefreshedTimeTooltip, {
            lastUpdate: (0, $8K9kM.formatDistanceStrictWithLocale)(lastRefreshedTime, Date.now(), locale, true)
        });
    }, [
        formatMessage,
        locale,
        queue.badgeCount,
        queue.lastRefreshedTime
    ]);
    const shouldShowBadge = (0, $eUqFw.useCallback)(()=>isSelected || queue.starred || !queue.canBeHidden, [
        isSelected,
        queue.canBeHidden,
        queue.starred
    ]);
    const getDisplayBadgeValue = ()=>{
        const shouldDisplayCountBadge = queueId && pathCategory === queueCategory;
        if (shouldDisplayCountBadge) return (0, (/*@__PURE__*/$parcel$interopDefault($lzTt0)))(queue.badgeCount) ? (0, (/*@__PURE__*/$parcel$interopDefault($7kP6w)))(queue.badgeCount) : '-';
        return null;
    };
    const issueCountBadge = shouldShowBadge() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: ()=>getFormattedRelativeLastRefreshedTime()
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-is-queue-issue-count-badge": true,
            ...tooltipProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Badge, {
            max: $1360ae691bbbc1ca$var$MAX_BADGE_COUNT
        }, getDisplayBadgeValue())));
    const starButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9NT6W.StarButton), {
        isStarred: queue.starred,
        queueId: queue.id
    }));
    const shouldShowIssueCountError = (0, $eUqFw.useCallback)(()=>queue.shouldSkipIssueCountRefresh && (queue.starred || !queue.canBeHidden), [
        queue.canBeHidden,
        queue.shouldSkipIssueCountRefresh,
        queue.starred
    ]);
    const issueCountIcon = shouldShowIssueCountError() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ftE4T.default), {
        queue: queue
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, issueCountBadge);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6ngP.MenuLinkItem), {
        analytics: {
            itemId: `queue-${queue.id}`
        },
        href: href,
        isSelected: isSelected,
        elemAfter: issueCountIcon,
        actionsOnHover: starButton,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gaxd9))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        "aria-label": queue.name,
        ...rest
    }, queue.name);
};
const $1360ae691bbbc1ca$var$QueueItemNew = ({ Badge: Badge = (0, $9nkwJ.default), queue: queue, section: section, projectKey: projectKey, priorityGroupId: priorityGroupId, isQueueInFlyOut: isQueueInFlyOut = false, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const locale = (0, $4xHig.useLocale)();
    const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
    const pathname = location.pathname;
    const [queueIdFromPath] = (0, $lB25E.usePathParam)('queueId');
    const [practiceFromPath] = (0, $lB25E.usePathParam)('practiceType');
    const [projectKeyFromPath] = (0, $lB25E.usePathParam)('projectKey');
    const categoryFromPath = (0, $fDE9L.toItsmPractice)(practiceFromPath);
    const categoryFromQueue = queue.category || (0, $f1lMr.NO_CATEGORY);
    const [selectedNavLocation, { updateSelectedNavLocation: updateSelectedNavLocation }] = (0, $5oGu5.useSelectedNavLocation)(queueIdFromPath || '');
    const isViewQueueUrl = (0, $jO9z1.isValidCategorisedViewQueueUrl)(projectKey || '', categoryFromQueue, queueIdFromPath, pathname);
    // Is queue selected logic
    const href = `/jira/servicedesk${queue.url}`;
    const queueMatchesRoute = route != null && queueIdFromPath === queue.id && location.pathname.startsWith(href);
    const isQueueSelected = (0, $btmoM.useIsQueueSelected)(queue, section, priorityGroupId) && queueMatchesRoute;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isPoppedOut] = (0, $jo4Ct.usePoppedOutState)(`${projectKey}-${categoryFromQueue}`);
    (0, $eUqFw.useEffect)(()=>{
        if (isQueueSelected) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'queueItemSelected rendered', {
            id: queue.id,
            name: queue.name,
            category: categoryFromQueue,
            section: section,
            priorityGroupId: priorityGroupId,
            isQueueInFlyOut: isQueueInFlyOut,
            isQueueInPopOutPanel: isPoppedOut
        });
    }, [
        categoryFromQueue,
        createAnalyticsEvent,
        isQueueInFlyOut,
        isQueueSelected,
        isPoppedOut,
        priorityGroupId,
        queue.category,
        queue.id,
        queue.name,
        section
    ]);
    // Internal methods
    const getFormattedRelativeLastRefreshedTime = (0, $eUqFw.useCallback)(()=>{
        if (queue.badgeCount === undefined) return formatMessage((0, $l8dro.tooltipMessages).loadingIssueCountTooltip);
        const lastRefreshedTime = queue.lastRefreshedTime || Date.now();
        return formatMessage((0, $l8dro.tooltipMessages).showLastRefreshedTimeTooltip, {
            lastUpdate: (0, $8K9kM.formatDistanceStrictWithLocale)(lastRefreshedTime, Date.now(), locale, true)
        });
    }, [
        formatMessage,
        locale,
        queue.badgeCount,
        queue.lastRefreshedTime
    ]);
    const onMenuItemClick = ()=>{
        updateSelectedNavLocation(queue.id, section, priorityGroupId);
    };
    // Should queue show issue count badge
    const inSelectedProject = projectKey === projectKeyFromPath;
    const inSelectedCategory = categoryFromQueue === categoryFromPath;
    const isValidLocation = isViewQueueUrl && inSelectedProject && inSelectedCategory;
    const shouldShowBadgeInSection = {
        [(0, $9a7bp.QueueListSection).STARRED]: true,
        [(0, $9a7bp.QueueListSection).PRIORITY_GROUP]: selectedNavLocation.groupId === priorityGroupId,
        [(0, $9a7bp.QueueListSection).ALL_QUEUES]: isQueueSelected
    };
    const shouldShowBadge = isValidLocation && shouldShowBadgeInSection[section];
    const badgeDisplayValue = shouldShowBadge && ((0, (/*@__PURE__*/$parcel$interopDefault($lzTt0)))(queue.badgeCount) ? (0, (/*@__PURE__*/$parcel$interopDefault($7kP6w)))(queue.badgeCount) : '-');
    const issueCountBadge = shouldShowBadge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: ()=>getFormattedRelativeLastRefreshedTime()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-is-queue-issue-count-badge": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Badge, {
        max: $1360ae691bbbc1ca$var$MAX_BADGE_COUNT
    }, badgeDisplayValue)));
    const starButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9NT6W.StarButton), {
        isStarred: queue.starred,
        queueId: queue.id
    });
    // issue count errors
    const shouldShowIssueCountError = queue.shouldSkipIssueCountRefresh && shouldShowBadge;
    const issueCountIcon = shouldShowIssueCountError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ftE4T.default), {
        queue: queue
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, issueCountBadge);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6ngP.MenuLinkItem), {
        analytics: {
            itemId: `queue-${queue.id}`
        },
        href: href,
        isSelected: isQueueSelected && !isQueueInFlyOut,
        onClick: onMenuItemClick,
        elemAfter: issueCountIcon,
        actionsOnHover: starButton,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gaxd9))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }),
        "aria-label": queue.name,
        ...rest
    }, queue.name);
};
const $1360ae691bbbc1ca$export$1b63de307530e1bc = (0, $bAQOb.componentWithFF)('jsm-queues-nav4-refresh-m2-dogfooding_rh43y', $1360ae691bbbc1ca$var$QueueItemNew, $1360ae691bbbc1ca$var$QueueItemLegacy);

});
parcelRegister("9nkwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d99ab26ca06411$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $aG4Mw = parcelRequire("aG4Mw");
function $00d99ab26ca06411$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $00d99ab26ca06411$var$boxStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $00d99ab26ca06411$var$neutral300 = '#DDDEE1';
const $00d99ab26ca06411$var$red300 = '#FD9891';
const $00d99ab26ca06411$var$blue300 = '#8FB8F6';
const $00d99ab26ca06411$var$neutral1000 = '#292A2E';
const $00d99ab26ca06411$var$styles = {
    root: {
        name: "85bcg3",
        styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
    },
    added: {
        name: "4x7cmh",
        styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
    },
    default: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$neutral300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    important: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$red300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primary: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$blue300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primaryInverted: {
        name: "1425qmy",
        styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
    },
    removed: {
        name: "10hiq01",
        styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
    }
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $00d99ab26ca06411$var$Badge = /*#__PURE__*/ (0, $eUqFw.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        css: [
            $00d99ab26ca06411$var$styles.root,
            $00d99ab26ca06411$var$styles[appearance]
        ],
        style: {
            background: style?.backgroundColor,
            color: style?.color
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        testId: testId,
        as: "span",
        backgroundColor: $00d99ab26ca06411$var$backgroundColors[appearance],
        xcss: $00d99ab26ca06411$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $00d99ab26ca06411$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
});
$00d99ab26ca06411$var$Badge.displayName = 'Badge';
var $00d99ab26ca06411$export$2e2bcd8739ae039 = $00d99ab26ca06411$var$Badge;
const $00d99ab26ca06411$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $00d99ab26ca06411$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("aG4Mw", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $a8e5bba3d913fce3$export$7c4d25c0c3217d8c);
function $a8e5bba3d913fce3$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $a8e5bba3d913fce3$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $a8e5bba3d913fce3$var$getSafeValue(value);
    const safeMax = $a8e5bba3d913fce3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("gaxd9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::507ba0a7522eee51c688b0df4f02c52b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc57578ad3be8c9a$var$_react = $bc57578ad3be8c9a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $bc57578ad3be8c9a$var$_UNSAFE_baseNew = $bc57578ad3be8c9a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $bc57578ad3be8c9a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc57578ad3be8c9a$var$PagesIcon = (props)=>/*#__PURE__*/ $bc57578ad3be8c9a$var$_react.default.createElement($bc57578ad3be8c9a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10 4.75H4m4.5 3H4m-1 4.5h8c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25Z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$bc57578ad3be8c9a$var$PagesIcon.displayName = 'PagesIcon';
var $bc57578ad3be8c9a$var$_default = module.exports.default = $bc57578ad3be8c9a$var$PagesIcon;

});

parcelRegister("ftE4T", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9101fe0cf8541e8$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $blejQ = parcelRequire("blejQ");

var $23NQ5 = parcelRequire("23NQ5");

var $29yDk = parcelRequire("29yDk");


var $5JgJ2 = parcelRequire("5JgJ2");

var $cPEpP = parcelRequire("cPEpP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bNe1g = parcelRequire("bNe1g");

var $1L8BM = parcelRequire("1L8BM");

var $c7H0g = parcelRequire("c7H0g");

var $ldC4D = parcelRequire("ldC4D");
const $e9101fe0cf8541e8$export$9facd8d31b938a25 = ()=>{
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const projectContext = (0, $bNe1g.useProjectContext)();
    const isProjectAdmin = isAdmin || projectContext?.data?.isProjectAdmin || false;
    return {
        isProjectAdmin: isProjectAdmin
    };
};
const $e9101fe0cf8541e8$var$learnMoreUrl = 'https://community.atlassian.com/t5/Jira-Service-Management-articles/Managing-queues-at-scale-in-Jira-Service-Management/ba-p/2102021';
const $e9101fe0cf8541e8$export$ca8e59510a286136 = ({ queue: queue })=>{
    const [showDialog, setShowDialog] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: project } = (0, $cPEpP.useProject)();
    const [, , , methods] = (0, $1L8BM.useCategorizedNavItems)('', project ? project.key : '', queue.category);
    const onReload = (0, $eUqFw.useCallback)((e)=>{
        // stopping the propagration and default behavior, otherwise the queue menu item will be clicked
        e.stopPropagation();
        e.preventDefault();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'ReloadBadQueueButton');
        methods.enableRefreshForQueues([
            queue.id
        ]);
        methods.refreshIssueCountForItems([
            queue.id
        ]);
    }, [
        methods,
        queue.id,
        createAnalyticsEvent
    ]);
    const onEditQueue = (0, $eUqFw.useCallback)((e)=>{
        // stopping the propagration and default behavior, otherwise the queue menu item will be clicked
        e.stopPropagation();
        e.preventDefault();
        window.open(`${queue.url}/edit`, '_blank');
        setShowDialog(false);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'EditQueueFromIssueCountErrorDialog'
        }), {
            meta: {
                id: 'ViewEditQueueFromIssueCountErrorDialog',
                packageName: 'jiraNavigationAppsSidebarServicedesk',
                teamName: 'jsd-shield'
            },
            canBeHidden: queue.canBeHidden,
            isStarred: queue.starred
        });
    }, [
        setShowDialog,
        queue.url,
        queue.canBeHidden,
        queue.starred,
        createAnalyticsEvent
    ]);
    const onLearnMoreClick = (0, $eUqFw.useCallback)((e)=>{
        // stopping the propagration and default behavior, otherwise the queue menu item will be clicked
        e.stopPropagation();
        e.preventDefault();
        setShowDialog(false);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'BadQueueLearnMoreButton');
        window.open($e9101fe0cf8541e8$var$learnMoreUrl, '_blank');
    }, [
        createAnalyticsEvent
    ]);
    const learnMoreButton = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            target: "_blank",
            onClick: onLearnMoreClick
        }, formatMessage((0, $ldC4D.messages).learnMoreButtonLabel)), [
        formatMessage,
        onLearnMoreClick
    ]);
    const reloadButton = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            onClick: onReload
        }, formatMessage((0, $ldC4D.messages).reloadButtonLabel)), [
        onReload,
        formatMessage
    ]);
    const editQueueButton = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            onClick: onEditQueue,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                label: "",
                size: "small"
            })
        }, formatMessage((0, $ldC4D.messages).editQueueButtonLabel)), [
        onEditQueue,
        formatMessage
    ]);
    const { isProjectAdmin: isProjectAdmin } = $e9101fe0cf8541e8$export$9facd8d31b938a25();
    const userActionButton = isProjectAdmin ? editQueueButton : reloadButton;
    const agentMessage = queue.starred ? (0, $ldC4D.messages).issueCountErrorMessageAgentStarred : (0, $ldC4D.messages).issueCountErrorMessageAgentNotStarred;
    const contentMessage = isProjectAdmin ? (0, $ldC4D.messages).issueCountErrorMessageAdmin : agentMessage;
    const content = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9101fe0cf8541e8$var$InlineDialogContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9101fe0cf8541e8$var$InlineDialogHeader, null, formatMessage((0, $ldC4D.messages).issueCountErrorMessageHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage(contentMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9101fe0cf8541e8$var$InlineDialogButtons, null, learnMoreButton, userActionButton)), [
        contentMessage,
        formatMessage,
        learnMoreButton,
        userActionButton
    ]);
    const onIssueCountErrorButtonClick = (0, $eUqFw.useCallback)(// @ts-expect-error - TS2315 - Type 'Mouse Event' is not generic.
    (e)=>{
        e.stopPropagation(); // prevent underlying queue button from being pressed
        e.preventDefault();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'IssueCountErrorButton');
        setShowDialog(!showDialog);
    }, [
        showDialog,
        setShowDialog,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
        onClose: ()=>{
            setShowDialog(false);
        },
        content: content,
        isOpen: showDialog
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9101fe0cf8541e8$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "none",
        onClick: onIssueCountErrorButtonClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($blejQ))), {
            label: "",
            size: "small",
            primaryColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N200})`
        })
    })));
};
var $e9101fe0cf8541e8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $e9101fe0cf8541e8$export$ca8e59510a286136;
const $e9101fe0cf8541e8$var$InlineDialogContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _zg8l4jg8 _k48p1nn1 _p12f3xl8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e9101fe0cf8541e8$var$InlineDialogHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p8n31",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e9101fe0cf8541e8$var$InlineDialogButtons = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0xmi2 _19pku2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e9101fe0cf8541e8$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _14hp1tcg _jq8g1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e9101fe0cf8541e8$export$7ed12d2a5241e393 = {
    InlineDialogContainer: $e9101fe0cf8541e8$var$InlineDialogContainer,
    InlineDialogHeader: $e9101fe0cf8541e8$var$InlineDialogHeader,
    InlineDialogButtons: $e9101fe0cf8541e8$var$InlineDialogButtons,
    ButtonWrapper: $e9101fe0cf8541e8$var$ButtonWrapper
};

});
parcelRegister("blejQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $841cc35b0ae95138$var$_react = $841cc35b0ae95138$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $841cc35b0ae95138$var$_warning = $841cc35b0ae95138$var$_interopRequireDefault((parcelRequire("ewJfY")));
function $841cc35b0ae95138$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $841cc35b0ae95138$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $841cc35b0ae95138$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
    }, props, {
        newIcon: $841cc35b0ae95138$var$_warning.default
    }));
$841cc35b0ae95138$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $841cc35b0ae95138$var$_default = module.exports.default = $841cc35b0ae95138$var$EditorWarningIcon;

});

parcelRegister("ldC4D", function(module, exports) {

$parcel$export(module.exports, "messages", () => $424844a392dfdf07$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $424844a392dfdf07$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issueCountErrorMessageHeader: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-header",
        "defaultMessage": "We can't show the number of issues"
    },
    issueCountErrorMessageAdmin: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-admin",
        "defaultMessage": "There seems to be a problem with the queue's filters. Edit the queue and try again."
    },
    issueCountErrorMessageAgentStarred: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-agent-starred",
        "defaultMessage": "There seems to be a problem with the queue's filters. Contact your admins to edit this queue or remove it from Starred."
    },
    issueCountErrorMessageAgentNotStarred: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-agent-not-starred",
        "defaultMessage": "There seems to be a problem with the queue's filters. Contact your admins to edit this queue."
    },
    learnMoreButtonLabel: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.learn-more-button-label",
        "defaultMessage": "Learn more"
    },
    reloadButtonLabel: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.reload-button-label",
        "defaultMessage": "Reload"
    },
    editQueueButtonLabel: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.edit-queue-button-label",
        "defaultMessage": "Edit queue"
    }
});

});


parcelRegister("l8dro", function(module, exports) {

$parcel$export(module.exports, "tooltipMessages", () => $a7980fc7f488dc85$export$4713da6aa4410043);

var $90IgZ = parcelRequire("90IgZ");
const $a7980fc7f488dc85$export$4713da6aa4410043 = (0, $90IgZ.defineMessages)({
    loadingIssueCountTooltip: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.loading-issue-count-tooltip",
        "defaultMessage": "Loading the number of issues"
    },
    showLastRefreshedTimeTooltip: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.show-last-refreshed-time-tooltip",
        "defaultMessage": "Last updated {lastUpdate}"
    }
});

});

parcelRegister("9NT6W", function(module, exports) {

$parcel$export(module.exports, "StarButton", () => $e35918bd97d0183f$export$b4b5678234ca6d4d);

var $eUqFw = parcelRequire("eUqFw");

var $ktkCe = parcelRequire("ktkCe");

var $jrdvV = parcelRequire("jrdvV");

var $dQZ5c = parcelRequire("dQZ5c");
const $e35918bd97d0183f$export$b4b5678234ca6d4d = ({ isStarred: isStarred, queueId: queueId })=>{
    const { changeFavorite: changeFavorite } = (0, $eUqFw.useContext)((0, $dQZ5c.FavoriteChangeContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ktkCe.default), {
        isFavorite: isStarred,
        pending: false,
        isSmall: true,
        onClick: (analyticsEvent)=>{
            changeFavorite({
                id: queueId,
                value: !isStarred,
                type: (0, $jrdvV.QUEUES_ITEM_TYPE)
            }, analyticsEvent);
        }
    });
};

});



parcelRegister("ak8vS", function(module, exports) {

$parcel$export(module.exports, "AllQueuesFlyout", () => $f6b730e40ba6ce8b$export$6e323880808677df);

var $eUqFw = parcelRequire("eUqFw");

var $fiu69 = parcelRequire("fiu69");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hTOEt = parcelRequire("hTOEt");

var $1L8BM = parcelRequire("1L8BM");

var $dkB9x = parcelRequire("dkB9x");
var $2vG9C = parcelRequire("2vG9C");
var $gniqE = parcelRequire("gniqE");

var $k0MMw = parcelRequire("k0MMw");

var $1LOQS = parcelRequire("1LOQS");
const $f6b730e40ba6ce8b$export$6e323880808677df = ({ projectKey: projectKey, practice: practice })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const queueCustomContext = (0, $hTOEt.useQueueCustomRouterContext)(projectKey);
    const [allQueues] = (0, $1L8BM.useCategorizedNavItems)('', projectKey, practice, queueCustomContext);
    if (!allQueues || allQueues.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkB9x.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gniqE.FlyoutMenuItemTrigger), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fiu69))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        })
    }, formatMessage((0, $1LOQS.messages).viewAllQueues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2vG9C.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k0MMw.AllQueues), {
        projectKey: projectKey,
        practice: practice,
        isFlyOut: true
    })));
};

});
parcelRegister("k0MMw", function(module, exports) {

$parcel$export(module.exports, "AllQueues", () => $3c847210245d5c96$export$4c4b4d372f994d4e);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $9IsWp = parcelRequire("9IsWp");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hTOEt = parcelRequire("hTOEt");

var $9a7bp = parcelRequire("9a7bp");

var $1L8BM = parcelRequire("1L8BM");

var $9758r = parcelRequire("9758r");

var $jtrqc = parcelRequire("jtrqc");

var $1LOQS = parcelRequire("1LOQS");
const $3c847210245d5c96$export$4c4b4d372f994d4e = ({ projectKey: projectKey, practice: practice, isFlyOut: isFlyOut = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const queueCustomContext = (0, $hTOEt.useQueueCustomRouterContext)(projectKey);
    const [allQueues] = (0, $1L8BM.useCategorizedNavItems)('', projectKey, practice, queueCustomContext);
    const [filter, setFilter] = (0, $eUqFw.useState)('');
    const searchResultQueues = (0, $eUqFw.useMemo)(()=>allQueues?.filter((queue)=>queue.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase())) ?? [], [
        allQueues,
        filter
    ]);
    const SearchIconMemo = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9IsWp))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleChange = (0, $eUqFw.useCallback)((event)=>{
        setFilter(event.currentTarget.value);
    }, []);
    const onStopQueueSearch = (0, $eUqFw.useCallback)(()=>{
        const getViewAllQueueSearchEvent = createAnalyticsEvent({
            action: 'blurred',
            actionSubject: 'jsmViewAllQueueFlyoutSearch'
        });
        (0, $jMP2a.fireUIAnalytics)(getViewAllQueueSearchEvent, 'stopViewAllQueueSearch', {
            projectKey: projectKey,
            practice: practice
        });
    }, [
        createAnalyticsEvent,
        projectKey,
        practice
    ]);
    if (!allQueues || allQueues.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9758r.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.050"
    }, isFlyOut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, formatMessage((0, $1LOQS.messages).allQueues))), isFlyOut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3c847210245d5c96$var$filterContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        isCompact: true,
        value: filter,
        onChange: handleChange,
        "aria-label": formatMessage((0, $1LOQS.messages).searchYourQueue),
        placeholder: formatMessage((0, $1LOQS.messages).searchYourQueue),
        elemBeforeInput: SearchIconMemo,
        onBlur: onStopQueueSearch
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.050",
        xcss: $3c847210245d5c96$var$scrollBoxStyles
    }, searchResultQueues.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jtrqc.QueueList), {
        queues: searchResultQueues,
        section: (0, $9a7bp.QueueListSection).ALL_QUEUES,
        isQueueListInFlyOut: isFlyOut
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlock: "space.100",
        xcss: $3c847210245d5c96$var$noSearchResultsFoundStyles
    }, formatMessage((0, $1LOQS.messages).noSearchResultsFound)))));
};
const $3c847210245d5c96$var$noSearchResultsFoundStyles = (0, $1ZAYh.xcss)({
    fontStyle: 'italic'
});
const $3c847210245d5c96$var$scrollBoxStyles = (0, $1ZAYh.xcss)({
    maxHeight: '500px',
    overflow: 'auto',
    scrollbarGutter: 'stable',
    padding: 'space.050'
});
const $3c847210245d5c96$var$filterContainerStyles = (0, $1ZAYh.xcss)({
    minHeight: 'space.400',
    paddingRight: 'space.100'
});

});
parcelRegister("1LOQS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $cae14c7712a0c26e$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $cae14c7712a0c26e$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    allQueues: {
        "id": "servicedesk-queues-nav4.common.practice-queues.all-queues-section.all-queues",
        "defaultMessage": "All queues"
    },
    viewAllQueues: {
        "id": "servicedesk-queues-nav4.common.practice-queues.all-queues-section.view-all-queues",
        "defaultMessage": "View all queues"
    },
    searchYourQueue: {
        "id": "servicedesk-queues-nav4.common.practice-queues.all-queues-section.search-your-queue",
        "defaultMessage": "Search your queue"
    },
    noSearchResultsFound: {
        "id": "servicedesk-queues-nav4.common.practice-queues.all-queues-section.no-search-results-found",
        "defaultMessage": "No search results found"
    }
});

});



parcelRegister("cgR4D", function(module, exports) {

$parcel$export(module.exports, "AllQueuesPopOut", () => $5054903ec4250cc1$export$c9909bdf149a8c80);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hTOEt = parcelRequire("hTOEt");

var $1L8BM = parcelRequire("1L8BM");

var $fUrao = parcelRequire("fUrao");
var $2sdKK = parcelRequire("2sdKK");
var $4cwcz = parcelRequire("4cwcz");

var $lB25E = parcelRequire("lB25E");

var $5oGu5 = parcelRequire("5oGu5");

var $koTTC = parcelRequire("koTTC");

var $k0MMw = parcelRequire("k0MMw");

var $1LOQS = parcelRequire("1LOQS");
const $5054903ec4250cc1$export$c9909bdf149a8c80 = ({ projectKey: projectKey, practice: practice })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const queueCustomContext = (0, $hTOEt.useQueueCustomRouterContext)(projectKey);
    const [allQueues] = (0, $1L8BM.useCategorizedNavItems)('', projectKey, practice, queueCustomContext);
    const [queueIdFromPath] = (0, $lB25E.usePathParam)('queueId');
    const [selectedNavLocation] = (0, $5oGu5.useSelectedNavLocation)(queueIdFromPath || '');
    if (!allQueues || allQueues.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fUrao.ExpandableMenuItem), {
        isDefaultExpanded: selectedNavLocation.section === (0, $koTTC.QueueListSection).ALL_QUEUES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cwcz.ExpandableMenuItemTrigger), null, formatMessage((0, $1LOQS.messages).allQueues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2sdKK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k0MMw.AllQueues), {
        projectKey: projectKey,
        practice: practice
    })));
};

});


parcelRegister("6lOal", function(module, exports) {

$parcel$export(module.exports, "AlwaysVisibleSection", () => $4ce5ca0ca41ec12c$export$4175e3bad498b65b);

var $eUqFw = parcelRequire("eUqFw");

var $exb0h = parcelRequire("exb0h");

var $bKxX9 = parcelRequire("bKxX9");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $hTOEt = parcelRequire("hTOEt");

var $9a7bp = parcelRequire("9a7bp");

var $1L8BM = parcelRequire("1L8BM");

var $9758r = parcelRequire("9758r");
var $ghvAB = parcelRequire("ghvAB");

var $jtrqc = parcelRequire("jtrqc");

var $br2GR = parcelRequire("br2GR");
const $4ce5ca0ca41ec12c$export$4175e3bad498b65b = ({ projectKey: projectKey, practice: practice })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // TODO: This baseUrl has a dependency on @atlassian/jira-servicedesk-queues-categorized-store
    // The above items need to be updated prior to complete baseUrl removal from this file.
    const baseUrl = '';
    const queueCustomContext = (0, $hTOEt.useQueueCustomRouterContext)(projectKey);
    const queuesDefault = (0, $1L8BM.useAlwaysVisibleNavItems)(baseUrl, projectKey, practice, queueCustomContext);
    const [queues] = queuesDefault;
    const archive = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
            analytics: {
                itemId: 'archives'
            },
            selectedOn: [
                (0, $exb0h.ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY)
            ],
            href: "/jira/issues/archive",
            "data-testid": "servicedesk-queues-nav4.common.ui.practice-queues.always-visible-section.archives-link"
        }, formatMessage((0, $br2GR.messages).archive));
    if (!queues || queues.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9758r.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ghvAB.MenuSectionHeading), null, formatMessage((0, $br2GR.messages).teamPriority)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jtrqc.QueueList), {
        queues: queues,
        section: (0, $9a7bp.QueueListSection).PRIORITY_GROUP
    }), (0, $bKxX9.ff)('issue-unarchival_wdpb9') && archive());
};

});
parcelRegister("ghvAB", function(module, exports) {

$parcel$export(module.exports, "MenuSectionHeading", () => $21dcb71713da1503$export$5d3acdbf9237a364);
/* menu-section-heading.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7bHjs = parcelRequire("7bHjs");
const $21dcb71713da1503$var$styles = {
    root: "_syaz131l _11c816g6 _1rjcu2gc _bozg12x7"
};
const $21dcb71713da1503$export$5d3acdbf9237a364 = ({ children: children })=>{
    const id = (0, $7bHjs.useMenuSectionContext)();
    return /*#__PURE__*/ $eUqFw.createElement("h2", {
        id: `${id}-heading`,
        className: (0, $7JEyt.default)([
            $21dcb71713da1503$var$styles.root
        ])
    }, children);
};

});

parcelRegister("br2GR", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bfcbc83dbbecf44c$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $bfcbc83dbbecf44c$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    teamPriority: {
        "id": "servicedesk-queues-nav4.common.practice-queues.always-visible-section.team-priority",
        "defaultMessage": "Team priority"
    },
    archive: {
        "id": "servicedesk-queues-nav4.common.practice-queues.always-visible-section.archive",
        "defaultMessage": "Archive"
    }
});

});


parcelRegister("4beXo", function(module, exports) {

$parcel$export(module.exports, "HiddenSection", () => $edac9fa1770cfccb$export$8fb99fb4efab05ce);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $keguF = parcelRequire("keguF");

var $hTOEt = parcelRequire("hTOEt");

var $9a7bp = parcelRequire("9a7bp");

var $1L8BM = parcelRequire("1L8BM");

var $fUrao = parcelRequire("fUrao");
var $2sdKK = parcelRequire("2sdKK");
var $4cwcz = parcelRequire("4cwcz");

var $jtrqc = parcelRequire("jtrqc");

var $1f1tS = parcelRequire("1f1tS");
const $edac9fa1770cfccb$export$8fb99fb4efab05ce = ({ practice: practice, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // TODO This baseUrl has a dependency o@atlassian/jira-servicedesk-queues-categorized-store
    // The above items need to be updated prior to complete baseUrl removal from this file.
    const baseUrl = '';
    const queueCustomContext = (0, $hTOEt.useQueueCustomRouterContext)(projectKey);
    const [hiddenQueues] = (0, $1L8BM.useCanBeHiddenNavItems)(baseUrl, projectKey, practice, queueCustomContext);
    const queueId = (0, $keguF.getMatchedRoute)()?.match.params.queueId;
    const isHiddenQueueSelected = hiddenQueues != null && hiddenQueues.find((queue)=>queue.id === queueId) != null;
    if (hiddenQueues && hiddenQueues.length !== 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fUrao.ExpandableMenuItem), {
        isDefaultExpanded: isHiddenQueueSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cwcz.ExpandableMenuItemTrigger), null, formatMessage((0, $1f1tS.messages).others)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2sdKK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jtrqc.QueueList), {
        queues: hiddenQueues,
        section: (0, $9a7bp.QueueListSection).ALL_QUEUES
    })));
    return null;
};

});
parcelRegister("1f1tS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c5d84d5da2daa535$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c5d84d5da2daa535$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    others: {
        "id": "servicedesk-queues-nav4.common.practice-queues.hidden-section.others",
        "defaultMessage": "Other"
    }
});

});


parcelRegister("xHJp2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f72ee13faa27d38f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $f72ee13faa27d38f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    fetchQueuesError: {
        "id": "servicedesk-queues-nav4.common.practice-queues.fetch-queues-error",
        "defaultMessage": "We're unable to load queues data, <button>try again.</button>"
    }
});

});

parcelRegister("l2FFM", function(module, exports) {

$parcel$export(module.exports, "QueueGroupsSection", () => $3ad4c125b84034f0$export$95e0028b61fb2a1a);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");

var $guiFP = parcelRequire("guiFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6EHLX = parcelRequire("6EHLX");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $9a7bp = parcelRequire("9a7bp");

var $fUrao = parcelRequire("fUrao");
var $2sdKK = parcelRequire("2sdKK");
var $4cwcz = parcelRequire("4cwcz");
var $9758r = parcelRequire("9758r");

var $lB25E = parcelRequire("lB25E");

var $5oGu5 = parcelRequire("5oGu5");

var $btmoM = parcelRequire("btmoM");

var $jtrqc = parcelRequire("jtrqc");

var $fTviz = parcelRequire("fTviz");
const $3ad4c125b84034f0$export$95e0028b61fb2a1a = ({ projectKey: projectKey, currentCategory: currentCategory, onGroupDataRefresh: onGroupDataRefresh })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [filteredGroups, isLoading, error] = (0, $btmoM.useFilteredCategorizedQueueGroups)(projectKey, currentCategory);
    const [queueIdFromPath] = (0, $lB25E.usePathParam)('queueId');
    const [selectedNavLocation] = (0, $5oGu5.useSelectedNavLocation)(queueIdFromPath || '');
    const isInvalidSelectedNavLocation = queueIdFromPath && selectedNavLocation.section === undefined;
    const ExpandableGroups = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, filteredGroups.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fUrao.ExpandableMenuItem), {
                key: group.group.id,
                isDefaultExpanded: selectedNavLocation?.groupId === group.group.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cwcz.ExpandableMenuItemTrigger), null, group.group.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2sdKK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jtrqc.QueueList), {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                queues: group.queues,
                section: (0, $9a7bp.QueueListSection).PRIORITY_GROUP,
                projectKey: projectKey,
                priorityGroupId: group.group.id
            }))))), [
        filteredGroups,
        projectKey,
        selectedNavLocation?.groupId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) (0, $guiFP.default)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            meta: {
                id: 'jsmQueueGroupsError',
                packageName: 'jiraServicedeskQueuesNav4',
                teamName: 'jsd-shield'
            }
        });
        else if (filteredGroups && !isLoading && filteredGroups.length > 0) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueGroups rendered', {
            projectKey: projectKey,
            groupSize: filteredGroups.length,
            category: currentCategory,
            packageName: 'jiraServicedeskQueuesNav4',
            teamName: 'jsd-shield'
        });
    }, [
        createAnalyticsEvent,
        currentCategory,
        error,
        filteredGroups,
        isLoading,
        projectKey
    ]);
    // Render loading state
    if (isLoading || isInvalidSelectedNavLocation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6EHLX.SkeletonNavMenuItems), {
        count: 2
    });
    // Render error state
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9758r.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        padding: "space.100"
    }, formatMessage((0, $fTviz.messages).fetchPriorityGroupError, {
        button: (buttonLabel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                spacing: "none",
                appearance: "link",
                onClick: onGroupDataRefresh
            }, buttonLabel)
    })));
    return ExpandableGroups;
};

});
parcelRegister("6EHLX", function(module, exports) {

$parcel$export(module.exports, "SkeletonNavMenuItems", () => $a103aa4bb117c12a$export$c3a3a246584433d7);

var $eUqFw = parcelRequire("eUqFw");

var $6aCS7 = parcelRequire("6aCS7");

var $aVkzK = parcelRequire("aVkzK");

var $jzazL = parcelRequire("jzazL");
const $a103aa4bb117c12a$export$c3a3a246584433d7 = ({ count: count = 5 })=>(0, (/*@__PURE__*/$parcel$interopDefault($6aCS7)))(0, count).map((index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jzazL.MenuListItem), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
            isShimmering: true
        })));

});
parcelRegister("6aCS7", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $47e1d465ca3ee8c1$var$func = $jFIrw('range', (parcelRequire("iqjbc")));

$47e1d465ca3ee8c1$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $47e1d465ca3ee8c1$var$func;

});


parcelRegister("fTviz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9c105028579eff93$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9c105028579eff93$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    fetchPriorityGroupError: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-groups.fetch-priority-group-error",
        "defaultMessage": "We're unable to load data in the priority group, <button>try again.</button>"
    }
});

});


parcelRegister("aeDO2", function(module, exports) {

$parcel$export(module.exports, "StarredSection", () => $a6ab298849aa434c$export$e5f8d87968088916);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hTOEt = parcelRequire("hTOEt");

var $9a7bp = parcelRequire("9a7bp");

var $1L8BM = parcelRequire("1L8BM");

var $fUrao = parcelRequire("fUrao");
var $2sdKK = parcelRequire("2sdKK");
var $4cwcz = parcelRequire("4cwcz");
var $9758r = parcelRequire("9758r");
var $ghvAB = parcelRequire("ghvAB");

var $lB25E = parcelRequire("lB25E");

var $jjGQs = parcelRequire("jjGQs");

var $5oGu5 = parcelRequire("5oGu5");

var $jtrqc = parcelRequire("jtrqc");

var $dCxEe = parcelRequire("dCxEe");
const $a6ab298849aa434c$export$e5f8d87968088916 = ({ practice: practice, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const queueCustomContext = (0, $hTOEt.useQueueCustomRouterContext)(projectKey);
    const popoutConfig = (0, $jjGQs.usePopoutConfig)(projectKey, practice);
    const [queues] = (0, $1L8BM.useFavouriteNavItems)('', projectKey, practice, queueCustomContext);
    const [queueIdFromPath] = (0, $lB25E.usePathParam)('queueId');
    const [selectedNavLocation] = (0, $5oGu5.useSelectedNavLocation)(queueIdFromPath || '');
    if (!queues || queues.length === 0) return null;
    if ((0, $1ybV0.ff)('jsm-queues-nav4-refresh-m2-queues-pop-out-view_atq13') && popoutConfig.isPoppedOut) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fUrao.ExpandableMenuItem), {
        isDefaultExpanded: selectedNavLocation.section === (0, $9a7bp.QueueListSection).STARRED
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cwcz.ExpandableMenuItemTrigger), null, formatMessage((0, $dCxEe.messages).starredHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2sdKK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jtrqc.QueueList), {
        queues: queues,
        section: (0, $9a7bp.QueueListSection).STARRED,
        projectKey: projectKey
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9758r.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ghvAB.MenuSectionHeading), null, formatMessage((0, $dCxEe.messages).starredHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jtrqc.QueueList), {
        queues: queues,
        section: (0, $9a7bp.QueueListSection).STARRED,
        projectKey: projectKey
    }));
};

});
parcelRegister("dCxEe", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3ff7f1a9ee9d94b2$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $3ff7f1a9ee9d94b2$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    starredHeader: {
        "id": "servicedesk-queues-nav4.common.practice-queues.starred-section.starred-header",
        "defaultMessage": "Starred"
    }
});

});



parcelRegister("7kuQk", function(module, exports) {

$parcel$export(module.exports, "default", () => $685627be846a54e9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $685627be846a54e9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    spotlightHeading: {
        "id": "servicedesk-queues-popout-panel-nav4.spotlight-heading",
        "defaultMessage": "Work on queues your way"
    },
    spotlightMessage: {
        "id": "servicedesk-queues-popout-panel-nav4.spotlight-message",
        "defaultMessage": "Choose to work on queues from your main navigation, or pop out queues to keep focused."
    },
    spotlightDismissButtonLabel: {
        "id": "servicedesk-queues-popout-panel-nav4.spotlight-dismiss-button-label",
        "defaultMessage": "OK"
    }
});

});


parcelRegister("p1pRy", function(module, exports) {

$parcel$export(module.exports, "BoardPromoSpotlight", () => $df178cae998a7762$export$106c1938e1a88514);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $27cI3 = parcelRequire("27cI3");
const $df178cae998a7762$var$BoardPromoSpotlightWithDelay = ()=>{
    const [shouldShowBoardPromoSpotlight, setShouldShowBoardPromoSpotlight] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setShouldShowBoardPromoSpotlight(true);
        }, 2000);
        return ()=>clearTimeout(timeoutId);
    }, []);
    return shouldShowBoardPromoSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27cI3.default), null);
};
const $df178cae998a7762$export$106c1938e1a88514 = ()=>{
    const emptyFallback = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "jira-servicedesk-queues-board-promotion-spotlight",
        packageName: "jiraServicedeskQueuesAgentView",
        teamName: "jsd-shield",
        fallback: emptyFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df178cae998a7762$var$BoardPromoSpotlightWithDelay, null));
};

});
parcelRegister("27cI3", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b9ac66b35d05d54$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $3i6VQ = parcelRequire("3i6VQ");

var $8WkKY = parcelRequire("8WkKY");
const $2b9ac66b35d05d54$var$mapStateToProps = (state)=>({
        isAdmin: (0, $3i6VQ.getAppProps)(state).isAdmin || (0, $3i6VQ.getAppProps)(state).isJiraAdmin,
        projectKey: (0, $3i6VQ.getAppProps)(state).projectKey
    });
var $2b9ac66b35d05d54$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($2b9ac66b35d05d54$var$mapStateToProps, {})((0, $8WkKY.BoardPromoSpotlightView));

});
parcelRegister("8WkKY", function(module, exports) {

$parcel$export(module.exports, "BoardPromoSpotlightView", () => $b9da84c42a24b64e$export$2b6106a2ccad4bf5);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $9WJJx = parcelRequire("9WJJx");

var $lcnyw = parcelRequire("lcnyw");

var $5ge6s = parcelRequire("5ge6s");

var $eI5EY = parcelRequire("eI5EY");

var $bpLfw = parcelRequire("bpLfw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $51Ia6 = parcelRequire("51Ia6");

var $bKFaV = parcelRequire("bKFaV");

var $lB25E = parcelRequire("lB25E");

var $jUeCh = parcelRequire("jUeCh");

var $9BNw0 = parcelRequire("9BNw0");

var $iGytm = parcelRequire("iGytm");
const $b9da84c42a24b64e$var$QUEUES_ADMIN_MESSAGE_ID = 'jira-jsm-boards-promotion-admin';
const $b9da84c42a24b64e$var$QUEUES_AGENT_MESSAGE_ID = 'jira-jsm-boards-promotion-agent';
const $b9da84c42a24b64e$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $b9da84c42a24b64e$var$BoardSpotlightShowDecider = ({ stop: stop, isAdmin: isAdmin, projectKey: projectKey, renderSpotlightCard: renderSpotlightCard })=>{
    const { shouldRenderBoardPromotion: shouldRenderBoardPromotion } = (0, $9BNw0.useBoardPromotion)(isAdmin, projectKey);
    return shouldRenderBoardPromotion ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ge6s.default), {
        messageId: isAdmin ? $b9da84c42a24b64e$var$QUEUES_ADMIN_MESSAGE_ID : $b9da84c42a24b64e$var$QUEUES_AGENT_MESSAGE_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b9da84c42a24b64e$export$83d026e3dd5706d, {
        stop: stop
    }, renderSpotlightCard)) : null;
};
const $b9da84c42a24b64e$export$2b6106a2ccad4bf5 = ({ isAdmin: isAdmin, projectKey: projectKey })=>{
    const [showSpotlight, setShowSpotlight] = (0, $eUqFw.useState)(true);
    const { push: push } = (0, $lB25E.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ data: pageContextData }] = (0, $51Ia6.usePageContext)();
    const { projectId: projectId, projectType: projectType } = pageContextData?.projectContext || {};
    const renderSpotlightCard = (stop)=>{
        const onDismissOnboarding = ()=>{
            stop?.();
            setShowSpotlight(false);
        };
        const handleEnableBoard = ()=>{
            if (projectKey) {
                const enableBoardsUrl = `/jira/servicedesk/projects/${projectKey}/settings/itsm-features?queues-board-promotion=true`;
                push(enableBoardsUrl);
                onDismissOnboarding();
            }
        };
        const handleLearnMore = ()=>{
            onDismissOnboarding();
            window.open('https://support.atlassian.com/jira-service-management-cloud/docs/manage-your-work-using-a-board/', '_blank', 'noreferrer');
        };
        const renderNudge = ()=>{
            const SpotlightRef = (0, $bKFaV.createOnboardingSpotlight)({
                actions: [
                    isAdmin ? {
                        onClick: ()=>{
                            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'boardAdminActivationSpotlightDismiss', {
                                projectId: projectId,
                                projectType: projectType
                            });
                            onDismissOnboarding();
                        },
                        content: formatMessage((0, $iGytm.default).dismiss),
                        appearance: 'subtle'
                    } : {
                        onClick: ()=>{
                            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'boardAgentActivationSpotlightLearnMore', {
                                projectId: projectId,
                                projectType: projectType
                            });
                            handleLearnMore();
                        },
                        content: formatMessage((0, $iGytm.default).learnMore),
                        appearance: 'subtle'
                    },
                    isAdmin ? {
                        onClick: ()=>{
                            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'boardAdminActivationSpotlightActivate', {
                                projectId: projectId,
                                projectType: projectType
                            });
                            handleEnableBoard();
                        },
                        content: formatMessage((0, $iGytm.default).enable),
                        appearance: 'primary'
                    } : {
                        onClick: ()=>{
                            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'boardAgentActivationSpotlightOk', {
                                projectId: projectId,
                                projectType: projectType
                            });
                            onDismissOnboarding();
                        },
                        content: formatMessage((0, $iGytm.default).ok),
                        appearance: 'primary'
                    }
                ],
                contentMessage: isAdmin ? formatMessage((0, $iGytm.default).adminDescription) : formatMessage((0, $iGytm.default).agentDescription),
                image: (0, $eI5EY.fg)('jsm_queues_consolidate_jfe_assets') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bpLfw.default), {
                    alt: "",
                    width: "320"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($jUeCh))),
                    alt: "",
                    width: "320"
                }),
                headingMessage: formatMessage((0, $iGytm.default).heading)
            });
            // eslint-disable-next-line react/no-unstable-nested-components
            return /*#__PURE__*/ (0, $eUqFw.forwardRef)((_, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    "aria-label": "promotion",
                    ref: ref
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SpotlightRef, null)));
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b9da84c42a24b64e$var$ModalWrapperStyles, {
            "aria-label": "promotion"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
            sourceName: `board${isAdmin ? 'Admin' : 'Agent'}ActivationSpotlight`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9WJJx.NudgeSpotlight), {
            setHidden: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            hidden: !showSpotlight,
            spotlightCard: renderNudge(),
            position: "bottom-end",
            zIndex: (0, $lcnyw.layers).spotlight(),
            hideSpotlightCardOnOutsideClick: false
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
            attributes: {
                messageId: isAdmin ? $b9da84c42a24b64e$var$QUEUES_ADMIN_MESSAGE_ID : $b9da84c42a24b64e$var$QUEUES_AGENT_MESSAGE_ID,
                name: `board${isAdmin ? 'Admin' : 'Agent'}ActivationSpotlight`,
                projectId: projectId,
                projectType: projectType
            }
        })));
    };
    return showSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b9da84c42a24b64e$var$BoardSpotlightShowDecider, {
        isAdmin: isAdmin,
        projectKey: projectKey,
        renderSpotlightCard: renderSpotlightCard
    }) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b9da84c42a24b64e$var$ModalWrapperStyles = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _94n5xy5q _1xi2oahv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bpLfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $785eb6a3c5492c37$export$2e2bcd8739ae039);

var $9TZf5 = parcelRequire("9TZf5");

var $e3mjM = parcelRequire("e3mjM");
const $785eb6a3c5492c37$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($e3mjM)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($e3mjM))
});
var $785eb6a3c5492c37$export$2e2bcd8739ae039 = $785eb6a3c5492c37$var$Illustration;
const $785eb6a3c5492c37$export$a179c88182cb9d56 = [
    0,
    0,
    600,
    308
];

});
parcelRegister("e3mjM", function(module, exports) {
module.exports = new URL("board.3d681b47.png", import.meta.url).toString();

});


parcelRegister("bKFaV", function(module, exports) {

$parcel$export(module.exports, "createOnboardingSpotlight", () => $cfce4704fdb8ae06$export$3de3bbc64fe39fe6);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $6Pq2D = parcelRequire("6Pq2D");

var $bbaTG = parcelRequire("bbaTG");
var $7u4fN = parcelRequire("7u4fN");

var $g9Oms = parcelRequire("g9Oms");


var $7dRgX = parcelRequire("7dRgX");
const $cfce4704fdb8ae06$var$NudgeHeading = ({ formattedMessage: formattedMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfce4704fdb8ae06$var$Title, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfce4704fdb8ae06$var$CustomHeading, null, formattedMessage));
const $cfce4704fdb8ae06$var$NudgeAction = ({ appearance: appearance, content: content, onClick: onClick })=>{
    // if appearance is primary, override styles with custom button
    // note CustomThemeButton is advised against and we need a better solution
    // (potentially even going with the blue button). Leaving this code for the experiment
    if (appearance === 'primary') {
        const customTheme = (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: `${"var(--ds-icon-discovery, #8270DB)"}`,
                    minWidth: '84px',
                    margin: `0 ${"var(--ds-space-050, 4px)"}`,
                    color: `${`var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`}`
                },
                spinnerStyles: spinnerStyles
            };
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
            appearance: appearance,
            onClick: onClick,
            theme: customTheme
        }, content);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: appearance,
        onClick: onClick
    }, content);
};
const $cfce4704fdb8ae06$var$NudgeActions = ({ actions: actions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfce4704fdb8ae06$var$Footer, null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfce4704fdb8ae06$var$NudgeAction, {
            key: index,
            ...action
        })));
const $cfce4704fdb8ae06$export$3de3bbc64fe39fe6 = ({ actions: actions, contentMessage: contentMessage, headingMessage: headingMessage, image: image, width: width = (0, $7dRgX.DEFAULT_NUDGE_WIDTH), CustomWrapper: CustomWrapper, actionsBeforeElement: actionsBeforeElement })=>{
    const Wrapper = CustomWrapper || $cfce4704fdb8ae06$var$SpotlightCardWrapper;
    return /*#__PURE__*/ (0, $eUqFw.forwardRef)((_, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9Oms.default), {
            image: image,
            heading: headingMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfce4704fdb8ae06$var$NudgeHeading, {
                formattedMessage: headingMessage
            }) : null,
            width: width,
            actionsBeforeElement: actionsBeforeElement
        }, contentMessage, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfce4704fdb8ae06$var$NudgeActions, {
            actions: actions
        }))));
};
const $cfce4704fdb8ae06$export$cbbb2ee263b2a558 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ focusLock: focusLock, ...rest }, ref)=>{
    const Spotlight = $cfce4704fdb8ae06$export$3de3bbc64fe39fe6({
        ...rest
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), {
        disabled: !focusLock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Spotlight, {
        ref: ref
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfce4704fdb8ae06$var$SpotlightCardWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_fkwn1bhr _tml110s3 _19yu10s3",
            __cmplp.className
        ])
    });
});
const $cfce4704fdb8ae06$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $cfce4704fdb8ae06$var$CustomHeading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81bk4 _syaz10s3",
            __cmplp.className
        ])
    });
});
const $cfce4704fdb8ae06$var$Footer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o _ca0qu2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jUeCh", function(module, exports) {
module.exports = new URL("boards.3d681b47.png", import.meta.url).toString();

});

parcelRegister("9BNw0", function(module, exports) {

$parcel$export(module.exports, "useBoardPromotion", () => $a858ee13b19c4b02$export$4d6b304f2ae1fcc0);

var $eUqFw = parcelRequire("eUqFw");

var $aSEj7 = parcelRequire("aSEj7");

var $kK7gc = parcelRequire("kK7gc");
const $a858ee13b19c4b02$export$4d6b304f2ae1fcc0 = (isAdmin, projectKey)=>{
    const [doesHaveSharedObjectsPermissionEnabled, setDoesHaveSharedObjectsPermissionEnabled] = (0, $eUqFw.useState)();
    const [issueCount, setIssueCount] = (0, $eUqFw.useState)();
    const { data: features } = (0, $aSEj7.default)();
    (0, $eUqFw.useEffect)(()=>{
        if (isAdmin !== undefined && projectKey) {
            (0, $kK7gc.getCreateSharedObjectsPermission)().then((data)=>{
                setDoesHaveSharedObjectsPermissionEnabled(data);
            });
            (0, $kK7gc.getBoardIssueCount)(projectKey).then((data)=>{
                setIssueCount(data);
            });
        }
    }, [
        isAdmin,
        projectKey
    ]);
    const shouldRenderBoardPromotion = (0, $eUqFw.useMemo)(()=>{
        if (features && doesHaveSharedObjectsPermissionEnabled && issueCount !== undefined) {
            const isWithinMaxIssueCountLimit = issueCount < 4000;
            const hasEnabledBoards = $a858ee13b19c4b02$var$hasUserEnabledBoardsFeature(features);
            if (isAdmin) {
                const permissionEnabled = doesHaveSharedObjectsPermissionEnabled !== undefined && doesHaveSharedObjectsPermissionEnabled === true;
                return isWithinMaxIssueCountLimit && permissionEnabled && !hasEnabledBoards;
            }
            // agent
            return isWithinMaxIssueCountLimit && !hasEnabledBoards;
        }
        return false;
    }, [
        features,
        doesHaveSharedObjectsPermissionEnabled,
        isAdmin,
        issueCount
    ]);
    return {
        shouldRenderBoardPromotion: shouldRenderBoardPromotion
    };
};
const $a858ee13b19c4b02$var$hasUserEnabledBoardsFeature = (features)=>{
    if (features) return features['jsm-board']?.status === 'ENABLED';
    return false;
};

});
parcelRegister("aSEj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d93f023cd162d6f9$export$2e2bcd8739ae039);

var $k1AKH = parcelRequire("k1AKH");

var $lB25E = parcelRequire("lB25E");
const $d93f023cd162d6f9$var$useServiceProjectFeatures = ()=>(0, $lB25E.useResource)((0, $k1AKH.featuresResource));
var $d93f023cd162d6f9$export$2e2bcd8739ae039 = $d93f023cd162d6f9$var$useServiceProjectFeatures;

});

parcelRegister("kK7gc", function(module, exports) {

$parcel$export(module.exports, "getCreateSharedObjectsPermission", () => $40c0cf4ecf2b23d6$export$c96038ddeaebae69);
$parcel$export(module.exports, "getBoardIssueCount", () => $40c0cf4ecf2b23d6$export$6d2f1fdc3632246);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $40c0cf4ecf2b23d6$export$cb6b2d808818e009 = new (0, $kDfSL.UFOExperience)('jsm-board-promotion-get-issue-count', {
    type: (0, $12kyE.ExperienceTypes).Operation,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom
});
const $40c0cf4ecf2b23d6$var$PERMISSION_BASE_URL = '/rest/api/3/mypermissions';
const $40c0cf4ecf2b23d6$var$CREATE_SHARED_OBJECTS_PERMISSION_PARAM = 'permissions=CREATE_SHARED_OBJECTS';
const $40c0cf4ecf2b23d6$export$c96038ddeaebae69 = async ()=>{
    try {
        const myPermission = await (0, $lRmyA.performGetRequest)(`${$40c0cf4ecf2b23d6$var$PERMISSION_BASE_URL}?${$40c0cf4ecf2b23d6$var$CREATE_SHARED_OBJECTS_PERMISSION_PARAM}`);
        return myPermission?.permissions?.CREATE_SHARED_OBJECTS?.havePermission;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('queues-agent-view.services.board-promotion.getCreateSharedObjectsPermission', 'Unable to fetch create shared objects permission', error);
        return undefined;
    }
};
const $40c0cf4ecf2b23d6$export$6d2f1fdc3632246 = async (projectKey)=>{
    const issueCountBaseUrl = '/rest/api/2/search';
    const jqlParam = encodeURIComponent(`project=${projectKey} and status != Resolved or (status = Resolved and updated >= 1d) ORDER BY Rank ASC`);
    const url = `${issueCountBaseUrl}?jql=${jqlParam}&maxResults=0&fields=id&LIMIT=4001`;
    try {
        $40c0cf4ecf2b23d6$export$cb6b2d808818e009.start();
        const issueCount = await (0, $lRmyA.performGetRequest)(url);
        $40c0cf4ecf2b23d6$export$cb6b2d808818e009.success();
        return issueCount?.total;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        $40c0cf4ecf2b23d6$export$cb6b2d808818e009.failure();
        (0, $gUUjF.default).safeErrorWithoutCustomerData('queues-agent-view.services.board-promotion.getBoardIssueCount', `Unable to fetch jql for unresolved issues in project ${projectKey}`, error);
        return undefined;
    }
};

});


parcelRegister("iGytm", function(module, exports) {

$parcel$export(module.exports, "default", () => $897faf1ba17f44f0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $897faf1ba17f44f0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    agentDescription: {
        "id": "servicedesk.queues.agent-view.layout.board-promo-spotlight.agent-description",
        "defaultMessage": "Get better visibility of the status of your issues. Track the progress of all issues, or use filters to show specific issues. Ask an admin to enable your board."
    },
    adminDescription: {
        "id": "servicedesk.queues.agent-view.layout.board-promo-spotlight.admin-description",
        "defaultMessage": "Get better visibility of the status of your issues. Track the progress of all issues, or use filters to show specific issues. Enable your board in Features."
    },
    heading: {
        "id": "servicedesk.queues.agent-view.layout.board-promo-spotlight.heading",
        "defaultMessage": "Visualize your work on a board"
    },
    enable: {
        "id": "servicedesk.queues.agent-view.layout.board-promo-spotlight.enable",
        "defaultMessage": "Go to Features"
    },
    ok: {
        "id": "servicedesk.queues.agent-view.layout.board-promo-spotlight.ok",
        "defaultMessage": "OK"
    },
    dismiss: {
        "id": "servicedesk.queues.agent-view.layout.board-promo-spotlight.dismiss",
        "defaultMessage": "Dismiss"
    },
    learnMore: {
        "id": "servicedesk.queues.agent-view.layout.board-promo-spotlight.learn-more",
        "defaultMessage": "Learn more"
    }
});

});




parcelRegister("9F9nP", function(module, exports) {

$parcel$export(module.exports, "FilterQueryFailed", () => $8f4c1e4f23c40427$export$fd20e2768ee7eace);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $eI5EY = parcelRequire("eI5EY");

var $2BP1Y = parcelRequire("2BP1Y");

var $4Es8k = parcelRequire("4Es8k");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4FGiQ = parcelRequire("4FGiQ");

var $hm8AF = parcelRequire("hm8AF");
const $8f4c1e4f23c40427$export$fd20e2768ee7eace = ({ onFilterClear: onFilterClear })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const renderImage = ()=>(0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $2BP1Y.default))({
            imageWidth: 120,
            maxImageWidth: 120,
            maxImageHeight: 160
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f4c1e4f23c40427$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        testId: "servicedesk-queues-agent-view.layout.filter-query-failed.query-failed",
        imageUrl: (0, $eI5EY.fg)('jsm_queues_consolidate_jfe_assets') ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($4FGiQ))),
        renderImage: (0, $eI5EY.fg)('jsm_queues_consolidate_jfe_assets') ? renderImage : undefined,
        header: formatMessage((0, $hm8AF.default).errorHeader),
        description: formatMessage((0, $hm8AF.default).errorMessage),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            onClick: onFilterClear,
            testId: "servicedesk-queues-agent-view.layout.filter-query-failed.clear-search-button"
        }, formatMessage((0, $hm8AF.default).clearSearch))
    }));
};
const $8f4c1e4f23c40427$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2BP1Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $e497aeb1100a6e82$export$2e2bcd8739ae039);

var $9TZf5 = parcelRequire("9TZf5");

var $4mFwk = parcelRequire("4mFwk");
const $e497aeb1100a6e82$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4mFwk)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($4mFwk))
});
var $e497aeb1100a6e82$export$2e2bcd8739ae039 = $e497aeb1100a6e82$var$Illustration;
const $e497aeb1100a6e82$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("4mFwk", function(module, exports) {
module.exports = new URL("error-white.e2723ea8.svg", import.meta.url).toString();

});


parcelRegister("4FGiQ", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("hm8AF", function(module, exports) {

$parcel$export(module.exports, "default", () => $50adbbcd5c86472c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $50adbbcd5c86472c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorHeader: {
        "id": "servicedesk.queues.agent-view.layout.filter-query-failed.error-header",
        "defaultMessage": "We couldn't load your search results"
    },
    errorMessage: {
        "id": "servicedesk.queues.agent-view.layout.filter-query-failed.error-message",
        "defaultMessage": "Check for typos, or try another search term"
    },
    clearSearch: {
        "id": "servicedesk.queues.agent-view.layout.filter-query-failed.clear-search",
        "defaultMessage": "Clear search"
    }
});

});


parcelRegister("l9RnQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $192dbada9acd0ac5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $192dbada9acd0ac5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    openIssueInSidebar: {
        "id": "servicedesk.queues.agent-view.layout.open-issue-in-sidebar",
        "defaultMessage": "Open issue in sidebar"
    },
    openIssueInDialog: {
        "id": "servicedesk.queues.agent-view.layout.open-issue-in-dialog",
        "defaultMessage": "Open issue in dialog"
    }
});

});

parcelRegister("l3I5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $352306501325d9d1$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $9mlBv = parcelRequire("9mlBv");

var $1RqtY = parcelRequire("1RqtY");

var $1cX5m = parcelRequire("1cX5m");

var $jo4xA = parcelRequire("jo4xA");

var $kqhz5 = parcelRequire("kqhz5");
const $352306501325d9d1$var$mapStateToProps = (state)=>({
        IssueCount: $1cX5m.default,
        IssueSearch: $jo4xA.default,
        isQueuesErrorHeaderDisplayed: (0, $1RqtY.isQueuesErrorHeaderDisplayed)(state)
    });
const $352306501325d9d1$var$mapDispatchToProps = {
    renderDisplayError: (0, $9mlBv.displayQueuesErrorHeaderAction)
};
var $352306501325d9d1$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($352306501325d9d1$var$mapStateToProps, $352306501325d9d1$var$mapDispatchToProps)((0, $kqhz5.default));

});
parcelRegister("1cX5m", function(module, exports) {

$parcel$export(module.exports, "default", () => $972c9ff46def3f0f$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");


var $8N2pO = parcelRequire("8N2pO");

var $3ztB9 = parcelRequire("3ztB9");

var $8UPn4 = parcelRequire("8UPn4");

var $8GAE5 = parcelRequire("8GAE5");

var $1RqtY = parcelRequire("1RqtY");

var $5XwaC = parcelRequire("5XwaC");
const $972c9ff46def3f0f$var$mapDispatchToProps = (dispatch)=>({
        onFilterReloadClick: ()=>{
            dispatch((0, $8N2pO.isNewFilterQueryPendingAction)(true));
            dispatch((0, $3ztB9.loadIssuesAction)(0, (0, $34edc5e681269c4f$export$be4c1ea173a5271a)));
        }
    });
const $972c9ff46def3f0f$var$mapStateToProps = (state)=>({
        issueCount: (0, $8GAE5.getIssueCount)(state),
        isCurrentDataFiltered: (0, $8UPn4.getIsCurrentDataFiltered)(state),
        isLoadingIssues: (0, $1RqtY.isLoadingIssues)(state)
    });
var $972c9ff46def3f0f$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($972c9ff46def3f0f$var$mapStateToProps, $972c9ff46def3f0f$var$mapDispatchToProps)((0, $5XwaC.default));

});
parcelRegister("5XwaC", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e00ced6615d9c2d$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $iPlKJ = parcelRequire("iPlKJ");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $2eG9N = parcelRequire("2eG9N");

var $9VPEO = parcelRequire("9VPEO");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $4P0Ok = parcelRequire("4P0Ok");
const $9e00ced6615d9c2d$export$542fba90cc9c1bd1 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { issueCount: issueCount, isCurrentDataFiltered: isCurrentDataFiltered, isLoadingIssues: isLoadingIssues, onFilterReloadClick: onFilterReloadClick } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleReloadClick = ()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueFiltering reloaded');
        onFilterReloadClick();
    };
    if (!isCurrentDataFiltered && issueCount !== 0 && !isLoadingIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e00ced6615d9c2d$export$e6dfd72ab29f8598, null, formatMessage((0, $4P0Ok.default).numberOfIssues, {
        issueCount: issueCount
    }));
    if (isCurrentDataFiltered && !isLoadingIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e00ced6615d9c2d$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e00ced6615d9c2d$var$Layout, null, formatMessage((0, $4P0Ok.default).numberOfFilteredIssues, {
        filteredIssueCount: issueCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9e00ced6615d9c2d$var$spacerStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        position: "bottom",
        content: formatMessage((0, $4P0Ok.default).refreshResults)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": formatMessage((0, $4P0Ok.default).refreshResults),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iPlKJ))), {
            label: formatMessage((0, $4P0Ok.default).refreshResults),
            size: "small"
        }),
        "data-testId": "servicedesk-queues-agent-view.layout.queues-details.issue-count.reload-button",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleReloadClick
    }))));
    return isLoadingIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e00ced6615d9c2d$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        height: "24px",
        width: "100px",
        "data-testid": "servicedesk-queues-agent-view.layout.queues-details.issue-count.skeleton"
    })) : null;
};
var $9e00ced6615d9c2d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = $9e00ced6615d9c2d$export$542fba90cc9c1bd1;
const $9e00ced6615d9c2d$var$Layout = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $9e00ced6615d9c2d$var$spacerStyles = (0, $1ZAYh.xcss)({
    width: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $9e00ced6615d9c2d$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1a45 _19pkutpp _otyr1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4P0Ok", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f28539960ef283d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0f28539960ef283d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    numberOfIssues: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-count.number-of-issues",
        "defaultMessage": "{issueCount, plural,\n            =1 {{issueCount, number} issue}\n            other {{issueCount, number} issues}\n            }"
    },
    numberOfFilteredIssues: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-count.number-of-filtered-issues",
        "defaultMessage": "{filteredIssueCount, plural,\n            =1 {{filteredIssueCount, number} issue found}\n            other {{filteredIssueCount, number} issues found}\n            }"
    },
    refreshResults: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-count.refresh-results",
        "defaultMessage": "Refresh results"
    }
});

});



parcelRegister("jo4xA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2030e5f4760387d5$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $lNNXV = parcelRequire("lNNXV");

var $8N2pO = parcelRequire("8N2pO");

var $8UPn4 = parcelRequire("8UPn4");

var $3KNsL = parcelRequire("3KNsL");

var $le6ZF = parcelRequire("le6ZF");
const $2030e5f4760387d5$var$mapDispatchToProps = (dispatch)=>({
        onChange: (text)=>{
            dispatch((0, $8N2pO.filterQuerySubmittedAction)(text));
        },
        onChangedIsPendingSubmission: (loading)=>dispatch((0, $8N2pO.isNewFilterQueryPendingAction)(loading)),
        onFocusChange: (isFocused)=>dispatch((0, $8N2pO.isFilterFocusedAction)(isFocused))
    });
const $2030e5f4760387d5$var$mapStateToProps = (state)=>({
        queueId: (0, $3KNsL.getQueueId)(state),
        filterQuery: (0, $8UPn4.getCurrentFilterQuery)(state)
    });
var $2030e5f4760387d5$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($2030e5f4760387d5$var$mapStateToProps, $2030e5f4760387d5$var$mapDispatchToProps)((0, $le6ZF.default));

});
parcelRegister("le6ZF", function(module, exports) {

$parcel$export(module.exports, "default", () => $741cf53703107d82$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dxIU5 = parcelRequire("dxIU5");

var $SD4Im = parcelRequire("SD4Im");

var $bPZtE = parcelRequire("bPZtE");

var $cf2Y4 = parcelRequire("cf2Y4");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2iVXz = parcelRequire("2iVXz");
const $741cf53703107d82$var$TextFieldWidth = 240;
const $741cf53703107d82$var$createJQLClause = (text)=>`summary ~ "${text}*" OR description ~ "${text}*"`;
const $741cf53703107d82$var$IssueSearchView = ({ onChange: onChange, onChangedIsPendingSubmission: onChangedIsPendingSubmission, onFocusChange: onFocusChange, queueId: queueId, filterQuery: filterQuery })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { placeholder: placeholder } = (0, $2iVXz.default);
    const [value, setValue] = (0, $eUqFw.useState)('');
    const [isIconHovered, setHovered] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        setValue('');
    }, [
        queueId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (filterQuery === null) setValue('');
    }, [
        filterQuery
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            onFocusChange(false);
        }, [
        onFocusChange
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'queueSearchBox'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'queueSearchBoxViewed');
    }, [
        createAnalyticsEvent
    ]); // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedSearch = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((query)=>{
        const filterJQL = query === '' ? null : $741cf53703107d82$var$createJQLClause(query);
        onChange(filterJQL);
        onChangedIsPendingSubmission(true);
    }, 2000), [
        onChange
    ]); // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    const handleSearchChange = (event)=>{
        setValue(event.target.value);
        debouncedSearch(event.target.value);
    };
    const onFocusHandle = ()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueFiltering clicked');
        onFocusChange(true);
    };
    const onBlurHandle = ()=>onFocusChange(false);
    const onMouseEnterButton = (0, $eUqFw.useCallback)(()=>setHovered(true), []);
    const onMouseLeaveButton = (0, $eUqFw.useCallback)(()=>setHovered(false), []);
    const clearSearch = ()=>{
        setValue('');
        onChange(null);
        onChangedIsPendingSubmission(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($741cf53703107d82$var$MinWidthWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        isCompact: true,
        width: $741cf53703107d82$var$TextFieldWidth,
        placeholder: formatMessage(placeholder),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bPZtE))), {
            label: ""
        }),
        onChange: handleSearchChange,
        value: value,
        onFocus: onFocusHandle,
        onBlur: onBlurHandle,
        elemAfterInput: value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: formatMessage((0, $2iVXz.default).clearSearch)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($741cf53703107d82$var$ClearSearchWrapper, {
            onClick: clearSearch,
            onMouseEnter: onMouseEnterButton,
            onMouseLeave: onMouseLeaveButton,
            "data-testid": "servicedesk-queues-agent-view.layout.queues-details.issue-search.clear-search"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($SD4Im))), {
            color: isIconHovered ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-disabled, #091E424F)",
            label: formatMessage((0, $2iVXz.default).clearSearch),
            spacing: "none"
        })))
    }));
};
var $741cf53703107d82$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $741cf53703107d82$var$IssueSearchView;
const $741cf53703107d82$var$ClearSearchWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _80omtlke _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); /*
     * these styles are used for accomodating smaller screen sizes with the introduction of the split filters
     *
     * the min-width is needed to prevent the text area from shrinking to 0 size
     * the flex-shrink is used to give width priority to the active issue types / portal groups filters
     * the text-overflow is used when the text input is shrunken
     */ 
const $741cf53703107d82$var$MinWidthWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbp3fh _1ul953f4 _1o9z15gg _509t1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2iVXz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2840737dae97d9b3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2840737dae97d9b3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-search.placeholder",
        "defaultMessage": "Search for issues"
    },
    clearSearch: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-search.clear-search",
        "defaultMessage": "Clear search"
    }
});

});



parcelRegister("kqhz5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab098cc1d5dee1a0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $lRvnl = parcelRequire("lRvnl");
var $cEUHb = parcelRequire("cEUHb");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $g039U = parcelRequire("g039U");

var $gCpM6 = parcelRequire("gCpM6");
function $ab098cc1d5dee1a0$export$2e2bcd8739ae039(props) {
    const [addTopMargin, setAddTopMargin] = (0, $eUqFw.useState)(false);
    const { renderDisplayError: renderDisplayError, IssueCount: IssueCount, IssueSearch: IssueSearch, isQueuesErrorHeaderDisplayed: isQueuesErrorHeaderDisplayed } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleError = (location)=>{
        if (location === 'common.error-boundary.queues-details') setAddTopMargin(true);
        renderDisplayError();
    };
    const handleReload = ()=>{
        window.location.reload();
    };
    const errorSectionDefaultStyles = (0, $1ZAYh.xcss)({
        marginTop: 'space.0'
    });
    const errorMarginTopStyles = (0, $1ZAYh.xcss)({
        marginTop: 'space.400'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g039U.FFErrorBoundary), {
        onError: handleError,
        id: "queues-details-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.400",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: [
            errorSectionDefaultStyles,
            addTopMargin && errorMarginTopStyles
        ]
    }, isQueuesErrorHeaderDisplayed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        title: formatMessage((0, $gCpM6.messages).errorSectionTitle),
        appearance: "error",
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEUHb.default), {
            onClick: handleReload
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gCpM6.messages).reloadPageLinkText))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gCpM6.messages).errorSectionBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g039U.FFErrorBoundary), {
        onError: renderDisplayError,
        id: "queue-issue-search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueSearch, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueCount, null)))));
}

});
parcelRegister("gCpM6", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9e1b04f6ce25a24d$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9e1b04f6ce25a24d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    errorSectionTitle: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.error-section-title",
        "defaultMessage": "We currently have an outage"
    },
    errorSectionBody: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.error-section-body",
        "defaultMessage": "We're working hard to resolve temporary glitches with this page. But rest assured, the key functions on this page remain fully operational."
    },
    reloadPageLinkText: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.reload-page-link-text",
        "defaultMessage": "Reload the page"
    }
});

});



parcelRegister("frip8", function(module, exports) {

$parcel$export(module.exports, "default", () => $acc8b98481c22c12$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $9mlBv = parcelRequire("9mlBv");

var $3KNsL = parcelRequire("3KNsL");

var $64hzg = parcelRequire("64hzg");

var $kBLMh = parcelRequire("kBLMh");
const $acc8b98481c22c12$var$mapStateToProps = (state)=>({
        Actions: $64hzg.default,
        queueName: (0, $3KNsL.getQueueName)(state)
    });
const $acc8b98481c22c12$var$mapDispatchToProps = {
    renderDisplayError: (0, $9mlBv.displayQueuesErrorHeaderAction)
};
var $acc8b98481c22c12$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($acc8b98481c22c12$var$mapStateToProps, $acc8b98481c22c12$var$mapDispatchToProps)((0, $kBLMh.default));

});
parcelRegister("64hzg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dfaf8a2f7f6dd5c$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $3KNsL = parcelRequire("3KNsL");

var $6ycyf = parcelRequire("6ycyf");

var $1RqtY = parcelRequire("1RqtY");

var $5Uha5 = parcelRequire("5Uha5");

var $83IRM = parcelRequire("83IRM");

var $4YhFx = parcelRequire("4YhFx");

var $l3RCV = parcelRequire("l3RCV");

var $fFcZm = parcelRequire("fFcZm");
const $4dfaf8a2f7f6dd5c$var$mapStateToProps = (state)=>({
        ActionsMenu: $5Uha5.default,
        ResetSortingButton: $l3RCV.default,
        FavoriteButton: $83IRM.default,
        OpenInIssueNavButton: $4YhFx.default,
        canManageQueue: (0, $3KNsL.canManageQueue)(state),
        isManuallySorted: (0, $6ycyf.isManuallySorted)(state),
        isFavoriteEnabled: !(0, $3KNsL.isQueueTransient)(state),
        showIssueFailureError: (0, $1RqtY.showIssueFailureError)(state)
    });
var $4dfaf8a2f7f6dd5c$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($4dfaf8a2f7f6dd5c$var$mapStateToProps, {})((0, $fFcZm.default));

});
parcelRegister("5Uha5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d37d2f2c439eaa84$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $4Bees = parcelRequire("4Bees");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d37d2f2c439eaa84$var$LazyComponent = (0, $7rh0R.lazy)(()=>(parcelRequire("fKrac")), {
    moduleId: "./src/packages/servicedesk/queues-agent-view/src/view/layout/queues-header/actions/async-actions-menu/actions-menu/index.tsx"
});
const $d37d2f2c439eaa84$var$Component = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "queues-agent-view-actions-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d37d2f2c439eaa84$var$LoadingComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "small"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d37d2f2c439eaa84$var$LazyComponent, props));
var $d37d2f2c439eaa84$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d37d2f2c439eaa84$var$Component;
const $d37d2f2c439eaa84$var$LoadingComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb14no _4t3i1tcg _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fKrac", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("1fueU")
]).then(()=>parcelRequire('9JSiL'));

});


parcelRegister("83IRM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b5dfc7c88e47235$export$2e2bcd8739ae039);

var $c8Guq = parcelRequire("c8Guq");

var $6rCaY = parcelRequire("6rCaY");

var $lNNXV = parcelRequire("lNNXV");

var $2dkjn = parcelRequire("2dkjn");

var $3KNsL = parcelRequire("3KNsL");

var $amODm = parcelRequire("amODm");
const $8b5dfc7c88e47235$var$mapStateToProps = (state)=>({
        isFavorite: (0, $2dkjn.isQueueFavorited)(state),
        queueId: (0, $3KNsL.getQueueId)(state)
    });
var $8b5dfc7c88e47235$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $6rCaY.default)((state)=>({
        attributes: {
            queueId: (0, $3KNsL.getQueueId)(state),
            isFavorite: !(0, $2dkjn.isQueueFavorited)(state)
        }
    })), (0, $lNNXV.connect)($8b5dfc7c88e47235$var$mapStateToProps, {}))(// @ts-expect-error - Argument of type '({ isFavorite, queueId }: Props) => JSX.Element' is not assignable to parameter of type 'ComponentType<unknown>'.
(0, $amODm.default));

});
parcelRegister("amODm", function(module, exports) {

$parcel$export(module.exports, "default", () => $56a6adc09a2f7159$export$2e2bcd8739ae039);
/* eslint-disable jira/react-no-inline-function-prop */ 
var $eUqFw = parcelRequire("eUqFw");

var $ktkCe = parcelRequire("ktkCe");

var $jrdvV = parcelRequire("jrdvV");

var $dQZ5c = parcelRequire("dQZ5c");

var $aS6XE = parcelRequire("aS6XE");

var $aNBkj = parcelRequire("aNBkj");
const $56a6adc09a2f7159$var$FavoriteButton = ({ isFavorite: isFavorite, queueId: queueId })=>{
    const { changeFavorite: changeFavorite, items: items } = (0, $eUqFw.useContext)((0, $dQZ5c.FavoriteChangeContext));
    const getIsPending = ()=>{
        const queueItemChanges = items[0, $jrdvV.QUEUES_ITEM_TYPE];
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        const itemChanged = queueItemChanges[(0, $aNBkj.fromQueueIdString)(queueId)];
        return itemChanged ? itemChanged.pending : false;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aS6XE.AvailableQueuesConsumer), null, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ktkCe.default), {
            isFavorite: isFavorite,
            pending: getIsPending(),
            onClick: (analyticsEvent)=>{
                changeFavorite({
                    id: (0, $aNBkj.fromQueueIdString)(queueId),
                    value: !isFavorite,
                    type: (0, $jrdvV.QUEUES_ITEM_TYPE)
                }, analyticsEvent);
            }
        }));
};
var $56a6adc09a2f7159$export$2e2bcd8739ae039 = $56a6adc09a2f7159$var$FavoriteButton;

});


parcelRegister("4YhFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bed8aff96e30efe6$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $3nTcJ = parcelRequire("3nTcJ");

var $3KNsL = parcelRequire("3KNsL");

var $jaoOf = parcelRequire("jaoOf");
const $bed8aff96e30efe6$var$mapStateToProps = (state)=>({
        projectKey: (0, $3nTcJ.getProjectKey)(state),
        queueJql: (0, $3KNsL.getCompleteJql)(state)
    });
var $bed8aff96e30efe6$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($bed8aff96e30efe6$var$mapStateToProps, {})((0, $jaoOf.OpenInIssueNavButton));

});
parcelRegister("jaoOf", function(module, exports) {

$parcel$export(module.exports, "OpenInIssueNavButton", () => $0fae3fd373648712$export$72e8ee1dd9380293);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $23NQ5 = parcelRequire("23NQ5");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $6TlNX = parcelRequire("6TlNX");
const $0fae3fd373648712$var$getIssueNavUrl = (projectKey, queueJql)=>projectKey ? `/jira/servicedesk/projects/${projectKey}/issues/?jql=${encodeURIComponent(queueJql)}` : `/issues/?jql=${encodeURIComponent(queueJql)}`;
const $0fae3fd373648712$export$72e8ee1dd9380293 = (_props)=>{
    const { projectKey: projectKey, queueJql: queueJql } = _props;
    const issueNavUrl = $0fae3fd373648712$var$getIssueNavUrl(projectKey, queueJql);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onClick = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'navigateToIssueNavFromQueues', {
            hasProjectKey: typeof projectKey === 'string'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $6TlNX.default).openWithIssueNav)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "servicedesk-queues-agent-view.layout.queues-header.actions.open-in-issue-nav-button.open-in-issue-nav-button",
        href: issueNavUrl,
        target: "_blank",
        onClick: onClick,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
            label: "",
            size: "medium"
        }),
        appearance: "subtle"
    }));
};

});


parcelRegister("l3RCV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9634434b0c4fce4$export$2e2bcd8739ae039);

var $c8Guq = parcelRequire("c8Guq");

var $6rCaY = parcelRequire("6rCaY");

var $8un0w = parcelRequire("8un0w");

var $lNNXV = parcelRequire("lNNXV");

var $bfxje = parcelRequire("bfxje");

var $6ycyf = parcelRequire("6ycyf");

var $gNgYj = parcelRequire("gNgYj");
var $b9634434b0c4fce4$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $8un0w.default)({
    onResetSorting: 'resetSorting'
}), (0, $6rCaY.default)((state)=>({
        attributes: {
            fieldId: (0, $6ycyf.getSortedByColumn)(state),
            sortOrder: (0, $6ycyf.getSortOrder)(state)
        }
    })), (0, $lNNXV.connect)(null, {
    onResetSorting: (0, $bfxje.resetSortOrderAction)
}))((0, $gNgYj.default));

});
parcelRegister("gNgYj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e602b9dfb0611105$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $giAhk = parcelRequire("giAhk");

var $6TlNX = parcelRequire("6TlNX");
function $e602b9dfb0611105$export$ce3eb8345b6d11e3(props) {
    const { intl: { formatMessage: formatMessage }, onResetSorting: onResetSorting } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onResetSorting
    }, formatMessage((0, $6TlNX.default).resetSorting));
}
var $e602b9dfb0611105$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($e602b9dfb0611105$export$ce3eb8345b6d11e3);

});


parcelRegister("fFcZm", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6ce6e423a52445e$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dHiWd = parcelRequire("dHiWd");
function $e6ce6e423a52445e$export$2e2bcd8739ae039({ canManageQueue: canManageQueue, isManuallySorted: isManuallySorted, isFavoriteEnabled: isFavoriteEnabled, onDeleteComplete: onDeleteComplete, showIssueFailureError: showIssueFailureError, ActionsMenu: ActionsMenu, FavoriteButton: FavoriteButton, ResetSortingButton: ResetSortingButton, OpenInIssueNavButton: OpenInIssueNavButton }) {
    const shouldShowResetSortingButton = !showIssueFailureError && !canManageQueue && isManuallySorted;
    const hasMultipleActions = isFavoriteEnabled && (canManageQueue || shouldShowResetSortingButton);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e6ce6e423a52445e$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dHiWd.AsyncQueuesAutomationMenu), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(OpenInIssueNavButton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e6ce6e423a52445e$var$Spacer, null)), isFavoriteEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FavoriteButton, null), hasMultipleActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e6ce6e423a52445e$var$Spacer, null), canManageQueue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ActionsMenu, {
        onDeleteComplete: onDeleteComplete
    }), shouldShowResetSortingButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ResetSortingButton, null));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e6ce6e423a52445e$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $e6ce6e423a52445e$var$Spacer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbu2gc",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kBLMh", function(module, exports) {

$parcel$export(module.exports, "default", () => $db847a705e7bc541$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3a8wJ = parcelRequire("3a8wJ");

var $55Wlg = parcelRequire("55Wlg");

var $g039U = parcelRequire("g039U");
function $db847a705e7bc541$export$2e2bcd8739ae039(props) {
    const [, setAddTopMargin] = (0, $eUqFw.useState)(false);
    const { queueName: queueName, onDeleteComplete: onDeleteComplete, renderDisplayError: renderDisplayError, Actions: Actions } = props;
    const handleError = (location)=>{
        if (location === 'common.error-boundary.queue-page-header') setAddTopMargin(true);
        renderDisplayError();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g039U.FFErrorBoundary), {
        onError: handleError,
        id: "queue-page-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
        truncateTitle: true,
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Actions, {
            onDeleteComplete: onDeleteComplete
        }),
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55Wlg.default), null)
    }, queueName));
}

});


parcelRegister("kQ4V1", function(module, exports) {

$parcel$export(module.exports, "SidebarIssueView", () => $3a72c6ac1a4fb0d6$export$ccdf533f42a8d6f8);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eKZPH = parcelRequire("eKZPH");

var $6vrw7 = parcelRequire("6vrw7");

var $2Ckla = parcelRequire("2Ckla");

var $9RBI2 = parcelRequire("9RBI2");

var $gPixD = parcelRequire("gPixD");
const $3a72c6ac1a4fb0d6$var$callWhenIdle = (callback)=>{
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(callback);
    else setTimeout(callback, 3000);
};
const $3a72c6ac1a4fb0d6$export$ccdf533f42a8d6f8 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, onClose: onClose, analyticsSource: analyticsSource, onChange: onChange, onIssueDeleteSuccess: onIssueDeleteSuccess, parentWidth: parentWidth, setIsResizing: setIsResizing })=>{
    (0, $eUqFw.useEffect)(()=>{
        // Preload IssueApp here, otherwise it'd be loaded when Sidebar opens up for the first time, which is a bit slow
        $3a72c6ac1a4fb0d6$var$callWhenIdle(()=>{
            (0, $2Ckla.default).preload();
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eKZPH.JiraDetailPanel), null, (setDetailPanelWidth)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gPixD.default), {
            parentWidth: parentWidth,
            onResize: setDetailPanelWidth,
            setIsResizing: setIsResizing
        }, issueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3a72c6ac1a4fb0d6$var$SidebarWrapper, {
            "data-testid": "servicedesk-queues-agent-view.layout.sidebar-issue-app.wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RBI2.SidebarIssueApp), {
            issueKey: (0, $6vrw7.toIssueKey)(issueKey),
            onClose: onClose,
            analyticsSource: analyticsSource,
            onChange: onChange,
            onIssueDeleteSuccess: onIssueDeleteSuccess
        }))));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a72c6ac1a4fb0d6$var$SidebarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eKZPH", function(module, exports) {

$parcel$export(module.exports, "JiraDetailPanel", () => $1b225f5f3fb1073b$export$93acb63f4e179357);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $a576Y = parcelRequire("a576Y");

var $5GxEP = parcelRequire("5GxEP");

var $53ucm = parcelRequire("53ucm");
const $1b225f5f3fb1073b$var$DetailPanel = ({ children: children, panelWidth: panelWidth })=>{
    const { setWidth: setWidth } = (0, $53ucm.useDetailPanelActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (panelWidth !== undefined) setWidth(panelWidth);
        return ()=>setWidth(0);
    }, [
        panelWidth,
        setWidth
    ]);
    const throttleSetWidth = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(setWidth, 50, {
            leading: true,
            trailing: true
        }), [
        setWidth
    ]);
    return typeof children === 'function' ? children(throttleSetWidth) : children;
};
const $1b225f5f3fb1073b$export$93acb63f4e179357 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "jira-detail-panel",
        packageName: "jira-bottom-right-corner-controller",
        render: ()=>typeof props.children === 'function' ? props.children((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))) : props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b225f5f3fb1073b$var$DetailPanel, props));

});

parcelRegister("2Ckla", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f4e3bd1fc93dca4$export$2e2bcd8739ae039);

var $7rh0R = parcelRequire("7rh0R");

var // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
$1f4e3bd1fc93dca4$export$2e2bcd8739ae039 = (0, $7rh0R.lazy)(()=>(parcelRequire("kT5hT")), {
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});

});
parcelRegister("kT5hT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("kWrFZ"),
    $d1Cng("92sUi"),
    $d1Cng("i5RRW"),
    $d1Cng("dsiAd"),
    $d1Cng("eNmuD"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kMAKK")
]).then(()=>parcelRequire('9zAkH'));

});


parcelRegister("9RBI2", function(module, exports) {

$parcel$export(module.exports, "SidebarIssueApp", () => $76c23b4ef7f62ac3$export$e402f7c18d4d7f37);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $gJYxu = parcelRequire("gJYxu");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");

var $c4qEZ = parcelRequire("c4qEZ");

var $2Ckla = parcelRequire("2Ckla");
const $76c23b4ef7f62ac3$var$PACKAGE_NAME = 'jsmQueueAgentViewSidebar';
const $76c23b4ef7f62ac3$export$e402f7c18d4d7f37 = ({ analyticsSource: analyticsSource, issueKey: issueKey, onClose: onClose, onIssueDeleteSuccess: onIssueDeleteSuccess, onChange: onChange })=>{
    const [currentIssueKey, setCurrentIssueKey] = (0, $eUqFw.useState)(issueKey);
    // @ts-expect-error - TS7031 - Binding element 'nextIssueKey' implicitly has an 'any' type.
    const onIssueKeyChange = (0, $eUqFw.useCallback)(({ toIssueKey: nextIssueKey })=>{
        setCurrentIssueKey(nextIssueKey);
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        setCurrentIssueKey(issueKey);
    }, [
        issueKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: $76c23b4ef7f62ac3$var$PACKAGE_NAME,
        attributes: {
            viewMode: 'SIDEBAR'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJYxu.IssueBoundary), {
        packageName: $76c23b4ef7f62ac3$var$PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ckla.default), {
        viewModeOptions: {
            viewMode: 'SIDEBAR'
        },
        issueKey: currentIssueKey,
        analyticsSource: analyticsSource,
        shouldShowCloseButton: true,
        onClose: onClose,
        onIssueKeyChange: onIssueKeyChange,
        shouldSetInitialFocus: true,
        shouldShowRootProjectsBreadcrumb: true,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        onIssueDeleteFailure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        isSpaEnabled: false,
        isLoadedWithPage: false,
        onChange: onChange
    }))));
};

});
parcelRegister("gJYxu", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $47dde6f657625382$export$fbf48ede0cf52b5a);
$parcel$export(module.exports, "IssueModalBoundary", () => $47dde6f657625382$export$74d408982642a541);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $5GxEP = parcelRequire("5GxEP");

var $cyVXS = parcelRequire("cyVXS");

var $gGtKh = parcelRequire("gGtKh");

var $c4qEZ = parcelRequire("c4qEZ");
const $47dde6f657625382$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $47dde6f657625382$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});
parcelRegister("cyVXS", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $f96d169c5da11246$export$c3f500e812fb1bb3);

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");

var $fee69 = parcelRequire("fee69");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");
const $f96d169c5da11246$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $eUqFw.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});
parcelRegister("h97Af", function(module, exports) {

$parcel$export(module.exports, "default", () => $97ef913b7770c56a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6iz4v = parcelRequire("6iz4v");
const $97ef913b7770c56a$var$PerformanceMark = ({ metricKey: metricKey, onSet: onSet })=>{
    const renderRef = (0, $eUqFw.useRef)(false);
    if (!renderRef.current) {
        renderRef.current = true;
        (0, $6iz4v.setMark)(metricKey);
        onSet && onSet();
    }
    return null;
};
var $97ef913b7770c56a$export$2e2bcd8739ae039 = $97ef913b7770c56a$var$PerformanceMark;

});


parcelRegister("c4qEZ", function(module, exports) {

$parcel$export(module.exports, "IssueViewSkeleton", () => $d58942287640a101$export$49addbcdecb6e6ff);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $kB5wN = parcelRequire("kB5wN");

var $8ICxF = parcelRequire("8ICxF");

var $haxva = parcelRequire("haxva");
const $d58942287640a101$var$fullpageStyles = null;
const $d58942287640a101$var$modalStyles = null;
const $d58942287640a101$var$customSpacingStyles = null;
const $d58942287640a101$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $d58942287640a101$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $d58942287640a101$var$fullpageStyles : null,
        isModalView === true ? $d58942287640a101$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kB5wN.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($haxva))),
        className: (0, $7JEyt.default)([
            "_p12f1ypn _18s85ogf _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};

});
parcelRegister("kB5wN", function(module, exports) {

$parcel$export(module.exports, "CompactModeContext", () => $628d22027b8eaf89$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $628d22027b8eaf89$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $628d22027b8eaf89$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $6mgGK = parcelRequire("6mgGK");

var $lB25E = parcelRequire("lB25E");

var $fruGB = parcelRequire("fruGB");
const $628d22027b8eaf89$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const { Provider: $628d22027b8eaf89$var$Provider, Consumer: $628d22027b8eaf89$var$Consumer } = $628d22027b8eaf89$export$37eeac5cc5245b18;
const $628d22027b8eaf89$export$55a90a8e865a39b5 = 700;
const $628d22027b8eaf89$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$628d22027b8eaf89$export$55a90a8e865a39b5}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $628d22027b8eaf89$var$useRouteKey() {
    const [routeState] = (0, $lB25E.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $628d22027b8eaf89$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $628d22027b8eaf89$var$useRouteKey();
    (0, $fruGB.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $fruGB.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $ebe79147dfe00ff9$export$ee15e0cd1efafcb4);
        (0, $fruGB.setCachedIsCompactValue)(defaultState, key);
    }
    const [isCompact, setIsCompact] = (0, $eUqFw.useState)(defaultState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($628d22027b8eaf89$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6mgGK.ContainerQueryObserver), {
        query: $628d22027b8eaf89$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY,
        onChange: (state)=>{
            (0, $fruGB.setCachedIsCompactValue)(state, key);
            setIsCompact(state);
        },
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($628d22027b8eaf89$var$Provider, {
        value: isCompact
    }, children));
};
const $628d22027b8eaf89$export$20feb77b5b617e44 = $628d22027b8eaf89$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $628d22027b8eaf89$var$StyledWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
const $ebe79147dfe00ff9$export$ee15e0cd1efafcb4 = false;

parcelRegister("6mgGK", function(module, exports) {

$parcel$export(module.exports, "ContainerQueryObserver", () => $2f0f372a50da62d9$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

const $2f0f372a50da62d9$var$QueryContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
let $2f0f372a50da62d9$var$currentIdSeed = 0;
function $2f0f372a50da62d9$var$generateAttributeValue() {
    return `indicator-span-${$2f0f372a50da62d9$var$currentIdSeed++}`;
}
function $2f0f372a50da62d9$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $ebe79147dfe00ff9$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $eUqFw.useState)(defaultState);
    const handleQueryStatusChange = (0, $eUqFw.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f0f372a50da62d9$var$QueryContext.Provider, {
        value: active
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f0f372a50da62d9$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), children);
}
function $2f0f372a50da62d9$export$b66a67697973e01() {
    const currentState = (0, $eUqFw.useContext)($2f0f372a50da62d9$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $2f0f372a50da62d9$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $eUqFw.useMemo)(()=>$2f0f372a50da62d9$var$generateAttributeValue(), []);
    const spanRef = (0, $eUqFw.useRef)(null);
    const containerRef = (0, $eUqFw.useRef)(null);
    const currentState = $2f0f372a50da62d9$export$b66a67697973e01();
    (0, $eUqFw.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f0f372a50da62d9$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh; 
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2f0f372a50da62d9$var$ContainerToBeQueried = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fruGB", function(module, exports) {

$parcel$export(module.exports, "getCachedIsCompactValue", () => $592157d792cf61e1$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $592157d792cf61e1$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $592157d792cf61e1$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $592157d792cf61e1$var$cachedIsCompactValues = {};
let $592157d792cf61e1$var$previousRouteKey;
function $592157d792cf61e1$export$c47621d55d10906c(key) {
    return $592157d792cf61e1$var$cachedIsCompactValues[key];
}
function $592157d792cf61e1$export$568b2dd75c2027b4(isCompactValue, key) {
    $592157d792cf61e1$var$cachedIsCompactValues[key] = isCompactValue;
}
function $592157d792cf61e1$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $592157d792cf61e1$var$previousRouteKey) {
        $592157d792cf61e1$var$previousRouteKey = currentRouteKey;
        delete $592157d792cf61e1$var$cachedIsCompactValues[$592157d792cf61e1$var$previousRouteKey];
    }
}

});


parcelRegister("8ICxF", function(module, exports) {

$parcel$export(module.exports, "AppSkeletonImage", () => $f467e6485d9792e8$export$45b107c5dc7b51a5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $5JgJ2 = parcelRequire("5JgJ2");

var $apShl = parcelRequire("apShl");

var $h1hCM = parcelRequire("h1hCM");
const $f467e6485d9792e8$var$skeletonImageStyles = null;
const $f467e6485d9792e8$export$45b107c5dc7b51a5 = ({ src: src, className: className, containerStyles: containerStyles })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "app-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f467e6485d9792e8$var$SkeletonWrapper // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: src,
        alt: `${formatMessage((0, $h1hCM.default).loading)}...`,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _vchhusvi _1bsb1osq _1dqonqa1 _1h6d3acm _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
            className
        ])
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f467e6485d9792e8$var$SkeletonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h1hCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b5b2a6284984f9f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0b5b2a6284984f9f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    loading: {
        "id": "skeletons.common.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("haxva", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.31d538db.svg", import.meta.url).toString();

});




parcelRegister("gPixD", function(module, exports) {

$parcel$export(module.exports, "default", () => $20a1613445638c86$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $a576Y = parcelRequire("a576Y");

var $dkPd7 = parcelRequire("dkPd7");

var $4yBoB = parcelRequire("4yBoB");
const $20a1613445638c86$var$IS_DRAGGING_CLASS_NAME = 'ak-dnd-is-dragging';
const $20a1613445638c86$var$Resizer = ({ parentWidth: parentWidth, children: children, onResize: onResize, setIsResizing: setIsResizing })=>{
    const [width, setWidth] = (0, $eUqFw.useState)(0);
    const startX = (0, $eUqFw.useRef)(0);
    const extraWidth = (0, $eUqFw.useRef)(0);
    const onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(()=>{
        const newWidth = Math.max(parentWidth * (0, $4yBoB.getDetailViewWidthRatio)(), (0, $4yBoB.MIN_DETAILS_WIDTH_ISSUE));
        if (newWidth !== width) setWidth(newWidth);
    }, (0, $4yBoB.WINDOW_RESIZE_THROTTLE));
    (0, $eUqFw.useEffect)(()=>{
        setWidth(Math.max(parentWidth * (0, $4yBoB.getDetailViewWidthRatio)(), (0, $4yBoB.MIN_DETAILS_WIDTH_ISSUE)));
    }, [
        parentWidth
    ]);
    (0, $eUqFw.useEffect)(()=>{
        window.addEventListener('resize', onWindowResize);
        onResize?.(width);
        return ()=>{
            window.removeEventListener('resize', onWindowResize);
        };
    }, [
        onResize,
        onWindowResize,
        width
    ]);
    const onMouseDown = (0, $dkPd7.useEvent)((e)=>{
        startX.current = e.clientX + (width - (0, $4yBoB.MIN_DETAILS_WIDTH_ISSUE));
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
        setIsResizing(true);
        if (document.body) document.body.classList.add($20a1613445638c86$var$IS_DRAGGING_CLASS_NAME);
    });
    const onMouseMove = (0, $dkPd7.useEvent)((e)=>{
        extraWidth.current = Math.max(startX.current - e.clientX, 0);
        const newWidth = Math.min((0, $4yBoB.MIN_DETAILS_WIDTH_ISSUE) + extraWidth.current, parentWidth / 2);
        if (newWidth !== width) setWidth(newWidth);
    });
    const onMouseUp = (0, $dkPd7.useEvent)(()=>{
        startX.current = 0;
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
        if (document.body) document.body.classList.remove($20a1613445638c86$var$IS_DRAGGING_CLASS_NAME);
        const widthRatio = width === (0, $4yBoB.MIN_DETAILS_WIDTH_ISSUE) ? 0 : width / parentWidth;
        (0, $4yBoB.setDetailViewWidthRatio)(widthRatio);
        setIsResizing(false);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($20a1613445638c86$var$Container, {
        minWidth: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($20a1613445638c86$var$ResizeHandle, {
        onMouseDown: onMouseDown,
        role: "presentation"
    }), children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20a1613445638c86$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minWidth: minWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_7ypm2r": (0, $9t7rW.default)(`${__cmplp.minWidth || 400}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1kdj _1ul9152j _1tke1osq _c71l1osq _18m91wug _1reo15vq _1e0c1txw _2lx2vrvc _4cvr1y6m _11q7vuon _1pbyb4wl _18u0u2gc _u5f3u2gc",
            __cmplp.className
        ])
    });
});
const $20a1613445638c86$var$ResizeHandle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9ftgi _80omuf7j _kqswh2mm _1wpz1fhb _aetrb3bt _z0aiv77o _1qdgv47k _15l21ssb _clh31i34 _19do1b66 _qc5othzt _18postnw _16r2hloo _1jju1pom _5u1r1pom _1gvg1osq _1kmz1osq",
            __cmplp.className
        ])
    });
});
var $20a1613445638c86$export$2e2bcd8739ae039 = $20a1613445638c86$var$Resizer;

});
parcelRegister("dkPd7", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => $e657ee26e376985d$export$90fc3a17d93f704c);

var $eUqFw = parcelRequire("eUqFw");
const $e657ee26e376985d$export$90fc3a17d93f704c = (callback)=>{
    const callbackRef = (0, $eUqFw.useRef)(callback);
    (0, $eUqFw.useLayoutEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    return (0, $eUqFw.useCallback)((...args)=>callbackRef.current(...args), []);
};

});

parcelRegister("4yBoB", function(module, exports) {

$parcel$export(module.exports, "MIN_DETAILS_WIDTH_ISSUE", () => $1c690fe435dd0d0e$export$b4e0432c87affda2);
$parcel$export(module.exports, "WINDOW_RESIZE_THROTTLE", () => $1c690fe435dd0d0e$export$db1057b88f0c8a04);
$parcel$export(module.exports, "getDetailViewWidthRatio", () => $1c690fe435dd0d0e$export$5a9c556da9744b1b);
$parcel$export(module.exports, "setDetailViewWidthRatio", () => $1c690fe435dd0d0e$export$d194f7c4bdc33538);

var $aZaPn = parcelRequire("aZaPn");
const $1c690fe435dd0d0e$export$b4e0432c87affda2 = 440;
const $1c690fe435dd0d0e$export$db1057b88f0c8a04 = 350;
const $1c690fe435dd0d0e$var$DETAIL_VIEW_WIDTH_RATIO = 'gh.detailViewWidth';
const $1c690fe435dd0d0e$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('jsmqueueagentview');
const $1c690fe435dd0d0e$export$5a9c556da9744b1b = ()=>{
    const value = $1c690fe435dd0d0e$var$localStorage.get($1c690fe435dd0d0e$var$DETAIL_VIEW_WIDTH_RATIO);
    return value ? Number(value) : 0;
};
const $1c690fe435dd0d0e$export$d194f7c4bdc33538 = (ratio)=>$1c690fe435dd0d0e$var$localStorage.set($1c690fe435dd0d0e$var$DETAIL_VIEW_WIDTH_RATIO, ratio);

});





parcelRegister("6weDO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7357314a755857e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2CgwC = parcelRequire("2CgwC");

var $5YsMl = parcelRequire("5YsMl");

var $1Yimi = parcelRequire("1Yimi");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bwX0t = parcelRequire("bwX0t");

var $dv1cd = parcelRequire("dv1cd");
const $d7357314a755857e$var$warning = 'warning';
const $d7357314a755857e$var$Bold = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "strong"
    }, props.children);
const $d7357314a755857e$var$LEARN_MORE = 'https://support.atlassian.com/jira-service-management-cloud/docs/switch-microsoft-and-google-email-accounts-to-oauth/';
const $d7357314a755857e$var$BannerForAdmin = (props)=>{
    const { baseUrl: baseUrl, projectKey: projectKey } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'link'
    });
    const fireAnalytics = ()=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'navigateToEmailRequestBasicAuthConnection');
    };
    const appearance = $d7357314a755857e$var$warning;
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: "",
        secondaryColor: "inherit"
    });
    const message = formatMessage((0, $dv1cd.default).bannerMessage, {
        boldStart: '{boldStart}',
        boldEnd: '{boldEnd}'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "queuesAgentViewBasicAuthBanner",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2CgwC.default), {
        testId: `servicedesk-queues-agent-view.layout.basic-auth-users-banner.admin-banner-${appearance}`,
        appearance: appearance,
        icon: icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        componentsMapping: {
            bold: $d7357314a755857e$var$Bold
        },
        message: message
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/settings/email`,
        target: "_blank",
        onClick: fireAnalytics
    }, formatMessage((0, $dv1cd.default).navigateToEmailRequestLinkMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};
const $d7357314a755857e$var$BannerForAgent = (_props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'link'
    });
    const fireAnalytics = ()=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'navigateToEmailRequestBasicAuthConnectionForAgent');
    };
    const appearance = $d7357314a755857e$var$warning;
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: "",
        secondaryColor: "inherit"
    });
    const message = formatMessage((0, $dv1cd.default).bannerMessageForAgent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "queuesAgentViewBasicAuthBannerForAgent",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2CgwC.default), {
        testId: `servicedesk-queues-agent-view.layout.basic-auth-users-banner.agent-banner-${appearance}`,
        appearance: appearance,
        icon: icon
    }, message, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: $d7357314a755857e$var$LEARN_MORE,
        target: "_blank",
        onClick: fireAnalytics
    }, formatMessage((0, $dv1cd.default).navigateToEmailRequestLinkMessageForAgent))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};
const $d7357314a755857e$var$BasicAuthBanner = (props)=>{
    const { baseUrl: baseUrl, projectKey: projectKey, isAdmin: isAdmin } = props;
    if (isAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7357314a755857e$var$BannerForAdmin, {
        baseUrl: baseUrl,
        projectKey: projectKey
    });
    if ((0, $1ybV0.ff)('banner-for-basic-auth-connected-agents_j4xfi')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7357314a755857e$var$BannerForAgent, {
        baseUrl: baseUrl,
        projectKey: projectKey
    });
    return null;
};
const $d7357314a755857e$var$BasicAuthUsersBanner = (props)=>{
    const { baseUrl: baseUrl, projectKey: projectKey, isAdmin: isAdmin } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "jiraQueueViewBasicAuthWarningBanner",
        packageName: "jiraServicedeskQueuesAgentView",
        teamName: "jsd-shield"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bwX0t.default), {
        baseUrl: baseUrl,
        projectKey: projectKey
    }, ({ needsOAuthWarning: needsOAuthWarning })=>needsOAuthWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7357314a755857e$var$BasicAuthBanner, {
            baseUrl: baseUrl,
            projectKey: projectKey,
            isAdmin: isAdmin
        })));
};
var $d7357314a755857e$export$2e2bcd8739ae039 = $d7357314a755857e$var$BasicAuthUsersBanner;

});
parcelRegister("3x4sL", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $88ddecd12f0773cd$export$200d7bd7633253ce);

var $eUqFw = parcelRequire("eUqFw");

var $dO2kc = parcelRequire("dO2kc");

var $6nVYw = parcelRequire("6nVYw");
const $88ddecd12f0773cd$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $eUqFw.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $6nVYw.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $6nVYw.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $6nVYw.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $dO2kc.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $dO2kc.MalformedMessageError)) {
                (0, $dO2kc.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $dO2kc.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("dO2kc", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $1a42e2705665fc85$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $1a42e2705665fc85$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $1a42e2705665fc85$export$40d900e818b9630e);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

const $1a42e2705665fc85$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $1a42e2705665fc85$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $guiFP.default)({
            meta: {
                packageName: packageName,
                id: (0, $376af31d5cd90f0d$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $376af31d5cd90f0d$export$f3390a0e172fee41)}`;
        (0, $gUUjF.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $1a42e2705665fc85$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $376af31d5cd90f0d$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("6nVYw", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $ec16d76793463e9e$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $ec16d76793463e9e$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $ec16d76793463e9e$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $ec16d76793463e9e$export$d5170904651e91b1);

const $ec16d76793463e9e$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $ec16d76793463e9e$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$d5170904651e91b1 = (letter)=>letter === (0, $a86f32165c278403$export$a10c567c3288a6b4);

});
const $a86f32165c278403$export$a10c567c3288a6b4 = '}';



parcelRegister("bwX0t", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dce58c0f27d4ca7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $giAhk = parcelRequire("giAhk");
// eslint-disable-next-line jira/react/no-class-components
class $7dce58c0f27d4ca7$var$BasicAuthUserProvider extends (0, $eUqFw.Component) {
    componentDidMount() {
        this.fetchEntries();
    }
    render() {
        const { children: children } = this.props;
        const { needsOAuthWarning: needsOAuthWarning } = this.state;
        return children({
            needsOAuthWarning: needsOAuthWarning
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            needsOAuthWarning: false
        };
        // eslint-disable-next-line jira/react-arrow-function-property-naming, jira/react-no-unneeded-arrow-function-properties
        this.fetchEntries = async ()=>{
            const { baseUrl: baseUrl, projectKey: projectKey } = this.props;
            const baseNextState = {
                loading: false,
                error: undefined,
                needsOAuthWarning: this.state.needsOAuthWarning
            };
            try {
                const needsOAuthWarning = await (0, $2OdyW.default)(`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/incomingemail/showbanner`);
                this.setState({
                    needsOAuthWarning: needsOAuthWarning
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                this.setState({
                    ...baseNextState
                });
                (0, $guiFP.default)({
                    meta: {
                        id: 'fetchShouldDisplayBasicAuthBanner',
                        packageName: 'jiraServicedeskQueuesAgentView',
                        teamName: 'jsd-shield'
                    },
                    error: e,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw e;
            }
        };
    }
}
var $7dce58c0f27d4ca7$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($7dce58c0f27d4ca7$var$BasicAuthUserProvider);

});

parcelRegister("dv1cd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f861aa352a1f76cf$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f861aa352a1f76cf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    bannerMessage: {
        "id": "servicedesk.queues.agent-view.layout.basic-auth-users-banner.banner-message",
        "defaultMessage": "You must reconnect your Microsoft email in {boldStart}Project settings > Email requests{boldEnd} to continue receiving customer requests. "
    },
    navigateToEmailRequestLinkMessage: {
        "id": "servicedesk.queues.agent-view.layout.basic-auth-users-banner.navigate-to-email-request-link-message",
        "defaultMessage": "Reconnect"
    },
    bannerMessageForAgent: {
        "id": "servicedesk.queues.agent-view.layout.basic-auth-users-banner.banner-message-for-agent",
        "defaultMessage": "Your admin must reconnect the Microsoft account with OAuth immediately to continue receiving email requests. "
    },
    navigateToEmailRequestLinkMessageForAgent: {
        "id": "servicedesk.queues.agent-view.layout.basic-auth-users-banner.navigate-to-email-request-link-message-for-agent",
        "defaultMessage": "Learn more"
    },
    bannerMessagePostDeprecation: {
        "id": "servicedesk.queues.agent-view.layout.basic-auth-users-banner.banner-message-post-deprecation",
        "defaultMessage": "You must connect your Microsoft account again using OAuth to receive customer requests via email. "
    },
    bannerMessageForAgentPostDeprecation: {
        "id": "servicedesk.queues.agent-view.layout.basic-auth-users-banner.banner-message-for-agent-post-deprecation",
        "defaultMessage": "Your admin must reconnect the Microsoft account using OAuth to receive customer requests via email. "
    }
});

});


parcelRegister("j1Y1q", function(module, exports) {

$parcel$export(module.exports, "ChangeManagementTour", () => $2fd66e85055032c7$export$b9e679128cfbb66a);

var $eUqFw = parcelRequire("eUqFw");

var $bNe1g = parcelRequire("bNe1g");

var $IsF0v = parcelRequire("IsF0v");

var $9Y2K4 = parcelRequire("9Y2K4");

var $f1lMr = parcelRequire("f1lMr");

var $lB25E = parcelRequire("lB25E");
const $2fd66e85055032c7$export$b9e679128cfbb66a = (props)=>{
    const [practiceType] = (0, $lB25E.usePathParam)('practiceType');
    const { data: isItsmProject } = (0, $IsF0v.useIsItsmTemplateProject)();
    if (isItsmProject !== true) return null;
    return practiceType === (0, $f1lMr.SHORT_FORM_CHANGES) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, ({ data: data })=>data && data.isProjectAdmin === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Y2K4.AsyncChangeManagementTourQueues), props) : null) : null;
};

});
parcelRegister("9Y2K4", function(module, exports) {

$parcel$export(module.exports, "AsyncChangeManagementTourIssue", () => $33484f5159f17867$export$1ed01ce8c1ac7746);
$parcel$export(module.exports, "AsyncChangeManagementTourQueues", () => $33484f5159f17867$export$fb9c9876407ca830);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $c5Upq = parcelRequire("c5Upq");

const $33484f5159f17867$var$ChangeManagementTourIssueComponent = ()=>(parcelRequire("1Hsn3"));

const $33484f5159f17867$var$ChangeManagementTourQueuesComponent = ()=>(parcelRequire("46OSK"));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $33484f5159f17867$var$ChangeManagementTourIssue = (0, $7rh0R.lazy)(()=>$33484f5159f17867$var$ChangeManagementTourIssueComponent(), {});
const $33484f5159f17867$export$1ed8a177940b97cb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "change-management-tour-issue",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33484f5159f17867$var$ChangeManagementTourIssue, props));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $33484f5159f17867$var$ChangeManagementTourQueues = (0, $7rh0R.lazy)(()=>$33484f5159f17867$var$ChangeManagementTourQueuesComponent(), {});
const $33484f5159f17867$export$2e6a672121096a76 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "change-management-tour-queues",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33484f5159f17867$var$ChangeManagementTourQueues, props));
const $33484f5159f17867$export$1ed01ce8c1ac7746 = (0, $c5Upq.withShouldRenderWithinItsmSampleProject)($33484f5159f17867$export$1ed8a177940b97cb, false);
const $33484f5159f17867$export$fb9c9876407ca830 = (0, $c5Upq.withShouldRenderWithinItsmSampleProject)($33484f5159f17867$export$2e6a672121096a76, false);

});
parcelRegister("c5Upq", function(module, exports) {

$parcel$export(module.exports, "withShouldRenderWithinItsmSampleProject", () => $287404fd76a9d51f$export$226e9fc1ef19c2cf);

var $eUqFw = parcelRequire("eUqFw");

var $gEZA0 = parcelRequire("gEZA0");
const $287404fd76a9d51f$export$226e9fc1ef19c2cf = (WrappedComponent, shouldRenderWithinItsmSampleProject)=>{
    const WithShouldRenderWithinItsmSampleProject = (props)=>{
        const { data: isItsmSampleProject } = (0, $gEZA0.useIsItsmSampleProject)();
        const shouldRender = shouldRenderWithinItsmSampleProject === isItsmSampleProject;
        // @ts-expect-error - TS2322 - Type 'Props' is not assignable to type 'IntrinsicAttributes & LibraryManagedAttributes<Component, PropsWithChildren<PropsWithoutRef<Props> & RefAttributes<any>>>'.
        return shouldRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props);
    };
    WithShouldRenderWithinItsmSampleProject.displayName = `WithShouldRenderWithinItsmSampleProject(${WrappedComponent.displayName ?? WrappedComponent.name ?? 'Component'})`;
    // @ts-expect-error - TS2322 - Type '{ (props: Props): false | JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<Props, any>'.
    return WithShouldRenderWithinItsmSampleProject;
};

});

parcelRegister("1Hsn3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("kWrFZ"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("eKQOd")
]).then(()=>parcelRequire('dEONe'));

});

parcelRegister("46OSK", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8K9ld")
]).then(()=>parcelRequire('a6Pli'));

});



parcelRegister("3dyVe", function(module, exports) {

$parcel$export(module.exports, "default", () => $41076b2394f4b7e4$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $3KNsL = parcelRequire("3KNsL");

var $1RqtY = parcelRequire("1RqtY");

var $dMtsw = parcelRequire("dMtsw");
const $41076b2394f4b7e4$var$mapStateToProps = (state)=>({
        queueId: (0, $3KNsL.getQueueId)(state),
        isQueueVisible: (0, $1RqtY.isQueueVisible)(state)
    });
var $41076b2394f4b7e4$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($41076b2394f4b7e4$var$mapStateToProps, {})((0, $dMtsw.default));

});
parcelRegister("dMtsw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ada17fe006743a9d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9EHc8 = parcelRequire("9EHc8");

var $aNBkj = parcelRequire("aNBkj");

var $eIp1n = parcelRequire("eIp1n");

var $gd0Sp = parcelRequire("gd0Sp");

var $a1gFF = parcelRequire("a1gFF");
function $ada17fe006743a9d$export$2e2bcd8739ae039(props) {
    const { queueId: queueId, children: children, isQueueVisible: isQueueVisible } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
            analyticsSource: "queues",
            experience: "viewQueue",
            experienceId: (0, $aNBkj.fromQueueIdString)(queueId),
            application: (0, $eIp1n.JIRA_SERVICE_DESK),
            edition: tenantContext.appEditions.serviceDesk,
            isExperienceReady: isQueueVisible
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1gFF.default), null), children));
}

});
parcelRegister("a1gFF", function(module, exports) {

$parcel$export(module.exports, "default", () => $442606c33fc789de$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $5Aqh1 = parcelRequire("5Aqh1");

var $4elYi = parcelRequire("4elYi");
const $442606c33fc789de$var$mapStateToProps = (state)=>({
        initialFetchStatus: (0, $5Aqh1.getExperienceTrackingInitialFetchStatus)(state),
        initialFetchFailureEventAttributes: (0, $5Aqh1.getInitialFetchErrorEventAttributes)(state)
    });
var $442606c33fc789de$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($442606c33fc789de$var$mapStateToProps, {})((0, $4elYi.default));

});
parcelRegister("4elYi", function(module, exports) {

$parcel$export(module.exports, "default", () => $96720d83b30010a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwMhr = parcelRequire("kwMhr");

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$96720d83b30010a9$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceResultFromPropsTracker), {
        location: "failed-fetching-initial-data",
        hasSucceeded: props.initialFetchStatus === (0, $749205be6d2f0e96$export$d3ab616c5a76689d),
        hasFailed: props.initialFetchStatus === (0, $749205be6d2f0e96$export$70ef9aa03c29b42b),
        failureEventAttributes: props.initialFetchFailureEventAttributes
    });

});




parcelRegister("eV38i", function(module, exports) {

$parcel$export(module.exports, "default", () => $9606456eb9c0bbb9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $6Sjez = parcelRequire("6Sjez");
var $eo17r = parcelRequire("eo17r");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $bUdM7 = parcelRequire("bUdM7");
class $9606456eb9c0bbb9$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
            onMount: this.onMount
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Sjez.AsyncFlagsDispatcher), {
            mapperFactory: this.getFlagsMapperFactory((0, $bUdM7.default))
        }));
    }
    constructor(...args){
        super(...args);
        this.onMount = (analyticsEvent)=>{
            this.flagsAnalyticEvent = analyticsEvent;
        };
        this.getFlagsMapperFactory = (0, $5iWql.default)((factory)=>(args)=>{
                const mapper = factory(args);
                return (action, state)=>{
                    const flagConfig = mapper(action, state);
                    if (flagConfig) {
                        const { type: type } = action;
                        let analyticsAction = 'viewed';
                        // Only type of DismissFlag has command field
                        // @ts-expect-error - TS2339 - Property 'command' does not exist on type 'DismissFlag | Flag'.
                        if (flagConfig.command) analyticsAction = (0, $eo17r.DISMISS_COMMAND).toLowerCase();
                        this.flagsAnalyticEvent.update({
                            action: analyticsAction
                        });
                        (0, $jMP2a.fireUIAnalytics)(this.flagsAnalyticEvent, `flag ${analyticsAction}`, {
                            actionType: type.split('.').pop()
                        });
                    }
                    return flagConfig;
                };
            });
    }
}

});
parcelRegister("bUdM7", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bf77dad3a09550e$export$2e2bcd8739ae039);

var $hTLlD = parcelRequire("hTLlD");

var $bfxje = parcelRequire("bfxje");

var $kBhD3 = parcelRequire("kBhD3");

var $8vuXb = parcelRequire("8vuXb");

var $cugzJ = parcelRequire("cugzJ");
const $8bf77dad3a09550e$var$WARNING_FLAG_ID = 'WARNING_FLAG_ID';
const $8bf77dad3a09550e$var$FETCH_WARNING_FLAG_ID = 'FETCH_WARNING_FLAG_ID';
const $8bf77dad3a09550e$var$ERROR_FLAG_ID = 'ERROR_FLAG_ID';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8bf77dad3a09550e$export$2e2bcd8739ae039 = ({ dismissFlag: dismissFlag, toFlagId: toFlagId })=>{
    let unsuccessfulFlagId;
    const isErrorFlagDisplayed = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(unsuccessfulFlagId, toFlagId($8bf77dad3a09550e$var$ERROR_FLAG_ID));
    const flagsMapper = (action)=>{
        switch(action.type){
            case 0, $kBhD3.DELETE_QUEUE_FAILURE:
                return (0, $cugzJ.deleteQueueErrorConfig)(action.payload.queueName);
            case 0, $8vuXb.DISPLAY_UNSUCCESSFUL_POLL_WARNING:
                if (unsuccessfulFlagId) return undefined;
                unsuccessfulFlagId = toFlagId($8bf77dad3a09550e$var$WARNING_FLAG_ID);
                return (0, $cugzJ.unsuccessfulPollFlagConfig)(unsuccessfulFlagId);
            case 0, $bfxje.DISPLAY_UNSUCCESSFUL_FETCH_WARNING:
                if (unsuccessfulFlagId) return undefined;
                unsuccessfulFlagId = toFlagId($8bf77dad3a09550e$var$FETCH_WARNING_FLAG_ID);
                return (0, $cugzJ.unsuccessfulFetchFlagConfig)(unsuccessfulFlagId);
            case 0, $bfxje.DISPLAY_UNSUCCESSFUL_FETCH_ERROR:
                if (unsuccessfulFlagId) return undefined;
                unsuccessfulFlagId = toFlagId($8bf77dad3a09550e$var$ERROR_FLAG_ID);
                return (0, $cugzJ.unsuccessfulFetchErrorFlagConfig)(unsuccessfulFlagId);
            case 0, $8vuXb.DISMISS_ALL_FLAGS:
                {
                    if (!unsuccessfulFlagId) return undefined;
                    const dismissAllFlagsConfig = dismissFlag(unsuccessfulFlagId);
                    unsuccessfulFlagId = undefined;
                    return dismissAllFlagsConfig;
                }
            case 0, $8vuXb.DISMISS_WARNING_FLAG:
                {
                    if (!unsuccessfulFlagId || isErrorFlagDisplayed()) return undefined;
                    const dismissWarningFlagConfig = dismissFlag(unsuccessfulFlagId);
                    unsuccessfulFlagId = undefined;
                    return dismissWarningFlagConfig;
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return undefined;
                }
        }
    };
    return flagsMapper;
};

});
parcelRegister("cugzJ", function(module, exports) {

$parcel$export(module.exports, "unsuccessfulFetchFlagConfig", () => $29db8f62274c3d4b$export$1c654f36e3d7dd60);
$parcel$export(module.exports, "unsuccessfulFetchErrorFlagConfig", () => $29db8f62274c3d4b$export$e39d17f9389fd3ea);
$parcel$export(module.exports, "unsuccessfulPollFlagConfig", () => $29db8f62274c3d4b$export$84de65b00282fe10);
$parcel$export(module.exports, "deleteQueueErrorConfig", () => $29db8f62274c3d4b$export$894642f3f2ceae70);

var $lAoHj = parcelRequire("lAoHj");
const $29db8f62274c3d4b$var$reload = ()=>{
    window.location.reload();
};
const $29db8f62274c3d4b$export$1c654f36e3d7dd60 = (id)=>({
        id: id,
        type: 'warning',
        title: (0, $lAoHj.default).warningTitle,
        description: (0, $lAoHj.default).warningDescription,
        appearance: 'warning',
        actions: [
            {
                content: (0, $lAoHj.default).tryAgainButton,
                onClick: $29db8f62274c3d4b$var$reload
            }
        ]
    });
const $29db8f62274c3d4b$export$e39d17f9389fd3ea = (id)=>({
        id: id,
        type: 'error',
        title: (0, $lAoHj.default).errorTitle,
        description: (0, $lAoHj.default).errorOnScrollDescription,
        appearance: 'error'
    });
const $29db8f62274c3d4b$export$84de65b00282fe10 = (id)=>({
        id: id,
        type: 'warning',
        title: (0, $lAoHj.default).warningTitle,
        description: (0, $lAoHj.default).warningDescription,
        appearance: 'warning'
    });
const $29db8f62274c3d4b$export$894642f3f2ceae70 = (queueName)=>({
        type: 'error',
        title: (0, $lAoHj.default).queueDeleteFlagErrorTitle,
        description: [
            (0, $lAoHj.default).queueDeleteFlagErrorDescription,
            {
                queueName: queueName
            }
        ]
    });

});
parcelRegister("lAoHj", function(module, exports) {

$parcel$export(module.exports, "default", () => $70b8ed4fbb382115$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $70b8ed4fbb382115$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    warningTitle: {
        "id": "servicedesk.queues.agent-view.flags.message.warning-title",
        "defaultMessage": "Queue data may be outdated"
    },
    warningDescription: {
        "id": "servicedesk.queues.agent-view.flags.message.warning-description",
        "defaultMessage": "We are unable to refresh the queue data. Check your internet connection."
    },
    errorTitle: {
        "id": "servicedesk.queues.agent-view.flags.message.error-title",
        "defaultMessage": "Problem loading queue"
    },
    errorDescription: {
        "id": "servicedesk.queues.agent-view.flags.message.error-description",
        "defaultMessage": "We couldn't load the queue. Give it a few seconds, then try again."
    },
    errorOnScrollDescription: {
        "id": "servicedesk.queues.agent-view.flags.message.error-on-scroll-description",
        "defaultMessage": "We couldn't load some requests. Check your internet connection."
    },
    tryAgainButton: {
        "id": "servicedesk.queues.agent-view.flags.message.try-again-button",
        "defaultMessage": "Try again"
    },
    queueDeleteFlagErrorTitle: {
        "id": "servicedesk.queues.agent-view.flags.message.queue-delete-flag-error-title",
        "defaultMessage": "Problem deleting queue"
    },
    queueDeleteFlagErrorDescription: {
        "id": "servicedesk.queues.agent-view.flags.message.queue-delete-flag-error-description",
        "defaultMessage": "'{queueName}' couldn't be deleted. Please try again in a few seconds."
    }
});

});




parcelRegister("lUzaT", function(module, exports) {

$parcel$export(module.exports, "IncidentManagementTour", () => $ac0c32ef0d78a9d0$export$f345c7b8b33c1ee8);

var $eUqFw = parcelRequire("eUqFw");

var $bNe1g = parcelRequire("bNe1g");

var $IsF0v = parcelRequire("IsF0v");

var $2zgGr = parcelRequire("2zgGr");

var $f1lMr = parcelRequire("f1lMr");

var $lB25E = parcelRequire("lB25E");
const $ac0c32ef0d78a9d0$export$f345c7b8b33c1ee8 = (props)=>{
    const [practiceType] = (0, $lB25E.usePathParam)('practiceType');
    const { data: isItsmProject } = (0, $IsF0v.useIsItsmTemplateProject)();
    if (isItsmProject !== true) return null;
    return practiceType === (0, $f1lMr.SHORT_FORM_INCIDENTS) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, ({ data: data })=>data && data.isProjectAdmin === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2zgGr.AsyncIncidentManagementTourQueues), props) : null) : null;
};

});
parcelRegister("2zgGr", function(module, exports) {

$parcel$export(module.exports, "AsyncIncidentManagementTourIssue", () => $0fb06167a9630899$export$2dc985b4b00b6eec);
$parcel$export(module.exports, "AsyncIncidentManagementTourQueues", () => $0fb06167a9630899$export$a33c87c292735e8b);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $c5Upq = parcelRequire("c5Upq");

const $0fb06167a9630899$var$IncidentManagementTourIssueComponent = ()=>(parcelRequire("hkKJ5"));

const $0fb06167a9630899$var$IncidentManagementTourQueuesComponent = ()=>(parcelRequire("fJ73a"));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0fb06167a9630899$var$IncidentManagementTourIssueNew = (0, $7rh0R.lazy)(()=>$0fb06167a9630899$var$IncidentManagementTourIssueComponent(), {});
const $0fb06167a9630899$var$AsyncIncidentManagementTourIssueNew = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "incident-management-tour-issue",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0fb06167a9630899$var$IncidentManagementTourIssueNew, props));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0fb06167a9630899$var$IncidentManagementTourQueuesNew = (0, $7rh0R.lazy)(()=>$0fb06167a9630899$var$IncidentManagementTourQueuesComponent(), {});
const $0fb06167a9630899$var$AsyncIncidentManagementTourQueuesNew = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "incident-management-tour-queues",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0fb06167a9630899$var$IncidentManagementTourQueuesNew, props));
const $0fb06167a9630899$export$2dc985b4b00b6eec = (0, $c5Upq.withShouldRenderWithinItsmSampleProject)($0fb06167a9630899$var$AsyncIncidentManagementTourIssueNew, false);
const $0fb06167a9630899$export$a33c87c292735e8b = (0, $c5Upq.withShouldRenderWithinItsmSampleProject)($0fb06167a9630899$var$AsyncIncidentManagementTourQueuesNew, false);

});
parcelRegister("hkKJ5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8kPnV")
]).then(()=>parcelRequire('hMeFY'));

});

parcelRegister("fJ73a", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bCkYG")
]).then(()=>parcelRequire('i4ouu'));

});




parcelRegister("3o0h6", function(module, exports) {

$parcel$export(module.exports, "PageStyle", () => $d0c61d036d967c5f$export$c59987a647e9a55);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9c7gV = parcelRequire("9c7gV");
const $d0c61d036d967c5f$export$c59987a647e9a55 = ({ Page: Page, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0c61d036d967c5f$var$JSDSpaPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Page, null, children));
$d0c61d036d967c5f$export$c59987a647e9a55.defaultProps = {
    Page: (0, $9c7gV.default)
};
var $d0c61d036d967c5f$export$2e2bcd8739ae039 = $d0c61d036d967c5f$export$c59987a647e9a55;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d0c61d036d967c5f$var$JSDSpaPageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8zdiv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9c7gV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4be3daaa307b075d$export$2e2bcd8739ae039);

var $aJWi0 = parcelRequire("aJWi0");

var $j7bQJ = parcelRequire("j7bQJ");

var $6tahE = parcelRequire("6tahE");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$4be3daaa307b075d$export$2e2bcd8739ae039 = (0, $aJWi0.default);

});
parcelRegister("aJWi0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7341c6e5fd381e79$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");
function $7341c6e5fd381e79$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7341c6e5fd381e79$var$bannerStyles = {
    name: "4oew4k",
    styles: "width:100%;position:fixed"
};
const $7341c6e5fd381e79$var$bannerContainerStyles = {
    name: "1x3pv69",
    styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
};
const $7341c6e5fd381e79$var$pageContentStyles = {
    name: "15n167b",
    styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
};
const $7341c6e5fd381e79$var$wrapperStyles = {
    name: "m5v4sl",
    styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
};
const $7341c6e5fd381e79$var$mainContainerStyles = {
    name: "1cete8c",
    styles: "display:flex;flex:1 1 auto"
};
const $7341c6e5fd381e79$var$navigationStyles = {
    name: "wrqbg1",
    styles: "position:relative;z-index:2"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $7341c6e5fd381e79$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $cuCEk.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$wrapperStyles,
        "data-testid": testId
    }, banner ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? `${bannerHeight}px` : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? `${testId}--banner-container` : undefined
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$bannerStyles
    }, banner)) : null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$mainContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$navigationStyles
    }, navigation), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7341c6e5fd381e79$var$pageContentStyles
    }, children)));
};
var $7341c6e5fd381e79$export$2e2bcd8739ae039 = $7341c6e5fd381e79$var$Page;

});
parcelRegister("cuCEk", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $63536614c324c20f$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $63536614c324c20f$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $63536614c324c20f$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $63536614c324c20f$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $63536614c324c20f$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $63536614c324c20f$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $63536614c324c20f$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $63536614c324c20f$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $63536614c324c20f$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $63536614c324c20f$export$936829b4511db3e4);
const $63536614c324c20f$export$3aaf3a78c909ea56 = 8;
const $63536614c324c20f$export$74797698e12f8baa = 12;
const $63536614c324c20f$export$b8241a1616ab1b96 = $63536614c324c20f$export$3aaf3a78c909ea56 * 10;
const $63536614c324c20f$export$2a89a65a43bab52d = {
    comfortable: $63536614c324c20f$export$3aaf3a78c909ea56 * 5,
    cosy: $63536614c324c20f$export$3aaf3a78c909ea56 * 2,
    compact: $63536614c324c20f$export$3aaf3a78c909ea56 * 0.5
};
const $63536614c324c20f$export$8ec7372efd74b753 = 'cosy';
const $63536614c324c20f$export$d77f83c3d17a7b8a = 52;
const $63536614c324c20f$export$f8725d21f81f3e01 = 0;
const $63536614c324c20f$export$2303d2bd9eeff99a = 'fixed';
const $63536614c324c20f$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $63536614c324c20f$export$8b7e31f391e6e681 = '--ds-column-span';
const $63536614c324c20f$export$936829b4511db3e4 = '--ds-grid-spacing';

});


parcelRegister("j7bQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $21cf405c5617943d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");

var $gw8fk = parcelRequire("gw8fk");

var $6tahE = parcelRequire("6tahE");

var $02LzD = parcelRequire("02LzD");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $21cf405c5617943d$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const { medium: medium } = (0, $eUqFw.useContext)((0, $6tahE.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $cuCEk.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $cuCEk.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02LzD.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gw8fk.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $21cf405c5617943d$export$2e2bcd8739ae039 = $21cf405c5617943d$var$GridWrapper;

});
parcelRegister("gw8fk", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $7946ba115b4da3a8$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
function $7946ba115b4da3a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7946ba115b4da3a8$var$gridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $7946ba115b4da3a8$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $cuCEk.varColumnsNum)}) * ${(0, $cuCEk.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $7946ba115b4da3a8$var$nestedGridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $cuCEk.varGridSpacing)}))`
});
const $7946ba115b4da3a8$export$ef2184bd89960b14 = ({ layout: layout = (0, $cuCEk.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $7946ba115b4da3a8$var$gridStyles,
            $7946ba115b4da3a8$var$gridLayoutStyles[layout],
            isNested && $7946ba115b4da3a8$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varGridSpacing)]: `${(0, $cuCEk.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("02LzD", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $abe6d6b3e91c4986$export$11cae3e04ab99fae);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");
const $abe6d6b3e91c4986$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $cuCEk.defaultSpacing),
    columns: (0, $cuCEk.defaultGridColumns)
});

});


parcelRegister("6tahE", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $384e4fce86f51330$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $384e4fce86f51330$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
var $384e4fce86f51330$var$ColumnVariant;
/**
 * Determines the method by which column width is calculated.
 */ (function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
})($384e4fce86f51330$var$ColumnVariant || ($384e4fce86f51330$var$ColumnVariant = {}));
const $384e4fce86f51330$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $cuCEk.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $384e4fce86f51330$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $384e4fce86f51330$var$singleColumnWidth = `(${$384e4fce86f51330$var$availableWidth} / var(${(0, $cuCEk.varColumnsNum)}))`;
const $384e4fce86f51330$var$gridColumnStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} - var(${(0, $cuCEk.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $384e4fce86f51330$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} *  var(${(0, $cuCEk.varColumnSpan)}) - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $384e4fce86f51330$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    medium: (0, $cuCEk.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $384e4fce86f51330$var$GridColumn = ({ medium: medium = (0, $cuCEk.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $384e4fce86f51330$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)($384e4fce86f51330$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $384e4fce86f51330$var$gridColumnStyles,
            $384e4fce86f51330$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $384e4fce86f51330$export$2e2bcd8739ae039 = $384e4fce86f51330$var$GridColumn;

});




parcelRegister("jK1pm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f009785aaee067$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $3Hphq = parcelRequire("3Hphq");

var $fYqUr = parcelRequire("fYqUr");

var $5crv8 = parcelRequire("5crv8");
/** A portion of the page we apply measurement to */ function $f6f009785aaee067$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $3Hphq.useInteractionContext)();
    const relayProfilerContext = (0, $eUqFw.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $eUqFw.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    this.getInteractionContext().addPreload((0, $fYqUr.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $fYqUr.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children));
}
function $f6f009785aaee067$export$2e2bcd8739ae039({ name: segmentName, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5crv8.default), {
        name: segmentName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6f009785aaee067$var$JiraUFOSegmentWrapper, null, children));
}

});

parcelRegister("9CCgP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba1ecc366c9ff44$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2CgwC = parcelRequire("2CgwC");

var $ewJfY = parcelRequire("ewJfY");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $0cdA8 = parcelRequire("0cdA8");

var $3QLcd = parcelRequire("3QLcd");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $1R3n5 = parcelRequire("1R3n5");

var $dpbDO = parcelRequire("dpbDO");
function $1ba1ecc366c9ff44$var$CipherDeprecationBanner() {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "jiraQueueViewCipherDeprecationBanner",
        packageName: "jiraSpaAppsServicedeskQueuesAgentView",
        teamName: "jsd-shield"
    }, isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2CgwC.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $1ba1ecc366c9ff44$var$bannerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ewJfY))), {
        label: "Warning",
        color: "var(--ds-icon-warning-inverse, #172B4D)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, formatMessage((0, $dpbDO.default).cipherDeprecationMessage, {
        button: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
                articleId: "6bSBVhywj4oQDe7rCDr9tT",
                appearance: "subtle-link",
                spacing: "none",
                onClick: (e, analyticsEvent)=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'learnMoreAboutLatestEmailCiphersLink'),
                fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, chunks)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $1ba1ecc366c9ff44$var$linkTextStyles
            }, chunks))
    })))));
}
const $1ba1ecc366c9ff44$var$bannerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    columnGap: 'space.100'
});
const $1ba1ecc366c9ff44$var$linkTextStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.warning.inverse',
    textDecoration: 'underline'
});
var $1ba1ecc366c9ff44$export$2e2bcd8739ae039 = $1ba1ecc366c9ff44$var$CipherDeprecationBanner;

});
parcelRegister("dpbDO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c03641788ccb5a29$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c03641788ccb5a29$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    cipherDeprecationMessage: {
        "id": "spa-apps-servicedesk-queues-agent-view.content.cipher-deprecation-banner.cipher-deprecation-message",
        "defaultMessage": "Verify that your <button>email server uses the latest ciphers</button> to receive requests and comments from connected email accounts."
    }
});

});



parcelRegister("guZLT", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc41b9ab1a2fec5f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $foc4i = parcelRequire("foc4i");

var $g3JCd = parcelRequire("g3JCd");

var $fJAmy = parcelRequire("fJAmy");

var $4YkVK = parcelRequire("4YkVK");

var $cVYSD = parcelRequire("cVYSD");

var $gd0Sp = parcelRequire("gd0Sp");

var $jK1pm = parcelRequire("jK1pm");

var $lB25E = parcelRequire("lB25E");
const $cc41b9ab1a2fec5f$var$LegacyIssueView = (props)=>{
    const { push: push, match: match } = props;
    const [{ location: location }] = (0, $lB25E.useRouter)();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const projectKey = match && match.params && match.params.projectKey ? match.params.projectKey : undefined;
    const [{ data: kbLink, loading: loading }] = (0, $4YkVK.useKbConfluenceContext)(projectKey);
    const { locale: locale } = tenantContext;
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null);
    return match && match.params && match.params.issueKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "queues-legacy-issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fJAmy.Page), {
        entity: match.params.queueId || '',
        issueKey: match.params.issueKey,
        onNavigation: push,
        locale: locale,
        wrmDataForPage: {
            'com.atlassian.servicedesk.core-ui:util-base-url.base-url': `https://${// @ts-expect-error - TS2339 - Property 'host' does not exist on type 'Location'.
            location.host || window.location.host}`,
            moment_user_locale: locale,
            'sd-kb-link': kbLink
        },
        pathname: location.pathname
    })) : null;
};
const $cc41b9ab1a2fec5f$var$QueuesIssueViewContent = (props)=>{
    const { pageContext: pageContext, push: push, match: match, issueNavigatorData: issueNavigatorData } = props;
    const { isProjectSimplified: isProjectSimplified, canSeeNewIssueView: canSeeNewIssueView } = pageContext;
    const [{ location: { search: search } }] = (0, $lB25E.useRouter)();
    const { showLegacyIssueView: showLegacyIssueView } = (0, $cVYSD.useShouldShowLegacyIssueView)(isProjectSimplified, canSeeNewIssueView, search);
    if (showLegacyIssueView) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc41b9ab1a2fec5f$var$LegacyIssueView, {
        push: push,
        match: match
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "queues-issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3JCd.default), {
        issueNavigatorData: issueNavigatorData
    }));
};
var $cc41b9ab1a2fec5f$export$2e2bcd8739ae039 = $cc41b9ab1a2fec5f$var$QueuesIssueViewContent;

});
parcelRegister("g3JCd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6434ce5bd980a8ef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $jBy23 = parcelRequire("jBy23");

var $iEcUp = parcelRequire("iEcUp");

var $hgiIU = parcelRequire("hgiIU");

var $jc4kK = parcelRequire("jc4kK");

var $2bMHt = parcelRequire("2bMHt");

var $jK1pm = parcelRequire("jK1pm");

var $asM86 = parcelRequire("asM86");
let $6434ce5bd980a8ef$var$dispatchExternalAction;
const $6434ce5bd980a8ef$var$getIssueKey = ()=>(0, $iEcUp.parseIssueKey)(window.location.href);
const $6434ce5bd980a8ef$var$getPreviousUrl = ()=>{
    const urlParts = window.location.href.split('/');
    return urlParts.slice(0, urlParts.length - 1).join('/');
};
const $6434ce5bd980a8ef$var$queueRoutesPattern = Object.values((0, $2bMHt.QUEUE_ROUTES)).join('|').replace(/\//g, '\\/');
const $6434ce5bd980a8ef$var$QUEUES_URL_REGEX = new RegExp(`.*\\/projects\\/[^/]+\\/(${$6434ce5bd980a8ef$var$queueRoutesPattern})\\/custom\\/.*`);
const $6434ce5bd980a8ef$var$isComingFromQueue = ()=>window.location.pathname.match($6434ce5bd980a8ef$var$QUEUES_URL_REGEX);
const $6434ce5bd980a8ef$var$REPORTS_URL_REGEX = /.*\/projects\/[^/]+\/reports\/.*/;
const $6434ce5bd980a8ef$var$isComingFromReport = ()=>window.location.pathname.match($6434ce5bd980a8ef$var$REPORTS_URL_REGEX);
const $6434ce5bd980a8ef$var$isComingFromQueueOrReport = ()=>$6434ce5bd980a8ef$var$isComingFromQueue() || $6434ce5bd980a8ef$var$isComingFromReport();
const $6434ce5bd980a8ef$var$redirectAfterSuccessfulDelete = ()=>()=>{
        const issueKey = $6434ce5bd980a8ef$var$getIssueKey();
        const projectKey = (0, $jBy23.extractProjectKey)(issueKey);
        let url;
        if ($6434ce5bd980a8ef$var$isComingFromQueueOrReport()) url = $6434ce5bd980a8ef$var$getPreviousUrl();
        else url = `/projects/${projectKey}`;
        window.location.assign(url);
    };
(0, $hgiIU.listenToExternalActionFromLegacy)(()=>({
        dispatchExternalAction: $6434ce5bd980a8ef$var$dispatchExternalAction,
        modifiedIssueIssueKey: $6434ce5bd980a8ef$var$getIssueKey()
    }));
const $6434ce5bd980a8ef$var$onDispatchExternalActionRef = (ref)=>{
    if (ref) $6434ce5bd980a8ef$var$dispatchExternalAction = ref;
};
const $6434ce5bd980a8ef$var$getAnalyticsSourceFromUrl = ()=>{
    const { pathname: pathname } = window.location;
    if (pathname.includes('section')) return 0, $0100842672acae20$export$7063ee6d0035a982;
    if (pathname.includes('queues')) return 0, $0100842672acae20$export$7063ee6d0035a982;
    return 0, $0100842672acae20$export$5bd5011b6596a0e7;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6434ce5bd980a8ef$export$2e2bcd8739ae039 = ({ issueNavigatorData: issueNavigatorData } = {})=>{
    (0, $jc4kK.markFragmentReady)();
    const issueKey = $6434ce5bd980a8ef$var$getIssueKey();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "jsm-issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $asM86.default), {
        backButtonUrl: $6434ce5bd980a8ef$var$isComingFromQueueOrReport() ? $6434ce5bd980a8ef$var$getPreviousUrl() : undefined,
        issueNavigatorData: issueNavigatorData,
        analyticsSource: $6434ce5bd980a8ef$var$getAnalyticsSourceFromUrl(),
        issueKey: issueKey,
        onIssueDeleteSuccess: $6434ce5bd980a8ef$var$redirectAfterSuccessfulDelete(),
        onDispatchExternalActionRef: $6434ce5bd980a8ef$var$onDispatchExternalActionRef
    }));
};

});
parcelRegister("jBy23", function(module, exports) {

$parcel$export(module.exports, "extractProjectKey", () => $7901038b5997e3c0$export$f1a2e4721b127828);

var $6vrw7 = parcelRequire("6vrw7");
const $7901038b5997e3c0$export$f1a2e4721b127828 = (issueKey)=>(0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);

});

parcelRegister("iEcUp", function(module, exports) {

$parcel$export(module.exports, "parseIssueKey", () => $bfe586d9caaf9342$export$775cba7641fc60e9);

var $6vrw7 = parcelRequire("6vrw7");
const $bfe586d9caaf9342$export$775cba7641fc60e9 = (href)=>{
    const path = href.split('/').pop();
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    return (0, $6vrw7.toIssueKey)(path.split('?')[0].split('#')[0]);
};

});

parcelRegister("hgiIU", function(module, exports) {

$parcel$export(module.exports, "listenToExternalActionFromLegacy", () => $c80637eb06558544$export$60376d8e2c7d8037);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
const $c80637eb06558544$export$60376d8e2c7d8037 = (getDispatcherAndModifiedIssue)=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $2BvS3.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    }).then((Events)=>{
        Events.bind('modify-issue-view-via-external-action', (e, payload)=>{
            const { issueKey: issueKey, externalAction: externalAction } = payload;
            const { dispatchExternalAction: dispatchExternalAction, modifiedIssueIssueKey: modifiedIssueIssueKey } = getDispatcherAndModifiedIssue();
            if (issueKey === modifiedIssueIssueKey && externalAction && dispatchExternalAction) dispatchExternalAction(externalAction);
        });
    });
};

});

parcelRegister("jc4kK", function(module, exports) {

$parcel$export(module.exports, "markFragmentReady", () => $3ef0a8a6a82c0ed3$export$f35671de67f03a2b);
$parcel$export(module.exports, "initialiseMetrics", () => $3ef0a8a6a82c0ed3$export$1ac307e078c767d0);
$parcel$export(module.exports, "markIssueStartRendering", () => $3ef0a8a6a82c0ed3$export$c039505b02c87616);
$parcel$export(module.exports, "markIssueRender", () => $3ef0a8a6a82c0ed3$export$c16cf8a32075f588);
$parcel$export(module.exports, "markIssueLegacyInteractive", () => $3ef0a8a6a82c0ed3$export$4d5d547fdbe28097);
$parcel$export(module.exports, "markSPAReadyEndOfCriticalPath", () => $3ef0a8a6a82c0ed3$export$a45a77102d75517f);
$parcel$export(module.exports, "markIssueInteractive", () => $3ef0a8a6a82c0ed3$export$e57956c4b76a36f);
$parcel$export(module.exports, "markIssueOnPageLoadEvent", () => $3ef0a8a6a82c0ed3$export$c30d9392d27ab5a8);
$parcel$export(module.exports, "markStartIssue", () => $3ef0a8a6a82c0ed3$export$71cdf78946f275c);
$parcel$export(module.exports, "markIssuePreviewRendered", () => $3ef0a8a6a82c0ed3$export$7f5545008a1e5a18);
$parcel$export(module.exports, "setIsInitialRender", () => $3ef0a8a6a82c0ed3$export$eedeaa0a5b3bd3d1);
$parcel$export(module.exports, "isFullIssueView", () => $3ef0a8a6a82c0ed3$export$db2ef91f6ace96c7);

var $hompL = parcelRequire("hompL");

var $hknOo = parcelRequire("hknOo");

var $6iz4v = parcelRequire("6iz4v");

var $gUUjF = parcelRequire("gUUjF");

var $6xYPC = parcelRequire("6xYPC");

var $eI5EY = parcelRequire("eI5EY");


var $RvFPW = parcelRequire("RvFPW");

var $g0N0Z = parcelRequire("g0N0Z");

var $8Bhia = parcelRequire("8Bhia");

var $782cd = parcelRequire("782cd");

var $lMwBY = parcelRequire("lMwBY");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $iTvzN = parcelRequire("iTvzN");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $fbE19 = parcelRequire("fbE19");

var $fYqUr = parcelRequire("fYqUr");

var $9OxOE = parcelRequire("9OxOE");

var $7iu2Y = parcelRequire("7iu2Y");

var $gU59E = parcelRequire("gU59E");

var $7YIVI = parcelRequire("7YIVI");
const $3ef0a8a6a82c0ed3$var$LOG_LOCATION = 'issue.metrics';
let $3ef0a8a6a82c0ed3$var$state;
const $3ef0a8a6a82c0ed3$var$getSsrMark = ()=>{
    const ssrMark = (0, $6iz4v.getMark)((0, $hknOo.SPA_SSR_RENDERED_MARK));
    if (ssrMark != null) return Math.floor(ssrMark.startTime);
    return null;
};
const $3ef0a8a6a82c0ed3$var$setMarkWithError = (markName)=>{
    try {
        (0, $6iz4v.setMark)(markName);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData($3ef0a8a6a82c0ed3$var$LOG_LOCATION, 'Setting performance mark failed', error);
    }
};
const $3ef0a8a6a82c0ed3$export$f35671de67f03a2b = ()=>{
    $3ef0a8a6a82c0ed3$var$setMarkWithError($848ef1328a091c81$export$625e4e4c6eb56930);
};
const $3ef0a8a6a82c0ed3$export$1ac307e078c767d0 = (options)=>{
    try {
        const { issueContextActions: issueContextActions, isLoadedWithPage: isLoadedWithPage, isSPA: isSPA, isRecentIssue: isRecentIssue, recentIssuesCount: recentIssuesCount, dataProvider: dataProvider, analyticsSource: analyticsSource, store: store, route: route } = options;
        $3ef0a8a6a82c0ed3$var$state = new (0, $gU59E.default)({
            isLoadedWithPage: isLoadedWithPage,
            isSPA: isSPA,
            isRecentIssue: isRecentIssue,
            analyticsSource: analyticsSource,
            recentIssuesCount: recentIssuesCount,
            correlationId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
            // @ts-expect-error - TS2322 - Type '{ analyticsKey: ApplicationKey | undefined; viewMode: any; issueId: string | undefined; }' is not assignable to type 'MetricsProps'.
            lazyMetricsProps: ()=>(0, $7YIVI.metricsStateSelector)(store.getState()),
            timingDataReporter: ()=>({
                    ...(0, $782cd.serverTimingSelector)(store.getState()),
                    ...(0, $RvFPW.getFetchIssueNetworkTimes)()
                }),
            issueScaleabilityReporter: (0, $7iu2Y.issueScaleabilityReporterFactory)(store, issueContextActions),
            dataProvider: dataProvider,
            route: route
        });
        // Marking init of bm3
        (0, $g0N0Z.issueViewLoad).mark('metrics_init');
        (0, $g0N0Z.issueViewOnPageLoad).mark('metrics_init');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData($3ef0a8a6a82c0ed3$var$LOG_LOCATION, 'Failed to initialise issue metrics', error);
    }
};
const $3ef0a8a6a82c0ed3$export$c039505b02c87616 = ()=>{
    $3ef0a8a6a82c0ed3$var$setMarkWithError($848ef1328a091c81$export$10082883a7f4ea4d);
    (0, $g0N0Z.issueViewLoad).mark($848ef1328a091c81$export$10082883a7f4ea4d);
};
const $3ef0a8a6a82c0ed3$export$c16cf8a32075f588 = ()=>{
    $3ef0a8a6a82c0ed3$var$setMarkWithError($848ef1328a091c81$export$7f7b606f70e669e6);
    (0, $g0N0Z.issueViewOnPageLoad).mark($848ef1328a091c81$export$7f7b606f70e669e6);
};
const $3ef0a8a6a82c0ed3$export$4d5d547fdbe28097 = ()=>{
    $3ef0a8a6a82c0ed3$var$setMarkWithError($848ef1328a091c81$export$b292c195104c50d3);
    (0, $g0N0Z.issueViewLoad).mark($848ef1328a091c81$export$b292c195104c50d3);
};
const $3ef0a8a6a82c0ed3$export$8bc8bca4478fe6d7 = (markTime)=>{
    (0, $g0N0Z.issueViewOnPageLoad).mark($848ef1328a091c81$export$4d1080224e02ef0b, markTime);
};
const $3ef0a8a6a82c0ed3$export$a45a77102d75517f = ()=>{
    $3ef0a8a6a82c0ed3$var$setMarkWithError($848ef1328a091c81$export$434b58ebadf14df2);
    (0, $g0N0Z.issueViewLoad).mark($848ef1328a091c81$export$434b58ebadf14df2);
};
const $3ef0a8a6a82c0ed3$var$getSharedCustomData = ()=>({
        ...$3ef0a8a6a82c0ed3$var$state.getIssueScaleabilityReporter()(),
        ...(0, $9OxOE.getBackendBlockingTime)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            issueViewLoad: (0, $g0N0Z.issueViewLoad)
        }),
        isBentoRecentIssue: $3ef0a8a6a82c0ed3$var$state.getIsRecentIssue(),
        bentoRecentIssuesCount: $3ef0a8a6a82c0ed3$var$state.getRecentIssuesCount(),
        correlationId: $3ef0a8a6a82c0ed3$var$state.getCorrelationId(),
        ...(0, $eI5EY.fg)('enable-metric-full-page-bundle-load-count') ? {
            initialLoadFullPageBundleLoadCount: $3ef0a8a6a82c0ed3$var$state.getIsInitial() ? performance.getEntriesByType('resource').filter((x)=>x.name.includes('async-issue-app--full-page')).length : 0
        } : {}
    });
const $3ef0a8a6a82c0ed3$export$e57956c4b76a36f = ({ lastTransitionTime: // TODO JIV-14563 Fixup or remove embeddedIssueTTI in BM3 metrics due to broken lastTransitionStartTime
// @ts-expect-error - this has never been wired up correctly, I only just discovered it by adding types for the data that is actually passed through.
lastTransitionTime })=>{
    const isFullIssue = $3ef0a8a6a82c0ed3$var$state.getIsFullIssue();
    $3ef0a8a6a82c0ed3$var$state.setInteractiveEnd(performance.now());
    if ($3ef0a8a6a82c0ed3$var$state) {
        const startTime = lastTransitionTime || $3ef0a8a6a82c0ed3$var$state.getStartTime();
        if ($3ef0a8a6a82c0ed3$var$state.getIsFullIssue()) (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
        const embeddedCustomData = !isFullIssue ? {
            embeddedIssueFMP: Math.floor($3ef0a8a6a82c0ed3$var$state.getFMP()),
            embeddedIssueTTI: Math.floor($3ef0a8a6a82c0ed3$var$state.getInteractiveEnd() - startTime),
            analyticsSource: $3ef0a8a6a82c0ed3$var$state.getAnalyticsSource(),
            featureFlags: Object.fromEntries((0, $fbE19.allFeatureFlagsAccessed))
        } : {};
        const perfConfig = {
            stopTime: $3ef0a8a6a82c0ed3$var$state.getInteractiveEnd(),
            customData: {
                ...$3ef0a8a6a82c0ed3$var$getSharedCustomData(),
                ...embeddedCustomData
            }
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $3iMaY.addUFOCustomData)(perfConfig.customData);
        const ufoMetricKey = isFullIssue ? 'issue-view' : 'issue-embed';
        (0, $fYqUr.addApdexToAll)({
            key: ufoMetricKey,
            startTime: isFullIssue ? undefined : (0, $g0N0Z.embeddedIssueViewLoad).getData()?.start ?? undefined,
            stopTime: perfConfig.stopTime
        });
        if (isFullIssue) (0, $eJ3kO.addBM3TimingsToUFO)((0, $g0N0Z.issueViewLoad).getData()?.marks, (0, $g0N0Z.issueViewLoad).getData()?.config.timings);
        if (isFullIssue && (0, $8Bhia.isBM3EmitOnRafTopExperiencesEnabled)()) (0, $lMwBY.afterPaintEmit)(()=>{
            // @ts-expect-error payload type mismatch with optional values
            (0, $g0N0Z.issueViewLoad).stop(perfConfig);
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $g0N0Z.issueViewLoad));
        else // @ts-expect-error payload type mismatch with optional values
        (0, $g0N0Z.issueViewLoad).stop(perfConfig);
        (0, $iTvzN.markUimTtiIssueViewLoaded)();
        if (!isFullIssue) // See markStartIssue for more information.
        {
            if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
        }
    }
};
const $3ef0a8a6a82c0ed3$var$getBrowserNavigationMetrics = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0 || !(entries[0] instanceof PerformanceNavigationTiming)) return null;
    const navigation = entries[0];
    return {
        connectEnd: Math.round(navigation.connectEnd),
        connectStart: Math.round(navigation.connectStart),
        domComplete: Math.round(navigation.domComplete),
        domContentLoadedEventEnd: Math.round(navigation.domContentLoadedEventEnd),
        domContentLoadedEventStart: Math.round(navigation.domContentLoadedEventStart),
        domInteractive: Math.round(navigation.domInteractive),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        fetchStart: Math.round(navigation.fetchStart),
        loadEventStart: Math.round(navigation.loadEventStart),
        requestStart: Math.round(navigation.requestStart),
        responseEnd: Math.round(navigation.responseEnd),
        responseStart: Math.round(navigation.responseStart),
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        redirectCount: navigation.redirectCount,
        type: navigation.type
    };
};
const $3ef0a8a6a82c0ed3$export$c30d9392d27ab5a8 = ()=>{
    const isFullIssue = $3ef0a8a6a82c0ed3$var$state.getIsFullIssue();
    if (!isFullIssue) return;
    if ($3ef0a8a6a82c0ed3$var$state) {
        try {
            new PerformanceObserver((entryList)=>{
                entryList.getEntries().forEach((entry)=>$3ef0a8a6a82c0ed3$export$8bc8bca4478fe6d7(entry.startTime));
            }).observe({
                type: 'largest-contentful-paint',
                buffered: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
        // do nothing
        }
        const customData = {
            ...$3ef0a8a6a82c0ed3$var$getSharedCustomData(),
            browserNavigationMetrics: $3ef0a8a6a82c0ed3$var$getBrowserNavigationMetrics()
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $g0N0Z.issueViewOnPageLoad).stop(customData);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $3iMaY.addUFOCustomData)(customData);
    }
};
const $3ef0a8a6a82c0ed3$export$71cdf78946f275c = (isFullPage = false)=>{
    (0, $g0N0Z.issueViewLoad).start();
    if (!isFullPage) {
        (0, $g0N0Z.embeddedIssueViewLoad).start({
            startTime: performance.now()
        });
        /**
		 * All SPA full page loads already start the event delay through the
		 * usePageLoadedSubscriber hook in @atlassian/jira-event-delay-controller.
		 * The embedded views need to start this critical section explicitly here because
		 * there is no equivalent hook that is generically applicable to all experiences.
		 *
		 * The only events that currently leverage the delay mechanism are the automatic
		 * exposure events, so we can avoid the overhead of starting this critical section
		 * if it won't be necessary.
		 */ if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.startLowPriorityEventDelay)();
    }
    if (isFullPage) (0, $g0N0Z.issueViewOnPageLoad).start({
        startTime: 0
    });
    (0, $iTvzN.startUimTti)();
};
const $3ef0a8a6a82c0ed3$export$7f5545008a1e5a18 = ({ isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime })=>{
    const ssrMark = $3ef0a8a6a82c0ed3$var$getSsrMark();
    const previewTime = performance.now();
    const startTime = $3ef0a8a6a82c0ed3$var$state.getStartTime();
    let fmp = 0;
    if ($3ef0a8a6a82c0ed3$var$state.getIsFullIssue()) {
        if (isInitialRender) // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number'.
        fmp = ssrMark;
        else fmp = previewTime - (lastTransitionStartTime || startTime);
    } else fmp = previewTime - startTime;
    (0, $g0N0Z.issueViewLoad).mark($848ef1328a091c81$export$62c04f0e896827e3);
    (0, $g0N0Z.issueViewOnPageLoad).mark($848ef1328a091c81$export$62c04f0e896827e3);
    $3ef0a8a6a82c0ed3$var$state.setFMP(fmp);
    $3ef0a8a6a82c0ed3$var$state.setPreviewEnd(previewTime);
    $3ef0a8a6a82c0ed3$var$setMarkWithError($848ef1328a091c81$export$62c04f0e896827e3);
};
const $3ef0a8a6a82c0ed3$export$eedeaa0a5b3bd3d1 = (isInitialRender)=>{
    if ($3ef0a8a6a82c0ed3$var$state) $3ef0a8a6a82c0ed3$var$state.setIsLoadedWithPage(isInitialRender);
};
const $3ef0a8a6a82c0ed3$export$db2ef91f6ace96c7 = ()=>$3ef0a8a6a82c0ed3$var$state && $3ef0a8a6a82c0ed3$var$state.getIsFullIssue();

});
const $848ef1328a091c81$export$625e4e4c6eb56930 = 'ISSUE_FRAGMENT_READY_MARK';
const $848ef1328a091c81$export$10082883a7f4ea4d = 'ISSUE_START_RENDERING_MARK';
const $848ef1328a091c81$export$62c04f0e896827e3 = 'ISSUE_PREVIEW_RENDERED';
const $848ef1328a091c81$export$5db08809a3f311ed = 'ISSUE_FETCHED_MARK';
const $848ef1328a091c81$export$c21b33196a19ec61 = 'ISSUE_START_FETCHING_DATA';
const $848ef1328a091c81$export$e64e32643802b552 = 'ISSUE_READY_FOR_DATA';
const $848ef1328a091c81$export$e52cc35f872875f7 = 'ISSUE_DATA_AVAILABLE';
const $848ef1328a091c81$export$91b5cb94c32a9b = 'ISSUE_CACHED_CONTENT_LOADED';
const $848ef1328a091c81$export$205779a1d31dbc62 = 'ssr.issue.rendered';
const $848ef1328a091c81$export$bfb91b09e6b87d3c = 'ISSUE_START_GIRA_FETCH';
const $848ef1328a091c81$export$beb8599162403c36 = 'ISSUE_FINISH_GIRA_FETCH';
const $848ef1328a091c81$export$3a9e4a905dec520d = 'ISSUE_MOUNTED';
const $848ef1328a091c81$export$7f7b606f70e669e6 = 'ISSUE_RENDERED';
const $848ef1328a091c81$export$b292c195104c50d3 = 'ISSUE_LEGACY_INTERACTIVE';
const $848ef1328a091c81$export$434b58ebadf14df2 = 'ISSUE_SPA_MARKED_READY_END_OF_CRITICAL_PATH';
const $848ef1328a091c81$export$4d1080224e02ef0b = 'LCP_CANDIDATE';
const $848ef1328a091c81$export$a98a3196940af8fa = 'issueViewCriticalData-agg-suspense';
const $848ef1328a091c81$export$7b35970640b1e1c0 = 'issueViewCriticalData-gira-suspense';
const $848ef1328a091c81$export$1ea0ab50283b82a8 = 'issueViewCriticalData-redux';

parcelRegister("RvFPW", function(module, exports) {

$parcel$export(module.exports, "clearFetchIssueNetworkTimes", () => $65ddff06319f9633$export$8d777cefeb6b914e);
$parcel$export(module.exports, "getFetchIssueNetworkTimes", () => $65ddff06319f9633$export$48cecd0d00931806);

var $8ITzY = parcelRequire("8ITzY");

var $hgcvd = parcelRequire("hgcvd");

var $cUHte = parcelRequire("cUHte");
const $65ddff06319f9633$var$fetchIssueNetworkMarks = [
    (0, $cUHte.fetchUploadPerf),
    (0, $cUHte.fetchCommentsPerf),
    (0, $cUHte.fetchIssuePropertiesPerf),
    (0, $cUHte.fetchIssueLinkPerf),
    (0, $cUHte.fetchViewContextPerf),
    (0, $cUHte.fetchSubtaskTypesPerf),
    (0, $cUHte.fetchFieldDataPerf),
    (0, $cUHte.fetchUserAuthPerf)
];
// Data remains the same once called once (for the same issue), so we cache it
// here for future requests for this data due to the calculation wiping the
//  performance marks required to calculate.  It does however need to be reset
// in cases like subtask click throughs when we load a new issue.
let $65ddff06319f9633$var$fetchIssueNetworkTimes;
const $65ddff06319f9633$var$calculateFetchIssueNetworkTimes = ()=>{
    const issueNetworkTimes = $65ddff06319f9633$var$fetchIssueNetworkMarks.reduce((obj, perf)=>{
        const beginMarkName = `BEGIN_${perf.prefix}_${perf.key}`;
        const endMarkName = `END_${perf.prefix}_${perf.key}`;
        const networkTime = (0, $8ITzY.timeBetweenMarks)(beginMarkName, endMarkName);
        if (networkTime != null && networkTime > 0) {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            const aggregated = {
                ...obj,
                [`${perf.key}_NETWORK`]: networkTime
            };
            // This is vital to clear mark after use.  Or next call will failed to add the mark of same name.
            if ((0, $hgcvd.default).clearMarks) {
                (0, $hgcvd.default).clearMarks(beginMarkName);
                (0, $hgcvd.default).clearMarks(endMarkName);
            }
            return aggregated;
        }
        return obj;
    }, {});
    return issueNetworkTimes;
};
const $65ddff06319f9633$export$8d777cefeb6b914e = ()=>{
    $65ddff06319f9633$var$fetchIssueNetworkMarks.forEach((perf)=>{
        const beginMarkName = `BEGIN_${perf.prefix}_${perf.key}`;
        const endMarkName = `END_${perf.prefix}_${perf.key}`;
        if ((0, $hgcvd.default).clearMarks) {
            (0, $hgcvd.default).clearMarks(beginMarkName);
            (0, $hgcvd.default).clearMarks(endMarkName);
        }
    });
    $65ddff06319f9633$var$fetchIssueNetworkTimes = null;
    window.ISSUE_DATA_AVAILABLE = null;
};
const $65ddff06319f9633$export$48cecd0d00931806 = ()=>{
    if (!$65ddff06319f9633$var$fetchIssueNetworkTimes) $65ddff06319f9633$var$fetchIssueNetworkTimes = $65ddff06319f9633$var$calculateFetchIssueNetworkTimes();
    return $65ddff06319f9633$var$fetchIssueNetworkTimes;
};

});
parcelRegister("8ITzY", function(module, exports) {

$parcel$export(module.exports, "timeBetweenMarks", () => $bf8e4b1e21537136$export$9c25bf1893ba64c);

var $6iz4v = parcelRequire("6iz4v");
const $bf8e4b1e21537136$export$9c25bf1893ba64c = (startMarkName, endMarkName)=>{
    const startMark = (0, $6iz4v.getMark)(startMarkName);
    const endMark = (0, $6iz4v.getMark)(endMarkName);
    if (!startMark || !endMark || startMark.startTime > endMark.startTime) return null;
    return endMark.startTime - startMark.startTime;
};

});

parcelRegister("cUHte", function(module, exports) {

$parcel$export(module.exports, "fetchFieldDataPerf", () => $e54dd57964efa8b8$export$b97d963a8496fa2f);
$parcel$export(module.exports, "fetchCommentsPerf", () => $e54dd57964efa8b8$export$179836a99669cbe7);
$parcel$export(module.exports, "fetchIssueLinkPerf", () => $e54dd57964efa8b8$export$8d0984a0f9f31117);
$parcel$export(module.exports, "fetchSubtaskTypesPerf", () => $e54dd57964efa8b8$export$c1324bd586e9a53a);
$parcel$export(module.exports, "fetchUploadPerf", () => $e54dd57964efa8b8$export$72fcc6cb1cdc70e0);
$parcel$export(module.exports, "fetchUserAuthPerf", () => $e54dd57964efa8b8$export$4052b1eae3373c3b);
$parcel$export(module.exports, "fetchViewContextPerf", () => $e54dd57964efa8b8$export$b4e2588a18d8d980);
$parcel$export(module.exports, "fetchIssuePropertiesPerf", () => $e54dd57964efa8b8$export$2ee73dd298bdfe8a);
const $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX = 'ISSUE_DETAILS';
const $e54dd57964efa8b8$var$FETCH_FIELD_DATA_REQUEST = 'FETCH_FIELD_DATA';
const $e54dd57964efa8b8$var$FETCH_INITIAL_COMMENTS_REQUEST = 'FETCH_INITIAL_COMMENTS';
const $e54dd57964efa8b8$var$FETCH_ISSUE_LINK_TYPES_REQUEST = 'FETCH_ISSUE_LINK_TYPES';
const $e54dd57964efa8b8$var$FETCH_SUBTASK_TYPES_REQUEST = 'FETCH_SUBTASK_TYPES';
const $e54dd57964efa8b8$var$FETCH_UPLOAD_CONTEXT_REQUEST = 'FETCH_LOAD_CONTEXT';
const $e54dd57964efa8b8$var$FETCH_USER_AUTH_REQUEST = 'FETCH_USER_AUTH';
const $e54dd57964efa8b8$var$FETCH_VIEW_CONTEXT_REQUEST = 'FETCH_VIEW_CONTEXT';
const $e54dd57964efa8b8$var$FETCH_ISSUE_PROPERTIES_REQUEST = 'FETCH_ISSUE_PROPERTIES';
const $e54dd57964efa8b8$export$b97d963a8496fa2f = {
    key: $e54dd57964efa8b8$var$FETCH_FIELD_DATA_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$179836a99669cbe7 = {
    key: $e54dd57964efa8b8$var$FETCH_INITIAL_COMMENTS_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$8d0984a0f9f31117 = {
    key: $e54dd57964efa8b8$var$FETCH_ISSUE_LINK_TYPES_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$c1324bd586e9a53a = {
    key: $e54dd57964efa8b8$var$FETCH_SUBTASK_TYPES_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$72fcc6cb1cdc70e0 = {
    key: $e54dd57964efa8b8$var$FETCH_UPLOAD_CONTEXT_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$4052b1eae3373c3b = {
    key: $e54dd57964efa8b8$var$FETCH_USER_AUTH_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$b4e2588a18d8d980 = {
    key: $e54dd57964efa8b8$var$FETCH_VIEW_CONTEXT_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$2ee73dd298bdfe8a = {
    key: $e54dd57964efa8b8$var$FETCH_ISSUE_PROPERTIES_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};

});


parcelRegister("g0N0Z", function(module, exports) {

$parcel$export(module.exports, "issueViewLoad", () => $95fa1cd4aae1a34f$export$49371c2cc4aaa4f6);
$parcel$export(module.exports, "issueViewOnPageLoad", () => $95fa1cd4aae1a34f$export$2f6837d06b669285);
$parcel$export(module.exports, "embeddedIssueViewLoad", () => $95fa1cd4aae1a34f$export$9d773f01a8da623e);
$parcel$export(module.exports, "epicDropdownOpenInteraction", () => $95fa1cd4aae1a34f$export$8d33579ffe76aa5b);
$parcel$export(module.exports, "epicModalOpenInteraction", () => $95fa1cd4aae1a34f$export$8f0deabe791d5bb9);

var $lNfG4 = parcelRequire("lNfG4");

const $95fa1cd4aae1a34f$export$49371c2cc4aaa4f6 = (0, $lNfG4.metrics).custom({
    key: 'issue-view-load',
    virtual: true,
    timings: [
        {
            key: 'legacy-tti-2021',
            startMark: 'metrics_init',
            endMark: $848ef1328a091c81$export$b292c195104c50d3
        },
        {
            key: 'timeBlockedOnBackend',
            startMark: $848ef1328a091c81$export$e64e32643802b552,
            endMark: $848ef1328a091c81$export$e52cc35f872875f7
        }
    ]
});
const $95fa1cd4aae1a34f$export$2f6837d06b669285 = (0, $lNfG4.metrics).custom({
    key: 'issue-view-on-page-load',
    timings: [
        {
            key: 'issue-mounted',
            endMark: $848ef1328a091c81$export$3a9e4a905dec520d
        },
        {
            key: 'latest-lcp',
            endMark: $848ef1328a091c81$export$4d1080224e02ef0b
        }
    ]
});
const $95fa1cd4aae1a34f$export$9d773f01a8da623e = (0, $lNfG4.metrics).custom({
    key: 'embedded-issue-view-load',
    until: $95fa1cd4aae1a34f$export$49371c2cc4aaa4f6,
    include: [
        $95fa1cd4aae1a34f$export$49371c2cc4aaa4f6
    ]
});
const $95fa1cd4aae1a34f$export$1e32b6c8e1e31a3d = (0, $lNfG4.metrics).pageLoad({
    key: 'service-management.queues.issue'
});
const $95fa1cd4aae1a34f$export$4be279014c4d8d39 = (0, $lNfG4.metrics).pageLoad({
    key: 'service-management.reports.issue'
});
const $95fa1cd4aae1a34f$export$8d33579ffe76aa5b = (0, $lNfG4.metrics).interaction({
    key: 'issue-epic-dropdown-menu-open'
});
const $95fa1cd4aae1a34f$export$8f0deabe791d5bb9 = (0, $lNfG4.metrics).interaction({
    key: 'issue-epic-modal-open'
});

});

parcelRegister("8Bhia", function(module, exports) {

$parcel$export(module.exports, "isGiraAGGConsistencyCheckEnabled", () => $706d7ea06981f598$export$3c97eb4b6ff2fec1);
$parcel$export(module.exports, "isJiraIssueViewEditorAIEnabled", () => $706d7ea06981f598$export$183bff9fcee964a2);
$parcel$export(module.exports, "isSwitcherooRealtimeExposuresTestFlagEnabled", () => $706d7ea06981f598$export$a73c9c09ec24e5e9);
$parcel$export(module.exports, "isJsmTimelineEnabled", () => $706d7ea06981f598$export$575e1bf822db15b5);
$parcel$export(module.exports, "isBM3EmitOnRafTopExperiencesEnabled", () => $706d7ea06981f598$export$ee410f0ba32dc900);
$parcel$export(module.exports, "isIssueViewWhiteboardsStandaloneEnabled", () => $706d7ea06981f598$export$6f64fb042a8db7d9);
$parcel$export(module.exports, "isWhiteboardStandaloneEnabled", () => $706d7ea06981f598$export$18b62f1e8801aa0f);
$parcel$export(module.exports, "isCrossJoinContentPreviewEnabled", () => $706d7ea06981f598$export$ce9fb45735ec88ee);
$parcel$export(module.exports, "isIdeaViewSidebarEnabled", () => $706d7ea06981f598$export$dcf527cccb1a409e);
$parcel$export(module.exports, "isForgeUiModificationsScreenTabsSupportEnabled", () => $706d7ea06981f598$export$1ee1f7892e4153f2);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $1Iui1 = parcelRequire("1Iui1");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

const $706d7ea06981f598$export$b5be9eaa7fce369 = ()=>(0, $1ybV0.ff)('configurable-child-issues-panel_3ht06', false);
const $706d7ea06981f598$export$7f7b600c4eafe68f = ()=>(0, $1ybV0.ff)('issue_view_quick_actions_revamp_l8mbx');
const $706d7ea06981f598$export$2fe22bada87c2b25 = ()=>(0, $1ybV0.ff)('pin_field_exp_launch_darkly_flag_ef4mc');
const $706d7ea06981f598$export$c8aa8a13c42858dd = ()=>(0, $1ybV0.ff)('jira-issue-history-data-classification_mhyjw', false);
const $706d7ea06981f598$export$3041d162b6562717 = ()=>(0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view', false);
const $706d7ea06981f598$export$91d9e9331bcb489f = ()=>(0, $1ybV0.ff)('issue.details.relay-cascading-select-field-issue-view-layout-integration');
const $706d7ea06981f598$export$4bef98bf98ff2cb = ()=>(0, $1ybV0.ff)('issue.details.migration-migrated-stream', false);
const $706d7ea06981f598$export$3c97eb4b6ff2fec1 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('issue.details.gira-agg-consistency-check-master-flag', 'OLD', [
        'OLD',
        'NEW',
        'CHECK',
        'CHECK_RETURN_NEW'
    ]) === 'CHECK';
const $706d7ea06981f598$export$183bff9fcee964a2 = ()=>(0, $1ybV0.ff)('issue.details.jira-issue-view-editor-ai_sozy', false);
const $706d7ea06981f598$export$bb7bcfe9ba7992e5 = ()=>(0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl', false);
const $706d7ea06981f598$export$b1c6c927b1de3746 = ()=>(0, $1ybV0.ff)('issue.details.feature-flags-to-slo-analytics', false);
const $706d7ea06981f598$export$4166161ebaa7c45b = ()=>(0, $1ybV0.ff)('issue-view-a11y-for-issue-key-strikethrough_3xavq', false);
const $706d7ea06981f598$export$c3e066f7be7868e8 = ()=>(0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w');
const $706d7ea06981f598$export$a3e5d5dfe1ed90ed = ()=>(0, $1ybV0.ff)('issue.details.media-inline', false);
const $706d7ea06981f598$export$cdd5c612352d7bf0 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('invite.from.assign', (0, $1Iui1.NOT_ENROLLED), [
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.NOT_ENROLLED),
        (0, $1Iui1.VARIATION)
    ]) === (0, $1Iui1.VARIATION);
const $706d7ea06981f598$export$5b9220081498abd7 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('invite.from.assign.modal', 'not-enrolled', [
        'control',
        'not-enrolled',
        'variation'
    ]);
const $706d7ea06981f598$export$89f18660d3a3bb78 = ()=>(0, $1ybV0.ff)('invite.from.assign.modal.fe.event', false);
const $706d7ea06981f598$export$dcc4742bc52ec465 = ()=>(0, $1ybV0.ff)('comment-limit-exceed-warning-flag_3rx53', false);
const $706d7ea06981f598$export$fa2b2d3091ee4acb = ()=>(0, $1ybV0.ff)('worklog-limit-exceed-warning-flag_hh86h', false);
const $706d7ea06981f598$export$8138f2ec6e2b730c = ()=>(0, $1ybV0.ff)('confluence-link-limit-exceed-warning-flag_1ycku', false);
const $706d7ea06981f598$export$d0ed2d8440fb5bbc = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.milestone-1');
const $706d7ea06981f598$export$41470180bace44ba = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.issue-remote-link');
const $706d7ea06981f598$export$9a5cf06e051f6deb = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.issue-attachments-limit');
const $706d7ea06981f598$export$e3bcb7ed6340e909 = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.issue-weblinks-limit');
const $706d7ea06981f598$export$a0e01c32249a7097 = ()=>(0, $1ybV0.ff)('parent-field-changeboarding_4ljdy', false);
const $706d7ea06981f598$export$78dd97cfaffb6fb1 = ()=>(0, $1ybV0.getFeatureFlagValue)('issue.details.editor.performance-tracking', {});
const $706d7ea06981f598$export$a801da94b6dd586b = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const value = (0, $1ybV0.getFeatureFlagValue)('issue.details.editor.valid-transactions-tracking', {});
    // workaround as editor is interpreting an empty object as enabled: https://product-fabric.atlassian.net/browse/ED-12432
    const enabled = typeof value === 'object' && Object.keys(value).length;
    return enabled ? value : undefined;
};
const $706d7ea06981f598$export$fd99e03c299972d3 = ()=>(0, $1ybV0.ff)('issue.details.editor.ufo', false);
const $706d7ea06981f598$export$ef24e9eecc594777 = ()=>(0, $1ybV0.ff)('issue.details.renderer.spec-based-validator');
const $706d7ea06981f598$export$67305b99ef59566c = ()=>(0, $1ybV0.ff)('project.config.pce.modern.global-issue-create.trigger', false);
const $706d7ea06981f598$export$fa44fb942e45b85d = ()=>(0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view', false);
const $706d7ea06981f598$export$9ba0da55e7f403e1 = ()=>(0, $1ybV0.ff)('project.config.pce.modern.global-subtask-issue-create-trigger', false);
const $706d7ea06981f598$export$dbaf42ba39b66293 = ()=>$706d7ea06981f598$export$67305b99ef59566c() && $706d7ea06981f598$export$9ba0da55e7f403e1();
const $706d7ea06981f598$export$5dc774c58824d858 = ()=>(0, $1ybV0.ff)('proforma-harmonisation-main_ca6ff', false);
const $706d7ea06981f598$export$73957227bab0d3f7 = ()=>(0, $1ybV0.ff)('hide-epic-link-from-issue-view-for-epic-renaming-beta_r1g77', false);
const $706d7ea06981f598$export$dd5401dbc8bdbdfb = ()=>(0, $1ybV0.ff)('disable-epic-link-and-parent-link-fields-in-issue-view-and-gic_zixrt', false);
const $706d7ea06981f598$export$c197f8974183a4f0 = ()=>(0, $1ybV0.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy', false);
const $706d7ea06981f598$export$6e06c78fd874f07f = ()=>(0, $1ybV0.ff)('remove-parent-link-from-issue-view_4t7dy', false);
const $706d7ea06981f598$export$9c7fa56ed1fa2e15 = ()=>(0, $1ybV0.ff)('parent-field-in-issue-view_x4zn4', false);
const $706d7ea06981f598$export$33e603f2e83329f5 = ()=>(0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1', false);
const $706d7ea06981f598$export$a73c9c09ec24e5e9 = ()=>(0, $1ybV0.ff)('switcheroo-realtime-exposures-test-flag_648u4', false);
const $706d7ea06981f598$export$bfc00b5a0f36c863 = ()=>(0, $1ybV0.ff)('issue-view-placeholder-end-user-request-modal_myc7n', false);
const $706d7ea06981f598$export$fff49f3f84d869e5 = ()=>(0, $1ybV0.ff)('confluence-template-placeholder_2bhgf', false);
const $706d7ea06981f598$export$e9544b00b7cb5703 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-events-transformer-ld', false);
const $706d7ea06981f598$export$6df7a6ecffbd200 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-soft-refresh-ld');
const $706d7ea06981f598$export$6c3661f793bf9d1 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-priority_ri9vi');
const $706d7ea06981f598$export$7000df6bbe3f5099 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-reporter_jfzs2');
const $706d7ea06981f598$export$5b6e3c64e3051457 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-parent_5p1ac');
const $706d7ea06981f598$export$e253ac70cea0d36b = ()=>(0, $1ybV0.ff)('issue.details.follow-up-relay-multi-select-field-issue-view-integration', false);
const $706d7ea06981f598$export$12afaf05e3ffffed = ()=>(0, $1ybV0.ff)('issue.details.fix-issue-status-transition-loading_6s8n8', false);
const $706d7ea06981f598$export$47d240e96e9bc1b3 = ()=>(0, $1ybV0.ff)('issue.details.fix-incorrect-state-closed-sprint-field_mpzbh', false);
const $706d7ea06981f598$export$9591540fa082da5a = ()=>(0, $1ybV0.ff)('editor.renderer-alt-text-on-images', false);
const $706d7ea06981f598$export$369fa0ed6b2504fb = ()=>(0, $1ybV0.ff)('offeringcataloguefeatures-resource-layer-in-frontend_o5pnu', false);
const $706d7ea06981f598$export$a792a3f88a852f06 = ()=>(0, $1ybV0.ff)('sea-2830-improve-accessibility-of-priority-field-in-backlog-card_k53tq', false);
const $706d7ea06981f598$export$575e1bf822db15b5 = ()=>(0, $1ybV0.ff)('jsm-timelines-phase-2_70gja', false);
const $706d7ea06981f598$export$9f71233b08c04922 = ()=>(0, $1ybV0.ff)('jsm-canned-response', false);
const $706d7ea06981f598$export$6f0be57bd65ee8bc = ()=>(0, $1ybV0.ff)('responders-field-in-all-projects-issues-ui', false);
const $706d7ea06981f598$export$e3bafd4acea73c60 = ()=>{
    const experiences = (0, $1ybV0.getFeatureFlagValue)('odin.ec.client.integration.issueview', '');
    return experiences.length > 0;
};
const $706d7ea06981f598$export$317ab03e75769d4f = ()=>(0, $1ybV0.ff)('ken-545-display-hide-when-empty-button-to-user-_fjpw9');
const $706d7ea06981f598$export$6604067817758030 = ()=>{
    const featureFlagValue = (0, $1ybV0.getMultivariateFeatureFlag)('issue.details.gira-agg-migration-isarchived', 'OLD', [
        'OLD',
        'NEW',
        'CHECK',
        'CHECK_RETURN_NEW'
    ]);
    return featureFlagValue === 'NEW' || featureFlagValue === 'CHECK_RETURN_NEW' || featureFlagValue === 'CHECK';
};
const $706d7ea06981f598$export$c108c03095e0e655 = ()=>(0, $1ybV0.ff)('enable-archived-issues-page-link', false);
const $706d7ea06981f598$export$ee410f0ba32dc900 = ()=>(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences', false);
const $706d7ea06981f598$export$3068bf83bd6f9396 = ()=>(0, $1ybV0.ff)('issue.details.custom-message-for-linking-with-no-permissions_k7qsn', false);
const $706d7ea06981f598$export$da019fa3d31e5c7e = ()=>(0, $1ybV0.ff)('issue-view.enable-search-by-email-in-multiselect-user-picker-field', false);
const $706d7ea06981f598$export$48d407f97269c8fa = ()=>(0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration', false);
const $706d7ea06981f598$export$bf10032e4a734a65 = {
    CROSS_FLOW: 'jira.issue-view.placeholder-template-cross-flow'
};
const $706d7ea06981f598$export$fb512d5beec30a90 = (experiment)=>experiment ? (0, $1ybV0.getMultivariateFeatureFlag)(experiment, (0, $1Iui1.NOT_ENROLLED), [
        (0, $3401608855dcf8dc$export$fb6fa89d43ed06f7),
        (0, $3401608855dcf8dc$export$c52ae1847ec8c2c),
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.NOT_ENROLLED)
    ]) : (0, $1Iui1.NOT_ENROLLED);
const $706d7ea06981f598$export$6e7dfb06c9e45ae7 = ()=>[
        (0, $1Iui1.CONTROL),
        (0, $3401608855dcf8dc$export$fb6fa89d43ed06f7)
    ].includes($706d7ea06981f598$export$fb512d5beec30a90($706d7ea06981f598$export$bf10032e4a734a65.CROSS_FLOW));
const $706d7ea06981f598$export$ef28379ba310de6e = (experiment)=>$706d7ea06981f598$export$fb512d5beec30a90(experiment) === (0, $3401608855dcf8dc$export$fb6fa89d43ed06f7);
const $706d7ea06981f598$export$98dcb5ffd7beaf00 = ()=>(0, $1ybV0.ff)('jracloud-81255-stop-loading-field-config-twice_jfdek', false);
const $706d7ea06981f598$export$8ea052ed520b62bc = ()=>(0, $1ybV0.ff)('issue.details.non-critical-gira-query-experience-tracking', false);
const $706d7ea06981f598$export$496e94e3da873a49 = ()=>(0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x');
const $706d7ea06981f598$export$33008660eb5353ef = ()=>(0, $1ybV0.ff)('compass-components-in-jira-components_xw42u', false);
const $706d7ea06981f598$export$176e4d6701700463 = ()=>(0, $1ybV0.ff)('hide-icc-for-all-users_avyh5', false);
const $706d7ea06981f598$export$c567845e4f18ee11 = ()=>(0, $1ybV0.ff)('issue.details.issue-link-limit-exceed-warning-flag');
const $706d7ea06981f598$export$2b839c758c080224 = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-pages', false);
const $706d7ea06981f598$export$882e8ff421f7744c = ()=>(0, $1ybV0.ff)('devops_app_recommendation_on_link_paste', false) && (0, $79xbN.expValEquals)('devops_app_recommendation_on_link_paste', 'cohort', 'variation');
const $706d7ea06981f598$export$c3737cff1b9064df = ()=>(0, $1ybV0.ff)('issue-view-remove-backgroundscripts-from-critical-fetch_6f6on');
const $706d7ea06981f598$export$d4fe7150f9d83fa = ()=>(0, $1ybV0.ff)('jiv-14067-issue.details.gira-agg-migration-comments_pzao9', false);
const $706d7ea06981f598$export$f6bbc5e1c7a75195 = ()=>(0, $1ybV0.ff)('issue-jiv-14530-comments-consistency-check_x716d', false);
const $706d7ea06981f598$export$bc3ae4e1219a64e = ()=>(0, $1ybV0.ff)('jiv-18751-investigate-time-tracking-update-errors_ng38s');
const $706d7ea06981f598$export$5a53bba8e442c4f9 = ()=>(0, $1ybV0.ff)('issue.details.gira-agg-migration-attachments_ecebe', false);
const $706d7ea06981f598$export$6f64fb042a8db7d9 = ()=>(0, $1ybV0.ff)('jira-issue-view-whiteboards-standalone', false);
const $706d7ea06981f598$export$667dd70f296d7a79 = ()=>(0, $1ybV0.ff)('platform_embed-conf_jira-issue_create_cross-join', false);
const $706d7ea06981f598$export$8d9e5c2fc560d7fb = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.linked-page-cross-join', false);
const $706d7ea06981f598$export$602a082cd6009b66 = ()=>(0, $1ybV0.ff)('hrz-716-integrate-goal-picker-into-issue-view', false);
const $706d7ea06981f598$export$590b056868f89976 = ()=>(0, $1ybV0.ff)('im-tokens-and-styled-components-migration_qpsld', false);
const $706d7ea06981f598$export$f67982569b9aab31 = ()=>(0, $1ybV0.ff)('issue-unarchival_wdpb9', false);
const $706d7ea06981f598$export$59aedb8bed66fbb5 = ()=>(0, $1ybV0.ff)('sentiment-custom-field', false);
const $706d7ea06981f598$export$ab71258032925094 = ()=>(0, $1ybV0.ff)('issue-view-classification-level-editability_88zal', false);
const $706d7ea06981f598$export$5dbdd9e44df66fdb = ()=>(0, $1ybV0.ff)('jsm-restrict-internal-comment-visibility', false);
const $706d7ea06981f598$export$9e983b29015333eb = ()=>(0, $1ybV0.ff)('jiv-17158-agg-use-iseditableinview_8nogh', false);
const $706d7ea06981f598$export$418f24ad76008d74 = ()=>(0, $1ybV0.ff)('uim-cascading-select-field-support-gic_h1cda', false);
const $706d7ea06981f598$export$614b1f6ee38ef8fe = ()=>(0, $1ybV0.ff)('selectable-field-edit-view-replace-select-with-footer_301u0', false);
const $706d7ea06981f598$export$8fa51a766c2ece72 = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-content-crossflow', false);
const $706d7ea06981f598$export$1262b52679049b5e = ()=>(0, $1ybV0.ff)('jiv-18175-usemutation-for-remaining-estimate-field_ar10h', false);
const $706d7ea06981f598$export$d9ce3c80c1cc862d = ()=>(0, $1ybV0.ff)('jsw.xflow.issue-view-nudge-experiment', false);
const $706d7ea06981f598$export$9e54bab54faf7459 = ()=>(0, $1ybV0.ff)('convert-approvals-glance-to-collapsible-context-group_gqbgz', false);
const $706d7ea06981f598$export$4399c72174f6c25d = ()=>(0, $1ybV0.ff)('jsw.xflow.issue-view-nudge-experiment', false);
const $706d7ea06981f598$export$18b62f1e8801aa0f = ()=>(0, $1ybV0.ff)('jira-issue-view-whiteboards-standalone', false);
const $706d7ea06981f598$export$ce9fb45735ec88ee = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.linked-page-cross-join', false);
const $706d7ea06981f598$export$31792eb3d1db9c94 = ()=>(0, $1ybV0.ff)('hide-issue-key-when-linked-issue-has-no-access_8nb8t');
const $706d7ea06981f598$export$e73f54d78d4ddfd8 = ()=>(0, $1ybV0.ff)('select-feedback-type-label_683rg', false);
const $706d7ea06981f598$export$653dc805d400e563 = ()=>(0, $1ybV0.ff)('custom-select-feedback-for-issue-view_y8h7f', false);
const $706d7ea06981f598$export$98975042f993a7b1 = ()=>(0, $1ybV0.ff)('assets-rearch-deprecate-attribute-value-id_ykukg', false);
const $706d7ea06981f598$export$7248d3c792741fe6 = ()=>(0, $1ybV0.ff)('fix-narrow-button-spacing-on-issue-actions_icmq8', false);
const $706d7ea06981f598$export$6ff28b2229a27899 = ()=>(0, $1ybV0.ff)('third_party_app_nudge_on_issues_watch', false) && (0, $79xbN.expValEquals)('third_party_app_nudge_on_issues_watch', 'cohort', 'variation');
const $706d7ea06981f598$export$aff6e532ec3ced01 = ()=>(0, $1ybV0.ff)('linked_mentioned_pages_handle_restricted_page_on_click', false);
const $706d7ea06981f598$export$d365d0b31e3df46e = ()=>(0, $1ybV0.ff)('jira.onboarding.kuro-5895', false);
const $706d7ea06981f598$export$c3c0abcc7a24c315 = ()=>(0, $1ybV0.ff)('polaris.jpd-panel-in-issue-view', false);
const $706d7ea06981f598$export$dcf527cccb1a409e = ()=>(0, $1ybV0.ff)('polaris.show-idea-sidebar-on-card-click_py19i', false);
const $706d7ea06981f598$export$fc627b9c964c8914 = ()=>(0, $1ybV0.ff)('adding-error-analytics-to-child-issue-panel-if-issue-types-array-is-empty_tb0ut', false);
const $706d7ea06981f598$export$757c7dfbd7ddcbdd = ()=>(0, $1ybV0.ff)('reminder-nudge-for-failed-xflow_z8l8q', false);
const $706d7ea06981f598$export$1ee1f7892e4153f2 = ()=>(0, $1ybV0.ff)('forge-ui-modifications-screentabs_qoa33', false);
const $706d7ea06981f598$export$44436302a680c0e0 = ()=>(0, $1ybV0.ff)('jira.issue-view.create-confluence-page.template-browser', false);
const $706d7ea06981f598$export$5696901bc5f2fcb6 = ()=>(0, $1ybV0.ff)('ui-modifications-issue-view-status-custom-field-support_hwx15', false);
const $706d7ea06981f598$export$f3c5e3944e08cc8a = ()=>(0, $1ybV0.ff)('placeholder-template-end-users-cross-flow-via-e2e-flow-killswitch_4bfgx', false);
const $706d7ea06981f598$export$ebdc109f22d5762d = ()=>(0, $1ybV0.ff)('fix-for-jracloud-84181_dm5fg', false);
const $706d7ea06981f598$export$3336aec97cc6ad82 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-sprint_jozpu');
const $706d7ea06981f598$export$1ebd956541101430 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-metadata_d42b0');
const $706d7ea06981f598$export$2f960bba67ffb99d = ()=>(0, $1ybV0.ff)('issue.details.embedded-confluence.jira-issue.auto-link-pages-on-link-paste', false);
const $706d7ea06981f598$export$f523e13f8d29cd4d = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-assignee-ld', false);
const $706d7ea06981f598$export$d51d9f0f8bb8e5d5 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-number_q0em4', false);
const $706d7ea06981f598$export$b496d047520756aa = ()=>(0, $1ybV0.ff)('uim-orginal-estimate-field-support_ugzqt', false);
const $706d7ea06981f598$export$ae1c98a76fd367f1 = ()=>(0, $1ybV0.ff)('bifrost.playbooks-in-issue-view_lv7b2', false);
const $706d7ea06981f598$export$b15e700f73951a90 = ()=>(0, $1ybV0.ff)('compiled-react-migration-issue-view_zilee', false);
const $706d7ea06981f598$export$3215b3331a7b187a = ()=>(0, $1ybV0.ff)('compiled-react-migration-issue-view_u9myz', false);
const $706d7ea06981f598$export$a465afdb16c2fb1e = ()=>(0, $1ybV0.ff)('enable_jsm_repackaging_changes_vtwk9', false);
const $706d7ea06981f598$export$b8f1556e1f953f8d = ()=>(0, $1ybV0.ff)('compal-sunset-and-remove-dot-menu_66j8q', false);
const $706d7ea06981f598$export$7262f08c93e522ee = ()=>(0, $1ybV0.ff)('compal-dot-menu-shortcut-integration_dvvg2', false);
const $706d7ea06981f598$export$39e338620e4f1561 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-single-line-text_in6w6', false);
const $706d7ea06981f598$export$fb62da0fafc1b47b = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-date_ptj72', false);
const $706d7ea06981f598$export$b41fe6134b9dd04b = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-project-select_w0xem', false);
const $706d7ea06981f598$export$d705591f59096b16 = ()=>(0, $1ybV0.ff)('add-team-id-analytics-data');
const $706d7ea06981f598$export$386ddedc27abb46a = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-date-time_eaqd2', false);
const $706d7ea06981f598$export$8fac1563227555f2 = ()=>(0, $1ybV0.ff)('polaris.jpd-panel-filter-by-delivery-link-type', false);
const $706d7ea06981f598$export$b4501966f3d67615 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-url_ob8uu', false);
const $706d7ea06981f598$export$404ba26ddf44eb5c = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-security-level_7y5uv', false);
const $706d7ea06981f598$export$51e354a6287b4e6f = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-summary_eog1v', false);
const $706d7ea06981f598$export$60d59ed70ac781ae = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-single-line-text-message', false);
const $706d7ea06981f598$export$95907a52a35b3961 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-user');
const $706d7ea06981f598$export$b6e9d0a9667c0f05 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-approvers', false);
const $706d7ea06981f598$export$4d3db41296db446d = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-time-tracking_eefh0', false);
const $706d7ea06981f598$export$1f73bbaf5f11f42e = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-checkbox-select_ytl5n', false);
const $706d7ea06981f598$export$6cc75390b4e231dc = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-people', false);
const $706d7ea06981f598$export$bb9056b4adf9c3e2 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-color_wrbay', false);
const $706d7ea06981f598$export$8503e8a8212316b2 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-components-select_prpz1', false);
const $706d7ea06981f598$export$8edffc79742276c2 = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-original-estimate_eb4wv', false);
const $706d7ea06981f598$export$99f9e0265c10ef5c = ()=>(0, $1ybV0.ff)('relay-migration-issue-fields-issue-type-switcher_l0lrt', false); // </psavchenko>

});
const $3401608855dcf8dc$export$fb6fa89d43ed06f7 = 'variant-contextual';
const $3401608855dcf8dc$export$c52ae1847ec8c2c = 'variant-contextual-not-enrolled';


parcelRegister("782cd", function(module, exports) {

$parcel$export(module.exports, "serverTimingSelector", () => $51fba4a554a079cc$export$a0b21c7e17057a47);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $51fba4a554a079cc$export$8ef68fa2b28a6d0f = (state)=>state.timing;
const $51fba4a554a079cc$export$a0b21c7e17057a47 = (0, $df4Sl.createSelector)($51fba4a554a079cc$export$8ef68fa2b28a6d0f, (0, $jZDJX.isLoadingSelector), (timing, isLoading)=>isLoading ? undefined : timing.server);

});
parcelRegister("jZDJX", function(module, exports) {

$parcel$export(module.exports, "entitiesSelector", () => $ea753f2b3db28e48$export$ccebe5cc5854d0fa);
$parcel$export(module.exports, "projectSelector", () => $ea753f2b3db28e48$export$852a6c34ff1a2e77);
$parcel$export(module.exports, "uiSelector", () => $ea753f2b3db28e48$export$185c0864c82372e3);
$parcel$export(module.exports, "entitiesIssueSelector", () => $ea753f2b3db28e48$export$fa3ac1f794979805);
$parcel$export(module.exports, "entitiesRefreshedOnSelector", () => $ea753f2b3db28e48$export$c4ebdc93969b82cc);
$parcel$export(module.exports, "flagsSelector", () => $ea753f2b3db28e48$export$40cfdc5e96db7759);
$parcel$export(module.exports, "projectIdSelector", () => $ea753f2b3db28e48$export$4c9d6034f65d22f4);
$parcel$export(module.exports, "projectIdsSelector", () => $ea753f2b3db28e48$export$9edb3f63d1bd8546);
$parcel$export(module.exports, "projectKeySelector", () => $ea753f2b3db28e48$export$404de5ac601b84bc);
$parcel$export(module.exports, "projectTypeSelector", () => $ea753f2b3db28e48$export$69316f88206ca90b);
$parcel$export(module.exports, "isSimplifiedProjectSelector", () => $ea753f2b3db28e48$export$d94d544d4b2e1310);
$parcel$export(module.exports, "loggedInUserDetailsSelector", () => $ea753f2b3db28e48$export$b5a68452fc64275d);
$parcel$export(module.exports, "loggedInUserAvatarUrlSelector", () => $ea753f2b3db28e48$export$e0efa9c12379be7a);
$parcel$export(module.exports, "loggedInUserDisplayNameSelector", () => $ea753f2b3db28e48$export$4f56a07246719eb0);
$parcel$export(module.exports, "parentIssueEntitySelector", () => $ea753f2b3db28e48$export$e10c57d263d23c49);
$parcel$export(module.exports, "loggedInUserTimeZoneSelector", () => $ea753f2b3db28e48$export$ac6f9fd801c94fff);
$parcel$export(module.exports, "idSelector", () => $ea753f2b3db28e48$export$66c501bed2fcd648);
$parcel$export(module.exports, "isClassicProjectSelector", () => $ea753f2b3db28e48$export$45347d9f8a67561b);
$parcel$export(module.exports, "isLoadingSelector", () => $ea753f2b3db28e48$export$c077f23183070903);
$parcel$export(module.exports, "doNotUseIsLoadingPromiseSelector", () => $ea753f2b3db28e48$export$2ca9575c7da6bf18);
$parcel$export(module.exports, "isPreviewSelector", () => $ea753f2b3db28e48$export$b33a1a8958a8d805);
$parcel$export(module.exports, "isCompletedLoadingSelector", () => $ea753f2b3db28e48$export$9b99fb9e23fc133);
$parcel$export(module.exports, "loadingStageSelector", () => $ea753f2b3db28e48$export$18bc980d36bf93d);
$parcel$export(module.exports, "isDeleteIssueModalOpenSelector", () => $ea753f2b3db28e48$export$7cfd3e0dd7059b87);
$parcel$export(module.exports, "isDeletingIssueSelector", () => $ea753f2b3db28e48$export$d414d8eddcb409e4);
$parcel$export(module.exports, "didIssueDeleteFailSelector", () => $ea753f2b3db28e48$export$834732624d2c73e1);
$parcel$export(module.exports, "errorSelector", () => $ea753f2b3db28e48$export$47aec13333381be0);
$parcel$export(module.exports, "errorMessageSelector", () => $ea753f2b3db28e48$export$9b1097e17c0e6dc2);
$parcel$export(module.exports, "getUserByIdSelector", () => $ea753f2b3db28e48$export$801a2f2bd4059665);
$parcel$export(module.exports, "parentLevelIssuesSelector", () => $ea753f2b3db28e48$export$aa8980c49aba4478);
$parcel$export(module.exports, "baseAriSelector", () => $ea753f2b3db28e48$export$fa12ae06e35ebd67);
$parcel$export(module.exports, "issueAriSelector", () => $ea753f2b3db28e48$export$a2cdbba2136e72d3);
$parcel$export(module.exports, "epicLinkFieldKeySelector", () => $ea753f2b3db28e48$export$27abc48b8d528300);
$parcel$export(module.exports, "isEpicSelector", () => $ea753f2b3db28e48$export$6e8ebe94ad8bb62b);
$parcel$export(module.exports, "isServiceDeskSelector", () => $ea753f2b3db28e48$export$43d733e4b7e8c7d0);

var $df4Sl = parcelRequire("df4Sl");

var $7ZZxN = parcelRequire("7ZZxN");


var $f9RL0 = parcelRequire("f9RL0");

var $6vrw7 = parcelRequire("6vrw7");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");
const $ea753f2b3db28e48$export$ccebe5cc5854d0fa = (state)=>state.entities;
const $ea753f2b3db28e48$export$852a6c34ff1a2e77 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (entities)=>entities ? entities.project : null);
const $ea753f2b3db28e48$export$185c0864c82372e3 = (state)=>state.ui;
const $ea753f2b3db28e48$export$27493ac3d8611290 = (state)=>state.agile;
const $ea753f2b3db28e48$export$fa3ac1f794979805 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (entities)=>entities.issue);
const $ea753f2b3db28e48$export$c4ebdc93969b82cc = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (entities)=>entities.refreshedOn);
const $ea753f2b3db28e48$export$40cfdc5e96db7759 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.flags);
const $ea753f2b3db28e48$export$4c9d6034f65d22f4 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$852a6c34ff1a2e77, (project)=>project && project.projectId ? project.projectId : null);
const $ea753f2b3db28e48$export$9edb3f63d1bd8546 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$852a6c34ff1a2e77, (project)=>project && project.projectId ? [
        project.projectId
    ] : []);
const $ea753f2b3db28e48$export$404de5ac601b84bc = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$852a6c34ff1a2e77, (project)=>project ? project.projectKey : null);
const $ea753f2b3db28e48$export$69316f88206ca90b = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$852a6c34ff1a2e77, (project)=>project && project.projectType ? project.projectType : null);
const $ea753f2b3db28e48$export$d94d544d4b2e1310 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$852a6c34ff1a2e77, (project)=>!!project && project.isSimplified);
const $ea753f2b3db28e48$export$b5a68452fc64275d = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (0, $5JqpU.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>loggedInAccountId ? entities.users[loggedInAccountId] : null);
const $ea753f2b3db28e48$export$e0efa9c12379be7a = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (0, $5JqpU.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>{
    const loggedInUser = loggedInAccountId ? entities.users[loggedInAccountId] : null;
    return loggedInUser ? loggedInUser.avatarUrl : null;
});
const $ea753f2b3db28e48$export$4f56a07246719eb0 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (0, $5JqpU.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>{
    const loggedInUser = loggedInAccountId ? entities.users[loggedInAccountId] : null;
    return loggedInUser ? loggedInUser.displayName : null;
});
const $ea753f2b3db28e48$export$e10c57d263d23c49 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (entities)=>entities.parentIssue);
const $ea753f2b3db28e48$export$ac6f9fd801c94fff = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$b5a68452fc64275d, (loggedInUser)=>loggedInUser ? loggedInUser.timeZone : undefined);
const $ea753f2b3db28e48$export$66c501bed2fcd648 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$fa3ac1f794979805, (issue)=>issue && (0, $6vrw7.toIssueId)(issue.id));
const $ea753f2b3db28e48$export$45347d9f8a67561b = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$d94d544d4b2e1310, (isSimplified)=>!isSimplified);
const $ea753f2b3db28e48$export$c077f23183070903 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $d6ff0428d6ad71a2$export$26d55645375ca9a));
const $ea753f2b3db28e48$export$2ca9575c7da6bf18 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.doNotUseIsLoadingPromise);
const $ea753f2b3db28e48$export$b33a1a8958a8d805 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $d6ff0428d6ad71a2$export$1b56cc494043d9bf));
const $ea753f2b3db28e48$export$9b99fb9e23fc133 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $d6ff0428d6ad71a2$export$1660a2d7c2fff354));
const $ea753f2b3db28e48$export$18bc980d36bf93d = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.loadingStage);
const $ea753f2b3db28e48$export$7cfd3e0dd7059b87 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>!!(ui.issueDeletion && ui.issueDeletion.isDeleteIssueModalOpen));
const $ea753f2b3db28e48$export$d414d8eddcb409e4 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.issueDeletion ? ui.issueDeletion.isDeletingIssue : false);
const $ea753f2b3db28e48$export$834732624d2c73e1 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.issueDeletion ? ui.issueDeletion.didIssueDeleteFail : false);
const $ea753f2b3db28e48$export$47aec13333381be0 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.error);
const $ea753f2b3db28e48$export$9b1097e17c0e6dc2 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$185c0864c82372e3, (ui)=>ui.errorMessage);
const $ea753f2b3db28e48$export$801a2f2bd4059665 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (entities)=>(userId)=>userId ? entities.users[userId] : undefined);
const $ea753f2b3db28e48$export$aa8980c49aba4478 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$ccebe5cc5854d0fa, (entities)=>entities.parentLevelIssues);
const $ea753f2b3db28e48$export$a60a6c96db10acc4 = ()=>'jira';
const $ea753f2b3db28e48$export$57c6957997fb7f1d = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$69316f88206ca90b, (0, $7ZZxN.projectTypeToCanonicalId));
const $ea753f2b3db28e48$export$fa12ae06e35ebd67 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$a60a6c96db10acc4, (0, $5JqpU.cloudIdSelector), (resourceOwner, cloudId)=>cloudId ? `ari:cloud:${resourceOwner}:${cloudId}` : null);
const $ea753f2b3db28e48$export$a2cdbba2136e72d3 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$fa12ae06e35ebd67, $ea753f2b3db28e48$export$66c501bed2fcd648, (baseAri, issueId)=>{
    if (!baseAri || !issueId) return null;
    return `${baseAri}:issue/${issueId}`;
});
const $ea753f2b3db28e48$export$27abc48b8d528300 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$27493ac3d8611290, (agile)=>agile && agile.epic && agile.epic.key || null);
const $ea753f2b3db28e48$export$d062a59cf4fc9cec = (fields)=>({}).hasOwnProperty.call(fields, (0, $f9RL0.EPIC_ISSUES));
const $ea753f2b3db28e48$export$6e8ebe94ad8bb62b = (0, $df4Sl.createSelector)((0, $fokFV.fieldsSelector), (fields)=>$ea753f2b3db28e48$export$d062a59cf4fc9cec(fields));
const $ea753f2b3db28e48$export$43d733e4b7e8c7d0 = (0, $df4Sl.createSelector)($ea753f2b3db28e48$export$69316f88206ca90b, (projectType)=>projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT));

});
const $d6ff0428d6ad71a2$export$26d55645375ca9a = 'LOADING';
const $d6ff0428d6ad71a2$export$1b56cc494043d9bf = 'PREVIEW';
const $d6ff0428d6ad71a2$export$1660a2d7c2fff354 = 'COMPLETE';

parcelRegister("f9RL0", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE", () => $3183c1ede6a2aff4$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $3183c1ede6a2aff4$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $3183c1ede6a2aff4$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $3183c1ede6a2aff4$export$289917d9a7031e1d);
$parcel$export(module.exports, "VOTES", () => $3183c1ede6a2aff4$export$81614f6dc3be5b00);
$parcel$export(module.exports, "SECURITY", () => $3183c1ede6a2aff4$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ISSUE_RESTRICTION", () => $3183c1ede6a2aff4$export$caf1ff54fbdf44bf);
$parcel$export(module.exports, "ASSIGNEE", () => $3183c1ede6a2aff4$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $3183c1ede6a2aff4$export$6d7021166edc895c);
$parcel$export(module.exports, "DUE_DATE", () => $3183c1ede6a2aff4$export$cf7e173386d30cdd);
$parcel$export(module.exports, "PRIORITY", () => $3183c1ede6a2aff4$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $3183c1ede6a2aff4$export$79b91d4669dcadcb);
$parcel$export(module.exports, "DEV_SUMMARY", () => $3183c1ede6a2aff4$export$950d47e775e208ee);
$parcel$export(module.exports, "EPIC", () => $3183c1ede6a2aff4$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $3183c1ede6a2aff4$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $3183c1ede6a2aff4$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $3183c1ede6a2aff4$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $3183c1ede6a2aff4$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $3183c1ede6a2aff4$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $3183c1ede6a2aff4$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $3183c1ede6a2aff4$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SLA_PANEL", () => $3183c1ede6a2aff4$export$1d0e0bb6a21b800b);
$parcel$export(module.exports, "LINKED_ALERTS", () => $3183c1ede6a2aff4$export$340fac260c3e3637);
$parcel$export(module.exports, "CHAT_CHANNEL", () => $3183c1ede6a2aff4$export$24ec4dcc8e5b08ef);
$parcel$export(module.exports, "MSTEAMS_CHANNEL", () => $3183c1ede6a2aff4$export$8631065e0909313);
$parcel$export(module.exports, "ZOOM_MEETING", () => $3183c1ede6a2aff4$export$3c4dccba7d7e0acb);
$parcel$export(module.exports, "CONFERENCE_CALL", () => $3183c1ede6a2aff4$export$cd5e9246357daec3);
$parcel$export(module.exports, "KNOWLEDGE_BASE", () => $3183c1ede6a2aff4$export$203643a6fd9496a0);
$parcel$export(module.exports, "SENTIMENT", () => $3183c1ede6a2aff4$export$9c83bd19c3ffd90d);
$parcel$export(module.exports, "ASSET_ONBOARDING", () => $3183c1ede6a2aff4$export$c5c04443c6097d6e);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS", () => $3183c1ede6a2aff4$export$26d855f4cd7e5fe9);
$parcel$export(module.exports, "SUMMARY", () => $3183c1ede6a2aff4$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $3183c1ede6a2aff4$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $3183c1ede6a2aff4$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $3183c1ede6a2aff4$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $3183c1ede6a2aff4$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $3183c1ede6a2aff4$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $3183c1ede6a2aff4$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $3183c1ede6a2aff4$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $3183c1ede6a2aff4$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $3183c1ede6a2aff4$export$aba22e09a66f6826);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $3183c1ede6a2aff4$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $3183c1ede6a2aff4$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $3183c1ede6a2aff4$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $3183c1ede6a2aff4$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $3183c1ede6a2aff4$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $3183c1ede6a2aff4$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $3183c1ede6a2aff4$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $3183c1ede6a2aff4$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $3183c1ede6a2aff4$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $3183c1ede6a2aff4$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $3183c1ede6a2aff4$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $3183c1ede6a2aff4$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $3183c1ede6a2aff4$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $3183c1ede6a2aff4$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $3183c1ede6a2aff4$export$902f6c5cc939598a);

var $2wUFy = parcelRequire("2wUFy");

var $7ZZxN = parcelRequire("7ZZxN");

var $lO4Or = parcelRequire("lO4Or");
const $3183c1ede6a2aff4$export$ebb48b08205007c5 = 'issuetype';
const $3183c1ede6a2aff4$export$a464614f8f5fe986 = 'summary';
const $3183c1ede6a2aff4$export$a311a3c9b207604e = 'parent';
const $3183c1ede6a2aff4$export$2a4f270075a033de = 'parent-issue';
const $3183c1ede6a2aff4$export$4561a4960baf1b2b = 'parent'; // new Hierarchy unification parent field
const $3183c1ede6a2aff4$export$289917d9a7031e1d = 'watches';
const $3183c1ede6a2aff4$export$81614f6dc3be5b00 = 'votes';
const $3183c1ede6a2aff4$export$72a5630aa398d6b4 = 'security';
const $3183c1ede6a2aff4$export$caf1ff54fbdf44bf = 'issuerestriction';
const $3183c1ede6a2aff4$export$f8f7545d2bb78afb = 'assignee';
const $3183c1ede6a2aff4$export$6d7021166edc895c = 'reporter';
const $3183c1ede6a2aff4$export$cf7e173386d30cdd = 'duedate';
const $3183c1ede6a2aff4$export$bb34f3538ba26c7e = 'priority';
const $3183c1ede6a2aff4$export$79b91d4669dcadcb = 'labels';
const $3183c1ede6a2aff4$export$cbedbfe2cd0caec7 = 'components';
const $3183c1ede6a2aff4$export$950d47e775e208ee = 'devSummary';
const $3183c1ede6a2aff4$export$f91d2bb4cc99fa5e = 'releases';
const $3183c1ede6a2aff4$export$a316570a0dbfd2b0 = 'sprint';
const $3183c1ede6a2aff4$export$405b6d72f2d243a9 = 'storyPointsField';
const $3183c1ede6a2aff4$export$3cb4a99a332e4186 = 'epic';
const $3183c1ede6a2aff4$export$d7e18f5730074533 = 'fixVersions';
const $3183c1ede6a2aff4$export$c435f0000304e508 = 'versions';
const $3183c1ede6a2aff4$export$ee99ef6ee562a446 = 'timetracking';
const $3183c1ede6a2aff4$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $3183c1ede6a2aff4$export$e50006273435e7d4 = 'status';
const $3183c1ede6a2aff4$export$f1a6ce22cbb7eb32 = 'resolution';
const $3183c1ede6a2aff4$export$ff39ebd4bb12b718 = 'created';
const $3183c1ede6a2aff4$export$cd8e68094cb5c3cb = 'updated';
const $3183c1ede6a2aff4$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $3183c1ede6a2aff4$export$340fac260c3e3637 = 'LINKED_ALERTS';
const $3183c1ede6a2aff4$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
const $3183c1ede6a2aff4$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
const $3183c1ede6a2aff4$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
const $3183c1ede6a2aff4$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
const $3183c1ede6a2aff4$export$203643a6fd9496a0 = 'KNOWLEDGE_BASE';
const $3183c1ede6a2aff4$export$9c83bd19c3ffd90d = 'SENTIMENT';
const $3183c1ede6a2aff4$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
const $3183c1ede6a2aff4$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
const $3183c1ede6a2aff4$export$913055729e1380b2 = 'summary';
const $3183c1ede6a2aff4$export$d44826c816b5619b = 'description';
const $3183c1ede6a2aff4$export$a29989082612d0d9 = 'comment';
const $3183c1ede6a2aff4$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $3183c1ede6a2aff4$export$3b3d0889022c85b3 = 'children-issues';
const $3183c1ede6a2aff4$export$be46596bc6608f3b = 'environment';
const $3183c1ede6a2aff4$export$f528fadbfdb3c25e = 'subtasks';
const $3183c1ede6a2aff4$export$f10e53e8928b61bd = 'dataclassification';
const $3183c1ede6a2aff4$export$e0dfb65d1047c53c = (0, $lO4Or.PARENT_CF_TYPE);
const $3183c1ede6a2aff4$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $3183c1ede6a2aff4$export$cdbd1eb3b05729e0 = 'flagActions';
const $3183c1ede6a2aff4$export$c161a774ec2e7e56 = 'cardCoverActions';
const $3183c1ede6a2aff4$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$3183c1ede6a2aff4$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$3183c1ede6a2aff4$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$3183c1ede6a2aff4$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $lO4Or.TEAM_CF_TYPE)]: (0, $lO4Or.TEAM_CF_TYPE),
        [(0, $lO4Or.PARENT_CF_TYPE)]: (0, $lO4Or.PARENT_CF_TYPE),
        [(0, $lO4Or.BASELINE_START_CF_TYPE)]: (0, $lO4Or.BASELINE_START_CF_TYPE),
        [(0, $lO4Or.BASELINE_END_CF_TYPE)]: (0, $lO4Or.BASELINE_END_CF_TYPE),
        [(0, $lO4Or.COLOR_CF_TYPE)]: (0, $lO4Or.COLOR_CF_TYPE),
        [(0, $lO4Or.EPIC_COLOR_TYPE)]: (0, $lO4Or.EPIC_COLOR_TYPE),
        [(0, $lO4Or.EPIC_NAME_TYPE)]: (0, $lO4Or.EPIC_NAME_TYPE)
    };
    return fields;
};
const $3183c1ede6a2aff4$export$87934b3672715c91 = [
    (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $3183c1ede6a2aff4$var$serviceDeskCustomFields = [
    (0, $lO4Or.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $lO4Or.ORGANIZATIONS_CF_TYPE),
    (0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE),
    (0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE),
    (0, $lO4Or.APPROVALS_CF_TYPE),
    (0, $lO4Or.APPROVERS_LIST_CF_TYPE),
    (0, $lO4Or.REQUEST_TYPE_CF_TYPE),
    (0, $lO4Or.CMDB_OBJECT_CF_TYPE),
    (0, $lO4Or.RESPONDERS_CF_TYPE),
    (0, $lO4Or.MAJOR_INCIDENT_CF_TYPE),
    (0, $lO4Or.ENTITLEMENT_CF_TYPE),
    (0, $lO4Or.SENTIMENT_CF_TYPE)
];
const $3183c1ede6a2aff4$export$efd443bccc4c01ed = ()=>[
        (0, $lO4Or.LABELS_CF_TYPE),
        (0, $lO4Or.TEXT_CF_TYPE),
        (0, $lO4Or.MULTI_USER_CF_TYPE),
        (0, $lO4Or.PARTICIPANTS_CF_TYPE),
        (0, $lO4Or.URL_CF_TYPE),
        (0, $lO4Or.NUMBER_CF_TYPE),
        (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $lO4Or.SELECT_CF_TYPE),
        (0, $lO4Or.MULTI_SELECT_CF_TYPE),
        (0, $lO4Or.VERSION_CF_TYPE),
        (0, $lO4Or.TEXT_AREA_CF_TYPE),
        (0, $lO4Or.MULTI_VERSION_CF_TYPE),
        (0, $lO4Or.DATE_CF_TYPE),
        (0, $lO4Or.GROUP_CF_TYPE),
        (0, $lO4Or.MULTI_GROUP_CF_TYPE),
        (0, $lO4Or.USER_CF_TYPE),
        (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
        (0, $lO4Or.RADIO_BUTTONS_CF_TYPE),
        (0, $lO4Or.DATETIME_CF_TYPE),
        (0, $lO4Or.ASSETS_CF_TYPE),
        (0, $lO4Or.SERVICE_ENTITY_CF_TYPE),
        (0, $lO4Or.PEOPLE_CF_TYPE),
        (0, $lO4Or.CASCADING_SELECT_CF_TYPE),
        (0, $lO4Or.PROJECT_PICKER_CF_TYPE),
        (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
        (0, $lO4Or.READ_ONLY_CF_TYPE),
        (0, $lO4Or.EPIC_STATUS_TYPE),
        (0, $lO4Or.MESSAGE_VIEW_CF_TYPE),
        (0, $lO4Or.MESSAGE_EDIT_CF_TYPE),
        (0, $lO4Or.CATEGORY_TYPE),
        (0, $lO4Or.GOALS_CF_TYPE),
        ...$3183c1ede6a2aff4$export$87934b3672715c91,
        ...$3183c1ede6a2aff4$var$serviceDeskCustomFields
    ];
const $3183c1ede6a2aff4$export$a18b3a656ee9c709 = {
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $7ZZxN.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $3183c1ede6a2aff4$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $3183c1ede6a2aff4$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $2wUFy.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $2wUFy.default).SOFTWARE_ISSUE,
        issueActions: [
            $3183c1ede6a2aff4$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $2wUFy.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $3183c1ede6a2aff4$export$cdbd1eb3b05729e0,
            $3183c1ede6a2aff4$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $2wUFy.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $3183c1ede6a2aff4$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $2wUFy.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $3183c1ede6a2aff4$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $2wUFy.default).MOBILE_ISSUE,
        issueActions: []
    });
const $3183c1ede6a2aff4$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $2wUFy.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $2wUFy.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if (config.isSimplified) return $3183c1ede6a2aff4$export$aebf676dfa727a1c();
            return $3183c1ede6a2aff4$export$27e0678365e5dcff();
        case 0, $7ZZxN.CORE_PROJECT:
            return $3183c1ede6a2aff4$export$381ce08838c53afa();
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return $3183c1ede6a2aff4$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $3183c1ede6a2aff4$export$27e0678365e5dcff();
    }
    return $3183c1ede6a2aff4$export$27e0678365e5dcff();
};

});

parcelRegister("5JqpU", function(module, exports) {

$parcel$export(module.exports, "contextSelector", () => $2109a7cb7c7dfa9a$export$c420c9f40402ab6d);
$parcel$export(module.exports, "accountIdloggedInUserSelector", () => $2109a7cb7c7dfa9a$export$cb29341089829e17);
$parcel$export(module.exports, "orgIdSelector", () => $2109a7cb7c7dfa9a$export$24984a39db14d8);
$parcel$export(module.exports, "baseUrlSelector", () => $2109a7cb7c7dfa9a$export$1ca9a92a5f28e233);
$parcel$export(module.exports, "loginRedirectUrlSelector", () => $2109a7cb7c7dfa9a$export$767583fcce1653ec);
$parcel$export(module.exports, "issueKeySelector", () => $2109a7cb7c7dfa9a$export$d22bc6271070f453);
$parcel$export(module.exports, "issueIdSelector", () => $2109a7cb7c7dfa9a$export$31efbca30077ec1e);
$parcel$export(module.exports, "projectKeySelector", () => $2109a7cb7c7dfa9a$export$404de5ac601b84bc);
$parcel$export(module.exports, "analyticsSourceSelector", () => $2109a7cb7c7dfa9a$export$85a9d212d56669b4);
$parcel$export(module.exports, "cloudIdSelector", () => $2109a7cb7c7dfa9a$export$b5a643cfff945455);
$parcel$export(module.exports, "activationIdSelector", () => $2109a7cb7c7dfa9a$export$2335b963a9875096);
$parcel$export(module.exports, "isAnonymousSelector", () => $2109a7cb7c7dfa9a$export$a165ec261432d0b8);
$parcel$export(module.exports, "localeSelector", () => $2109a7cb7c7dfa9a$export$f7b7935883444b11);
$parcel$export(module.exports, "issueActionsSelector", () => $2109a7cb7c7dfa9a$export$b62cb5286b153905);
$parcel$export(module.exports, "applicationKeySelector", () => $2109a7cb7c7dfa9a$export$6c7d07328f197de7);
$parcel$export(module.exports, "isMobileSelector", () => $2109a7cb7c7dfa9a$export$4cbb8c74e98876a5);
$parcel$export(module.exports, "isBitbucketSelector", () => $2109a7cb7c7dfa9a$export$245e5ba54167b84a);
$parcel$export(module.exports, "isServiceDeskSelector", () => $2109a7cb7c7dfa9a$export$43d733e4b7e8c7d0);
$parcel$export(module.exports, "isEcosystemEnabledSelector", () => $2109a7cb7c7dfa9a$export$9bffc1987c753bd9);
$parcel$export(module.exports, "rapidViewIdSelector", () => $2109a7cb7c7dfa9a$export$718e830000b27a0e);
$parcel$export(module.exports, "boardTypeSelector", () => $2109a7cb7c7dfa9a$export$5af08fd769c0f0);
$parcel$export(module.exports, "boardIdSelector", () => $2109a7cb7c7dfa9a$export$955e7dbf76b61f80);
$parcel$export(module.exports, "siteAdminStatusSelector", () => $2109a7cb7c7dfa9a$export$93badd2a066af8bd);
$parcel$export(module.exports, "licensedProductsSelector", () => $2109a7cb7c7dfa9a$export$f29192b357e6beca);
$parcel$export(module.exports, "appPermissionsSelector", () => $2109a7cb7c7dfa9a$export$5b71e1eb43056b6c);
$parcel$export(module.exports, "isModalSelector", () => $2109a7cb7c7dfa9a$export$5fa593caa6a15917);
$parcel$export(module.exports, "shouldRenderHeaderSelector", () => $2109a7cb7c7dfa9a$export$631793d49dec78de);
$parcel$export(module.exports, "viewModeSelector", () => $2109a7cb7c7dfa9a$export$1f11fe78e4f22d45);
$parcel$export(module.exports, "appEditionsSelector", () => $2109a7cb7c7dfa9a$export$28ca74e18c8f4529);
$parcel$export(module.exports, "tenantHasActiveServiceDeskLicenseSelector", () => $2109a7cb7c7dfa9a$export$96c87532aec3474a);
$parcel$export(module.exports, "hasShownIntentToXflowToConfluenceTraitSelector", () => $2109a7cb7c7dfa9a$export$ab1f876d8f682229);
$parcel$export(module.exports, "hasActivatedConfluenceWithinFourteenDaysSelector", () => $2109a7cb7c7dfa9a$export$2b8e6729c89e24f5);

var $df4Sl = parcelRequire("df4Sl");

var $7n7Dc = parcelRequire("7n7Dc");
var $kWEgJ = parcelRequire("kWEgJ");
var $3xcI8 = parcelRequire("3xcI8");
var $3jYzf = parcelRequire("3jYzf");
var $9FEvp = parcelRequire("9FEvp");


var $e91YZ = parcelRequire("e91YZ");

var $jBy23 = parcelRequire("jBy23");

var $f9RL0 = parcelRequire("f9RL0");

var $6vrw7 = parcelRequire("6vrw7");

var $7HKaW = parcelRequire("7HKaW");
const $2109a7cb7c7dfa9a$export$c420c9f40402ab6d = (state)=>state.context;
const $2109a7cb7c7dfa9a$export$cb29341089829e17 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.atlassianAccountId);
const $2109a7cb7c7dfa9a$export$24984a39db14d8 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context?.orgId || null);
const $2109a7cb7c7dfa9a$export$1ca9a92a5f28e233 = (_)=>'';
const $2109a7cb7c7dfa9a$export$767583fcce1653ec = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.loginRedirectUrl);
const $2109a7cb7c7dfa9a$export$d22bc6271070f453 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>(0, $6vrw7.toIssueKey)(context.issueKey));
const $2109a7cb7c7dfa9a$export$31efbca30077ec1e = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.issueId);
const $2109a7cb7c7dfa9a$export$404de5ac601b84bc = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$d22bc6271070f453, (issueKey)=>(0, $jBy23.extractProjectKey)(issueKey));
const $2109a7cb7c7dfa9a$export$85a9d212d56669b4 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.analyticsSource !== undefined ? context.analyticsSource : undefined);
const $2109a7cb7c7dfa9a$export$b5a643cfff945455 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.cloudId || (0, $6vrw7.toCloudId)(''));
const $2109a7cb7c7dfa9a$export$2335b963a9875096 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.activationId || (0, $6vrw7.toActivationId)(''));
const $2109a7cb7c7dfa9a$export$a165ec261432d0b8 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.isAnonymous);
const $2109a7cb7c7dfa9a$export$f7b7935883444b11 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.locale);
const $2109a7cb7c7dfa9a$export$b62cb5286b153905 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.issueActions || []);
const $2109a7cb7c7dfa9a$export$6c7d07328f197de7 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.applicationKey);
const $2109a7cb7c7dfa9a$export$4cbb8c74e98876a5 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$2109a7cb7c7dfa9a$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $0100842672acae20$export$ce88447986394f2d));
const $2109a7cb7c7dfa9a$export$6fbe1dbaf5b67cc5 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $f9RL0.simpleSoftwareBoardConfiguration)().applicationKey || applicationKey === (0, $f9RL0.standardRoadmapConfiguration)().applicationKey);
const $2109a7cb7c7dfa9a$export$7479ef2453efd3b4 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $f9RL0.softwareConfiguration)().applicationKey);
const $2109a7cb7c7dfa9a$export$245e5ba54167b84a = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$2109a7cb7c7dfa9a$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $0100842672acae20$export$7552fe2669628499));
const $2109a7cb7c7dfa9a$export$43d733e4b7e8c7d0 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $f9RL0.serviceDeskConfiguration)().applicationKey);
const $2109a7cb7c7dfa9a$export$9bffc1987c753bd9 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>!!context.ecosystemEnabled);
const $2109a7cb7c7dfa9a$export$718e830000b27a0e = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.rapidViewId);
const $2109a7cb7c7dfa9a$export$8065de5fbcf23af5 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.estimationStatistic || null);
const $2109a7cb7c7dfa9a$export$5af08fd769c0f0 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.boardType);
const $2109a7cb7c7dfa9a$export$955e7dbf76b61f80 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.boardId);
const $2109a7cb7c7dfa9a$export$93badd2a066af8bd = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.siteAdminStatus);
const $2109a7cb7c7dfa9a$export$b468116a08f9183e = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.productCrossSellConfig);
const $2109a7cb7c7dfa9a$export$f29192b357e6beca = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.licensedProducts);
const $2109a7cb7c7dfa9a$export$5b71e1eb43056b6c = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.appPermissions);
const $2109a7cb7c7dfa9a$export$5fa593caa6a15917 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.isModal);
const $2109a7cb7c7dfa9a$export$631793d49dec78de = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$5fa593caa6a15917, $2109a7cb7c7dfa9a$export$4cbb8c74e98876a5, (isModal, isMobile)=>!isModal && !isMobile);
const $2109a7cb7c7dfa9a$export$1f11fe78e4f22d45 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.viewMode);
const $2109a7cb7c7dfa9a$export$28ca74e18c8f4529 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.appEditions);
const $2109a7cb7c7dfa9a$export$beea798086c18f0a = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.licenseStates);
const $2109a7cb7c7dfa9a$export$40487a15195e570e = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$beea798086c18f0a, (licenseStates)=>licenseStates && licenseStates.serviceDesk === (0, $7HKaW.LICENSE_STATE_ACTIVE));
const $2109a7cb7c7dfa9a$export$96c87532aec3474a = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$f29192b357e6beca, $2109a7cb7c7dfa9a$export$40487a15195e570e, (licensedProducts, isServiceDeskLicenseActive)=>licensedProducts && licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SERVICEDESK] && isServiceDeskLicenseActive);
const $2109a7cb7c7dfa9a$export$ab1f876d8f682229 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.hasShownIntentToXflowToConfluence);
const $2109a7cb7c7dfa9a$export$747a61878b414bda = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$c420c9f40402ab6d, (context)=>context.confluenceActivationDate);
const $2109a7cb7c7dfa9a$export$2b8e6729c89e24f5 = (0, $df4Sl.createSelector)($2109a7cb7c7dfa9a$export$747a61878b414bda, (confluenceActivationDate)=>{
    try {
        if (!confluenceActivationDate) return false;
        const today = (0, $7n7Dc.default)(new Date());
        const fourteenDaysAgo = (0, $3jYzf.default)((0, $9FEvp.default)(today, 14));
        const dateToCheck = (0, $3xcI8.default)(confluenceActivationDate);
        return (0, $kWEgJ.default)(dateToCheck, {
            start: fourteenDaysAgo,
            end: today
        });
    } catch (error) {
        return false;
    }
});

});

parcelRegister("fokFV", function(module, exports) {

$parcel$export(module.exports, "fieldsSelector", () => $d3e83eef394576d0$export$e1512647ca813bfa);
$parcel$export(module.exports, "getFieldHandlingSpecialFields", () => $d3e83eef394576d0$export$46dde968006cd8d4);
$parcel$export(module.exports, "fieldByCustomTypeSelector", () => $d3e83eef394576d0$export$72dfc619a02c972c);
$parcel$export(module.exports, "customFieldIdSelector", () => $d3e83eef394576d0$export$8ad8506b941e30dc);
$parcel$export(module.exports, "fieldSelector", () => $d3e83eef394576d0$export$4ee5e7baedf94214);
$parcel$export(module.exports, "hasIssueLinksSelector", () => $d3e83eef394576d0$export$3c65f67962ca81cc);
$parcel$export(module.exports, "hasSubtasksSelector", () => $d3e83eef394576d0$export$f363078714850fd9);
$parcel$export(module.exports, "hasSubtasksValuesSelector", () => $d3e83eef394576d0$export$689f8f96c9d81e1b);
$parcel$export(module.exports, "hasPortfolioChildIssuesSelector", () => $d3e83eef394576d0$export$724b8972771ff092);
$parcel$export(module.exports, "hasPortfolioChildIssueValuesSelector", () => $d3e83eef394576d0$export$c6d2d4f8e243ac37);
$parcel$export(module.exports, "hasChildrenIssuesSelector", () => $d3e83eef394576d0$export$29f34d4d7c528e9c);
$parcel$export(module.exports, "hasChildrenIssueValuesSelector", () => $d3e83eef394576d0$export$9034aaa32d45814b);
$parcel$export(module.exports, "childIssuesLimitUrlSelector", () => $d3e83eef394576d0$export$762e13908aaafb2d);
$parcel$export(module.exports, "availableFieldIdsSelector", () => $d3e83eef394576d0$export$641248fa887fb9ea);
$parcel$export(module.exports, "fieldSchemaConfigurationSelector", () => $d3e83eef394576d0$export$3c65874760e68948);
$parcel$export(module.exports, "isFieldEditableSelector", () => $d3e83eef394576d0$export$76ece3d8c4244af2);
$parcel$export(module.exports, "fieldNameSelector", () => $d3e83eef394576d0$export$2d1abc174b8a710e);
$parcel$export(module.exports, "fieldMetaKeySelector", () => $d3e83eef394576d0$export$351970d5fcbd0b29);
$parcel$export(module.exports, "fieldARISelector", () => $d3e83eef394576d0$export$f6363cecfaa3a9b0);
$parcel$export(module.exports, "fieldAutoCompleteUrlSelector", () => $d3e83eef394576d0$export$d27105f13ab27906);
$parcel$export(module.exports, "fieldAllowedValuesSelector", () => $d3e83eef394576d0$export$351dc1c32c2771ea);
$parcel$export(module.exports, "isFieldRequiredSelector", () => $d3e83eef394576d0$export$4c5f76e28914074);
$parcel$export(module.exports, "fieldTypeSelector", () => $d3e83eef394576d0$export$9e2f15437ff59992);
$parcel$export(module.exports, "fieldPersistedValueSelector", () => $d3e83eef394576d0$export$ae4660b0b7ebeee9);
$parcel$export(module.exports, "fieldPendingValueSelector", () => $d3e83eef394576d0$export$2ae929653dce6648);
$parcel$export(module.exports, "fieldEditingValueSelector", () => $d3e83eef394576d0$export$487becf51bedcd03);
$parcel$export(module.exports, "fieldEditingAdfValueSelector", () => $d3e83eef394576d0$export$31406f841bca5b75);
$parcel$export(module.exports, "fieldHtmlValueSelector", () => $d3e83eef394576d0$export$e69c8171ecd8fde2);
$parcel$export(module.exports, "isFieldEditingSelector", () => $d3e83eef394576d0$export$29e6b1cade110749);
$parcel$export(module.exports, "fieldEditSessionIdSelector", () => $d3e83eef394576d0$export$c53ab145ef243c95);
$parcel$export(module.exports, "isFieldWaitingSelector", () => $d3e83eef394576d0$export$30e972ebce44d9b8);
$parcel$export(module.exports, "fieldInvalidMessageSelector", () => $d3e83eef394576d0$export$d323462f155519c3);
$parcel$export(module.exports, "fieldInvalidSelector", () => $d3e83eef394576d0$export$e35f4d21d9739426);
$parcel$export(module.exports, "isRichTextFieldSelector", () => $d3e83eef394576d0$export$120a4249e9b3c231);
$parcel$export(module.exports, "richTextFieldIdsSelector", () => $d3e83eef394576d0$export$862745d3ab4003e5);
$parcel$export(module.exports, "isRichTextFieldEditingSelector", () => $d3e83eef394576d0$export$df9b7004d8b93e46);
$parcel$export(module.exports, "isMultilineFieldSelector", () => $d3e83eef394576d0$export$4d0b1fe809ae5e75);
$parcel$export(module.exports, "getEditingMultilineFieldIdsSelector", () => $d3e83eef394576d0$export$2469330614f0dba9);
$parcel$export(module.exports, "getVersionsFieldIds", () => $d3e83eef394576d0$export$a2fc0905011957cb);

var $df4Sl = parcelRequire("df4Sl");

var $8i1R8 = parcelRequire("8i1R8");

var $gUUjF = parcelRequire("gUUjF");


var $btjMs = parcelRequire("btjMs");

var $f9RL0 = parcelRequire("f9RL0");

var $lO4Or = parcelRequire("lO4Or");


var $5JqpU = parcelRequire("5JqpU");

var $9BmVu = parcelRequire("9BmVu");

var $7K0ls = parcelRequire("7K0ls");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d3e83eef394576d0$var$STABLE_EMPTY_ARRAY = [];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d3e83eef394576d0$var$STABLE_EMPTY_OBJECT = {};
const $d3e83eef394576d0$export$e1512647ca813bfa = (state)=>state.fields || $d3e83eef394576d0$var$STABLE_EMPTY_OBJECT;
const $d3e83eef394576d0$var$getFieldByCustomType = (customType, fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(fields, (field)=>(field.schema && field.schema.custom) === customType);
const $d3e83eef394576d0$export$46dde968006cd8d4 = (fieldId, fields)=>{
    let field = fields[fieldId];
    const customSystemFields = (0, $f9RL0.specialFields)();
    if (!field && Object.keys(customSystemFields).includes(fieldId)) {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        const customType = customSystemFields[fieldId];
        // @ts-expect-error - TS2322 - Type 'Field | undefined' is not assignable to type 'Field'.
        field = $d3e83eef394576d0$var$getFieldByCustomType(customType, fields);
    }
    return field;
};
const $d3e83eef394576d0$export$cb67eba45dd11f50 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>!!fields[fieldId]);
const $d3e83eef394576d0$export$309344981947f228 = (fieldsState, fieldName)=>Array.isArray(fieldsState[fieldName]?.value) ? fieldsState[fieldName].value.length > 0 : fieldsState[fieldName]?.value != null;
const $d3e83eef394576d0$export$72dfc619a02c972c = (customType)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>$d3e83eef394576d0$var$getFieldByCustomType(customType, fields));
const $d3e83eef394576d0$export$8ad8506b941e30dc = (customFieldType)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$72dfc619a02c972c(customFieldType), (customField)=>{
        const idCandidates = customField ? customField.key.match(/customfield_(\d+)$/i) : null;
        return idCandidates ? +idCandidates[1] : null;
    });
const $d3e83eef394576d0$export$4ee5e7baedf94214 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>$d3e83eef394576d0$export$46dde968006cd8d4(fieldId, fields));
const $d3e83eef394576d0$export$b8de62018cc85a18 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>$d3e83eef394576d0$export$46dde968006cd8d4(fieldId, fields));
const $d3e83eef394576d0$export$3c65f67962ca81cc = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $ebc098a76317be78$export$a5fc282ab2bf9b89)));
const $d3e83eef394576d0$export$f363078714850fd9 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes('subtasks'));
const $d3e83eef394576d0$export$689f8f96c9d81e1b = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>$d3e83eef394576d0$export$309344981947f228(fields, 'subtasks'));
const $d3e83eef394576d0$export$724b8972771ff092 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $f9RL0.PORTFOLIO_CHILD_ISSUES)));
const $d3e83eef394576d0$export$c6d2d4f8e243ac37 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>$d3e83eef394576d0$export$309344981947f228(fields, (0, $f9RL0.PORTFOLIO_CHILD_ISSUES)));
const $d3e83eef394576d0$export$29f34d4d7c528e9c = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $f9RL0.CHILDREN_ISSUES)));
const $d3e83eef394576d0$export$9034aaa32d45814b = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>$d3e83eef394576d0$export$309344981947f228(fields, (0, $f9RL0.CHILDREN_ISSUES)));
const $d3e83eef394576d0$export$762e13908aaafb2d = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>{
    const getChildIssueUrlSelector = (fieldId)=>fields?.[fieldId]?.issueLimitUrl || '';
    return getChildIssueUrlSelector;
});
const $d3e83eef394576d0$export$9ee3b3f5d4ad4423 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>Object.keys(fields).map((fieldKey)=>$d3e83eef394576d0$export$46dde968006cd8d4(fieldKey, fields)).filter(Boolean));
const $d3e83eef394576d0$export$641248fa887fb9ea = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (fields)=>Object.keys(fields));
const $d3e83eef394576d0$export$e50b5889a6b86caf = (field)=>field ? field.editable : false;
const $d3e83eef394576d0$export$3c65874760e68948 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && field.schema && field.schema.configuration && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        field.schema.configuration.reduce((config, { key: key, value: value })=>({
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...config,
                [key]: value
            }), {}));
const $d3e83eef394576d0$export$76ece3d8c4244af2 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>$d3e83eef394576d0$export$e50b5889a6b86caf(field));
const $d3e83eef394576d0$export$2d1abc174b8a710e = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>{
        if (field && field.title) return field.title;
        (0, $gUUjF.default).safeWarnWithoutCustomerData('issue.field.selector', `${fieldId} does not have a field title`);
        return '';
    });
const $d3e83eef394576d0$export$d20285fb6e3fb007 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$b8de62018cc85a18, (state, { fieldId: fieldId })=>fieldId, (field, fieldId)=>{
    if (field?.title) return field.title;
    (0, $gUUjF.default).safeWarnWithoutCustomerData('issue.field.selector', `${fieldId} does not have a field title`);
    return '';
});
const $d3e83eef394576d0$export$351970d5fcbd0b29 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && field.key);
const $d3e83eef394576d0$export$f6363cecfaa3a9b0 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.ari : undefined);
const $d3e83eef394576d0$export$d27105f13ab27906 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && field.autoCompleteUrl);
const $d3e83eef394576d0$export$351dc1c32c2771ea = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.allowedValues : $d3e83eef394576d0$var$STABLE_EMPTY_ARRAY);
const $d3e83eef394576d0$export$4c5f76e28914074 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.required : false);
const $d3e83eef394576d0$export$9e2f15437ff59992 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $btjMs.getFieldType)(field));
const $d3e83eef394576d0$export$ae4660b0b7ebeee9 = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && field.value);
const $d3e83eef394576d0$export$bf3f8fd2c145740 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$b8de62018cc85a18, (field)=>field?.value);
const $d3e83eef394576d0$export$2ae929653dce6648 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $7K0ls.default)(field));
const $d3e83eef394576d0$export$487becf51bedcd03 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $9BmVu.default)(field));
const $d3e83eef394576d0$export$31406f841bca5b75 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (field)=>field && (0, $9BmVu.getEditingAdfValue)(field));
const $d3e83eef394576d0$export$e69c8171ecd8fde2 = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && field.renderedValue);
const $d3e83eef394576d0$export$4e96991314eba25 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$b8de62018cc85a18, (field)=>field?.renderedValue);
const $d3e83eef394576d0$export$18ec1d851ee244b3 = (field)=>field ? field.editingValue !== undefined : false;
const $d3e83eef394576d0$export$29e6b1cade110749 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>$d3e83eef394576d0$export$18ec1d851ee244b3(field));
const $d3e83eef394576d0$export$c53ab145ef243c95 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>(field ? field.fieldEditSessionId : null) || '');
const $d3e83eef394576d0$export$30e972ebce44d9b8 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.pendingValue !== undefined : false);
const $d3e83eef394576d0$export$d323462f155519c3 = (fieldId, fallbackInvalidMessage)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && (field.isInvalid ? field.invalidMessage || fallbackInvalidMessage : null));
const $d3e83eef394576d0$export$e35f4d21d9739426 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>Boolean(field && field.isInvalid));
const $d3e83eef394576d0$export$448aaad27e620666 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214(fieldId), (field)=>field && field.schema && field.schema.renderer);
const $d3e83eef394576d0$export$94cc87cea4e06b09 = (fieldType)=>fieldType === (0, $lO4Or.TEXT_AREA_CF_TYPE) || fieldType === (0, $f9RL0.ENVIRONMENT) || fieldType === (0, $f9RL0.DESCRIPTION);
const $d3e83eef394576d0$export$120a4249e9b3c231 = (fieldId)=>(0, $df4Sl.createSelector)((0, $5JqpU.isServiceDeskSelector), $d3e83eef394576d0$export$9e2f15437ff59992(fieldId), $d3e83eef394576d0$export$448aaad27e620666(fieldId), (isServiceDesk, fieldType, fieldRenderer)=>{
        const isDescription = fieldId === (0, $f9RL0.DESCRIPTION);
        const isMultilineRichTextField = $d3e83eef394576d0$export$94cc87cea4e06b09(fieldType) && fieldRenderer === (0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c);
        return isDescription || isMultilineRichTextField;
    });
const $d3e83eef394576d0$export$862745d3ab4003e5 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (state)=>state, (fields, state)=>Object.keys(fields).filter((fieldId)=>$d3e83eef394576d0$export$120a4249e9b3c231(fieldId)(state)));
const $d3e83eef394576d0$export$df9b7004d8b93e46 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$862745d3ab4003e5, (state)=>state, (richTextFieldIds, state)=>richTextFieldIds.some((fieldId)=>$d3e83eef394576d0$export$29e6b1cade110749(fieldId)(state)));
const $d3e83eef394576d0$export$4d0b1fe809ae5e75 = (fieldId)=>(0, $df4Sl.createSelector)($d3e83eef394576d0$export$9e2f15437ff59992(fieldId), (fieldType)=>$d3e83eef394576d0$export$94cc87cea4e06b09(fieldType));
const $d3e83eef394576d0$export$3263c202444b0e0 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$e1512647ca813bfa, (state)=>state, (fields, state)=>Object.keys(fields).filter((fieldId)=>$d3e83eef394576d0$export$4d0b1fe809ae5e75(fieldId)(state)));
const $d3e83eef394576d0$export$2469330614f0dba9 = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$3263c202444b0e0, (state)=>state, (multilineFieldsIds, state)=>multilineFieldsIds.filter((fieldId)=>$d3e83eef394576d0$export$29e6b1cade110749(fieldId)(state)));
const $d3e83eef394576d0$export$a2fc0905011957cb = (0, $df4Sl.createSelector)($d3e83eef394576d0$export$4ee5e7baedf94214((0, $f9RL0.FIX_VERSIONS)), $d3e83eef394576d0$export$4ee5e7baedf94214((0, $f9RL0.AFFECTS_VERSIONS)), (fixVersions, affectsVersions)=>{
    const ids = [];
    if (fixVersions) ids.push(fixVersions.key);
    if (affectsVersions) ids.push(affectsVersions.key);
    return ids;
});

});
parcelRegister("btjMs", function(module, exports) {

$parcel$export(module.exports, "getFieldType", () => $2e3967e17ab00816$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isRichTextSupported", () => $2e3967e17ab00816$export$24d1b07fa0e9f9f1);


var $f9RL0 = parcelRequire("f9RL0");

var $lO4Or = parcelRequire("lO4Or");
const $2e3967e17ab00816$var$atlassianSystemCFTypes = ()=>{
    const customSystemFields = (0, $f9RL0.specialFields)();
    return [
        ...(0, $f9RL0.customFieldsToDisplay)().filter((cf)=>!(0, $f9RL0.ecosystemCustomFields).includes(cf)),
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
        (0, $lO4Or.FLAGGED_CF_TYPE)
    ];
};
const $2e3967e17ab00816$export$f521834fc2bfcd81 = (custom)=>$2e3967e17ab00816$var$atlassianSystemCFTypes().find((type)=>type === custom);
const $2e3967e17ab00816$export$b9089a6e41ed43aa = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? $2e3967e17ab00816$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
};
const $2e3967e17ab00816$export$24d1b07fa0e9f9f1 = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? fieldSchema.type === (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE) && fieldSchema.renderer === (0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c) || $2e3967e17ab00816$export$b9089a6e41ed43aa(field) === (0, $lO4Or.DESCRIPTION_TYPE) : false;
};

});

const $ebc098a76317be78$export$e18419056f3d184a = 'assignee';
const $ebc098a76317be78$export$45cafdfd629c3ca1 = 'reporter';
const $ebc098a76317be78$export$d5bc879e3b748593 = 'description';
const $ebc098a76317be78$export$a68dbc90211df1a8 = 'fixVersions';
const $ebc098a76317be78$export$93605f2a09aa8d26 = 'labels';
const $ebc098a76317be78$export$4420b7468f889692 = 'status';
const $ebc098a76317be78$export$e7cf1830fe735d1f = 'summary';
const $ebc098a76317be78$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $ebc098a76317be78$export$a5fc282ab2bf9b89 = 'issuelinks';
const $ebc098a76317be78$export$b52547457d714bc0 = 'epic-issues';
const $ebc098a76317be78$export$3cca6e37a5823d5a = 'children-issues';
const $ebc098a76317be78$export$98a935eb30de54ab = 'components';

parcelRegister("9BmVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d346be13db9b307d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getEditingAdfValue", () => $d346be13db9b307d$export$a799cf637c5b7727);

var $7K0ls = parcelRequire("7K0ls");
var /**
 * Returns the first available value for a given field.
 * editingValue => pendingValue => value
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$d346be13db9b307d$export$2e2bcd8739ae039 = (field)=>typeof field.editingValue !== 'undefined' ? field.editingValue : (0, $7K0ls.default)(field);
const $d346be13db9b307d$export$a799cf637c5b7727 = (field)=>field.editingValue || (0, $7K0ls.getPendingAdfValue)(field);

});
parcelRegister("7K0ls", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d564564465be8d6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getPendingAdfValue", () => $8d564564465be8d6$export$5012210a9f91b010);
var /**
 * Returns the first available value for a given field, excluding editingValue
 * pendingValue => value
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$8d564564465be8d6$export$2e2bcd8739ae039 = (field)=>typeof field.pendingValue !== 'undefined' ? field.pendingValue : field.value;
const $8d564564465be8d6$export$5012210a9f91b010 = (field)=>field.pendingValue || field.adfValue || field.value;

});





parcelRegister("lMwBY", function(module, exports) {

$parcel$export(module.exports, "afterPaintEmit", () => $6a5d9a384a9292d0$export$dc4c3408669b8f4e);

var $6iz4v = parcelRequire("6iz4v");

const $6a5d9a384a9292d0$export$dc4c3408669b8f4e = (emitMetrics, metric)=>{
    const stopTime = performance.now();
    setTimeout(()=>{
        metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        setTimeout(()=>{
            emitMetrics(stopTime);
        }, 500);
    });
};

});

parcelRegister("iTvzN", function(module, exports) {

$parcel$export(module.exports, "startUimTti", () => $f4d69f5c84cf80c8$export$1422384676f6de7a);
$parcel$export(module.exports, "markUimTtiIssueViewLoaded", () => $f4d69f5c84cf80c8$export$5a9389b70d93def2);
$parcel$export(module.exports, "stopTTI", () => $f4d69f5c84cf80c8$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $f4d69f5c84cf80c8$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $f4d69f5c84cf80c8$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $f4d69f5c84cf80c8$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $f4d69f5c84cf80c8$export$d86f4868694f2aa7);

var $lNfG4 = parcelRequire("lNfG4");

var $gGRYc = parcelRequire("gGRYc");
const $f4d69f5c84cf80c8$var$uimInIssueViewTTI = (0, $lNfG4.metrics).interaction({
    key: 'ui-modifications-in-issue-view',
    timings: [
        {
            key: 'issue-view-tti-delta',
            startMark: 'issue-view-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $f4d69f5c84cf80c8$export$1422384676f6de7a = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.start();
};
const $f4d69f5c84cf80c8$export$5a9389b70d93def2 = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.mark('issue-view-tti');
};
const $f4d69f5c84cf80c8$export$30ca4c461fab486c = (customData)=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.stop({
        customData: customData
    });
};
const $f4d69f5c84cf80c8$export$27f2445288b528c = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.cancel();
};
const $f4d69f5c84cf80c8$export$7a2709fc1e33401a = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.mark('iframe-load');
};
const $f4d69f5c84cf80c8$export$cf3893335c93e33b = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.mark('fields-registered');
};
const $f4d69f5c84cf80c8$export$d86f4868694f2aa7 = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.mark('oninit-resolved');
};

});

parcelRegister("9OxOE", function(module, exports) {

$parcel$export(module.exports, "blockedOnBackendEntryLog", () => $93a7d723277e8ab3$export$dd1b3502b1e8ca97);
$parcel$export(module.exports, "getBackendBlockingTime", () => $93a7d723277e8ab3$export$8720c1f879c7ca46);

var $6iz4v = parcelRequire("6iz4v");


var $fxvfh = parcelRequire("fxvfh");

var $aLdVB = parcelRequire("aLdVB");
const $93a7d723277e8ab3$export$dd1b3502b1e8ca97 = (0, $fxvfh.createBlockedOnBackendEntryLog)();
function $93a7d723277e8ab3$var$measureBlockingEntry(measureName, backendBlockingStart, backendBlockingEnd) {
    (0, $6iz4v.setMark)(`${measureName}Start`, {
        startTime: backendBlockingStart
    });
    (0, $6iz4v.setMark)(`${measureName}End`, {
        startTime: backendBlockingEnd
    });
    (0, $6iz4v.setMeasure)(`${measureName}`, `${measureName}Start`, `${measureName}End`);
}
const $93a7d723277e8ab3$export$8720c1f879c7ca46 = (args)=>{
    const { blockingStart: blockingStartOrZero, totalBlockingDuration: totalBlockingDuration } = (0, $aLdVB.getSimplifiedBlockingTime)($93a7d723277e8ab3$export$dd1b3502b1e8ca97);
    const backendBlockingStart = Math.max(args.issueViewLoad.startTime, blockingStartOrZero);
    // Add the marks to the issueViewLoad BM3 event
    const backendBlockingEnd = backendBlockingStart + totalBlockingDuration;
    args.issueViewLoad.mark($848ef1328a091c81$export$e52cc35f872875f7, backendBlockingEnd);
    args.issueViewLoad.mark($848ef1328a091c81$export$e64e32643802b552, backendBlockingStart);
    $93a7d723277e8ab3$export$dd1b3502b1e8ca97.getBlockedOnBackendEntries().forEach(([blockingReason, { blockingStart: blockingStart, blockingEnd: blockingEnd }])=>$93a7d723277e8ab3$var$measureBlockingEntry(`issueView_blockedOnBackend_${blockingReason}`, blockingStart, blockingEnd));
    return {
        issueDataAvailable: backendBlockingEnd,
        issueReadyForData: backendBlockingStart
    };
};

});
parcelRegister("fxvfh", function(module, exports) {

$parcel$export(module.exports, "createBlockedOnBackendEntryLog", () => $929fa833717a1818$export$44ddca89673a78bc);
const $929fa833717a1818$export$44ddca89673a78bc = ()=>{
    const blockedOnBackendState = {
        timestamps: {}
    };
    // Internal use, use initialiseBlockedOnBackendStateForUpdatedKey externally
    const clearBlockedOnBackendState = ()=>{
        blockedOnBackendState.timestamps = {};
        blockedOnBackendState.currentKey = undefined;
    };
    // Internal use, use markStartBackendBlockingTimestamp or markEndBackendBlockingTimestamp
    const getOrCreateTimestampsEntryForKey = (blockingReasonKey)=>{
        let blockingDurationTimestamps = blockedOnBackendState.timestamps[blockingReasonKey];
        if (!blockingDurationTimestamps) {
            blockingDurationTimestamps = {};
            blockedOnBackendState.timestamps[blockingReasonKey] = blockingDurationTimestamps;
        }
        return blockingDurationTimestamps;
    };
    /**
	 * Initialise the store for a given key string.
	 * Only resets the state the first if the key string updates from its initial undefined OR if the key updates from the last time this was called
	 */ const initialiseBlockedOnBackendStateForUpdatedKey = (key)=>{
        if (key !== blockedOnBackendState.currentKey) {
            clearBlockedOnBackendState();
            blockedOnBackendState.currentKey = key;
        }
    };
    /**
	 * Fire this to mark the start of being blocked on backend for a given reason.
	 * @param blockingReasonKey An identifier for the reason for blocking. Until state is re-initialised, this reason cannot be used again to start a blocking span. Overlapping reasons will not be double counted
	 * @param timestamp optional, defaults to current time
	 */ const markStartBackendBlockingTimestamp = (blockingReasonKey, timestamp = performance.now())=>{
        const blockingDurationTimestamps = getOrCreateTimestampsEntryForKey(blockingReasonKey);
        if (!blockingDurationTimestamps.blockingStart) blockingDurationTimestamps.blockingStart = timestamp;
    };
    /**
	 * Fire this to mark the end of being blocked on backend for a given reason
	 * @param blockingReasonKey
	 * @param timestamp optional, defaults to current time
	 */ const markEndBackendBlockingTimestamp = (blockingReasonKey, timestamp = performance.now())=>{
        const blockingDurationTimestamps = getOrCreateTimestampsEntryForKey(blockingReasonKey);
        if (!blockingDurationTimestamps.blockingEnd) blockingDurationTimestamps.blockingEnd = timestamp;
    };
    /**
	 * Return a list of the entries gathered so far
	 * @param sorted whether the returned results should be sorted based on their start time. true by default
	 */ const getBlockedOnBackendEntries = ({ sorted: sorted = true } = {})=>{
        let entries = Object.entries(blockedOnBackendState.timestamps).filter((entry)=>{
            const [, blockingTimestamps] = entry;
            return blockingTimestamps.blockingStart != null && blockingTimestamps.blockingEnd != null && blockingTimestamps.blockingStart <= blockingTimestamps.blockingEnd;
        });
        if (sorted) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        entries = entries.sort(([, { blockingStart: start1 }], [, { blockingStart: start2 }])=>start1 - start2);
        return entries;
    };
    return {
        initialiseBlockedOnBackendStateForUpdatedKey: initialiseBlockedOnBackendStateForUpdatedKey,
        markStartBackendBlockingTimestamp: markStartBackendBlockingTimestamp,
        markEndBackendBlockingTimestamp: markEndBackendBlockingTimestamp,
        getBlockedOnBackendEntries: getBlockedOnBackendEntries
    };
};

});

parcelRegister("aLdVB", function(module, exports) {

$parcel$export(module.exports, "getSimplifiedBlockingTime", () => $da7b43236f8323c7$export$580550d1d1ffca6c);

var $iHCl1 = parcelRequire("iHCl1");
const $da7b43236f8323c7$export$580550d1d1ffca6c = (entryLog)=>{
    const blockingTimestampEntries = entryLog.getBlockedOnBackendEntries({
        sorted: true
    });
    const blockingSpans = (0, $iHCl1.mergeOverlappingBlockingEntries)(blockingTimestampEntries);
    const blockingStartTimes = blockingSpans.map(({ blockingStart: blockingStart })=>blockingStart ?? 0);
    const blockingDurations = blockingSpans.map(({ blockingEnd: blockingEnd, blockingStart: blockingStart })=>blockingEnd - blockingStart);
    const blockingStart = Math.min(...blockingStartTimes.length ? blockingStartTimes : [
        0
    ]);
    const totalBlockingDuration = blockingDurations.reduce((a, b)=>a + b, 0);
    return {
        blockingStart: blockingStart,
        totalBlockingDuration: totalBlockingDuration
    };
};

});
parcelRegister("iHCl1", function(module, exports) {

$parcel$export(module.exports, "mergeOverlappingBlockingEntries", () => $1e46ae3ace8b54ee$export$e63ec487944afc72);
function $1e46ae3ace8b54ee$export$e63ec487944afc72(blockingTimestampEntriesSortedByStartTime) {
    return blockingTimestampEntriesSortedByStartTime.reduce((nonOverlappingSpans, [, { blockingStart: blockingStart, blockingEnd: blockingEnd }])=>{
        const lastSpan = nonOverlappingSpans[nonOverlappingSpans.length - 1];
        if (!lastSpan || blockingStart > lastSpan.blockingEnd) nonOverlappingSpans.push({
            blockingStart: blockingStart,
            blockingEnd: blockingEnd
        }); // add the span as-is to the known non-overlapping spans
        else if (lastSpan.blockingEnd < blockingEnd) lastSpan.blockingEnd = blockingEnd;
        return nonOverlappingSpans;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    []);
}

});



parcelRegister("7iu2Y", function(module, exports) {

$parcel$export(module.exports, "issueScaleabilityReporterFactory", () => $c5094ff7f20cdaa9$export$9f6c068bd6582299);

var $1ybV0 = parcelRequire("1ybV0");


var $6azHZ = parcelRequire("6azHZ");

var $f9RL0 = parcelRequire("f9RL0");

var $kSuBQ = parcelRequire("kSuBQ");

var $4sNXH = parcelRequire("4sNXH");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $8CSFK = parcelRequire("8CSFK");

var $8QKSg = parcelRequire("8QKSg");

var $1b2Vj = parcelRequire("1b2Vj");

var $cj1Xt = parcelRequire("cj1Xt");

var $9D3Vo = parcelRequire("9D3Vo");

var $dmojD = parcelRequire("dmojD");

var $cFY86 = parcelRequire("cFY86");

var $ke6cX = parcelRequire("ke6cX");

var $6Fp9G = parcelRequire("6Fp9G");

var $dv9do = parcelRequire("dv9do");

var $lO4Or = parcelRequire("lO4Or");

var $9s86T = parcelRequire("9s86T");

var $6VKiL = parcelRequire("6VKiL");
const $c5094ff7f20cdaa9$var$getCascadingSelectFields = (state)=>Object.values((0, $fokFV.fieldsSelector)(state)).filter((fieldValues)=>fieldValues.schema.custom === (0, $lO4Or.CASCADING_SELECT_CF_TYPE));
const $c5094ff7f20cdaa9$var$getAtlassianTeamFields = (state)=>Object.values((0, $fokFV.fieldsSelector)(state)).filter((fieldValues)=>fieldValues.schema.custom === (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c5094ff7f20cdaa9$var$getCascadingSelectOptionChildrenCount = (cascadingSelectFieldValue)=>{
    if (cascadingSelectFieldValue.length === 0) return 0;
    return Object.values(cascadingSelectFieldValue).reduce((accumulatedCount, parentValue)=>accumulatedCount + (parentValue?.children?.length || 1), 0);
};
const $c5094ff7f20cdaa9$var$getCascadingSelectOptionsTotalCount = (state)=>{
    const cascadingSelectFields = $c5094ff7f20cdaa9$var$getCascadingSelectFields(state);
    if (cascadingSelectFields.length === 0) return 0;
    return cascadingSelectFields.reduce((accumulatedCount, cascadingSelectField)=>accumulatedCount + ($c5094ff7f20cdaa9$var$getCascadingSelectOptionChildrenCount(cascadingSelectField.allowedValues) || 1), 0);
};
const $c5094ff7f20cdaa9$export$ae327590f8230d00 = ({ projectKey: projectKey, ecosystem: ecosystem, forge: forge })=>{
    let open = 0;
    let closed = 0;
    if (projectKey !== undefined) {
        // The context groups store the state of open / closed inside local storage, so we need to get access to that
        // here. It's not held in redux which is why we look it up this way.
        const groupLocalStorageName = (0, $kSuBQ.getGroupLocalStorageName)(projectKey, 'context-group');
        try {
            // It's possible panels are uninstalled and not removed from localstorage, so we need to check they are installed
            // otherwise the analytics may be incorrectly advising how many panels are open
            const installedPanels = [
                ...ecosystem.map((item)=>`${groupLocalStorageName}-${(0, $4sNXH.generateContextPanelId)(item)}`),
                ...forge.map((item)=>`${groupLocalStorageName}-${item.id}`)
            ];
            open = Object.values((0, $kSuBQ.getGroupsLocalStorage)(installedPanels, (0, $ab2aafcdf11a1361$export$e1184c3be46bd7cb))).filter(Boolean).length;
            // Panels may not exist in localStorage but may be installed, in which case they are closed as this is the default state
            closed = installedPanels.length - open;
        } catch  {
        // No action required
        }
    }
    return {
        open: open,
        closed: closed
    };
};
const $c5094ff7f20cdaa9$export$9f6c068bd6582299 = (store, issueContextActions)=>()=>{
        const state = store.getState();
        const { permalinkType: permalinkType } = (0, $9s86T.getPermalinkTypeAndId)() || {};
        const childIssues = (0, $fokFV.fieldSelector)((0, $lO4Or.CHILDREN_ISSUES))(state);
        const proformaHarmonisation = (0, $fokFV.fieldSelector)((0, $lO4Or.PROFORMA_FORMS))(state);
        const { open: contextPanelOpenCount, closed: contextPanelClosedCount } = $c5094ff7f20cdaa9$export$ae327590f8230d00({
            projectKey: state?.entities?.project?.projectKey,
            ecosystem: (0, $8CSFK.contextPanelEntitiesSelector)(state),
            forge: (0, $8QKSg.forgeContextPanelsSelector)(state)
        });
        const subtaskCount = (0, $fokFV.childIssuesLimitUrlSelector)(state)((0, $f9RL0.SUBTASKS)) && issueContextActions ? (0, $6azHZ.getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : (0, $dv9do.subtaskEntitiesSelector)(state).length;
        const childIssuesCount = (0, $fokFV.childIssuesLimitUrlSelector)(state)((0, $lO4Or.CHILDREN_ISSUES)) && issueContextActions ? (0, $6azHZ.getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : childIssues?.value.length ?? 0;
        // If a portfolio issue is over the limit we cannot tell because
        // only the subtasks panel is displayed. Once the portfolio issue
        // type hierarchy level is a value > 1 then we can set this to ">100".
        let portfolioChildIssueCount;
        let actualSubtaskCount;
        let actualChildIssueCount;
        let actualEpicIssueCount;
        let epicIssueCount;
        const subtasks = (0, $fokFV.fieldSelector)((0, $f9RL0.SUBTASKS))(state);
        const epicIssues = (0, $fokFV.fieldSelector)((0, $f9RL0.EPIC_ISSUES))(state);
        const portfolioChildIssues = (0, $fokFV.fieldSelector)((0, $f9RL0.PORTFOLIO_CHILD_ISSUES))(state);
        const getChildIssuesLimitUrl = (0, $fokFV.childIssuesLimitUrlSelector)(state);
        const isEpicIssuesOverLimit = Boolean(getChildIssuesLimitUrl((0, $f9RL0.EPIC_ISSUES)));
        const isOverLimit = Boolean(getChildIssuesLimitUrl((0, $f9RL0.SUBTASKS))) || Boolean(getChildIssuesLimitUrl((0, $lO4Or.CHILDREN_ISSUES))) || isEpicIssuesOverLimit;
        if (isOverLimit) {
            actualChildIssueCount = childIssues?.originalContentLength ?? 0;
            actualEpicIssueCount = epicIssues?.originalContentLength ?? 0;
            // If epic issue is over the limit, we exclude the subtasks field
            // from the store. So we need to grab the data from the epicIssues field.
            actualSubtaskCount = isEpicIssuesOverLimit ? epicIssues?.otherOriginalChildIssuesLength ?? 0 : subtasks?.originalContentLength ?? 0;
            epicIssueCount = isEpicIssuesOverLimit && issueContextActions ? (0, $6azHZ.getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : epicIssues?.originalContentLength ?? 0;
            // If portfolio issue is over the limit, we exclude the portfolio-child-issues field
            // from the store. So we need to grab the data from the subtasks field.
            portfolioChildIssueCount = subtasks?.otherOriginalChildIssuesLength ?? 0;
        } else {
            actualChildIssueCount = childIssues?.value.length ?? 0;
            actualSubtaskCount = subtasks?.value.length ?? 0;
            actualEpicIssueCount = epicIssues?.value.length ?? 0;
            portfolioChildIssueCount = portfolioChildIssues?.value.length ?? 0;
            epicIssueCount = actualEpicIssueCount;
        }
        // Properties added here show up in:
        // - jira.fe.custom.issue-view-on-page-load
        // - jira.fe.page-load.issue-view
        // - and jira.fe.custom.embedded-issue-view-load
        // Verify these in the BM3 tab of the Chrome Analytics extension.
        return {
            ecosystemGlances: (0, $8CSFK.glancesSelector)(state).length,
            ecosystemContentPanels: (0, $8CSFK.allContentPanelsSelector)(state).length,
            contextPanelOpenCount: contextPanelOpenCount,
            contextPanelClosedCount: contextPanelClosedCount,
            ecosystemActivityPanels: (0, $8CSFK.activityPanelsSelector)(state).length,
            ...!(0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? {
                ecosystemOperations: (0, $8CSFK.operationsSelector)(state).length
            } : {},
            ecosystemCustomsFields: (0, $cj1Xt.ecosystemCustomFieldIdsSelector)(state).length,
            childIssues: childIssuesCount,
            linkIssueCount: (0, $cFY86.combinedLinkedIssueCountSelector)(state),
            subtaskCount: subtaskCount,
            actualChildIssueCount: actualChildIssueCount,
            actualSubtaskCount: actualSubtaskCount,
            actualEpicIssueCount: actualEpicIssueCount,
            actualPortfolioChildIssueCount: portfolioChildIssueCount,
            epicIssueCount: epicIssueCount,
            portfolioChildIssueCount: portfolioChildIssueCount,
            issueId: (0, $5JqpU.issueIdSelector)(state),
            commentsTotalCount: (0, $dmojD.totalCommentsSelector)(state),
            hasCommentPermalink: permalinkType === (0, $6VKiL.COMMENTS),
            cascadingSelectCount: $c5094ff7f20cdaa9$var$getCascadingSelectFields(state).length,
            isAtlassianTeamFieldEnabled: $c5094ff7f20cdaa9$var$getAtlassianTeamFields(state).length > 0,
            cascadingSelectOptionsTotalCount: $c5094ff7f20cdaa9$var$getCascadingSelectOptionsTotalCount(state),
            proformaHarmonisationEnabled: proformaHarmonisation ? proformaHarmonisation.value.isHarmonisationEnabled : false,
            hasSubtasksTypes: (0, $6Fp9G.isSubtaskTypesPresentSelector)(state),
            issueTypesCount: (0, $ke6cX.issueTypesSelector)(state).length,
            issueTypeHierarchyLevel: !(0, $jZDJX.isSimplifiedProjectSelector)(state) ? (0, $9D3Vo.issueTypeHierarchyLevelSelector)(state) : (0, $1b2Vj.hierarchyLevelSelector)(state)
        };
    };

});
const $ab2aafcdf11a1361$export$dcd281f501ceae1a = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.pinned-fields';
const $ab2aafcdf11a1361$export$e1184c3be46bd7cb = false;
const $ab2aafcdf11a1361$export$2028cf1423b28cf8 = 'global-spotlight-target-';
const $ab2aafcdf11a1361$export$988f0f6f6457039a = 'status-and-approval-spotlight';

parcelRegister("6azHZ", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimitExceededAnalyticsCount", () => $fdeece38e8748ab6$export$8cbe27041ec414b7);
const $fdeece38e8748ab6$export$1e3c128c36bad9a4 = 'CHILD_ISSUES_LIMIT_EXCEEDED';
const $fdeece38e8748ab6$export$8cbe27041ec414b7 = (childIssuesLimit)=>`>${childIssuesLimit}`;

});

parcelRegister("kSuBQ", function(module, exports) {

$parcel$export(module.exports, "getGroupLocalStorageName", () => $d054c54ec3a75126$export$a3b190a19b138f2e);
$parcel$export(module.exports, "isGroupPanelOpen", () => $d054c54ec3a75126$export$e79995f22545fd3e);
$parcel$export(module.exports, "getGroupsLocalStorage", () => $d054c54ec3a75126$export$d0a5ccc42f3bcd33);
$parcel$export(module.exports, "useGroupLocalStorage", () => $d054c54ec3a75126$export$4e1a840a45fb467c);

var $eUqFw = parcelRequire("eUqFw");
const $d054c54ec3a75126$export$a3b190a19b138f2e = (projectKey, id)=>`group.state.${projectKey}.${id}`;
const $d054c54ec3a75126$export$a7e7b7df48874d2c = (keyName, defaultValue)=>{
    try {
        const item = window.localStorage.getItem(keyName);
        if (item === 'true') return true;
        if (item === 'false') return false;
        throw Error('Invalid group state value');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        return defaultValue;
    }
};
const $d054c54ec3a75126$export$e79995f22545fd3e = (projectKey, group, panelId, defaultValue)=>{
    const groupLocalStorageName = $d054c54ec3a75126$export$a3b190a19b138f2e(projectKey, group);
    return $d054c54ec3a75126$export$a7e7b7df48874d2c(`${groupLocalStorageName}-${panelId}`, defaultValue);
};
const $d054c54ec3a75126$export$d0a5ccc42f3bcd33 = (keyNames, initialOpened)=>{
    const items = {};
    keyNames.forEach((key)=>{
        items[key] = $d054c54ec3a75126$export$a7e7b7df48874d2c(key, initialOpened);
    });
    return items;
};
const $d054c54ec3a75126$export$4e1a840a45fb467c = (projectKey, id, initialOpened)=>{
    const keyName = $d054c54ec3a75126$export$a3b190a19b138f2e(projectKey, id);
    const [storedValue, setStoredValue] = (0, $eUqFw.useState)(()=>$d054c54ec3a75126$export$a7e7b7df48874d2c(keyName, initialOpened));
    const setValue = (0, $eUqFw.useCallback)((value)=>{
        try {
            setStoredValue(value);
            window.localStorage.setItem(keyName, String(value));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (_) {
        // Not decided what we do when we reach here.
        }
    }, [
        keyName
    ]);
    return [
        storedValue,
        setValue
    ];
};

});

parcelRegister("4sNXH", function(module, exports) {

$parcel$export(module.exports, "shouldHideNullUneditableField", () => $677ed9cfdaabf5a5$export$e7987ba89f8e2996);
$parcel$export(module.exports, "ecosystemGlancesToLayoutItem", () => $677ed9cfdaabf5a5$export$8dd9174e11169a13);
$parcel$export(module.exports, "ecosystemContextsToLayoutItem", () => $677ed9cfdaabf5a5$export$ff0381f8ed1f6cc7);
$parcel$export(module.exports, "useForgeGlancesAsLayoutItems", () => $677ed9cfdaabf5a5$export$969c8278a214a2d9);
$parcel$export(module.exports, "useForgeContextPanelsAsLayoutItems", () => $677ed9cfdaabf5a5$export$b4095ac407369aa0);
$parcel$export(module.exports, "addChangeboardingRefToFirstItem", () => $677ed9cfdaabf5a5$export$b7aff69af7ee8f70);
$parcel$export(module.exports, "getPinnedFieldItems", () => $677ed9cfdaabf5a5$export$7fc9f8048722ede9);
$parcel$export(module.exports, "generateContextPanelId", () => $677ed9cfdaabf5a5$export$c55ff2c236d30544);

var $8i1R8 = parcelRequire("8i1R8");

var $fTsDx = parcelRequire("fTsDx");

var $hJ992 = parcelRequire("hJ992");

var $kmr29 = parcelRequire("kmr29");

var $bLiXo = parcelRequire("bLiXo");

var $fkvsU = parcelRequire("fkvsU");


var $4faf8 = parcelRequire("4faf8");

var $f9RL0 = parcelRequire("f9RL0");

var $2Sajo = parcelRequire("2Sajo");


var $g8to1 = parcelRequire("g8to1");

var $lO4Or = parcelRequire("lO4Or");

var $guDlK = parcelRequire("guDlK");

var $5YYzL = parcelRequire("5YYzL");
const $677ed9cfdaabf5a5$export$87af144309c7a3c5 = (canLogTime, isNativeJiraTimeTrackingEnabled)=>// Here we assume that if the time tracking field is an available field
    // but isNativeJiraTimeTrackingEnabled is false, a 3rd party time tracking app is installed.
    isNativeJiraTimeTrackingEnabled ? !canLogTime : false;
const $677ed9cfdaabf5a5$var$getFieldByCustomType = (customType, fieldsConfiguration)=>(0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(fieldsConfiguration, (field)=>(field.schema && field.schema.custom) === customType);
const $677ed9cfdaabf5a5$var$getFieldConfiguration = (fieldId, fields)=>{
    const field = fields[fieldId];
    const customSystemFields = (0, $f9RL0.specialFields)();
    const condition = !field && Object.prototype.hasOwnProperty.call(customSystemFields, fieldId);
    if (condition) {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        const customType = customSystemFields[fieldId];
        return $677ed9cfdaabf5a5$var$getFieldByCustomType(customType, fields);
    }
    return field;
};
const $677ed9cfdaabf5a5$export$e7987ba89f8e2996 = (itemId, issueFieldsConfig, value, canLogTime, isNativeJiraTimeTrackingEnabled)=>{
    const fieldConfig = $677ed9cfdaabf5a5$var$getFieldConfiguration(itemId, issueFieldsConfig);
    const fieldType = (0, $g8to1.getFieldType)(fieldConfig);
    if ((0, $g8to1.getPanels)().includes(itemId)) return false;
    if (!fieldConfig || fieldType === undefined) return true;
    if ((0, $g8to1.isEmpty)(value) && !fieldConfig.isEditable) {
        if (itemId === (0, $lO4Or.ASSIGNEE_TYPE) || fieldType === (0, $lO4Or.REQUEST_TYPE_CF_TYPE) || fieldType === (0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE)) return false;
        // ARKEN-40: Forge custom fields with readonly and an empty value must still be shown as primary or secondary items
        if ((0, $4faf8.isForgeField)(fieldConfig)) return false;
        if (itemId === (0, $lO4Or.TIME_TRACKING_TYPE)) return $677ed9cfdaabf5a5$export$87af144309c7a3c5(canLogTime, isNativeJiraTimeTrackingEnabled);
        return true;
    }
    return false;
};
const $677ed9cfdaabf5a5$export$8dd9174e11169a13 = (ecosystemGlances)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = Object.keys(ecosystemGlances).reduce((acc, next)=>{
        const ecosystem = ecosystemGlances[next];
        const modules = Object.keys(ecosystem).map((moduleKey)=>ecosystem[moduleKey]);
        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        return [
            ...acc,
            ...modules
        ];
    }, []);
    return result.map((connectGlance)=>({
            id: `${0, $lO4Or.ECOSYSTEM_GLANCE_TYPE}__${connectGlance.appKey}__${connectGlance.moduleKey}`,
            type: (0, $lO4Or.ECOSYSTEM_GLANCE_TYPE),
            payload: {
                ...connectGlance,
                glanceType: (0, $fkvsU.CONNECT_ENTITY_TYPE)
            }
        }));
};
const $677ed9cfdaabf5a5$export$ff0381f8ed1f6cc7 = (ecosystemContextPanels)=>{
    const contextPanels = [];
    Object.values(ecosystemContextPanels).forEach((contextPanelObject)=>{
        contextPanels.push(Object.values(contextPanelObject)[0]);
    });
    return contextPanels.map((connectContextPanel)=>({
            id: `${0, $lO4Or.ECOSYSTEM_CONTEXT_TYPE}__${connectContextPanel.appKey}__${connectContextPanel.moduleKey}`,
            type: (0, $lO4Or.ECOSYSTEM_CONTEXT_TYPE),
            payload: {
                ...connectContextPanel,
                contextPanelType: (0, $fkvsU.CONNECT_ENTITY_TYPE)
            }
        }));
};
const $677ed9cfdaabf5a5$var$ISSUE_TYPE = 'issuetype';
const $677ed9cfdaabf5a5$export$ea6c3ae2bd3a5510 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const issueId = (0, $hJ992.useIssueId)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const [permissions] = (0, $5YYzL.useProjectPermissions)(projectKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const projectId = (0, $guDlK.useProjectId)(projectKey);
    const [issueType] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: $677ed9cfdaabf5a5$var$ISSUE_TYPE
    });
    return {
        issueId: issueId || null,
        issueKey: issueKey,
        issueType: issueType && issueType.name,
        projectId: projectId,
        projectKey: projectKey,
        projectType: projectType || null,
        // Prop normalisation copied from original redux selector - Props names are exposed externally.
        canAddComments: permissions.canAddComments,
        canAdministerJira: permissions.canAdministerJira,
        canAdministerProjects: permissions.canAdministerProject,
        canAssignIssues: permissions.canAssignIssues,
        canBeAssignedToIssues: permissions.canBeAssignedToIssues,
        canCloneIssues: permissions.canCloneIssue,
        canCreateAttachments: permissions.canCreateAttachments,
        canCreateChildren: permissions.canCreateChildren,
        canCreateSubtasks: permissions.canCreateSubtask,
        canDeleteAllAttachments: permissions.canDeleteAllAttachments,
        canDeleteAllComments: permissions.canDeleteAllComments,
        canDeleteAllWorklogs: permissions.canDeleteAllWorklogs,
        canDeleteIssues: permissions.canDeleteIssue,
        canDeleteOwnAttachments: permissions.canDeleteOwnAttachments,
        canDeleteOwnComments: permissions.canDeleteOwnComments,
        canDeleteOwnWorklogs: permissions.canDeleteOwnWorklogs,
        canEditAllComments: permissions.canEditAllComments,
        canEditAllWorklogs: permissions.canEditAllWorklogs,
        canEditIssues: permissions.canEditIssues,
        canEditOwnComments: permissions.canEditOwnComments,
        canEditOwnWorklogs: permissions.canEditOwnWorklogs,
        canLinkIssues: permissions.canLinkIssues,
        canLogWork: permissions.canLogWork,
        canManageWatchers: permissions.canManageWatchers,
        canModifyReporters: permissions.canModifyReporter,
        canMoveIssues: permissions.canMoveIssue,
        canScheduleIssues: permissions.canScheduleIssues,
        canUseServiceManagementAgentFeatures: permissions.canUseServiceDeskAgentFeatures,
        canBrowseUsers: permissions.canBrowseUsers,
        canViewDevTools: permissions.canViewDevTools,
        canViewWatchers: permissions.canViewWatchers
    };
};
const $677ed9cfdaabf5a5$export$969c8278a214a2d9 = ()=>{
    const [forgeGlances] = (0, $2Sajo.useForgeGlances)();
    const staticContext = $677ed9cfdaabf5a5$export$ea6c3ae2bd3a5510();
    return forgeGlances.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, staticContext)).map((forgeGlance)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: icon } } = forgeGlance;
        return {
            id: id,
            type: (0, $lO4Or.FORGE_GLANCE_TYPE),
            payload: {
                label: label,
                title: title,
                status: status,
                icon: icon,
                extension: forgeGlance,
                glanceType: (0, $fe92e572161b5748$export$6f3804b3f188f650),
                moduleKey: id,
                appKey: id
            }
        };
    });
};
const $677ed9cfdaabf5a5$export$b4095ac407369aa0 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const { ecosystemEnabled: ecosystemEnabled } = (0, $guDlK.useProjectConfiguration)(projectKey);
    const [forgeContextPanels] = (0, $2Sajo.useForgeContextPanels)();
    const staticContext = $677ed9cfdaabf5a5$export$ea6c3ae2bd3a5510();
    if (!ecosystemEnabled) return [];
    return forgeContextPanels.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, staticContext)).map((contextPanels)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: url } } = contextPanels;
        return {
            id: id,
            type: (0, $bLiXo.FORGE_CONTEXT_TYPE),
            payload: {
                type: (0, $bLiXo.FORGE_CONTEXT_TYPE),
                label: label,
                name: title,
                status: status || null,
                icon: url ? {
                    url: url
                } : null,
                extension: contextPanels,
                contextPanelType: (0, $fe92e572161b5748$export$6f3804b3f188f650),
                moduleKey: id,
                appKey: id,
                options: null
            }
        };
    });
};
const $677ed9cfdaabf5a5$export$b7aff69af7ee8f70 = (items)=>{
    let wrapperAdded = false;
    const allowedTypes = [
        (0, $bLiXo.layoutContainerItemTypes).field,
        (0, $bLiXo.layoutContainerItemTypes).panel
    ];
    const disallowedIds = [
        (0, $lO4Or.ASSIGNEE_TYPE),
        (0, $lO4Or.SLA_PANEL_TYPE)
    ];
    return items.map((item)=>{
        const typename = item.type !== undefined ? item.type : '';
        // @ts-expect-error - TS2345 - Argument of type 'any' is not assignable to parameter of type 'never'.
        if (!wrapperAdded && !disallowedIds.includes(item.id) && allowedTypes.includes(typename)) {
            wrapperAdded = true;
            // if it was added to csat field and csat field to be removed later in servicedesk template, this effectively won't work
            return {
                ...item,
                globalRef: (0, $ab3fc2ac1a2f2638$export$95ff4d03075475e2)
            };
        }
        return item;
    });
};
const $677ed9cfdaabf5a5$export$7fc9f8048722ede9 = (dedupedItems, pinnedFields)=>pinnedFields.reduce((result, pinnedId)=>{
        const item = dedupedItems.find((dedupedItem)=>dedupedItem.type === (0, $bLiXo.layoutContainerItemTypes).field && dedupedItem.fieldItemId === pinnedId || dedupedItem.type === (0, $bLiXo.layoutContainerItemTypes).panel && dedupedItem.panelItemId === pinnedId);
        if (item !== undefined) result.push(item);
        return result;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, []);
const $677ed9cfdaabf5a5$export$c55ff2c236d30544 = ({ appKey: appKey, moduleKey: moduleKey })=>`${0, $lO4Or.ECOSYSTEM_CONTEXT_TYPE}__${appKey}__${moduleKey}`;

});
parcelRegister("bLiXo", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $9366007edb455895$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $9366007edb455895$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $9366007edb455895$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $9366007edb455895$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $9366007edb455895$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $9366007edb455895$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $9366007edb455895$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $9366007edb455895$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $9366007edb455895$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $9366007edb455895$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $9366007edb455895$export$ad3536b13febb432);
const $9366007edb455895$export$99ad62164189f781 = 'ecosystemGlance';
const $9366007edb455895$export$7719ef6e9283671 = 'forgeGlance';
const $9366007edb455895$export$bfebea5ce2e1887a = 'ecosystemContext';
const $9366007edb455895$export$be8e68fb1aed253e = 'forgeContext';
const $9366007edb455895$export$7bf561e6ab380ea1 = 'context';
const $9366007edb455895$export$f42c11634d75863e = 'content';
const $9366007edb455895$export$b38842736b6dbc1d = 'content-request';
const $9366007edb455895$export$bc9fa2d93b5fabae = 'FIELD';
const $9366007edb455895$var$STATUS_TYPE = 'STATUS';
const $9366007edb455895$var$TAB_TYPE = 'TAB';
const $9366007edb455895$var$PANEL_TYPE = 'PANEL';
const $9366007edb455895$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
const $9366007edb455895$var$FORGE_TYPE = 'FORGE';
const $9366007edb455895$export$605c43f1b33ab69 = 'SUMMARY';
const $9366007edb455895$export$e655b77b9efe622f = 'CustomItem';
const $9366007edb455895$export$5cf403de05e9bea = 'FieldSectionItem';
const $9366007edb455895$export$30f7f9a86f182492 = 'TabLayout';
const $9366007edb455895$export$196e597ad9a97f7a = 'PanelSectionItem';
const $9366007edb455895$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
const $9366007edb455895$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $9366007edb455895$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $9366007edb455895$export$ad3536b13febb432 = (node)=>node.type === $9366007edb455895$export$5507f31126c8b283.tab;

});

parcelRegister("fkvsU", function(module, exports) {

$parcel$export(module.exports, "FORGE_ENTITY_TYPE", () => $f4e7965032899654$export$6f3804b3f188f650);
$parcel$export(module.exports, "CONNECT_ENTITY_TYPE", () => $f4e7965032899654$export$1b2059a011c9174d);
const $f4e7965032899654$export$6f3804b3f188f650 = 'FORGE_ENTITY_TYPE';
const $f4e7965032899654$export$1b2059a011c9174d = 'CONNECT_ENTITY_TYPE';
const $f4e7965032899654$export$38f0fc1cf1f24cba = [
    $f4e7965032899654$export$6f3804b3f188f650,
    $f4e7965032899654$export$1b2059a011c9174d
];

});

/**
 * Opt into the new issue view modal key. To be cleaned up with issue.details.opt-back-in
 * This key is stored in the API and should not be renamed.
 * @see https://hello.atlassian.net/wiki/spaces/JIE/pages/920124493/How+to+re-set+new+Bento+Change+Boarding#Re-set-Opt-In-Back-Modal
 */ const $ab3fc2ac1a2f2638$export$a3338d0a4845edfa = 'jira.details.opt-in-back.next-reminding-date';
const $ab3fc2ac1a2f2638$export$26de4b42c139644c = 'jira.user.issue.should.show.welcome.message';
const $ab3fc2ac1a2f2638$export$ece45f325779a5d5 = 'jira.user.issue.opt.in.back.modal.has.dismissed';
const $ab3fc2ac1a2f2638$export$4603581e6066a63f = 'jira.user.issue.opt.in.back.banner.has.dismissed';
const $ab3fc2ac1a2f2638$export$af60a7ae4202be66 = 'issue-details-changeboarding';
const $ab3fc2ac1a2f2638$export$7b98e5a33c854454 = 30;
const $ab3fc2ac1a2f2638$export$956fcd3a2e5c48a8 = 'SOFTWARE_ISSUE_STATUS';
const $ab3fc2ac1a2f2638$export$ebb7dcd60318cfac = 'SERVICEDESK_ISSUE_STATUS';
const $ab3fc2ac1a2f2638$export$a446d697df3d6b2c = 'SERVICEDESK_REQUEST_PANEL';
const $ab3fc2ac1a2f2638$export$d3dadb39db0c423 = 'SERVICEDESK_CREATE_COMMENT_ACTIONS';
const $ab3fc2ac1a2f2638$export$75867eab2abae162 = 'SERVICEDESK_PLACEHOLDER_CREATE_COMMENT_ACTIONS';
const $ab3fc2ac1a2f2638$export$483d9bcbbd8280a6 = 'status-spotlight';
const $ab3fc2ac1a2f2638$export$95f98990d7202b31 = 'SHOW_MORE';
const $ab3fc2ac1a2f2638$export$95ff4d03075475e2 = 'PIN_FIELD';
const $ab3fc2ac1a2f2638$export$256eddbefbf4b2ce = 'EDIT_FIELD';
const $ab3fc2ac1a2f2638$export$6f48b612d5c03f4d = 'PERMALINK';
const $ab3fc2ac1a2f2638$export$d84e7970e2d564af = 'BOARD_SIDEBAR';
const $ab3fc2ac1a2f2638$export$fa5ad81958817beb = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-group.container.details-group';
const $ab3fc2ac1a2f2638$export$1ba8bc5ff9e50d09 = 'QUICK_ADDS';
const $ab3fc2ac1a2f2638$export$f9baa44349b5d6b8 = 'JSW_ACTIVITY_FEED_BUTTONS';
const $ab3fc2ac1a2f2638$export$f49830a0e4ffb3f9 = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-group.container.sla-group';
const $ab3fc2ac1a2f2638$export$efb12103a5e32a1e = 'PIN_FIELD_PLACEHOLDER_BANNER';
const $ab3fc2ac1a2f2638$export$4288bce987c22af4 = 'PINNED_FIELDS_PANEL';
const $ab3fc2ac1a2f2638$export$ddb80c23a62a41e = 'jira.user.issue.has.seen.quick-actions.change-boarding.message';

parcelRegister("4faf8", function(module, exports) {

$parcel$export(module.exports, "isForgeField", () => $45669342ae4293ea$export$f4484ef180517e0e);
$parcel$export(module.exports, "getForgeFieldType", () => $45669342ae4293ea$export$3f8bcfe7fea0362a);

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $lO4Or = parcelRequire("lO4Or");
const $45669342ae4293ea$export$f4484ef180517e0e = (field)=>field && (0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(field, 'schema.custom') && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(field.schema.custom) && field.schema.custom.includes('ari:cloud:ecosystem::extension');
const $45669342ae4293ea$export$3f8bcfe7fea0362a = (field)=>{
    if (!$45669342ae4293ea$export$f4484ef180517e0e(field)) return null;
    if (false) return field.schema.type;
    return 0, $lO4Or.FORGE_CUSTOM_FIELD_TYPE;
};

});

parcelRegister("2Sajo", function(module, exports) {

$parcel$export(module.exports, "useForgeGlances", () => $dcae2a1bd36bdf24$export$dc79f3e7b8a6c3e1);
$parcel$export(module.exports, "useForgeContextPanels", () => $dcae2a1bd36bdf24$export$a1a589b738ca01b8);
$parcel$export(module.exports, "useForgeDataComplete", () => $dcae2a1bd36bdf24$export$db75d05b888b2963);
$parcel$export(module.exports, "useForgeCustomField", () => $dcae2a1bd36bdf24$export$2a006c08e9ab6fc3);
$parcel$export(module.exports, "useForgeActions", () => $dcae2a1bd36bdf24$export$4f3ebb446fd03f21);
$parcel$export(module.exports, "useForgeLoadingFailed", () => $dcae2a1bd36bdf24$export$25b2fc6a75c5447b);
$parcel$export(module.exports, "useForgeUimModules", () => $dcae2a1bd36bdf24$export$37d5ed3ba137e5df);
$parcel$export(module.exports, "useHasBlockedExtensions", () => $dcae2a1bd36bdf24$export$955dca49c49bfb60);
$parcel$export(module.exports, "useBlockedExtensions", () => $dcae2a1bd36bdf24$export$61349d0d8e89be3);
$parcel$export(module.exports, "useIsForgeDataEmpty", () => $dcae2a1bd36bdf24$export$57f2fa4b04feb8c2);

var $eUqFw = parcelRequire("eUqFw");

var $kFGm5 = parcelRequire("kFGm5");

var $ala54 = parcelRequire("ala54");

var $2W5Mi = parcelRequire("2W5Mi");
const $dcae2a1bd36bdf24$export$dc79f3e7b8a6c3e1 = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return [
        forge.issueGlance
    ];
};
const $dcae2a1bd36bdf24$export$a1a589b738ca01b8 = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return [
        forge.issueContext
    ];
};
const $dcae2a1bd36bdf24$export$db75d05b888b2963 = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return [
        forge.isForgeDataComplete
    ];
};
const $dcae2a1bd36bdf24$export$1a3a35919478733d = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return [
        [
            ...forge.customField,
            ...forge.customFieldType
        ]
    ];
};
const $dcae2a1bd36bdf24$export$2a006c08e9ab6fc3 = (extensionId)=>{
    const [customFieldExtensions] = $dcae2a1bd36bdf24$export$1a3a35919478733d();
    return (0, $ala54.useMemoizedStateObject)((0, $eUqFw.useMemo)(()=>customFieldExtensions.find((ext)=>ext.id === extensionId), [
        customFieldExtensions,
        extensionId
    ]));
};
const $dcae2a1bd36bdf24$export$4f3ebb446fd03f21 = ()=>{
    const [, actions] = (0, $2W5Mi.useForgeActionsStore)();
    return [
        undefined,
        actions
    ];
};
const $dcae2a1bd36bdf24$export$25b2fc6a75c5447b = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return forge.isForgeLoadingFailed;
};
const $dcae2a1bd36bdf24$export$37d5ed3ba137e5df = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return forge.uiModifications;
};
const $dcae2a1bd36bdf24$export$955dca49c49bfb60 = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return (0, $eUqFw.useMemo)(()=>forge.blockedExtensions ? Object.values((0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(forge.blockedExtensions, [
            'jiraIssueViewBackgroundScript',
            'jiraUiModifications'
        ])).some((blockedExtensions)=>blockedExtensions.length > 0) : false, [
        forge.blockedExtensions
    ]);
};
const $dcae2a1bd36bdf24$export$61349d0d8e89be3 = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    return forge.blockedExtensions;
};
const $dcae2a1bd36bdf24$export$57f2fa4b04feb8c2 = ()=>{
    const [forge] = (0, $2W5Mi.useForgeStore)();
    const isExtensionsEmpty = Object.keys(forge).every((key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        Array.isArray(forge[key]) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        forge[key].length === 0 : true);
    const isBlockedExtensionsEmpty = Object.keys(forge.blockedExtensions).every(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (key)=>forge.blockedExtensions[key].length === 0);
    return isExtensionsEmpty && isBlockedExtensionsEmpty;
};

});
parcelRegister("ala54", function(module, exports) {

$parcel$export(module.exports, "useMemoizedStateObject", () => $18a93586b800a37c$export$cc725e2aa41de44a);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");
const $18a93586b800a37c$export$cc725e2aa41de44a = (data, equalityCheck = (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))))=>{
    const memoizedData = (0, $eUqFw.useRef)(data);
    return (0, $eUqFw.useMemo)(()=>{
        if (!equalityCheck(data, memoizedData.current)) {
            memoizedData.current = data;
            return data;
        }
        return memoizedData.current;
    }, [
        data,
        equalityCheck
    ]);
};

});

parcelRegister("2W5Mi", function(module, exports) {

$parcel$export(module.exports, "useForgeStore", () => $f3300ca6503131e5$export$10f3118dc1498dfc);
$parcel$export(module.exports, "useForgeActionsStore", () => $f3300ca6503131e5$export$7dd6be1114d73937);
$parcel$export(module.exports, "ForceStoreContainer", () => $f3300ca6503131e5$export$540c057b33607be9);

var $WBLbN = parcelRequire("WBLbN");

var $eazmh = parcelRequire("eazmh");
const $f3300ca6503131e5$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    name: 'issue-view-layout-forge-apps-service',
    initialState: {
        issueGlance: [],
        issueContext: [],
        issueAction: [],
        issuePanel: [],
        issueActivity: [],
        customField: [],
        issueViewBackgroundScript: [],
        customFieldType: [],
        activeAction: null,
        uiModifications: [],
        isForgeLoadingFailed: false,
        isForgeDataComplete: false,
        blockedExtensions: {
            issueGlance: [],
            issueContext: [],
            issueAction: [],
            issuePanel: [],
            issueActivity: [],
            customField: [],
            issueViewBackgroundScript: [],
            customFieldType: [],
            uiModifications: []
        },
        // Not rate limited
        forgeRateLimitedUntil: 0,
        failedEventsCount: 0
    },
    actions: $eazmh
});
const $f3300ca6503131e5$export$10f3118dc1498dfc = (0, $WBLbN.createHook)($f3300ca6503131e5$export$6f57813fe9f31bf9);
const $f3300ca6503131e5$export$7dd6be1114d73937 = (0, $WBLbN.createHook)($f3300ca6503131e5$export$6f57813fe9f31bf9, {
    selector: null
});
const $f3300ca6503131e5$export$540c057b33607be9 = (0, $WBLbN.createContainer)($f3300ca6503131e5$export$6f57813fe9f31bf9);

});
parcelRegister("eazmh", function(module, exports) {

$parcel$export(module.exports, "setForge", () => $4b1f8e23931858cc$export$8307a9da1b91b3b4);
$parcel$export(module.exports, "setForgeLoadingFailed", () => $4b1f8e23931858cc$export$7ff580b28fd472d0);
$parcel$export(module.exports, "setFailedEventsCount", () => $4b1f8e23931858cc$export$2c9ac2591e62f664);
$parcel$export(module.exports, "isForgeRateLimited", () => $4b1f8e23931858cc$export$161809ef1d8417c5);

var $7wgLf = parcelRequire("7wgLf");
const $4b1f8e23931858cc$export$8307a9da1b91b3b4 = (forge)=>({ setState: setState })=>{
        setState(forge);
    };
const $4b1f8e23931858cc$export$7ff580b28fd472d0 = ()=>({ setState: setState })=>{
        setState({
            isForgeLoadingFailed: true
        });
    };
const $4b1f8e23931858cc$export$2c9ac2591e62f664 = (param)=>({ setState: setState, getState: getState })=>{
        if (typeof param === 'function') {
            const currentFailedEventsCount = getState().failedEventsCount;
            const result = param(currentFailedEventsCount);
            setState({
                failedEventsCount: result,
                forgeRateLimitedUntil: (0, $7wgLf.calculateRateLimitedUntil)(result)
            });
            return;
        }
        setState({
            failedEventsCount: param,
            forgeRateLimitedUntil: (0, $7wgLf.calculateRateLimitedUntil)(param)
        });
    };
const $4b1f8e23931858cc$export$161809ef1d8417c5 = ()=>({ getState: getState })=>{
        const state = getState();
        const throttleTime = state.forgeRateLimitedUntil - Date.now();
        return throttleTime > 0;
    };

});
parcelRegister("7wgLf", function(module, exports) {

$parcel$export(module.exports, "calculateRateLimitedUntil", () => $169737d2797a25da$export$d47414e51d623595);
/**
 * Defines the time gaps between retries in seconds for rate limited requests.
 * The first value is 0, because the first retry should be immediate.
 */ const $169737d2797a25da$export$565f18fa3aa433b0 = [
    0,
    3,
    8,
    21
];
function $169737d2797a25da$export$d47414e51d623595(failedEventsCount) {
    const currentDate = new Date();
    const gap = $169737d2797a25da$export$565f18fa3aa433b0[Math.min($169737d2797a25da$export$565f18fa3aa433b0.length - 1, failedEventsCount)];
    return gap ? new Date(currentDate.getTime() + gap * 1000).getTime() : 0;
}

});




const $fe92e572161b5748$export$6f3804b3f188f650 = 'FORGE_ENTITY_TYPE';

parcelRegister("g8to1", function(module, exports) {

$parcel$export(module.exports, "getPanels", () => $55eb035be1758949$export$be078297eeb6e8a2);
$parcel$export(module.exports, "isEmpty", () => $55eb035be1758949$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "getAtlassianCustomFieldType", () => $55eb035be1758949$export$f521834fc2bfcd81);
$parcel$export(module.exports, "fieldTypeHandler", () => $55eb035be1758949$export$b2cc0ead6ce019e3);
$parcel$export(module.exports, "getFieldType", () => $55eb035be1758949$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isUnsupportedItem", () => $55eb035be1758949$export$3d38168d24278ebb);

var $1c8hB = parcelRequire("1c8hB");

var $ldoFd = parcelRequire("ldoFd");

var $jtsd5 = parcelRequire("jtsd5");

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");

var $bLiXo = parcelRequire("bLiXo");

var $4faf8 = parcelRequire("4faf8");

var $f9RL0 = parcelRequire("f9RL0");

var $dZWHl = parcelRequire("dZWHl");

var $lO4Or = parcelRequire("lO4Or");
const $55eb035be1758949$export$272b07e3e852ec4 = [
    (0, $f9RL0.DEV_SUMMARY),
    (0, $f9RL0.SLA_PANEL),
    (0, $f9RL0.KNOWLEDGE_BASE),
    (0, $f9RL0.ASSET_ONBOARDING),
    (0, $f9RL0.SENTIMENT)
];
const $55eb035be1758949$export$be078297eeb6e8a2 = ()=>[
        ...$55eb035be1758949$export$272b07e3e852ec4,
        (0, $f9RL0.LINKED_ALERTS),
        ...(0, $dfBCt.isFedRamp)() ? [] : [
            (0, $f9RL0.CHAT_CHANNEL)
        ],
        ...(0, $dfBCt.isFedRamp)() ? [] : [
            (0, $f9RL0.MSTEAMS_CHANNEL)
        ],
        ...(0, $dfBCt.isFedRamp)() ? [] : [
            (0, $f9RL0.ZOOM_MEETING)
        ],
        (0, $f9RL0.MANAGE_STAKEHOLDERS),
        ...(0, $1ybV0.ff)('hide-icc-for-all-users_avyh5') ? [] : [
            (0, $f9RL0.CONFERENCE_CALL)
        ]
    ];
const $55eb035be1758949$export$dd1bc94b04021eeb = (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) || (0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(value) && value.length === 0 || (0, (/*@__PURE__*/$parcel$interopDefault($jtsd5)))(value) && Object.keys(value).length === 0 || (0, (/*@__PURE__*/$parcel$interopDefault($jtsd5)))(value) && value.type === 'doc' && value.content && Object.keys(value.content).length === 0;
const $55eb035be1758949$var$atlassianSystemCFTypes = ()=>{
    const customSystemFields = (0, $f9RL0.specialFields)();
    return [
        ...(0, $f9RL0.customFieldsToDisplay)().filter((cf)=>!(0, $f9RL0.ecosystemCustomFields).includes(cf)),
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
        (0, $lO4Or.FLAGGED_CF_TYPE)
    ];
};
const $55eb035be1758949$export$f521834fc2bfcd81 = (custom)=>$55eb035be1758949$var$atlassianSystemCFTypes().find((type)=>type === custom);
const $55eb035be1758949$export$b2cc0ead6ce019e3 = (fieldConfig, layoutItem)=>{
    const id = (0, $dZWHl.getLayoutItemId)(layoutItem);
    const { type: type } = layoutItem;
    if (type === (0, $bLiXo.layoutContainerItemTypes).tab || type === (0, $lO4Or.ECOSYSTEM_GLANCE_TYPE) || type === (0, $lO4Or.FORGE_GLANCE_TYPE) || type === (0, $lO4Or.ECOSYSTEM_CONTEXT_TYPE) || type === (0, $bLiXo.FORGE_CONTEXT_TYPE)) return {
        type: type,
        id: id
    };
    if ($55eb035be1758949$export$be078297eeb6e8a2().includes(id)) return {
        id: id,
        type: id
    };
    const forgeCustomField = (0, $4faf8.getForgeFieldType)(fieldConfig);
    if (forgeCustomField !== null) return {
        type: forgeCustomField,
        id: id
    };
    const fieldSchema = fieldConfig?.schema || {};
    const systemType = fieldSchema.system !== null ? fieldSchema.system : '';
    return {
        type: $55eb035be1758949$export$f521834fc2bfcd81(fieldSchema.custom) || systemType || fieldSchema.type,
        id: id
    };
};
const $55eb035be1758949$export$b9089a6e41ed43aa = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? $55eb035be1758949$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
};
// This typing exists to ensure that we include fields here when adding new ones.
const $55eb035be1758949$var$BASE_SUPPORTED_ITEMS = {
    // @ts-expect-error - TS2322 - Type '{ ecosystemGlance: boolean; forgeGlance: boolean; "com.pyxis.greenhopper.jira:gh-epic-status": true; "com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect": true; assignee: true; ... 75 more ...; "com.pyxis.greenhopper.jira:gh-epic-label": true; }' is not assignable to type 'CheckFieldTypeDefinitions<CheckedLegacyFieldTypeDefinitions<boolean>, IgnoredFieldChecks<boolean>>'.
    [(0, $lO4Or.ECOSYSTEM_GLANCE_TYPE)]: true,
    [(0, $lO4Or.FORGE_GLANCE_TYPE)]: true,
    [(0, $bLiXo.FORGE_CONTEXT_TYPE)]: true,
    [(0, $lO4Or.ECOSYSTEM_CONTEXT_TYPE)]: true,
    [(0, $lO4Or.EPIC_STATUS_TYPE)]: true,
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: true,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: true,
    [(0, $lO4Or.REPORTER_TYPE)]: true,
    [(0, $lO4Or.DESCRIPTION_TYPE)]: true,
    [(0, $lO4Or.ENVIRONMENT_TYPE)]: true,
    [(0, $lO4Or.DUE_DATE_TYPE)]: true,
    [(0, $lO4Or.PRIORITY_TYPE)]: true,
    [(0, $lO4Or.LABELS_TYPE)]: true,
    [(0, $lO4Or.COMPONENTS_TYPE)]: true,
    [(0, $lO4Or.SPRINT_TYPE)]: true,
    [(0, $lO4Or.STORY_POINTS_TYPE)]: true,
    [(0, $lO4Or.EPIC_TYPE)]: true,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: true,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: true,
    [(0, $lO4Or.TIME_TRACKING_TYPE)]: true,
    [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: true,
    [(0, $lO4Or.LABELS_CF_TYPE)]: true,
    [(0, $lO4Or.TEXT_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: true,
    [(0, $lO4Or.PARTICIPANTS_CF_TYPE)]: true,
    [(0, $lO4Or.URL_CF_TYPE)]: true,
    [(0, $lO4Or.NUMBER_CF_TYPE)]: true,
    [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: true,
    [(0, $lO4Or.SELECT_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: true,
    [(0, $lO4Or.VERSION_CF_TYPE)]: true,
    [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: true,
    [(0, $lO4Or.DATE_CF_TYPE)]: true,
    [(0, $lO4Or.GROUP_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: true,
    [(0, $lO4Or.USER_CF_TYPE)]: true,
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: true,
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: true,
    [(0, $lO4Or.DATETIME_CF_TYPE)]: true,
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: true,
    [(0, $lO4Or.TEAM_CF_TYPE)]: true,
    [(0, $lO4Or.PARENT_CF_TYPE)]: true,
    [(0, $lO4Or.PARENT_FIELD_TYPE)]: true,
    [(0, $lO4Or.BASELINE_START_CF_TYPE)]: true,
    [(0, $lO4Or.BASELINE_END_CF_TYPE)]: true,
    [(0, $lO4Or.COLOR_CF_TYPE)]: true,
    [(0, $lO4Or.REQUEST_TYPE_CF_TYPE)]: true,
    [(0, $lO4Or.APPROVALS_CF_TYPE)]: true,
    [(0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE)]: true,
    [(0, $lO4Or.REQUEST_PARTICIPANTS_CF_TYPE)]: true,
    [(0, $lO4Or.ORGANIZATIONS_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE)]: true,
    [(0, $lO4Or.ASSETS_CF_TYPE)]: true,
    [(0, $lO4Or.SERVICE_ENTITY_CF_TYPE)]: true,
    [(0, $lO4Or.APPROVERS_LIST_CF_TYPE)]: true,
    [(0, $lO4Or.CMDB_OBJECT_CF_TYPE)]: true,
    [(0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_GROUPS_CF_TYPE)]: true,
    [(0, $lO4Or.ISSUE_FIELD_STRINGS_CF_TYPE)]: true,
    [(0, $lO4Or.READ_ONLY_CF_TYPE)]: true,
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: true,
    [(0, $lO4Or.FORGE_CUSTOM_FIELD_TYPE)]: true,
    [(0, $lO4Or.KNOWLEDGE_BASE_TYPE)]: true,
    [(0, $lO4Or.SLA_PANEL_TYPE)]: true,
    [(0, $lO4Or.SENTIMENT_TYPE)]: true,
    [(0, $lO4Or.DEV_SUMMARY_TYPE)]: true,
    [(0, $lO4Or.RELEASES_TYPE)]: true,
    [(0, $lO4Or.ASSET_ONBOARDING_TYPE)]: true,
    [(0, $lO4Or.LINKED_ALERTS_TYPE)]: true,
    [(0, $lO4Or.CHAT_CHANNEL_TYPE)]: !false && !(0, $dfBCt.isFedRamp)(),
    [(0, $lO4Or.MSTEAMS_CHANNEL_TYPE)]: !false && !(0, $dfBCt.isFedRamp)(),
    [(0, $lO4Or.ZOOM_MEETING_TYPE)]: !false && !(0, $dfBCt.isFedRamp)(),
    [(0, $lO4Or.MANAGE_STAKEHOLDERS_TYPE)]: !false,
    // eslint-disable-next-line jira/ff/no-module-level-eval
    [(0, $lO4Or.CONFERENCE_CALL_TYPE)]: !false && !(0, $1ybV0.ff)('hide-icc-for-all-users_avyh5'),
    [(0, $lO4Or.RESPONDERS_CF_TYPE)]: true,
    [(0, $lO4Or.MAJOR_INCIDENT_CF_TYPE)]: true,
    [(0, $lO4Or.MESSAGE_EDIT_CF_TYPE)]: true,
    [(0, $lO4Or.MESSAGE_VIEW_CF_TYPE)]: true,
    [(0, $lO4Or.EPIC_NAME_TYPE)]: true,
    [(0, $lO4Or.CATEGORY_TYPE)]: true,
    [(0, $lO4Or.ENTITLEMENT_CF_TYPE)]: true,
    [(0, $lO4Or.SENTIMENT_CF_TYPE)]: true,
    [(0, $lO4Or.GOALS_CF_TYPE)]: true
};
const $55eb035be1758949$export$3d38168d24278ebb = (type)=>!$55eb035be1758949$var$BASE_SUPPORTED_ITEMS[type];

});
parcelRegister("dZWHl", function(module, exports) {

$parcel$export(module.exports, "getLayoutItemId", () => $b8d413cf2e7e532a$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $b8d413cf2e7e532a$export$355607dae809ec65);

var $bLiXo = parcelRequire("bLiXo");
const $b8d413cf2e7e532a$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $bLiXo.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $bLiXo.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $bLiXo.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $b8d413cf2e7e532a$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($b8d413cf2e7e532a$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $bLiXo.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $b8d413cf2e7e532a$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});


parcelRegister("5YYzL", function(module, exports) {

$parcel$export(module.exports, "useProjectPermissions", () => $bc17d6d67083dab8$export$c6c6b35628cf47a8);
$parcel$export(module.exports, "useCanAdministerProject", () => $bc17d6d67083dab8$export$f39ed5a161efa614);
$parcel$export(module.exports, "useCanAdministerJira", () => $bc17d6d67083dab8$export$ec12ddafd19b95ac);
$parcel$export(module.exports, "useCanConfigureIssue", () => $bc17d6d67083dab8$export$e7267b8a084eadb3);
$parcel$export(module.exports, "useCanUseServiceDeskAgentFeatures", () => $bc17d6d67083dab8$export$756d7c97077a2f76);
$parcel$export(module.exports, "useProjectPermissionsActions", () => $bc17d6d67083dab8$export$86c656cdb87052cd);

var $eUqFw = parcelRequire("eUqFw");

var $gd0Sp = parcelRequire("gd0Sp");

var $anOKD = parcelRequire("anOKD");
const $bc17d6d67083dab8$export$c6c6b35628cf47a8 = (projectKey)=>{
    const [permissions, { setProjectPermissions: setProjectPermissions }] = (0, $anOKD.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const actions = (0, $eUqFw.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        permissions,
        actions
    ];
};
const $bc17d6d67083dab8$export$f39ed5a161efa614 = (projectKey)=>{
    const [permissions] = (0, $anOKD.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerProject;
};
const $bc17d6d67083dab8$export$ec12ddafd19b95ac = (projectKey)=>{
    const [permissions] = (0, $anOKD.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerJira;
};
const $bc17d6d67083dab8$export$e7267b8a084eadb3 = (projectKey)=>{
    const canConfigureAdministerProject = $bc17d6d67083dab8$export$f39ed5a161efa614(projectKey);
    const canAdministerJira = $bc17d6d67083dab8$export$ec12ddafd19b95ac(projectKey);
    return canConfigureAdministerProject || canAdministerJira;
};
const $bc17d6d67083dab8$export$756d7c97077a2f76 = (projectKey)=>{
    const [permissions] = (0, $anOKD.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { appPermissions: appPermissions } = (0, $gd0Sp.useTenantContext)();
    return permissions.canUseServiceDeskAgentFeatures && appPermissions?.hasServiceDeskAccess;
};
const $bc17d6d67083dab8$export$86c656cdb87052cd = ()=>{
    const [, { setProjectPermissions: setProjectPermissions }] = (0, $anOKD.useProjectPermissionsStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("anOKD", function(module, exports) {

$parcel$export(module.exports, "defaultPermissions", () => $777dfd95ecbd2e05$export$ccfee65526b322ca);
$parcel$export(module.exports, "useProjectPermissionsStore", () => $777dfd95ecbd2e05$export$4919fa09a3d81224);
$parcel$export(module.exports, "useProjectPermissionsStoreActions", () => $777dfd95ecbd2e05$export$e8436ef485b33bdb);

var $WBLbN = parcelRequire("WBLbN");

var $1TYLm = parcelRequire("1TYLm");
const $777dfd95ecbd2e05$export$ccfee65526b322ca = {
    canAddComments: false,
    canAdministerJira: false,
    canAdministerProject: false,
    canAssignIssues: false,
    canBeAssignedToIssues: false,
    canCloneIssue: false,
    canCreateAttachments: false,
    canCreateChildren: false,
    canCreateSubtask: false,
    canDeleteAllAttachments: false,
    canDeleteAllComments: false,
    canDeleteAllWorklogs: false,
    canDeleteIssue: false,
    canDeleteOwnAttachments: false,
    canDeleteOwnComments: false,
    canDeleteOwnWorklogs: false,
    canEditAllComments: false,
    canEditAllWorklogs: false,
    canEditIssues: false,
    canEditOwnComments: false,
    canEditOwnWorklogs: false,
    canLinkIssues: false,
    canLogWork: false,
    canManageWatchers: false,
    canMoveIssue: false,
    canModifyReporter: false,
    canScheduleIssues: false,
    canUseServiceDeskAgentFeatures: false,
    canBrowseUsers: false,
    canViewDevTools: false,
    canViewWatchers: false,
    canViewVoters: false,
    canCreateIssuesInClassicProjectEpic: false,
    canResolveIssues: false,
    canExportIssue: false,
    canArchiveIssue: false,
    canUnarchiveIssue: false
};
const $777dfd95ecbd2e05$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    name: 'project-permissions',
    initialState: {},
    actions: $1TYLm
});
const $777dfd95ecbd2e05$var$getProjectPermissionSelector = (state, { projectKey: projectKey })=>state[projectKey] || $777dfd95ecbd2e05$export$ccfee65526b322ca;
const $777dfd95ecbd2e05$export$4919fa09a3d81224 = (0, $WBLbN.createHook)($777dfd95ecbd2e05$export$6f57813fe9f31bf9, {
    selector: $777dfd95ecbd2e05$var$getProjectPermissionSelector
});
const $777dfd95ecbd2e05$export$e8436ef485b33bdb = (0, $WBLbN.createHook)($777dfd95ecbd2e05$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("1TYLm", function(module, exports) {

$parcel$export(module.exports, "setProjectPermissions", () => $54a1a48853cdbc94$export$53f5cc27627e5fe3);
const $54a1a48853cdbc94$export$53f5cc27627e5fe3 = (projectKey, permissions)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [projectKey]: permissions
        });
    };

});




parcelRegister("8CSFK", function(module, exports) {

$parcel$export(module.exports, "ecosystemBackgroundScriptsSelector", () => $ed8f699fce32689f$export$4bf619a76f77f026);
$parcel$export(module.exports, "issueViewBackgroundScriptsSelector", () => $ed8f699fce32689f$export$eef935056c1a5112);
$parcel$export(module.exports, "issueContentPanelsSelector", () => $ed8f699fce32689f$export$80fcdb58a34c02a8);
$parcel$export(module.exports, "isIssueContentPanelCustomisedSelector", () => $ed8f699fce32689f$export$7d77b0f1f3d84166);
$parcel$export(module.exports, "canInstallAddonsSelector", () => $ed8f699fce32689f$export$779e1275bbd7ba59);
$parcel$export(module.exports, "isIssueCreatedAfterEcosystemOnSelector", () => $ed8f699fce32689f$export$528e2c054f1a65f6);
$parcel$export(module.exports, "contextPanelEntitiesSelector", () => $ed8f699fce32689f$export$830512515d42357);
$parcel$export(module.exports, "glancesSelector", () => $ed8f699fce32689f$export$d73d3447fc053be);
$parcel$export(module.exports, "ecosystemGlancesSelector", () => $ed8f699fce32689f$export$df7140249f849373);
$parcel$export(module.exports, "glancePanelSelector", () => $ed8f699fce32689f$export$e8938da368c7c5c4);
$parcel$export(module.exports, "allContentPanelsSelector", () => $ed8f699fce32689f$export$7bc028a03185fc96);
$parcel$export(module.exports, "ecosystemAllPanelsSelector", () => $ed8f699fce32689f$export$47d3fa7df862ae6f);
$parcel$export(module.exports, "ecosystemAddedContentPanelsSelector", () => $ed8f699fce32689f$export$a48c28ad36cb708e);
$parcel$export(module.exports, "selectedContentPanelSelector", () => $ed8f699fce32689f$export$1a9c93efcb1ffec7);
$parcel$export(module.exports, "operationsSelector", () => $ed8f699fce32689f$export$5244c0030b3a418e);
$parcel$export(module.exports, "ecosystemOperationsSelector", () => $ed8f699fce32689f$export$5d88ae12b2751fc1);
$parcel$export(module.exports, "activityPanelsSelector", () => $ed8f699fce32689f$export$dd6c9850f9e61a72);
$parcel$export(module.exports, "ecosystemActivityPanelsSelector", () => $ed8f699fce32689f$export$9222e43f5478367f);

var $df4Sl = parcelRequire("df4Sl");

var $6ZDS2 = parcelRequire("6ZDS2");

var $gdPSX = parcelRequire("gdPSX");

var $7C4za = parcelRequire("7C4za");

var $fkvsU = parcelRequire("fkvsU");

var $duMa0 = parcelRequire("duMa0");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");


var $9Hrk7 = parcelRequire("9Hrk7");

var $8QKSg = parcelRequire("8QKSg");
const $ed8f699fce32689f$export$4bf619a76f77f026 = (0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>ecosystem.backgroundScripts || []);
const $ed8f699fce32689f$export$eef935056c1a5112 = (0, $df4Sl.createSelector)((0, $9Hrk7.forgeEntitiesSelector), (forge)=>forge.backgroundScripts || []);
const $ed8f699fce32689f$export$80fcdb58a34c02a8 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.issueContentPanels || []);
const $ed8f699fce32689f$export$7d77b0f1f3d84166 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>!!entities.issueContentPanels && entities.issueContentPanels.includes((0, $6c91ecd17276581e$export$bdafa6b589be8b30)));
const $ed8f699fce32689f$export$779e1275bbd7ba59 = (0, $df4Sl.createSelector)((0, $9F6MO.canAdministerJiraPermissionsSelector), (canAdministerJira)=>canAdministerJira);
const $ed8f699fce32689f$export$528e2c054f1a65f6 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.ecosystem && !!entities.ecosystem.ecosystemOnDate && // @ts-expect-error - TS2345 - Argument of type 'AuthoredTimestamp | undefined' is not assignable to parameter of type 'string'.
    Date.parse(entities.createdDate) > entities.ecosystem.ecosystemOnDate);
const $ed8f699fce32689f$var$extractSecondLevelDeepValuesFromObject = (obj)=>Object.keys(obj || {}).flatMap((key)=>Object.values(obj ? obj[key] : {}));
const $ed8f699fce32689f$var$glanceEntitiesSelector = (0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>$ed8f699fce32689f$var$extractSecondLevelDeepValuesFromObject(ecosystem.glances || {}));
const $ed8f699fce32689f$export$830512515d42357 = (0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>$ed8f699fce32689f$var$extractSecondLevelDeepValuesFromObject(ecosystem.contextPanels));
const $ed8f699fce32689f$var$contentPanelsEntitiesSelector = (0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>$ed8f699fce32689f$var$extractSecondLevelDeepValuesFromObject(ecosystem.contentPanels));
const $ed8f699fce32689f$var$activityPanelsEntitiesSelector = (0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>$ed8f699fce32689f$var$extractSecondLevelDeepValuesFromObject(ecosystem.activityPanels));
const $ed8f699fce32689f$export$7fec16e3d5cd5f4e = (selector)=>(0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), selector, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (ecosystemEnabled, otherSelector)=>ecosystemEnabled && otherSelector || []);
const $ed8f699fce32689f$export$d73d3447fc053be = $ed8f699fce32689f$export$7fec16e3d5cd5f4e((0, $df4Sl.createSelector)($ed8f699fce32689f$var$glanceEntitiesSelector, (glanceEntities)=>glanceEntities.map((entity)=>({
            appKey: entity.appKey,
            moduleKey: entity.moduleKey,
            name: entity.name,
            icon: entity.icon && entity.icon.url && {
                url: entity.icon.url
            },
            label: entity.label,
            status: entity.status,
            type: entity.type,
            glanceType: (0, $fkvsU.CONNECT_ENTITY_TYPE)
        }))));
const $ed8f699fce32689f$export$df7140249f849373 = (0, $df4Sl.createSelector)([
    (0, $8QKSg.forgeGlancesSelector),
    $ed8f699fce32689f$export$d73d3447fc053be
], (forge, connect)=>[
        ...forge,
        ...connect
    ]);
const $ed8f699fce32689f$export$e8938da368c7c5c4 = (appKey, moduleKey)=>(0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.glances && ecosystem.glances[appKey] && ecosystem.glances[appKey][moduleKey]);
const $ed8f699fce32689f$export$7bc028a03185fc96 = $ed8f699fce32689f$export$7fec16e3d5cd5f4e((0, $df4Sl.createSelector)($ed8f699fce32689f$var$contentPanelsEntitiesSelector, (contentPanelEntities)=>contentPanelEntities));
const $ed8f699fce32689f$export$47d3fa7df862ae6f = (0, $df4Sl.createSelector)([
    (0, $8QKSg.forgePanelsSelector),
    $ed8f699fce32689f$export$7bc028a03185fc96
], (forge, connect)=>[
        ...forge,
        ...connect
    ]);
const $ed8f699fce32689f$var$panelsComparator = (firstPanel, secondPanel)=>{
    // The sort order rule:
    // 1. Forge panels without quick add button (no dateAdded prop)
    // 2. Forge panels sorted by date added (oldest > newest)
    // 3. Connect panels, sorting criteria won't be changed
    if (firstPanel.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) {
        // @ts-expect-error - TS2339 - Property 'dateAdded' does not exist on type 'AddedPanel'.
        const firstValue = firstPanel.dateAdded || 1;
        if (secondPanel.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) {
            // @ts-expect-error - TS2339 - Property 'dateAdded' does not exist on type 'AddedPanel'.
            const secondValue = secondPanel.dateAdded || 1;
            return firstValue - secondValue;
        }
        return firstValue;
    }
    return Infinity;
};
const $ed8f699fce32689f$var$sortPanels = (allPanelsToAddedPanels)=>allPanelsToAddedPanels// @ts-expect-error - TS2769 - No overload matches this call.
    .map((panel)=>[].concat(panel)).sort((firstPanel, secondPanel)=>$ed8f699fce32689f$var$panelsComparator(firstPanel[0], secondPanel[0]));
const $ed8f699fce32689f$export$b2c15e41218fc96 = (firstActivity, secondActivity)=>{
    // The sort order rule:
    // 1. Forge activity ordered alphabetically.
    // 2. Connect panels, sorting criteria won't be changed
    if (firstActivity.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) {
        const firstValue = firstActivity.name.toLowerCase();
        if (secondActivity.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) {
            const secondValue = secondActivity.name.toLowerCase();
            if (firstValue < secondValue) return -Infinity;
            if (firstValue > secondValue) return Infinity;
            return 0;
        }
        return Infinity;
    }
    return Infinity;
};
const $ed8f699fce32689f$export$a48c28ad36cb708e = $ed8f699fce32689f$export$7fec16e3d5cd5f4e((0, $df4Sl.createSelector)($ed8f699fce32689f$export$80fcdb58a34c02a8, $ed8f699fce32689f$export$47d3fa7df862ae6f, $ed8f699fce32689f$export$7d77b0f1f3d84166, $ed8f699fce32689f$export$528e2c054f1a65f6, (0, $5JqpU.analyticsSourceSelector), (selectedPanels, allPanels, customised, newIssue, analyticsSource)=>{
    const allPanelsToAddedPanels = allPanels.map((panel)=>{
        // Forge-defined panels
        if (panel.type === (0, $fkvsU.FORGE_ENTITY_TYPE)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            const forgePanel = panel;
            // For a transition period we always render panels without a quick add button
            if (!forgePanel.iconUrl) return forgePanel;
            const prefix = `${forgePanel.appKey}/${forgePanel.moduleKey}-`;
            const filteredSelectedPanels = selectedPanels.filter((sPanel)=>(0, $7C4za.isKeyMatchPrefix)(sPanel, prefix)).map((sPanel)=>{
                const panelProperties = (0, $duMa0.parseForgeIssuePanel)(sPanel);
                if (panelProperties == null) (0, $gdPSX.fireOperationalFailedEvent)(analyticsSource, {
                    error: Error(`Panel key doesn't match regexp: ${sPanel}`)
                });
                return panelProperties && {
                    ...forgePanel,
                    dateAdded: panelProperties.added,
                    panelInstanceId: panelProperties.id
                };
            }).filter(Boolean);
            return filteredSelectedPanels.length > 0 && filteredSelectedPanels;
        }
        // Connect-defined panels
        if (!customised && !newIssue) return panel;
        const isSelected = selectedPanels.includes(`${panel.appKey}_${panel.moduleKey}`) || // BENTO-2491 SelectedPanels could be saved using keys without tailing digits
        selectedPanels.includes(`${panel.appKey}_${(0, $duMa0.removeTimestamp)(panel.moduleKey, 10)}`) || panel.showByDefault;
        return isSelected && panel;
    });
    const addedPanels = (0, (/*@__PURE__*/$parcel$interopDefault($6ZDS2)))($ed8f699fce32689f$var$sortPanels(allPanelsToAddedPanels.filter(Boolean)));
    return addedPanels;
}));
const $ed8f699fce32689f$export$9f3aeb87662f360b = (appKey, moduleKey)=>(0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.contentPanels && ecosystem.contentPanels[appKey] && ecosystem.contentPanels[appKey][moduleKey]);
const $ed8f699fce32689f$export$1a9c93efcb1ffec7 = (appKey, moduleKey)=>(0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>Boolean(ecosystem && ecosystem.selectedContentPanel && (ecosystem.selectedContentPanel === `${appKey}_${moduleKey}` || ecosystem.selectedContentPanel === `${appKey}_${(0, $duMa0.removeTimestamp)(moduleKey, 10)}`)));
const $ed8f699fce32689f$export$5244c0030b3a418e = $ed8f699fce32689f$export$7fec16e3d5cd5f4e((0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>ecosystem.operations || []));
const $ed8f699fce32689f$export$5d88ae12b2751fc1 = $ed8f699fce32689f$export$7fec16e3d5cd5f4e((0, $df4Sl.createSelector)([
    (0, $8QKSg.forgeIssueActionsSelector),
    $ed8f699fce32689f$export$5244c0030b3a418e
], (forge, connect)=>[
        ...forge,
        ...connect
    ]));
const $ed8f699fce32689f$export$dd6c9850f9e61a72 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), $ed8f699fce32689f$var$activityPanelsEntitiesSelector, (isEcosystemEnabled, activityPanelEntities)=>isEcosystemEnabled ? activityPanelEntities.map((entity)=>({
            name: entity.name,
            appKey: entity.appKey,
            moduleKey: entity.moduleKey,
            options: entity.options,
            type: (0, $fkvsU.CONNECT_ENTITY_TYPE)
        })) : []);
const $ed8f699fce32689f$export$9222e43f5478367f = (0, $df4Sl.createSelector)([
    (0, $8QKSg.forgeIssueActivitySelector),
    $ed8f699fce32689f$export$dd6c9850f9e61a72
], (forge, connect)=>[
        ...forge,
        ...connect
    ].sort($ed8f699fce32689f$export$b2c15e41218fc96));

});
parcelRegister("gdPSX", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $efc14f04fccc55bd$export$add44f896fb31ba3);
$parcel$export(module.exports, "fireUiActionClickedEvent", () => $efc14f04fccc55bd$export$a645c87ca2607d94);
$parcel$export(module.exports, "fireTrackActionSucceedEvent", () => $efc14f04fccc55bd$export$435f030e21a120be);
$parcel$export(module.exports, "fireOperationalActionFailedEvent", () => $efc14f04fccc55bd$export$828a66ad00e9a886);
$parcel$export(module.exports, "fireTrackSavedEvent", () => $efc14f04fccc55bd$export$1dbf5d2537a38bd8);
$parcel$export(module.exports, "fireOperationalSaveFailedEvent", () => $efc14f04fccc55bd$export$cda76554fa8eee1d);
$parcel$export(module.exports, "fireUiRemoveClickedEvent", () => $efc14f04fccc55bd$export$2e4d409fc887e7e);
$parcel$export(module.exports, "fireTrackRemovedEvent", () => $efc14f04fccc55bd$export$daf10221407e1b30);
$parcel$export(module.exports, "fireOperationalRemoveFailedEvent", () => $efc14f04fccc55bd$export$d12e864ea545eb36);
$parcel$export(module.exports, "fireUiTriggerSelectedEvent", () => $efc14f04fccc55bd$export$4d7a3fdb2dd15cbb);
$parcel$export(module.exports, "fireUiCollapseExpandClickedEvent", () => $efc14f04fccc55bd$export$c157193e598947ac);
$parcel$export(module.exports, "fireTrackUpdateSucceedEvent", () => $efc14f04fccc55bd$export$98e4a25792520246);
$parcel$export(module.exports, "fireOperationalUpdateFailedEvent", () => $efc14f04fccc55bd$export$9ee09996d253231a);

var $2Rqjr = parcelRequire("2Rqjr");

var $8XU7c = parcelRequire("8XU7c");

var $cYWDh = parcelRequire("cYWDh");

var $d6g7g = parcelRequire("d6g7g");

var $hRcYT = parcelRequire("hRcYT");
const $efc14f04fccc55bd$var$moduleEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.ISSUE_PANEL_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_EXTENSION)
});
const $efc14f04fccc55bd$var$triggerEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.ISSUE_PANEL_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER)
});
const $efc14f04fccc55bd$export$add44f896fb31ba3 = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).FAILED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$a645c87ca2607d94 = (source, attributes)=>(0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).ACTION_CLICKED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$435f030e21a120be = (source, attributes)=>(0, $cYWDh.fireTrackEvent)((0, $hRcYT.TRACK_ACTIONS).ACTION_SUCCEED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$828a66ad00e9a886 = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).ACTION_FAILED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$1dbf5d2537a38bd8 = (source, attributes)=>(0, $cYWDh.fireTrackEvent)((0, $hRcYT.TRACK_ACTIONS).SAVED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$cda76554fa8eee1d = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).SAVE_FAILED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$2e4d409fc887e7e = (source, attributes)=>(0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).REMOVE_CLICKED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$daf10221407e1b30 = (source, attributes)=>(0, $cYWDh.fireTrackEvent)((0, $hRcYT.TRACK_ACTIONS).REMOVED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$d12e864ea545eb36 = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).REMOVE_FAILED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$4d7a3fdb2dd15cbb = (extensionId, source, attributes)=>{
    (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).start({
        startTime: performance.now()
    });
    return (0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).SELECTED, {
        id: $efc14f04fccc55bd$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};
const $efc14f04fccc55bd$export$c157193e598947ac = (source, attributes)=>(0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).COLLAPSE_EXPAND_CLICKED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$98e4a25792520246 = (source, attributes)=>(0, $cYWDh.fireTrackEvent)((0, $hRcYT.TRACK_ACTIONS).UPDATE_SUCCEED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $efc14f04fccc55bd$export$9ee09996d253231a = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).UPDATE_FAILED, {
        id: $efc14f04fccc55bd$var$moduleEventId,
        source: source,
        attributes: attributes
    });

});
parcelRegister("8XU7c", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $ea56d020133ed4ec$export$5639f6a927500d9);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $ea56d020133ed4ec$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getEventActionName", () => $ea56d020133ed4ec$export$644ccb9a67b9a9c1);

var $2Rqjr = parcelRequire("2Rqjr");

var $TrUS5 = parcelRequire("TrUS5");

var $hRcYT = parcelRequire("hRcYT");
const $ea56d020133ed4ec$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $ea56d020133ed4ec$var$prepareModuleMode = (entryPoint)=>`${$ea56d020133ed4ec$var$capitalizeFirstLetter(entryPoint)}`;
const $ea56d020133ed4ec$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $ea56d020133ed4ec$var$prepareModuleName = (moduleName)=>(0, $2Rqjr.SUPPORTED_MODULES).includes(moduleName) ? $ea56d020133ed4ec$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $ea56d020133ed4ec$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $hRcYT.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $TrUS5.toEventId)(`${$ea56d020133ed4ec$var$prepareModuleName(module)}${$ea56d020133ed4ec$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $ea56d020133ed4ec$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>(0, $TrUS5.toEventId)(`${$ea56d020133ed4ec$var$prepareModuleName(module)}${$ea56d020133ed4ec$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
const $ea56d020133ed4ec$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $hRcYT.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});


parcelRegister("7C4za", function(module, exports) {

$parcel$export(module.exports, "toForgeKey", () => $7c20fcbbb166c6a7$export$fef910e3c6a21573);
$parcel$export(module.exports, "toForgeKeyWithDate", () => $7c20fcbbb166c6a7$export$4a8bc976ef8470fb);
$parcel$export(module.exports, "toForgeKeyFromExtensionId", () => $7c20fcbbb166c6a7$export$72368b9e5ac31f04);
$parcel$export(module.exports, "toConnectKey", () => $7c20fcbbb166c6a7$export$f1cde82a5f64810e);
$parcel$export(module.exports, "toEcosystemKeys", () => $7c20fcbbb166c6a7$export$c9483bbc66b4fb20);
$parcel$export(module.exports, "isForgeExtension", () => $7c20fcbbb166c6a7$export$b0ed77f2dd403096);
$parcel$export(module.exports, "isKeyMatchPrefix", () => $7c20fcbbb166c6a7$export$75f2b72396a13fc0);

var $2Rqjr = parcelRequire("2Rqjr");
const $7c20fcbbb166c6a7$export$fef910e3c6a21573 = (appKey, moduleKey)=>`${appKey}/${moduleKey}`;
const $7c20fcbbb166c6a7$export$4a8bc976ef8470fb = (appKey, moduleKey, panelInstanceId, dateAdded)=>`${appKey}/${moduleKey}-${panelInstanceId}-${dateAdded}`;
const $7c20fcbbb166c6a7$export$72368b9e5ac31f04 = (extensionId, panelInstanceId, dateAdded)=>panelInstanceId != null ? `${extensionId}-${panelInstanceId}-${dateAdded}` : `${extensionId}-${0, $2Rqjr.NONE_PANEL_INSTANCE_ID}-${dateAdded}`;
const $7c20fcbbb166c6a7$export$f1cde82a5f64810e = (appKey, moduleKey)=>`${appKey}_${moduleKey}`;
const $7c20fcbbb166c6a7$export$c9483bbc66b4fb20 = (extensionId)=>{
    const [prefix, appId, envId, ...rest] = extensionId.split('/');
    const appKey = [
        prefix,
        appId,
        envId
    ].join('/');
    const moduleKey = rest.join('/');
    return {
        appKey: appKey,
        moduleKey: moduleKey
    };
};
const $7c20fcbbb166c6a7$export$b0ed77f2dd403096 = (appKey)=>appKey.startsWith((0, $2Rqjr.FORGE_FIELD_TYPE_PREFIX));
const $7c20fcbbb166c6a7$export$75f2b72396a13fc0 = (key, prefix)=>key.startsWith(prefix) && /^\w+-\d+$/.test(key.slice(prefix.length));

});

parcelRegister("duMa0", function(module, exports) {

$parcel$export(module.exports, "removeTimestamp", () => $5a77e887744126ed$export$8144a1156e1fc1b3);
$parcel$export(module.exports, "parseForgeIssuePanel", () => $5a77e887744126ed$export$a21b4e384e411f26);
// when input is like 'my-issue-content-panel-5794110541888792068', output is 'my-issue-content-panel'
const $5a77e887744126ed$export$8144a1156e1fc1b3 = (str, minDigitsLen = 0)=>{
    const indexOfHyphen = str.lastIndexOf('-');
    const tail = str.substr(indexOfHyphen + 1);
    if (/^\d+$/.test(tail) && tail.length >= minDigitsLen) return str.substr(0, indexOfHyphen);
    return str;
};
const $5a77e887744126ed$export$a21b4e384e411f26 = (panelKey)=>{
    const match = panelKey.match(/^(.*)-(\w+)-(\d+)$/);
    if (match == null) return null;
    const [, extensionId, id, timestamp] = match;
    const added = Number(timestamp);
    return {
        extensionId: extensionId,
        id: id,
        added: added
    };
};

});

parcelRegister("9F6MO", function(module, exports) {

$parcel$export(module.exports, "permissionsSelector", () => $f28a7cb0a30833d7$export$7a13e26fbaa74911);
$parcel$export(module.exports, "canBeAssignedToIssuesPermissionsSelector", () => $f28a7cb0a30833d7$export$6da6e9cc5af6cc92);
$parcel$export(module.exports, "canAdministerProjectPermissionsSelector", () => $f28a7cb0a30833d7$export$106fd3c30fc8b230);
$parcel$export(module.exports, "canAdministerJiraPermissionsSelector", () => $f28a7cb0a30833d7$export$adf4ccad5657586d);
$parcel$export(module.exports, "canModifyReporterPermissionsSelector", () => $f28a7cb0a30833d7$export$85a3c8518f632ff1);
$parcel$export(module.exports, "canExportIssueSelector", () => $f28a7cb0a30833d7$export$a409252beda5dd99);
$parcel$export(module.exports, "watchersPermissionsSelector", () => $f28a7cb0a30833d7$export$b3bd1cf4683807d8);
$parcel$export(module.exports, "canViewDevToolsPermissionsSelector", () => $f28a7cb0a30833d7$export$dfc7b576e23ac861);
$parcel$export(module.exports, "canUseServiceDeskAgentFeaturesSelector", () => $f28a7cb0a30833d7$export$1b79be16305d8111);

var $df4Sl = parcelRequire("df4Sl");

var $czx3b = parcelRequire("czx3b");

var $7ZZxN = parcelRequire("7ZZxN");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");
const $f28a7cb0a30833d7$var$internalPermissionsSelector = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.permissions);
const $f28a7cb0a30833d7$var$jsdPermissionsSetThatNeedApplicationRoleAndAgentPerm = new Set([
    // In the BE this is not technically a veto'd permission, however it simplifies the FE code to pretend that it is.
    'canUseServiceDeskAgentFeatures',
    // Normal veto'd permissions as per ServiceDeskCollaboratorPermissionOverrideStrategy in BE
    'canEditIssues',
    'canTransitionIssues',
    'canScheduleIssues',
    'canMoveIssue',
    'canAssignIssues',
    'canBeAssignedToIssues',
    'canDeleteIssue',
    'canManageWatchers',
    'canEditAllComments',
    'canDeleteAllComments',
    'canDeleteAllAttachments',
    'canLogWork',
    'canEditOwnWorklogs',
    'canEditAllWorklogs',
    'canDeleteOwnWorklogs',
    'canDeleteAllWorklogs',
    // These should be vetoed, but aren't requested by JFE yet
    'canResolveIssues',
    'canViewReadonlyWorkflow',
    'canCloseIssues',
    'canModifyReporter',
    'canSetIssueSecurity',
    'canArchiveIssue',
    'canUnarchiveIssue'
]);
const $f28a7cb0a30833d7$export$7a13e26fbaa74911 = (0, $df4Sl.createSelector)((0, $5JqpU.appPermissionsSelector), (0, $jZDJX.projectTypeSelector), $f28a7cb0a30833d7$var$internalPermissionsSelector, (0, $5JqpU.tenantHasActiveServiceDeskLicenseSelector), (applicationPermissions, projectType, permissions, tenantHasActiveServiceDeskLicense)=>{
    if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT) && tenantHasActiveServiceDeskLicense) {
        const { canUseServiceDeskAgentFeatures: canUseServiceDeskAgentFeatures } = permissions;
        const hasJsdAppRole = applicationPermissions.hasServiceDeskAccess;
        return (0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(permissions, (hasPermission, key)=>$f28a7cb0a30833d7$var$jsdPermissionsSetThatNeedApplicationRoleAndAgentPerm.has(key) ? hasPermission && hasJsdAppRole && canUseServiceDeskAgentFeatures : hasPermission);
    }
    return permissions;
});
const $f28a7cb0a30833d7$export$6da6e9cc5af6cc92 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>!!permissions.canBeAssignedToIssues);
const $f28a7cb0a30833d7$export$106fd3c30fc8b230 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>!!permissions.canAdministerProject);
const $f28a7cb0a30833d7$export$adf4ccad5657586d = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>!!permissions.canAdministerJira);
const $f28a7cb0a30833d7$var$canViewWatchersPermissionsSelector = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canViewWatchers);
const $f28a7cb0a30833d7$var$canManageWatchersPermissionsSelector = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canManageWatchers);
const $f28a7cb0a30833d7$export$85a3c8518f632ff1 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canModifyReporter);
const $f28a7cb0a30833d7$export$a409252beda5dd99 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canExportIssue);
const $f28a7cb0a30833d7$export$b3bd1cf4683807d8 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$var$canViewWatchersPermissionsSelector, $f28a7cb0a30833d7$var$canManageWatchersPermissionsSelector, (canViewWatchers, canManageWatchers)=>({
        canViewWatchers: canViewWatchers,
        canManageWatchers: canManageWatchers
    }));
const $f28a7cb0a30833d7$export$ca6b7f39a3de4ff9 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canBrowseUsers);
const $f28a7cb0a30833d7$export$dfc7b576e23ac861 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canViewDevTools);
const $f28a7cb0a30833d7$export$1b79be16305d8111 = (0, $df4Sl.createSelector)($f28a7cb0a30833d7$export$7a13e26fbaa74911, (permissions)=>permissions.canUseServiceDeskAgentFeatures);

});
parcelRegister("czx3b", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $piimr = parcelRequire("piimr");

var $7qARj = parcelRequire("7qARj");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $9272640aa667e27d$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $7qARj(iteratee, 3);
    $piimr(object, function(value, key, object) {
        $3pSMu(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $9272640aa667e27d$var$mapValues;

});


const $6c91ecd17276581e$export$bdafa6b589be8b30 = 'issue.content.panel.customised.flag';

parcelRegister("9Hrk7", function(module, exports) {

$parcel$export(module.exports, "ecosystemEntitiesSelector", () => $683f24d420bc5103$export$8db07a5bb000e56f);
$parcel$export(module.exports, "forgeEntitiesSelector", () => $683f24d420bc5103$export$92b32d478f0e29fb);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");

var $k8iGR = parcelRequire("k8iGR");
const $683f24d420bc5103$export$8db07a5bb000e56f = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.ecosystem || {});
const $683f24d420bc5103$export$92b32d478f0e29fb = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.forge || (0, $k8iGR.initialState));

});
parcelRegister("k8iGR", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $9fdfda2b324e48f8$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $9fdfda2b324e48f8$export$2e2bcd8739ae039);

var $i7QJO = parcelRequire("i7QJO");

var $5nezI = parcelRequire("5nezI");

var $fYteL = parcelRequire("fYteL");
const $9fdfda2b324e48f8$export$d4c72bab9d6cc13a = {
    actions: [],
    glances: [],
    issueContexts: [],
    panels: [],
    activities: [],
    customFields: [],
    customFieldTypes: [],
    backgroundScripts: [],
    activeAction: null,
    panelsKeys: {
        newPanels: [],
        collapsedPanels: []
    },
    uiModifications: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9fdfda2b324e48f8$export$2e2bcd8739ae039 = (state = $9fdfda2b324e48f8$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $i7QJO.FETCH_FORGE_SUCCESS:
            return {
                ...state,
                actions: action.payload.issueAction,
                glances: action.payload.issueGlance,
                issueContexts: action.payload.issueContext,
                panels: action.payload.issuePanel,
                activities: action.payload.issueActivity,
                customFields: action.payload.customField,
                customFieldTypes: action.payload.customFieldType,
                backgroundScripts: action.payload.issueViewBackgroundScript,
                activeAction: null,
                panelsKeys: {
                    ...state.panelsKeys,
                    newPanels: []
                },
                uiModifications: action.payload.uiModifications
            };
        case 0, $i7QJO.FORGE_ISSUE_ACTION_EXEC:
            return {
                ...state,
                activeAction: {
                    action: action.payload,
                    isLoading: true
                }
            };
        case 0, $i7QJO.FORGE_ISSUE_ACTION_RENDERED:
            return {
                ...state,
                // @ts-expect-error - TS2322 - Type '{ isLoading: false; action?: Action | undefined; }' is not assignable to type 'ActiveAction'.
                activeAction: {
                    ...state.activeAction,
                    isLoading: false
                }
            };
        case 0, $i7QJO.FORGE_ISSUE_ACTION_CLOSE:
            return {
                ...state,
                activeAction: null
            };
        case 0, $i7QJO.FORGE_ISSUE_PANEL_ADDED:
            return {
                ...state,
                panelsKeys: {
                    ...state.panelsKeys,
                    newPanels: [
                        ...state.panelsKeys.newPanels,
                        action.payload
                    ]
                }
            };
        case 0, $i7QJO.FORGE_NEW_ISSUE_PANEL_UNTRACK:
            {
                const removedPanelKey = action.payload;
                const { panelsKeys: panelsKeys } = state;
                return {
                    ...state,
                    panelsKeys: {
                        ...panelsKeys,
                        newPanels: panelsKeys.newPanels.filter((panelKey)=>panelKey !== removedPanelKey)
                    }
                };
            }
        case 0, $i7QJO.FORGE_ISSUE_PANEL_REMOVED:
            {
                const removedPanelKey = action.payload;
                return {
                    ...state,
                    panelsKeys: {
                        newPanels: state.panelsKeys.newPanels.filter((panelKey)=>panelKey !== removedPanelKey),
                        collapsedPanels: state.panelsKeys.collapsedPanels.filter((panelKey)=>panelKey !== removedPanelKey)
                    }
                };
            }
        case 0, $i7QJO.FORGE_ISSUE_PANEL_UPDATED:
            {
                const { panelKey: panelKey, collapsed: collapsed } = action.payload;
                const updatedCollapsedPanels = collapsed ? Array.from(new Set([
                    ...state.panelsKeys.collapsedPanels,
                    panelKey
                ])) : state.panelsKeys.collapsedPanels.filter((key)=>key !== panelKey);
                return {
                    ...state,
                    panelsKeys: {
                        ...state.panelsKeys,
                        collapsedPanels: updatedCollapsedPanels
                    }
                };
            }
        case 0, $fYteL.FETCH_ISSUE_SUCCESS:
        case 0, $fYteL.REFRESH_ISSUE_SUCCESS:
        case 0, $5nezI.FETCH_ISSUE_REMOTE_DATA_SUCCESS:
            {
                const collapsedPanels = action.payload.forgeIssueProperties?.collapsedPanels || [];
                return {
                    ...state,
                    panelsKeys: {
                        ...state.panelsKeys,
                        collapsedPanels: Array.from(new Set([
                            ...state.panelsKeys.collapsedPanels,
                            ...collapsedPanels
                        ]))
                    }
                };
            }
        default:
            return state;
    }
};

});
parcelRegister("i7QJO", function(module, exports) {

$parcel$export(module.exports, "FETCH_FORGE_SUCCESS", () => $2c680f99c3f1e6c8$export$b40fce05e753d390);
$parcel$export(module.exports, "fetchForgeSuccess", () => $2c680f99c3f1e6c8$export$1b05a0184822bc74);
$parcel$export(module.exports, "FORGE_ISSUE_ACTION_EXEC", () => $2c680f99c3f1e6c8$export$8c062df60fb76839);
$parcel$export(module.exports, "forgeIssueActionExec", () => $2c680f99c3f1e6c8$export$3a189763780c504b);
$parcel$export(module.exports, "FORGE_ISSUE_ACTION_RENDERED", () => $2c680f99c3f1e6c8$export$dd307b8c5e0de67d);
$parcel$export(module.exports, "forgeIssueActionRendered", () => $2c680f99c3f1e6c8$export$2484a0b7a9a14f92);
$parcel$export(module.exports, "FORGE_ISSUE_ACTION_CLOSE", () => $2c680f99c3f1e6c8$export$d91b51ae909f8e95);
$parcel$export(module.exports, "forgeIssueActionClose", () => $2c680f99c3f1e6c8$export$335a03a463c5945a);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_ADDED", () => $2c680f99c3f1e6c8$export$7d7831d10e022e0);
$parcel$export(module.exports, "forgeIssuePanelAdded", () => $2c680f99c3f1e6c8$export$f24c609edeac582f);
$parcel$export(module.exports, "FORGE_NEW_ISSUE_PANEL_UNTRACK", () => $2c680f99c3f1e6c8$export$d36cecbf4e320d4a);
$parcel$export(module.exports, "forgeNewIssuePanelUntrack", () => $2c680f99c3f1e6c8$export$b93b979485d242c8);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_REMOVED", () => $2c680f99c3f1e6c8$export$798e467d6a4cb5c);
$parcel$export(module.exports, "forgeIssuePanelRemoved", () => $2c680f99c3f1e6c8$export$b584e6f1797702be);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_UPDATE_REQUEST", () => $2c680f99c3f1e6c8$export$bb2e005bc0498829);
$parcel$export(module.exports, "forgeIssuePanelUpdateRequest", () => $2c680f99c3f1e6c8$export$c67c4f64ec92ba7f);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_UPDATED", () => $2c680f99c3f1e6c8$export$2ce5fe154022894b);
$parcel$export(module.exports, "forgeIssuePanelUpdated", () => $2c680f99c3f1e6c8$export$e2eebb5b364492ce);
const $2c680f99c3f1e6c8$export$b40fce05e753d390 = 'FETCH_FORGE_SUCCESS';
const $2c680f99c3f1e6c8$export$1b05a0184822bc74 = (payload)=>({
        type: $2c680f99c3f1e6c8$export$b40fce05e753d390,
        payload: payload
    });
const $2c680f99c3f1e6c8$export$8c062df60fb76839 = 'FORGE_ISSUE_ACTION_EXEC';
const $2c680f99c3f1e6c8$export$3a189763780c504b = (action)=>({
        type: $2c680f99c3f1e6c8$export$8c062df60fb76839,
        payload: action
    });
const $2c680f99c3f1e6c8$export$dd307b8c5e0de67d = 'FORGE_ISSUE_ACTION_RENDERED';
const $2c680f99c3f1e6c8$export$2484a0b7a9a14f92 = ()=>({
        type: $2c680f99c3f1e6c8$export$dd307b8c5e0de67d
    });
const $2c680f99c3f1e6c8$export$d91b51ae909f8e95 = 'FORGE_ISSUE_ACTION_CLOSE';
const $2c680f99c3f1e6c8$export$335a03a463c5945a = ()=>({
        type: $2c680f99c3f1e6c8$export$d91b51ae909f8e95
    });
const $2c680f99c3f1e6c8$export$7d7831d10e022e0 = 'FORGE_ISSUE_PANEL_ADDED';
const $2c680f99c3f1e6c8$export$f24c609edeac582f = (issuePanelKey)=>({
        type: $2c680f99c3f1e6c8$export$7d7831d10e022e0,
        payload: issuePanelKey
    });
const $2c680f99c3f1e6c8$export$d36cecbf4e320d4a = 'FORGE_NEW_ISSUE_PANEL_UNTRACK';
const $2c680f99c3f1e6c8$export$b93b979485d242c8 = (issuePanelKey)=>({
        type: $2c680f99c3f1e6c8$export$d36cecbf4e320d4a,
        payload: issuePanelKey
    });
const $2c680f99c3f1e6c8$export$798e467d6a4cb5c = 'FORGE_ISSUE_PANEL_REMOVED';
const $2c680f99c3f1e6c8$export$b584e6f1797702be = (issuePanelKey)=>({
        type: $2c680f99c3f1e6c8$export$798e467d6a4cb5c,
        payload: issuePanelKey
    });
const $2c680f99c3f1e6c8$export$bb2e005bc0498829 = 'FORGE_ISSUE_PANEL_UPDATE_REQUEST';
const $2c680f99c3f1e6c8$export$c67c4f64ec92ba7f = (payload)=>({
        type: $2c680f99c3f1e6c8$export$bb2e005bc0498829,
        payload: payload
    });
const $2c680f99c3f1e6c8$export$2ce5fe154022894b = 'FORGE_ISSUE_PANEL_UPDATED';
const $2c680f99c3f1e6c8$export$e2eebb5b364492ce = (payload)=>({
        type: $2c680f99c3f1e6c8$export$2ce5fe154022894b,
        payload: payload
    });

});

parcelRegister("5nezI", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_REQUEST", () => $739b73405dd64b1d$export$d8a6e69b46d6d184);
$parcel$export(module.exports, "fetchIssueRemoteDataRequest", () => $739b73405dd64b1d$export$222125e4e0f166e4);
$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_SUCCESS", () => $739b73405dd64b1d$export$2cdd723fc40cdd47);
$parcel$export(module.exports, "fetchIssueRemoteDataSuccess", () => $739b73405dd64b1d$export$615a2d29b149df95);
$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_FAILURE", () => $739b73405dd64b1d$export$396f0d977db541d9);
$parcel$export(module.exports, "fetchIssueRemoteDataFailure", () => $739b73405dd64b1d$export$f7fd18472eaf2b77);
const $739b73405dd64b1d$export$d8a6e69b46d6d184 = 'FETCH_ISSUE_REMOTE_DATA_REQUEST';
const $739b73405dd64b1d$export$222125e4e0f166e4 = (issueKey)=>({
        type: $739b73405dd64b1d$export$d8a6e69b46d6d184,
        payload: issueKey
    });
const $739b73405dd64b1d$export$2cdd723fc40cdd47 = 'FETCH_ISSUE_REMOTE_DATA_SUCCESS';
const $739b73405dd64b1d$export$615a2d29b149df95 = (entities)=>({
        type: $739b73405dd64b1d$export$2cdd723fc40cdd47,
        payload: entities
    });
const $739b73405dd64b1d$export$396f0d977db541d9 = 'FETCH_ISSUE_REMOTE_DATA_FAILURE';
const $739b73405dd64b1d$export$f7fd18472eaf2b77 = ()=>({
        type: $739b73405dd64b1d$export$396f0d977db541d9
    });

});

parcelRegister("fYteL", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_REQUEST", () => $98506972d7379203$export$afc8565512ebbf99);
$parcel$export(module.exports, "fetchIssueRequest", () => $98506972d7379203$export$ff7cd1a46115d8ca);
$parcel$export(module.exports, "FETCH_ISSUE_SUCCESS", () => $98506972d7379203$export$c32d0e1f370b7914);
$parcel$export(module.exports, "fetchIssueSuccess", () => $98506972d7379203$export$1e39a30e3f37e9d1);
$parcel$export(module.exports, "FETCH_ISSUE_FAILURE", () => $98506972d7379203$export$700ca24f76d5bbe6);
$parcel$export(module.exports, "fetchIssueFailure", () => $98506972d7379203$export$625e6e61fad65793);
$parcel$export(module.exports, "REFRESH_ISSUE_REQUEST", () => $98506972d7379203$export$b48f53bf5b842d57);
$parcel$export(module.exports, "refreshIssueRequest", () => $98506972d7379203$export$ccd0db94940d9159);
$parcel$export(module.exports, "CANCEL_REFRESH_ISSUE_REQUEST", () => $98506972d7379203$export$6b6ca6acd76420d1);
$parcel$export(module.exports, "cancelRefreshIssueRequest", () => $98506972d7379203$export$a7629a657f902cbc);
$parcel$export(module.exports, "REFRESH_ISSUE_SUCCESS", () => $98506972d7379203$export$de11c913f06a7952);
$parcel$export(module.exports, "refreshIssueSuccess", () => $98506972d7379203$export$cbd1c08fb706639c);
$parcel$export(module.exports, "FETCH_FORGE_REQUEST", () => $98506972d7379203$export$36b76b7384d868f3);
$parcel$export(module.exports, "fetchForgeRequest", () => $98506972d7379203$export$6ce2430992033a55);
const $98506972d7379203$export$afc8565512ebbf99 = 'FETCH_ISSUE_REQUEST';
const $98506972d7379203$export$ff7cd1a46115d8ca = ()=>({
        type: $98506972d7379203$export$afc8565512ebbf99
    });
const $98506972d7379203$export$c32d0e1f370b7914 = 'FETCH_ISSUE_SUCCESS';
const $98506972d7379203$export$1e39a30e3f37e9d1 = (entities)=>({
        type: $98506972d7379203$export$c32d0e1f370b7914,
        payload: entities
    });
const $98506972d7379203$export$700ca24f76d5bbe6 = 'FETCH_ISSUE_FAILURE';
const $98506972d7379203$export$625e6e61fad65793 = (failureDescription)=>({
        type: $98506972d7379203$export$700ca24f76d5bbe6,
        payload: failureDescription
    });
const $98506972d7379203$export$b48f53bf5b842d57 = 'REFRESH_ISSUE_REQUEST';
const $98506972d7379203$export$ccd0db94940d9159 = (payload, meta)=>({
        type: $98506972d7379203$export$b48f53bf5b842d57,
        payload: payload,
        meta: meta
    });
const $98506972d7379203$export$6b6ca6acd76420d1 = 'CANCEL_REFRESH_ISSUE_REQUEST';
const $98506972d7379203$export$a7629a657f902cbc = ()=>({
        type: $98506972d7379203$export$6b6ca6acd76420d1
    });
const $98506972d7379203$export$de11c913f06a7952 = 'REFRESH_ISSUE_SUCCESS';
const $98506972d7379203$export$cbd1c08fb706639c = (entities)=>({
        type: $98506972d7379203$export$de11c913f06a7952,
        payload: entities
    });
const $98506972d7379203$export$36b76b7384d868f3 = 'FETCH_FORGE_REQUEST';
const $98506972d7379203$export$6ce2430992033a55 = ()=>({
        type: $98506972d7379203$export$36b76b7384d868f3
    });

});



parcelRegister("8QKSg", function(module, exports) {

$parcel$export(module.exports, "forgeContextPanelsSelector", () => $0fae948f4d8718f3$export$94c701814d50fed3);
$parcel$export(module.exports, "forgeGlancesSelector", () => $0fae948f4d8718f3$export$92747468cb57714e);
$parcel$export(module.exports, "forgeUiModificationsSelector", () => $0fae948f4d8718f3$export$325ea69d1eb5eda0);
$parcel$export(module.exports, "forgeIssueActionsSelector", () => $0fae948f4d8718f3$export$9bcd40b01af57823);
$parcel$export(module.exports, "forgePanelsSelector", () => $0fae948f4d8718f3$export$ca115d43abfd7206);
$parcel$export(module.exports, "forgeUserCanSaveIssuePanelSelector", () => $0fae948f4d8718f3$export$ae25fce59e44b253);
$parcel$export(module.exports, "forgeJustAddedPanelSelector", () => $0fae948f4d8718f3$export$9c375a0b9a6e5017);
$parcel$export(module.exports, "forgeActiveIssueActionSelector", () => $0fae948f4d8718f3$export$ccad5f28efcec42d);
$parcel$export(module.exports, "forgeIssueDataSelector", () => $0fae948f4d8718f3$export$d3cd515b7639ce61);
$parcel$export(module.exports, "forgeIssueActivitySelector", () => $0fae948f4d8718f3$export$18ce84b90b4920eb);
$parcel$export(module.exports, "isForgePanelNewToIssueSelector", () => $0fae948f4d8718f3$export$97dadedc102bebdf);
$parcel$export(module.exports, "getForgeIssuePanel", () => $0fae948f4d8718f3$export$b01f1fc9eba6d8cd);
$parcel$export(module.exports, "forgeIsCollapsedPanelSelector", () => $0fae948f4d8718f3$export$3d7856e5c65d2291);

var $df4Sl = parcelRequire("df4Sl");

var $ldoFd = parcelRequire("ldoFd");

var $fTsDx = parcelRequire("fTsDx");

var $7C4za = parcelRequire("7C4za");

var $bLiXo = parcelRequire("bLiXo");

var $fkvsU = parcelRequire("fkvsU");

var $duMa0 = parcelRequire("duMa0");

var $6vrw7 = parcelRequire("6vrw7");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $9D3Vo = parcelRequire("9D3Vo");

var $9Hrk7 = parcelRequire("9Hrk7");
const $0fae948f4d8718f3$var$filterExtensions = (list, staticContext)=>list.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, staticContext));
const $0fae948f4d8718f3$var$sortIssuePanels = (first, second)=>{
    if (first.name === second.name) return 0;
    return first.name > second.name ? 1 : -1;
};
const $0fae948f4d8718f3$export$b302c9df74ede99a = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (0, $5JqpU.issueIdSelector), (0, $5JqpU.issueKeySelector), (0, $9D3Vo.issueTypeNameSelector), (0, $jZDJX.projectIdSelector), (0, $5JqpU.projectKeySelector), (0, $jZDJX.projectTypeSelector), (permissions, issueId, issueKey, issueType, projectId, projectKey, projectType)=>({
        issueId: issueId || null,
        issueKey: issueKey,
        issueType: issueType,
        projectId: projectId,
        projectKey: projectKey,
        projectType: projectType || null,
        // Instead of dumping permissions as is we'd like to normalize prop names a bit
        // as they are exposed externally and have to look respectable
        canAddComments: permissions.canAddComments,
        canAdministerJira: permissions.canAdministerJira,
        canAdministerProjects: permissions.canAdministerProject,
        canArchiveIssue: permissions.canArchiveIssue,
        canAssignIssues: permissions.canAssignIssues,
        canBeAssignedToIssues: permissions.canBeAssignedToIssues,
        canCloneIssues: permissions.canCloneIssue,
        canCreateAttachments: permissions.canCreateAttachments,
        canCreateChildren: permissions.canCreateChildren,
        canCreateSubtasks: permissions.canCreateSubtask,
        canDeleteAllAttachments: permissions.canDeleteAllAttachments,
        canDeleteAllComments: permissions.canDeleteAllComments,
        canDeleteAllWorklogs: permissions.canDeleteAllWorklogs,
        canDeleteIssues: permissions.canDeleteIssue,
        canDeleteOwnAttachments: permissions.canDeleteOwnAttachments,
        canDeleteOwnComments: permissions.canDeleteOwnComments,
        canDeleteOwnWorklogs: permissions.canDeleteOwnWorklogs,
        canEditAllComments: permissions.canEditAllComments,
        canEditAllWorklogs: permissions.canEditAllWorklogs,
        canEditIssues: permissions.canEditIssues,
        canEditOwnComments: permissions.canEditOwnComments,
        canEditOwnWorklogs: permissions.canEditOwnWorklogs,
        canLinkIssues: permissions.canLinkIssues,
        canLogWork: permissions.canLogWork,
        canManageWatchers: permissions.canManageWatchers,
        canModifyReporters: permissions.canModifyReporter,
        canMoveIssues: permissions.canMoveIssue,
        canScheduleIssues: permissions.canScheduleIssues,
        canUnarchiveIssue: permissions.canUnarchiveIssue,
        canUseServiceManagementAgentFeatures: permissions.canUseServiceDeskAgentFeatures,
        canBrowseUsers: permissions.canBrowseUsers,
        canViewDevTools: permissions.canViewDevTools,
        canViewWatchers: permissions.canViewWatchers,
        canExportIssue: permissions.canExportIssue
    }));
const $0fae948f4d8718f3$export$94c701814d50fed3 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.issueContexts)) return [];
    return forge.issueContexts.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, issueViewStaticContext)).map((contextPanels)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: url } } = contextPanels;
        return {
            id: id,
            type: (0, $bLiXo.FORGE_CONTEXT_TYPE),
            payload: {
                type: (0, $bLiXo.FORGE_CONTEXT_TYPE),
                label: label,
                name: title,
                status: status || null,
                icon: url ? {
                    url: url
                } : null,
                contextPanelType: (0, $fkvsU.FORGE_ENTITY_TYPE),
                moduleKey: id,
                appKey: id,
                options: null
            }
        };
    });
});
const $0fae948f4d8718f3$export$92747468cb57714e = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.glances)) return [];
    return $0fae948f4d8718f3$var$filterExtensions(forge.glances, issueViewStaticContext).map((extension)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: icon } } = extension;
        return {
            title: title,
            label: label,
            status: status,
            icon: icon,
            extension: extension,
            glanceType: (0, $fkvsU.FORGE_ENTITY_TYPE),
            // Legacy props, too much refactoring needed in order to get rid of them
            moduleKey: id,
            appKey: id
        };
    });
});
const $0fae948f4d8718f3$export$325ea69d1eb5eda0 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.uiModifications)) return [];
    return forge.uiModifications;
});
const $0fae948f4d8718f3$export$9bcd40b01af57823 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.actions)) return [];
    return $0fae948f4d8718f3$var$filterExtensions(forge.actions, issueViewStaticContext).map((extension)=>{
        const { id: id, properties: { title: title } } = extension;
        return {
            id: id,
            title: title,
            extension: extension,
            type: (0, $fkvsU.FORGE_ENTITY_TYPE)
        };
    });
});
const $0fae948f4d8718f3$export$ca115d43abfd7206 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.panels)) return [];
    return $0fae948f4d8718f3$var$filterExtensions(forge.panels, issueViewStaticContext).filter((extension)=>extension.properties.icon != null).map((extension)=>{
        const { id: id, properties: { title: title, icon: icon, allowMultiple: allowMultiple } } = extension;
        const { appKey: appKey, moduleKey: moduleKey } = (0, $7C4za.toEcosystemKeys)(id);
        return {
            name: title,
            tooltip: title,
            iconUrl: icon,
            extension: extension,
            allowMultiple: !!allowMultiple,
            showByDefault: false,
            type: (0, $fkvsU.FORGE_ENTITY_TYPE),
            moduleKey: moduleKey,
            appKey: appKey
        };
    }).sort($0fae948f4d8718f3$var$sortIssuePanels);
});
const $0fae948f4d8718f3$export$ae25fce59e44b253 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, issueViewStaticContext)=>isEcosystemEnabled && issueViewStaticContext.canEditIssues);
const $0fae948f4d8718f3$export$9c375a0b9a6e5017 = (panelKey)=>(0, $df4Sl.createSelector)((0, $9Hrk7.ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.selectedContentPanel === panelKey);
const $0fae948f4d8718f3$export$38dd8c9ba1d48d98 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.customFields)) return [];
    return $0fae948f4d8718f3$var$filterExtensions(forge.customFields, issueViewStaticContext);
});
const $0fae948f4d8718f3$export$9cef69a20109a92c = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.customFieldTypes)) return [];
    return $0fae948f4d8718f3$var$filterExtensions(forge.customFieldTypes, issueViewStaticContext);
});
const $0fae948f4d8718f3$export$2f1d736b0e7e1293 = (0, $df4Sl.createSelector)($0fae948f4d8718f3$export$38dd8c9ba1d48d98, (fields)=>fields.length > 0);
const $0fae948f4d8718f3$export$252a589d17b14921 = (0, $df4Sl.createSelector)($0fae948f4d8718f3$export$9cef69a20109a92c, (fieldsTypes)=>fieldsTypes.length > 0);
const $0fae948f4d8718f3$export$89b67d7e4e300f7d = (0, $df4Sl.createSelector)($0fae948f4d8718f3$export$2f1d736b0e7e1293, $0fae948f4d8718f3$export$252a589d17b14921, (hasCustomFields, hasCustomFieldTypes)=>hasCustomFields || hasCustomFieldTypes);
const $0fae948f4d8718f3$export$e824cf91ff446be9 = (0, $df4Sl.createSelector)($0fae948f4d8718f3$export$38dd8c9ba1d48d98, $0fae948f4d8718f3$export$9cef69a20109a92c, (customFields, customFieldTypes)=>[
        ...customFields,
        ...customFieldTypes
    ]);
const $0fae948f4d8718f3$export$ccad5f28efcec42d = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled) return null;
    return forge.activeAction || null;
});
const $0fae948f4d8718f3$export$e04b25b621339356 = (0, $df4Sl.createSelector)((0, $fokFV.fieldsSelector), (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>fields[fieldId]?.schema.custom || '');
const $0fae948f4d8718f3$export$fbab82209930cdab = (0, $df4Sl.createSelector)($0fae948f4d8718f3$export$e824cf91ff446be9, $0fae948f4d8718f3$export$e04b25b621339356, (forgeFields, extensionId)=>{
    const extension = forgeFields.find((field)=>field.id === extensionId);
    return extension || null;
});
const $0fae948f4d8718f3$export$c9095ffee4d5bbc0 = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$e04b25b621339356, $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, extensionId, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.customFields) || !Array.isArray(forge.customFieldTypes)) return false;
    const extension = [
        ...forge.customFields,
        ...forge.customFieldTypes
    ].find((field)=>field.id === extensionId);
    return !extension ? false : !(0, $fTsDx.doesExtensionMeetConditions)(extension, issueViewStaticContext);
});
const $0fae948f4d8718f3$export$7640f867620fe598 = (0, $df4Sl.createSelector)($0fae948f4d8718f3$export$fbab82209930cdab, (extension)=>{
    if (!extension) return false;
    const hasRenderingFunction = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(extension.properties.function);
    const hasFormatterDefined = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(extension.properties.formatter);
    return !hasRenderingFunction && hasFormatterDefined;
});
const $0fae948f4d8718f3$export$d3cd515b7639ce61 = (0, $df4Sl.createSelector)((0, $5JqpU.issueKeySelector), (0, $5JqpU.issueIdSelector), (0, $9D3Vo.issueTypeIdSelector), (0, $9D3Vo.issueTypeNameSelector), (0, $5JqpU.projectKeySelector), (0, $jZDJX.projectIdSelector), (0, $jZDJX.projectTypeSelector), (issueKey, issueId, issueTypeId, issueType, projectKey, projectId, projectType)=>({
        issue: {
            key: issueKey,
            id: issueId,
            type: issueType,
            typeId: issueTypeId
        },
        project: {
            id: projectId !== null ? (0, $6vrw7.toProjectId)(projectId.toString()) : projectId,
            key: projectKey,
            type: projectType
        }
    }));
const $0fae948f4d8718f3$export$18ce84b90b4920eb = (0, $df4Sl.createSelector)((0, $5JqpU.isEcosystemEnabledSelector), (0, $9Hrk7.forgeEntitiesSelector), $0fae948f4d8718f3$export$b302c9df74ede99a, (isEcosystemEnabled, forge, issueViewStaticContext)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.actions)) return [];
    return $0fae948f4d8718f3$var$filterExtensions(forge.activities, issueViewStaticContext).map((extension)=>{
        const { id: id, properties: { title: title } } = extension;
        const { appKey: appKey, moduleKey: moduleKey } = (0, $7C4za.toEcosystemKeys)(id);
        return {
            name: title,
            extension: extension,
            type: (0, $fkvsU.FORGE_ENTITY_TYPE),
            moduleKey: moduleKey,
            appKey: appKey
        };
    });
});
const $0fae948f4d8718f3$export$97dadedc102bebdf = (0, $df4Sl.createSelector)((0, $9Hrk7.forgeEntitiesSelector), (_, issuePanelKey)=>issuePanelKey, (forge, issuePanelKey)=>forge.panelsKeys.newPanels.includes(issuePanelKey));
const $0fae948f4d8718f3$export$b01f1fc9eba6d8cd = (forgePanelKey)=>(0, $df4Sl.createSelector)($0fae948f4d8718f3$export$ca115d43abfd7206, (panels)=>{
        const { extensionId: extensionId } = (0, $duMa0.parseForgeIssuePanel)(forgePanelKey) || {};
        return panels.find((panel)=>extensionId === panel.extension.id);
    });
const $0fae948f4d8718f3$export$3d7856e5c65d2291 = (0, $df4Sl.createSelector)((0, $9Hrk7.forgeEntitiesSelector), (_, issuePanelKey)=>issuePanelKey, (forge, issuePanelKey)=>forge.panelsKeys.collapsedPanels.includes(issuePanelKey));

});
parcelRegister("9D3Vo", function(module, exports) {

$parcel$export(module.exports, "createFullIssueUrl", () => $77aaf5a68eaa155c$export$f107e3172d0c8a79);
$parcel$export(module.exports, "issueTypeSelector", () => $77aaf5a68eaa155c$export$c5a236f192993436);
$parcel$export(module.exports, "issueUrlSelector", () => $77aaf5a68eaa155c$export$7855e152de23b9ca);
$parcel$export(module.exports, "fullIssueUrlSelector", () => $77aaf5a68eaa155c$export$14eeb219bfe6649b);
$parcel$export(module.exports, "issueTypeNameSelector", () => $77aaf5a68eaa155c$export$477df8db13e4dac3);
$parcel$export(module.exports, "issueTypeHierarchyLevelSelector", () => $77aaf5a68eaa155c$export$2bcfec06e5c80ef6);
$parcel$export(module.exports, "issueTypeIdSelector", () => $77aaf5a68eaa155c$export$22410768c09b3a82);
$parcel$export(module.exports, "issueTypeIconUrlSelector", () => $77aaf5a68eaa155c$export$4cf7e4622f7b8aee);
$parcel$export(module.exports, "isIssueTypeFieldEditableSelector", () => $77aaf5a68eaa155c$export$580b385a93b77724);
$parcel$export(module.exports, "getParentIssuesSelector", () => $77aaf5a68eaa155c$export$1e6d1c8ba22c2162);

var $df4Sl = parcelRequire("df4Sl");

var $f9RL0 = parcelRequire("f9RL0");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");
// @ts-expect-error - TS2304 - Cannot find name 'BaseUrl'. | TS7006 - Parameter 'issueKey' implicitly has an 'any' type.
const $77aaf5a68eaa155c$var$createRelativeIssueUrl = (baseUrl, issueKey)=>`${baseUrl ? baseUrl.replace(/\/?$/, '/') : '/'}browse/${issueKey}`;
const $77aaf5a68eaa155c$export$f107e3172d0c8a79 = (baseUrl, issueKey)=>`${window.location.protocol}//${window.location.host}${$77aaf5a68eaa155c$var$createRelativeIssueUrl(baseUrl, issueKey)}`;
const $77aaf5a68eaa155c$var$issueTypeFieldSelector = (0, $fokFV.fieldSelector)((0, $f9RL0.ISSUE_TYPE));
const $77aaf5a68eaa155c$var$subtaskIssueFieldSelector = (0, $fokFV.fieldSelector)((0, $f9RL0.SUBTASK_PARENT));
const $77aaf5a68eaa155c$var$portfolioParentFieldSelector = (0, $fokFV.fieldSelector)((0, $f9RL0.PARENT));
const $77aaf5a68eaa155c$export$c5a236f192993436 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$var$issueTypeFieldSelector, (issueType)=>issueType && issueType.value);
const $77aaf5a68eaa155c$export$7855e152de23b9ca = (0, $df4Sl.createSelector)((0, $5JqpU.baseUrlSelector), (0, $5JqpU.issueKeySelector), $77aaf5a68eaa155c$var$createRelativeIssueUrl);
const $77aaf5a68eaa155c$export$14eeb219bfe6649b = (0, $df4Sl.createSelector)((0, $5JqpU.baseUrlSelector), (0, $5JqpU.issueKeySelector), $77aaf5a68eaa155c$export$f107e3172d0c8a79);
const $77aaf5a68eaa155c$export$477df8db13e4dac3 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$export$c5a236f192993436, (issueType)=>issueType && issueType.name);
const $77aaf5a68eaa155c$export$2bcfec06e5c80ef6 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$export$c5a236f192993436, (issueType)=>{
    if (!issueType) return null;
    return issueType && issueType.hierarchyLevel;
});
const $77aaf5a68eaa155c$export$22410768c09b3a82 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$export$c5a236f192993436, (issueType)=>issueType && issueType.id);
const $77aaf5a68eaa155c$export$4cf7e4622f7b8aee = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$export$c5a236f192993436, (issueType)=>issueType && issueType.iconUrl);
const $77aaf5a68eaa155c$export$580b385a93b77724 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$var$issueTypeFieldSelector, (issueType)=>issueType && Boolean(issueType.editable));
const $77aaf5a68eaa155c$var$transformParentIssue = (issue, baseUrl)=>issue ? {
        summary: issue.summary,
        key: issue.key,
        url: $77aaf5a68eaa155c$var$createRelativeIssueUrl(baseUrl, issue.key),
        issueTypeName: issue.issueTypeName || '',
        issueTypeIconUrl: issue.issueTypeIconUrl || ''
    } : null;
// @ts-expect-error - TS7006 - Parameter 'issue' implicitly has an 'any' type.
const $77aaf5a68eaa155c$var$transformSubtaskParentIssue = (issue, baseUrl)=>issue ? {
        summary: issue.fields.summary,
        key: issue.key,
        url: $77aaf5a68eaa155c$var$createRelativeIssueUrl(baseUrl, issue.key),
        issueTypeName: issue.issueTypeName || '',
        issueTypeIconUrl: issue.issueTypeIconUrl || ''
    } : null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $77aaf5a68eaa155c$var$transformPortfolioParentIssue = (value, baseUrl)=>value && value.data ? {
        summary: value.data.summary,
        key: value.data.key,
        url: $77aaf5a68eaa155c$var$createRelativeIssueUrl(baseUrl, value.data.key),
        issueTypeName: value.data.issueTypeName || '',
        issueTypeIconUrl: value.data.issueTypeIconUrl || ''
    } : null;
const $77aaf5a68eaa155c$export$77f9f02e63a0906f = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$var$portfolioParentFieldSelector, (0, $5JqpU.baseUrlSelector), (portfolioParentIssue, baseUrl)=>$77aaf5a68eaa155c$var$transformPortfolioParentIssue(portfolioParentIssue && portfolioParentIssue.value, baseUrl));
const $77aaf5a68eaa155c$var$subtaskIssueParentSelector = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$var$subtaskIssueFieldSelector, (0, $5JqpU.baseUrlSelector), (subtaskIssue, baseUrl)=>$77aaf5a68eaa155c$var$transformSubtaskParentIssue(subtaskIssue && subtaskIssue.value, baseUrl));
const $77aaf5a68eaa155c$var$parentIssueSelector = (0, $df4Sl.createSelector)((0, $jZDJX.parentIssueEntitySelector), (0, $5JqpU.baseUrlSelector), (parentIssue, baseUrl)=>$77aaf5a68eaa155c$var$transformParentIssue(parentIssue, baseUrl));
const $77aaf5a68eaa155c$export$dfeb83ef40558422 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$var$parentIssueSelector, $77aaf5a68eaa155c$var$subtaskIssueParentSelector, $77aaf5a68eaa155c$export$77f9f02e63a0906f, (parentIssue, subtaskIssue, portfolioParentIssue)=>parentIssue || subtaskIssue || portfolioParentIssue);
const $77aaf5a68eaa155c$export$1e6d1c8ba22c2162 = (0, $df4Sl.createSelector)($77aaf5a68eaa155c$var$parentIssueSelector, (parentIssue)=>[
        parentIssue
    ].filter(Boolean));

});



parcelRegister("1b2Vj", function(module, exports) {

$parcel$export(module.exports, "supportedChildIssueTypesEntitiesSelector", () => $6915515a9b677dd8$export$1e8043fccfcba3b9);
$parcel$export(module.exports, "supportsChildCreationSelector", () => $6915515a9b677dd8$export$1af32b549149f3d9);
$parcel$export(module.exports, "parentLevelIssueTypeIdsSelector", () => $6915515a9b677dd8$export$be50776e2ae27cf6);
$parcel$export(module.exports, "parentLevelIssueTypeNamesSelector", () => $6915515a9b677dd8$export$57b3549670d3627b);
$parcel$export(module.exports, "sameLevelIssueTypesIdsSelector", () => $6915515a9b677dd8$export$a81bfe971074142b);
$parcel$export(module.exports, "hierarchyLevelSelector", () => $6915515a9b677dd8$export$4f7eb1d272a8015);
$parcel$export(module.exports, "isIssueBaseLevel", () => $6915515a9b677dd8$export$d9c73da87a448c4);
$parcel$export(module.exports, "canLinkToParentSelector", () => $6915515a9b677dd8$export$5530450eb840ecb2);

var $df4Sl = parcelRequire("df4Sl");

var $3l6tm = parcelRequire("3l6tm");

var $lO4Or = parcelRequire("lO4Or");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $7FqHc = parcelRequire("7FqHc");
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $6915515a9b677dd8$var$childLevelValueSelector = (0, $fokFV.fieldPersistedValueSelector)((0, $lO4Or.HIERARCHY_LEVEL_BELOW)) || null;
const $6915515a9b677dd8$var$isChildLevelSubtaskLevelSelector = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$childLevelValueSelector, (childLevelFieldValue)=>{
    if (!childLevelFieldValue) return false;
    return (0, $3l6tm.isSubtaskHierarchyLevel)(childLevelFieldValue.level);
});
const $6915515a9b677dd8$export$7a45e255c239753 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$childLevelValueSelector, (childLevelValue)=>childLevelValue && childLevelValue.issueTypes || []);
const $6915515a9b677dd8$export$1e8043fccfcba3b9 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), $6915515a9b677dd8$export$7a45e255c239753, (entities, supportedIssueTypes)=>{
    const allIssueTypes = entities.issueTypes;
    const supportedIssueTypeIds = supportedIssueTypes.map((issueType)=>issueType.id);
    return allIssueTypes.filter(// @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
    (issueType)=>supportedIssueTypeIds.indexOf(issueType.id) !== -1);
});
const $6915515a9b677dd8$export$1af32b549149f3d9 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), $6915515a9b677dd8$export$7a45e255c239753, $6915515a9b677dd8$var$isChildLevelSubtaskLevelSelector, (0, $jZDJX.isSimplifiedProjectSelector), (permissions, supportedChildIssueTypes, isChildLevelSubtask, isSimplifiedProject)=>permissions.canCreateChildren && !!supportedChildIssueTypes.length && (isSimplifiedProject ? true : !isChildLevelSubtask));
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $6915515a9b677dd8$var$parentLevelValueSelector = (0, $fokFV.fieldPersistedValueSelector)((0, $lO4Or.HIERARCHY_LEVEL_ABOVE)) || null;
const $6915515a9b677dd8$export$55a6507420d37093 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && (parentLevelValue.name || null));
const $6915515a9b677dd8$export$be50776e2ae27cf6 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && parentLevelValue.issueTypeIds.map(String) || []);
const $6915515a9b677dd8$export$57b3549670d3627b = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && parentLevelValue.issueTypes.map((type)=>type.name).filter((name)=>name) || []);
const $6915515a9b677dd8$export$121e4a84c99db916 = (0, $df4Sl.createSelector)($6915515a9b677dd8$export$be50776e2ae27cf6, (parentLevelValue)=>parentLevelValue.length > 0);
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $6915515a9b677dd8$var$sameLevelValueSelector = (0, $fokFV.fieldPersistedValueSelector)((0, $lO4Or.HIERARCHY_LEVEL_SAME_LEVEL)) || null;
const $6915515a9b677dd8$export$26996c7f0f08c0d8 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$sameLevelValueSelector, (sameLevelFieldValue)=>{
    if (!sameLevelFieldValue) return false;
    return (0, $3l6tm.isSubtaskHierarchyLevel)(sameLevelFieldValue.level);
});
const $6915515a9b677dd8$export$a81bfe971074142b = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$sameLevelValueSelector, (sameLevelFieldValue)=>sameLevelFieldValue ? sameLevelFieldValue.issueTypeIds.map(String) : []);
const $6915515a9b677dd8$export$4f7eb1d272a8015 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6915515a9b677dd8$var$sameLevelValueSelector, (sameLevelFieldValue)=>sameLevelFieldValue ? (0, $3l6tm.toHierarchyLevel)(sameLevelFieldValue.level) : null);
const $6915515a9b677dd8$export$d9c73da87a448c4 = (0, $df4Sl.createSelector)($6915515a9b677dd8$export$4f7eb1d272a8015, (level)=>{
    if (level == null) // Some product types (JSM, Core, ...) do not support hierarchies at all and will not return this field.
    // For these, all issues are considered to be "Base" level.
    return true;
    return (0, $3l6tm.isBaseHierarchyLevel)(level);
});
const $6915515a9b677dd8$export$5530450eb840ecb2 = (0, $df4Sl.createSelector)($6915515a9b677dd8$export$55a6507420d37093, (0, $7FqHc.canEditIssuesSelector), $6915515a9b677dd8$export$121e4a84c99db916, (parentLevelName, shouldShowAddParent, hasParentIssueTypeId)=>Boolean(parentLevelName) && shouldShowAddParent && hasParentIssueTypeId);

});
parcelRegister("7FqHc", function(module, exports) {

$parcel$export(module.exports, "canEditIssuesSelector", () => $82be12fe73ce8456$export$cdd6892c8add3e54);
$parcel$export(module.exports, "canLinkIssuesSelector", () => $82be12fe73ce8456$export$50487d0d29271836);

var $df4Sl = parcelRequire("df4Sl");

var $9F6MO = parcelRequire("9F6MO");
const $82be12fe73ce8456$export$a7a483ca0afc4ab3 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canCloneIssue);
const $82be12fe73ce8456$export$c1f4ef01259b4eb = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canDeleteIssue);
const $82be12fe73ce8456$export$2f9dd165cbf0c5ea = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canMoveIssue);
const $82be12fe73ce8456$export$cdd6892c8add3e54 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canEditIssues);
const $82be12fe73ce8456$export$f48030c6644c0c4d = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canAdministerJira || permissions.canAdministerProject);
const $82be12fe73ce8456$export$4e8dac873f71d13e = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canAssignIssues);
const $82be12fe73ce8456$export$50487d0d29271836 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canLinkIssues);

});


parcelRegister("cj1Xt", function(module, exports) {

$parcel$export(module.exports, "ecosystemCustomFieldIdsSelector", () => $c6007774372d78ef$export$c16e6010c2ccc7b2);

var $df4Sl = parcelRequire("df4Sl");

var $btjMs = parcelRequire("btjMs");

var $f9RL0 = parcelRequire("f9RL0");

var $fokFV = parcelRequire("fokFV");
const $c6007774372d78ef$export$1caf4359a6680b64 = (0, $df4Sl.createSelector)((0, $fokFV.fieldsSelector), (fields)=>Object.keys(fields).filter((id)=>{
        const type = (0, $btjMs.getFieldType)(fields[id]);
        return type && (0, $f9RL0.customFieldsToDisplay)().includes(type);
    }));
const $c6007774372d78ef$export$c16e6010c2ccc7b2 = (0, $df4Sl.createSelector)((0, $fokFV.fieldsSelector), (fields)=>Object.keys(fields).filter((id)=>{
        const type = (0, $btjMs.getFieldType)(fields[id]);
        return type && (0, $f9RL0.ecosystemCustomFields).includes(type);
    }));

});

parcelRegister("dmojD", function(module, exports) {

$parcel$export(module.exports, "entitiesCommentsSelector", () => $2fc412f4c8af7d4e$export$2bcb958351592bb9);
$parcel$export(module.exports, "totalCommentsSelector", () => $2fc412f4c8af7d4e$export$3873a5701cda7746);
$parcel$export(module.exports, "startIndexCommentsSelector", () => $2fc412f4c8af7d4e$export$10621129a0e171e5);
$parcel$export(module.exports, "loadedCommentsSelector", () => $2fc412f4c8af7d4e$export$c3802eebab78988b);
$parcel$export(module.exports, "isLoadingMoreCommentsSelector", () => $2fc412f4c8af7d4e$export$5d4ebbdab84a3a1);
$parcel$export(module.exports, "hasScrolledPermalinkCommentSelector", () => $2fc412f4c8af7d4e$export$3190c124f9d4af8a);
$parcel$export(module.exports, "loadingStageSelector", () => $2fc412f4c8af7d4e$export$18bc980d36bf93d);
$parcel$export(module.exports, "commentAuthorSelector", () => $2fc412f4c8af7d4e$export$6f6ac03c75ab3545);
$parcel$export(module.exports, "commentUpdateAuthorSelector", () => $2fc412f4c8af7d4e$export$7190d6fab16715b8);
$parcel$export(module.exports, "commentEditingBodySelector", () => $2fc412f4c8af7d4e$export$3e2634438f2a9b1a);
$parcel$export(module.exports, "commentEditingVisibilitySelector", () => $2fc412f4c8af7d4e$export$3c2f8c0a34054ef7);
$parcel$export(module.exports, "commentEditingOrViewBodyAdfSelector", () => $2fc412f4c8af7d4e$export$b0e0bc0c48cf00e6);
$parcel$export(module.exports, "commentOutsiderCommentSelector", () => $2fc412f4c8af7d4e$export$e7022c391905c53f);
$parcel$export(module.exports, "commentBodyHtmlSelector", () => $2fc412f4c8af7d4e$export$b9c6e85825c49cba);
$parcel$export(module.exports, "commentIsDeletedSelector", () => $2fc412f4c8af7d4e$export$e6360edf7c25f03d);
$parcel$export(module.exports, "commentRepliesSelector", () => $2fc412f4c8af7d4e$export$9fdd1ba68d7464f1);
$parcel$export(module.exports, "commentCreatedDateSelector", () => $2fc412f4c8af7d4e$export$b580f3d971b4e6fb);
$parcel$export(module.exports, "commentUpdatedDateSelector", () => $2fc412f4c8af7d4e$export$8b9935e49715b2d6);
$parcel$export(module.exports, "commentEditedSelector", () => $2fc412f4c8af7d4e$export$eff4fd551b2f55a1);
$parcel$export(module.exports, "pendingCommentSelector", () => $2fc412f4c8af7d4e$export$d63578bef1057cae);
$parcel$export(module.exports, "commentIsOptimisticSelector", () => $2fc412f4c8af7d4e$export$be047268481f07d8);
$parcel$export(module.exports, "commentSaveFailedSelector", () => $2fc412f4c8af7d4e$export$72075ae8ef4d6f6a);
$parcel$export(module.exports, "commentHasDeleteModalSelector", () => $2fc412f4c8af7d4e$export$c756ab72f25508bb);
$parcel$export(module.exports, "commentVisibilitySelector", () => $2fc412f4c8af7d4e$export$2cf9d22f626e5db0);
$parcel$export(module.exports, "commentEditingOrViewVisibilitySelector", () => $2fc412f4c8af7d4e$export$82fbf902093fe491);
$parcel$export(module.exports, "commentEditingEventOccurredAtSelector", () => $2fc412f4c8af7d4e$export$d820e1c3ac105e35);
$parcel$export(module.exports, "commentEventOccurredAtSelector", () => $2fc412f4c8af7d4e$export$9c8937d1bd8cf4a);
$parcel$export(module.exports, "commentJsdIncidentActivityViewHiddenSelector", () => $2fc412f4c8af7d4e$export$8c7be677b9a2cbf3);
$parcel$export(module.exports, "isInternalCommentSelector", () => $2fc412f4c8af7d4e$export$b99aa78c1374f9fe);
$parcel$export(module.exports, "isEditingInternalCommentSelector", () => $2fc412f4c8af7d4e$export$54205c8c886a2b43);
$parcel$export(module.exports, "canAddCommentsSelector", () => $2fc412f4c8af7d4e$export$a34c155854eb296b);
$parcel$export(module.exports, "canDeleteCommentSelector", () => $2fc412f4c8af7d4e$export$8cc876bb72dc09b7);
$parcel$export(module.exports, "canEditCommentSelector", () => $2fc412f4c8af7d4e$export$eb110f3a00a8432);
$parcel$export(module.exports, "visibleCommentIdsSelector", () => $2fc412f4c8af7d4e$export$3b3d01d442cb684a);
$parcel$export(module.exports, "sortedVisibleCommentIdsSelector", () => $2fc412f4c8af7d4e$export$81c523e14f04df2d);
$parcel$export(module.exports, "isEditingCommentSelector", () => $2fc412f4c8af7d4e$export$6eba3f548a7f384e);
$parcel$export(module.exports, "getEditingCommentIdsSelector", () => $2fc412f4c8af7d4e$export$3a00787e516c672c);
$parcel$export(module.exports, "commentIdsSelector", () => $2fc412f4c8af7d4e$export$4c04cd370caea884);
$parcel$export(module.exports, "isEditingAnyCommentSelector", () => $2fc412f4c8af7d4e$export$2e24e984817b4c7b);
$parcel$export(module.exports, "isAddCommentEditorExpandedSelector", () => $2fc412f4c8af7d4e$export$5373a6bfd674797c);
$parcel$export(module.exports, "addCommentEditorForceFocusSelector", () => $2fc412f4c8af7d4e$export$37aee7d1ec9d42d3);
$parcel$export(module.exports, "isCommentEditorOpenSelector", () => $2fc412f4c8af7d4e$export$6df0ef2ac2b35c13);
$parcel$export(module.exports, "isCommentAttachmentInProgressSelector", () => $2fc412f4c8af7d4e$export$f140c5c89826efc6);
$parcel$export(module.exports, "isCommentVisibilityRestrictionSupportedSelector", () => $2fc412f4c8af7d4e$export$2ce513eb85289331);
$parcel$export(module.exports, "isReplyingToCommentSelector", () => $2fc412f4c8af7d4e$export$ab64c511f5921cdf);
$parcel$export(module.exports, "isCommentReplyEditorOpenSelector", () => $2fc412f4c8af7d4e$export$d89d07d36d57d778);
$parcel$export(module.exports, "replyContentSelector", () => $2fc412f4c8af7d4e$export$bb44f1aa6771eeb6);
$parcel$export(module.exports, "replyingToAuthorSelector", () => $2fc412f4c8af7d4e$export$6fe69cb268473af1);
$parcel$export(module.exports, "commentParentIdSelector", () => $2fc412f4c8af7d4e$export$9f25935861e23f9b);

var $df4Sl = parcelRequire("df4Sl");

var $hvbu2 = parcelRequire("hvbu2");

var $78IOp = parcelRequire("78IOp");

var $kirCf = parcelRequire("kirCf");

var $7ZZxN = parcelRequire("7ZZxN");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");


var $f6MOn = parcelRequire("f6MOn");

var $8aR1q = parcelRequire("8aR1q");

var $5JqpU = parcelRequire("5JqpU");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $gIyTt = parcelRequire("gIyTt");

var $gzLYm = parcelRequire("gzLYm");

const $2fc412f4c8af7d4e$export$9832028921909a8f = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.pendingDeletedIds);
const $2fc412f4c8af7d4e$export$2bcb958351592bb9 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.comments);
const $2fc412f4c8af7d4e$export$3873a5701cda7746 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.totalComments);
const $2fc412f4c8af7d4e$export$10621129a0e171e5 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.commentsStartIndex);
const $2fc412f4c8af7d4e$export$c3802eebab78988b = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.loadedComments);
const $2fc412f4c8af7d4e$export$5d4ebbdab84a3a1 = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.isLoadingMoreComments);
const $2fc412f4c8af7d4e$export$3190c124f9d4af8a = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.hasScrolledPermalinkComment);
const $2fc412f4c8af7d4e$export$cb15fb58f04e4339 = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.pendingSavedValues);
const $2fc412f4c8af7d4e$var$deleteModalCommentIdSelector = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.deleteModalCommentId);
const $2fc412f4c8af7d4e$export$18bc980d36bf93d = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.loadingStage);
const $2fc412f4c8af7d4e$export$f82d111da9150583 = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$2bcb958351592bb9, $2fc412f4c8af7d4e$export$cb15fb58f04e4339, (comments, optimisticComments)=>({
        ...comments,
        ...optimisticComments
    }));
const $2fc412f4c8af7d4e$var$commentSelector = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$f82d111da9150583, (comments)=>comments[commentId]);
const $2fc412f4c8af7d4e$var$persistedCommentSelector = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$2bcb958351592bb9, (comments)=>comments[commentId]);
// If the user is anonymous, then they are not considered comment author
const $2fc412f4c8af7d4e$var$isUserCommentAuthorSelector = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (0, $5JqpU.accountIdloggedInUserSelector), (comment, loggedInUserId)=>loggedInUserId !== null && loggedInUserId === (comment && comment.authorId));
const $2fc412f4c8af7d4e$var$authorSelector = (commentId, authorIdPropertyName)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (0, $jZDJX.getUserByIdSelector), (comment, userByIdSelector)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'OptimisticComment | PersistedComment'.
        comment && comment[authorIdPropertyName] ? userByIdSelector(comment[authorIdPropertyName]) : null);
const $2fc412f4c8af7d4e$var$uiAllCommentsSelector = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui && ui.comments || null);
const $2fc412f4c8af7d4e$var$uiAllCommentEditorsSelector = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiAllCommentsSelector, (uiComments)=>uiComments && uiComments.commentEditors || null);
const $2fc412f4c8af7d4e$var$uiCommentEditorSelector = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiAllCommentEditorsSelector, (uiCommentEditors)=>uiCommentEditors && uiCommentEditors[commentId] || null);
const $2fc412f4c8af7d4e$export$6f6ac03c75ab3545 = (commentId)=>$2fc412f4c8af7d4e$var$authorSelector(commentId, 'authorId');
const $2fc412f4c8af7d4e$export$7190d6fab16715b8 = (commentId)=>$2fc412f4c8af7d4e$var$authorSelector(commentId, 'updateAuthorId');
const $2fc412f4c8af7d4e$export$3e2634438f2a9b1a = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.editingValue || null);
const $2fc412f4c8af7d4e$export$3c2f8c0a34054ef7 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.visibility || null);
const $2fc412f4c8af7d4e$export$b0e0bc0c48cf00e6 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$3e2634438f2a9b1a(commentId), $2fc412f4c8af7d4e$var$commentSelector(commentId), (editingComment, comment)=>editingComment || comment && comment.bodyAdf || null);
const $2fc412f4c8af7d4e$export$e7022c391905c53f = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.jsdAuthorCanSeeRequest : null);
const $2fc412f4c8af7d4e$export$b9c6e85825c49cba = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.bodyHtml : null);
const $2fc412f4c8af7d4e$export$e6360edf7c25f03d = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.isDeleted : null);
const $2fc412f4c8af7d4e$export$9fdd1ba68d7464f1 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$persistedCommentSelector(commentId), $2fc412f4c8af7d4e$export$f82d111da9150583, $2fc412f4c8af7d4e$export$9832028921909a8f, (comment, allComments, deletedIds)=>{
        if (comment?.replies && comment.replies.length > 0) {
            const nonDeletedReplies = comment.replies.filter((id)=>!deletedIds.includes(id) && allComments[id]);
            if (nonDeletedReplies.length > 0) return nonDeletedReplies.map($2fc412f4c8af7d4e$var$mapIdToCommentSortInfo(allComments)).sort($2fc412f4c8af7d4e$var$compareComments).map((sortedComment)=>sortedComment.id);
        }
        return null;
    });
const $2fc412f4c8af7d4e$export$b580f3d971b4e6fb = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.createdDate : null);
const $2fc412f4c8af7d4e$export$8b9935e49715b2d6 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.updatedDate : null);
const $2fc412f4c8af7d4e$export$eff4fd551b2f55a1 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.edited : null);
const $2fc412f4c8af7d4e$export$d63578bef1057cae = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$cb15fb58f04e4339, (pendingComments)=>pendingComments[commentId]);
const $2fc412f4c8af7d4e$export$be047268481f07d8 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$d63578bef1057cae(commentId), (pendingComment)=>!!pendingComment);
const $2fc412f4c8af7d4e$export$72075ae8ef4d6f6a = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$d63578bef1057cae(commentId), (pendingComment)=>!!(pendingComment && pendingComment.hasSaveFailed));
const $2fc412f4c8af7d4e$export$c756ab72f25508bb = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$deleteModalCommentIdSelector, (deleteModalCommentId)=>deleteModalCommentId === commentId);
const $2fc412f4c8af7d4e$export$2cf9d22f626e5db0 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), $2fc412f4c8af7d4e$export$8f158a3cc48edde6(commentId), (comment, parent)=>{
        if ($2fc412f4c8af7d4e$var$isThreadedCommentsEnabled() && parent && !parent.isDeleted) return parent.visibility || (0, $f6MOn.COMMENT_VISIBILITY_PUBLIC);
        return comment ? comment.visibility : (0, $f6MOn.COMMENT_VISIBILITY_PUBLIC);
    });
const $2fc412f4c8af7d4e$var$commentIsInternalSelector = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment ? comment.isInternal : false);
const $2fc412f4c8af7d4e$export$82fbf902093fe491 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$3c2f8c0a34054ef7(commentId), $2fc412f4c8af7d4e$export$2cf9d22f626e5db0(commentId), (editingVisibility, visibility)=>editingVisibility || visibility);
const $2fc412f4c8af7d4e$export$d820e1c3ac105e35 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.eventOccurredAt || null);
const $2fc412f4c8af7d4e$export$9c8937d1bd8cf4a = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment && comment.eventOccurredAt ? comment.eventOccurredAt : null);
const $2fc412f4c8af7d4e$export$9b5c22d8443e21d6 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$d820e1c3ac105e35(commentId), $2fc412f4c8af7d4e$export$9c8937d1bd8cf4a(commentId), (editingEventOccurredAt, eventOccurredAt)=>editingEventOccurredAt || eventOccurredAt);
const $2fc412f4c8af7d4e$export$8c7be677b9a2cbf3 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment && typeof comment.jsdIncidentActivityViewHidden === 'boolean' ? comment.jsdIncidentActivityViewHidden : null);
const $2fc412f4c8af7d4e$export$b99aa78c1374f9fe = (commentId)=>(0, $df4Sl.createSelector)((0, $5JqpU.isServiceDeskSelector), $2fc412f4c8af7d4e$var$commentIsInternalSelector(commentId), (isServiceDeskComment, isInternal)=>isServiceDeskComment && isInternal);
const $2fc412f4c8af7d4e$export$54205c8c886a2b43 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiCommentEditorSelector(commentId), (commentEditor)=>commentEditor?.isInternal ?? true);
const $2fc412f4c8af7d4e$export$a34c155854eb296b = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), (permissions)=>permissions.canAddComments);
const $2fc412f4c8af7d4e$export$8cc876bb72dc09b7 = (commentId)=>(0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), $2fc412f4c8af7d4e$var$isUserCommentAuthorSelector(commentId), (permissions, isUserCommentAuthor)=>permissions.canDeleteAllComments || permissions.canDeleteOwnComments && isUserCommentAuthor);
const $2fc412f4c8af7d4e$export$eb110f3a00a8432 = (commentId)=>(0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), $2fc412f4c8af7d4e$var$isUserCommentAuthorSelector(commentId), (permissions, isUserCommentAuthor)=>permissions.canEditAllComments || permissions.canEditOwnComments && isUserCommentAuthor);
const $2fc412f4c8af7d4e$var$mapIdToCommentSortInfo = (comments)=>(id)=>{
        const comment = comments[id];
        return {
            id: id,
            createdDate: new Date(comment.createdDate),
            eventOccurredAt: comment.eventOccurredAt ? new Date(comment.eventOccurredAt) : null
        };
    };
const $2fc412f4c8af7d4e$var$compareComments = (a, b)=>{
    if (a.eventOccurredAt && b.eventOccurredAt && (0, $78IOp.default)(a.eventOccurredAt, b.eventOccurredAt) === 0) return (0, $78IOp.default)(a.createdDate, b.createdDate);
    const dateForA = a.eventOccurredAt ? a.eventOccurredAt : a.createdDate;
    const dateForB = b.eventOccurredAt ? b.eventOccurredAt : b.createdDate;
    return (0, $78IOp.default)(dateForA, dateForB);
};
const $2fc412f4c8af7d4e$var$visibleCommentIdsSelectorOld = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$f82d111da9150583, $2fc412f4c8af7d4e$export$9832028921909a8f, (comments, deletedIds)=>{
    // filter out any comments currently pending deletion
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>!deletedIds.includes(id));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map((id)=>({
            id: id,
            createdDate: new Date(comments[id].createdDate)
        })).sort((a, b)=>(0, $78IOp.default)(a.createdDate, b.createdDate)).map((comment)=>comment.id);
    return sortedIds;
});
const $2fc412f4c8af7d4e$var$visibleCommentIdsSelectorNew = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$f82d111da9150583, $2fc412f4c8af7d4e$export$9832028921909a8f, (comments, deletedIds)=>{
    // filter out any comments currently pending deletion
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>!deletedIds.includes(id));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map($2fc412f4c8af7d4e$var$mapIdToCommentSortInfo(comments)).sort($2fc412f4c8af7d4e$var$compareComments).map((comment)=>comment.id);
    return sortedIds;
});
const $2fc412f4c8af7d4e$export$3b3d01d442cb684a = (0, $8aR1q.selectorWithCondition)((0, $gIyTt.isJsmTimelineEnabled), $2fc412f4c8af7d4e$var$visibleCommentIdsSelectorNew, $2fc412f4c8af7d4e$var$visibleCommentIdsSelectorOld);
const $2fc412f4c8af7d4e$var$compareCommentsInclSortOrderType = (sortOrderType)=>(a, b)=>{
        if (a.eventOccurredAt && b.eventOccurredAt && (0, $78IOp.default)(a.eventOccurredAt, b.eventOccurredAt) === 0) return sortOrderType === (0, $25476979aca7c7e0$export$e86669f498228fff) ? (0, $78IOp.default)(a.createdDate, b.createdDate) : (0, $kirCf.default)(a.createdDate, b.createdDate);
        const dateForA = a.eventOccurredAt ? a.eventOccurredAt : a.createdDate;
        const dateForB = b.eventOccurredAt ? b.eventOccurredAt : b.createdDate;
        return sortOrderType === (0, $25476979aca7c7e0$export$e86669f498228fff) ? (0, $78IOp.default)(dateForA, dateForB) : (0, $kirCf.default)(dateForA, dateForB);
    };
const $2fc412f4c8af7d4e$var$isThreadedCommentsEnabled = ()=>{
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jira_threaded_comment_experiment');
    return expConfig.get('is_enabled', false);
};
const $2fc412f4c8af7d4e$var$sortedVisibleCommentIdsSelectorOld = (0, $df4Sl.createSelector)((0, $gzLYm.getSelectedActivitySortOrder), $2fc412f4c8af7d4e$export$f82d111da9150583, $2fc412f4c8af7d4e$export$9832028921909a8f, (sortOrderType, comments, deletedIds)=>{
    // filter out any comments currently pending deletion
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>(deletedIds.includes(id) && comments[id]?.isDeleted && $2fc412f4c8af7d4e$var$isThreadedCommentsEnabled() || !deletedIds.includes(id)) && ($2fc412f4c8af7d4e$var$isThreadedCommentsEnabled() ? !comments[id].parentId : true));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map((id)=>{
        const comment = comments[id];
        return {
            id: id,
            createdDate: new Date(comment.createdDate)
        };
    }).sort((a, b)=>sortOrderType === (0, $25476979aca7c7e0$export$e86669f498228fff) ? (0, $78IOp.default)(a.createdDate, b.createdDate) : (0, $kirCf.default)(a.createdDate, b.createdDate)).map((comment)=>comment.id);
    return sortedIds;
});
const $2fc412f4c8af7d4e$var$sortedVisibleCommentIdsSelectorNew = (0, $df4Sl.createSelector)((0, $gzLYm.getSelectedActivitySortOrder), $2fc412f4c8af7d4e$export$f82d111da9150583, $2fc412f4c8af7d4e$export$9832028921909a8f, (sortOrderType, comments, deletedIds)=>{
    // filter out any comments currently pending deletion and replies as well
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>(deletedIds.includes(id) && comments[id]?.isDeleted && $2fc412f4c8af7d4e$var$isThreadedCommentsEnabled() || !deletedIds.includes(id)) && ($2fc412f4c8af7d4e$var$isThreadedCommentsEnabled() ? !comments[id].parentId : true));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map($2fc412f4c8af7d4e$var$mapIdToCommentSortInfo(comments)).sort($2fc412f4c8af7d4e$var$compareCommentsInclSortOrderType(sortOrderType)).map((comment)=>comment.id);
    return sortedIds;
});
const $2fc412f4c8af7d4e$export$81c523e14f04df2d = (0, $8aR1q.selectorWithCondition)((0, $gIyTt.isJsmTimelineEnabled), $2fc412f4c8af7d4e$var$sortedVisibleCommentIdsSelectorNew, $2fc412f4c8af7d4e$var$sortedVisibleCommentIdsSelectorOld);
const $2fc412f4c8af7d4e$export$6eba3f548a7f384e = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$uiCommentEditorSelector(commentId), (commentEditor)=>!!commentEditor && commentEditor.isEditing);
const $2fc412f4c8af7d4e$export$3a00787e516c672c = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$3b3d01d442cb684a, (state)=>state, (visibleCommentIds, state)=>visibleCommentIds.filter((commentId)=>$2fc412f4c8af7d4e$export$6eba3f548a7f384e(commentId)(state)));
const $2fc412f4c8af7d4e$export$4c04cd370caea884 = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$2bcb958351592bb9, (comments)=>comments ? Object.keys(comments).filter((key)=>typeof comments[key] === 'object') : []);
const $2fc412f4c8af7d4e$export$2e24e984817b4c7b = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$4c04cd370caea884, (state)=>state, (commentIds, state)=>commentIds.some((id)=>$2fc412f4c8af7d4e$export$6eba3f548a7f384e(id)(state)));
const $2fc412f4c8af7d4e$export$5373a6bfd674797c = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.addCommentEditorExpand || false);
const $2fc412f4c8af7d4e$export$37aee7d1ec9d42d3 = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.addCommentEditorForceFocus || 0);
const $2fc412f4c8af7d4e$export$6df0ef2ac2b35c13 = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$5373a6bfd674797c, $2fc412f4c8af7d4e$var$uiAllCommentEditorsSelector, (isAddCommentEditorExpanded, commentEditors)=>isAddCommentEditorExpanded || (commentEditors ? (0, (/*@__PURE__*/$parcel$interopDefault($hvbu2)))(commentEditors).some((editor)=>editor.isEditing) : false));
const $2fc412f4c8af7d4e$export$f140c5c89826efc6 = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.isCommentAttachmentInProgress);
const $2fc412f4c8af7d4e$export$82d184f5a79c6a3d = (0, $df4Sl.createSelector)((0, $jZDJX.isSimplifiedProjectSelector), (0, $jZDJX.projectTypeSelector), (isSimplified, projectType)=>!isSimplified && (projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT)));
const $2fc412f4c8af7d4e$export$e17f2dbd8456d708 = (0, $df4Sl.createSelector)((0, $jZDJX.isSimplifiedProjectSelector), (0, $jZDJX.projectTypeSelector), (isSimplified, projectType)=>!isSimplified && (projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT) || projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)));
const $2fc412f4c8af7d4e$export$2ce513eb85289331 = (0, $8aR1q.selectorWithCondition)(()=>(0, $1ybV0.ff)('jsm-restrict-internal-comment-visibility'), $2fc412f4c8af7d4e$export$e17f2dbd8456d708, $2fc412f4c8af7d4e$export$82d184f5a79c6a3d);
const $2fc412f4c8af7d4e$var$replyingToCommentIdSelector = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.replyingToCommentId);
const $2fc412f4c8af7d4e$export$ab64c511f5921cdf = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$replyingToCommentIdSelector, (replyingToCommentId)=>replyingToCommentId === commentId);
const $2fc412f4c8af7d4e$export$d89d07d36d57d778 = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$replyingToCommentIdSelector, (replyingToCommentId)=>!!replyingToCommentId);
const $2fc412f4c8af7d4e$export$bb44f1aa6771eeb6 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$3e2634438f2a9b1a(`${(0, $b10b5cb385fb5d46$export$56251dcfec1ad08d)}-${commentId}`), (editingComment)=>editingComment || undefined);
const $2fc412f4c8af7d4e$var$replyingToAuthorIdSelector = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.comments.replyingToAuthorId);
const $2fc412f4c8af7d4e$export$6fe69cb268473af1 = (0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$replyingToAuthorIdSelector, (0, $jZDJX.getUserByIdSelector), (replyingToAuthorId, getUserById)=>getUserById(replyingToAuthorId));
const $2fc412f4c8af7d4e$export$9f25935861e23f9b = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$var$commentSelector(commentId), (comment)=>comment && comment.parentId);
const $2fc412f4c8af7d4e$export$8f158a3cc48edde6 = (commentId)=>(0, $df4Sl.createSelector)($2fc412f4c8af7d4e$export$f82d111da9150583, $2fc412f4c8af7d4e$export$9f25935861e23f9b(commentId), (comments, parentId)=>parentId ? comments[parentId] : undefined);

});
// Activity sort order
const $25476979aca7c7e0$export$eda5fe8da1abb04c = 'NEWEST_FIRST';
const $25476979aca7c7e0$export$e86669f498228fff = 'OLDEST_FIRST';

parcelRegister("f6MOn", function(module, exports) {

$parcel$export(module.exports, "SAVE_COMMENT_LOADING", () => $125592c68d6a8334$export$ea56f55e95ac48c4);
$parcel$export(module.exports, "LOADING", () => $125592c68d6a8334$export$26d55645375ca9a);
$parcel$export(module.exports, "COMPLETE", () => $125592c68d6a8334$export$1660a2d7c2fff354);
$parcel$export(module.exports, "COMMENT_VISIBILITY_PUBLIC", () => $125592c68d6a8334$export$5dd24cf16d0bbf18);

const $125592c68d6a8334$export$34e5759f24cbaeac = (value)=>value;
const $125592c68d6a8334$export$ea56f55e95ac48c4 = 'SAVE_COMMENT_LOADING';
const $125592c68d6a8334$export$26d55645375ca9a = 'LOADING';
const $125592c68d6a8334$export$1660a2d7c2fff354 = 'COMPLETE';
const $125592c68d6a8334$export$5dd24cf16d0bbf18 = {
    type: (0, $b9bd3ab49fd3c4c9$export$a3863626f98a38c2),
    value: ''
};

});
const $b9bd3ab49fd3c4c9$export$537a061b2f9c8800 = 'group';
const $b9bd3ab49fd3c4c9$export$28a8bb936dce2def = 'role';
const $b9bd3ab49fd3c4c9$export$a3863626f98a38c2 = 'public';


parcelRegister("8aR1q", function(module, exports) {

$parcel$export(module.exports, "selectorWithCondition", () => $af2d2bdf884c8cd1$export$6be2ebff06b95055);
const $af2d2bdf884c8cd1$export$6be2ebff06b95055 = (condition, selectorTrue, selectorFalse)=>{
    const selector = (...args)=>{
        if (condition()) return selectorTrue(...args);
        return selectorFalse(...args);
    };
    return selector;
};

});

parcelRegister("gIyTt", function(module, exports) {

$parcel$export(module.exports, "isJsmTimelineEnabled", () => $b83585f211a8f289$export$575e1bf822db15b5);

var $1ybV0 = parcelRequire("1ybV0");
const $b83585f211a8f289$export$575e1bf822db15b5 = ()=>(0, $1ybV0.ff)('jsm-timelines-phase-2_70gja', false);

});

parcelRegister("gzLYm", function(module, exports) {

$parcel$export(module.exports, "getSelectedActivityItem", () => $297516f6b6fa6295$export$49b8848afae8c381);
$parcel$export(module.exports, "getSelectedActivitySortOrder", () => $297516f6b6fa6295$export$7091381d8f3bc5cc);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $297516f6b6fa6295$var$getUiActivityFeed = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.activityFeed);
const $297516f6b6fa6295$export$49b8848afae8c381 = (0, $df4Sl.createSelector)($297516f6b6fa6295$var$getUiActivityFeed, (activityFeed)=>activityFeed.selectedActivityItem);
const $297516f6b6fa6295$export$7091381d8f3bc5cc = (0, $df4Sl.createSelector)($297516f6b6fa6295$var$getUiActivityFeed, (activityFeed)=>activityFeed.selectedActivitySortOrder);

});

const $b10b5cb385fb5d46$export$c4134c813c47beb0 = 'NEW_OPTIMISTIC_COMMENT';
const $b10b5cb385fb5d46$export$56251dcfec1ad08d = 'NEW_OPTIMISTIC_COMMENT_REPLY';


parcelRegister("cFY86", function(module, exports) {

$parcel$export(module.exports, "isIssueLinksEnabledSelector", () => $a8031e8c92164db2$export$a8cf8910b8314c1a);
$parcel$export(module.exports, "remoteIssuesSelector", () => $a8031e8c92164db2$export$13978ee723866c4d);
$parcel$export(module.exports, "optimisticLinksDataSelector", () => $a8031e8c92164db2$export$819781ef7e99d6c7);
$parcel$export(module.exports, "hasCombinedIssueLinksSelector", () => $a8031e8c92164db2$export$8b1b2dfb6701d22c);
$parcel$export(module.exports, "combinedLinkedIssueCountSelector", () => $a8031e8c92164db2$export$7e10bfdc67ac9362);
$parcel$export(module.exports, "combinedLinksSelector", () => $a8031e8c92164db2$export$a101eb6fc884a8a0);
$parcel$export(module.exports, "issueLinkSelector", () => $a8031e8c92164db2$export$b82f4900195f5854);
$parcel$export(module.exports, "linkedIssueSelector", () => $a8031e8c92164db2$export$f5f26ceb5c86ee0);
$parcel$export(module.exports, "quickAddClickedCountSelector", () => $a8031e8c92164db2$export$d545d81c8e208408);
$parcel$export(module.exports, "isOpenedFromJsmSimilarIssuesSelector", () => $a8031e8c92164db2$export$3bf48255064c85d5);
$parcel$export(module.exports, "quickAddClickedIssueSelector", () => $a8031e8c92164db2$export$2c43c6abed5983de);
$parcel$export(module.exports, "shouldDisplayAddLinksSelector", () => $a8031e8c92164db2$export$5757979a0baa9c47);
$parcel$export(module.exports, "canCreateLinkedIssueSelector", () => $a8031e8c92164db2$export$99914e520087b170);

var $df4Sl = parcelRequire("df4Sl");

var $8blac = parcelRequire("8blac");

var $3LiTJ = parcelRequire("3LiTJ");

var $3cdA4 = parcelRequire("3cdA4");

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");

var $03XEB = parcelRequire("03XEB");

var $jZDJX = parcelRequire("jZDJX");

var $9HtxD = parcelRequire("9HtxD");
/**
 * selectors for issue links
 *
 * issue links state looks like
 * issueLinks: {
 *  issueLinks: [
 *      link1,
 *      link2
 *  ],
 *  linkedIssueKeys: ['KEY-1', 'KEY-2'],
 *  linkedIssues: {
 *      'KEY-1': issue1,
 *      'KEY-2': issue2
 *  }
 * }
 */ const $a8031e8c92164db2$var$issueLinksRootSelector = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.issueLinks);
const $a8031e8c92164db2$export$a8cf8910b8314c1a = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (root)=>!!root);
const $a8031e8c92164db2$var$linksDataSelector = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.issueLinks);
const $a8031e8c92164db2$export$13978ee723866c4d = (state)=>state.entities.remoteIssueLinks.remoteIssues;
const $a8031e8c92164db2$export$819781ef7e99d6c7 = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$linksDataSelector, (issueLinks)=>issueLinks && (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))(issueLinks, (link)=>link.isOptimistic));
const $a8031e8c92164db2$var$linkedIssuesSelector = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.linkedIssues);
const $a8031e8c92164db2$export$701dc165268e44de = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>issueLinks?.linkedIssueKeys || []);
const $a8031e8c92164db2$export$3c65f67962ca81cc = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$linksDataSelector, (links)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(links));
const $a8031e8c92164db2$export$8b1b2dfb6701d22c = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$linksDataSelector, $a8031e8c92164db2$export$13978ee723866c4d, (links, remoteLinks)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(links) || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(remoteLinks));
const $a8031e8c92164db2$export$7e10bfdc67ac9362 = (0, $df4Sl.createSelector)($a8031e8c92164db2$export$701dc165268e44de, $a8031e8c92164db2$export$13978ee723866c4d, (links, remoteLinks)=>links.length + remoteLinks.length);
const $a8031e8c92164db2$export$f9c1778e36ca60f9 = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$linksDataSelector, $a8031e8c92164db2$var$linkedIssuesSelector, (0, $9HtxD.jpdDeliverLinkTypeIdSelector), (links, issues, jpdDeliverLinkTypeId)=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(links)) return (0, (/*@__PURE__*/$parcel$interopDefault($3cdA4)))(links).filter((link)=>!link.isDeleted && !!link.linkedIssueKey)// Filter out links with jpd delivery link typeId and direction === "OUTWARD" and they are displayed in separate Ideas section
    .filter($a8031e8c92164db2$var$removeOutwardImplementsIdeaLinks(jpdDeliverLinkTypeId, issues)).map((link)=>({
            ...link,
            linkedIssue: issues[link.linkedIssueKey]
        })) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((linksMap, link)=>Object.assign(linksMap, {
            [link.typeName]: [
                ...linksMap[link.typeName] || [],
                link
            ]
        }), {});
    return null;
});
function $a8031e8c92164db2$var$removeOutwardImplementsIdeaLinks(jpdDeliverLinkTypeId, issues) {
    return (link)=>{
        if ((0, $1ybV0.ff)('polaris.jpd-panel-filter-by-delivery-link-type') && jpdDeliverLinkTypeId) {
            const isImplementsLink = link.typeId === jpdDeliverLinkTypeId;
            const isOutwardLink = link.direction === (0, $03XEB.OUTWARD_LINK_DIRECTION);
            const isIdea = issues[link.linkedIssueKey]?.issueProjectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT);
            if (isIdea && isImplementsLink && isOutwardLink) return false;
        }
        return true;
    };
}
const $a8031e8c92164db2$export$a101eb6fc884a8a0 = (0, $df4Sl.createSelector)($a8031e8c92164db2$export$f9c1778e36ca60f9, $a8031e8c92164db2$export$13978ee723866c4d, (links, remoteIssues)=>{
    if (links == null && remoteIssues.length === 0) return null;
    const extractBasicIssueDetails = (remoteIssueLinkEntity)=>({
            id: remoteIssueLinkEntity.remoteIssueId,
            issueKey: remoteIssueLinkEntity.issueKey,
            issueLink: remoteIssueLinkEntity.issueLinkUrl,
            issueSummary: remoteIssueLinkEntity.summary,
            issueTypeIconUrl: remoteIssueLinkEntity.iconUrl
        });
    // FIXME: JIV-15410 - expected to return IssueLink[]
    return remoteIssues.reduce((combinedLinks, remoteIssue)=>{
        const { issueDetails: issueDetails, relationship: relationship, id: id, issueKey: issueKey, issueLinkUrl: issueLinkUrl, remoteIssueLinkError: remoteIssueLinkError, globalId: globalId, isSaved: isSaved, isLoading: isLoading, isOptimistic: isOptimistic, hasError: hasError, isDeleted: isDeleted } = remoteIssue;
        if (relationship != null && isDeleted !== true) return {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...combinedLinks,
            [relationship]: [
                ...combinedLinks[relationship] || [],
                {
                    id: id.toString(),
                    direction: (0, $03XEB.OUTWARD_LINK_DIRECTION),
                    typeName: relationship,
                    linkedIssueKey: issueKey,
                    linkedIssue: issueDetails || extractBasicIssueDetails(remoteIssue),
                    isRemote: true,
                    globalId: globalId,
                    remoteServerHostname: new URL(issueLinkUrl).hostname,
                    remoteIssueLinkError: remoteIssueLinkError,
                    isSaved: isSaved,
                    isLoading: isLoading,
                    isOptimistic: isOptimistic,
                    hasError: hasError
                }
            ]
        };
        return combinedLinks;
    }, {
        ...links
    });
});
const $a8031e8c92164db2$export$b82f4900195f5854 = (issueLinkId)=>(0, $df4Sl.createSelector)($a8031e8c92164db2$var$linksDataSelector, (links)=>links && links[issueLinkId] || null);
const $a8031e8c92164db2$export$f5f26ceb5c86ee0 = (issueKey)=>(0, $df4Sl.createSelector)($a8031e8c92164db2$var$linkedIssuesSelector, (linkedIssues)=>linkedIssues && linkedIssues[issueKey] || null);
const $a8031e8c92164db2$export$d545d81c8e208408 = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.quickAddClicked);
const $a8031e8c92164db2$export$3bf48255064c85d5 = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>!!issueLinks?.isOpenedFromJsmSimilarIssues);
const $a8031e8c92164db2$export$2c43c6abed5983de = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.quickAddClickedIssue);
const $a8031e8c92164db2$export$5757979a0baa9c47 = (0, $df4Sl.createSelector)($a8031e8c92164db2$export$d545d81c8e208408, (count)=>!!count);
const $a8031e8c92164db2$export$99914e520087b170 = (0, $df4Sl.createSelector)($a8031e8c92164db2$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.canCreateLinkedIssue);

});
parcelRegister("3cdA4", function(module, exports) {

var $bQoXG = parcelRequire("bQoXG");

var $b69Sx = parcelRequire("b69Sx");

var $fjnSB = parcelRequire("fjnSB");

var $jxg5X = parcelRequire("jxg5X");

var $4ZYEI = parcelRequire("4ZYEI");

var $hQ6NY = parcelRequire("hQ6NY");

var $c1eMI = parcelRequire("c1eMI");

var $bAWWz = parcelRequire("bAWWz");

var $aSldm = parcelRequire("aSldm");

var $hvbu2 = parcelRequire("hvbu2");
/** `Object#toString` result references. */ var $253d06f861bc4c67$var$mapTag = '[object Map]', $253d06f861bc4c67$var$setTag = '[object Set]';
/** Built-in value references. */ var $253d06f861bc4c67$var$symIterator = $bQoXG ? $bQoXG.iterator : undefined;
/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */ function $253d06f861bc4c67$var$toArray(value) {
    if (!value) return [];
    if ($jxg5X(value)) return $4ZYEI(value) ? $aSldm(value) : $b69Sx(value);
    if ($253d06f861bc4c67$var$symIterator && value[$253d06f861bc4c67$var$symIterator]) return $hQ6NY(value[$253d06f861bc4c67$var$symIterator]());
    var tag = $fjnSB(value), func = tag == $253d06f861bc4c67$var$mapTag ? $c1eMI : tag == $253d06f861bc4c67$var$setTag ? $bAWWz : $hvbu2;
    return func(value);
}
module.exports = $253d06f861bc4c67$var$toArray;

});
parcelRegister("hQ6NY", function(module, exports) {
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */ function $cfcc92505e25a5f1$var$iteratorToArray(iterator) {
    var data, result = [];
    while(!(data = iterator.next()).done)result.push(data.value);
    return result;
}
module.exports = $cfcc92505e25a5f1$var$iteratorToArray;

});


parcelRegister("03XEB", function(module, exports) {

$parcel$export(module.exports, "INWARD_LINK_DIRECTION", () => $dc38a98d5f20359c$export$b5e2b68b0fa7f1c8);
$parcel$export(module.exports, "OUTWARD_LINK_DIRECTION", () => $dc38a98d5f20359c$export$5dec99d71ec794ba);
$parcel$export(module.exports, "BOTH_LINK_DIRECTION", () => $dc38a98d5f20359c$export$6cdcf74878b11d34);
$parcel$export(module.exports, "IssueLinkDirectionTypes", () => $dc38a98d5f20359c$export$4b7bcc27238c61b9);
const $dc38a98d5f20359c$export$b5e2b68b0fa7f1c8 = 'INWARD';
const $dc38a98d5f20359c$export$5dec99d71ec794ba = 'OUTWARD';
const $dc38a98d5f20359c$export$6cdcf74878b11d34 = 'BOTH';
const $dc38a98d5f20359c$export$4b7bcc27238c61b9 = {
    [$dc38a98d5f20359c$export$b5e2b68b0fa7f1c8]: $dc38a98d5f20359c$export$b5e2b68b0fa7f1c8,
    [$dc38a98d5f20359c$export$5dec99d71ec794ba]: $dc38a98d5f20359c$export$5dec99d71ec794ba,
    [$dc38a98d5f20359c$export$6cdcf74878b11d34]: $dc38a98d5f20359c$export$6cdcf74878b11d34
};

});

parcelRegister("9HtxD", function(module, exports) {

$parcel$export(module.exports, "jpdDeliverLinkTypeIdSelector", () => $bfa856540e4e60df$export$c25a0be5d19458d3);

var $df4Sl = parcelRequire("df4Sl");

var $jZDJX = parcelRequire("jZDJX");
const $bfa856540e4e60df$export$c25a0be5d19458d3 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.jpdDeliveryIssueLinkTypeId);

});


parcelRegister("ke6cX", function(module, exports) {

$parcel$export(module.exports, "issueTypesSelector", () => $4a7e93d9a88b268c$export$f5378064bf877b95);
$parcel$export(module.exports, "hasUnsupportedType", () => $4a7e93d9a88b268c$export$1f59505fa2d77635);
$parcel$export(module.exports, "issueTypesForClassicProjectEpicSelector", () => $4a7e93d9a88b268c$export$a0efcb09d3e23dc1);
$parcel$export(module.exports, "fetchIssueTypesStatusSelector", () => $4a7e93d9a88b268c$export$bfbb65ccb13a16eb);

var $df4Sl = parcelRequire("df4Sl");

var $8blac = parcelRequire("8blac");

var $jZDJX = parcelRequire("jZDJX");

var $9D3Vo = parcelRequire("9D3Vo");
const $4a7e93d9a88b268c$export$f5378064bf877b95 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.issueTypes);
// A collection of issue fields which are marked as `required`
// for the creation of an issue, but are considered as 'provided' since
// the data for these fields is supplied by JIRA.
const $4a7e93d9a88b268c$var$providedRequiredFields = [
    'summary',
    'issuetype',
    'parent',
    'project'
];
const $4a7e93d9a88b268c$var$isRequiredFieldProvided = (fieldName)=>$4a7e93d9a88b268c$var$providedRequiredFields.find((providedFieldName)=>fieldName === providedFieldName);
// A field is considered 'unsupported' if not provided by JIRA,
// has no default value, and is a `required` field.
const $4a7e93d9a88b268c$var$hasUnsupportedRequiredField = (fields)=>// @ts-expect-error - TS2769 - No overload matches this call.
    !!Object.keys(fields).find((fieldName)=>!$4a7e93d9a88b268c$var$isRequiredFieldProvided(fieldName) && // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        !fields[fieldName].hasDefaultValue && // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        fields[fieldName].required);
const $4a7e93d9a88b268c$export$1f59505fa2d77635 = (issueType)=>(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(issueType.fields) || $4a7e93d9a88b268c$var$hasUnsupportedRequiredField(issueType.fields);
const $4a7e93d9a88b268c$export$a0efcb09d3e23dc1 = (0, $df4Sl.createSelector)($4a7e93d9a88b268c$export$f5378064bf877b95, (0, $9D3Vo.issueTypeSelector), (0, $jZDJX.isEpicSelector), (issueTypes, currentIssueType, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isCurrentIssueAnEpic)=>{
    const epicIssueTypeId = isCurrentIssueAnEpic && currentIssueType && currentIssueType.id;
    return issueTypes.filter(// @ts-expect-error - TS2367 - This condition will always return 'true' since the types 'number' and 'string | boolean | undefined' have no overlap.
    (issueType)=>!issueType.subtask && issueType.id !== epicIssueTypeId);
});
const $4a7e93d9a88b268c$export$bfbb65ccb13a16eb = (0, $df4Sl.createSelector)((0, $jZDJX.uiSelector), (ui)=>ui.fetchIssueTypesStatus);

});

parcelRegister("6Fp9G", function(module, exports) {

$parcel$export(module.exports, "subtaskTypesSelector", () => $d7237d4b8f5dc461$export$86a4f97fc27a0c44);
$parcel$export(module.exports, "isSubtaskTypesPresentSelector", () => $d7237d4b8f5dc461$export$9a147dcac364dd81);
$parcel$export(module.exports, "hasUnsupportedTypeSelector", () => $d7237d4b8f5dc461$export$3fbfbdcf57f34c2);

var $df4Sl = parcelRequire("df4Sl");

var $ke6cX = parcelRequire("ke6cX");
const $d7237d4b8f5dc461$export$86a4f97fc27a0c44 = (0, $df4Sl.createSelector)((0, $ke6cX.issueTypesSelector), (issueTypes)=>issueTypes.filter((type)=>type.subtask));
const $d7237d4b8f5dc461$export$9a147dcac364dd81 = (0, $df4Sl.createSelector)($d7237d4b8f5dc461$export$86a4f97fc27a0c44, (subtaskTypes)=>subtaskTypes.length >= 1);
const $d7237d4b8f5dc461$export$3fbfbdcf57f34c2 = (0, $df4Sl.createSelector)($d7237d4b8f5dc461$export$86a4f97fc27a0c44, (subtaskTypes)=>!!subtaskTypes.find((0, $ke6cX.hasUnsupportedType)));

});

parcelRegister("dv9do", function(module, exports) {

$parcel$export(module.exports, "isSubtaskSelector", () => $ebb19174331d951e$export$15fea4741156936);
$parcel$export(module.exports, "subtaskEntitiesSelector", () => $ebb19174331d951e$export$17e529874841c746);
$parcel$export(module.exports, "hasSubtasksSelector", () => $ebb19174331d951e$export$f363078714850fd9);
$parcel$export(module.exports, "canCreateSubtaskSelector", () => $ebb19174331d951e$export$151aaebeef1cfe63);

var $df4Sl = parcelRequire("df4Sl");


var $f9RL0 = parcelRequire("f9RL0");

var $5JqpU = parcelRequire("5JqpU");

var $fokFV = parcelRequire("fokFV");

var $jZDJX = parcelRequire("jZDJX");

var $9F6MO = parcelRequire("9F6MO");

var $eeyEP = parcelRequire("eeyEP");

var $1b2Vj = parcelRequire("1b2Vj");

var $9D3Vo = parcelRequire("9D3Vo");

var $kndnY = parcelRequire("kndnY");

var $6Fp9G = parcelRequire("6Fp9G");
const $ebb19174331d951e$export$15fea4741156936 = (0, $df4Sl.createSelector)((0, $9D3Vo.issueTypeSelector), (issueType)=>!!(issueType && issueType.subtask));
const $ebb19174331d951e$export$17e529874841c746 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), (entities)=>entities.subtasks);
const $ebb19174331d951e$export$f363078714850fd9 = (0, $df4Sl.createSelector)($ebb19174331d951e$export$17e529874841c746, (0, $fokFV.childIssuesLimitUrlSelector), (subtasks, getChildIssuesLimitUrl)=>subtasks.length > 0 || Boolean(getChildIssuesLimitUrl((0, $f9RL0.SUBTASKS))));
const $ebb19174331d951e$export$899afcd59181acbb = (0, $df4Sl.createSelector)((0, $jZDJX.isSimplifiedProjectSelector), (0, $1b2Vj.isIssueBaseLevel), (0, $eeyEP.hasChildrenIssuesSelector), $ebb19174331d951e$export$f363078714850fd9, (isSimplifiedProject, issueBaseLevel, hasChildrenIssues, hasSubtasks)=>isSimplifiedProject ? issueBaseLevel && hasChildrenIssues : hasSubtasks);
const $ebb19174331d951e$export$58b46fbc7ab224f6 = (0, $df4Sl.createSelector)((0, $6Fp9G.hasUnsupportedTypeSelector), (0, $kndnY.projectHasSubtaskValidatorsSelector), (hasRequiredFields, hasSubtaskValidators)=>hasRequiredFields || hasSubtaskValidators);
const $ebb19174331d951e$export$94f22e5d109e9b04 = (0, $df4Sl.createSelector)((0, $jZDJX.entitiesSelector), ({ jiraSettings: jiraSettings })=>jiraSettings.subtasksConfiguration.enabled);
const $ebb19174331d951e$export$151aaebeef1cfe63 = (0, $df4Sl.createSelector)((0, $9F6MO.permissionsSelector), $ebb19174331d951e$export$15fea4741156936, (0, $6Fp9G.isSubtaskTypesPresentSelector), $ebb19174331d951e$export$58b46fbc7ab224f6, (0, $5JqpU.isMobileSelector), (0, $5JqpU.isBitbucketSelector), (0, $5JqpU.isServiceDeskSelector), (0, $jZDJX.isSimplifiedProjectSelector), $ebb19174331d951e$export$94f22e5d109e9b04, (0, $jZDJX.projectSelector), ({ canCreateSubtask: canCreateSubtask }, isSubtask, typesPresent, shouldUseFallbackDialog, isMobile, isBitbucket, isServicedesk, isSimplified, subtasksEnabled, project)=>{
    const shouldHideForMobileOrBitbucket = shouldUseFallbackDialog ? isMobile || isBitbucket : false;
    const isProjectActive = (project?.projectStatus ?? (0, $5bd9e96e4d7e8aee$export$62113557945f790a)) === (0, $5bd9e96e4d7e8aee$export$62113557945f790a);
    const shouldShowSubtask = isServicedesk ? !isSimplified : true;
    return !!(canCreateSubtask && !isSubtask && typesPresent && !shouldHideForMobileOrBitbucket && shouldShowSubtask && subtasksEnabled && isProjectActive);
});

});
parcelRegister("eeyEP", function(module, exports) {

$parcel$export(module.exports, "hasChildrenIssuesSelector", () => $2579e5337c5b7c8d$export$29f34d4d7c528e9c);

var $df4Sl = parcelRequire("df4Sl");

var $8blac = parcelRequire("8blac");

var $lO4Or = parcelRequire("lO4Or");

var $fokFV = parcelRequire("fokFV");
const $2579e5337c5b7c8d$var$childrenIssueSelector = (0, $fokFV.fieldSelector)((0, $lO4Or.CHILDREN_ISSUES));
const $2579e5337c5b7c8d$export$29f34d4d7c528e9c = (0, $df4Sl.createSelector)($2579e5337c5b7c8d$var$childrenIssueSelector, (0, $fokFV.childIssuesLimitUrlSelector), (childrenIssues, getChildIssuesLimitUrl)=>childrenIssues ? !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(childrenIssues.value) || Boolean(getChildIssuesLimitUrl((0, $lO4Or.CHILDREN_ISSUES))) : false);

});

parcelRegister("kndnY", function(module, exports) {

$parcel$export(module.exports, "projectHasSubtaskValidatorsSelector", () => $d92659ac5d07e0a6$export$ecfed315b19a7565);

var $df4Sl = parcelRequire("df4Sl");

const $d92659ac5d07e0a6$var$hasSubtaskValidators = (hasValidators)=>hasValidators.status === (0, $97086cfe7b0ec751$export$4c02edeb1b5e410a) && hasValidators.value;
const $d92659ac5d07e0a6$var$unknown = (hasValidators)=>hasValidators.status === (0, $97086cfe7b0ec751$export$26d55645375ca9a) || hasValidators.status === (0, $97086cfe7b0ec751$export$d71930f7f5807a72);
const $d92659ac5d07e0a6$export$ecfed315b19a7565 = (0, $df4Sl.createSelector)(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
(state)=>state.validators, (validators)=>{
    const val = validators.projectHasSubtaskValidators;
    return $d92659ac5d07e0a6$var$hasSubtaskValidators(val) || $d92659ac5d07e0a6$var$unknown(val);
});

});
const $97086cfe7b0ec751$export$26d55645375ca9a = 'LOADING';
const $97086cfe7b0ec751$export$d71930f7f5807a72 = 'FAILED';
const $97086cfe7b0ec751$export$4c02edeb1b5e410a = 'LOADED';



parcelRegister("9s86T", function(module, exports) {

$parcel$export(module.exports, "getPermalinkTypeAndId", () => $6e310a2be6a89df8$export$f72cac1fa8a03e80);
$parcel$export(module.exports, "getPermalinkStatus", () => $6e310a2be6a89df8$export$f79ae8c396759c89);
$parcel$export(module.exports, "getUrlPermalinkParameter", () => $6e310a2be6a89df8$export$b66f3e03c722c21c);

var $5iWql = parcelRequire("5iWql");

var $53ciZ = parcelRequire("53ciZ");

var $6VKiL = parcelRequire("6VKiL");
const $6e310a2be6a89df8$export$58d3deae755361f = (0, $5iWql.default)((searchString)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parseUrl(searchString).query;
    if (params[(0, $6VKiL.PermalinkType).COMMENTS]) return {
        permalinkType: (0, $6VKiL.COMMENTS),
        permalinkId: params[(0, $6VKiL.PermalinkType).COMMENTS]
    };
    if (params[(0, $6VKiL.PermalinkType).WORKLOG]) return {
        permalinkType: (0, $6VKiL.WORKLOG),
        permalinkId: params[(0, $6VKiL.PermalinkType).WORKLOG]
    };
    return null;
});
const $6e310a2be6a89df8$export$f72cac1fa8a03e80 = ()=>$6e310a2be6a89df8$export$58d3deae755361f(window.location.search);
const $6e310a2be6a89df8$export$f79ae8c396759c89 = (targetPermalinkType)=>{
    const { permalinkId: permalinkId, permalinkType: permalinkType } = $6e310a2be6a89df8$export$f72cac1fa8a03e80() || {};
    const hasPermalink = permalinkType === targetPermalinkType && permalinkId != null;
    return {
        hasPermalink: hasPermalink,
        permalinkId: hasPermalink ? permalinkId : ''
    };
};
const $6e310a2be6a89df8$export$b66f3e03c722c21c = (id, permalinkType)=>{
    const pathName = window.location.pathname;
    let urlQueryParam = `?${permalinkType}=${id}`;
    // in backlogs/modal view, next-gen board view, or jsd queues view
    if (/\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/.test(pathName) || /\/jira\/people\/.*\/boards\/.*/.test(pathName) || pathName === '/secure/RapidBoard.jspa' || pathName.startsWith('/jira/software/projects/') && pathName.split('/')[5] === 'boards' || pathName.startsWith('/jira/servicedesk/projects/') && pathName.split('/')[5] === 'queues') {
        const url = new URL(window.location.href);
        // delete the opposite to avoid doubling up param in url
        url.searchParams.delete(permalinkType === (0, $6VKiL.PermalinkType).WORKLOG ? (0, $6VKiL.PermalinkType).COMMENTS : (0, $6VKiL.PermalinkType).WORKLOG);
        url.searchParams.set(permalinkType, id);
        urlQueryParam = url.search;
    }
    return urlQueryParam;
};

});
parcelRegister("6VKiL", function(module, exports) {

$parcel$export(module.exports, "COMMENTS", () => $5c63d4511ab79db4$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $5c63d4511ab79db4$export$df36fc05622c402);
$parcel$export(module.exports, "PermalinkType", () => $5c63d4511ab79db4$export$b18d061fc042df1a);
const $5c63d4511ab79db4$export$4cab9dfa8fc858f4 = 'Comments';
const $5c63d4511ab79db4$export$df36fc05622c402 = 'Worklog';
const $5c63d4511ab79db4$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};

});



parcelRegister("gU59E", function(module, exports) {

$parcel$export(module.exports, "default", () => $f78fb3da3b537c5c$export$2e2bcd8739ae039);
class $f78fb3da3b537c5c$export$2e2bcd8739ae039 {
    constructor(state){
        this.hasLoadedEditor = false;
        this.startTime = Math.floor(performance.now()) // start time in origin relative  millis
        ;
        this.immutableState = state;
        this.isLoadedWithPage = state.isLoadedWithPage;
    }
    lazyMetricsProps() {
        return this.immutableState.lazyMetricsProps;
    }
    getDataProvider() {
        return this.immutableState.dataProvider;
    }
    getIsFullIssue() {
        return this.immutableState.analyticsSource === 'full-issue';
    }
    getIsLoadedWithPage() {
        return this.immutableState.isLoadedWithPage;
    }
    setIsLoadedWithPage(newValue) {
        this.isLoadedWithPage = newValue;
    }
    getIsSPA() {
        return this.immutableState.isSPA;
    }
    getIsRecentIssue() {
        return this.immutableState.isRecentIssue;
    }
    getRecentIssuesCount() {
        return this.immutableState.recentIssuesCount;
    }
    getAnalyticsSource() {
        return this.immutableState.analyticsSource;
    }
    getCorrelationId() {
        return this.immutableState.correlationId;
    }
    getIssueScaleabilityReporter() {
        return this.immutableState.issueScaleabilityReporter;
    }
    getStartTime() {
        return this.startTime;
    }
    setPreviewEnd(end) {
        this.previewEnd = end === null ? 0 : Math.floor(end);
    }
    getPreviewEnd() {
        return this.previewEnd;
    }
    setFMP(end) {
        this.fmp = end === null ? 0 : Math.floor(end);
    }
    getFMP() {
        return this.fmp;
    }
    setInteractiveEnd(millisSinceEpoch) {
        this.interactiveEnd = millisSinceEpoch;
    }
    getInteractiveEnd() {
        return this.interactiveEnd;
    }
    setTrueInteractiveEnd(millisSinceEpoch) {
        this.trueInteractiveEnd = Math.floor(millisSinceEpoch);
    }
    getTrueInteractiveEnd() {
        return Math.floor(this.trueInteractiveEnd);
    }
    getHasLoadedEditor() {
        return this.hasLoadedEditor;
    }
    getIsInitial() {
        return this.getIsFullIssue() && !this.getIsSPA();
    }
    getLocation() {
        const { route: route } = this.immutableState;
        const routeName = route?.name;
        return routeName || '';
    }
}

});

parcelRegister("7YIVI", function(module, exports) {

$parcel$export(module.exports, "metricsStateSelector", () => $fe3be24289bfe219$export$8cfb2e5f509cb762);

var $df4Sl = parcelRequire("df4Sl");

var $01hTQ = parcelRequire("01hTQ");

var $5JqpU = parcelRequire("5JqpU");
const $fe3be24289bfe219$export$8cfb2e5f509cb762 = (0, $df4Sl.createSelector)((0, $5JqpU.applicationKeySelector), (0, $5JqpU.viewModeSelector), (0, $5JqpU.issueIdSelector), (analyticsKey, viewMode, issueId)=>({
        analyticsKey: analyticsKey,
        viewMode: (0, $01hTQ.getSafeViewMode)(viewMode),
        issueId: issueId
    }));

});
parcelRegister("01hTQ", function(module, exports) {

$parcel$export(module.exports, "getSafeViewMode", () => $36ca2814f036e464$export$abc152b4d639d329);
const $36ca2814f036e464$var$getViewMode = ()=>window.localStorage && window.localStorage.getItem('gh.ghx-issue-fragment-view-mode') || 'default';
const $36ca2814f036e464$var$mapPredefinedViewMode = (predefinedViewMode)=>{
    switch(predefinedViewMode){
        case 'MODAL':
            return 'modal';
        case 'SIDEBAR':
            return 'sidebar';
        default:
            return null;
    }
};
const $36ca2814f036e464$export$abc152b4d639d329 = (predefinedViewMode = null)=>$36ca2814f036e464$var$mapPredefinedViewMode(predefinedViewMode) || $36ca2814f036e464$var$getViewMode().replace(/"/g, '');

});



parcelRegister("asM86", function(module, exports) {

$parcel$export(module.exports, "default", () => $80b3f33d2d36e8da$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $hFmdR = parcelRequire("hFmdR");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $gJYxu = parcelRequire("gJYxu");

var $9mxRp = parcelRequire("9mxRp");

var $bsdZ2 = parcelRequire("bsdZ2");

var $bFzGY = parcelRequire("bFzGY");

var $iVSJI = parcelRequire("iVSJI");

var $6HEK3 = parcelRequire("6HEK3");

var $6WAxo = parcelRequire("6WAxo");

var $6vrw7 = parcelRequire("6vrw7");

var $90ZS3 = parcelRequire("90ZS3");

var $lB25E = parcelRequire("lB25E");
const $80b3f33d2d36e8da$var$isEcClientEnabled = ()=>{
    const experiences = (0, $1ybV0.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-issue-view');
};

const $80b3f33d2d36e8da$export$8c70dcc4643464f8 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("kT5hT")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $80b3f33d2d36e8da$export$5aebed4b5cba826a = ({ backButtonUrl: backButtonUrl, issueNavigatorData: issueNavigatorData, issueKey: issueKey, onDispatchExternalActionRef: onDispatchExternalActionRef, onIssueDeleteSuccess: onIssueDeleteSuccess, analyticsSource: analyticsSource, ServiceDeskAnalyticsContext: ServiceDeskAnalyticsContext = (0, $iVSJI.ServiceDeskAnalyticsContext) })=>{
    const routerActions = (0, $lB25E.useRouterActions)();
    const [selectedIssueKey, setIssueKey] = (0, $90ZS3.useQueryParam)('selectedIssue');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let saveIssueMutationToCache;
    if ($80b3f33d2d36e8da$var$isEcClientEnabled()) // eslint-disable-next-line react-hooks/rules-of-hooks
    saveIssueMutationToCache = (0, $bsdZ2.useEcClient)().saveIssueMutationToCache;
    const onIssueKeyChange = (data)=>{
        setIssueKey(data.toIssueKey);
        if ((0, $1ybV0.ff)('jsm-redirecting-issue-to-browse-url-when-old-key-is-invalid')) {
            (0, $gUUjF.default).safeInfoWithoutCustomerData('jsm.issue.view.issue-key-change', 'Invalid issue key, redirecting to correct issue key');
            routerActions.push(`/browse/${data.toIssueKey}`);
        }
    };
    const onChangeHandler = (event)=>{
        (0, $6HEK3.saveIssueMutationAnalyticsToCache)(event, createAnalyticsEvent, saveIssueMutationToCache);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6WAxo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ServiceDeskAnalyticsContext, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJYxu.IssueBoundary), {
        packageName: "servicedesk-issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80b3f33d2d36e8da$export$8c70dcc4643464f8, {
        onClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        analyticsSource: analyticsSource,
        backButtonUrl: backButtonUrl,
        dispatchExternalActionRef: onDispatchExternalActionRef,
        shouldSetInitialFocus: true,
        isLoadedWithPage: true,
        issueKey: (0, $6vrw7.toIssueKey)(selectedIssueKey) || issueKey,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        onIssueKeyChange: onIssueKeyChange,
        issueMaxWidth: (0, $9mxRp.getIssueContainerMaxWidth)(),
        onChange: onChangeHandler,
        issueNavigatorData: issueNavigatorData
    }))));
};
const $80b3f33d2d36e8da$var$getAnalyticsSourceFromUrl = ()=>{
    const { pathname: pathname } = window.location;
    if (pathname.includes('reports')) return 'viewReportIssue';
    return 'viewQueueIssue';
};
const $80b3f33d2d36e8da$var$WrappedIssueView = (0, $hFmdR.AnalyticsSource)($80b3f33d2d36e8da$var$getAnalyticsSourceFromUrl(), (0, $41ea3621645e2acc$export$f636b5b56f1d624a))($80b3f33d2d36e8da$export$5aebed4b5cba826a);
const $80b3f33d2d36e8da$var$IssueViewContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80b3f33d2d36e8da$var$WrappedIssueView, props);
var $80b3f33d2d36e8da$export$2e2bcd8739ae039 = $80b3f33d2d36e8da$var$IssueViewContainer;

});
parcelRegister("9mxRp", function(module, exports) {

$parcel$export(module.exports, "HEADER_BREADCRUMBS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$eb0ef5297b0cdc23);
$parcel$export(module.exports, "HEADER_BREADCRUMBS_END_MARK_KEY", () => $3849cfed910e9285$export$9c0a7052eb43d49c);
$parcel$export(module.exports, "HEADER_ACTIONS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$ff64d9f93169b1f0);
$parcel$export(module.exports, "HEADER_ACTIONS_END_MARK_KEY", () => $3849cfed910e9285$export$e696e07345d019c7);
$parcel$export(module.exports, "ISSUE_NAME_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$39f2c7a88d6952c7);
$parcel$export(module.exports, "ISSUE_NAME_END_MARK_KEY", () => $3849cfed910e9285$export$6b38db117e6a59c3);
$parcel$export(module.exports, "QUICK_ADD_ITEMS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$e4ec603cd2ae64c3);
$parcel$export(module.exports, "QUICK_ADD_ITEMS_END_MARK_KEY", () => $3849cfed910e9285$export$485e8138df2fade3);
$parcel$export(module.exports, "CONTENT_ITEMS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$37c39403f63dfe50);
$parcel$export(module.exports, "CONTENT_ITEMS_END_MARK_KEY", () => $3849cfed910e9285$export$bcac34901554ce05);
$parcel$export(module.exports, "ACTIVITY_FEED_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$cfd354167a2170f3);
$parcel$export(module.exports, "ACTIVITY_FEED_END_MARK_KEY", () => $3849cfed910e9285$export$e20857c483438d46);
$parcel$export(module.exports, "FOOTNOTE_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$2f7e8d259a68175d);
$parcel$export(module.exports, "FOOTNOTE_END_MARK_KEY", () => $3849cfed910e9285$export$8c4857e697bb9a6b);
$parcel$export(module.exports, "ISSUE_STATUS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$6669013ba0004c0);
$parcel$export(module.exports, "ISSUE_STATUS_END_MARK_KEY", () => $3849cfed910e9285$export$ff2ebe781d7bd44e);
$parcel$export(module.exports, "defaultRatioRightColumn", () => $3849cfed910e9285$export$7fec582ac43ca9da);
$parcel$export(module.exports, "getIssueContainerMaxWidth", () => $3849cfed910e9285$export$c76181843186885);
const $3849cfed910e9285$export$eb0ef5297b0cdc23 = 'HEADER_BREADCRUMBS_BEGIN_MARK';
const $3849cfed910e9285$export$9c0a7052eb43d49c = 'HEADER_BREADCRUMBS_END_MARK';
const $3849cfed910e9285$export$ff64d9f93169b1f0 = 'HEADER_ACTIONS_BEGIN_MARK';
const $3849cfed910e9285$export$e696e07345d019c7 = 'HEADER_ACTIONS_END_MARK';
const $3849cfed910e9285$export$39f2c7a88d6952c7 = 'ISSUE_NAME_BEGIN_MARK';
const $3849cfed910e9285$export$6b38db117e6a59c3 = 'ISSUE_NAME_END_MARK';
const $3849cfed910e9285$export$e4ec603cd2ae64c3 = 'QUICK_ADD_ITEMS_BEGIN_MARK';
const $3849cfed910e9285$export$485e8138df2fade3 = 'QUICK_ADD_ITEMS_END_MARK';
const $3849cfed910e9285$export$37c39403f63dfe50 = 'CONTENT_ITEMS_BEGIN_MARK';
const $3849cfed910e9285$export$bcac34901554ce05 = 'CONTENT_ITEMS_END_MARK';
const $3849cfed910e9285$export$cfd354167a2170f3 = 'ACTIVITY_FEED_BEGIN_MARK';
const $3849cfed910e9285$export$e20857c483438d46 = 'ACTIVITY_FEED_END_MARK';
const $3849cfed910e9285$export$2f7e8d259a68175d = 'FOOTNOTE_BEGIN_MARK';
const $3849cfed910e9285$export$8c4857e697bb9a6b = 'FOOTNOTE_END_MARK';
const $3849cfed910e9285$export$6669013ba0004c0 = 'ISSUE_STATUS_BEGIN_MARK';
const $3849cfed910e9285$export$ff2ebe781d7bd44e = 'ISSUE_STATUS_END_MARK';
const $3849cfed910e9285$export$7fec582ac43ca9da = 0.35;
const $3849cfed910e9285$export$c76181843186885 = ()=>1680;

});

parcelRegister("6WAxo", function(module, exports) {

$parcel$export(module.exports, "default", () => $97cff08cca774849$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1rx5k = parcelRequire("1rx5k");
const $97cff08cca774849$export$e809a659e11e6855 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1rx5k.FullPageIssueContainer), null, props.children);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$97cff08cca774849$export$2e2bcd8739ae039 = ({ ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($97cff08cca774849$export$e809a659e11e6855, rest);

});
parcelRegister("1rx5k", function(module, exports) {

$parcel$export(module.exports, "FullPageIssueContainer", () => $e6a16efa52554d80$export$f4550b4a355415eb);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $e6a16efa52554d80$export$f4550b4a355415eb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("90ZS3", function(module, exports) {

$parcel$export(module.exports, "useQueryParam", () => $531b22dea21c6f31$export$ae316f0eeb712a36);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $i7Fym = parcelRequire("i7Fym");

var $53ciZ = parcelRequire("53ciZ");

var $lB25E = parcelRequire("lB25E");
const $531b22dea21c6f31$export$ae316f0eeb712a36 = (queryParam)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push }] = (0, $lB25E.useRouter)();
    const queryParamValue = query[queryParam];
    const setQueryParam = (0, $eUqFw.useCallback)((newValue)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
            ...query,
            [queryParam]: newValue
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value));
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(parsedSearch);
        push(pathname + (strSearch !== '' ? `?${strSearch}` : ''));
    }, [
        pathname,
        push,
        query,
        queryParam
    ]);
    return [
        queryParamValue,
        setQueryParam
    ];
};

});



parcelRegister("fJAmy", function(module, exports) {

$parcel$export(module.exports, "Page", () => $2526d70ca07ebb02$export$6955bcca4cd3539f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $foc4i = parcelRequire("foc4i");

var $guiFP = parcelRequire("guiFP");

var $5zSUY = parcelRequire("5zSUY");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $hqj5v = parcelRequire("hqj5v");

var $5yh8X = parcelRequire("5yh8X");

var $7F257 = parcelRequire("7F257");

var $bibmI = parcelRequire("bibmI");

var $8A37l = parcelRequire("8A37l");

var $3GAHU = parcelRequire("3GAHU");

var $9ihe5 = parcelRequire("9ihe5");

var $kyfix = parcelRequire("kyfix");

var $77u8i = parcelRequire("77u8i");

var $54i0g = parcelRequire("54i0g");

var $7Rqgg = parcelRequire("7Rqgg");

var $51Ia6 = parcelRequire("51Ia6");

var $78d1w = parcelRequire("78d1w");

var $bpOk7 = parcelRequire("bpOk7");

var $2a1Mo = parcelRequire("2a1Mo");

var $jNZWQ = parcelRequire("jNZWQ");
const $2526d70ca07ebb02$var$getResources = (locale)=>[
        ...(0, $kyfix.getMomentResources)(locale),
        (0, $9ihe5.getCalendarResources)(locale)
    ];
const $2526d70ca07ebb02$export$6955bcca4cd3539f = (props)=>{
    const { onNavigation: onNavigation, entity: entity, issueKey: issueKey, locale: locale, wrmDataForPage: wrmDataForPage, pathname: pathname } = props;
    const outerElement = (0, $eUqFw.useRef)(null);
    const [{ data: pageContext }] = (0, $51Ia6.usePageContext)();
    const { projectContext: projectContext } = pageContext || {};
    const { projectKey: projectKey } = projectContext || {};
    const metricKey = typeof entity === 'string' ? 'servicedesk.queues.issue' : 'servicedesk.reports.custom.issue';
    const metric = typeof entity === 'string' ? (0, $jNZWQ.JSMIssueViewLoad) : (0, $jNZWQ.JSMReportsIssueViewLoad);
    (0, $eUqFw.useEffect)(()=>{
        (0, $8A37l.addLinkInterceptor)(outerElement.current, onNavigation);
        // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        (0, $3GAHU.addNavigationListener)(projectKey, outerElement.current, onNavigation, false);
        (0, $77u8i.addMetaTags)({
            'atlassian-token': (0, $5zSUY.default)()
        }, {
            shouldIncludeAjsPrefix: false
        });
    }, [
        onNavigation,
        projectKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7F257.AttachmentDropzoneContainer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bibmI.LegacyIssueShortcuts), {
        ref: outerElement
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2526d70ca07ebb02$var$LegacyStyles, {
        ref: outerElement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bpOk7.default), {
        wrmData: wrmDataForPage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78d1w.default), null, ({ isInitialRender: isInitialRender })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2a1Mo.WRMModuleLoader), {
            modules: $2526d70ca07ebb02$var$getResources(locale)
        }, ({ loading: loading, error: error })=>{
            if (error) {
                // If the WRM fails to load here something has gone horribly wrong
                // In this case we want to throw to the JS error boundary to catch and log the error
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'ServiceDeskLegacyIssuePage',
                        packageName: 'jiraServicedeskLegacyBridges'
                    }
                });
                throw error;
            }
            if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null);
            return(// @ts-expect-error - TS2769 - No overload matches this call.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqj5v.default), {
                metricKey: metricKey,
                withMarks: [
                    (0, $5yh8X.appBundleReadyMark)
                ],
                isExpectedToHaveSsr: false,
                metric: metric
            }, ({ submit: submit })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
                    sourceName: "serviceDeskLegacyIssuePage",
                    sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
                    attributes: {
                        pageKey: metricKey
                    }
                }, !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), typeof entity === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $54i0g.default), {
                    queueId: entity,
                    issueKey: issueKey,
                    onSubmitApdex: submit,
                    isInitialRender: isInitialRender,
                    pathname: pathname
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Rqgg.default), {
                    report: entity,
                    issueKey: issueKey,
                    onSubmitApdex: submit,
                    isInitialRender: isInitialRender,
                    pathname: pathname
                }))));
        }))));
};
var $2526d70ca07ebb02$export$2e2bcd8739ae039 = $2526d70ca07ebb02$export$6955bcca4cd3539f;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2526d70ca07ebb02$var$LegacyStyles = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4gktf _colwidpf _vbyaglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hqj5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd515edca209afee$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0S0fK = parcelRequire("0S0fK");

var $7vf5z = parcelRequire("7vf5z");
// eslint-disable-next-line jira/react/no-class-components
class $dd515edca209afee$var$ApdexActions extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = (0, $7vf5z.baseDefaultProps);
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, children: children, metric: metric } = this.props;
        (0, $7vf5z.checkAndEmitApdexSignal)(appName, metricKey);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0S0fK.default).Consumer, null, ({ onReady: onReady })=>children({
                submit: ()=>onReady(metricKey || `jira.fe.spa.initial-render.${String(appName)}`, metricKey || `jira.fe.spa.transition.${String(appName)}`, extra, metric)
            }));
    }
}
var $dd515edca209afee$export$2e2bcd8739ae039 = $dd515edca209afee$var$ApdexActions;

});

parcelRegister("7F257", function(module, exports) {

$parcel$export(module.exports, "AttachmentDropzoneContainer", () => $4dbfcfbfca18ea70$export$91f929d3b164c89f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $4dbfcfbfca18ea70$export$91f929d3b164c89f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4dbfcfbfca18ea70$var$Container, {
        id: "attachment-dropzone-mask-container"
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4dbfcfbfca18ea70$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bibmI", function(module, exports) {

$parcel$export(module.exports, "LegacyIssueShortcuts", () => $e5d7be7830086b17$export$db79c283a92e239b);
/* global JIRA */ 
var $eUqFw = parcelRequire("eUqFw");

var $9aFSa = parcelRequire("9aFSa");
const $e5d7be7830086b17$export$db79c283a92e239b = /*#__PURE__*/ (0, $eUqFw.forwardRef)((_, ref)=>{
    // Provides a callback to click on the element found via
    // the given query selector.
    const clickElementCallback = (querySelector)=>()=>{
            const element = ref && 'current' in ref ? ref.current : null;
            if (element) {
                const elementToClick = element.querySelector(querySelector);
                if (elementToClick) // @ts-expect-error - Property 'click' does not exist on type 'Element'
                elementToClick.click();
            }
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: {
            e: {
                callback: clickElementCallback('.issueaction-edit-issue')
            },
            a: {
                callback: clickElementCallback('.issueaction-assign-issue')
            },
            i: {
                callback: clickElementCallback('.issueaction-assign-to-me')
            },
            l: {
                callback: clickElementCallback('#edit-labels')
            },
            s: {
                callback: clickElementCallback('.viewissue-share')
            },
            m: {
                callback: ()=>{
                    // :bow: PLEASE DON'T JUDGE :bow:
                    // Shortcuts doesn't pass through the event so we can't
                    // preventDefault(). This prevents 'm' being typed into
                    // the comment box after you activate the shortcut.
                    setTimeout(()=>JIRA.Issue.invokeCommentTrigger(), 0);
                }
            }
        }
    });
});

});

parcelRegister("8A37l", function(module, exports) {

$parcel$export(module.exports, "addLinkInterceptor", () => $87efcf9371ebfbdc$export$1ce34b3859880107);
const $87efcf9371ebfbdc$var$spaUrlRegex = '(/jira/servicedesk/projects/.*)';
const $87efcf9371ebfbdc$var$assetsPageRegex = '(/jira/servicedesk/assets/.*)';
const $87efcf9371ebfbdc$var$insightPageRegex = '(/jira/servicedesk/insight/.*)';
const $87efcf9371ebfbdc$export$1ce34b3859880107 = (element, onNavigateClicked)=>{
    if (!element) return;
    element.addEventListener('click', (e)=>{
        // @ts-expect-error - TS2339 - Property 'closest' does not exist on type 'EventTarget'.
        const anchor = e.target && e.target.closest('a');
        if (anchor) {
            const { href: href } = anchor;
            // We only want to target links, so that we can do the navigation ourselves.
            if (href != null) {
                // @ts-expect-error - TS2339 - Property 'getAttribute' does not exist on type 'EventTarget'.
                const isAuiTab = e.target.getAttribute('role') === 'tab';
                // We don't want to target links that open in a new tab
                // @ts-expect-error - TS2339 - Property 'target' does not exist on type 'EventTarget'.
                const opensInNewTab = e.target.target === '_blank';
                // We only want to target links that navigate somewhere else in this SPA
                const isPartOfSpa = href && href.match && href.match($87efcf9371ebfbdc$var$spaUrlRegex) !== null;
                // Insight legacy pages are special because they are rendered outside of a servicedesk project context
                const isInsightPage = href && href.match && (href.match($87efcf9371ebfbdc$var$assetsPageRegex) !== null || href.match($87efcf9371ebfbdc$var$insightPageRegex) !== null);
                // Don't do it for '#' hrefs - these act like buttons
                const hrefWithoutPath = // @ts-expect-error - TS2339 - Property 'getAttribute' does not exist on type 'EventTarget'.
                e.target.getAttribute('href') || anchor.getAttribute('href');
                const actsAsButton = hrefWithoutPath && hrefWithoutPath.startsWith && hrefWithoutPath.startsWith('#');
                if (!isAuiTab && !opensInNewTab && isPartOfSpa && !actsAsButton) {
                    e.preventDefault();
                    onNavigateClicked(href.match($87efcf9371ebfbdc$var$spaUrlRegex)[0]);
                } else if (!isAuiTab && !opensInNewTab && !actsAsButton && isInsightPage) {
                    e.preventDefault();
                    let matchUrl = href.match($87efcf9371ebfbdc$var$insightPageRegex);
                    if (matchUrl == null) matchUrl = href.match($87efcf9371ebfbdc$var$assetsPageRegex);
                    onNavigateClicked(matchUrl[0]);
                }
            }
        }
    });
};

});

parcelRegister("3GAHU", function(module, exports) {

$parcel$export(module.exports, "addNavigationListener", () => $6ec9094474d8655b$export$50694ac99c31244c);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $cqJw8 = parcelRequire("cqJw8");

var $lFVIh = parcelRequire("lFVIh");
// This event fires on navigation events in JSD's legacy SPA, BUT
// (unexpected) does not fire when navigating backwards and forward in the browser
// (expected) It does not fire when a page has a dirty form warning that delays navigation
const $6ec9094474d8655b$var$JSD_LEGACY_NAVIGATE_EVENT = 'jsdLegacyNavigate';
const $6ec9094474d8655b$export$50694ac99c31244c = (projectKey, element, onNavigation, isSettings)=>{
    // Detach all event listeners for this event in case we already have one
    (0, $lFVIh.Events).off($6ec9094474d8655b$var$JSD_LEGACY_NAVIGATE_EVENT);
    (0, $lFVIh.Events).on($6ec9094474d8655b$var$JSD_LEGACY_NAVIGATE_EVENT, (fragment)=>{
        if (isSettings) return onNavigation(`${(0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.SERVICE_DESK_PROJECT), projectKey)}/${fragment}`);
        return onNavigation(`/jira/servicedesk/projects/${projectKey}/${fragment}`);
    });
};
const $6ec9094474d8655b$export$1661a729db6303de = (onNavigation)=>{
    (0, $eUqFw.useEffect)(()=>{
        (0, $lFVIh.Events).on($6ec9094474d8655b$var$JSD_LEGACY_NAVIGATE_EVENT, onNavigation);
        return ()=>{
            (0, $lFVIh.Events).off($6ec9094474d8655b$var$JSD_LEGACY_NAVIGATE_EVENT, onNavigation);
        };
    }, [
        onNavigation
    ]);
};

});

parcelRegister("9ihe5", function(module, exports) {

$parcel$export(module.exports, "getCalendarResources", () => $c74ed5aa09407ffd$export$7fb1869917da484d);

var $drNtW = parcelRequire("drNtW");
const $c74ed5aa09407ffd$export$7fb1869917da484d = (locale)=>(0, $drNtW.default)(locale);

});
parcelRegister("drNtW", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcc2e3f79d8a74bd$export$2e2bcd8739ae039);
/*
 * There are components in Issue and Service Desk that invoke legacy UI components. Some of these
 * components require Jira Calendar resources, but only two of the three required resources are
 * loaded implicitly. The third resource must be loaded dynamically because it depends on the
 * current user's locale.
 *
 * Here we generate the resource name for that calendar locale dependency, for loading through WRM.
 *
 * For more context in Jira, see:
 * - com.atlassian.jira.web.action.util.CalendarResourceIncluder
 * - jira-components/jira-webapp-resources/src/main/webapp/includes/lib/calendar
 * - system-webresources-plugin.xml
 */ const $bcc2e3f79d8a74bd$var$calendarLocaleMap = {
    cs_CZ: 'calendar-cs',
    da_DK: 'calendar-da',
    de_DE: 'calendar-de',
    en_GB: 'calendar-en',
    en_UK: 'calendar-en',
    en_ZZ: 'calendar-en',
    en_US: 'calendar-en',
    es_ES: 'calendar-es',
    et_EE: 'calendar-en',
    fi_FI: 'calendar-fi',
    fr_FR: 'calendar-fr',
    hu_HU: 'calendar-hu',
    is_IS: 'calendar-en',
    it_IT: 'calendar-it',
    ja_JP: 'calendar-jp',
    ko_KR: 'calendar-ko',
    nb_NO: 'calendar-no',
    nl_NL: 'calendar-nl',
    pl_PL: 'calendar-pl',
    pt_BR: 'calendar-pt',
    pt_PT: 'calendar-pt',
    ro_RO: 'calendar-ro',
    ru_RU: 'calendar-ru',
    sk_SK: 'calendar-sk',
    sv_SE: 'calendar-sv',
    tr_TR: 'calendar-tr',
    zh_CN: 'calendar-zh',
    zh_TW: 'calendar-zh'
};
const $bcc2e3f79d8a74bd$var$getCalendarResource = (locale)=>$bcc2e3f79d8a74bd$var$calendarLocaleMap[locale] || $bcc2e3f79d8a74bd$var$calendarLocaleMap.en_US;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcc2e3f79d8a74bd$export$2e2bcd8739ae039 = (locale)=>`wrc!jira.webresources:${$bcc2e3f79d8a74bd$var$getCalendarResource(locale)}`;

});


parcelRegister("kyfix", function(module, exports) {

$parcel$export(module.exports, "getMomentResources", () => $f57104be77810364$export$4c97d1314fac2e0c);
/**
 * This copies the logic that currently exists in the backend monolith
 * in PageLanguageTools.java into the Jira frontend so that it can be used
 * by pages in the SPA.
 *
 * (https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-plugins/jira-servicedesk/sd-components/project-ui/src/main/java/com/atlassian/servicedesk/project/internal/web/action/PageLanguageTools.java)
 */ 
var $3OXzs = parcelRequire("3OXzs");
const $f57104be77810364$var$SUPPORTED_LANGUAGES = [
    'af',
    'ar-ma',
    'ar-sa',
    'ar-tn',
    'ar',
    'az',
    'be',
    'bg',
    'bn',
    'bo',
    'br',
    'bs',
    'ca',
    'cs',
    'cv',
    'cy',
    'da',
    'de-at',
    'de',
    'el',
    'en-au',
    'en-ca',
    'en-gb',
    'eo',
    'es',
    'et',
    'eu',
    'fa',
    'fi',
    'fo',
    'fr-ca',
    'fr',
    'fy',
    'gl',
    'he',
    'hi',
    'hr',
    'hu',
    'hy-am',
    'id',
    'is',
    'it',
    'ja',
    'jv',
    'ka',
    'km',
    'ko',
    'lb',
    'lt',
    'lv',
    'me',
    'mk',
    'ml',
    'mr',
    'ms-my',
    'my',
    'nb',
    'ne',
    'nl',
    'nn',
    'pl',
    'pt-br',
    'pt',
    'ro',
    'ru',
    'si',
    'sk',
    'sl',
    'sq',
    'sr-cyrl',
    'sr',
    'sv',
    'ta',
    'th',
    'tl-ph',
    'tr',
    'tzm-latn',
    'tzm',
    'uk',
    'uz',
    'vi',
    'zh-cn',
    'zh-tw'
];
const $f57104be77810364$var$isSupportedLanguage = (language)=>(0, (/*@__PURE__*/$parcel$interopDefault($3OXzs)))($f57104be77810364$var$SUPPORTED_LANGUAGES, language);
const $f57104be77810364$var$getLanguage = (locale)=>{
    const localeStr = locale.replace('_', '-');
    if ($f57104be77810364$var$isSupportedLanguage(localeStr)) return localeStr;
    return localeStr.split('-')[0];
};
const $f57104be77810364$var$addMomentLanguage = (resources, locale)=>{
    const language = $f57104be77810364$var$getLanguage(locale);
    if (language !== 'en' && $f57104be77810364$var$isSupportedLanguage(language)) return resources.concat([
        `com.atlassian.servicedesk.core-ui:momentjs-sd-${language}`
    ]);
    return resources;
};
const $f57104be77810364$export$4c97d1314fac2e0c = (locale)=>$f57104be77810364$var$addMomentLanguage([
        'com.atlassian.servicedesk.core-ui:lib-moment'
    ], locale);

});

parcelRegister("77u8i", function(module, exports) {

$parcel$export(module.exports, "addMetaTags", () => $933ed534dc13f409$export$8db8627a2f899700);
const $933ed534dc13f409$var$getTagKey = (key, shouldIncludeAjsPrefix)=>`${shouldIncludeAjsPrefix ? 'ajs-' : ''}${key}`;
const $933ed534dc13f409$var$deleteMetaTag = (key, shouldIncludeAjsPrefix)=>{
    const existingMetaTag = document.querySelector(`meta[name='${$933ed534dc13f409$var$getTagKey(key, shouldIncludeAjsPrefix)}']`);
    existingMetaTag && existingMetaTag.parentNode && existingMetaTag.parentNode.removeChild(existingMetaTag);
};
const $933ed534dc13f409$var$createMetaTag = (key, content, shouldIncludeAjsPrefix)=>{
    const existingMetaTag = document.querySelector(`meta[name='${$933ed534dc13f409$var$getTagKey(key, shouldIncludeAjsPrefix)}']`);
    if (!existingMetaTag) {
        const meta = document.createElement('meta');
        meta.setAttribute('name', $933ed534dc13f409$var$getTagKey(key, shouldIncludeAjsPrefix));
        meta.setAttribute('content', content);
        return {
            meta: meta,
            previousValue: undefined
        };
    }
    const previousValue = existingMetaTag.getAttribute('content');
    existingMetaTag.setAttribute('content', content);
    return {
        meta: existingMetaTag,
        previousValue: previousValue
    };
};
const $933ed534dc13f409$export$8db8627a2f899700 = (metaDataForPage, { shouldIncludeAjsPrefix: shouldIncludeAjsPrefix } = {
    shouldIncludeAjsPrefix: true
})=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const previousValues = {};
    Object.keys(metaDataForPage).forEach((key)=>{
        if (!metaDataForPage[key]) $933ed534dc13f409$var$deleteMetaTag(key, shouldIncludeAjsPrefix);
        else {
            const { meta: meta, previousValue: previousValue } = $933ed534dc13f409$var$createMetaTag(key, // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
            metaDataForPage[key], shouldIncludeAjsPrefix);
            if (meta && !previousValue) document.head.appendChild(meta);
            previousValues[key] = previousValue;
        }
    });
    return ()=>{
        $933ed534dc13f409$export$8db8627a2f899700(previousValues);
    };
};

});

parcelRegister("54i0g", function(module, exports) {

$parcel$export(module.exports, "default", () => $d284dd528f4f5938$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3JafE = parcelRequire("3JafE");
parcelRequire("cpH8E");

var $foc4i = parcelRequire("foc4i");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $cGWC4 = parcelRequire("cGWC4");

var $b3V2m = parcelRequire("b3V2m");

var $cZWuN = parcelRequire("cZWuN");
class $d284dd528f4f5938$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onSubmitApdex: ()=>{}
        };
    }
    componentDidMount() {
        this.requestForBridgedView();
    }
    shouldComponentUpdate({ issueKey: nextKey, queueId: nextQueueId }, { loading: nextLoading }) {
        const { issueKey: issueKey, queueId: queueId } = this.props;
        const { issueView: issueView } = this;
        const { loading: loading } = this.state;
        if (nextQueueId !== queueId && issueView) // no visual changes, just update back link to
        // return to correct queue
        issueView.updateQueueId(nextQueueId);
        return nextKey !== issueKey || nextLoading !== loading;
    }
    componentDidUpdate({ issueKey: prevIssueKey }) {
        const { issueView: issueView } = this;
        const { issueKey: key, queueId: queueId } = this.props;
        const hasIssueKeyChanged = prevIssueKey !== key;
        // guard in case of a force update
        if (hasIssueKeyChanged) {
            if (issueView) issueView.render({
                key: key,
                queueId: queueId
            });
            else {
                this.bridgeSubscription.unsubscribe();
                this.requestForBridgedView();
            }
        }
    }
    componentWillUnmount() {
        const { bridgeSubscription: bridgeSubscription, issueView: issueView } = this;
        if (bridgeSubscription) bridgeSubscription.unsubscribe();
        if (issueView) issueView.dismiss();
    }
    requestForBridgedView() {
        const { onSubmitApdex: onSubmitApdex, pathname: pathname, isInitialRender: isInitialRender } = this.props;
        this.bridgeSubscription = (0, $3JafE.Observable).fromPromise((0, $cZWuN.getLegacyIssueView)()).subscribe((IssueView)=>{
            let generatedPageState;
            if (!onSubmitApdex && pathname) {
                const jsdApdexSanitizedPathname = pathname.replace('/jira/servicedesk', '');
                generatedPageState = (0, $cGWC4.generatePageState)({
                    newRoute: jsdApdexSanitizedPathname,
                    isSettings: false
                });
                (0, $b3V2m.start)(generatedPageState, isInitialRender);
            }
            this.setState({
                loading: false
            });
            const { queueId: queueId, issueKey: key } = this.props;
            const { current: el } = this.wrapperRef;
            if (el) {
                // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
                this.issueView = new IssueView();
                this.issueView.setElement(el).render({
                    key: key,
                    queueId: queueId
                }).then(()=>{
                    if (onSubmitApdex) onSubmitApdex();
                    else generatedPageState && (0, $b3V2m.end)(generatedPageState);
                });
            }
        }, (error)=>{
            const errMessage = `Queues Legacy issue view has failed to load: ${error}`;
            (0, $guiFP.default)({
                meta: {
                    id: 'legacyIssueViewLoad',
                    packageName: 'jiraServicedeskQueuesLegacyIssueView',
                    teamName: 'jsd-shield'
                },
                error: new Error(errMessage)
            });
            (0, $gUUjF.default).safeErrorWithoutCustomerData('servicedesk.queues.legacy-issue-view.view', errMessage);
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.state.loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this.wrapperRef
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            loading: true
        };
        this.wrapperRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
    }
}

});
parcelRegister("cGWC4", function(module, exports) {

$parcel$export(module.exports, "generatePageState", () => $9bc7317f0cb0e58c$export$f2c04cc57e85bfe1);
const $9bc7317f0cb0e58c$export$f2c04cc57e85bfe1 = ({ newRoute: newRoute, isSettings: isSettings })=>{
    const processedSubRoute = newRoute.match(`/projects/[^/]+${isSettings ? '/settings' : ''}/(.*)`);
    const subRoute = processedSubRoute && processedSubRoute.length >= 2 ? processedSubRoute[1] : '';
    const splitUrl = subRoute.split('/');
    return {
        module: splitUrl[0],
        item: splitUrl[1],
        secondaryItem: splitUrl[2],
        tertiaryItem: splitUrl[3],
        quaternaryItem: splitUrl[4],
        quinternaryItem: splitUrl[5]
    };
};

});

parcelRegister("cZWuN", function(module, exports) {

$parcel$export(module.exports, "getLegacyIssueView", () => $4c316ee6bc010170$export$31910960cc695581);

var $16kIm = parcelRequire("16kIm");
const $4c316ee6bc010170$export$31910960cc695581 = ()=>(0, $16kIm.asyncWrmRequire)([
        'wrc!jira.view.issue',
        'wrc!sd.project.legacy.issue.view',
        'wrc!sd.project.queues.legacy.issue.view.bridge'
    ]).then(()=>__jsdQueues.LegacyIssueView);

});


parcelRegister("7Rqgg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ce1e4f6297182b3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3JafE = parcelRequire("3JafE");
parcelRequire("cpH8E");

var $foc4i = parcelRequire("foc4i");

var $gUUjF = parcelRequire("gUUjF");

var $0cdA8 = parcelRequire("0cdA8");

var $guiFP = parcelRequire("guiFP");

var $cGWC4 = parcelRequire("cGWC4");

var $b3V2m = parcelRequire("b3V2m");

var $f0TrZ = parcelRequire("f0TrZ");
class $4ce1e4f6297182b3$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onSubmitApdex: ()=>{}
        };
    }
    componentDidMount() {
        this.requestForBridgedView();
    }
    shouldComponentUpdate({ issueKey: nextKey }, { loading: nextLoading }) {
        const { issueKey: issueKey } = this.props;
        const { loading: loading } = this.state;
        return nextKey !== issueKey || nextLoading !== loading;
    }
    componentDidUpdate({ issueKey: prevIssueKey }) {
        const { issueView: issueView } = this;
        const { issueKey: key, report: report } = this.props;
        const hasIssueKeyChanged = prevIssueKey !== key;
        // guard in case of a force update
        if (hasIssueKeyChanged) {
            if (issueView) issueView.render({
                key: key,
                report: report
            });
            else {
                this.bridgeSubscription.unsubscribe();
                this.requestForBridgedView();
            }
        }
    }
    componentWillUnmount() {
        const { bridgeSubscription: bridgeSubscription, issueView: issueView } = this;
        if (bridgeSubscription) bridgeSubscription.unsubscribe();
        if (issueView) issueView.dismiss();
    }
    requestForBridgedView() {
        const { onSubmitApdex: onSubmitApdex, pathname: pathname, isInitialRender: isInitialRender } = this.props;
        this.bridgeSubscription = (0, $3JafE.Observable).fromPromise((0, $f0TrZ.getLegacyIssueView)()).subscribe((IssueView)=>{
            let generatedPageState;
            if (!onSubmitApdex && pathname) {
                const jsdApdexSanitizedPathname = pathname.replace('/jira/servicedesk', '');
                generatedPageState = (0, $cGWC4.generatePageState)({
                    newRoute: jsdApdexSanitizedPathname,
                    isSettings: false
                });
                (0, $b3V2m.start)(generatedPageState, isInitialRender);
            }
            this.setState({
                loading: false
            });
            const { report: report, issueKey: key } = this.props;
            const { current: el } = this.wrapperRef;
            if (el) {
                // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
                this.issueView = new IssueView();
                this.issueView.setElement(el).render({
                    key: key,
                    report: report
                }).then(()=>{
                    if (onSubmitApdex) onSubmitApdex();
                    else generatedPageState && (0, $b3V2m.end)(generatedPageState);
                });
            }
        }, (error)=>{
            const errMessage = `Reports Legacy issue view has failed to load: ${error}`;
            (0, $guiFP.default)({
                meta: {
                    id: 'legacyIssueViewLoad',
                    packageName: 'jiraServicedeskReportsLegacyIssueView'
                },
                error: new Error(errMessage)
            });
            (0, $gUUjF.default).safeErrorWithoutCustomerData('servicedesk.reports.legacy-issue-view.view', errMessage);
        });
    }
    render() {
        const ReportsLegacyIssueView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.state.loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this.wrapperRef
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "reportsLegacyIssueViewApp",
            packageName: "jiraServicedeskReportsLegacyIssueView",
            fallback: "flag"
        }, ReportsLegacyIssueView);
    }
    constructor(...args){
        super(...args);
        this.state = {
            loading: true
        };
        this.wrapperRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
    }
}

});
parcelRegister("f0TrZ", function(module, exports) {

$parcel$export(module.exports, "getLegacyIssueView", () => $36ca7eda7d8a5c6a$export$31910960cc695581);

var $16kIm = parcelRequire("16kIm");
const $36ca7eda7d8a5c6a$export$31910960cc695581 = ()=>(0, $16kIm.asyncWrmRequire)([
        'wrc!jira.view.issue',
        'wrc!sd.project.legacy.issue.view',
        'wrc!sd.project.report.legacy.issue.view.bridge'
    ]).then(()=>__jsdReport.LegacyIssueView);

});


parcelRegister("bpOk7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1668c2c75a2a4f99$export$2e2bcd8739ae039);
/* wrm-data-container.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $1668c2c75a2a4f99$export$eabf00abaa2cb4bf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cagmp _4t3iidpf _tzy4idpf",
            __cmplp.className
        ])
    });
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1668c2c75a2a4f99$export$2e2bcd8739ae039 = ({ wrmData: wrmData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1668c2c75a2a4f99$export$eabf00abaa2cb4bf, {
        id: "jsd-spa-page-wrm-data-container"
    }, JSON.stringify(wrmData));

});

parcelRegister("2a1Mo", function(module, exports) {

$parcel$export(module.exports, "WRMModuleLoader", () => $c3f2f0b2bf813513$export$7b7998ab5dc5666b);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $16kIm = parcelRequire("16kIm");
class $c3f2f0b2bf813513$export$7b7998ab5dc5666b extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onLoad: ()=>{}
        };
    }
    componentDidMount() {
        this.getModules();
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.modules !== this.props.modules) this.getModules();
        if (prevState.loading && !this.state.loading) {
            if (!this.state.error) this.props.onLoad();
        }
    }
    getModules() {
        (0, $16kIm.asyncWrmRequire)(this.props.modules).then(()=>{
            this.setState({
                loading: false,
                error: null
            });
        }).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('wrm-module-loader.getModules', 'asyncWrmRequire error', error);
            this.setState({
                loading: false,
                error: error
            });
        });
    }
    render() {
        const { loading: loading, error: error } = this.state;
        return this.props.children({
            loading: loading,
            error: error
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            loading: true,
            error: null
        };
    }
}

});

parcelRegister("jNZWQ", function(module, exports) {

$parcel$export(module.exports, "JSMIssueViewLoad", () => $7175273f07dae875$export$1e32b6c8e1e31a3d);
$parcel$export(module.exports, "JSMReportsIssueViewLoad", () => $7175273f07dae875$export$30ebd3f479793fc1);

var $lNfG4 = parcelRequire("lNfG4");
const $7175273f07dae875$export$1e32b6c8e1e31a3d = (0, $lNfG4.metrics).pageLoad({
    key: 'service-management.queues.issue'
});
const $7175273f07dae875$export$30ebd3f479793fc1 = (0, $lNfG4.metrics).pageLoad({
    key: 'service-management.reports.issue'
});

});


parcelRegister("4YkVK", function(module, exports) {

$parcel$export(module.exports, "useKbConfluenceContext", () => $cb72f3010d1f4c73$export$a8450b4f39918e6d);

var $eUqFw = parcelRequire("eUqFw");

var $bbvOQ = parcelRequire("bbvOQ");

var $lB25E = parcelRequire("lB25E");
const $cb72f3010d1f4c73$var$getKbConfluenceContextResource = ()=>(0, $bbvOQ.kbConfluenceContextResource);
const $cb72f3010d1f4c73$export$a8450b4f39918e6d = (projectKey)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $lB25E.useResource)($cb72f3010d1f4c73$var$getKbConfluenceContextResource());
    (0, $eUqFw.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};
var $cb72f3010d1f4c73$export$2e2bcd8739ae039 = $cb72f3010d1f4c73$export$a8450b4f39918e6d;

});

parcelRegister("cVYSD", function(module, exports) {

$parcel$export(module.exports, "useShouldShowLegacyIssueView", () => $495e21ac5e72f6a7$export$ebe5701b3a084631);

var $53ciZ = parcelRequire("53ciZ");

var $gUUjF = parcelRequire("gUUjF");

var $7JKBZ = parcelRequire("7JKBZ");
const $495e21ac5e72f6a7$var$OLD_ISSUE_VIEW_QUERY_PARAM = 'oldIssueView';
const $495e21ac5e72f6a7$var$hasOldIssueViewQueryParam = (search)=>{
    if (false) {
        const query = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search);
        return Object.keys(query).includes($495e21ac5e72f6a7$var$OLD_ISSUE_VIEW_QUERY_PARAM);
    }
    const query = new URLSearchParams(search);
    return query.get('oldIssueView') === 'true';
};
const $495e21ac5e72f6a7$var$useNewIssueViewLockedIn = ()=>{
    const { error: error, newIssueViewLockedIn: newIssueViewLockedIn } = (0, $7JKBZ.useNewIssueViewLockInStatus)();
    if (newIssueViewLockedIn !== null) return newIssueViewLockedIn;
    if (error) (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-commons.utils.should-show-legacy-issue-view-provider', 'Error getting new issue view lock in status, default to false');
    return false;
};
const $495e21ac5e72f6a7$export$ebe5701b3a084631 = (isProjectSimplified, canSeeNewIssueView, search)=>{
    const isNewIssueViewLockedIn = $495e21ac5e72f6a7$var$useNewIssueViewLockedIn();
    if (isNewIssueViewLockedIn) return {
        showLegacyIssueView: false
    };
    if (canSeeNewIssueView) return {
        showLegacyIssueView: $495e21ac5e72f6a7$var$hasOldIssueViewQueryParam(search)
    };
    return {
        showLegacyIssueView: true
    };
};

});



// error types
const $8b8bfa076f313cc4$export$6c8cb487d6ffc522 = 'QueryError';
const $8b8bfa076f313cc4$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $8b8bfa076f313cc4$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $8b8bfa076f313cc4$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $8b8bfa076f313cc4$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $8b8bfa076f313cc4$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $8b8bfa076f313cc4$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $8b8bfa076f313cc4$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $8b8bfa076f313cc4$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $8b8bfa076f313cc4$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $8b8bfa076f313cc4$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $8b8bfa076f313cc4$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


//# sourceMappingURL=async-servicedesk-queues-agent-and-issue-view.ad2cf3ac.js.map
